{
 "tools": [
  {
   "id": "icu",
   "sheet": "ICU Rounding Tool",
   "label": "Adult ICU Rounding Tool"
  },
  {
   "id": "spa",
   "sheet": "SPA Quick-Ref",
   "label": "SPA Quick Reference"
  },
  {
   "id": "peds-cards",
   "sheet": "Peds Card Set",
   "label": "Pediatric Card Set"
  },
  {
   "id": "picu-wf",
   "sheet": "PICU Workflow",
   "label": "PICU Workflow"
  },
  {
   "id": "ed-cards",
   "sheet": "ED Card Set",
   "label": "ED Card Set"
  },
  {
   "id": "ed-wf",
   "sheet": "ED Workflow",
   "label": "ED Workflow"
  },
  {
   "id": "sd-cards",
   "sheet": "Step-Down Card Set",
   "label": "Step-Down Card Set"
  },
  {
   "id": "sd-wf",
   "sheet": "Step-Down Workflow",
   "label": "Step-Down Workflow"
  }
 ],
 "claims": [
  {
   "id": "icu-r3",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Status strip — Sedation",
   "statement": "Avoid deep sedation unless clinically required.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2018",
    "PADIS 2025",
    "SAT/SBT"
   ],
   "anchor": "PADIS 2018 — p. 16",
   "passage": "… Across the five studies, a total of 739 patients were randomized (DSI, n = 373; NP, n = 366). Benzodiazepines were commonly prescribed for sedation in both groups, often paired with opioids for analgesia. Two studies reported no difference in level of sedation achieved between DSI and NP-targeted sedation (178, 179). The remaining studies appear contradictory; one noted higher RASS with DSI versus NP-targeted sedation (180), another noted lower median SAS scores with DSI versus NP-targeted sedation, but no difference in the percentage of time spent in the targeted light sedation range (181). A third study reported lighter sedation with DSI than with NP-targeted sedation (182). As outlined in these guidelines, clinicians should target a light rather than deep level of sedation in their intubated, critically ill adult patients unless deeper sedation is clinically indicated. Our literature review suggests that both DSI protocols and NP-targeted sedation are safe and no differences exist between them in achieving and maintaining a light level of sedation. There are, however, some important caveats: first, most studies evaluating DSIs and NP have done so in the context of sedation with benzodiazepines, which are no longer recommended for sedation in critically ill patients; second, DSI protocols may be associated with increasing nursing workload (179); and third, a brief DSI should not be used to justify the use of deep sedation for the rest of the day when it is not indicated. …\nThe formal recommendation on p. 15 states the same position: \"We suggest using light sedation (vs deep sedation).\"",
   "evidence": "Full text, p. 16",
   "status": "fulltext",
   "pageNum": "16",
   "citations": [
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governing on-scope source: the guideline's Light Sedation recommendation directly endorses light over deep sedation and states the target-light-unless-clinically-indicated principle the claim paraphrases.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Recommendation: We suggest using light sedation (vs deep sedation) in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence).",
       "highlight": "We suggest using light sedation (vs deep sedation) in critically ill, mechanically ventilated adults",
       "scope": "on-scope",
       "note": "The formal conditional recommendation for light over deep sedation in the exact population — direct support for avoiding deep sedation.",
       "page": "e838",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "As outlined in these guidelines, clinicians should target a light rather than deep level of sedation in their intubated, critically ill adult patients unless deeper sedation is clinically indicated. Our literature review suggests that both DSI protocols and NP-targeted sedation are safe and no differences exist between them in achieving and maintaining a light level of sedation. There are, however, some important caveats: first, most studies evaluating DSIs and NP have done so in the context of sedation with benzodiazepines, which are no longer recommended for sedation in critically ill patients; second, DSI protocols may be associated with increasing nursing workload (179); and third, a brief DSI should not be used to justify the use of deep sedation for the rest of the day when it is not indicated. Because light levels of sedation are associated with improved outcomes and are needed to facilitate other interventions such as spontaneous breathing trials and early mobilization, healthcare providers should strive to achieve light levels of sedation in the majority of patients the majority of the time. Light sedation, assessed using a validated sedation scale, can be achieved either using a NP or through DSI protocols (where light sedation is targeted, whereas sedatives are infusing).",
       "highlight": "clinicians should target a light rather than deep level of sedation in their intubated, critically ill adult patients unless deeper sedation is clinically indicated",
       "scope": "on-scope",
       "note": "States the operative principle almost verbatim: target light rather than deep sedation unless deeper sedation is clinically indicated.",
       "page": "e839",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Focused update (adds anxiety; re-examines dexmedetomidine vs propofol). It does not re-address the light-vs-deep sedation-depth question, so it states no position on the claim; light sedation appears only as the assumed target setting for the agent-choice recommendation.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "If a patient requires deep sedation or has a high risk of bradycardia, alternative sedative agents should be considered.",
       "highlight": "If a patient requires deep sedation or has a high risk of bradycardia, alternative sedative agents should be considered",
       "scope": "different-intervention",
       "note": "The guideline mentions deep sedation only as a reason to select an alternative sedative agent (a different intervention, agent choice), not as guidance to avoid a sedation depth.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "SAT/SBT",
     "cite": "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org.",
     "kind": "pdf",
     "stance": "background",
     "note": "ICUDelirium.org (Vanderbilt CIBS) educational page; archived web text with site navigation. Contributes supportive context on the light-sedation goal via the SAT/daily-sedative-interruption method rather than stating the sedation-depth recommendation itself.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt",
     "paragraphs": [
      {
       "context": "Spontaneous Awakening Trials (SATs), also known as daily sedative interruptions, are one of the recommended titration methods in the recent Pain, Agitation, Delirium, Immobility, and Sleep Disruption (PADIS) guidelines for managing sedatives in critically ill patients and achieving light sedation.",
       "highlight": "for managing sedatives in critically ill patients and achieving light sedation",
       "scope": "different-intervention",
       "note": "Frames SAT/daily sedative interruption as a titration method to achieve light sedation under PADIS — corroborates the light-sedation aim but describes a specific intervention, not the avoid-deep-sedation depth recommendation.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2018 directly supports the statement: it suggests light over deep sedation in critically ill, mechanically ventilated adults and advises clinicians to target a light rather than deep level of sedation unless deeper sedation is clinically indicated — this on-scope recommendation governs. The 2025 focused update did not re-address the sedation-depth question (it re-examined dexmedetomidine vs propofol and added anxiety), so the 2018 light-sedation recommendation remains the current position, while the ICUDelirium.org SAT/SBT page corroborates the light-sedation goal via a specific titration method rather than the depth recommendation itself.",
   "discrepancy": true
  },
  {
   "id": "icu-r4",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Status strip — Sedation",
   "statement": "Daily SAT/SBT when feasible.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2018",
    "PADIS 2025",
    "SAT/SBT"
   ],
   "anchor": "PADIS 2018 — p. 15",
   "passage": "… Finally, as outlined elsewhere in these guidelines, the relationship between level of sedation and the ability to evaluate, pain, delirium, and sleep has not been fully elucidated. Daily Sedative Interruption/Nurse-Protocolized Sedation Question: In critically ill, intubated adults, is there a difference between daily sedative interruption (DSI) protocols and nursing-protocolized (NP)-targeted sedation in the ability to achieve and maintain a light level of sedation? Ungraded Statement: In critically ill, intubated adults, DSI protocols and NP-targeted sedation can achieve and maintain a light level of sedation. Remarks: A DSI or a SAT is defined as a period of time, each day, during which a patient's sedative medication is discontinued and patients can wake up and achieve arousal and/or alertness , defined by objective actions such as opening eyes in response to a voice, following simple commands, and/or having a Sedation-Agitation Scale (SAS) score of 4-7 or a RASS score of -1 to +1. NP-targeted sedation is defined as an established sedation protocol implemented by nurses at the bedside to determine sedative choices and to titrate these medications to achieve prescription-targeted sedation scores.\nAlso SAT/SBT: \"Pairing together daily SATs with daily Spontaneous Breathing Trials (SBTs) in a protocol that included safety screens and failure criteria resulted in improved patients outcomes.\"\nPADIS 2018 defines the daily SAT but does not itself pair it with a daily SBT; the paired-daily protocol is stated explicitly in the ICU Delirium SAT/SBT source, quoted second.",
   "evidence": "Full text, p. 15 — partial support",
   "status": "fulltext",
   "pageNum": "15",
   "citations": [
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Addresses the daily-SAT (DSI) component and references SBT, but issues only an ungraded statement treating DSI/SAT as equivalent to nurse-protocolized titration; it does not itself make the paired daily SAT+SBT feasibility recommendation.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "As outlined in these guidelines, clinicians should target a light rather than deep level of sedation in their intubated, critically ill adult patients unless deeper sedation is clinically indicated. Our literature review suggests that both DSI protocols and NP-targeted sedation are safe and no differences exist between them in achieving and maintaining a light level of sedation. There are, however, some important caveats: first, most studies evaluating DSIs and NP have done so in the context of sedation with benzodiazepines, which are no longer recommended for sedation in critically ill patients; second, DSI protocols may be associated with increasing nursing workload (179); and third, a brief DSI should not be used to justify the use of deep sedation for the rest of the day when it is not indicated. Because light levels of sedation are associated with improved outcomes and are needed to facilitate other interventions such as spontaneous breathing trials and early mobilization, healthcare providers should strive to achieve light levels of sedation in the majority of patients the majority of the time. Light sedation, assessed using a validated sedation scale, can be achieved either using a NP or through DSI protocols (where light sedation is targeted, whereas sedatives are infusing).",
       "highlight": "facilitate other interventions such as spontaneous breathing trials and early mobilization",
       "scope": "on-scope",
       "note": "On the cited page 15, light sedation is described as needed to enable spontaneous breathing trials and early mobilization, linking the sedation target to SBT.",
       "page": "e839 (p. 15)",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Remarks: A DSI or a SAT is defined as a period of time, each day, during which a patient's sedative medication is discontinued and patients can wake up and achieve arousal and/or alertness, defined by objective actions such as opening eyes in response to a voice, following simple commands, and/or having a Sedation-Agitation Scale (SAS) score of 4-7 or a RASS score of -1 to +1. NP-targeted sedation is defined as an established sedation protocol implemented by nurses at the bedside to determine sedative choices and to titrate these medications to achieve prescription-targeted sedation scores.",
       "highlight": "A DSI or a SAT is defined as a period of time, each day, during which a patient's sedative medication is discontinued and patients can wake up",
       "scope": "on-scope",
       "note": "Defines a daily SAT (=DSI) as a daily period of sedative discontinuation letting the patient wake — the daily-SAT component of the claim.",
       "page": "e838 (p. 14)",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "In critically ill, intubated adults, DSI protocols and NP-targeted sedation can achieve and maintain a light level of sedation.",
       "highlight": "DSI protocols and NP-targeted sedation can achieve and maintain a light level of sedation",
       "scope": "on-scope",
       "note": "Ungraded statement: daily SAT (DSI) and nurse-protocolized sedation are equivalent routes to light sedation, so SAT is endorsed but not privileged over NP titration (the partial nuance).",
       "page": "e838 (p. 14)",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Rationale: The 2013 PAD guidelines made an ungraded statement that maintaining a light level of sedation will shorten time to extubation and reduce ICU LOS (1). Although the prior guideline defined light sedation as a RASS scale score of greater than or equal to -2 and eye opening of at least 10 minutes (112), this level of sedation is probably deeper than required for management of mechanically ventilated adults in an ICU. No universally accepted definition of light sedation exists. To address this question, we evaluated studies in which light versus deep sedation were defined a priori, measured, and explicitly reported with objective scales describing whether patients met these clear light, versus deep, sedation targets systematically over the time spent in the ICU and at least q6h. Surrogate measures (e.g., sedative plasma levels) or subjective clinical assessments of wakefulness were not considered as part of the definition of level of sedation. Studies describing a daily spontaneous awakening trial (SAT) were not deemed indicative of a light sedation approach because they reported lightening of sedation at a single point in time, rather than over the entire day. For studies that used scales, such as the RASS (159), a RASS score of -2 to +1 range (or its equivalent using other scales) was considered as light sedation in the evaluated studies.",
       "highlight": "were not deemed indicative of a light sedation approach",
       "scope": "background",
       "note": "Clarifies that a daily SAT lightens sedation only at a single point in time, so SAT studies were not counted as a light-sedation approach — a scope nuance about what SAT does.",
       "page": "e838 (p. 14)",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Focused update re-addressed sedation only as sedative drug choice (dexmedetomidine over propofol) and did not revisit the daily SAT/SBT (DSI) question; the 2018 position on daily SAT therefore remains the current position.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "In adult patients admitted to the ICU, the task force issued conditional recommendations to use dexmedetomidine over propofol for sedation, provide enhanced mobilization/rehabilitation over usual mobilization/rehabilitation, and administer melatonin. The task force was unable to issue recommendations on the administration of benzodiazepines to treat anxiety, and the use of antipsychotics to treat delirium.",
       "highlight": "use dexmedetomidine over propofol for sedation",
       "scope": "different-intervention",
       "note": "Nearest sedation content is the agent-choice recommendation (dexmedetomidine over propofol); the update does not address awakening/breathing trials.",
       "page": "p. 5",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "SAT/SBT",
     "cite": "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Archived Vanderbilt CIBS Center / ICUDelirium.org page (the 'B — Both SAT and SBT' ABCDEF element); directly describes daily SAT paired with daily SBT under safety screens.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt",
     "paragraphs": [
      {
       "context": "The ABC study, also known as the Wake Up and Breathe study, showed that pairing together daily SATs with daily Spontaneous Breathing Trials (SBTs) in a protocol that included safety screens and failure criteria resulted in improved patients outcomes (i.e., decreased time on the ventilator, reduced time spent in the ICU and hospital, and improved one-year survival).",
       "highlight": "pairing together daily SATs with daily Spontaneous Breathing Trials (SBTs) in a protocol that included safety screens and failure criteria resulted in improved patients outcomes",
       "scope": "on-scope",
       "note": "Directly on-scope: the ABC (Wake Up and Breathe) trial paired daily SATs with daily SBTs within a protocol of safety screens and failure criteria — the safety-screen gate is the 'when feasible' qualifier.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
      },
      {
       "context": "Daily SATs are the stopping of narcotics (as long as pain is controlled) and sedatives every day and, if needed, restarting either narcotics or sedatives at half the previous dose and titrating as needed.",
       "highlight": "Daily SATs are the stopping of narcotics (as long as pain is controlled) and sedatives every day",
       "scope": "on-scope",
       "note": "Defines the daily SAT as stopping narcotics/sedatives every day (restart at half dose if needed) — the 'daily' cadence of the claim.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
      }
     ]
    }
   ],
   "synthesis": "The archived ICUDelirium (Wake Up and Breathe / ABC study) page is the on-scope source and governs the claim: it directly pairs daily SATs with daily SBTs within a protocol of safety screens and failure criteria, which is exactly \"daily SAT/SBT when feasible.\" PADIS 2018 partially aligns — it endorses the daily SAT (DSI) as one of two equivalent (ungraded) ways to reach light sedation and notes light sedation is needed to enable SBTs, but does not itself issue the paired SAT+SBT recommendation — and the 2025 focused update did not revisit this question (its sedation update is sedative drug choice only), so the 2018 position remains the current guideline position.",
   "discrepancy": true
  },
  {
   "id": "icu-r5",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Status strip — CAM-ICU result",
   "statement": "Positive — delirium present",
   "contentType": "Cited clinical content",
   "sources": [
    "CAM-ICU Worksheet",
    "Ely 2001"
   ],
   "anchor": "CAM-ICU Worksheet — p. 7, ¶14",
   "passage": "Feature 1 plus 2 and either 3 or 4 present = CAM-ICU positive Criteria Met ! \" CAM-ICU Positive (Delirium Present) Criteria Not Met ! \" CAM-ICU Negative (No Delirium)",
   "evidence": "Full text, p. 7",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Ely EW; Vanderbilt University. CAM-ICU Worksheet. ICUDelirium.org.",
    "Ely EW, Inouye SK, Bernard GR, et al. Delirium in mechanically ventilated patients: validity and reliability of the CAM-ICU. JAMA. 2001;286(21):2703-2710."
   ],
   "links": [
    "https://www.icudelirium.org/resource-downloads/cam-icu-worksheet",
    "https://doi.org/10.1001/jama.286.21.2703"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "CAM-ICU Worksheet",
     "cite": "Ely EW; Vanderbilt University. CAM-ICU Worksheet. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The Vanderbilt worksheet's terminal decision rule maps a positive feature combination directly to the result 'Delirious'.",
     "docUrl": "https://www.icudelirium.org/resource-downloads/cam-icu-worksheet",
     "paragraphs": [
      {
       "context": "Both Features 1 and 2 and either Feature 3 or 4 are present Delirious",
       "highlight": "Both Features 1 and 2 and either Feature 3 or 4 are present",
       "scope": "on-scope",
       "note": "The worksheet's terminal decision node: when Feature 1 and Feature 2 plus either Feature 3 or 4 are present, the result is 'Delirious' — i.e. a positive CAM-ICU means delirium is present, exactly the claim.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/resource-downloads/cam-icu-worksheet"
      }
     ]
    },
    {
     "label": "Ely 2001",
     "cite": "Ely EW, Inouye SK, Bernard GR, et al. Delirium in mechanically ventilated patients: validity and reliability of the CAM-ICU. JAMA. 2001;286(21):2703-2710.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The CAM-ICU validation study defines a positive CAM (features 1+2 plus 3 or 4) as the patient being delirious.",
     "docUrl": "https://doi.org/10.1001/jama.286.21.2703",
     "paragraphs": [
      {
       "context": "Development and Validation Phases of Study Design Delirium, as defined by the CAM,31 has 4 features: (1) an acute onset of changes or fluctuations in the course of mental status, (2) inattention, (3) disorganized thinking, and (4) an altered level of consciousness (ie, other than alert). The patient is determined to be delirious (ie, CAM positive) if he/she manifests both features 1 and 2, plus either feature 3 or 4 (FIGURE). The development of the CAM-ICU began by adapting the patient assessment (without modifying the actual CAM instrument) using nonverbal, objective tests derived through a comprehensive literature review and consultation with numerous delirium experts. This resulted in a pilot investigation that yielded promising results.34 .",
       "highlight": "The patient is determined to be delirious (ie, CAM positive)",
       "scope": "on-scope",
       "note": "Explicit definition equating a positive CAM-ICU (both features 1 and 2 plus either feature 3 or 4) with the patient being delirious — direct support for 'Positive — delirium present.'",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jama.286.21.2703"
      },
      {
       "context": "The diagnosis of delirium requires the presence of acute onset of changes or fluctuations in the course of mental status, and inattention, and either disorganized thinking or an altered level of consciousness.",
       "highlight": "and either disorganized thinking or an altered level of consciousness",
       "scope": "on-scope",
       "note": "States the diagnostic criteria (acute change + inattention + either disorganized thinking or altered level of consciousness) that constitute a positive result.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jama.286.21.2703"
      },
      {
       "context": "The patient is determined to be delirious (ie, CAM positive) if he/she manifests both features 1 and 2, plus either feature 3 or 4 (FIGURE).",
       "highlight": "determined to be delirious (ie, CAM positive) if he/she manifests both features 1 and 2, plus either feature 3 or 4",
       "scope": "on-scope",
       "note": "States the CAM-ICU determination rule: features 1 and 2 plus either feature 3 or 4 yields a CAM-positive (delirium present) result.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jama.286.21.2703"
      }
     ]
    }
   ],
   "synthesis": "Both sources agree and are on-scope for the adult ICU: the CAM-ICU Worksheet's decision rule and Ely 2001 (the CAM-ICU validation study) each state that when Features 1 and 2 plus either Feature 3 or 4 are present the patient is delirious (CAM positive), directly supporting \"Positive — delirium present.\" No source contradicts or narrows the claim.",
   "discrepancy": false
  },
  {
   "id": "icu-r6",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Status strip — CAM-ICU result",
   "statement": "Negative",
   "contentType": "Cited clinical content",
   "sources": [
    "CAM-ICU Worksheet",
    "Ely 2001"
   ],
   "anchor": "CAM-ICU Worksheet — p. 7, ¶15",
   "passage": "Criteria Met ! \" CAM-ICU Positive (Delirium Present) Criteria Not Met ! \" CAM-ICU Negative (No Delirium)",
   "evidence": "Full text, p. 7 — see note",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Ely EW; Vanderbilt University. CAM-ICU Worksheet. ICUDelirium.org.",
    "Ely EW, Inouye SK, Bernard GR, et al. Delirium in mechanically ventilated patients: validity and reliability of the CAM-ICU. JAMA. 2001;286(21):2703-2710."
   ],
   "links": [
    "https://www.icudelirium.org/resource-downloads/cam-icu-worksheet",
    "https://doi.org/10.1001/jama.286.21.2703"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "CAM-ICU Worksheet",
     "cite": "Ely EW; Vanderbilt University. CAM-ICU Worksheet. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The operational bedside worksheet that defines the CAM-ICU result the status strip reports; its algorithm produces the 'Not Delirious' (Negative) outcome.",
     "docUrl": "https://www.icudelirium.org/resource-downloads/cam-icu-worksheet",
     "paragraphs": [
      {
       "context": "Both Features 1 and 2 and either Feature 3 or 4 are present Delirious Otherwise Not Delirious",
       "highlight": "Not Delirious",
       "scope": "on-scope",
       "note": "The worksheet's scoring rule: delirium requires Features 1 and 2 plus either 3 or 4; otherwise the result is 'Not Delirious' — the tool's Negative status.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/resource-downloads/cam-icu-worksheet"
      },
      {
       "context": "If no to both, stop Patient is not delirious",
       "highlight": "Patient is not delirious",
       "scope": "on-scope",
       "note": "Feature 1 (acute change/fluctuation) absent on both questions ends the screen as Negative (not delirious).",
       "page": "",
       "docUrl": "https://www.icudelirium.org/resource-downloads/cam-icu-worksheet"
      },
      {
       "context": "If 0-2 errors, stop Patient is not delirious",
       "highlight": "Patient is not delirious",
       "scope": "on-scope",
       "note": "Feature 2 (inattention) not met (0-2 errors) ends the screen as Negative (not delirious).",
       "page": "",
       "docUrl": "https://www.icudelirium.org/resource-downloads/cam-icu-worksheet"
      }
     ]
    },
    {
     "label": "Ely 2001",
     "cite": "Ely EW, Inouye SK, Bernard GR, et al. Delirium in mechanically ventilated patients: validity and reliability of the CAM-ICU. JAMA. 2001;286(21):2703-2710.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The CAM-ICU validation study in mechanically ventilated adult ICU patients; defines the identical algorithm and the Yes/No overall result, with high negative predictive value.",
     "docUrl": "https://doi.org/10.1001/jama.286.21.2703",
     "paragraphs": [
      {
       "context": "Development and Validation Phases of Study Design Delirium, as defined by the CAM,31 has 4 features: (1) an acute onset of changes or fluctuations in the course of mental status, (2) inattention, (3) disorganized thinking, and (4) an altered level of consciousness (ie, other than alert). The patient is determined to be delirious (ie, CAM positive) if he/she manifests both features 1 and 2, plus either feature 3 or 4 (FIGURE). The development of the CAM-ICU began by adapting the patient assessment (without modifying the actual CAM instrument) using nonverbal, objective tests derived through a comprehensive literature review and consultation with numerous delirium experts. This resulted in a pilot investigation that yielded promising results.34 .",
       "highlight": "The patient is determined to be delirious (ie, CAM positive) if he/she manifests both features 1 and 2, plus either feature 3 or 4",
       "scope": "on-scope",
       "note": "States the positive rule; a Negative (CAM-negative) result is the complement — when this feature combination is not met.",
       "page": "2704",
       "docUrl": "https://doi.org/10.1001/jama.286.21.2703"
      },
      {
       "context": "The patient is determined to be delirious (ie, CAM positive) if he/she manifests both features 1 and 2, plus either feature 3 or 4 (FIGURE).",
       "highlight": "if he/she manifests both features 1 and 2, plus either feature 3 or 4",
       "scope": "on-scope",
       "note": "The CAM-ICU determination rule produces the Table 1 overall Yes/No assessment; not meeting the feature criteria yields the No (CAM-ICU Negative) result the status strip records.",
       "page": "2705",
       "docUrl": "https://doi.org/10.1001/jama.286.21.2703"
      }
     ]
    }
   ],
   "synthesis": "Both sources agree. The CAM-ICU Worksheet is the operational instrument for the status-strip result and explicitly yields \"Not Delirious\" (the Negative result) whenever the feature combination for delirium is not met, and Ely 2001 validates the identical algorithm — delirious only with Features 1 and 2 plus either 3 or 4, otherwise the Overall CAM-ICU Assessment is answered \"No\" — with a 98-100% negative predictive value. The Worksheet governs the \"Negative\" label and Ely 2001 concurs and validates it, with no scope conflict.",
   "discrepancy": false
  },
  {
   "id": "icu-r7",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Status strip — CAM-ICU result",
   "statement": "Unable to assess (RASS −4/−5)",
   "contentType": "Cited clinical content",
   "sources": [
    "CAM-ICU Worksheet",
    "Ely 2001",
    "CAM-ICU Manual"
   ],
   "anchor": "CAM-ICU Worksheet — p. 6, ¶15",
   "passage": "Briefly awakens to voice (eyes open & contact <10 sec) -3 MODERATE SEDATION Movement or eye opening to voice (no eye contact) If RASS is ≥ -3 proceed to CAM-ICU (Is patient CAM-ICU positive or negative?) If RASS is -4 or -5 ! STOP (patient unconscious), RECHECK later V O I C E\nThe worksheet does not use the phrase \"unable to assess\"; its equivalent instruction at RASS −4/−5 is to stop the assessment (patient unconscious) and recheck later.",
   "evidence": "Full text, p. 6",
   "status": "fulltext",
   "pageNum": "6",
   "citations": [
    "Ely EW; Vanderbilt University. CAM-ICU Worksheet. ICUDelirium.org.",
    "Ely EW, Inouye SK, Bernard GR, et al. Delirium in mechanically ventilated patients: validity and reliability of the CAM-ICU. JAMA. 2001;286(21):2703-2710."
   ],
   "links": [
    "https://www.icudelirium.org/resource-downloads/cam-icu-worksheet",
    "https://doi.org/10.1001/jama.286.21.2703"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Ely 2001",
     "cite": "Ely EW, Inouye SK, Bernard GR, et al. Delirium in mechanically ventilated patients: validity and reliability of the CAM-ICU. JAMA. 2001;286(21):2703-2710.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Governing on-scope source: defines RASS -4/-5 as unarousable and validated CAM-ICU only in verbally-arousable patients (comatose/stuporous excluded), the basis for 'unable to assess' — but does not print the operational status label verbatim.",
     "docUrl": "https://doi.org/10.1001/jama.286.21.2703",
     "paragraphs": [
      {
       "context": "The a priori decision to include this level of consciousness as the first comparison for validation and reliability testing was made to include only interactive patient evaluations, avoiding comatose and stuporous evaluations because they lack characteristic delirium features and their relative ease of rating might falsely elevate the test characteristics of the CAM-ICU.",
       "highlight": "avoiding comatose and stuporous evaluations because they lack characteristic delirium features",
       "scope": "on-scope",
       "note": "CAM-ICU validation used only interactive patients arousable to verbal stimulation who could make eye contact and follow commands; comatose and stuporous (unarousable) evaluations were excluded because they lack delirium features - the rationale for an 'unable to assess' result when the patient cannot participate.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jama.286.21.2703"
      },
      {
       "context": "*The scores included in the 10-point RASS range from a high of 4 (combative) to a low of -5 (deeply comatose and unresponsive). Under the RASS system, patients who were spontaneously alert, calm, and not agitated were scored at 0 (neutral zone). Anxious or agitated patients received a range of scores depending on their level of anxiety: 1 for anxious, 2 for agitated (fighting ventilator), 3 for very agitated (pulling on or removing catheters), or 4 for combative (violent and a danger to staff). The scores -1 to -5 were assigned for patients with varying degrees of sedation based on their ability to maintain eye contact: -1 for more than 10 seconds, -2 for less than 10 seconds, and -3 for eye opening but no eye contact. If physical stimulation was required, then the patients were scored as either -4 for eye opening or movement with physical or painful stimulation or -5 for no response to physical or painful stimulation. The RASS has excellent interrater reliability and intraclass correlation coefficients of 0.95 and 0.97, respectively, and has been validated against visual analog scale and geropsychiatric diagnoses in 2 ICU studies.37,38 In completing the visual ASE, the patients were shown 5 simple pictures (previously published34) at 3-second intervals and asked to remember them.",
       "highlight": "-4 for eye opening or movement with physical or painful stimulation or -5 for no response to physical or painful stimulation",
       "scope": "on-scope",
       "note": "Defines the claim's parenthetical RASS values: -4 = responds only to physical/painful stimulation, -5 = no response — the unarousable levels at which a patient cannot complete the CAM-ICU.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jama.286.21.2703"
      },
      {
       "context": "The CAM-ICU was completed by the study nurses as described in TABLE 1. To aid in the assessment of acute onset or fluctuation of mental status changes, patients were followed up daily with the Glasgow Coma Scale36 and an agitation/ sedation scale called the Richmond Agitation Sedation Scale (RASS) (See Table 1 footnotes).37,38 Any fluctuation during the prior 24-hour period in the patient's Glasgow Coma Scale or RASS scores was used by the study nurse to indicate a positive mental status, and as such these scales became a standardized part of the rating of the CAM-ICU by the nurses.",
       "highlight": "these scales became a standardized part of the rating of the CAM-ICU by the nurses",
       "scope": "background",
       "note": "Establishes that RASS is embedded in CAM-ICU administration, but this passage does not itself state the deep-sedation threshold at which assessment is impossible.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jama.286.21.2703"
      },
      {
       "context": "The reference standard delirium experts and 2 critical care study nurses completed evaluations in 111 patients. Comparison of the demographic variables of the 111 enrolled patients with the 47 patients excluded based on criteria designated a priori showed no significant differences in age, sex, race, severity of illness, or other baseline characteristics (all P.25). After excluding 15 enrolled patients because they remained comatose throughout the investigation, 96 (86.5%) of 111 enrolled patients remained and comprised the final study population. Characteristics of these 96 patients at the time of enrollment are presented in TABLE 2. The mean (SD) age of the study population was 55.3 (17.4) years (range, 18-92 years). The study patients, all of whom were mechanically ventilated, had high severity of illness with mean (SD) APACHE II scores of 22.9 (7.2) (median, 23; interquartile range [IQR], 18-29], and a wide spectrum of illnesses. The presence of visual or auditory deficits were reported at baseline in 61.5% of patients, supporting the need to have both visual and auditory means to assess cognitive function as part of the CAM-ICU.",
       "highlight": "excluding 15 enrolled patients because they remained comatose throughout the investigation",
       "scope": "narrower",
       "note": "Study-level exclusion of persistently comatose patients — a narrower case (permanent coma removed from analysis entirely) than the tool's per-timepoint 'unable to assess' status at transient RASS -4/-5.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jama.286.21.2703"
      }
     ]
    },
    {
     "label": "CAM-ICU Worksheet",
     "cite": "Ely EW; Vanderbilt University. CAM-ICU Worksheet. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Cited primary CAM-ICU instrument, but this extraction lacks any preliminary RASS/sedation gate; RASS appears only inside Features 1 and 3, so the RASS -4/-5 'unable to assess' rule is not stated in the provided file (no -4/-5, no 'unable to assess', no coma/unarousable text present).",
     "docUrl": "https://www.icudelirium.org/resource-downloads/cam-icu-worksheet",
     "paragraphs": [
      {
       "context": "Present if the actual RASS score is anything other than alert and calm (zero) if RASS anything other than zero 4 Disorganized thinking Check box Yes/No Questions (See training manual for alternate set of questions) if combined 1.",
       "highlight": "RASS score is anything other than alert and calm (zero)",
       "scope": "background",
       "note": "Feature 3 uses RASS to flag altered level of consciousness as a CAM-ICU feature; nearest RASS content in the worksheet, but it addresses scoring a feature, not the deep-sedation state at which the whole assessment cannot be performed.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/resource-downloads/cam-icu-worksheet"
      },
      {
       "context": "Has the patient had any fluctuation in mental status in the past 24 hours as evidenced by fluctuation on a sedation/level of consciousness scale (i.e., RASS, SAS, or GCS) or previous delirium assessment?",
       "highlight": "a sedation/level of consciousness scale (i.e., RASS, SAS, or GCS)",
       "scope": "background",
       "note": "Feature 1 lists RASS among scales used to detect fluctuation; the worksheet contains no threshold that renders the patient unassessable, so this is context rather than support for the claim.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/resource-downloads/cam-icu-worksheet"
      }
     ]
    },
    {
     "label": "CAM-ICU Manual",
     "stance": "agrees",
     "note": "The RASS -4/-5 stop is stated in the training manual's Step Two flow. The worksheet, which the claim also cites, carries the four features but no arousal gate.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "Step Two: Delirium Assessment Using the CAM-ICU RASS Score Level of Consciousness If RASS is >= -3 proceed to CAM-ICU (Is patient CAM-ICU positive or negative?) If RASS is -4 or -5 ! STOP (patient unconscious), RECHECK later",
       "highlight": "If RASS is -4 or -5 ! STOP (patient unconscious), RECHECK later",
       "page": "6"
      }
     ]
    }
   ],
   "synthesis": "Ely 2001 is the governing on-scope source: it defines RASS -4 (responds only to physical/painful stimulation) and -5 (no response) as unarousable states and validated the CAM-ICU only in patients arousable to voice, explicitly excluding comatose and stuporous evaluations because they lack characteristic delirium features — the clinical basis for reporting \"unable to assess\" at RASS -4/-5. The provided CAM-ICU Worksheet extraction references RASS only within Features 1 and 3 and omits any preliminary sedation-gate step, so it does not state this rule; the operational \"stop and reassess later\" threshold is standard CAM-ICU flowsheet practice consistent with Ely 2001's validation population.",
   "discrepancy": true
  },
  {
   "id": "icu-r8",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Status strip — Motor subtype",
   "statement": "Hyperactive (agitated, combative — least common)",
   "contentType": "Cited clinical content",
   "sources": [
    "la Cour 2022",
    "Krewulak 2018",
    "Hayhurst 2020"
   ],
   "anchor": "la Cour 2022 — p. 1",
   "passage": "… The aim of this review was to describe the distribution, pharmacological interventions, and outcomes of delirium motor subtypes in ICU patients. Methods: This systematic scoping review was performed according to the PRISMA-ScR and Cochrane guidelines. We performed a systematic search in six major databases to identify relevant studies. A meta-regression analysis was performed where pooled estimates with 95% confidence intervals were computed by a random effect model. Results: We included 131 studies comprising 13,902 delirious patients. There was a large between-study heterogeneity among studies, including differences in study design, setting, population, and outcome reporting. Hypoactive delirium was the most prevalent delirium motor subtype (50.3% [95% CI 46.0-54.7]), followed by mixed delirium (27.7% [95% CI 24.1-31.3]) and hyperactive delirium (22.7% [95% CI 19.0-26.5]). When comparing the delirium motor subtypes, patients with mixed delirium experienced the longest delirium duration, ICU and hospital length of stay, the highest ICU and hospital mortality, and more frequently received administration of specific agents (antipsychotics, α2-agonists, benzodiazepines, and propofol) during ICU stay. In studies with high average age for delirious patients (> 65 years), patients were more likely to experience hypoactive delirium. Conclusions: Hypoactive delirium was the most prevalent motor subtype in critically ill patients. …\nThe 22.7% figure is the lowest of the three subtypes, supporting \"least common\"; la Cour 2022 describes hyperactive delirium as an agitated state marked by aggression and restlessness (p. 2), consistent with \"agitated, combative.\"",
   "evidence": "Full text, p. 1",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "la Cour KN, Andersen-Ranberg NC, Weihe S, et al. Distribution of delirium motor subtypes in the ICU: a systematic scoping review. Crit Care. 2022;26:53.",
    "Krewulak KD, Stelfox HT, Leigh JP, Ely EW, Fiest KM. Incidence and prevalence of delirium subtypes in an adult ICU: a systematic review and meta-analysis. Crit Care Med. 2018;46(12):2029-2035.",
    "Hayhurst CJ, Patel MB, McNeil JB, et al. Association of hypoactive and hyperactive delirium with cognitive function after critical illness. Crit Care Med. 2020;48(6):e480-e488."
   ],
   "links": [
    "https://doi.org/10.1186/s13054-022-03931-3",
    "https://doi.org/10.1097/CCM.0000000000003402",
    "https://doi.org/10.1097/CCM.0000000000004313"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "la Cour 2022",
     "cite": "la Cour KN, Andersen-Ranberg NC, Weihe S, et al. Distribution of delirium motor subtypes in the ICU: a systematic scoping review. Crit Care. 2022;26:53.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1186/s13054-022-03931-3",
     "paragraphs": [
      {
       "context": "One hundred and twelve studies contributed to the distribution of all three motor subtypes, while 19 studies contributed to the distribution of hypoactive and hyperactive delirium only. Dichotomous distribution of delirium motor subtypes was typically reported in studies determining delirium motor subtype upon study inclusion making it impossible to determine the mixed subtype. Among studies reporting on all three motor subtypes, we found that hypoactive delirium was the most prevalent (50.3% [95% CI 46.0–54.7]), followed by mixed delirium (27.7% [95% CI 24.1–31.3]) and hyperactive delirium (22.7% [95% CI 19.0–26.5]). Data on distribution of delirium motor subtypes are presented in Table 3 . Forrest plots in Additional file illustrate the prevalence of the three motor subtypes across studies (see Additional file 1 : Figs. S3, S4, and S5). Table 3 Distribution of delirium motor subtypes in studies with 3 or 2 motoric subtypes * Three studies only had data on distribution of the hypoactive delirium motor subtype ** One study only had data on distribution of the hyperactive delirium motor subtype *** These studies only discriminated between hypoactive and hyperactive delirium motor subtype Secondary outcomes Few studies reported on secondary outcomes at motor subtype level and hence contributed to these results.",
       "highlight": "and hyperactive delirium (22.7% [95% CI 19.0–26.5])",
       "scope": "on-scope",
       "note": "Pooled three-way distribution across 112 studies ranks hyperactive lowest (22.7%) below hypoactive (50.3%) and mixed (27.7%), directly supporting 'least common'.",
       "page": "",
       "docUrl": "https://doi.org/10.1186/s13054-022-03931-3"
      },
      {
       "context": "Results: We included 131 studies comprising 13,902 delirious patients. There was a large between-study heteroge neity among studies, including differences in study design, setting, population, and outcome reporting. Hypoactive delirium was the most prevalent delirium motor subtype (50.3% [95% CI 46.0-54.7]), followed by mixed delirium (27.7% [95% CI 24.1-31.3]) and hyperactive delirium (22.7% [95% CI 19.0-26.5]). When comparing the delirium motor subtypes, patients with mixed delirium experienced the longest delirium duration, ICU and hospital length of stay, the highest ICU and hospital mortality, and more frequently received administration of specific agents (antipsychotics, 2-agonists, benzodiazepines, and propofol) during ICU stay. In studies with high average age for delirious patients (>65 years), patients were more likely to experience hypoactive delirium.",
       "highlight": "followed by mixed delirium (27.7% [95% CI 24.1-31.3]) and hyperactive delirium (22.7% [95% CI 19.0-26.5])",
       "scope": "on-scope",
       "note": "Abstract restates the same subtype ranking, confirming hyperactive is the least prevalent of the three motor subtypes in critically ill adults.",
       "page": "1",
       "docUrl": "https://doi.org/10.1186/s13054-022-03931-3"
      },
      {
       "context": "A patient with hyperactive delirium is in an agitated state of mind and may display symptoms of aggression and restlessness, whereas a patient with hypoactive delirium is in an apathetic state of mind and may display symptoms of lethargy, depression, and stupor. In mixed delirium , the patient shifts between hyperactive and hypoactive delirium. All delirium motor subtypes experience elements of the hallmark symptoms in delirium such as confusion and inattention [ 5 ]. Delirium may also be divided into other clinical phenotypes based on underlying mechanisms, e.g., sedation- or hypoxic-associated delirium [ 6 ].",
       "highlight": "hyperactive delirium is in an agitated state of mind and may display symptoms of aggression and restlessness",
       "scope": "background",
       "note": "Definitional description of the hyperactive phenotype (agitation, aggression, restlessness) supporting the 'agitated, combative' descriptor in the claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1186/s13054-022-03931-3"
      }
     ]
    },
    {
     "label": "Krewulak 2018",
     "cite": "Krewulak KD, Stelfox HT, Leigh JP, Ely EW, Fiest KM. Incidence and prevalence of delirium subtypes in an adult ICU: a systematic review and meta-analysis. Crit Care Med. 2018;46(12):2029-2035.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited by the Status strip / Motor subtype section; systematic review and meta-analysis of ICU delirium subtype incidence and prevalence. No text file to quote; la Cour 2022 reports its own distribution is 'in accordance with' Krewulak et al., so it is concordant secondary support.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003402",
     "paragraphs": []
    },
    {
     "label": "Hayhurst 2020",
     "cite": "Hayhurst CJ, Patel MB, McNeil JB, et al. Association of hypoactive and hyperactive delirium with cognitive function after critical illness. Crit Care Med. 2020;48(6):e480-e488.",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000004313",
     "paragraphs": [
      {
       "context": "Within our cohort, 71% of patients (411/582) experienced hypoactive delirium for a median of 3 days (1-7 d), and 17% (100/582) experienced hyperactive delirium for a median of 1 day (1-2 d). In total, 8% (49/582) experienced a day with both hyperactive and hypoactive delirium, with a median duration of 1 day (1-2 d) of both subtypes during same day. Of those with delirium, 92% had a day with only hypoactive delirium, and 5% had a day with only hyperactive delirium. Patients with hyperactive delirium on average received higher daily doses of benzodiazepines, propofol, and antipsychotics (Table 1).",
       "highlight": "17% (100/582) experienced hyperactive delirium for a median of 1 day",
       "scope": "different-population",
       "note": "Single post-hoc cohort using a two-way, non-exclusive day-level hypo/hyper scheme with no mutually-exclusive mixed subtype; corroborates only that hyperactive (17%) is less common than hypoactive (71%), not the three-way 'least common' ranking.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000004313"
      },
      {
       "context": "Delirium, however, is heterogeneous and can present with different motoric phenotypes (5). Hypoactive delirium is characterized by reduced activity, apathy, decreased amount or speed of speech, decreased alertness, unawareness, or hypersomnolence. Hyperactive delirium, alternatively, is characterized by increased activity levels, increased speed of actions or Author Manuscript Author Manuscript Crit Care Med.",
       "highlight": "Hyperactive delirium, alternatively, is characterized by increased activity levels",
       "scope": "background",
       "note": "Definitional description of the hyperactive phenotype (increased activity), supporting the 'agitated, combative' descriptor rather than the prevalence claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000004313"
      }
     ]
    }
   ],
   "synthesis": "la Cour 2022, a systematic scoping review of 131 ICU studies, is the governing on-scope source: among studies reporting all three motor subtypes, hyperactive delirium was the least prevalent (22.7%), below hypoactive (50.3%) and mixed (27.7%), directly supporting \"hyperactive — least common,\" and it describes the subtype as agitated/aggressive/restless. Krewulak 2018 (unarchived, cited) is concordant per la Cour, while Hayhurst 2020 is a nearest match at a different scope — a single cohort using a two-way, non-exclusive hypo/hyper scheme that confirms only that hyperactive is less common than hypoactive (17% vs 71%) and never addresses the mixed subtype, so it does not independently establish the three-way \"least common\" ranking.",
   "discrepancy": true
  },
  {
   "id": "icu-r9",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Status strip — Motor subtype",
   "statement": "Hypoactive (somnolent, quiet — most common, easily missed)",
   "contentType": "Cited clinical content",
   "sources": [
    "la Cour 2022",
    "Krewulak 2018",
    "Hayhurst 2020"
   ],
   "anchor": "la Cour 2022 — p. 1",
   "passage": "… Hypoactive delirium was the most prevalent delirium motor subtype (50.3% [95% CI 46.0-54.7]), followed by mixed delirium (27.7% [95% CI 24.1-31.3]) and hyperactive delirium (22.7% [95% CI 19.0-26.5]). When comparing the delirium motor subtypes, patients with mixed delirium experienced the longest delirium duration, ICU and hospital length of stay, the highest ICU and hospital mortality, and more frequently received administration of specific agents (antipsychotics, α2-agonists, benzodiazepines, and propofol) during ICU stay. In studies with high average age for delirious patients (> 65 years), patients were more likely to experience hypoactive delirium. Conclusions: Hypoactive delirium was the most prevalent motor subtype in critically ill patients. Mixed delirium had the worst outcomes in terms of delirium duration, length of stay, and mortality, and received more pharmacological interventions compared to other delirium motor subtypes. Few studies contributed to secondary outcomes; hence, these results should be interpreted with care. The large between-study heterogeneity suggests that a more standardized methodology in delirium research is warranted. Keywords: Critically ill, Delirium, Delirium motor subtype, Intensive care © The Author(s) 2022. …\nla Cour 2022 describes hypoactive delirium as an apathetic state with lethargy and stupor (p. 2), consistent with \"somnolent, quiet.\" The \"easily missed\" descriptor is clinical elaboration not stated in the source.",
   "evidence": "Full text, p. 1",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "la Cour KN, Andersen-Ranberg NC, Weihe S, et al. Distribution of delirium motor subtypes in the ICU: a systematic scoping review. Crit Care. 2022;26:53.",
    "Krewulak KD, Stelfox HT, Leigh JP, Ely EW, Fiest KM. Incidence and prevalence of delirium subtypes in an adult ICU: a systematic review and meta-analysis. Crit Care Med. 2018;46(12):2029-2035.",
    "Hayhurst CJ, Patel MB, McNeil JB, et al. Association of hypoactive and hyperactive delirium with cognitive function after critical illness. Crit Care Med. 2020;48(6):e480-e488."
   ],
   "links": [
    "https://doi.org/10.1186/s13054-022-03931-3",
    "https://doi.org/10.1097/CCM.0000000000003402",
    "https://doi.org/10.1097/CCM.0000000000004313"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "la Cour 2022",
     "cite": "la Cour KN, Andersen-Ranberg NC, Weihe S, et al. Distribution of delirium motor subtypes in the ICU: a systematic scoping review. Crit Care. 2022;26:53.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Systematic scoping review (131 ICU studies, 50,232 patients) — the governing on-scope source for hypoactive being the most common/most prevalent ICU delirium motor subtype and for the somnolent/quiet (apathetic, lethargic) presentation.",
     "docUrl": "https://doi.org/10.1186/s13054-022-03931-3",
     "paragraphs": [
      {
       "context": "Conclusions: Hypoactive delirium was the most prevalent motor subtype in critically ill patients. Mixed delirium had the worst outcomes in terms of delirium duration, length of stay, and mortality, and received more pharmacological interventions compared to other delirium motor subtypes. Few studies contributed to secondary outcomes; hence, these results should be interpreted with care. The large between-study heterogeneity suggests that a more standard ized methodology in delirium research is warranted.",
       "highlight": "Hypoactive delirium was the most prevalent motor subtype in critically ill patients",
       "scope": "on-scope",
       "note": "Abstract conclusion directly supports the 'most common' claim; matches the primary anchor (p. 1).",
       "page": "1",
       "docUrl": "https://doi.org/10.1186/s13054-022-03931-3"
      },
      {
       "context": "Results: We included 131 studies comprising 13,902 delirious patients. There was a large between-study heteroge neity among studies, including differences in study design, setting, population, and outcome reporting. Hypoactive delirium was the most prevalent delirium motor subtype (50.3% [95% CI 46.0-54.7]), followed by mixed delirium (27.7% [95% CI 24.1-31.3]) and hyperactive delirium (22.7% [95% CI 19.0-26.5]). When comparing the delirium motor subtypes, patients with mixed delirium experienced the longest delirium duration, ICU and hospital length of stay, the highest ICU and hospital mortality, and more frequently received administration of specific agents (antipsychotics, 2-agonists, benzodiazepines, and propofol) during ICU stay. In studies with high average age for delirious patients (>65 years), patients were more likely to experience hypoactive delirium.",
       "highlight": "the most prevalent delirium motor subtype (50.3% [95% CI 46.0-54.7])",
       "scope": "on-scope",
       "note": "Abstract Results gives the pooled prevalence (50.3%) ranking hypoactive ahead of mixed and hyperactive — quantifies 'most common'.",
       "page": "1",
       "docUrl": "https://doi.org/10.1186/s13054-022-03931-3"
      },
      {
       "context": "A patient with hyperactive delirium is in an agitated state of mind and may display symptoms of aggression and restlessness, whereas a patient with hypoactive delirium is in an apathetic state of mind and may display symptoms of lethargy, depression, and stupor. In mixed delirium , the patient shifts between hyperactive and hypoactive delirium. All delirium motor subtypes experience elements of the hallmark symptoms in delirium such as confusion and inattention [ 5 ]. Delirium may also be divided into other clinical phenotypes based on underlying mechanisms, e.g., sedation- or hypoxic-associated delirium [ 6 ].",
       "highlight": "a patient with hypoactive delirium is in an apathetic state of mind and may display symptoms of lethargy, depression, and stupor",
       "scope": "on-scope",
       "note": "Defines the hypoactive presentation (apathetic, lethargy, stupor) — supports the 'somnolent, quiet' descriptor.",
       "page": "2",
       "docUrl": "https://doi.org/10.1186/s13054-022-03931-3"
      },
      {
       "context": "In this scoping systematic review comprising 131 studies and a pooled cohort of 50,232 ICU patients of whom 13,902 had delirium, we found hypoactive delirium to be the most prevalent delirium motor subtype among ICU patients accounting for half (50.3%) of delirium cases. Furthermore, we identified patients with mixed delirium to have the longest delirium duration, ICU and hospital length of stay, and the highest ICU and hospital mortality. Data on pharmacological interventions were complex. While patients with hyperactive delirium were more frequently intervened with a delirium-targeted pharmacological strategy, patients with mixed delirium were more likely to receive administration of specific pharmacological agents (antipsychotics, α2-agonists, benzodiazepines, and propofol) during their ICU stay (no reported indication). Our subgroup analysis identified hypoactive delirium to be more prevalent in studies with high mean age (≥ 65 years) in delirious patients and mixed delirium to be more prevalent in studies with low mean age (< 65 years) in delirious patients. The subgroup analyses also revealed a significantly higher proportion of mixed delirium cases in studies with low risk of bias or good quality.",
       "highlight": "hypoactive delirium to be the most prevalent delirium motor subtype",
       "scope": "on-scope",
       "note": "Discussion restates the pooled finding that hypoactive is the most prevalent ICU subtype.",
       "page": "8",
       "docUrl": "https://doi.org/10.1186/s13054-022-03931-3"
      }
     ]
    },
    {
     "label": "Krewulak 2018",
     "cite": "Krewulak KD, Stelfox HT, Leigh JP, Ely EW, Fiest KM. Incidence and prevalence of delirium subtypes in an adult ICU: a systematic review and meta-analysis. Crit Care Med. 2018;46(12):2029-2035.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Systematic review/meta-analysis of delirium-subtype incidence and prevalence in an adult ICU — directly on point for which motor subtype is most common, but no archived full text was available to quote (cited by section/DOI only).",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003402",
     "paragraphs": []
    },
    {
     "label": "Hayhurst 2020",
     "cite": "Hayhurst CJ, Patel MB, McNeil JB, et al. Association of hypoactive and hyperactive delirium with cognitive function after critical illness. Crit Care Med. 2020;48(6):e480-e488.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "582-patient ICU cohort focused on cognitive outcomes; specific sentences corroborate the descriptor, that hypoactive was more common than hyperactive, and that it goes undiagnosed without routine screening ('easily missed'). Its headline cognition/complication findings are a different question.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000004313",
     "paragraphs": [
      {
       "context": "Measurements and Results: Hypoactive delirium was more common and persistent than hyperactive delirium (71% vs 17%; median 3 vs 1 d). Longer duration of hypoactive delirium was associated with worse global cognition at 3 (-5.13 [-8.75 to -1.51]; p = 0.03) but not 12 (-5.76 [-9.99 to -1.53]; p = 0.08) months and with worse executive functioning at 3 (-3.61 [-7.48 to 0.26]; p = 0.03) and 12 (-6.22 [-10.12 to -2.33]; p = 0.004) months; these associations were not modified by hyperactive delirium. Hyperactive delirium was not associated with global cognition or executive function in this cohort.",
       "highlight": "Hypoactive delirium was more common and persistent than hyperactive delirium (71% vs 17%; median 3 vs 1 d)",
       "scope": "on-scope",
       "note": "Cohort finding corroborating 'most common' (hypoactive 71% vs hyperactive 17%), consistent with la Cour's pooled ranking.",
       "page": "e488",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000004313"
      },
      {
       "context": "Delirium, however, is heterogeneous and can present with different motoric phenotypes (5). Hypoactive delirium is characterized by reduced activity, apathy, decreased amount or speed of speech, decreased alertness, unawareness, or hypersomnolence. Hyperactive delirium, alternatively, is characterized by increased activity levels, increased speed of actions or Author Manuscript Author Manuscript Crit Care Med.",
       "highlight": "reduced activity, apathy, decreased amount or speed of speech, decreased alertness, unawareness, or hypersomnolence",
       "scope": "on-scope",
       "note": "Characterizes hypoactive delirium (reduced activity, hypersomnolence) — supports the 'somnolent, quiet' descriptor.",
       "page": "e488",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000004313"
      },
      {
       "context": "Our results support the importance of routine delirium assessments in the ICU, as the majority of hypoactive delirium will go undiagnosed without routine screening (32) but is associated with worse outcomes. This has implications for targeted prevention and treatment strategies, recognizing that although hyperactive delirium is more disruptive, the outcomes associated with it are not as poor as outcomes from hypoactive delirium. Our results, in addition to those of prior studies, support the importance of appropriate and timely clinical evaluation of patients with hypoactive delirium, which could be a presentation of encephalopathy or neuropathology that has long-term consequences. Pharmacologic treatments have shown no benefit in hypoactive delirium (27, 33) although implementation of prevention strategies such as the ICU Liberation Bundle of interventions (ABCDEF) have been able to demonstrate reduction in delirium (including hypoactive delirium) and improve its associated deleterious outcomes (34-36). The results of our study further emphasize the need to pay close attention to hypoactive delirium among critically ill patients and to implement strategies to reduce its incidence and duration.",
       "highlight": "majority of hypoactive delirium will go undiagnosed without routine screening",
       "scope": "on-scope",
       "note": "Directly supports 'easily missed' — hypoactive delirium is missed absent routine ICU screening.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000004313"
      },
      {
       "context": "speech, restlessness, abnormal content of verbal output, hyperalertness, irritability, and combativeness. In previous studies, subtypes that include hypoactive appear to be the most prevalent (6, 7). Specific subtypes of delirium also likely have different outcomes. In postoperative and hospital settings, patients with hypoactive delirium have greater risk for pressure ulcers and hospital-acquired infections, have prolonged length of stay, and have increased mortality compared with patients with hyperactive delirium (8-10). The association between motoric subtypes and outcomes in the critically ill, however, remains unknown, and the reasons for differences in outcomes between motoric subtypes are also unclear. It has previously been suggested that patients who develop hypoactive delirium have more frailty and more neuropathology and are, therefore, unable to exhibit the overt signs of hyperactivity. This increased vulnerability and disease burden could lead to worse long-term outcomes. It is not known if the motoric subtypes of delirium are associated with different cognitive outcomes after critical illness.",
       "highlight": "postoperative and hospital settings, patients with hypoactive delirium have greater risk",
       "scope": "different-setting",
       "note": "Nearest keyword match but a different scope: postoperative/hospital settings (not ICU) and about complications/mortality, not prevalence — must not be read as support for 'most common'.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000004313"
      }
     ]
    }
   ],
   "synthesis": "la Cour 2022 (systematic scoping review, 131 ICU studies, 50,232 patients) and Hayhurst 2020 (582-patient ICU cohort) agree that hypoactive delirium — reduced activity, apathy, hypersomnolence, the 'somnolent, quiet' presentation — is the most common ICU motor subtype (50.3% pooled prevalence; 71% vs 17% vs hyperactive in Hayhurst) and frequently goes undiagnosed without routine screening ('easily missed'). la Cour governs the 'most common' assertion as the pooled-review source and the primary anchor, while Hayhurst supplies the 'easily missed' support; note that Hayhurst's postoperative/hospital-settings sentence is a different-setting nearest match about complications/mortality, not prevalence, and should not be read as direct support.",
   "discrepancy": true
  },
  {
   "id": "icu-r10",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Status strip — Motor subtype",
   "statement": "Mixed (fluctuates between both)",
   "contentType": "Cited clinical content",
   "sources": [
    "la Cour 2022",
    "Krewulak 2018",
    "Hayhurst 2020"
   ],
   "anchor": "la Cour 2022 — p. 2",
   "passage": "Page 2 of 11 la Cour et al. Critical Care (2022) 26:53 describe the different manifestations, and with the term mixed delirium being introduced shortly after [4]. A patient with hyperactive delirium is in an agitated state of mind and may display symptoms of aggression and restlessness, whereas a patient with hypoactive delirium is in an apathetic state of mind and may display symptoms of lethargy, depression, and stupor. In mixed delirium, the patient shifts between hyperactive and hypoactive delirium. All delirium motor subtypes experience elements of the hallmark symptoms in delirium such as confusion and inattention [5]. Delirium may also be divided into other clinical phenotypes based on underlying mechanisms, e.g., sedationor hypoxic-associated delirium [6]. We still have limited knowledge about the pathophysiology of delirium. The Neurotransmitter Hypothesis suggests that specific neurotransmitter interactions with the cholinergic pathway might determine delirium motor subtype [7-9]. Currently no evidence-based pharmacological treatment exists for this severe condition [1, 10]. …\nThe same review reports a mixed-delirium prevalence of 27.7%.",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "la Cour KN, Andersen-Ranberg NC, Weihe S, et al. Distribution of delirium motor subtypes in the ICU: a systematic scoping review. Crit Care. 2022;26:53.",
    "Krewulak KD, Stelfox HT, Leigh JP, Ely EW, Fiest KM. Incidence and prevalence of delirium subtypes in an adult ICU: a systematic review and meta-analysis. Crit Care Med. 2018;46(12):2029-2035.",
    "Hayhurst CJ, Patel MB, McNeil JB, et al. Association of hypoactive and hyperactive delirium with cognitive function after critical illness. Crit Care Med. 2020;48(6):e480-e488."
   ],
   "links": [
    "https://doi.org/10.1186/s13054-022-03931-3",
    "https://doi.org/10.1097/CCM.0000000000003402",
    "https://doi.org/10.1097/CCM.0000000000004313"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "la Cour 2022",
     "cite": "la Cour KN, Andersen-Ranberg NC, Weihe S, et al. Distribution of delirium motor subtypes in the ICU: a systematic scoping review. Crit Care. 2022;26:53.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Directly and explicitly defines the mixed motor subtype both conceptually (shifts between hyperactive and hypoactive) and operationally (any combination of hypo- and hyperactive assessments during ICU stay) in adult critically ill patients.",
     "docUrl": "https://doi.org/10.1186/s13054-022-03931-3",
     "paragraphs": [
      {
       "context": "A patient with hyperactive delirium is in an agitated state of mind and may display symptoms of aggression and restlessness, whereas a patient with hypoactive delirium is in an apathetic state of mind and may display symptoms of lethargy, depression, and stupor. In mixed delirium , the patient shifts between hyperactive and hypoactive delirium. All delirium motor subtypes experience elements of the hallmark symptoms in delirium such as confusion and inattention [ 5 ]. Delirium may also be divided into other clinical phenotypes based on underlying mechanisms, e.g., sedation- or hypoxic-associated delirium [ 6 ].",
       "highlight": "In mixed delirium , the patient shifts between hyperactive and hypoactive delirium",
       "scope": "on-scope",
       "note": "Conceptual definition of the mixed motor subtype as a patient shifting between hyperactive and hypoactive delirium, i.e., fluctuating between both.",
       "page": "2",
       "docUrl": "https://doi.org/10.1186/s13054-022-03931-3"
      },
      {
       "context": "Mixed delirium was defined as any combination of hypo- and hyperactive delirium assessments during ICU stay.",
       "highlight": "Mixed delirium was defined as any combination of hypo- and hyperactive delirium assessments during ICU stay",
       "scope": "on-scope",
       "note": "Operational definition used in the scoping review, equating mixed with any combination of hypoactive and hyperactive assessments during the ICU stay.",
       "page": "3",
       "docUrl": "https://doi.org/10.1186/s13054-022-03931-3"
      },
      {
       "context": "Delirium is a cerebral dysfunction affecting nearly one-third of patients in the intensive care unit (ICU) [ 1 , 2 ]. The clinical manifestations of delirium exhibit great variance. Lipowski et al. [ 3 ] were the first to suggest the use of hyperactive and hypoactive motor subtypes to describe the different manifestations, and with the term mixed delirium being introduced shortly after [ 4 ].",
       "highlight": "with the term mixed delirium being introduced shortly after",
       "scope": "background",
       "note": "Historical origin of the three-subtype scheme; establishes mixed as a recognized motor subtype but is context rather than the operative definition.",
       "page": "2",
       "docUrl": "https://doi.org/10.1186/s13054-022-03931-3"
      }
     ]
    },
    {
     "label": "Krewulak 2018",
     "cite": "Krewulak KD, Stelfox HT, Leigh JP, Ely EW, Fiest KM. Incidence and prevalence of delirium subtypes in an adult ICU: a systematic review and meta-analysis. Crit Care Med. 2018;46(12):2029-2035.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited (Crit Care Med 2018;46(12):2029-2035) as the systematic review/meta-analysis of delirium subtype incidence and prevalence in an adult ICU, which enumerates mixed as one of the recognized motor subtypes; full text not archived here for verbatim confirmation.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003402",
     "paragraphs": []
    },
    {
     "label": "Hayhurst 2020",
     "cite": "Hayhurst CJ, Patel MB, McNeil JB, et al. Association of hypoactive and hyperactive delirium with cognitive function after critical illness. Crit Care Med. 2020;48(6):e480-e488.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest match at a different scope: studies the association of hypoactive/hyperactive delirium with cognitive outcomes and deliberately classifies motoric subtype per assessment rather than labeling patients 'mixed,' so it neither defines nor directly supports the mixed subtype label.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000004313",
     "paragraphs": [
      {
       "context": "Within our cohort, 71% of patients (411/582) experienced hypoactive delirium for a median of 3 days (1-7 d), and 17% (100/582) experienced hyperactive delirium for a median of 1 day (1-2 d). In total, 8% (49/582) experienced a day with both hyperactive and hypoactive delirium, with a median duration of 1 day (1-2 d) of both subtypes during same day. Of those with delirium, 92% had a day with only hypoactive delirium, and 5% had a day with only hyperactive delirium. Patients with hyperactive delirium on average received higher daily doses of benzodiazepines, propofol, and antipsychotics (Table 1).",
       "highlight": "experienced a day with both hyperactive and hypoactive delirium",
       "scope": "narrower",
       "note": "Reports the cohort prevalence of patients having both subtypes on the same day, the empirical analog of 'mixed/fluctuates between both,' but framed as a per-cohort statistic, not the general definition.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000004313"
      },
      {
       "context": "Author Manuscript than studies with patients labeled as mixed by accounting for motoric subtype per assessment and overall days with hyperactive delirium exposure. Further, we used duration of each subtype, as opposed to presence or absence, to provide increased statistical power.",
       "highlight": "studies with patients labeled as mixed",
       "scope": "background",
       "note": "Explicitly contrasts this study's per-assessment method with studies that label patients 'mixed,' showing Hayhurst avoids the mixed subtype category rather than endorsing its definition.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000004313"
      }
     ]
    }
   ],
   "synthesis": "la Cour 2022 governs this claim: it directly defines the mixed motor subtype both conceptually (\"the patient shifts between hyperactive and hypoactive delirium\") and operationally (\"any combination of hypo- and hyperactive delirium assessments during ICU stay\") in adult critically ill patients, matching the tool's \"Mixed (fluctuates between both).\" Krewulak 2018 (not archived) is cited as the adult-ICU subtype incidence/prevalence review that recognizes mixed as a subtype, while Hayhurst 2020 is a nearest match at a different scope — it studies subtype cognitive outcomes and deliberately counts days with both subtypes instead of labeling patients \"mixed,\" so it is background context rather than direct support.",
   "discrepancy": true
  },
  {
   "id": "icu-r11",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "DELIRIUM(S) causative factors",
   "statement": "D — Drugs / Withdrawal: Deliriogenic agents? Dose reduction? Alcohol / benzo / opioid withdrawal — check last use & home meds.",
   "contentType": "Cited clinical content",
   "sources": [
    "DELIRIUM(S)",
    "Flaherty 2011",
    "Maldonado 2018"
   ],
   "anchor": "DELIRIUM(S): \"Drugs\"",
   "passage": "The mnemonic entry is limited to \"Drugs\"; the withdrawal, dose-reduction, and last-use/home-medication details are standard clinical expansion not spelled out in the source.",
   "evidence": "Web page — partial support",
   "status": "web",
   "pageNum": null,
   "citations": [
    "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
    "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
    "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457."
   ],
   "links": [
    "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
    "https://pubmed.ncbi.nlm.nih.gov/21549878/",
    "https://doi.org/10.1002/gps.4823"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "DELIRIUM(S)",
     "cite": "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Archived Vanderbilt/CIBS 'Terminology & Mnemonics' page. The DELIRIUM(S) (SLU GEMS) mnemonic the tool reproduces lists 'D — Drugs' as a causative factor; the same page's ICU DELIRIUM(S) 'D rugs' entry supplies the deliriogenic-agent and withdrawal detail (sedatives/benzodiazepines/opiates, anticholinergics, alcohol/smoking cessation, withdrawal from chronically used sedatives).",
     "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
     "paragraphs": [
      {
       "context": "DELIRIUM(S) Differential diagnosis for patients with Delirium (Remember: delirium usually has more than one cause) D Drugs E Eyes, ears, and other sensory deficits",
       "highlight": "D Drugs E Eyes, ears, and other sensory deficits",
       "scope": "on-scope",
       "note": "The exact DELIRIUM(S) differential mnemonic the tool reproduces; 'D = Drugs' is the causative factor the claim states.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "Evaluate the use of sedatives (e.g. benzodiazepines or opiates) and medications with anticholinergic activity. Consider the abrupt cessation of smoking or alcohol. Consider withdrawal from chronically used sedatives.",
       "highlight": "Consider the abrupt cessation of smoking or alcohol. Consider withdrawal from chronically used sedatives.",
       "scope": "on-scope",
       "note": "Same-page ICU DELIRIUM(S) risk-factor variant elaborating the drug/withdrawal detail (sedatives, anticholinergics, withdrawal from alcohol/chronically used sedatives), grounding the deliriogenic-agents and alcohol/benzo withdrawal wording; explicit 'opioid withdrawal' is a modest extension.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "Dr. DRE (Disease remediation, Drug Removal, Environmental modifications) Strategies to consider when delirium is present Dr Diseases (Sepsis, COPD, CHF) DR Drug Removal (SATs and stopping benzodiazepines/ narcotics)",
       "highlight": "DR Drug Removal (SATs and stopping benzodiazepines/ narcotics)",
       "scope": "different-intervention",
       "note": "From the Dr. DRE management-strategy mnemonic (what to do when delirium is present), not the causative differential; shares the drug keyword by advising stopping benzodiazepines/narcotics rather than listing them as a cause.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "I WATCH DEATH Differential Diagnosis of Delirium. I nfection HIV, sepsis, Pneumonia W ithdrawal Alcohol, barbiturate, sedative-hypnotic",
       "highlight": "W ithdrawal Alcohol, barbiturate, sedative-hypnotic",
       "scope": "broader",
       "note": "From the I WATCH DEATH general (all-setting) delirium differential, where withdrawal is its own category; supports the withdrawal keyword but is broader than the ICU-specific DELIRIUM(S) drugs entry the claim cites.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      }
     ]
    },
    {
     "label": "Flaherty 2011",
     "cite": "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Unarchived (no local text file). Cited as a general reference on the evaluation and management of delirium in older persons, including deliriogenic-drug review and withdrawal states; corroborates the drug/withdrawal causative factor by citation (Med Clin North Am. 2011;95(3):555-577).",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/21549878/",
     "paragraphs": []
    },
    {
     "label": "Maldonado 2018",
     "cite": "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Unarchived (no local text file). Cited for delirium pathophysiology and etiology of acute brain failure, including drug and withdrawal mechanisms; background support for the drug factor by citation (Int J Geriatr Psychiatry. 2018;33(11):1428-1457).",
     "docUrl": "https://doi.org/10.1002/gps.4823",
     "paragraphs": []
    }
   ],
   "synthesis": "The archived Vanderbilt/CIBS Terminology & Mnemonics page directly supports the claim: the DELIRIUM(S) (SLU GEMS) mnemonic the tool reproduces lists 'D — Drugs,' and the same page's ICU DELIRIUM(S) 'D rugs' entry supplies the deliriogenic-agent and withdrawal detail (benzodiazepines/opiates, anticholinergics, alcohol/smoking cessation, withdrawal from chronically used sedatives) that the tool's statement expands on, with Flaherty 2011 and Maldonado 2018 cited as corroborating drug/withdrawal etiology; this on-scope DELIRIUM(S) mnemonic governs. Nearest-match passages that share the drug keyword but sit at a different scope — Dr. DRE 'Drug Removal' (a management/intervention mnemonic) and I WATCH DEATH 'Withdrawal' (a broader all-setting differential) — should not be read as the causative DELIRIUM(S) list, and explicit 'opioid withdrawal' is a modest extension since the page names opiates only as deliriogenic drugs.",
   "discrepancy": true
  },
  {
   "id": "icu-r12",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "DELIRIUM(S) causative factors",
   "statement": "E — Eyes / Ears (sensory): Glasses & hearing aids in? Other sensory deficits addressed?",
   "contentType": "Cited clinical content",
   "sources": [
    "DELIRIUM(S)",
    "Flaherty 2011",
    "Maldonado 2018"
   ],
   "anchor": "DELIRIUM(S): \"Eyes, ears, and other sensory deficits\"",
   "passage": "Glasses and hearing aids operationalize the source's broader \"eyes, ears, and other sensory deficits\" category rather than being named in it.",
   "evidence": "Web page",
   "status": "web",
   "pageNum": null,
   "citations": [
    "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
    "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
    "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457."
   ],
   "links": [
    "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
    "https://pubmed.ncbi.nlm.nih.gov/21549878/",
    "https://doi.org/10.1002/gps.4823"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "DELIRIUM(S)",
     "cite": "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Archived ICUDelirium.org Terminology & Mnemonics page; the DELIRIUM(S) differential lists E = Eyes, ears, and other sensory deficits, and sibling mnemonics on the same page name glasses/hearing aids.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
     "paragraphs": [
      {
       "context": "DELIRIUM(S) Differential diagnosis for patients with Delirium (Remember: delirium usually has more than one cause) D Drugs E Eyes, ears, and other sensory deficits",
       "highlight": "E Eyes, ears, and other sensory deficits",
       "scope": "on-scope",
       "note": "The cited DELIRIUM(S) differential's E item is exactly 'Eyes, ears, and other sensory deficits,' directly grounding the tool's 'E - Eyes/Ears (sensory)' and 'other sensory deficits addressed?' prompt.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "Consider the alterations of the sleep cycle and sleep deprivation. Consider the non availability of glasses (poor vision). Consider the non availability of hearings devices (poor hearing).",
       "highlight": "Consider the non availability of glasses (poor vision). Consider the non availability of hearings devices (poor hearing).",
       "scope": "broader",
       "note": "From a sibling mnemonic (ICU DELIRIUM(S) risk factors) on the same page - same ICU delirium population, different framework; it ties sensory deprivation to unavailable glasses/hearing devices, grounding the 'Glasses & hearing aids in?' wording the DELIRIUM(S) letter leaves implicit.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "N Nonpharmacological interventions Hearing aids, glasses, reorient, sleep protocols, music, noise control, ambulation",
       "highlight": "Hearing aids, glasses, reorient, sleep protocols, music, noise control, ambulation",
       "scope": "broader",
       "note": "THINK mnemonic's nonpharmacologic-intervention item lists hearing aids and glasses as delirium management; supports the tool's 'Glasses & hearing aids in?' action prompt but from a different (management) mnemonic than the cited DELIRIUM(S) differential.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      }
     ]
    },
    {
     "label": "Flaherty 2011",
     "cite": "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Unarchived (no text file); cited by section/journal citation as a supporting review on evaluation and management of delirium in older persons, in which correction of sensory impairment (vision/hearing) is a recognized modifiable factor.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/21549878/",
     "paragraphs": []
    },
    {
     "label": "Maldonado 2018",
     "cite": "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Unarchived (no text file); cited as a delirium-pathophysiology review that includes sensory contributors to acute brain failure — supplies etiologic background rather than the mnemonic wording.",
     "docUrl": "https://doi.org/10.1002/gps.4823",
     "paragraphs": []
    }
   ],
   "synthesis": "The on-scope DELIRIUM(S) mnemonic (Vanderbilt CIBS Center / ICUDelirium.org) directly supports and governs the tool item — its E letter is verbatim \"Eyes, ears, and other sensory deficits\" — while sibling mnemonics on the same archived page (THINK's nonpharmacologic interventions and the ICU DELIRIUM(S) sensory-deprivation item) reinforce the \"Glasses & hearing aids in?\" operationalization, and Flaherty 2011 and Maldonado 2018 are unarchived supporting references. The sources agree with no contradiction; the only nuance is that the literal glasses/hearing-aids wording is grounded in broader-scope sibling mnemonics rather than the DELIRIUM(S) letter itself, which names sensory deficits generically.",
   "discrepancy": true
  },
  {
   "id": "icu-r13",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "DELIRIUM(S) causative factors",
   "statement": "L — Low O₂ states: Check SpO₂, Hgb; MI, stroke, pulmonary embolism.",
   "contentType": "Cited clinical content",
   "sources": [
    "DELIRIUM(S)",
    "Flaherty 2011",
    "Maldonado 2018"
   ],
   "anchor": "DELIRIUM(S): \"Low O2 states (e.g. heart attack, stroke, and pulmonary embolism)\"",
   "passage": "",
   "evidence": "Web page",
   "status": "web",
   "pageNum": null,
   "citations": [
    "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
    "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
    "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457."
   ],
   "links": [
    "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
    "https://pubmed.ncbi.nlm.nih.gov/21549878/",
    "https://doi.org/10.1002/gps.4823"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "DELIRIUM(S)",
     "cite": "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Archived ICUDelirium.org (Vanderbilt CIBS Center) mnemonics page. The cited SLU GEMS DELIRIUM(S) differential directly contains the 'L — Low O2 states' line naming heart attack (MI), stroke, and pulmonary embolism; the tool's 'Check SpO2, Hgb' is an operationalization not stated verbatim in the source.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
     "paragraphs": [
      {
       "context": "DELIRIUM(S) Differential diagnosis for patients with Delirium (Remember: delirium usually has more than one cause) D Drugs E Eyes, ears, and other sensory deficits L Low O2 states (e.g. heart attack, stroke, and pulmonary embolism)",
       "highlight": "Low O2 states (e.g. heart attack, stroke, and pulmonary embolism)",
       "scope": "on-scope",
       "note": "Exact cited DELIRIUM(S) mnemonic 'L' entry; heart attack = MI, plus stroke and pulmonary embolism, matching the claim's low-O2 causes.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "Consider respiratory failure (PCO2 greater than 45 mmHg or PO2 less than 55 mmHg or oxygen saturation less than 88%). Consider causes such as COPD, ARDS, PE",
       "highlight": "Consider causes such as COPD, ARDS, PE",
       "scope": "background",
       "note": "This is the separate, similarly named 'ICU DELIRIUM(S)' risk-factor mnemonic (its R/M/I lines also list PE, myocardial infarction, and stroke); shares the low-O2/respiratory keywords but is a distinct list, not the cited SLU GEMS differential.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "THINK What to THINK about when delirium is present T Toxic Situations CHF, shock, dehydration Deliriogenic meds (Tight Titration) New organ failure, e.g, liver, kidney H Hypoxemia",
       "highlight": "H Hypoxemia",
       "scope": "background",
       "note": "The THINK mnemonic lists Hypoxemia as a reversible factor; overlaps the low-O2 concept but is a different mnemonic than the cited DELIRIUM(S) differential.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      }
     ]
    },
    {
     "label": "Flaherty 2011",
     "cite": "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited (Med Clin North Am. 2011;95(3):555-577) as a corroborating review of delirium evaluation/reversible causes in older persons; full text not archived, referenced by citation only.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/21549878/",
     "paragraphs": []
    },
    {
     "label": "Maldonado 2018",
     "cite": "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited (Int J Geriatr Psychiatry. 2018;33(11):1428-1457) for the pathophysiologic basis linking hypoxia/impaired oxidative metabolism to delirium; not archived, referenced by citation/DOI only.",
     "docUrl": "https://doi.org/10.1002/gps.4823",
     "paragraphs": []
    }
   ],
   "synthesis": "The cited DELIRIUM(S) (SLU GEMS) mnemonic on the archived ICUDelirium.org page directly and unambiguously supports the claim's 'L — Low O2 states' line, listing heart attack (MI), stroke, and pulmonary embolism verbatim, so the source agrees; the tool's added 'Check SpO2, Hgb' is a reasonable operationalization not stated in the source, and Flaherty 2011 and Maldonado 2018 are unarchived corroborating references. The same page also carries other mnemonics (the similarly named 'ICU DELIRIUM(S)' risk-factor list and THINK's 'Hypoxemia') that share the low-O2/MI/stroke keywords but are distinct lists and must not be read as the cited support — the SLU GEMS DELIRIUM(S) differential governs.",
   "discrepancy": true
  },
  {
   "id": "icu-r14",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "DELIRIUM(S) causative factors",
   "statement": "I — Infection: Fever, leukocytosis, cultures pending? Occult sepsis?",
   "contentType": "Cited clinical content",
   "sources": [
    "DELIRIUM(S)",
    "Flaherty 2011",
    "Maldonado 2018"
   ],
   "anchor": "DELIRIUM(S): \"Infection\"",
   "passage": "The fever, leukocytosis, and occult-sepsis details are clinical elaboration of the source's \"Infection\" category.",
   "evidence": "Web page",
   "status": "web",
   "pageNum": null,
   "citations": [
    "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
    "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
    "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457."
   ],
   "links": [
    "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
    "https://pubmed.ncbi.nlm.nih.gov/21549878/",
    "https://doi.org/10.1002/gps.4823"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "DELIRIUM(S)",
     "cite": "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Archived Vanderbilt CIBS Center / ICUDelirium.org Terminology & Mnemonics page: the DELIRIUM(S) differential lists Infection directly, and the companion ICU DELIRIUM(S) mnemonic grounds the 'occult sepsis' gloss.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
     "paragraphs": [
      {
       "context": "DELIRIUM(S) Differential diagnosis for patients with Delirium (Remember: delirium usually has more than one cause) D Drugs E Eyes, ears, and other sensory deficits L Low O2 states (e.g. heart attack, stroke, and pulmonary embolism) I Infection R Retention (of urine or stool)",
       "highlight": "I Infection R Retention (of urine or stool)",
       "scope": "on-scope",
       "note": "This is the exact DELIRIUM(S) differential-diagnosis mnemonic the tool's item derives from, with Infection as the 'I'.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "I nfection Sepsis and severe sepsis. Especially urinary, respiratory tract infections.",
       "highlight": "I nfection Sepsis and severe sepsis. Especially urinary, respiratory tract infections.",
       "scope": "on-scope",
       "note": "Same page, same ICU-adult population: the ICU DELIRIUM(S) risk-factor mnemonic specifies infection as sepsis (esp. urinary/respiratory), supporting the statement's 'occult sepsis?' elaboration.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      }
     ]
    },
    {
     "label": "Flaherty 2011",
     "cite": "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited by the DELIRIUM(S) section (Med Clin North Am 2011;95(3):555-577); not archived (file null) — geriatric delirium evaluation reference offering background on infection as a reversible precipitant.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/21549878/",
     "paragraphs": []
    },
    {
     "label": "Maldonado 2018",
     "cite": "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited by the DELIRIUM(S) section (Int J Geriatr Psychiatry 2018;33(11):1428-1457); not archived (file null) — pathophysiology review giving mechanistic background linking systemic infection/sepsis to delirium.",
     "docUrl": "https://doi.org/10.1002/gps.4823",
     "paragraphs": []
    }
   ],
   "synthesis": "The archived ICUDelirium.org (Vanderbilt CIBS Center) page directly lists Infection as the 'I' in the DELIRIUM(S) differential and, in its companion ICU DELIRIUM(S) risk-factor mnemonic, specifies sepsis (especially urinary and respiratory) — squarely supporting the tool's 'I — Infection … occult sepsis' item, and the DELIRIUM(S) mnemonic is the governing on-scope source. Flaherty 2011 and Maldonado 2018 are unarchived journal references (file null) that add only geriatric-evaluation and pathophysiologic background, so the archived page and the two citations agree.",
   "discrepancy": false
  },
  {
   "id": "icu-r15",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "DELIRIUM(S) causative factors",
   "statement": "R — Retention: Urinary retention or constipation? Bladder scan; treat if indicated.",
   "contentType": "Cited clinical content",
   "sources": [
    "DELIRIUM(S)",
    "Flaherty 2011",
    "Maldonado 2018"
   ],
   "anchor": "DELIRIUM(S): \"Retention (of urine or stool)\"",
   "passage": "",
   "evidence": "Web page",
   "status": "web",
   "pageNum": null,
   "citations": [
    "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
    "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
    "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457."
   ],
   "links": [
    "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
    "https://pubmed.ncbi.nlm.nih.gov/21549878/",
    "https://doi.org/10.1002/gps.4823"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "DELIRIUM(S)",
     "cite": "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Archived Vanderbilt CIBS Center Terminology & Mnemonics page; the DELIRIUM(S) differential-diagnosis mnemonic and the ICU DELIRIUM(S) risk-factor mnemonic both name retention as a reversible cause of delirium. Site navigation/boilerplate ignored.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
     "paragraphs": [
      {
       "context": "DELIRIUM(S) Differential diagnosis for patients with Delirium (Remember: delirium usually has more than one cause) D Drugs E Eyes, ears, and other sensory deficits L Low O2 states (e.g. heart attack, stroke, and pulmonary embolism) I Infection R Retention (of urine or stool)",
       "highlight": "R Retention (of urine or stool)",
       "scope": "on-scope",
       "note": "The DELIRIUM(S) differential-diagnosis mnemonic lists retention of urine or stool as a reversible delirium cause to check - the exact cited item behind the claim's primaryAnchor.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "U rinary/faecal retention Consider urinary retention or fecal impaction, especially in elderly and in postoperative patients",
       "highlight": "Consider urinary retention or fecal impaction, especially in elderly and in postoperative patients",
       "scope": "on-scope",
       "note": "The ICU DELIRIUM(S) risk-factor mnemonic on the same page gives the ICU-specific, more detailed version of the same retention concept (urinary retention or fecal impaction, especially postoperative).",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      }
     ]
    },
    {
     "label": "Flaherty 2011",
     "cite": "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited by the DELIRIUM(S) causative-factors section for evaluation/management of reversible delirium precipitants including retention (Med Clin North Am 2011;95(3):555-577); no archived text file, could not be verified against the wording.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/21549878/",
     "paragraphs": []
    },
    {
     "label": "Maldonado 2018",
     "cite": "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited for delirium pathophysiology framing reversible precipitants such as retention (Int J Geriatr Psychiatry 2018;33(11):1428-1457); no archived text file, could not be verified against the wording.",
     "docUrl": "https://doi.org/10.1002/gps.4823",
     "paragraphs": []
    }
   ],
   "synthesis": "The archived DELIRIUM(S) mnemonic page directly supports the cited retention item (\"Retention (of urine or stool)\" = urinary retention or constipation), and the ICU DELIRIUM(S) risk-factor mnemonic on the same page reinforces it in the ICU/postoperative population; this on-scope source governs. The management detail (\"Bladder scan; treat if indicated\") is not present in the archived mnemonic and rests on the unarchived Flaherty 2011 / Maldonado 2018 references, which could not be text-verified but are consistent background. Sources agree on retention as a reversible delirium cause.",
   "discrepancy": false
  },
  {
   "id": "icu-r16",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "DELIRIUM(S) causative factors",
   "statement": "I — Ictal / Seizure: Consider non-convulsive seizures — especially unexplained ↓LOC. Consider EEG.",
   "contentType": "Cited clinical content",
   "sources": [
    "DELIRIUM(S)",
    "Flaherty 2011",
    "Maldonado 2018"
   ],
   "anchor": "DELIRIUM(S): \"Ictal state\"",
   "passage": "The source entry is limited to \"ictal state\"; the non-convulsive-seizure emphasis and the EEG step are clinical elaboration.",
   "evidence": "Web page",
   "status": "web",
   "pageNum": null,
   "citations": [
    "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
    "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
    "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457."
   ],
   "links": [
    "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
    "https://pubmed.ncbi.nlm.nih.gov/21549878/",
    "https://doi.org/10.1002/gps.4823"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "DELIRIUM(S)",
     "cite": "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Archived ICUDelirium.org Terminology & Mnemonics page (DELIRIUM(S) adapted from SLU GEMS). It confirms the mnemonic letter 'I = Ictal state' but is silent on non-convulsive seizures, unexplained decreased LOC, and EEG — those elaborations rest on the two unarchived clinical references.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
     "paragraphs": [
      {
       "context": "DELIRIUM(S) Differential diagnosis for patients with Delirium (Remember: delirium usually has more than one cause) D Drugs E Eyes, ears, and other sensory deficits L Low O2 states (e.g. heart attack, stroke, and pulmonary embolism) I Infection R Retention (of urine or stool) I Ictal state",
       "highlight": "I Ictal state",
       "scope": "on-scope",
       "note": "Directly establishes that 'I' in the DELIRIUM(S) differential stands for 'Ictal state' - the exact mnemonic label the tool cites for this item.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "C NS pathology Abscess, hemorrhage, hydrocephalus, subdural hematoma, Infection, seizures, stroke, tumors, metastases, vasculitis, Encephalitis, meningitis, syphilis",
       "highlight": "Infection, seizures, stroke, tumors",
       "scope": "broader",
       "note": "A different delirium-differential mnemonic (I WATCH DEATH) on the same page that folds seizures into a broad CNS-pathology list; shares the seizure keyword but is not the cited DELIRIUM(S) 'Ictal state' item.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      }
     ]
    },
    {
     "label": "Flaherty 2011",
     "cite": "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Paywalled, not archived (cited by section/DOI: Med Clin North Am. 2011;95(3):555-577). Supplies the clinical elaboration that seizures/ictal causes — including non-convulsive seizures presenting with unexplained decreased LOC — belong in the delirium workup; text not available to quote.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/21549878/",
     "paragraphs": []
    },
    {
     "label": "Maldonado 2018",
     "cite": "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Paywalled, not archived (cited by section/DOI: Int J Geriatr Psychiatry. 2018;33(11):1428-1457). Provides pathophysiologic support for seizure/ictal activity as an etiologic contributor to acute brain failure; text not available to quote.",
     "docUrl": "https://doi.org/10.1002/gps.4823",
     "paragraphs": []
    }
   ],
   "synthesis": "The archived ICUDelirium.org DELIRIUM(S) page (adapted from SLU GEMS) directly confirms the tool's mnemonic label that \"I = Ictal state,\" which governs the letter; but the specific guidance to consider non-convulsive seizures — especially with unexplained decreased LOC — and to obtain an EEG is not stated on that page and rests on the two unarchived clinical references (Flaherty 2011, Maldonado 2018). No source contradicts the claim; the DELIRIUM(S) page is partial (silent on the EEG / non-convulsive detail) and its separate I WATCH DEATH mnemonic is a broader, different-scope nearest match that also names seizures.",
   "discrepancy": true
  },
  {
   "id": "icu-r17",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "DELIRIUM(S) causative factors",
   "statement": "U — Under-hydration / Nutrition: Volume status, intake, electrolytes. Thiamine promptly in at-risk patients — do not delay glucose.",
   "contentType": "Cited clinical content",
   "sources": [
    "DELIRIUM(S)",
    "Flaherty 2011",
    "Maldonado 2018"
   ],
   "anchor": "DELIRIUM(S): \"Underhydration/undernutrition\"",
   "passage": "The thiamine-before-glucose point is not part of this entry; in the source, thiamine appears under the I WATCH DEATH mnemonic (\"Deficiencies\") rather than the DELIRIUM(S) U entry.",
   "evidence": "Web page",
   "status": "web",
   "pageNum": null,
   "citations": [
    "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
    "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
    "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457."
   ],
   "links": [
    "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
    "https://pubmed.ncbi.nlm.nih.gov/21549878/",
    "https://doi.org/10.1002/gps.4823"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "DELIRIUM(S)",
     "cite": "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Directly backs the mnemonic label and electrolyte element; silent on the thiamine-before-glucose guidance, whose only nearby keyword sits in a different mnemonic.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
     "paragraphs": [
      {
       "context": "DELIRIUM(S) Differential diagnosis for patients with Delirium (Remember: delirium usually has more than one cause) D Drugs E Eyes, ears, and other sensory deficits L Low O2 states (e.g. heart attack, stroke, and pulmonary embolism) I Infection R Retention (of urine or stool) I Ictal state U Underhydration/undernutrition",
       "highlight": "U Underhydration/undernutrition",
       "scope": "on-scope",
       "note": "The DELIRIUM(S) differential mnemonic's 'U' is 'Underhydration/undernutrition', with electrolyte/metabolic captured under 'M', directly supporting the statement's under-hydration/nutrition and electrolytes elements.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "D eficiencies Vitamin B12, folate, niacin, thiamine",
       "highlight": "D eficiencies Vitamin B12, folate, niacin, thiamine",
       "scope": "different-intervention",
       "note": "The page's only thiamine reference is in the separate I WATCH DEATH mnemonic, framing thiamine deficiency as a diagnostic cause; it does not support the statement's give-thiamine-promptly / do-not-delay-glucose prophylaxis guidance.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      }
     ]
    },
    {
     "label": "Flaherty 2011",
     "cite": "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Unarchived (full text not held); cited in this section by citation/DOI as support for evaluating and managing under-hydration/undernutrition, including thiamine, in delirium.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/21549878/",
     "paragraphs": []
    },
    {
     "label": "Maldonado 2018",
     "cite": "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Unarchived (full text not held); cited by citation/DOI for the pathophysiologic basis linking metabolic and nutritional derangements to delirium.",
     "docUrl": "https://doi.org/10.1002/gps.4823",
     "paragraphs": []
    }
   ],
   "synthesis": "The archived DELIRIUM(S) page directly supplies the on-scope \"U — Underhydration/undernutrition\" letter plus the electrolyte/metabolic element (\"M\"), so it governs the mnemonic-label portion of the statement; its only thiamine reference sits in a different mnemonic (I WATCH DEATH) as a deficiency cause and it never mentions giving thiamine before glucose, so the \"thiamine promptly / do not delay glucose\" prophylaxis guidance rests on the unarchived Flaherty 2011 and Maldonado 2018 citations. The sources are complementary rather than conflicting.",
   "discrepancy": true
  },
  {
   "id": "icu-r18",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "DELIRIUM(S) causative factors",
   "statement": "M — Metabolic: Na, Mg, Ca, glucose, BUN/Cr, acid–base, liver function.",
   "contentType": "Cited clinical content",
   "sources": [
    "DELIRIUM(S)",
    "Flaherty 2011",
    "Maldonado 2018"
   ],
   "anchor": "DELIRIUM(S): \"Metabolic causes (DM, Post-operative state, Sodium abnormalities)\"",
   "passage": "Support is at the category level; the source's named examples (diabetes, the post-operative state, sodium abnormalities) do not itemize the statement's fuller laboratory list.",
   "evidence": "Web page",
   "status": "web",
   "pageNum": null,
   "citations": [
    "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
    "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
    "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457."
   ],
   "links": [
    "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
    "https://pubmed.ncbi.nlm.nih.gov/21549878/",
    "https://doi.org/10.1002/gps.4823"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "DELIRIUM(S)",
     "cite": "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "partial",
     "note": "The DELIRIUM(S) mnemonic on this page (SLU GEMS) — the exact instrument the tool section cites — confirms M = Metabolic and names sodium abnormalities and DM (glucose), but the DELIRIUM(S) line itself does not itemize Mg, Ca, BUN/Cr, acid–base, or liver function; those specifics appear only in sibling mnemonics on the same page.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
     "paragraphs": [
      {
       "context": "Metabolic causes (DM, Post-operative state, Sodium abnormalities)",
       "highlight": "Metabolic causes (DM, Post-operative state, Sodium abnormalities)",
       "scope": "on-scope",
       "note": "The cited DELIRIUM(S) differential maps M to Metabolic causes and names sodium abnormalities and DM (glucose); the source line interleaves an overlay fragment ('K+ or Electrolyte problems') but the metabolic phrase is intact and directly supports the tool's M item.",
       "page": "Terminology & Mnemonics",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "DELIRIOUS D Drugs (continuous drips, Na+, Ca+, BUN/Cr, NH3+) E Environmental factors (hearing aids, eye glasses, sleep/wake cycle) L Labs (including Na+, K+, Ca+, BUN/Cr, NH3+)",
       "highlight": "L Labs (including Na+, K+, Ca+, BUN/Cr, NH3+)",
       "scope": "different-intervention",
       "note": "A separate mnemonic (DELIRIOUS) on the same page that itemizes Na, Ca, and BUN/Cr - the very labs the tool lists under M - but it is a different instrument than DELIRIUM(S), so its keyword overlap is not direct support for the DELIRIUM(S) M item.",
       "page": "Terminology & Mnemonics",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "L aboratory abnormalities Especially hyponatremia, azotemia, hyperbilirubinemia, hypocalcemia and metabolic acidosis",
       "highlight": "Especially hyponatremia, azotemia, hyperbilirubinemia, hypocalcemia and metabolic acidosis",
       "scope": "different-intervention",
       "note": "The 'ICU DELIRIUM(S)' risk-factor mnemonic shares the DELIRIUM(S) name but is a different instrument (its M = Myocardial); it lists the metabolic derangements (hyponatremia, azotemia=BUN, hypocalcemia, metabolic acidosis) under L, so the name collision must not be read as the same M item.",
       "page": "Terminology & Mnemonics",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "A cute metabolic Acidosis, alkalosis, electrolyte disturbance, hepatic failure, renal failure",
       "highlight": "Acidosis, alkalosis, electrolyte disturbance, hepatic failure, renal failure",
       "scope": "different-intervention",
       "note": "The I WATCH DEATH mnemonic on the same page covers the acid-base and liver-function items the tool lists, but under a separate differential-diagnosis instrument, not DELIRIUM(S).",
       "page": "Terminology & Mnemonics",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      }
     ]
    },
    {
     "label": "Flaherty 2011",
     "cite": "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited in this section as a supporting reference for the metabolic/electrolyte evaluation of delirium in older persons (Med Clin North Am 2011;95(3):555-577); no archived text available to verify wording against the statement.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/21549878/",
     "paragraphs": []
    },
    {
     "label": "Maldonado 2018",
     "cite": "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited as background on delirium pathophysiology, including metabolic contributors to acute brain failure (Int J Geriatr Psychiatry 2018;33(11):1428-1457); no archived text available to verify wording against the statement.",
     "docUrl": "https://doi.org/10.1002/gps.4823",
     "paragraphs": []
    }
   ],
   "synthesis": "The archived DELIRIUM(S) mnemonic (SLU GEMS, reproduced on ICUDelirium.org) is the governing on-scope source and confirms the tool's mapping that M denotes Metabolic causes, explicitly naming sodium abnormalities (Na) and DM (glucose); it partially supports the statement, because the DELIRIUM(S) line itself does not itemize Mg, Ca, BUN/Cr, acid–base, or liver function. Those additional labs are a clinically consistent elaboration whose specifics appear only in the parallel mnemonics on the same page (DELIRIOUS: Ca, BUN/Cr; I WATCH DEATH: acid–base, hepatic/liver failure; the separately-named ICU DELIRIUM(S) risk-factor list: hypocalcemia, azotemia, metabolic acidosis) — different instruments that share keywords but must not be read as direct support for the DELIRIUM(S) M item.",
   "discrepancy": true
  },
  {
   "id": "icu-r19",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "DELIRIUM(S) causative factors",
   "statement": "(S) — Subdural / Sleep: Subdural hematoma (fall or anticoagulation)? Sleep deprivation?",
   "contentType": "Cited clinical content",
   "sources": [
    "DELIRIUM(S)",
    "Flaherty 2011",
    "Maldonado 2018"
   ],
   "anchor": "DELIRIUM(S): \"Subdural hematoma\"",
   "passage": "The (S) entry covers subdural hematoma only, with the fall/anticoagulation context matching; sleep deprivation is not part of this entry and appears in the source as a separate delirium factor.",
   "evidence": "Web page — partial support",
   "status": "web",
   "pageNum": null,
   "citations": [
    "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
    "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
    "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457."
   ],
   "links": [
    "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
    "https://pubmed.ncbi.nlm.nih.gov/21549878/",
    "https://doi.org/10.1002/gps.4823"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "DELIRIUM(S)",
     "cite": "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Archived ICUDelirium.org page; the DELIRIUM(S) mnemonic supplies the (S) = Subdural hematoma, and the sibling ICU DELIRIUM(S) mnemonic supplies the sleep-deprivation cause, together covering both halves of the claim.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
     "paragraphs": [
      {
       "context": "(S) Subdural hematoma",
       "highlight": "(S) Subdural hematoma",
       "scope": "on-scope",
       "note": "The SLU-GEMS-adapted DELIRIUM(S) differential names (S) = Subdural hematoma, directly supporting the subdural half of the claim; the surrounding M line is layout-garbled but the (S) Subdural hematoma phrase is intact.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "S leep and Sensory deprivation Consider the alterations of the sleep cycle and sleep deprivation.",
       "highlight": "Consider the alterations of the sleep cycle and sleep deprivation",
       "scope": "on-scope",
       "note": "The ICU DELIRIUM(S) risk-factor mnemonic's (S) = Sleep and Sensory deprivation directly supports the sleep-deprivation half of the claim, drawn from the same source page.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      },
      {
       "context": "C NS pathology Abscess, hemorrhage, hydrocephalus, subdural hematoma, Infection, seizures, stroke, tumors, metastases, vasculitis, Encephalitis, meningitis, syphilis",
       "highlight": "hydrocephalus, subdural hematoma, Infection, seizures",
       "scope": "broader",
       "note": "The separate I WATCH DEATH general delirium differential also lists subdural hematoma, sharing the keyword but as part of a broad differential rather than the ICU DELIRIUM(S) causative-factors framework, so it is a nearest match at a different scope.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      }
     ]
    },
    {
     "label": "Flaherty 2011",
     "cite": "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Unarchived; cited for the older-persons delirium evaluation/differential (Med Clin North Am. 2011;95(3):555-577) that underpins the subdural (fall/anticoagulation) and sleep-deprivation causative factors. No text file to verify.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/21549878/",
     "paragraphs": []
    },
    {
     "label": "Maldonado 2018",
     "cite": "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Unarchived; cited for delirium pathophysiology/etiology (Int J Geriatr Psychiatry. 2018;33(11):1428-1457), including sleep-deprivation contributions to acute brain failure. No text file to verify.",
     "docUrl": "https://doi.org/10.1002/gps.4823",
     "paragraphs": []
    }
   ],
   "synthesis": "The ICUDelirium.org Terminology & Mnemonics page directly supports both halves of the (S) item: \"Subdural hematoma\" is the (S) of the SLU-GEMS-adapted DELIRIUM(S) differential (the primary on-scope match), and \"sleep deprivation\" is the (S) of the sibling ICU DELIRIUM(S) risk-factor mnemonic on the same page; this page governs the mnemonic itself, while the \"(fall or anticoagulation)\" elaboration and older-persons/pathophysiology context are carried by the unarchived Flaherty 2011 and Maldonado 2018. A separate general I WATCH DEATH mnemonic on the page also lists subdural hematoma but within a broader delirium differential rather than the ICU causative-factors framework, so it is a nearest keyword match at a different scope, not additional direct support.",
   "discrepancy": true
  },
  {
   "id": "icu-r20",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Reorientation",
   "statement": "Clock and calendar visible",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "PADIS 2018 — p. 25",
   "passage": "Copyright © 2018 by the Society of Critical Care Medicine and Wolters Kluwer Health, Inc. All Rights Reserved. Devlin et al e848 www.ccmjournal.org September 2018 • Volume 46 • Number 9 Recommendation: We suggest using a multicomponent, nonpharmacologic intervention that is focused on (but not limited to) reducing modifiable risk factors for delirium, improving cognition, and optimizing sleep, mobility, hearing, and vision in critically ill adults (conditional recommendation, low quality of evidence). Remarks: These multicomponent interventions include (but are not limited to) strategies to reduce or shorten delirium (e.g., reorientation, cognitive stimulation, use of clocks) ; improve sleep (e.g., minimizing light and noise); improve wakefulness (i.e., reduced sedation); reduce immobility (e.g., early rehabilitation/mobilization); and reduce hearing and/or visual impairment (e.g., enable use of devices such as hearing aids or eye glasses). Rationale: The multicomponent intervention studies evaluated a bundle of interventions. Many examples of multicomponent bundles (8, 283, 391-396) have shown improved outcomes in critically ill adults (Supplemental Table 29, Supplemental Digital Content 37, http://links.lww.com/CCM/ D795). …\nThe passage supports a visible clock for reorientation; a visible calendar specifically is not itemized in the cited sources.",
   "evidence": "Full text, p. 25 — partial support",
   "status": "fulltext",
   "pageNum": "25",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived SCCM web page (with site navigation boilerplate) that establishes the ABCDEF bundle and its D (Delirium) element; it contains no reorientation, clock, or calendar content.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "The ICU Liberation Bundle consists of the following individual elements A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs) C Element : Choice of Analgesia and Sedation D Element : Delirium: Assess, Prevent, and Manage E Element: Early Mobility and Exercise F Element : Family Engagement and Empowerment",
       "highlight": "D Element : Delirium: Assess, Prevent, and Manage",
       "scope": "background",
       "note": "Enumerates the bundle's D (Delirium: Assess, Prevent, and Manage) element without describing the specific reorientation cue (clock/calendar).",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "background",
     "note": "ICU Liberation Collaborative outcomes study of the ABCDEF bundle; it names the D (Delirium) element but does not address reorientation, clocks, or calendars.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "To our knowledge, few studies to date have specifically focused on evaluating integrated, interprofessional approaches to symptom management during critical illness. One such approach is known as the ABCDEF bundle (Assess, prevent, and manage pain; Both spontaneous awakening and breathing trials: Choice of Analgesia and Sedation; Delirium assess, prevent, and manage; Early Mobility and Exercise; Family engagement/ empowerment) (14-18). The ABCDEF bundle differs from other evidence-based, multicomponent ICU interventions (19-23) in several ways. First, it is applicable to every ICU patient every day, regardless of mechanical ventilation status or admitting diagnosis. Second, as it focuses on symptom assessment, prevention, and management rather than disease processes, it is particularly relevant early during the course of critical illness and is suitable for use in conjunction with other life-sustaining therapies. The team-based ABCDEF bundle approach is also unique in that its ultimate goal is to produce patients who are more awake, cognitively engaged, and physically active, which ultimately serves to facilitate patient autonomy and the ability to express unmet physical, emotional, and spiritual needs.",
       "highlight": "Delirium assess, prevent, and manage",
       "scope": "background",
       "note": "Lists the D element of the ABCDEF bundle as bundle context, but gives no detail on the reorientation intervention itself.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "ABCDEF-bundle review that discusses ICU nonpharmacologic delirium prevention but names a different intervention set (sleep hygiene + mobilization), not reorientation/clock/calendar.",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "The only strategy strongly recommended in the PAD Guidelines, to reduce the incidence and duration of ICU delirium and to improve functional outcomes, is promoting sleep hygiene to prevent sleep disruption and the use of early and progressive mobilization and in these patients.",
       "highlight": "promoting sleep hygiene to prevent sleep disruption and the use of early and progressive mobilization",
       "scope": "different-intervention",
       "note": "Same ICU setting and delirium-prevention goal, but the strongly recommended nonpharmacologic strategies it names are sleep hygiene and early mobilization, not a visible clock/calendar for reorientation.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope governing source: recommends a multicomponent nonpharmacologic intervention in critically ill adults that explicitly names reorientation and use of clocks.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Remarks: These multicomponent interventions include (but are not limited to) strategies to reduce or shorten delirium (e.g., reorientation, cognitive stimulation, use of clocks); improve sleep (e.g., minimizing light and noise); improve wakefulness (i.e., reduced sedation); reduce immobility (e.g., early rehabilitation/mobilization); and reduce hearing and/or visual impairment (e.g., enable use of devices such as hearing aids or eye glasses).",
       "highlight": "reorientation, cognitive stimulation, use of clocks",
       "scope": "on-scope",
       "note": "Directly supports a visible clock/reorientation cue for adult ICU patients; PADIS names clocks and reorientation explicitly (calendars are a conventional reorientation aid grouped under reorientation rather than separately enumerated).",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Recommendation: We suggest using a multicomponent, nonpharmacologic intervention that is focused on (but not limited to) reducing modifiable risk factors for delirium, improving cognition, and optimizing sleep, mobility, hearing, and vision in critically ill adults (conditional recommendation, low quality of evidence).",
       "highlight": "improving cognition, and optimizing sleep, mobility, hearing, and vision in critically ill adults",
       "scope": "on-scope",
       "note": "The formal conditional recommendation framing the multicomponent nonpharmacologic bundle for critically ill adults within which reorientation/clocks sit.",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "background",
     "note": "HELP RCT provides the foundational reorientation evidence but in hospitalized medical patients aged 70+ (not ICU), using an orientation board rather than a bedside clock/calendar.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — cognitive impairment. Eligible patients: All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily. Standardized intervention protocols: Orientation protocol: board with names of care-team members and day’s schedule; communication to reorient to surroundings. Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games). Targeted outcome for reassessment: Change in orientation score.",
       "highlight": "board with names of care-team members and day’s schedule; communication to reorient to surroundings",
       "scope": "different-population",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "Table of HELP intervention protocols flattened into run-on text; row labels merged and truncated mid-word at both ends."
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "background",
     "note": "Meta-analysis of HELP-type multicomponent nonpharmacologic delirium interventions in hospitalized (largely older, non-ICU) patients; reorientation is a component but clocks/calendars are not separately specified.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations",
       "scope": "different-population",
       "note": "Reorientation appears as one HELP component, but the pooled population is hospitalized older adults across wards, not the adult ICU, and no bedside clock/calendar cue is specified.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2018 is the on-scope governing source: its conditional recommendation for a multicomponent nonpharmacologic intervention in critically ill adults explicitly names reorientation and the use of clocks (journal page e847), directly supporting a visible bedside clock/reorientation cue — calendars being a conventional reorientation aid grouped under reorientation rather than separately enumerated. The remaining sources are nearest matches at a different scope: Inouye 1999 (HELP) and Hshieh 2015 supply the foundational reorientation evidence but in hospitalized older non-ICU populations (and via an orientation board), Marra 2017 names sleep hygiene and early mobilization rather than reorientation for ICU delirium, and Pun 2019 plus the SCCM page establish ABCDEF-bundle context without addressing the specific cue.",
   "discrepancy": true
  },
  {
   "id": "icu-r21",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Reorientation",
   "statement": "Whiteboard updated (date, team, goals)",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "Inouye 1999 — p. 3, ¶60",
   "passage": "Cognitive impairment* All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily Orientation protocol: board with names of care-team members and day's schedule; communication to reorient to surroundings Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games) Change in orientation score Sleep deprivation All patients; need for protocol assessed once daily Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures) Change in rate of use of sedative drug for sleep† Immobility All patients; ambulation …",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Remarks: These multicomponent interventions include (but are not limited to) strategies to reduce or shorten delirium (e.g., reorientation, cognitive stimulation, use of clocks); improve sleep (e.g., minimizing light and noise); improve wakefulness (i.e., reduced sedation); reduce immobility (e.g., early rehabilitation/mobilization); and reduce hearing and/or visual impairment (e.g., enable use of devices such as hearing aids or eye glasses).",
       "highlight": "reorientation, cognitive stimulation, use of clocks",
       "scope": "on-scope",
       "note": "PADIS, the 2018 ICU guideline, lists reorientation and use of clocks among multicomponent non-pharmacologic strategies to reduce delirium in critically ill adults — the setting-matched basis for a reorientation whiteboard.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Recommendation: We suggest using a multicomponent, nonpharmacologic intervention that is focused on (but not limited to) reducing modifiable risk factors for delirium, improving cognition, and optimizing sleep, mobility, hearing, and vision in critically ill adults (conditional recommendation, low quality of evidence).",
       "highlight": "improving cognition, and optimizing sleep, mobility, hearing, and vision in critically ill adults",
       "scope": "on-scope",
       "note": "The formal recommendation endorsing multicomponent non-pharmacologic delirium prevention in critically ill adults, the ICU umbrella under which reorientation sits.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "STANDARDIZED INTERVENTION PROTOCOLS Orientation protocol: board with names of care-team members and day's schedule; communication to reorient to surroundings Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games) Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures) Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints) Vision protocol: visual aids (e.g., glasses or magnifying lenses) and adaptive equipment (e.g., large illuminated telephone keypads, large-print books, and fluorescent tape on call bell), with daily reinforcement of their use Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques, with daily reinforcement of these adaptations Dehydration protocol: early recognition of dehydration and volume repletion (i.e., encouragement of oral intake of fluids)",
       "highlight": "board with names of care-team members and day's schedule",
       "scope": "on-scope",
       "note": "The HELP orientation protocol specifies a board listing care-team members and the day's schedule — the direct source of the whiteboard's team and goals content; note HELP was studied in hospitalized older patients on general wards, not the ICU.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived SCCM web page (stored as a pdf-kind source); most of the file is site navigation, so the anchor is the bundle-content sentence, not menu items.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "The ICU Liberation Bundle consists of the following individual elements A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs) C Element : Choice of Analgesia and Sedation D Element : Delirium: Assess, Prevent, and Manage E Element: Early Mobility and Exercise F Element : Family Engagement and Empowerment",
       "highlight": "D Element : Delirium: Assess, Prevent, and Manage",
       "scope": "broader",
       "note": "Defines the ICU Liberation (ABCDEF) bundle's D element umbrella for delirium assess/prevent/manage, under which non-pharmacologic reorientation lives, but the page never specifies a reorientation whiteboard.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "To our knowledge, few studies to date have specifically focused on evaluating integrated, interprofessional approaches to symptom management during critical illness. One such approach is known as the ABCDEF bundle (Assess, prevent, and manage pain; Both spontaneous awakening and breathing trials: Choice of Analgesia and Sedation; Delirium assess, prevent, and manage; Early Mobility and Exercise; Family engagement/ empowerment) (14-18). The ABCDEF bundle differs from other evidence-based, multicomponent ICU interventions (19-23) in several ways. First, it is applicable to every ICU patient every day, regardless of mechanical ventilation status or admitting diagnosis. Second, as it focuses on symptom assessment, prevention, and management rather than disease processes, it is particularly relevant early during the course of critical illness and is suitable for use in conjunction with other life-sustaining therapies. The team-based ABCDEF bundle approach is also unique in that its ultimate goal is to produce patients who are more awake, cognitively engaged, and physically active, which ultimately serves to facilitate patient autonomy and the ability to express unmet physical, emotional, and spiritual needs.",
       "highlight": "Choice of Analgesia and Sedation; Delirium",
       "scope": "broader",
       "note": "Establishes the ABCDEF bundle (including the Delirium assess/prevent/manage element) across >15,000 ICU adults, but does not describe a reorientation whiteboard or its content.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "The only strategy strongly recommended in the PAD Guidelines, to reduce the incidence and duration of ICU delirium and to improve functional outcomes, is promoting sleep hygiene to prevent sleep disruption and the use of early and progressive mobilization and in these patients.",
       "highlight": "promoting sleep hygiene to prevent sleep disruption and the use of early and progressive mobilization",
       "scope": "different-intervention",
       "note": "Marra's ABCDEF review names the strongly-recommended non-pharmacologic delirium strategy as sleep hygiene plus early mobilization — a different intervention from a reorientation whiteboard, so this is nearest-but-different-scope background.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "b Evidence-based nonpharmacological interventions include the following: cognition or orientation (C), early mobility (E), hearing (H), sleep-wake cycle preservation (P), vision (V), and hydration (W).",
       "highlight": "cognition or orientation (C)",
       "scope": "different-population",
       "note": "Meta-analysis of multicomponent non-pharmacologic delirium prevention lists cognition/orientation (reorientation) as a core component, but pooled older hospitalized medical patients rather than critically ill ICU adults.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    }
   ],
   "synthesis": "The ICU-setting on-scope support is PADIS 2018, which recommends reorientation and use of clocks as multicomponent non-pharmacologic delirium prevention in critically ill adults, while the specific whiteboard content (care-team names and the day's schedule) traces to Inouye 1999's HELP orientation board — noting HELP was studied in hospitalized older non-ICU ward patients. The ABCDEF-bundle sources (SCCM, Pun 2019) frame reorientation only under the broader \"Delirium: assess, prevent, and manage\" element, Marra 2017's named non-pharm strategy is a different intervention (sleep hygiene plus mobilization), and Hshieh 2015 confirms reorientation as a component but in a different, older-inpatient population; none describe the whiteboard itself.",
   "discrepancy": true
  },
  {
   "id": "icu-r22",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Reorientation",
   "statement": "Verbal reorientation each encounter",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "Inouye 1999 — p. 3, ¶60",
   "passage": "Cognitive impairment* All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily Orientation protocol: board with names of care-team members and day's schedule; communication to reorient to surroundings Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games) Change in orientation score Sleep deprivation All patients; need for protocol assessed once daily Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures) Change in rate of use of sedative drug for sleep† Immobility All patients; ambulation …",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived SCCM web page (heavy nav boilerplate); establishes the ICU Liberation Bundle as implementing PADIS in every ICU patient and names the 'D' delirium-prevention element, but does not itself name verbal reorientation.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes while transforming culture.",
       "highlight": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes",
       "scope": "background",
       "note": "The ICU Liberation (ABCDEF) bundle is the umbrella under which this comfort, orientation, or sleep measure is delivered; the bundle resource endorses implementing these elements rather than stating this specific bedside line.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      },
      {
       "context": "The ICU Liberation Bundle consists of the following individual elements A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs) C Element : Choice of Analgesia and Sedation D Element : Delirium: Assess, Prevent, and Manage E Element: Early Mobility and Exercise F Element : Family Engagement and Empowerment",
       "highlight": "D Element : Delirium: Assess, Prevent, and Manage",
       "scope": "background",
       "note": "The bundle's D (delirium assess/prevent/manage) element encompasses non-pharm measures such as reorientation, but reorientation is not itemized here.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "background",
     "note": "ICU cohort/outcomes study of ABCDEF bundle performance; defines the 'D — Delirium assess, prevent, and manage' element (the on-scope ICU framework) but does not describe verbal reorientation as a specific practice.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "To our knowledge, few studies to date have specifically focused on evaluating integrated, interprofessional approaches to symptom management during critical illness. One such approach is known as the ABCDEF bundle (Assess, prevent, and manage pain; Both spontaneous awakening and breathing trials: Choice of Analgesia and Sedation; Delirium assess, prevent, and manage; Early Mobility and Exercise; Family engagement/ empowerment) (14-18). The ABCDEF bundle differs from other evidence-based, multicomponent ICU interventions (19-23) in several ways. First, it is applicable to every ICU patient every day, regardless of mechanical ventilation status or admitting diagnosis. Second, as it focuses on symptom assessment, prevention, and management rather than disease processes, it is particularly relevant early during the course of critical illness and is suitable for use in conjunction with other life-sustaining therapies. The team-based ABCDEF bundle approach is also unique in that its ultimate goal is to produce patients who are more awake, cognitively engaged, and physically active, which ultimately serves to facilitate patient autonomy and the ability to express unmet physical, emotional, and spiritual needs.",
       "highlight": "Delirium assess, prevent, and manage",
       "scope": "background",
       "note": "Defines the ICU ABCDEF bundle including the delirium prevent/manage element; supplies bundle context, not the reorientation intervention itself.",
       "page": "3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "ICU ABCDEF-bundle review (correct setting) but the nearest non-pharm delirium-prevention content names sleep hygiene and early mobilization as the strongly recommended strategies, not reorientation — a same-setting, different-intervention near match.",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "The only strategy strongly recommended in the PAD Guidelines, to reduce the incidence and duration of ICU delirium and to improve functional outcomes, is promoting sleep hygiene to prevent sleep disruption and the use of early and progressive mobilization and in these patients.",
       "highlight": "is promoting sleep hygiene to prevent sleep disruption and the use of early and progressive mobilization",
       "scope": "different-intervention",
       "note": "Nearest ICU non-pharm paragraph, but it endorses sleep hygiene + progressive mobilization as the strongly recommended measures, not verbal reorientation.",
       "page": "228",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      },
      {
       "context": "5. Early mobility is the only currently known intervention associated with a decrease in delirium duration. Physical therapy is safe and feasible in the ICU, even while on mechanical ventilation, renal replacement therapy, and/or circulatory support.",
       "highlight": "Early mobility is the only currently known intervention associated with a decrease in delirium duration",
       "scope": "different-intervention",
       "note": "Reinforces that within the ICU the singularly proven non-pharm measure is early mobility, not reorientation.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The on-scope governing source: the ICU practice guideline recommends a multicomponent nonpharmacologic intervention in critically ill adults and explicitly names reorientation as one of the delirium-reduction strategies.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Recommendation: We suggest using a multicomponent, nonpharmacologic intervention that is focused on (but not limited to) reducing modifiable risk factors for delirium, improving cognition, and optimizing sleep, mobility, hearing, and vision in critically ill adults (conditional recommendation, low quality of evidence).",
       "highlight": "optimizing sleep, mobility, hearing, and vision in critically ill adults",
       "scope": "on-scope",
       "note": "Formal conditional recommendation for a multicomponent nonpharmacologic delirium intervention in critically ill (ICU) adults.",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Remarks: These multicomponent interventions include (but are not limited to) strategies to reduce or shorten delirium (e.g., reorientation, cognitive stimulation, use of clocks); improve sleep (e.g., minimizing light and noise); improve wakefulness (i.e., reduced sedation); reduce immobility (e.g., early rehabilitation/mobilization); and reduce hearing and/or visual impairment (e.g., enable use of devices such as hearing aids or eye glasses).",
       "highlight": "reorientation, cognitive stimulation, use of clocks",
       "scope": "on-scope",
       "note": "Directly names reorientation as an ICU non-pharm strategy to reduce/shorten delirium — direct support for the claim.",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Rationale: The multicomponent intervention studies evaluated a bundle of interventions. Many examples of multicomponent bundles (8, 283, 391-396) have shown improved outcomes in critically ill adults (Supplemental Table 29, Supplemental Digital Content 37, http://links.lww.com/CCM/ D795). Pilot studies suggested that combining cognitive and physical therapy early during critical illness is feasible and safe (391) and using nonpharmacologic multicomponent interventions in ICU patients is feasible (392). Studies of multicomponent interventions, many of which were not randomized, focus on cognitive impairment (e.g., reorientation, cognitive stimulation, music, use of clocks); sedation/sleep disruption (e.g., reducing sedation, minimizing light and noise); immobility (early rehabilitation/mobilization); and hearing and visual impairment (e.g., use of hearing aids and glasses). Overall, the use of such strategies reduced delirium significantly (five studies, n = 1,318; OR, 0.59; 95% CI, 0.39-0.88) (392-396). Further, ICU duration of delirium (16 vs 20hr) (395), ICU LOS (387), and hospital mortality all decreased (393).",
       "highlight": "reduced delirium significantly (five studies, n = 1,318; OR, 0.59; 95% CI, 0.39-0.88)",
       "scope": "on-scope",
       "note": "Pooled ICU effect estimate for the multicomponent strategies that include reorientation.",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Foundational HELP RCT proving an orientation protocol (board + verbal reorientation) prevents delirium — but in hospitalized older (≥70) general-medicine inpatients, not ICU; supports the intervention, not the ICU scope.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — cognitive impairment. Eligible patients: All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily. Standardized intervention protocols: Orientation protocol: board with names of care-team members and day’s schedule; communication to reorient to surroundings. Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games). Targeted outcome for reassessment: Change in orientation score.",
       "highlight": "communication to reorient to surroundings",
       "scope": "different-population",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "Concatenated cells from Inouye's intervention-protocols table (Orientation/Therapeutic-activities/Sleep protocols), starting mid-sentence and truncated at '(e.g., si'."
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Meta-analysis showing multicomponent nonpharmacologic interventions that include reorientation reduce delirium incidence (OR 0.47) — but the evidence base is hospitalized elderly (largely HELP-derived), not ICU patients.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "including reorientation, early mobilization, therapeutic activities",
       "scope": "different-population",
       "note": "Lists reorientation as a core component of the pooled multicomponent interventions, but these are HELP-style programs for hospitalized elderly, not ICU.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "CONCLUSIONS AND RELEVANCE Multicomponent nonpharmacological delirium prevention interventions are effective in reducing delirium incidence and preventing falls, with a trend toward decreasing length of stay and avoiding institutionalization. Given the current focus on prevention of hospital-based complications and improved cost-effectiveness of care, this meta-analysis supports the use of these interventions to advance acute care for older persons.",
       "highlight": "effective in reducing delirium incidence",
       "scope": "different-population",
       "note": "Overall efficacy conclusion for reorientation-containing multicomponent bundles, drawn from non-ICU hospitalized-elderly studies.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "D elirium is an acute confusional state marked by inattention and global cognitive dysfunction. It is multifactorial and develops owing to interactions between risk factors and noxious insults.1 Common yet underdiagnosed, delirium is particularly prevalent among the hospitalized elderly, occurring in 29% to 64%, and contributes to more than $164 billion in health care costs in the United States annually.1,2 Delirium significantly increases risk of falls, functional decline, dementia, prolonged hospital length of stay, and institutionalization.3 The strong correlation between delirium and hospital-related falls has led to calls for delirium prevention quality metrics to improve hospital care and prevent falls in older persons.4 Most important, at least 30% to 40% of delirium cases are preventable.1,5,6 Surprisingly, most hospitals do not have delirium prevention programs or their protocols are inconsistently implemented, with variable adherence.1,7 Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations.",
       "highlight": "particularly prevalent among the hospitalized elderly",
       "scope": "different-population",
       "note": "Confirms the population of this evidence base is the hospitalized elderly, distinguishing it from the ICU setting of the claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2018 governs on-scope: it is the only source that directly supports the ICU claim, recommending a multicomponent nonpharmacologic intervention in critically ill adults and explicitly naming reorientation (with clocks and cognitive stimulation) among the delirium-reduction strategies, while the SCCM ICU Liberation bundle and Pun 2019 situate this within the ICU 'D' (Delirium: assess, prevent, manage) element without itemizing reorientation. The controlled efficacy evidence for reorientation itself is from hospitalized older non-ICU patients (Inouye 1999 HELP; Hshieh 2015 meta-analysis, OR 0.47), and Marra 2017 is a same-setting near match that names sleep hygiene and early mobilization — not reorientation — as the strongly recommended ICU non-pharm measures, so reorientation is warranted as one bundle element rather than an independently ICU-proven measure.",
   "discrepancy": true
  },
  {
   "id": "icu-r23",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Reorientation",
   "statement": "Family / familiar voice involvement",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "Marra 2017 — p. 9",
   "passage": "F: Family engagement The ABCDE bundle has evolved to include Family Engagement, as no ICU treatment plan is complete without incorporation of the family's wishes, concerns, questions, and participation. Family members and surrogate decision makers must become active partners in multi-professional decision-making and treatment planning. Through this partnership, patients' preferences can be identified, the anxiety of families can be lessened, and physicians can have appropriate input into decisions.67 Family presence on ICU rounds is beneficial, and it does not interfere with education and communication process.68 Families have reported increased feelings of inclusion, respect, and having a better understanding of their loved one's care. …\nThe cited sources support family involvement generally; the specific \"familiar voice\" reorientation element is not stated.",
   "evidence": "Full text, p. 9 — partial support",
   "status": "fulltext",
   "pageNum": "9",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived SCCM program landing page (heavy site navigation/boilerplate); the relevant content names bundle element F but does not describe a familiar-voice reorientation tactic.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "The ICU Liberation Bundle consists of the following individual elements A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs) C Element : Choice of Analgesia and Sedation D Element : Delirium: Assess, Prevent, and Manage E Element: Early Mobility and Exercise F Element : Family Engagement and Empowerment",
       "highlight": "F Element : Family Engagement and Empowerment",
       "scope": "broader",
       "note": "Names Family Engagement and Empowerment as ICU Liberation bundle element F — establishes family involvement as an ICU bundle element, broader than the specific reorientation/familiar-voice item.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "partial",
     "note": "ICU Liberation Collaborative in >15,000 ICU adults; supports family engagement as bundle element F but does not address reorientation or familiar voice.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "of the bundle elements performed. All three outcomes were significant (p < 0.0001). The covariates adjusted for include demographic variables (age, sex, race, ethnicity, body mass index, residence before admission, mobility restriction before admission), admission features (diagnosis, hospital type [community vs. teaching], and ICU type), and daily ICU characteristics on the day of bundle exposure (receipt of medications, including benzodiazepines, opioids, propofol, dexmedetomidine, typical/atypical antipsychotics; comfort care order; mechanical ventilation; coma). We also adjusted for delirium on the day of bundle exposure when looking at the association between the bundle and delirium. Patients were \"eligible to receive\" elements A, C, D, and E on all ICU days. Patients were eligible for element B if sedated (part 1, SAT) and/or mechanically ventilated (part 2, SBT), and were eligible for element F if family or another caregiver was present. Therefore, patients were eligible for a maximum of seven and a minimum of four elements on any given day; proportion of elements performed is the number of elements performed, divided by the elements the patient was eligible to receive.",
       "highlight": "were eligible for element F if family or another caregiver was present",
       "scope": "broader",
       "note": "Operationalizes bundle element F as family/caregiver presence in the ICU — supports family involvement broadly, not familiar-voice reorientation specifically.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "partial",
     "note": "The tool's primary anchor (p. 9, 'F: Family engagement'); describes family engagement/empowerment as decision-making partnership and presence, not familiar-voice reorientation.",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "The ABCDE bundle has evolved to include Family Engagement, as no ICU treatment plan is complete without incorporation of the family's wishes, concerns, questions, and participation. Family members and surrogate decision makers must become active partners in multi-professional decision-making and treatment planning. Through this partnership, patients' preferences can be identified, the anxiety of families can be lessened, and physicians can have appropriate input into decisions.67 Family presence on ICU rounds is beneficial, and it does not interfere with education and communication process.68 Families have reported increased feelings of inclusion, respect, and having a better understanding of their loved one's care.",
       "highlight": "Family members and surrogate decision makers must become active partners in multi-professional decision-making and treatment planning",
       "scope": "broader",
       "note": "Bundle element F framed as family engagement/empowerment (shared decision-making, ICU rounds, family conferences) — the parent concept, broader than and distinct from familiar-voice reorientation.",
       "page": "ms. p.9",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ICU delirium guideline — the on-scope source that governs: names family participation in care as a studied ICU intervention and lists reorientation/cognitive stimulation among conditionally recommended multicomponent nonpharmacologic strategies.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Rationale: ICU delirium studies of nonpharmacologic interventions focused on either one modifiable risk factor with a single intervention or several modifiable risk factors with multicomponent interventions (Supplemental Table 28, Supplemental Digital Content 36, http://links.lww.com/ CCM/D794). For the purposes of these guidelines, one question addressed single intervention studies and one question addressed multicomponent intervention studies. Delirium incidence, prevalence, and duration were considered the most important outcomes across both questions. ICU LOS, hospital LOS, and hospital mortality were also considered to be critical outcomes for these questions. Bright light therapy, family participation in care, and a psychoeducational program were the only single-component interventions that have been studied in the ICU.",
       "highlight": "family participation in care, and a psychoeducational program were the only single-component interventions that have been studied in the ICU",
       "scope": "on-scope",
       "note": "Directly identifies family participation in care as a nonpharmacologic intervention studied in the ICU population — ICU-specific support for family involvement.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Remarks: These multicomponent interventions include (but are not limited to) strategies to reduce or shorten delirium (e.g., reorientation, cognitive stimulation, use of clocks); improve sleep (e.g., minimizing light and noise); improve wakefulness (i.e., reduced sedation); reduce immobility (e.g., early rehabilitation/mobilization); and reduce hearing and/or visual impairment (e.g., enable use of devices such as hearing aids or eye glasses).",
       "highlight": "reorientation, cognitive stimulation, use of clocks",
       "scope": "on-scope",
       "note": "Reorientation and cognitive stimulation are listed multicomponent nonpharmacologic strategies the panel conditionally recommends to reduce ICU delirium — the reorientation basis for this bedside item.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "partial",
     "note": "HELP RCT in hospitalized older medical patients (non-ICU); supports reorientation as a delirium-prevention component but not in the ICU and not via family/familiar voice.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — cognitive impairment. Eligible patients: All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily. Standardized intervention protocols: Orientation protocol: board with names of care-team members and day’s schedule; communication to reorient to surroundings. Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games). Targeted outcome for reassessment: Change in orientation score.",
       "highlight": "board with names of care-team members and day’s schedule; communication to reorient to surroundings",
       "scope": "different-setting",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "Table of risk factors and standardized intervention protocols rendered as run-on scattered cells/labels, starting mid-sentence and containing replacement characters."
      },
      {
       "context": "Previous interventional studies of delirium have focused on four types of intervention: general geriatric approaches,9-14 nursing care,15-19 family interventions,20 and anesthesia.21-23 Although in most of the studies there were trends toward a reduction in delirium in the intervention group, in most cases the reduction was not statistically significant. Many studies had methodologic limitations, such as small samples, use of nontargeted interventions, and use of relatively insensitive outcome measures (e.g., screening mental-status tests or confusion checklists). Finally, most previous studies focused on the treatment of delirium rather than on primary prevention, which was the goal of the present study.",
       "highlight": "nursing care,15-19 family interventions,20 and anesthesia",
       "scope": "background",
       "note": "Lists family interventions among prior delirium-prevention study categories as background — not part of the HELP intervention actually tested.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Meta-analysis of multicomponent nonpharmacologic delirium prevention in hospitalized older adults on acute medical/surgical wards (non-ICU); reorientation is a component and family members can deliver interventions, but the setting/population differs.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "using volunteers, family members, and nurses in the delivery of interventions",
       "scope": "different-setting",
       "note": "HELP-type multicomponent nonpharmacologic interventions (which include reorientation) can be delivered by family members — but studied in hospitalized older adults, not the ICU.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "Overall, approximately 4267 patients at 12 sites (acute medical and surgical wards in academic and community hospitals) were involved; their mean age was 79.7 years. All studies involving non-acute care settings were excluded based on our criteria.",
       "highlight": "acute medical and surgical wards in academic and community hospitals",
       "scope": "different-population",
       "note": "Confirms the pooled population is older adults (mean age 79.7) on acute medical/surgical wards with non-acute settings excluded — not an ICU cohort.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2018 is the on-scope, ICU-specific source and governs this item: it names family participation in care as a nonpharmacologic intervention studied in the ICU and lists reorientation/cognitive stimulation among the multicomponent strategies it conditionally recommends to reduce ICU delirium. The ABCDEF-bundle sources (Marra 2017 — the tool's primary anchor, Pun 2019, and the SCCM ICU Liberation page) support family involvement more broadly as bundle element F (family engagement/empowerment in decision-making and presence) rather than familiar-voice reorientation specifically, while the HELP reorientation evidence (Inouye 1999, Hshieh 2015) comes from hospitalized older adults on general medical/surgical wards, not the ICU.",
   "discrepancy": true
  },
  {
   "id": "icu-r24",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Sensory",
   "statement": "Glasses in place",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "Inouye 1999 — p. 3, ¶60",
   "passage": "…  to allow sleep (e.g., rescheduling of medications and procedures) Change in rate of use of sedative drug for sleep† Immobility All patients; ambulation whenever possible, and range-of-motion exercises when patients chronically non-ambulatory, bed or wheelchair bound, immobilized (e.g., because of an extremity fracture or deep venous thrombosis), or when prescribed bed rest Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints) Change in Activities of Daily Living score Visual impairment Patients with <20/70 visual acuity on binocular near-vision testing Vision protocol: visual aids (e.g., glasses or magnifying lenses) and adaptive equipment (e.g., large illuminated telephone keypads, large-print books, and fluorescent tape on call bell), with daily reinforcement of their use Early correction of vision, «48 hr after admission Hearing impairment Patients hearing «6 of 12 whispers on Whisper Test Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques, with daily reinforcement of these adaptations Change in Whisper Test score Dehydration Patients with ratio of blood urea nitrogen to creatinine»18, screened for protocol by geriatric nurse-specialist Dehydration protocol: early recognition of dehydration and volume repletion (i.e., encouragement of oral intake of fluids) Change in ratio of blood urea nitrogen to creatinine The New England Journal of Medicine is produced by NEJM Group, a division of the Massach …\nPADIS 2018 likewise lists eyeglasses among sensory aids (p. 25).",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ICU-specific guideline that directly recommends enabling eye glasses to reduce visual impairment in critically ill adults; the governing on-scope source for this statement.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Recommendation: We suggest using a multicomponent, nonpharmacologic intervention that is focused on (but not limited to) reducing modifiable risk factors for delirium, improving cognition, and optimizing sleep, mobility, hearing, and vision in critically ill adults (conditional recommendation, low quality of evidence).",
       "highlight": "optimizing sleep, mobility, hearing, and vision in critically ill adults",
       "scope": "on-scope",
       "note": "Formal recommendation for a multicomponent nonpharmacologic intervention that optimizes vision in critically ill (ICU) adults — the tool's exact population.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Remarks: These multicomponent interventions include (but are not limited to) strategies to reduce or shorten delirium (e.g., reorientation, cognitive stimulation, use of clocks); improve sleep (e.g., minimizing light and noise); improve wakefulness (i.e., reduced sedation); reduce immobility (e.g., early rehabilitation/mobilization); and reduce hearing and/or visual impairment (e.g., enable use of devices such as hearing aids or eye glasses).",
       "highlight": "enable use of devices such as hearing aids or eye glasses",
       "scope": "on-scope",
       "note": "Remarks spell out that the intervention includes enabling eye glasses to reduce visual impairment — direct support for 'glasses in place'.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Rationale: The multicomponent intervention studies evaluated a bundle of interventions. Many examples of multicomponent bundles (8, 283, 391-396) have shown improved outcomes in critically ill adults (Supplemental Table 29, Supplemental Digital Content 37, http://links.lww.com/CCM/ D795). Pilot studies suggested that combining cognitive and physical therapy early during critical illness is feasible and safe (391) and using nonpharmacologic multicomponent interventions in ICU patients is feasible (392). Studies of multicomponent interventions, many of which were not randomized, focus on cognitive impairment (e.g., reorientation, cognitive stimulation, music, use of clocks); sedation/sleep disruption (e.g., reducing sedation, minimizing light and noise); immobility (early rehabilitation/mobilization); and hearing and visual impairment (e.g., use of hearing aids and glasses). Overall, the use of such strategies reduced delirium significantly (five studies, n = 1,318; OR, 0.59; 95% CI, 0.39-0.88) (392-396). Further, ICU duration of delirium (16 vs 20hr) (395), ICU LOS (387), and hospital mortality all decreased (393).",
       "highlight": "use of hearing aids and glasses",
       "scope": "on-scope",
       "note": "Rationale restates glasses as a bundle component in ICU patients and reports the pooled delirium reduction (OR 0.59).",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary anchor; the HELP RCT that defines the vision protocol (glasses) as a delirium-prevention intervention, though studied in hospitalized older general-medicine patients rather than the ICU.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Vision protocol: visual aids (e.g., glasses or magnifying lenses) and adaptive equipment (e.g., large illuminated telephone keypads, large-print books, and fluorescent tape on call bell), with daily reinforcement of their use Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques, with daily reinforcement of these adaptations Dehydration protocol: early recognition of dehydration and volume repletion (i.e., encouragement of oral intake of fluids) TARGETED OUTCOME FOR REASSESSMENT Change in orientation score Change in rate of use of sedative drug for sleep Change in Activities of Daily Living score Early correction of vision, 48 hr after admission Change in Whisper Test score Change in ratio of blood urea nitrogen to creatinine *The orientation score consisted of results on the first 10 items on the Mini-Mental State Examination (MMSE).",
       "highlight": "visual aids (e.g., glasses or magnifying lenses)",
       "scope": "on-scope",
       "note": "Standardized vision protocol directly describing provision of glasses; note the study population is hospitalized older patients on general-medicine units, not ICU.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Meta-analysis confirming multicomponent nonpharmacologic bundles that include vision adaptations reduce delirium, but pooling predominantly non-ICU hospitalized older adults (HELP-derived).",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "b Evidence-based nonpharmacological interventions include the following: cognition or orientation (C), early mobility (E), hearing (H), sleep-wake cycle preservation (P), vision (V), and hydration (W).",
       "highlight": "sleep-wake cycle preservation (P), vision (V), and hydration (W)",
       "scope": "broader",
       "note": "Names vision (V) as one of six effective bundle components across the pooled trials — broader than the single glasses item.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "hearing and vision adaptations",
       "scope": "different-population",
       "note": "Describes the HELP program's interventions (including vision adaptations) in hospitalized older adults, a different population/setting from the ICU tool.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "ABCDEF-bundle review covering nonpharmacologic ICU delirium prevention but not naming sensory/vision aids; highlights sleep hygiene and early mobilization instead.",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "The only strategy strongly recommended in the PAD Guidelines, to reduce the incidence and duration of ICU delirium and to improve functional outcomes, is promoting sleep hygiene to prevent sleep disruption and the use of early and progressive mobilization and in these patients.",
       "highlight": "promoting sleep hygiene to prevent sleep disruption and the use of early and progressive mobilization",
       "scope": "different-intervention",
       "note": "Nearest match on nonpharmacologic ICU delirium prevention, but it emphasizes sleep hygiene and mobilization — not glasses — so it must not be read as direct support for the sensory item.",
       "page": "228",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "background",
     "note": "ICU Liberation Collaborative outcomes study (>15,000 adults) establishing that the ABCDEF bundle (including the D delirium element) improves outcomes; does not itself specify sensory/vision interventions.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "One such approach is known as the ABCDEF bundle (Assess, prevent, and manage pain; Both spontaneous awakening and breathing trials: Choice of Analgesia and Sedation; Delirium assess, prevent, and manage; Early Mobility and Exercise; Family engagement/ empowerment) (14-18).",
       "highlight": "known as the ABCDEF bundle",
       "scope": "background",
       "note": "Defines the ABCDEF bundle and its delirium (D) element as the context for nonpharmacologic prevention, without naming glasses.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived SCCM ICU Liberation page (site navigation stripped); lists the bundle's D delirium element implementing the 2018 PADIS guidelines but does not itself name glasses/sensory aids.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "The ICU Liberation Bundle consists of the following individual elements A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs) C Element : Choice of Analgesia and Sedation D Element : Delirium: Assess, Prevent, and Manage E Element: Early Mobility and Exercise F Element : Family Engagement and Empowerment",
       "highlight": "D Element : Delirium: Assess, Prevent, and Manage",
       "scope": "background",
       "note": "Names the delirium (D) element of the ICU Liberation Bundle as bundle-level context; the specific glasses intervention is not stated here.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2018 governs: it is the ICU-specific guideline that directly recommends enabling eye glasses to reduce visual impairment in critically ill adults, and Inouye 1999 (HELP) — the primary anchor — is the foundational RCT that verbatim defines the glasses/vision protocol, though in hospitalized older general-medicine patients rather than the ICU, with Hshieh 2015's meta-analysis confirming vision as an effective bundle component across mostly non-ICU inpatients. Marra 2017, Pun 2019, and the SCCM ICU Liberation page establish the ABCDEF/PADIS delirium-prevention bundle context but do not themselves name glasses (Marra instead emphasizes sleep hygiene and early mobilization).",
   "discrepancy": true
  },
  {
   "id": "icu-r25",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Sensory",
   "statement": "Hearing aids in place",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "PADIS 2018 — p. 25",
   "passage": "… Remarks: These multicomponent interventions include (but are not limited to) strategies to reduce or shorten delirium (e.g., reorientation, cognitive stimulation, use of clocks); improve sleep (e.g., minimizing light and noise); improve wakefulness (i.e., reduced sedation); reduce immobility (e.g., early rehabilitation/mobilization); and reduce hearing and/or visual impairment (e.g., enable use of devices such as hearing aids or eye glasses) . Rationale: The multicomponent intervention studies evaluated a bundle of interventions. Many examples of multicomponent bundles (8, 283, 391-396) have shown improved outcomes in critically ill adults (Supplemental Table 29, Supplemental Digital Content 37, http://links.lww.com/CCM/ D795). Pilot studies suggested that combining cognitive and physical therapy early during critical illness is feasible and safe (391) and using nonpharmacologic multicomponent interventions in ICU patients is feasible (392). …\nThe Inouye 1999 hearing protocol (\"portable amplifying devices,\" p. 3) supports the same intervention.",
   "evidence": "Full text, p. 25",
   "status": "fulltext",
   "pageNum": "25",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope ICU guideline: directly recommends optimizing hearing via devices such as hearing aids as part of multicomponent nonpharmacologic delirium prevention in critically ill adults.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Remarks: These multicomponent interventions include (but are not limited to) strategies to reduce or shorten delirium (e.g., reorientation, cognitive stimulation, use of clocks); improve sleep (e.g., minimizing light and noise); improve wakefulness (i.e., reduced sedation); reduce immobility (e.g., early rehabilitation/mobilization); and reduce hearing and/or visual impairment (e.g., enable use of devices such as hearing aids or eye glasses).",
       "highlight": "enable use of devices such as hearing aids or eye glasses",
       "scope": "on-scope",
       "note": "Guideline Remarks explicitly list enabling hearing aids/eyeglasses among the multicomponent nonpharmacologic strategies for ICU delirium, directly supporting the sensory bundle item.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Recommendation: We suggest using a multicomponent, nonpharmacologic intervention that is focused on (but not limited to) reducing modifiable risk factors for delirium, improving cognition, and optimizing sleep, mobility, hearing, and vision in critically ill adults (conditional recommendation, low quality of evidence).",
       "highlight": "optimizing sleep, mobility, hearing, and vision in critically ill adults",
       "scope": "on-scope",
       "note": "The formal recommendation frames optimizing hearing as part of the intervention in critically ill adults, the exact population/setting of the ICU rounding tool.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Supports addressing hearing impairment to prevent delirium, but in a different setting/population (older general-medicine inpatients, not the ICU) and via amplifying devices/earwax removal rather than patient hearing aids.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques, with daily reinforcement of these adaptations Dehydration protocol: early recognition of dehydration and volume repletion (i.e., encouragement of oral intake of fluids) TARGETED OUTCOME FOR REASSESSMENT Change in orientation score Change in rate of use of sedative drug for sleep Change in Activities of Daily Living score Early correction of vision, 48 hr after admission Change in Whisper Test score Change in ratio of blood urea nitrogen to creatinine *The orientation score consisted of results on the first 10 items on the Mini-Mental State Examination (MMSE).",
       "highlight": "Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques",
       "scope": "different-setting",
       "note": "HELP RCT hearing protocol in hospitalized older medical-ward patients (not critically ill / non-ICU); nearest match on the sensory-hearing intervention but a different care setting and population.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Meta-analysis confirming hearing/sensory adaptation is a recognized component of multicomponent nonpharmacologic delirium prevention, but across predominantly non-ICU hospitalized populations.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "b Evidence-based nonpharmacological interventions include the following: cognition or orientation (C), early mobility (E), hearing (H), sleep-wake cycle preservation (P), vision (V), and hydration (W).",
       "highlight": "hearing (H)",
       "scope": "different-setting",
       "note": "Lists hearing as one of the evidence-based nonpharmacological intervention components, but the pooled studies are mostly general-hospital/non-ICU multicomponent programs, a broader setting than the ICU.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "hearing and vision adaptations",
       "scope": "different-setting",
       "note": "Describes the HELP model's hearing/vision adaptations; supports the intervention concept but in the general hospitalized-elderly setting rather than the ICU.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    },
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived SCCM web page establishing the ICU Liberation (ABCDEF) Bundle and its Delirium (D) element that houses nonpharmacologic sensory care, but it does not itemize hearing aids/glasses.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes while transforming culture.",
       "highlight": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes",
       "scope": "broader",
       "note": "The ICU Liberation (ABCDEF) bundle is the umbrella under which this comfort, orientation, or sleep measure is delivered; the bundle resource endorses implementing these elements rather than stating this specific bedside line.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "background",
     "note": "Large ICU Liberation Collaborative showing bundle performance improves delirium outcomes, but it evaluates bundle compliance/outcomes and does not describe the individual sensory hearing-aid component.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "ABCDEF bundle performance showed significant and clinically meaningful improvements in outcomes including survival, mechanical ventilation use, coma and delirium, restraint-free care, ICU readmissions, and post-ICU discharge disposition.",
       "highlight": "improvements in outcomes including survival, mechanical ventilation use, coma and delirium",
       "scope": "broader",
       "note": "Demonstrates the bundle (which contains the delirium element) improves delirium outcomes at scale in the ICU, but does not itemize hearing aids as an intervention.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "background",
     "note": "Narrative review of the ABCDEF bundle; its Delirium (D) element emphasizes assessment, reversible-precipitant search, and pharmacologic management and does not address the sensory hearing-aid intervention.",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "An important third element in the PAD guidelines is monitoring and management of delirium. Delirium is a disturbance in attention and awareness that develops over a short period of time, hours to days, and fluctuates over time.",
       "highlight": "monitoring and management of delirium",
       "scope": "broader",
       "note": "Reviews the D (Delirium) bundle element but focuses on assessment and pharmacologic management, not the nonpharmacologic hearing/sensory item.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2018 is the on-scope governing source: it directly recommends optimizing hearing in critically ill adults and names enabling devices such as hearing aids/eyeglasses within multicomponent nonpharmacologic delirium prevention, matching the ICU rounding tool's sensory bundle item. Inouye 1999 (HELP RCT) and Hshieh 2015 (meta-analysis) agree on the sensory-hearing principle but are nearest matches in different, mostly non-ICU hospitalized-elderly settings, while SCCM, Pun 2019, and Marra 2017 supply the ABCDEF/ICU Liberation bundle framework as background without itemizing the hearing-aid intervention.",
   "discrepancy": true
  },
  {
   "id": "icu-r26",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Sensory",
   "statement": "Language barrier addressed",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "structure",
   "pageNum": null,
   "citations": [],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "A communication/reorientation implementation item of the cited multicomponent bundle — addressing a language barrier (interpreter, familiar-language cues) supports reorientation. Standard supportive care rather than a separately-cited recommendation.",
   "perSource": [],
   "synthesis": "",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "icu-r27",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Sensory",
   "statement": "Noise sources minimized",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "Inouye 1999 — p. 3, ¶60",
   "passage": "Cognitive impairment* All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily Orientation protocol: board with names of care-team members and day's schedule; communication to reorient to surroundings Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games) Change in orientation score Sleep deprivation All patients; need for protocol assessed once daily Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures) Change in rate of use of sedative drug for sleep† Immobility All patients; ambulation whenever possible, and range-of-motion exercises when patients chronically non-ambulatory, bed or wheelchair bound, immobilized (e.g., because of an extremity fracture or deep venous thrombosis), or when prescribed bed rest Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints) Change in Activities of Daily Living score Visual impairment Patients with <20/70 visual acuity on bino …",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes while transforming culture.",
       "highlight": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes",
       "scope": "background",
       "note": "The ICU Liberation (ABCDEF) bundle is the umbrella under which this comfort, orientation, or sleep measure is delivered; the bundle resource endorses implementing these elements rather than stating this specific bedside line.",
       "page": "1",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "Critically ill patients experience a variety of distressing symptoms during their hospital stay including pain, agitation, delirium, weakness, and sleep deprivation (1-3). Because of the complexity of caring for ICU patients, these symptoms are often managed by keeping patients heavily sedated, immobilized, and often socially isolated (4-6). Historically, daily goals of care were organized according to specific organ dysfunction, rather than an integrated holistic approach, and team members worked in siloed care systems. Evidence increasingly suggests that symptoms, and the way the ICU team chooses to manage them, can have important negative prognostic implications (1-3). Given the aging population, rising healthcare costs, and increasing millions of patients who survive critical illness (7-10), society has an evergrowing public health problem related to ineffective symptom management that ultimately contributes to persistent and life-altering impairments in physical, mental, and cognitive health (often referred to as Post Intensive Care Syndrome, PICS) (11-13).",
       "highlight": "sleep deprivation",
       "scope": "background",
       "note": "Establishes sleep deprivation as a distressing ICU symptom the ABCDEF bundle targets, but the paper reports bundle compliance and outcomes and never addresses noise minimization specifically.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "The only strategy strongly recommended in the PAD Guidelines, to reduce the incidence and duration of ICU delirium and to improve functional outcomes, is promoting sleep hygiene to prevent sleep disruption and the use of early and progressive mobilization and in these patients.",
       "highlight": "promoting sleep hygiene to prevent sleep disruption",
       "scope": "broader",
       "note": "ICU review states the one strongly recommended delirium-prevention strategy in the PAD guidelines is sleep hygiene (the umbrella that includes noise minimization) plus early mobilization, but it does not name noise reduction as a discrete intervention.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Recommendation: We suggest using noise and light reduction strategies to improve sleep in critically ill adults (conditional recommendation, low quality of evidence).",
       "highlight": "using noise and light reduction strategies to improve sleep in critically ill adults",
       "scope": "on-scope",
       "note": "Direct ICU guideline recommendation to use noise and light reduction to improve sleep in critically ill adults (conditional recommendation, low quality of evidence).",
       "page": "e857",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Remarks: These multicomponent interventions include (but are not limited to) strategies to reduce or shorten delirium (e.g., reorientation, cognitive stimulation, use of clocks); improve sleep (e.g., minimizing light and noise); improve wakefulness (i.e., reduced sedation); reduce immobility (e.g., early rehabilitation/mobilization); and reduce hearing and/or visual impairment (e.g., enable use of devices such as hearing aids or eye glasses).",
       "highlight": "improve sleep (e.g., minimizing light and noise)",
       "scope": "on-scope",
       "note": "Lists minimizing light and noise as a component of the recommended multicomponent nonpharmacologic delirium-reduction interventions for critically ill adults.",
       "page": "e848",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "The factors most frequently cited by patients as disruptive to sleep were noise, pain and discomfort, immobility/restricted movement, nursing care interventions, and worry/anxiety/fear (449, 455, 456, 482, 484-490, 492, 493).",
       "highlight": "factors most frequently cited by patients as disruptive to sleep were noise",
       "scope": "background",
       "note": "Rationale: noise is the top patient-reported extrinsic disruptor of ICU sleep, supporting why noise sources are minimized.",
       "page": "e853",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The HELP sleep-enhancement protocol is unit-wide noise reduction. Table 1 names the measures, which is what this item asks the team to do.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Cognitive impairment. All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily. Orientation protocol: board with names of care-team members and day’s schedule; communication to reorient to surroundings. [...] Sleep deprivation. All patients; need for protocol assessed once daily. Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage. Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures).",
       "highlight": "Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways)",
       "scope": "on-scope",
       "note": "Table 1, the intervention protocols. Noise reduction is a named component of the trial’s sleep-enhancement protocol.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations.",
       "highlight": "sleep strategies, and hearing and vision adaptations",
       "scope": "different-setting",
       "note": "Meta-analysis of HELP-type multicomponent interventions whose sleep strategies encompass noise reduction, but it does not name noise and pools non-ICU inpatients.",
       "page": "512",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "Overall, approximately 4267 patients at 12 sites (acute medical and surgical wards in academic and community hospitals) were involved; their mean age was 79.7 years. All studies involving non-acute care settings were excluded based on our criteria.",
       "highlight": "acute medical and surgical wards in academic and community hospitals",
       "scope": "different-setting",
       "note": "Confirms the pooled population is non-ICU acute medical and surgical wards (mean age 79.7 years), a different care setting from the ICU tool.",
       "page": "515",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2018 is the on-scope ICU source and governs the claim: it directly recommends noise and light reduction to improve sleep in critically ill adults, with SCCM ICU Liberation operationalizing that bundle and Marra broadly endorsing ICU sleep hygiene. The tool's primary anchor, Inouye 1999 (HELP), and Hshieh 2015 define and validate the noise-reduction intervention but in non-ICU older inpatients on general medical/surgical wards, so they are foundational rather than on-scope ICU evidence; Pun 2019 only notes sleep deprivation as an ICU symptom without addressing noise.",
   "discrepancy": true
  },
  {
   "id": "icu-r28",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Sleep",
   "statement": "Nighttime light/noise reduced (quiet hours)",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "PADIS 2018 — p. 34",
   "passage": "… Given the low quality of evidence (no blinding, ambient noise not controlled) and the resources needed to institute this intervention, the panel made a conditional recommendation against the use of music to improve sleep in critically ill adults. Music may play a role in reducing pain (see pain section) and anxiety in the ICU (133). If patients (or their families) request it, it should be considered. Noise and Light Reduction Question: Should noise and light reduction strategies (vs not using these strategies) be used at night to improve sleep in critically ill adults? Recommendation: We suggest using noise and light reduction strategies to improve sleep in critically ill adults (conditional recommendation, low quality of evidence). Rationale: Two RCTs (458, 513) and two observational studies (514, 515) evaluated strategies to reduce ICU noise and light at night through the use of earplugs with or without the use of eyeshades. Use of earplugs and eyeshades (vs control) on the first postoperative ICU night after cardiac surgery maintained sleep quality at the preoperative level (513). Application of earplugs (vs no earplugs) to nonsedated, critically ill adults improved patient-reported sleep quality and reduced delirium (458). …",
   "evidence": "Full text, p. 33",
   "status": "fulltext",
   "pageNum": "33",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope governing source: the 2018 PADIS ICU guideline gives an explicit conditional recommendation for nighttime noise and light reduction to improve sleep in critically ill adults (primary anchor p. 34).",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Recommendation: We suggest using noise and light reduction strategies to improve sleep in critically ill adults (conditional recommendation, low quality of evidence).",
       "highlight": "We suggest using noise and light reduction strategies to improve sleep in critically ill adults (conditional recommendation, low quality of evidence).",
       "scope": "on-scope",
       "note": "Direct guideline recommendation for the exact intervention (noise and light reduction at night) in the exact population (critically ill adults).",
       "page": "e857",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Rationale: Two RCTs (458, 513) and two observational studies (514, 515) evaluated strategies to reduce ICU noise and light at night through the use of earplugs with or without the use of eyeshades. Use of earplugs and eyeshades (vs control) on the first postoperative ICU night after cardiac surgery maintained sleep quality at the preoperative level (513). Application of earplugs (vs no earplugs) to nonsedated, critically ill adults improved patient-reported sleep quality and reduced delirium (458). Pooled analysis from the two ICU observational studies (n = 164) found that application of ear plugs (vs no ear plugs)",
       "highlight": "Application of earplugs (vs no earplugs) to nonsedated, critically ill adults improved patient-reported sleep quality and reduced delirium",
       "scope": "on-scope",
       "note": "Rationale: reducing ICU noise and light at night (earplugs/eyeshades) improved sleep quality and reduced delirium in ICU adults.",
       "page": "e857",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Remarks: These multicomponent interventions include (but are not limited to) strategies to reduce or shorten delirium (e.g., reorientation, cognitive stimulation, use of clocks); improve sleep (e.g., minimizing light and noise); improve wakefulness (i.e., reduced sedation); reduce immobility (e.g., early rehabilitation/mobilization); and reduce hearing and/or visual impairment (e.g., enable use of devices such as hearing aids or eye glasses).",
       "highlight": "improve sleep (e.g., minimizing light and noise)",
       "scope": "on-scope",
       "note": "PADIS lists minimizing light and noise to improve sleep as a component of multicomponent delirium-reduction strategies in critically ill adults.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "The top three reported extrinsic factors disrupting sleep were noise, lighting, and nursing interventions (e.g., baths).",
       "highlight": "The top three reported extrinsic factors disrupting sleep were noise, lighting, and nursing interventions (e.g., baths).",
       "scope": "background",
       "note": "Establishes noise and lighting as the top patient-reported sleep disruptors in ICU adults, motivating their reduction.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ICU review that endorses sleep hygiene / preventing sleep disruption as strongly recommended to reduce ICU delirium — same setting, broader than the specific noise/light element.",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "The only strategy strongly recommended in the PAD Guidelines, to reduce the incidence and duration of ICU delirium and to improve functional outcomes, is promoting sleep hygiene to prevent sleep disruption and the use of early and progressive mobilization and in these patients.",
       "highlight": "is promoting sleep hygiene to prevent sleep disruption",
       "scope": "broader",
       "note": "Endorses sleep hygiene to prevent sleep disruption in ICU delirium; nighttime noise/light reduction is a specific instance of this broader category.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived SCCM bundle overview page (nav boilerplate stripped); frames the ABCDEF bundle as implementing PADIS including sleep disruption, but does not state the specific noise/light intervention.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes while transforming culture.",
       "highlight": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes",
       "scope": "broader",
       "note": "The ICU Liberation (ABCDEF) bundle is the umbrella under which this comfort, orientation, or sleep measure is delivered; the bundle resource endorses implementing these elements rather than stating this specific bedside line.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "background",
     "note": "ICU Liberation Collaborative outcomes paper; names sleep deprivation among the symptoms the bundle addresses but does not describe the noise/light intervention.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "Critically ill patients experience a variety of distressing symptoms during their hospital stay including pain, agitation, delirium, weakness, and sleep deprivation (1-3). Because of the complexity of caring for ICU patients, these symptoms are often managed by keeping patients heavily sedated, immobilized, and often socially isolated (4-6). Historically, daily goals of care were organized according to specific organ dysfunction, rather than an integrated holistic approach, and team members worked in siloed care systems. Evidence increasingly suggests that symptoms, and the way the ICU team chooses to manage them, can have important negative prognostic implications (1-3). Given the aging population, rising healthcare costs, and increasing millions of patients who survive critical illness (7-10), society has an evergrowing public health problem related to ineffective symptom management that ultimately contributes to persistent and life-altering impairments in physical, mental, and cognitive health (often referred to as Post Intensive Care Syndrome, PICS) (11-13).",
       "highlight": "weakness, and sleep deprivation",
       "scope": "background",
       "note": "Lists sleep deprivation as a target ICU symptom of the ABCDEF bundle; provides bundle context, not the specific noise/light measure.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Nearest match on the actual intervention (unit-wide noise reduction, quiet) but studied in non-ICU, general-medicine, older inpatients (HELP) — different population and setting.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Potential participants in the study were consecutive patients admitted to the general-medicine service (non-intensive care) at Yale-New Haven Hospital from March 25, 1995, through March 18, 1998.",
       "highlight": "the general-medicine service (non-intensive care)",
       "scope": "different-population",
       "note": "HELP enrolled patients 70+ on a general-medicine (explicitly non-intensive-care) service, a different population from the ICU quiet-hours setting the item targets.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "background",
     "note": "Meta-analysis of HELP-derived multicomponent nonpharmacological programs in hospitalized older patients; sleep-wake preservation is one bundle component — broader intervention and different population than the ICU noise/light claim.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "b Evidence-based nonpharmacological interventions include the following: cognition or orientation (C), early mobility (E), hearing (H), sleep-wake cycle preservation (P), vision (V), and hydration (W).",
       "highlight": "sleep-wake cycle preservation (P)",
       "scope": "broader",
       "note": "Sleep-wake cycle preservation is only one component of the multicomponent bundle evaluated, broader than the specific nighttime noise/light reduction measure.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "D elirium is an acute confusional state marked by inattention and global cognitive dysfunction. It is multifactorial and develops owing to interactions between risk factors and noxious insults.1 Common yet underdiagnosed, delirium is particularly prevalent among the hospitalized elderly, occurring in 29% to 64%, and contributes to more than $164 billion in health care costs in the United States annually.1,2 Delirium significantly increases risk of falls, functional decline, dementia, prolonged hospital length of stay, and institutionalization.3 The strong correlation between delirium and hospital-related falls has led to calls for delirium prevention quality metrics to improve hospital care and prevent falls in older persons.4 Most important, at least 30% to 40% of delirium cases are preventable.1,5,6 Surprisingly, most hospitals do not have delirium prevention programs or their protocols are inconsistently implemented, with variable adherence.1,7 Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations.",
       "highlight": "the hospitalized elderly",
       "scope": "different-population",
       "note": "The meta-analysis targets the hospitalized elderly (HELP-style programs), not the ICU-specific critically ill population of the claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2018 is the on-scope governing source: it directly recommends using noise and light reduction strategies at night to improve sleep in critically ill adults (earplugs/eyeshades reduced delirium), and Marra 2017, SCCM ICU Liberation, and Pun 2019 concur at the broader ICU sleep-hygiene / bundle level. Inouye 1999 (HELP) and Hshieh 2015 are the nearest matches on the actual noise-reduction sleep intervention but were conducted in non-ICU hospitalized older patients, so they support the concept without governing the ICU-specific claim.",
   "discrepancy": true
  },
  {
   "id": "icu-r29",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Sleep",
   "statement": "Eye mask & earplugs offered",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "PADIS 2018 — p. 34",
   "passage": "… Music may play a role in reducing pain (see pain section) and anxiety in the ICU (133). If patients (or their families) request it, it should be considered. Noise and Light Reduction Question: Should noise and light reduction strategies (vs not using these strategies) be used at night to improve sleep in critically ill adults? Recommendation: We suggest using noise and light reduction strategies to improve sleep in critically ill adults (conditional recommendation, low quality of evidence). Rationale: Two RCTs (458, 513) and two observational studies (514, 515) evaluated strategies to reduce ICU noise and light at night through the use of earplugs with or without the use of eyeshades . Use of earplugs and eyeshades (vs control) on the first postoperative ICU night after cardiac surgery maintained sleep quality at the preoperative level (513). Application of earplugs (vs no earplugs) to nonsedated, critically ill adults improved patient-reported sleep quality and reduced delirium (458). Pooled analysis from the two ICU observational studies (n = 164) found that application of ear plugs (vs no ear plugs) was associated with a greater proportion of achieving greater than 4 hours of sleep (RR, 1.2; 95% CI, 0.64-2.24; low quality) (513, 515). …\nThe supporting rationale reports that earplug use improved sleep and reduced delirium.",
   "evidence": "Full text, p. 34",
   "status": "fulltext",
   "pageNum": "34",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope governing source: conditional recommendation for noise/light reduction via earplugs with or without eyeshades to improve sleep in critically ill adults, and a sleep-promoting protocol that explicitly offers earplugs and eyeshades.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Recommendation: We suggest using noise and light reduction strategies to improve sleep in critically ill adults (conditional recommendation, low quality of evidence).",
       "highlight": "We suggest using noise and light reduction strategies to improve sleep in critically ill adults",
       "scope": "on-scope",
       "note": "The formal recommendation to use noise- and light-reduction strategies (the category earplugs and eyeshades fall under) in the ICU.",
       "page": "e857",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Rationale: Two RCTs (458, 513) and two observational studies (514, 515) evaluated strategies to reduce ICU noise and light at night through the use of earplugs with or without the use of eyeshades. Use of earplugs and eyeshades (vs control) on the first postoperative ICU night after cardiac surgery maintained sleep quality at the preoperative level (513). Application of earplugs (vs no earplugs) to nonsedated, critically ill adults improved patient-reported sleep quality and reduced delirium (458). Pooled analysis from the two ICU observational studies (n = 164) found that application of ear plugs (vs no ear plugs)",
       "highlight": "through the use of earplugs with or without the use of eyeshades",
       "scope": "on-scope",
       "note": "Rationale naming earplugs and eyeshades as the noise/light-reduction modality evaluated in critically ill adults, matching the tool item.",
       "page": "e857",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "was associated with a greater proportion of achieving greater than 4 hours of sleep (RR, 1.2; 95% CI, 0.64-2.24; low quality) (513, 515). The overall quality of evidence was low due to a lack of blinding, a population of patients not severely ill, and the refusal of some patients to keep the earplugs inserted. Earplugs, with or without eyeshades, represent a low-cost intervention that can be applied in all ICUs to improve sleep quality and reduce delirium. In general patients, particularly those who cannot initiate sleep, should be asked if they want this intervention and earplugs should always be removed in the morning.",
       "highlight": "particularly those who cannot initiate sleep, should be asked if they want this intervention",
       "scope": "on-scope",
       "note": "Directly supports the 'offered' framing: patients should be asked if they want earplugs/eyeshades, which are removed in the morning.",
       "page": "e857",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "The sleep-promoting protocols eligible for inclusion varied in their components, as described below (459, 527-529). All included offering earplugs and eyeshades to patients who could choose to use them or to discontinue their use if they wished and two also included use of relaxing music (459, 526).",
       "highlight": "All included offering earplugs and eyeshades to patients who could choose to use them or to discontinue their use if they wished",
       "scope": "on-scope",
       "note": "Sleep-promoting-protocol rationale uses the exact 'offering earplugs and eyeshades' language the tool item paraphrases.",
       "page": "e858",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived SCCM web page (nav boilerplate stripped); frames the A-F bundle as implementing the PADIS guidelines but does not itself specify eye masks or earplugs.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes while transforming culture.",
       "highlight": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes",
       "scope": "broader",
       "note": "The ICU Liberation (ABCDEF) bundle is the umbrella under which this comfort, orientation, or sleep measure is delivered; the bundle resource endorses implementing these elements rather than stating this specific bedside line.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "background",
     "note": "ABCDEF-bundle implementation collaborative; names sleep deprivation among the target symptoms but does not address eye masks or earplugs specifically.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "Critically ill patients experience a variety of distressing symptoms during their hospital stay including pain, agitation, delirium, weakness, and sleep deprivation (1-3). Because of the complexity of caring for ICU patients, these symptoms are often managed by keeping patients heavily sedated, immobilized, and often socially isolated (4-6). Historically, daily goals of care were organized according to specific organ dysfunction, rather than an integrated holistic approach, and team members worked in siloed care systems. Evidence increasingly suggests that symptoms, and the way the ICU team chooses to manage them, can have important negative prognostic implications (1-3). Given the aging population, rising healthcare costs, and increasing millions of patients who survive critical illness (7-10), society has an evergrowing public health problem related to ineffective symptom management that ultimately contributes to persistent and life-altering impairments in physical, mental, and cognitive health (often referred to as Post Intensive Care Syndrome, PICS) (11-13).",
       "highlight": "including pain, agitation, delirium, weakness, and sleep deprivation",
       "scope": "broader",
       "note": "Nearest content: sleep deprivation is listed as one of the distressing ICU symptoms the bundle targets, but the paper does not specify the eye-mask/earplug intervention.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Endorses sleep hygiene broadly as a delirium-prevention strategy, but at a higher level of abstraction than the specific eye-mask/earplug item.",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "The only strategy strongly recommended in the PAD Guidelines, to reduce the incidence and duration of ICU delirium and to improve functional outcomes, is promoting sleep hygiene to prevent sleep disruption and the use of early and progressive mobilization and in these patients.",
       "highlight": "promoting sleep hygiene to prevent sleep disruption",
       "scope": "broader",
       "note": "Supports sleep promotion as a strongly recommended delirium-prevention strategy, but 'sleep hygiene' is broader than and does not name eye masks or earplugs.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "partial",
     "note": "HELP multicomponent trial in hospitalized patients aged 70+ on a general-medicine ward (not ICU); its sleep protocol uses warm drinks/relaxation and unit-wide environmental noise reduction rather than patient-worn eye masks or earplugs.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — sleep deprivation. Eligible patients: All patients; need for protocol assessed once daily. Standardized intervention protocols: Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage. Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures). Targeted outcome for reassessment: Change in rate of use of sedative drug for sleep.",
       "highlight": "Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage",
       "scope": "different-population",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "Table of HELP intervention protocols with cell labels (Nonpharmacologic sleep/Sleep-enhancement/Early-mobilization/Vision protocol) run together, truncated mid-word."
      },
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — sleep deprivation. Eligible patients: All patients; need for protocol assessed once daily. Standardized intervention protocols: Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage. Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures). Targeted outcome for reassessment: Change in rate of use of sedative drug for sleep.",
       "highlight": "unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways)",
       "scope": "different-intervention",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "Continuation of the same protocol table with multiple cells concatenated and truncated mid-word ('equipme')."
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "background",
     "note": "Meta-analysis of multicomponent nonpharmacological delirium interventions (predominantly HELP-type, non-ICU) in which sleep strategies are one bundled component; does not isolate eye masks or earplugs.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "sleep strategies",
       "scope": "broader",
       "note": "Sleep strategies appear only as one component of the pooled multicomponent programs, mostly outside the ICU; the specific eye-mask/earplug intervention is not separated out.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2018 is the on-scope governing source: it makes a conditional recommendation to use noise- and light-reduction strategies (earplugs with or without eyeshades) to improve sleep in critically ill adults, and its sleep-promoting protocol explicitly describes \"offering earplugs and eyeshades\" to patients who may accept or decline them — directly supporting the ICU tool's \"eye mask & earplugs offered\" item. The remaining sources agree in spirit but are broader or different in scope: SCCM, Pun 2019, and Marra 2017 endorse sleep promotion at the ABCDEF-bundle / sleep-hygiene level without naming the device, while Inouye 1999 (HELP) and Hshieh 2015 describe nonpharmacologic sleep protocols in older non-ICU inpatients that rely on environmental noise reduction and warm-drink/relaxation measures rather than patient-worn eye masks or earplugs.",
   "discrepancy": true
  },
  {
   "id": "icu-r30",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Sleep",
   "statement": "Care clustered to protect sleep",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015",
    "PADIS 2025",
    "SAT/SBT"
   ],
   "anchor": "Inouye 1999 — p. 3, ¶60",
   "passage": "… ientation score of <8, protocol three times daily Orientation protocol: board with names of care-team members and day's schedule; communication to reorient to surroundings Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games) Change in orientation score Sleep deprivation All patients; need for protocol assessed once daily Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures) Change in rate of use of sedative drug for sleep† Immobility All patients; ambulation whenever possible, and range-of-motion exercises when patients chronically non-ambulatory, bed or wheelchair bound, immobilized (e.g., because of an extremity fracture or deep venous thrombosis), or when prescribed bed rest Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints) Change in Activities of Daily Living score Visual impairment Patients with <20/70 visual acuity on binocular near-vision testing Vision protocol: visual aids (e.g., glasses or magnifying lenses)  …",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived SCCM web page; the ICU Liberation (A-F) bundle is the implementation vehicle for the 2018 PADIS guidelines that include the sleep-disruption/care-clustering recommendation, but the page itself does not state the specific tactic (cited by section).",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes while transforming culture.",
       "highlight": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes",
       "scope": "broader",
       "note": "The ICU Liberation (ABCDEF) bundle is the umbrella under which this comfort, orientation, or sleep measure is delivered; the bundle resource endorses implementing these elements rather than stating this specific bedside line.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "background",
     "note": "ABCDEF-bundle outcomes study; establishes bundle efficacy and lists sleep deprivation among the distressing ICU symptoms the bundle targets, but every 'cluster' occurrence is statistical ('clustered by study site') and it does not describe care-clustering to protect sleep.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "Critically ill patients experience a variety of distressing symptoms during their hospital stay including pain, agitation, delirium, weakness, and sleep deprivation (1-3). Because of the complexity of caring for ICU patients, these symptoms are often managed by keeping patients heavily sedated, immobilized, and often socially isolated (4-6). Historically, daily goals of care were organized according to specific organ dysfunction, rather than an integrated holistic approach, and team members worked in siloed care systems. Evidence increasingly suggests that symptoms, and the way the ICU team chooses to manage them, can have important negative prognostic implications (1-3). Given the aging population, rising healthcare costs, and increasing millions of patients who survive critical illness (7-10), society has an evergrowing public health problem related to ineffective symptom management that ultimately contributes to persistent and life-altering impairments in physical, mental, and cognitive health (often referred to as Post Intensive Care Syndrome, PICS) (11-13).",
       "highlight": "sleep deprivation",
       "scope": "background",
       "note": "Names sleep deprivation as a distressing symptom the ABCDEF bundle addresses; background context for the bundle, not support for the specific clustering tactic.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ABCDEF-bundle review; endorses the general non-pharmacologic strategy of promoting sleep hygiene to prevent sleep disruption in ICU delirium, of which clustering care is one tactic (no 'cluster' wording).",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "The only strategy strongly recommended in the PAD Guidelines, to reduce the incidence and duration of ICU delirium and to improve functional outcomes, is promoting sleep hygiene to prevent sleep disruption and the use of early and progressive mobilization and in these patients.",
       "highlight": "promoting sleep hygiene to prevent sleep disruption",
       "scope": "broader",
       "note": "Supports the umbrella recommendation (sleep hygiene / preventing sleep disruption) that the claim's care-clustering is a specific instance of; broader than the specific clustering technique.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governing source: adult-ICU guideline that conditionally recommends a sleep-promoting multicomponent protocol and explicitly names clustering of care to minimize overnight interruptions as a component.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "One of the observational studies used a similar intervention to Hu et al (527), earplugs, eye shades, and music, whereas the other two tested more complex interventions including these interventions plus environmental changes, namely clustering of care to minimize interruptions overnight and early mobilization (459, 529).",
       "highlight": "clustering of care to minimize interruptions overnight",
       "scope": "on-scope",
       "note": "Directly names 'clustering of care to minimize interruptions overnight' as a component of the sleep-promoting protocol in critically ill adults — exact support for 'care clustered to protect sleep'.",
       "page": "e859",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Recommendation: We suggest using a sleep-promoting, multicomponent protocol in critically ill adults (conditional recommendation, very low quality of evidence.)",
       "highlight": "sleep-promoting, multicomponent protocol",
       "scope": "on-scope",
       "note": "The graded conditional recommendation backing the intervention that care-clustering forms part of, in the adult ICU population.",
       "page": "e858",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "2025 focused update; its sleep recommendation is pharmacologic (melatonin) only. It did not re-address the non-pharmacologic sleep-promoting/care-clustering question, so the 2018 non-pharm position remains the current position rather than being overridden.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": []
    },
    {
     "label": "SAT/SBT",
     "cite": "",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Archived Vanderbilt CIBS page about Spontaneous Awakening/Breathing Trials (the ABCDEF 'B' element) — a sedation-interruption and ventilator-liberation intervention, not care-clustering to protect sleep.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt",
     "paragraphs": []
    }
   ],
   "synthesis": "PADIS 2018 governs: it issues a conditional recommendation for a sleep-promoting, multicomponent protocol and explicitly names \"clustering of care to minimize interruptions overnight\" as a component, directly supporting the claim, while Marra 2017 and the SCCM ICU Liberation bundle back the broader sleep-hygiene/ABCDEF framework. The 2025 PADIS focused update addressed sleep only pharmacologically (melatonin) and did not re-address the non-pharmacologic clustering question, so the 2018 recommendation remains the current position; Pun 2019 (bundle-outcome evidence) and the SAT/SBT page (a different intervention) do not speak to care-clustering.",
   "discrepancy": true
  },
  {
   "id": "icu-r31",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Sleep",
   "statement": "Long daytime napping avoided",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "structure",
   "pageNum": null,
   "citations": [],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "A sleep-hygiene implementation item supporting the bundle’s sleep-protection aim (the HELP nonpharmacologic sleep protocol; PADIS 2018 sleep component) — consolidating the day–night rhythm. Standard implementation rather than a verbatim source recommendation.",
   "perSource": [],
   "synthesis": "",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "icu-r32",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Mobility",
   "statement": "Early mobility / PT–OT performed",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "Inouye 1999 — p. 3, ¶60",
   "passage": "…  for protocol assessed once daily Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures) Change in rate of use of sedative drug for sleep† Immobility All patients; ambulation whenever possible, and range-of-motion exercises when patients chronically non-ambulatory, bed or wheelchair bound, immobilized (e.g., because of an extremity fracture or deep venous thrombosis), or when prescribed bed rest Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily ; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints) Change in Activities of Daily Living score Visual impairment Patients with <20/70 visual acuity on binocular near-vision testing Vision protocol: visual aids (e.g., glasses or magnifying lenses) and adaptive equipment (e.g., large illuminated telephone keypads, large-print books, and fluorescent tape on call bell), with daily reinforcement of their use Early correction of vision, «48 hr after admission Hearing impairment Patients hearing «6 of 12 whispers on Whisper Test Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques, with daily reinforc …\nPADIS 2025 similarly suggests enhanced mobilization and rehabilitation over usual care.",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "web",
     "stance": "background",
     "note": "SCCM ICU Liberation Bundle (A–F) framework cited by the Mobility section; its element E ('Early Mobility and Exercise') is the operational basis for the checkbox, but no archived full text was provided to quote.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": []
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "To our knowledge, few studies to date have specifically focused on evaluating integrated, interprofessional approaches to symptom management during critical illness. One such approach is known as the ABCDEF bundle (Assess, prevent, and manage pain; Both spontaneous awakening and breathing trials: Choice of Analgesia and Sedation; Delirium assess, prevent, and manage; Early Mobility and Exercise; Family engagement/ empowerment) (14-18). The ABCDEF bundle differs from other evidence-based, multicomponent ICU interventions (19-23) in several ways. First, it is applicable to every ICU patient every day, regardless of mechanical ventilation status or admitting diagnosis. Second, as it focuses on symptom assessment, prevention, and management rather than disease processes, it is particularly relevant early during the course of critical illness and is suitable for use in conjunction with other life-sustaining therapies. The team-based ABCDEF bundle approach is also unique in that its ultimate goal is to produce patients who are more awake, cognitively engaged, and physically active, which ultimately serves to facilitate patient autonomy and the ability to express unmet physical, emotional, and spiritual needs.",
       "highlight": "Early Mobility and Exercise",
       "scope": "on-scope",
       "note": "Defines the ABCDEF bundle studied in >15,000 ICU adults, with element E = Early Mobility and Exercise, naming the mobility component directly.",
       "page": "3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      },
      {
       "context": "of the bundle elements performed. All three outcomes were significant (p < 0.0001). The covariates adjusted for include demographic variables (age, sex, race, ethnicity, body mass index, residence before admission, mobility restriction before admission), admission features (diagnosis, hospital type [community vs. teaching], and ICU type), and daily ICU characteristics on the day of bundle exposure (receipt of medications, including benzodiazepines, opioids, propofol, dexmedetomidine, typical/atypical antipsychotics; comfort care order; mechanical ventilation; coma). We also adjusted for delirium on the day of bundle exposure when looking at the association between the bundle and delirium. Patients were \"eligible to receive\" elements A, C, D, and E on all ICU days. Patients were eligible for element B if sedated (part 1, SAT) and/or mechanically ventilated (part 2, SBT), and were eligible for element F if family or another caregiver was present. Therefore, patients were eligible for a maximum of seven and a minimum of four elements on any given day; proportion of elements performed is the number of elements performed, divided by the elements the patient was eligible to receive.",
       "highlight": "elements A, C, D, and E on all ICU days",
       "scope": "on-scope",
       "note": "Methods confirm element E (early mobility) was a tracked, performed bundle element for which patients were eligible on all ICU days.",
       "page": "4",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "Early mobility is an integral part of the ABCDEF bundle and has been the only intervention resulting in a decrease in days of delirium.54 During ICU stay critically ill patients can lose up to 25% peripheral muscle weakness within 4 days when mechanically ventilated and 18% in body weight by the time of discharge and this process is higher in the first 2-3 weeks of immobilization.55 The consequence of physical dysfunction in critically ill patients can be profound and long-term with significant reduction in functional status being observed even 1 year and 5 years after ICU discharge.56-58 ICU-acquired weakness is caused by many different pathophysiological mechanisms that are not mutually exclusive given the diverse diseases that precipitate critical illness, the drugs used during its management, and the consequences of protracted immobility.54 The reported incidence of ICU-acquired weakness ranges from 25 to 100%.59,60 The diagnosis of ICUacquired weakness is made by the Medical Research Council (MRC) scale for grading the strength (i.e., 0, total palsy to 5, normal strength) of various muscle groups in the upper and lower extremities.",
       "highlight": "Early mobility is an integral part of the ABCDEF bundle and has been the only intervention resulting in a decrease in days of delirium",
       "scope": "on-scope",
       "note": "States early mobility is an integral ABCDEF element and the only intervention shown to decrease days of delirium in the ICU.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      },
      {
       "context": "Studying patients early in the their course of mechanical ventilation (<3 days), Schweickert et al. showed that a daily SAT combined with physical and occupational therapy, versus SAT alone, resulted in an improved return to independent functional status at hospital discharge, shorter duration of ICU-delirium, higher survival, and more days breathing without assistance.",
       "highlight": "physical and occupational therapy, versus SAT alone, resulted in an improved return to independent functional status at hospital discharge, shorter duration of ICU-delirium",
       "scope": "on-scope",
       "note": "Cites the Schweickert RCT where SAT plus physical and occupational therapy improved functional recovery and shortened ICU-delirium — direct PT–OT support.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      },
      {
       "context": "5. Early mobility is the only currently known intervention associated with a decrease in delirium duration. Physical therapy is safe and feasible in the ICU, even while on mechanical ventilation, renal replacement therapy, and/or circulatory support.",
       "highlight": "Physical therapy is safe and feasible in the ICU, even while on mechanical ventilation, renal replacement therapy, and/or circulatory support",
       "scope": "on-scope",
       "note": "Key-points summary: early mobility is the only known intervention reducing delirium duration and physical therapy is safe and feasible in the ICU.",
       "page": "ms. p.15",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "We suggest performing rehabilitation or mobilization in critically ill adults (conditional recommendation, low quality evidence).",
       "highlight": "We suggest performing rehabilitation or mobilization in critically ill adults",
       "scope": "on-scope",
       "note": "The governing ICU guideline recommendation: conditionally suggests performing rehabilitation or mobilization in critically ill adults.",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Efficacy and Benefit Question: For critically ill adults, is receiving rehabilitation or mobilization (performed either in-bed or out-of-bed) beneficial in improving patient, family, or health system outcomes compared with usual care, a different rehabilitation/mobilization intervention, placebo, or sham intervention?",
       "highlight": "is receiving rehabilitation or mobilization (performed either in-bed or out-of-bed) beneficial",
       "scope": "on-scope",
       "note": "The efficacy PICO question framing the recommendation — rehabilitation/mobilization performed in-bed or out-of-bed in critically ill adults.",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Rationale: The multicomponent intervention studies evaluated a bundle of interventions. Many examples of multicomponent bundles (8, 283, 391-396) have shown improved outcomes in critically ill adults (Supplemental Table 29, Supplemental Digital Content 37, http://links.lww.com/CCM/ D795). Pilot studies suggested that combining cognitive and physical therapy early during critical illness is feasible and safe (391) and using nonpharmacologic multicomponent interventions in ICU patients is feasible (392). Studies of multicomponent interventions, many of which were not randomized, focus on cognitive impairment (e.g., reorientation, cognitive stimulation, music, use of clocks); sedation/sleep disruption (e.g., reducing sedation, minimizing light and noise); immobility (early rehabilitation/mobilization); and hearing and visual impairment (e.g., use of hearing aids and glasses). Overall, the use of such strategies reduced delirium significantly (five studies, n = 1,318; OR, 0.59; 95% CI, 0.39-0.88) (392-396). Further, ICU duration of delirium (16 vs 20hr) (395), ICU LOS (387), and hospital mortality all decreased (393).",
       "highlight": "the use of such strategies reduced delirium significantly (five studies, n = 1,318; OR, 0.59; 95% CI, 0.39-0.88)",
       "scope": "broader",
       "note": "Broader multicomponent-bundle evidence in ICU adults (early rehabilitation/mobilization is one component) showing significant delirium reduction — covers mobility as part of a whole bundle rather than in isolation.",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints)",
       "highlight": "ambulation or active range-of-motion exercises three times daily",
       "scope": "different-setting",
       "note": "The claim's stated primary anchor: the HELP early-mobilization protocol, but in hospitalized older patients on a general-medicine service, not an ICU population.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — immobility. Eligible patients: All patients; ambulation whenever possible, and range-of-motion exercises when patients chronically non-ambulatory, bed or wheelchair bound, immobilized (e.g., because of an extremity fracture or deep venous thrombosis), or when prescribed bed rest. Standardized intervention protocols: Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints). Targeted outcome for reassessment: Change in Activities of Daily Living score.",
       "highlight": "ambulation whenever possible, and range-of-motion exercises",
       "scope": "different-setting",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "Risk-factor criteria table flattened into label+definition pairs (Visual impairment / Hearing impairment / Dehydration) with the greater-than-or-equal symbols dropped as replacement characters."
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations.",
       "highlight": "early mobilization",
       "scope": "different-setting",
       "note": "Describes HELP's early-mobilization component within multicomponent nonpharmacological prevention, but for hospitalized older patients rather than ICU.",
       "page": "513",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "Overall, approximately 4267 patients at 12 sites (acute medical and surgical wards in academic and community hospitals) were involved; their mean age was 79.7 years. All studies involving non-acute care settings were excluded based on our criteria.",
       "highlight": "acute medical and surgical wards in academic and community hospitals",
       "scope": "different-setting",
       "note": "The meta-analysis population is acute medical/surgical wards (mean age 79.7), a non-ICU setting — shares the early-mobility keyword but is a different scope than the ICU tool.",
       "page": "515",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    }
   ],
   "synthesis": "The on-scope ICU sources agree: PADIS 2018 conditionally recommends performing rehabilitation/mobilization in critically ill adults, and the ABCDEF bundle (Marra 2017, Pun 2019, SCCM ICU Liberation) defines \"E — Early Mobility and Exercise\" as a performed element, with Marra noting early mobility is the only intervention shown to shorten delirium duration. The claim's stated primary anchor, Inouye 1999 (HELP), and Hshieh 2015 are the foundational evidence for early mobilization within multicomponent delirium prevention but come from general-medicine/acute wards in older patients — nearest matches that share the keyword but a different care setting/population, so the ICU-specific PADIS 2018 recommendation and the ABCDEF bundle element E govern this rounding-tool checkbox.",
   "discrepancy": true
  },
  {
   "id": "icu-r33",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Mobility",
   "statement": "HOB elevated where able",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "structure",
   "pageNum": null,
   "citations": [],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "A routine supportive-care item accompanying the cited bundle's early-mobility component; standard bedside care rather than a separately-cited delirium recommendation.",
   "perSource": [],
   "synthesis": "",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "icu-r34",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Mobility",
   "statement": "Restraints removed or minimized",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015",
    "PADIS 2025",
    "SAT/SBT"
   ],
   "anchor": "Inouye 1999 — p. 3, ¶60",
   "passage": "… or herbal tea), relaxation tapes or music, and back massage Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures) Change in rate of use of sedative drug for sleep† Immobility All patients; ambulation whenever possible, and range-of-motion exercises when patients chronically non-ambulatory, bed or wheelchair bound, immobilized (e.g., because of an extremity fracture or deep venous thrombosis), or when prescribed bed rest Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints) Change in Activities of Daily Living score Visual impairment Patients with <20/70 visual acuity on binocular near-vision testing Vision protocol: visual aids (e.g., glasses or magnifying lenses) and adaptive equipment (e.g., large illuminated telephone keypads, large-print books, and fluorescent tape on call bell), with daily reinforcement of their use Early correction of vision, «48 hr after admission Hearing impairment Patients hearing «6 of 12 whispers on Whisper Test Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques, with daily reinforcement of these adaptations Change in Whisper Test score Dehydration Patients with ratio o …",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived SCCM page describing the A-F ICU Liberation Bundle; provides the bundle framework the tool's non-pharm/mobility section sits under but never mentions restraints.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "The ICU Liberation Bundle consists of the following individual elements A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs) C Element : Choice of Analgesia and Sedation D Element : Delirium: Assess, Prevent, and Manage E Element: Early Mobility and Exercise F Element : Family Engagement and Empowerment",
       "highlight": "E Element: Early Mobility and Exercise",
       "scope": "broader",
       "note": "Lists the whole A-F bundle including Early Mobility; restraint minimization is an implicit non-pharm element but is not stated on this page.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope: complete ABCDEF/ICU-Liberation bundle performance is associated with significantly less physical restraint use and improved restraint-free care.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "Conclusions: ABCDEF bundle performance showed significant and clinically meaningful improvements in outcomes including survival, mechanical ventilation use, coma and delirium, restraint-free care, ICU readmissions, and post-ICU discharge disposition.",
       "highlight": "coma and delirium, restraint-free care, ICU readmissions",
       "scope": "on-scope",
       "note": "Conclusion lists restraint-free care among outcomes improved by ABCDEF bundle performance.",
       "page": "3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      },
      {
       "context": "Table 2 shows the adjusted hazard ratios (AHRs) and adjusted odds ratios (AORs) for outcomes of patients with complete ABCDEF bundle performance (versus anything less), adjusting for covariates. Patients with complete ABCDEF bundle performance on a given day (8% of all ICU days, SDC Table 4) had a higher likelihood of ICU discharge (AHR, 1.17; CI, 1.05-1.30) and hospital discharge (AHR, 1.19; CI, 1.01-1.40) and a lower likelihood of death (AHR, 0.32; CI, 0.17-0.62) at any given time (within the up-to-7-day observation period) compared with patients who did not receive 100% of all eligible bundle elements on that day. A patient with complete ABCDEF bundle performance on a given day also had a significantly lower likelihood of mechanical ventilation (AOR, 0.28; CI, 0.22- 0.36), coma (AOR, 0.35; 95% CI, 0.22-0.56), delirium (AOR, 0.60; CI, 0.49-0.72) or physical restraint (AOR, 0.37; CI, 0.30-0.46) on the following day. Table 2 also shows that hospital survivors with complete bundle performance (vs. any other patients) had a 46% lower likelihood of ICU readmission (AOR, 54%) and a 36% lower likelihood (AOR, 64%) of discharge to a destination other than home after adjusting for covariates.",
       "highlight": "physical restraint (AOR, 0.37; CI, 0.30-0.46) on the following day",
       "scope": "on-scope",
       "note": "Complete bundle performance associated with markedly lower odds of physical restraint the next day, directly supporting restraint minimization.",
       "page": "7",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Reviews the ABCDEF bundle including the early-mobility element but contains no discussion of physical restraints; nearest passage is a different intervention.",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "Early mobility is an integral part of the ABCDEF bundle and has been the only intervention resulting in a decrease in days of delirium.54 During ICU stay critically ill patients can lose up to 25% peripheral muscle weakness within 4 days when mechanically ventilated and 18% in body weight by the time of discharge and this process is higher in the first 2-3 weeks of immobilization.55 The consequence of physical dysfunction in critically ill patients can be profound and long-term with significant reduction in functional status being observed even 1 year and 5 years after ICU discharge.56-58 ICU-acquired weakness is caused by many different pathophysiological mechanisms that are not mutually exclusive given the diverse diseases that precipitate critical illness, the drugs used during its management, and the consequences of protracted immobility.54 The reported incidence of ICU-acquired weakness ranges from 25 to 100%.59,60 The diagnosis of ICUacquired weakness is made by the Medical Research Council (MRC) scale for grading the strength (i.e., 0, total palsy to 5, normal strength) of various muscle groups in the upper and lower extremities.",
       "highlight": "Early mobility is an integral part of the ABCDEF bundle",
       "scope": "different-intervention",
       "note": "Covers the early-mobility bundle element (the tool's Mobility section) but addresses mobilization, not restraint removal - shares the bundle context without supporting the restraint claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope and governing: dedicated Physical Restraints section on critically ill ICU adults; no efficacy evidence, documented harms, and guidance to weigh risks/benefits before initiating or maintaining restraints.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Critical care providers report using restraints to prevent self-extubation and medical device removal, avoid falls, and to protect staff from combative patients despite a lack of studies demonstrating efficacy and the safety concerns associated with physical restraints (e.g., unplanned extubations and greater agitation).",
       "highlight": "despite a lack of studies demonstrating efficacy and the safety concerns associated with physical restraints",
       "scope": "on-scope",
       "note": "Ungraded statement that restraints are used without efficacy evidence and with safety concerns, supporting minimizing their use.",
       "page": "e841",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Patients' perceptions of being physically restrained during an ICU stay vary but often provoke strong emotional responses that persist after the ICU stay (169, 269). Given the prevalence, unintended consequences, and patients' perceptions of physical restraint use, critical care providers should closely weigh the risks and benefits of this practice in the adult ICU setting before initiating or maintaining physical restraint use. Although certain countries report a \"restraint-free\" ICU environment, it may be possible that their use of bedside sitters and/or pharmacologic restraints is increased.",
       "highlight": "critical care providers should closely weigh the risks and benefits of this practice in the adult ICU setting before initiating or maintaining physical restraint use",
       "scope": "on-scope",
       "note": "Directly advises weighing risks/benefits before initiating or maintaining restraints in the adult ICU - the core support for 'restraints removed or minimized.'",
       "page": "e841",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "To date, no RCT has explored the safety and efficacy of physical restraint use in critically ill adults. The few descriptive studies exploring physical restraint use and outcomes of the critically ill paradoxically report higher rates of the events that their use is intended to prevent. These events include more unplanned extubations and frequent reintubations (245, 247, 267, 268); greater unintentional device removal (268); longer ICU LOS (245); increased agitation; higher benzodiazepine, opioid, and antipsychotic medication use (244, 268); and increased risk for delirium or disorientation (257, 259, 268, 270, 271).",
       "highlight": "paradoxically report higher rates of the events that their use is intended to prevent",
       "scope": "on-scope",
       "note": "Evidence that restraints are associated with more of the harms (unplanned extubation, agitation, delirium) they are meant to prevent, reinforcing minimization.",
       "page": "e841",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "",
     "kind": "pdf",
     "stance": "background",
     "note": "Focused update that adds Anxiety and revisits pain/sedation/delirium/immobility/sleep; it does not re-address physical restraints, so the 2018 restraint position remains the current position.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": []
    },
    {
     "label": "SAT/SBT",
     "cite": "",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived Vanderbilt CIBS/ICUDelirium page about the SAT/SBT (Wake Up and Breathe) bundle element; the only occurrence of 'restraints' is an anecdotal patient testimonial, not a clinical recommendation.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt",
     "paragraphs": []
    }
   ],
   "synthesis": "PADIS 2018 and Pun 2019 are the on-scope sources and agree: physical restraints in critically ill ICU adults lack efficacy evidence and are associated with harm, and higher ABCDEF/ICU-Liberation bundle performance is associated with significantly less physical restraint use, together supporting \"restraints removed or minimized.\" PADIS 2018 governs the restraint question directly and the 2025 focused update did not re-address physical restraints, so the 2018 position remains the current position; the SCCM ICU Liberation and SAT/SBT pages supply only bundle/SAT-SBT context and Marra 2017's nearest passage is the early-mobility element (a related but different intervention), so none of those three directly support the restraint claim.",
   "discrepancy": true
  },
  {
   "id": "icu-r35",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Mobility",
   "statement": "Unneeded lines / catheters removed",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "Inouye 1999 — p. 3, ¶60",
   "passage": "… or herbal tea), relaxation tapes or music, and back massage Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures) Change in rate of use of sedative drug for sleep† Immobility All patients; ambulation whenever possible, and range-of-motion exercises when patients chronically non-ambulatory, bed or wheelchair bound, immobilized (e.g., because of an extremity fracture or deep venous thrombosis), or when prescribed bed rest Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints) Change in Activities of Daily Living score Visual impairment Patients with <20/70 visual acuity on binocular near-vision testing Vision protocol: visual aids (e.g., glasses or magnifying lenses) and adaptive equipment (e.g., large illuminated telephone keypads, large-print books, and fluorescent tape on call bell), with daily reinforcement of their use Early correction of vision, «48 hr after admission Hearing impairment Patients hearing «6 of 12 whispers on Whisper Test Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques, with daily reinforcement of these adaptations Change in Whisper Test score Dehydration Patients with ratio o …",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "HELP RCT — the only source that directly prescribes minimizing catheters as part of the mobility intervention; governs this item.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints)",
       "highlight": "minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints)",
       "scope": "on-scope",
       "note": "HELP's early-mobilization protocol explicitly prescribes minimal use of immobilizing equipment such as bladder catheters — the direct basis for the 'unneeded lines/catheters removed' item, though HELP was a general-medicine older-adult ward program, not an ICU.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "partial",
     "note": "ICU guideline that recommends rehabilitation/mobilization and multicomponent nonpharmacologic prevention (the mobility category), but does not name catheter/line removal; a device-removal mention is a different-scope keyword match.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "We suggest performing rehabilitation or mobilization in critically ill adults (conditional recommendation, low quality evidence).",
       "highlight": "performing rehabilitation or mobilization in critically ill adults",
       "scope": "broader",
       "note": "Supports the ICU early-mobilization bundle the catheter-removal item belongs to, without addressing catheters specifically.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Remarks: These multicomponent interventions include (but are not limited to) strategies to reduce or shorten delirium (e.g., reorientation, cognitive stimulation, use of clocks); improve sleep (e.g., minimizing light and noise); improve wakefulness (i.e., reduced sedation); reduce immobility (e.g., early rehabilitation/mobilization); and reduce hearing and/or visual impairment (e.g., enable use of devices such as hearing aids or eye glasses).",
       "highlight": "reduce immobility (e.g., early rehabilitation/mobilization)",
       "scope": "broader",
       "note": "The multicomponent nonpharmacologic recommendation lists reducing immobility via early mobilization, the umbrella category, not the specific catheter-removal action.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Critical care providers report using restraints to prevent self-extubation and medical device removal, avoid falls, and to protect staff from combative patients despite a lack of studies demonstrating efficacy and the safety concerns associated with physical restraints (e.g., unplanned extubations and greater agitation).",
       "highlight": "medical device removal",
       "scope": "different-intervention",
       "note": "Nearest keyword match ('medical device removal') but framed oppositely — restraints used to PREVENT patients pulling devices, not clinicians removing unneeded catheters/lines.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "partial",
     "note": "ICU ABCDEF cohort showing improved restraint-free care/mobility outcomes (broader); its urinary-catheter mention describes a different, failed bundle.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "Conclusions: ABCDEF bundle performance showed significant and clinically meaningful improvements in outcomes including survival, mechanical ventilation use, coma and delirium, restraint-free care, ICU readmissions, and post-ICU discharge disposition.",
       "highlight": "restraint-free care",
       "scope": "broader",
       "note": "ABCDEF bundle improved restraint-free care and mobility in the ICU — the nearest supportive outcome, but not catheter/line-removal specific.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      },
      {
       "context": "Considering the burden that PICS imposes on ICU survivors, their family members, and society as a whole (5, 7, 42-45), there is a driving unmet need to improve both ICU structure and culture for the more than five million patients admitted to ICUs in the United States each year (46-51). One obvious tactic is to bundle proven interventions together. While some bundles and toolkits have been successful in improving patient outcomes (19-21), others have not (22). When assorted interventions that had proven effective individually (i.e., low tidal volume ventilation, moderate sedation, central venous and urinary catheter use, head of bed elevation, thromboembolism prophylaxis, and nutrition) were bundled together and implemented in 118 ICUs in Brazil, patient outcomes did not change (22). By contrast, the philosophy behind building the ABCDEF bundle was that the features had to be interdependent and clinically synergistic.",
       "highlight": "urinary catheter use, head of bed elevation, thromboembolism prophylaxis, and nutrition",
       "scope": "different-intervention",
       "note": "Keyword match ('urinary catheter') but describes a separate Brazilian daily-checklist bundle that merely tracked catheter use and did not improve outcomes — not the mobility item about removing unneeded catheters.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "partial",
     "note": "ABCDEF review establishing early mobility as the key delirium-prevention component (broader); its line/catheter mention concerns procedural pain, a different topic.",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "Early mobility is an integral part of the ABCDEF bundle and has been the only intervention resulting in a decrease in days of delirium.54 During ICU stay critically ill patients can lose up to 25% peripheral muscle weakness within 4 days when mechanically ventilated and 18% in body weight by the time of discharge and this process is higher in the first 2-3 weeks of immobilization.55 The consequence of physical dysfunction in critically ill patients can be profound and long-term with significant reduction in functional status being observed even 1 year and 5 years after ICU discharge.56-58 ICU-acquired weakness is caused by many different pathophysiological mechanisms that are not mutually exclusive given the diverse diseases that precipitate critical illness, the drugs used during its management, and the consequences of protracted immobility.54 The reported incidence of ICU-acquired weakness ranges from 25 to 100%.59,60 The diagnosis of ICUacquired weakness is made by the Medical Research Council (MRC) scale for grading the strength (i.e., 0, total palsy to 5, normal strength) of various muscle groups in the upper and lower extremities.",
       "highlight": "Early mobility is an integral part of the ABCDEF bundle",
       "scope": "broader",
       "note": "Frames early mobility as the ICU delirium-prevention element the catheter-removal item enables, without naming catheter/line removal.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      },
      {
       "context": "For the three most painful procedures (i.e., chest tube removal, wound drain removal, and arterial line insertion) pain intensity more than doubled during the procedure compared with the pre-procedural levels.",
       "highlight": "chest tube removal, wound drain removal, and arterial line insertion",
       "scope": "different-intervention",
       "note": "Nearest keyword match ('line', 'removal') but this concerns procedural pain assessment (the analgesia element), not removing unneeded lines/catheters for mobility.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived ICU Liberation landing page naming Early Mobility and Exercise as bundle element E; provides the ABCDEF framing but no catheter-removal detail.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "The ICU Liberation Bundle consists of the following individual elements A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs) C Element : Choice of Analgesia and Sedation D Element : Delirium: Assess, Prevent, and Manage E Element: Early Mobility and Exercise F Element : Family Engagement and Empowerment",
       "highlight": "E Element: Early Mobility and Exercise",
       "scope": "broader",
       "note": "Names Early Mobility and Exercise as the ICU bundle element that houses the item; the page is an index and does not itself specify catheter/line removal.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Meta-analysis of HELP-based multicomponent nonpharmacologic prevention identifying early mobility as an effective component (broader); does not name catheter/line removal.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "b Evidence-based nonpharmacological interventions include the following: cognition or orientation (C), early mobility (E), hearing (H), sleep-wake cycle preservation (P), vision (V), and hydration (W).",
       "highlight": "early mobility (E)",
       "scope": "broader",
       "note": "Identifies early mobility as an evidence-based component of effective multicomponent prevention — the category the catheter-removal action supports, without addressing catheters directly.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    }
   ],
   "synthesis": "Inouye 1999 (HELP) is the only source that directly supports this item, prescribing \"minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints)\" within its early-mobilization protocol, so it governs — though HELP was a general-medicine older-adult ward program rather than an ICU. The ICU sources (PADIS 2018, Pun 2019, Marra 2017, SCCM ICU Liberation) and the Hshieh 2015 meta-analysis agree on the broader early-mobility/mobilization bundle the item belongs to but do not name catheter or line removal, and several of their catheter/line/device mentions (Pun's failed Brazilian checklist, Marra's procedural-pain list, PADIS's restraint rationale) are different-scope keyword matches rather than direct support.",
   "discrepancy": true
  },
  {
   "id": "icu-r36",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Hydration & Nutrition",
   "statement": "Adequate fluids / nutrition reviewed",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "Inouye 1999 — p. 3, ¶60",
   "passage": "… ity on binocular near-vision testing Vision protocol: visual aids (e.g., glasses or magnifying lenses) and adaptive equipment (e.g., large illuminated telephone keypads, large-print books, and fluorescent tape on call bell), with daily reinforcement of their use Early correction of vision, «48 hr after admission Hearing impairment Patients hearing «6 of 12 whispers on Whisper Test Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques, with daily reinforcement of these adaptations Change in Whisper Test score Dehydration Patients with ratio of blood urea nitrogen to creatinine»18, screened for protocol by geriatric nurse-specialist Dehydration protocol: early recognition of dehydration and volume repletion (i.e., encouragement of oral intake of fluids) Change in ratio of blood urea nitrogen to creatinine The New England Journal of Medicine is produced by NEJM Group, a division of the Massachusetts Medical Society. Downloaded from nejm.org on June 18, 2026.\nAlso Hshieh 2015: \"therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations\"\nThe Inouye 1999 dehydration protocol addresses fluids only; nutrition is covered as a HELP component in Hshieh 2015, quoted second.",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Archived SCCM page defining the ICU Liberation (ABCDEF) bundle; the A-F element list contains no hydration/nutrition element, so it does not state the claim.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "The ICU Liberation Bundle consists of the following individual elements A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs) C Element : Choice of Analgesia and Sedation D Element : Delirium: Assess, Prevent, and Manage E Element: Early Mobility and Exercise F Element : Family Engagement and Empowerment",
       "highlight": "A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs)",
       "scope": "different-intervention",
       "note": "This is the nearest ICU-scoped match (the A-F bundle the tool's non-pharm section is built on), but the bundle enumerates only A-F and includes no hydration/nutrition item.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "The only nutrition mention is a separate Brazilian ICU bundle used as a contrast, not the ABCDEF bundle, so it does not support reviewing fluids/nutrition.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "Considering the burden that PICS imposes on ICU survivors, their family members, and society as a whole (5, 7, 42-45), there is a driving unmet need to improve both ICU structure and culture for the more than five million patients admitted to ICUs in the United States each year (46-51). One obvious tactic is to bundle proven interventions together. While some bundles and toolkits have been successful in improving patient outcomes (19-21), others have not (22). When assorted interventions that had proven effective individually (i.e., low tidal volume ventilation, moderate sedation, central venous and urinary catheter use, head of bed elevation, thromboembolism prophylaxis, and nutrition) were bundled together and implemented in 118 ICUs in Brazil, patient outcomes did not change (22). By contrast, the philosophy behind building the ABCDEF bundle was that the features had to be interdependent and clinically synergistic.",
       "highlight": "thromboembolism prophylaxis, and nutrition) were bundled together and implemented in 118 ICUs in Brazil, patient outcomes did not change",
       "scope": "different-intervention",
       "note": "Nutrition appears only as one component of a different, unsuccessful ICU bundle cited to contrast with the interdependent ABCDEF bundle, not as an endorsed delirium-prevention action.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Reviews the ICU ABCDEF bundle (A-F) with no mention of hydration, fluids, or nutrition anywhere in the text.",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "The ABCDEF bundle represents an evidence-based guide for clinicians to approach the organizational changes needed for optimizing ICU patient recovery and outcomes. The ABCDEF bundle includes: Assess, Prevent, and Manage Pain, Both Spontaneous Awakening Trials (SAT) and Spontaneous Breathing Trials (SBT), Choice of analgesia and sedation, Delirium: Assess, Prevent, and Manage, Early mobility and Exercise, and Family engagement and empowerment. In this chapter, we will review the core evidence and features behind the ABCDEF bundle. The bundle has individual components that are clearly defined, flexible to implement, and help empower multidisciplinary clinicians and families in the shared care of the critically ill. The ABCDEF bundle helps guide well-rounded patient care and optimal resource utilization resulting in more interactive ICU patients with better controlled pain, who can safely participate in higherorder physical and cognitive activities at the earliest point in their critical illness.",
       "highlight": "Early mobility and Exercise, and Family engagement and empowerment",
       "scope": "different-intervention",
       "note": "Nearest ICU match: the A-F bundle enumeration, which contains no hydration/nutrition element and so does not itemize the claim's action.",
       "page": "225",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "The ICU multicomponent nonpharmacologic prevention recommendation lists cognition, sleep, mobility, hearing, and vision but does not itemize hydration or nutrition (only disclosures mention nutrition).",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Recommendation: We suggest using a multicomponent, nonpharmacologic intervention that is focused on (but not limited to) reducing modifiable risk factors for delirium, improving cognition, and optimizing sleep, mobility, hearing, and vision in critically ill adults (conditional recommendation, low quality of evidence).",
       "highlight": "improving cognition, and optimizing sleep, mobility, hearing, and vision in critically ill adults",
       "scope": "broader",
       "note": "The broader ICU umbrella recommendation could subsume hydration under 'not limited to' but does not name fluids or nutrition as components.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Remarks: These multicomponent interventions include (but are not limited to) strategies to reduce or shorten delirium (e.g., reorientation, cognitive stimulation, use of clocks); improve sleep (e.g., minimizing light and noise); improve wakefulness (i.e., reduced sedation); reduce immobility (e.g., early rehabilitation/mobilization); and reduce hearing and/or visual impairment (e.g., enable use of devices such as hearing aids or eye glasses).",
       "highlight": "reduce hearing and/or visual impairment (e.g., enable use of devices such as hearing aids or eye glasses)",
       "scope": "broader",
       "note": "The enumerated ICU component list (reorientation, sleep, wakefulness, mobility, hearing/vision) omits any hydration or nutrition element.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "partial",
     "note": "The HELP dehydration protocol directly validates reviewing/repleting fluids as delirium prevention, but only the fluids half (no nutrition) and in hospitalized adults >=70 on a general-medicine ward, not the ICU.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — dehydration. Eligible patients: Patients with ratio of blood urea nitrogen to creatinine ≥18, screened for protocol by geriatric nurse-specialist. Standardized intervention protocols: Dehydration protocol: early recognition of dehydration and volume repletion (i.e., encouragement of oral intake of fluids). Targeted outcome for reassessment: Change in ratio of blood urea nitrogen to creatinine.",
       "highlight": "early recognition of dehydration and volume repletion (i.e., encouragement of oral intake of fluids)",
       "scope": "different-setting",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "This is a table/figure rendered as scattered cells (a column header \"TARGETED OUTCOME FOR REASSESSMENT\" followed by \"Change in ... score\" cell contents), not prose."
      },
      {
       "context": "Six risk factors for delirium were targeted for intervention: cognitive impairment, sleep deprivation, immobility, visual impairment, hearing impairment, and dehydration.24,25,28,38 These factors were selected on the basis of evidence of their association with the risk of delirium and because they were amenable to intervention strategies considered feasible in the context of current hospital practice. Table 1 describes the risk group that received each intervention, the standardized intervention protocols for each risk factor, and the targeted outcome for each intervention protocol.",
       "highlight": "cognitive impairment, sleep deprivation, immobility, visual impairment, hearing impairment, and dehydration",
       "scope": "different-setting",
       "note": "Confirms dehydration is one of the six targeted modifiable risk factors in HELP, but in the hospitalized-older-adult ward population rather than the ICU.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Meta-analysis of multicomponent nonpharmacologic delirium prevention that explicitly names both hydration AND nutrition as HELP components and finds these interventions effective, but in hospitalized older persons (acute care), not the ICU.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations",
       "scope": "different-setting",
       "note": "The only source that names both hydration and nutrition as delirium-prevention components, but the pooled interventions target hospitalized older persons on general wards, not critically ill ICU patients.",
       "page": "513",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    }
   ],
   "synthesis": "The evidence for an \"adequate fluids / nutrition reviewed\" delirium-prevention item comes from the HELP family of multicomponent nonpharmacologic programs in hospitalized older adults: Hshieh 2015 governs because it is the only source that explicitly names both hydration and nutrition as effective components, and Inouye 1999 provides the original dehydration-repletion protocol (fluids only). Both are general-ward/older-adult studies rather than ICU trials, and none of the ICU-scoped sources itemize this action — the ABCDEF bundle (Marra 2017, the SCCM ICU Liberation page) has no hydration/nutrition element, PADIS 2018's ICU multicomponent recommendation lists cognition/sleep/mobility/hearing/vision without naming fluids or nutrition, and Pun 2019 mentions nutrition only as part of a separate, unsuccessful ICU bundle.",
   "discrepancy": true
  },
  {
   "id": "icu-r37",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Hydration & Nutrition",
   "statement": "Bowel & bladder care addressed",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "structure",
   "pageNum": null,
   "citations": [],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "A routine supportive-care item (comfort, retention/constipation, early device removal) within the cited multicomponent bundle's scope; standard bedside care rather than a separately-cited recommendation.",
   "perSource": [],
   "synthesis": "",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "icu-r38",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Hydration & Nutrition",
   "statement": "Prolonged fasting avoided",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "structure",
   "pageNum": null,
   "citations": [],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "A hydration/nutrition supportive-care item aligned with the cited bundle's hydration component; standard bedside care rather than a verbatim source recommendation.",
   "perSource": [],
   "synthesis": "",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "icu-r39",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Hydration & Nutrition",
   "statement": "Oral care completed",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "structure",
   "pageNum": null,
   "citations": [],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "A routine supportive-care item within the cited bundle's scope; standard bedside nursing care rather than a separately-cited delirium recommendation.",
   "perSource": [],
   "synthesis": "",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "icu-r40",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Engagement",
   "statement": "Cognitive stimulation offered",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "Inouye 1999 — p. 3, ¶60",
   "passage": "Cognitive impairment* All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily Orientation protocol: board with names of care-team members and day's schedule; communication to reorient to surroundings Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games) Change in orientation score Sleep deprivation All patients; need for protocol assessed once daily Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures) Change in rate of use of sedative drug for sleep† Immobility All patients; ambulation whenever possible, and range-of-motion exercises when patients chronically non-ambulatory, bed or wheelchair bound, immobilized (e.g., because of an extremity f …",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived SCCM web page; describes the A-F ICU Liberation Bundle at a high level (D and F elements) but does not name cognitive stimulation as a discrete intervention.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "The ICU Liberation Bundle consists of the following individual elements A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs) C Element : Choice of Analgesia and Sedation D Element : Delirium: Assess, Prevent, and Manage E Element: Early Mobility and Exercise F Element : Family Engagement and Empowerment",
       "highlight": "Delirium: Assess, Prevent, and Manage",
       "scope": "background",
       "note": "Lists the bundle's delirium element (the framework within which non-pharmacologic cognitive stimulation would sit) but does not state cognitive stimulation itself.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "background",
     "note": "Describes the ABCDEF bundle and its goal of cognitively engaged patients, but does not state cognitive stimulation as an offered non-pharmacologic intervention.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "To our knowledge, few studies to date have specifically focused on evaluating integrated, interprofessional approaches to symptom management during critical illness. One such approach is known as the ABCDEF bundle (Assess, prevent, and manage pain; Both spontaneous awakening and breathing trials: Choice of Analgesia and Sedation; Delirium assess, prevent, and manage; Early Mobility and Exercise; Family engagement/ empowerment) (14-18). The ABCDEF bundle differs from other evidence-based, multicomponent ICU interventions (19-23) in several ways. First, it is applicable to every ICU patient every day, regardless of mechanical ventilation status or admitting diagnosis. Second, as it focuses on symptom assessment, prevention, and management rather than disease processes, it is particularly relevant early during the course of critical illness and is suitable for use in conjunction with other life-sustaining therapies. The team-based ABCDEF bundle approach is also unique in that its ultimate goal is to produce patients who are more awake, cognitively engaged, and physically active, which ultimately serves to facilitate patient autonomy and the ability to express unmet physical, emotional, and spiritual needs.",
       "highlight": "more awake, cognitively engaged, and physically active",
       "scope": "background",
       "note": "States a bundle goal (cognitively engaged patients) rather than offering cognitive stimulation as a specific intervention.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "background",
     "note": "Reviews the ABCDEF bundle framework; references higher-order cognitive activities as an outcome but does not name cognitive stimulation as an offered engagement intervention.",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "The ABCDEF bundle represents an evidence-based guide for clinicians to approach the organizational changes needed for optimizing ICU patient recovery and outcomes. The ABCDEF bundle includes: Assess, Prevent, and Manage Pain, Both Spontaneous Awakening Trials (SAT) and Spontaneous Breathing Trials (SBT), Choice of analgesia and sedation, Delirium: Assess, Prevent, and Manage, Early mobility and Exercise, and Family engagement and empowerment. In this chapter, we will review the core evidence and features behind the ABCDEF bundle. The bundle has individual components that are clearly defined, flexible to implement, and help empower multidisciplinary clinicians and families in the shared care of the critically ill. The ABCDEF bundle helps guide well-rounded patient care and optimal resource utilization resulting in more interactive ICU patients with better controlled pain, who can safely participate in higherorder physical and cognitive activities at the earliest point in their critical illness.",
       "highlight": "participate in higherorder physical and cognitive activities",
       "scope": "background",
       "note": "Frames cognitive activity as a bundle outcome/goal in ICU patients, not as the offered cognitive-stimulation intervention itself.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ICU-specific guideline: directly recommends a multicomponent nonpharmacologic intervention that explicitly includes cognitive stimulation for critically ill adults. This is the on-scope governing source.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Remarks: These multicomponent interventions include (but are not limited to) strategies to reduce or shorten delirium (e.g., reorientation, cognitive stimulation, use of clocks); improve sleep (e.g., minimizing light and noise); improve wakefulness (i.e., reduced sedation); reduce immobility (e.g., early rehabilitation/mobilization); and reduce hearing and/or visual impairment (e.g., enable use of devices such as hearing aids or eye glasses).",
       "highlight": "reorientation, cognitive stimulation, use of clocks",
       "scope": "on-scope",
       "note": "Names cognitive stimulation (and reorientation) as an explicit component of the recommended ICU multicomponent intervention.",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Recommendation: We suggest using a multicomponent, nonpharmacologic intervention that is focused on (but not limited to) reducing modifiable risk factors for delirium, improving cognition, and optimizing sleep, mobility, hearing, and vision in critically ill adults (conditional recommendation, low quality of evidence).",
       "highlight": "improving cognition, and optimizing sleep, mobility, hearing, and vision in critically ill adults",
       "scope": "on-scope",
       "note": "Formal conditional recommendation for the multicomponent non-pharm bundle in critically ill (ICU) adults, the correct population for the tool.",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Foundational HELP trial defining the 'cognitively stimulating activities' protocol, but in hospitalized older general-medicine patients, not ICU; it is the origin of the intervention PADIS carries into the ICU rather than direct ICU evidence.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — cognitive impairment. Eligible patients: All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily. Standardized intervention protocols: Orientation protocol: board with names of care-team members and day’s schedule; communication to reorient to surroundings. Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games). Targeted outcome for reassessment: Change in orientation score.",
       "highlight": "cognitively stimulating activities three times daily",
       "scope": "different-setting",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "Concatenated cells from Inouye's standardized-intervention-protocols table, not prose; starts and ends mid-entry."
      },
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — cognitive impairment. Eligible patients: All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily. Standardized intervention protocols: Orientation protocol: board with names of care-team members and day’s schedule; communication to reorient to surroundings. Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games). Targeted outcome for reassessment: Change in orientation score.",
       "highlight": "communication to reorient to surroundings",
       "scope": "different-setting",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "Risk-factor/eligibility and protocol table cells merged into one blob, with replacement characters where symbols were lost."
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Meta-analysis confirming multicomponent non-pharm delirium interventions (reorientation, therapeutic activities) reduce delirium, but in hospitalized elderly (non-ICU) populations, so it is off-setting supporting evidence rather than direct ICU support.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "reorientation, early mobilization, therapeutic activities",
       "scope": "different-population",
       "note": "Lists the HELP components (incl. therapeutic activities = cognitive stimulation) meta-analyzed across hospitalized elderly, not ICU, patients.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "b Evidence-based nonpharmacological interventions include the following: cognition or orientation (C), early mobility (E), hearing (H), sleep-wake cycle preservation (P), vision (V), and hydration (W).",
       "highlight": "cognition or orientation (C)",
       "scope": "different-population",
       "note": "Classifies cognition/orientation as an evidence-based non-pharm intervention component, but in the general hospitalized-elderly population rather than ICU.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    }
   ],
   "synthesis": "The on-scope ICU source, PADIS 2018, directly governs and agrees: it recommends a multicomponent nonpharmacologic intervention that explicitly names cognitive stimulation (and reorientation) for critically ill adults. The primary anchor Inouye 1999 (HELP) and Hshieh 2015 define and quantify the same cognitively-stimulating-activities component but in hospitalized older, non-ICU patients, so they are the foundational off-setting evidence rather than direct ICU support, while the ABCDEF/ICU Liberation sources (SCCM, Pun 2019, Marra 2017) describe the surrounding bundle framework without naming cognitive stimulation.",
   "discrepancy": true
  },
  {
   "id": "icu-r41",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Engagement",
   "statement": "Preferred music / familiar media",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "PADIS 2018 — p. 34",
   "passage": "… The music had a small effect on improving sleep quality (as evaluated by the Verran and Snyder-Halpern Sleep Scale) (MD, 48 points; 95% CI, 34.5-130.5; very low quality) and sleep efficiency (as evaluated by polysomnography) (MD, 2.3%; 95% CI, 27.3-32.0; very low quality). Given the low quality of evidence (no blinding, ambient noise not controlled) and the resources needed to institute this intervention, the panel made a conditional recommendation against the use of music to improve sleep in critically ill adults. Music may play a role in reducing pain (see pain section) and anxiety in the ICU (133). If patients (or their families) request it, it should be considered. Noise and Light Reduction Question: Should noise and light reduction strategies (vs not using these strategies) be used at night to improve sleep in critically ill adults? Recommendation: We suggest using noise and light reduction strategies to improve sleep in critically ill adults (conditional recommendation, low quality of evidence). Rationale: Two RCTs (458, 513) and two observational studies (514, 515) evaluated strategies to reduce ICU noise and light at night through the use of earplugs with or without the use of eyeshades. …\nPADIS 2018 supports offering music at patient or family request; \"familiar media\" more broadly is not stated. The Inouye 1999 sleep protocol likewise offers relaxation tapes or music.",
   "evidence": "Full text, p. 34 — partial support",
   "status": "fulltext",
   "pageNum": "34",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived web page establishing the A-F ICU Liberation Bundle; its 'Engagement' element is Family Engagement/Empowerment and it never mentions patient music or familiar media.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "The ICU Liberation Bundle consists of the following individual elements A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs) C Element : Choice of Analgesia and Sedation D Element : Delirium: Assess, Prevent, and Manage E Element: Early Mobility and Exercise F Element : Family Engagement and Empowerment",
       "highlight": "F Element : Family Engagement and Empowerment",
       "scope": "background",
       "note": "Lists the A-F bundle the tool's non-pharm bundle mirrors; the engagement element here is Family Engagement/Empowerment, not the patient's preferred music/media, which the page does not address.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "background",
     "note": "Reports ABCDEF bundle outcomes in >15,000 ICU adults; defines the F 'Family engagement/empowerment' element but does not name music or familiar media as an intervention.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "To our knowledge, few studies to date have specifically focused on evaluating integrated, interprofessional approaches to symptom management during critical illness. One such approach is known as the ABCDEF bundle (Assess, prevent, and manage pain; Both spontaneous awakening and breathing trials: Choice of Analgesia and Sedation; Delirium assess, prevent, and manage; Early Mobility and Exercise; Family engagement/ empowerment) (14-18). The ABCDEF bundle differs from other evidence-based, multicomponent ICU interventions (19-23) in several ways. First, it is applicable to every ICU patient every day, regardless of mechanical ventilation status or admitting diagnosis. Second, as it focuses on symptom assessment, prevention, and management rather than disease processes, it is particularly relevant early during the course of critical illness and is suitable for use in conjunction with other life-sustaining therapies. The team-based ABCDEF bundle approach is also unique in that its ultimate goal is to produce patients who are more awake, cognitively engaged, and physically active, which ultimately serves to facilitate patient autonomy and the ability to express unmet physical, emotional, and spiritual needs.",
       "highlight": "Family engagement/ empowerment)",
       "scope": "background",
       "note": "The bundle's engagement component is family engagement/empowerment; shares the 'engagement' keyword but is a different intervention than patient music/media and is not direct support.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "background",
     "note": "Narrative ABCDEF review; its 'Engagement' content is the F Family Engagement element (family wishes/participation), not patient music or familiar media.",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "The ABCDE bundle has evolved to include Family Engagement, as no ICU treatment plan is complete without incorporation of the family's wishes, concerns, questions, and participation. Family members and surrogate decision makers must become active partners in multi-professional decision-making and treatment planning. Through this partnership, patients' preferences can be identified, the anxiety of families can be lessened, and physicians can have appropriate input into decisions.67 Family presence on ICU rounds is beneficial, and it does not interfere with education and communication process.68 Families have reported increased feelings of inclusion, respect, and having a better understanding of their loved one's care.",
       "highlight": "no ICU treatment plan is complete without incorporation of the family's wishes",
       "scope": "background",
       "note": "Nearest 'engagement' content is family engagement/empowerment; the review does not address music or familiar media, so it is bundle context only.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope adult-ICU guideline: music is part of multicomponent nonpharmacologic delirium-reduction and carries a conditional recommendation to offer patient-preferred music therapy to critically ill adults.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Rationale: The multicomponent intervention studies evaluated a bundle of interventions. Many examples of multicomponent bundles (8, 283, 391-396) have shown improved outcomes in critically ill adults (Supplemental Table 29, Supplemental Digital Content 37, http://links.lww.com/CCM/ D795). Pilot studies suggested that combining cognitive and physical therapy early during critical illness is feasible and safe (391) and using nonpharmacologic multicomponent interventions in ICU patients is feasible (392). Studies of multicomponent interventions, many of which were not randomized, focus on cognitive impairment (e.g., reorientation, cognitive stimulation, music, use of clocks); sedation/sleep disruption (e.g., reducing sedation, minimizing light and noise); immobility (early rehabilitation/mobilization); and hearing and visual impairment (e.g., use of hearing aids and glasses). Overall, the use of such strategies reduced delirium significantly (five studies, n = 1,318; OR, 0.59; 95% CI, 0.39-0.88) (392-396). Further, ICU duration of delirium (16 vs 20hr) (395), ICU LOS (387), and hospital mortality all decreased (393).",
       "highlight": "reorientation, cognitive stimulation, music, use of clocks",
       "scope": "on-scope",
       "note": "Multicomponent nonpharmacologic interventions in ICU patients explicitly including music (with reorientation/cognitive stimulation) significantly reduced delirium (five studies, n=1,318; OR 0.59) — directly the engagement/cognitive-stimulation framing of the claim.",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Recommendation: We suggest offering music therapy to relieve both nonprocedural and procedural pain in critically ill adults (conditional recommendation, low quality of evidence).",
       "highlight": "We suggest offering music therapy to relieve both nonprocedural and procedural pain in critically ill adults",
       "scope": "on-scope",
       "note": "PADIS conditional recommendation to offer music therapy to critically ill adults — direct ICU-population support for music as a nonpharmacologic intervention.",
       "page": "e835",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "For nonprocedural pain management, effectiveness of music was tested in four studies including three RCTs with a total of 434 medical or surgical ICU patients (12, 116, 117, 131) and a pre/posttest observational study with 87 cardiac surgery ICU patients (132). The comparator arms included standard care (117) or a rest period (116, 131). Pooled analysis showed that music reduced pain intensity (0-10 NRS) (MD, -0.66cm; 95% CI, -0.89 to -0.43; low quality). These reductions in pain intensity for both procedural and nonprocedural pain management were not considered to be clinically significant. However, the potential for benefit outweighed any signal for harm or resource requirements. One large RCT that found that personal-directed music therapy reduces anxiety and sedative use in critically ill adults was not included in the evidence profile for this question because it did not report pain assessments (133).",
       "highlight": "personal-directed music therapy reduces anxiety and sedative use in critically ill adults",
       "scope": "on-scope",
       "note": "Supports the 'preferred/personal-directed' framing: patient-selected music reduced anxiety and sedative use in ICU adults; the panel also states the patient's preference should be considered.",
       "page": "e836",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "partial",
     "note": "HELP RCT in patients >=70 on a general-medicine (non-ICU) service; music appears as a nonpharmacologic protocol component but in a different setting/population from the ICU tool.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — sleep deprivation. Eligible patients: All patients; need for protocol assessed once daily. Standardized intervention protocols: Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage. Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures). Targeted outcome for reassessment: Change in rate of use of sedative drug for sleep.",
       "highlight": "relaxation tapes or music",
       "scope": "different-setting",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "This is Inouye's intervention-protocols table dumped as text: multiple protocol labels concatenated, starting and ending mid-content."
      },
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — cognitive impairment. Eligible patients: All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily. Standardized intervention protocols: Orientation protocol: board with names of care-team members and day’s schedule; communication to reorient to surroundings. Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games). Targeted outcome for reassessment: Change in orientation score.",
       "highlight": "cognitively stimulating activities three times daily",
       "scope": "different-setting",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "Same intervention-protocols table content run together, truncated mid-word ('immobil')."
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "background",
     "note": "Meta-analysis of HELP-type multicomponent nonpharmacologic delirium prevention in patients >=65 (largely non-ICU); lists cognitive/orientation and therapeutic-activity components but not music or familiar media specifically.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "reorientation, early mobilization, therapeutic activities",
       "scope": "different-population",
       "note": "Nearest match on multicomponent nonpharmacologic delirium prevention, but in older (>=65) hospitalized patients outside the ICU and without music/media named as a component.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    }
   ],
   "synthesis": "The adult-ICU guideline PADIS 2018 is the on-scope governing source: it lists music among multicomponent nonpharmacologic interventions that significantly reduced delirium in ICU patients and issues a conditional recommendation to offer patient-preferred/personal-directed music therapy to critically ill adults. The ICU Liberation / ABCDEF sources (SCCM, Pun 2019, Marra 2017) establish the bundle and its Family Engagement element but never name music or familiar media, and HELP (Inouye 1999) and Hshieh 2015 support music/cognitive-stimulation only in older, non-ICU inpatients — so those nearest matches are a different scope.",
   "discrepancy": true
  },
  {
   "id": "icu-r42",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Engagement",
   "statement": "Family present or contacted",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015"
   ],
   "anchor": "Marra 2017 — p. 9",
   "passage": "F: Family engagement The ABCDE bundle has evolved to include Family Engagement, as no ICU treatment plan is complete without incorporation of the family's wishes, concerns, questions, and participation. Family members and surrogate decision makers must become active partners in multi-professional decision-making and treatment planning. Through this partnership, patients' preferences can be identified, the anxiety of families can be lessened, and physicians can have appropriate input into decisions.67 Family presence on ICU rounds is beneficial, and it does not interfere with education and communication process. 68 Families have reported increased feelings of inclusion, respect, and having a better understanding of their loved one's care. …",
   "evidence": "Full text, p. 9",
   "status": "fulltext",
   "pageNum": "9",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
    "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Archived SCCM web page (site navigation stripped); the content sentence names the bundle's F element as Family Engagement and Empowerment, the element the checklist item implements.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "The ICU Liberation Bundle consists of the following individual elements A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs) C Element : Choice of Analgesia and Sedation D Element : Delirium: Assess, Prevent, and Manage E Element: Early Mobility and Exercise F Element : Family Engagement and Empowerment",
       "highlight": "Family Engagement and Empowerment",
       "scope": "on-scope",
       "note": "Defines the F element of the ICU Liberation (ABCDEF) bundle as family engagement/empowerment, directly on point for 'Family present or contacted.'",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Pun 2019",
     "cite": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Large multicenter ICU cohort; operationalizes element F as family/caregiver presence and lists it as a defined bundle element.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003482",
     "paragraphs": [
      {
       "context": "of the bundle elements performed. All three outcomes were significant (p < 0.0001). The covariates adjusted for include demographic variables (age, sex, race, ethnicity, body mass index, residence before admission, mobility restriction before admission), admission features (diagnosis, hospital type [community vs. teaching], and ICU type), and daily ICU characteristics on the day of bundle exposure (receipt of medications, including benzodiazepines, opioids, propofol, dexmedetomidine, typical/atypical antipsychotics; comfort care order; mechanical ventilation; coma). We also adjusted for delirium on the day of bundle exposure when looking at the association between the bundle and delirium. Patients were \"eligible to receive\" elements A, C, D, and E on all ICU days. Patients were eligible for element B if sedated (part 1, SAT) and/or mechanically ventilated (part 2, SBT), and were eligible for element F if family or another caregiver was present. Therefore, patients were eligible for a maximum of seven and a minimum of four elements on any given day; proportion of elements performed is the number of elements performed, divided by the elements the patient was eligible to receive.",
       "highlight": "eligible for element F if family or another caregiver was present",
       "scope": "on-scope",
       "note": "Operational definition: element F was credited when family or another caregiver was present, precisely matching 'Family present or contacted.'",
       "page": "4",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      },
      {
       "context": "To our knowledge, few studies to date have specifically focused on evaluating integrated, interprofessional approaches to symptom management during critical illness. One such approach is known as the ABCDEF bundle (Assess, prevent, and manage pain; Both spontaneous awakening and breathing trials: Choice of Analgesia and Sedation; Delirium assess, prevent, and manage; Early Mobility and Exercise; Family engagement/ empowerment) (14-18). The ABCDEF bundle differs from other evidence-based, multicomponent ICU interventions (19-23) in several ways. First, it is applicable to every ICU patient every day, regardless of mechanical ventilation status or admitting diagnosis. Second, as it focuses on symptom assessment, prevention, and management rather than disease processes, it is particularly relevant early during the course of critical illness and is suitable for use in conjunction with other life-sustaining therapies. The team-based ABCDEF bundle approach is also unique in that its ultimate goal is to produce patients who are more awake, cognitively engaged, and physically active, which ultimately serves to facilitate patient autonomy and the ability to express unmet physical, emotional, and spiritual needs.",
       "highlight": "Family engagement/ empowerment",
       "scope": "on-scope",
       "note": "Enumerates the ABCDEF bundle elements including Family engagement/empowerment as F, situating the checklist item within the bundle.",
       "page": "3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    },
    {
     "label": "Marra 2017",
     "cite": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary source; the dedicated 'F: Family engagement' section (p. 9) defines the element and endorses family presence and contact.",
     "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005",
     "paragraphs": [
      {
       "context": "The ABCDE bundle has evolved to include Family Engagement, as no ICU treatment plan is complete without incorporation of the family's wishes, concerns, questions, and participation. Family members and surrogate decision makers must become active partners in multi-professional decision-making and treatment planning. Through this partnership, patients' preferences can be identified, the anxiety of families can be lessened, and physicians can have appropriate input into decisions.67 Family presence on ICU rounds is beneficial, and it does not interfere with education and communication process.68 Families have reported increased feelings of inclusion, respect, and having a better understanding of their loved one's care.",
       "highlight": "Family members and surrogate decision makers must become active partners in multi-professional decision-making and treatment planning",
       "scope": "on-scope",
       "note": "Opens the F: Family engagement section, defining family as active partners in ICU care and decision-making.",
       "page": "ms. p.9",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      },
      {
       "context": "Family presence on ICU rounds is beneficial, and it does not interfere with education and communication process.68 Families have reported increased feelings of inclusion, respect, and having a better understanding of their loved one's care.",
       "highlight": "Family presence on ICU rounds is beneficial",
       "scope": "on-scope",
       "note": "Directly supports family presence/contact at the bedside (rounds, family conferences, communication) as the F element in practice.",
       "page": "ms. p.9",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      },
      {
       "context": "Beyond sharing of communication, family presence has been encouraged in traumatizing medical events and procedures, such as Cardiopulmonary Resuscitation (CPR). In some studies, the family presence during CPR is associated with positive results on psychological variables, and did not interfere with medical efforts, increase stress in the health care team, or result in medicolegal conflicts. In fact, relatives who did not witness CPR had symptoms of anxiety and depression more frequently than those who did witness CPR.77 Critical illness usually impacts not only an individual, but their entire support system, which may or may not be their nuclear family, or some combination of family and friends or other Author Manuscript Author Manuscript Crit Care Clin.",
       "highlight": "family presence during CPR is associated with positive results on psychological variables",
       "scope": "different-intervention",
       "note": "Nearest keyword match but a distinct scenario (family witnessed resuscitation), not the routine engagement/contact the checklist item denotes.",
       "page": "ms. p.9",
       "docUrl": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ICU guideline; endorses the ABCDEF bundle (which includes the F family-engagement focus) within a conditional recommendation for multicomponent interventions, and separately reviews single-component family participation.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "When a revised and expanded ABCDEF bundle (which includes a focus on \"F,\" Family engagement) was evaluated in a larger, multicenter, before-after, cohort study, and where delirium was also assessed using the CAM-ICU, an adjusted analysis showed that improvements in bundle compliance were significantly associated with reduced mortality and more ICU days without coma or delirium (9).",
       "highlight": "focus on \"F,\" Family engagement",
       "scope": "on-scope",
       "note": "Names the expanded ABCDEF bundle's 'F' Family engagement focus in the multicomponent-intervention recommendation the panel conditionally supports.",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Rationale: ICU delirium studies of nonpharmacologic interventions focused on either one modifiable risk factor with a single intervention or several modifiable risk factors with multicomponent interventions (Supplemental Table 28, Supplemental Digital Content 36, http://links.lww.com/ CCM/D794). For the purposes of these guidelines, one question addressed single intervention studies and one question addressed multicomponent intervention studies. Delirium incidence, prevalence, and duration were considered the most important outcomes across both questions. ICU LOS, hospital LOS, and hospital mortality were also considered to be critical outcomes for these questions. Bright light therapy, family participation in care, and a psychoeducational program were the only single-component interventions that have been studied in the ICU.",
       "highlight": "family participation in care, and a psychoeducational program were the only single-component interventions",
       "scope": "different-intervention",
       "note": "Treats 'family participation in care' as one isolated single-component delirium-prevention intervention studied, a narrower/different framing than the bundle's engagement element.",
       "page": "e846",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Three studies examined the effects of light therapy, which did not demonstrate beneficial effect on either delirium incidence or ICU LOS (387-389). One before-after study evaluated the effect of family participation in care (390). Panel members judged that the undesirable consequences of using bright light therapy outweighed the potential desirable effects associated with its use and thus issued a conditional recommendation against its use.",
       "highlight": "One before-after study evaluated the effect of family participation in care",
       "scope": "different-intervention",
       "note": "Cites the single before-after study of family participation in care as an intervention, distinct from routine family presence/contact at the bedside.",
       "page": "e846",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "background",
     "note": "HELP RCT in hospitalized older non-ICU medical patients; family appears only as a prior-study category and a baseline-history informant, not as a HELP intervention protocol, so it does not directly support the F engagement element.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Previous interventional studies of delirium have focused on four types of intervention: general geriatric approaches,9-14 nursing care,15-19 family interventions,20 and anesthesia.21-23 Although in most of the studies there were trends toward a reduction in delirium in the intervention group, in most cases the reduction was not statistically significant. Many studies had methodologic limitations, such as small samples, use of nontargeted interventions, and use of relatively insensitive outcome measures (e.g., screening mental-status tests or confusion checklists). Finally, most previous studies focused on the treatment of delirium rather than on primary prevention, which was the goal of the present study.",
       "highlight": "nursing care,15-19 family interventions,20 and anesthesia",
       "scope": "different-population",
       "note": "Lists 'family interventions' only as one prior category of delirium studies; the HELP protocols themselves (orientation, mobilization, vision, hearing, hydration, therapeutic activities) contain no family-engagement element, and the setting is general medical wards, not the ICU.",
       "page": "669",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Eligible patients then underwent the base-line assessment, which included the collection of demographic data, assessment of instrumental activities of daily living,34 the Whisper Test35 for hearing, and assessment of sleep. Visual impairment was defined as binocular near vision, after correction, worse than 20/70 as measured by the standard Jaeger test. The APACHE II score measures severity of illness on a scale of 0 to 71, with higher scores indicating increased severity. The instrumental Activities of Daily Living scale assesses the ability to perform seven complex activities (using the telephone, grocery shopping, using transportation, cooking, housekeeping, taking medications, and handling finances) on a scale of 0 to 14, with lower scores indicating functional impairment. The Whisper Test measures hearing according to the number of 12 whispers heard, with 6 or fewer indicating hearing impairment. A family member was interviewed at the time of admission and asked to describe the patient's cognitive functioning before admission and any recent cognitive changes and to complete the modified Blessed Dementia Rating Scale,36,37 an observer-rated score that correlates directly with the number of neuritic plaques found on postmortem examination of the brain. The modified (shortened) version has been tested37; scores greater than 2 on the modified Blessed Dementia Rating Scale indicate possible dementia. A ratio of blood urea nitrogen to creatinine (both measured in milligrams per deciliter) of 18 or greater was used as an index of dehydration. Screening and base-line assessments were completed within 48 hours after admission.",
       "highlight": "A family member was interviewed at the time of admission",
       "scope": "background",
       "note": "Family is used here as a baseline-history informant during screening, a methods detail rather than a family-engagement intervention.",
       "page": "670",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "background",
     "note": "Meta-analysis of multicomponent nonpharmacological delirium prevention in mostly older general-hospital (non-ICU) patients; family is noted only as a possible deliverer of interventions in some newer programs.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "using volunteers, family members, and nurses in the delivery of interventions",
       "scope": "different-population",
       "note": "Mentions family members as one channel for delivering multicomponent interventions in general-ward programs, not the ICU bundle's 'family present or contacted' engagement element.",
       "page": "512",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    }
   ],
   "synthesis": "The on-scope ICU sources agree: Marra 2017 (\"F: Family engagement,\" p. 9), Pun 2019 (element F is counted whenever \"family or another caregiver was present\"), and the SCCM ICU Liberation page (\"F Element: Family Engagement and Empowerment\") all establish family presence/engagement as the ABCDEF bundle's \"F\" element, directly supporting the bedside item \"Family present or contacted\"; PADIS 2018 endorses this within its conditional recommendation for multicomponent interventions. Marra 2017 governs as the primary on-scope source; Inouye 1999 (HELP) and Hshieh 2015 are different-population general-ward delirium-prevention programs whose protocols do not contain a family-engagement element (family is mentioned only as a prior-study category, a baseline-history informant, or an intervention deliverer), so they are background rather than direct support.",
   "discrepancy": true
  },
  {
   "id": "icu-r43",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "1",
   "section": "Non-pharm bundle — Engagement",
   "statement": "T-A-D-A used (Tolerate, Anticipate, Don’t Agitate)",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Pun 2019",
    "Marra 2017",
    "PADIS 2018",
    "Inouye 1999",
    "Hshieh 2015",
    "Flaherty & Little 2011"
   ],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "guideline",
   "pageNum": null,
   "citations": [],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://doi.org/10.1097/CCM.0000000000003482",
    "https://doi.org/10.1016/j.ccc.2016.12.005",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Flaherty & Little 2011",
     "cite": "Flaherty JH, Little MO. Matching the environment to patients with delirium: lessons learned from the delirium room. J Am Geriatr Soc. 2011;59(Suppl 2):S295-S300.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Describes the T-A-D-A method: Tolerate, Anticipate, Don't Agitate.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/22091576/",
     "paragraphs": [
      {
       "context": "This article is based on 13 years of experience at two hospitals. The authors have found that a restraint-free environment can be achieved; “tolerate, anticipate, and don't agitate” (the T-A-DA method) are the core principles of the nonpharmacological approach that go beyond the traditional strategies of management (such as reorientation)",
       "highlight": "“tolerate, anticipate, and don't agitate” (the T-A-DA method) are the core principles of the nonpharmacological approach",
       "scope": "on-scope",
       "note": "Read from the published abstract, not the full text, which is paywalled. The abstract names the method and expands all three letters, which is what the card states. It does not carry the Delirium Room's operational detail, so nothing beyond the naming and expansion rests on this source.",
       "page": "Abstract",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/22091576/"
      }
     ]
    }
   ],
   "synthesis": "T-A-D-A (Tolerate, Anticipate, Don't Agitate) is the restraint-free delirium-room approach described by Flaherty & Little 2011 — a way to manage agitation without escalating it within the bundle's engagement element.",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "icu-r44",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Pharmacologic considerations",
   "statement": "Reserve for imminent safety risk only. Antipsychotics have not been shown to treat or shorten delirium (MIND-USA; PADIS 2025: unable to recommend for or against) — medication does not treat the underlying cause.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MIND-USA 2018",
    "Haloperidol PI",
    "Dexmedetomidine PI",
    "MENDS2 2021",
    "PADIS 2018"
   ],
   "anchor": "PADIS 2025 — p. 8",
   "passage": "… All subgroup find ings in prior trials are simply hypothesis-generating at this point and further research is needed (55, 56). The Intensive Care Medicine Rapid Practice Guidelines recommended the use of dexmedetomidine over the use of other sedation medications if the desirable effects of a reduction in delirium were valued over the undesirable effects of hypotension and bradycardia. Similar to us, they did not make a recommendation to avoid use of dexmedetomidine in those under the age of 65 but left it to the practitioner's discretion (57). ANTIPSYCHOTICS FOR DELIRIUM Recommendation 3 We are unable to issue a recommendation for or against the use of antipsychotics over usual care for the treatment of delirium in adult patients admitted to the ICU (conditional recommendation; for intervention or comparison; low certainty of evidence). Evidence Summary A total of eight RCTs (58-65) enrolling 1869 adult ICU patients administered antipsychotics compared with no antipsychotic for the treatment of established delirium. Six RCTs administered haloperidol as the antipsychotic, one administered both atypical and typical antipsychotics, and the last RCT had three treatment arms: haloperidol, ziprasidone, and pla cebo. …\nAlso PADIS 2018: \"or who are agitated and may be physically harmful to themselves or others, may benefit from short-term use of haloperidol or an atypical antipsychotic until these distressing symptoms resolve\"\nPADIS 2025 also suggests not routinely using haloperidol or an atypical antipsychotic. PADIS 2018 supports reserving antipsychotics for patients posing a safety risk, and MIND-USA is the trial basis for \"not shown to treat or shorten delirium.\"",
   "evidence": "Full text, p. 7",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Girard TD, Exline MC, Carson SS, et al. Haloperidol and ziprasidone for treatment of delirium in critical illness (MIND-USA). N Engl J Med. 2018;379(26):2506-2516.",
    "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
    "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa1808217",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary governing source; the 2025 focused update re-addressed antipsychotics for delirium and issued no recommendation for or against.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "We are unable to issue a recommendation for or against the use of antipsychotics over usual care for the treatment of delirium in adult patients admitted to the ICU (conditional recommendation; for intervention or comparison; low certainty of evidence).",
       "highlight": "We are unable to issue a recommendation for or against the use of antipsychotics over usual care for the treatment of delirium in adult patients admitted to the ICU",
       "scope": "on-scope",
       "note": "Recommendation 3 verbatim - the exact 'unable to recommend for or against' antipsychotics position the claim cites.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "The panel was unable to issue a recommendation for the use of antipsychotics to treat delirium, despite a possible reduction in mortality and increase in delirium-free days. First, all potential benefits were of low certainty evidence, in part due to imprecision. Second, it is not understood how antipsychotics may result in a reduction in mortality when the only change we detected was a slight improvement in the number of delirium-free days, but no change in other outcomes such as duration of mechanical ventilation, ICU length of stay, etc. Last, a delirium-free outcome does not account for coma, that is, a patient can be delirium-free because they have a normal mental status, or they are comatose.",
       "highlight": "all potential benefits were of low certainty evidence, in part due to imprecision",
       "scope": "on-scope",
       "note": "Evidence-to-recommendation rationale — any apparent benefit is only low-certainty, so no benefit is established.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "A total of eight RCTs (58-65) enrolling 1869 adult ICU patients administered antipsychotics compared with no antipsychotic for the treatment of established delirium. Six RCTs administered haloperidol as the antipsychotic, one administered both atypical and typical antipsychotics, and the last RCT had three treatment arms: haloperidol, ziprasidone, and placebo. Overall, antipsychotics may slightly increase the number of delirium-free days (MD, 1.25 d; 95% CI, -0.35 to 2.86 d; low certainty) and may reduce 28-day mortality (RR, 0.87; 95% CI, 0.75-1.01; low certainty) and mortality at longest follow-up (RR, 0.89; 95% CI, 0.79-1.01; low certainty).",
       "highlight": "A total of eight RCTs (58-65) enrolling 1869 adult ICU patients administered antipsychotics compared with no antipsychotic",
       "scope": "on-scope",
       "note": "Pooled evidence summary — effect on duration of delirium is uncertain, supporting 'not shown to shorten delirium.'",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "RESULTS: The task force issued five statements related to the management of anxiety, agitation/sedation, delirium, immobility, and sleep disruption in adults admitted to the ICU. In adult patients admitted to the ICU, the task force issued conditional recommendations to use dexmedetomidine over propofol for sedation, provide enhanced mobilization/rehabilitation over usual mobilization/rehabilitation, and administer melatonin. The task force was unable to issue recommendations on the administration of benzodiazepines to treat anxiety, and the use of antipsychotics to treat delirium.",
       "highlight": "the use of antipsychotics to treat delirium",
       "scope": "on-scope",
       "note": "Abstract-level restatement of the no-recommendation on antipsychotics for delirium.",
       "page": "ms. p.1",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Pain, Agitation/Sedation, Delirium, Immobility, and Sleep Disruption 2018 Recommendations No recommendations previously existed We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence) We suggest not routinely using haloperidol or an atypical antipsychotic, to treat delirium (conditional recommendation, low quality of evidence) We suggest performing rehabilitation or mobilization in critically ill adults (conditional recommendation, low quality evidence) We make no recommendation regarding the use of melatonin to improve sleep in critically ill adults (no recommendation, very low quality of evidence)",
       "highlight": "We suggest not routinely using haloperidol or an atypical antipsychotic, to treat delirium",
       "scope": "background",
       "note": "This is the reproduced PADIS 2018 recommendation shown in the 2025 comparison table, not the 2025 position itself.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MIND-USA 2018",
     "cite": "Girard TD, Exline MC, Carson SS, et al. Haloperidol and ziprasidone for treatment of delirium in critical illness (MIND-USA). N Engl J Med. 2018;379(26):2506-2516.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Largest ICU RCT of antipsychotics for delirium; directly supports 'not shown to treat or shorten delirium.'",
     "docUrl": "https://doi.org/10.1056/NEJMoa1808217",
     "paragraphs": [
      {
       "context": "For more than 40 years, intravenous antipsychotic medications have been used to treat delirium in hospitalized patients.16,35-39 In an international survey of 1521 intensivists, 65% reported that they treat delirium in the ICU with haloperidol and 53% reported that they treat delirium with atypical antipsychotic medications.16 In this double-blind, randomized, placebo-controlled trial of intravenous antipsychotic medications for the treatment of delirium in the ICU, there was no evidence that either haloperidol or ziprasidone led to a shorter duration of delirium and coma. Patients who received treatment with up to 20 mg of haloperidol per day or up to 40 mg of ziprasidone per day and those who received placebo had similar outcomes, including survival and lengths of stay in the ICU and hospital.",
       "highlight": "there was no evidence that either haloperidol or ziprasidone led to a shorter duration of delirium and coma",
       "scope": "on-scope",
       "note": "Discussion — the trial's core efficacy finding for ICU delirium.",
       "page": "ms. p.10",
       "docUrl": "https://doi.org/10.1056/NEJMoa1808217"
      },
      {
       "context": "In conclusion, in this large, double-blind, randomized, placebo-controlled trial, we found no evidence that the use of haloperidol (up to 20 mg daily) or ziprasidone (up 40 mg daily) had an effect on the duration of delirium among patients with acute respiratory failure or shock in the ICU.",
       "highlight": "we found no evidence that the use of haloperidol (up to 20 mg daily) or ziprasidone (up 40 mg daily) had an effect on the duration of delirium",
       "scope": "on-scope",
       "note": "Formal trial conclusion — no effect on delirium duration.",
       "page": "ms. p.11",
       "docUrl": "https://doi.org/10.1056/NEJMoa1808217"
      },
      {
       "context": "CONCLUSIONS--The use of haloperidol or ziprasidone, as compared with placebo, in patients with acute respiratory failure or shock and hypoactive or hyperactive delirium in the ICU did not significantly alter the duration of delirium. (Funded by the National Institutes of Health and the VA Geriatric Research Education and Clinical Center; MIND-USA ClinicalTrials.gov number, NCT01211522.)",
       "highlight": "did not significantly alter the duration of delirium",
       "scope": "on-scope",
       "note": "Abstract conclusion stating the primary negative efficacy result.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1056/NEJMoa1808217"
      }
     ]
    },
    {
     "label": "Haloperidol PI",
     "cite": "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Grounds the safety rationale for reserving antipsychotics; silent on delirium efficacy, and its boxed-warning population differs from ICU delirium.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
     "paragraphs": [
      {
       "context": "Cases of sudden death, QTc interval-prolongation, and Torsades de Pointes have been reported in patients receiving haloperidol (see ADVERSE REACTIONS). Higher than recommended doses of any formulation and intravenous administration of haloperidol appear to be associated with a higher risk of QTc interval-prolongation and Torsades de Pointes. Also, a QTc interval that exceeds 500 msec is associated with an increased risk of Torsades de Pointes. Although cases have been reported even in the absence of predisposing factors, particular caution is advised in treating patients with other QTcprolonging conditions (including electrolyte imbalance [particularly hypokalemia and hypomagnesemia], drugs known to prolong QTc, underlying cardiac abnormalities, hypothyroidism, and familial long QT-syndrome). HALOPERIDOL INJECTION IS NOT APPROVED FOR INTRAVENOUS ADMINISTRATION.",
       "highlight": "Cases of sudden death, QTc interval-prolongation, and Torsades de Pointes have been reported in patients receiving haloperidol",
       "scope": "on-scope",
       "note": "Cardiac safety risk (worse at higher doses and IV) that grounds the 'reserve for imminent safety risk only' framing; applies to all haloperidol recipients.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      },
      {
       "context": "Increased Mortality in Elderly Patients with Dementia-Related Psychosis -- Elderly patients with dementia-related psychosis treated with antipsychotic drugs are at an increased risk of death. Analyses of seventeen placebo-controlled trials (modal duration of 10 weeks), largely in patients taking atypical antipsychotic drugs, revealed a risk of death in drug-treated patients of between 1.6 to 1.7 times the risk of death in placebo-treated patients. Over the course of a typical 10 week controlled trial, the rate of death in drug-treated patients was about 4.5%, compared to a rate of about 2.6% in the placebo group. Although the causes of death were varied, most of the deaths appeared to be either cardiovascular (e.g., heart failure, sudden death) or infectious (e.g., pneumonia) in nature. Observational studies suggest that, similar to atypical antipsychotic drugs, treatment with conventional antipsychotic drugs may increase mortality. The extent to which the findings of increased mortality in observational studies may be attributed to the antipsychotic drug as opposed to some characteristic(s) of the patients is not clear. Haloperidol Injection is not approved for the treatment of patients with dementia-related psychosis (see WARNINGS).",
       "highlight": "Elderly patients with dementia-related psychosis treated with antipsychotic drugs are at an increased risk of death",
       "scope": "different-population",
       "note": "Boxed-warning mortality signal is specific to elderly dementia-related psychosis, not ICU delirium — shares keywords but a different population.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      },
      {
       "context": "Patients with Parkinson's Disease or Dementia with Lewy Bodies are reported to have an increased sensitivity to antipsychotic medication. Manifestations of this increased sensitivity with haloperidol treatment include severe extrapyramidal symptoms, confusion, sedation, and falls. In addition, haloperidol may impair the antiparkinson effects of levodopa and other dopamine agonists. Haloperidol is contraindicated in patients with Parkinson's Disease or Dementia with Lewy Bodies (see CONTRAINDICATIONS).",
       "highlight": "Haloperidol is contraindicated in patients with Parkinson's Disease or Dementia with Lewy Bodies",
       "scope": "different-population",
       "note": "Contraindication in a specific subpopulation (Parkinson's/Lewy body) cited by the tool; a caution rather than direct support for the treatment statement.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      }
     ]
    },
    {
     "label": "Dexmedetomidine PI",
     "cite": "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "background",
     "note": "Cited for the alternative agent's ICU sedation indication and dosing (0.2-0.7 mcg/kg/hour); does not address antipsychotic efficacy for delirium.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
     "paragraphs": [
      {
       "context": "PRECEDEX is indicated for sedation of initially intubated and mechanically ventilated adult patients during treatment in an intensive care setting.",
       "highlight": "sedation of initially intubated and mechanically ventilated adult patients during treatment in an intensive care setting",
       "scope": "different-intervention",
       "note": "Labeled ICU sedation indication for dexmedetomidine — a different intervention from antipsychotics for delirium.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74"
      },
      {
       "context": "For adult patients: a maintenance infusion of 0.2 to 0.7 mcg/kg/ hour . The rate of the maintenance infusion should be adjusted to achieve the desired level of sedation.",
       "highlight": "maintenance infusion of 0.2 to 0.7 mcg/kg/ hour",
       "scope": "different-intervention",
       "note": "ICU sedation maintenance-dose the tool cites for dexmedetomidine; supports the section's preferred-sedation content, not the antipsychotic claim.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74"
      }
     ]
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "background",
     "note": "Sedative-choice trial (dexmedetomidine vs propofol); nearest match on ICU pharmacology but a different intervention from antipsychotics.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "CONCLUSIONS--Among mechanically ventilated adults with sepsis who were being treated with recommended light-sedation approaches, outcomes in patients who received dexmedetomidine did not differ from outcomes in those who received propofol. (Funded by the National Institutes of Health; ClinicalTrials.gov number, NCT01739933.)",
       "highlight": "outcomes in patients who received dexmedetomidine did not differ from outcomes in those who received propofol",
       "scope": "different-intervention",
       "note": "Compares two sedatives, not antipsychotics; cited for the section's sedation approach, not for the antipsychotic-efficacy statement.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Prior guideline; recommends against routine antipsychotic treatment and reserves short-term use for distress/harm — remains consistent with, and is updated by, PADIS 2025.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "We suggest not routinely using haloperidol, an atypical antipsychotic, or a HMG-CoA reductase inhibitor (i.e., a statin) to treat delirium (conditional recommendation, low quality of evidence).",
       "highlight": "not routinely using haloperidol, an atypical antipsychotic, or a HMG-CoA reductase inhibitor (i.e., a statin) to treat delirium",
       "scope": "on-scope",
       "note": "Treatment recommendation for established ICU delirium: the guideline conditionally advises against routinely using antipsychotics to treat delirium, reflecting no demonstrated benefit on delirium duration.",
       "page": "e846",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Although this recommendation discourages the \"routine\" use of antipsychotic agents in the treatment of delirium, patients who experience significant distress secondary to symptoms of a delirium such as anxiety, fearfulness, hallucinations, or delusions, or who are agitated and may be physically harmful to themselves or others, may benefit from short-term use of haloperidol or an atypical antipsychotic until these distressing symptoms resolve based on the panel's clinical experience. Patients who start with an antipsychotic for delirium in the ICU often remain on these medications unnecessarily after discharge (305-307). Continued exposure to antipsychotic medication can result in significant morbidity and financial cost. Panel members judged that the undesirable consequences of using either haloperidol or an atypical antipsychotic far outweighed the potential benefits for most critically adults with delirium and thus issued a conditional recommendation against their routine use.",
       "highlight": "who are agitated and may be physically harmful to themselves or others, may benefit from short-term use of haloperidol or an atypical antipsychotic until these distressing symptoms resolve",
       "scope": "on-scope",
       "note": "Directly supports 'reserve for imminent safety risk only' — short-term use limited to agitation/harm until symptoms resolve.",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "We suggest not using haloperidol, an atypical antipsychotic, dexmedetomidine, a -Hydroxy -methylglutaryl-Coenzyme A (HMG-CoA) reductase inhibitor (i.e., statin), or ketamine to prevent delirium in all critically ill adults (conditional recommendation, very low to low quality of evidence).",
       "highlight": "to prevent delirium in all critically ill adults",
       "scope": "different-intervention",
       "note": "Prevention recommendation (different purpose than treating existing delirium) - a nearest keyword match, not direct support.",
       "page": "e845",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Recommendation: We suggest not using haloperidol or an atypical antipsychotic to treat subsyndromal delirium in critically ill adults (conditional recommendations, very low to low quality of evidence).",
       "highlight": "We suggest not using haloperidol or an atypical antipsychotic to treat subsyndromal delirium",
       "scope": "different-population",
       "note": "Addresses subsyndromal delirium, a different population than established delirium in the claim.",
       "page": "e846",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    }
   ],
   "synthesis": "The on-scope sources agree: MIND-USA found haloperidol and ziprasidone did not shorten the duration of delirium, and PADIS 2025 — which re-addressed this question directly — remains unable to recommend antipsychotics for or against treating ICU delirium, the current governing position updating PADIS 2018's advice against routine treatment use. PADIS 2018's short-term-use-only-for-agitation/harm caveat plus the haloperidol label's cardiac and boxed-warning risks ground the \"reserve for imminent safety risk only\" framing, while the dexmedetomidine label and MENDS2 are different-intervention (sedation) references rather than antipsychotic-efficacy evidence.",
   "discrepancy": true
  },
  {
   "id": "icu-r45",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Pharmacologic considerations",
   "statement": "Haloperidol: Per local order set · baseline EKG, monitor QTc (caution > 500 ms) · avoid in Parkinson / Lewy body disease · IV route off-label — prefer PO/IM, continuous ECG if IV (example: 0.25–0.5 mg q4–6h PRN)",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MIND-USA 2018",
    "Haloperidol PI",
    "Dexmedetomidine PI",
    "MENDS2 2021",
    "PADIS 2018"
   ],
   "anchor": "Haloperidol PI — p. 2",
   "passage": "… WARNINGS Increased Mortality in Elderly Patients with Dementia-Related Psychosis - Elderly patients with dementia-related psychosis treated with antipsychotic drugs are at an increased risk of death. Haloperidol Injection is not approved for the treatment of patients with dementia-related psychosis (see BOXED WARNING). Cardiovascular Effects Cases of sudden death, QTc interval-prolongation, and Torsades de Pointes have been reported in patients receiving haloperidol (see ADVERSE REACTIONS). Higher than recommended doses of any formulation and intravenous administration of haloperidol appear to be associated with a higher risk of QTc interval-prolongation and Torsades de Pointes. Also, a QTc interval that exceeds 500 msec is associated with an increased risk of Torsades de Pointes . Although cases have been reported even in the absence of predisposing factors, particular caution is advised in treating patients with other QTcprolonging conditions (including electrolyte imbalance [particularly hypokalemia and hypomagnesemia], drugs known to prolong QTc, underlying cardiac abnormalities, hypothyroidism, and familial long QT-syndrome). HALOPERIDOL INJECTION IS NOT 1 APPROVED FOR INTRAVENOUS ADMINISTRATION. If haloperidol is administered intravenously, the ECG should be monitored for QTc prolongation and arrhythmias. Tachycardia and hypotension (including orthostatic hypotension) have also been reported in occasional patients (see ADVERSE REACTIONS). Cerebrovascular Adverse Reactions In controlled trials, elderly patients with dementia-related psychosis treated with some antipsychotics had an increased risk (compared to placebo) of cerebrovascular adverse reactions (e.g., stroke, transient ischemic attack), including fatalities. The mechanism for this increased risk is not known. An increased risk cannot be excluded for haloperidol, other antipsychotics, or other patient populations. Haloperidol should be used with caution in patients with risk factors for cerebrovascular adverse reactions. …\nThe label's contraindications also list Parkinson disease and dementia with Lewy bodies (p. 2). The example dose (0.25–0.5 mg) is not from the label.",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Girard TD, Exline MC, Carson SS, et al. Haloperidol and ziprasidone for treatment of delirium in critical illness (MIND-USA). N Engl J Med. 2018;379(26):2506-2516.",
    "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
    "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa1808217",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "2025 focused update that re-addressed the antipsychotics-for-delirium question and now states the current position; supports the tool's cautious, selective use of haloperidol.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "We are unable to issue a recommendation for or against the use of antipsychotics over usual care for the treatment of delirium in adult patients admitted to the ICU (conditional recommendation; for intervention or comparison; low certainty of evidence).",
       "highlight": "unable to issue a recommendation for or against the use of antipsychotics over usual care for the treatment of delirium",
       "scope": "broader",
       "note": "Current guideline position (2025 focused update) on whether to use antipsychotics for ICU delirium, superseding PADIS 2018's 'suggest not routinely' recommendation for this question.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Question In adults admitted to the ICU, do benzodiazepines administered for anxiety, when compared with no benzodiazepines, impact patient outcomes? In mechanically ventilated adults admitted to the ICU, should dexmedetomidine, when compared with propofol, be used for sedation? In adults admitted to the ICU, do antipsychotics administered for delirium compared with no antipsychotics, impact patient outcomes?",
       "highlight": "do antipsychotics administered for delirium compared with no antipsychotics, impact patient outcomes?",
       "scope": "broader",
       "note": "The PICO question showing the 2025 focused update did re-address the antipsychotics-for-delirium question rather than leaving the 2018 position untouched.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Most RCTs enrolled a mix of patients with either hypoactive and/or hyperactive delirium and, therefore, it is unclear if there is a single patient population that would benefit most from an antipsychotic. In addition, if used, one must be prudent to discontinue antipsychotics that were newly initiated in the ICU upon discharge if no longer clinically required (66).",
       "highlight": "prudent to discontinue antipsychotics that were newly initiated in the ICU upon discharge",
       "scope": "broader",
       "note": "Reinforces cautious, time-limited antipsychotic use, consistent with the tool's guarded framing but addressing continuation rather than the specific administration safeguards in the claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MIND-USA 2018",
     "cite": "Girard TD, Exline MC, Carson SS, et al. Haloperidol and ziprasidone for treatment of delirium in critical illness (MIND-USA). N Engl J Med. 2018;379(26):2506-2516.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Randomized ICU trial that directly confirms IV haloperidol for delirium is off-label and found no efficacy; QTc safety guardrails support the monitoring caution.",
     "docUrl": "https://doi.org/10.1056/NEJMoa1808217",
     "paragraphs": [
      {
       "context": "This randomized, double-blind, placebo-controlled, phase 3 trial was conducted at 16 medical centers in the United States. Before we randomly assigned the patients to receive a trial drug or placebo, we obtained written informed consent from the patients or their authorized representatives. The institutional review board at each participating center approved the protocol, available with the full text of this article at NEJM.org. The Food and Drug Administration approved an Investigational New Drug application, which was obtained because the intravenous route of administration and the indication for delirium that were used in this trial are not approved for antipsychotic medications (see the Supplementary Appendix, available at NEJM.org). The trial was registered at ClinicalTrials.gov on September 29, 2010, before the first patient was enrolled. The statistical analysis plan was registered at Open Science Framework (https://osf.io/mq38r) on March 22, 2018, before the trial-group assignments were unmasked. The authors vouch for the accuracy and completeness of the data and for the fidelity of the trial to the protocol.",
       "highlight": "are not approved for antipsychotic medications",
       "scope": "on-scope",
       "note": "Directly grounds the claim's 'IV route off-label' point: the trial needed an IND because the IV route and delirium indication are not approved for antipsychotics.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa1808217"
      },
      {
       "context": "For more than 40 years, intravenous antipsychotic medications have been used to treat delirium in hospitalized patients.16,35-39 In an international survey of 1521 intensivists, 65% reported that they treat delirium in the ICU with haloperidol and 53% reported that they treat delirium with atypical antipsychotic medications.16 In this double-blind, randomized, placebo-controlled trial of intravenous antipsychotic medications for the treatment of delirium in the ICU, there was no evidence that either haloperidol or ziprasidone led to a shorter duration of delirium and coma. Patients who received treatment with up to 20 mg of haloperidol per day or up to 40 mg of ziprasidone per day and those who received placebo had similar outcomes, including survival and lengths of stay in the ICU and hospital.",
       "highlight": "no evidence that either haloperidol or ziprasidone led to a shorter duration of delirium and coma",
       "scope": "on-scope",
       "note": "Supports the tool's cautious, non-routine framing of haloperidol by showing it did not shorten ICU delirium versus placebo.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa1808217"
      },
      {
       "context": "When delirium was present at the time of informed consent or during the 5 days after informed consent was obtained and the corrected QT interval was less than 550 msec on a 12-lead electrocardiogram (see the Supplementary Appendix), we randomly assigned the patients, in a 1:1:1 ratio, to receive placebo, haloperidol, or ziprasidone using a computergenerated, permuted-block randomization scheme, with stratification according to trial site. The research personnel, managing clinicians, patients, and their families were not aware of the trial-group assignments.",
       "highlight": "corrected QT interval was less than 550 msec",
       "scope": "narrower",
       "note": "A trial-specific QT safety threshold (enrollment/monitoring at <550 msec) consistent with QTc caution, but a stricter operational cutoff than the label's >500 msec basis the tool cites.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa1808217"
      }
     ]
    },
    {
     "label": "Haloperidol PI",
     "cite": "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The primary on-scope source: label establishes the QTc >500 msec Torsades risk, Parkinson's/Lewy body contraindication, IV route not approved, and ECG monitoring if given IV.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
     "paragraphs": [
      {
       "context": "Higher than recommended doses of any formulation and intravenous administration of haloperidol appear to be associated with a higher risk of QTc interval-prolongation and Torsades de Pointes. Also, a QTc interval that exceeds 500 msec is associated with an increased risk of Torsades de Pointes.",
       "highlight": "a QTc interval that exceeds 500 msec is associated with an increased risk of Torsades de Pointes",
       "scope": "on-scope",
       "note": "Grounds the claim's 'monitor QTc (caution > 500 ms)' instruction directly from the Cardiovascular Effects warning, including the higher IV-route risk.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      },
      {
       "context": "Cases of sudden death, QTc interval-prolongation, and Torsades de Pointes have been reported in patients receiving haloperidol (see ADVERSE REACTIONS). Higher than recommended doses of any formulation and intravenous administration of haloperidol appear to be associated with a higher risk of QTc interval-prolongation and Torsades de Pointes. Also, a QTc interval that exceeds 500 msec is associated with an increased risk of Torsades de Pointes. Although cases have been reported even in the absence of predisposing factors, particular caution is advised in treating patients with other QTcprolonging conditions (including electrolyte imbalance [particularly hypokalemia and hypomagnesemia], drugs known to prolong QTc, underlying cardiac abnormalities, hypothyroidism, and familial long QT-syndrome). HALOPERIDOL INJECTION IS NOT APPROVED FOR INTRAVENOUS ADMINISTRATION. If haloperidol is administered intravenously, the ECG should be monitored for QTc prolongation and arrhythmias.",
       "highlight": "HALOPERIDOL INJECTION IS NOT APPROVED FOR INTRAVENOUS ADMINISTRATION",
       "scope": "on-scope",
       "note": "Grounds 'IV route off-label' and the preference for PO/IM: the injectable label explicitly is not approved for IV use.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      },
      {
       "context": "APPROVED FOR INTRAVENOUS ADMINISTRATION. If haloperidol is administered intravenously, the ECG should be monitored for QTc prolongation and arrhythmias.",
       "highlight": "the ECG should be monitored for QTc prolongation and arrhythmias",
       "scope": "on-scope",
       "note": "Grounds the 'continuous ECG if IV' instruction directly from the label.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      },
      {
       "context": "Patients with Parkinson's Disease or Dementia with Lewy Bodies are reported to have an increased sensitivity to antipsychotic medication. Manifestations of this increased sensitivity with haloperidol treatment include severe extrapyramidal symptoms, confusion, sedation, and falls. In addition, haloperidol may impair the antiparkinson effects of levodopa and other dopamine agonists. Haloperidol is contraindicated in patients with Parkinson's Disease or Dementia with Lewy Bodies (see CONTRAINDICATIONS).",
       "highlight": "Haloperidol is contraindicated in patients with Parkinson's Disease or Dementia with Lewy Bodies",
       "scope": "on-scope",
       "note": "Grounds 'avoid in Parkinson / Lewy body disease' — the label lists both as contraindications.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      },
      {
       "context": "Patients with Parkinson's Disease or Dementia with Lewy Bodies are reported to have an increased sensitivity to antipsychotic medication. Manifestations of this increased sensitivity with haloperidol treatment include severe extrapyramidal symptoms, confusion, sedation, and falls. In addition, haloperidol may impair the antiparkinson effects of levodopa and other dopamine agonists. Haloperidol is contraindicated in patients with Parkinson's Disease or Dementia with Lewy Bodies (see CONTRAINDICATIONS).",
       "highlight": "increased sensitivity to antipsychotic medication",
       "scope": "on-scope",
       "note": "Explains why haloperidol is avoided in Parkinson's/Lewy body disease (severe extrapyramidal symptoms, confusion, sedation, falls).",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      },
      {
       "context": "Parenteral medication, administered intramuscularly in doses of 2 to 5 mg, is utilized for prompt control of the acutely agitated schizophrenic patient with moderately severe to very severe symptoms. Depending on the response of the patient, subsequent doses may be given, administered as often as every hour, although 4 to 8 hour intervals may be satisfactory. The maximum dose is 20 mg/day.",
       "highlight": "administered intramuscularly in doses of 2 to 5 mg",
       "scope": "different-population",
       "note": "The label's IM 2–5 mg dose is for the acutely agitated schizophrenic patient, a different indication/population than the tool's conservative low-dose ICU-delirium example (0.25–0.5 mg).",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      }
     ]
    },
    {
     "label": "Dexmedetomidine PI",
     "cite": "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Archived DailyMed label for dexmedetomidine, a different drug cited for the section's ICU-sedation dosing example; it contains no haloperidol content and does not address this haloperidol statement (different intervention).",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
     "paragraphs": []
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Trial of dexmedetomidine vs propofol for sedation in septic ventilated adults; haloperidol appears only as a rescue medication and dose-equivalent unit, not as the intervention this claim concerns (different intervention).",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "We had some cross-contamination of sedative use, although substantially less than that in similar sedation studies, and had a rescue protocol that included the use of low-dose antipsychotic medications.",
       "highlight": "low-dose antipsychotic medications",
       "scope": "different-intervention",
       "note": "The only antipsychotic-related content is a rescue-protocol mention within a dexmedetomidine-vs-propofol sedation trial — a keyword match, not support for the haloperidol prescribing claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Guideline that endorses only short-term haloperidol for distressing/dangerous delirium symptoms and recommends against routine use; the whether-to-use recommendation is updated by PADIS 2025.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Although this recommendation discourages the \"routine\" use of antipsychotic agents in the treatment of delirium, patients who experience significant distress secondary to symptoms of a delirium such as anxiety, fearfulness, hallucinations, or delusions, or who are agitated and may be physically harmful to themselves or others, may benefit from short-term use of haloperidol or an atypical antipsychotic until these distressing symptoms resolve based on the panel's clinical experience. Patients who start with an antipsychotic for delirium in the ICU often remain on these medications unnecessarily after discharge (305-307). Continued exposure to antipsychotic medication can result in significant morbidity and financial cost. Panel members judged that the undesirable consequences of using either haloperidol or an atypical antipsychotic far outweighed the potential benefits for most critically adults with delirium and thus issued a conditional recommendation against their routine use.",
       "highlight": "may benefit from short-term use of haloperidol or an atypical antipsychotic until these distressing symptoms resolve",
       "scope": "on-scope",
       "note": "Directly supports the tool's cautious, symptom-limited (PRN) framing of haloperidol for distressed or dangerously agitated delirious patients.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "We suggest not routinely using haloperidol, an atypical antipsychotic, or a HMG-CoA reductase inhibitor (i.e., a statin) to treat delirium (conditional recommendation, low quality of evidence).",
       "highlight": "We suggest not routinely using haloperidol, an atypical antipsychotic, or a HMG-CoA reductase inhibitor (i.e., a statin) to treat delirium",
       "scope": "broader",
       "note": "Addresses the broader whether-to-use question; this specific recommendation is superseded by the 2025 focused update's 'unable to recommend for or against.'",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    }
   ],
   "synthesis": "The Haloperidol prescribing information is the on-scope governing source for this claim's specific safety/administration statements: it establishes the QTc >500 msec Torsades risk, the contraindication in Parkinson's disease / dementia with Lewy bodies, that IV administration is not FDA-approved (off-label) with ECG monitoring required if given IV; MIND-USA independently confirms the IV route/delirium indication is unapproved and found no delirium benefit, while PADIS 2018 (short-term haloperidol only for distressing/dangerous symptoms) and the 2025 focused update — which re-addressed the question and is now \"unable to recommend for or against,\" the current guideline position — supply the cautious, non-routine posture the tool reflects. The Dexmedetomidine PI and MENDS2 concern a different drug/intervention (ICU sedation) and do not address the haloperidol statement, and the PI's IM 2–5 mg dose targets acutely agitated schizophrenia, a different population than the tool's conservative low-dose ICU example.",
   "discrepancy": true
  },
  {
   "id": "icu-r46",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Pharmacologic considerations",
   "statement": "Quetiapine: PO per local order set · lowest dose, shortest duration · monitor QTc & orthostasis (example: 12.5–25 mg q12h PO)",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MIND-USA 2018",
    "Haloperidol PI",
    "Dexmedetomidine PI",
    "MENDS2 2021",
    "PADIS 2018"
   ],
   "anchor": "PADIS 2018 — p. 24",
   "passage": "… Administration of such open-label medication to the placebo group in these studies may bias the results of these investigations toward the null hypothesis. The undesirable effects of haloperidol and atypical antipsychotics remain uncertain, given the small sample sizes of the available studies. Although this recommendation discourages the \"routine\" use of antipsychotic agents in the treatment of delirium, patients who experience significant distress secondary to symptoms of a delirium such as anxiety, fearfulness, hallucinations, or delusions, or who are agitated and may be physically harmful to themselves or others, may benefit from short-term use of haloperidol or an atypical antipsychotic until these distressing symptoms resolve based on the panel's clinical experience. Patients who start with an antipsychotic for delirium in the ICU often remain on these medications unnecessarily after discharge (305-307). Continued exposure to antipsychotic medication can result in significant morbidity and financial cost. Panel members judged that the undesirable consequences of using either haloperidol or an atypical antipsychotic far outweighed the potential benefits for most critically adults with delirium and thus issued a conditional recommendation against their routine use. Dexmedetomidine. …\nPADIS 2018 names quetiapine as an example atypical antipsychotic (p. 24) and supports short-term use. The specific dose (12.5–25 mg q12h) and the QTc/orthostasis monitoring points are not stated in the cited sources; the dose is a configurable example.",
   "evidence": "Full text, p. 24 — partial support",
   "status": "fulltext",
   "pageNum": "24",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Girard TD, Exline MC, Carson SS, et al. Haloperidol and ziprasidone for treatment of delirium in critical illness (MIND-USA). N Engl J Med. 2018;379(26):2506-2516.",
    "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
    "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa1808217",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Focused update that adds Anxiety; it cites the quetiapine trials (Devlin 2010 ref 60, Garg 2022 ref 62) only in its reference list and does not re-address antipsychotic/quetiapine treatment of delirium, so it adds no new position on quetiapine dosing or monitoring.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": []
    },
    {
     "label": "MIND-USA 2018",
     "cite": "Girard TD, Exline MC, Carson SS, et al. Haloperidol and ziprasidone for treatment of delirium in critical illness (MIND-USA). N Engl J Med. 2018;379(26):2506-2516.",
     "kind": "pdf",
     "stance": "background",
     "note": "Names quetiapine among atypical antipsychotics used for ICU delirium but the trial itself studied haloperidol/ziprasidone, and gives no quetiapine dose or QTc/orthostasis monitoring.",
     "docUrl": "https://doi.org/10.1056/NEJMoa1808217",
     "paragraphs": [
      {
       "context": "Atypical antipsychotic medications, such as olanzapine, quetiapine, risperidone, and ziprasidone, are also used for this purpose, and one placebo-controlled trial has suggested a benefit,20 whereas another18 showed no evidence of benefit.",
       "highlight": "olanzapine, quetiapine, risperidone, and ziprasidone, are also used for this purpose",
       "scope": "background",
       "note": "Background mention that quetiapine is among atypicals used to treat ICU delirium; not a dosing or monitoring statement and the trial intervention was haloperidol/ziprasidone.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa1808217"
      }
     ]
    },
    {
     "label": "Haloperidol PI",
     "cite": "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Directly supports the claim's safety framing (QTc/Torsades monitoring, orthostatic hypotension, smallest dose/shortest duration) but for haloperidol, a different drug than quetiapine; class-analog nearest match, not quetiapine-specific.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
     "paragraphs": [
      {
       "context": "Cases of sudden death, QTc interval-prolongation, and Torsades de Pointes have been reported in patients receiving haloperidol (see ADVERSE REACTIONS). Higher than recommended doses of any formulation and intravenous administration of haloperidol appear to be associated with a higher risk of QTc interval-prolongation and Torsades de Pointes. Also, a QTc interval that exceeds 500 msec is associated with an increased risk of Torsades de Pointes. Although cases have been reported even in the absence of predisposing factors, particular caution is advised in treating patients with other QTcprolonging conditions (including electrolyte imbalance [particularly hypokalemia and hypomagnesemia], drugs known to prolong QTc, underlying cardiac abnormalities, hypothyroidism, and familial long QT-syndrome). HALOPERIDOL INJECTION IS NOT APPROVED FOR INTRAVENOUS ADMINISTRATION.",
       "highlight": "Higher than recommended doses of any formulation and intravenous administration of haloperidol appear to be associated with a higher risk of QTc interval-prolongation",
       "scope": "different-intervention",
       "note": "QTc-prolongation/Torsades monitoring rationale, but stated for haloperidol rather than quetiapine (shared antipsychotic class effect).",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      },
      {
       "context": "Tachycardia and hypotension (including orthostatic hypotension) have also been reported in occasional patients (see ADVERSE REACTIONS).",
       "highlight": "Tachycardia and hypotension (including orthostatic hypotension) have also been reported in occasional patients",
       "scope": "different-intervention",
       "note": "Orthostatic hypotension caution mirrors the claim's 'monitor orthostasis' but for haloperidol, not quetiapine.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      },
      {
       "context": "Given these considerations, antipsychotic drugs should be prescribed in a manner that is most likely to minimize the occurrence of tardive dyskinesia. Chronic antipsychotic treatment should generally be reserved for patients who suffer from a chronic illness that, 1) is known to respond to antipsychotic drugs, and, 2) for whom alternative, equally effective, but potentially less harmful treatments are not available or appropriate. In patients who do require chronic treatment, the smallest dose and the shortest duration of treatment producing a satisfactory clinical response should be sought. The need for continued treatment should be reassessed periodically.",
       "highlight": "the smallest dose and the shortest duration of treatment producing a satisfactory clinical response should be sought",
       "scope": "different-intervention",
       "note": "Mirrors the claim's 'lowest dose, shortest duration' principle, but is the haloperidol-label statement, not quetiapine-specific.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      }
     ]
    },
    {
     "label": "Dexmedetomidine PI",
     "cite": "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Dexmedetomidine (Precedex) sedation label; contains no quetiapine, antipsychotic, or QTc content relevant to this quetiapine dosing/monitoring claim.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
     "paragraphs": []
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "background",
     "note": "Sedation trial (dexmedetomidine vs propofol) in which antipsychotics appeared only as co-administration/rescue; it gives no quetiapine dose or QTc/orthostasis monitoring for delirium treatment.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "sedative use, although substantially less than that in similar sedation studies, and had a rescue protocol that included the use of low-dose antipsychotic medications. The trial drug was started a median of 22 hours after the patient met all inclusion criteria, which may have limited our ability to affect outcomes.",
       "highlight": "a rescue protocol that included the use of low-dose antipsychotic medications",
       "scope": "different-intervention",
       "note": "'Low-dose antipsychotic' rescue in a sedation trial loosely echoes 'lowest dose' but is a different intervention/setting and does not name quetiapine or monitoring.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Governing on-scope source: the guideline addresses whether antipsychotics (including quetiapine) should treat ICU delirium and suggests not routinely using them; it does not specify a quetiapine dose or QTc/orthostasis monitoring.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "We suggest not routinely using haloperidol, an atypical antipsychotic, or a HMG-CoA reductase inhibitor (i.e., a statin) to treat delirium (conditional recommendation, low quality of evidence).",
       "highlight": "We suggest not routinely using haloperidol, an atypical antipsychotic, or a HMG-CoA reductase inhibitor (i.e., a statin) to treat delirium",
       "scope": "on-scope",
       "note": "Guideline stance covering quetiapine (as an atypical antipsychotic) for treating ICU delirium; supports the cautious 'per local order set / lowest dose / shortest duration' framing but gives no dose or monitoring parameters.",
       "page": "e846",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "A total of six RCTs were identified: haloperidol (n = 2) (380, 381), atypical antipsychotics (quetiapine) (n = 1) (382), ziprasidone (n = 1) (380), olanzapine (n = 1) (383), and a statin (i.e., rosuvastatin) (n = 1) (384).",
       "highlight": "atypical antipsychotics (quetiapine) (n = 1) (382)",
       "scope": "on-scope",
       "note": "The treatment rationale's RCT inventory names the single quetiapine trial among the six delirium-treatment RCTs evaluated, underlying the conditional recommendation against routine antipsychotic use.",
       "page": "e846",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    }
   ],
   "synthesis": "The governing on-scope source is PADIS 2018, which addresses whether antipsychotics including quetiapine should treat ICU delirium and suggests not routinely using them; the 2025 focused update added anxiety and did not re-address this question, so PADIS 2018 remains the current position. No provided source states the specific 12.5-25 mg q12h quetiapine dose (it derives from the Devlin 2010 pilot, cited but not among these sources), and the \"lowest dose, shortest duration / monitor QTc and orthostasis\" safety framing is stated directly only in the haloperidol prescribing information — a different drug used as a class-analog — making these keyword-sharing but different-intervention matches.",
   "discrepancy": true
  },
  {
   "id": "icu-r47",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Pharmacologic considerations",
   "statement": "Dexmedetomidine: Ventilated patients — agitation precluding weaning, or when light sedation / delirium reduction is the priority · monitor bradycardia / hypotension (example: 0.2–0.7 mcg/kg/hr)",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MIND-USA 2018",
    "Haloperidol PI",
    "Dexmedetomidine PI",
    "MENDS2 2021",
    "PADIS 2018"
   ],
   "anchor": "PADIS 2018 — p. 24",
   "passage": "… Patients who start with an antipsychotic for delirium in the ICU often remain on these medications unnecessarily after discharge (305-307). Continued exposure to antipsychotic medication can result in significant morbidity and financial cost. Panel members judged that the undesirable consequences of using either haloperidol or an atypical antipsychotic far outweighed the potential benefits for most critically adults with delirium and thus issued a conditional recommendation against their routine use. Dexmedetomidine. Recommendation: We suggest using dexmedetomidine for delirium in mechanically ventilated adults where agitation is precluding weaning/extubation (conditional recommendation, low quality of evidence). Rationale: The single RCT used to evaluate the role of dexmedetomidine as a treatment for agitation precluding ventilator liberation in patients with delirium screened 21,500 intubated patients from 15 ICUs to enroll the 71 study patients and was terminated early because the funding amount (from the manufacturer of dexmedetomidine) had been used up (386). …\nThe infusion rate (0.2–0.7 mcg/kg/hr) and the bradycardia/hypotension monitoring derive from the Precedex label rather than PADIS 2018. PADIS 2025 also favors dexmedetomidine over propofol for sedation.",
   "evidence": "Full text, p. 24",
   "status": "fulltext",
   "pageNum": "24",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Girard TD, Exline MC, Carson SS, et al. Haloperidol and ziprasidone for treatment of delirium in critical illness (MIND-USA). N Engl J Med. 2018;379(26):2506-2516.",
    "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
    "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa1808217",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Focused-update conditional recommendation for dexmedetomidine over propofol when light sedation/delirium reduction is the priority; supports the bradycardia/hypotension caution.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "In adult patients admitted to the ICU, the task force issued conditional recommendations to use dexmedetomidine over propofol for sedation, provide enhanced mobilization/rehabilitation over usual mobilization/rehabilitation, and administer melatonin. The task force was unable to issue recommendations on the administration of benzodiazepines to treat anxiety, and the use of antipsychotics to treat delirium.",
       "highlight": "use dexmedetomidine over propofol for sedation",
       "scope": "on-scope",
       "note": "The focused update's conditional recommendation to use dexmedetomidine over propofol for sedation supports preferring dexmedetomidine in ventilated ICU adults.",
       "page": "e715",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "reduction in delirium are of highest priorities (conditional recommendation; for intervention; moderate certainty of evidence).",
       "highlight": "reduction in delirium are of highest priorities",
       "scope": "on-scope",
       "note": "Completes Recommendation 2 (split by a page break) - delirium reduction as a priority indication, matching the statement's 'delirium reduction is the priority'.",
       "page": "e715",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Dexmedetomidine probably increases the risk of bradycardia (RR, 1.65; 95% CI, 1.28-2.12; absolute risk increase [ARI], 6 more per 100; 95% from 2 more to 10 more; moderate certainty) and may result in little to no difference in the risk of hypotension (RR, 1.07; 95% CI, 0.92-1.25; low certainty).",
       "highlight": "Dexmedetomidine probably increases the risk of bradycardia",
       "scope": "on-scope",
       "note": "Evidence summary: dex probably increases bradycardia and shows little-to-no difference in hypotension - supports the 'monitor bradycardia/hypotension' caution.",
       "page": "e715",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "The panel judged the desirable effects of dexmedetomidine to outweigh the possible adverse event of bradycardia in most ICU patients.",
       "highlight": "the desirable effects of dexmedetomidine to outweigh the possible adverse event of bradycardia in most ICU patients",
       "scope": "on-scope",
       "note": "Evidence-to-recommendation judgement that dexmedetomidine's desirable effects outweigh bradycardia in most ICU patients, framing the bradycardia trade-off the card notes.",
       "page": "e716",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MIND-USA 2018",
     "cite": "Girard TD, Exline MC, Carson SS, et al. Haloperidol and ziprasidone for treatment of delirium in critical illness (MIND-USA). N Engl J Med. 2018;379(26):2506-2516.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Tests antipsychotics (haloperidol/ziprasidone) for ICU delirium, not dexmedetomidine - a different pharmacologic class; does not address the dex statement.",
     "docUrl": "https://doi.org/10.1056/NEJMoa1808217",
     "paragraphs": [
      {
       "context": "CONCLUSIONS--The use of haloperidol or ziprasidone, as compared with placebo, in patients with acute respiratory failure or shock and hypoactive or hyperactive delirium in the ICU did not significantly alter the duration of delirium. (Funded by the National Institutes of Health and the VA Geriatric Research Education and Clinical Center; MIND-USA ClinicalTrials.gov number, NCT01211522.)",
       "highlight": "did not significantly alter the duration of delirium",
       "scope": "different-intervention",
       "note": "Same ICU/ventilated delirium setting but a different intervention (antipsychotics), which showed no delirium-duration benefit - nearest match, not support for dexmedetomidine.",
       "page": "2506",
       "docUrl": "https://doi.org/10.1056/NEJMoa1808217"
      },
      {
       "context": "Author Manuscript BACKGROUND--There are conflicting data on the effects of antipsychotic medications on delirium in patients in the intensive care unit (ICU).",
       "highlight": "the effects of antipsychotic medications on delirium",
       "scope": "different-intervention",
       "note": "Background frames the trial around antipsychotic medications, not the alpha-2 agonist dexmedetomidine of the statement.",
       "page": "2506",
       "docUrl": "https://doi.org/10.1056/NEJMoa1808217"
      }
     ]
    },
    {
     "label": "Haloperidol PI",
     "cite": "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Prescribing information for an antipsychotic (labeled for schizophrenia), not dexmedetomidine; does not support the dex statement.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
     "paragraphs": [
      {
       "context": "Haloperidol is indicated for the treatment of patients with schizophrenia.",
       "highlight": "Haloperidol is indicated for the treatment of patients with schizophrenia",
       "scope": "different-intervention",
       "note": "A different drug and indication (schizophrenia; used off-label for ICU agitation) - distinct pharmacologic class from the dexmedetomidine of the statement.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      }
     ]
    },
    {
     "label": "Dexmedetomidine PI",
     "cite": "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Precedex label: ICU sedation of ventilated adults, 0.2-0.7 mcg/kg/hr maintenance range, and the hypotension/bradycardia warning - directly supports the statement's dose example and monitoring.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
     "paragraphs": [
      {
       "context": "PRECEDEX is indicated for sedation of initially intubated and mechanically ventilated adult patients during treatment in an intensive care setting.",
       "highlight": "sedation of initially intubated and mechanically ventilated adult patients during treatment in an intensive care setting",
       "scope": "on-scope",
       "note": "Labeled indication matches the statement's population and setting: sedation of intubated, mechanically ventilated ICU adults.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74"
      },
      {
       "context": "For adult patients: a maintenance infusion of 0.2 to 0.7 mcg/kg/ hour . The rate of the maintenance infusion should be adjusted to achieve the desired level of sedation.",
       "highlight": "a maintenance infusion of 0.2 to 0.7 mcg/kg/ hour",
       "scope": "on-scope",
       "note": "Labeled ICU maintenance-infusion range is exactly the statement's example dose of 0.2-0.7 mcg/kg/hr.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74"
      },
      {
       "context": "Reports of hypotension and bradycardia have been associated with PRECEDEX infusion. Some of these cases have resulted in fatalities.",
       "highlight": "Reports of hypotension and bradycardia have been associated with PRECEDEX infusion",
       "scope": "on-scope",
       "note": "Label warning supports the statement's 'monitor bradycardia / hypotension' caution.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74"
      }
     ]
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Reinforces the general guideline (light sedation with dex or propofol in ventilated adults), though the trial itself enrolled a narrower sepsis population.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "BACKGROUND--Guidelines currently recommend targeting light sedation with dexmedetomidine or propofol for adults receiving mechanical ventilation. Differences exist between these sedatives in arousability, immunity, and inflammation. Whether they affect outcomes differentially in mechanically ventilated adults with sepsis undergoing light sedation is unknown.",
       "highlight": "Guidelines currently recommend targeting light sedation with dexmedetomidine or propofol for adults receiving mechanical ventilation",
       "scope": "on-scope",
       "note": "States the guideline basis for the statement - light sedation with dexmedetomidine (or propofol) in ventilated adults.",
       "page": "1424",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "Although recent data suggest that many critically ill adults receiving mechanical ventilation may not require sedative infusions,38,39 our trial specifically enrolled adults with sepsis who had a high severity of illness, a greater risk for ARDS, and a higher requirement for continuous sedation. It was important to better characterize the effect of greater arousability, analgesic properties, and lack of respiratory depression observed with dexmedetomidine as compared with GABAergic sedatives in this population. Data indicate meaningful differences between dexmedetomidine and GABAergic sedatives with respect to innate immunity and risk of infection, including evidence that dexmedetomidine may offer superior antiinflammatory effects.11-17 Despite these theoretical benefits and studies supporting the use of dexmedetomidine, the choice between dexmedetomidine and propofol alone does not appear to substantially affect patient outcomes in the complex milieu of critical illness with sepsis. Our findings, therefore, strongly reinforce current guidelines24 that recommend the use of either dexmedetomidine or propofol for light sedation when continuous sedation is needed for adults with or without sepsis who require mechanical ventilation.",
       "highlight": "the use of either dexmedetomidine or propofol for light sedation when continuous sedation is needed for adults with or without sepsis who require mechanical ventilation",
       "scope": "on-scope",
       "note": "Discussion explicitly generalizes the light-sedation recommendation to adults 'with or without sepsis' who require mechanical ventilation.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "BACKGROUND--Guidelines currently recommend targeting light sedation with dexmedetomidine or propofol for adults receiving mechanical ventilation. Differences exist between these sedatives in arousability, immunity, and inflammation. Whether they affect outcomes differentially in mechanically ventilated adults with sepsis undergoing light sedation is unknown.",
       "highlight": "mechanically ventilated adults with sepsis undergoing light sedation",
       "scope": "different-population",
       "note": "The RCT population is the sepsis subset (dex vs propofol showed no outcome difference), narrower than the statement's general ventilated ICU population.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary anchor: dedicated recommendation to use dexmedetomidine for delirium in ventilated adults where agitation precludes weaning; also endorses dex as a light-sedation choice and notes greater bradycardia.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "We suggest using dexmedetomidine for delirium in mechanically ventilated adults where agitation is precluding weaning/extubation (conditional recommendation, low quality of evidence).",
       "highlight": "using dexmedetomidine for delirium in mechanically ventilated adults where agitation is precluding weaning/extubation",
       "scope": "on-scope",
       "note": "The guideline's dedicated conditional recommendation directly matches 'agitation precluding weaning'; not re-addressed by the 2025 update, so it remains the current position.",
       "page": "e846",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Recommendation: We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence).",
       "highlight": "We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults",
       "scope": "on-scope",
       "note": "Supports dexmedetomidine as a sedative choice for ventilated adults - the 'light sedation is the priority' part of the statement.",
       "page": "e839",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "The SEDCOM (167) and Maximizing the Efficacy of Sedation and Reducing Neurological Dysfunction (MENDS) (172) studies both demonstrated a greater incidence of bradycardia in the dexmedetomidine group; neither study found intervention was required for the bradycardia. Overall, the panel judged that the desirable consequences of using dexmedetomidine probably outweigh any undesirable consequences and thus issued a conditional recommendation favoring dexmedetomidine over a benzodiazepine.",
       "highlight": "both demonstrated a greater incidence of bradycardia in the dexmedetomidine group",
       "scope": "on-scope",
       "note": "Notes greater bradycardia incidence with dexmedetomidine - supports the bradycardia-monitoring caution.",
       "page": "e839",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Recommendation: We suggest not using haloperidol, an atypical antipsychotic, dexmedetomidine, a -Hydroxy -methylglutaryl-Coenzyme A (HMG-CoA) reductase inhibitor (i.e., statin), or ketamine to prevent delirium in all critically ill adults (conditional recommendation, very low to low quality of evidence).",
       "highlight": "to prevent delirium in all critically ill adults",
       "scope": "different-intervention",
       "note": "A different question - routine delirium PREVENTION, where dexmedetomidine is NOT recommended - distinct from the treatment/sedation use in the statement; shares the dex keyword but points the opposite direction.",
       "page": "e844",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    }
   ],
   "synthesis": "The on-scope sources agree with the statement: PADIS 2018 governs the \"agitation precluding weaning\" indication with its dedicated conditional recommendation to use dexmedetomidine for delirium in mechanically ventilated adults where agitation precludes weaning/extubation, and because the 2025 focused update did not re-address that specific question it remains the current position; the PADIS 2025 focused update governs the \"light sedation / delirium reduction is the priority\" part with its updated conditional recommendation for dexmedetomidine over propofol, while the Precedex label supplies the labeled ICU-ventilated indication, the 0.2-0.7 mcg/kg/hr maintenance range, and the bradycardia/hypotension caution. MENDS2 is a narrower sepsis-subset trial that reinforces the general light-sedation guideline, whereas MIND-USA and the haloperidol label concern antipsychotics (a different drug class) and do not address dexmedetomidine.",
   "discrepancy": true
  },
  {
   "id": "icu-r48",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Pharmacologic considerations",
   "statement": "Benzodiazepines: Alcohol / benzo withdrawal only — may worsen delirium",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MIND-USA 2018",
    "Haloperidol PI",
    "Dexmedetomidine PI",
    "MENDS2 2021",
    "PADIS 2018"
   ],
   "anchor": "PADIS 2018 — p. 19",
   "passage": "… The evidence summaries and evidence-to-decision tables used to develop recommendations for the delirium group are available in Supplemental Table 19 (Supplemental Digital Content 26, http:// links.lww.com/CCM/D784), and the forest plots for all metaanalyses are available in Supplemental Figure 7 (Supplemental Digital Content 27, http://links.lww.com/CCM/D785). Risk Factors Question: Which predisposing and precipitating risk factors are associated with delirium occurrence (i.e., incidence, prevalence, or daily transition), delirium duration, or severity in critically ill adults? Ungraded Statement: For the following risk factors, strong evidence indicates that these are associated with delirium in critically ill adults: \"modifiable\"-benzodiazepine use and blood transfusions , and \"nonmodifiable\"-greater\nThe \"alcohol/benzodiazepine withdrawal only\" restriction is clinical convention and is not stated as a directive in the cited sources.",
   "evidence": "Full text, p. 19 — partial support",
   "status": "fulltext",
   "pageNum": "19",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Girard TD, Exline MC, Carson SS, et al. Haloperidol and ziprasidone for treatment of delirium in critical illness (MIND-USA). N Engl J Med. 2018;379(26):2506-2516.",
    "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
    "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa1808217",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governing on-scope source: names benzodiazepines a modifiable delirium risk factor and de-emphasizes them for ICU sedation.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Benzodiazepine use and blood transfusion administration are the only two modifiable factors with strong evidence for an association with delirium detected by screening tools",
       "highlight": "Benzodiazepine use and blood transfusion administration are the only two modifiable factors with strong evidence for an association with delirium",
       "scope": "on-scope",
       "note": "Direct support for 'may worsen delirium' — benzodiazepine use is a modifiable factor with strong evidence for association with ICU delirium.",
       "page": "e842",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Benzodiazepine use and blood transfusion administration are the only two modifiable factors with strong evidence for an association with delirium detected by screening tools (Supplemental Table 22, Supplemental Digital Content 30, http://links.lww. com/CCM/D788).",
       "highlight": "Benzodiazepine use and blood transfusion administration are the only two modifiable factors with strong evidence for an association with delirium detected by screening tools",
       "scope": "on-scope",
       "note": "Risk-factor analysis names benzodiazepine use as one of only two modifiable factors with strong evidence of association with ICU delirium, supporting reserving benzodiazepines for withdrawal only.",
       "page": "e842",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Recommendation: We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence).",
       "highlight": "using either propofol or dexmedetomidine over benzodiazepines for sedation",
       "scope": "on-scope",
       "note": "Supports keeping benzodiazepines off first-line for routine sedation — the basis for reserving them to narrow indications.",
       "page": "e839",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "The role of benzodiazepines versus propofol or dexmedetomidine in patients who are hemodynamically unstable, need deep sedation, are at risk for delirium, or have signs of alcohol withdrawal needs to be studied.",
       "highlight": "have signs of alcohol withdrawal needs to be studied",
       "scope": "background",
       "note": "Nearest mention of the alcohol-withdrawal scenario, but framed as an evidence gap rather than a positive recommendation; clinicians distill it into 'reserve benzodiazepines for withdrawal'.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Focused update reaffirms the 2018 sedation recommendation but does not re-address the withdrawal reservation or benzodiazepines-as-delirium-risk; its new benzodiazepine question is about anxiety.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence)",
       "highlight": "using either propofol or dexmedetomidine over benzodiazepines for sedation",
       "scope": "on-scope",
       "note": "Carries forward the 2018 recommendation, keeping benzodiazepines off first-line for routine ICU sedation.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "There is insufficient evidence to make a recommendation on the use of benzodiazepines to treat anxiety in adult patients admitted to the ICU.",
       "highlight": "insufficient evidence to make a recommendation on the use of benzodiazepines to treat anxiety",
       "scope": "different-intervention",
       "note": "The only benzodiazepine question the update newly opened is treating anxiety, a different indication than the alcohol/benzo-withdrawal exception in the claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Of note, abrupt cessation of benzodiazepines prescribed for baseline chronic anxiety may precipitate acute withdrawal; hence, continuation of the chronic benzodiazepines upon admission to the ICU should be considered.",
       "highlight": "may precipitate acute withdrawal",
       "scope": "different-intervention",
       "note": "'Withdrawal' here means iatrogenic withdrawal from chronic anxiolytic benzodiazepines, not the alcohol/benzo-withdrawal treatment indication.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MIND-USA 2018",
     "cite": "Girard TD, Exline MC, Carson SS, et al. Haloperidol and ziprasidone for treatment of delirium in critical illness (MIND-USA). N Engl J Med. 2018;379(26):2506-2516.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Trial of haloperidol/ziprasidone for delirium treatment; does not address benzodiazepines, the withdrawal reservation, or benzodiazepines worsening delirium.",
     "docUrl": "https://doi.org/10.1056/NEJMoa1808217",
     "paragraphs": [
      {
       "context": "hyperactive delirium describing delusions and hallucinations, those with alcohol withdrawal, or those with another delirium phenotype2) may benefit from antipsychotic treatment. The 20-mg dose of haloperidol that we used in the trial is considered to be high,36-38 and yet we cannot exclude a potential benefit from higher doses.39 In keeping with the literature on haloperidol use,41 which indicates that a dose of haloperidol higher than 25 mg per day has a deleterious effect on cognition, we chose a dose that would avoid these adverse effects.",
       "highlight": "those with alcohol withdrawal",
       "scope": "different-intervention",
       "note": "Nearest keyword ('alcohol withdrawal') but describes a subgroup that might benefit from antipsychotic treatment, not a benzodiazepine indication.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa1808217"
      }
     ]
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "background",
     "note": "Dexmedetomidine-vs-propofol trial in septic ventilated adults; benzodiazepines appear only as background comparator and as an exclusion criterion.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "Trials comparing dexmedetomidine with benzodiazepines in adults have shown that the use of dexmedetomidine results in improvement in outcomes such as delirium, coma, and time receiving mechanical ventilation.",
       "highlight": "the use of dexmedetomidine results in improvement in outcomes such as delirium, coma",
       "scope": "background",
       "note": "Cites prior dex-vs-benzodiazepine trials for worse delirium/coma with benzodiazepines; this trial itself compares dexmedetomidine vs propofol, not benzodiazepines.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "We included adults who were sequentially admitted to a medical or surgical ICU, had suspected or known infection, and were treated with continuous sedation for invasive mechanical ventilation. Patients were excluded if they had baseline severe cognitive impairment; were pregnant or breast-feeding; were blind, deaf, or unable to understand approved languages; had second-degree or third-degree heart block or persistent bradycardia requiring intervention; had an allergy to dexmedetomidine or propofol; had an indication for benzodiazepines; were anticipated to have immediate discontinuation of mechanical ventilation; were expected to have neuromuscular blockade for more than 48 hours; were in a moribund state; or had received mechanical ventilation for more than 96 hours before meeting all inclusion criteria. Additional details on exclusion and inclusion criteria are provided in Section S1 in the Supplementary Appendix. We randomly assigned patients to receive dexmedetomidine or propofol in a 1:1 ratio using computer-generated permuted blocks stratified by enrollment site and age (<65 years vs. 65 years). Researchers, clinicians (except bedside nurses), patients, and families were unaware of the group assignments.",
       "highlight": "had an indication for benzodiazepines",
       "scope": "narrower",
       "note": "Patients with a benzodiazepine indication were excluded, consistent with reserved benzodiazepine use, but the indication (e.g., withdrawal) is not named.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "Haloperidol PI",
     "cite": "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Haloperidol prescribing information, cited for the haloperidol/antipsychotic line (boxed warnings, QTc/Torsades) in this section; contains no statement about benzodiazepines, the withdrawal reservation, or benzodiazepines worsening delirium.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
     "paragraphs": []
    },
    {
     "label": "Dexmedetomidine PI",
     "cite": "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Precedex (dexmedetomidine) DailyMed label, cited for the dexmedetomidine ICU sedation infusion (0.2-0.7 mcg/kg/hour) line; its 'withdrawal'/'emergence delirium' content concerns dexmedetomidine itself, not benzodiazepines, so it does not speak to this benzodiazepine claim.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
     "paragraphs": []
    }
   ],
   "synthesis": "PADIS 2018 governs this claim: it directly supports \"benzodiazepines may worsen delirium\" (benzodiazepine use is one of only two modifiable factors with strong evidence for an association with ICU delirium) and their de-emphasis for routine sedation (propofol or dexmedetomidine preferred over benzodiazepines), with alcohol withdrawal flagged only as a residual scenario needing study — the \"reserve for alcohol/benzo withdrawal only\" framing is the clinical corollary of avoiding routine benzodiazepine sedation. The PADIS 2025 focused update did not re-address this question (its only new benzodiazepine content concerns treating anxiety, a different indication) and reaffirms the 2018 sedation recommendation, so the 2018 position remains the current position. MIND-USA (antipsychotics for delirium) and MENDS2 (dexmedetomidine vs propofol in sepsis) are nearest keyword matches at a different scope, and the haloperidol and dexmedetomidine labels are cited for other lines in the section, not the benzodiazepine statement.",
   "discrepancy": true
  },
  {
   "id": "icu-r49",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Pharmacologic considerations",
   "statement": "No antipsychotics at discharge without a psychiatric indication.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MIND-USA 2018",
    "Haloperidol PI",
    "Dexmedetomidine PI",
    "MENDS2 2021",
    "PADIS 2018"
   ],
   "anchor": "PADIS 2018 — p. 24",
   "passage": "… The undesirable effects of haloperidol and atypical antipsychotics remain uncertain, given the small sample sizes of the available studies. Although this recommendation discourages the \"routine\" use of antipsychotic agents in the treatment of delirium, patients who experience significant distress secondary to symptoms of a delirium such as anxiety, fearfulness, hallucinations, or delusions, or who are agitated and may be physically harmful to themselves or others, may benefit from short-term use of haloperidol or an atypical antipsychotic until these distressing symptoms resolve based on the panel's clinical experience. Patients who start with an antipsychotic for delirium in the ICU often remain on these medications unnecessarily after discharge (305-307). Continued exposure to antipsychotic medication can result in significant morbidity and financial cost. Panel members judged that the undesirable consequences of using either haloperidol or an atypical antipsychotic far outweighed the potential benefits for most critically adults with delirium and thus issued a conditional recommendation against their routine use. Dexmedetomidine. Recommendation: We suggest using dexmedetomidine for delirium in mechanically ventilated adults where agitation is precluding weaning/extubation (conditional recommendation, low quality of evidence). …\nThe passage supports the deprescribing intent but does not state the directive itself; PADIS 2025 likewise contains no explicit statement on discharge antipsychotics.",
   "evidence": "Full text, p. 24 — partial support",
   "status": "fulltext",
   "pageNum": "24",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Girard TD, Exline MC, Carson SS, et al. Haloperidol and ziprasidone for treatment of delirium in critical illness (MIND-USA). N Engl J Med. 2018;379(26):2506-2516.",
    "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
    "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa1808217",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary anchor (p. 24); states ICU-initiated antipsychotics are frequently continued unnecessarily after discharge, the direct basis for the claim.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Although this recommendation discourages the \"routine\" use of antipsychotic agents in the treatment of delirium, patients who experience significant distress secondary to symptoms of a delirium such as anxiety, fearfulness, hallucinations, or delusions, or who are agitated and may be physically harmful to themselves or others, may benefit from short-term use of haloperidol or an atypical antipsychotic until these distressing symptoms resolve based on the panel's clinical experience. Patients who start with an antipsychotic for delirium in the ICU often remain on these medications unnecessarily after discharge (305-307). Continued exposure to antipsychotic medication can result in significant morbidity and financial cost. Panel members judged that the undesirable consequences of using either haloperidol or an atypical antipsychotic far outweighed the potential benefits for most critically adults with delirium and thus issued a conditional recommendation against their routine use.",
       "highlight": "often remain on these medications unnecessarily after discharge",
       "scope": "on-scope",
       "note": "PADIS 2018 rationale: patients started on an antipsychotic for ICU delirium often stay on it unnecessarily after discharge, with morbidity and cost — the source basis for stopping without an ongoing indication.",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "The disadvantages of delirium screening should be considered. A false-positive screening, although rare with either the CAM-ICU or the ICDSC, may result in unnecessary pharmacologic or nonpharmacologic treatment. ICU antipsychotic use is often associated with its continuation and prolonged administration after ICU and hospital discharge (305-307). Delirium screening may be burdensome for nursing staff (287). In the context of the criteria needed to generate a best practice statement, we felt that the benefits of widespread delirium assessment with the CAM-ICU or the ICDSC far outweigh any potential disadvantages.",
       "highlight": "ICU antipsychotic use is often associated with its continuation and prolonged administration after ICU and hospital discharge",
       "scope": "on-scope",
       "note": "Reiterates the continuation-after-discharge concern that motivates de-prescribing antipsychotics at transitions of care.",
       "page": "e844",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Current PADIS focused update explicitly re-addresses discontinuing ICU-initiated antipsychotics at discharge — reaffirms and sharpens the 2018 position.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "Most RCTs enrolled a mix of patients with either hypoactive and/or hyperactive delirium and, therefore, it is unclear if there is a single patient population that would benefit most from an antipsychotic. In addition, if used, one must be prudent to discontinue antipsychotics that were newly initiated in the ICU upon discharge if no longer clinically required (66).",
       "highlight": "discontinue antipsychotics that were newly initiated in the ICU upon discharge if no longer clinically required",
       "scope": "on-scope",
       "note": "Directly supports the claim: antipsychotics newly started in the ICU should be discontinued at discharge unless still clinically required.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MIND-USA 2018",
     "cite": "Girard TD, Exline MC, Carson SS, et al. Haloperidol and ziprasidone for treatment of delirium in critical illness (MIND-USA). N Engl J Med. 2018;379(26):2506-2516.",
     "kind": "pdf",
     "stance": "background",
     "note": "Efficacy trial cited as the basis for not continuing antipsychotics; does not itself address discharge de-prescribing.",
     "docUrl": "https://doi.org/10.1056/NEJMoa1808217",
     "paragraphs": [
      {
       "context": "CONCLUSIONS--The use of haloperidol or ziprasidone, as compared with placebo, in patients with acute respiratory failure or shock and hypoactive or hyperactive delirium in the ICU did not significantly alter the duration of delirium. (Funded by the National Institutes of Health and the VA Geriatric Research Education and Clinical Center; MIND-USA ClinicalTrials.gov number, NCT01211522.)",
       "highlight": "did not significantly alter the duration of delirium",
       "scope": "background",
       "note": "Establishes that haloperidol/ziprasidone do not improve ICU delirium duration or outcomes — the efficacy rationale for stopping them, but scoped to in-ICU treatment, not the discharge-continuation question.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa1808217"
      }
     ]
    },
    {
     "label": "Haloperidol PI",
     "cite": "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "background",
     "note": "Drug-label safety/stewardship guidance broader than ICU discharge; supports reserving continued antipsychotic use for a responsive indication.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
     "paragraphs": [
      {
       "context": "Given these considerations, antipsychotic drugs should be prescribed in a manner that is most likely to minimize the occurrence of tardive dyskinesia. Chronic antipsychotic treatment should generally be reserved for patients who suffer from a chronic illness that, 1) is known to respond to antipsychotic drugs, and, 2) for whom alternative, equally effective, but potentially less harmful treatments are not available or appropriate. In patients who do require chronic treatment, the smallest dose and the shortest duration of treatment producing a satisfactory clinical response should be sought. The need for continued treatment should be reassessed periodically.",
       "highlight": "The need for continued treatment should be reassessed periodically",
       "scope": "broader",
       "note": "General labeling: reserve chronic antipsychotic treatment for a responsive chronic illness and reassess continued need — broader than ICU discharge but consistent with stopping absent an ongoing indication.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      },
      {
       "context": "Both the risk of developing tardive dyskinesia and the likelihood that it will become irreversible are believed to increase as the duration of treatment and the total cumulative dose of antipsychotic drugs administered to the patient increase. However, the syndrome can develop, although much less commonly, after relatively brief treatment periods at low doses.",
       "highlight": "increase as the duration of treatment and the total cumulative dose of antipsychotic drugs administered",
       "scope": "background",
       "note": "Tardive-dyskinesia risk rises with duration and cumulative dose — the harm rationale for limiting continued antipsychotic exposure.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      }
     ]
    },
    {
     "label": "Dexmedetomidine PI",
     "cite": "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived DailyMed label (navigation boilerplate + ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hr); cited for sedation-dosing context in the Pharmacologic considerations section, not the antipsychotic-at-discharge claim.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
     "paragraphs": []
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "background",
     "note": "Sedation-choice trial (dexmedetomidine vs propofol in ventilated septic adults); antipsychotics appear only as concomitant/rescue meds. Different-intervention context — does not address antipsychotic de-prescribing at discharge.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": []
    }
   ],
   "synthesis": "The two on-scope guideline sources agree and govern: PADIS 2018 (the primary anchor) states antipsychotics started for ICU delirium often remain on unnecessarily after discharge, and the 2025 PADIS focused update explicitly advises discontinuing ICU-initiated antipsychotics upon discharge if no longer clinically required — together directly supporting \"no antipsychotics at discharge without a psychiatric indication.\" The other four sources are supporting context of a different scope and must not be read as direct support: MIND-USA supplies the efficacy basis (haloperidol/ziprasidone did not alter delirium duration), the haloperidol label gives the general safety rationale (tardive-dyskinesia risk rising with duration; reassess continued need), and the dexmedetomidine label and MENDS2 concern sedation choice/dosing rather than antipsychotic de-prescribing.",
   "discrepancy": true
  },
  {
   "id": "icu-r50",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Pharmacologic considerations",
   "statement": "Do NOT stop abruptly: benzos · opioids · SSRIs · steroids · antiepileptics · dexmedetomidine.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MIND-USA 2018",
    "Haloperidol PI",
    "Dexmedetomidine PI",
    "MENDS2 2021",
    "PADIS 2018"
   ],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "structure",
   "pageNum": null,
   "citations": [],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa1808217",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "partial",
     "note": "On-scope for the benzodiazepine element only; adds a keyword-coincidence bullet about dexmedetomidine used to treat alcohol withdrawal.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "Of note, abrupt cessation of benzodiazepines prescribed for baseline chronic anxiety may precipitate acute withdrawal; hence, continuation of the chronic benzodiazepines upon admission to the ICU should be considered.",
       "highlight": "abrupt cessation of benzodiazepines prescribed for baseline chronic anxiety may precipitate acute withdrawal",
       "scope": "on-scope",
       "note": "Directly supports the benzodiazepine element of the claim: abrupt benzo cessation may precipitate acute withdrawal, so chronic benzodiazepines should be continued on ICU admission; covers only benzos of the six agents listed.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "Dexmedetomidine PI",
     "cite": "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "partial",
     "note": "On-scope for the dexmedetomidine element only — documents withdrawal on abrupt discontinuation; says nothing about the other five agents.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
     "paragraphs": [
      {
       "context": "However, since studies in rodents and primates have demonstrated that PRECEDEX exhibits pharmacologic actions similar to those of clonidine, it is possible that PRECEDEX may produce a clonidine-like withdrawal syndrome upon abrupt discontinuation",
       "highlight": "PRECEDEX may produce a clonidine-like withdrawal syndrome upon abrupt discontinuation",
       "scope": "on-scope",
       "note": "Directly supports the dexmedetomidine element: abrupt discontinuation may produce a clonidine-like withdrawal syndrome; covers only dexmedetomidine of the six listed agents.",
       "page": "§9.3 Dependence",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74"
      },
      {
       "context": "With administration up to 7 days, regardless of dose, 12 (5%) PRECEDEX adult subjects experienced at least 1 event related to withdrawal within the first 24 hours after discontinuing study drug and 7 (3%) PRECEDEX adult subjects experienced at least 1 event 24 to 48 hours after end of study drug.",
       "highlight": "experienced at least 1 event related to withdrawal within the first 24 hours after discontinuing study drug",
       "scope": "on-scope",
       "note": "Section 5.5 Withdrawal quantifies withdrawal events after ICU-sedation dexmedetomidine is discontinued, reinforcing cautious cessation of dexmedetomidine specifically.",
       "page": "§5.5 Withdrawal",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74"
      }
     ]
    }
   ],
   "synthesis": "A composite safety reminder grounded in established withdrawal pharmacology: abrupt cessation of each listed class can precipitate a withdrawal or rebound syndrome. Two elements are documented in the cited sources — the dexmedetomidine label (a clonidine-like withdrawal on abrupt discontinuation) and PADIS 2025 (continue chronic benzodiazepines to avoid acute withdrawal). The opioid, SSRI, steroid, and antiepileptic elements rest on standard drug-class withdrawal pharmacology rather than a delirium-specific citation in the tool's registry.",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "icu-r51",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Deliriogenic medications",
   "statement": "Deliriogenic medications — review & limit (drug-class list; specific agents in data/meds.js — brands/doses configurable)",
   "contentType": "Cited clinical content",
   "sources": [
    "Beers 2023",
    "PADIS 2018",
    "ACB Scale"
   ],
   "anchor": "Beers 2023 — p. 1",
   "passage": "2023 American Geriatrics Society Beers Criteria Table 2. 2023 American Geriatrics Society Beers Criteria for Potentially Inappropriate Medication Use in Older Adults Organ System, Therapeutic Category, Drugs Rationale Recommendation Quality of Evidence Strength of Recommendation Antihistamines First-generation antihistamines ● Brompheniramine ● Chlorpheniramine ● Cyproheptadine ● Dimenhydrinate ● Diphenhydramine (PO) ● Doxylamine ● Hydroxyzine ● Meclizine ● Promethazine ● Triprolidine Highly anticholinergic; clearance reduced with advanced age, and tolerance develops when used as hypnotic; risk of confusion, dry mouth, constipation, and other anticholinergic effects or toxicity. Cumulative exposure to anticholinergic drugs is associated with an increased risk of falls, delirium, and dementia, even in younger adults. Consider total anticholinergic burden during regular medication reviews and be cautious in \"young-old\" as well as \"old-old\" adults. Use of diphenhydramine in situations such as acute treatment of severe allergic reactions may be appropriate. Avoid Moderate Strong Anti-infective Nitrofurantoin Potential for pulmonary toxicity, hepatotoxicity, and peripheral neuropathy, especially with long-term use; safer alternatives available Avoid in individuals with CrCl <30 mL/ min or for long-term suppression. Low Strong Cardiovascular and antithrombotics Aspirin for primary prevention of cardiovascular disease Risk of major bleeding from aspirin increases markedly in older age. …\nBeers 2023 also names benzodiazepines as deliriogenic and advises avoiding such agents in patients at high risk of delirium \"because of the potential of inducing or worsening delirium.\"",
   "evidence": "Full text, p. 1",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Boustani M, Campbell N, Munger S, Maidment I, Fox C. Impact of anticholinergics on the aging brain: a review and practical application (Anticholinergic Cognitive Burden scale). Aging Health. 2008;4(3):311-320."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/37139824/",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.2217/1745509X.4.3.311"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beers 2023",
     "cite": "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Supplies the deliriogenic drug-class list the claim references, but validated in older adults (>=65) across all settings, not ICU-specifically.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/",
     "paragraphs": [
      {
       "context": "Anticholinergics Antipsychotics Benzodiazepines Corticosteroids (oral and parenteral) H2-receptor antagonists Cimetidine Famotidine Nizatidine Nonbenzodiazepine benzodiazepine receptor agonist hypnotics (\"Zdrugs\") Eszopiclone Zaleplon AChEIs cause bradycardia and should be avoided in older adults whose syncope may be due to bradycardia.",
       "highlight": "Anticholinergics Antipsychotics Benzodiazepines Corticosteroids (oral and parenteral) H2-receptor antagonists",
       "scope": "on-scope",
       "note": "Names the deliriogenic drug classes (plus Z-drugs and opioids listed adjacently) to avoid in patients with or at risk of delirium — the drug-class list the tool cites.",
       "page": "CNS — Delirium",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      },
      {
       "context": "Avoid in older adults with or at high risk of delirium because of the potential of inducing or worsening delirium. Antipsychotics: avoid for behavioral problems of dementia or delirium unless nonpharmacologic options (eg, behavioral interventions) have failed or are not possible and the older adult is threatening substantial harm to self or others. If used, periodic deprescribing attempts should be considered to assess ongoing need and/or the lowest effective dose.",
       "highlight": "Avoid in older adults with or at high risk of delirium because of the potential of inducing or worsening delirium.",
       "scope": "on-scope",
       "note": "The recommendation to avoid these classes because they can induce or worsen delirium — directly supports 'review & limit', though phrased for older adults.",
       "page": "CNS — Delirium",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      },
      {
       "context": "Cumulative exposure to anticholinergic drugs is associated with an increased risk of falls, delirium, and dementia, even in younger adults. Consider total anticholinergic burden during regular medication reviews and be cautious in \"young-old\" as well as \"old-old\" adults.",
       "highlight": "Consider total anticholinergic burden during regular medication reviews",
       "scope": "on-scope",
       "note": "Anticholinergic burden raises delirium risk and should be reviewed at medication review — supports the review-and-limit intent for anticholinergics.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      },
      {
       "context": "Use of more than one medication with anticholinergic properties increases the risk of cognitive decline, delirium, and falls or fractures.",
       "highlight": "Use of more than one medication with anticholinergic properties increases the risk of cognitive decline, delirium, and falls or fractures.",
       "scope": "on-scope",
       "note": "Multiple anticholinergics compound delirium risk; the paired recommendation is to minimize the number of anticholinergic drugs — supports limiting the class.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "partial",
     "note": "On-scope adult-ICU source: confirms benzodiazepines as the principal modifiable deliriogenic agent, but narrows the list versus Beers — opioid use and mechanical ventilation were strongly shown NOT to alter ICU delirium risk.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Benzodiazepine use and blood transfusion administration are the only two modifiable factors with strong evidence for an association with delirium detected by screening tools (Supplemental Table 22, Supplemental Digital Content 30, http://links.lww. com/CCM/D788).",
       "highlight": "Benzodiazepine use and blood transfusion administration are the only two modifiable factors with strong evidence for an association with delirium detected by screening tools",
       "scope": "on-scope",
       "note": "ICU risk-factor analysis identifies benzodiazepine use as a modifiable factor with strong evidence for association with delirium, supporting review and reduction of deliriogenic medications.",
       "page": "e842",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Benzodiazepine use and blood transfusion administration are the only two modifiable factors with strong evidence for an association with delirium detected by screening tools (Supplemental Table 22, Supplemental Digital Content 30, http://links.lww. com/CCM/D788). The nonmodifiable risk factors with strong evidence for an association with delirium include increasing age, dementia, prior coma, pre-ICU emergency surgery or trauma, and increasing APACHE and ASA scores. Sex, opioid use, and mechanical ventilation each have been strongly shown not to alter the risk of delirium occurrence. Moderate evidence exists showing the following increase the risk for delirium: history of hypertension; admission because of a neurologic disease; trauma; and the use of psychoactive medication (e.g., antipsychotics, anticonvulsants). A history of respiratory disease, medical admission, nicotine use, dialysis or continuous venovenous hemofiltration, and a lower Glasgow Coma Scale score have each been moderately shown not to increase the risk for delirium. See the \"Sedation section\" for a review on how sedative choice may affect delirium and the \"Sleep section\" regarding the relationship between sleep and delirium. For all other potential delirium-associated risk factors, evidence currently remains inconclusive.",
       "highlight": "Sex, opioid use, and mechanical ventilation each have been strongly shown not to alter the risk of delirium occurrence.",
       "scope": "on-scope",
       "note": "Governing ICU evidence: only benzodiazepines (and transfusion) are strong modifiable deliriogenic factors; psychoactive meds (antipsychotics, anticonvulsants) are moderate, while opioids were shown NOT to raise ICU delirium risk — the divergence from Beers' broader list.",
       "page": "e842",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Recommendation: We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence).",
       "highlight": "We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults",
       "scope": "narrower",
       "note": "A narrower, specific application of limiting benzodiazepines — sedative-agent choice in mechanically ventilated adults — rather than the general deliriogenic-med review.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "ACB Scale",
     "cite": "Boustani M, Campbell N, Munger S, Maidment I, Fox C. Impact of anticholinergics on the aging brain: a review and practical application (Anticholinergic Cognitive Burden scale). Aging Health. 2008;4(3):311-320.",
     "kind": "web",
     "stance": "background",
     "note": "Cited (Boustani 2008, Aging Health 4(3):311-320) as the Anticholinergic Cognitive Burden scale underpinning how anticholinergic burden is scored; not archived here.",
     "docUrl": "https://doi.org/10.2217/1745509X.4.3.311",
     "paragraphs": []
    }
   ],
   "synthesis": "Beers 2023 (older adults, all settings) supplies the deliriogenic drug-class list the tool references — anticholinergics, antipsychotics, benzodiazepines, corticosteroids, H2-antagonists, Z-drugs and opioids — to avoid or minimize in patients with or at risk of delirium, with anticholinergic burden flagged for medication review; PADIS 2018 is the on-scope adult-ICU source and confirms benzodiazepines as the principal modifiable deliriogenic agent (strong evidence) but explicitly found opioid use and mechanical ventilation NOT associated with ICU delirium, so the ICU evidence is narrower than the general geriatric list. PADIS governs the ICU-specific 'review & limit' emphasis (benzodiazepines above all), while Beers governs the broader drug-class list and the ACB scale is the cited anticholinergic-burden instrument.",
   "discrepancy": true
  },
  {
   "id": "icu-r52",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 1 · Deter",
   "statement": "No deliriogenic drugs added today",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r53",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 1 · Deter",
   "statement": "No abrupt medication discontinuation",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r54",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 1 · Deter",
   "statement": "Devices / lines limited to essential",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r55",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 1 · Deter",
   "statement": "Prevention bundle applied",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r56",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 2 · Detect",
   "statement": "CAM-ICU completed this shift",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r57",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 2 · Detect",
   "statement": "RASS documented",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r58",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 2 · Detect",
   "statement": "Baseline mental status known",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r59",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 2 · Detect",
   "statement": "Provider notified if first positive CAM",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r60",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 3 · Do (acute)",
   "statement": "Fall prevention active",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r61",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 3 · Do (acute)",
   "statement": "Devices removed or disguised",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r62",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 3 · Do (acute)",
   "statement": "Family teaching done",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r63",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 3 · Do (acute)",
   "statement": "T-A-D-A approach applied",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r64",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 3 · Do (acute)",
   "statement": "Plan individualized in the EHR",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r65",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 3 · Do (acute)",
   "statement": "Nurse–assistant handoff completed",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r66",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 4–6 · Daily care",
   "statement": "CAM-ICU per unit frequency + PRN",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r67",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 4–6 · Daily care",
   "statement": "Comfort / calm / consistent",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r68",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 4–6 · Daily care",
   "statement": "Toileting completed",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r69",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 4–6 · Daily care",
   "statement": "Adequate nutrition & hydration",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r70",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 4–6 · Daily care",
   "statement": "Sleep–wake cycle maintained",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r71",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 4–6 · Daily care",
   "statement": "Med response assessed & documented",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r72",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 7 · Discharge",
   "statement": "Delirium course & cause documented",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r73",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 7 · Discharge",
   "statement": "Unnecessary psychotropics stopped",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r74",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 7 · Discharge",
   "statement": "Successful strategies documented",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r75",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 7 · Discharge",
   "statement": "Follow-up arranged if not resolved",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "icu-r76",
   "toolId": "icu",
   "tool": "Adult ICU Rounding Tool",
   "page": "2",
   "section": "Nurse care pathway — 7 · Discharge",
   "statement": "Family & patient educated",
   "contentType": "Local protocol — site-customized",
   "sources": [],
   "anchor": "Site-adapted content; no central citation applies.",
   "passage": "",
   "evidence": "Not applicable — site content",
   "status": "na",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": ""
  },
  {
   "id": "spa-r3",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Sedation",
   "statement": "Set a RASS goal every shift: Target the lightest RASS that meets the clinical goal; avoid deep sedation (−3 or lower) unless required.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2018",
    "PADIS 2025",
    "MENDS2 2021",
    "SAT/SBT"
   ],
   "anchor": "PADIS 2018 — p. 15",
   "passage": "Copyright © 2018 by the Society of Critical Care Medicine and Wolters Kluwer Health, Inc. All Rights Reserved. Devlin et al e838 www.ccmjournal.org September 2018 • Volume 46 • Number 9 for the agitation (sedation) group are available in Supplemental Table 12 (Supplemental Digital Content 15, http://links.lww. com/CCM/D773), and the forest plots for all completed metaanalyses are available in Supplemental Figure 3 (Supplemental Digital Content 16, http://links.lww.com/CCM/D774). Light Sedation Question: Does light sedation (vs deep sedation), regardless of the sedative agent(s) used, significantly affect outcomes in critically ill, mechanically ventilated adults? Recommendation: We suggest using light sedation (vs deep sedation) in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence). Rationale: The 2013 PAD guidelines made an ungraded statement that maintaining a light level of sedation will shorten time to extubation and reduce ICU LOS (1). Although the prior guideline defined light sedation as a RASS scale score of greater than or equal to -2 and eye opening of at least 10 minutes (112), this level of sedation is probably deeper than required for management of mechanically ventilated adults in an ICU. No universally accepted definition of light sedation exists. …\nPADIS 2018 defines light sedation as RASS −2 to +1, so a target of −3 or lower falls outside the light range. The per-shift goal-setting cadence is operational framing not found in the guideline.",
   "evidence": "Full text, p. 15",
   "status": "fulltext",
   "pageNum": "15",
   "citations": [
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governing on-scope guideline: its recommendation and rationale directly support targeting light over deep sedation unless deeper sedation is clinically indicated.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "As outlined in these guidelines, clinicians should target a light rather than deep level of sedation in their intubated, critically ill adult patients unless deeper sedation is clinically indicated. Our literature review suggests that both DSI protocols and NP-targeted sedation are safe and no differences exist between them in achieving and maintaining a light level of sedation. There are, however, some important caveats: first, most studies evaluating DSIs and NP have done so in the context of sedation with benzodiazepines, which are no longer recommended for sedation in critically ill patients; second, DSI protocols may be associated with increasing nursing workload (179); and third, a brief DSI should not be used to justify the use of deep sedation for the rest of the day when it is not indicated. Because light levels of sedation are associated with improved outcomes and are needed to facilitate other interventions such as spontaneous breathing trials and early mobilization, healthcare providers should strive to achieve light levels of sedation in the majority of patients the majority of the time. Light sedation, assessed using a validated sedation scale, can be achieved either using a NP or through DSI protocols (where light sedation is targeted, whereas sedatives are infusing).",
       "highlight": "target a light rather than deep level of sedation in their intubated, critically ill adult patients unless deeper sedation is clinically indicated",
       "scope": "on-scope",
       "note": "Directive to target light over deep sedation unless deeper sedation is clinically indicated — the direct basis for the card's 'avoid deep sedation unless required.'",
       "page": "e839 (p. 15)",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Recommendation: We suggest using light sedation (vs deep sedation) in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence).",
       "highlight": "We suggest using light sedation (vs deep sedation) in critically ill, mechanically ventilated adults",
       "scope": "on-scope",
       "note": "The formal conditional recommendation favoring light over deep sedation in mechanically ventilated ICU adults.",
       "page": "e838 (p. 14)",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Rationale: The 2013 PAD guidelines made an ungraded statement that maintaining a light level of sedation will shorten time to extubation and reduce ICU LOS (1). Although the prior guideline defined light sedation as a RASS scale score of greater than or equal to -2 and eye opening of at least 10 minutes (112), this level of sedation is probably deeper than required for management of mechanically ventilated adults in an ICU. No universally accepted definition of light sedation exists. To address this question, we evaluated studies in which light versus deep sedation were defined a priori, measured, and explicitly reported with objective scales describing whether patients met these clear light, versus deep, sedation targets systematically over the time spent in the ICU and at least q6h. Surrogate measures (e.g., sedative plasma levels) or subjective clinical assessments of wakefulness were not considered as part of the definition of level of sedation. Studies describing a daily spontaneous awakening trial (SAT) were not deemed indicative of a light sedation approach because they reported lightening of sedation at a single point in time, rather than over the entire day. For studies that used scales, such as the RASS (159), a RASS score of -2 to +1 range (or its equivalent using other scales) was considered as light sedation in the evaluated studies.",
       "highlight": "a RASS score of -2 to +1 range (or its equivalent using other scales) was considered as light sedation",
       "scope": "on-scope",
       "note": "Defines the light band as RASS -2 to +1, so -3 or lower is deeper than light — grounds the card's RASS target and its '-3 or lower' deep cut.",
       "page": "e838 (p. 14)",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "background",
     "note": "Focused update; its sedation content addresses sedative choice (dexmedetomidine vs propofol), not the light-vs-deep depth target, so the 2018 light-sedation recommendation remains the current position.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "A total of 3087 mechanically ventilated adults admitted to the ICU were randomized to dexmedetomidine vs. propofol in 29 randomized controlled trials (RCTs) (26-54), the majority of which explicitly stated medications were titrated to achieve light sedation (22 RCTs).",
       "highlight": "titrated to achieve light sedation",
       "scope": "different-intervention",
       "note": "The update's sedation content concerns dexmedetomidine vs. propofol titrated to light sedation (a different intervention, agent choice); it shares the light-sedation keyword but sets no RASS depth target.",
       "page": "p. 5",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "has delirium, clinical judgment must be used. If a patient requires deep sedation or has a high risk of bradycardia, alternative sedative agents should be considered. The cost of dexmedetomidine acquisition for many hospitals is now lower than when initially marketed, and the cost of propofol and dexmedetomidine are likely comparable in many countries. However, there is significant variability in costs and availability of dexmedetomidine. Therefore, cost and ability to obtain dexmedetomidine may well be prohibitive in some centers and hence our recommendation is conditional rather than strong.",
       "highlight": "If a patient requires deep sedation or has a high risk of bradycardia, alternative sedative agents should be considered",
       "scope": "different-intervention",
       "note": "A drug-selection caveat (avoid dexmedetomidine when deep sedation is required); acknowledges deep sedation may be needed but concerns agent choice, not setting the RASS target.",
       "page": "p. 8",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Sepsis drug-choice RCT that reinforces the light-sedation target and labels RASS -3 as deep sedation; operational support, with the protocol content set in a narrower (sepsis) population.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "Guidelines currently recommend targeting light sedation with dexmedetomidine or propofol for adults receiving mechanical ventilation.",
       "highlight": "Guidelines currently recommend targeting light sedation with dexmedetomidine or propofol for adults receiving mechanical ventilation",
       "scope": "on-scope",
       "note": "States the standing guideline recommendation to target light sedation for mechanically ventilated adults — matches the card's target.",
       "page": "Page 4",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "Characteristic Infection confirmed by culture Infection suspected but not confirmed by culture Infection ruled out Dexmedetomidine before enrollment -- no. (%) Propofol before enrollment -- no. (%) Benzodiazepine before enrollment -- no. (%) Opioid before enrollment -- no. (%) Antipsychotic agent before enrollment -- no. (%) Delirium at enrollment -- no. (%) Level of arousal closest to the time of randomization -- no. (%) Coma: RASS -5 or -4 Deep sedation: RASS -3 Light sedation: RASS -2 or -1 Awake and calm: RASS 0 Agitated: RASS +1 to +4 Dexmedetomidine (N = 214) 146 (68) 58 (27) 10 (5) 35 (16) 131 (61) 62 (29) 144 (67) 24 (11) Propofol (N = 208) 132 (63) 68 (33) 8 (4) 25 (12) 129 (62) 73 (35) 147 (71) 27 (13) 75 (35) 91 (44) 81 (38) 29 (14) 85 (40) 13 (6) 6 (3) 74 (36) 38 (18) 75 (36) 14 (7) 7 (3) *Percentages may not total 100 because of rounding.",
       "highlight": "Deep sedation: RASS -3 Light sedation: RASS -2 or -1",
       "scope": "on-scope",
       "note": "MENDS2's arousal banding labels RASS -3 as deep and -2/-1 as light, matching the card's 'deep sedation (−3 or lower)' cut.",
       "page": "Page 17 (Table 1)",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "and 5 to 50 g per kilogram of actual body weight per minute for propofol) to adjust the trial drug every 10 minutes to target sedation goals set by the clinical team and documented each adjustment and the rationale for it. The clinical team used the Richmond Agitation-Sedation Scale (RASS, on which scores range from -5 [unresponsive] to +4 [combative]),26 to set the sedation goal, which was primarily light sedation (RASS score 0 to -2).",
       "highlight": "to set the sedation goal, which was primarily light sedation (RASS score 0 to -2)",
       "scope": "narrower",
       "note": "Trial protocol in mechanically ventilated septic adults: clinicians set a RASS sedation goal, primarily light (RASS 0 to -2) — operationalizes the card but in a narrower population.",
       "page": "Page 7",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "SAT/SBT",
     "cite": "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org.",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived Vanderbilt CIBS page (site nav stripped); contributes the daily SAT/SBT titration method toward light sedation — a distinct ABCDEF element from setting a per-shift RASS target.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt",
     "paragraphs": [
      {
       "context": "Spontaneous Awakening Trials (SATs), also known as daily sedative interruptions, are one of the recommended titration methods in the recent Pain, Agitation, Delirium, Immobility, and Sleep Disruption (PADIS) guidelines for managing sedatives in critically ill patients and achieving light sedation.",
       "highlight": "for managing sedatives in critically ill patients and achieving light sedation",
       "scope": "different-intervention",
       "note": "Describes daily sedative interruption as a titration method for achieving light sedation — a different intervention sharing the same light-sedation goal as the RASS-target card.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2018 governs and directly supports the card: it recommends targeting light over deep sedation — defining light as RASS -2 to +1 — unless deeper sedation is clinically indicated, and MENDS2 reinforces this target while labeling RASS -3 as \"deep sedation,\" matching the card's \"-3 or lower\" cut (though within a narrower sepsis drug-choice trial). The 2025 focused update addressed sedative choice (dexmedetomidine over propofol), not the depth target, so the 2018 light-sedation recommendation remains the current position, and the SAT/SBT page covers a different (daily-awakening) intervention toward the same light-sedation goal; the card's \"every shift\" cadence is operational framing rather than a verbatim guideline threshold.",
   "discrepancy": true
  },
  {
   "id": "spa-r4",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Sedation",
   "statement": "Lightest sedative possible: Prefer dexmedetomidine or propofol over benzodiazepines — benzodiazepines increase delirium risk.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2018",
    "PADIS 2025",
    "MENDS2 2021",
    "SAT/SBT"
   ],
   "anchor": "PADIS 2018 — p. 17",
   "passage": "Copyright © 2018 by the Society of Critical Care Medicine and Wolters Kluwer Health, Inc. All Rights Reserved. Devlin et al e840 www.ccmjournal.org September 2018 • Volume 46 • Number 9 Should dexmedetomidine, when compared with propofol, be used for sedation in critically ill, mechanically ventilated adults? Recommendation: We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence). Rationale: We evaluated the effect of propofol versus benzodiazepine, dexmedetomidine versus benzodiazepine, and propofol versus dexmedetomidine in three separate analyses for the outcomes deemed critical. In most studies, benzodiazepines were administered as continuous infusions and not intermittent boluses. We combined studies using midazolam and lorazepam. In critically ill, mechanically ventilated patients, a shortened time to light sedation of at least 4 hours and time to extubation of at least 8-12 hours (one nursing shift) were deemed clinically significant. Propofol Versus Benzodiazepines. …\nAlso MENDS2 2021: \"Trials comparing dexmedetomidine with benzodiazepines in adults have shown that the use of dexmedetomidine results in improvement in outcomes such as delirium, coma, and time receiving mechanical ventilation.\"\nThe MENDS2 background statement corroborates the delirium risk of benzodiazepines relative to dexmedetomidine; PADIS 2018 additionally reports the SEDCOM delirium finding (RR 0.71, p. 17).",
   "evidence": "Full text, p. 17",
   "status": "fulltext",
   "pageNum": "17",
   "citations": [
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Directly answers the sedative-choice question and names benzodiazepine use as a delirium risk factor — the governing on-scope source.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Recommendation: We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence).",
       "highlight": "using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults",
       "scope": "on-scope",
       "note": "The sedation recommendation: prefer the nonbenzodiazepine agents (propofol or dexmedetomidine) over benzodiazepines in ventilated ICU adults.",
       "page": "e839",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Benzodiazepine use and blood transfusion administration are the only two modifiable factors with strong evidence for an association with delirium detected by screening tools (Supplemental Table 22, Supplemental Digital Content 30, http://links.lww. com/CCM/D788). The nonmodifiable risk factors with strong evidence for an association with delirium include increasing age, dementia, prior coma, pre-ICU emergency surgery or trauma, and increasing APACHE and ASA scores. Sex, opioid use, and mechanical ventilation each have been strongly shown not to alter the risk of delirium occurrence. Moderate evidence exists showing the following increase the risk for delirium: history of hypertension; admission because of a neurologic disease; trauma; and the use of psychoactive medication (e.g., antipsychotics, anticonvulsants). A history of respiratory disease, medical admission, nicotine use, dialysis or continuous venovenous hemofiltration, and a lower Glasgow Coma Scale score have each been moderately shown not to increase the risk for delirium. See the \"Sedation section\" for a review on how sedative choice may affect delirium and the \"Sleep section\" regarding the relationship between sleep and delirium. For all other potential delirium-associated risk factors, evidence currently remains inconclusive.",
       "highlight": "Benzodiazepine use and blood transfusion administration are the only two modifiable factors with strong evidence for an association with delirium",
       "scope": "on-scope",
       "note": "Supports the second half of the claim: benzodiazepine use is one of only two modifiable factors with strong evidence of association with delirium.",
       "page": "e842",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "recommendation) that nonbenzodiazepine sedatives (either propofol or dexmedetomidine) are preferable to benzodiazepine sedatives (either midazolam or lorazepam) in critically ill, mechanically ventilated adults because of improved shortterm outcomes such as ICU LOS, duration of mechanical ventilation, and delirium (1). For the current guidelines, we considered both short-term and long-term outcomes as critical for evaluation. These included time to extubation, time to light sedation, and delirium, and long-term outcomes such as 90-day mortality, cognitive and physical functioning, institutionalization, and psychologic dysfunction.",
       "highlight": "nonbenzodiazepine sedatives (either propofol or dexmedetomidine) are preferable to benzodiazepine sedatives",
       "scope": "on-scope",
       "note": "Reiterates the prior (2013) recommendation carried forward, citing improved short-term outcomes including delirium.",
       "page": "e839",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Focused update reproduces the 2018 benzodiazepine-avoidance recommendation without re-addressing it, so that position remains current; its own new recommendation concerns choosing between the two preferred nonbenzodiazepine agents.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence)",
       "highlight": "using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults",
       "scope": "on-scope",
       "note": "The 2025 update reproduces the 2018 recommendation verbatim in its carry-forward table, confirming the benzo-avoidance position remains the current guidance.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "In adult patients admitted to the ICU, the task force issued conditional recommendations to use dexmedetomidine over propofol for sedation, provide enhanced mobilization/rehabilitation over usual mobilization/rehabilitation, and administer melatonin. The task force was unable to issue recommendations on the administration of benzodiazepines to treat anxiety, and the use of antipsychotics to treat delirium.",
       "highlight": "use dexmedetomidine over propofol for sedation",
       "scope": "different-intervention",
       "note": "The update's new recommendation compares the two nonbenzodiazepine agents (dexmedetomidine vs. propofol) - a different question than benzodiazepine avoidance.",
       "page": "ms. p.1",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Compared with propofol, dexmedetomidine probably reduced the prevalence of delirium (RR, 0.55; 95% CI, 0.37-0.81; absolute risk reduction [ARR], 15 fewer patients per 100; 95% CI, from 20 fewer to 6 fewer; moderate certainty) and may reduce the duration of delirium (MD, -25.58hr; 95% CI, -43.49 to -7.66hr; low certainty).",
       "highlight": "dexmedetomidine probably reduced the prevalence of delirium (RR, 0.55; 95% CI, 0.37-0.81",
       "scope": "different-intervention",
       "note": "Delirium reduction here is dexmedetomidine vs propofol (both nonbenzodiazepines), not the benzo-vs-nonbenzo contrast in the claim.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "A dexmedetomidine-vs-propofol trial in sepsis (both preferred agents) — its framing and conclusion reinforce the guideline preference, but its head-to-head result answers a different question than benzodiazepine avoidance.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "Trials comparing dexmedetomidine with benzodiazepines in adults have shown that the use of dexmedetomidine results in improvement in outcomes such as delirium, coma, and time receiving mechanical ventilation.",
       "highlight": "the use of dexmedetomidine results in improvement in outcomes such as delirium",
       "scope": "on-scope",
       "note": "Intro summary directly supporting that dexmedetomidine improves delirium versus benzodiazepines — i.e., benzodiazepines carry higher delirium risk.",
       "page": "1424",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "BACKGROUND--Guidelines currently recommend targeting light sedation with dexmedetomidine or propofol for adults receiving mechanical ventilation. Differences exist between these sedatives in arousability, immunity, and inflammation. Whether they affect outcomes differentially in mechanically ventilated adults with sepsis undergoing light sedation is unknown.",
       "highlight": "Guidelines currently recommend targeting light sedation with dexmedetomidine or propofol for adults receiving mechanical ventilation",
       "scope": "on-scope",
       "note": "Restates the guideline preference for light sedation with dexmedetomidine or propofol, matching the claim's 'lightest sedative possible' framing.",
       "page": "1424",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "Our findings, therefore, strongly reinforce current guidelines24 that recommend the use of either dexmedetomidine or propofol for light sedation when continuous sedation is needed for adults with or without sepsis who require mechanical ventilation.",
       "highlight": "reinforce current guidelines24 that recommend the use of either dexmedetomidine or propofol for light sedation",
       "scope": "on-scope",
       "note": "The conclusion explicitly reinforces the guideline recommendation to use either dexmedetomidine or propofol for light sedation.",
       "page": "1433",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "In this multicenter, double-blind, randomized, controlled trial involving mechanically ventilated adults with sepsis who were being treated with recommended light-sedation approaches, we did not find evidence that sedation with dexmedetomidine led to more days alive without acute brain dysfunction than propofol. Furthermore, we found no difference in ventilator-free days at 28 days, death at 90 days, or global cognition (as assessed with the use of age-adjusted TICS-T scores) at 6 months between the dexmedetomidine and propofol groups. Safety end points were also similar in the two groups.",
       "highlight": "we did not find evidence that sedation with dexmedetomidine led to more days alive without acute brain dysfunction than propofol",
       "scope": "different-intervention",
       "note": "The trial's own primary finding (dexmed vs propofol, no difference, in septic ventilated adults) is a different comparison and population than the benzo-avoidance claim — nearest match, different scope.",
       "page": "1433",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "SAT/SBT",
     "cite": "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Supports the 'achieve light sedation' goal but via spontaneous awakening trials (sedative interruption), not the dexmedetomidine/propofol-over-benzodiazepine agent choice; does not mention the agents or benzodiazepine delirium risk.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt",
     "paragraphs": [
      {
       "context": "Spontaneous Awakening Trials (SATs), also known as daily sedative interruptions, are one of the recommended titration methods in the recent Pain, Agitation, Delirium, Immobility, and Sleep Disruption (PADIS) guidelines for managing sedatives in critically ill patients and achieving light sedation.",
       "highlight": "recommended titration methods in the recent Pain, Agitation, Delirium, Immobility, and Sleep Disruption (PADIS) guidelines for managing sedatives in critically ill patients and achieving light sedation",
       "scope": "different-intervention",
       "note": "Backs the light-sedation objective through daily sedative interruption (SAT), a different intervention than the sedative-agent selection the claim specifies.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2018 is the governing on-scope source: it directly recommends the nonbenzodiazepine agents propofol or dexmedetomidine over benzodiazepines in ventilated ICU adults and names benzodiazepine use as one of only two modifiable factors with strong evidence of association with delirium — supporting both halves of the claim. The 2025 focused update reproduced that benzodiazepine-avoidance recommendation without revisiting it, so it remains the current position, while the update's new dexmedetomidine-over-propofol recommendation and the MENDS2 trial address a different question (choosing between the two already-preferred agents) and the SAT/SBT page supports light sedation through sedative interruption rather than agent choice.",
   "discrepancy": true
  },
  {
   "id": "spa-r5",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Sedation",
   "statement": "Bolus over continuous: When safe, consider intermittent dosing rather than continuous infusions.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2018",
    "PADIS 2025",
    "MENDS2 2021",
    "SAT/SBT"
   ],
   "anchor": "PADIS 2018 — p. 18",
   "passage": "Copyright © 2018 by the Society of Critical Care Medicine and Wolters Kluwer Health, Inc. All Rights Reserved. Online Special Article Critical Care Medicine www.ccmjournal.org e841 care and the perceptions of patients while on each of these sedatives are also needed; of note, our patient panel members described very different subjective experiences when receiving sedatives that could not be translated into guideline recommendation content. Pharmacokinetic and pharmacodynamic considerations should be incorporated in both sedative choice and delivery methods (162, 163). For example, the risks and benefits of an intermittent benzodiazepine administration strategy after establishing analgesia need to be studied against use of continuous sedative infusions. Benzodiazepine medications still form the mainstay of therapy in resource-poor areas; risks and benefits need to be studied in the context of their cost. Additionally, the role of sedative medications in the context of an analgesia-first approach or to supplement analgosedation needs to be better studied. The role of benzodiazepines versus propofol or dexmedetomidine in patients who are hemodynamically unstable, need deep sedation, are at risk for delirium, or have signs of alcohol withdrawal needs to be studied. …\nPADIS 2018 frames intermittent versus continuous sedative dosing as an evidence gap needing study, not a graded recommendation to prefer boluses; no cited source firmly recommends bolus over continuous dosing.",
   "evidence": "Full text, p. 18 — partial support",
   "status": "fulltext",
   "pageNum": "18",
   "citations": [
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "partial",
     "note": "The nearest and most direct source: it discusses the exact intermittent-vs-continuous sedation dichotomy in the same ICU population, but treats it as an unresolved evidence gap rather than issuing a bolus-over-continuous recommendation. Its broader framework (light sedation over deep, analgesia-first/analgosedation, drug-accumulation harms) is directionally consistent with the heuristic.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "For example, the risks and benefits of an intermittent benzodiazepine administration strategy after establishing analgesia need to be studied against use of continuous sedative infusions.",
       "highlight": "the risks and benefits of an intermittent benzodiazepine administration strategy after establishing analgesia need to be studied against use of continuous sedative infusions",
       "scope": "on-scope",
       "note": "Directly juxtaposes an intermittent sedative strategy against continuous infusions in ICU adults, but frames the comparison as something that 'needs to be studied' — an evidence gap, not a graded recommendation.",
       "page": "e841",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Evidence Gaps: Variability in nursing sedation assessment frequency and its reporting, and modality of sedative administration (infusion vs bolus) differ among institutions. The most frequent sedative choice (benzodiazepines) described in the studies may not reflect current practice. Patient and family preferences and education as to depth of sedation within a \"light sedation\" range should also be considered. Nonetheless, future research should focus on the effect of sedation level on patient-centered outcomes.",
       "highlight": "modality of sedative administration (infusion vs bolus) differ among institutions",
       "scope": "on-scope",
       "note": "Names the exact infusion-vs-bolus dichotomy of the claim, but only as an evidence-gap observation that practice varies across institutions, not as an endorsement of bolus dosing.",
       "page": "e838",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "AGITATION/SEDATION Sedatives are frequently administered to critically ill patients to relieve anxiety, reduce the stress of being mechanically ventilated, and prevent agitation-related harm (1). These medications may predispose patients to increased morbidity (157, 158). The healthcare provider must determine the specific indication for the use of sedatives. If a sedative is needed, the patient's current sedation status should be assessed and then frequently reassessed using valid and reliable scales (158-161). In critically ill patients, unpredictable pharmacokinetics and pharmacodynamics secondary to drug interactions, organ dysfunction, inconsistent absorption and protein binding, hemodynamic instability, and drug accumulation can lead to adverse events (1, 162, 163).",
       "highlight": "drug accumulation can lead to adverse events",
       "scope": "broader",
       "note": "Pharmacologic rationale that underpins the heuristic — continuous sedative exposure risks accumulation and adverse events — though the guideline applies it to sedative choice and assessment generally, not specifically to bolus-vs-continuous delivery.",
       "page": "e836",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "The focused update's only agitation/sedation recommendation concerns agent choice (dexmedetomidine over propofol); it did not re-address delivery mode, so the 2018 treatment of intermittent-vs-continuous remains the current position.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "In adult patients admitted to the ICU, the task force issued conditional recommendations to use dexmedetomidine over propofol for sedation, provide enhanced mobilization/rehabilitation over usual mobilization/rehabilitation, and administer melatonin. The task force was unable to issue recommendations on the administration of benzodiazepines to treat anxiety, and the use of antipsychotics to treat delirium.",
       "highlight": "use dexmedetomidine over propofol for sedation",
       "scope": "different-intervention",
       "note": "The 2025 update addressed which sedative agent to prefer, not intermittent boluses vs. continuous infusion; it did not reopen the delivery-mode question.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "background",
     "note": "A drug-choice trial comparing two continuous sedative infusions (dexmedetomidine vs propofol) in septic ventilated adults; it assumes continuous sedation and never evaluates bolus-vs-continuous delivery, so it is a nearest-topic match on a different question.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "Although recent data suggest that many critically ill adults receiving mechanical ventilation may not require sedative infusions,38,39 our trial specifically enrolled adults with sepsis who had a high severity of illness, a greater risk for ARDS, and a higher requirement for continuous sedation. It was important to better characterize the effect of greater arousability, analgesic properties, and lack of respiratory depression observed with dexmedetomidine as compared with GABAergic sedatives in this population. Data indicate meaningful differences between dexmedetomidine and GABAergic sedatives with respect to innate immunity and risk of infection, including evidence that dexmedetomidine may offer superior antiinflammatory effects.11-17 Despite these theoretical benefits and studies supporting the use of dexmedetomidine, the choice between dexmedetomidine and propofol alone does not appear to substantially affect patient outcomes in the complex milieu of critical illness with sepsis. Our findings, therefore, strongly reinforce current guidelines24 that recommend the use of either dexmedetomidine or propofol for light sedation when continuous sedation is needed for adults with or without sepsis who require mechanical ventilation.",
       "highlight": "many critically ill adults receiving mechanical ventilation may not require sedative infusions",
       "scope": "different-intervention",
       "note": "MENDS2 reinforces using either dexmedetomidine or propofol 'when continuous sedation is needed' and only references in passing that many patients may not require infusions at all; it does not compare intermittent dosing against continuous infusion.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "SAT/SBT",
     "cite": "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org.",
     "kind": "pdf",
     "stance": "background",
     "note": "Describes Spontaneous Awakening Trials (daily interruption of continuous sedation), a distinct sedation-minimization method rather than intermittent bolus dosing; anchored on the content sentence, not the archived page's navigation menu.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt",
     "paragraphs": [
      {
       "context": "Spontaneous Awakening Trials (SATs), also known as daily sedative interruptions, are one of the recommended titration methods in the recent Pain, Agitation, Delirium, Immobility, and Sleep Disruption (PADIS) guidelines for managing sedatives in critically ill patients and achieving light sedation.",
       "highlight": "daily sedative interruptions, are one of the recommended titration methods",
       "scope": "different-intervention",
       "note": "Daily sedative interruption lightens or pauses a continuous infusion and restarts it at a reduced dose; it is a different sedation-minimization intervention from replacing continuous infusion with intermittent boluses.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
      }
     ]
    }
   ],
   "synthesis": "The bedside heuristic to prefer intermittent dosing over continuous infusions when safe is directionally consistent with PADIS 2018's sedation-minimization framework, but PADIS 2018 — the only on-scope source — explicitly treats the intermittent-vs-continuous comparison as an evidence gap that \"needs to be studied\" rather than issuing a graded recommendation, so its support is partial. The other three sources are nearest matches on different questions (PADIS 2025 and MENDS2 address sedative agent choice among continuous infusions; SAT/SBT addresses daily sedative interruption), none of which evaluate delivery mode, so PADIS 2018 remains the governing (though non-graded) source for this claim.",
   "discrepancy": true
  },
  {
   "id": "spa-r6",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Sedation",
   "statement": "Daily SAT / SBT: Awakening + breathing trial daily when feasible; coordinate with respiratory therapy.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2018",
    "PADIS 2025",
    "MENDS2 2021",
    "SAT/SBT"
   ],
   "anchor": "SAT/SBT: \"The ABC study, also known as the Wake Up and Breathe study, showed that pairing together daily SATs with daily Spontaneous Breathing Trials (SBTs) in a protocol that included safety screens and failure criteria resulted in improved patients outcomes.\"",
   "passage": "Also PADIS 2018: \"A DSI or a SAT is defined as a period of time, each day, during which a patient's sedative medication is discontinued and patients can wake up and achieve arousal and/or alertness\"\nThe ICUDelirium.org page states the paired daily SAT+SBT protocol, with the SBT as the respiratory-therapy component; PADIS 2018 corroborates the daily awakening trial (p. 16).",
   "evidence": "Web page",
   "status": "web",
   "pageNum": null,
   "citations": [
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Supports the daily SAT (DSI) component and links light sedation to SBTs, but frames SAT as one of two equivalent titration methods, not as the SAT+SBT pairing/coordination recommendation.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Remarks: A DSI or a SAT is defined as a period of time, each day, during which a patient's sedative medication is discontinued and patients can wake up and achieve arousal and/or alertness, defined by objective actions such as opening eyes in response to a voice, following simple commands, and/or having a Sedation-Agitation Scale (SAS) score of 4-7 or a RASS score of -1 to +1. NP-targeted sedation is defined as an established sedation protocol implemented by nurses at the bedside to determine sedative choices and to titrate these medications to achieve prescription-targeted sedation scores.",
       "highlight": "A DSI or a SAT is defined as a period of time, each day",
       "scope": "on-scope",
       "note": "Defines the daily spontaneous awakening trial (DSI/SAT) that the card's 'awakening trial daily' rests on.",
       "page": "e838",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "As outlined in these guidelines, clinicians should target a light rather than deep level of sedation in their intubated, critically ill adult patients unless deeper sedation is clinically indicated. Our literature review suggests that both DSI protocols and NP-targeted sedation are safe and no differences exist between them in achieving and maintaining a light level of sedation. There are, however, some important caveats: first, most studies evaluating DSIs and NP have done so in the context of sedation with benzodiazepines, which are no longer recommended for sedation in critically ill patients; second, DSI protocols may be associated with increasing nursing workload (179); and third, a brief DSI should not be used to justify the use of deep sedation for the rest of the day when it is not indicated. Because light levels of sedation are associated with improved outcomes and are needed to facilitate other interventions such as spontaneous breathing trials and early mobilization, healthcare providers should strive to achieve light levels of sedation in the majority of patients the majority of the time. Light sedation, assessed using a validated sedation scale, can be achieved either using a NP or through DSI protocols (where light sedation is targeted, whereas sedatives are infusing).",
       "highlight": "needed to facilitate other interventions such as spontaneous breathing trials and early mobilization",
       "scope": "on-scope",
       "note": "Ties light sedation to spontaneous breathing trials, the SBT half of the pairing.",
       "page": "e839",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "In critically ill, intubated adults, DSI protocols and NP-targeted sedation can achieve and maintain a light level of sedation.",
       "highlight": "DSI protocols and NP-targeted sedation can achieve and maintain a light level of sedation",
       "scope": "on-scope",
       "note": "Ungraded statement endorsing daily SAT (DSI) as a valid approach, but as one of two equivalent methods rather than a pairing/coordination recommendation.",
       "page": "e838",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "The focused update did not re-address daily SAT/SBT; its sedation question was dexmedetomidine vs propofol. It does not speak to this claim, so the 2018 position remains current.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "METHODS: The task force focused on five main content areas as they pertain to adult ICU patients: anxiety (new topic), agitation/sedation, delirium, immobility, and sleep disruption. Using the GRADE approach, we conducted a rigorous systematic review for each population, intervention, control, and outcome question to identify the best available evidence, statistically summarized the evidence, assessed the quality of evidence, and then performed the evidence-to-decision framework to formulate recommendations.",
       "highlight": "five main content areas as they pertain to adult ICU patients: anxiety (new topic), agitation/sedation, delirium, immobility, and sleep disruption",
       "scope": "background",
       "note": "Documents the update's scope (anxiety, agitation/sedation, delirium, immobility, sleep)—SAT/SBT was not among the re-examined questions, so this update neither supports nor revises the claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "background",
     "note": "A dexmedetomidine-vs-propofol RCT in septic ventilated adults; SAT/SBT coordination was applied uniformly as ABCDE-bundle background care in both arms, not tested or recommended as the intervention.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "Our trial builds on other trials that have compared dexmedetomidine with propofol,21-23,40 with important methodologic advances that include a higher degree of sedative trial drug blinding, a better separation between groups with regard to sedative exposure, and stricter adherence to light sedation approaches, with high compliance with a standardized, multicomponent sedation management bundle (i.e., the ABCDE bundle)28,29 that has been shown to reduce mortality and improve other important outcomes. One study by Kawazoe et al.22 randomly assigned 201 patients with sepsis who required mechanical ventilation to open-label sedation with dexmedetomidine (up to 0.7 g per kilogram per hour) or sedation without dexmedetomidine (infusions of propofol or midazolam or both) for up to 7 days. On 1 or more study days, 29% of the dexmedetomidine group received propofol (nearly three times the crossover rate of our study) and up to 21% received midazolam. The authors found no significant difference in the number of days without delirium or coma, the number of ventilator-free days, or mortality at 28 days with dexmedetomidine use, although the trial was probably underpowered to measure a difference in mortality.",
       "highlight": "high compliance with a standardized, multicomponent sedation management bundle (i.e., the ABCDE bundle)",
       "scope": "different-intervention",
       "note": "SAT/SBT was delivered as ABCDE-bundle background in both arms; the studied intervention was sedative choice (dexmedetomidine vs propofol), not the SAT/SBT pairing.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "All centers performed, and investigators reinforced, the ABCDE (awakening and breathing coordination, choice of sedation, delirium monitoring and management, and early mobility) bundle,28,29 with daily adherence recorded.",
       "highlight": "awakening and breathing coordination",
       "scope": "different-intervention",
       "note": "Describes the trial's ABCDE bundle (awakening and breathing coordination) with daily adherence recorded — a process measure in this drug-comparison trial, not a recommendation to perform SAT/SBT.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "SAT/SBT",
     "cite": "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Archived Vanderbilt CIBS/ICUDelirium.org 'Both SAT and SBT' page (the claim's primary anchor); anchored on content sentences, not site navigation. Governing on-scope source.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt",
     "paragraphs": [
      {
       "context": "The ABC study, also known as the Wake Up and Breathe study, showed that pairing together daily SATs with daily Spontaneous Breathing Trials (SBTs) in a protocol that included safety screens and failure criteria resulted in improved patients outcomes (i.e., decreased time on the ventilator, reduced time spent in the ICU and hospital, and improved one-year survival).",
       "highlight": "pairing together daily SATs with daily Spontaneous Breathing Trials (SBTs) in a protocol that included safety screens and failure criteria resulted in improved patients outcomes",
       "scope": "on-scope",
       "note": "Directly supports pairing daily SAT with daily SBT (ABC / Wake Up and Breathe trial) — the core of the card.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
      },
      {
       "context": "This coordination of SATs and SBTs (awakening and breathing trials) emphasizes that narcotic and sedation titration alongside timely removal of mechanical ventilation play a pivotal role in liberating patients from the ICU and are thus core features of the ABCDEF bundle.",
       "highlight": "This coordination of SATs and SBTs (awakening and breathing trials)",
       "scope": "on-scope",
       "note": "Supports the 'coordinate' element — coordinating awakening and breathing trials (the SBT being the respiratory-therapy step).",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
      },
      {
       "context": "Daily SATs are the stopping of narcotics (as long as pain is controlled) and sedatives every day and, if needed, restarting either narcotics or sedatives at half the previous dose and titrating as needed.",
       "highlight": "Daily SATs are the stopping of narcotics (as long as pain is controlled) and sedatives every day",
       "scope": "on-scope",
       "note": "Establishes the daily cadence of the SAT that the card specifies.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
      }
     ]
    }
   ],
   "synthesis": "The governing on-scope source is the Vanderbilt CIBS \"Both SAT and SBT\" reference, which—drawing on the ABC/Wake Up and Breathe trial—supports pairing daily spontaneous awakening trials with daily spontaneous breathing trials in one coordinated protocol. PADIS 2018 backs the daily SAT (DSI) component and states light sedation is needed to facilitate SBTs, but frames SAT as one of two equivalent titration methods rather than issuing the pairing/coordination recommendation itself, so it is partial; MENDS2 2021 applied SAT/SBT coordination only as background ABCDE-bundle adherence within a dexmedetomidine-versus-propofol trial in septic patients (a different intervention), and the 2025 PADIS focused update did not re-address SAT/SBT, so the 2018 position remains the current guideline stance.",
   "discrepancy": true
  },
  {
   "id": "spa-r7",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Sedation",
   "statement": "CAM-ICU & RASS each shift: Document RASS; complete the CAM-ICU once per shift and with any mental-status change.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2018",
    "PADIS 2025",
    "MENDS2 2021",
    "SAT/SBT"
   ],
   "anchor": "PADIS 2018 — p. 20",
   "passage": "… The effect of a reduction in known delirium risk factors including comorbid diseases, sepsis, nicotine and alcohol abuse, and the use of opioids and systemic steroids on delirium burden and patient outcome is unknown. Confounding is a key issue in these studies. Future studies on delirium risk factors should therefore make adequate adjustments based on previously considered risk factors (278). Assessment Question: Should we assess for delirium using a valid tool (compared with not performing this assessment with a valid tool) in critically ill adults? Good Practice Statement: Critically ill adults should be regularly assessed for delirium using a valid tool. Remarks: The previous guidelines provided psychometric appraisals of pain, sedation, and delirium screening tools (1). A reevaluation of the psychometrics for available delirium screening tools was not conducted as part of these guidelines. This question's focus is the effect of using any delirium assessment tool (vs no assessment tool) in clinical practice. Rationale: Most studies evaluating delirium assessment combine the assessment intervention with one or more management strategies (8, 110, 283), precluding the ability to evaluate outcomes related to the monitoring itself. …\nPADIS 2018 also states that sedation status 'should be assessed and then frequently reassessed using valid and reliable scales,' naming the RASS (p. 14). The once-per-shift frequency is operational rather than guideline-specified.",
   "evidence": "Full text, p. 20",
   "status": "fulltext",
   "pageNum": "20",
   "citations": [
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary governing source: two ungraded good practice statements underwrite routine delirium assessment (CAM-ICU) and frequent sedation reassessment (RASS); the exact per-shift cadence is a bundle operationalization, not a verbatim guideline number.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Critically ill adults should be regularly assessed for delirium using a valid tool.",
       "highlight": "Critically ill adults should be regularly assessed for delirium using a valid tool",
       "scope": "on-scope",
       "note": "Good Practice Statement directly supporting completing the CAM-ICU (a valid delirium tool) as routine monitoring; guideline says 'regularly' without specifying once-per-shift.",
       "page": "e843",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "AGITATION/SEDATION Sedatives are frequently administered to critically ill patients to relieve anxiety, reduce the stress of being mechanically ventilated, and prevent agitation-related harm (1). These medications may predispose patients to increased morbidity (157, 158). The healthcare provider must determine the specific indication for the use of sedatives. If a sedative is needed, the patient's current sedation status should be assessed and then frequently reassessed using valid and reliable scales (158-161). In critically ill patients, unpredictable pharmacokinetics and pharmacodynamics secondary to drug interactions, organ dysfunction, inconsistent absorption and protein binding, hemodynamic instability, and drug accumulation can lead to adverse events (1, 162, 163).",
       "highlight": "frequently reassessed using valid and reliable scales",
       "scope": "on-scope",
       "note": "Supports documenting RASS (a valid/reliable sedation scale, ref 159) at initiation and frequently thereafter; frequency stated as 'frequently', not 'each shift'.",
       "page": "e837",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Focused update covering anxiety, dexmedetomidine-vs-propofol, antipsychotics for delirium, mobilization, and melatonin; it did not re-address the RASS/CAM-ICU monitoring-frequency question, so the 2018 good practice statements remain the current position. Cited as the current umbrella guideline for the Sedation section.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": []
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest-match different-scope: a sedative-choice RCT in mechanically ventilated adults with sepsis whose research-assessment protocol used RASS and CAM-ICU twice daily; a trial procedure in a narrower population, not a monitoring-frequency recommendation.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "All centers performed, and investigators reinforced, the ABCDE (awakening and breathing coordination, choice of sedation, delirium monitoring and management, and early mobility) bundle,28,29 with daily adherence recorded. In addition to care assessments made by nurses, trained research personnel assessed patients with the use of RASS for level of arousal,26 Confusion Assessment Method for the ICU (CAM-ICU)30 for delirium, and the Critical Care Pain Observation Tool31 for pain; assessments were made twice daily in the ICU and then once daily after transfer from the ICU for up to 14 days or until discharge from the hospital or death. We strived to conduct delirium assessments when the patient was maximally awake. A RASS score of -4 or -5 indicated coma, and a positive CAM-ICU score indicated delirium.",
       "highlight": "assessments were made twice daily in the ICU and then once daily after transfer from the ICU",
       "scope": "different-population",
       "note": "Shares the RASS/CAM-ICU keywords but describes a trial's research-assessment cadence (twice daily) in mechanically ventilated sepsis patients, not routine bedside monitoring per shift.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "SAT/SBT",
     "cite": "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org.",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived ICUDelirium.org page (with site navigation boilerplate) about the ABCDEF 'B' element; content is about SAT/SBT sedative titration and ventilator liberation, a different intervention than RASS/CAM-ICU monitoring frequency.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt",
     "paragraphs": [
      {
       "context": "Spontaneous Awakening Trials (SATs), also known as daily sedative interruptions, are one of the recommended titration methods in the recent Pain, Agitation, Delirium, Immobility, and Sleep Disruption (PADIS) guidelines for managing sedatives in critically ill patients and achieving light sedation.",
       "highlight": "one of the recommended titration methods in the recent Pain, Agitation, Delirium, Immobility, and Sleep Disruption (PADIS) guidelines for managing sedatives",
       "scope": "different-intervention",
       "note": "Describes Spontaneous Awakening Trials for achieving light sedation; shares the Sedation action-card context but does not address documenting RASS or completing the CAM-ICU per shift.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2018 governs and directly supports the statement: its good practice statements that critically ill adults be regularly assessed for delirium with a valid tool and that sedation status be frequently reassessed with valid and reliable scales underwrite documenting RASS and completing the CAM-ICU as routine monitoring — though the specific \"once per shift and with any mental-status change\" cadence is a common ABCDEF-bundle operationalization rather than a verbatim guideline number. The 2025 focused update did not re-address monitoring frequency, so the 2018 statements remain the current position; MENDS2 (a sepsis-restricted sedative-choice RCT using twice-daily research assessments) and the SAT/SBT page (sedative titration/ventilator liberation) are nearest matches on different scope, not monitoring recommendations.",
   "discrepancy": true
  },
  {
   "id": "spa-r8",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Pain / Pharmacy",
   "statement": "Multimodal pain management: Analgesia first — scheduled acetaminophen, NSAIDs where appropriate, regional techniques to limit opioids.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2018",
    "PADIS 2025",
    "Beers 2023",
    "Pro-MEDIC 2022",
    "Melatonin ICU meta-analysis 2025"
   ],
   "anchor": "PADIS 2018 — p. 8",
   "passage": "Copyright © 2018 by the Society of Critical Care Medicine and Wolters Kluwer Health, Inc. All Rights Reserved. Online Special Article Critical Care Medicine www.ccmjournal.org e831 important safety concerns, such as sedation, delirium, respiratory depression, ileus, and immunosuppression, may lengthen ICU LOS and worsen post-ICU patient outcome. A \"multi-modal analgesia\" approach has been used in the perioperative setting to reduce opioid use and to optimize postoperative analgesia and rehabilitation (82). Nonopioid analgesics such as acetaminophen, nefopam, ketamine, lidocaine, neuropathic agents, and nonsteroidal anti-inflammatory drugs (NSAIDs) have each been evaluated in critically ill adults with the aim of sparing opioid use and improving analgesic effectiveness. In addition to opioids, these nonopioid analgesic alternatives may be combined with regional anesthetics and nonpharmacologic interventions known to reduce pain (see below). Dose, duration, and pharmacologic effectiveness need to be evaluated when combination strategies are being evaluated. Acetaminophen. Question: Should acetaminophen be used as an adjunct to an opioid (vs an opioid alone) for pain management in critically ill adults? Recommendation: We suggest using acetaminophen as an adjunct to an opioid to decrease pain intensity and opioid consumption for pain management in critically ill adults (conditional recommendation, very low quality of evidence). …\nPADIS 2018's multimodal-analgesia discussion supports combining nonopioids with regional techniques to spare opioids and recommends acetaminophen as an opioid-sparing adjunct.",
   "evidence": "Full text, p. 8",
   "status": "fulltext",
   "pageNum": "8",
   "citations": [
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
    "Wibrow B, Martinez FE, Myers E, et al. Prophylactic melatonin for delirium in intensive care (Pro-MEDIC): an RCT. Intensive Care Med. 2022;48(4):414-425.",
    "Tang BHY, Manalo J, Chowdhury SR, et al. Melatonin use in the ICU: a systematic review and meta-analysis. Crit Care Med. 2025;53(9):e1714-e1724. (32 RCTs, n=3895; may reduce delirium RR 0.72 and improve sleep — low certainty; slight reduction in adverse events.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://pubmed.ncbi.nlm.nih.gov/37139824/",
    "https://doi.org/10.1007/s00134-022-06638-9",
    "https://doi.org/10.1097/CCM.0000000000006767"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governing on-scope ICU source: endorses an analgesia-first, multimodal strategy with acetaminophen as a scheduled opioid-sparing adjunct, nonopioids combined with regional anesthetics, and NSAIDs used only where appropriate.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Summary of Pharmacologic Adjuvants to Opioid Therapy. The panel generally supports the utilization of multimodal pharmacotherapy as a component of an analgesia-first approach to spare and/or minimize both opioids and sedatives. A multimodal analgesia strategy is likely to improve pain control, reduce opioid consumption, and improve patientcentered outcomes. In patients for whom the risk of these nonopioid-adjunctive medications favors their exclusion, the several nonpharmacologic strategies (described below) provide an opportunity to minimize opioid consumption.",
       "highlight": "multimodal pharmacotherapy as a component of an analgesia-first approach to spare and/or minimize both opioids and sedatives",
       "scope": "on-scope",
       "note": "Directly states the analgesia-first, multimodal framing at the heart of the claim.",
       "page": "e833",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "important safety concerns, such as sedation, delirium, respiratory depression, ileus, and immunosuppression, may lengthen ICU LOS and worsen post-ICU patient outcome. A \"multi-modal analgesia\" approach has been used in the perioperative setting to reduce opioid use and to optimize postoperative analgesia and rehabilitation (82). Nonopioid analgesics such as acetaminophen, nefopam, ketamine, lidocaine, neuropathic agents, and nonsteroidal anti-inflammatory drugs (NSAIDs) have each been evaluated in critically ill adults with the aim of sparing opioid use and improving analgesic effectiveness. In addition to opioids, these nonopioid analgesic alternatives may be combined with regional anesthetics and nonpharmacologic interventions known to reduce pain (see below). Dose, duration, and pharmacologic effectiveness need to be evaluated when combination strategies are being evaluated.",
       "highlight": "these nonopioid analgesic alternatives may be combined with regional anesthetics and nonpharmacologic interventions known to reduce pain",
       "scope": "on-scope",
       "note": "Names acetaminophen and NSAIDs as opioid-sparing nonopioids and explicitly pairs them with regional anesthetics to limit opioids.",
       "page": "e831",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Recommendation: We suggest using acetaminophen as an adjunct to an opioid to decrease pain intensity and opioid consumption for pain management in critically ill adults (conditional recommendation, very low quality of evidence).",
       "highlight": "We suggest using acetaminophen as an adjunct to an opioid to decrease pain intensity and opioid consumption",
       "scope": "on-scope",
       "note": "Supports the scheduled-acetaminophen element (evaluated as IV 1 g every 6 hours) as an opioid-sparing adjunct.",
       "page": "e831",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "NSAID-related side effects including acute kidney injury and excessive bleeding were not significantly different between the three NSAIDs and the placebo group. Both studies had a high risk of bias (102, 103). Given the perceived small beneficial effect balanced with serious potential safety concerns (e.g., bleeding and kidney injury), particularly when NSAIDs are administered for multiple doses, the panel members recommend against routine use of NSAIDs along with opioids for nonprocedural pain management in critically ill adults. As with most conditional recommendations, the panel felt that there are likely patients--and perhaps even cohorts of patients--who may benefit from NSAIDs. No RCT evaluating a COX-2-specific NSAID (e.g., celecoxib) in critically ill adults was identified; thus, the role of these agents remains unclear.",
       "highlight": "recommend against routine use of NSAIDs along with opioids for nonprocedural pain management in critically ill adults",
       "scope": "narrower",
       "note": "Nearest NSAID match that qualifies rather than blanket-supports: routine adjunctive COX-1-selective NSAIDs are advised against for nonprocedural pain, which is exactly the 'where appropriate' hedge.",
       "page": "e833",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Recommendation: We suggest using an NSAID administered IV, orally, or rectally as an alternative to opioids for pain management during discrete and infrequent procedures in critically ill adults (conditional recommendation, low quality of evidence).",
       "highlight": "an NSAID administered IV, orally, or rectally as an alternative to opioids for pain management during discrete and infrequent procedures",
       "scope": "different-intervention",
       "note": "Endorses NSAIDs to limit opioids only in the specific context of discrete, infrequent procedures, not as a scheduled multimodal adjunct.",
       "page": "e834",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Focused update covering anxiety, agitation/sedation, delirium, immobility, and sleep only; it did not re-address the pain/analgesia questions, so the 2018 multimodal recommendation remains the current position.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "In these guidelines update, members of the \"Pain\" subpanel focused on anxiety to address this gap in the previous guidelines version.",
       "highlight": "subpanel focused on anxiety to address this gap in the previous guidelines version",
       "scope": "background",
       "note": "Shows the update's Pain subpanel worked on anxiety rather than reopening the multimodal-analgesia question.",
       "page": "e713",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "analgesia-first approach or to supplement analgesiasedation needs to be better studied. Studies evaluating the value of patient communication with family members during ICU care and the perceptions of patients while on propofol vs. dexmedetomidine (may include patients who can participate in their own care). The role of dexmedetomidine in patients who require treatment with deep sedation. RCTs definitively addressing a possible heterogeneity of dexmedetomidine treatment effect by age (over or under 65 yr old).",
       "highlight": "analgesia-first approach or to supplement analgesiasedation needs to be better studied",
       "scope": "different-intervention",
       "note": "Shares the 'analgesia-first' keyword but is a sedation research-gap item about the role of sedatives, not the pain multimodal recommendation.",
       "page": "e720",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "RCTs examining nonpharmacologic and/or multimodal approaches to treat anxiety in the critically ill.",
       "highlight": "nonpharmacologic and/or multimodal approaches to treat anxiety",
       "scope": "different-intervention",
       "note": "Shares the 'multimodal' keyword but refers to anxiety treatment, not multimodal pain analgesia.",
       "page": "e720",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "Beers 2023",
     "cite": "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Different-population guidance (older adults, potentially inappropriate medications) that aligns with the claim's spirit — favor multimodal, opioid-minimizing strategies and use NSAIDs cautiously — but is not ICU-specific.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/",
     "paragraphs": [
      {
       "context": "Opioids: emerging data highlights an association between opioid administration and delirium. For older adults with pain, use a balanced approach, including the use of validated pain assessment tools and multimodal strategies that include non drug approaches to minimize opioid use.",
       "highlight": "multimodal strategies that include non drug approaches to minimize opioid use",
       "scope": "different-population",
       "note": "Nearest match to the multimodal/opioid-limiting concept but for older adults generally and tied to delirium risk, not ICU multimodal analgesia.",
       "page": "2052-2081",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      },
      {
       "context": "Increased risk of GI bleeding or peptic ulcer disease in high-risk groups, including those >75 years old or taking oral or parenteral corticosteroids, anticoagulants, or antiplatelet agents; use of proton-pump inhibitor or misoprostol reduces but does not eliminate risk.",
       "highlight": "Increased risk of GI bleeding or peptic ulcer disease in high-risk groups",
       "scope": "different-population",
       "note": "Beers oral-NSAID rationale — GI bleeding/peptic-ulcer risk in high-risk older adults — supporting the 'NSAIDs where appropriate' caution; the population is older adults broadly (different, broader than ICU), with an avoid-chronic/scheduled-use recommendation.",
       "page": "2052-2081",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      }
     ]
    },
    {
     "label": "Pro-MEDIC 2022",
     "cite": "Wibrow B, Martinez FE, Myers E, et al. Prophylactic melatonin for delirium in intensive care (Pro-MEDIC): an RCT. Intensive Care Med. 2022;48(4):414-425.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Statistical analysis plan for a prophylactic-melatonin delirium-prevention RCT; it contains no pain, analgesia, opioid, NSAID, or acetaminophen content and does not address this multimodal-pain statement (it belongs to the melatonin/sleep material).",
     "docUrl": "https://doi.org/10.1007/s00134-022-06638-9",
     "paragraphs": []
    },
    {
     "label": "Melatonin ICU meta-analysis 2025",
     "cite": "Tang BHY, Manalo J, Chowdhury SR, et al. Melatonin use in the ICU: a systematic review and meta-analysis. Crit Care Med. 2025;53(9):e1714-e1724. (32 RCTs, n=3895; may reduce delirium RR 0.72 and improve sleep — low certainty; slight reduction in adverse events.)",
     "kind": "unarchived",
     "stance": "background",
     "note": "Melatonin ICU systematic review/meta-analysis (delirium and sleep outcomes, Crit Care Med. 2025;53(9):e1714-e1724); does not address multimodal analgesia or pain and is cited in the Pharmacy section by DOI for the melatonin/sleep item rather than this pain statement.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006767",
     "paragraphs": []
    }
   ],
   "synthesis": "PADIS 2018 is the governing on-scope source and directly supports the statement: it endorses an analgesia-first, multimodal strategy with acetaminophen as a scheduled opioid-sparing adjunct, nonopioids combined with regional anesthetics to spare opioids, and NSAIDs used only where appropriate (advising against routine adjunctive NSAIDs for nonprocedural pain while endorsing them as an opioid alternative for discrete procedures). The 2025 focused update did not re-address the pain/analgesia questions, so the 2018 recommendation remains the current position; Beers 2023 aligns in a different (older-adult) population, and the two melatonin sources do not bear on pain management.",
   "discrepancy": true
  },
  {
   "id": "spa-r9",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Pain / Pharmacy",
   "statement": "Review medications daily: Can any deliriogenic drug be stopped or reduced? Benzodiazepines, anticholinergics, steroids.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2018",
    "PADIS 2025",
    "Beers 2023",
    "Pro-MEDIC 2022",
    "Melatonin ICU meta-analysis 2025"
   ],
   "anchor": "Beers 2023 — p. 12",
   "passage": "… Non-selective peripheral alpha-1 blockers cause orthostatic blood pressure changes and should be avoided in older adults whose syncope may be due to orthostatic hypotension alpha-1 blockers: Weak AChEIs, tertiary TCAs: Strong Central Nervous System Delirium Anticholinergics Antipsychotics Benzodiazepines Corticosteroids (oral and parenteral) H2-receptor antagonists ● Cimetidine ● Famotidine ● Nizatidine Nonbenzodiazepine benzodiazepine receptor agonist hypnotics (\"Zdrugs\") ● Eszopiclone ● Zaleplon Avoid in older adults with or at high risk of delirium because of the potential of inducing or worsening delirium. Antipsychotics: avoid for behavioral problems of dementia or delirium unless nonpharmacologic options (eg, behavioral interventions) have failed or are not possible and the older adult is threatening substantial harm to self or others. If used, periodic deprescribing attempts should be considered to assess ongoing need and/or the lowest effective dose. Avoid, except in situations listed under the rationale statement. H2-receptor antagonists: Low All others: Moderate Strong Last Updated 11/02/2023 J Am Geriatr Soc.2023;71:2052-2081. DOI: 10.1111/jgs.18372\nThe Beers 2023 delirium category lists anticholinergics, antipsychotics, benzodiazepines, and oral or parenteral corticosteroids as drugs to avoid, matching the classes named in the statement. For corticosteroids it advises using the lowest possible dose and monitoring for delirium.",
   "evidence": "Full text, p. 12",
   "status": "fulltext",
   "pageNum": "12",
   "citations": [
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
    "Wibrow B, Martinez FE, Myers E, et al. Prophylactic melatonin for delirium in intensive care (Pro-MEDIC): an RCT. Intensive Care Med. 2022;48(4):414-425.",
    "Tang BHY, Manalo J, Chowdhury SR, et al. Melatonin use in the ICU: a systematic review and meta-analysis. Crit Care Med. 2025;53(9):e1714-e1724. (32 RCTs, n=3895; may reduce delirium RR 0.72 and improve sleep — low certainty; slight reduction in adverse events.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://pubmed.ncbi.nlm.nih.gov/37139824/",
    "https://doi.org/10.1007/s00134-022-06638-9",
    "https://doi.org/10.1097/CCM.0000000000006767"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "partial",
     "note": "ICU-setting guideline: strongly supports the benzodiazepine portion of the claim (modifiable risk factor; prefer propofol/dexmedetomidine) but is silent on anticholinergics and steroids.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Benzodiazepine use and blood transfusion administration are the only two modifiable factors with strong evidence for an association with delirium detected by screening tools (Supplemental Table 22, Supplemental Digital Content 30, http://links.lww. com/CCM/D788). The nonmodifiable risk factors with strong evidence for an association with delirium include increasing age, dementia, prior coma, pre-ICU emergency surgery or trauma, and increasing APACHE and ASA scores. Sex, opioid use, and mechanical ventilation each have been strongly shown not to alter the risk of delirium occurrence. Moderate evidence exists showing the following increase the risk for delirium: history of hypertension; admission because of a neurologic disease; trauma; and the use of psychoactive medication (e.g., antipsychotics, anticonvulsants). A history of respiratory disease, medical admission, nicotine use, dialysis or continuous venovenous hemofiltration, and a lower Glasgow Coma Scale score have each been moderately shown not to increase the risk for delirium. See the \"Sedation section\" for a review on how sedative choice may affect delirium and the \"Sleep section\" regarding the relationship between sleep and delirium. For all other potential delirium-associated risk factors, evidence currently remains inconclusive.",
       "highlight": "Benzodiazepine use and blood transfusion administration are the only two modifiable factors with strong evidence for an association with delirium",
       "scope": "on-scope",
       "note": "Identifies benzodiazepine use as the key modifiable drug-related risk factor for ICU delirium, supporting the claim's benzodiazepine element, but it does not name anticholinergics or steroids.",
       "page": "e842",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence).",
       "highlight": "using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults",
       "scope": "on-scope",
       "note": "Recommends non-benzodiazepine sedation, i.e. reducing benzodiazepine exposure, which operationalizes the claim's reduce-deliriogenic-drug action for benzodiazepines.",
       "page": "e839",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "background",
     "note": "Focused update (adds Anxiety) that did not re-address the deliriogenic-medication-review question; retains the 2018 non-benzodiazepine sedation stance and adds a chronic-benzodiazepine caveat.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence)",
       "highlight": "using either propofol or dexmedetomidine over benzodiazepines for sedation",
       "scope": "background",
       "note": "The focused update lists the retained 2018 non-benzodiazepine sedation recommendation; it did not re-address deliriogenic-medication review, so that position remains the current guidance.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Of note, abrupt cessation of benzodiazepines prescribed for baseline chronic anxiety may precipitate acute withdrawal; hence, continuation of the chronic benzodiazepines upon admission to the ICU should be considered.",
       "highlight": "continuation of the chronic benzodiazepines upon admission to the ICU should be considered",
       "scope": "different-population",
       "note": "Caveat about patients on chronic benzodiazepines for baseline anxiety, warning against abrupt cessation, a nuance the blanket instruction to reduce benzodiazepines must not override.",
       "page": "ms. p.5",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "Beers 2023",
     "cite": "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary anchor and the governing on-scope source for the specific drug triad (benzodiazepines, anticholinergics, corticosteroids); framed for older adults rather than ICU-only.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/",
     "paragraphs": [
      {
       "context": "Avoid in older adults with or at high risk of delirium because of the potential of inducing or worsening delirium.",
       "highlight": "Avoid in older adults with or at high risk of delirium because of the potential of inducing or worsening delirium.",
       "scope": "on-scope",
       "note": "The 2023 Beers Delirium criterion, whose drug list includes benzodiazepines, anticholinergics, and corticosteroids, recommends avoiding these classes in older adults with or at high risk of delirium, supporting the daily review to stop or reduce deliriogenic drugs.",
       "page": "2066",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      },
      {
       "context": "Corticosteroids: if needed, use the lowest possible dose for the shortest duration and monitor for delirium.",
       "highlight": "use the lowest possible dose for the shortest duration and monitor for delirium",
       "scope": "on-scope",
       "note": "Supports reducing/minimizing steroids where possible and monitoring for delirium, backing the 'steroids' element of the claim.",
       "page": "2066",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      },
      {
       "context": "Cumulative exposure to anticholinergic drugs is associated with an increased risk of falls, delirium, and dementia, even in younger adults. Consider total anticholinergic burden during regular medication reviews and be cautious in \"young-old\" as well as \"old-old\" adults.",
       "highlight": "Consider total anticholinergic burden during regular medication reviews",
       "scope": "on-scope",
       "note": "Directly endorses the daily medication-review action and reducing anticholinergic burden to lower delirium risk.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      }
     ]
    },
    {
     "label": "Pro-MEDIC 2022",
     "cite": "Wibrow B, Martinez FE, Myers E, et al. Prophylactic melatonin for delirium in intensive care (Pro-MEDIC): an RCT. Intensive Care Med. 2022;48(4):414-425.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Nearest-topic but different intervention (prophylactic melatonin); says nothing about reviewing/reducing benzodiazepines, anticholinergics, or steroids.",
     "docUrl": "https://doi.org/10.1007/s00134-022-06638-9",
     "paragraphs": [
      {
       "context": "Rationale: Delirium is defined as acute organic brain dysfunction characterised by inattention and disturbance of cognition. It is common in the intensive care unit and is associated with poorer outcomes. Good quality sleep is important in the prevention and management of delirium. Melatonin is a natural hormone secreted by the pineal gland which helps in the regulation of the sleep-wake cycle. It is possible that melatonin supplementation in intensive care improves sleep and prevents delirium. Methods and design: The `Prophylactic Melatonin for Delirium in Intensive Care' study is a multi-centre, randomised, double-blinded, placebo-controlled trial. The primary objective of this study is to determine whether melatonin given prophylactically decreases delirium in critically ill patients. A total of 850 ICU patients have been randomised (1:1) to receive either melatonin or a placebo. Participants were monitored twice daily for symptoms of delirium.",
       "highlight": "melatonin given prophylactically decreases delirium in critically ill patients",
       "scope": "different-intervention",
       "note": "Quoted from the trial's published statistical analysis plan (Wibrow B, et al. Trials. 2021;22:7), which is the Pro-MEDIC document held here; the main trial report is not archived. It states the trial's subject, which is melatonin for delirium prevention rather than the medication review this item asks for.",
       "page": "Analysis plan, p. 1",
       "docUrl": "https://doi.org/10.1186/s13063-020-04981-0"
      }
     ]
    },
    {
     "label": "Melatonin ICU meta-analysis 2025",
     "cite": "Tang BHY, Manalo J, Chowdhury SR, et al. Melatonin use in the ICU: a systematic review and meta-analysis. Crit Care Med. 2025;53(9):e1714-e1724. (32 RCTs, n=3895; may reduce delirium RR 0.72 and improve sleep — low certainty; slight reduction in adverse events.)",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited by section/DOI (Crit Care Med 2025;53(9):e1714-e1724) as ICU melatonin evidence; a different pharmacologic-prevention intervention (adding melatonin) rather than deprescribing deliriogenic drugs, and no archived text is available to quote.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006767",
     "paragraphs": []
    }
   ],
   "synthesis": "Beers 2023 is the governing on-scope source and directly backs the claim's specific triad, naming benzodiazepines, anticholinergics, and corticosteroids (oral and parenteral) as delirium-precipitating drugs to avoid or minimize during medication review, while PADIS 2018 corroborates the benzodiazepine element for the ICU (a modifiable delirium risk factor; prefer propofol/dexmedetomidine) but does not address anticholinergics or steroids. The 2025 PADIS focused update did not re-address deliriogenic-medication review, so these positions remain the current guidance (with a caveat not to abruptly stop chronic benzodiazepines), whereas the two melatonin sources describe a different prevention intervention and do not support the deprescribing action.",
   "discrepancy": true
  },
  {
   "id": "spa-r10",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Pain / Pharmacy",
   "statement": "Treat pain before sedation: Uncontrolled pain drives agitation — assess and treat pain first.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2018",
    "PADIS 2025",
    "Beers 2023",
    "Pro-MEDIC 2022",
    "Melatonin ICU meta-analysis 2025"
   ],
   "anchor": "PADIS 2018 — p. 14",
   "passage": "… Whether music's coanalgesic effect depends on patient's musical preferences should be considered. Interventions to reduce procedural pain should be evaluated during procedures other than CTR. Implementation studies documenting the feasibility and associated costs related to the use of these interventions are also needed. Studies to determine the effect of relaxation techniques on other outcomes such as sleep are also required. Protocol-Based Pain Assessment and Management Question: Should a protocol-based (analgesia/analgosedation) pain assessment and management program be used in the care of critically ill adults when compared with usual care? Good Practice Statement: Management of pain for adult ICU patients should be guided by routine pain assessment and pain should be treated before a sedative agent is considered. Recommendation: We suggest using an assessment-driven, protocol-based, stepwise approach for pain and sedation management in critically ill adults (conditional recommendation, moderate quality of evidence). Remarks: For this recommendation, analgosedation is defined as either analgesia-first sedation (i.e., an analgesic [usually an opioid] is used before a sedative to reach the sedative goal) or analgesia-based sedation (i.e., an analgesic [usually an opioid] is used instead of a sedative to reach the sedative goal). …\n'Uncontrolled pain drives agitation' is the printed rationale rather than a phrase from the source.",
   "evidence": "Full text, p. 14",
   "status": "fulltext",
   "pageNum": "14",
   "citations": [
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
    "Wibrow B, Martinez FE, Myers E, et al. Prophylactic melatonin for delirium in intensive care (Pro-MEDIC): an RCT. Intensive Care Med. 2022;48(4):414-425.",
    "Tang BHY, Manalo J, Chowdhury SR, et al. Melatonin use in the ICU: a systematic review and meta-analysis. Crit Care Med. 2025;53(9):e1714-e1724. (32 RCTs, n=3895; may reduce delirium RR 0.72 and improve sleep — low certainty; slight reduction in adverse events.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://pubmed.ncbi.nlm.nih.gov/37139824/",
    "https://doi.org/10.1007/s00134-022-06638-9",
    "https://doi.org/10.1097/CCM.0000000000006767"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governing source: the analgesia-first / protocol-based pain-and-sedation recommendation on pages e833-e837 directly supports treating pain before sedation.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Good Practice Statement: Management of pain for adult ICU patients should be guided by routine pain assessment and pain should be treated before a sedative agent is considered.",
       "highlight": "pain should be treated before a sedative agent is considered",
       "scope": "on-scope",
       "note": "Good practice statement directly instructs that ICU pain be treated before a sedative is considered — the core of 'treat pain before sedation.'",
       "page": "e837",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Remarks: For this recommendation, analgosedation is defined as either analgesia-first sedation (i.e., an analgesic [usually an opioid] is used before a sedative to reach the sedative goal) or analgesia-based sedation (i.e., an analgesic [usually an opioid] is used instead of a sedative to reach the sedative goal). The implementation of this recommendation infers that institutions should have an assessment-driven protocol that mandates regular pain and sedation assessment using validated tools, provides clear guidance on medication choice and dosing, and makes treating pain a priority over providing sedatives.",
       "highlight": "makes treating pain a priority over providing sedatives",
       "scope": "on-scope",
       "note": "The analgosedation recommendation's implementation remark makes treating pain the explicit priority over sedatives.",
       "page": "e837",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Summary of Pharmacologic Adjuvants to Opioid Therapy. The panel generally supports the utilization of multimodal pharmacotherapy as a component of an analgesia-first approach to spare and/or minimize both opioids and sedatives. A multimodal analgesia strategy is likely to improve pain control, reduce opioid consumption, and improve patientcentered outcomes. In patients for whom the risk of these nonopioid-adjunctive medications favors their exclusion, the several nonpharmacologic strategies (described below) provide an opportunity to minimize opioid consumption.",
       "highlight": "an analgesia-first approach to spare and/or minimize both opioids and sedatives",
       "scope": "on-scope",
       "note": "States the analgesia-first principle (analgesia used before/instead of a sedative) that underlies treating pain first.",
       "page": "e833",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Patients did not commonly receive opioids; some of the agitation may have been pain related; and the number of patients enrolled with acute alcohol withdrawal was not reported.",
       "highlight": "some of the agitation may have been pain related",
       "scope": "narrower",
       "note": "Only oblique support for the 'pain drives agitation' rationale — it is commentary on a single dexmedetomidine RCT, not a general guideline finding.",
       "page": "e847",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Focused update re-addressed sedation (dexmedetomidine vs propofol), delirium antipsychotics, immobility, sleep/melatonin and the new anxiety domain; it did not re-address the 2018 analgesia-first / pain-before-sedation good practice statement, which remains the current position.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "analgesia-first approach or to supplement analgesiasedation needs to be better studied. Studies evaluating the value of patient communication with family members during ICU care and the perceptions of patients while on propofol vs. dexmedetomidine (may include patients who can participate in their own care). The role of dexmedetomidine in patients who require treatment with deep sedation. RCTs definitively addressing a possible heterogeneity of dexmedetomidine treatment effect by age (over or under 65 yr old).",
       "highlight": "analgesia-first approach or to supplement analgesiasedation needs to be better studied",
       "scope": "background",
       "note": "Mentions the analgesia-first approach only as a carried-over research need within the dexmedetomidine section; not a re-addressal of the pain-before-sedation question.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "Beers 2023",
     "cite": "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Addresses potentially inappropriate medications in older adults (benzodiazepines, Z-drugs, meperidine); cited on the Pharmacy card for deliriogenic-drug avoidance, not for the pain-before-sedation principle — contains no passage on sequencing pain treatment before sedation.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/",
     "paragraphs": []
    },
    {
     "label": "Pro-MEDIC 2022",
     "cite": "Wibrow B, Martinez FE, Myers E, et al. Prophylactic melatonin for delirium in intensive care (Pro-MEDIC): an RCT. Intensive Care Med. 2022;48(4):414-425.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "A prophylactic-melatonin RCT statistical-analysis plan that records antipsychotic/sedation use only as a binary outcome; it does not address treating pain before sedation.",
     "docUrl": "https://doi.org/10.1007/s00134-022-06638-9",
     "paragraphs": []
    },
    {
     "label": "Melatonin ICU meta-analysis 2025",
     "cite": "Tang BHY, Manalo J, Chowdhury SR, et al. Melatonin use in the ICU: a systematic review and meta-analysis. Crit Care Med. 2025;53(9):e1714-e1724. (32 RCTs, n=3895; may reduce delirium RR 0.72 and improve sleep — low certainty; slight reduction in adverse events.)",
     "kind": "unarchived",
     "stance": "background",
     "note": "Unarchived (no text file); cited on the Pharmacy card for melatonin delirium/sleep evidence (Crit Care Med 2025;53(9):e1714-e1724), not for the pain-before-sedation statement.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006767",
     "paragraphs": []
    }
   ],
   "synthesis": "PADIS 2018 directly and cleanly supports the actionable directive: its good practice statement holds that ICU pain \"should be treated before a sedative agent is considered,\" and the analgosedation recommendation makes \"treating pain a priority over providing sedatives\" (the analgesia-first principle) — while the rationale clause \"uncontrolled pain drives agitation\" is not a stated general guideline finding (PADIS only notes agitation \"may have been pain related\" in commentary on one dexmedetomidine trial), so that clause is background rationale rather than a cited conclusion. The 2025 focused update did not re-address the analgesia-first / pain-before-sedation question, so the 2018 statement remains the current position; Beers 2023, Pro-MEDIC 2022, and the 2025 melatonin meta-analysis are cited for other Pain/Pharmacy-card content and are silent on treating pain before sedation.",
   "discrepancy": true
  },
  {
   "id": "spa-r11",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Pain / Pharmacy",
   "statement": "Avoid meperidine: Higher neurotoxicity/delirium risk than other opioids (Beers) — avoid in at-risk patients.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2018",
    "PADIS 2025",
    "Beers 2023",
    "Pro-MEDIC 2022",
    "Melatonin ICU meta-analysis 2025"
   ],
   "anchor": "Beers 2023 — p. 10",
   "passage": "2023 American Geriatrics Society Beers Criteria ● Oxaprozin ● Piroxicam ● Sulindac take a gastroprotective agent. Indomethacin Ketorolac (oral and parenteral) Increased risk of GI bleeding/peptic ulcer disease and acute kidney injury in older adults. Of all the NSAIDs, indomethacin has the most adverse effects, including a higher risk of adverse CNS effects. Avoid Moderate Strong Meperidine Oral analgesic not effective in dosages commonly used; may have a higher risk of neurotoxicity, including delirium, than other opioids; safer alternatives available. Avoid Moderate Strong Skeletal muscle relaxants ● Carisoprodol ● Chlorzoxazone ● Cyclobenzaprine ● Metaxalone ● Methocarbamol ● Orphenadrine Muscle relaxants typically used to treat musculoskeletal complaints are poorly tolerated by older adults due to anticholinergic adverse effects, sedation, and increased risk of fractures; effectiveness at dosages tolerated by older adults is questionable. This criterion does not apply to skeletal muscle relaxants typically used for the management of spasticity (i.e., baclofen and tizanidine) although these drugs can also cause substantial adverse effects Avoid Moderate Strong Last Updated 11/02/2023 J Am Geriatr Soc.2023;71:2052-2081. …\nThe Beers 2023 meperidine entry carries the recommendation 'Avoid.'",
   "evidence": "Full text, p. 10",
   "status": "fulltext",
   "pageNum": "10",
   "citations": [
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
    "Wibrow B, Martinez FE, Myers E, et al. Prophylactic melatonin for delirium in intensive care (Pro-MEDIC): an RCT. Intensive Care Med. 2022;48(4):414-425.",
    "Tang BHY, Manalo J, Chowdhury SR, et al. Melatonin use in the ICU: a systematic review and meta-analysis. Crit Care Med. 2025;53(9):e1714-e1724. (32 RCTs, n=3895; may reduce delirium RR 0.72 and improve sleep — low certainty; slight reduction in adverse events.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://pubmed.ncbi.nlm.nih.gov/37139824/",
    "https://doi.org/10.1007/s00134-022-06638-9",
    "https://doi.org/10.1097/CCM.0000000000006767"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beers 2023",
     "cite": "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Directly supports the claim: meperidine is listed among opioids to avoid because it may carry higher neurotoxicity/delirium risk than other opioids; the delirium drug-disease criterion (opioids added in 2023) covers the 'avoid in at-risk patients' clause.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/",
     "paragraphs": [
      {
       "context": "Oral analgesic not effective in dosages commonly used; may have a higher risk of neurotoxicity, including delirium, than other opioids; safer alternatives available.",
       "highlight": "may have a higher risk of neurotoxicity, including delirium, than other opioids",
       "scope": "on-scope",
       "note": "Table 2 rationale for the 'Avoid' recommendation on meperidine — states verbatim that it may have higher neurotoxicity/delirium risk than other opioids, with safer alternatives available.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      },
      {
       "context": "Specific mention of meperidine was removed from this criterion because it is subsumed under the general category of opioids, which was added to this criterion.",
       "highlight": "subsumed under the general category of opioids, which was added to this criterion",
       "scope": "background",
       "note": "Documents that in the 2023 update meperidine is now covered by the opioid entry added to the delirium drug-disease criterion, which advises avoiding in older adults with or at high risk of delirium — supports the 'avoid in at-risk patients' clause.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Does not mention meperidine (or pethidine); its nearest content evaluates opioids as a class as an ICU delirium risk factor, a different question from meperidine's relative neurotoxicity in older adults.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Benzodiazepine use and blood transfusion administration are the only two modifiable factors with strong evidence for an association with delirium detected by screening tools (Supplemental Table 22, Supplemental Digital Content 30, http://links.lww. com/CCM/D788). The nonmodifiable risk factors with strong evidence for an association with delirium include increasing age, dementia, prior coma, pre-ICU emergency surgery or trauma, and increasing APACHE and ASA scores. Sex, opioid use, and mechanical ventilation each have been strongly shown not to alter the risk of delirium occurrence. Moderate evidence exists showing the following increase the risk for delirium: history of hypertension; admission because of a neurologic disease; trauma; and the use of psychoactive medication (e.g., antipsychotics, anticonvulsants). A history of respiratory disease, medical admission, nicotine use, dialysis or continuous venovenous hemofiltration, and a lower Glasgow Coma Scale score have each been moderately shown not to increase the risk for delirium. See the \"Sedation section\" for a review on how sedative choice may affect delirium and the \"Sleep section\" regarding the relationship between sleep and delirium. For all other potential delirium-associated risk factors, evidence currently remains inconclusive.",
       "highlight": "Sex, opioid use, and mechanical ventilation each have been strongly shown not to alter the risk of delirium occurrence",
       "scope": "different-intervention",
       "note": "Nearest match on the opioid-delirium topic, but the exposure studied is the opioid class as a whole in critically ill adults — not meperidine versus other opioids — so it neither supports nor contradicts the Beers meperidine-specific claim.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Focused update adding Anxiety; contains no mention of opioids or meperidine and does not re-address the opioid/meperidine neurotoxicity question, so the PADIS 2018 position remains the current guideline stance on it.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": []
    },
    {
     "label": "Pro-MEDIC 2022",
     "cite": "Wibrow B, Martinez FE, Myers E, et al. Prophylactic melatonin for delirium in intensive care (Pro-MEDIC): an RCT. Intensive Care Med. 2022;48(4):414-425.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Statistical analysis plan for a prophylactic-melatonin delirium RCT; does not address meperidine, opioids, or opioid neurotoxicity — off-topic for this claim.",
     "docUrl": "https://doi.org/10.1007/s00134-022-06638-9",
     "paragraphs": []
    },
    {
     "label": "Melatonin ICU meta-analysis 2025",
     "cite": "Tang BHY, Manalo J, Chowdhury SR, et al. Melatonin use in the ICU: a systematic review and meta-analysis. Crit Care Med. 2025;53(9):e1714-e1724. (32 RCTs, n=3895; may reduce delirium RR 0.72 and improve sleep — low certainty; slight reduction in adverse events.)",
     "kind": "unarchived",
     "stance": "background",
     "note": "Melatonin-in-ICU systematic review/meta-analysis, cited by section/DOI; unrelated to meperidine or opioid neurotoxicity and not archived for passage-level checking.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006767",
     "paragraphs": []
    }
   ],
   "synthesis": "Beers 2023 is the governing on-scope source and directly supports the claim, listing meperidine among opioids to avoid because it \"may have a higher risk of neurotoxicity, including delirium, than other opioids,\" with the opioid class now folded into its delirium drug-disease criterion (avoid in older adults with or at high risk of delirium). PADIS 2018's nearest content — that opioid use as a class is strongly shown not to alter ICU delirium risk — is a different-scope question (a whole-class ICU risk-factor analysis, not one drug's relative neurotoxicity in older adults) and does not contradict Beers; PADIS 2025 does not re-address it, so PADIS 2018 remains the current position, while Pro-MEDIC and the melatonin meta-analysis are melatonin studies unrelated to meperidine.",
   "discrepancy": true
  },
  {
   "id": "spa-r12",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Pain / Pharmacy",
   "statement": "Melatonin — consider for prevention: PADIS 2025 conditionally suggests melatonin to reduce delirium (low-certainty evidence); dose per local practice.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2018",
    "PADIS 2025",
    "Beers 2023",
    "Pro-MEDIC 2022",
    "Melatonin ICU meta-analysis 2025"
   ],
   "anchor": "PADIS 2025 — p. 7",
   "passage": "… ation for or against the use of antipsychotics over usual care for the treat ment of delirium in adult patients admitted to the ICU Conditional recommenda tion; for intervention or comparison; low certainty We suggest not routinely using haloperidol or an atyp ical antipsychotic, to treat delirium (conditional recom mendation, low quality of evidence) 4 We suggest providing enhanced mobilization/rehabilita tion over usual care mobilization/rehabilitation to adult patients admitted to the ICU Conditional recommen dation; for intervention; moderate certainty We suggest performing rehabilitation or mobilization in critically ill adults (conditional recommendation, low quality evidence) 5 We suggest administering melatonin over no melatonin in adult patients admitted to the ICU Conditional recommendation; for intervention; low certainty We make no recommendation regarding the use of melatonin to improve sleep in critically ill adults (no recommendation, very low quality of evidence)\nPADIS 2025 Recommendation 5; the rationale states melatonin 'may reduce the prevalence of delirium (RR, 0.70; 95% CI, 0.57-0.87; low certainty).' The guideline specifies no dose, consistent with 'per local practice.'",
   "evidence": "Full text, p. 7",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
    "Wibrow B, Martinez FE, Myers E, et al. Prophylactic melatonin for delirium in intensive care (Pro-MEDIC): an RCT. Intensive Care Med. 2022;48(4):414-425.",
    "Tang BHY, Manalo J, Chowdhury SR, et al. Melatonin use in the ICU: a systematic review and meta-analysis. Crit Care Med. 2025;53(9):e1714-e1724. (32 RCTs, n=3895; may reduce delirium RR 0.72 and improve sleep — low certainty; slight reduction in adverse events.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://pubmed.ncbi.nlm.nih.gov/37139824/",
    "https://doi.org/10.1007/s00134-022-06638-9",
    "https://doi.org/10.1097/CCM.0000000000006767"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "background",
     "note": "The 2018 guideline evaluated melatonin only for improving sleep and issued no recommendation (now superseded by the 2025 update); its delirium-reduction signal is for ramelteon, a different drug.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "If patients (or their families) request it, it should be considered. the use of melatonin to improve sleep in critically ill adults (no recommendation, very low quality of evidence).",
       "highlight": "the use of melatonin to improve sleep in critically ill adults (no recommendation, very low quality of evidence)",
       "scope": "background",
       "note": "2018 PADIS assessed melatonin only for the sleep question and made no recommendation; this prior position is superseded by the 2025 update and is not a melatonin-for-delirium-prevention recommendation.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Ramelteon, an FDA-approved melatonin receptor agonist, was evaluated in a single study (not included in this analysis) to prevent delirium in the elderly (520). A small number of patients in that study were critically ill; however, there was no demonstrable improvement in subjective sleep quality. Similar to melatonin, few adverse events are reported with the medication, but sleep promotion was not proven and the cost is higher than that of melatonin. One recent single-center, double-blind, placebo-controlled RCT, also not included in this analysis, found that the administration of 8mg of ramelteon at 20:00 hours each day to critically ill adults without delirium was associated with significant reduction in delirium occurrence (521).",
       "highlight": "the administration of 8mg of ramelteon at 20:00 hours each day to critically ill adults without delirium was associated with significant reduction in delirium occurrence",
       "scope": "different-intervention",
       "note": "Nearest keyword match on reduced delirium, but this is ramelteon (a melatonin receptor agonist), not melatonin, and was explicitly not included in the analysis.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary on-scope source: conditionally recommends melatonin for adult ICU patients (low certainty), grounded in reduced delirium prevalence, and declines a specific dose because of trial heterogeneity.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "We suggest administering melatonin over no melatonin in adult patients admitted to the ICU",
       "highlight": "We suggest administering melatonin over no melatonin in adult patients admitted to the ICU",
       "scope": "on-scope",
       "note": "Recommendation 5 - the conditional (for intervention; low certainty) recommendation to administer melatonin, directly supporting the claim; the certainty parenthetical is split across a column break so the clean clause is used.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Melatonin may reduce the prevalence of delirium (RR, 0.70; 95% CI, 0.57-0.87; low certainty), although melatonin made little to no difference in delirium duration (MD, -0.16 d; 95% CI, -1.0 to 0.68 d; low certainty). Melatonin may increase patients' perceived sleep quality (low certainty) but showed little to no difference in total nocturnal sleep duration (MD, 0.04hr; 95% CI, -0.18 to 0.26hr; moderate certainty). Use of melatonin may slightly reduce the ICU length of stay (MD, -0.5 d; 95% CI, -0.89 to -0.1 d; low certainty) but has little to no difference in duration of mechanical ventilation or hospital length of stay (both low certainty). Evidence was uncertain related to the number of awakenings, anxiety, the proportion of patients with agitation, post-ICU cognitive function, and posttraumatic stress disorder (all very low certainty), as well as ICU mortality and functional status post-ICU (both low certainty). There may be a slight reduction in adverse events (as defined by study authors) when melatonin is administered compared with no melatonin (low certainty).",
       "highlight": "Melatonin may reduce the prevalence of delirium (RR, 0.70; 95% CI, 0.57-0.87; low certainty)",
       "scope": "on-scope",
       "note": "Pooled evidence summary: melatonin may reduce delirium prevalence, low certainty — the basis for the recommendation.",
       "page": "ms. p.10",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "RESULTS: The task force issued five statements related to the management of anxiety, agitation/sedation, delirium, immobility, and sleep disruption in adults admitted to the ICU. In adult patients admitted to the ICU, the task force issued conditional recommendations to use dexmedetomidine over propofol for sedation, provide enhanced mobilization/rehabilitation over usual mobilization/rehabilitation, and administer melatonin. The task force was unable to issue recommendations on the administration of benzodiazepines to treat anxiety, and the use of antipsychotics to treat delirium.",
       "highlight": "the task force issued conditional recommendations to use dexmedetomidine over propofol for sedation, provide enhanced mobilization/rehabilitation over usual mobilization/rehabilitation, and administer melatonin",
       "scope": "on-scope",
       "note": "Abstract confirms the melatonin recommendation is conditional.",
       "page": "e711",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Melatonin is commonly used in practice to mitigate the adverse effects of sleep and circadian disruption in critically ill adults (157). Endogenous melatonin suppression and circadian disturbances have been found in critically ill patients (158), which provides a rationale for replacement therapy. The conditional recommendation favoring melatonin is based on the reduction of delirium prevalence and perceived improvement in sleep quality balanced against the low risk of adverse events. These data have limitations which is why a strong recommendation was not provided. Sleep/circadian outcomes were not assessed in many included RCTs. Most RCTs that included sleep as an outcome used subjective measurement tools, which Special Considerations Melatonin is not U.S.",
       "highlight": "The conditional recommendation favoring melatonin is based on the reduction of delirium prevalence and perceived improvement in sleep quality balanced against the low risk of adverse events",
       "scope": "on-scope",
       "note": "States the rationale — reduced delirium prevalence and perceived sleep improvement weighed against low adverse-event risk.",
       "page": "ms. p.10",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Melatonin is not U.S. Food and Drug Administration (FDA)-regulated so quality may vary. Ramelteon, an FDA-approved melatonin receptor agonist, could be considered a melatonin alternative in countries where it is available. There was significant heterogeneity of included trials in terms of dose, duration, and frequency of melatonin which limits specific recommendations for administration. Furthermore, cost may vary by country.",
       "highlight": "There was significant heterogeneity of included trials in terms of dose, duration, and frequency of melatonin which limits specific recommendations for administration",
       "scope": "on-scope",
       "note": "Supports 'dose per local practice' — the guideline declined a specific dose because of trial heterogeneity.",
       "page": "ms. p.10",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "Beers 2023",
     "cite": "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Beers 2023 lists potentially inappropriate medications for older adults (anticholinergic first-generation antihistamines and Z-drug hypnotics flagged for delirium/fall risk) but contains no mention of melatonin; it informs the card's deliriogenic-medication context, not this melatonin recommendation.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/",
     "paragraphs": []
    },
    {
     "label": "Pro-MEDIC 2022",
     "cite": "Wibrow B, Martinez FE, Myers E, et al. Prophylactic melatonin for delirium in intensive care (Pro-MEDIC): an RCT. Intensive Care Med. 2022;48(4):414-425.",
     "kind": "pdf",
     "stance": "background",
     "note": "Pro-MEDIC statistical analysis plan — establishes the prophylactic-melatonin-for-ICU-delirium design and a 4 mg nightly dose, but this document is the pre-results SAP and does not report the trial's efficacy outcome.",
     "docUrl": "https://doi.org/10.1007/s00134-022-06638-9",
     "paragraphs": [
      {
       "context": "Study methods This is a multi-centre, randomised, double-blinded, placebo-controlled trial of melatonin versus placebo to decrease the rate of delirium in ICU. A total of 850 ICU patients have been randomised on a 1:1 ratio to receive either melatonin or a placebo. Study participants were administered an oral dose of melatonin 4 mg enterally or placebo once daily at 21:00hs. for up to 14 days or until discharge from the ICU. Participants were monitored twice daily for symptoms of delirium. Additionally, data is being collected on the duration and severity of delirium, sleep quality, hospital and ICU length of stay (LOS), duration of mechanical ventilation, and mortality.",
       "highlight": "an oral dose of melatonin 4 mg enterally or placebo once daily at 21:00hs. for up to 14 days",
       "scope": "on-scope",
       "note": "Provides a concrete example dose (melatonin 4 mg enterally nightly) relevant to 'dose per local practice'; this is the SAP's planned regimen, not an efficacy result.",
       "page": "",
       "docUrl": "https://doi.org/10.1007/s00134-022-06638-9"
      },
      {
       "context": "Rationale: Delirium is defined as acute organic brain dysfunction characterised by inattention and disturbance of cognition. It is common in the intensive care unit and is associated with poorer outcomes. Good quality sleep is important in the prevention and management of delirium. Melatonin is a natural hormone secreted by the pineal gland which helps in the regulation of the sleep-wake cycle. It is possible that melatonin supplementation in intensive care improves sleep and prevents delirium. Methods and design: The `Prophylactic Melatonin for Delirium in Intensive Care' study is a multi-centre, randomised, double-blinded, placebo-controlled trial. The primary objective of this study is to determine whether melatonin given prophylactically decreases delirium in critically ill patients. A total of 850 ICU patients have been randomised (1:1) to receive either melatonin or a placebo. Participants were monitored twice daily for symptoms of delirium.",
       "highlight": "The primary objective of this study is to determine whether melatonin given prophylactically decreases delirium in critically ill patients",
       "scope": "background",
       "note": "Same population/setting/intervention (prophylactic melatonin to prevent ICU delirium), but this file states the trial's hypothesis and design, not a result.",
       "page": "",
       "docUrl": "https://doi.org/10.1007/s00134-022-06638-9"
      }
     ]
    },
    {
     "label": "Melatonin ICU meta-analysis 2025",
     "cite": "Tang BHY, Manalo J, Chowdhury SR, et al. Melatonin use in the ICU: a systematic review and meta-analysis. Crit Care Med. 2025;53(9):e1714-e1724. (32 RCTs, n=3895; may reduce delirium RR 0.72 and improve sleep — low certainty; slight reduction in adverse events.)",
     "kind": "unarchived",
     "stance": "background",
     "note": "Unarchived; not text-verifiable here. Tang et al., Crit Care Med 2025;53(9):e1714-e1724 (32 RCTs, n=3895) is the SCCM systematic review underpinning the PADIS 2025 recommendation — pooled RR ~0.72 for delirium (low certainty), consistent with PADIS 2025's RR 0.70; cited by DOI/section.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006767",
     "paragraphs": []
    }
   ],
   "synthesis": "The on-scope primary source, PADIS 2025, directly supports the claim: it issues a conditional recommendation (for intervention; low certainty) to administer melatonin in adult ICU patients, grounded in a possible reduction in delirium prevalence (RR 0.70), and explicitly declines a specific dose because of trial heterogeneity — matching \"dose per local practice.\" The Pro-MEDIC statistical analysis plan and the Tang 2025 meta-analysis supply the underlying trial and pooled evidence (RR ~0.72, consistent with 0.70), while PADIS 2018 (which addressed melatonin only for sleep and made no recommendation — now superseded) and its ramelteon note are different-scope nearest matches, and Beers 2023 does not mention melatonin.",
   "discrepancy": true
  },
  {
   "id": "spa-r13",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Activity / Awareness",
   "statement": "Mobilize — remove barriers: Get the patient up; discontinue catheters, lines, and restraints when safe.",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Hodgson 2014",
    "Early Mobility",
    "Hshieh 2015",
    "Inouye 1999"
   ],
   "anchor": "Inouye 1999 — p. 3, ¶60",
   "passage": "…  for protocol assessed once daily Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures) Change in rate of use of sedative drug for sleep† Immobility All patients; ambulation whenever possible, and range-of-motion exercises when patients chronically non-ambulatory, bed or wheelchair bound, immobilized (e.g., because of an extremity fracture or deep venous thrombosis), or when prescribed bed rest Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints) Change in Activities of Daily Living score Visual impairment Patients with <20/70 visual acuity on binocular near-vision testing Vision protocol: visual aids (e.g., glasses or magnifying lenses) and adaptive equipment (e.g., large illuminated telephone keypads, large-print books, and fluorescent tape on call bell), with daily reinforcement of their use Early correction of vision, «48 hr after admission Hearing impairment Patients hearing «6 of 12 whispers on Whisper Test Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques, with daily reinforcement of these adaptations Change in Whisper Test score Dehydration Patients with ratio o …",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
    "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
    "https://doi.org/10.1001/jamainternmed.2014.7779",
    "https://doi.org/10.1056/NEJM199903043400901"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "partial",
     "note": "Archived SCCM ICU Liberation page (site nav stripped): names Early Mobility as bundle element E for all ICU patients, endorsing getting patients moving but not restating the specific barrier-removal actions.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "The ICU Liberation Bundle consists of the following individual elements A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs) C Element : Choice of Analgesia and Sedation D Element : Delirium: Assess, Prevent, and Manage E Element: Early Mobility and Exercise F Element : Family Engagement and Empowerment",
       "highlight": "E Element: Early Mobility and Exercise",
       "scope": "broader",
       "note": "Bundle-level endorsement of early mobility for every ICU patient; supports the mobilize concept but does not address discontinuing catheters, lines, or restraints.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Hodgson 2014",
     "cite": "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Expert-consensus safety criteria for active mobilization of mechanically ventilated ICU adults; supports the 'when safe' qualifier and treats lines/drains as considerations, but is a narrower ventilated population and does not recommend discontinuing catheters or restraints.",
     "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
     "paragraphs": [
      {
       "context": "The group decided that recommendations would be developed only for active mobilization and that no guidance would be provided with respect to safety criteria for passive mobilization. Active mobilization was defined as any activity where the patient assists with the activity using their own muscle strength and control: the patient may need assistance from staff or equipment, but they are actively participating in the exercise. Activities that comprise active mobilization are out-of-bed mobilization (that is, any activity where the patient sits over the edge of the bed (dangling), stands, walks, marches on the spot or sits out of bed) and in-bed mobilization (that is, any activity undertaken whilst the patient is sitting or lying in bed such as rolling, bridging, upper-limb weight training). The level of mobilization should be determined by the patient’s strength and endurance, as well as an assessment of the safety criteria.",
       "highlight": "out-of-bed mobilization (that is, any activity where the patient sits over the edge of the bed (dangling), stands, walks, marches on the spot or sits out of bed)",
       "scope": "narrower",
       "note": "Defines active/out-of-bed mobilization (supports 'get the patient up'), but scoped to mechanically ventilated ICU adults under a safety-criteria framework rather than a general barrier-removal action.",
       "page": "",
       "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y"
      },
      {
       "context": "The consensus for safe mobilization was provided for respiratory, cardiovascular, neurological and other considerations including lines and drains The group provided recommendations for active mobilization.",
       "highlight": "other considerations including lines and drains",
       "scope": "different-intervention",
       "note": "Frames lines/drains as safety considerations to assess before mobilizing (the 'when safe' angle), not as barriers to discontinue; nearest match on 'lines' but a safety-gating rather than removal framing.",
       "page": "",
       "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y"
      }
     ]
    },
    {
     "label": "Early Mobility",
     "cite": "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Archived Vanderbilt CIBS ICU early-mobility page (site nav stripped): supports getting the ICU patient up across the activity spectrum, but silent on discontinuing catheters, lines, or restraints.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
     "paragraphs": [
      {
       "context": "It consists of activities from passive range of motion to ambulation.",
       "highlight": "It consists of activities from passive range of motion to ambulation",
       "scope": "on-scope",
       "note": "ICU early-mobility progression from passive range of motion to ambulation directly supports 'get the patient up'; does not state the catheter/line/restraint removal specifics.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Meta-analysis of multicomponent nonpharmacological delirium prevention in hospitalized older persons (age 65+, not ICU); identifies early mobilization as one bundle component but does not specify the catheter/line/restraint barrier-removal actions.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations.",
       "highlight": "including reorientation, early mobilization, therapeutic activities",
       "scope": "broader",
       "note": "Lists early mobilization as one component of the HELP multicomponent intervention; component-level endorsement in hospitalized older persons rather than the specific barrier-removal action, and not ICU-specific.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "Few intervention strategies have proved effective for fall prevention in the hospital. Most fall interventions have focused on identifying fall risk and implementing various alarms that limit patient mobility. Although minimally effective for preventing falls, these approaches result in unintended consequences of decreased physical and cognitive functioning.34 Notably, 12 of 14 studies examined in this meta-analysis included exercise interventions designed to enhance mobility. The well-documented effectiveness of these strategies for fall prevention is worthy of special emphasis.",
       "highlight": "12 of 14 studies examined in this meta-analysis included exercise interventions designed to enhance mobility",
       "scope": "broader",
       "note": "Emphasizes enhancing mobility over mobility-limiting devices in the fall-prevention context; supports getting patients moving but does not name catheters, lines, or restraints.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary source (HELP): the early-mobilization protocol supplies the exact wording behind both halves of the card, though studied in hospitalized patients 70+ on a general-medicine service, not the ICU.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — immobility. Eligible patients: All patients; ambulation whenever possible, and range-of-motion exercises when patients chronically non-ambulatory, bed or wheelchair bound, immobilized (e.g., because of an extremity fracture or deep venous thrombosis), or when prescribed bed rest. Standardized intervention protocols: Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints). Targeted outcome for reassessment: Change in Activities of Daily Living score.",
       "highlight": "minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints)",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "Standardized intervention-protocol table rendered as run-together rows, truncated mid-entry ('special comm')."
      },
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — immobility. Eligible patients: All patients; ambulation whenever possible, and range-of-motion exercises when patients chronically non-ambulatory, bed or wheelchair bound, immobilized (e.g., because of an extremity fracture or deep venous thrombosis), or when prescribed bed rest. Standardized intervention protocols: Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints). Targeted outcome for reassessment: Change in Activities of Daily Living score.",
       "highlight": "ambulation whenever possible, and range-of-motion exercises when patients chronically non-ambulatory",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "Risk-factor/eligibility table with the two columns interleaved as running text; also carries replacement characters."
      }
     ]
    }
   ],
   "synthesis": "Inouye 1999 (HELP) is the primary source and governs: its early-mobilization protocol prescribes ambulation and \"minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints),\" matching the card's \"get the patient up\" and \"discontinue catheters... and restraints.\" The other sources agree at the level of endorsing early mobility (Hshieh's meta-analysis, SCCM's bundle element E, Vanderbilt's ICU page) without restating the specific barrier list, while the ICU-specific \"lines\" and the \"when safe\" qualifier trace to Hodgson 2014's mechanically-ventilated safety criteria — which frames lines/drains as considerations rather than items to discontinue; note that HELP and Hshieh studied hospitalized older medical patients, not the ICU.",
   "discrepancy": true
  },
  {
   "id": "spa-r14",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Activity / Awareness",
   "statement": "PT / OT consult early: Involve PT & OT at admission for at-risk ICU patients — earlier is better.",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Hodgson 2014",
    "Early Mobility",
    "Hshieh 2015",
    "Inouye 1999"
   ],
   "anchor": "Early Mobility: \"Early mobility can be performed by any part of the interdisciplinary team including nurses, physical therapists, occupational therapists, or physicians.\"",
   "passage": "The ICUDelirium page describes 'early exercise and mobilization (physical and occupational therapy) during periods of daily interruption of sedation,' supporting PT/OT involvement, but the consult-at-admission timing is not stated. Inouye 1999 and Hshieh 2015 support early mobilization generally without addressing PT/OT consult timing.",
   "evidence": "Web page — partial support",
   "status": "web",
   "pageNum": null,
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
    "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
    "https://doi.org/10.1001/jamainternmed.2014.7779",
    "https://doi.org/10.1056/NEJM199903043400901"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Early Mobility",
     "cite": "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope governing source: ICU early mobility performed by an interdisciplinary team that explicitly includes physical and occupational therapists, with ICU RCT evidence that earlier PT/OT mobilization improves delirium and functional outcomes.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
     "paragraphs": [
      {
       "context": "Early mobility can be performed by any part of the interdisciplinary team including nurses, physical therapists, occupational therapists, or physicians.",
       "highlight": "Early mobility can be performed by any part of the interdisciplinary team including nurses, physical therapists, occupational therapists, or physicians.",
       "scope": "on-scope",
       "note": "Directly names physical therapists and occupational therapists as part of the ICU early-mobility team (the claim's primary anchor).",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
      },
      {
       "context": "Early mobility is an integral part of the ABCDEF Bundle and has been the only intervention resulting in a decrease in days of delirium.",
       "highlight": "Early mobility is an integral part of the ABCDEF Bundle and has been the only intervention resulting in a decrease in days of delirium.",
       "scope": "on-scope",
       "note": "Establishes why early mobility (the PT/OT-delivered intervention) matters for at-risk ICU patients.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
      },
      {
       "context": "104 patients randomized to early exercise and mobilization (physical and occupational therapy) during periods of daily interruption of sedation or to daily interruption of sedation with therapy as ordered by the primary care team. Early mobility was safe and well tolerated, and resulted in better functional outcomes at hospital discharge, a shorter duration of delirium, and more ventilator-free days compared with standard care.",
       "highlight": "Early mobility was safe and well tolerated, and resulted in better functional outcomes at hospital discharge, a shorter duration of delirium, and more ventilator-free days compared with standard care.",
       "scope": "on-scope",
       "note": "Schweickert RCT summary: early physical and occupational therapy in ventilated ICU patients improved outcomes and shortened delirium (supports 'earlier is better').",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
      },
      {
       "context": "Used an intensive care unit Mobility Team (critical care nurse, nursing assistant, physical therapist) initiated the protocol within 48 hrs of mechanical ventilation.",
       "highlight": "initiated the protocol within 48 hrs of mechanical ventilation",
       "scope": "on-scope",
       "note": "Morris study summary: an ICU mobility team including a physical therapist started within 48 hours, supporting early PT involvement.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
      }
     ]
    },
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived SCCM web page (mostly site navigation); relevant content lists Early Mobility as bundle element E but does not address PT/OT consultation or timing. Contributes bundle context.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "The ICU Liberation Bundle consists of the following individual elements A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs) C Element : Choice of Analgesia and Sedation D Element : Delirium: Assess, Prevent, and Manage E Element: Early Mobility and Exercise F Element : Family Engagement and Empowerment",
       "highlight": "E Element: Early Mobility and Exercise",
       "scope": "background",
       "note": "Names Early Mobility and Exercise as the E element of the ICU Liberation Bundle, but says nothing about involving PT/OT early or at admission.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Hodgson 2014",
     "cite": "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Same ICU setting and supports the value of early mobilization with physiotherapy input, but the paper is scoped to safety criteria for mobilizing mechanically ventilated adults rather than the timing of PT/OT consultation, and does not address occupational therapy or admission-time consult.",
     "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
     "paragraphs": [
      {
       "context": "In the past, critically ill patients who were receiving mechanical ventilation were often managed with deep sedation and bed rest, at least during the early stages of their ICU admission. Despite long-standing evidence that prolonged bed rest results in deconditioning [ 1 , 2 ], studies investigating the effectiveness of early progressive mobilization for ICU patients have only started appearing in the literature in the last 10 to 15 years [ 3 , 4 ]. While the earlier publications documented the feasibility, safety and physiological effects associated with the mobilization of ICU patients [ 5 - 8 ], point-prevalence studies [ 9 , 10 ] and controlled trials investigating the effectiveness of early progressive mobilization have been published in more recent years [ 11 - 16 ]. These studies, and concomitant systematic reviews [ 4 , 17 - 22 ], provide evidence that early progressive mobilization of adult ICU patients is feasible, safe, and may result in benefits including improved functional outcomes, and reduced ICU and hospital length of stay.",
       "highlight": "early progressive mobilization of adult ICU patients is feasible, safe, and may result in benefits including improved functional outcomes, and reduced ICU and hospital length of stay.",
       "scope": "broader",
       "note": "Supports the broad value of early mobilization in ICU, but this consensus paper's focus is mobilization safety, not PT/OT consult timing.",
       "page": "",
       "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y"
      },
      {
       "context": "The consensus group agreed that the recommendations were aimed at assisting in the assessment of adult, mechanically ventilated ICU patients to determine if and when mobilization could commence. A critical element that was adopted was that these criteria should be regarded as a guide and should always be used in conjunction with clinical reasoning. It was agreed that the input into the decision to mobilize should lie with all members of the multidisciplinary team (that is, physiotherapy, medical, nursing staff) with the treating clinician having ultimate responsibility for decision making.",
       "highlight": "the input into the decision to mobilize should lie with all members of the multidisciplinary team (that is, physiotherapy, medical, nursing staff)",
       "scope": "narrower",
       "note": "Physiotherapy is part of the mobilization decision team, but this is the narrower safety/decision process for ventilated patients and omits OT and consult-at-admission framing.",
       "page": "",
       "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y"
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest match on early mobilization as a delirium-prevention component, but a meta-analysis of multicomponent interventions in hospitalized (largely elderly) patients, not at-risk ICU patients, and does not single out PT/OT consultation.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations.",
       "scope": "different-setting",
       "note": "Early mobilization is one component of the multicomponent HELP program in hospitalized elderly, not an ICU PT/OT consult.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "Few intervention strategies have proved effective for fall prevention in the hospital. Most fall interventions have focused on identifying fall risk and implementing various alarms that limit patient mobility. Although minimally effective for preventing falls, these approaches result in unintended consequences of decreased physical and cognitive functioning.34 Notably, 12 of 14 studies examined in this meta-analysis included exercise interventions designed to enhance mobility. The well-documented effectiveness of these strategies for fall prevention is worthy of special emphasis.",
       "highlight": "12 of 14 studies examined in this meta-analysis included exercise interventions designed to enhance mobility.",
       "scope": "different-setting",
       "note": "Confirms mobility/exercise as a near-universal component of these delirium-prevention trials, but the pooled studies are hospital-ward, not ICU.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest match that includes a physical-therapy consultant and an early-mobilization protocol, but the HELP RCT population is patients 70+ on a general-medicine ward, not ICU, and includes no occupational therapist.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "The intervention strategy, called the Elder Life Program, was implemented by a trained interdisciplinary team, which consisted of a geriatric nurse-specialist, two specially trained Elder Life specialists, a certified therapeutic-recreation specialist, a physicaltherapy consultant, a geriatrician, and trained volunteers.",
       "highlight": "implemented by a trained interdisciplinary team, which consisted of a geriatric nurse-specialist, two specially trained Elder Life specialists, a certified therapeutic-recreation specialist, a physicaltherapy consultant, a geriatrician, and trained volunteers",
       "scope": "different-setting",
       "note": "A physical-therapy consultant is on the HELP interdisciplinary team, but this is a general-medicine ward program for older patients, not an ICU PT/OT consult, and OT is not included.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — immobility. Eligible patients: All patients; ambulation whenever possible, and range-of-motion exercises when patients chronically non-ambulatory, bed or wheelchair bound, immobilized (e.g., because of an extremity fracture or deep venous thrombosis), or when prescribed bed rest. Standardized intervention protocols: Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints). Targeted outcome for reassessment: Change in Activities of Daily Living score.",
       "highlight": "Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment",
       "scope": "different-setting",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "Intervention-protocol table flattened into a run-on list of labeled cells (Early-mobilization/Vision/Hearing protocol), truncated at 'special comm'."
      }
     ]
    }
   ],
   "synthesis": "The governing on-scope source, Vanderbilt's ICU Early Mobility page, directly supports involving physical and occupational therapists early as part of the ICU interdisciplinary mobility team and cites ICU RCT evidence (Schweickert's early PT/OT trial; Morris's mobility team started within 48 hours of ventilation) that earlier mobilization shortens delirium and improves functional outcomes. The other sources agree on the value of early mobilization but at a different grain: SCCM lists it only as bundle element E, Hodgson 2014 is same-setting ICU but scoped to mobilization safety criteria rather than consult timing, and Hshieh 2015 and Inouye 1999 support early mobilization as a delirium-prevention component in hospitalized older/general-ward patients rather than ICU.",
   "discrepancy": true
  },
  {
   "id": "spa-r15",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Activity / Awareness",
   "statement": "Glasses, hearing aids, orient: Sensory deprivation is reversible; update the orientation board every shift.",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Hodgson 2014",
    "Early Mobility",
    "Hshieh 2015",
    "Inouye 1999"
   ],
   "anchor": "Inouye 1999 — p. 3, ¶60",
   "passage": "Cognitive impairment* All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily Orientation protocol: board with names of care-team members and day's schedule; communication to reorient to surroundings Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games) Change in orientation score Sleep deprivation All patients; need for protocol assessed once daily Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures) Change in rate of use of sedative drug for sleep† Immobility All patients; ambulation …\nBeyond the orientation board, the HELP vision protocol ('visual aids (e.g., glasses or magnifying lenses)... with daily reinforcement') and hearing protocol ('portable amplifying devices, earwax disimpaction') cover the glasses and hearing-aid items. The orientation board is reinforced daily in the protocol.",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
    "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
    "https://doi.org/10.1001/jamainternmed.2014.7779",
    "https://doi.org/10.1056/NEJM199903043400901"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Vision protocol: visual aids (e.g., glasses or magnifying lenses) and adaptive equipment (e.g., large illuminated telephone keypads, large-print books, and fluorescent tape on call bell), with daily reinforcement of their use Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques, with daily reinforcement of these adaptations Dehydration protocol: early recognition of dehydration and volume repletion (i.e., encouragement of oral intake of fluids) TARGETED OUTCOME FOR REASSESSMENT Change in orientation score Change in rate of use of sedative drug for sleep Change in Activities of Daily Living score Early correction of vision, 48 hr after admission Change in Whisper Test score Change in ratio of blood urea nitrogen to creatinine *The orientation score consisted of results on the first 10 items on the Mini-Mental State Examination (MMSE).",
       "highlight": "visual aids (e.g., glasses or magnifying lenses)",
       "scope": "on-scope",
       "note": "HELP Table 1 vision protocol defines the statement's \"glasses\" intervention (visual aids with daily reinforcement of their use).",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques, with daily reinforcement of these adaptations Dehydration protocol: early recognition of dehydration and volume repletion (i.e., encouragement of oral intake of fluids) TARGETED OUTCOME FOR REASSESSMENT Change in orientation score Change in rate of use of sedative drug for sleep Change in Activities of Daily Living score Early correction of vision, 48 hr after admission Change in Whisper Test score Change in ratio of blood urea nitrogen to creatinine *The orientation score consisted of results on the first 10 items on the Mini-Mental State Examination (MMSE).",
       "highlight": "portable amplifying devices, earwax disimpaction, and special communication techniques",
       "scope": "on-scope",
       "note": "HELP Table 1 hearing protocol defines the statement's \"hearing aids\" intervention (portable amplifying devices).",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "STANDARDIZED INTERVENTION PROTOCOLS Orientation protocol: board with names of care-team members and day's schedule; communication to reorient to surroundings Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games) Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures) Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints) Vision protocol: visual aids (e.g., glasses or magnifying lenses) and adaptive equipment (e.g., large illuminated telephone keypads, large-print books, and fluorescent tape on call bell), with daily reinforcement of their use Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques, with daily reinforcement of these adaptations Dehydration protocol: early recognition of dehydration and volume repletion (i.e., encouragement of oral intake of fluids)",
       "highlight": "board with names of care-team members and day's schedule; communication to reorient to surroundings",
       "scope": "on-scope",
       "note": "HELP Table 1 orientation protocol is the reorientation board the statement operationalizes; source specifies daily reinforcement rather than a per-shift cadence.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Six risk factors for delirium were targeted for intervention: cognitive impairment, sleep deprivation, immobility, visual impairment, hearing impairment, and dehydration.24,25,28,38 These factors were selected on the basis of evidence of their association with the risk of delirium and because they were amenable to intervention strategies considered feasible in the context of current hospital practice. Table 1 describes the risk group that received each intervention, the standardized intervention protocols for each risk factor, and the targeted outcome for each intervention protocol.",
       "highlight": "amenable to intervention strategies considered feasible in the context of current hospital practice",
       "scope": "on-scope",
       "note": "Supports \"sensory deprivation is reversible\": visual and hearing impairment are among the modifiable risk factors amenable to intervention. Population is hospitalized medical patients aged 70+, not ICU-specific.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "hearing and vision adaptations",
       "scope": "on-scope",
       "note": "Meta-analysis enumerates the HELP components as reorientation plus hearing and vision adaptations — the same interventions the statement names; pooled from hospitalized older-adult prevention trials, not ICU-specific.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "b Evidence-based nonpharmacological interventions include the following: cognition or orientation (C), early mobility (E), hearing (H), sleep-wake cycle preservation (P), vision (V), and hydration (W).",
       "highlight": "cognition or orientation (C), early mobility (E), hearing (H), sleep-wake cycle preservation (P), vision (V), and hydration (W)",
       "scope": "broader",
       "note": "Component taxonomy lists orientation, hearing, and vision among the six evidence-based components; supports these as valid prevention interventions but evaluates the whole bundle rather than the sensory/orientation piece alone.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    },
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes while transforming culture.",
       "highlight": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes",
       "scope": "background",
       "note": "The ICU Liberation (ABCDEF) bundle is the umbrella under which this comfort, orientation, or sleep measure is delivered; the bundle resource endorses implementing these elements rather than stating this specific bedside line.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Hodgson 2014",
     "cite": "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "",
     "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
     "paragraphs": [
      {
       "context": "The safety criteria covered by the consensus group were divided into four categories: (1) respiratory considerations, including intubation status, ventilatory parameters and the need for adjunctive therapies; (2) cardiovascular considerations, including the presence of devices, cardiac arrhythmias and blood pressure; (3) neurological considerations, including level of consciousness, delirium and intracranial pressure, and (4) other considerations, including lines and surgical or medical conditions.",
       "highlight": "neurological considerations, including level of consciousness, delirium and intracranial pressure",
       "scope": "different-intervention",
       "note": "Consensus safety criteria for active mobilization of mechanically ventilated adults (the Activity component); addresses delirium only as a mobilization-safety consideration, not sensory aids or reorientation.",
       "page": "",
       "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y"
      }
     ]
    },
    {
     "label": "Early Mobility",
     "cite": "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "",
     "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
     "paragraphs": [
      {
       "context": "Early mobility is an integral part of the ABCDEF Bundle and has been the only intervention resulting in a decrease in days of delirium.",
       "highlight": "the only intervention resulting in a decrease in days of delirium",
       "scope": "different-intervention",
       "note": "Vanderbilt CIBS early-mobility page covering the E (Early Mobility) bundle element — a different Activity-side intervention, not the sensory-aid or reorientation content the statement addresses.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
      }
     ]
    }
   ],
   "synthesis": "The two on-scope sources agree: Inouye 1999 (HELP) — the designated primary anchor — directly defines the statement's interventions, specifying a reorientation board (care-team names + day's schedule, with daily reinforcement), visual aids such as glasses/magnifying lenses, and portable amplifying devices for hearing, with these targeted impairments described as reversible (\"amenable to intervention\"); Hshieh 2015's meta-analysis concurs, listing reorientation and hearing/vision adaptations among the six evidence-based non-pharmacological components. Both derive from hospitalized older-adult prevention trials rather than ICU-specific data, and the three ICU bundle sources attached here (SCCM Liberation overview, Hodgson mobilization-safety consensus, Vanderbilt Early Mobility) are nearest matches that address the Activity/mobility component, not sensory aids or reorientation — so Inouye 1999 governs as the on-scope source, and the \"every shift\" board cadence is a reasonable operationalization of the source's \"daily reinforcement,\" not a verbatim figure.",
   "discrepancy": true
  },
  {
   "id": "spa-r16",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Activity / Awareness",
   "statement": "Engage family & caregivers: Familiar faces reorient; teach T-A-D-A (Tolerate, Anticipate, Don’t Agitate).",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Hodgson 2014",
    "Early Mobility",
    "Hshieh 2015",
    "Inouye 1999"
   ],
   "anchor": "Hshieh 2015 — p. 2",
   "passage": "… The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacologicaldeliriuminterventionshavebeendeveloped,targetingperioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions. 19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscoredthelimitationsofsmallsamples,heterogeneousoutcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes. …\nHshieh 2015 supports involving family in multicomponent delirium interventions; 'familiar faces reorient' is only indirectly supported, and the T-A-D-A mnemonic is not stated in any cited source.",
   "evidence": "Full text, p. 2 — partial support",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
    "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
    "https://doi.org/10.1001/jamainternmed.2014.7779",
    "https://doi.org/10.1056/NEJM199903043400901"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "partial",
     "note": "Archived SCCM web page; names Family Engagement and Empowerment as a core A-F bundle element (adult + pediatric) but does not describe familiar-faces reorientation or the T-A-D-A mnemonic.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "The ICU Liberation Bundle consists of the following individual elements A Element : Assess, Prevent, and Manage Pain B Element : Both Spontaneous Awakening Trials (SATs) and Spontaneous Breathing Trials (SBTs) C Element : Choice of Analgesia and Sedation D Element : Delirium: Assess, Prevent, and Manage E Element: Early Mobility and Exercise F Element : Family Engagement and Empowerment",
       "highlight": "F Element : Family Engagement and Empowerment",
       "scope": "on-scope",
       "note": "Directly supports engaging family/caregivers by making it a named ICU Liberation bundle element, but gives no detail on the reorientation mechanism or T-A-D-A.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      },
      {
       "context": "Pediatric considerations and resources are also included in each element.",
       "highlight": "Pediatric considerations and resources are also included in each element",
       "scope": "background",
       "note": "Frames the bundle (including family engagement) as applied to every ICU patient across adult and pediatric care.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Meta-analysis of multicomponent nonpharmacological delirium prevention in hospitalized older adults; supports family involvement in delivery and reorientation, but is silent on the T-A-D-A mnemonic and is a general-ward (not ICU/ED) population.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "using volunteers, family members, and nurses in the delivery of interventions",
       "scope": "on-scope",
       "note": "Supports engaging family/caregivers to deliver delirium-prevention interventions (page 2 of the article).",
       "page": "513",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "practical interventions, including reorientation",
       "scope": "on-scope",
       "note": "Establishes reorientation as a core effective HELP delirium-prevention component underpinning the 'familiar faces reorient' half.",
       "page": "513",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "partial",
     "note": "HELP RCT in hospitalized patients >=70y; supports reorientation as a prevention protocol but it is volunteer/staff-delivered (a care-team board), not family-delivered, and T-A-D-A is not stated.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "STANDARDIZED INTERVENTION PROTOCOLS Orientation protocol: board with names of care-team members and day's schedule; communication to reorient to surroundings Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games) Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures) Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints) Vision protocol: visual aids (e.g., glasses or magnifying lenses) and adaptive equipment (e.g., large illuminated telephone keypads, large-print books, and fluorescent tape on call bell), with daily reinforcement of their use Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques, with daily reinforcement of these adaptations Dehydration protocol: early recognition of dehydration and volume repletion (i.e., encouragement of oral intake of fluids)",
       "highlight": "communication to reorient to surroundings",
       "scope": "on-scope",
       "note": "Directly supports reorientation as a delirium-prevention intervention, though delivered by trained volunteers/staff rather than by family/familiar faces.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Previous interventional studies of delirium have focused on four types of intervention: general geriatric approaches,9-14 nursing care,15-19 family interventions,20 and anesthesia.21-23 Although in most of the studies there were trends toward a reduction in delirium in the intervention group, in most cases the reduction was not statistically significant. Many studies had methodologic limitations, such as small samples, use of nontargeted interventions, and use of relatively insensitive outcome measures (e.g., screening mental-status tests or confusion checklists). Finally, most previous studies focused on the treatment of delirium rather than on primary prevention, which was the goal of the present study.",
       "highlight": "family interventions,20",
       "scope": "background",
       "note": "Cites family interventions as a prior category of delirium-prevention studies, distinct from HELP's own staff/volunteer-delivered protocols.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "Hodgson 2014",
     "cite": "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Consensus safety criteria for active mobilization of mechanically ventilated adults; a different intervention (mobility/E-element) that mentions delirium only as a neurological safety consideration, not family engagement, reorientation, or T-A-D-A.",
     "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
     "paragraphs": [
      {
       "context": "The safety criteria covered by the consensus group were divided into four categories: (1) respiratory considerations, including intubation status, ventilatory parameters and the need for adjunctive therapies; (2) cardiovascular considerations, including the presence of devices, cardiac arrhythmias and blood pressure; (3) neurological considerations, including level of consciousness, delirium and intracranial pressure, and (4) other considerations, including lines and surgical or medical conditions.",
       "highlight": "level of consciousness, delirium and intracranial pressure",
       "scope": "different-intervention",
       "note": "Nearest keyword match ('delirium') but in the context of safety-screening for mobilizing ventilated patients — not the family/awareness intervention the statement describes.",
       "page": "2",
       "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y"
      }
     ]
    },
    {
     "label": "Early Mobility",
     "cite": "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Archived ICUDelirium.org page about the E element (early mobility); Family Engagement appears only as a bundle navigation link, so the page does not support the family/reorientation/T-A-D-A statement.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
     "paragraphs": [
      {
       "context": "Early mobility is an integral part of the ABCDEF Bundle and has been the only intervention resulting in a decrease in days of delirium.",
       "highlight": "Early mobility is an integral part of the ABCDEF Bundle",
       "scope": "different-intervention",
       "note": "Page content addresses early mobility (a sibling bundle element), not family engagement, familiar-faces reorientation, or T-A-D-A.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
      }
     ]
    }
   ],
   "synthesis": "The family-engagement and reorientation halves of the statement are supported, but the T-A-D-A (Tolerate, Anticipate, Don't Agitate) mnemonic is stated by none of the cited sources. SCCM ICU Liberation names \"Family Engagement and Empowerment\" as a core bundle element and governs the family half; Hshieh 2015 and Inouye 1999 (HELP) establish reorientation as an effective nonpharmacological prevention component, with Hshieh noting family members can help deliver interventions — though that evidence is from general-ward older adults and in HELP reorientation is volunteer/staff-delivered rather than by \"familiar faces.\" Hodgson 2014 and the Early Mobility page are different-intervention (mobilization) references, so overall support is partial with an unsupported T-A-D-A element.",
   "discrepancy": true
  },
  {
   "id": "spa-r17",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "S·P·A action cards — Activity / Awareness",
   "statement": "Protect sleep — day / night: Dim lights per quiet-hours protocol, cluster cares, offer eye masks and earplugs.",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM ICU Liberation",
    "Hodgson 2014",
    "Early Mobility",
    "Hshieh 2015",
    "Inouye 1999"
   ],
   "anchor": "Inouye 1999 — p. 3, ¶60",
   "passage": "Cognitive impairment* All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily Orientation protocol: board with names of care-team members and day's schedule; communication to reorient to surroundings Therapeutic-activities protocol: cognitively stimulating activities three times daily (e.g., discussion of current events, structured reminiscence, or word games) Change in orientation score Sleep deprivation All patients; need for protocol assessed once daily Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures) Change in rate of use of sedative drug for sleep† Immobility All patients; ambulation whenever possible, and range-of-motion exercises when patients chronically non-ambulatory, bed or wheelchair bound, immobilized (e.g., because of an extremity fracture or deep venous thrombosis), or when prescribed bed rest Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints) Change in Activities of Daily Living score Visual impairment Patients with <20/70 visual acuity on binocular near-vision testing Vision protocol: visual aids (e.g., glasses or magnifying lenses)  …\nThe HELP sleep protocol supports noise reduction and rescheduling/clustering of cares; eye masks, earplugs, and dimmed lights are not in Inouye 1999 and derive from other ICU sleep bundles.",
   "evidence": "Full text, p. 3 — partial support",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
    "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
    "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
    "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
    "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676."
   ],
   "links": [
    "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
    "https://doi.org/10.1001/jamainternmed.2014.7779",
    "https://doi.org/10.1056/NEJM199903043400901"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM ICU Liberation",
     "cite": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
     "kind": "pdf",
     "stance": "partial",
     "note": "Archived ICU Liberation landing page; contributes only high-level bundle context — names sleep disruption as a target domain but no specific sleep-protection actions.",
     "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
     "paragraphs": [
      {
       "context": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes while transforming culture.",
       "highlight": "Implement the A-F elements of the ICU Liberation Bundle to improve outcomes",
       "scope": "broader",
       "note": "The ICU Liberation (ABCDEF) bundle is the umbrella under which this comfort, orientation, or sleep measure is delivered; the bundle resource endorses implementing these elements rather than stating this specific bedside line.",
       "page": "",
       "docUrl": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    },
    {
     "label": "Hodgson 2014",
     "cite": "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Expert-consensus safety criteria for active mobilization of ventilated ICU patients — the Activity/mobility intervention, not sleep protection; no sleep content anywhere in the file.",
     "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
     "paragraphs": [
      {
       "context": "The aim of this study was to develop consensus recommendations on safety criteria that should be considered prior to mobilizing adult, mechanically ventilated, ICU patients.",
       "highlight": "safety criteria that should be considered prior to mobilizing adult, mechanically ventilated, ICU patients",
       "scope": "different-intervention",
       "note": "Whole paper is about when it is safe to mobilize ventilated ICU patients — a different intervention from protecting sleep; contributes nothing to the sleep statement.",
       "page": "",
       "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y"
      }
     ]
    },
    {
     "label": "Early Mobility",
     "cite": "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Archived Vanderbilt CIBS page on the E (Early Mobility) element; addresses ambulation/exercise, a different intervention, with no sleep-protection content.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
     "paragraphs": [
      {
       "context": "Early mobility is an integral part of the ABCDEF Bundle and has been the only intervention resulting in a decrease in days of delirium.",
       "highlight": "Early mobility is an integral part of the ABCDEF Bundle",
       "scope": "different-intervention",
       "note": "Covers early mobility/exercise (the E element), a different intervention from sleep protection; no dim-lights/cluster-cares/eye-mask/earplug measures described.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
      }
     ]
    },
    {
     "label": "Hshieh 2015",
     "cite": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Meta-analysis of multicomponent nonpharmacological delirium interventions in hospitalized older adults; endorses sleep-wake cycle preservation as an evidence-based component at the category level, not ICU-specific.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "b Evidence-based nonpharmacological interventions include the following: cognition or orientation (C), early mobility (E), hearing (H), sleep-wake cycle preservation (P), vision (V), and hydration (W).",
       "highlight": "sleep-wake cycle preservation (P)",
       "scope": "broader",
       "note": "Lists sleep-wake cycle preservation among the evidence-based nonpharmacological delirium-prevention components; supports the protect-sleep action broadly (older inpatients, not ICU; no eye-mask/earplug detail).",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "Systematic reviews and clinical guidelines have recommended targeted multicomponent nonpharmacological intervention strategies for prevention of delirium (eTable in the Supplement).8,9 The Hospital Elder Life Program (HELP) is the original evidence-based approach targeted to delirium risk factors, which is widely known and disseminated.5,10,11 The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations. The HELP has been cost-effective and successful in preventing delirium and functional decline.2,12,13 Studies12,14,15 have evaluated modified HELP models. New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.19,20 However, differing outcomes were examined across studies, and a systematic examination of their effectiveness has not been conducted to our knowledge. Most recently, there have been systematic reviews and guidelines,7,8 but these statements underscored the limitations of small samples, heterogeneous outcomes, and variable adherence. A need exists for more definitive review to expedite dissemination in practice and spur further research into areas of uncertain outcomes.",
       "highlight": "sleep strategies",
       "scope": "broader",
       "note": "Describes HELP (the original evidence-based multicomponent program) as including sleep strategies among its interventions.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    },
    {
     "label": "Inouye 1999",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary-anchor source: HELP RCT whose Table 1 specifies both a nonpharmacologic sleep protocol and a unit-wide sleep-enhancement protocol; directly supports the protect-sleep concept and clustering/rescheduling of care, but in general-medicine inpatients >=70 rather than the ICU.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — sleep deprivation. Eligible patients: All patients; need for protocol assessed once daily. Standardized intervention protocols: Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage. Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures). Targeted outcome for reassessment: Change in rate of use of sedative drug for sleep.",
       "highlight": "Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "Intervention-protocol table cells concatenated into run-on text ending mid-word 'immobil', not a genuine paragraph."
      },
      {
       "context": "Table 1. Risk factors for delirium and intervention protocols. Targeted risk factor — sleep deprivation. Eligible patients: All patients; need for protocol assessed once daily. Standardized intervention protocols: Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage. Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures). Targeted outcome for reassessment: Change in rate of use of sedative drug for sleep.",
       "highlight": "schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures)",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed. The table sets the eligible patients, the intervention protocols and the targeted outcome in three columns; they are labeled here so the row reads in the order the table gives it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
       "qcNote": "Same intervention-protocol table cells merged into run-on text ending mid-word 'adaptive equipme'."
      }
     ]
    }
   ],
   "synthesis": "Inouye 1999 (HELP) is the governing on-scope source: its Table 1 directly establishes a nonpharmacologic sleep protocol plus unit-wide noise reduction and rescheduling/clustering of medications and procedures, which underpins the \"protect sleep / cluster cares\" action — though in general-medicine inpatients >=70 rather than the ICU and without naming dim lights, eye masks, or earplugs, which are contemporary ICU operationalizations of its environmental sleep-enhancement principle. Hshieh 2015 and SCCM ICU Liberation broadly corroborate sleep-wake preservation as an evidence-based delirium-prevention component, while Hodgson 2014 and the Early Mobility page address active mobilization (a different intervention) and say nothing about sleep.",
   "discrepancy": true
  },
  {
   "id": "spa-r18",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "RASS scale",
   "statement": "RASS +4 / +3: Combative / Very agitated",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002",
    "Ely 2003"
   ],
   "anchor": "Ely 2003 — p. 2985",
   "passage": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
    "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1001/jama.289.22.2983"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Ely 2003",
     "cite": "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
     "paragraphs": [
      {
       "context": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
       "highlight": "+4 Combative — Overtly combative, violent, immediate danger to staff",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed; the table’s term and description columns are joined with an em dash so each row reads as one line. The two ten-second anchors are −1 at more than 10 seconds and −2 at under 10 seconds — the distinction between them is the direction of that comparison.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
       "qcNote": "The RASS scale (Table 1) rendered as a linear run of scattered score/term/description cells, not prose."
      },
      {
       "context": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
       "highlight": "+3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed; the table’s term and description columns are joined with an em dash so each row reads as one line. The two ten-second anchors are −1 at more than 10 seconds and −2 at under 10 seconds — the distinction between them is the direction of that comparison.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
       "qcNote": "Same RASS scale table dumped as sequential cells; not a readable paragraph."
      }
     ]
    },
    {
     "label": "Sessler 2002",
     "cite": "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
     "kind": "web",
     "stance": "background",
     "note": "Original RASS development and validation paper (Am J Respir Crit Care Med 2002) that introduced the +4 Combative / +3 Very agitated score labels; cited in the RASS scale section as the primary derivation but supplied here without a text file to search.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "Both sources agree: Table 1 of Ely 2003 defines the RASS with +4 = Combative and +3 = Very agitated, directly and exactly matching the claim's mapping; Sessler 2002 is the original RASS development/validation paper that introduced these same score labels and is cited alongside as the primary derivation. The on-scope adult-ICU RASS definition in Ely 2003 governs.",
   "discrepancy": false
  },
  {
   "id": "spa-r19",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "RASS scale",
   "statement": "RASS +2 / +1: Agitated / Restless",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002",
    "Ely 2003"
   ],
   "anchor": "Ely 2003 — p. 2985",
   "passage": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
    "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1001/jama.289.22.2983"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002",
     "cite": "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
     "kind": "web",
     "stance": "background",
     "note": "Original RASS derivation paper (Ely's Table 1 is 'Adapted with permission' from this reference) and the source of the same +2 = Agitated / +1 = Restless anchors; not archived as a text file here, so cited by section/DOI only.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Ely 2003",
     "cite": "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Table 1 (The Richmond Agitation-Sedation Scale) on journal page 2984 lists +2 = Agitated and +1 = Restless verbatim, matching the tool exactly; present in both a clean-text and a layout-preserved extraction in the file.",
     "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
     "paragraphs": [
      {
       "context": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
       "highlight": "+2 Agitated — Frequent nonpurposeful movement, fights ventilator",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed; the table’s term and description columns are joined with an em dash so each row reads as one line. The two ten-second anchors are −1 at more than 10 seconds and −2 at under 10 seconds — the distinction between them is the direction of that comparison.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      },
      {
       "context": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
       "highlight": "+1 Restless — Anxious but movements not aggressive or vigorous",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed; the table’s term and description columns are joined with an em dash so each row reads as one line. The two ten-second anchors are −1 at more than 10 seconds and −2 at under 10 seconds — the distinction between them is the direction of that comparison.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      },
      {
       "context": "Utilization of the RASS for 1833 observations in 275 patients indicated that the patients who received mechanical ventilation spent about one third of their time either unarousable or in a deeply sedated state (RASS score, −5 or −4; n=548 observations), one third in a moderate to light sedation state (RASS score, −3 to −1; n=625 observations), and one third in an alert and calm state (RASS score, 0; n=619 observations). Spontaneous agitation (RASS score, +1 to +4; n=41 observations), which was rated prior to stimulation, was an uncommon state (<5%) found by the study nurses.",
       "highlight": "Spontaneous agitation (RASS score, +1 to +4; n=41 observations)",
       "scope": "broader",
       "note": "Read from the printed page. The article sets the negative scores with a minus sign, and the \"less than\" sign before 5% is one of the characters this PDF’s font does not map.",
       "page": "2987",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      }
     ]
    }
   ],
   "synthesis": "Both sources describe the same adult-ICU Richmond Agitation-Sedation Scale, and they agree. Ely 2003 Table 1 (p. 2985) is the on-scope governing source: it defines +2 = \"Agitated\" and +1 = \"Restless\" exactly as the tool states, and Sessler 2002 is the original scale Ely's table is \"Adapted with permission\" from, so it is consistent rather than conflicting.",
   "discrepancy": false
  },
  {
   "id": "spa-r20",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "RASS scale",
   "statement": "RASS 0: Alert & calm",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002",
    "Ely 2003"
   ],
   "anchor": "Ely 2003 — p. 2985",
   "passage": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
    "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1001/jama.289.22.2983"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Ely 2003",
     "cite": "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Table 1 gives the canonical RASS scale in which score 0 = 'Alert and calm'; the results section restates the same score-0 label.",
     "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
     "paragraphs": [
      {
       "context": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
       "highlight": "0 Alert and calm",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed; the table’s term and description columns are joined with an em dash so each row reads as one line. The two ten-second anchors are −1 at more than 10 seconds and −2 at under 10 seconds — the distinction between them is the direction of that comparison.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
       "qcNote": "This is the RASS scale table rendered as interleaved score/term/description cells, not prose (e.g. 'Moderate ... sedation' split around the description, '-5 Unarou' cut off)."
      },
      {
       "context": "Utilization of the RASS for 1833 observations in 275 patients indicated that the patients who received mechanical ventilation spent about one third of their time either unarousable or in a deeply sedated state (RASS score, −5 or −4; n=548 observations), one third in a moderate to light sedation state (RASS score, −3 to −1; n=625 observations), and one third in an alert and calm state (RASS score, 0; n=619 observations). Spontaneous agitation (RASS score, +1 to +4; n=41 observations), which was rated prior to stimulation, was an uncommon state (<5%) found by the study nurses.",
       "highlight": "an alert and calm state (RASS score, 0; n=619 observations)",
       "scope": "on-scope",
       "note": "Read from the printed page. The article sets the negative scores with a minus sign, and the \"less than\" sign before 5% is one of the characters this PDF’s font does not map.",
       "page": "2987",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      }
     ]
    },
    {
     "label": "Sessler 2002",
     "cite": "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
     "kind": "web",
     "stance": "background",
     "note": "Original RASS development/validation paper (Am J Respir Crit Care Med 2002;166(10):1338-1344) cited as the source of the scale itself; no archived text file provided, contributes the scale's provenance for the score-0 'Alert and calm' anchor.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "Ely 2003 directly supports the claim: its Table 1 defines RASS score 0 verbatim as \"Alert and calm,\" and the results section restates the same score-0 label, so the on-scope Ely 2003 source governs. Sessler 2002 (web-cited, no text file) is the original RASS paper providing the scale's provenance, and the sources agree.",
   "discrepancy": false
  },
  {
   "id": "spa-r21",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "RASS scale",
   "statement": "RASS −1: Drowsy",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002",
    "Ely 2003"
   ],
   "anchor": "Ely 2003 — p. 2985",
   "passage": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
    "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1001/jama.289.22.2983"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Ely 2003",
     "cite": "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Table 1 (The Richmond Agitation-Sedation Scale) explicitly lists the -1 level as Drowsy, directly supporting the claim.",
     "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
     "paragraphs": [
      {
       "context": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
       "highlight": "−1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds)",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed; the table’s term and description columns are joined with an em dash so each row reads as one line. The two ten-second anchors are −1 at more than 10 seconds and −2 at under 10 seconds — the distinction between them is the direction of that comparison.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      }
     ]
    },
    {
     "label": "Sessler 2002",
     "cite": "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
     "kind": "web",
     "stance": "background",
     "note": "Original RASS validation paper that first defined the scale (including score -1 = Drowsy); cited alongside Ely 2003 for the RASS scale section but not archived as a text file here.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "Both sources are the definitive RASS references; Ely 2003 (the archived PDF) directly governs, its Table 1 listing \"-1 Drowsy\" with the description \"Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds)\", exactly matching the claim's RASS −1: Drowsy anchor. Sessler 2002, the original RASS validation paper, defines the same scale and is cited alongside it; the two agree with no scope divergence.",
   "discrepancy": false
  },
  {
   "id": "spa-r22",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "RASS scale",
   "statement": "RASS −2: Light sedation",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002",
    "Ely 2003"
   ],
   "anchor": "Ely 2003 — p. 2985",
   "passage": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
    "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1001/jama.289.22.2983"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Ely 2003",
     "cite": "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
     "paragraphs": [
      {
       "context": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
       "highlight": "−2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds)",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed; the table’s term and description columns are joined with an em dash so each row reads as one line. The two ten-second anchors are −1 at more than 10 seconds and −2 at under 10 seconds — the distinction between them is the direction of that comparison.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
       "qcNote": "This is the RASS scale table rendered as interleaved cells (score/term/description columns collapsed into one line, e.g. 'Moderate ... sedation' split), not prose."
      }
     ]
    },
    {
     "label": "Sessler 2002",
     "cite": "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
     "kind": "web",
     "stance": "background",
     "note": "Original RASS validation paper (the scale Ely 2003 adapts in Table 1); web source with no text file, cited by section/DOI for the -2 = light sedation band.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "Both sources define RASS -2 as \"light sedation\": Ely 2003's Table 1 (the RASS reproduced/adapted from the original Sessler 2002 scale) lists \"-2 Light sedation\" directly, and the on-scope PDF (Ely 2003) governs. The two agree, with Sessler 2002 being the originating scale publication cited by section/DOI.",
   "discrepancy": false
  },
  {
   "id": "spa-r23",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "RASS scale",
   "statement": "RASS −3: Moderate sedation",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002",
    "Ely 2003"
   ],
   "anchor": "Ely 2003 — p. 2985",
   "passage": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
    "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1001/jama.289.22.2983"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Ely 2003",
     "cite": "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Table 1 (RASS) defines score -3 as Moderate sedation; the results paragraph is a broader nearest-match on the same terms.",
     "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
     "paragraphs": [
      {
       "context": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
       "highlight": "−3 Moderate sedation — Movement or eye opening to voice (but no eye contact)",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed; the table’s term and description columns are joined with an em dash so each row reads as one line. The two ten-second anchors are −1 at more than 10 seconds and −2 at under 10 seconds — the distinction between them is the direction of that comparison.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
       "qcNote": "This is the Richmond Agitation-Sedation Scale rendered as scattered score values, terms, and descriptions from a table, not prose."
      },
      {
       "context": "Utilization of the RASS for 1833 observations in 275 patients indicated that the patients who received mechanical ventilation spent about one third of their time either unarousable or in a deeply sedated state (RASS score, −5 or −4; n=548 observations), one third in a moderate to light sedation state (RASS score, −3 to −1; n=625 observations), and one third in an alert and calm state (RASS score, 0; n=619 observations). Spontaneous agitation (RASS score, +1 to +4; n=41 observations), which was rated prior to stimulation, was an uncommon state (<5%) found by the study nurses.",
       "highlight": "moderate to light sedation state (RASS score, −3 to −1",
       "scope": "broader",
       "note": "Read from the printed page. The article sets the negative scores with a minus sign, and the \"less than\" sign before 5% is one of the characters this PDF’s font does not map.",
       "page": "2987",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      }
     ]
    },
    {
     "label": "Sessler 2002",
     "cite": "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
     "kind": "web",
     "stance": "background",
     "note": "Original RASS derivation and validation paper (Am J Respir Crit Care Med 2002;166:1338-1344) cited by the RASS scale section as the scale's source; archived web reference with no extractable PDF text to quote.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "Ely 2003 Table 1 (the RASS) is the on-scope source and defines score -3 exactly as \"Moderate sedation\" (description: movement or eye opening to voice but no eye contact), directly supporting the claim. Sessler 2002 is the original RASS derivation/validation paper cited as background (archived web page, no extractable PDF text); a separate results paragraph in Ely 2003 groups RASS -3 through -1 collectively as a \"moderate to light sedation state,\" a broader frequency descriptor rather than the -3 label, so the Table 1 definition governs.",
   "discrepancy": true
  },
  {
   "id": "spa-r24",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "RASS scale",
   "statement": "RASS −4 / −5: Deep sedation / Unarousable",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002",
    "Ely 2003"
   ],
   "anchor": "Ely 2003 — p. 2985",
   "passage": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
    "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1001/jama.289.22.2983"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Ely 2003",
     "cite": "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Table 1 (the RASS scale) states the definitional labels for scores -4 and -5, directly supporting the claim.",
     "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
     "paragraphs": [
      {
       "context": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
       "highlight": "−4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed; the table’s term and description columns are joined with an em dash so each row reads as one line. The two ten-second anchors are −1 at more than 10 seconds and −2 at under 10 seconds — the distinction between them is the direction of that comparison.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
       "qcNote": "This is the RASS scale table rendered as scattered score numbers and labels, not prose."
      },
      {
       "context": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
       "highlight": "−5 Unarousable — No response to voice or physical stimulation",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed; the table’s term and description columns are joined with an em dash so each row reads as one line. The two ten-second anchors are −1 at more than 10 seconds and −2 at under 10 seconds — the distinction between them is the direction of that comparison.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
       "qcNote": "This is the RASS scale table rendered as scattered score numbers and labels, not prose."
      },
      {
       "context": "Utilization of the RASS for 1833 observations in 275 patients indicated that the patients who received mechanical ventilation spent about one third of their time either unarousable or in a deeply sedated state (RASS score, −5 or −4; n=548 observations), one third in a moderate to light sedation state (RASS score, −3 to −1; n=625 observations), and one third in an alert and calm state (RASS score, 0; n=619 observations). Spontaneous agitation (RASS score, +1 to +4; n=41 observations), which was rated prior to stimulation, was an uncommon state (<5%) found by the study nurses.",
       "highlight": "unarousable or in a deeply sedated state (RASS score, −5 or −4",
       "scope": "background",
       "note": "Read from the printed page. The article sets the negative scores with a minus sign, and the \"less than\" sign before 5% is one of the characters this PDF’s font does not map.",
       "page": "2987",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      }
     ]
    },
    {
     "label": "Sessler 2002",
     "cite": "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
     "kind": "web",
     "stance": "background",
     "note": "Original RASS development/validation paper cited by the RASS-scale section; kind web with no extracted text, so contributes as background reference (Am J Respir Crit Care Med. 2002;166(10):1338-1344).",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "Ely 2003 Table 1 (the RASS) directly defines score -4 as \"Deep sedation\" and -5 as \"Unarousable\", exactly matching the claim's label mapping, and is the governing on-scope source. Sessler 2002, cited via the section as the original RASS validation, is a web source with no extracted text and serves as background; the two agree with no conflict.",
   "discrepancy": false
  },
  {
   "id": "spa-r25",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "RASS sedation target",
   "statement": "Target −3 to −4: Deep sedation — documented indication required.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002",
    "Ely 2003"
   ],
   "anchor": "Ely 2003 — p. 2985",
   "passage": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
   "evidence": "Full text, p. 4 — partial support",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
    "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1001/jama.289.22.2983"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002",
     "cite": "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
     "kind": "web",
     "stance": "background",
     "note": "Original RASS validation (Sessler et al, Am J Respir Crit Care Med 2002) cited by the RASS-target section; it defines the 10-point RASS whose -4 'deep sedation' anchor the tool's band rests on. Not archived here, so no paragraph-level verification is possible; contributes the instrument definition by citation.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Ely 2003",
     "cite": "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Table 1 supports the -4 = 'Deep sedation' term the band uses, but the paper labels -3 'Moderate sedation' and groups it with light sedation, and it makes no recommendation about documenting a deep-sedation indication.",
     "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
     "paragraphs": [
      {
       "context": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
       "highlight": "−4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed; the table’s term and description columns are joined with an em dash so each row reads as one line. The two ten-second anchors are −1 at more than 10 seconds and −2 at under 10 seconds — the distinction between them is the direction of that comparison.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      },
      {
       "context": "Utilization of the RASS for 1833 observations in 275 patients indicated that the patients who received mechanical ventilation spent about one third of their time either unarousable or in a deeply sedated state (RASS score, −5 or −4; n=548 observations), one third in a moderate to light sedation state (RASS score, −3 to −1; n=625 observations), and one third in an alert and calm state (RASS score, 0; n=619 observations). Spontaneous agitation (RASS score, +1 to +4; n=41 observations), which was rated prior to stimulation, was an uncommon state (<5%) found by the study nurses.",
       "highlight": "moderate to light sedation state (RASS score, −3 to −1; n=625 observations)",
       "scope": "narrower",
       "note": "Read from the printed page. The article sets the negative scores with a minus sign, and the \"less than\" sign before 5% is one of the characters this PDF’s font does not map.",
       "page": "2987",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      },
      {
       "context": "During this investigation, no protocol to guide analgesia, sedation, or neuromuscular blockade existed in our ICU, and no objective target levels of sedation were routinely identified according to disease state or ventilator settings. All doses of narcotics, benzodiazepines, propofol, and neuromuscular blocking agents were recorded prospectively in 8-hour intervals throughout the investigation. Administered narcotics were either morphine or fentanyl. Administered benzodiazepines were either lorazepam or midazolam (the midazolam dose was converted to lorazepam equivalents by dividing by 3 to achieve equipotent dose33). If neuromuscular blocking agents had been given within 8 hours of RASS assessment, patient observations were excluded from our pharmacological analyses.",
       "highlight": "no objective target levels of sedation were routinely identified according to disease state or ventilator settings",
       "scope": "background",
       "note": "The study set no objective sedation targets by disease state or ventilator settings, confirming this reliability/validity paper does not prescribe the 'documented indication required' rule the claim attaches to the deep-sedation band.",
       "page": "2984",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      }
     ]
    }
   ],
   "synthesis": "Ely 2003 Table 1 (the on-scope source) validates the RASS and defines score -4 as 'Deep sedation,' supporting the term the tool applies, but it labels -3 as 'Moderate sedation' and its own cohort results group -4 with -5 ('deeply sedated') while placing -3 with -1 ('moderate to light') — so the tool's -3-to-4 'Deep sedation' band is broader than the source's per-score terms, and 'documented indication required' is a practice overlay this reliability/validity study never addresses. Sessler 2002 (the original RASS validation, not archived here) is the co-cited instrument source defining the same scale; the RASS-terminology support governs, while the band boundary and documentation requirement are not established by either source.",
   "discrepancy": true
  },
  {
   "id": "spa-r26",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "1",
   "section": "RASS sedation target",
   "statement": "Target (write-in): Per prescriber order — write the target in each shift.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002",
    "Ely 2003"
   ],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "structure",
   "pageNum": null,
   "citations": [],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1001/jama.289.22.2983"
   ],
   "decision": "",
   "notes": "A write-in documentation field: the RASS sedation target is set by the prescriber's order for the individual patient, so the line itself carries no fixed citation. The RASS scale it records is validated (Sessler 2002; Ely 2003).",
   "perSource": [],
   "synthesis": "",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "spa-r27",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Deeper guidance — S — Sedation",
   "statement": "Dexmedetomidine preferred in ventilated patients — reduces delirium vs benzodiazepines; monitor bradycardia / hypotension.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MENDS2 2021",
    "Haloperidol PI",
    "Hodgson 2014",
    "Early Mobility"
   ],
   "anchor": "PADIS 2025 — p. 5",
   "passage": "… Nonpharmacological treatment approaches, such as music listening (21, 25) or virtual reality (22), have shown promise. A patientcentered approach to care, research, and quality im provement that encompasses all sources of discomfort and distress in the ICU is essential to providing compre hensive management of anxiety. Of note, abrupt cessation of benzodiazepines pre scribed for baseline chronic anxiety may precipitate acute withdrawal; hence, continuation of the chronic benzodiazepines upon admission to the ICU should be considered. DEXMEDETOMIDINE FOR SEDATION Recommendation 2 We suggest using dexmedetomidine over propofol for sedation in mechanically ventilated adult patients admitted to the ICU where light sedation and/or a\nAlso MENDS2 2021: \"Trials comparing dexmedetomidine with benzodiazepines in adults have shown that the use of dexmedetomidine results in improvement in outcomes such as delirium, coma, and time receiving mechanical ventilation.\"\nPADIS 2025 notes dexmedetomidine 'probably reduced the prevalence of delirium (RR, 0.55)' versus propofol and 'probably increases the risk of bradycardia (RR, 1.65),' supporting the monitoring caution; MENDS2 supports the delirium benefit over benzodiazepines.",
   "evidence": "Full text, p. 5",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
    "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
    "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "A total of 3087 mechanically ventilated adults admitted to the ICU were randomized to dexmedetomidine vs. propofol in 29 randomized controlled trials (RCTs) (26-54), the majority of which explicitly stated medications were titrated to achieve light sedation (22 RCTs). Compared with propofol, dexmedetomidine probably reduced the prevalence of delirium (RR, 0.55; 95% CI, 0.37-0.81; absolute risk reduction [ARR], 15 fewer patients per 100; 95% CI, from 20 fewer to 6 fewer; moderate certainty) and may reduce the duration of delirium (MD, -25.58hr; 95% CI, -43.49 to -7.66hr; low certainty).",
       "highlight": "dexmedetomidine probably reduced the prevalence of delirium",
       "scope": "on-scope",
       "note": "2025 focused-update evidence: in ventilated ICU adults titrated to light sedation, dexmedetomidine probably reduced the prevalence of delirium versus propofol.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Compared with propofol, dexmedetomidine probably reduced the prevalence of delirium (RR, 0.55; 95% CI, 0.37-0.81; absolute risk reduction [ARR], 15 fewer patients per 100; 95% CI, from 20 fewer to 6 fewer; moderate certainty) and may reduce the duration of delirium (MD, -25.58hr; 95% CI, -43.49 to -7.66hr; low certainty).",
       "highlight": "Compared with propofol, dexmedetomidine probably reduced the prevalence of delirium (RR, 0.55; 95% CI, 0.37-0.81",
       "scope": "on-scope",
       "note": "29-RCT meta-analysis (dex vs propofol): delirium prevalence reduced (RR 0.55); the same summary reports dexmedetomidine probably increases bradycardia with little-to-no difference in hypotension - grounds 'reduces delirium' and the bradycardia/hypotension monitoring caveat.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "has delirium, clinical judgment must be used. If a patient requires deep sedation or has a high risk of bradycardia, alternative sedative agents should be considered. The cost of dexmedetomidine acquisition for many hospitals is now lower than when initially marketed, and the cost of propofol and dexmedetomidine are likely comparable in many countries. However, there is significant variability in costs and availability of dexmedetomidine. Therefore, cost and ability to obtain dexmedetomidine may well be prohibitive in some centers and hence our recommendation is conditional rather than strong.",
       "highlight": "If a patient requires deep sedation or has a high risk of bradycardia, alternative sedative agents should be considered",
       "scope": "on-scope",
       "note": "Supports the monitoring caveat — consider alternative agents when bradycardia risk is high.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence)",
       "highlight": "We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults",
       "scope": "broader",
       "note": "The 2018 recommendation recapped in the 2025 update - dexmedetomidine OR propofol over benzodiazepines. It is the only place a benzodiazepine comparator appears; it bundles dexmedetomidine with propofol and makes no delirium-reduction claim, while the 2025 delirium data compare dexmedetomidine with propofol.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "METHODS--In a multicenter, double-blind trial, we randomly assigned mechanically ventilated adults with sepsis to receive dexmedetomidine (0.2 to 1.5 g per kilogram of body weight per hour) or propofol (5 to 50 g per kilogram per minute), with doses adjusted by bedside nurses to achieve target sedation goals set by clinicians according to the Richmond Agitation-Sedation Scale (RASS, on which scores range from -5 [unresponsive] to +4 [combative]). The primary end point was days alive without delirium or coma during the 14-day intervention period. Secondary end points were ventilator-free days at 28 days, death at 90 days, and age-adjusted total score on the Telephone Interview for Cognitive Status questionnaire (TICS-T; scores range from 0 to 100, with a mean of 50 10 and lower scores indicating worse cognition) at 6 months.",
       "highlight": "mechanically ventilated adults with sepsis to receive dexmedetomidine (0.2 to 1.5 g per kilogram of body weight per hour) or propofol",
       "scope": "different-population",
       "note": "Comparator is PROPOFOL (not a benzodiazepine) and the population is ventilated adults with SEPSIS — a different comparator and population than the claim's 'vs benzodiazepines.'",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "In this multicenter, double-blind, randomized, controlled trial involving mechanically ventilated adults with sepsis who were being treated with recommended light-sedation approaches, we did not find evidence that sedation with dexmedetomidine led to more days alive without acute brain dysfunction than propofol.",
       "highlight": "we did not find evidence that sedation with dexmedetomidine led to more days alive without acute brain dysfunction than propofol",
       "scope": "different-intervention",
       "note": "Null primary result: no difference from propofol in days alive without delirium or coma, so it does not support a delirium-reduction claim, and the comparator is propofol rather than a benzodiazepine.",
       "page": "ms. p.9",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "Data on organ dysfunction and safety end points by group are shown in Tables S6 and S7, respectively. The proportions of patients who had organ dysfunction, hypotension, or severe lactic acidosis after randomization were similar in the two groups. Symptomatic bradycardia requiring discontinuation of the trial drug was similar in the two groups (Table S2). Fewer patients in the dexmedetomidine group had acute respiratory distress syndrome (ARDS) or signs of trial drug withdrawal, and fewer patients in the propofol group extubated themselves. Median plasma triglyceride levels and the proportion of patients with severely elevated levels of trigliceride (>500 mg per deciliter) were quantitatively higher in the propofol group than in the dexmedetomidine group on days 7 and 14, although these differences are unlikely to be clinically relevant. Similarly, median plasma cortisol levels at day 14 were slightly lower in the dexmedetomidine group than in the propofol group, including a higher proportion of patients with low cortisol (<20 g per deciliter). Clinicians had access to these results without indication of group assignment and discontinued the trial drug in eight patients owing to hypertriglyceridemia. One patient had suspected propofolrelated infusion syndrome (later disproved) and had the propofol discontinued.",
       "highlight": "Symptomatic bradycardia requiring discontinuation of the trial drug was similar in the two groups",
       "scope": "different-intervention",
       "note": "Hypotension and symptomatic bradycardia were similar to propofol here (vs the increased bradycardia PADIS reports for dex-vs-propofol) — relevant to the monitoring caveat but from a propofol comparator, not benzodiazepine.",
       "page": "ms. p.9",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "Haloperidol PI",
     "cite": "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
     "paragraphs": [
      {
       "context": "In general, the symptoms of overdosage would be an exaggeration of known pharmacologic effects and adverse reactions, the most prominent of which would be: 1) severe extrapyramidal reactions, 2) hypotension, or 3) sedation. The patient would appear comatose with respiratory depression and hypotension which could be severe enough to produce a shock-like state. The extrapyramidal reactions would be manifested by muscular weakness or rigidity and a generalized or localized tremor as demonstrated by the akinetic or agitans types respectively. With accidental overdosage, hypertension rather than hypotension occurred in a two-year old child. The risk of ECG changes associated with torsade de pointes should be considered. (For further information regarding torsade de pointes, please refer to ADVERSE REACTIONS.)",
       "highlight": "hypotension, or 3) sedation",
       "scope": "different-intervention",
       "note": "Haloperidol (an antipsychotic) prescribing info is bundled in the Sedation section for antipsychotic cautions; the shared keywords 'hypotension'/'sedation' describe haloperidol overdose effects, not the dexmedetomidine-vs-benzodiazepine claim.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      }
     ]
    },
    {
     "label": "Hodgson 2014",
     "cite": "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
     "paragraphs": [
      {
       "context": "These findings are contributing to a shift in ICU clinical practice, where patients who once would have received deep sedation and bed rest, are now less heavily sedated and receive early progressive mobilization [23].",
       "highlight": "now less heavily sedated and receive early progressive mobilization",
       "scope": "different-intervention",
       "note": "Consensus safety criteria for early mobilization — a different intervention; mentions lighter sedation only as background context, not dexmedetomidine vs benzodiazepine.",
       "page": "",
       "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y"
      }
     ]
    },
    {
     "label": "Early Mobility",
     "cite": "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
     "paragraphs": [
      {
       "context": "Early mobility is an integral part of the ABCDEF Bundle and has been the only intervention resulting in a decrease in days of delirium.",
       "highlight": "has been the only intervention resulting in a decrease in days of delirium",
       "scope": "different-intervention",
       "note": "Vanderbilt CIBS early-mobility page (archived web): the 'E' of the ABCDEF bundle — a different intervention; shares 'delirium' but does not address dexmedetomidine or benzodiazepines.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2025 is the governing on-scope source and supports the statement's clinical substance: dexmedetomidine is preferred over propofol for sedation in ventilated ICU adults where reducing delirium is a priority (delirium RR 0.55), with an increased bradycardia risk and a hypotension caveat to monitor. The claim's \"vs benzodiazepines\" framing traces to the 2018 PADIS recommendation (dexmedetomidine OR propofol over benzodiazepines), which the 2025 focused update did not re-address and so remains the current position — but the 2025 quantified delirium reduction is vs propofol, and MENDS2 (dexmedetomidine vs propofol in sepsis) found no delirium/coma-free difference, so none of these sources demonstrates a benzodiazepine-comparator delirium reduction; Haloperidol PI, Hodgson 2014, and the early-mobility page are different-intervention references bundled into the Sedation section, not support for this statement.",
   "discrepancy": true
  },
  {
   "id": "spa-r28",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Deeper guidance — S — Sedation",
   "statement": "Propofol acceptable short-term; reassess need daily.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MENDS2 2021",
    "Haloperidol PI",
    "Hodgson 2014",
    "Early Mobility"
   ],
   "anchor": "PADIS 2025 — p. 7",
   "passage": "… Table of Recommendations No. Recommendations Recommendation Strength, Direction, and Certainty of Evidence Pain, Agitation/Sedation, Delirium, Immobility, and Sleep Disruption 2018 Recommendations 1 There is insufficient evidence to make a recommendation on the use of benzodiazepines to treat anxiety in adult patients admitted to the ICU No recommendation; no evidence available No recommendations previously existed 2 We suggest using dexmedetomidine over propofol for se dation in mechanically ventilated adult patients admitted to the ICU where light sedation and/or a reduction in delirium are of highest priorities Conditional recommen dation; for intervention; moderate certainty We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, me chanically ventilated adults (conditional recommenda tion, low quality of evidence) 3 We are unable to issue a recommendation for or against the use of antipsychotics over usual care for the treat ment of delirium in adult patients admitted to the ICU Conditional recommenda tion; for intervention or comparison; low certainty We suggest not routinely using haloperidol or an atyp ical antipsychotic, to treat delirium (conditional recom mendation, low quality of evidence) 4 We suggest providing enhanced mobilization/rehabilita tion over usual care mobilization/rehabilitation to adult patients admitted to the ICU Conditional recommen dation; for intervention; moderate certainty We sugges …\nPropofol is endorsed over benzodiazepines, though PADIS 2025 prefers dexmedetomidine over propofol where delirium reduction is a priority. The short-term-use and daily-reassessment qualifiers are not stated in the source.",
   "evidence": "Full text, p. 7 — partial support",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
    "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
    "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Current guideline (primary anchor, p.7): keeps propofol acceptable but conditionally prefers dexmedetomidine; does not state 'short-term' or 'reassess daily'.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence)",
       "highlight": "using either propofol or dexmedetomidine over benzodiazepines for sedation",
       "scope": "on-scope",
       "note": "Restated 2018 recommendation naming propofol as an accepted sedative (over benzodiazepines) for ventilated ICU adults, supporting 'propofol acceptable'.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "In adult patients admitted to the ICU, the task force issued conditional recommendations to use dexmedetomidine over propofol for sedation, provide enhanced mobilization/rehabilitation over usual mobilization/rehabilitation, and administer melatonin. The task force was unable to issue recommendations on the administration of benzodiazepines to treat anxiety, and the use of antipsychotics to treat delirium.",
       "highlight": "use dexmedetomidine over propofol for sedation",
       "scope": "on-scope",
       "note": "The focused-update recommendation conditionally prefers dexmedetomidine over propofol when light sedation/delirium reduction are prioritized - a nuance the bedside line 'propofol acceptable' simplifies.",
       "page": "ms. p.1",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "has delirium, clinical judgment must be used. If a patient requires deep sedation or has a high risk of bradycardia, alternative sedative agents should be considered. The cost of dexmedetomidine acquisition for many hospitals is now lower than when initially marketed, and the cost of propofol and dexmedetomidine are likely comparable in many countries. However, there is significant variability in costs and availability of dexmedetomidine. Therefore, cost and ability to obtain dexmedetomidine may well be prohibitive in some centers and hence our recommendation is conditional rather than strong.",
       "highlight": "If a patient requires deep sedation or has a high risk of bradycardia, alternative sedative agents should be considered",
       "scope": "on-scope",
       "note": "Confirms propofol remains appropriate where deep sedation is required or bradycardia risk is high (with comparable cost), reinforcing propofol acceptability.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "RCT in ventilated adults with sepsis; supports propofol as acceptable/equivalent to dexmedetomidine, short-term use, within a daily SAT/ABCDE reassessment framework.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "Although recent data suggest that many critically ill adults receiving mechanical ventilation may not require sedative infusions,38,39 our trial specifically enrolled adults with sepsis who had a high severity of illness, a greater risk for ARDS, and a higher requirement for continuous sedation. It was important to better characterize the effect of greater arousability, analgesic properties, and lack of respiratory depression observed with dexmedetomidine as compared with GABAergic sedatives in this population. Data indicate meaningful differences between dexmedetomidine and GABAergic sedatives with respect to innate immunity and risk of infection, including evidence that dexmedetomidine may offer superior antiinflammatory effects.11-17 Despite these theoretical benefits and studies supporting the use of dexmedetomidine, the choice between dexmedetomidine and propofol alone does not appear to substantially affect patient outcomes in the complex milieu of critical illness with sepsis. Our findings, therefore, strongly reinforce current guidelines24 that recommend the use of either dexmedetomidine or propofol for light sedation when continuous sedation is needed for adults with or without sepsis who require mechanical ventilation.",
       "highlight": "either dexmedetomidine or propofol for light sedation when continuous sedation is needed",
       "scope": "on-scope",
       "note": "Trial conclusion reinforces guidelines endorsing propofol (or dexmedetomidine) for light sedation in ventilated adults with or without sepsis — direct support for 'propofol acceptable'.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "CONCLUSIONS--Among mechanically ventilated adults with sepsis who were being treated with recommended light-sedation approaches, outcomes in patients who received dexmedetomidine did not differ from outcomes in those who received propofol. (Funded by the National Institutes of Health; ClinicalTrials.gov number, NCT01739933.)",
       "highlight": "outcomes in patients who received dexmedetomidine did not differ from outcomes in those who received propofol",
       "scope": "on-scope",
       "note": "Propofol produced outcomes equivalent to dexmedetomidine (days alive without delirium/coma); tested population is sepsis but the authors generalize.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "RESULTS--Of 432 patients who underwent randomization, 422 were assigned to receive a trial drug and were included in the analyses -- 214 patients received dexmedetomidine at a median dose of 0.27 g per kilogram per hour, and 208 received propofol at a median dose of 10.21 g per kilogram per minute. The median duration of receipt of the trial drugs was 3.0 days (interquartile range, 2.0 to 6.0), and the median RASS score was -2.0 (interquartile range, -3.0 to -1.0). We found no difference between dexmedetomidine and propofol in the number of days alive without Author Manuscript Author Manuscript N Engl J Med.",
       "highlight": "The median duration of receipt of the trial drugs was 3.0 days",
       "scope": "on-scope",
       "note": "Propofol/dexmedetomidine were given for a median of about 3 days, consistent with the 'short-term' framing.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "Administration of the trial drug was temporarily held in the event of hypotension, bradycardia, sedation deeper than the target level, spontaneous awakening trials, or surgery. The trial drug was permanently discontinued if the patient had persistent symptomatic bradycardia, new onset second- or third-degree heart block, serious allergic reactions, suspected propofol-related infusion syndrome (refractory shock, rhabdomyolysis, acidosis, and kidney failure related to high propofol exposure), or any serious adverse event related to the intervention. The trial drug was discontinued after the 14-day intervention period, extubation, or discharge from the ICU, whichever came first. Patients whose trachea was extubated and reintubated within the 14-day intervention period resumed the trial drug if sedation was indicated.",
       "highlight": "spontaneous awakening trials",
       "scope": "on-scope",
       "note": "Sedative was held for spontaneous awakening trials within the ABCDE bundle (daily adherence recorded) — operationalizes 'reassess need daily'.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "Haloperidol PI",
     "cite": "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "background",
     "note": "Antipsychotic label; only a keyword-level parallel ('shortest duration / reassess periodically'), a different drug/intervention from propofol sedation.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
     "paragraphs": [
      {
       "context": "Given these considerations, antipsychotic drugs should be prescribed in a manner that is most likely to minimize the occurrence of tardive dyskinesia. Chronic antipsychotic treatment should generally be reserved for patients who suffer from a chronic illness that, 1) is known to respond to antipsychotic drugs, and, 2) for whom alternative, equally effective, but potentially less harmful treatments are not available or appropriate. In patients who do require chronic treatment, the smallest dose and the shortest duration of treatment producing a satisfactory clinical response should be sought. The need for continued treatment should be reassessed periodically.",
       "highlight": "The need for continued treatment should be reassessed periodically",
       "scope": "different-intervention",
       "note": "This shortest-duration/periodic-reassessment guidance is for chronic antipsychotic (haloperidol) therapy, not propofol sedation — a keyword match, not support for the propofol statement.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      }
     ]
    },
    {
     "label": "Hodgson 2014",
     "cite": "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
     "kind": "pdf",
     "stance": "background",
     "note": "Mobilization safety-criteria consensus; addresses sedation only as an enabler of early mobility, not sedative choice or daily reassessment.",
     "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
     "paragraphs": [
      {
       "context": "These findings are contributing to a shift in ICU clinical practice, where patients who once would have received deep sedation and bed rest, are now less heavily sedated and receive early progressive mobilization [23].",
       "highlight": "are now less heavily sedated and receive early progressive mobilization",
       "scope": "different-intervention",
       "note": "About early mobilization, not propofol acceptability; mentions lighter sedation only as context for mobilizing patients — a different intervention from the sedation statement.",
       "page": "",
       "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y"
      }
     ]
    },
    {
     "label": "Early Mobility",
     "cite": "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived early-mobility reference page (CIBS Center); topic is mobility, so relevance is keyword-level ('daily interruption of sedation').",
     "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
     "paragraphs": [
      {
       "context": "104 patients randomized to early exercise and mobilization (physical and occupational therapy) during periods of daily interruption of sedation or to daily interruption of sedation with therapy as ordered by the primary care team.",
       "highlight": "daily interruption of sedation",
       "scope": "different-intervention",
       "note": "Describes the Schweickert early-mobility trial's use of daily sedation interruption; the page's subject is mobility, making this a keyword-level nearest match rather than direct support for propofol acceptability.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
      }
     ]
    }
   ],
   "synthesis": "On-scope sources agree that propofol is an acceptable sedative for mechanically ventilated ICU adults: MENDS2 found propofol equivalent to dexmedetomidine (median use ~3 days, held daily for spontaneous awakening trials) and reinforced guidance endorsing either agent for light sedation, while the PADIS 2025 focused update keeps propofol acceptable but now conditionally prefers dexmedetomidine where light sedation/delirium reduction are prioritized — PADIS governs as the current guideline. Neither states a propofol-specific \"reassess daily\" rule; that reflects the standing light-sedation/ABCDE daily-assessment framework, which remains the current position, and the haloperidol label, Hodgson mobilization criteria, and Early Mobility page are different-intervention nearest matches (antipsychotic reassessment, sedation-lightening for mobility) that share keywords only and do not directly support the statement.",
   "discrepancy": true
  },
  {
   "id": "spa-r29",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Deeper guidance — S — Sedation",
   "statement": "Avoid midazolam / lorazepam for routine sedation.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MENDS2 2021",
    "Haloperidol PI",
    "Hodgson 2014",
    "Early Mobility"
   ],
   "anchor": "PADIS 2025 — p. 7",
   "passage": "… Table of Recommendations No. Recommendations Recommendation Strength, Direction, and Certainty of Evidence Pain, Agitation/Sedation, Delirium, Immobility, and Sleep Disruption 2018 Recommendations 1 There is insufficient evidence to make a recommendation on the use of benzodiazepines to treat anxiety in adult patients admitted to the ICU No recommendation; no evidence available No recommendations previously existed 2 We suggest using dexmedetomidine over propofol for se dation in mechanically ventilated adult patients admitted to the ICU where light sedation and/or a reduction in delirium are of highest priorities Conditional recommen dation; for intervention; moderate certainty We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, me chanically ventilated adults (conditional recommenda tion, low quality of evidence) 3 We are unable to issue a recommendation for or against the use of antipsychotics over usual care for the treat ment of delirium in adult patients admitted to the ICU Conditional recommenda tion; for intervention or comparison; low certainty We suggest not routinely using haloperidol or an atyp ical antipsychotic, to treat delirium (conditional recom mendation, low quality of evidence) 4 We suggest providing enhanced mobilization/rehabilita tion over usual care mobilization/rehabilitation to adult patients admitted to the ICU Conditional recommen dation; for intervention; moderate certainty We sugges …\nMidazolam and lorazepam are benzodiazepines and thus fall under the recommendation against routine benzodiazepine sedation; PADIS 2018 makes the same recommendation.",
   "evidence": "Full text, p. 7",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
    "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
    "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary/governing source; the p.7 recommendation is the PADIS position restated in the 2025 focused update's summary of prior recommendations.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence)",
       "highlight": "using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults",
       "scope": "on-scope",
       "note": "Directly supports avoiding benzodiazepines (midazolam/lorazepam) for routine sedation: the guideline suggests propofol or dexmedetomidine over benzodiazepines in mechanically ventilated adults.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "In adult patients admitted to the ICU, the task force issued conditional recommendations to use dexmedetomidine over propofol for sedation, provide enhanced mobilization/rehabilitation over usual mobilization/rehabilitation, and administer melatonin. The task force was unable to issue recommendations on the administration of benzodiazepines to treat anxiety, and the use of antipsychotics to treat delirium.",
       "highlight": "use dexmedetomidine over propofol for sedation",
       "scope": "different-intervention",
       "note": "Nearest sedation recommendation in the 2025 update, but it compares two nonbenzodiazepines (dexmedetomidine vs. propofol) and does not itself address benzodiazepine avoidance.",
       "page": "ms. p.1",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Supports the claim by reciting and reinforcing the PADIS guideline; its own trial arm is a non-benzodiazepine-vs-non-benzodiazepine comparison.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "Guidelines currently recommend targeting light sedation with dexmedetomidine or propofol for adults receiving mechanical ventilation.",
       "highlight": "Guidelines currently recommend targeting light sedation with dexmedetomidine or propofol for adults receiving mechanical ventilation",
       "scope": "on-scope",
       "note": "MENDS2 recites the guideline recommendation to sedate with dexmedetomidine or propofol (i.e., not benzodiazepines) in mechanically ventilated adults, consistent with the claim.",
       "page": "abstract",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "Although recent data suggest that many critically ill adults receiving mechanical ventilation may not require sedative infusions,38,39 our trial specifically enrolled adults with sepsis who had a high severity of illness, a greater risk for ARDS, and a higher requirement for continuous sedation. It was important to better characterize the effect of greater arousability, analgesic properties, and lack of respiratory depression observed with dexmedetomidine as compared with GABAergic sedatives in this population. Data indicate meaningful differences between dexmedetomidine and GABAergic sedatives with respect to innate immunity and risk of infection, including evidence that dexmedetomidine may offer superior antiinflammatory effects.11-17 Despite these theoretical benefits and studies supporting the use of dexmedetomidine, the choice between dexmedetomidine and propofol alone does not appear to substantially affect patient outcomes in the complex milieu of critical illness with sepsis. Our findings, therefore, strongly reinforce current guidelines24 that recommend the use of either dexmedetomidine or propofol for light sedation when continuous sedation is needed for adults with or without sepsis who require mechanical ventilation.",
       "highlight": "use of either dexmedetomidine or propofol for light sedation",
       "scope": "on-scope",
       "note": "The trial's own conclusion reinforces the guideline recommending dexmedetomidine or propofol (non-benzodiazepines) for light sedation, supporting benzodiazepine avoidance.",
       "page": "ms. p.9",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      },
      {
       "context": "The Society of Critical Care Medicine24 recommends sedation with either dexmedetomidine or propofol targeted to light levels of sedation for adults receiving mechanical ventilation and continuous sedation. Given the superior immunomodulatory effects of dexmedetomidine and its benefit in patients with sepsis as compared with benzodiazepines, we designed the MENDS2 trial (Maximizing the Efficacy of Sedation and Reducing Neurological Dysfunction and Mortality in Septic Patients with Acute Respiratory Failure) to test whether dexmedetomidine leads to better short-term and long-term outcomes than propofol in mechanically ventilated adults with sepsis.",
       "highlight": "dexmedetomidine leads to better short-term and long-term outcomes than propofol",
       "scope": "different-intervention",
       "note": "MENDS2's own randomized comparison is dexmedetomidine vs propofol (two non-benzodiazepines) in sepsis, so it provides no head-to-head evidence on avoiding benzodiazepines.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "Haloperidol PI",
     "cite": "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Does not address benzodiazepine avoidance for sedation; a different drug (antipsychotic) with only a coincidental 'sedation' keyword.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
     "paragraphs": [
      {
       "context": "Patients with Parkinson's Disease or Dementia with Lewy Bodies are reported to have an increased sensitivity to antipsychotic medication. Manifestations of this increased sensitivity with haloperidol treatment include severe extrapyramidal symptoms, confusion, sedation, and falls. In addition, haloperidol may impair the antiparkinson effects of levodopa and other dopamine agonists. Haloperidol is contraindicated in patients with Parkinson's Disease or Dementia with Lewy Bodies (see CONTRAINDICATIONS).",
       "highlight": "confusion, sedation, and falls",
       "scope": "different-intervention",
       "note": "The only 'sedation' mention is haloperidol's adverse-effect profile (an antipsychotic) in Parkinson's/Lewy body disease; the label never mentions benzodiazepines and does not address sedative choice.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      }
     ]
    },
    {
     "label": "Hodgson 2014",
     "cite": "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Mobilization safety criteria (the 'M'/'E' of the bundle); off-topic for benzodiazepine avoidance, matches only on the word 'sedation.'",
     "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
     "paragraphs": [
      {
       "context": "These findings are contributing to a shift in ICU clinical practice, where patients who once would have received deep sedation and bed rest, are now less heavily sedated and receive early progressive mobilization [23].",
       "highlight": "deep sedation and bed rest, are now less heavily sedated",
       "scope": "different-intervention",
       "note": "Hodgson's topic is safety criteria for active mobilization; sedation depth is mentioned only as context for mobilizing, not as guidance on avoiding benzodiazepines or choosing a sedative agent.",
       "page": "",
       "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y"
      }
     ]
    },
    {
     "label": "Early Mobility",
     "cite": "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Archived early-mobility page; addresses mobility, not sedative choice — off-scope keyword match for this claim.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
     "paragraphs": [
      {
       "context": "The two videos above show how an awake and walking patient avoids delirium and weakness—a list of 14 benefits requiring sedation be fully OFF and metabolized AND benefits are not the same when a patient sits edge of bed or passively moves to a chair",
       "highlight": "requiring sedation be fully OFF and metabolized",
       "scope": "different-intervention",
       "note": "ABCDEF 'Early Mobility' page; sedation is mentioned only as a precondition for mobilizing (sedation off), not as guidance on benzodiazepine avoidance or sedative selection.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2025 (primary anchor, p. 7) governs the claim: it suggests propofol or dexmedetomidine over benzodiazepines for sedation in mechanically ventilated adults, and because the 2025 focused update re-addressed dexmedetomidine vs propofol but did not re-open the benzodiazepine question, this recommendation remains the current position; MENDS2 recites and reinforces the same guideline, though its own randomized arm compares two non-benzodiazepines (dexmedetomidine vs propofol in sepsis) rather than testing benzodiazepine avoidance directly. The haloperidol label, Hodgson mobilization criteria, and the Early Mobility page do not address sedative choice and match only on the word \"sedation,\" so they neither support nor contradict the claim.",
   "discrepancy": true
  },
  {
   "id": "spa-r30",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Deeper guidance — S — Sedation",
   "statement": "Exception: benzodiazepines are first-line for alcohol / benzodiazepine withdrawal.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MENDS2 2021",
    "Haloperidol PI",
    "Hodgson 2014",
    "Early Mobility"
   ],
   "anchor": "PADIS 2025 — p. 5",
   "passage": "… In addition, unidimensional self-assessment scales (e.g., Visual Analogue Scale, Numeric Rating Scale) could serve as pragmatic alternatives (9) for assessing anxiety (21, 22), and other distressing symptoms such as pain, dyspnea (23), and thirst (24). Nonpharmacological treatment approaches, such as music listening (21, 25) or virtual reality (22), have shown promise. A patientcentered approach to care, research, and quality im provement that encompasses all sources of discomfort and distress in the ICU is essential to providing compre hensive management of anxiety. Of note, abrupt cessation of benzodiazepines pre scribed for baseline chronic anxiety may precipitate acute withdrawal; hence, continuation of the chronic benzodiazepines upon admission to the ICU should be considered. DEXMEDETOMIDINE FOR SEDATION Recommendation 2 We suggest using dexmedetomidine over propofol for sedation in mechanically ventilated adult patients admitted to the ICU where light sedation and/or a\nPADIS 2025 supports continuing chronic benzodiazepines to avoid precipitating withdrawal but does not state that benzodiazepines are first-line treatment for alcohol or benzodiazepine withdrawal; that specific exception is not directly asserted in the cited sources.",
   "evidence": "Full text, p. 5 — partial support",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
    "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
    "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "partial",
     "note": "The only on-point source. Partially supports the statement: it grounds the benzodiazepine-withdrawal half but does not endorse benzodiazepines as first-line for alcohol withdrawal, and its general position is to prefer non-benzodiazepine sedatives.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "Of note, abrupt cessation of benzodiazepines prescribed for baseline chronic anxiety may precipitate acute withdrawal; hence, continuation of the chronic benzodiazepines upon admission to the ICU should be considered.",
       "highlight": "continuation of the chronic benzodiazepines upon admission to the ICU should be considered",
       "scope": "narrower",
       "note": "Supports only the benzodiazepine-withdrawal half of the exception, and frames it as continuing a patient's chronic benzodiazepines to avoid precipitating withdrawal (within the anxiety recommendation) rather than as first-line treatment; says nothing about alcohol withdrawal. This is the primaryAnchor page.",
       "page": "ms. p.5",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence)",
       "highlight": "using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults",
       "scope": "broader",
       "note": "The default general-sedation position this statement is framed as an exception to - the guideline prefers propofol/dexmedetomidine over benzodiazepines for routine sedation.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "The role of dexmedetomidine in alcohol withdrawal.",
       "highlight": "The role of dexmedetomidine in alcohol withdrawal",
       "scope": "background",
       "note": "In the research agenda the guideline lists alcohol-withdrawal pharmacotherapy as an unresolved question (studying dexmedetomidine), so it does not affirm benzodiazepines as first-line for the alcohol-withdrawal half of the statement.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "A dexmedetomidine-vs-propofol sedation trial in septic ventilated adults; supports the general avoid-benzodiazepines rule, not the withdrawal exception, and explicitly excluded patients with a benzodiazepine indication.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "We included adults who were sequentially admitted to a medical or surgical ICU, had suspected or known infection, and were treated with continuous sedation for invasive mechanical ventilation. Patients were excluded if they had baseline severe cognitive impairment; were pregnant or breast-feeding; were blind, deaf, or unable to understand approved languages; had second-degree or third-degree heart block or persistent bradycardia requiring intervention; had an allergy to dexmedetomidine or propofol; had an indication for benzodiazepines; were anticipated to have immediate discontinuation of mechanical ventilation; were expected to have neuromuscular blockade for more than 48 hours; were in a moribund state; or had received mechanical ventilation for more than 96 hours before meeting all inclusion criteria. Additional details on exclusion and inclusion criteria are provided in Section S1 in the Supplementary Appendix. We randomly assigned patients to receive dexmedetomidine or propofol in a 1:1 ratio using computer-generated permuted blocks stratified by enrollment site and age (<65 years vs. 65 years). Researchers, clinicians (except bedside nurses), patients, and families were unaware of the group assignments.",
       "highlight": "had an indication for benzodiazepines",
       "scope": "different-intervention",
       "note": "Shares the benzodiazepine keyword only as an exclusion criterion; the trial studied non-benzodiazepine sedatives and carved out the very population (benzodiazepine-indicated) the exception concerns, so it cannot be read as support.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "Haloperidol PI",
     "cite": "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Antipsychotic label cited for QTc/Torsades and Parkinson/Lewy-body cautions; its 'withdrawal' content is antipsychotic withdrawal-emergent dyskinesia and neonatal withdrawal, and 'alcohol' appears only as a CNS-depressant interaction — nothing on benzodiazepines for alcohol/benzodiazepine withdrawal.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
     "paragraphs": []
    },
    {
     "label": "Hodgson 2014",
     "cite": "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Consensus safety criteria for mobilizing mechanically ventilated ICU patients; cited for the mobility/de-sedation context and contains no content on benzodiazepines or withdrawal treatment.",
     "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
     "paragraphs": []
    },
    {
     "label": "Early Mobility",
     "cite": "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
     "kind": "web",
     "stance": "background",
     "note": "Archived Vanderbilt CIBS 'Early Mobility and Exercise' page cited for the E (early mobility) component of the ABCDEF bundle; contains only mobility content and nothing on benzodiazepines for withdrawal.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
     "paragraphs": []
    }
   ],
   "synthesis": "The governing on-point source is PADIS 2025, which only partially supports the statement: it advises continuing a patient's chronic benzodiazepines on ICU admission to avoid precipitating acute withdrawal (p. 5), which grounds the benzodiazepine-withdrawal part, but it does not affirm benzodiazepines as first-line for alcohol withdrawal — it lists dexmedetomidine's role in alcohol withdrawal as an open research question — and its general recommendation is to prefer propofol/dexmedetomidine over benzodiazepines. The other four sources (MENDS2, Haloperidol PI, Hodgson 2014, Early Mobility) are cited for adjacent parts of the sedation/ABCDEF guidance and do not address the exception, with MENDS2 explicitly excluding benzodiazepine-indicated patients.",
   "discrepancy": true
  },
  {
   "id": "spa-r31",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Deeper guidance — P — Pain / Pharmacy",
   "statement": "Haloperidol for hyperactive delirium with safety risk — baseline EKG, monitor QTc; IV route off-label, prefer PO/IM; avoid in Parkinson / Lewy body disease.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MENDS2 2021",
    "Haloperidol PI",
    "Hodgson 2014",
    "Early Mobility"
   ],
   "anchor": "Haloperidol PI — p. 3",
   "passage": "APPROVED FOR INTRAVENOUS ADMINISTRATION. If haloperidol is administered intravenously, the ECG should be monitored for QTc prolongation and arrhythmias. Tachycardia and hypotension (including orthostatic hypotension) have also been reported in occasional patients (see ADVERSE REACTIONS). Cerebrovascular Adverse Reactions In controlled trials, elderly patients with dementia-related psychosis treated with some antipsychotics had an increased risk (compared to placebo) of cerebrovascular adverse reactions (e.g., stroke, transient ischemic attack), including fatalities. The mechanism for this increased risk is not known. An increased risk cannot be excluded for haloperidol, other antipsychotics, or other patient populations. Haloperidol should be used with caution in patients with risk factors for cerebrovascular adverse reactions. …\nAlso Haloperidol PI: \"Haloperidol Injection is contraindicated in patients with: … Parkinson's disease … Dementia with Lewy bodies\"\nThe label states 'HALOPERIDOL INJECTION IS NOT APPROVED FOR INTRAVENOUS ADMINISTRATION,' carries a boxed cardiovascular warning (sudden death, QTc prolongation, torsades), and contraindicates use in Parkinson's disease and dementia with Lewy bodies (p. 2). The delirium indication itself is off-label; the label covers schizophrenia.",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
    "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
    "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Haloperidol PI",
     "cite": "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary on-scope source; the label directly supports QTc/ECG monitoring, IV being an unapproved (off-label) route with IM the labeled parenteral route, and the Parkinson/Lewy contraindication.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
     "paragraphs": [
      {
       "context": "Cases of sudden death, QTc interval-prolongation, and Torsades de Pointes have been reported in patients receiving haloperidol (see ADVERSE REACTIONS). Higher than recommended doses of any formulation and intravenous administration of haloperidol appear to be associated with a higher risk of QTc interval-prolongation and Torsades de Pointes. Also, a QTc interval that exceeds 500 msec is associated with an increased risk of Torsades de Pointes. Although cases have been reported even in the absence of predisposing factors, particular caution is advised in treating patients with other QTcprolonging conditions (including electrolyte imbalance [particularly hypokalemia and hypomagnesemia], drugs known to prolong QTc, underlying cardiac abnormalities, hypothyroidism, and familial long QT-syndrome). HALOPERIDOL INJECTION IS NOT APPROVED FOR INTRAVENOUS ADMINISTRATION.",
       "highlight": "intravenous administration of haloperidol appear to be associated with a higher risk of QTc interval-prolongation and Torsades de Pointes",
       "scope": "on-scope",
       "note": "Label ties IV administration and high doses to elevated QTc-prolongation/Torsades risk — the basis for QTc monitoring and for IV being off-label.",
       "page": "3",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      },
      {
       "context": "APPROVED FOR INTRAVENOUS ADMINISTRATION. If haloperidol is administered intravenously, the ECG should be monitored for QTc prolongation and arrhythmias.",
       "highlight": "the ECG should be monitored for QTc prolongation and arrhythmias",
       "scope": "on-scope",
       "note": "States haloperidol injection is not approved for IV use (off-label) and that ECG/QTc must be monitored if given IV — supports 'baseline EKG, monitor QTc; IV route off-label'.",
       "page": "3",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      },
      {
       "context": "Patients with Parkinson's Disease or Dementia with Lewy Bodies are reported to have an increased sensitivity to antipsychotic medication. Manifestations of this increased sensitivity with haloperidol treatment include severe extrapyramidal symptoms, confusion, sedation, and falls. In addition, haloperidol may impair the antiparkinson effects of levodopa and other dopamine agonists. Haloperidol is contraindicated in patients with Parkinson's Disease or Dementia with Lewy Bodies (see CONTRAINDICATIONS).",
       "highlight": "Haloperidol is contraindicated in patients with Parkinson's Disease or Dementia with Lewy Bodies",
       "scope": "on-scope",
       "note": "Directly supports 'avoid in Parkinson / Lewy body disease' — a labeled contraindication.",
       "page": "5",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      },
      {
       "context": "Haloperidol Injection, USP is available as a sterile parenteral form for intramuscular injection. Each mL of Haloperidol Injection, USP contains 5 mg haloperidol (as the lactate) with 1.8 mg methylparaben, 0.2 mg propylparaben and lactic acid for pH adjustment between 3.0 to 3.8.",
       "highlight": "sterile parenteral form for intramuscular injection",
       "scope": "on-scope",
       "note": "Approved parenteral route is IM (vial labels read 'For Intramuscular use ONLY') and the label directs an oral form to supplant the injectable as soon as practicable — supports 'prefer PO/IM'.",
       "page": "2",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Nearest guideline on haloperidol in ICU delirium, but a different question: it is unable to recommend antipsychotics for delirium and prescribes no safety-monitoring — it neither endorses the use nor governs the 'how to give it safely' guidance.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "We are unable to issue a recommendation for or against the use of antipsychotics over usual care for the treatment of delirium in adult patients admitted to the ICU (conditional recommendation; for intervention or comparison; low certainty of evidence).",
       "highlight": "We are unable to issue a recommendation for or against the use of antipsychotics over usual care for the treatment of delirium",
       "scope": "broader",
       "note": "Current PADIS position addresses whether to use antipsychotics for delirium at all — a broader efficacy question, not the safety-monitoring practice the claim describes; it does not endorse the use.",
       "page": "e718",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Most RCTs enrolled a mix of patients with either hypoactive and/or hyperactive delirium and, therefore, it is unclear if there is a single patient population that would benefit most from an antipsychotic. In addition, if used, one must be prudent to discontinue antipsychotics that were newly initiated in the ICU upon discharge if no longer clinically required (66).",
       "highlight": "it is unclear if there is a single patient population that would benefit most from an antipsychotic",
       "scope": "broader",
       "note": "Shares the 'hyperactive delirium' keyword but concludes the benefiting subtype is unclear — not support for specifically targeting hyperactive delirium.",
       "page": "e719",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "-0.35 to 2.86 d; low certainty) and may reduce 28-day mortality (RR, 0.87; 95% CI, 0.75-1.01; low certainty) and mortality at longest follow-up (RR, 0.89; 95% CI, 0.79-1.01; low certainty). There was little to no effect on the duration of invasive mechanical ventilation (moderate certainty), ICU length of stay (very low certainty), or hospital length of stay (low certainty). There was uncertainty regarding the effect on post-ICU posttraumatic stress disorder, functional status at 3 months, post-ICU quality of life, post-ICU cognitive impairment, and duration of delirium (all very low certainty). There may be a slight increase in the risk of arrhythmias (RR, 1.57; 95% CI, 0.66-3.74; low certainty), and little to no effect on QT interval prolongation and extrapyramidal symptoms (both low certainty).",
       "highlight": "little to no effect on QT interval prolongation and extrapyramidal symptoms",
       "scope": "broader",
       "note": "Pooled-RCT adverse-event data (arrhythmia/QT) from the efficacy review; consistent with the label's cardiac caution but not a monitoring recommendation.",
       "page": "e719",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Pain, Agitation/Sedation, Delirium, Immobility, and Sleep Disruption 2018 Recommendations No recommendations previously existed We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence) We suggest not routinely using haloperidol or an atypical antipsychotic, to treat delirium (conditional recommendation, low quality of evidence) We suggest performing rehabilitation or mobilization in critically ill adults (conditional recommendation, low quality evidence) We make no recommendation regarding the use of melatonin to improve sleep in critically ill adults (no recommendation, very low quality of evidence)",
       "highlight": "not routinely using haloperidol or an atypical antipsychotic, to treat delirium",
       "scope": "background",
       "note": "The prior 2018 recommendation, shown for context; the 2025 update revised this to 'unable to recommend'.",
       "page": "e717",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "background",
     "note": "Trial of dexmedetomidine vs propofol sedation in septic ventilated adults; mentions antipsychotics only as concomitant exposure and does not address haloperidol safety monitoring.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "*The reasons for temporary holding of the drug included oversedation, hypotension, or bradycardia; spontaneous awakening trials or times during which patients were not being sedated, were not receiving mechanical ventilation, or were in the operating room are not included. The Critical Care Pain Observation Tool (CPOT) is used to assess for pain by evaluating facial expression, body movement, muscle tension, and adherence to use of the ventilator if intubated or vocalization if extubated. Total scores range from 0 to 8, with scores higher than 2 indicating the presence of pain. The ABCDE bundle includes evaluations for awakening and breathing coordination, choice of sedation, delirium monitoring and management, and early mobility. Values shown are in intravenous haloperidol equivalents.",
       "highlight": "intravenous haloperidol equivalents",
       "scope": "different-intervention",
       "note": "Only reports antipsychotic exposure normalized to IV haloperidol equivalents (42% of patients received an antipsychotic); the intervention studied is a sedation choice, not haloperidol dosing/monitoring.",
       "page": "1430",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "Hodgson 2014",
     "cite": "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
     "kind": "pdf",
     "stance": "background",
     "note": "Consensus safety criteria for active mobilization of ventilated adults — a different ABCDEF bundle element; contains no haloperidol/antipsychotic pharmacology content.",
     "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
     "paragraphs": [
      {
       "context": "The safety criteria covered by the consensus group were divided into four categories: (1) respiratory considerations, including intubation status, ventilatory parameters and the need for adjunctive therapies; (2) cardiovascular considerations, including the presence of devices, cardiac arrhythmias and blood pressure; (3) neurological considerations, including level of consciousness, delirium and intracranial pressure, and (4) other considerations, including lines and surgical or medical conditions.",
       "highlight": "cardiac arrhythmias and blood pressure",
       "scope": "background",
       "note": "'Cardiac arrhythmias' here is a mobilization-clearance consideration, not a haloperidol monitoring criterion — shares a keyword but is off-scope for this claim.",
       "page": "3",
       "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y"
      }
     ]
    },
    {
     "label": "Early Mobility",
     "cite": "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "background",
     "note": "Archived CIBS Center / ICUDelirium.org page on the Early Mobility (E) bundle element; no pharmacologic or haloperidol content — does not bear on this claim (cited by section, not for this statement).",
     "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
     "paragraphs": []
    }
   ],
   "synthesis": "The Haloperidol prescribing information is the on-scope source and directly supports each safety element in the statement: IV administration and high doses raise QTc-prolongation/Torsades risk with ECG monitoring required (basis for baseline EKG / monitor QTc), IV is not an approved route (off-label) while IM is the labeled parenteral route with oral to supplant it (prefer PO/IM), and haloperidol is contraindicated in Parkinson disease and Lewy body dementia — so the label governs the claim. PADIS 2025 is the nearest guideline on haloperidol in ICU delirium but answers a different question (it remains unable to recommend antipsychotics for delirium and prescribes no safety monitoring), and MENDS2 and the two mobilization sources are off-scope for this pharmacology statement.",
   "discrepancy": true
  },
  {
   "id": "spa-r32",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Deeper guidance — P — Pain / Pharmacy",
   "statement": "Quetiapine when the oral route is available — monitor QTc and orthostasis.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MENDS2 2021",
    "Haloperidol PI",
    "Hodgson 2014",
    "Early Mobility",
    "Quetiapine PI"
   ],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "web",
   "pageNum": null,
   "citations": [],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Quetiapine PI",
     "cite": "Seroquel (quetiapine fumarate) prescribing information — QTc prolongation and orthostatic hypotension. DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "partial",
     "note": "The label states orthostatic hypotension outright. Its QT section is more qualified than the item’s monitoring instruction: quetiapine was not associated with a persistent QT increase in clinical trials, and the reported prolongation is in overdose, concomitant illness, co-administered QT-prolonging drugs, and named risk groups including the elderly.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=0584dda8-bc3c-48fe-1a90-79608f78e8a0",
     "paragraphs": [
      {
       "context": "Quetiapine may induce orthostatic hypotension associated with dizziness, tachycardia and, in some patients, syncope, especially during the initial dose-titration period, probably reflecting its alpha-adrenergic antagonist properties. Syncope was reported in 1% (28/3265) of the patients treated with SEROQUEL, compared with 0.2% (2/954) on placebo and about 0.4% (2/527) on active control drugs. Orthostatic hypotension, dizziness, and syncope may lead to falls.",
       "highlight": "Quetiapine may induce orthostatic hypotension associated with dizziness, tachycardia and, in some patients, syncope, especially during the initial dose-titration period",
       "scope": "on-scope",
       "note": "Direct support for the orthostasis half of the item.",
       "page": "§5.7 Orthostatic Hypotension",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=0584dda8-bc3c-48fe-1a90-79608f78e8a0"
      },
      {
       "context": "5.12 QT Prolongation. In clinical trials, quetiapine was not associated with a persistent increase in QT intervals. However, the QT effect was not systematically evaluated in a thorough QT study. In post marketing experience, there were cases reported of QT prolongation in patients who overdosed on quetiapine, in patients with concomitant illness, and in patients taking medicines known to cause electrolyte imbalance or increase QT interval. The use of quetiapine should be avoided in combination with other drugs that are known to prolong QTc.",
       "highlight": "In clinical trials, quetiapine was not associated with a persistent increase in QT intervals",
       "scope": "narrower",
       "note": "Read this before treating the item’s QTc instruction as label-directed. The label’s concern is concentrated in overdose, co-administration and named risk groups rather than routine monitoring.",
       "page": "§5.12 QT Prolongation",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=0584dda8-bc3c-48fe-1a90-79608f78e8a0"
      }
     ]
    }
   ],
   "synthesis": "Antipsychotics are reserved for hyperactive delirium with a safety risk; when quetiapine is used, its dose-related QTc prolongation and orthostatic hypotension are the monitoring concerns documented in the product label.",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "spa-r33",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Deeper guidance — P — Pain / Pharmacy",
   "statement": "Scheduled acetaminophen as an opioid-sparing adjunct.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MENDS2 2021",
    "Haloperidol PI",
    "Hodgson 2014",
    "Early Mobility",
    "PADIS 2018"
   ],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "fulltext",
   "pageNum": null,
   "citations": [],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Recommends acetaminophen as an adjunct to an opioid to reduce pain and opioid use.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "We suggest using acetaminophen as an adjunct to an opioid to decrease pain intensity and opioid consumption for pain management in critically ill adults (conditional recommendation, very low quality of evidence).",
       "highlight": "acetaminophen as an adjunct to an opioid to decrease pain intensity and opioid consumption",
       "scope": "on-scope",
       "note": "",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2018 conditionally recommends acetaminophen as an opioid-sparing adjunct in critically ill adults — the basis for this analgesia-first line.",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "spa-r34",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Deeper guidance — P — Pain / Pharmacy",
   "statement": "Pharmacy consult for CAM-positive patients or a high sedative burden.",
   "contentType": "Cited clinical content",
   "sources": [],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "structure",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": "An operational referral prompt. When to involve pharmacy — for a CAM-positive patient or a high sedative burden — is a local-practice decision, not a citable clinical threshold.",
   "perSource": [],
   "synthesis": "",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "spa-r35",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Deeper guidance — P — Pain / Pharmacy",
   "statement": "Check electrolytes; evaluate for infection / occult sepsis in new delirium.",
   "contentType": "Cited clinical content",
   "sources": [],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "structure",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": "A standard new-delirium workup step — identify and treat precipitants (electrolyte derangement, occult infection/sepsis), per the DELIRIUM(S) differential and NICE CG103's 'find and manage the underlying cause' principle. Do not attribute delirium to asymptomatic bacteriuria (Nicolle 2019).",
   "perSource": [],
   "synthesis": "",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "spa-r36",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Deeper guidance — A — Activity / Awareness",
   "statement": "Every device is a barrier to mobility — remove urinary catheters early; least-restrictive restraints.",
   "contentType": "Cited clinical content",
   "sources": [],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "structure",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": "Two standard measures: minimize immobilizing devices — remove urinary catheters early (a mobility barrier, per the ICU Liberation early-mobility element) — and use the least-restrictive form of restraint when one is unavoidable (NICE NG10). Implementation guidance rather than a single cited threshold.",
   "perSource": [],
   "synthesis": "",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "spa-r37",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Deeper guidance — A — Activity / Awareness",
   "statement": "Mobility progression: passive ROM → active ROM → sit / edge of bed → stand / transfer → ambulate.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MENDS2 2021",
    "Haloperidol PI",
    "Hodgson 2014",
    "Early Mobility"
   ],
   "anchor": "Early Mobility: \"It consists of activities from passive range of motion to ambulation.\"",
   "passage": "The ICUDelirium page supports the passive-ROM-to-ambulation spectrum but does not spell out the intermediate steps (sit/edge of bed, stand/transfer). The full text of Hodgson 2014 was not available for verification.",
   "evidence": "Web page — partial support",
   "status": "web",
   "pageNum": null,
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
    "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
    "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
    "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Early Mobility",
     "cite": "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Archived ICUDelirium.org page; directly states early mobility spans passive ROM to ambulation, with activity level graded by RASS.",
     "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
     "paragraphs": [
      {
       "context": "It consists of activities from passive range of motion to ambulation. The level of activity for each patient can be determined by the patient’s RASS score.",
       "highlight": "It consists of activities from passive range of motion to ambulation.",
       "scope": "on-scope",
       "note": "States the full mobility spectrum from passive range of motion to ambulation, and that the activity level is set by the patient's RASS score, matching the graded progression's endpoints.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
      },
      {
       "context": "The two videos above show how an awake and walking patient avoids delirium and weakness—a list of 14 benefits requiring sedation be fully OFF and metabolized AND benefits are not the same when a patient sits edge of bed or passively moves to a chair",
       "highlight": "a patient sits edge of bed or passively moves to a chair",
       "scope": "background",
       "note": "Names intermediate rungs (sitting at edge of bed, moving to chair) but within a list contrasting the benefits of awake walking versus sitting, not as a progression sequence.",
       "page": "",
       "docUrl": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
      }
     ]
    },
    {
     "label": "Hodgson 2014",
     "cite": "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Consensus safety criteria for active mobilization of mechanically ventilated ICU adults; enumerates the active rungs but explicitly excludes passive mobilization and is population-narrower than the general claim.",
     "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
     "paragraphs": [
      {
       "context": "The group decided that recommendations would be developed only for active mobilization and that no guidance would be provided with respect to safety criteria for passive mobilization. Active mobilization was defined as any activity where the patient assists with the activity using their own muscle strength and control: the patient may need assistance from staff or equipment, but they are actively participating in the exercise. Activities that comprise active mobilization are out-of-bed mobilization (that is, any activity where the patient sits over the edge of the bed (dangling), stands, walks, marches on the spot or sits out of bed) and in-bed mobilization (that is, any activity undertaken whilst the patient is sitting or lying in bed such as rolling, bridging, upper-limb weight training). The level of mobilization should be determined by the patient’s strength and endurance, as well as an assessment of the safety criteria.",
       "highlight": "the patient sits over the edge of the bed (dangling), stands, walks, marches on the spot or sits out of bed",
       "scope": "narrower",
       "note": "Enumerates the out-of-bed active rungs (edge-of-bed sitting to standing to walking, level determined by strength and endurance), directly matching the upper rungs, but scoped to mechanically ventilated adults and to active mobilization only.",
       "page": "2",
       "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y"
      },
      {
       "context": "The group provided recommendations for active mobilization. No guidance was provided with respect to safety criteria for passive mobilization Hodgson et al.",
       "highlight": "No guidance was provided with respect to safety criteria for passive mobilization",
       "scope": "narrower",
       "note": "Explicitly excludes passive mobilization, so it does not cover the ladder's first rung (passive ROM) that the general claim includes.",
       "page": "1",
       "docUrl": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "background",
     "note": "Focused-update guideline recommends enhanced mobilization/rehabilitation (its current position) but does not re-address or describe a step-wise passive-to-ambulate progression.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "Enhanced mobilization/rehabilitation compared with usual care mobilization/rehabilitation reduces the proportion of patients that develop ICU-acquired weakness (RR, 0.77; 95% CI, 0.64-0.93; ARR, 9 fewer per 100 patients; 95% CI, 14 fewer to 3 fewer; high certainty).",
       "highlight": "Enhanced mobilization/rehabilitation compared with usual care mobilization/rehabilitation",
       "scope": "broader",
       "note": "Recommends enhanced over usual-care mobilization/rehabilitation generally rather than prescribing a progression order, so it is broader than the specific ladder.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Rehabilitation and mobilization in the ICU aim to mitigate the long-term effects of ICU-acquired weakness (e.g., survival and quality of life) (67), yet the appropriate frequency, intensity, duration, or delivery of these interventions is not established. We adopted a previously established definition of mobilization: \"the process of moving oneself and of changing and maintaining postures,\" excluding pulmonary rehabilitation (68). We defined enhanced to be anything more than a unit's usual mobilization/rehabilitation (e.g., enhanced may include one of: cycling, stepping, early, twice daily, protocolized, or extended durations of mobilization/ rehabilitation).",
       "highlight": "enhanced may include one of: cycling, stepping, early, twice daily, protocolized",
       "scope": "broader",
       "note": "Defines mobilization content by intensity/frequency examples (cycling, stepping, twice daily, protocolized), not as a passive-to-ambulate sequence.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "MENDS2 2021",
     "cite": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Sedation RCT (dexmedetomidine vs propofol) in septic ventilated adults; references early mobilization only as an ABCDE-bundle adherence measure, not a progression.",
     "docUrl": "https://doi.org/10.1056/NEJMoa2024922",
     "paragraphs": [
      {
       "context": "Median days of receipt of drug (IQR) Median days from first meeting trial criteria to initiation of drug (IQR) Median daily volume on days administered (IQR) -- ml Median daily dose on days administered (IQR) Median total no. of drug adjustments per patient (IQR) Drug temporarily held -- no. (%)* Median no. of times drug temporarily held per patient (IQR) Drug permanently discontinued -- no. (%) Trial or clinical team aware of the drug used -- no. (%) Withdrawal from trial during hospitalization -- no. (%) Median RASS score while receiving drug (IQR) Percent time at target sedation level while receiving drug Median CPOT score while receiving drug (IQR) Percent of days with adherence to ABCDE bundle Spontaneous awakening trial Spontaneous breathing trial Coordination of awakening and breathing trials Nondrug delirium interventions Early mobilization Median daily fentanyl dose on days administered (IQR) -- g/hr Midazolam exposure Ever used -- no. (%) Median days among users (IQR)",
       "highlight": "Early mobilization",
       "scope": "background",
       "note": "Appears only as a checkbox item in the ABCDE-bundle adherence table; does not describe any mobility progression.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    },
    {
     "label": "Haloperidol PI",
     "cite": "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Prescribing information; the only 'ambulat-' hit is a false keyword match unrelated to mobility progression.",
     "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
     "paragraphs": [
      {
       "context": "Haloperidol may impair the mental and/or physical abilities required for the performance of hazardous tasks such as operating machinery or driving a motor vehicle. The ambulatory patient should be warned accordingly.",
       "highlight": "The ambulatory patient should be warned accordingly",
       "scope": "background",
       "note": "Uses 'ambulatory' to mean an outpatient in a driving/machinery caution, not ambulation as a mobility rung, so it does not bear on the progression claim.",
       "page": "",
       "docUrl": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      }
     ]
    }
   ],
   "synthesis": "The on-scope governing source is the ICUDelirium.org Early Mobility page, which frames ICU early mobility as a graded spectrum \"from passive range of motion to ambulation\" (activity level set by RASS), directly supporting the progression's endpoints. Hodgson 2014 is the nearest granular match but narrower — it enumerates the active rungs (edge-of-bed sitting to standing to walking, level set by strength/endurance) yet is specific to mechanically ventilated adults and explicitly declines to address passive mobilization (the ladder's first rung); PADIS 2025 recommends enhanced mobilization/rehabilitation (its current position) without describing a step-wise progression, and MENDS2 and the haloperidol label do not address the progression.",
   "discrepancy": true
  },
  {
   "id": "spa-r38",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Deeper guidance — A — Activity / Awareness",
   "statement": "T-A-D-A: Tolerate, Anticipate triggers, Don’t Agitate.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MENDS2 2021",
    "Haloperidol PI",
    "Hodgson 2014",
    "Early Mobility",
    "Flaherty & Little 2011"
   ],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "guideline",
   "pageNum": null,
   "citations": [],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Flaherty & Little 2011",
     "cite": "Flaherty JH, Little MO. Matching the environment to patients with delirium: lessons learned from the delirium room. J Am Geriatr Soc. 2011;59(Suppl 2):S295-S300.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Describes the T-A-D-A method: Tolerate, Anticipate, Don't Agitate.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/22091576/",
     "paragraphs": [
      {
       "context": "This article is based on 13 years of experience at two hospitals. The authors have found that a restraint-free environment can be achieved; “tolerate, anticipate, and don't agitate” (the T-A-DA method) are the core principles of the nonpharmacological approach that go beyond the traditional strategies of management (such as reorientation)",
       "highlight": "“tolerate, anticipate, and don't agitate” (the T-A-DA method) are the core principles of the nonpharmacological approach",
       "scope": "on-scope",
       "note": "Read from the published abstract, not the full text, which is paywalled. The abstract names the method and expands all three letters, which is what the card states. It does not carry the Delirium Room's operational detail, so nothing beyond the naming and expansion rests on this source.",
       "page": "Abstract",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/22091576/"
      }
     ]
    }
   ],
   "synthesis": "T-A-D-A (Tolerate, Anticipate, Don't Agitate) is the restraint-free delirium-room approach described by Flaherty & Little 2011 — a way to manage agitation without escalating it.",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "spa-r39",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Deeper guidance — A — Activity / Awareness",
   "statement": "Orientation board updated each shift; protect sleep; cluster cares.",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "MENDS2 2021",
    "Haloperidol PI",
    "Hodgson 2014",
    "Early Mobility",
    "Inouye 1999 (HELP)",
    "PADIS 2018"
   ],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "guideline",
   "pageNum": null,
   "citations": [],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://doi.org/10.1056/NEJMoa2024922",
    "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
    "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
    "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Inouye 1999 (HELP)",
     "cite": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Table 1 carries the orientation board and both sleep protocols this item bundles. The cadence differs: the trial ran the orientation protocol once daily, or three times daily for patients with a baseline MMSE below 20 or an orientation score below 8, not once per shift.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Cognitive impairment. All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily. Orientation protocol: board with names of care-team members and day’s schedule; communication to reorient to surroundings. [...] Sleep deprivation. All patients; need for protocol assessed once daily. Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage. Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures).",
       "highlight": "Orientation protocol: board with names of care-team members and day’s schedule; communication to reorient to surroundings",
       "scope": "on-scope",
       "note": "The orientation board itself, as the trial defined it.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Cognitive impairment. All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily. Orientation protocol: board with names of care-team members and day’s schedule; communication to reorient to surroundings. [...] Sleep deprivation. All patients; need for protocol assessed once daily. Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage. Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures).",
       "highlight": "protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily",
       "scope": "narrower",
       "note": "The trial’s cadence for that protocol. The item’s per-shift wording is a local operationalization, not the trial’s schedule.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Cognitive impairment. All patients, protocol once daily; patients with base-line MMSE score of <20 or orientation score of <8, protocol three times daily. Orientation protocol: board with names of care-team members and day’s schedule; communication to reorient to surroundings. [...] Sleep deprivation. All patients; need for protocol assessed once daily. Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage. Sleep-enhancement protocol: unit-wide noise-reduction strategies (e.g., silent pill crushers, vibrating beepers, and quiet hallways) and schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures).",
       "highlight": "schedule adjustments to allow sleep (e.g., rescheduling of medications and procedures)",
       "scope": "on-scope",
       "note": "The clustering half of the item — rescheduling care so sleep is not interrupted.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Two conditional recommendations cover the sleep half of this item, and clustering of care appears in the sleep-protocol rationale as a component of the studied bundles. The guideline does not address an orientation board.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Recommendation: We suggest using noise and light reduction strategies to improve sleep in critically ill adults (conditional recommendation, low quality of evidence). Rationale: Two RCTs and two observational studies evaluated strategies to reduce ICU noise and light at night through the use of earplugs with or without the use of eyeshades.",
       "highlight": "We suggest using noise and light reduction strategies to improve sleep in critically ill adults (conditional recommendation, low quality of evidence)",
       "scope": "on-scope",
       "note": "The formal recommendation behind protecting sleep.",
       "page": "e858",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "Sleep-Promoting Protocol. Question: Should a sleep-promoting protocol be used to improve sleep in critically ill adults? Recommendation: We suggest using a sleep-promoting, multicomponent protocol in critically ill adults (conditional recommendation, very low quality of evidence.)",
       "highlight": "We suggest using a sleep-promoting, multicomponent protocol in critically ill adults",
       "scope": "on-scope",
       "note": "Protecting sleep as a bundled protocol rather than a single measure.",
       "page": "e859",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "One of the observational studies used a similar intervention to Hu et al, earplugs, eye shades, and music, whereas the other two tested more complex interventions including these interventions plus environmental changes, namely clustering of care to minimize interruptions overnight and early mobilization.",
       "highlight": "clustering of care to minimize interruptions overnight",
       "scope": "background",
       "note": "Clustering appears in the rationale as a component of the trials pooled for the recommendation, not as a recommendation of its own.",
       "page": "e860",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    }
   ],
   "synthesis": "Reorientation, sleep protection, and clustering care are components of validated multicomponent prevention: the HELP orientation and nonpharmacologic sleep protocols (Inouye 1999) and the PADIS 2018 sleep-disruption recommendations.",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "spa-r40",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Deliriogenic medications",
   "statement": "Deliriogenic medications — review & limit (drug-class list; specific agents in data/meds.js)",
   "contentType": "Cited clinical content",
   "sources": [
    "Beers 2023",
    "PADIS 2018",
    "ACB Scale"
   ],
   "anchor": "Beers 2023 — p. 12",
   "passage": "… Non-selective peripheral alpha-1 blockers cause orthostatic blood pressure changes and should be avoided in older adults whose syncope may be due to orthostatic hypotension alpha-1 blockers: Weak AChEIs, tertiary TCAs: Strong Central Nervous System Delirium Anticholinergics Antipsychotics Benzodiazepines Corticosteroids (oral and parenteral) H2-receptor antagonists ● Cimetidine ● Famotidine ● Nizatidine Nonbenzodiazepine benzodiazepine receptor agonist hypnotics (\"Zdrugs\") ● Eszopiclone ● Zaleplon Avoid in older adults with or at high risk of delirium because of the potential of inducing or worsening delirium. Antipsychotics: avoid for behavioral problems of dementia or delirium unless nonpharmacologic options (eg, behavioral interventions) have failed or are not possible and the older adult is threatening substantial harm to self or others. If used, periodic deprescribing attempts should be considered to assess ongoing need and/or the lowest effective dose. Avoid, except in situations listed under the rationale statement. H2-receptor antagonists: Low All others: Moderate Strong Last Updated 11/02/2023 J Am Geriatr Soc.2023;71:2052-2081. DOI: 10.1111/jgs.18372\nThe Beers 2023 delirium category supplies the drug-class list: anticholinergics, antipsychotics, benzodiazepines, corticosteroids (oral and parenteral), H2-receptor antagonists, and Z-drug hypnotics. Specific agents are enumerated in the tool's data/meds.js.",
   "evidence": "Full text, p. 12",
   "status": "fulltext",
   "pageNum": "12",
   "citations": [
    "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
    "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
    "Boustani M, Campbell N, Munger S, Maidment I, Fox C. Impact of anticholinergics on the aging brain: a review and practical application (Anticholinergic Cognitive Burden scale). Aging Health. 2008;4(3):311-320."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/37139824/",
    "https://pubmed.ncbi.nlm.nih.gov/30113379/",
    "https://doi.org/10.2217/1745509X.4.3.311"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beers 2023",
     "cite": "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/",
     "paragraphs": [
      {
       "context": "Avoid in older adults with or at high risk of delirium because of the potential of inducing or worsening delirium.",
       "highlight": "Avoid in older adults with or at high risk of delirium",
       "scope": "on-scope",
       "note": "Beers Table 3 Delirium criterion — the recommendation to avoid the deliriogenic drug classes (anticholinergics, antipsychotics, benzodiazepines, corticosteroids, H2 antagonists, Z-drugs, opioids) in older adults with or at high risk of delirium; the drug-class list the claim summarizes (geriatric population).",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      },
      {
       "context": "Avoid in older adults with or at high risk of delirium because of the potential of inducing or worsening delirium. Antipsychotics: avoid for behavioral problems of dementia or delirium unless nonpharmacologic options (eg, behavioral interventions) have failed or are not possible and the older adult is threatening substantial harm to self or others. If used, periodic deprescribing attempts should be considered to assess ongoing need and/or the lowest effective dose.",
       "highlight": "Avoid in older adults with or at high risk of delirium because of the potential of inducing or worsening delirium.",
       "scope": "on-scope",
       "note": "The explicit recommendation to avoid these classes in patients with or at high risk of delirium — the 'review & limit' action the claim asserts.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      },
      {
       "context": "Cumulative exposure to anticholinergic drugs is associated with an increased risk of falls, delirium, and dementia, even in younger adults. Consider total anticholinergic burden during regular medication reviews and be cautious in \"young-old\" as well as \"old-old\" adults.",
       "highlight": "Consider total anticholinergic burden during regular medication reviews",
       "scope": "on-scope",
       "note": "Directly supports the 'review' verb — total anticholinergic (deliriogenic) burden should be assessed at regular medication reviews; cumulative exposure is linked to delirium.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      },
      {
       "context": "Use of more than one medication with anticholinergic properties increases the risk of cognitive decline, delirium, and falls or fractures.",
       "highlight": "Use of more than one medication with anticholinergic properties increases the risk of cognitive decline, delirium, and falls or fractures",
       "scope": "on-scope",
       "note": "Supports the 'limit' verb — minimize the number of anticholinergic (deliriogenic) drugs, which is tied to increased delirium risk.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      },
      {
       "context": "Avoid because of adverse CNS effects. See criteria on individual drugs for additional information. Antipsychotics: increased risk of stroke and greater rate of cognitive decline and mortality in people with dementia. Avoid antipsychotics for behavioral problems of dementia or delirium unless documented nonpharmacologic options (e.g., behavioral interventions) have failed and/or the patient is threatening substantial harm to self or others. If used, periodic deprescribing attempts should be considered to assess ongoing need and/or the lowest effective dose.",
       "highlight": "Avoid because of adverse CNS effects.",
       "scope": "different-population",
       "note": "Nearest sibling drug-disease row listing the same classes (anticholinergics, benzodiazepines, Z-drugs) but for older adults with dementia/cognitive impairment or history of falls/fractures, not delirium — shares keywords, different target condition.",
       "page": "",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      }
     ]
    },
    {
     "label": "PADIS 2018",
     "cite": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
     "paragraphs": [
      {
       "context": "Benzodiazepine use and blood transfusion administration are the only two modifiable factors with strong evidence for an association with delirium detected by screening tools (Supplemental Table 22, Supplemental Digital Content 30, http://links.lww. com/CCM/D788). The nonmodifiable risk factors with strong evidence for an association with delirium include increasing age, dementia, prior coma, pre-ICU emergency surgery or trauma, and increasing APACHE and ASA scores. Sex, opioid use, and mechanical ventilation each have been strongly shown not to alter the risk of delirium occurrence. Moderate evidence exists showing the following increase the risk for delirium: history of hypertension; admission because of a neurologic disease; trauma; and the use of psychoactive medication (e.g., antipsychotics, anticonvulsants). A history of respiratory disease, medical admission, nicotine use, dialysis or continuous venovenous hemofiltration, and a lower Glasgow Coma Scale score have each been moderately shown not to increase the risk for delirium. See the \"Sedation section\" for a review on how sedative choice may affect delirium and the \"Sleep section\" regarding the relationship between sleep and delirium. For all other potential delirium-associated risk factors, evidence currently remains inconclusive.",
       "highlight": "Benzodiazepine use and blood transfusion administration are the only two modifiable factors with strong evidence for an association with delirium detected by screening tools",
       "scope": "on-scope",
       "note": "ICU-specific evidence identifying benzodiazepine use as the key modifiable deliriogenic medication; narrower than a broad class list, and it notes opioid use is strongly shown NOT to alter delirium risk — a divergence from Beers' emerging opioid signal.",
       "page": "e842",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      },
      {
       "context": "As outlined in these guidelines, clinicians should target a light rather than deep level of sedation in their intubated, critically ill adult patients unless deeper sedation is clinically indicated. Our literature review suggests that both DSI protocols and NP-targeted sedation are safe and no differences exist between them in achieving and maintaining a light level of sedation. There are, however, some important caveats: first, most studies evaluating DSIs and NP have done so in the context of sedation with benzodiazepines, which are no longer recommended for sedation in critically ill patients; second, DSI protocols may be associated with increasing nursing workload (179); and third, a brief DSI should not be used to justify the use of deep sedation for the rest of the day when it is not indicated. Because light levels of sedation are associated with improved outcomes and are needed to facilitate other interventions such as spontaneous breathing trials and early mobilization, healthcare providers should strive to achieve light levels of sedation in the majority of patients the majority of the time. Light sedation, assessed using a validated sedation scale, can be achieved either using a NP or through DSI protocols (where light sedation is targeted, whereas sedatives are infusing).",
       "highlight": "benzodiazepines, which are no longer recommended for sedation in critically ill patients",
       "scope": "on-scope",
       "note": "Supports the 'limit' action for a deliriogenic class in the ICU setting — benzodiazepines are no longer recommended for sedation of critically ill patients.",
       "page": "e839",
       "docUrl": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    },
    {
     "label": "ACB Scale",
     "cite": "Boustani M, Campbell N, Munger S, Maidment I, Fox C. Impact of anticholinergics on the aging brain: a review and practical application (Anticholinergic Cognitive Burden scale). Aging Health. 2008;4(3):311-320.",
     "kind": "web",
     "stance": "background",
     "note": "Anticholinergic Cognitive Burden scale (Boustani 2008) cited by section/DOI; it operationalizes identifying and quantifying the anticholinergic (deliriogenic) medications the 'review & limit' guidance targets. No PDF text archived, so no paragraph anchors.",
     "docUrl": "https://doi.org/10.2217/1745509X.4.3.311",
     "paragraphs": []
    }
   ],
   "synthesis": "The two on-scope PDF sources agree that deliriogenic medications should be reviewed and limited: Beers 2023 supplies the comprehensive drug-class list (anticholinergics, antipsychotics, benzodiazepines, corticosteroids, H2-receptor antagonists, Z-drugs) to avoid in patients with or at high risk of delirium plus the anticholinergic-burden review/minimize guidance, and — as the primary anchor — governs the tool's class list, while PADIS 2018 corroborates in the ICU setting that benzodiazepine use is a modifiable delirium risk factor no longer recommended for sedation. They diverge on opioids (PADIS found opioid use strongly not associated with ICU delirium, whereas Beers flags an emerging opioid–delirium association) and Beers' population is older adults rather than the general ICU, so the sources are complementary rather than identical.",
   "discrepancy": true
  },
  {
   "id": "spa-r41",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Escalation ladder — 1 · All patients",
   "statement": "Apply S·P·A on admission",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "NICE CG103",
    "Project BETA"
   ],
   "anchor": "NICE CG103 — p. 7",
   "passage": "1.4 Preventing delirium 1.4.1 Ensure that people at risk of delirium are cared for by a team of healthcare professionals who are familiar to the person at risk. Avoid moving people within and between wards or rooms unless absolutely necessary. [2010] 1.4.2 Give a tailored multicomponent intervention package: • within 24 hours of admission, assess people at risk for clinical factors contributing to delirium • based on the results of this assessment, provide a multicomponent intervention tailored to the person's individual needs and care setting as described in recommendations 1.4.4 to 1.4.13. [2010] 1.4.3 The tailored multicomponent intervention package should be delivered by a multidisciplinary team trained and competent in delirium prevention. …\nThe quoted passage is NICE CG103 recommendation 1.4.2.",
   "evidence": "Full text, p. 7",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://www.nice.org.uk/guidance/cg103",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Recommendation 1.4.2 (p. 7) directly grounds the claim: on-admission risk assessment plus a tailored multicomponent prevention package, which is what 'Apply S·P·A on admission' operationalizes.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "within 24 hours of admission, assess people at risk for clinical factors contributing to delirium based on the results of this assessment, provide a multicomponent intervention tailored to the person's individual needs and care setting as described in recommendations 1.4.4 to 1.4.13. [2010] 1.4.3 The tailored multicomponent intervention package should be delivered by a multidisciplinary team trained and competent in delirium prevention. [2010]",
       "highlight": "within 24 hours of admission, assess people at risk for clinical factors contributing to delirium",
       "scope": "on-scope",
       "note": "Rec 1.4.2 sets the on-admission timing (within 24 hours) for assessing at-risk patients and starting prevention — the core of applying S·P·A on admission.",
       "page": "7",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "based on the results of this assessment, provide a multicomponent intervention tailored to the person's individual needs and care setting as described in recommendations 1.4.4 to 1.4.13. [2010]",
       "highlight": "provide a multicomponent intervention tailored to the person's individual needs and care setting",
       "scope": "on-scope",
       "note": "The multicomponent prevention package (1.4.4–1.4.13: orientation, mobility, sleep, hydration, medication review) is the prevention bundle SPA compresses; NICE is a general hospital/long-term-care guideline, so slightly broader setting than the ICU-focused SPA tool.",
       "page": "7",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "background",
     "note": "This focused ICU update grounds the care domains SPA compresses (sedation, activity/mobilization, pharmacology) but does not itself restate an on-admission, all-patients prevention rule — that timing is governed by NICE.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "RESULTS: The task force issued five statements related to the management of anxiety, agitation/sedation, delirium, immobility, and sleep disruption in adults admitted to the ICU. In adult patients admitted to the ICU, the task force issued conditional recommendations to use dexmedetomidine over propofol for sedation, provide enhanced mobilization/rehabilitation over usual mobilization/rehabilitation, and administer melatonin. The task force was unable to issue recommendations on the administration of benzodiazepines to treat anxiety, and the use of antipsychotics to treat delirium.",
       "highlight": "conditional recommendations to use dexmedetomidine over propofol for sedation, provide enhanced mobilization/rehabilitation over usual mobilization/rehabilitation, and administer melatonin",
       "scope": "broader",
       "note": "These ICU recommendations map onto the SPA domains (S = dexmedetomidine over propofol, A = enhanced mobilization, P = melatonin) but are component recommendations across the ICU stay, not an on-admission-for-all timing statement.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "Project BETA",
     "cite": "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25.",
     "kind": "pdf",
     "stance": "background",
     "note": "Cited for the SPA escalation ladder's de-escalation content (T-A-D-A / verbal de-escalation), not for the on-admission prevention rung; nearest match on the topic but a different scope.",
     "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/",
     "paragraphs": [
      {
       "context": "Agitation is an acute behavioral emergency requiring immediate intervention. Traditional methods of treating agitated patients, ie, routine restraints and involuntary medication, have been replaced with a much greater emphasis on a noncoercive approach.",
       "highlight": "Agitation is an acute behavioral emergency requiring immediate intervention",
       "scope": "different-intervention",
       "note": "Addresses verbal de-escalation of already-agitated patients in emergency psychiatry — a later escalation-ladder rung, not the universal on-admission prevention this claim asserts.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      }
     ]
    }
   ],
   "synthesis": "NICE CG103 recommendation 1.4.2 (p. 7) governs: it directs on-admission (within 24 hours) risk assessment plus a tailored multicomponent prevention package for at-risk patients, which is exactly what \"Apply S·P·A on admission\" operationalizes. PADIS 2025 agrees at the level of individual ICU domains (sedation, mobilization, pharmacology) but as a focused update does not restate the on-admission-for-all timing, and Project BETA is a nearest keyword match on the escalation-ladder topic but a different scope (verbal de-escalation of agitated patients, not on-admission prevention).",
   "discrepancy": true
  },
  {
   "id": "spa-r42",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Escalation ladder — 1 · All patients",
   "statement": "CAM-ICU + RASS each shift",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "NICE CG103",
    "Project BETA"
   ],
   "anchor": "NICE CG103 — p. 9",
   "passage": "… [2010] 1.4.12 Address sensory impairment by: • resolving any reversible cause of the impairment, such as impacted ear wax • ensuring hearing and visual aids are available to and used by people who need them, and that they are in good working order. [2010] 1.4.13 Promote good sleep patterns and sleep hygiene by: • avoiding nursing or medical procedures during sleeping hours, if possible • scheduling medication rounds to avoid disturbing sleep • reducing noise to a minimum during sleep periods. [2010] 1.5 Indicators of delirium: daily observations 1.5.1 Observe, at least daily, all people in hospital or long-term care for recent (within hours or days) changes or fluctuations indicating delirium (for example, see recommendation 1.3.1). These may be reported by the person at risk, or a carer or relative. If any of these changes are present the person should have an assessment using an appropriate tool (see recommendation 1.6.1). [2010, amended 2023] 1.5.2 Ensure that any changes that may indicate delirium are documented in the person's record or notes. [2023] Delirium: prevention, diagnosis and management in hospital and long-term care (CG103) © NICE 2025. All rights reserved. Subject to Notice of rights (https://www.nice.org.uk/terms-andconditions#notice-of-rights). Page 9 of 24\nNICE CG103 1.5.1 supports at-least-daily observation for delirium but does not specify the CAM-ICU and RASS instruments or a per-shift frequency; that combination comes from PADIS 2018, which is not cited for this row.",
   "evidence": "Full text, p. 9 — partial support",
   "status": "fulltext",
   "pageNum": "9",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://www.nice.org.uk/guidance/cg103",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "This focused update adds anxiety and revisits sedation, antipsychotics, mobility and sleep but does not re-address delirium-monitoring frequency or CAM-ICU/RASS screening; it names RASS only as an outcome measure.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": []
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "partial",
     "note": "Governing on-scope source: recommends CAM-ICU/ICDSC for delirium assessment in critical care and at-least-daily monitoring, but does not specify each-shift frequency or the RASS sedation scale.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "competent to do so should carry out an assessment using the 4AT. In critical care or in the recovery room after surgery use the Confusion Assessment Method for the Intensive Care Unit (CAM-ICU) or Intensive Care Delirium Screening Checklist (ICDSC) instead of the 4AT.",
       "highlight": "the Intensive Care Unit (CAM-ICU) or Intensive Care Delirium Screening Checklist",
       "scope": "on-scope",
       "note": "Directly recommends CAM-ICU (or ICDSC) as the delirium assessment tool in critical care, though it is triggered when indicators are identified rather than mandated routinely each shift, and RASS is not mentioned.",
       "page": "10",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Observe, at least daily, all people in hospital or long-term care for recent (within hours or days) changes or fluctuations indicating delirium (for example, see recommendation 1.3.1).",
       "highlight": "Observe, at least daily, all people in hospital or long-term care",
       "scope": "broader",
       "note": "Nearest frequency guidance, but specifies at-least-daily observation for changes across all hospital and long-term care, broader and less frequent than ICU each-shift CAM-ICU/RASS screening.",
       "page": "9",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "For critical care and post-surgical settings, the Confusion Assessment Method for the Intensive Care Unit (CAM-ICU) and Intensive Care Delirium Screening Checklist (ICDSC) worked best because they were specifically designed for those settings. However, the committee noted that training is needed for both CAM-ICU and ICDSC before practitioners can use them.",
       "highlight": "worked best because they were specifically designed for those settings",
       "scope": "background",
       "note": "Committee rationale confirming CAM-ICU/ICDSC as the preferred critical-care delirium tools.",
       "page": "19",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "Project BETA",
     "cite": "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Emergency-psychiatry consensus on verbal de-escalation of agitation; it does not address ICU delirium or sedation monitoring, CAM-ICU, or RASS (the 'Richmond' matches are the author's name, not the Richmond Agitation-Sedation Scale).",
     "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/",
     "paragraphs": [
      {
       "context": "The use of objective scales to measure agitation can help mitigate defensive behaviors on the part of staff that might result in their avoiding or “ignoring” early signs of agitation.",
       "highlight": "objective scales to measure agitation",
       "scope": "different-setting",
       "note": "Nearest match: emergency-psychiatry guidance to use objective scales to measure agitation (BARS), a different setting and tool from routine ICU CAM-ICU/RASS scoring each shift.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      }
     ]
    }
   ],
   "synthesis": "NICE CG103 is the governing on-scope source: it recommends CAM-ICU (or ICDSC) as the delirium assessment tool in critical care and at-least-daily monitoring for changes, partially supporting the statement but without specifying each-shift frequency or the RASS sedation scale. The each-shift CAM-ICU + RASS pairing is the 2018 PADIS ICU-bundle standard, which the 2025 PADIS focused update did not re-address (so it remains the current position; the update names RASS only as an outcome metric), while Project BETA is a different-setting/intervention source (emergency-psychiatry agitation de-escalation) that does not address ICU delirium or sedation monitoring.",
   "discrepancy": true
  },
  {
   "id": "spa-r43",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Escalation ladder — 1 · All patients",
   "statement": "Medication review",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "NICE CG103",
    "Project BETA"
   ],
   "anchor": "NICE CG103 — p. 9",
   "passage": "1.4.10 Carry out a medication review for people taking multiple drugs, taking into account both the type and number of medications. For information on medicines optimisation see the NICE guideline on medicines optimisation. [2010] 1.4.11 Address poor nutrition by: • following the advice given on nutrition in the NICE guideline on nutrition support for adults • if people have dentures, ensuring they fit properly. [2010] 1.4.12 Address sensory impairment by: • resolving any reversible cause of the impairment, such as impacted ear wax • ensuring hearing and visual aids are available to and used by people who need them, and that they are in good working order. …\nThe quoted passage is NICE CG103 recommendation 1.4.10.",
   "evidence": "Full text, p. 9",
   "status": "fulltext",
   "pageNum": "9",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://www.nice.org.uk/guidance/cg103",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "This focused update issues recommendations only on dexmedetomidine vs propofol, enhanced mobilization, melatonin, antipsychotics for delirium, and benzodiazepines for anxiety; it does not address a general medication review as a delirium-prevention step. Cited for ICU context.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "Most RCTs enrolled a mix of patients with either hypoactive and/or hyperactive delirium and, therefore, it is unclear if there is a single patient population that would benefit most from an antipsychotic. In addition, if used, one must be prudent to discontinue antipsychotics that were newly initiated in the ICU upon discharge if no longer clinically required (66).",
       "highlight": "discontinue antipsychotics that were newly initiated in the ICU upon discharge if no longer clinically required",
       "scope": "narrower",
       "note": "Nearest match: a narrow deprescribing instruction for one drug class at ICU discharge, not the general 'review all deliriogenic medications' step the claim asserts.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Recommendation 1.4.10 is the operative, on-scope support for the medication-review rung.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "Carry out a medication review for people taking multiple drugs, taking into account both the type and number of medications. For information on medicines optimisation see the NICE guideline on medicines optimisation. [2010]",
       "highlight": "Carry out a medication review for people taking multiple drugs, taking into account both the type and number of medications.",
       "scope": "on-scope",
       "note": "Recommendation 1.4.10 within the multicomponent interventions to prevent delirium — directly instructs a medication review, matching the escalation-ladder step for all patients.",
       "page": "9",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Although there is moderate-quality evidence of clinical and cost effectiveness for multicomponent interventions for the prevention of delirium in people in hospital, there is no evidence in a long-term care setting. It is anticipated that such an intervention would benefit this long-term care population. A large, adequately powered, randomised trial, or a large, adequately powered, cluster randomised trial should be conducted in people in long-term care to compare a multicomponent intervention with usual care. The multicomponent intervention should include assessment by a trained and competent healthcare professional, who would recommend actions tailored to the person's needs. The intervention should include the recommended interventions to prevent delirium, particularly reorientation, medication review, hydration and sleep hygiene. The primary outcome should be the incidence of delirium, measured at least daily using a validated diagnostic tool. The severity and duration of delirium should also be recorded using a validated tool, together with the consequences of delirium, including admission to hospital.",
       "highlight": "particularly reorientation, medication review, hydration and sleep hygiene",
       "scope": "background",
       "note": "Same guideline lists medication review among prevention components, but here inside a research recommendation for long-term care rather than the operative recommendation.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "Project BETA",
     "cite": "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Archived PMC page (consensus statement on verbal de-escalation of the agitated patient). It concerns offering/administering calming medication during de-escalation, not reviewing or reducing a patient's existing medications; cited by section/DOI for the de-escalation content, not this rung.",
     "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/",
     "paragraphs": [
      {
       "context": "Ask the patient what medication has helped him in the past or state, “I see that you're quite uncomfortable. May I offer you some medication?”",
       "highlight": "Ask the patient what medication has helped him in the past",
       "scope": "different-intervention",
       "note": "Nearest keyword match: eliciting a patient's prior medication response to offer calming medication to an agitated psychiatric/ED patient — a different intervention and population, not a medication review to reduce deliriogenic drugs.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      }
     ]
    }
   ],
   "synthesis": "NICE CG103 recommendation 1.4.10 (p. 9) is the on-scope source and governs: it directly instructs a medication review for people taking multiple drugs as part of the multicomponent delirium-prevention package, matching the escalation-ladder step for all patients. PADIS 2025 is a focused update that did not re-address medication review (its nearest content is deprescribing newly-started antipsychotics at ICU discharge), and Project BETA addresses verbal de-escalation / offering calming medication to agitated patients — a different intervention that only shares the keyword \"medication\"; neither supplies direct support.",
   "discrepancy": true
  },
  {
   "id": "spa-r44",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Escalation ladder — 2 · CAM positive",
   "statement": "Notify provider; document",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "NICE CG103",
    "Project BETA"
   ],
   "anchor": "NICE CG103 — p. 9",
   "passage": "… [2010] 1.5 Indicators of delirium: daily observations 1.5.1 Observe, at least daily, all people in hospital or long-term care for recent (within hours or days) changes or fluctuations indicating delirium (for example, see recommendation 1.3.1). These may be reported by the person at risk, or a carer or relative. If any of these changes are present the person should have an assessment using an appropriate tool (see recommendation 1.6.1). [2010, amended 2023] 1.5.2 Ensure that any changes that may indicate delirium are documented in the person's record or notes. [2023] Delirium: prevention, diagnosis and management in hospital and long-term care (CG103) © NICE 2025. All rights reserved. Subject to Notice of rights (https://www.nice.org.uk/terms-andconditions#notice-of-rights). Page 9 of 24\nNICE CG103 1.5.2 supports documenting changes indicating delirium; 'notify provider' is not stated in the cited sources.",
   "evidence": "Full text, p. 9 — partial support",
   "status": "fulltext",
   "pageNum": "9",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://www.nice.org.uk/guidance/cg103",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope: covers adults in hospital and critical care, uses CAM-ICU in the ICU, and its assessment/diagnosis recommendations ground both 'notify provider' and 'document'.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "If the assessment described in recommendation 1.6.1 indicates delirium, a healthcare professional with the relevant expertise should make the final diagnosis.",
       "highlight": "healthcare professional with the relevant expertise should make the final",
       "scope": "on-scope",
       "note": "Grounds 'notify provider' — once the CAM-ICU/4AT assessment indicates delirium, a healthcare professional with the relevant expertise makes the final diagnosis (rec 1.6.2).",
       "page": "10",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Ensure that the diagnosis of delirium is documented both in the person's record or notes, and in their primary care health record.",
       "highlight": "the diagnosis of delirium is documented both in the person's record",
       "scope": "on-scope",
       "note": "Grounds 'document' — rec 1.6.4 requires the delirium diagnosis to be recorded in the person's notes and primary care record.",
       "page": "10",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Ensure that any changes that may indicate delirium are documented in the person's record or notes.",
       "highlight": "any changes that may indicate delirium are documented in the",
       "scope": "on-scope",
       "note": "The cited p. 9 recommendation (1.5.2) — changes that may indicate delirium must be documented in the person's record or notes.",
       "page": "9",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "competent to do so should carry out an assessment using the 4AT. In critical care or in the recovery room after surgery use the Confusion Assessment Method for the Intensive Care Unit (CAM-ICU) or Intensive Care Delirium Screening Checklist (ICDSC) instead of the 4AT.",
       "highlight": "the Intensive Care Unit (CAM-ICU) or Intensive Care Delirium Screening Checklist",
       "scope": "background",
       "note": "Establishes the CAM-ICU as the critical-care screening tool whose positive result triggers this escalation step (rec 1.6.1).",
       "page": "10",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Same adult-ICU population but this focused update addresses symptom management (anxiety, sedation, mobility, sleep, antipsychotics for delirium); it does not address the notify-provider/document escalation action.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "Pain, Agitation/Sedation, Delirium, Immobility, and Sleep Disruption 2018 Recommendations No recommendations previously existed We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence) We suggest not routinely using haloperidol or an atypical antipsychotic, to treat delirium (conditional recommendation, low quality of evidence) We suggest performing rehabilitation or mobilization in critically ill adults (conditional recommendation, low quality evidence) We make no recommendation regarding the use of melatonin to improve sleep in critically ill adults (no recommendation, very low quality of evidence)",
       "highlight": "not routinely using haloperidol or an atypical antipsychotic, to treat delirium",
       "scope": "different-intervention",
       "note": "Nearest delirium content is a pharmacologic-treatment recommendation, a different intervention than the notify/document workflow the claim describes.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "Project BETA",
     "cite": "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "A verbal-de-escalation-of-agitation consensus statement from emergency psychiatry; it names delirium only as an example of cognitive impairment and does not address notifying a provider or documentation after a positive CAM screen.",
     "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/",
     "paragraphs": [
      {
       "context": "Clinicians in emergency settings also will need to be skilled at recognizing that the inability to conform is due to either cognitive impairment—for example, delirium, psychosis, intoxication, and intellectual disability—or the patient's lack of the skills needed to effectively get his needs met, eg, personality disorder.",
       "highlight": "for example, delirium, psychosis, intoxication, and intellectual disability",
       "scope": "different-setting",
       "note": "Different setting/intervention — emergency-psychiatry de-escalation that names delirium as one possible cause of a patient's behavior, not the delirium-screen escalation action.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      }
     ]
    }
   ],
   "synthesis": "NICE CG103 governs and directly supports the claim: after a positive CAM-ICU/4AT screen a healthcare professional with the relevant expertise makes the final diagnosis (grounding \"notify provider\"), and both the changes that may indicate delirium and the confirmed diagnosis must be documented in the person's record (recs 1.5.2, 1.6.2, 1.6.4). PADIS 2025 (an ICU symptom-management focused update centered on anxiety) and Project BETA (verbal de-escalation of agitation in emergency psychiatry) share keywords but are different-scope and do not address the notify-provider/document escalation action.",
   "discrepancy": true
  },
  {
   "id": "spa-r45",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Escalation ladder — 2 · CAM positive",
   "statement": "Intensify S·P·A measures",
   "contentType": "Cited clinical content",
   "sources": [],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "structure",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": "An operational escalation step: 'intensify the S·P·A measures' means applying more of the same non-pharmacologic bundle documented above, so it is a workflow instruction rather than a separate cited claim.",
   "perSource": [],
   "synthesis": "",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "spa-r46",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Escalation ladder — 2 · CAM positive",
   "statement": "Treat reversible causes",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "NICE CG103",
    "Project BETA"
   ],
   "anchor": "NICE CG103 — p. 11",
   "passage": "1.7 Treating delirium Initial management 1.7.1 In people diagnosed with delirium, identify and manage the possible underlying cause or combination of causes. [2010] 1.7.2 Ensure effective communication and reorientation (for example explaining where the person is, who they are and what your role is) and provide reassurance for people diagnosed with delirium. Consider involving family, friends and carers to help with this. Provide a suitable care environment (see recommendation 1.4.1 in the section on preventing delirium). [2010] Distressed people 1.7.3 If a person with delirium is distressed or considered a risk to themselves or others, first use verbal and non-verbal techniques to de-escalate the situation. For more information on de-escalation techniques, see the NICE guideline on violence and aggression. …\nThe quoted passage is NICE CG103 recommendation 1.7.1.",
   "evidence": "Full text, p. 11",
   "status": "fulltext",
   "pageNum": "11",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://www.nice.org.uk/guidance/cg103",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Focused update to the PADIS guidelines; its only delirium recommendation concerns antipsychotics for established ICU delirium and does not re-address treating reversible/underlying causes (cited by section).",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "We are unable to issue a recommendation for or against the use of antipsychotics over usual care for the treatment of delirium in adult patients admitted to the ICU (conditional recommendation; for intervention or comparison; low certainty of evidence).",
       "highlight": "the use of antipsychotics over usual care for the treatment of delirium",
       "scope": "different-intervention",
       "note": "The focused update's sole delirium recommendation addresses antipsychotics for established ICU delirium, a different intervention than treating reversible causes, which it does not re-address.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Recommendation 1.7.1 on p. 11 is the direct source for the 'treat reversible causes' step of the escalation ladder.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "In people diagnosed with delirium, identify and manage the possible underlying cause or combination of causes.",
       "highlight": "identify and manage the possible underlying",
       "scope": "on-scope",
       "note": "Recommendation 1.7.1 directly instructs clinicians to identify and manage the underlying cause or combination of causes of delirium — the primary support for treating reversible causes.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "For people in whom delirium does not resolve: re-evaluate for underlying causes follow up and assess for possible dementia (see the NICE guideline on dementia).",
       "highlight": "re-evaluate for underlying causes",
       "scope": "narrower",
       "note": "Recommendation 1.7.5 applies the same principle to the narrower subset of delirium that does not resolve, where the guideline says to re-evaluate for underlying causes.",
       "page": "12",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "Project BETA",
     "cite": "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Consensus statement on verbal de-escalation of the agitated patient (emergency psychiatry); addresses a different intervention and population, not treatment of reversible causes (cited by section/DOI 10.5811/westjem.2011.9.6864).",
     "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/",
     "paragraphs": [
      {
       "context": "After initial stabilization of the patient's agitation, the clinician can work with the patient to establish a final diagnosis.",
       "highlight": "the clinician can work with the patient to establish a final diagnosis",
       "scope": "different-intervention",
       "note": "Project BETA de-escalates agitation regardless of underlying etiology and only mentions establishing a final diagnosis after stabilization — a different intervention and population (emergency-psychiatry agitation, not ICU delirium cause-treatment).",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      }
     ]
    }
   ],
   "synthesis": "NICE CG103 governs: recommendation 1.7.1 (p. 11) directly instructs clinicians to identify and manage the underlying cause or combination of causes of delirium — exactly the \"treat reversible causes\" step — and 1.7.5 extends the principle to non-resolving delirium. The PADIS 2025 focused update does not re-address treating reversible/underlying causes (its only delirium recommendation concerns antipsychotics for established ICU delirium, so its prior position remains the current one), and Project BETA covers verbal de-escalation of agitation regardless of etiology; both are adjacent, different-intervention sources rather than direct support.",
   "discrepancy": true
  },
  {
   "id": "spa-r47",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Escalation ladder — 3 · Persistent > 1 shift",
   "statement": "1:1 sitter; family presence",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "NICE CG103",
    "Project BETA"
   ],
   "anchor": "NICE CG103 — p. 11",
   "passage": "1.7 Treating delirium Initial management 1.7.1 In people diagnosed with delirium, identify and manage the possible underlying cause or combination of causes. [2010] 1.7.2 Ensure effective communication and reorientation (for example explaining where the person is, who they are and what your role is) and provide reassurance for people diagnosed with delirium. Consider involving family, friends and carers to help with this. Provide a suitable care environment (see recommendation 1.4.1 in the section on preventing delirium). [2010] Distressed people 1.7.3 If a person with delirium is distressed or considered a risk to themselves or others, first use verbal and non-verbal techniques to de-escalate the situation. For more information on de-escalation techniques, see the NICE guideline on violence and aggression. Distress may be less evident in people with hypoactive delirium, who can still become distressed by, for example, psychotic symptoms. …\nNICE CG103 1.7.2 supports family presence for reorientation and reassurance; a 1:1 sitter is not stated in the cited sources.",
   "evidence": "Full text, p. 11 — partial support",
   "status": "fulltext",
   "pageNum": "11",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://www.nice.org.uk/guidance/cg103",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "partial",
     "note": "Primary anchor (p.11, section 1.7 Treating delirium): supports involving family/carers in delirium care ('family presence'), but nowhere recommends a 1:1 sitter or enhanced/constant observation.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "people diagnosed with delirium. Consider involving family, friends and carers to help with this.",
       "highlight": "Consider involving family, friends and carers to",
       "scope": "on-scope",
       "note": "Recommendation 1.7.2 (treating delirium) directly supports the 'family presence' element as an aid to communication and reorientation.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "others, first use verbal and non-verbal techniques to de-escalate the situation.",
       "highlight": "first use verbal and non-verbal techniques to de-escalate the situation",
       "scope": "different-intervention",
       "note": "Recommendation 1.7.3 is the first-line behavioral step for the distressed/agitated delirious patient (de-escalation), a different rung than the sitter/family measure in this claim.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "For people in whom delirium does not resolve: re-evaluate for underlying causes follow up and assess for possible dementia (see the NICE guideline on dementia).",
       "highlight": "re-evaluate for underlying causes",
       "scope": "different-intervention",
       "note": "Recommendation 1.7.5 addresses persistent (non-resolving) delirium but prescribes re-evaluating causes and assessing for dementia, not a 1:1 sitter or family presence.",
       "page": "12",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "facilitating regular visits from family and friends. [2010]",
       "highlight": "facilitating regular visits from family and friends",
       "scope": "different-intervention",
       "note": "Recommendation 1.4.4 is family visits within the prevention bundle, not a persistent-agitation escalation measure; nearest keyword match on 'family'.",
       "page": "7",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Focused update (adds Anxiety); covers ICU sedation, mobilization, melatonin and was unable to recommend antipsychotics for delirium. It does not re-address non-pharmacologic delirium/agitation management such as 1:1 sitters or family presence.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "Studies evaluating the value of patient communication with family members during ICU care and the perceptions of patients while on propofol vs. dexmedetomidine (may include patients who can participate in their own care).",
       "highlight": "patient communication with family members during ICU care",
       "scope": "different-intervention",
       "note": "Nearest 'family' match, but framed as a future-research gap on family communication during propofol vs. dexmedetomidine sedation, not a recommendation for family presence.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "RESULTS: The task force issued five statements related to the management of anxiety, agitation/sedation, delirium, immobility, and sleep disruption in adults admitted to the ICU. In adult patients admitted to the ICU, the task force issued conditional recommendations to use dexmedetomidine over propofol for sedation, provide enhanced mobilization/rehabilitation over usual mobilization/rehabilitation, and administer melatonin. The task force was unable to issue recommendations on the administration of benzodiazepines to treat anxiety, and the use of antipsychotics to treat delirium.",
       "highlight": "the use of antipsychotics to treat delirium",
       "scope": "background",
       "note": "Shows the focused update declined to make a delirium pharmacotherapy recommendation and does not touch the non-pharmacologic sitter/family question at all.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "Project BETA",
     "cite": "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25.",
     "kind": "pdf",
     "stance": "background",
     "note": "Psychiatric-emergency consensus on verbal de-escalation of the agitated patient; supports a noncoercive behavioral approach but does not mention a 1:1 sitter or family presence.",
     "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/",
     "paragraphs": [
      {
       "context": "Modern clinical thinking endorses less coercive interventions, in which the patient becomes a collaborative partner with staff members in managing behavior.",
       "highlight": "endorses less coercive interventions",
       "scope": "different-intervention",
       "note": "Endorses verbal de-escalation over restraints/coercion for the agitated patient in the psychiatric-emergency setting; a different intervention and setting than the ICU sitter/family rung.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      },
      {
       "context": "The first person to make contact with the patient should be the person designated to de-escalate the patient.",
       "highlight": "the person designated to de-escalate the patient",
       "scope": "different-intervention",
       "note": "Keyword trap: the single designated de-escalator does the talking, not a 1:1 sitter providing constant observation.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      }
     ]
    }
   ],
   "synthesis": "NICE CG103 is the governing on-scope source: recommendation 1.7.2 (p.11) supports involving family, friends and carers in delirium care, underpinning the 'family presence' half of this rung, but none of the three sources recommends a 1:1 sitter — NICE's own guidance for non-resolving (persistent) delirium is to re-evaluate causes and assess for dementia (1.7.5), while Project BETA (verbal de-escalation of agitation) and the PADIS 2025 focused update (ICU sedation/mobilization; unable to recommend antipsychotics for delirium) address adjacent interventions rather than sitters. The '1:1 sitter' element is therefore not directly cited by any of these sources.",
   "discrepancy": true
  },
  {
   "id": "spa-r48",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Escalation ladder — 3 · Persistent > 1 shift",
   "statement": "Geriatrics / psychiatry consult",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "NICE CG103",
    "Project BETA"
   ],
   "anchor": "NICE CG103 — p. 19",
   "passage": "… However, the committee noted that training is needed for both CAM-ICU and ICDSC before practitioners can use them. If the assessment shows delirium is likely, the committee agreed that the final diagnosis should be carried out by a healthcare professional with the necessary experience and expertise, for example, a specialist nurse, a GP, lead clinician or a member of the frailty team. Depending on the circumstances, this might be the same person who carried out the 4AT. If there is uncertainty about the diagnosis, a specialist such as a geriatrician or psychiatrist, may need to be involved. The committee agreed that although the evidence allowed them to make recommendations overall, further, more specific, research on the accuracy and ease of use of different assessment tools in different settings, for different patient groups (including those with dementia, cognitive impairments, learning disabilities or affective disorders) Delirium: prevention, diagnosis and management in hospital and long-term care (CG103) © NICE 2025. All rights reserved. Subject to Notice of rights (https://www.nice.org.uk/terms-andconditions#notice-of-rights). Page 19 of 24\nNICE CG103 names geriatrician or psychiatrist involvement in the context of diagnostic uncertainty rather than persistent delirium; the consult is supported in principle.",
   "evidence": "Full text, p. 19 — partial support",
   "status": "fulltext",
   "pageNum": "19",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://www.nice.org.uk/guidance/cg103",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "The SCCM ICU PADIS focused update covers anxiety, agitation/sedation, delirium, immobility and sleep in adult ICU patients; it makes no recommendation about geriatrics or psychiatry consultation for persistent delirium, so it does not address this escalation step (the only 'psychiatry' mentions are author affiliations and references).",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": []
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "If the assessment shows delirium is likely, the committee agreed that the final diagnosis should be carried out by a healthcare professional with the necessary experience and expertise, for example, a specialist nurse, a GP, lead clinician or a member of the frailty team. Depending on the circumstances, this might be the same person who carried out the 4AT. If there is uncertainty about the diagnosis, a specialist such as a geriatrician or psychiatrist, may need to be involved.",
       "highlight": "If there is uncertainty about the diagnosis, a specialist such as a geriatrician or psychiatrist, may need to be involved.",
       "scope": "on-scope",
       "note": "Directly names geriatrician or psychiatrist as the specialists to involve, supporting the 'geriatrics / psychiatry consult' step, though NICE frames this around diagnostic uncertainty rather than the tool's 'persistent > 1 shift' trigger.",
       "page": "19",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "re-evaluate for underlying causes follow up and assess for possible dementia (see the NICE guideline on dementia). [2010]",
       "highlight": "re-evaluate for underlying causes",
       "scope": "different-intervention",
       "note": "Nearest match on the persistence trigger (recommendation 1.7.5, delirium that does not resolve), but NICE's advice here is to re-evaluate underlying causes and assess for dementia — a different intervention from obtaining a specialist consult.",
       "page": "12",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "Project BETA",
     "cite": "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/",
     "paragraphs": [
      {
       "context": "Clinicians in emergency settings also will need to be skilled at recognizing that the inability to conform is due to either cognitive impairment—for example, delirium, psychosis, intoxication, and intellectual disability—or the patient's lack of the skills needed to effectively get his needs met, eg, personality disorder.",
       "highlight": "for example, delirium, psychosis, intoxication, and intellectual disability",
       "scope": "different-intervention",
       "note": "This APA emergency-psychiatry consensus is about verbal de-escalation of agitation (a different intervention) and only mentions delirium in passing as a cause of a patient's inability to conform; it does not recommend geriatrics or psychiatry consultation for persistent delirium.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      }
     ]
    }
   ],
   "synthesis": "NICE CG103 is the governing on-scope source: it explicitly names a geriatrician or psychiatrist as the specialists to involve (p. 19), which supports the \"geriatrics / psychiatry consult\" step — but NICE frames that involvement around diagnostic uncertainty, and its actual recommendation for delirium that does NOT resolve is to re-evaluate underlying causes and assess for dementia (1.7.5), not to obtain a specialist consult, so it only partially matches the tool's \"persistent > 1 shift → consult\" trigger. PADIS 2025 (ICU focused update on anxiety/sedation/delirium/immobility/sleep) and Project BETA (ED verbal de-escalation of agitation) do not address specialist consultation for persistent delirium and are off-scope for this statement.",
   "discrepancy": true
  },
  {
   "id": "spa-r49",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Escalation ladder — 3 · Persistent > 1 shift",
   "statement": "Reassess sedation strategy",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "NICE CG103",
    "Project BETA"
   ],
   "anchor": "PADIS 2025 — p. 5",
   "passage": "… Nonpharmacological treatment approaches, such as music listening (21, 25) or virtual reality (22), have shown promise. A patientcentered approach to care, research, and quality im provement that encompasses all sources of discomfort and distress in the ICU is essential to providing compre hensive management of anxiety. Of note, abrupt cessation of benzodiazepines pre scribed for baseline chronic anxiety may precipitate acute withdrawal; hence, continuation of the chronic benzodiazepines upon admission to the ICU should be considered. DEXMEDETOMIDINE FOR SEDATION Recommendation 2 We suggest using dexmedetomidine over propofol for sedation in mechanically ventilated adult patients admitted to the ICU where light sedation and/or a\nPADIS 2025 sedation recommendations support revisiting the sedative choice toward delirium-sparing agents; 'reassess sedation strategy' is the printed wording rather than a directive stated in the source.",
   "evidence": "Full text, p. 5 — partial support",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://www.nice.org.uk/guidance/cg103",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governing on-scope source: the focused update's re-addressed sedation question directly informs what reassessing an ICU sedation strategy entails.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "In adult patients admitted to the ICU, the task force issued conditional recommendations to use dexmedetomidine over propofol for sedation, provide enhanced mobilization/rehabilitation over usual mobilization/rehabilitation, and administer melatonin. The task force was unable to issue recommendations on the administration of benzodiazepines to treat anxiety, and the use of antipsychotics to treat delirium.",
       "highlight": "use dexmedetomidine over propofol for sedation",
       "scope": "on-scope",
       "note": "The focused update's sedation recommendation (prefer dexmedetomidine over propofol) is the evidence-based substance of reassessing an ICU patient's sedation strategy.",
       "page": "ms. p.1",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "has delirium, clinical judgment must be used. If a patient requires deep sedation or has a high risk of bradycardia, alternative sedative agents should be considered. The cost of dexmedetomidine acquisition for many hospitals is now lower than when initially marketed, and the cost of propofol and dexmedetomidine are likely comparable in many countries. However, there is significant variability in costs and availability of dexmedetomidine. Therefore, cost and ability to obtain dexmedetomidine may well be prohibitive in some centers and hence our recommendation is conditional rather than strong.",
       "highlight": "alternative sedative agents should be considered",
       "scope": "on-scope",
       "note": "Directly instructs clinicians to reconsider and switch sedative agents when deep sedation, bradycardia risk, or delirium apply — an explicit reassess-the-sedation-strategy directive.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "It may improve the time spent at target sedation (low certainty) and reduce the proportion that require supplemental analgesics (RR, 0.71; 95% CI, 0.52-0.99; moderate certainty).",
       "highlight": "It may improve the time spent at target sedation",
       "scope": "on-scope",
       "note": "Supporting evidence that titrating sedatives to light/target sedation is the strategy that reduces delirium, reinforcing the reassessment goal.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Nearest-match delirium guidance but never addresses sedation strategy; covers hospital and long-term care generally, not ICU sedation.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "For people in whom delirium does not resolve: re-evaluate for underlying causes follow up and assess for possible dementia (see the NICE guideline on dementia).",
       "highlight": "re-evaluate for underlying causes",
       "scope": "different-setting",
       "note": "Closest parallel to the persistent-agitation trigger, but reassesses underlying causes generally in hospital/long-term care rather than reassessing an ICU sedation strategy.",
       "page": "12",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "If a person with delirium is distressed or considered a risk to themselves or others, first use verbal and non-verbal techniques to de-escalate the situation.",
       "highlight": "first use verbal and non-verbal techniques to de-escalate the situation",
       "scope": "different-intervention",
       "note": "Addresses distressed delirious patients via verbal/non-verbal de-escalation (an earlier ladder step and a different intervention), not sedation reassessment.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "Project BETA",
     "cite": "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Verbal de-escalation guidance from the psychiatric emergency setting; contributes agitation-management context but does not address ICU sedation reassessment.",
     "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/",
     "paragraphs": [
      {
       "context": "The goal of medicating the agitated patient is not to sedate but to calm him.",
       "highlight": "is not to sedate but to calm him",
       "scope": "different-setting",
       "note": "Psychiatric-emergency de-escalation guidance whose stated aim is to calm rather than sedate — a different setting and intervention that contrasts with, rather than supports, a sedation strategy.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      },
      {
       "context": "Finally, when verbal attempts to de-escalate fail, more coercive measures such as restraints or injectable medication may be necessary to ensure safety but always as a last resort.",
       "highlight": "more coercive measures such as restraints or injectable medication may be necessary",
       "scope": "different-setting",
       "note": "Describes the psychiatric-ED escalation endpoint (medication/restraint only after verbal de-escalation fails) — a different-setting parallel to the tool's ladder, not sedation reassessment.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      }
     ]
    }
   ],
   "synthesis": "PADIS 2025 is the governing on-scope source: its focused update recommends preferring dexmedetomidine over propofol, titrating to light/target sedation, and switching to alternative agents when delirium or deep-sedation risk apply — the evidence-based substance of \"reassess sedation strategy\" in the ICU. NICE CG103 and Project BETA are nearest matches on agitation/distress management but a different scope (re-evaluating underlying causes and verbal de-escalation in general hospital/long-term care and psychiatric-emergency settings, respectively), so they do not directly support the ICU sedation-strategy step.",
   "discrepancy": true
  },
  {
   "id": "spa-r50",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Escalation ladder — 4 · Safety risk only",
   "statement": "Document the indication first",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "NICE CG103",
    "Project BETA"
   ],
   "anchor": "NICE CG103 — p. 11",
   "passage": "… Consider involving family, friends and carers to help with this. Provide a suitable care environment (see recommendation 1.4.1 in the section on preventing delirium). [2010] Distressed people 1.7.3 If a person with delirium is distressed or considered a risk to themselves or others, first use verbal and non-verbal techniques to de-escalate the situation. For more information on de-escalation techniques, see the NICE guideline on violence and aggression. Distress may be less evident in people with hypoactive delirium, who can still become distressed by, for example, psychotic symptoms. [2010] 1.7.4 If a person with delirium is distressed or considered a risk to themselves or others, and verbal and non-verbal de-escalation techniques are ineffective or inappropriate, consider giving short-term haloperidol (usually for 1 week or less). Start at the lowest clinically appropriate dose and titrate cautiously according to symptoms. Take into account the Medicines and Healthcare products Regulatory Agency's advice about the risks of using haloperidol for the acute treatment of delirium in older people, including the risks of cardiac and neurological side effects (especially in people living with Parkinson's disease or dementia with Lewy bodies). [2010] Delirium: prevention, diagnosis and management in hospital and long-term care (CG103) © NICE 2025. All rights reserved. Subject to Notice of rights (https://www.nice.org.uk/terms-andconditions#notice-of-rights). Page 11 of 24\nNICE CG103 1.7.4 conditions pharmacologic treatment on a specific indication (distress or safety risk after failed de-escalation), supporting the step in substance; the explicit act of documenting the indication is not stated.",
   "evidence": "Full text, p. 11 — partial support",
   "status": "fulltext",
   "pageNum": "11",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://www.nice.org.uk/guidance/cg103",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "partial",
     "note": "Page-11 recommendations restrict pharmacologic use to a distress/safety-risk indication after de-escalation fails and separately require documenting the delirium diagnosis, but NICE never states the exact 'document the indication first' imperative for the medication.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "inappropriate, consider giving short-term haloperidol (usually for 1 week or less).",
       "highlight": "consider giving short-term haloperidol (usually for 1 week or less)",
       "scope": "on-scope",
       "note": "Defines the safety-risk indication (person distressed or a risk to self/others, de-escalation ineffective/inappropriate) that gates short-term haloperidol — the indication the step tells staff to document.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "others, first use verbal and non-verbal techniques to de-escalate the situation.",
       "highlight": "first use verbal and non-verbal techniques to de-escalate the situation.",
       "scope": "on-scope",
       "note": "Requires verbal/non-verbal de-escalation before any medication — the escalation-ladder ordering the 'safety risk only' step enforces.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Ensure that the diagnosis of delirium is documented both in the person's record or notes, and in their primary care health record.",
       "highlight": "the diagnosis of delirium is documented both in the person's record",
       "scope": "broader",
       "note": "NICE's documentation duty, but scoped to the delirium diagnosis rather than the specific medication indication the tool step names.",
       "page": "10",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Ensure that any changes that may indicate delirium are documented in the person's record or notes.",
       "highlight": "changes that may indicate delirium are documented",
       "scope": "background",
       "note": "Supports the general documentation principle (record changes indicating delirium) but does not address documenting a medication indication before pharmacologic escalation.",
       "page": "9",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "The adult-ICU focused update addresses antipsychotic efficacy and de-prescribing, not documenting an indication before pharmacologic management of a safety-risk agitation.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "We are unable to issue a recommendation for or against the use of antipsychotics over usual care for the treatment of delirium in adult patients admitted to the ICU (conditional recommendation; for intervention or comparison; low certainty of evidence).",
       "highlight": "the use of antipsychotics over usual care for the treatment of delirium in adult patients admitted to the ICU",
       "scope": "different-setting",
       "note": "Nearest keyword match, but scoped to antipsychotic efficacy for established delirium in adult ICU patients - silent on documenting an indication for a safety risk.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Pain, Agitation/Sedation, Delirium, Immobility, and Sleep Disruption 2018 Recommendations No recommendations previously existed We suggest using either propofol or dexmedetomidine over benzodiazepines for sedation in critically ill, mechanically ventilated adults (conditional recommendation, low quality of evidence) We suggest not routinely using haloperidol or an atypical antipsychotic, to treat delirium (conditional recommendation, low quality of evidence) We suggest performing rehabilitation or mobilization in critically ill adults (conditional recommendation, low quality evidence) We make no recommendation regarding the use of melatonin to improve sleep in critically ill adults (no recommendation, very low quality of evidence)",
       "highlight": "not routinely using haloperidol or an atypical antipsychotic, to treat delirium",
       "scope": "different-setting",
       "note": "Reserves antipsychotics for delirium (aligns loosely with 'safety risk only') but frames it as ICU efficacy guidance, not a documentation instruction.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Most RCTs enrolled a mix of patients with either hypoactive and/or hyperactive delirium and, therefore, it is unclear if there is a single patient population that would benefit most from an antipsychotic. In addition, if used, one must be prudent to discontinue antipsychotics that were newly initiated in the ICU upon discharge if no longer clinically required (66).",
       "highlight": "discontinue antipsychotics that were newly initiated in the ICU upon discharge if no longer clinically required",
       "scope": "different-setting",
       "note": "Closest to a clinical-indication caveat (continue only if clinically required) but ICU-specific and about de-prescribing at discharge, not documenting the indication first.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "Project BETA",
     "cite": "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25.",
     "kind": "pdf",
     "stance": "background",
     "note": "APA Project BETA consensus on verbal de-escalation of the agitated patient (emergency psychiatry) — supports de-escalation before medication and medication/restraint as a last resort, but says nothing about documenting the indication.",
     "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/",
     "paragraphs": [
      {
       "context": "Finally, when verbal attempts to de-escalate fail, more coercive measures such as restraints or injectable medication may be necessary to ensure safety but always as a last resort.",
       "highlight": "more coercive measures such as restraints or injectable medication may be necessary to ensure safety but always as a last resort",
       "scope": "different-setting",
       "note": "Nearest match on the escalation ordering (medication as a last resort after de-escalation fails) but set in emergency psychiatry / acute behavioral emergency, not ICU delirium documentation.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      },
      {
       "context": "There are patients who cannot be effectively engaged and verbally de-escalated, eg, a delirious patient.",
       "highlight": "cannot be effectively engaged and verbally de-escalated, eg, a delirious patient",
       "scope": "different-setting",
       "note": "Names delirious patients as an exception to verbal de-escalation, but in the emergency-department agitation context, not addressing the documentation step.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      }
     ]
    }
   ],
   "synthesis": "NICE CG103 governs: its page-11 recommendations restrict pharmacologic management to a distress/safety-risk indication (after verbal/non-verbal de-escalation is ineffective or inappropriate) and it separately requires documenting the delirium diagnosis, which together underpin the \"document the indication first\" step, though NICE does not state that exact imperative verbatim (partial). PADIS 2025 (adult ICU, antipsychotic efficacy/de-prescribing) and Project BETA (emergency-psychiatry verbal de-escalation) are nearest-match but different-setting sources that supply de-escalation-first / reserve-medication context and do not address documenting the indication, so neither governs this claim.",
   "discrepancy": true
  },
  {
   "id": "spa-r51",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Escalation ladder — 4 · Safety risk only",
   "statement": "Lowest dose, shortest duration; monitor QTc",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "NICE CG103",
    "Project BETA"
   ],
   "anchor": "NICE CG103 — p. 11",
   "passage": "… [2010] Distressed people 1.7.3 If a person with delirium is distressed or considered a risk to themselves or others, first use verbal and non-verbal techniques to de-escalate the situation. For more information on de-escalation techniques, see the NICE guideline on violence and aggression. Distress may be less evident in people with hypoactive delirium, who can still become distressed by, for example, psychotic symptoms. [2010] 1.7.4 If a person with delirium is distressed or considered a risk to themselves or others, and verbal and non-verbal de-escalation techniques are ineffective or inappropriate, consider giving short-term haloperidol (usually for 1 week or less). Start at the lowest clinically appropriate dose and titrate cautiously according to symptoms. Take into account the Medicines and Healthcare products Regulatory Agency's advice about the risks of using haloperidol for the acute treatment of delirium in older people, including the risks of cardiac and neurological side effects (especially in people living with Parkinson's disease or dementia with Lewy bodies). [2010] Delirium: prevention, diagnosis and management in hospital and long-term care (CG103) © NICE 2025. All rights reserved. Subject to Notice of rights (https://www.nice.org.uk/terms-andconditions#notice-of-rights). Page 11 of 24\nNICE CG103 1.7.4 also directs clinicians to weigh 'the risks of cardiac and neurological side effects,' consistent with QTc monitoring; the explicit QTc/torsades warning appears in the haloperidol label.",
   "evidence": "Full text, p. 11",
   "status": "fulltext",
   "pageNum": "11",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://www.nice.org.uk/guidance/cg103",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary on-scope source (p.11): directly recommends the lowest clinically appropriate dose and short-term haloperidol (usually 1 week or less), reserved for delirium patients who are a risk to self/others when de-escalation fails, with a cardiac side-effect caution underpinning QTc monitoring.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "others, and verbal and non-verbal de-escalation techniques are ineffective or inappropriate, consider giving short-term haloperidol (usually for 1 week or less).",
       "highlight": "consider giving short-term haloperidol (usually for 1 week or less)",
       "scope": "on-scope",
       "note": "Reserves short-term haloperidol (usually 1 week or less = the shortest-duration element) for delirium patients who are a risk to self/others after de-escalation fails, matching the tool's 'safety risk only' step.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Start at the lowest clinically appropriate dose and titrate cautiously according to symptoms.",
       "highlight": "Start at the lowest clinically appropriate dose",
       "scope": "on-scope",
       "note": "Directly supports the 'lowest dose' element of the statement.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "delirium in older people, including the risks of cardiac and neurological side effects (especially in people living with Parkinson's disease or dementia with Lewy bodies).",
       "highlight": "including the risks of cardiac and neurological side",
       "scope": "on-scope",
       "note": "The cardiac side-effect caution is the basis for QTc monitoring, though NICE says 'risks of cardiac ... side effects' rather than literally 'monitor QTc'.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "ICU-specific nearest match: declines to recommend antipsychotics for delirium and gives no lowest-dose/shortest-duration/monitor-QTc rule, though it reports pooled QT/arrhythmia safety data and advises stopping ICU-initiated antipsychotics at discharge.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "We are unable to issue a recommendation for or against the use of antipsychotics over usual care for the treatment of delirium in adult patients admitted to the ICU (conditional recommendation; for intervention or comparison; low certainty of evidence).",
       "highlight": "unable to issue a recommendation for or against the use of antipsychotics over usual care for the treatment of delirium in adult patients admitted to the ICU",
       "scope": "different-setting",
       "note": "ICU setting; makes no recommendation on antipsychotics for delirium and states no dosing or duration rule, so it neither states nor governs the 'lowest dose, shortest duration' principle.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "-0.35 to 2.86 d; low certainty) and may reduce 28-day mortality (RR, 0.87; 95% CI, 0.75-1.01; low certainty) and mortality at longest follow-up (RR, 0.89; 95% CI, 0.79-1.01; low certainty). There was little to no effect on the duration of invasive mechanical ventilation (moderate certainty), ICU length of stay (very low certainty), or hospital length of stay (low certainty). There was uncertainty regarding the effect on post-ICU posttraumatic stress disorder, functional status at 3 months, post-ICU quality of life, post-ICU cognitive impairment, and duration of delirium (all very low certainty). There may be a slight increase in the risk of arrhythmias (RR, 1.57; 95% CI, 0.66-3.74; low certainty), and little to no effect on QT interval prolongation and extrapyramidal symptoms (both low certainty).",
       "highlight": "little to no effect on QT interval prolongation and extrapyramidal symptoms (both low certainty)",
       "scope": "different-setting",
       "note": "Pooled ICU safety data on QT prolongation and arrhythmia — the rationale behind QTc monitoring — but a meta-analytic effect estimate, not a monitoring instruction.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "Most RCTs enrolled a mix of patients with either hypoactive and/or hyperactive delirium and, therefore, it is unclear if there is a single patient population that would benefit most from an antipsychotic. In addition, if used, one must be prudent to discontinue antipsychotics that were newly initiated in the ICU upon discharge if no longer clinically required (66).",
       "highlight": "discontinue antipsychotics that were newly initiated in the ICU upon discharge if no longer clinically required",
       "scope": "different-setting",
       "note": "Supports minimizing duration (stop when no longer needed) but is ICU discontinuation-at-discharge advice, not a bedside 'shortest duration' dosing rule.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "Project BETA",
     "cite": "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Emergency-psychiatry agitation (archived PMC page), not delirium-specific: supports the escalation-ladder 'safety risk only / medication as last resort' framing and choosing an agent by side-effect profile, but states no dose, duration, or QTc-monitoring guidance.",
     "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/",
     "paragraphs": [
      {
       "context": "Finally, when verbal attempts to de-escalate fail, more coercive measures such as restraints or injectable medication may be necessary to ensure safety but always as a last resort.",
       "highlight": "when verbal attempts to de-escalate fail, more coercive measures such as restraints or injectable medication may be necessary to ensure safety but always as a last resort",
       "scope": "different-population",
       "note": "Agitated emergency-psychiatry patients (not delirium-specific); supports reserving medication for a safety risk as a last resort, but gives no dose/duration/QTc detail.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      },
      {
       "context": "Even when there is no choice but to give an injection, the clinician can give a choice as to which drug is to be used, emphasizing that one has a more beneficial side-effect profile.",
       "highlight": "emphasizing that one has a more beneficial side-effect profile",
       "scope": "different-population",
       "note": "Choosing an agent by side-effect profile is adjacent to the cardiac/QTc-safety concern but is about offering the patient a drug choice, not lowest dose or QTc monitoring.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      },
      {
       "context": "The goal of medicating the agitated patient is not to sedate but to calm him.",
       "highlight": "The goal of medicating the agitated patient is not to sedate but to calm him",
       "scope": "different-population",
       "note": "'Calm, not sedate' is philosophically adjacent to a lowest-effective-dose approach but is an agitation-management principle, not the delirium dosing/duration/QTc statement.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      }
     ]
    }
   ],
   "synthesis": "NICE CG103 (p.11) is the governing on-scope source: it directly supports the lowest clinically appropriate dose and short-term haloperidol (usually 1 week or less), reserved for delirium patients who are a risk to self/others after de-escalation fails, and cautions about cardiac side effects — the basis for QTc monitoring, though it does not use the words \"monitor QTc.\" PADIS 2025 (ICU antipsychotics-for-delirium, which declines to recommend and reports only pooled QT/arrhythmia safety data) and Project BETA (emergency-psychiatry agitation, medication-as-last-resort) are nearest matches at different scope that reinforce the surrounding framing but do not state the lowest-dose/shortest-duration/monitor-QTc rule.",
   "discrepancy": true
  },
  {
   "id": "spa-r52",
   "toolId": "spa",
   "tool": "SPA Quick Reference",
   "page": "2",
   "section": "Escalation ladder — 4 · Safety risk only",
   "statement": "Taper / stop; none at discharge without psych indication",
   "contentType": "Cited clinical content",
   "sources": [
    "PADIS 2025",
    "NICE CG103",
    "Project BETA"
   ],
   "anchor": "NICE CG103 — p. 11",
   "passage": "… [2010] Distressed people 1.7.3 If a person with delirium is distressed or considered a risk to themselves or others, first use verbal and non-verbal techniques to de-escalate the situation. For more information on de-escalation techniques, see the NICE guideline on violence and aggression. Distress may be less evident in people with hypoactive delirium, who can still become distressed by, for example, psychotic symptoms. [2010] 1.7.4 If a person with delirium is distressed or considered a risk to themselves or others, and verbal and non-verbal de-escalation techniques are ineffective or inappropriate, consider giving short-term haloperidol (usually for 1 week or less). Start at the lowest clinically appropriate dose and titrate cautiously according to symptoms. Take into account the Medicines and Healthcare products Regulatory Agency's advice about the risks of using haloperidol for the acute treatment of delirium in older people, including the risks of cardiac and neurological side effects (especially in people living with Parkinson's disease or dementia with Lewy bodies). [2010] Delirium: prevention, diagnosis and management in hospital and long-term care (CG103) © NICE 2025. All rights reserved. Subject to Notice of rights (https://www.nice.org.uk/terms-andconditions#notice-of-rights). Page 11 of 24\nNICE CG103's short-term framing (one week or less) supports tapering and stopping; discontinuation at discharge absent a psychiatric indication is not stated in the cited sources.",
   "evidence": "Full text, p. 11 — partial support",
   "status": "fulltext",
   "pageNum": "11",
   "citations": [
    "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000006574",
    "https://www.nice.org.uk/guidance/cg103",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "PADIS 2025",
     "cite": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000006574",
     "paragraphs": [
      {
       "context": "Most RCTs enrolled a mix of patients with either hypoactive and/or hyperactive delirium and, therefore, it is unclear if there is a single patient population that would benefit most from an antipsychotic. In addition, if used, one must be prudent to discontinue antipsychotics that were newly initiated in the ICU upon discharge if no longer clinically required (66).",
       "highlight": "one must be prudent to discontinue antipsychotics that were newly initiated in the ICU upon discharge if no longer clinically required",
       "scope": "on-scope",
       "note": "Directly governs the discharge clause: ICU-initiated antipsychotics should be stopped at discharge unless still clinically required (i.e., none continued without an ongoing indication).",
       "page": "e718",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      },
      {
       "context": "We are unable to issue a recommendation for or against the use of antipsychotics over usual care for the treatment of delirium in adult patients admitted to the ICU (conditional recommendation; for intervention or comparison; low certainty of evidence).",
       "highlight": "We are unable to issue a recommendation for or against the use of antipsychotics over usual care for the treatment of delirium",
       "scope": "broader",
       "note": "The overarching antipsychotic-for-delirium question (no recommendation for routine use) grounds the ladder's reserve-them-for-safety-risk-only framing that precedes the taper/stop instruction.",
       "page": "e718",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "inappropriate, consider giving short-term haloperidol (usually for 1 week or less).",
       "highlight": "consider giving short-term haloperidol (usually for 1 week or less)",
       "scope": "on-scope",
       "note": "Grounds the safety-risk-only trigger (distress or risk to self/others after de-escalation fails) and the taper/stop half (short-term, usually 1 week or less, lowest dose, titrate cautiously); it does not itself address the at-discharge clause.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "Project BETA",
     "cite": "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/",
     "paragraphs": [
      {
       "context": "The goal of medicating the agitated patient is not to sedate but to calm him.",
       "highlight": "The goal of medicating the agitated patient is not to sedate but to calm him",
       "scope": "different-setting",
       "note": "Emergency-psychiatry verbal de-escalation of the acutely agitated patient; nearest content match on the ladder's de-escalation-first / medication-to-calm philosophy, but it does not address antipsychotic tapering or discharge deprescribing.",
       "page": "",
       "docUrl": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      }
     ]
    }
   ],
   "synthesis": "The two on-scope guidelines agree and are complementary: NICE CG103 (p.11) reserves short-term haloperidol (usually 1 week or less) for distress or safety risk after de-escalation fails — grounding the safety-risk-only trigger and the taper/stop half — while PADIS 2025 governs the discharge clause, directing that ICU-initiated antipsychotics be discontinued at discharge if no longer clinically required. Project BETA is a different-setting nearest match (emergency-psychiatry verbal de-escalation, medication to calm not sedate) that grounds the ladder's de-escalation-first philosophy but says nothing about antipsychotic tapering or discharge deprescribing.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r3",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "1",
   "section": "Arousal card — RASS anchors",
   "statement": "RASS 0: Spontaneous attention to caregiver",
   "contentType": "Validated instrument wording",
   "sources": [
    "Sessler 2002 (RASS)",
    "Kerson 2016 (RASS)"
   ],
   "anchor": "Kerson 2016 (Table 1): \"Alert and calm\"",
   "passage": "Kerson 2016 (Table 1) defines RASS 0 as 'Alert and calm'; the printed 'spontaneous attention to caregiver' is a pediatric operationalization rather than the verbatim source anchor.",
   "evidence": "Full text, p. 2 — partial support",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1186/s40560-016-0189-5"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Original adult RASS validation cited by section/DOI (Am J Respir Crit Care Med 2002;166:1338); it defines the RASS scale whose score 0 is \"Alert and calm,\" but it is not archived here, so no paragraphs are extractable.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Kerson 2016 (RASS)",
     "cite": "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)",
     "kind": "pdf",
     "stance": "partial",
     "note": "Pediatric RASS validation reproduces the RASS in Table 1 (score 0 = \"Alert and calm\") and confirms its validity in critically ill children; it grounds the card's RASS-0 arousal level but does not contain the card's descriptor \"Spontaneous attention to caregiver.\"",
     "docUrl": "",
     "paragraphs": [
      {
       "context": "The specific RASS items from 0 to -5, respectively, include \"alert and calm,\" \"drowsy,\" \"light sedation,\" \"moderate sedation,\" \"deep sedation,\" and \"unarousable.\"",
       "highlight": "alert and calm",
       "scope": "on-scope",
       "note": "The Statistical-analysis sentence names \"alert and calm\" as the RASS 0 item (items given 0 to -5, respectively); the tool's \"attention to caregiver\" wording does not appear, so it supports the RASS-0 arousal anchor only in part.",
       "page": "3",
       "docUrl": ""
      },
      {
       "context": "The specific RASS items from 0 to -5, respectively, include \"alert and calm,\" \"drowsy,\" \"light sedation,\" \"moderate sedation,\" \"deep sedation,\" and \"unarousable.\"",
       "highlight": "alert and calm",
       "scope": "on-scope",
       "note": "Statistical-analysis prose restates the RASS score-to-term mapping, explicitly naming RASS 0 as \"alert and calm\" — the source term for the card's RASS-0 anchor.",
       "page": "3",
       "docUrl": ""
      },
      {
       "context": "Conclusions: The RASS is a valid responsiveness tool for use in critically ill children. It allows for accurate assessment of awareness in mechanically ventilated and spontaneously breathing patients, and may improve our ability to titrate sedatives and assess for delirium in pediatrics.",
       "highlight": "The RASS is a valid responsiveness tool for use in critically ill children",
       "scope": "broader",
       "note": "Establishes RASS validity across mechanically ventilated and spontaneously breathing (verbal) critically ill children, supporting the tool's application of RASS to verbal children but broader than the specific RASS-0 descriptor.",
       "page": "1",
       "docUrl": ""
      }
     ]
    }
   ],
   "synthesis": "Kerson 2016 — the pediatric RASS validation the card applies to verbal children — governs this claim: Table 1 gives RASS score 0 = \"Alert and calm\" and the paper confirms RASS validity in critically ill children, so the card's RASS-0 anchor is well grounded. Support is partial only on wording: the card's descriptor \"Spontaneous attention to caregiver\" is a behavioral gloss of that alert-and-calm level and appears nowhere verbatim in the source (whose RASS-0 term, per both Kerson and the cited Sessler 2002 original, is \"Alert and calm\").",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r4",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "1",
   "section": "Arousal card — RASS anchors",
   "statement": "RASS +4: Combative, violent — immediate danger to staff",
   "contentType": "Validated instrument wording",
   "sources": [
    "Sessler 2002 (RASS)",
    "Kerson 2016 (RASS)"
   ],
   "anchor": "Kerson 2016 (Table 1): \"Overtly combative or violent; immediate danger to staff\"",
   "passage": "",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1186/s40560-016-0189-5"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Original adult RASS derivation that defines the +4 anchor as combative/violent with immediate danger to staff; cited by section as the scale's origin (no archived text to quote).",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Kerson 2016 (RASS)",
     "cite": "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "",
     "paragraphs": [
      {
       "context": "Overtly combative or violent; immediate danger to staff",
       "highlight": "Overtly combative or violent; immediate danger to staff",
       "scope": "on-scope",
       "note": "Table 1 defines the pediatric RASS score of 4 (Combative) with wording identical to the claim statement.",
       "page": "Table 1",
       "docUrl": ""
      },
      {
       "context": "Prior to scoring the RASS, the bedside nurse completed a 10-cm VAS by marking a single line on a scale anchored by the terms \"unresponsive\" and \"combative\" for each patient (with the center of the scale intended to represent \"alert and calm\").",
       "highlight": "anchored by the terms \"unresponsive\" and \"combative\"",
       "scope": "background",
       "note": "Nearest keyword match: the 10-cm visual analog scale is anchored by \"unresponsive\" and \"combative\", but this is a separate validation instrument in the methods, not the RASS +4 arousal-scale definition.",
       "page": "",
       "docUrl": ""
      }
     ]
    }
   ],
   "synthesis": "The two sources agree: Kerson 2016 Table 1 — the pediatric RASS validation and the on-scope source for this verbal-child tool — reproduces the RASS +4 definition verbatim (\"Overtly combative or violent; immediate danger to staff\"), matching Sessler's original adult RASS that the section cites as the scale's origin. The VAS \"combative\" anchor in Kerson's methods shares the keyword but is a separate validation instrument, not direct support for the +4 arousal-scale definition.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r5",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "1",
   "section": "Arousal card — RASS anchors",
   "statement": "RASS +3: Pulls to remove tubes or catheters; aggressive",
   "contentType": "Validated instrument wording",
   "sources": [
    "Sessler 2002 (RASS)",
    "Kerson 2016 (RASS)"
   ],
   "anchor": "Kerson 2016 (Table 1): \"Pulls on or removes tube(s) or catheter(s) or has aggressive behavior toward staff\"",
   "passage": "",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1186/s40560-016-0189-5"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Kerson 2016 (RASS)",
     "cite": "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "",
     "paragraphs": [
      {
       "context": "Pulls on or removes tube(s) or catheter(s) or has aggressive behavior toward staff",
       "highlight": "Pulls on or removes tube(s) or catheter(s) or has aggressive behavior toward staff",
       "scope": "on-scope",
       "note": "Table 1 gives the RASS score 3 \"Very agitated\" description verbatim as the claim's +3 anchor, in the pediatric RASS validation the tool applies to children.",
       "page": "2",
       "docUrl": ""
      },
      {
       "context": "From Sessler et al. [8] and Malviya et al. [10] Kerson et al. Journal of Intensive Care (2016) 4:65 upon the nurse's interaction with the patient in order to Results generate the RASS score).",
       "highlight": "From Sessler et al. [8] and Malviya et al. [10]",
       "scope": "background",
       "note": "Table 1's footnote attributes the RASS anchor wording to the original adult Sessler RASS, here reproduced within the pediatric validation the claim cites.",
       "page": "2",
       "docUrl": ""
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Cited as the original adult RASS (Am J Respir Crit Care Med 2002;166:1338); it is the source from which Kerson Table 1's +3 'Very agitated' wording derives, but no archived text file was provided for this source.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "Kerson 2016 Table 1 directly supports the claim, reproducing the RASS score 3 ('Very agitated') description verbatim as \"Pulls on or removes tube(s) or catheter(s) or has aggressive behavior toward staff\" within a pediatric ICU validation, which is the on-scope governing source for the tool's pediatric card. Sessler 2002 is the original adult RASS from which that wording is drawn (Table 1 attributes it \"From Sessler et al.\"), so the two sources agree on the anchor text.",
   "discrepancy": false
  },
  {
   "id": "peds-cards-r6",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "1",
   "section": "Arousal card — RASS anchors",
   "statement": "RASS +2: Frequent non-purposeful movement; fights ventilator",
   "contentType": "Validated instrument wording",
   "sources": [
    "Sessler 2002 (RASS)",
    "Kerson 2016 (RASS)"
   ],
   "anchor": "Kerson 2016 (Table 1): \"Frequent nonpurposeful movement or patient-ventilator dyssynchrony\"",
   "passage": "The printed 'fights ventilator' corresponds to the source's 'patient-ventilator dyssynchrony'.",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1186/s40560-016-0189-5"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Kerson 2016 (RASS)",
     "cite": "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Pediatric RASS validation; Table 1 directly defines the +2 'Agitated' row as 'Frequent nonpurposeful movement or patient-ventilator dyssynchrony'.",
     "docUrl": "",
     "paragraphs": [
      {
       "context": "Frequent nonpurposeful movement or patient-ventilator dyssynchrony",
       "highlight": "Frequent nonpurposeful movement or patient-ventilator dyssynchrony",
       "scope": "on-scope",
       "note": "Table 1 gives the +2 'Agitated' descriptor verbatim for the on-scope population (critically ill children) the arousal card applies to.",
       "page": "2 of 6",
       "docUrl": ""
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Original adult RASS (Sessler 2002) is the parent scale and the source of the 'fights ventilator' wording for the +2 'Agitated' anchor; cited by section, no archived text file to quote.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "The pediatric RASS validation (Kerson 2016, Table 1) directly supports the +2 'Agitated' descriptor — \"Frequent nonpurposeful movement or patient-ventilator dyssynchrony\" — and is the on-scope governing source for the tool's verbal-child population. The 'fights ventilator' phrasing in the statement traces to the original adult Sessler RASS, which Kerson rephrases as patient-ventilator dyssynchrony with equivalent meaning, so the two sources agree in substance.",
   "discrepancy": false
  },
  {
   "id": "peds-cards-r7",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "1",
   "section": "Arousal card — RASS anchors",
   "statement": "RASS +1: Anxious, apprehensive — movements not aggressive",
   "contentType": "Validated instrument wording",
   "sources": [
    "Sessler 2002 (RASS)",
    "Kerson 2016 (RASS)"
   ],
   "anchor": "Kerson 2016 (Table 1): \"Anxious or apprehensive but movements not aggressive or vigorous\"",
   "passage": "",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1186/s40560-016-0189-5"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Web source (no archived text file); the original adult ICU validation of the Richmond Agitation-Sedation Scale from which the RASS +1 \"Restless\" descriptor originates. Cited by section/DOI as the scale's provenance.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Kerson 2016 (RASS)",
     "cite": "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Table 1 (reproduced in both the plain-text and layout-preserving extractions) gives the RASS +1 \"Restless\" row as \"Anxious or apprehensive but movements not aggressive or vigorous,\" directly supporting the claim in the on-scope critically-ill-children population.",
     "docUrl": "",
     "paragraphs": [
      {
       "context": "Anxious or apprehensive but movements not aggressive or vigorous",
       "highlight": "Anxious or apprehensive but movements not aggressive or vigorous",
       "scope": "on-scope",
       "note": "Table 1's RASS score +1 (\"Restless\") descriptor matches the tool's arousal-card wording verbatim, in the pediatric RASS validation the tool applies to verbal children.",
       "page": "Table 1",
       "docUrl": ""
      }
     ]
    }
   ],
   "synthesis": "Kerson 2016 Table 1 reproduces the RASS +1 (\"Restless\") descriptor verbatim as \"Anxious or apprehensive but movements not aggressive or vigorous,\" directly supporting the tool's arousal-card wording; as the pediatric RASS validation in critically ill children it is the governing on-scope source. Sessler 2002 (web, background) is the original adult RASS this descriptor derives from, and the two sources agree.",
   "discrepancy": false
  },
  {
   "id": "peds-cards-r8",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "1",
   "section": "Arousal card — RASS anchors",
   "statement": "RASS -1: Not fully alert — sustained awakening to voice; eye opening and eye contact ≥ 10 s",
   "contentType": "Validated instrument wording",
   "sources": [
    "Sessler 2002 (RASS)",
    "Kerson 2016 (RASS)"
   ],
   "anchor": "Kerson 2016 (Table 1): \"Not fully alert, but has sustained (more than 10 s) awakening, with eye contact, to voice\"",
   "passage": "",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1186/s40560-016-0189-5"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Kerson 2016 (RASS)",
     "cite": "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Pediatric RASS validation; Table 1 reproduces the RASS -1 anchor that the claim states.",
     "docUrl": "",
     "paragraphs": [
      {
       "context": "Not fully alert, but has sustained (more than 10 s) 1 awakening, with eye contact, to voice",
       "highlight": "sustained (more than 10 s) 1 awakening, with eye contact, to voice",
       "scope": "on-scope",
       "note": "Table 1 RASS -1 'Drowsy' row defines the anchor as sustained (>10 s) awakening with eye contact to voice; the '1' is an inline footnote marker in the source.",
       "page": "3",
       "docUrl": ""
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Original adult RASS scale, cited as the source of Kerson's Table 1 ('From Sessler et al. [8]') and the origin of the eye-opening/eye-contact (≥10 s) description; no archived file to quote (cited by section).",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "The pediatric RASS validation (Kerson 2016, Table 1) directly reproduces the RASS -1 \"Drowsy\" anchor — sustained (>10 s) awakening with eye contact to voice — matching the claim, and is the on-scope source that governs. Sessler 2002 is the original adult RASS from which that description derives (cited as the source of Table 1) and agrees as background; the two do not conflict.",
   "discrepancy": false
  },
  {
   "id": "peds-cards-r9",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "1",
   "section": "Arousal card — RASS anchors",
   "statement": "RASS -2: Briefly awakens to voice; eyes open but contact < 10 s",
   "contentType": "Validated instrument wording",
   "sources": [
    "Sessler 2002 (RASS)",
    "Kerson 2016 (RASS)"
   ],
   "anchor": "Kerson 2016 (Table 1): \"Briefly (less than 10 s) awakens with eye contact to voice\"",
   "passage": "",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1186/s40560-016-0189-5"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Kerson 2016 (RASS)",
     "cite": "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Table 1 (page 3, 'Comparison of Richmond Agitation-Sedation Scale and University of Michigan Sedation Scale') reproduces the RASS with the -2 descriptor verbatim; Kerson validated this scale in critically ill children, matching the pediatric card's scope.",
     "docUrl": "",
     "paragraphs": [
      {
       "context": "Briefly (less than 10 s) awakens with eye contact to voice -3 Moderate sedation Any movement (but no eye contact) to voice 2 -4 Deep sedation No response to voice, but any movement to 3 physical stimulation -5 Unarousable No response to voice or physical stimulation 4 Awake and alert Minimally sedated Tired/sleepy, appropriate response to verbal conversation and/or sound Moderately sedated Somnolent/sleeping, easily aroused with light tactile stimulation or a simple verbal command Deeply sedated Deep sleep, arousable on with significant physical stimulation Unarousable Unarousable From Sessler et al.",
       "highlight": "Briefly (less than 10 s) awakens with eye contact to voice",
       "scope": "on-scope",
       "note": "Table 1's RASS column defines the -2 'light sedation' anchor exactly as the card states: brief (<10 s) awakening with eye contact to voice, in the pediatric RASS validation the tool applies.",
       "page": "3",
       "docUrl": ""
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Original adult RASS source (Am J Respir Crit Care Med 2002;166:1338-44) from which the -2 descriptor derives; not archived as text here, cited as the primary scale reference (Kerson's Table 1 attributes it to Sessler et al. [8]).",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "Both sources agree on the RASS -2 anchor. Kerson 2016 is the on-scope governing source: its Table 1 reproduces the RASS in the pediatric validation and states the -2 (light sedation) descriptor \"Briefly (less than 10 s) awakens with eye contact to voice,\" matching the card verbatim; Sessler 2002 is the original adult RASS from which that wording derives and supplies no separate archived text here.",
   "discrepancy": false
  },
  {
   "id": "peds-cards-r10",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "1",
   "section": "Arousal card — RASS anchors",
   "statement": "RASS -3: Movement or eye opening to voice; no eye contact",
   "contentType": "Validated instrument wording",
   "sources": [
    "Sessler 2002 (RASS)",
    "Kerson 2016 (RASS)"
   ],
   "anchor": "Kerson 2016 (Table 1): \"Any movement (but no eye contact) to voice\"",
   "passage": "",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1186/s40560-016-0189-5"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Kerson 2016 (RASS)",
     "cite": "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Pediatric RASS validation; Table 1 gives the exact -3 anchor.",
     "docUrl": "",
     "paragraphs": [
      {
       "context": "-3 Moderate sedation Any movement (but no eye contact) to voice 2 -4 Deep sedation No response to voice, but any movement to 3 physical stimulation -5 Unarousable No response to voice or physical stimulation 4 Awake and alert Minimally sedated Tired/sleepy, appropriate response to verbal conversation and/or sound Moderately sedated Somnolent/sleeping, easily aroused with light tactile stimulation or a simple verbal command Deeply sedated Deep sleep, arousable on with significant physical stimulation Unarousable Unarousable From Sessler et al.",
       "highlight": "Any movement (but no eye contact) to voice",
       "scope": "on-scope",
       "note": "Kerson Table 1 defines RASS -3 (moderate sedation) in critically ill children as any movement, but no eye contact, to voice — directly matching the card's arousal anchor and the target pediatric population.",
       "page": "3",
       "docUrl": ""
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Original adult-ICU derivation/validation of the RASS; supplies the standard -3 wording ('movement or eye opening to voice, but no eye contact') that Kerson Table 1 reproduces. Cited by reference, not archived as text here.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "The two sources agree: Kerson 2016 Table 1 reproduces the Sessler RASS and defines the -3 \"moderate sedation\" level as \"any movement (but no eye contact) to voice\" in critically ill children — the on-scope pediatric validation that governs the tool's arousal anchor. The claim's \"or eye opening\" phrasing is part of the standard Sessler RASS -3 wording that Kerson explicitly cites (\"From Sessler et al.\"), so there is no substantive conflict.",
   "discrepancy": false
  },
  {
   "id": "peds-cards-r11",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "1",
   "section": "Arousal card — RASS anchors",
   "statement": "RASS -4: No response to voice; movement or eye opening to touch",
   "contentType": "Validated instrument wording",
   "sources": [
    "Sessler 2002 (RASS)",
    "Kerson 2016 (RASS)"
   ],
   "anchor": "Kerson 2016 (Table 1): \"No response to voice, but any movement to physical stimulation\"",
   "passage": "",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1186/s40560-016-0189-5"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Original RASS derivation and validation paper (Am J Respir Crit Care Med 2002;166:1338); cited as the source of the standard RASS -4 wording 'No response to voice, but movement or eye opening to physical stimulation' that the card's statement uses. Not archived here (no text file).",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Kerson 2016 (RASS)",
     "cite": "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Pediatric (PICU) RASS validation — the arousal scale the tool applies to verbal children; Table 1 gives the RASS -4 anchor directly.",
     "docUrl": "",
     "paragraphs": [
      {
       "context": "If there was no response, the nurse physically stimulated the patient while saying his/her name.",
       "highlight": "the nurse physically stimulated the patient while saying his/her name",
       "scope": "background",
       "note": "Study-procedure prose describing how physical/touch stimulation was applied during RASS scoring — context for the '-4 ... to touch' step, not the -4 anchor wording itself.",
       "page": "",
       "docUrl": ""
      }
     ]
    }
   ],
   "synthesis": "Both sources support the RASS -4 anchor and do not conflict. Kerson 2016 — the pediatric PICU RASS validation the tool applies to verbal children — is the on-scope governing source and reproduces the RASS -4 row (attributed to Sessler) as \"No response to voice, but any movement to physical stimulation\" (physical stimulation = touch); the co-cited original adult scale, Sessler 2002 (unarchived web), is the origin of the fuller \"movement or eye opening to physical stimulation\" wording the card uses. Kerson's simplified Table 1 does not separately list \"eye opening,\" but that element traces to the standard RASS in Sessler, so the statement is fully supported across the two sources with no contradiction.",
   "discrepancy": false
  },
  {
   "id": "peds-cards-r12",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "1",
   "section": "Arousal card — RASS anchors",
   "statement": "RASS -5: No response to noxious stimuli",
   "contentType": "Validated instrument wording",
   "sources": [
    "Sessler 2002 (RASS)",
    "Kerson 2016 (RASS)"
   ],
   "anchor": "Kerson 2016 (Table 1): \"No response to voice or physical stimulation\"",
   "passage": "The printed 'no response to noxious stimuli' paraphrases the source anchor 'no response to voice or physical stimulation'; a close but not verbatim match.",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1186/s40560-016-0189-5"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Kerson 2016 (RASS)",
     "cite": "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Table 1 defines RASS -5 as unarousable/no response to voice or physical stimulation; supports the card's -5 anchor (tool paraphrases 'physical stimulation' as 'noxious stimuli').",
     "docUrl": "",
     "paragraphs": [
      {
       "context": "No response to voice or physical stimulation 4 Awake and alert Minimally sedated Tired/sleepy, appropriate response to verbal conversation and/or sound Moderately sedated Somnolent/sleeping, easily aroused with light tactile stimulation or a simple verbal command Deeply sedated Deep sleep, arousable on with significant physical stimulation Unarousable Unarousable From Sessler et al.",
       "highlight": "No response to voice or physical stimulation",
       "scope": "on-scope",
       "note": "Table 1's RASS -5 row ('Unarousable') defines the level as no response to voice or physical stimulation, the direct source of the card's -5 anchor.",
       "page": "3",
       "docUrl": ""
      },
      {
       "context": "If there was no response, the nurse physically stimulated the patient while saying his/her name.",
       "highlight": "the nurse physically stimulated the patient",
       "scope": "on-scope",
       "note": "Study-procedure text describing the RASS scoring escalation to physical stimulation when the patient does not respond, corroborating the -5 (no response to physical stimulation) criterion.",
       "page": "",
       "docUrl": ""
      },
      {
       "context": "Methods The study took place in a 23-bed urban, academic, tertiary care PICU. Our objective was to include 100 consecutive assessments on designated study days. The RASS had been implemented in this PICU as standard of care approximately 5 years prior and is currently performed every 4 h, on every patient, by nursing staff. For the purpose of this study, a separate (simultaneous) RASS was scored by the research team (n = 2). The research team completed an additional sedation assessment, using the previously validated University of Michigan Sedation Scale (UMSS) [10], and the bedside nurse completed a visual analog scale (VAS). Use of the VAS allowed for capture of the bedside nurse's expert opinion in a quantitative fashion. The UMSS was used to assess criterion validity of the sedation portion of the RASS, as it has been validated in children for procedural sedation. (We chose the UMSS, as other pediatric sedation scores require patient intervention such as testing response to noxious stimuli and cough reflex to suctioning. In contrast, the UMSS is simple and observational and is analogous to the sedation portion of the RASS.) The patient's sedation regimen was not altered in any way for the purpose of this study.",
       "highlight": "testing response to noxious stimuli and cough reflex to suctioning",
       "scope": "different-intervention",
       "note": "Only literal 'noxious stimuli' mention in the paper, but it explains why OTHER pediatric sedation scores were rejected in favor of the UMSS — keyword overlap with the claim, not the RASS -5 definition.",
       "page": "2",
       "docUrl": ""
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Original adult RASS derivation/validation (Am J Respir Crit Care Med 2002;166:1338) that defines -5 as unarousable with no response to voice or physical stimulation; cited as the primary RASS the pediatric validation adopts. Web source with no archived text file, so no paragraphs.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "The on-scope source (Kerson 2016, pediatric RASS validation) governs: its Table 1 defines RASS -5 \"Unarousable\" as \"No response to voice or physical stimulation,\" directly grounding the card's -5 anchor, and the tool's \"noxious stimuli\" is a paraphrase of the source's \"physical stimulation.\" Sessler 2002 is the original adult RASS this pediatric study adopts and agrees; the only literal appearance of \"noxious stimuli\" in Kerson is a different-scope keyword match describing why other pediatric sedation scores were rejected in favor of the UMSS, not the -5 definition.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r13",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "1",
   "section": "Arousal card — RASS gate",
   "statement": "RASS ≥ −3 → proceed to Step 2 — the delirium screen; RASS −4 / −5 → STOP — record \"unable to assess\"; reassess when the child responds to voice",
   "contentType": "Validated instrument wording",
   "sources": [
    "Sessler 2002 (RASS)",
    "Kerson 2016 (RASS)"
   ],
   "anchor": "Kerson 2016 (Table 1): \"No response to voice, but any movement to physical stimulation\"",
   "passage": "Kerson 2016 defines the RASS anchors, with no response to voice at -4/-5, which underpins recording 'unable to assess'. The explicit gate ('RASS >= -3 proceed; -4/-5 stop') is not stated in the cited source; it is a CAM-ICU/pCAM protocol convention stated in the psCAM/pCAM instruction materials, which are not cited on this row.",
   "evidence": "Full text, p. 2 — partial support",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)"
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1186/s40560-016-0189-5"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Kerson 2016 (RASS)",
     "cite": "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)",
     "kind": "pdf",
     "stance": "partial",
     "note": "Pediatric RASS validation; Table 1 supplies the −3/−4/−5 arousal definitions the gate applies and the Discussion ties RASS to pediatric delirium screening, but the specific ≥−3 screen cutoff and 'unable to assess' wording are not stated here.",
     "docUrl": "",
     "paragraphs": [
      {
       "context": "No response to voice or physical stimulation",
       "highlight": "No response to voice or physical stimulation",
       "scope": "on-scope",
       "note": "Table 1 RASS -5 'Unarousable' definition — one of the -4/-5 STOP-threshold levels in the claim (record 'unable to assess').",
       "page": "2",
       "docUrl": ""
      },
      {
       "context": "Any movement (but no eye contact) to voice",
       "highlight": "Any movement (but no eye contact) to voice",
       "scope": "on-scope",
       "note": "Table 1 RASS -3 'Moderate sedation' = any movement to voice; the 'responds to voice' boundary separating proceed (≥-3) from STOP (-4/-5).",
       "page": "2",
       "docUrl": ""
      },
      {
       "context": "If the patient did not meet the criteria for a score of 0-4 (see Table 1), the bedside nurse loudly instructed the patient to \"open your eyes,\" as the researcher observed. If there was no response, the nurse physically stimulated the patient while saying his/her name.",
       "highlight": "the nurse physically stimulated the patient while saying his/her name",
       "scope": "on-scope",
       "note": "Scoring procedure operationalizing the voice-first then physical-stimulation escalation that distinguishes 'responds to voice' (-3) from no response to voice (-4/-5).",
       "page": "2",
       "docUrl": ""
      },
      {
       "context": "With validation of the RASS in pediatric patients, use of this tool in PICUs may allow for more accurate assessments of responsiveness and will improve our ability to conduct research on the risk factors and outcomes associated with various levels of sedation and agitation. This will facilitate screening and research in related areas such as delirium, where the RASS has already been used in the validation of delirium scoring systems such as the Cornell Assessment of Pediatric Delirium (CAPD) and the Pediatric Confusion Assessment Method for the ICU (pCAM-ICU) [12, 13].",
       "highlight": "the RASS has already been used in the validation of delirium scoring systems such as the Cornell Assessment of Pediatric Delirium (CAPD) and the Pediatric Confusion Assessment Method for the ICU (pCAM-ICU)",
       "scope": "on-scope",
       "note": "Confirms RASS gates pediatric delirium instruments (CAPD, pCAM-ICU) — the 'proceed to the delirium screen' step — though Kerson does not itself specify the ≥−3 eligibility cutoff.",
       "page": "5",
       "docUrl": ""
      },
      {
       "context": "In adults, the Richmond Agitation-Sedation Scale (RASS) provides a single tool that is intuitive, easy to use, and includes both agitation and sedation. The RASS has been shown to be both reliable and valid in critically ill adults with and without mechanical ventilation and sedating medications [8, 9]. It is an attractive option for use as a responsiveness scale in the Pediatric Intensive Care Unit (PICU). However, it has not been validated in children.",
       "highlight": "The RASS has been shown to be both reliable and valid in critically ill adults",
       "scope": "different-population",
       "note": "Nearest keyword match about RASS validity but in adults (the Sessler/Ely provenance); shares terms yet is not the pediatric support the gate rests on.",
       "page": "1",
       "docUrl": ""
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Original adult-ICU RASS validation (Am J Respir Crit Care Med 2002;166:1338) — provenance of the RASS instrument the pediatric arousal gate is built on; adult population, so it contributes the scale itself rather than pediatric gating support. Cited by section/DOI; not archived here.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "Both sources address the RASS itself, and Kerson 2016 is the on-scope governing source: it is the pediatric (PICU) validation of the RASS and its Table 1 supplies the exact arousal-level definitions the gate applies — −3 \"any movement to voice\" (responds to voice → proceed), −4 \"no response to voice, but movement to physical stimulation\", and −5 \"no response to voice or physical stimulation\" (the −4/−5 STOP levels) — and the Discussion confirms RASS is used as the arousal gate feeding pediatric delirium instruments (CAPD, pCAM-ICU). Kerson is marked partial because it validates the scale and defines the \"responds to voice\" boundary but does not itself state the numeric screen-eligibility cutoff (screen only if RASS ≥ −3) or the \"record unable to assess\" wording — that gating rule derives from the delirium instruments Kerson cites; Sessler 2002 is the RASS's original adult-ICU validation and contributes the instrument's provenance (different population), not pediatric support.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r14",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "1",
   "section": "Arousal card — SBS gate",
   "statement": "SBS ≥ −1 → proceed to Step 2 — the delirium screen; SBS −2 / −3 → STOP — record \"unable to assess\"; reassess when the child responds to gentle touch or voice. Score the child’s response to your voice, then gentle touch, then noxious stimulus, per unit practice (Curley 2006).",
   "contentType": "Validated instrument wording",
   "sources": [
    "Curley 2006 (SBS)"
   ],
   "anchor": "Curley 2006 (SBS) — p. 14, ¶1",
   "passage": "NIH-PA Author Manuscript NIH-PA Author Manuscript NIH-PA Author Manuscript Curley et al. Page 14 Table 3 State Behavioral Scale (SBS) Score as patient's response to voice then gentle touch then noxious stimuli (planned endotracheal suctioning or <5 seconds of nail bed pressure) Score Description Definition -3 Unresponsive No spontaneous respiratory effort No cough or coughs only with suctioning No response to noxious stimuli Unable to pay attention to care provider Does not distress with any procedure (including noxious) Does not move -2 Responsive to noxious stimuli Spontaneous yet supported breathing Coughs with suctioning/repositioning Responds to noxious stimuli Unable to pay attention to care provider Will distress with a noxious procedure Does not move/occasional movement of extremities or shifting of position -1 Responsive to gentle touch or voice Spontaneous but ineffective nonsupported breaths Coughs with suctioning/repositioning Responds to touch/voice A …\nCurley 2006 (Table 3) supports the attributed assessment sequence verbatim, and the -2/-3 anchors ('unable to pay attention to care provider') underpin 'unable to assess'. The '>= -1 proceed; -2/-3 stop' gate itself is a screening convention not stated in Curley.",
   "evidence": "Full text, p. 14 — partial support",
   "status": "fulltext",
   "pageNum": "14",
   "citations": [
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114."
   ],
   "links": [
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Curley 2006 (SBS)",
     "stance": "partial",
     "note": "Curley's Table 3 gives the assessment sequence verbatim and the attention anchors the gate rests on: -3 and -2 are both 'unable to pay attention to care provider', while -1 is 'able to pay attention but drifts off'. The gate itself, proceed at -1 or above and stop at -2/-3, is a screening convention Curley does not state.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "Table 3 State Behavioral Scale (SBS) Score as patient's response to voice then gentle touch then noxious stimuli (planned endotracheal suctioning or <5 seconds of nail bed pressure) Score Description Definition -3 Unresponsive No spontaneous respiratory effort No cough or coughs only with suctioning No response to noxious stimuli Unable to pay attention to care provider Does not distress with any procedure (including noxious) Does not move -2 Responsive to noxious stimuli Spontaneous yet supported breathing Coughs with suctioning/repositioning Responds to noxious stimuli Unable to pay attention to care provider Will distress with a noxious procedure Does not move/occasional movement of extremities or shifting of position -1 Responsive to gentle touch or voice Spontaneous but ineffective nonsupported breaths Coughs with suctioning/repositioning Responds to touch/voice Able to pay attention but drifts off after stimulation Distresses with procedures Able to calm with comforting touch or voice when stimulus removed",
       "highlight": "Score as patient's response to voice then gentle touch then noxious stimuli",
       "page": "14"
      },
      {
       "scope": "on-scope",
       "context": "Table 3 State Behavioral Scale (SBS) Score as patient's response to voice then gentle touch then noxious stimuli (planned endotracheal suctioning or <5 seconds of nail bed pressure) Score Description Definition -3 Unresponsive No spontaneous respiratory effort No cough or coughs only with suctioning No response to noxious stimuli Unable to pay attention to care provider Does not distress with any procedure (including noxious) Does not move -2 Responsive to noxious stimuli Spontaneous yet supported breathing Coughs with suctioning/repositioning Responds to noxious stimuli Unable to pay attention to care provider Will distress with a noxious procedure Does not move/occasional movement of extremities or shifting of position -1 Responsive to gentle touch or voice Spontaneous but ineffective nonsupported breaths Coughs with suctioning/repositioning Responds to touch/voice Able to pay attention but drifts off after stimulation Distresses with procedures Able to calm with comforting touch or voice when stimulus removed",
       "highlight": "Unable to pay attention to care provider",
       "page": "14"
      },
      {
       "scope": "different-intervention",
       "context": "Table 3 State Behavioral Scale (SBS) Score as patient's response to voice then gentle touch then noxious stimuli (planned endotracheal suctioning or <5 seconds of nail bed pressure) Score Description Definition -3 Unresponsive No spontaneous respiratory effort No cough or coughs only with suctioning No response to noxious stimuli Unable to pay attention to care provider Does not distress with any procedure (including noxious) Does not move -2 Responsive to noxious stimuli Spontaneous yet supported breathing Coughs with suctioning/repositioning Responds to noxious stimuli Unable to pay attention to care provider Will distress with a noxious procedure Does not move/occasional movement of extremities or shifting of position -1 Responsive to gentle touch or voice Spontaneous but ineffective nonsupported breaths Coughs with suctioning/repositioning Responds to touch/voice Able to pay attention but drifts off after stimulation Distresses with procedures Able to calm with comforting touch or voice when stimulus removed",
       "highlight": "Able to pay attention but drifts off after stimulation",
       "page": "14"
      }
     ]
    }
   ]
  },
  {
   "id": "peds-cards-r15",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "2",
   "section": "Choose-the-screen card",
   "statement": "CAPD — Every age — the default screen: Observational: rate the child over the shift against age-expected behavior. Works at any developmental age, including deep developmental delay.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Traube 2014 (CAPD)",
    "Smith 2016 (psCAM-ICU)",
    "Smith 2011 (pCAM-ICU)"
   ],
   "anchor": "Traube 2014 (CAPD) — p. 7",
   "passage": "… Psychiatric assessment for these children is more specific and would be appropriate for children with developmental delay who score greater than 9 on the CAPD. However, the screen still has high negative predictive value in this population. Nearly half (48%) of the subjects who received a false-positive CAPD score were diagnosed with delirium at a later point in their PICU stay. We theorize that the CAPD score may trend with the patient's waxing and waning clinical status and may be useful in identifying evolving delirium. Applicability It is significant that 31% of our assessments were in children less than 2 years old, and 27% of our assessments were in children who are developmentally delayed. Our study indicates that the CAPD is a valid and reliable delirium screen in these vulnerable populations. The developmental anchor points for each item were a valuable point-of-use reference for assessing the youngest of patients. With the addition of these anchor points and minimal training, the critical care nursing staff became adept at using the CAPD in all but the most developmentally delayed patients. The nurses completed the assessment midshift, after several hours of observing the child's behavior. In every assessment, the nurses required less than 2 minutes to complete the CAPD screen. Study Limitations The CAPD was developed and validated in a single institution and needs to be replicated in a multi-institutional study. Preparations for such a study are ongoing. …\nTraube 2014 supports the observational design (nurses rate the child over the shift against developmental anchor points) and validation across ages and developmental levels. The paper itself limits use to 'all but the most developmentally delayed patients', and Gupta 2021 reports 16.5% specificity in developmental delay, so 'including deep developmental delay' overstates the evidence.",
   "evidence": "Full text, p. 7",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/CCM.0b013e3181feb489"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary CAPD validation; directly supports every-age, observational-over-shift, age-anchored screening and applicability in developmental delay, with a 'most developmentally delayed' usability caveat.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "It is significant that 31% of our assessments were in children less than 2 years old, and 27% of our assessments were in children who are developmentally delayed. Our study indicates that the CAPD is a valid and reliable delirium screen in these vulnerable populations. The developmental anchor points for each item were a valuable point-of-use reference for assessing the youngest of patients. With the addition of these anchor points and minimal training, the critical care nursing staff became adept at using the CAPD in all but the most developmentally delayed patients. The nurses completed the assessment midshift, after several hours of observing the child's behavior. In every assessment, the nurses required less than 2 minutes to complete the CAPD screen.",
       "highlight": "the critical care nursing staff became adept at using the CAPD in all but the most developmentally delayed patients",
       "scope": "on-scope",
       "note": "Primary anchor (Applicability): confirms CAPD is a valid screen in vulnerable populations and completed midshift after hours of observation, but qualifies 'deep developmental delay' — nurses were adept in all BUT the most developmentally delayed.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "children more than 5 years old, limited in patients with developmental delay, and requires extensive nurse training. The PAED (35) designed, for immediate postoperative use by anesthesiologists, selects for the hyperactive subtype of delirium. An ideal screening tool would detect all types of delirium (hyperactive, hypoactive, and mixed), in patients of all ages and developmental levels.",
       "highlight": "in patients of all ages and developmental levels",
       "scope": "on-scope",
       "note": "States the every-age / every-developmental-level design target the CAPD was built to meet, supporting 'Every age' and 'any developmental age.'",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "The CAPD screen performed similarly in all age groups of children from 0 to 13 years old. The exceptional group was adolescents (> 13-21 years old) where sensitivity was lower (50%; 95% CI, 1.3-99%) and specificity was high (98.1%; 95% CI, 94.3-100%), but this is based on only two confirmed diagnoses of delirium (out of 56 total encounters) in this age group. The performance of the CAPD by gender, respiratory support, prematurity, and illness severity as determined by PIM-2 score is presented in Table 4.",
       "highlight": "The CAPD screen performed similarly in all age groups of children from 0 to 13 years old",
       "scope": "on-scope",
       "note": "Empirical support for 'works at any age' across 0–13 years; adolescents (>13) were the small-n exception, a minor caveat on 'every age.'",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "(51.2%; CI, 24.7-77.8%). Despite this, ROC analysis of the CAPD in children with developmental delay had an area under the curve of 0.86 (Fig. 3), demonstrating its applicability in this hard-to-assess population. The negative predictive value remained quite high at 98.5% (95% CI, 94.8-99.8%).",
       "highlight": "demonstrating its applicability in this hard-to-assess population",
       "scope": "on-scope",
       "note": "Supports use in developmental delay: sensitivity remained high and AUC 0.86 despite reduced specificity (51.2%), the core evidence behind 'including deep developmental delay.'",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "Based on the pilot study, we made additional changes. To better capture a fluctuating course of delirium over a nurse's shift, response options were changed from the original (not at all/ just a little/quite a bit/very much/extremely) to the format \"never/rarely/sometimes/often/ always\". To better reflect the DSM-IV criteria for delirium, and detect alteration in cognitive functioning, we added a third novel item (question 4, Fig. 1), to assess the ability to communicate needs and wants. Content validity of the revised CAPD (Fig. 1) was evaluated by experts in the fields of pediatric critical care, development, delirium, and psychometrics.",
       "highlight": "To better capture a fluctuating course of delirium over a nurse's shift",
       "scope": "on-scope",
       "note": "Supports 'rate the child over the shift' — the response scale is designed to capture the fluctuating course across a nursing shift.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "Anchor Points--Orientation, arousal, and appropriate cognition (which are all affected in delirium) are difficult to assess in young children and even harder to measure in infants. Because of concerns about accurate screening in children under 2 years old, developmental anchor points were delineated. Based on classic texts and established scales of child development, each anchor point characterizes the normal developing child for each item on the CAPD (Table 1). Anchor points describe the associated observable behaviors in a PICU setting (rather than in the child's natural environment) (36, 37). After piloting with nurses for clarity of language and concepts, a short training session was done and anchor point charts were provided for reference to the approximately 100 critical care nurses who participated.",
       "highlight": "each anchor point characterizes the normal developing child for each item on the CAPD",
       "scope": "on-scope",
       "note": "Supports 'against age-expected behavior' — developmental anchor points define normal behavior per age so the child is rated against age-expected norms.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Third-party paper that corroborates CAPD's observational, over-a-shift, developmental-anchor characterization, but validates a different-scope tool (psCAM-ICU: interactive, 6mo–5yr, excludes deep developmental delay).",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "Despite the advances in pediatric delirium monitoring with the pCAM-ICU (objective, brief, in the moment assessment) and the CAPD (subjective scoring over a nursing shift), delirium remains under-recognized and poorly understood, especially among the very young. To address the challenges of delirium monitoring in pediatric patients, we designed this investigation 1) to create a principally objective and interactive, developmentally-targeted, delirium monitoring tool for critically ill infants and preschool-aged children, the Preschool Confusion Assessment Method for the ICU (psCAM-ICU); 2) to determine validity and reliability of objective delirium assessments using the psCAM-ICU; and 3) to simultaneously determine the prevalence of pediatric delirium in this population.",
       "highlight": "the CAPD (subjective scoring over a nursing shift)",
       "scope": "on-scope",
       "note": "Independently characterizes CAPD as subjective scoring over a nursing shift, corroborating 'rate the child over the shift.'",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "The approach for delirium diagnosis differs among available bedside tools which allow clinicians a choice in deciding on a tool that best fits their needs, based on resources, and ease of implementation in their particular ICUs. For instance, the CAPD applies scoring of observations over time to screen for delirium, providing an opportunity for the detection of subtle changes in patient behaviors which may not be picked up by an \"in the moment\" delirium screening test. However, the CAPD requires anchor points for each developmental stage as one is assessing for a range of behavior from normal to varied levels of abnormal. To be done appropriately this detailed assessment using the CAPD takes time. In contrast, the psCAM-ICU does not require developmental anchor points as the tool assesses for the lowest common denominator which would be considered abnormal for the broader cohort. The psCAM-ICU is unique as a fast and largely objective delirium assessment tool that requires the presence of inattention, the most fundamental feature of delirium. Additionally, the psCAM-ICU can be used to detect abrupt changes in brain function during shock, respiratory insufficiency, or even indolent disease processes, and subsequently be used for efficient reassessment to reflect acute delirium resolution following appropriate interventions.",
       "highlight": "the CAPD requires anchor points for each developmental stage",
       "scope": "on-scope",
       "note": "Corroborates 'against age-expected behavior' — CAPD uses anchor points for each developmental stage to judge normal-to-abnormal behavior.",
       "page": "ms. p.9",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "The Pediatric Confusion Assessment Method for the Intensive Care Unit (pCAM-ICU) was the first validated tool for objective delirium monitoring in critically ill children over 5 years of age, demonstrating a specificity of 99% and sensitivity of 83%. (6) The majority of pediatric ICU (PICU) patients are less than 5 years of age, in whom objective and interactive delirium monitoring is fraught with challenges as a result of variations in both language and cognitive development. Consequently, subjective and observational approaches to delirium screening in infants and young children have been validated. One such tool, the Cornell Assessment for Pediatric Delirium (CAPD) (8) was introduced as a subjective delirium screening tool in critically ill children with a reported specificity of 79% and sensitivity of 94%.",
       "highlight": "was introduced as a subjective delirium screening tool in critically ill children",
       "scope": "on-scope",
       "note": "Describes CAPD as a subjective (observational) delirium screening tool, corroborating the 'observational' framing.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "We enrolled pediatric patients aged 6 months to 5 years who were hospitalized at the Monroe Carell Jr. Children's Hospital at Vanderbilt (MCJCHV) pediatric intensive care unit (PICU), regardless of diagnosis, either ventilated or non-ventilated, into this prospective cohort validation study of the psCAM-ICU. We excluded patients with hearing/visual impairments, developmental delay (cognition < 6 months of age), those who were nonEnglish speaking, were transitioning out of the PICU, were moribund, or for whom we could not obtain consent. The institutional review board approved this study. In order to ensure accurate prevalence rates of delirium (i.e. to not miss presence of delirium due to an unavailable parent/guardian), we obtained an alteration of the consent process that allowed for collection of patient data and initial delirium assessments prior to consent when a surrogate was not immediately available. The parent/guardian then provided consent when able; if they refused consent, patients were withdrawn from the study, and all data were destroyed.",
       "highlight": "developmental delay (cognition < 6 months of age)",
       "scope": "different-intervention",
       "note": "Nearest-match but opposite scope: the psCAM-ICU study EXCLUDED deep developmental delay — a contrast screen that does not work where the claim says CAPD does, so must not be read as support.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "PATIENTS--Participants aged 6 months to 5 years and admitted to the pediatric ICU regardless of admission diagnosis were enrolled.",
       "highlight": "Participants aged 6 months to 5 years",
       "scope": "different-population",
       "note": "psCAM-ICU is validated only for ages 6 months–5 years, a narrower band than CAPD's every-age scope; shares keywords but is a different tool/population.",
       "page": "600",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "No archived text available (file null). Cited on the choose-the-screen card as the pCAM-ICU — the interactive, cooperation-requiring screen restricted to children >5 years — i.e., the different-scope alternative to CAPD, not support for CAPD's every-age/deep-delay applicability. Reference: Crit Care Med. 2011;39(1):150–157; PMID 20959783.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    }
   ],
   "synthesis": "Traube 2014 is the on-scope governing source: it developed and validated the CAPD as a rapid observational nursing screen scored over the shift against per-developmental-stage anchor points, across ages 0–21 and all developmental levels, retaining high sensitivity (96.2%) and applicability (AUC 0.86) in developmentally delayed children — though nurses became adept \"in all but the most developmentally delayed patients\" and specificity fell to 51.2%, a caveat on the claim's \"including deep developmental delay\" wording. Smith 2016 corroborates CAPD's characterization (\"subjective scoring over a nursing shift\" with anchor points for each developmental stage) but its own psCAM-ICU is a different-scope tool (interactive/objective, ages 6mo–5yr, and it explicitly excluded deep developmental delay), and Smith 2011's pCAM-ICU is the ≥5-years cooperation-required alternative — both are the contrast screens on the \"choose-the-screen\" card, not support for CAPD's every-age/deep-delay applicability.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r16",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "2",
   "section": "Choose-the-screen card",
   "statement": "psCAM-ICU — Developmental age 6 months – 5 years: Interactive point-in-time screen with age-adapted observational tasks (picture presentations).",
   "contentType": "Validated instrument wording",
   "sources": [
    "Traube 2014 (CAPD)",
    "Smith 2016 (psCAM-ICU)",
    "Smith 2011 (pCAM-ICU)"
   ],
   "anchor": "Smith 2016 (psCAM-ICU) — p. 4",
   "passage": "… RASS, GCS) and/or patient evaluation. The sedation scores (RASS) were reviewed for the past 24 hours to establish whether fluctuation in consciousness was present, while an abnormal GCS score or patient history and examination helped to determine whether an acute alteration from their baseline mental status was present (i.e. when the patient's mental status is not the same as when they are in good health). Feature 1 was \"present\" with either a current alteration from baseline mental status or fluctuation in mental status noted over time. The presence of inattention (Feature 2) was assessed using a staged process of both visual and verbal stimuli. The patient was shown 10 cards consisting of alternating mirrors and elementary, colorful pictures, during which the assessor engaged the patient by saying, \"Look at the little boy/girl (patients reflection in the mirror)\" or \"Is this a truck?\" according to whether there was a mirror being shown or a picture on display. The assessor moved the cards slowly in front of the child's face from the left to the right and back again to evaluate for the patient's attention. Specific components of inattention that were evaluated included the absence of: 1) initial eye contact, 2) tracking of the mirrors and pictures, 3) purposeful actions (i.e. reaching out for the cards, babbling or smiling while looking at their reflections), 4) sustained attention to the mirrors/ pictures during the assessment period, (i.e. …\nSmith 2016 enrolled children of developmental age 6 months to 5 years and characterizes the psCAM-ICU as an objective, interactive, developmentally targeted 'in the moment' assessment; the quoted passage documents the picture-card tasks.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/CCM.0b013e3181feb489"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary anchor: this is the psCAM-ICU validation paper and directly supports every element of the statement.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "was assessed using a staged process of both visual and verbal stimuli. The patient was shown 10 cards consisting of alternating mirrors and elementary, colorful pictures, during which the assessor engaged the patient by saying, \"Look at the little boy/girl (patients reflection in the mirror)\" or \"Is this a truck?\"",
       "highlight": "shown 10 cards consisting of alternating mirrors and elementary, colorful pictures",
       "scope": "on-scope",
       "note": "Describes the age-adapted observational picture-card task (Feature 2 inattention); children >=2 yr additionally identify the pictures, confirming age adaptation.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "PATIENTS--Participants aged 6 months to 5 years and admitted to the pediatric ICU regardless of admission diagnosis were enrolled.",
       "highlight": "Participants aged 6 months to 5 years",
       "scope": "on-scope",
       "note": "Confirms the developmental age band of 6 months to 5 years.",
       "page": "600",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "Despite the advances in pediatric delirium monitoring with the pCAM-ICU (objective, brief, in the moment assessment) and the CAPD (subjective scoring over a nursing shift), delirium remains under-recognized and poorly understood, especially among the very young. To address the challenges of delirium monitoring in pediatric patients, we designed this investigation 1) to create a principally objective and interactive, developmentally-targeted, delirium monitoring tool for critically ill infants and preschool-aged children, the Preschool Confusion Assessment Method for the ICU (psCAM-ICU); 2) to determine validity and reliability of objective delirium assessments using the psCAM-ICU; and 3) to simultaneously determine the prevalence of pediatric delirium in this population.",
       "highlight": "a principally objective and interactive, developmentally-targeted, delirium monitoring tool",
       "scope": "on-scope",
       "note": "Supports the 'interactive' and developmentally-targeted framing of the screen.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "The psCAM-ICU is a highly valid and reliable delirium assessment tool for critically ill infants and preschool-aged children. It is structured such that delirium cannot be diagnosed without the presence of inattention, and provides for immediate delirium assessment. Delirium prevalence was extremely high, especially among infants. Similar to that in adults, hypoactive delirium was the most prevalent motoric subtype in this critically ill pediatric cohort. The availability of delirium monitoring instruments such as the psCAM-ICU and pCAM-ICU affords an opportunity for delirium detection in pediatric cohorts with a wide range of ages, useful for both the bedside clinician and clinical research team. Implementation of pediatric delirium monitoring will promote large, prospective, multicenter investigations advancing our understanding of the mechanism, epidemiology, and the clinical management of pediatric delirium.",
       "highlight": "provides for immediate delirium assessment",
       "scope": "on-scope",
       "note": "Supports the point-in-time / 'in the moment' nature of the psCAM-ICU screen.",
       "page": "ms. p.10",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "background",
     "note": "A sibling pediatric delirium screen cited for contrast; it describes CAPD, not psCAM-ICU, and differs in method and population, so it is not direct support for this statement.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Conclusions--With an overall prevalence rate of 20.6% in our study population, delirium is a common problem in pediatric critical care. The Cornell Assessment of Pediatric Delirium is a valid, rapid, observational nursing screen that is urgently needed for the detection of delirium in PICU settings.",
       "highlight": "a valid, rapid, observational nursing screen",
       "scope": "different-intervention",
       "note": "CAPD is a passive observational nursing screen scored over a shift, not the interactive point-in-time picture-card assessment described in the claim.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "It is significant that 31% of our assessments were in children less than 2 years old, and 27% of our assessments were in children who are developmentally delayed. Our study indicates that the CAPD is a valid and reliable delirium screen in these vulnerable populations. The developmental anchor points for each item were a valuable point-of-use reference for assessing the youngest of patients. With the addition of these anchor points and minimal training, the critical care nursing staff became adept at using the CAPD in all but the most developmentally delayed patients. The nurses completed the assessment midshift, after several hours of observing the child's behavior. In every assessment, the nurses required less than 2 minutes to complete the CAPD screen.",
       "highlight": "after several hours of observing the child's behavior",
       "scope": "different-intervention",
       "note": "CAPD is scored after hours of observation over a shift, the opposite of psCAM-ICU's point-in-time assessment.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "One hundred eleven patients stratified over ages ranging from 0 to 21 years and across developmental levels.",
       "highlight": "ages ranging from 0 to 21 years and across developmental levels",
       "scope": "different-population",
       "note": "CAPD was validated across ages 0-21, not the 6 months-5 years developmental band psCAM-ICU targets.",
       "page": "663",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "children more than 5 years old, limited in patients with developmental delay, and requires extensive nurse training. The PAED (35) designed, for immediate postoperative use by anesthesiologists, selects for the hyperactive subtype of delirium. An ideal screening tool would detect all types of delirium (hyperactive, hypoactive, and mixed), in patients of all ages and developmental levels.",
       "highlight": "children more than 5 years old",
       "scope": "background",
       "note": "Notes the pCAM-ICU is restricted to children over 5 years old, the gap that psCAM-ICU (6 mo-5 yr) was designed to fill.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Unarchived (no text file). Cited as the pCAM-ICU validation (Crit Care Med. 2011;39(1):150-157) - the objective in-the-moment screen for children over 5 years that psCAM-ICU extends down to 6 months; a sibling tool, not consulted for text and not direct support for the 6 mo-5 yr psCAM-ICU statement.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    }
   ],
   "synthesis": "Smith 2016, the primary anchor and the psCAM-ICU validation paper, directly and fully supports the statement: enrollment aged 6 months to 5 years, a principally objective and interactive developmentally-targeted screen providing immediate (point-in-time) assessment, using age-adapted observational picture cards. Traube 2014 (CAPD) and Smith 2011 (pCAM-ICU) are sibling pediatric screens cited for contrast rather than support - CAPD is a passive observational nursing screen scored over a shift across ages 0-21, and pCAM-ICU is restricted to children over 5 - so Smith 2016 governs this psCAM-ICU statement.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r17",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "2",
   "section": "Choose-the-screen card",
   "statement": "pCAM-ICU — Chronological AND developmental age ≥ 5 years: Interactive point-in-time screen with verbal attention and command tasks.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Traube 2014 (CAPD)",
    "Smith 2016 (psCAM-ICU)",
    "Smith 2011 (pCAM-ICU)"
   ],
   "anchor": "Smith 2011 (pCAM-ICU) — p. 1",
   "passage": "FEATURE 1: Acute Change or Fluctuating Course of Mental Status 1. Is there an acute change from mental status baseline? (Y or N) 2. Has the patient's mental status fluctuated during the past 24 hours? (Y or N)  If \"YES\" to EITHER question then Feature 1 is PRESENT  move on to FEATURE 2 FEATURE 3: Altered Level of Consciousness (LOC)  Does the patient currently have an altered LOC? (i.e. not alert and calm)  If \"YES\" then STOP  DELIRIUM PRESENT  If \"NO\" then Feature 3 is NOT present  move on to FEATURE 4 FEATURE 2: Inattention Say: \"Squeeze my hand when I say 'A'. Let's practice: A, B. Squeeze only on A.\" Read this letter sequence: A B A D B A D A A Y  Did the patient make 3 or MORE ERRORS? (Error = No squeeze with 'A' or Squeeze with other letters)  If \"YES\" then Feature 2 is PRESENT  move on to FEATURE 3 DELIRIUM ABSENT FEATURE 4: Disorganized Thinking Say: \"I am going to ask you some questions.\" (Tell patient to answer yes/no by voice, head nod, etc.) Questions: 1. Is sugar sweet? Alternate questions: - Is a rock hard? (1 point each) 2. Is ice cream hot?\nAlso Smith 2016 (psCAM-ICU): \"The Pediatric Confusion Assessment Method for the Intensive Care Unit (pCAM-ICU) was the first validated tool for objective delirium monitoring in critically ill children over 5 years of age\"\nThe pCAM-ICU pocket card pairs the quoted verbal attention task with a two-step command task ('Hold up this many fingers...'); the >= 5 years criterion is supported by Smith 2016, quoted second.",
   "evidence": "Instrument document, p. 1",
   "status": "instrument",
   "pageNum": "1",
   "citations": [
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/CCM.0b013e3181feb489"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "partial",
     "note": "A CAPD validation paper, but its introduction directly describes the pCAM-ICU, corroborating the age cutoff and its cooperation-dependent (interactive) cognitive nature; it does not address point-in-time verbal attention/command tasks and phrases the cutoff as 'more than 5 years old'.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "children more than 5 years old, limited in patients with developmental delay, and requires extensive nurse training. The PAED (35) designed, for immediate postoperative use by anesthesiologists, selects for the hyperactive subtype of delirium. An ideal screening tool would detect all types of delirium (hyperactive, hypoactive, and mixed), in patients of all ages and developmental levels.",
       "highlight": "children more than 5 years old",
       "scope": "on-scope",
       "note": "Directly states the pCAM-ICU is restricted to children more than 5 years old, corroborating the claim's age cutoff (phrased '>5' vs the claim's '≥5').",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "The limitations of existing tools in the PICU population, including the Delirium Rating Scale (DRS), Pediatric Confusion Assessment Method for the ICU (pCAM-ICU), and the Pediatric Anesthesia Emergence Delirium (PAED) screen, have been discussed (6, 28-32). In brief, the DRS (33) was designed for psychiatrists' use and is labor intensive. The pCAMICU (34) is an elegant cognitive tool but requires patient cooperation, is restricted to Author Manuscript Crit Care Med.",
       "highlight": "an elegant cognitive tool but requires patient cooperation",
       "scope": "on-scope",
       "note": "Characterizes the pCAM-ICU as a cognitive tool requiring patient cooperation — the interactive quality named in the claim (same sentence, split across a page break).",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "children more than 5 years old, limited in patients with developmental delay, and requires extensive nurse training. The PAED (35) designed, for immediate postoperative use by anesthesiologists, selects for the hyperactive subtype of delirium. An ideal screening tool would detect all types of delirium (hyperactive, hypoactive, and mixed), in patients of all ages and developmental levels.",
       "highlight": "in patients of all ages and developmental levels",
       "scope": "different-intervention",
       "note": "Describes the goal of the CAPD (the paper's own tool) to cover all ages and developmental levels — the contrasting instrument, nearest match on topic but a different intervention and population than pCAM-ICU.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "A psCAM-ICU validation paper whose background directly describes the pCAM-ICU as the objective, brief, in-the-moment monitoring tool for children over 5 years, supporting the age cutoff, interactive/objective nature, and point-in-time facets; the verbal attention/command-task detail is not spelled out and the cutoff is phrased 'over 5 years'.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "The Pediatric Confusion Assessment Method for the Intensive Care Unit (pCAM-ICU) was the first validated tool for objective delirium monitoring in critically ill children over 5 years of age, demonstrating a specificity of 99% and sensitivity of 83%. (6) The majority of pediatric ICU (PICU) patients are less than 5 years of age, in whom objective and interactive delirium monitoring is fraught with challenges as a result of variations in both language and cognitive development. Consequently, subjective and observational approaches to delirium screening in infants and young children have been validated. One such tool, the Cornell Assessment for Pediatric Delirium (CAPD) (8) was introduced as a subjective delirium screening tool in critically ill children with a reported specificity of 79% and sensitivity of 94%.",
       "highlight": "objective delirium monitoring in critically ill children over 5 years of age",
       "scope": "on-scope",
       "note": "Directly identifies the pCAM-ICU as the objective delirium-monitoring tool for children over 5 years of age — the age cutoff and objective/interactive nature in the claim.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "Despite the advances in pediatric delirium monitoring with the pCAM-ICU (objective, brief, in the moment assessment) and the CAPD (subjective scoring over a nursing shift), delirium remains under-recognized and poorly understood, especially among the very young. To address the challenges of delirium monitoring in pediatric patients, we designed this investigation 1) to create a principally objective and interactive, developmentally-targeted, delirium monitoring tool for critically ill infants and preschool-aged children, the Preschool Confusion Assessment Method for the ICU (psCAM-ICU); 2) to determine validity and reliability of objective delirium assessments using the psCAM-ICU; and 3) to simultaneously determine the prevalence of pediatric delirium in this population.",
       "highlight": "pCAM-ICU (objective, brief, in the moment assessment)",
       "scope": "on-scope",
       "note": "Characterizes the pCAM-ICU as an objective, brief, in-the-moment assessment — supports the 'interactive point-in-time screen' framing.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "The psCAM-ICU is a highly valid and reliable delirium assessment tool for critically ill infants and preschool-aged children. It is structured such that delirium cannot be diagnosed without the presence of inattention, and provides for immediate delirium assessment. Delirium prevalence was extremely high, especially among infants. Similar to that in adults, hypoactive delirium was the most prevalent motoric subtype in this critically ill pediatric cohort. The availability of delirium monitoring instruments such as the psCAM-ICU and pCAM-ICU affords an opportunity for delirium detection in pediatric cohorts with a wide range of ages, useful for both the bedside clinician and clinical research team. Implementation of pediatric delirium monitoring will promote large, prospective, multicenter investigations advancing our understanding of the mechanism, epidemiology, and the clinical management of pediatric delirium.",
       "highlight": "critically ill infants and preschool-aged children",
       "scope": "different-population",
       "note": "The paper's own tool (psCAM-ICU) targets infants and preschool-aged children under 5 — the complement to the claim's pCAM-ICU (≥5), a nearest match but a different population and intervention.",
       "page": "ms. p.10",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Primary source for the pCAM-ICU (≥5 years) claim and the source of the verbal attention/command-task detail; not archived in this corpus, so its text could not be verified here. Cited as Smith HAB, et al., Crit Care Med. 2011;39(1):150-157.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    }
   ],
   "synthesis": "The two archived sources agree that the pCAM-ICU is the objective, brief, in-the-moment monitoring tool for critically ill children over 5 years of age (Smith 2016) that works as a cognitive test requiring patient cooperation (Traube 2014), corroborating the claim's age cutoff and interactive point-in-time framing; both phrase the boundary as \">5 / over 5 years\" while the claim and its unarchived primary source (Smith 2011) state \"≥5 years,\" and neither archived paper spells out the verbal attention/command tasks, so Smith 2011 governs the exact cutoff and task detail. The nearest matches on topic are deliberately different-scope: Traube's CAPD spans all ages and developmental levels and Smith 2016's psCAM-ICU targets infants and preschoolers under 5 — complementary tools, not the pCAM-ICU.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r18",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "3",
   "section": "CAPD card",
   "statement": "Cornell Assessment of Pediatric Delirium — observational, positive at score ≥ 9; Never,Rarely,Sometimes,Often,Always",
   "contentType": "Validated instrument wording",
   "sources": [
    "Traube 2014 (CAPD)",
    "Gupta 2021"
   ],
   "anchor": "Traube 2014 (CAPD) — p. 3",
   "passage": "… As the original PAED was designed to detect transient emergence delirium following anesthesia, it selects for patients with a hyperactive, agitated delirium subtype and would be incomplete for assessing the PICU population. Therefore, we added two elements (questions 7 and 8, Fig. 1) to improve the detection of hypoactive and mixed-type delirium. We changed the scale items from statements to questions and renamed the tool to reflect the comprehensive nature of the assessment. An initial pilot study showed feasibility for use as a rapid nursing screen (28). Based on the pilot study, we made additional changes. To better capture a fluctuating course of delirium over a nurse's shift, response options were changed from the original (not at all/ just a little/quite a bit/very much/extremely) to the format \"never/rarely/sometimes/often/ always\". To better reflect the DSM-IV criteria for delirium, and detect alteration in cognitive functioning, we added a third novel item (question 4, Fig. 1), to assess the ability to communicate needs and wants. Content validity of the revised CAPD (Fig. 1) was evaluated by experts in the fields of pediatric critical care, development, delirium, and psychometrics. Anchor Points-Orientation, arousal, and appropriate cognition (which are all affected in delirium) are difficult to assess in young children and even harder to measure in infants. …\nAlso Gupta 2021: \"Overall, CAPD score  9 had sensitivity of 81.8% and speciﬁcity of 44.8%\"\nTraube 2014 supplies the response labels and sets the positive cut point 'at a total CAPD score of 9 or greater' (p. 5); Gupta 2021 independently confirms the >= 9 threshold.",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)"
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary validation source; establishes all three elements of the statement (rapid observational screen, positive at total score ≥9, and never/rarely/sometimes/often/always response options) in the general PICU population.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Cut point analysis showed the best sensitivity and specificity for the screening instrument (prioritizing high sensitivity) at a total CAPD score of 9 or greater. Sensitivity was 94.1% (95% CI, 83.8-98.8%) and specificity 79.2% (95% CI, 73.5-84.9%). At a cut point of greater than or equal to 9, there were three false-negative CAPD screens (Table 3) and 41 false-positive screens. Concordance between CAPD and psychiatric diagnosis was 82.3% (r = 0.62). Nurses' CAPD interrater reliability was also highest at a cut point of 9, with = 0.94. ranged from 0.68 to 0.78 for each of the eight CAPD items.",
       "highlight": "at a total CAPD score of 9 or greater",
       "scope": "on-scope",
       "note": "ROC cut-point analysis sets the CAPD positive threshold at a total score of 9 or greater, directly supporting 'positive at score ≥ 9'.",
       "page": "ms. p.5",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "Based on the pilot study, we made additional changes. To better capture a fluctuating course of delirium over a nurse's shift, response options were changed from the original (not at all/ just a little/quite a bit/very much/extremely) to the format \"never/rarely/sometimes/often/ always\". To better reflect the DSM-IV criteria for delirium, and detect alteration in cognitive functioning, we added a third novel item (question 4, Fig. 1), to assess the ability to communicate needs and wants. Content validity of the revised CAPD (Fig. 1) was evaluated by experts in the fields of pediatric critical care, development, delirium, and psychometrics.",
       "highlight": "to the format \"never/rarely/sometimes/often/ always\"",
       "scope": "on-scope",
       "note": "Documents the five per-item response options (never/rarely/sometimes/often/always), matching the statement's response scale.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "Conclusions--With an overall prevalence rate of 20.6% in our study population, delirium is a common problem in pediatric critical care. The Cornell Assessment of Pediatric Delirium is a valid, rapid, observational nursing screen that is urgently needed for the detection of delirium in PICU settings.",
       "highlight": "a valid, rapid, observational nursing screen",
       "scope": "on-scope",
       "note": "Characterizes CAPD as a rapid observational nursing screen, supporting the 'observational' descriptor.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "partial",
     "note": "Corroborates the observational nature and the conventional ≥9 cutoff, but its cited specificity data (44.8% overall, 16.5% with developmental delay) come from a different population — mechanically ventilated, developmentally delayed children.",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "very few PICUs have successfully adopted a delirium screening tool. An international survey by Kudchadkar et al among intensivists (71% respondents) reported that routine delirium screening is not utilized in their units, while only 2% reported using a delirium screening tool.15 Among various scales used for screening of delirium in PICU, CAPD scale is the most widely used. Our institution implemented CAPD because of its perceived ease of use compared with pCAMICU. Traube et al reported good overall sensitivity and specificity of this scale based on a cut-off score of 9 (94.1 and 79.2%, respectively) in patients admitted to the PICU.1 Although hospitalization in the PICU increases an individual's risk for delirium, we implemented this scale in a subset of the population at a higher risk of developing delirium.16 To our knowledge, this is the first study assessing the performance of CAPD in this high-risk population.",
       "highlight": "based on a cut-off score of 9 (94.1 and 79.2%, respectively) in patients admitted to the PICU",
       "scope": "on-scope",
       "note": "Restates the established CAPD positive cut-off of 9 from the general-PICU validation, corroborating 'positive at score ≥ 9'.",
       "page": "27",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      },
      {
       "context": "The primary problem we encountered with the originally published developmental anchor points was the wide variability in the range for acquiring new developmental skills. This wide range produced extreme variation in bedside staff documentation of appropriate developmental abilities. The age classification used in the developmental anchor points were additionally not aligned with the classic pediatric milestone ranges.18 On the basis of nursing feedback, we also realized that some of the scale options are very closely related to each other (rarely/sometimes/often). In our PICU, most nursing assignments are for two patients, even if one or both are ventilated; the difference between rarely and often could at times reflect the relative proportion of time spent with one patient or the other. We did not calculate interrater reliability in our study. This has been demonstrated in prior studies; however, having too many closely linked options likely decreases the scale's reliability, as seen in some studies.10 Being an observation scale, scoring with these options is very subjective and caregiver-dependent. This has led to lower nursing compliance with the scale at our institution.",
       "highlight": "Being an observation scale, scoring with these options is very subjective and caregiver-dependent",
       "scope": "on-scope",
       "note": "Confirms CAPD is an observation scale and references its response options (rarely/sometimes/often), corroborating the observational nature and the Likert-style options.",
       "page": "29",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      },
      {
       "context": "A total of 837 paired assessments were performed. Prevalence of delirium was 19%. Overall, CAPD score ! 9 had sensitivity of 81.8% and specificity of 44.8%.",
       "highlight": "Overall, CAPD score ! 9 had sensitivity of 81.8% and specificity of 44.8%",
       "scope": "different-population",
       "note": "Reports CAPD >=9 performance specifically in this single-center cohort of mechanically ventilated children (overall specificity 44.8%) rather than the general-PICU instrument description the statement gives — a population-specific caveat.",
       "page": "24",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    }
   ],
   "synthesis": "Traube 2014 is the governing on-scope source: its general-PICU validation establishes CAPD as a rapid observational nursing screen that is positive at a total score of 9 or greater, scored with never/rarely/sometimes/often/always response options — supporting every element of the statement. Gupta 2021 corroborates the observational nature and the conventional ≥9 cutoff but reports its cited specificity in a different population (mechanically ventilated, developmentally delayed children, where ≥9 gives only 44.8% overall and 16.5% specificity), so it is a population-specific performance caveat rather than direct support for the instrument description.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r19",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "4",
   "section": "psCAM-ICU card",
   "statement": "Preschool Confusion Assessment Method for the ICU — developmental age 6 months–5 years; interactive point-in-time screen",
   "contentType": "Validated instrument wording",
   "sources": [
    "Smith 2016 (psCAM-ICU)"
   ],
   "anchor": "Smith 2016 (psCAM-ICU) — p. 1",
   "passage": "… The objectives of this study were to determine the validity and reliability of a fundamentally objective and developmentally appropriate delirium assessment tool for critically ill infants and preschool-aged children, and to determine delirium prevalence. DESIGN and SETTING-Prospective, observational cohort validation study of the PreSchool Confusion Assessment Method for the ICU (psCAM-ICU) in a tertiary medical center pediatric ICU. PATIENTS- Participants aged 6 months to 5 years and admitted to the pediatric ICU regardless of admission diagnosis were enrolled. Address correspondence to: Heidi A. Beverley Smith, M.D., M.S.C.I., Vanderbilt University Medical Center, Department of Anesthesiology, 2200 Children's Way, Suite 3115, Nashville, TN 37232, Phone: 615-936-6808, Fax: 615-936-4294, heidi.smith@vanderbilt.edu. Copyright form disclosures: The remaining authors have disclosed that they do not have any potential conflicts of interest. HHS Public Access Author manuscript Crit Care Med. Author manuscript; available in PMC 2017 March 01. Published in final edited form as: Crit Care Med. 2016 March ; 44(3): 592-600. doi:10.1097/CCM.0000000000001428. Author Manuscript Author Manuscript Author Manuscript Author Manuscript\nThe interactive, point-in-time character of the psCAM-ICU is described separately in Smith 2016; the quoted passage establishes the age band.",
   "evidence": "Full text, p. 1",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0000000000001428"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "stance": "agrees",
     "note": "The instrument's name, its 6 months to 5 years population and its point-in-time observational design are the validation study's own description.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "RATIONALE and OBJECTIVE-Delirium assessments in critically ill infants and young children pose unique challenges due to evolution of cognitive and language skills. The objectives of this study were to determine the validity and reliability of a fundamentally objective and developmentally appropriate delirium assessment tool for critically ill infants and preschool-aged children, and to determine delirium prevalence. DESIGN and SETTING-Prospective, observational cohort validation study of the PreSchool Confusion Assessment Method for the ICU (psCAM-ICU) in a tertiary medical center pediatric ICU. PATIENTS-Participants aged 6 months to 5 years and admitted to the pediatric ICU",
       "highlight": "Prospective, observational cohort validation study of the PreSchool Confusion Assessment Method for the ICU (psCAM-ICU) in a tertiary medical center pediatric ICU.",
       "page": "1"
      },
      {
       "scope": "on-scope",
       "context": "RATIONALE and OBJECTIVE-Delirium assessments in critically ill infants and young children pose unique challenges due to evolution of cognitive and language skills. The objectives of this study were to determine the validity and reliability of a fundamentally objective and developmentally appropriate delirium assessment tool for critically ill infants and preschool-aged children, and to determine delirium prevalence. DESIGN and SETTING-Prospective, observational cohort validation study of the PreSchool Confusion Assessment Method for the ICU (psCAM-ICU) in a tertiary medical center pediatric ICU. PATIENTS-Participants aged 6 months to 5 years and admitted to the pediatric ICU",
       "highlight": "Participants aged 6 months to 5 years and admitted to the pediatric ICU",
       "page": "1"
      }
     ]
    }
   ]
  },
  {
   "id": "peds-cards-r20",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "5",
   "section": "pCAM-ICU card",
   "statement": "Pediatric Confusion Assessment Method for the ICU — developmental age ≥ 5 years. Say: “Squeeze my hand when I say A. Let’s practice: A, B. Squeeze only on A.”",
   "contentType": "Validated instrument wording",
   "sources": [
    "Smith 2011 (pCAM-ICU)"
   ],
   "anchor": "Smith 2011 (pCAM-ICU) — p. 1",
   "passage": "FEATURE 1: Acute Change or Fluctuating Course of Mental Status 1. Is there an acute change from mental status baseline? (Y or N) 2. Has the patient's mental status fluctuated during the past 24 hours? (Y or N)  If \"YES\" to EITHER question then Feature 1 is PRESENT  move on to FEATURE 2 FEATURE 3: Altered Level of Consciousness (LOC)  Does the patient currently have an altered LOC? (i.e. not alert and calm)  If \"YES\" then STOP  DELIRIUM PRESENT  If \"NO\" then Feature 3 is NOT present  move on to FEATURE 4 FEATURE 2: Inattention Say: \"Squeeze my hand when I say 'A'. Let's practice: A, B. Squeeze only on A.\" Read this letter sequence: A B A D B A D A A Y  Did the patient make 3 or MORE ERRORS? (Error = No squeeze with 'A' or Squeeze with other letters)  If \"YES\" then Feature 2 is PRESENT  move on to FEATURE 3 DELIRIUM ABSENT FEATURE 4: Disorganized Thinking Say: \"I am going to ask you some questions.\" (Tell patient to answer yes/no by voice, head nod, etc.) Questions: 1. Is sugar sweet? Alternate questions: - Is a rock hard? (1 point each) 2. Is ice cream hot?\nAlso Smith 2016 (psCAM-ICU): \"The Pediatric Confusion Assessment Method for the Intensive Care Unit (pCAM-ICU) was the first validated tool for objective delirium monitoring in critically ill children over 5 years of age\"\nThe >= 5 years criterion is supported by Smith 2016, quoted second; the attention script matches the pCAM-ICU pocket card nearly verbatim.",
   "evidence": "Instrument document, p. 1",
   "status": "instrument",
   "pageNum": "1",
   "citations": [
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157."
   ],
   "links": [
    "https://doi.org/10.1097/CCM.0b013e3181feb489"
   ],
   "decision": "",
   "notes": ""
  },
  {
   "id": "peds-cards-r21",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "6",
   "section": "Act-on-a-positive — find/fix",
   "statement": "Withdrawal can mimic delirium — if the child is on or weaning prolonged opioids or benzodiazepines, assess for iatrogenic withdrawal (e.g. WAT-1).",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 5, ¶1",
   "passage": "… Conditional Low 7) We do not suggest routine use of haloperidol or atypical antipsychotics for the prevention of or decrease in duration of delirium in critically ill pediatric patients. Conditional Low 8) We suggest that in critically ill pediatric patients with refractory delirium, haloperidol or atypical antipsychotics be considered for the management of severe delirium manifestations, with consideration of possible adverse drug effects. Conditional Moderate 9) We recommend a baseline electrocardiogram followed by routine electrolyte and QTc interval monitoring for patients receiving haloperidol or atypical antipsychotics. Strong Moderate IWS 1) We recommend use of either the Withdrawal Assessment Tool-1or Sophia Observation Scale for the assessment of IWS due to opioid or benzodiazepine withdrawal in critically ill pediatric patients. Strong Moderate 2) We suggest routine IWS screening after a shorter duration (3-5 d) when higher opioid or benzodiazepine doses are used. Conditional Moderate 3) Until a validated screening tool is developed, monitoring for IWS from alpha2-agonists should be performed using a combination of associated symptoms (unexplained hypertension or tachycardia) with adjunct use of a validated benzodiazepine or opioid screening tool. Good practice\nPANDEM 2022 directly supports assessing for iatrogenic withdrawal with WAT-1 in the setting of opioid or benzodiazepine exposure; the 'withdrawal can mimic delirium' framing is the statement's rationale rather than language from the source.",
   "evidence": "Full text, p. 5",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Cited for the RASS sedation-agitation scale, which gates arousal before delirium screening; it does not address iatrogenic withdrawal or the WAT-1 (cited by section).",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Ensuring the comfort of critically ill infants and children is integral to the practice of pediatric critical care. Humane pediatric intensive care often includes the administration of sedatives, once pain, physiologic imbalance and environmental stressors have been addressed.[1] Over 90% of infants and children supported on mechanical ventilation receive some form of sedative therapy. [2] Sedation in this patient population is required for anxiolysis, amnesia, facilitation of care, patient safety in avoidance of adverse events and for decreasing oxygen consumption. For most young patients supported on mechanical ventilation, the goal of sedation is to attain a calm but responsive state [2,3] that protects the young patient from self-harm. Inadequate sedation is associated with potentially dangerous complications such as unplanned endotracheal extubation. [4] High-dose, long-term, and continuous intravenous sedation has been associated with prolonged weaning from mechanical ventilation and/or withdrawal syndrome. [5-7] Therefore, insufficient or excessive sedation is likely to add to the personal and financial burden of intensive care.",
       "highlight": "prolonged weaning from mechanical ventilation and/or withdrawal syndrome",
       "scope": "different-intervention",
       "note": "SBS is a sedation-depth scale; it notes prolonged sedation can cause withdrawal syndrome (supporting the claim's 'prolonged opioids/benzodiazepines' premise) but does not address withdrawal mimicking delirium or the WAT-1.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Validation of the Cornell Assessment of Pediatric Delirium screening tool; silent on iatrogenic withdrawal and the WAT-1. It is a general card-set delirium citation, not support for the withdrawal statement.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": []
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Reports CAPD specificity in mechanically ventilated children; contains no content on iatrogenic withdrawal or the WAT-1 (its only 'withdrawal' references are study/consent withdrawal).",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": []
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Validation of the pediatric CAM-ICU delirium screen; a general card-set delirium citation that does not address iatrogenic withdrawal or the WAT-1 (cited by section/DOI).",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Validation of the preschool CAM-ICU delirium screen; silent on iatrogenic withdrawal and the WAT-1 (its only 'withdrawal' reference is consent withdrawal in the CONSORT flow).",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": []
    },
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "Common to IWS from all agents, the relative nonspecificity of symptoms may also prevent identification of pain, nonwithdrawal based agitation, and delirium, which may further delay appropriately directed interventions (6, 115).",
       "highlight": "the relative nonspecificity of symptoms may also prevent identification of pain, nonwithdrawal based agitation, and delirium",
       "scope": "on-scope",
       "note": "Directly supports 'withdrawal can mimic delirium': the nonspecific symptoms of iatrogenic withdrawal can prevent identification of delirium in critically ill children.",
       "page": "e91",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "1) \"We recommend\" use of either the Withdrawal Assessment Tool-1 (WAT-1) or Sophia Observation Scale (SOS) for the assessment of IWS due to opioid or benzodiazepine withdrawal in critically ill pediatric patients (strong, moderate-level evidence).",
       "highlight": "the assessment of IWS due to opioid or benzodiazepine withdrawal in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "Directly supports the 'assess for iatrogenic withdrawal (e.g. WAT-1)' recommendation for children on opioids or benzodiazepines (strong, moderate-level evidence).",
       "page": "e90",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "\"We recommend\" use of either the Withdrawal Assessment Tool-1 (WAT-1) or Sophia Observation Scale (SOS) for the assessment of IWS due to opioid or benzodiazepine withdrawal in critically ill pediatric patients (strong, moderate-level evidence).",
       "highlight": "for the assessment of IWS due to opioid or benzodiazepine withdrawal in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "Guideline recommends WAT-1 or the Sophia Observation Scale to assess for opioid- or benzodiazepine-related iatrogenic withdrawal, supporting the 'on/weaning opioids or benzodiazepines, assess for withdrawal (e.g. WAT-1)' trigger (the delirium-mimicry rationale sits in a page-split sentence not usable verbatim).",
       "page": "e90",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "Conclusions--Benzodiazepines are an independent and modifiable risk factor for development of delirium in critically ill children, even after carefully controlling for time-dependent covariates, with a dose-response effect. This temporal relationship suggests causality between benzodiazepine exposure and pediatric delirium and supports limiting the use of benzodiazepines in critically ill children.",
       "highlight": "Benzodiazepines are an independent and modifiable risk factor for development of delirium in critically ill children",
       "scope": "different-intervention",
       "note": "Nearest match on benzodiazepines + pediatric delirium, but a different mechanism: ongoing benzodiazepine EXPOSURE causally increases delirium, whereas the claim concerns WITHDRAWAL from benzodiazepines mimicking delirium; not direct support.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    }
   ],
   "synthesis": "The SCCM PANDEM 2022 guideline is the on-scope source and directly supports the claim on both counts: it states that the nonspecific symptoms of iatrogenic withdrawal syndrome (whose CNS features explicitly include delirium) can prevent identification of delirium, and it recommends the Withdrawal Assessment Tool-1 (or Sophia Observation Scale) for assessing opioid- or benzodiazepine-related withdrawal in critically ill children who are on or weaning prolonged exposure. The remaining cited sources are silent on withdrawal-as-mimic — the delirium screens (CAPD, psCAM-ICU, pCAM-ICU) and sedation scales (SBS, RASS) are the card's general assessment citations, and Mody 2018 addresses benzodiazepine exposure as a delirium risk factor rather than withdrawal from benzodiazepines mimicking delirium — so PANDEM 2022 governs.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r22",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "6",
   "section": "Act-on-a-positive — find/fix",
   "statement": "Tell the team on rounds: target arousal, actual arousal, screen result, and today’s plan.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 16",
   "passage": "… Delirium Prevention and Management in the PICU. Nonpharmacologic management of delirium Question: Among critically ill pediatric patients, what \"nonpharmacologic\" strategies reduce the incidence and/or decrease duration or severity of delirium? (SDC Section E3, http://links.lww.com/PCC/ B920). Answer: 1) Given low patient risk, and possible patient benefit to reduce the occurrence rate and/or decrease duration or severity of delirium, \"we suggest\" the following \"nonpharmacologic strategies\": optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct patient care (conditional, low-level evidence). 2) \"We suggest\" performing EM, when feasible, to reduce the development of delirium (conditional, low-level evidence) although data are insufficient to make a recommendation regarding the impact of this intervention on the duration or severity of delirium. Rationale: Environmental impact on the prevention of delirium has yet to be studied in a robust manner in children. …\nPANDEM 2022 endorses interdisciplinary rounds and daily documented sedation targets but does not specify the itemized handoff content; the four-element script is an operational synthesis rather than a stated recommendation.",
   "evidence": "Full text, p. 4 — partial support",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "RASS is the validated adult-ICU agitation-sedation scale cited as the instrument for the 'actual arousal' value and underpins the arousal-first step in the pediatric ps/pCAM-ICU and CAPD; adult population, cited by section/DOI.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Valid and reliable tools that standardize the description of a pediatric patient's behavioral state while supported on mechanical ventilation would enhance systematic assessment and documentation of a patient's response to sedation, allow patient-specific alterations in the therapeutic regimen, and help avoid insufficient or excessive sedative use. [13,14] Such an assessment tool would enhance interdisciplinary agreement on the desired level of sedation, provide a foundation for the development of guidelines that would decrease unnecessary variation in the care [15-17] and permit objective study of the pharmacodynamics of sedative agents in the pediatric population. [18] From a research perspective, Kollef and colleagues [5] suggest that sedation practices should be standardized in any investigation employing the duration of mechanical ventilation as an outcome variable.",
       "highlight": "enhance interdisciplinary agreement on the desired level of sedation",
       "scope": "on-scope",
       "note": "The SBS's stated purpose — enabling interdisciplinary agreement on the desired level of sedation — is exactly the 'target arousal' the card asks the team to state on rounds.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      },
      {
       "context": "Ensuring the comfort of critically ill infants and children is integral to the practice of pediatric critical care. Humane pediatric intensive care often includes the administration of sedatives, once pain, physiologic imbalance and environmental stressors have been addressed.[1] Over 90% of infants and children supported on mechanical ventilation receive some form of sedative therapy. [2] Sedation in this patient population is required for anxiolysis, amnesia, facilitation of care, patient safety in avoidance of adverse events and for decreasing oxygen consumption. For most young patients supported on mechanical ventilation, the goal of sedation is to attain a calm but responsive state [2,3] that protects the young patient from self-harm. Inadequate sedation is associated with potentially dangerous complications such as unplanned endotracheal extubation. [4] High-dose, long-term, and continuous intravenous sedation has been associated with prolonged weaning from mechanical ventilation and/or withdrawal syndrome. [5-7] Therefore, insufficient or excessive sedation is likely to add to the personal and financial burden of intensive care.",
       "highlight": "the goal of sedation is to attain a calm but responsive state",
       "scope": "on-scope",
       "note": "Defines the sedation target (calm but responsive) that the 'target arousal' item communicates for ventilated young children.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Reliability Testing--After informed consent was obtained, a set of paired, double-blinded assessments was performed. The bedside nurse completed the CAPD as a paper checklist. Subsequently, the psychiatrist conducted a diagnostic interview and examination. If a child was diagnosed with delirium by the psychiatrist, this was reported to the medical team caring for the child so that appropriate interventions could be taken. If the subject was still present in the PICU on the next study day, the paired assessments were repeated, up to a predetermined maximum of 5 per subject. When the assessments were completed, CAPD screening results were compared with the psychiatric diagnosis and the interrater agreement was computed.",
       "highlight": "reported to the medical team caring for the child so that appropriate interventions could be taken",
       "scope": "on-scope",
       "note": "Mirrors the card's action: a positive delirium result is communicated to the caring team so a plan/intervention follows (here in the study protocol).",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "Conclusions--With an overall prevalence rate of 20.6% in our study population, delirium is a common problem in pediatric critical care. The Cornell Assessment of Pediatric Delirium is a valid, rapid, observational nursing screen that is urgently needed for the detection of delirium in PICU settings.",
       "highlight": "a valid, rapid, observational nursing screen that is urgently needed for the detection of delirium in PICU",
       "scope": "on-scope",
       "note": "Validates the CAPD as the bedside 'screen result' reported on rounds in the PICU population.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "All patients in the PICU on a given study day were eligible if there was a parent or guardian available to provide informed consent. The only exclusion criterion was a sedation score of less than -3 (deeply sedated or unarousable), using the Richmond Agitation and Sedation Scale (RASS) (38, 39). Demographic and clinical data were collected on each subject.",
       "highlight": "a sedation score of less than -3 (deeply sedated or unarousable), using the Richmond Agitation and Sedation Scale",
       "scope": "on-scope",
       "note": "Shows arousal (RASS) is checked before the delirium screen — linking the 'actual arousal' and 'screen result' items.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "Among typically developed patients, the sensitivity and specificity were 76.7 and 65.4%, respectively, whereas specificity was only 16.5% for developmentally delayed patients.",
       "highlight": "specificity was only 16.5% for developmentally delayed patients",
       "scope": "different-population",
       "note": "Nearest match on the 'screen result' item but scoped to a single-center ventilated/sedated cohort where CAPD specificity is low (16.5% with developmental delay) — a caveat, not direct support for the rounds communication practice.",
       "page": "24",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      },
      {
       "context": "Although primarily used as a screening tool, there is a possibility that the scores from these tests might bias a physician's judgment, especially if there is an unawareness among the physician regarding the difference in the accuracy of this test in children with developmental delay.",
       "highlight": "the scores from these tests might bias a physician's judgment",
       "scope": "narrower",
       "note": "Warns that the reported CAPD score can bias physician interpretation in developmentally delayed children — relevant to how the screen result is communicated, but a narrower accuracy caveat.",
       "page": "28",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU is the validated delirium screen for critically ill children >5 yr — one of the 'screen result' tools PANDEM endorses; cited by section (unarchived).",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "All psCAM-ICU assessments were completed using a two-step approach based on Plum and Posner's (14) categorization of consciousness: arousal and content. The first step was the assessment of patient arousal using the Richmond Agitation-Sedation Scale (RASS).",
       "highlight": "the assessment of patient arousal using the Richmond Agitation-Sedation Scale",
       "scope": "on-scope",
       "note": "Establishes the two-step arousal-then-content assessment: RASS gives 'actual arousal' and the psCAM-ICU gives the 'screen result' — the two values the card reports.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "3) We suggest that all pediatric patients requiring MV are assigned a target depth of sedation using a validated sedation assessment tool at least once daily.",
       "highlight": "assigned a target depth of sedation using a validated sedation assessment tool at least once daily",
       "scope": "on-scope",
       "note": "Governing guideline recommends a validated daily target sedation depth — the 'target arousal' the team states on rounds.",
       "page": "e76",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "We recommend the use of the COMFORT-B Scale or the State Behavioral Scale, to assess level of sedation in mechanically ventilated pediatric patients.",
       "highlight": "to assess level of sedation in mechanically ventilated pediatric patients",
       "scope": "on-scope",
       "note": "Recommends validated sedation scales (COMFORT-B/SBS) that produce the 'actual arousal' value reported on rounds.",
       "page": "e76",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "2) W e recommend routine screening for ICU delirium using a validated tool in critically ill pediatric patients upon admission through ICU discharge or transfer.",
       "highlight": "routine screening for ICU delirium using a validated tool in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "Strong recommendation for routine validated delirium screening — the 'screen result' item.",
       "page": "e88",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Given low patient risk, and possible patient benefit to reduce the incidence and/or decrease duration or severity of delirium we suggest the following non-pharmacologic strategies: optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct-patient care.",
       "highlight": "use of interdisciplinary rounds, family engagement on rounds",
       "scope": "on-scope",
       "note": "Endorses interdisciplinary rounds as recommended practice — the venue in which the card's four items are communicated.",
       "page": "e77",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "1) Assign a target depth of sedation at increasing frequency to adapt to changes in patient clinical status and communicate strategies to reach titration goal.",
       "highlight": "communicate strategies to reach titration goal",
       "scope": "different-setting",
       "note": "Closest verbatim 'communicate the plan' language, but it appears in the periextubation device-removal bundle rather than as a general rounds script.",
       "page": "e83",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "Conclusions--Benzodiazepines are an independent and modifiable risk factor for development of delirium in critically ill children, even after carefully controlling for time-dependent covariates, with a dose-response effect. This temporal relationship suggests causality between benzodiazepine exposure and pediatric delirium and supports limiting the use of benzodiazepines in critically ill children.",
       "highlight": "an independent and modifiable risk factor for development of delirium in critically ill children",
       "scope": "different-intervention",
       "note": "Supports the section's 'find/fix' action (reduce deliriogenic benzodiazepines as part of today's plan) rather than the communication-on-rounds statement itself — a different-scope nearest match.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    }
   ],
   "synthesis": "PANDEM 2022 is the governing pediatric guideline and supports the card's rounds prompt piece by piece — it recommends a validated daily target sedation depth (target arousal), sedation scales (SBS/COMFORT-B/RASS) for actual arousal, routine delirium screening for the screen result, and interdisciplinary rounds as the venue — while the instrument papers (Sessler RASS, Curley SBS, Traube CAPD, Smith ps/pCAM-ICU) validate the specific tools that generate those reported values and Mody supports the benzodiazepine \"fix.\" No single source states the four-item rounds script verbatim; it is a synthesis, and several nearest matches differ in scope (Gupta's low CAPD specificity is a ventilated/developmentally-delayed subgroup caveat, PANDEM's explicit \"communicate strategies\" language is periextubation-specific, Mody addresses a specific drug intervention rather than the communication act, and Sessler's RASS is adult-derived).",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r23",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "6",
   "section": "Act-on-a-positive — find/fix",
   "statement": "Find and fix precipitants: pain, hypoxia, sepsis, metabolic derangement, new medications.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 16",
   "passage": "… Interactive approaches such as cognitive stimulation and physical activity during the day may increase orientation during the day and quality sleep at night. Family presence and involvement, familiar care team members, and comforting objects from home can also help reassure and reorient patients. Studies in critically ill adults have shown decreased occurrence rate and duration of delirium with implementation of EM. A single-center prospective study indirectly supports potential effectiveness of this approach in children. Over a 22-month period, phased implementation of protocolized sedation followed by EM was associated with a near 40% reduction in delirium rates (224). Mitigation of delirium is often achieved by resolution of the underlying critical illness or other contributing medical conditions. Therefore, the initial steps in delirium management should focus on identification and treatment of these underlying etiologies (231, 239, 240, 247-249). Differential diagnoses should be considered using a model such as Bring oxygen, Remove/ Reduce deliriogenic drugs, patient Atmosphere, Immobilization, New organ dysfunction, Metabolic disturbances, Awake, Pain, Sedation (SDC Table 19, http://links.lww.com/PCC/B920) (247). Pharmacologic management of delirium Question: What \"pharmacologic\" sedation strategies reduce the incidence and/or decrease the duration or severity of delirium in critically ill pediatric patients? Answer: 1) \"We recommend\" minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients to\nPANDEM 2022 (p. 16) pairs the quoted guidance with a differential-diagnosis mnemonic covering hypoxia, deliriogenic drugs, metabolic disturbances, and pain; sepsis is subsumed under underlying critical illness and new organ dysfunction rather than named.",
   "evidence": "Full text, p. 16",
   "status": "fulltext",
   "pageNum": "16",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary governing source; directly recommends that initial delirium management target underlying etiologies, with a differential mnemonic that enumerates the claim's precipitants (oxygen/hypoxia, deliriogenic drugs/new meds, organ dysfunction/sepsis, metabolic disturbances, pain).",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "Differential diagnoses should be considered using a model such as Bring oxygen, Remove/ Reduce deliriogenic drugs, patient Atmosphere, Immobilization, New organ dysfunction, Metabolic disturbances, Awake, Pain, Sedation (SDC Table 19, http://links.lww.com/PCC/B920) (247).",
       "highlight": "Bring oxygen, Remove/ Reduce deliriogenic drugs, patient Atmosphere, Immobilization, New organ dysfunction, Metabolic disturbances, Awake, Pain, Sedation",
       "scope": "on-scope",
       "note": "The BRAIN MAPS differential (oxygen, deliriogenic drugs, new organ dysfunction, metabolic disturbances, pain) is the guideline's precipitant checklist and maps onto the claim's find-and-fix list.",
       "page": "e89 (PDF p.16)",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Figure 1. Schematic summary of the key Pain, Agitation, Neuromuscular Blockade, and Delirium in critically ill pediatric patients with consideration of the PICU Environment and Early Mobility (PANDEM) recommendations and representation of the interplay between sedative and analgesic choice on unintended but related outcomes. BRAIN MAPS = Bring oxygen, Remove/ Reduce deliriogenic drugs, patient Atmosphere, Immobilization, New organ dysfunction, Metabolic disturbances, Awake, Pain, Sedation, CAPD = Cornell Assessment of Pediatric Delirium, COMFORT-B = COMFORT-Behavior, EEG = electroencephalogram, ETT = endotracheal tube, FLACC = Faces, Legs, Activity, Cry, and Consolability, IWS = iatrogenic withdrawal syndrome, MV = mechanical ventilation, NMBA = neuromuscular blocking agent, NSAID = nonsteroidal anti-inflammatory drug, pCAM-ICU = pediatric Confusion Assessment Method for the ICU, PRIS = propofol-related infusion syndrome, psCAM-ICU = preschool Confusion Assessment Method for the ICU, RASS = Richmond Agitation-Sedation Scale, SBS = State Behavioral Scale, SOS = Sophia Observation Scale, TOF = train-of-four, WAT-I = Withdrawal Assessment Tool-1.",
       "highlight": "BRAIN MAPS = Bring oxygen, Remove/ Reduce deliriogenic drugs, patient Atmosphere, Immobilization, New organ dysfunction, Metabolic disturbances, Awake, Pain, Sedation",
       "scope": "on-scope",
       "note": "Figure 1 legend defining the BRAIN MAPS mnemonic used for the find/fix differential; the same precipitant categories the claim lists.",
       "page": "Fig. 1",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Concurs at the general-principle level: delirium treatment consists of environmental modification plus addressing the underlying trigger; supports find/fix but does not enumerate the specific precipitants.",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "Although primarily used as a screening tool, there is a possibility that the scores from these tests might bias a physician's judgment, especially if there is an unawareness among the physician regarding the difference in the accuracy of this test in children with developmental delay. Treatment of delirium mainly consists of environmental modifications and addressing the underlying trigger but, in refractory cases, may include use of antipsychotic medications such as risperidone and haloperidol, which have side effects such as QTc prolongation. Prescribing antipsychotic medication for children with developmental delay who are falsely diagnosed with delirium using the CAPD scale could potentially be harmful with no added benefit.",
       "highlight": "Treatment of delirium mainly consists of environmental modifications and addressing the underlying trigger",
       "scope": "on-scope",
       "note": "Same PICU population and management step; states the find/fix principle generally (addressing the underlying trigger) rather than naming each precipitant.",
       "page": "28",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Substantiates one element of the claim's list — medications — by establishing benzodiazepines as an independent, modifiable precipitant of pediatric delirium; framed as prevention rather than the full find/fix approach.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "Conclusions--Benzodiazepines are an independent and modifiable risk factor for development of delirium in critically ill children, even after carefully controlling for time-dependent covariates, with a dose-response effect. This temporal relationship suggests causality between benzodiazepine exposure and pediatric delirium and supports limiting the use of benzodiazepines in critically ill children.",
       "highlight": "Benzodiazepines are an independent and modifiable risk factor for development of delirium in critically ill children",
       "scope": "narrower",
       "note": "Supports only the 'new medications' precipitant (benzodiazepines) as modifiable; narrower than the claim's five-item list.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "background",
     "note": "Cited for the State Behavioral Scale (a sedation-assessment instrument); the nearest-match sentence is about sequencing sedation after addressing precipitants, not delirium-screen management.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Ensuring the comfort of critically ill infants and children is integral to the practice of pediatric critical care. Humane pediatric intensive care often includes the administration of sedatives, once pain, physiologic imbalance and environmental stressors have been addressed.[1] Over 90% of infants and children supported on mechanical ventilation receive some form of sedative therapy. [2] Sedation in this patient population is required for anxiolysis, amnesia, facilitation of care, patient safety in avoidance of adverse events and for decreasing oxygen consumption. For most young patients supported on mechanical ventilation, the goal of sedation is to attain a calm but responsive state [2,3] that protects the young patient from self-harm. Inadequate sedation is associated with potentially dangerous complications such as unplanned endotracheal extubation. [4] High-dose, long-term, and continuous intravenous sedation has been associated with prolonged weaning from mechanical ventilation and/or withdrawal syndrome. [5-7] Therefore, insufficient or excessive sedation is likely to add to the personal and financial burden of intensive care.",
       "highlight": "once pain, physiologic imbalance and environmental stressors have been addressed",
       "scope": "different-intervention",
       "note": "Shares keywords (pain, physiologic imbalance) but in the comfort/sedation context — addressing precipitants before giving sedatives, not the act-on-a-positive-delirium-screen step.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "background",
     "note": "Cited for the CAPD screening tool; the paper validates detection and defers treatment/causes to future research — a different step than find/fix management.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "The CAPD is a promising new clinical screening tool designed and validated for use in the PICU setting to detect delirium in most children. Future work will address further clinical applications of the CAPD, such as diagnostic algorithms for special populations in which delirium diagnoses are challenging. The CAPD may facilitate the development of much needed research investigating the causes, pathophysiology, treatment, and long-term implications of pediatric delirium.",
       "highlight": "designed and validated for use in the PICU setting to detect delirium in most children",
       "scope": "different-intervention",
       "note": "A detection/screening instrument, not the management step; nearest match on the topic but a different intervention.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "background",
     "note": "Cited for the psCAM-ICU screening tool; flags sedation practices as a modifiable delirium risk factor but does not address the find/fix management step.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "The specific associations between delirium and outcomes have not been delineated in children, though critically ill children who survive to home demonstrate decreases in spatial and verbal memory, inability to sustain attention, (23) have significantly longer school absences, (24) and demonstrate executive dysfunction months after discharge. (25) It is possible that elements of critical illness or management factors may contribute to these worse patient outcomes. Of these, sedation practices may be a modifiable risk factor for the development of delirium just as it has been reported in adults. (26) (27) (28) This is a poignant supposition given that 90% of pediatric patients are supported on sedative infusions, including high dose benzodiazepines, during mechanical ventilation. (29) In fact, benzodiazepine administration in critically ill children has previously been associated with the development of post-traumatic stress disorder and delusional memories following critical illness. (30) Using delirium tools such as the psCAM-ICU and pCAM-ICU, novel investigations can be conducted to answer key questions related to highly prevalent sedation practices and brain dysfunction outcomes (acute and long-term) in our sickest children.",
       "highlight": "sedation practices may be a modifiable risk factor for the development of delirium",
       "scope": "narrower",
       "note": "Touches only the medication/sedation precipitant, framed within a screening-tool rationale rather than the full precipitant list.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "No archived text file; cited by the pediatric card set as the RASS sedation-scale source, not for the find/fix management statement.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Unarchived; cited as the pCAM-ICU screening-tool validation source, not for the find/fix precipitant statement.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    }
   ],
   "synthesis": "The on-scope governing source is SCCM PANDEM 2022, which recommends that initial delirium management focus on identifying and treating underlying etiologies via the BRAIN MAPS differential (Bring oxygen, Remove deliriogenic drugs, New organ dysfunction, Metabolic disturbances, Pain), directly matching the claim's precipitant list; Gupta 2021 concurs generally (treatment = environmental modification plus addressing the underlying trigger) and Mody 2018 substantiates the single 'new medications' element via benzodiazepines. The remaining sources (Traube, Smith 2016, Curley, and the RASS/pCAM-ICU citations) are different-scope — they validate detection/sedation instruments rather than the act-on-a-positive management step.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r24",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "6",
   "section": "Act-on-a-positive — bundle",
   "statement": "Switch benzodiazepine sedation to dexmedetomidine; target light, goal-directed sedation.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 4, ¶3",
   "passage": "… Strong High 2) We recommend routine screening for ICU delirium using a validated tool in critically ill pediatric patients upon admission through ICU discharge or transfer. Strong High 3) Given low patient risk, and possible patient benefit to reduce the incidence and/or decrease duration or severity of delirium we suggest the following non-pharmacologic strategies: optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct-patient care. Conditional Low 4) We suggest performing EM, when feasible, to reduce the development of delirium. Conditional Low 5) We recommend minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients to decrease incidence and/or duration or severity of delirium. Strong Moderate (Continued) TABLE 1. (Continued). Summary of Recommendations Recommendations Strength of Recommendation Quality of Evidence\nAlso Mody 2018: \"Benzodiazepines are an independent and modifiable risk factor for development of delirium in critically ill children, even after carefully controlling for time-dependent covariates, with a dose-response effect.\"\nBeyond the quoted benzodiazepine recommendation, PANDEM 2022 advises that dexmedetomidine 'be considered as a primary agent' and that a target depth of sedation be set daily. Mody 2018, quoted second, establishes benzodiazepines as an independent, dose-responsive risk factor for delirium.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governing pediatric guideline: recommends alpha2-agonists as primary sedative class, minimizing benzodiazepines, and targeted goal-directed sedation; body rationale explicitly endorses transition to dexmedetomidine.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "Reducing benzodiazepine exposure by addition of or transition to dexmedetomidine sedation has decreased occurrence rate of delirium in several adult RCTs (252-256).",
       "highlight": "Reducing benzodiazepine exposure by addition of or transition to dexmedetomidine sedation has decreased occurrence rate of delirium",
       "scope": "on-scope",
       "note": "States both halves directly — reducing benzodiazepine exposure by transition to dexmedetomidine sedation lowers delirium occurrence.",
       "page": "e89",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "\"We suggest\" the use of alpha2-agonists as the primary sedative class in critically ill pediatric patients requiring MV (conditional, low-level evidence).",
       "highlight": "alpha2-agonists as the primary sedative class in critically ill pediatric patients requiring MV",
       "scope": "on-scope",
       "note": "Supports the 'to dexmedetomidine' element — dexmedetomidine is the alpha2-agonist recommended as the primary sedative class in ventilated PICU patients.",
       "page": "e76",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "5) We recommend minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients to decrease incidence and/or duration or severity of delirium.",
       "highlight": "minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "Supports the 'switch benzodiazepine' element — a strong recommendation to minimize benzodiazepine-based sedation to reduce delirium.",
       "page": "e77",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "\"We suggest\" that all pediatric patients requiring MV be assigned a target depth of sedation using a validated sedation assessment tool at least once daily (conditional, low-level evidence).",
       "highlight": "assigned a target depth of sedation using a validated sedation assessment tool",
       "scope": "on-scope",
       "note": "Supports the 'target goal-directed sedation' element — assigning and targeting a validated sedation depth.",
       "page": "e82",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "8) W e recommend that dexmedetomidine be considered as a primary agent for sedation in critically ill pediatric post-operative cardiac surgical patients with expected early extubation.",
       "highlight": "dexmedetomidine be considered as a primary agent for sedation in critically ill pediatric post-operative cardiac surgical patients",
       "scope": "different-population",
       "note": "Nearest match naming dexmedetomidine explicitly, but restricted to post-operative cardiac surgical patients with expected early extubation — narrower than the general switch recommendation.",
       "page": "e77",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Pediatric causal, dose-dependent evidence that benzodiazepines are a modifiable delirium risk factor, supporting the benzodiazepine-sparing half of the switch; does not itself name dexmedetomidine or address the sedation target.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "Conclusions--Benzodiazepines are an independent and modifiable risk factor for development of delirium in critically ill children, even after carefully controlling for time-dependent covariates, with a dose-response effect. This temporal relationship suggests causality between benzodiazepine exposure and pediatric delirium and supports limiting the use of benzodiazepines in critically ill children.",
       "highlight": "supports limiting the use of benzodiazepines in critically ill children",
       "scope": "on-scope",
       "note": "Grounds the 'switch away from benzodiazepine' action: independent, causal, dose-response link to pediatric delirium supporting benzodiazepine limitation.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      },
      {
       "context": "In this study, we have shown an independent, temporal, and dose-response relationship between benzodiazepine exposure and subsequent pediatric delirium. With alternate sedation choices available, this is an important and modifiable risk factor. Adoption of a benzodiazepine-sparing approach in the pediatric intensive care unit may decrease delirium rates and improve the care we provide to critically ill children.",
       "highlight": "Adoption of a benzodiazepine-sparing approach in the pediatric intensive care unit may decrease delirium rates",
       "scope": "on-scope",
       "note": "Directly recommends a benzodiazepine-sparing PICU sedation approach to reduce delirium.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      },
      {
       "context": "Delirium in critical illness has been linked to increased morbidity, mortality, and long term cognitive impairment(1-3). The pathophysiology of delirium remains incompletely understood, and involves a complex interplay between predisposing and precipitating influences(4). It is important to identify strategies to prevent delirium by focusing on specific modifiable risk factors. There is published evidence in the adult critical care literature establishing that sedatives -- particularly benzodiazepines -- contribute to the development of delirium(5-7). However, such evidence is lacking in the pediatric intensive care unit (PICU) population and benzodiazepines remain a first-line therapy for sedation in most PICUs(8). This represents a possible modifiable risk factor, as there are alternative sedative medications (albeit with other potential side effects) available for use in PICU patients(9).",
       "highlight": "alternative sedative medications (albeit with other potential side effects) available for use in PICU patients",
       "scope": "on-scope",
       "note": "States alternative sedatives are available to replace benzodiazepines, but does not name dexmedetomidine specifically.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "background",
     "note": "State Behavioral Scale validation — the validated sedation-assessment instrument that operationalizes goal-directed/light sedation targeting; not evidence for the benzodiazepine-to-dexmedetomidine switch.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Variability complicates the use of sedation in the pediatric intensive care unit (PICU) setting. First, a patient's sedative needs vary depending on the nature and course of their illness, drug interaction with concomitant therapies, and their response to therapy. [8,9] Some patients require deep sedation to tolerate synchronous modes of mechanical ventilation while others appear comfortable with light sedation even when supported on unconventional modes of ventilatory support. [10] Next, from a systems perspective, multidisciplinary staff with varying levels of expertise change several times over the working day. This means that patients are exposed to multiple subjective assessments of their sedation requirements, by several staff members, which may result in patients receiving varying dosages of sedation depending upon who performed the assessment. [11,12]",
       "highlight": "others appear comfortable with light sedation",
       "scope": "background",
       "note": "Motivates a validated tool to assess and target sedation depth (light vs deep) — background instrument for 'goal-directed sedation', not the sedative switch.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "background",
     "note": "CAPD is the delirium detection screen that triggers the act-on-a-positive bundle; the paper validates detection and notes sedatives as delirium risk factors but does not address the sedative switch.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Conclusions--With an overall prevalence rate of 20.6% in our study population, delirium is a common problem in pediatric critical care. The Cornell Assessment of Pediatric Delirium is a valid, rapid, observational nursing screen that is urgently needed for the detection of delirium in PICU settings.",
       "highlight": "urgently needed for the detection of delirium in PICU settings",
       "scope": "different-intervention",
       "note": "Detection/screening tool, not a sedation-management intervention — shares the delirium keyword but is the step preceding the bundle action.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "Delirium is acute cerebral dysfunction caused by systemic illness or the effects of treatment (1). There is an urgent need for pediatric-specific research into delirium (2-5). Recognition of delirium in children in the PICU has been suboptimal; therefore, the impact of delirium and therapeutic interventions have been understudied (6-9). Pediatric delirium is associated with increased length of PICU stay (10), posttraumatic symptoms (11), and possible neurocognitive dysfunction in children after discharge (12, 13). A growing body of literature in adult critical care describes delirium as exacerbated by the use of various sedative medications and has identified risk factors that predispose to delirium (5, 14-17). An impediment to the progress of pediatric delirium research has been the absence of an easily administered and widely applicable screening tool.",
       "highlight": "delirium as exacerbated by the use of various sedative medications",
       "scope": "background",
       "note": "Background rationale (adult-derived) that sedatives exacerbate delirium; not pediatric evidence for switching to dexmedetomidine.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "background",
     "note": "CAPD diagnostic-performance study in mechanically ventilated children — a detection-accuracy paper, not evidence for the sedative switch; notes sedation as a delirium risk factor only in passing.",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "This study aimed to examine the performance of CAPD scale in sedated and mechanically ventilated children. We also evaluated ways to improve the accuracy of this scale in patients with and without developmental delay.",
       "highlight": "examine the performance of CAPD scale in sedated and mechanically ventilated children",
       "scope": "different-intervention",
       "note": "Scope is delirium-screen performance (detection), not the benzodiazepine-to-dexmedetomidine switch.",
       "page": "",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      },
      {
       "context": "Delirium is a common problem in the pediatric intensive care unit (PICU). Prevalence of pediatric delirium usually ranges from 10 to 30% but can be as high as 50% in mechanically ventilated patients.1-7 Timely diagnosis of delirium is essential, especially in this high-risk population. There are very few validated delirium screening tools available for use in a pediatric population, including the Cornell Assessment of Pediatric Delirium (CAPD)1 and the Pediatric Confusion Assessment Method for Intensive Care Unit (pCAM-ICU) scales.2 CAPD scale is currently being used as a standard of care at multiple institutions nationwide due to its subjectivity and ease of use as compared with the pCAM-ICU scale. CAPD was validated at a single center for all the patients admitted to a tertiary-care PICU, irrespective of being mechanically ventilated or the level of developmental delay.1 Many studies have reported mechanical ventilation and sedation as risk factors for delirium, with a higher prevalence of delirium than those not requiring sedation or mechanical ventilation.3-8 The accuracy of delirium diagnosis in this population of critically ill children is limited by communication difficulty with the patients.",
       "highlight": "mechanical ventilation and sedation as risk factors for delirium",
       "scope": "background",
       "note": "Background note that sedation is a delirium risk factor; does not address dexmedetomidine or sedation targeting.",
       "page": "",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "background",
     "note": "psCAM-ICU preschool delirium-detection validation; notes that sedation practices (including high-dose benzodiazepines) are a modifiable delirium risk factor — rationale context for the switch, not evidence for dexmedetomidine or sedation targeting.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "It is possible that elements of critical illness or management factors may contribute to these worse patient outcomes. Of these, sedation practices may be a modifiable risk factor for the development of delirium just as it has been reported in adults.",
       "highlight": "sedation practices may be a modifiable risk factor for the development of delirium",
       "scope": "background",
       "note": "Supports the general rationale that sedation practices are a modifiable risk factor for delirium, but from a detection-tool paper and as background only, without naming dexmedetomidine.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "RASS validation (adult ICU); cited by section as the validated sedation scale that operationalizes the 'light, goal-directed sedation' target — a background measurement instrument, not evidence for the benzodiazepine-to-dexmedetomidine switch, and validated in an adult population.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU delirium-screening validation; cited by section as the detection tool that triggers the act-on-a-positive bundle, not evidence for the sedative switch or sedation target.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    }
   ],
   "synthesis": "The pediatric guideline SCCM PANDEM 2022 governs and directly supports all three elements of the statement: it recommends alpha2-agonists (dexmedetomidine) as the primary sedative class, recommends minimizing benzodiazepine-based sedation to reduce delirium, and recommends assigning a validated, targeted (goal-directed) depth of sedation, with its rationale explicitly endorsing \"transition to dexmedetomidine sedation.\" Mody 2018 supplies the pediatric causal, dose-dependent benzodiazepine-to-delirium evidence underpinning the benzodiazepine-sparing half; the RASS/SBS sedation scales and the CAPD/pCAM/psCAM delirium screens share keywords but are different-scope (they are the measurement and detection instruments that operationalize monitoring and trigger the bundle, not evidence for the sedative switch), and PANDEM's dexmedetomidine-specific evidence draws partly on a post-operative cardiac/scoliosis and adult-RCT base.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r25",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "6",
   "section": "Act-on-a-positive — bundle",
   "statement": "Deprescribe anticholinergics; minimize restraints.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 16",
   "passage": "… Studies in critically ill adults have shown decreased occurrence rate and duration of delirium with implementation of EM. A single-center prospective study indirectly supports potential effectiveness of this approach in children. Over a 22-month period, phased implementation of protocolized sedation followed by EM was associated with a near 40% reduction in delirium rates (224). Mitigation of delirium is often achieved by resolution of the underlying critical illness or other contributing medical conditions. Therefore, the initial steps in delirium management should focus on identification and treatment of these underlying etiologies (231, 239, 240, 247-249). Differential diagnoses should be considered using a model such as Bring oxygen, Remove/ Reduce deliriogenic drugs, patient Atmosphere, Immobilization, New organ dysfunction, Metabolic disturbances, Awake, Pain, Sedation (SDC Table 19, http://links.lww.com/PCC/B920) (247). Pharmacologic management of delirium Question: What \"pharmacologic\" sedation strategies reduce the incidence and/or decrease the duration or severity of delirium in critically ill pediatric patients? Answer: 1) \"We recommend\" minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients to\nPANDEM 2022 supports removing or reducing deliriogenic drugs but names neither anticholinergics nor physical restraints, and no other cited source supplies either element; only the 'reduce deliriogenic drugs' element is grounded.",
   "evidence": "Full text, p. 16 — partial support",
   "status": "fulltext",
   "pageNum": "16",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "RASS validation in adult ICU patients; cited as the sedation scale used by the pediatric card set, does not address deprescribing anticholinergics or minimizing restraints (cited by section).",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "State Behavioral Scale validation (infants/young children on mechanical ventilation); a sedation-assessment instrument cited by the card set, contains nothing on anticholinergics, deprescribing, or restraints/immobilization across all extractions.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": []
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD screening-tool validation; cited as the pediatric delirium screen that triggers the act-on-a-positive pathway, but says nothing about the intervention (no mention of anticholinergics, restraints, or immobilization).",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": []
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD performance in mechanically ventilated children; a screening-accuracy paper, silent on deprescribing anticholinergics or minimizing restraints.",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": []
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU validation; cited as the school-age screening tool for the card set, does not address this bundle item (cited by section/DOI).",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "psCAM-ICU (preschool) screening-tool validation; a detection instrument cited by the card set, contains nothing on anticholinergics, deprescribing, or restraints.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": []
    },
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "Differential diagnoses should be considered using a model such as Bring oxygen, Remove/ Reduce deliriogenic drugs, patient Atmosphere, Immobilization, New organ dysfunction, Metabolic disturbances, Awake, Pain, Sedation (SDC Table 19, http://links.lww.com/PCC/B920) (247).",
       "highlight": "Remove/ Reduce deliriogenic drugs, patient Atmosphere, Immobilization",
       "scope": "on-scope",
       "note": "PANDEM's BRAIN MAPS model directs clinicians to Remove/Reduce deliriogenic drugs (anticholinergics are a canonical deliriogenic class) and to address Immobilization (restraints); the card operationalizes these categories.",
       "page": "e89",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "As antipsychotics do not \"treat\" the cause(s) of delirium, vigilance to identify and modify exacerbating factors remains key.",
       "highlight": "vigilance to identify and modify exacerbating factors remains key",
       "scope": "broader",
       "note": "General management principle stated within the antipsychotic recommendation: because drugs do not treat delirium's cause, identifying and modifying exacerbating factors is key — supports de-escalating deliriogenic exposures without naming anticholinergics or restraints specifically.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "In bivariate analyses we found that highly significant predictors of delirium in our sample included being delirious the day prior (65% vs. 27%; p<0.001), receipt of benzodiazepines the day prior (38% vs. 14%; p<0.001), receipt of opiates the day prior (30% vs. 14%; p<0.001), use of restraints (52% vs. 18%; p<0.001), and need for invasive mechanical ventilation (42% vs. 12%; p<0.001).",
       "highlight": "use of restraints (52% vs. 18%; p<0.001)",
       "scope": "on-scope",
       "note": "In critically ill children (academic PICU), restraint use was a highly significant bivariate predictor of delirium (52% vs 18%); supports minimizing restraints, though this is an unadjusted association, not an adjusted/causal result or a deprescribing recommendation.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      },
      {
       "context": "Also, there are additional medications that may contribute to delirium, such as anticholinergics and steroids, that have not been included in this study design. Further research is needed to assess the relationship between delirium and these (and other) drug classes.",
       "highlight": "such as anticholinergics and steroids, that have not been included in this study design",
       "scope": "background",
       "note": "Anticholinergics appear only as a plausible deliriogenic drug class that this study did NOT examine (a stated limitation) — cannot be read as direct evidence for deprescribing anticholinergics.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    }
   ],
   "synthesis": "The governing on-scope source is the 2022 SCCM PANDEM pediatric guideline, whose BRAIN MAPS delirium-management model directs clinicians to \"Remove/Reduce deliriogenic drugs\" and address \"Immobilization\" — the broader categories the card operationalizes as \"deprescribe anticholinergics\" and \"minimize restraints.\" Mody 2018 (critically ill children, same PICU population) partially corroborates the restraint side — restraint use was a highly significant bivariate predictor of delirium (52% vs 18%, p<0.001) — but names anticholinergics only as an unstudied plausible contributor (a stated limitation), and the remaining citations are the card's screening instruments (RASS, SBS, CAPD, Gupta, pCAM/psCAM) that are silent on this intervention.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r26",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "6",
   "section": "Act-on-a-positive — bundle",
   "statement": "Restore sleep and day–night rhythm; mobilize early; maximize family presence.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 16",
   "passage": "… Delirium Prevention and Management in the PICU. Nonpharmacologic management of delirium Question: Among critically ill pediatric patients, what \"nonpharmacologic\" strategies reduce the incidence and/or decrease duration or severity of delirium? (SDC Section E3, http://links.lww.com/PCC/ B920). Answer: 1) Given low patient risk, and possible patient benefit to reduce the occurrence rate and/or decrease duration or severity of delirium, \"we suggest\" the following \"nonpharmacologic strategies\": optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct patient care (conditional, low-level evidence). 2) \"We suggest\" performing EM, when feasible, to reduce the development of delirium (conditional, low-level evidence) although data are insufficient to make a recommendation regarding the impact of this intervention on the duration or severity of delirium. Rationale: Environmental impact on the prevention of delirium has yet to be studied in a robust manner in children. …\nThe quoted passage covers sleep hygiene and family engagement; early mobilization is supported separately by PANDEM 2022 ('performing EM, when feasible, to reduce the development of delirium'), and day-night restoration by the environment guidance (p. 16).",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "RASS arousal-sedation scale; underpins the arousal step of the pediatric delirium screens on the card, not the sleep/mobility/family prevention bundle in this statement. Cited by section/DOI.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "The State Behavioral Scale is a sedation-agitation assessment instrument for ventilated infants/young children; it does not address restoring sleep, early mobility, or family presence as interventions, so it is silent on this statement.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": []
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD validation paper is a delirium screening tool; it discusses screening logistics (e.g., twice-daily, day/night symptom timing) but makes no recommendation about the prevention bundle, so it does not support this statement.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": []
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD diagnostic-performance study in ventilated children; the only 'sleep' hits are bibliographic. It does not address sleep restoration, early mobility, or family presence.",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": []
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU is a delirium diagnostic instrument for older critically ill children; an assessment tool cited on the card, not a source for the prevention bundle. Cited by section.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "background",
     "note": "psCAM-ICU validation (delirium screening for infants/preschoolers). Only relevant text uses sleep-wake disturbance as a delirium symptom; it does not recommend the prevention bundle.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "Sleep wake cycle disturbances have been consistently associated with ICU delirium in both children and adults.",
       "highlight": "Sleep wake cycle disturbances have been consistently associated with ICU delirium",
       "scope": "background",
       "note": "Keyword-overlap trap: here 'sleep-wake cycle disturbance' is a diagnostic FEATURE (Feature 4) of delirium in the psCAM-ICU, not the sleep-restoration intervention the statement calls for — shares the word 'sleep' but is not direct support.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governing source: PANDEM 2022 recommends the full act-on-positive bundle — sleep hygiene/day-night cycling, family presence/involvement, and early mobility — for delirium prevention in critically ill children.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "3) Given low patient risk, and possible patient benefit to reduce the incidence and/or decrease duration or severity of delirium we suggest the following non-pharmacologic strategies: optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct-patient care.",
       "highlight": "optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds",
       "scope": "on-scope",
       "note": "The guideline's formal nonpharmacologic delirium-prevention recommendation, naming sleep-hygiene optimization and family engagement/involvement; the same recommendation's next clause suggests performing EM.",
       "page": "e77",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Despite the limited data, implementation of environmental modifications such as maintaining day/ night cycles with the use of artificial light and sunlight during the day and healthy sleep conditions at night (minimizing noise, light, and stimulation) may impact the occurrence rate and severity of delirium in children (244-246).",
       "highlight": "healthy sleep conditions at night (minimizing noise, light, and stimulation)",
       "scope": "on-scope",
       "note": "Environmental rationale for 'restore sleep and day-night rhythm' — day/night cycling with daytime light and healthy, low-stimulation nighttime sleep conditions.",
       "page": "e89",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "\"We suggest\" performing EM to minimize the effects of immobility in critically ill pediatric patients (conditional, low-level evidence).",
       "highlight": "performing EM to minimize the effects of immobility in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "Dedicated early-mobility recommendation supporting the 'mobilize early' limb of the statement.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "1) We suggest facilitation of parental or caregiver presence in the PICU during routine care and interventional procedures to a) provide comfort to the child, b) decrease parental levels of stress and anxiety and c) increase level of satisfaction of care.",
       "highlight": "facilitation of parental or caregiver presence in the PICU during routine care and interventional procedures",
       "scope": "on-scope",
       "note": "Dedicated family-presence recommendation supporting the 'maximize family presence' limb of the statement.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "background",
     "note": "Causal-inference study on benzodiazepines and pediatric delirium; supports the broader delirium-prevention approach but addresses a different (pharmacologic) intervention than this statement's sleep/mobility/family bundle.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "Another important point to note is that opiate exposure was not independently associated with delirium. This may support the use of an `analgo-sedation' approach in critically ill children. Endorsed by the Society of (SCCM) for use in adults, analgosedation recommends an analgesic-first approach to critically ill patients, with optimization of pain control (utilizing both non-opioid and opioid analgesics, and taking advantage of the sedative side effects of the opiates), with minimization of additional sedation(1,21-23). Less sedation should improve recognition of pain, and optimize pain management. With better pain control, there is less need for sedation. With less sedation, there is less delirium and more opportunity for mobilization and weaning of mechanical ventilation. This paradigm shift has proven to be quite effective in changing the landscape in adult critical care(24,25). It is our hope that as similar data emerge in critically ill children, a comparable culture shift will take place(26).",
       "highlight": "more opportunity for mobilization and weaning of mechanical ventilation",
       "scope": "different-intervention",
       "note": "Different intervention: this paper's scope is minimizing benzodiazepine/analgo-sedation to reduce delirium; mobilization is mentioned only as a downstream benefit of lighter sedation, not as the mobilize-early recommendation itself.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    }
   ],
   "synthesis": "SCCM PANDEM 2022 is the governing on-scope source and directly supports all three limbs of the statement: it recommends optimizing sleep hygiene with day–night cycling, facilitating family presence/involvement, and performing early mobility (EM) to reduce delirium in critically ill children. The other cited PDFs are delirium/sedation assessment instruments (SBS, CAPD, pCAM/psCAM-ICU) or a benzodiazepine risk-factor study (Mody) that do not address the prevention bundle — the psCAM-ICU's \"sleep-wake cycle disturbance\" is a delirium diagnostic feature (keyword overlap only, not sleep restoration), and Mody names mobilization only as a downstream benefit of reduced sedation.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r27",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "6",
   "section": "Act-on-a-positive — escalate",
   "statement": "Drugs treat symptoms only — if agitation threatens safety and non-pharm has failed, consider a short course of an antipsychotic (PANDEM prefers no agent; atypicals are usually chosen first in reported PICU practice) at the lowest effective dose, reassessed daily (off-label, limited evidence).",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 5, ¶1",
   "passage": "Copyright © 2022 by the Society of Critical Care Medicine and the World Federation of Pediatric Intensive and Critical Care Societies. Unauthorized reproduction of this article is prohibited Smith et al e78 www.pccmjournal.org February 2022 • Volume 23 • Number 2 6) We suggest strategies to minimize overall sedation exposure whenever feasible to reduce coma and the incidence and/or severity of delirium in critically ill children. Conditional Low 7) We do not suggest routine use of haloperidol or atypical antipsychotics for the prevention of or decrease in duration of delirium in critically ill pediatric patients. Conditional Low 8) We suggest that in critically ill pediatric patients with refractory delirium, haloperidol or atypical antipsychotics be considered for the management of severe delirium manifestations, with consideration of possible adverse drug effects. Conditional Moderate 9) We recommend a baseline electrocardiogram followed by routine electrolyte and QTc interval monitoring for patients receiving haloperidol or atypical antipsychotics. Strong Moderate IWS 1) We recommend use of either the Withdrawal Assessment Tool-1or Sophia Observation Scale for the assessment of IWS due to opioid or benzodiazepine withdrawal in critically ill pediatric patients. …\nThe quoted recommendation grounds 'PANDEM prefers no agent'. For refractory delirium, PANDEM 2022 allows haloperidol or atypical antipsychotics for 'severe delirium manifestations, with consideration of possible adverse drug effects' (p. 5), and notes such use is not FDA-approved, supporting the off-label caveat.",
   "evidence": "Full text, p. 5",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Archived web source for the Richmond Agitation-Sedation Scale; cited by the card for gauging agitation level, not for the antipsychotic escalation statement.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Validation of the State Behavioral Scale (sedation-agitation measurement); antipsychotics appear only in a reference-list entry (adult Riker 1994), so the body does not address pharmacologic delirium management.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": []
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD screening-tool validation; delirium 'management' appears only in reference-list titles, not in body content about antipsychotic treatment.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": []
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Reported PICU practice corroborates non-pharm-first then antipsychotic escalation for refractory pediatric delirium; secondary to PANDEM.",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "Although primarily used as a screening tool, there is a possibility that the scores from these tests might bias a physician's judgment, especially if there is an unawareness among the physician regarding the difference in the accuracy of this test in children with developmental delay. Treatment of delirium mainly consists of environmental modifications and addressing the underlying trigger but, in refractory cases, may include use of antipsychotic medications such as risperidone and haloperidol, which have side effects such as QTc prolongation. Prescribing antipsychotic medication for children with developmental delay who are falsely diagnosed with delirium using the CAPD scale could potentially be harmful with no added benefit.",
       "highlight": "in refractory cases, may include use of antipsychotic medications such as risperidone and haloperidol",
       "scope": "on-scope",
       "note": "Single-center PICU study states pediatric delirium is managed with environmental/trigger measures first and antipsychotics (risperidone listed first, then haloperidol) reserved for refractory cases, matching the statement's escalation structure and 'atypicals chosen first in PICU practice'.",
       "page": "",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      },
      {
       "context": "Following each CAPD assessment, patients were assessed for the presence of delirium using the DSM-V criteria.12 If delirium was diagnosed, environmental and symptomatic management was initiated in addition to treatment with antipsychotic medications in refractory cases. Care decisions surrounding management and treatment of delirium were left to the individual provider; a standard algorithm was provided for guidance. Patients continued to be scored until transfer or discharge from PICU.",
       "highlight": "treatment with antipsychotic medications in refractory cases",
       "scope": "on-scope",
       "note": "Methods describe the same PICU practice: environmental/symptomatic management first, antipsychotics added only in refractory cases at provider discretion.",
       "page": "",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU screening-tool validation; cited for delirium detection in older children, not for pharmacologic management (unarchived, no text file).",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "psCAM-ICU assessment-tool validation; only mention of pharmacologic therapy is a limitations note that such therapy was infrequent during the study, so it does not address antipsychotic escalation.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": []
    },
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary on-scope source; conditional/low-to-moderate evidence recommendation that antipsychotics be reserved for refractory/severe pediatric delirium at smallest effective dose, off-label, with symptom-not-cause framing.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "Consequently, routine use of antipsychotics to prevent delirium in critically ill pediatric patients is not suggested although their use may be carefully considered for symptom control in patients with refractory and/or severe delirium.",
       "highlight": "their use may be carefully considered for symptom control in patients with refractory and/or severe delirium",
       "scope": "on-scope",
       "note": "Governing guideline position: does not suggest routine antipsychotics ('prefers no agent') but supports considering them for symptom control in refractory/severe delirium.",
       "page": "e90",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Management of severe delirium exacerbations should be limited to the smallest effective dose to decrease risk of side effects and occur in concert with low risk nonpharmacologic treatments preferably prior to initiating pharmacologic therapy",
       "highlight": "the smallest effective dose to decrease risk of side effects and occur in concert with low risk nonpharmacologic treatments preferably prior to initiating pharmacologic therapy",
       "scope": "on-scope",
       "note": "Directly supports 'lowest effective dose' and 'after non-pharm has failed' — nonpharmacologic treatments preferably before pharmacologic therapy (trailing SDC hyperlink trimmed as a split-URL artifact).",
       "page": "e90",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "The management of delirium with any antipsychotic is not approved for use in pediatric patients in the United States by the Food and Drug Administration. As antipsychotics do not \"treat\" the cause(s) of delirium, vigilance to identify and modify exacerbating factors remains key.",
       "highlight": "As antipsychotics do not \"treat\" the cause(s) of delirium",
       "scope": "on-scope",
       "note": "Supports 'off-label' (not FDA-approved in US children) and 'drugs treat symptoms only' — antipsychotics do not treat the cause of delirium.",
       "page": "e90",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Different intervention (benzodiazepine causal-effect study); does not support or contradict the antipsychotic-escalation statement.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "Recent pediatric delirium studies have shown an association between benzodiazepine exposure and delirium(10-12), but fall short of establishing that benzodiazepines directly contribute to delirium development in children. It is important to assess for a temporal relationship before assuming a causal role. For example, a child may be prescribed benzodiazepines as a treatment for the symptoms of agitated delirium. Furthermore, there is an intricate relationship between benzodiazepine use, opiate use, mechanical ventilation, and delirium in the PICU. It is important to obtain an unbiased assessment of the relationship Author Manuscript Author Manuscript Crit Care Med.",
       "highlight": "benzodiazepines as a treatment for the symptoms of agitated delirium",
       "scope": "different-intervention",
       "note": "Nearest match on drugs and pediatric PICU delirium, but concerns benzodiazepines as a deliriogenic risk factor (and their reverse-causation use for agitation), not the antipsychotic escalation the statement describes.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    }
   ],
   "synthesis": "The 2022 SCCM PANDEM pediatric guideline governs and directly supports the statement: it does not suggest routine antipsychotics (prefers no agent) but suggests haloperidol or an atypical antipsychotic be considered for refractory/severe delirium at the smallest effective dose after nonpharmacologic measures, noting antipsychotics do not treat the cause and are FDA off-label in children; Gupta 2021 (single-center PICU) agrees, reserving antipsychotics (risperidone, then haloperidol) for refractory cases. Mody 2018 is a nearest match on drugs and pediatric delirium but a different intervention (benzodiazepines as a deliriogenic risk factor, not antipsychotic treatment), and the RASS/SBS/CAPD/pCAM screening sources support assessment rather than pharmacologic escalation.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r28",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "6",
   "section": "Act-on-a-positive — escalate",
   "statement": "Before and during any antipsychotic: baseline 12-lead ECG (QTc), electrolytes (K, Mg, Ca), review of QT-prolonging drugs.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 5, ¶1",
   "passage": "… Conditional Low 7) We do not suggest routine use of haloperidol or atypical antipsychotics for the prevention of or decrease in duration of delirium in critically ill pediatric patients. Conditional Low 8) We suggest that in critically ill pediatric patients with refractory delirium, haloperidol or atypical antipsychotics be considered for the management of severe delirium manifestations, with consideration of possible adverse drug effects. Conditional Moderate 9) We recommend a baseline electrocardiogram followed by routine electrolyte and QTc interval monitoring for patients receiving haloperidol or atypical antipsychotics. Strong Moderate IWS 1) We recommend use of either the Withdrawal Assessment Tool-1or Sophia Observation Scale for the assessment of IWS due to opioid or benzodiazepine withdrawal in critically ill pediatric patients. Strong Moderate 2) We suggest routine IWS screening after a shorter duration (3-5 d) when higher opioid or benzodiazepine doses are used. Conditional Moderate 3) Until a validated screening tool is developed, monitoring for IWS from alpha2-agonists should be performed using a combination of associated symptoms (unexplained hypertension or tachycardia) with adjunct use of a validated benzodiazepine or opioid screening tool. Good practice\nPANDEM 2022 directly supports baseline ECG with routine electrolyte and QTc monitoring; the '12-lead' specification and the review of QT-prolonging drugs are elaborations not spelled out in the recommendation.",
   "evidence": "Full text, p. 5",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governing on-scope source: strongly recommends baseline ECG plus routine electrolyte and QTc monitoring for children on haloperidol/atypical antipsychotics. Note it says generic \"electrocardiogram\" and \"electrolyte\" — not \"12-lead\", not K/Mg/Ca, and no QT-prolonging-drug review; those claim specifics are elaborations not stated verbatim.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "9) We recommend a baseline electrocardiogram followed by routine electrolyte and QTc interval monitoring for patients receiving haloperidol or atypical antipsychotics.",
       "highlight": "a baseline electrocardiogram followed by routine electrolyte and QTc interval monitoring for patients receiving haloperidol or atypical antipsychotics",
       "scope": "on-scope",
       "note": "Summary of Recommendations (rec #9) states the exact monitoring recommendation for antipsychotics in critically ill children.",
       "page": "e78",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Due to the cardiac side effects, patients treated with haloperidol or atypical antipsychotics should have electrolyte and ECG monitoring at regular intervals.",
       "highlight": "patients treated with haloperidol or atypical antipsychotics should have electrolyte and ECG monitoring at regular intervals",
       "scope": "on-scope",
       "note": "Restates the before/during antipsychotic monitoring intent — electrolyte and ECG monitoring at regular intervals — driven by cardiac side effects.",
       "page": "e89",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest-topic match but different scope: names QTc prolongation as an antipsychotic side effect (cautioning against inappropriate prescribing after false-positive CAPD screening); supplies the cardiac-risk rationale but states no baseline-ECG/electrolyte/QTc monitoring protocol.",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "Although primarily used as a screening tool, there is a possibility that the scores from these tests might bias a physician's judgment, especially if there is an unawareness among the physician regarding the difference in the accuracy of this test in children with developmental delay. Treatment of delirium mainly consists of environmental modifications and addressing the underlying trigger but, in refractory cases, may include use of antipsychotic medications such as risperidone and haloperidol, which have side effects such as QTc prolongation. Prescribing antipsychotic medication for children with developmental delay who are falsely diagnosed with delirium using the CAPD scale could potentially be harmful with no added benefit.",
       "highlight": "antipsychotic medications such as risperidone and haloperidol, which have side effects such as QTc prolongation",
       "scope": "background",
       "note": "Shares the QTc/antipsychotic keywords but addresses side-effect existence and prescribing caution, not the monitoring recommendation the claim states.",
       "page": "",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "State Behavioral Scale sedation-instrument validation; only a reference-list mention of haloperidol (Riker 1994). No ECG/electrolyte/QTc antipsychotic-monitoring content.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": []
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD screening-tool validation; contains no antipsychotic, ECG, QTc, or electrolyte-monitoring content relevant to the claim.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "psCAM-ICU validation; \"electrolyte disturbance\" appears only as a patient-characteristic/admission-diagnosis descriptor, unrelated to antipsychotic cardiac monitoring.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": []
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Benzodiazepine-and-delirium causal-effect study; haloperidol appears only in a cited reference (Pisani 2015). No antipsychotic monitoring recommendation.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": []
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "RASS instrument reference cited on the card set; does not address antipsychotic ECG/electrolyte/QTc monitoring.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU validation cited as the pediatric screening-instrument reference; does not address the antipsychotic monitoring claim.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    }
   ],
   "synthesis": "SCCM PANDEM 2022 is the governing on-scope source and directly supports the claim's core: it strongly recommends a baseline electrocardiogram followed by routine electrolyte and QTc-interval monitoring for critically ill children receiving haloperidol or atypical antipsychotics, with a rationale citing cardiac side effects. PANDEM does not, however, specify a \"12-lead\" ECG, the individual electrolytes (K, Mg, Ca), or a \"review of QT-prolonging drugs\" (none of those terms appear) — those are standard operationalizations of its recommendation; Gupta 2021 is a nearest-topic match at a different scope, naming QTc prolongation only as an antipsychotic side effect (background rationale, not a monitoring protocol), and the remaining sources (SBS, CAPD, psCAM-ICU, Mody, RASS, pCAM-ICU) are card-set instrument citations that do not address antipsychotic cardiac monitoring.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r29",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "6",
   "section": "Act-on-a-positive — escalate",
   "statement": "Consider psychiatry / pharmacy consult per unit practice.",
   "contentType": "Cited clinical content",
   "sources": [],
   "anchor": "",
   "passage": "",
   "evidence": "Not stated in cited source — review",
   "status": "structure",
   "pageNum": null,
   "citations": [],
   "links": [],
   "decision": "",
   "notes": "An operational, unit-practice referral prompt ('per unit practice'). Whether and when to involve psychiatry or pharmacy is a local decision, not a centrally citable claim.",
   "perSource": [],
   "synthesis": "",
   "discrepancy": false,
   "context": ""
  },
  {
   "id": "peds-cards-r30",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "7",
   "section": "Prevention bundle (ABCDEF)",
   "statement": "A — Assess, prevent & manage pain: Validated pediatric scales (FLACC, FACES, or self-report by age); analgesia-first.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 3",
   "passage": "Copyright © 2022 by the Society of Critical Care Medicine and the World Federation of Pediatric Intensive and Critical Care Societies. Unauthorized reproduction of this article is prohibited Smith et al e76 www.pccmjournal.org February 2022 • Volume 23 • Number 2 TABLE 1. Summary of Recommendations Recommendations Strength of Recommendation Quality of Evidence Analgesia 1) We suggest that, in critically ill pediatric patients 6 yr old and older who are capable of communicating, pain assessment via self-report be routinely performed using the Visual Analog Scale, Numeric Rating Scale, Oucher Scale, or Wong-Baker Faces pain scale. Conditional Low 2) We recommend the use of either the Faces, Legs, Activity, Cry, and Consolability or COMFORT-B scales for assessing pain in non-communicative critically ill pediatric patients. Strong Moderate 3) We recommend the use of observational pain assessment tools rather than vital signs alone for assessment of postoperative pain in critically ill pediatric patients. Strong Moderate 4) We suggest the use of observational pain assessment tools rather than vital signs alone for assessment of procedure-related pain in critically ill pediatric patients. Conditional Low 5) We recommend that IV opioids be used as the primary analgesic for treating moderate to severe pain in critically ill pediatric patients. …\nPANDEM 2022 also recommends self-report scales (Visual Analog, Numeric Rating, Oucher, Wong-Baker Faces) where feasible (p. 3), covering 'self-report by age'. 'Analgesia-first' reflects the analgesia-before-sedation framing in Curley 2006 (sedatives given once pain is addressed) rather than the quoted recommendation.",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Cited as the RASS reference — an adult-ICU sedation-agitation scale for a different ABCDEF element (sedation), not a pediatric pain scale; contributes background only.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "We recommended that sedation assessment be completed at the start of normal cares at a frequency that aligns with the patient's clinical state. The Joint Commission for the Accreditation of Hospitals suggests that pain scoring be considered the 5th vital sign. [38] We suggest that sedation scoring should be completed with the patient's pain assessment every four hours and also before and after an intervention that impacts the patient's level of sedation.",
       "highlight": "pain scoring be considered the 5th vital sign",
       "scope": "different-intervention",
       "note": "SBS validates a sedation/agitation instrument (0-10 NRS of sedation), not a pain scale; it only recommends pairing sedation scoring with a separate pain assessment.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Although each individual item in the tool may describe behaviors or symptoms that can be associated with other causes of cerebral dysfunction (such as sedation, agitation, pain, and anxiety), the combination of these items with a total cutoff score of 9 successfully selects for delirium.",
       "highlight": "the combination of these items with a total cutoff score of 9 successfully selects for delirium",
       "scope": "different-intervention",
       "note": "CAPD is a delirium screening tool; it treats pain as a separate cause to be distinguished from delirium, not something it measures — shares the keyword but is a different construct.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "The purpose of this study was to examine the performance of the Cornell Assessment of Pediatric Delirium (CAPD) scale in these patients.",
       "highlight": "examine the performance of the Cornell Assessment of Pediatric Delirium (CAPD) scale",
       "scope": "different-intervention",
       "note": "Evaluates CAPD delirium-screening performance in mechanically ventilated children; contains no pain-scale or analgesia content.",
       "page": "",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited by section/DOI only; pCAM-ICU is a pediatric delirium diagnostic tool (a different ABCDEF element), not a pain scale.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "An interdisciplinary team comprising of pediatric anesthesiology/critical care, neurodevelopmental pediatrics, and child and adolescent psychiatry developed the psCAMICU based on the hierarchical design of the pCAM-ICU and the CAM-ICU, (9) which required the following for delirium diagnosis: 1) fluctuation or acute change from baseline mental status, 2) inattention, and either 3) a current altered level of consciousness, or 4) presence of disorganized thinking. Valid pediatric neurocognitive assessments, (10) pain and behavior scales, (11) (12) and developmental milestones, (13) were reviewed and used as a guide to ensure the cognitive and consciousness assessments within the psCAM-ICU were appropriate for both infants and preschool-aged children. As with the adult CAM-ICU and pCAM-ICU, and in agreement with the recent DSM-V, the psCAM-ICU requires the presence of inattention, the most fundamental feature of delirium, and is based on objective and interactive patient assessments.",
       "highlight": "pain and behavior scales",
       "scope": "different-intervention",
       "note": "psCAM-ICU is a preschool delirium-monitoring tool; pain/behavior scales are mentioned only as design inputs, not validated or recommended as the pain-assessment method.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "1) W e suggest that, in critically ill pediatric patients 6 yr old and older who are capable of communicating, pain assessment via self-report be routinely performed using the Visual Analog Scale, Numeric Rating Scale, Oucher Scale, or Wong-Baker Faces pain scale.",
       "highlight": "pain assessment via self-report be routinely performed using the Visual Analog Scale, Numeric Rating Scale, Oucher Scale, or Wong-Baker Faces pain scale",
       "scope": "on-scope",
       "note": "Recommends validated self-report pain scales — including Wong-Baker Faces (FACES) — for communicating children, directly backing the 'FACES / self-report' element.",
       "page": "e76 (p. 3)",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "a) \"We recommend\" the use of either the Faces, Legs, Activity, Cry, and Consolability (FLACC) or COMFORT-Behavior (COMFORT-B) scales for assessing pain in noncommunicative critically ill pediatric patients (strong, moderate-level evidence).",
       "highlight": "Faces, Legs, Activity, Cry, and Consolability (FLACC)",
       "scope": "on-scope",
       "note": "Strong recommendation for FLACC (or COMFORT-B) in noncommunicative children — directly backs the FLACC element of the claim.",
       "page": "e81 (p. 8)",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Rationale: Pain assessment tools can be divided into self-report and observational rating scales. In children able to express themselves, self-report represents the \"gold standard\" for pain assessment (20, 22, 34-39). The most commonly used pediatric self-report tools are the VAS (40), Numerical Rating Scale (41), Oucher scale (42), and the Wong Baker Faces pain scale (43) (SDC Table 1, http://links.lww.com/PCC/B920). Although all of these tools have been broadly validated in pediatric populations as young as 3 years old, self-report tools are felt to be most reliable in patients who are at least 6 years old (17, 19, 22, 37-39, 44).",
       "highlight": "self-report tools are felt to be most reliable in patients who are at least 6 years old",
       "scope": "on-scope",
       "note": "Establishes the age threshold (approximately 6 yr and older) for reliable self-report — backs the 'self-report by age' qualifier.",
       "page": "e81 (p. 8)",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "\"We recommend\" that IV opioids be used as the primary analgesic for treating moderate to severe pain in critically ill pediatric patients (strong, moderate-level evidence).",
       "highlight": "IV opioids be used as the primary analgesic for treating moderate to severe pain",
       "scope": "on-scope",
       "note": "Recommends IV opioids as the primary analgesic for moderate-to-severe pain, consistent with prioritizing analgesia ('analgesia-first').",
       "page": "e76 (p. 3)",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "Another important point to note is that opiate exposure was not independently associated with delirium. This may support the use of an `analgo-sedation' approach in critically ill children. Endorsed by the Society of (SCCM) for use in adults, analgosedation recommends an analgesic-first approach to critically ill patients, with optimization of pain control (utilizing both non-opioid and opioid analgesics, and taking advantage of the sedative side effects of the opiates), with minimization of additional sedation(1,21-23). Less sedation should improve recognition of pain, and optimize pain management. With better pain control, there is less need for sedation. With less sedation, there is less delirium and more opportunity for mobilization and weaning of mechanical ventilation. This paradigm shift has proven to be quite effective in changing the landscape in adult critical care(24,25). It is our hope that as similar data emerge in critically ill children, a comparable culture shift will take place(26).",
       "highlight": "analgosedation recommends an analgesic-first approach to critically ill patients, with optimization of pain control",
       "scope": "on-scope",
       "note": "Supports the analgesia-first (analgosedation) approach in critically ill children, but frames it as SCCM-endorsed for adults and extrapolated to pediatrics; does not address pain-scale selection.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    }
   ],
   "synthesis": "SCCM PANDEM 2022 is the on-scope guideline that governs and fully supports the pain element — validated self-report scales (VAS/NRS/Oucher/Wong-Baker FACES) for communicating children about 6 yr and older, FLACC or COMFORT-B for noncommunicative children, and IV opioids as the primary analgesic — while Mody 2018 supports the analgesia-first (analgosedation) approach in critically ill children, though its basis is the adult SCCM endorsement rather than pediatric pain-scale evidence. The RASS, SBS, CAPD, and pCAM-ICU/psCAM-ICU citations validate sedation- or delirium-assessment instruments (other ABCDEF elements) and are nearest-topic but different-scope for this pain statement, so they do not directly support it.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r31",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "7",
   "section": "Prevention bundle (ABCDEF)",
   "statement": "B — Both spontaneous awakening & breathing trials: Protocolized, nurse-driven sedation minimization; watch for iatrogenic withdrawal (WAT-1) when weaning.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 3",
   "passage": "… Strong High Sedation 1) We recommend the use of the COMFORT-B Scale or the State Behavioral Scale, to assess level of sedation in mechanically ventilated pediatric patients. Strong Moderate 2) We suggest the use of the Richmond Agitation-Sedation Scale to assess level of sedation in mechanically ventilated pediatric patients. Conditional Low 3) We suggest that all pediatric patients requiring MV are assigned a target depth of sedation using a validated sedation assessment tool at least once daily. Conditional Low 4) We suggest the use of protocolized sedation in all critically ill pediatric patients requiring sedation and/or analgesia during MV. Conditional Low 5) The addition of daily sedation interruption to sedation protocolization is not suggested due to lack of improvement in outcomes. Conditional Low 6) During the periextubation period when sedation is typically lightened, we suggest the following bundle strategies to decrease risk of inadvertent device removal: a) Assign a target depth of sedation at increasing frequency to adapt to changes inpatient clinical status and communicate strategies to reach titration goal. b) Consider a sedation weaning protocol. c) Consider unit standards for securement of endotracheal tubes and safety plan. …\nPANDEM 2022 separately supports standardized sedation and analgesia weaning to attenuate iatrogenic withdrawal, with WAT-1 for surveillance. PANDEM does not, however, suggest routine daily sedation interruption, so the awakening-trial element and the 'nurse-driven' phrasing rest on bundle convention rather than the guideline.",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Cited as the sedation-depth instrument (RASS) used to set/target a level of sedation, but validated in ADULT ICU patients; contributes the scale, not evidence for the pediatric B element (cited by section).",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Ensuring the comfort of critically ill infants and children is integral to the practice of pediatric critical care. Humane pediatric intensive care often includes the administration of sedatives, once pain, physiologic imbalance and environmental stressors have been addressed.[1] Over 90% of infants and children supported on mechanical ventilation receive some form of sedative therapy. [2] Sedation in this patient population is required for anxiolysis, amnesia, facilitation of care, patient safety in avoidance of adverse events and for decreasing oxygen consumption. For most young patients supported on mechanical ventilation, the goal of sedation is to attain a calm but responsive state [2,3] that protects the young patient from self-harm. Inadequate sedation is associated with potentially dangerous complications such as unplanned endotracheal extubation. [4] High-dose, long-term, and continuous intravenous sedation has been associated with prolonged weaning from mechanical ventilation and/or withdrawal syndrome. [5-7] Therefore, insufficient or excessive sedation is likely to add to the personal and financial burden of intensive care.",
       "highlight": "prolonged weaning from mechanical ventilation and/or withdrawal syndrome",
       "scope": "different-intervention",
       "note": "The State Behavioral Scale is a sedation-ASSESSMENT instrument (the tool that lets nurses target/minimize sedation), not the SAT/SBT protocol itself; this sentence is background rationale linking excessive sedation to prolonged weaning and withdrawal.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Delirium is acute cerebral dysfunction caused by systemic illness or the effects of treatment (1). There is an urgent need for pediatric-specific research into delirium (2-5). Recognition of delirium in children in the PICU has been suboptimal; therefore, the impact of delirium and therapeutic interventions have been understudied (6-9). Pediatric delirium is associated with increased length of PICU stay (10), posttraumatic symptoms (11), and possible neurocognitive dysfunction in children after discharge (12, 13). A growing body of literature in adult critical care describes delirium as exacerbated by the use of various sedative medications and has identified risk factors that predispose to delirium (5, 14-17). An impediment to the progress of pediatric delirium research has been the absence of an easily administered and widely applicable screening tool.",
       "highlight": "delirium as exacerbated by the use of various sedative medications",
       "scope": "different-intervention",
       "note": "CAPD is a delirium-SCREENING tool (the 'D' element); this nearest-match sentence links sedatives to delirium in adult literature but does not address protocolized sedation minimization, SAT/SBT, or WAT-1 withdrawal.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "Delirium is a common problem in the pediatric intensive care unit (PICU). Prevalence of pediatric delirium usually ranges from 10 to 30% but can be as high as 50% in mechanically ventilated patients.1-7 Timely diagnosis of delirium is essential, especially in this high-risk population. There are very few validated delirium screening tools available for use in a pediatric population, including the Cornell Assessment of Pediatric Delirium (CAPD)1 and the Pediatric Confusion Assessment Method for Intensive Care Unit (pCAM-ICU) scales.2 CAPD scale is currently being used as a standard of care at multiple institutions nationwide due to its subjectivity and ease of use as compared with the pCAM-ICU scale. CAPD was validated at a single center for all the patients admitted to a tertiary-care PICU, irrespective of being mechanically ventilated or the level of developmental delay.1 Many studies have reported mechanical ventilation and sedation as risk factors for delirium, with a higher prevalence of delirium than those not requiring sedation or mechanical ventilation.3-8 The accuracy of delirium diagnosis in this population of critically ill children is limited by communication difficulty with the patients.",
       "highlight": "mechanical ventilation and sedation as risk factors for delirium",
       "scope": "different-intervention",
       "note": "A CAPD delirium-screening performance study in ventilated/sedated children; shares sedation/MV/PICU keywords but is about the 'D' screening element, not the B sedation-minimization/withdrawal intervention.",
       "page": "",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Pediatric CAM-ICU delirium-screening tool cited by the card for the 'D' element; unarchived, so no paragraph extraction — does not bear on the B statement (cited by section).",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "The specific associations between delirium and outcomes have not been delineated in children, though critically ill children who survive to home demonstrate decreases in spatial and verbal memory, inability to sustain attention, (23) have significantly longer school absences, (24) and demonstrate executive dysfunction months after discharge. (25) It is possible that elements of critical illness or management factors may contribute to these worse patient outcomes. Of these, sedation practices may be a modifiable risk factor for the development of delirium just as it has been reported in adults. (26) (27) (28) This is a poignant supposition given that 90% of pediatric patients are supported on sedative infusions, including high dose benzodiazepines, during mechanical ventilation. (29) In fact, benzodiazepine administration in critically ill children has previously been associated with the development of post-traumatic stress disorder and delusional memories following critical illness. (30) Using delirium tools such as the psCAM-ICU and pCAM-ICU, novel investigations can be conducted to answer key questions related to highly prevalent sedation practices and brain dysfunction outcomes (acute and long-term) in our sickest children.",
       "highlight": "sedation practices may be a modifiable risk factor for the development of delirium",
       "scope": "different-intervention",
       "note": "The psCAM-ICU is a preschool delirium-screening tool ('D' element); this nearest-match sentence flags sedation as a modifiable delirium risk factor but does not address SAT/SBT, protocolized sedation minimization, or WAT-1 withdrawal (the file's other 'withdrawal' hits are study/consent withdrawal, not iatrogenic).",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "\"We suggest\" the use of protocolized sedation in all critically ill pediatric patients requiring sedation and/or analgesia during MV (conditional, low-level evidence).",
       "highlight": "the use of protocolized sedation in all critically ill pediatric patients requiring sedation and/or analgesia during MV",
       "scope": "on-scope",
       "note": "Directly supports 'protocolized sedation minimization' — protocolized sedation for all ventilated pediatric patients requiring sedation/analgesia.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "1) \"We recommend\" use of either the Withdrawal Assessment Tool-1 (WAT-1) or Sophia Observation Scale (SOS) for the assessment of IWS due to opioid or benzodiazepine withdrawal in critically ill pediatric patients (strong, moderate-level evidence).",
       "highlight": "use of either the Withdrawal Assessment Tool-1 (WAT-1) or Sophia Observation Scale (SOS) for the assessment of IWS due to opioid or benzodiazepine withdrawal in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "Directly supports 'watch for iatrogenic withdrawal (WAT-1)' — a strong recommendation to use WAT-1 (or SOS) to assess iatrogenic withdrawal syndrome.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Rationale: Whereas protocolized sedation typically encompasses titration of agents to meet sedation targets during MV, IWS most often occurs during ventilator weaning or following extubation, when sedatives are being weaned. Six studies were found more specifically addressing protocolization of opioid and benzodiazepine weaning (IV and/or enteral agents) and their impact on weaning process duration, cumulative drug exposure, and development of IWS symptoms (SDC Table 23, http://links.lww.com/PCC/B920). All five studies evaluating duration of sedative wean reported more rapid weaning with protocolization (124, 296- 299) as well as a decrease (124, 297) or no difference (298, 299) in the occurrence rate of IWS development. Two studies reported similar (300) or reduced IWS rates (299) with protocolized versus nonprotocolized weaning with more protocolized patients being totally weaned off sedatives prior to hospital discharge.",
       "highlight": "IWS most often occurs during ventilator weaning or following extubation, when sedatives are being weaned",
       "scope": "on-scope",
       "note": "Directly supports the '...when weaning' timing — the guideline states iatrogenic withdrawal most often arises during ventilator weaning/extubation as sedatives are weaned.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "5) The addition of daily sedation interruption to sedation protocolization is not suggested due to lack of improvement in outcomes.",
       "highlight": "The addition of daily sedation interruption to sedation protocolization is not suggested",
       "scope": "on-scope",
       "note": "Scope nuance on the same topic/population: PANDEM does NOT recommend daily sedation interruption (the pediatric analog of the adult 'spontaneous awakening trial'), so the adult ABCDEF 'Both SAT & SBT' framing is only partially transferable to children.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "Another important point to note is that opiate exposure was not independently associated with delirium. This may support the use of an `analgo-sedation' approach in critically ill children. Endorsed by the Society of (SCCM) for use in adults, analgosedation recommends an analgesic-first approach to critically ill patients, with optimization of pain control (utilizing both non-opioid and opioid analgesics, and taking advantage of the sedative side effects of the opiates), with minimization of additional sedation(1,21-23). Less sedation should improve recognition of pain, and optimize pain management. With better pain control, there is less need for sedation. With less sedation, there is less delirium and more opportunity for mobilization and weaning of mechanical ventilation. This paradigm shift has proven to be quite effective in changing the landscape in adult critical care(24,25). It is our hope that as similar data emerge in critically ill children, a comparable culture shift will take place(26).",
       "highlight": "With less sedation, there is less delirium and more opportunity for mobilization and weaning of mechanical ventilation",
       "scope": "on-scope",
       "note": "Supports the sedation-minimization rationale in critically ill children (analgo-sedation → less sedation → less delirium and easier weaning), though it does not itself address protocolization, nurse-driven delivery, SAT/SBT, or WAT-1.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    }
   ],
   "synthesis": "The 2022 SCCM PANDEM pediatric guideline governs this \"B\" element and directly supports its substance: it suggests protocolized sedation for all ventilated children and strongly recommends the WAT-1 (or Sophia Observation Scale) to monitor iatrogenic withdrawal, which it notes most often occurs during ventilator weaning/extubation — with Mody 2018 supporting the underlying sedation-minimization rationale; note, however, that PANDEM does NOT recommend routine daily sedation interruption (the pediatric analog of the adult \"spontaneous awakening trial\"), so the adult ABCDEF \"Both SAT & SBT\" label transfers only partially to pediatrics. The remaining sources (RASS, State Behavioral Scale, CAPD, psCAM-ICU, pCAM-ICU) are assessment-scale validations for other bundle elements and are different-intervention/background — they share sedation/ventilation/PICU keywords but do not directly support the B statement.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r32",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "7",
   "section": "Prevention bundle (ABCDEF)",
   "statement": "C — Choice of analgesia & sedation: Light, goal-directed (SBS −1 to 0 / unit RASS target); minimize benzodiazepines, prefer dexmedetomidine.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 4, ¶3",
   "passage": "… Strong High 2) We recommend routine screening for ICU delirium using a validated tool in critically ill pediatric patients upon admission through ICU discharge or transfer. Strong High 3) Given low patient risk, and possible patient benefit to reduce the incidence and/or decrease duration or severity of delirium we suggest the following non-pharmacologic strategies: optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct-patient care. Conditional Low 4) We suggest performing EM, when feasible, to reduce the development of delirium. Conditional Low 5) We recommend minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients to decrease incidence and/or duration or severity of delirium. Strong Moderate (Continued) TABLE 1. (Continued). Summary of Recommendations Recommendations Strength of Recommendation Quality of Evidence\nAlso Curley 2006 (SBS): \"−1\nResponsive to gentle\ntouch or voice ... 0\nAwake and able to\ncalm\"\nPANDEM 2022 also supports dexmedetomidine as a primary agent and a daily sedation target; the SBS -1 to 0 target maps to the Curley 2006 anchors quoted second (-1 'responsive to gentle touch or voice'; 0 'awake and able to calm').",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Adult-ICU validation of the Richmond Agitation-Sedation Scale; origin of the RASS instrument the statement invokes as the 'unit RASS target' (cited by section/DOI). Adult-derived scale applied here as the sedation-depth reference.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "The purpose of this study was to empirically construct and demonstrate preliminary construct validity and inter-rater reliability of a pediatric sedation assessment scale, the State Behavioral Scale (SBS), for use in young critically ill pediatric patients supported on mechanical ventilation.",
       "highlight": "the State Behavioral Scale (SBS), for use in young critically ill pediatric patients supported on mechanical ventilation",
       "scope": "on-scope",
       "note": "Establishes the SBS as the validated pediatric sedation-assessment instrument the statement's 'SBS -1 to 0' target draws on.",
       "page": "108",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      },
      {
       "context": "Using the median scores on the 7 dimensions and mean NRS scores for each group (see Table 2), the 5 profiles were then aligned to a bipolar numeric scale ranging from -3 to +1. We selected this metric because our group had experience using a modified MAAS [27] with a bipolar scale that clinicians described as logical and readily recalled; specifically, negative numbers equated to a less active states and more positive numbers equated to more active states. This bipolar numeric rating scale was also used in the original Sedation-Agitation Scale for critically ill adults. [26] The first cluster group with a mean (95% CI) NRS score of 1.1 (0.7- 1.6) was linked to a SBS dimension of -3 while the fourth cluster group with a mean NRS score of 5.3 (4.9-5.6) was equated with a SBS dimension of 0. The remaining -2, -1 and +1 values were then aligned around these fixed points.",
       "highlight": "was equated with a SBS dimension of 0",
       "scope": "on-scope",
       "note": "Constructs the bipolar SBS metric and anchors the -1 and 0 points, grounding the numeric range the statement uses as the light-sedation target.",
       "page": "111",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      },
      {
       "context": "The dimensions include descriptors that have been previously described to be associated with agitation. [24] More negative scores reflect a more sedated state. More positive scores reflect a more agitated state. The single-digit bipolar numeric avoids the complexity of summing multiple dimension scores and is logical in that the use of negative numbers for sedation and positive number for agitation and zero score for neither sedation nor agitation may enhance clinician recall of the measure. Each level contains multiple descriptors increasing the likelihood that a patient's behavior can be mapped to a single level. The SBS was developed to augment a clinician's clinical judgment. Differentiating behavioral distress from physiologic distress requires the clinician to interpret patient behavior within the context of their evolving clinical state.",
       "highlight": "zero score for neither sedation nor agitation",
       "scope": "on-scope",
       "note": "Defines what SBS -1 to 0 means - the light, calm-but-rousable zone (negative = sedated, 0 = neither sedated nor agitated).",
       "page": "112",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      },
      {
       "context": "The SBS was specifically designed for and tested in young intubated mechanically ventilated patients - a population who often experience extremes in level of sedation over their normal trajectory of illness. The tool reflects the presence and severity of the clinical conditions for which sedation is administered in this population. [20,36] We designed the SBS to require an evaluation of patient response to a progressive stimulus. This approach is familiar to intensive care clinicians as it is similar to the progressive stimulus performed during a neurological exam. We believe that appropriate levels of sedation should help the young patient through necessary care procedures that require a stimulated state while avoiding over-sedation when not stimulated.",
       "highlight": "avoiding over-sedation when not stimulated",
       "scope": "on-scope",
       "note": "Supports the 'light, goal-directed' concept - titrate to a rousable state and avoid over-sedation; does not address the benzodiazepine/dexmedetomidine choice.",
       "page": "112",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Delirium is acute cerebral dysfunction caused by systemic illness or the effects of treatment (1). There is an urgent need for pediatric-specific research into delirium (2-5). Recognition of delirium in children in the PICU has been suboptimal; therefore, the impact of delirium and therapeutic interventions have been understudied (6-9). Pediatric delirium is associated with increased length of PICU stay (10), posttraumatic symptoms (11), and possible neurocognitive dysfunction in children after discharge (12, 13). A growing body of literature in adult critical care describes delirium as exacerbated by the use of various sedative medications and has identified risk factors that predispose to delirium (5, 14-17). An impediment to the progress of pediatric delirium research has been the absence of an easily administered and widely applicable screening tool.",
       "highlight": "delirium as exacerbated by the use of various sedative medications",
       "scope": "background",
       "note": "A delirium-screening-tool validation; notes only (from adult literature) that sedatives exacerbate delirium, making no pediatric sedation-choice recommendation.",
       "page": "656",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "All patients in the PICU on a given study day were eligible if there was a parent or guardian available to provide informed consent. The only exclusion criterion was a sedation score of less than -3 (deeply sedated or unarousable), using the Richmond Agitation and Sedation Scale (RASS) (38, 39). Demographic and clinical data were collected on each subject.",
       "highlight": "using the Richmond Agitation and Sedation Scale (RASS)",
       "scope": "different-intervention",
       "note": "Shares the RASS keyword but uses it only as an arousal gate for CAPD screening (the 'D' element), not as a sedation target.",
       "page": "658",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "Delirium is a common problem in the pediatric intensive care unit (PICU). Prevalence of pediatric delirium usually ranges from 10 to 30% but can be as high as 50% in mechanically ventilated patients.1-7 Timely diagnosis of delirium is essential, especially in this high-risk population. There are very few validated delirium screening tools available for use in a pediatric population, including the Cornell Assessment of Pediatric Delirium (CAPD)1 and the Pediatric Confusion Assessment Method for Intensive Care Unit (pCAM-ICU) scales.2 CAPD scale is currently being used as a standard of care at multiple institutions nationwide due to its subjectivity and ease of use as compared with the pCAM-ICU scale. CAPD was validated at a single center for all the patients admitted to a tertiary-care PICU, irrespective of being mechanically ventilated or the level of developmental delay.1 Many studies have reported mechanical ventilation and sedation as risk factors for delirium, with a higher prevalence of delirium than those not requiring sedation or mechanical ventilation.3-8 The accuracy of delirium diagnosis in this population of critically ill children is limited by communication difficulty with the patients.",
       "highlight": "mechanical ventilation and sedation as risk factors for delirium",
       "scope": "different-intervention",
       "note": "A CAPD-performance study in ventilated children; notes sedation as a delirium risk factor but does not address the choice of sedative.",
       "page": "25",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      },
      {
       "context": "CAPD scale was used to screen all study patients by the bedside nurses twice a day during their shifts (4 a.m. and 4 p. m.). Our PICU uses the State Behavioral Scale (SBS) for monitoring sedation every 4 hours, so the CAPD scale was modified to replace the Richmond Agitation Sedation Scale (RASS) with SBS.1 RASS scores of 4 and 5 are considered equivalent to SBS scores of 2 and 3; thus, on our CAPD scale, if SBS was 2 or 3 prior to CAPD scoring, we did not proceed with scoring.13 Our clinical child life specialist interviewed all study patients' parents/guardians to determine baseline developmental age to determine presence or absence of developmental delay.",
       "highlight": "the State Behavioral Scale (SBS) for monitoring sedation every 4 hours",
       "scope": "different-intervention",
       "note": "Shares the SBS keyword but uses it only as an arousal precondition for delirium screening, not as a goal-directed sedation target.",
       "page": "26",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Validation of the pediatric CAM-ICU, a delirium-monitoring tool (the 'D' element) - a different intervention from the sedation-choice statement; part of the card set's tool base (cited by section/DOI). Source not archived.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "The specific associations between delirium and outcomes have not been delineated in children, though critically ill children who survive to home demonstrate decreases in spatial and verbal memory, inability to sustain attention, (23) have significantly longer school absences, (24) and demonstrate executive dysfunction months after discharge. (25) It is possible that elements of critical illness or management factors may contribute to these worse patient outcomes. Of these, sedation practices may be a modifiable risk factor for the development of delirium just as it has been reported in adults. (26) (27) (28) This is a poignant supposition given that 90% of pediatric patients are supported on sedative infusions, including high dose benzodiazepines, during mechanical ventilation. (29) In fact, benzodiazepine administration in critically ill children has previously been associated with the development of post-traumatic stress disorder and delusional memories following critical illness. (30) Using delirium tools such as the psCAM-ICU and pCAM-ICU, novel investigations can be conducted to answer key questions related to highly prevalent sedation practices and brain dysfunction outcomes (acute and long-term) in our sickest children.",
       "highlight": "sedation practices may be a modifiable risk factor for the development of delirium",
       "scope": "background",
       "note": "A preschool delirium-screening-tool paper; its discussion notes sedation/high-dose benzodiazepines as modifiable risk factors but makes no sedation-choice recommendation.",
       "page": "598",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "The first step was the assessment of patient arousal using the Richmond Agitation-Sedation Scale (RASS).",
       "highlight": "assessment of patient arousal using the Richmond Agitation-Sedation Scale (RASS)",
       "scope": "different-intervention",
       "note": "Shares the RASS keyword but uses it as an arousal gate for delirium assessment, not as a sedation target.",
       "page": "594",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "5) We recommend minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients to decrease incidence and/or duration or severity of delirium.",
       "highlight": "minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "The guideline recommendation directly supporting 'minimize benzodiazepines' in the pediatric ICU population.",
       "page": "e76",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Answer: \"We suggest\" the use of alpha2-agonists as the primary sedative class in critically ill pediatric patients requiring MV (conditional, low-level evidence).",
       "highlight": "alpha2-agonists as the primary sedative class in critically ill pediatric patients requiring MV",
       "scope": "on-scope",
       "note": "Directly supports 'prefer dexmedetomidine' - alpha2-agonists (dexmedetomidine) recommended as the primary sedative class for ventilated children.",
       "page": "e84",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "In a small single-center RCT, delirium rates were significantly lower in dexmedetomidine compared with midazolam-sedated patients following scoliosis surgery (125, 141).",
       "highlight": "delirium rates were significantly lower in dexmedetomidine compared with midazolam-sedated patients following scoliosis surgery",
       "scope": "on-scope",
       "note": "Pediatric RCT linking benzodiazepine (midazolam) avoidance and dexmedetomidine with lower delirium — grounds both halves of the pharmacologic recommendation.",
       "page": "e89",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "\"We suggest\" that all pediatric patients requiring MV be assigned a target depth of sedation using a validated sedation assessment tool at least once daily (conditional, low-level evidence).",
       "highlight": "assigned a target depth of sedation using a validated sedation assessment tool at least once daily",
       "scope": "on-scope",
       "note": "Supports 'light, goal-directed' sedation — assign and target a sedation depth using a validated tool at least once daily.",
       "page": "e82",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "1) \"We recommend\" that dexmedetomidine be considered as a primary agent for sedation in critically ill pediatric postoperative cardiac surgical patients with expected early extubation (strong, moderate-level evidence).",
       "highlight": "dexmedetomidine be considered as a primary agent for sedation",
       "scope": "narrower",
       "note": "The strong dexmedetomidine recommendation is narrower - limited to postoperative cardiac surgical patients - whereas the general alpha2-agonist recommendation covers the broad 'prefer dexmedetomidine.'",
       "page": "e84",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "Conclusions--Benzodiazepines are an independent and modifiable risk factor for development of delirium in critically ill children, even after carefully controlling for time-dependent covariates, with a dose-response effect. This temporal relationship suggests causality between benzodiazepine exposure and pediatric delirium and supports limiting the use of benzodiazepines in critically ill children.",
       "highlight": "supports limiting the use of benzodiazepines in critically ill children",
       "scope": "on-scope",
       "note": "Causal, dose-response, temporally-controlled evidence directly supporting the 'minimize benzodiazepines' element in critically ill children.",
       "page": "1490",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      },
      {
       "context": "In this study, we have shown an independent, temporal, and dose-response relationship between benzodiazepine exposure and subsequent pediatric delirium. With alternate sedation choices available, this is an important and modifiable risk factor. Adoption of a benzodiazepine-sparing approach in the pediatric intensive care unit may decrease delirium rates and improve the care we provide to critically ill children.",
       "highlight": "benzodiazepine-sparing approach in the pediatric intensive care unit may decrease delirium rates",
       "scope": "on-scope",
       "note": "Explicitly endorses a benzodiazepine-sparing PICU approach, reinforcing the statement's minimize-benzodiazepine element.",
       "page": "1490",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    }
   ],
   "synthesis": "The on-scope sources agree. The SCCM PANDEM 2022 pediatric guideline governs and directly supports all three elements of the statement: light, goal-directed sedation (assign and target a validated sedation depth), minimizing benzodiazepine-based sedation, and preferring alpha2-agonists/dexmedetomidine as the primary sedative class; Mody 2018 independently supplies causal dose-response evidence for benzodiazepine minimization in critically ill children, and Curley 2006 grounds the SBS -1 to 0 scale used as the pediatric light-sedation target (RASS, from the adult-derived Sessler 2002, is the adult analog). The CAPD/psCAM/pCAM-ICU screening-tool papers (Traube 2014, Gupta 2021, Smith 2011, Smith 2016) share keywords (sedation, RASS, SBS, benzodiazepines) but are a different intervention - delirium monitoring (the 'D' element), not sedation choice - and must not be read as direct support.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r33",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "7",
   "section": "Prevention bundle (ABCDEF)",
   "statement": "D — Delirium: assess, prevent & manage: Screen at least each shift with CAPD or pCAM/psCAM; address precipitants.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 4, ¶3",
   "passage": "4) We suggest that sedation and analgesia should be adequate to prevent awareness prior to and throughout NMBA use. Conditional Low 5) We recommend routine use of passive eyelid closure and eye lubrication for the prevention of corneal abrasions in critically ill pediatric patients receiving NMBAs. Strong Moderate ICU delirium 1) We recommend use of the preschool and pediatric Confusion Assessment Methods for the ICU or the Cornell Assessment for Pediatric Delirium as the most valid and reliable delirium monitoring tools in critically ill pediatric patients. Strong High 2) We recommend routine screening for ICU delirium using a validated tool in critically ill pediatric patients upon admission through ICU discharge or transfer. Strong High 3) Given low patient risk, and possible patient benefit to reduce the incidence and/or decrease duration or severity of delirium we suggest the following non-pharmacologic strategies: optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct-patient care. Conditional Low 4) We suggest performing EM, when feasible, to reduce the development of delirium. …\nPANDEM 2022 also recommends routine screening with a validated tool from admission through ICU discharge or transfer, and addressing precipitants (p. 16). The 'at least each shift' frequency is not stated by PANDEM; twice-daily (per-shift) screening comes from the CAPD user guide.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Validates the Richmond Agitation-Sedation Scale in adult ICU patients; cited by section/DOI as the arousal scale that gates pCAM-ICU/psCAM-ICU/CAPD delirium screening (a patient too deeply sedated cannot be screened) — supporting context, not direct evidence for pediatric delirium screening.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "background",
     "note": "The State Behavioral Scale is a sedation/arousal instrument, not a delirium tool; it is the nearest-match assessment scale cited as the arousal gate that precedes delirium scoring in the pediatric card set (used in place of RASS), so it is a different construct from the claim.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "State Behavioral Scale (SBS) A Sedation Assessment Instrument for Infants and Young Children Supported on Mechanical Ventilation Martha A.Q.",
       "highlight": "A Sedation Assessment Instrument",
       "scope": "different-intervention",
       "note": "Title identifies SBS as a sedation assessment tool — a different construct than delirium screening.",
       "page": "107",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      },
      {
       "context": "Objective--To develop and test the reliability and validity of the State Behavioral Scale (SBS) for use in describing sedation/agitation levels in young intubated patients supported on mechanical ventilation.",
       "highlight": "for use in describing sedation/agitation levels in young intubated patients supported on mechanical ventilation",
       "scope": "different-intervention",
       "note": "Objective confirms SBS measures the sedation-agitation continuum, not delirium; relevant only as the arousal assessment performed before CAPD/psCAM scoring.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope: validates CAPD as a rapid observational PICU delirium screen and explicitly recommends performing it at least twice daily, once per shift nurse — the source of the claim's 'at least each shift' frequency.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Cornell Assessment of Pediatric Delirium: A Valid, Rapid, Observational Tool for Screening Delirium in the PICU* Chani Traube, MD1, Gabrielle Silver, MD2, Julia Kearney, MD3, Anita Patel, MD4, Thomas M.",
       "highlight": "A Valid, Rapid, Observational Tool for Screening Delirium in the PICU",
       "scope": "on-scope",
       "note": "Directly validates CAPD as a delirium screening tool in the PICU — the 'CAPD' named in the claim.",
       "page": "656",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "For study purposes, the CAPD and psychiatric evaluations happened during the daylight hours, at approximately noon each day. To more accurately capture delirious patients, who may be more symptomatic at night, the CAPD will need to be performed a minimum of twice daily, once by each shift nurse.",
       "highlight": "the CAPD will need to be performed a minimum of twice daily, once by each shift nurse",
       "scope": "on-scope",
       "note": "Directly supports the 'screen at least each shift' frequency in the statement.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "With a sensitivity of 94.1%, the CAPD produced three false negatives out of 248 assessments. Of these (Table 3), two of the three children screened positive on a prior or subsequent CAPD. By performing the screen twice daily, these subjects would have been detected. Because one of these children had significant developmental delay, and the other a preexisting psychiatric illness, it is possible that these factors complicated the nursing assessment. The third screen may not have been performed accurately as it conflicts with the psychiatric assessment in many item responses. Larger studies are needed to further assess factors that confound detection of delirium.",
       "highlight": "By performing the screen twice daily, these subjects would have been detected",
       "scope": "on-scope",
       "note": "Reinforces twice-daily/per-shift screening to avoid missing fluctuating delirium.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "Conclusions--With an overall prevalence rate of 20.6% in our study population, delirium is a common problem in pediatric critical care. The Cornell Assessment of Pediatric Delirium is a valid, rapid, observational nursing screen that is urgently needed for the detection of delirium in PICU settings.",
       "highlight": "a valid, rapid, observational nursing screen that is urgently needed for the detection of delirium in PICU settings",
       "scope": "on-scope",
       "note": "Conclusion affirming CAPD as a valid PICU delirium screen.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "partial",
     "note": "Nearest-match different population: evaluates CAPD only in mechanically ventilated/sedated children. It confirms twice-a-day per-shift CAPD screening and addressing the underlying trigger (on-scope), but reports poor specificity in this subgroup (44.8% overall; 16.5% with developmental delay) — a subgroup caveat, not a contradiction.",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "CAPD scale was used to screen all study patients by the bedside nurses twice a day during their shifts (4 a.m. and 4 p. m.). Our PICU uses the State Behavioral Scale (SBS) for monitoring sedation every 4 hours, so the CAPD scale was modified to replace the Richmond Agitation Sedation Scale (RASS) with SBS.1 RASS scores of 4 and 5 are considered equivalent to SBS scores of 2 and 3; thus, on our CAPD scale, if SBS was 2 or 3 prior to CAPD scoring, we did not proceed with scoring.13 Our clinical child life specialist interviewed all study patients' parents/guardians to determine baseline developmental age to determine presence or absence of developmental delay.",
       "highlight": "screen all study patients by the bedside nurses twice a day during their shifts",
       "scope": "on-scope",
       "note": "Operationalizes CAPD screening twice a day per shift (4 a.m./4 p.m.), supporting the each-shift frequency.",
       "page": "25",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      },
      {
       "context": "Although primarily used as a screening tool, there is a possibility that the scores from these tests might bias a physician's judgment, especially if there is an unawareness among the physician regarding the difference in the accuracy of this test in children with developmental delay. Treatment of delirium mainly consists of environmental modifications and addressing the underlying trigger but, in refractory cases, may include use of antipsychotic medications such as risperidone and haloperidol, which have side effects such as QTc prolongation. Prescribing antipsychotic medication for children with developmental delay who are falsely diagnosed with delirium using the CAPD scale could potentially be harmful with no added benefit.",
       "highlight": "Treatment of delirium mainly consists of environmental modifications and addressing the underlying trigger",
       "scope": "on-scope",
       "note": "Supports the 'address precipitants' element (address the underlying trigger).",
       "page": "28",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      },
      {
       "context": "Overall, CAPD score ! 9 had sensitivity of 81.8% and specificity of 44.8%.",
       "highlight": "had sensitivity of 81.8% and specificity of 44.8%",
       "scope": "narrower",
       "note": "Different-scope caveat: at CAPD >=9 in ventilated/sedated children overall specificity is only 44.8% (16.5% with developmental delay), qualifying CAPD use in this subgroup.",
       "page": "24",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      },
      {
       "context": "This study shows that the CAPD may perform suboptimally in mechanically ventilated and sedated children. On the basis of nursing and physician feedback we received after implementing the scale, various limitations of the scale's applicability were evident, especially in patients with developmental Table 2 Sensitivity, specificity, and predictive values of CAPD scale assessments compared with clinical assessment by physician based on development Characteristics Prevalence of delirium, n (%) Sensitivity of CAPD scale, % Specificity of CAPD scale, % PPV of CAPD scale, % NPV of CAPD scale, % Overall (n 837 assessments) 159 (19) 81.8 44.8 25.8 91.3 Developmentally delayed, n 328 (39.2%) 43 (13.1) 95.3 16.5 14.7 95.9 Typically developed, n 509 (60.8%) 116 (22.8) 76.7 65.4 39.6 90.5 Abbreviations: CAPD, Cornell Assessment of Pediatric Delirium; NPV, negative predictive value; PPV, positive predictive value.",
       "highlight": "the CAPD may perform suboptimally in mechanically ventilated and sedated children",
       "scope": "narrower",
       "note": "Nearest-match narrower-population conclusion: CAPD may underperform in the MV/sedated subgroup, not overturning the general recommendation.",
       "page": "27",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Original validation of the pCAM-ICU in critically ill children >5 years; cited by section/DOI as the 'pCAM' tool named in the statement, but the full text is unarchived here so no passage can be quoted.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope: validates the psCAM-ICU as a valid, reliable delirium monitoring tool for infants and preschool-aged children (<5 years) — supporting the 'psCAM' option in the claim and extending screening to the youngest patients.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "The Preschool Confusion Assessment Method for the ICU (psCAM-ICU): Valid and Reliable Delirium Monitoring for Critically Ill Infants and Children Heidi A.B.",
       "highlight": "Valid and Reliable Delirium Monitoring for Critically Ill Infants and Children",
       "scope": "on-scope",
       "note": "Validates psCAM-ICU for delirium monitoring in infants/preschoolers — the 'psCAM' named in the claim.",
       "page": "592",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "CONCLUSIONS--The psCAM-ICU is a highly valid and reliable delirium instrument for critically ill infants and preschool-aged children, in whom delirium is extremely prevalent.",
       "highlight": "The psCAM-ICU is a highly valid and reliable delirium instrument for critically ill infants and preschool-aged children",
       "scope": "on-scope",
       "note": "Abstract conclusion affirming psCAM-ICU validity/reliability.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "This study demonstrates that delirium monitoring using the psCAM-ICU is highly valid and reliable in critically ill infants and preschool-aged children. The long-form (research) psCAM-ICU demonstrated a high specificity (91%), sensitivity (75%), NPV (86%), and PPV (84%) compared to the reference standard. In post-hoc analysis, the short-form (clinical) psCAM-ICU, with fewer required assessment components for Features 2 and 4, demonstrated improved sensitivity (78%) and maintained a high specificity (86%), taking less than 2 minutes to complete. Additionally, the psCAM-ICU demonstrated excellent reliability with a kappa statistic of 0.79. Both the adult and pediatric ICU landscapes now have access to different lines of evidence-based practices by which to measure ICU delirium, one being a brief \"in the moment\" assessment (psCAM-ICU, pCAM-ICU, CAMICU) (6) (9) and the other being performed over a nursing shift (CAPD, ICDCS) (8) (22).",
       "highlight": "delirium monitoring using the psCAM-ICU is highly valid and reliable in critically ill infants and preschool-aged children",
       "scope": "on-scope",
       "note": "Discussion restating validity across the <5-year age range.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "This study demonstrates that delirium monitoring using the psCAM-ICU is highly valid and reliable in critically ill infants and preschool-aged children. The long-form (research) psCAM-ICU demonstrated a high specificity (91%), sensitivity (75%), NPV (86%), and PPV (84%) compared to the reference standard. In post-hoc analysis, the short-form (clinical) psCAM-ICU, with fewer required assessment components for Features 2 and 4, demonstrated improved sensitivity (78%) and maintained a high specificity (86%), taking less than 2 minutes to complete. Additionally, the psCAM-ICU demonstrated excellent reliability with a kappa statistic of 0.79. Both the adult and pediatric ICU landscapes now have access to different lines of evidence-based practices by which to measure ICU delirium, one being a brief \"in the moment\" assessment (psCAM-ICU, pCAM-ICU, CAMICU) (6) (9) and the other being performed over a nursing shift (CAPD, ICDCS) (8) (22).",
       "highlight": "performed over a nursing shift (CAPD, ICDCS)",
       "scope": "background",
       "note": "Distinguishes CAPD (scored over a nursing shift) from the psCAM-ICU/pCAM-ICU 'in the moment' assessment — background on how the per-shift screening is applied.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governing on-scope source (primary anchor, Table 1, p. e77): strong, high-level-evidence recommendation to use ps/pCAM-ICU or CAPD and to routinely screen from admission through ICU discharge, and to identify/modify precipitants (BRAIN MAPS).",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "1) We recommend use of the preschool and pediatric Confusion Assessment Methods for the ICU or the Cornell Assessment for Pediatric Delirium as the most valid and reliable delirium monitoring tools in critically ill pediatric patients.",
       "highlight": "We recommend use of the preschool and pediatric Confusion Assessment Methods for the ICU or the Cornell Assessment for Pediatric Delirium as the most valid and reliable delirium monitoring tools in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "Table 1 recommendation naming ps/pCAM-ICU or CAPD as the delirium monitoring tools — the primary anchor for 'screen with CAPD or pCAM/psCAM'.",
       "page": "e77",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "2) W e recommend routine screening for ICU delirium using a validated tool in critically ill pediatric patients upon admission through ICU discharge or transfer.",
       "highlight": "routine screening for ICU delirium using a validated tool in critically ill pediatric patients upon admission through ICU discharge or transfer",
       "scope": "on-scope",
       "note": "Recommendation for routine screening throughout the ICU stay; supports the 'screen ... at least each shift' directive, though PANDEM specifies the span rather than a shift interval.",
       "page": "e77",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "\"We recommend\" use of the preschool and pCAM-ICU (ps/pCAM-ICU) or the CAPD as the most valid and reliable delirium monitoring tools in critically ill pediatric patients (strong, high-level evidence).",
       "highlight": "the preschool and pCAM-ICU (ps/pCAM-ICU) or the CAPD as the most valid and reliable delirium monitoring tools",
       "scope": "on-scope",
       "note": "Strong, high-level-evidence recommendation of the ps/pCAM-ICU or CAPD as the delirium screening tools.",
       "page": "e87",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Rationale: The care of critically ill pediatric patients is complicated and requires the collaboration and effectiveness of an interdisciplinary team. Routine monitoring in the ICU incorporates multiple organ/system surveillance supporting the acute management of ongoing organ dysfunction. Therefore, the recommendation for the implementation of routine monitoring for acute brain dysfunction considers the availability of valid and efficient bedside tools and the ability to identify and modify risk factors by which an opportunity is created to reduce prevalence, morbidity, and mortality associated with delirium. With the availability of validated screening tools (see above), delirium monitoring in the PICU is feasible (152, 224-227, 229, 242). We now recognize that ICU delirium is highly prevalent among critically ill children, with predominance of the hypoactive subtype which is most easily missed without routine screening. The goal of delirium monitoring is ultimately to implement patient care strategies to diminish its occurrence rate and effect on clinical outcomes such as mortality and further understand the role of acute brain dysfunction on the quality of life for pediatric survivors of critical illness.",
       "highlight": "the ability to identify and modify risk factors",
       "scope": "on-scope",
       "note": "Ties routine delirium monitoring to identifying and modifying risk factors — supports the 'address precipitants' element.",
       "page": "e88",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Differential diagnoses should be considered using a model such as Bring oxygen, Remove/ Reduce deliriogenic drugs, patient Atmosphere, Immobilization, New organ dysfunction, Metabolic disturbances, Awake, Pain, Sedation (SDC Table 19, http://links.lww.com/PCC/B920) (247).",
       "highlight": "Differential diagnoses should be considered using a model such as Bring oxygen, Remove/ Reduce deliriogenic drugs, patient Atmosphere, Immobilization, New organ dysfunction, Metabolic disturbances, Awake, Pain, Sedation",
       "scope": "on-scope",
       "note": "BRAIN MAPS framework for identifying/treating delirium precipitants — directly supports 'address precipitants'.",
       "page": "e88",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Delirium is highly prevalent (reported rates up to 80%) across the spectrum of disease states in the PICU and its development should be considered a possibility in all critically ill pediatric patients (113, 152, 221-236). Multiple studies have determined key risk factors for ICU delirium in pediatric patients. \"Predisposing risk factors\" for delirium include younger age, neurodevelopmental delay, poor nutritional status, and cyanotic heart disease. \"Precipitating risk factors\" include benzodiazepine exposure, coma and deep sedation, requirement for invasive MV, and prolonged cardiopulmonary bypass time (113, 151, 152, 221, 222, 226, 234, 237-239) (SDC Section E1, Table 16, http://links.lww.",
       "highlight": "\"Precipitating risk factors\" include benzodiazepine exposure, coma and deep sedation",
       "scope": "on-scope",
       "note": "Enumerates precipitating risk factors clinicians should address.",
       "page": "e87",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope for the 'address precipitants' element: identifies benzodiazepines as an independent, dose-dependent, modifiable precipitant of pediatric delirium (cohort screened daily with CAPD), supporting benzodiazepine-sparing sedation.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "Benzodiazepines are an independent and modifiable risk factor for development of delirium in critically ill children, even after carefully controlling for time-dependent covariates, with a dose-response effect. This temporal relationship suggests causality between benzodiazepine exposure and pediatric delirium and supports limiting the use of benzodiazepines in critically ill children.",
       "highlight": "Benzodiazepines are an independent and modifiable risk factor for development of delirium in critically ill children",
       "scope": "on-scope",
       "note": "Establishes benzodiazepines as a modifiable precipitant — a concrete target for 'address precipitants'.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      },
      {
       "context": "Conclusions--Benzodiazepines are an independent and modifiable risk factor for development of delirium in critically ill children, even after carefully controlling for time-dependent covariates, with a dose-response effect. This temporal relationship suggests causality between benzodiazepine exposure and pediatric delirium and supports limiting the use of benzodiazepines in critically ill children.",
       "highlight": "supports limiting the use of benzodiazepines in critically ill children",
       "scope": "on-scope",
       "note": "Concludes that a modifiable precipitant (benzodiazepines) should be limited.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      },
      {
       "context": "Delirium in critical illness has been linked to increased morbidity, mortality, and long term cognitive impairment(1-3). The pathophysiology of delirium remains incompletely understood, and involves a complex interplay between predisposing and precipitating influences(4). It is important to identify strategies to prevent delirium by focusing on specific modifiable risk factors. There is published evidence in the adult critical care literature establishing that sedatives -- particularly benzodiazepines -- contribute to the development of delirium(5-7). However, such evidence is lacking in the pediatric intensive care unit (PICU) population and benzodiazepines remain a first-line therapy for sedation in most PICUs(8). This represents a possible modifiable risk factor, as there are alternative sedative medications (albeit with other potential side effects) available for use in PICU patients(9).",
       "highlight": "focusing on specific modifiable risk factors",
       "scope": "on-scope",
       "note": "Reinforces the prevent/address-precipitants directive.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      },
      {
       "context": "Our study was conducted with approval from the Institutional Review Board at New York Presbyterian Hospital - Weill Cornell Medical Center. All patients admitted consecutively to our academic, urban, tertiary care PICU from January 2015 through June 2015 were included. This group is a part of a larger cohort of children included in a 12-month dataset. Children were prospectively screened for delirium each day throughout their PICU stay using the Cornell Assessment for Pediatric Delirium (CAPD). Each child was assigned a daily cognitive status of: delirium, coma, or normal (i.e.: delirium-free and coma-free (DFCF)). A status of `delirium' was defined as a positive CAPD screen with diagnosis confirmed by the treating physician. A status of `coma' was defined as being unarousable to verbal stimulation. A status of `normal' was defined as a negative CAPD screen. This cohort was included in a prior publication describing the epidemiology and outcomes of pediatric delirium(11).",
       "highlight": "prospectively screened for delirium each day throughout their PICU stay using the Cornell Assessment for Pediatric Delirium",
       "scope": "on-scope",
       "note": "Demonstrates routine daily CAPD screening throughout the PICU stay, consistent with the screening element (daily rather than each-shift frequency).",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    }
   ],
   "synthesis": "The governing on-scope source is the 2022 SCCM PANDEM guideline (Table 1, p. e77), which recommends the ps/pCAM-ICU or CAPD as the most valid and reliable delirium monitoring tools, routine screening from ICU admission through discharge, and identifying/modifying precipitants (BRAIN MAPS) — covering both halves of the claim; the tool-validation papers agree (Traube 2014 for CAPD, Smith 2016 for the psCAM-ICU, with Smith 2011/pCAM-ICU cited but unarchived), and Traube 2014 is the specific source of the \"at least each shift\" frequency (\"a minimum of twice daily, once by each shift nurse\"), which PANDEM itself does not quantify, while Mody 2018 supports \"address precipitants\" by identifying benzodiazepines as a modifiable precipitant. Two nearest-match sources differ in scope and drive the discrepancy: Gupta 2021 evaluates CAPD only in mechanically ventilated/sedated children and reports poor specificity (44.8% overall; 16.5% with developmental delay), a subgroup caveat rather than a contradiction, and Curley 2006 validates the State Behavioral Scale, a sedation/arousal instrument (not a delirium tool) that serves only as the arousal gate before delirium scoring.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r34",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "7",
   "section": "Prevention bundle (ABCDEF)",
   "statement": "E — Early mobility & exercise: Developmentally appropriate (passive ROM → active play → sit → stand → ambulate); involve PT/OT/child-life.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 4, ¶3",
   "passage": "… Strong High 2) We recommend routine screening for ICU delirium using a validated tool in critically ill pediatric patients upon admission through ICU discharge or transfer. Strong High 3) Given low patient risk, and possible patient benefit to reduce the incidence and/or decrease duration or severity of delirium we suggest the following non-pharmacologic strategies: optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct-patient care. Conditional Low 4) We suggest performing EM, when feasible, to reduce the development of delirium. Conditional Low 5) We recommend minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients to decrease incidence and/or duration or severity of delirium. Strong Moderate (Continued) TABLE 1. (Continued). Summary of Recommendations Recommendations Strength of Recommendation Quality of Evidence\nPANDEM 2022 supports early mobilization both to reduce delirium and to minimize the effects of immobility; the developmental progression from passive range of motion to ambulation is a pediatric elaboration not specified in the guideline.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "RASS is the arousal scale underpinning readiness/sedation assessment in the pediatric bundle; cited as the RASS source, not for early-mobility content (no archived file).",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "SBS is a sedation-agitation assessment tool; it does not address early mobility as an intervention. The nearest passage is a different-scope keyword match about scale-item age-appropriateness.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Operational definitions included the following: Sedation, a calm tranquil state that allays anxiety and excitement; Agitation, excitement accompanied by increased motor activity; Attention, the ability to open eyes and notice surroundings; Response, the ability to open eyes, or raise eyebrows, or turn head toward stimulus or move limbs; Distress, sudden increase in heart rate or blood pressure, and or a decrease in SpO2, or increase in movement. The 0-10 Numeric Rating Scale (NRS) with 0 equal to \"extremely sedated\" and 10 equal to \"extremely agitated\" served as a reference standard. We did not include changes in heart rate and blood pressure as distinct dimensions in the state behavioral assessment because of consistently low sensitivity and specificity in predicting agitation. [21,24,29] We also did not include the patient's ability to communicate, follow commands, or attempts to sit or climb out of bed because these items are not consistently developmentally appropriate across the 6 week to 6 year age group.",
       "highlight": "attempts to sit or climb out of bed",
       "scope": "different-intervention",
       "note": "Keyword overlap only: 'sit/climb out of bed' and 'developmentally appropriate' here describe why those items were EXCLUDED from a sedation-agitation scale, not an early-mobility progression.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD is a delirium screening tool; its developmental anchor descriptors share movement/play keywords with the mobility claim but describe observation for scoring, a different scope.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": []
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD performance study; does not address early mobility. 'Physical and Occupational Therapy' appears only as an author affiliation and 'child life' only as a developmental-assessment methods detail.",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "Our clinical child life specialist interviewed all study patients' parents/guardians to determine baseline developmental age to determine presence or absence of developmental delay.",
       "highlight": "clinical child life specialist",
       "scope": "different-intervention",
       "note": "Keyword overlap only: the 'child life specialist' here interviewed parents to assess developmental age for the CAPD study, not to deliver early-mobility/child-life support.",
       "page": "",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU delirium-tool validation; cited for the bundle's delirium-screening element, not for early mobility (no archived file).",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "psCAM-ICU delirium-tool validation; the file contains no early-mobility, PT/OT, child-life, or exercise content.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": []
    },
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governing on-scope source: recommends early mobility, a standardized developmentally-appropriate/progressive EM protocol via the multidisciplinary team, and identifies PT/OT as EM-relevant. The exact staged progression is an operationalization of its general wording; child-life for EM is not a PANDEM recommendation.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "5) We suggest the use of a standardized EM protocol that outlines readiness criteria, contraindications, developmentally appropriate mobility activities and goals, and safety thresholds guided by the multidisciplinary team and family decision-making.",
       "highlight": "developmentally appropriate mobility activities and goals, and safety thresholds guided by the multidisciplinary team and family decision-making",
       "scope": "on-scope",
       "note": "Directly supports the card's 'developmentally appropriate' framing and multidisciplinary/team involvement for early mobility.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "\"We suggest\" performing EM to minimize the effects of immobility in critically ill pediatric patients (conditional, low-level evidence).",
       "highlight": "performing EM to minimize the effects of immobility in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "Core PANDEM recommendation to perform early mobility (EM) in critically ill children — the E element of the bundle.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Rationale: Strategies to promote the success of a PICU EM program are primarily based on observational studies (224, 321, 346-348). The implementation of an EM program in these single-center PICUs demonstrated a significant increase in early rehabilitation consults and frequency of EM in critically ill children without increased adverse events. These studies all describe the use of a standardized multicomponent EM protocol that included multidisciplinary daily screening for appropriateness, progressive levels of mobility activities, and variables to monitor for safety and tolerance of the activity (SDC Section H3, http://links.lww. com/PCC/B920).",
       "highlight": "progressive levels of mobility activities",
       "scope": "on-scope",
       "note": "Supports the graded/progressive nature of the card's passive-ROM-to-ambulate sequence; PANDEM uses the general phrase 'progressive levels' rather than the specific stages.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "apply to all critically ill pediatric patients, the taskforce understands that not all critically ill pediatric populations are the same, and although we endeavored to qualify where recommendations may not be relevant for certain populations, we may not foresee all possible nuances for where certain recommendations may not be relevant, either due to patient needs or local resource availability. In retrospect, as some of the questions these guidelines sought to address apply directly to patients and their families, we did not solicit advice from patients and/or the families of critically ill children. We would suggest that this be a consideration made when the time comes for these guidelines to be updated. In similar fashion, we did not solicit input from other ancillary members of the critical care team for questions which might be directly relevant to them, including physical and occupational therapists for EM-related issues and bedside registered nurses (RNs) (although all advanced practice RN members on the taskforce had bedside experience and brought this to the discussion as well).",
       "highlight": "physical and occupational therapists for EM-related issues",
       "scope": "on-scope",
       "note": "Names PT/OT as the disciplines relevant to early mobility (supports 'involve PT/OT'); appears in the limitations noting their input was not solicited.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "ration of MV and LOS), and long-term cognitive and psychologic outcomes. 2) Describe risks associated with parental involvement and best practice for communication and empowerment. 3) The impact of child life/expressive therapies on environmental comfort in critically ill children. 4) The impact of improved sleep hygiene on outcomes (delirium, length of MV, sedation/opioid exposure, LOS, neurocogni- tive recovery).",
       "highlight": "child life/expressive therapies on environmental comfort",
       "scope": "different-intervention",
       "note": "The card lists child-life under early mobility, but PANDEM mentions child life only as a future-research question on ENVIRONMENTAL comfort, not as an EM component.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "background",
     "note": "Benzodiazepine-and-delirium study; addresses the A/S (sedation) elements. Its single 'mobilization' mention is a broader conceptual link, not direct support for the E-element progression or PT/OT/child-life involvement.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "Another important point to note is that opiate exposure was not independently associated with delirium. This may support the use of an `analgo-sedation' approach in critically ill children. Endorsed by the Society of (SCCM) for use in adults, analgosedation recommends an analgesic-first approach to critically ill patients, with optimization of pain control (utilizing both non-opioid and opioid analgesics, and taking advantage of the sedative side effects of the opiates), with minimization of additional sedation(1,21-23). Less sedation should improve recognition of pain, and optimize pain management. With better pain control, there is less need for sedation. With less sedation, there is less delirium and more opportunity for mobilization and weaning of mechanical ventilation. This paradigm shift has proven to be quite effective in changing the landscape in adult critical care(24,25). It is our hope that as similar data emerge in critically ill children, a comparable culture shift will take place(26).",
       "highlight": "more opportunity for mobilization and weaning of mechanical ventilation",
       "scope": "broader",
       "note": "Bundle-level link only: frames 'mobilization' as a downstream benefit of an analgosedation/less-sedation approach, not support for the developmental early-mobility progression itself.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    }
   ],
   "synthesis": "SCCM PANDEM 2022 is the only on-scope source and governs this card: it recommends performing early mobility to minimize immobility and using a standardized EM protocol with \"developmentally appropriate mobility activities\" and \"progressive levels of mobility activities\" guided by the multidisciplinary team, and it names physical and occupational therapists as the EM-relevant disciplines — supporting the developmentally-graded progression and PT/OT involvement, though the specific step sequence (passive ROM to active play to sit to stand to ambulate) operationalizes the guideline's general \"developmentally appropriate/progressive\" language rather than appearing verbatim, and child life appears in PANDEM only as a research question on environmental comfort, not as an EM component. The remaining sources are delirium/sedation assessment tools (SBS, CAPD, psCAM-ICU) and a benzodiazepine study that do not address early mobility as an intervention; their \"sit/climb out of bed,\" \"play/crawl or walk,\" \"child life,\" and \"mobilization\" wording is different-scope keyword overlap (scale item design, developmental anchor points, developmental-age assessment, and an analgosedation downstream benefit), not direct support.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r35",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "7",
   "section": "Prevention bundle (ABCDEF)",
   "statement": "F — Family engagement & empowerment: Caregiver presence, comfort, familiar voice/objects; educate families to recognize delirium.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 5, ¶4",
   "passage": "7) We suggest use of a standardized protocol for sedation/analgesia weaning to decrease duration of sedation taper and attenuate emergence of IWS. Conditional Low Optimizing environment 1) We suggest facilitation of parental or caregiver presence in the PICU during routine care and interventional procedures to a) provide comfort to the child, b) decrease parental levels of stress and anxiety and c) increase level of satisfaction of care. Conditional Low 2) We suggest offering patients the use of noise reducing devices such as ear plugs or headphones to reduce the impact of non-modifiable ambient noise (conditional, low-level evidence). Conditional Low 3) We suggest that PICU teams make environmental and/or behavioral changes to reduce excessive noise and therefore improve sleep hygiene and comfort, in critically ill pediatric patients. Conditional Low 4) We suggest performing EM to minimize the effects of immobility in critically ill pediatric patients. …\nPANDEM 2022 supports caregiver presence and family engagement, and notes that 'comforting objects from home' help reassure and reorient (p. 16). Educating families to recognize delirium is not explicitly stated.",
   "evidence": "Full text, p. 5",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary on-scope source: the 2022 pediatric guideline recommends family engagement and parental/caregiver presence for delirium prevention and notes familiar people/comforting objects help reorient patients.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "Family presence and involvement, familiar care team members, and comforting objects from home can also help reassure and reorient patients.",
       "highlight": "Family presence and involvement, familiar care team members, and comforting objects from home can also help reassure and reorient patients.",
       "scope": "on-scope",
       "note": "Directly supports the claim's 'familiar voice/objects' and comfort elements as delirium-prevention measures in critically ill children.",
       "page": "e88",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "3) Given low patient risk, and possible patient benefit to reduce the incidence and/or decrease duration or severity of delirium we suggest the following non-pharmacologic strategies: optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct-patient care.",
       "highlight": "family engagement on rounds, and family involvement with direct-patient care",
       "scope": "on-scope",
       "note": "Graded non-pharmacologic recommendation naming family engagement/involvement to reduce delirium incidence, severity, or duration.",
       "page": "e76",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "1) We suggest facilitation of parental or caregiver presence in the PICU during routine care and interventional procedures to a) provide comfort to the child, b) decrease parental levels of stress and anxiety and c) increase level of satisfaction of care.",
       "highlight": "facilitation of parental or caregiver presence in the PICU during routine care and interventional procedures to a) provide comfort to the child",
       "scope": "on-scope",
       "note": "Supports the claim's 'caregiver presence, comfort' element with a conditional recommendation.",
       "page": "e77",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "ration of MV and LOS), and long-term cognitive and psychologic outcomes. 2) Describe risks associated with parental involvement and best practice for communication and empowerment. 3) The impact of child life/expressive therapies on environmental comfort in critically ill children. 4) The impact of improved sleep hygiene on outcomes (delirium, length of MV, sedation/opioid exposure, LOS, neurocogni- tive recovery).",
       "highlight": "best practice for communication and empowerment",
       "scope": "background",
       "note": "Family communication/empowerment is listed as a research gap, so the claim's 'educate families to recognize delirium' is consistent with the guideline's direction but is not itself a graded recommendation.",
       "page": "e97",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "SBS validation study; the only caregiver-voice wording is part of the tool's consolability item, not a family-engagement intervention.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Although the ease with which the nurse evaluators rated each dimension was not systemically described, the overall experience of the raters was that the dimensions were clear and that completion of the behavioral assessment tool and NRS was easily accomplished in less than two minutes after the stimulation protocol was implemented. However, some dimensions may be more challenging to rate than others, for example, a patient may console differently to a nurse's voice/touch and to a known caregiver's voice/touch. The relatively low weighted kappa reported for consolability may also be in part due to a sensitivity of the kappa to the response distribution, which in the case of this item, was highly skewed. Over 95% of ratings by either rater consisted of \"self-regulates\" or \"able to calm; distractible,\" with only 4% giving a rating of \"does not consistently calm\" or \"unable to console.\" The actual concordance rate between raters for this item was moderately high, at 69% among all 198 ratings (79% among first ratings, 74% among randomly-selected single ratings), indicating inter-rater agreement comparable to the other dimensions.",
       "highlight": "a patient may console differently to a nurse's voice/touch and to a known caregiver's voice/touch",
       "scope": "different-intervention",
       "note": "Keyword overlap ('familiar voice', caregiver) but this describes inter-rater variability in scoring the State Behavioral Scale consolability dimension, not a prevention/family-engagement measure.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD validation study; 'familiar objects' appears only as a developmental anchor point inside the screening tool.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": []
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD performance study; parents are involved only to establish a developmental baseline for scoring.",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "CAPD scale was used to screen all study patients by the bedside nurses twice a day during their shifts (4 a.m. and 4 p. m.). Our PICU uses the State Behavioral Scale (SBS) for monitoring sedation every 4 hours, so the CAPD scale was modified to replace the Richmond Agitation Sedation Scale (RASS) with SBS.1 RASS scores of 4 and 5 are considered equivalent to SBS scores of 2 and 3; thus, on our CAPD scale, if SBS was 2 or 3 prior to CAPD scoring, we did not proceed with scoring.13 Our clinical child life specialist interviewed all study patients' parents/guardians to determine baseline developmental age to determine presence or absence of developmental delay.",
       "highlight": "interviewed all study patients' parents/guardians to determine baseline developmental age",
       "scope": "different-intervention",
       "note": "Parent/guardian involvement here is data collection for CAPD baseline anchoring, not family engagement as a delirium-prevention intervention.",
       "page": "",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "psCAM-ICU validation; 'parents/caregivers' appears only as a delirium diagnostic feature.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "Therefore, evidence of a disorganized brain (Feature 4), or the presence of dysregulated systems or behaviors was determined by the presence of at least two of the following components: 1) inconsolability, 2) unawareness of surroundings or parents/caregivers, and/or 3) a sleep-wake cycle disturbance.",
       "highlight": "unawareness of surroundings or parents/caregivers",
       "scope": "different-intervention",
       "note": "Keyword overlap but 'parents/caregivers' is a Feature 4 (disorganized brain) screening component, not a family-engagement prevention measure.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Benzodiazepine/delirium causal-effect study addressing the deliriogenic-medication (D) element; family engagement (F) not addressed.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "24. Ely EW. The ABCDEF Bundle: Science and Philosophy of How ICU Liberation Serves Patients and Families. Crit Care Med. 2017 Feb; 45(2):321-30. [PubMed: 28098628]",
       "highlight": "The ABCDEF Bundle: Science and Philosophy of How ICU Liberation Serves Patients and Families",
       "scope": "background",
       "note": "Only a reference-list citation naming the ABCDEF bundle; the study itself concerns benzodiazepines as a delirium risk factor, not the family-engagement element.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Archived source for the RASS sedation scale used throughout the pediatric card set; does not address family engagement.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited for the pCAM-ICU screening tool; unarchived and not about family engagement.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    }
   ],
   "synthesis": "SCCM PANDEM 2022 is the only on-scope source and it supports the claim: it recommends family engagement on rounds and in direct care, conditionally recommends facilitating parental/caregiver presence to provide comfort, and states that familiar care team members and comforting objects from home help reorient patients — so it governs and remains the current position. The 'educate families to recognize delirium' component is only partially anchored (the guideline lists family communication/empowerment as a research gap rather than a graded recommendation), and the screening-tool papers (Curley SBS, Traube CAPD, Gupta, Smith psCAM-ICU) and the benzodiazepine study (Mody) share keywords like caregiver voice, familiar objects, and parents/caregivers only inside tool items or citations, making them different-scope rather than support.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r36",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "7",
   "section": "Prevention measures",
   "statement": "Protect sleep / circadian rhythm — cluster night care, reduce noise and light, avoid sleep-fragmenting sedatives.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 16",
   "passage": "… 2) \"We suggest\" performing EM, when feasible, to reduce the development of delirium (conditional, low-level evidence) although data are insufficient to make a recommendation regarding the impact of this intervention on the duration or severity of delirium. Rationale: Environmental impact on the prevention of delirium has yet to be studied in a robust manner in children. Despite the limited data, implementation of environmental modifications such as maintaining day/ night cycles with the use of artificial light and sunlight during the day and healthy sleep conditions at night (minimizing noise, light, and stimulation) may impact the occurrence rate and severity of delirium in children (244-246). Interactive approaches such as cognitive stimulation and physical activity during the day may increase orientation during the day and quality sleep at night. Family presence and involvement, familiar care team members, and comforting objects from home can also help reassure and reorient patients. Studies in critically ill adults have shown decreased occurrence rate and duration of delirium with implementation of EM. A single-center prospective study indirectly supports potential effectiveness of this approach in children. …\nPANDEM 2022 supports maintaining day-night cycles and minimizing noise, light, and stimulation at night, with noise-reduction devices and behavioral changes addressed in the environment recommendations. 'Cluster night care' and 'avoid sleep-fragmenting sedatives' are not stated verbatim, though consistent with the guideline's sleep-hygiene optimization.",
   "evidence": "Full text, p. 16",
   "status": "fulltext",
   "pageNum": "16",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary source; issues the pediatric delirium-prevention recommendations that the card's sleep/circadian measure is built on.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "3) Given low patient risk, and possible patient benefit to reduce the incidence and/or decrease duration or severity of delirium we suggest the following non-pharmacologic strategies: optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct-patient care.",
       "highlight": "optimization of sleep hygiene",
       "scope": "on-scope",
       "note": "Formal nonpharmacologic delirium-prevention recommendation naming sleep-hygiene optimization for critically ill children.",
       "page": "e88",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Despite the limited data, implementation of environmental modifications such as maintaining day/ night cycles with the use of artificial light and sunlight during the day and healthy sleep conditions at night (minimizing noise, light, and stimulation) may impact the occurrence rate and severity of delirium in children (244-246).",
       "highlight": "maintaining day/ night cycles with the use of artificial light and sunlight during the day",
       "scope": "on-scope",
       "note": "Grounds the circadian/day-night cycling and reduce-noise-and-light components of the statement.",
       "page": "e88",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "3) We suggest that PICU teams make environmental and/or behavioral changes to reduce excessive noise and therefore improve sleep hygiene and comfort, in critically ill pediatric patients.",
       "highlight": "reduce excessive noise and therefore improve sleep hygiene and comfort, in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "Sleep-hygiene environment recommendation supporting the reduce-noise element of the measure.",
       "page": "e93",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "ICU factors disrupting sleep include patient-related factors such as presence of invasive devices, need for MV, immobility, medication effects, and inadequately controlled pain, as well as environmental factors such as ambient noise and light levels as well as the performance of frequent caregiver assessments (21, 23, 312, 313). Few pediatric studies have assessed environmental interventions effects on sleep and patient outcomes, but simple interventions may positively impact patients (SDC Section H, http://links. lww.com/PCC/B920).",
       "highlight": "the performance of frequent caregiver assessments",
       "scope": "on-scope",
       "note": "Identifies frequent caregiver assessments plus noise/light as sleep-disrupting factors, grounding the cluster-night-care and reduce-noise/light components.",
       "page": "e92",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "5) We recommend minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients to decrease incidence and/or duration or severity of delirium.",
       "highlight": "minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "Strong recommendation to minimize benzodiazepines, supporting the avoid-sleep-fragmenting-sedatives component (benzodiazepines being the canonical sleep-fragmenting class).",
       "page": "e76",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Reinforces one clause (avoid sedatives) by establishing benzodiazepines as a causal, dose-dependent, modifiable delirium risk in PICU children; does not address sleep hygiene, noise, or light, and its outcome is delirium rather than sleep fragmentation.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "Conclusions--Benzodiazepines are an independent and modifiable risk factor for development of delirium in critically ill children, even after carefully controlling for time-dependent covariates, with a dose-response effect. This temporal relationship suggests causality between benzodiazepine exposure and pediatric delirium and supports limiting the use of benzodiazepines in critically ill children.",
       "highlight": "supports limiting the use of benzodiazepines in critically ill children",
       "scope": "narrower",
       "note": "Directly backs the avoid-sedatives clause for the matching PICU population, but only that clause and via delirium-causation evidence, not sleep fragmentation.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      },
      {
       "context": "In this study, we have shown an independent, temporal, and dose-response relationship between benzodiazepine exposure and subsequent pediatric delirium. With alternate sedation choices available, this is an important and modifiable risk factor. Adoption of a benzodiazepine-sparing approach in the pediatric intensive care unit may decrease delirium rates and improve the care we provide to critically ill children.",
       "highlight": "Adoption of a benzodiazepine-sparing approach in the pediatric intensive care unit may decrease delirium rates",
       "scope": "narrower",
       "note": "Closing recommendation to spare benzodiazepines — supports the sedative-avoidance sub-point of the sleep-protection bundle.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "State Behavioral Scale is a sedation-agitation assessment instrument; it does not state the sleep/circadian-protection prevention measure.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Ensuring the comfort of critically ill infants and children is integral to the practice of pediatric critical care. Humane pediatric intensive care often includes the administration of sedatives, once pain, physiologic imbalance and environmental stressors have been addressed.[1] Over 90% of infants and children supported on mechanical ventilation receive some form of sedative therapy. [2] Sedation in this patient population is required for anxiolysis, amnesia, facilitation of care, patient safety in avoidance of adverse events and for decreasing oxygen consumption. For most young patients supported on mechanical ventilation, the goal of sedation is to attain a calm but responsive state [2,3] that protects the young patient from self-harm. Inadequate sedation is associated with potentially dangerous complications such as unplanned endotracheal extubation. [4] High-dose, long-term, and continuous intravenous sedation has been associated with prolonged weaning from mechanical ventilation and/or withdrawal syndrome. [5-7] Therefore, insufficient or excessive sedation is likely to add to the personal and financial burden of intensive care.",
       "highlight": "environmental stressors have been addressed",
       "scope": "different-intervention",
       "note": "Nearest topical mention — addressing environmental stressors before sedation — but this is a sedation-scale rationale, not a sleep-protection recommendation.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD is a delirium screening tool; it does not recommend sleep/circadian protection.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "For study purposes, the CAPD and psychiatric evaluations happened during the daylight hours, at approximately noon each day. To more accurately capture delirious patients, who may be more symptomatic at night, the CAPD will need to be performed a minimum of twice daily, once by each shift nurse.",
       "highlight": "may be more symptomatic at night",
       "scope": "different-intervention",
       "note": "The night reference concerns when to screen (delirium worse at night), a screening-timing point — shares the keyword but is not a sleep-protection measure.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "A CAPD specificity/performance study; it does not state the sleep-protection prevention measure.",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "Although primarily used as a screening tool, there is a possibility that the scores from these tests might bias a physician's judgment, especially if there is an unawareness among the physician regarding the difference in the accuracy of this test in children with developmental delay. Treatment of delirium mainly consists of environmental modifications and addressing the underlying trigger but, in refractory cases, may include use of antipsychotic medications such as risperidone and haloperidol, which have side effects such as QTc prolongation. Prescribing antipsychotic medication for children with developmental delay who are falsely diagnosed with delirium using the CAPD scale could potentially be harmful with no added benefit.",
       "highlight": "environmental modifications and addressing the underlying trigger",
       "scope": "broader",
       "note": "A passing mention of generic environmental modifications for delirium treatment — broader than, and different context (treatment vs prevention) from, the specific sleep/circadian measure.",
       "page": "",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "psCAM-ICU is a preschool delirium screening tool; it uses sleep-wake disturbance as a diagnostic feature, not as a sleep-protection intervention.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "Sleep wake cycle disturbances have been consistently associated with ICU delirium in both children and adults.",
       "highlight": "Sleep wake cycle disturbances have been consistently associated with ICU delirium",
       "scope": "different-intervention",
       "note": "Keyword-overlap trap: sleep-wake disturbance appears here as a delirium diagnostic feature (Feature 4), not as protecting sleep to prevent delirium.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Adult-ICU RASS validation; cited by the card set as the arousal/sedation scale underpinning delirium assessment, not as support for the sleep-protection measure.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU validation (Crit Care Med 2011;39(1):150-157); cited as the school-age delirium screening instrument, not the sleep-protection prevention measure.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    }
   ],
   "synthesis": "The primary source, the 2022 SCCM PANDEM pediatric guideline, directly and fully supports the statement: it recommends optimizing sleep hygiene and maintaining day/night cycles (minimizing noise, light, and stimulation), reducing excessive ambient noise, limiting sleep-disrupting frequent caregiver assessments, and minimizing benzodiazepine-based sedation, all as PICU delirium-prevention measures — so PANDEM governs and remains the current position. Mody 2018 narrowly reinforces only the \"avoid sedatives\" clause (benzodiazepines in PICU children, on delirium-causation grounds rather than sleep-fragmentation), while the screening-instrument papers (Curley SBS, Traube CAPD, Gupta, Smith psCAM, Sessler RASS, Smith pCAM) do not state this prevention measure — they touch sleep/environment only as a delirium diagnostic feature, a screening-timing note, or a general treatment aside, making them different-scope or background.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r37",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "7",
   "section": "Prevention measures",
   "statement": "Normalize day–night — daytime light and activity; dim, quiet nights; age-appropriate orientation.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 16",
   "passage": "… 2) \"We suggest\" performing EM, when feasible, to reduce the development of delirium (conditional, low-level evidence) although data are insufficient to make a recommendation regarding the impact of this intervention on the duration or severity of delirium. Rationale: Environmental impact on the prevention of delirium has yet to be studied in a robust manner in children. Despite the limited data, implementation of environmental modifications such as maintaining day/ night cycles with the use of artificial light and sunlight during the day and healthy sleep conditions at night (minimizing noise, light, and stimulation) may impact the occurrence rate and severity of delirium in children (244-246). Interactive approaches such as cognitive stimulation and physical activity during the day may increase orientation during the day and quality sleep at night. Family presence and involvement, familiar care team members, and comforting objects from home can also help reassure and reorient patients. Studies in critically ill adults have shown decreased occurrence rate and duration of delirium with implementation of EM. A single-center prospective study indirectly supports potential effectiveness of this approach in children. …",
   "evidence": "Full text, p. 16",
   "status": "fulltext",
   "pageNum": "16",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "RASS arousal-scale source cited elsewhere in the card set; no file and no content bearing on the day-night normalization prevention statement.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "The State Behavioral Scale is a sedation-agitation assessment instrument; it does not address day-night normalization, sleep-environment prevention, or reorientation, and is cited in the card set for arousal/sedation scoring only.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": []
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD validation paper; discusses orientation only as an assessment domain, not as a day-night prevention intervention.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Anchor Points--Orientation, arousal, and appropriate cognition (which are all affected in delirium) are difficult to assess in young children and even harder to measure in infants. Because of concerns about accurate screening in children under 2 years old, developmental anchor points were delineated. Based on classic texts and established scales of child development, each anchor point characterizes the normal developing child for each item on the CAPD (Table 1). Anchor points describe the associated observable behaviors in a PICU setting (rather than in the child's natural environment) (36, 37). After piloting with nurses for clarity of language and concepts, a short training session was done and anchor point charts were provided for reference to the approximately 100 critical care nurses who participated.",
       "highlight": "Orientation, arousal, and appropriate cognition (which are all affected in delirium) are difficult to assess in young children",
       "scope": "background",
       "note": "CAPD's 'orientation' is a cognitive domain screened via developmental (age-appropriate) anchor points, a keyword collision with the claim's 'age-appropriate orientation' prevention measure rather than support for it.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD performance study; its only environment mention is treatment of established delirium, not prevention.",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "Although primarily used as a screening tool, there is a possibility that the scores from these tests might bias a physician's judgment, especially if there is an unawareness among the physician regarding the difference in the accuracy of this test in children with developmental delay. Treatment of delirium mainly consists of environmental modifications and addressing the underlying trigger but, in refractory cases, may include use of antipsychotic medications such as risperidone and haloperidol, which have side effects such as QTc prolongation. Prescribing antipsychotic medication for children with developmental delay who are falsely diagnosed with delirium using the CAPD scale could potentially be harmful with no added benefit.",
       "highlight": "Treatment of delirium mainly consists of environmental modifications and addressing the underlying trigger",
       "scope": "background",
       "note": "Refers to environmental modifications as post-diagnosis delirium TREATMENT, not the day-night prevention measure the claim describes; keyword overlap only on 'environmental modifications'.",
       "page": "",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU validation source cited elsewhere for delirium screening; no file and no content on the prevention statement.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "psCAM-ICU validation paper; the sleep-wake reference is a screening feature, sharing the circadian keyword but a different scope.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "Sleep wake cycle disturbances have been consistently associated with ICU delirium in both children and adults.",
       "highlight": "Sleep wake cycle disturbances have been consistently associated with ICU delirium in both children and adults",
       "scope": "background",
       "note": "psCAM-ICU treats sleep-wake cycle disturbance as a diagnostic FEATURE of delirium (assessment), not as the day-night normalization prevention intervention the claim describes.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary source; PANDEM's environment/sleep-hygiene domain provides on-scope support for every element of the statement (day/night cycling, daytime light and activity, quiet dim nights, reorientation).",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "Despite the limited data, implementation of environmental modifications such as maintaining day/ night cycles with the use of artificial light and sunlight during the day and healthy sleep conditions at night (minimizing noise, light, and stimulation) may impact the occurrence rate and severity of delirium in children (244-246).",
       "highlight": "maintaining day/ night cycles with the use of artificial light and sunlight during the day and healthy sleep conditions at night (minimizing noise, light, and stimulation)",
       "scope": "on-scope",
       "note": "Directly supports 'normalize day-night, daytime light and activity, dim quiet nights' — day/night cycles with daytime light and quiet, low-stimulation night conditions.",
       "page": "e88-e89 (p. 16)",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Interactive approaches such as cognitive stimulation and physical activity during the day may increase orientation during the day and quality sleep at night. Family presence and involvement, familiar care team members, and comforting objects from home can also help reassure and reorient patients.",
       "highlight": "may increase orientation during the day and quality sleep at night. Family presence and involvement, familiar care team members, and comforting objects from home can also help reassure and reorient patients.",
       "scope": "on-scope",
       "note": "Supports 'age-appropriate orientation' and daytime activity — daytime cognitive stimulation/activity increases orientation, and familiar caregivers/comforting objects help reorient patients.",
       "page": "e88-e89 (p. 16)",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "3) Given low patient risk, and possible patient benefit to reduce the incidence and/or decrease duration or severity of delirium we suggest the following non-pharmacologic strategies: optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct-patient care.",
       "highlight": "we suggest the following non-pharmacologic strategies: optimization of sleep hygiene",
       "scope": "on-scope",
       "note": "The formal PANDEM recommendation this prevention card operationalizes: optimization of sleep hygiene as a non-pharmacologic strategy to reduce delirium incidence/severity.",
       "page": "e76-e77",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "1) \"We suggest\" that PICU teams make environmental and/ or behavioral changes to reduce excessive noise and therefore improve sleep hygiene and comfort, in critically ill pediatric patients (conditional, low-level evidence).",
       "highlight": "reduce excessive noise and therefore improve sleep hygiene and comfort, in critically ill pediatric patients",
       "scope": "narrower",
       "note": "Supports the 'quiet nights' component specifically — the noise-reduction sub-recommendation for improving sleep hygiene; narrower than the full day-night statement.",
       "page": "e94",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Benzodiazepine risk-factor study; a delirium-prevention paper cited for a different (pharmacologic) prevention measure, not day-night normalization.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "Delirium in critical illness has been linked to increased morbidity, mortality, and long term cognitive impairment(1-3). The pathophysiology of delirium remains incompletely understood, and involves a complex interplay between predisposing and precipitating influences(4). It is important to identify strategies to prevent delirium by focusing on specific modifiable risk factors. There is published evidence in the adult critical care literature establishing that sedatives -- particularly benzodiazepines -- contribute to the development of delirium(5-7). However, such evidence is lacking in the pediatric intensive care unit (PICU) population and benzodiazepines remain a first-line therapy for sedation in most PICUs(8). This represents a possible modifiable risk factor, as there are alternative sedative medications (albeit with other potential side effects) available for use in PICU patients(9).",
       "highlight": "It is important to identify strategies to prevent delirium by focusing on specific modifiable risk factors",
       "scope": "different-intervention",
       "note": "Same PICU population and same prevention goal, but the modifiable risk factor Mody targets is benzodiazepine sedation exposure (a pharmacologic intervention), not the environmental day-night normalization of the claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    }
   ],
   "synthesis": "The governing source is SCCM PANDEM 2022 (environment domain, ~p. 16/e88-e89): its rationale directly supports the claim, recommending maintenance of day/night cycles with daytime light and activity, healthy quiet/dim sleep conditions at night, and reorientation via cognitive stimulation, familiar caregivers, and comforting objects. The other bundled citations do not address this environmental prevention measure and only overlap by keyword in a different scope — the scale-validation papers (SBS, CAPD, Gupta, psCAM-ICU) use \"orientation\"/\"sleep-wake disturbance\" as delirium assessment constructs, Gupta's \"environmental modifications\" describe post-diagnosis treatment, and Mody's delirium-prevention strategy is a different (pharmacologic, benzodiazepine-reduction) intervention.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r38",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "7",
   "section": "Prevention measures",
   "statement": "Sensory aids & engagement — glasses, hearing aids; familiar comfort objects, music, play, child-life.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 16",
   "passage": "… Rationale: Environmental impact on the prevention of delirium has yet to be studied in a robust manner in children. Despite the limited data, implementation of environmental modifications such as maintaining day/ night cycles with the use of artificial light and sunlight during the day and healthy sleep conditions at night (minimizing noise, light, and stimulation) may impact the occurrence rate and severity of delirium in children (244-246). Interactive approaches such as cognitive stimulation and physical activity during the day may increase orientation during the day and quality sleep at night. Family presence and involvement, familiar care team members, and comforting objects from home can also help reassure and reorient patients. Studies in critically ill adults have shown decreased occurrence rate and duration of delirium with implementation of EM. A single-center prospective study indirectly supports potential effectiveness of this approach in children. Over a 22-month period, phased implementation of protocolized sedation followed by EM was associated with a near 40% reduction in delirium rates (224). Mitigation of delirium is often achieved by resolution of the underlying critical illness or other contributing medical conditions. Therefore, the initial steps in delirium management should focus on identification and treatment of these underlying etiologies (231, 239, 240, 247-249). …\nPANDEM 2022 supports familiar comfort objects and reorientation, recommends music for analgesia rather than delirium (p. 3), and names child-life and expressive therapies only as a research gap. Glasses and hearing aids are not addressed in any cited source; that element carries over from adult delirium practice.",
   "evidence": "Full text, p. 16 — partial support",
   "status": "fulltext",
   "pageNum": "16",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Cited as the source for the RASS arousal scale that gates pediatric delirium screening; contributes nothing to the sensory-aid/engagement prevention statement.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "State Behavioral Scale is a sedation-depth assessment tool; its only 'familiar' hit calls the progressive-stimulus exam approach familiar to clinicians, and it says nothing about sensory aids or engagement-based prevention.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": []
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "background",
     "note": "CAPD screening-tool validation; the comfort-object phrase is a scale anchor, not a prevention intervention, so it must not be read as support for the claim.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": []
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD performance study; its 'sensory' hits refer to patient sensory deficits (e.g., blindness) that degrade screening specificity and 'child life specialist' names a research assessor role — homonyms, not the sensory-aid or child-life engagement interventions in the claim.",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": []
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU validation cited in the pediatric card set's evidence base; does not address sensory aids or engagement-based prevention.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "psCAM-ICU validation study; its only non-pharmacologic mention is a study-period limitation (such therapy was infrequent at the time), not a prevention recommendation.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": []
    },
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Governs the claim: supports the comfort-object/family-engagement/reorientation content on p. 16, but does not mention glasses or hearing aids, and its music-therapy recommendation is for analgesia rather than delirium prevention — hence partial.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "Family presence and involvement, familiar care team members, and comforting objects from home can also help reassure and reorient patients.",
       "highlight": "Family presence and involvement, familiar care team members, and comforting objects from home can also help reassure and reorient patients.",
       "scope": "on-scope",
       "note": "Supports the engagement half of the claim — familiar comfort objects, family presence, and reorientation as nonpharmacologic pediatric delirium prevention (does not cover glasses/hearing aids).",
       "page": "e89 (p. 16)",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "3) Given low patient risk, and possible patient benefit to reduce the incidence and/or decrease duration or severity of delirium we suggest the following non-pharmacologic strategies: optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct-patient care.",
       "highlight": "optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement",
       "scope": "on-scope",
       "note": "The formal conditional recommendation for nonpharmacologic delirium prevention, grounding the 'engagement' portion of the statement.",
       "page": "e89 (p. 16)",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "\"We recommend\" that music therapy be offered to augment analgesia for critically ill postoperative pediatric patients (strong, moderate-level evidence).",
       "highlight": "music therapy be offered to augment analgesia for critically ill postoperative pediatric patients",
       "scope": "different-intervention",
       "note": "The claim lists music under engagement/prevention, but PANDEM recommends music therapy to augment analgesia (pain) — a different indication, not delirium prevention.",
       "page": "e82",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "ration of MV and LOS), and long-term cognitive and psychologic outcomes. 2) Describe risks associated with parental involvement and best practice for communication and empowerment. 3) The impact of child life/expressive therapies on environmental comfort in critically ill children. 4) The impact of improved sleep hygiene on outcomes (delirium, length of MV, sedation/opioid exposure, LOS, neurocogni- tive recovery).",
       "highlight": "child life/expressive therapies on environmental comfort in critically ill children",
       "scope": "background",
       "note": "Nearest 'child-life' match, but it appears as a listed evidence gap / future-research question, not as a recommendation supporting the claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Addresses a different prevention lever — minimizing benzodiazepines as a modifiable delirium risk factor — and does not mention sensory aids, comfort objects, music, play, or child-life engagement.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": []
    }
   ],
   "synthesis": "The primary anchor, SCCM PANDEM 2022 (p. 16 / e89), governs this claim and directly supports its engagement half — familiar comfort objects from home, family presence/involvement, and cognitive stimulation to reorient the child as low-risk nonpharmacologic delirium prevention — but it does not address the sensory-aid items (glasses, hearing aids) at all, and its music-therapy recommendation is for augmenting analgesia (pain), not delirium prevention. The remaining cited sources are screening/sedation-tool validations and a benzodiazepine risk-factor study that do not address this prevention measure; Traube 2014's \"comforted by familiar objects\" is a CAPD scoring anchor (a normal-behavior descriptor), not a prevention recommendation.",
   "discrepancy": true
  },
  {
   "id": "peds-cards-r39",
   "toolId": "peds-cards",
   "tool": "Pediatric Card Set",
   "page": "7",
   "section": "Prevention measures",
   "statement": "Minimize restraints & deliriogenic meds — deprescribe anticholinergics; reduce physical restraints.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Gupta 2021",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "SCCM PANDEM 2022",
    "Mody 2018"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 16",
   "passage": "… Studies in critically ill adults have shown decreased occurrence rate and duration of delirium with implementation of EM. A single-center prospective study indirectly supports potential effectiveness of this approach in children. Over a 22-month period, phased implementation of protocolized sedation followed by EM was associated with a near 40% reduction in delirium rates (224). Mitigation of delirium is often achieved by resolution of the underlying critical illness or other contributing medical conditions. Therefore, the initial steps in delirium management should focus on identification and treatment of these underlying etiologies (231, 239, 240, 247-249). Differential diagnoses should be considered using a model such as Bring oxygen, Remove/ Reduce deliriogenic drugs, patient Atmosphere, Immobilization, New organ dysfunction, Metabolic disturbances, Awake, Pain, Sedation (SDC Table 19, http://links.lww.com/PCC/B920) (247). Pharmacologic management of delirium Question: What \"pharmacologic\" sedation strategies reduce the incidence and/or decrease the duration or severity of delirium in critically ill pediatric patients? Answer: 1) \"We recommend\" minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients to\nAs at row 146, PANDEM 2022 supports reducing deliriogenic drugs but names neither anticholinergics nor physical restraints; restraint minimization is not sourced in any cited reference on this row.",
   "evidence": "Full text, p. 16 — partial support",
   "status": "fulltext",
   "pageNum": "16",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1055/s-0041-1728784",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://doi.org/10.1097/CCM.0000000000003194"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Primary anchor (p. 16 = e89): supports the 'minimize deliriogenic meds' core but the cited main text names neither anticholinergics nor physical restraints (those live in the supplement / other sources).",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "Differential diagnoses should be considered using a model such as Bring oxygen, Remove/ Reduce deliriogenic drugs, patient Atmosphere, Immobilization, New organ dysfunction, Metabolic disturbances, Awake, Pain, Sedation (SDC Table 19, http://links.lww.com/PCC/B920) (247).",
       "highlight": "Remove/ Reduce deliriogenic drugs",
       "scope": "on-scope",
       "note": "The BRAIN MAPS model for pediatric delirium directs clinicians to remove/reduce deliriogenic drugs — the core of the claim's 'minimize deliriogenic meds'.",
       "page": "e89",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "We recommend minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients to decrease incidence and/or duration or severity of delirium.",
       "highlight": "minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "Strong recommendation to minimize benzodiazepines (a deliriogenic class) for delirium prevention — a partial match to the card's broader 'minimize restraints & deliriogenic meds'.",
       "page": "e89",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Therefore, the avoidance and/or decreased use of benzodiazepine sedation is important for delirium prevention and management.",
       "highlight": "the avoidance and/or decreased use of benzodiazepine sedation is important for delirium prevention and management",
       "scope": "on-scope",
       "note": "Reinforces that reducing deliriogenic (benzodiazepine) exposure is a prevention strategy in this population.",
       "page": "e90",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Mody 2018",
     "cite": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Same PICU population: benzodiazepines an independent modifiable risk factor for delirium; restraint use strongly associated with delirium; anticholinergics named as a deliriogenic class — covering the specifics PANDEM's main text omits.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000003194",
     "paragraphs": [
      {
       "context": "Conclusions--Benzodiazepines are an independent and modifiable risk factor for development of delirium in critically ill children, even after carefully controlling for time-dependent covariates, with a dose-response effect. This temporal relationship suggests causality between benzodiazepine exposure and pediatric delirium and supports limiting the use of benzodiazepines in critically ill children.",
       "highlight": "supports limiting the use of benzodiazepines in critically ill children",
       "scope": "on-scope",
       "note": "Causal-inference study concluding benzodiazepines are a dose-dependent, modifiable driver of pediatric delirium — direct support for minimizing deliriogenic meds.",
       "page": "ms p. 2",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      },
      {
       "context": "In bivariate analyses we found that highly significant predictors of delirium in our sample included being delirious the day prior (65% vs. 27%; p<0.001), receipt of benzodiazepines the day prior (38% vs. 14%; p<0.001), receipt of opiates the day prior (30% vs. 14%; p<0.001), use of restraints (52% vs. 18%; p<0.001), and need for invasive mechanical ventilation (42% vs. 12%; p<0.001).",
       "highlight": "use of restraints (52% vs. 18%; p<0.001)",
       "scope": "on-scope",
       "note": "Restraint use is a highly significant predictor of delirium in critically ill children, supporting 'reduce physical restraints' (bivariate association, not the causal-modeled exposure).",
       "page": "ms p. 5",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      },
      {
       "context": "This study has noteworthy strengths, including a large sample size, prospective assessment of daily cognitive status, granular data collection regarding medication exposure, and sophisticated statistical analyses that allow for control of time-dependent covariates. There are also important limitations. As a single center study, these findings may not be widely generalizable, and it will be important to replicate these findings in other institutions. Also, there are additional medications that may contribute to delirium, such as anticholinergics and steroids, that have not been included in this study design. Further research is needed to assess the relationship between delirium and these (and other) drug classes. We acknowledge the limitations of not accounting for all time-varying confounders, as well as not being able to account for unmeasured confounding. Finally, as an observational study, we must be cautious not to over-conclude (particularly with respect to the lack of independent opiate Author Manuscript Author Manuscript Crit Care Med.",
       "highlight": "anticholinergics and steroids",
       "scope": "background",
       "note": "Names anticholinergics as a deliriogenic class relevant to deprescribing, but as an acknowledged limitation (not directly studied here).",
       "page": "ms p. 6",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "SBS is a sedation/agitation assessment instrument cited card-wide for depth-of-sedation scoring; it does not address the prevention interventions in this claim.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Objective--To develop and test the reliability and validity of the State Behavioral Scale (SBS) for use in describing sedation/agitation levels in young intubated patients supported on mechanical ventilation.",
       "highlight": "the reliability and validity of the State Behavioral Scale (SBS) for use in describing sedation/agitation levels",
       "scope": "different-intervention",
       "note": "A measurement/assessment tool for sedation-agitation level, not a prevention intervention — shares the sedation keyword but different scope.",
       "page": "114",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD is a delirium screening tool cited card-wide for detection; it does not address restraint or deliriogenic-med reduction.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Objective--To determine validity and reliability of the Cornell Assessment of Pediatric Delirium, a rapid observational screening tool.",
       "highlight": "a rapid observational screening tool",
       "scope": "different-intervention",
       "note": "Validation of a delirium detection instrument — the nearest topical match but a different intervention (screening, not prevention).",
       "page": "663",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Gupta 2021",
     "cite": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "CAPD screening-performance study in mechanically ventilated children; addresses detection accuracy, not prevention interventions.",
     "docUrl": "https://doi.org/10.1055/s-0041-1728784",
     "paragraphs": [
      {
       "context": "The purpose of this study was to examine the performance of the Cornell Assessment of Pediatric Delirium (CAPD) scale in these patients.",
       "highlight": "examine the performance of the Cornell Assessment of Pediatric Delirium (CAPD) scale",
       "scope": "different-intervention",
       "note": "Diagnostic-accuracy evaluation of a screening scale - same population but a detection intervention, not the prevention measure claimed.",
       "page": "24",
       "docUrl": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "psCAM-ICU is a preschool delirium screening tool; its rationale touches the modifiable-deliriogenic-meds concept but the paper validates detection, not prevention.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "The specific associations between delirium and outcomes have not been delineated in children, though critically ill children who survive to home demonstrate decreases in spatial and verbal memory, inability to sustain attention, (23) have significantly longer school absences, (24) and demonstrate executive dysfunction months after discharge. (25) It is possible that elements of critical illness or management factors may contribute to these worse patient outcomes. Of these, sedation practices may be a modifiable risk factor for the development of delirium just as it has been reported in adults. (26) (27) (28) This is a poignant supposition given that 90% of pediatric patients are supported on sedative infusions, including high dose benzodiazepines, during mechanical ventilation. (29) In fact, benzodiazepine administration in critically ill children has previously been associated with the development of post-traumatic stress disorder and delusional memories following critical illness. (30) Using delirium tools such as the psCAM-ICU and pCAM-ICU, novel investigations can be conducted to answer key questions related to highly prevalent sedation practices and brain dysfunction outcomes (acute and long-term) in our sickest children.",
       "highlight": "sedation practices may be a modifiable risk factor for the development of delirium",
       "scope": "background",
       "note": "Background rationale noting sedation as a modifiable risk factor (echoing 'minimize deliriogenic meds'), but stated to motivate a screening tool rather than as a prevention finding.",
       "page": "ms. p.9",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "RASS (adult ICU sedation-agitation scale validation) is cited card-wide for sedation-depth scoring, not for the restraint/deliriogenic-med prevention interventions in this claim. Cited by section by DOI 10.1164/rccm.2107138.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU delirium screening-tool validation is cited card-wide as a detection instrument for children >5 years, not as a prevention intervention. Cited by section (Crit Care Med 2011;39(1):150-157).",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    }
   ],
   "synthesis": "The on-scope pediatric guideline (SCCM PANDEM 2022, p. 16/e89) governs and remains the current position: it supports minimizing deliriogenic medication via the BRAIN MAPS \"Remove/Reduce deliriogenic drugs\" model and a strong recommendation to minimize benzodiazepine-based sedation, and Mody 2018 corroborates in the same PICU population (benzodiazepines an independent, dose-dependent, modifiable risk factor; restraint use strongly associated with delirium; anticholinergics named as a further deliriogenic class). The cited PANDEM main text does not name \"anticholinergics\" or \"physical restraints\" specifically — that support comes from Mody 2018 — so PANDEM only partially covers the bullet, and the assessment/screening instruments (SBS, CAPD, psCAM-ICU, pCAM-ICU, RASS) are cited card-wide for detection, a different intervention scope than this prevention claim.",
   "discrepancy": true
  },
  {
   "id": "picu-wf-r3",
   "toolId": "picu-wf",
   "tool": "PICU Workflow",
   "page": "1",
   "section": "1 · Screen every child",
   "statement": "Every PICU child, at least once per shift and with any mental-status change.",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM PANDEM 2022",
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "Lin 2023 (ICU Liberation)",
    "Traube 2017 (mortality)"
   ],
   "anchor": "Traube 2014 (CAPD) — p. 8",
   "passage": "For study purposes, the CAPD and psychiatric evaluations happened during the daylight hours, at approximately noon each day. To more accurately capture delirious patients, who may be more symptomatic at night, the CAPD will need to be performed a minimum of twice daily, once by each shift nurse. SUMMARY The CAPD is a promising new clinical screening tool designed and validated for use in the PICU setting to detect delirium in most children. Future work will address further clinical applications of the CAPD, such as diagnostic algorithms for special populations in which delirium diagnoses are challenging. The CAPD may facilitate the development of much needed research investigating the causes, pathophysiology, treatment, and long-term implications of pediatric delirium. Acknowledgments This work was performed at Weill Cornell Medical College/NY Presbyterian Hospital. Drs. Traube and Greenwald received support for travel from Weill Cornell Medical College. Dr. …\nAlso SCCM PANDEM 2022: \"We recommend routine screening for ICU delirium using a validated tool in critically ill pediatric patients upon admission through ICU discharge or transfer\"\nTraube 2014 supports the once-per-shift minimum (a CAPD by each shift nurse, twice daily), and PANDEM 2022 supports screening every PICU child from admission through discharge. The 'with any mental-status change' trigger is a clinical addition not stated in the pediatric sources.",
   "evidence": "Full text, p. 8",
   "status": "fulltext",
   "pageNum": "8",
   "citations": [
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
    "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898."
   ],
   "links": [
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000003262",
    "https://doi.org/10.1097/CCM.0000000000002250"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governs the 'every PICU child' element: strong, high-level recommendation for routine screening of all critically ill children from admission to discharge; does not itself specify the per-shift interval.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "\"We recommend\" routine screening for ICU delirium using a validated tool in critically ill pediatric patients upon admission through ICU discharge or transfer (strong, high-level evidence).",
       "highlight": "routine screening for ICU delirium using a validated tool in critically ill pediatric patients upon admission through ICU discharge or transfer",
       "scope": "on-scope",
       "note": "Directly supports screening every PICU child throughout the stay, but states no per-shift frequency.",
       "page": "e88",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Rationale: The care of critically ill pediatric patients is complicated and requires the collaboration and effectiveness of an interdisciplinary team. Routine monitoring in the ICU incorporates multiple organ/system surveillance supporting the acute management of ongoing organ dysfunction. Therefore, the recommendation for the implementation of routine monitoring for acute brain dysfunction considers the availability of valid and efficient bedside tools and the ability to identify and modify risk factors by which an opportunity is created to reduce prevalence, morbidity, and mortality associated with delirium. With the availability of validated screening tools (see above), delirium monitoring in the PICU is feasible (152, 224-227, 229, 242). We now recognize that ICU delirium is highly prevalent among critically ill children, with predominance of the hypoactive subtype which is most easily missed without routine screening. The goal of delirium monitoring is ultimately to implement patient care strategies to diminish its occurrence rate and effect on clinical outcomes such as mortality and further understand the role of acute brain dysfunction on the quality of life for pediatric survivors of critical illness.",
       "highlight": "the hypoactive subtype which is most easily missed without routine screening",
       "scope": "broader",
       "note": "General rationale for universal routine screening (hypoactive delirium missed otherwise), supporting the 'every child' framing rather than the cadence.",
       "page": "e88",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "RASS validation in adult ICU patients; cited as the arousal scale that gates delirium screening (patient must be arousable before CAPD/CAM-ICU). Contributes the sedation-level prerequisite, not the screening cadence.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest-match on assessment frequency but a different intervention: it recommends a cadence for sedation (SBS) scoring, not delirium screening.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "We recommended that sedation assessment be completed at the start of normal cares at a frequency that aligns with the patient's clinical state. The Joint Commission for the Accreditation of Hospitals suggests that pain scoring be considered the 5th vital sign. We suggest that sedation scoring should be completed with the patient's pain assessment every four hours and also before and after an intervention that impacts the patient's level of sedation.",
       "highlight": "sedation scoring should be completed with the patient's pain assessment every four hours and also before and after an intervention",
       "scope": "different-intervention",
       "note": "Every-4-hour cadence (plus before/after sedation-altering interventions) is for the State Behavioral Scale sedation assessment, not delirium screening; shares 'assessment frequency' keywords but must not be read as support for the delirium-screening interval.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary source for the once-per-shift cadence: recommends the CAPD be performed a minimum of twice daily, once by each shift nurse.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "For study purposes, the CAPD and psychiatric evaluations happened during the daylight hours, at approximately noon each day. To more accurately capture delirious patients, who may be more symptomatic at night, the CAPD will need to be performed a minimum of twice daily, once by each shift nurse.",
       "highlight": "the CAPD will need to be performed a minimum of twice daily, once by each shift nurse",
       "scope": "on-scope",
       "note": "Direct support for 'at least once per shift' — twice daily, once per shift nurse.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "With a sensitivity of 94.1%, the CAPD produced three false negatives out of 248 assessments. Of these (Table 3), two of the three children screened positive on a prior or subsequent CAPD. By performing the screen twice daily, these subjects would have been detected. Because one of these children had significant developmental delay, and the other a preexisting psychiatric illness, it is possible that these factors complicated the nursing assessment. The third screen may not have been performed accurately as it conflicts with the psychiatric assessment in many item responses. Larger studies are needed to further assess factors that confound detection of delirium.",
       "highlight": "By performing the screen twice daily, these subjects would have been detected",
       "scope": "on-scope",
       "note": "Empirical rationale that twice-daily (per-shift) screening catches cases a single daily screen misses.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU validation in children over 5 years; one of the recommended validated tools, cited by DOI for tool validity, not for the screening cadence.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "background",
     "note": "Validates a recommended screening tool (psCAM-ICU) and defines acute mental-status change as a core diagnostic feature, but states no screening interval or explicit screen-on-change trigger.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "An interdisciplinary team comprising of pediatric anesthesiology/critical care, neurodevelopmental pediatrics, and child and adolescent psychiatry developed the psCAMICU based on the hierarchical design of the pCAM-ICU and the CAM-ICU, (9) which required the following for delirium diagnosis: 1) fluctuation or acute change from baseline mental status, 2) inattention, and either 3) a current altered level of consciousness, or 4) presence of disorganized thinking. Valid pediatric neurocognitive assessments, (10) pain and behavior scales, (11) (12) and developmental milestones, (13) were reviewed and used as a guide to ensure the cognitive and consciousness assessments within the psCAM-ICU were appropriate for both infants and preschool-aged children. As with the adult CAM-ICU and pCAM-ICU, and in agreement with the recent DSM-V, the psCAM-ICU requires the presence of inattention, the most fundamental feature of delirium, and is based on objective and interactive patient assessments.",
       "highlight": "1) fluctuation or acute change from baseline mental status, 2) inattention",
       "scope": "background",
       "note": "Acute change from baseline mental status here is a diagnostic criterion within the tool, not the claim's screen-on-mental-status-change trigger; shares wording but different concept.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "The approach for delirium diagnosis differs among available bedside tools which allow clinicians a choice in deciding on a tool that best fits their needs, based on resources, and ease of implementation in their particular ICUs. For instance, the CAPD applies scoring of observations over time to screen for delirium, providing an opportunity for the detection of subtle changes in patient behaviors which may not be picked up by an \"in the moment\" delirium screening test. However, the CAPD requires anchor points for each developmental stage as one is assessing for a range of behavior from normal to varied levels of abnormal. To be done appropriately this detailed assessment using the CAPD takes time. In contrast, the psCAM-ICU does not require developmental anchor points as the tool assesses for the lowest common denominator which would be considered abnormal for the broader cohort. The psCAM-ICU is unique as a fast and largely objective delirium assessment tool that requires the presence of inattention, the most fundamental feature of delirium. Additionally, the psCAM-ICU can be used to detect abrupt changes in brain function during shock, respiratory insufficiency, or even indolent disease processes, and subsequently be used for efficient reassessment to reflect acute delirium resolution following appropriate interventions.",
       "highlight": "can be used to detect abrupt changes in brain function during shock, respiratory insufficiency, or even indolent disease processes, and subsequently be used for efficient reassessment",
       "scope": "background",
       "note": "Closest to the change-triggered reassessment idea, but framed as tool capability in a validation discussion rather than a screening-frequency recommendation.",
       "page": "ms. p.9",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Lin 2023 (ICU Liberation)",
     "cite": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Pediatric ABCDEF-bundle collaborative; the 'D' element entails routine delirium assessment, supporting the universal-screening context but not the specific per-shift interval. Cited by section/DOI.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000003262",
     "paragraphs": []
    },
    {
     "label": "Traube 2017 (mortality)",
     "cite": "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Operationalizes the per-shift cadence in a large multicenter cohort: each child screened twice daily (6 am / 6 pm) with the CAPD, consistent with the ESPNIC recommendation of every 8-12 hours.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000002324",
     "paragraphs": [
      {
       "context": "Consistent with our PICU standard, each child was screened for delirium twice daily by the bedside nurse, at 6 am and 6 pm, using the Cornell Assessment of Pediatric Delirium (CAPD)(8). This is also consistent with the recent position paper published by the European Society of Paediatric and Neonatal Intensive Care (ESPNIC), recommending use of CAPD to assess for pediatric delirium (grade of recommendation = A) every 8-12 hours(9). The CAPD is a well-validated observational 8-item tool that can reliably distinguish between pain, agitation, residual sedation, and delirium(8,9). A CAPD score of 9 or higher represents a positive screen; the diagnosis is then confirmed by the physician(8). Any developmentally delayed child who screened positive for delirium on the CAPD subsequently had the diagnosis of delirium confirmed (or refuted) by an intensivist or psychiatrist prior to being classified as delirious. (The clinician had to establish an alteration from mental status at prehospital baseline, in order to ensure that static encephalopathy - i.e.: the underlying developmental delay - was not confused with delirium).",
       "highlight": "each child was screened for delirium twice daily by the bedside nurse, at 6 am and 6 pm",
       "scope": "on-scope",
       "note": "Direct support: every child screened twice daily, once per 12-hour shift, matching 'at least once per shift'.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      },
      {
       "context": "Consistent with our PICU standard, each child was screened for delirium twice daily by the bedside nurse, at 6 am and 6 pm, using the Cornell Assessment of Pediatric Delirium (CAPD)(8). This is also consistent with the recent position paper published by the European Society of Paediatric and Neonatal Intensive Care (ESPNIC), recommending use of CAPD to assess for pediatric delirium (grade of recommendation = A) every 8-12 hours(9). The CAPD is a well-validated observational 8-item tool that can reliably distinguish between pain, agitation, residual sedation, and delirium(8,9). A CAPD score of 9 or higher represents a positive screen; the diagnosis is then confirmed by the physician(8). Any developmentally delayed child who screened positive for delirium on the CAPD subsequently had the diagnosis of delirium confirmed (or refuted) by an intensivist or psychiatrist prior to being classified as delirious. (The clinician had to establish an alteration from mental status at prehospital baseline, in order to ensure that static encephalopathy - i.e.: the underlying developmental delay - was not confused with delirium).",
       "highlight": "recommending use of CAPD to assess for pediatric delirium (grade of recommendation = A) every 8-12 hours",
       "scope": "on-scope",
       "note": "ESPNIC every-8-12-hour recommendation cited here maps directly to once-per-shift screening.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      },
      {
       "context": "Setting--Urban academic tertiary care pediatric intensive care unit (PICU). Patients--All consecutive admissions from September 2014 through August 2015. Intervention--Children were screened for delirium twice daily throughout their ICU stay. Measurements and Main Results--Of 1547 consecutive patients, delirium was diagnosed in 267 (17%), and lasted a median of two days (IQR 1,5). Seventy-eight percent of children with delirium developed it within the first three PICU days. Most cases of delirium were of the hypoactive (46%) and mixed (45%) subtypes; only 8% of delirium episodes were characterized as hyperactive delirium. In multivariable analysis, independent predictors of delirium included age 2 years, developmental delay, severity of illness, prior coma, mechanical ventilation, and receipt of benzodiazepines and anticholinergics. PICU LOS was increased in children with delirium (adjusted relative LOS 2.3, CI= 2.1, 2.5, p<0.001), as was duration of MV (median 4 vs. 1 day, p<0.001). Delirium was a strong and independent predictor of mortality (adjusted OR 4.39, CI= 1.96-9.99, p<0.001). Conclusions--Delirium occurs frequently in critically ill children and is independently associated with mortality. Some in-hospital risk factors for delirium development are modifiable. Interventional studies are needed to determine best practices to limit delirium exposure in at-risk children.",
       "highlight": "Children were screened for delirium twice daily throughout their ICU stay",
       "scope": "on-scope",
       "note": "Abstract statement of the twice-daily (per-shift) screening applied to every child for the whole stay.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      }
     ]
    }
   ],
   "synthesis": "The on-scope sources agree on universal, recurring screening: PANDEM 2022 recommends routine delirium screening of every critically ill child from admission through ICU discharge, while Traube 2014 (primary, p.8) and Traube 2017 set the cadence at twice daily / once by each shift nurse (Traube 2017 also cites the ESPNIC recommendation of every 8-12 hours). Curley 2006's every-4-hour recommendation is for sedation (SBS) scoring — a different intervention — and must not be read as delirium-screening support; the \"with any mental-status change\" clause is standard reassessment practice and is not stated as an explicit screening trigger in any single on-scope source (psCAM-ICU's acute-change-from-baseline is a diagnostic feature, not a cadence).",
   "discrepancy": true
  },
  {
   "id": "picu-wf-r4",
   "toolId": "picu-wf",
   "tool": "PICU Workflow",
   "page": "1",
   "section": "1 · Screen every child",
   "statement": "Delirium is common (~25% point prevalence) and mostly hypoactive or mixed — easily missed without a screen.",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM PANDEM 2022",
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "Lin 2023 (ICU Liberation)",
    "Traube 2017 (mortality)",
    "Traube 2017 (point prevalence)"
   ],
   "anchor": "Traube 2017 (point prevalence) — Abstract: \"Of the 835 remaining subjects, 25% screened positive for delirium, 13% were classified as comatose, and 62% were delirium-free and coma-free.\"",
   "passage": "Also SCCM PANDEM 2022: \"the hypoactive subtype which is most easily missed without routine screening.\"\nThe ~25% point prevalence is specific to Traube 2017's international point-prevalence study; PANDEM 2022 corroborates the hypoactive-predominant, easily missed presentation. PANDEM itself cites rates up to 80%, so the 25% figure should be attributed to Traube 2017.",
   "evidence": "Abstract",
   "status": "abstract",
   "pageNum": null,
   "citations": [
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
    "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
    "Traube C, Silver G, Reeder RW, et al. Delirium in critically ill children: an international point prevalence study. Crit Care Med. 2017;45(4):584–590."
   ],
   "links": [
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000003262",
    "https://doi.org/10.1097/CCM.0000000000002250"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Pediatric guideline states directly that ICU delirium is highly prevalent in children, predominantly hypoactive, and most easily missed without routine screening — supports all three elements of the statement qualitatively.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "Rationale: The care of critically ill pediatric patients is complicated and requires the collaboration and effectiveness of an interdisciplinary team. Routine monitoring in the ICU incorporates multiple organ/system surveillance supporting the acute management of ongoing organ dysfunction. Therefore, the recommendation for the implementation of routine monitoring for acute brain dysfunction considers the availability of valid and efficient bedside tools and the ability to identify and modify risk factors by which an opportunity is created to reduce prevalence, morbidity, and mortality associated with delirium. With the availability of validated screening tools (see above), delirium monitoring in the PICU is feasible (152, 224-227, 229, 242). We now recognize that ICU delirium is highly prevalent among critically ill children, with predominance of the hypoactive subtype which is most easily missed without routine screening. The goal of delirium monitoring is ultimately to implement patient care strategies to diminish its occurrence rate and effect on clinical outcomes such as mortality and further understand the role of acute brain dysfunction on the quality of life for pediatric survivors of critical illness.",
       "highlight": "ICU delirium is highly prevalent among critically ill children, with predominance of the hypoactive subtype which is most easily missed without routine screening",
       "scope": "on-scope",
       "note": "Single sentence that supports 'common', 'mostly hypoactive', and 'easily missed without a screen' together, for the PICU population.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Delirium is categorized based on psychomotor symptoms. Patients with hypoactive delirium may appear apathetic, withdrawn from the environment, or with depressed levels of arousal (215, 216), and rarely provoke concern despite being more likely to have poorer outcomes (215, 217, 218). Patients with hyperactive delirium suffer from agitation, emotional lability, or disruptive behavior, although this is the least common form of ICU delirium (219, 220). Patients who demonstrate hyperactive and hypoactive behaviors are categorized as having a mixed subtype of delirium.",
       "highlight": "this is the least common form of ICU delirium",
       "scope": "background",
       "note": "Definitional description of motoric subtypes; states hyperactive is the least common form, reinforcing that most delirium is hypoactive or mixed.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Cited by the workflow section for the Richmond Agitation-Sedation Scale (adult ICU arousal scale used to gate delirium assessment); does not address pediatric delirium prevalence or subtype.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "background",
     "note": "Validation of the State Behavioral Scale, a sedation/agitation instrument for intubated young children; contains no delirium prevalence or subtype content — it supports the arousal-level step of the workflow, not the delirium claim.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Objective--To develop and test the reliability and validity of the State Behavioral Scale (SBS) for use in describing sedation/agitation levels in young intubated patients supported on mechanical ventilation.",
       "highlight": "the State Behavioral Scale (SBS) for use in describing sedation/agitation levels in young intubated patients",
       "scope": "different-intervention",
       "note": "Nearest match on the 'screen every child' workflow but a sedation-level scale, not a delirium screen; the file mentions delirium nowhere.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "CAPD validation in a general PICU cohort: 20.6% prevalence establishes delirium as common, and the tool was built to detect hypoactive/mixed subtypes that hyperactive-only tools miss.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Conclusions--With an overall prevalence rate of 20.6% in our study population, delirium is a common problem in pediatric critical care. The Cornell Assessment of Pediatric Delirium is a valid, rapid, observational nursing screen that is urgently needed for the detection of delirium in PICU settings.",
       "highlight": "delirium is a common problem in pediatric critical care",
       "scope": "on-scope",
       "note": "Supports 'delirium is common' with a PICU prevalence (20.6%) close to the claimed ~25%; same population and setting.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "The CAPD is an adaptation of the PAED. As the original PAED was designed to detect transient emergence delirium following anesthesia, it selects for patients with a hyperactive, agitated delirium subtype and would be incomplete for assessing the PICU population. Therefore, we added two elements (questions 7 and 8, Fig. 1) to improve the detection of hypoactive and mixed-type delirium. We changed the scale items from statements to questions and renamed the tool to reflect the comprehensive nature of the assessment. An initial pilot study showed feasibility for use as a rapid nursing screen (28).",
       "highlight": "to improve the detection of hypoactive and mixed-type delirium",
       "scope": "on-scope",
       "note": "The screen was designed specifically to catch hypoactive/mixed delirium, implying these subtypes are otherwise easily missed.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited by the workflow for the pCAM-ICU screening tool (children >5 yr); full text not provided in this corpus.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Preschool/infant PICU cohort: hypoactive delirium strongly predominant and stated to be easily missed without a valid tool — directly supports the 'mostly hypoactive, easily missed' portion; its prevalence figure is population-specific.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "Pediatric delirium prevalence of 44% and 47% as determined by the psCAM-ICU and reference standard, respectively, is higher than previously reported. (5) (6) (7) Historically, prevalence studies largely based on consultative psychiatry services consist of patients with hyperactive delirium. The more common hypoactive subtype can easily go undetected when relying on routine clinical practice without the benefit of a valid bedside delirium tool. Therefore, one would expect to identify a much larger number of patients with hypoactive delirium following the implementation of delirium monitoring in the PICU. Additionally, in this study we were able to assess for delirium prior to IRB consent if a surrogate was not immediately available allowing for earlier evaluation of patients during their critical illness and thus a more accurate assessment of delirium prevalence in all comers to the PICU.",
       "highlight": "The more common hypoactive subtype can easily go undetected when relying on routine clinical practice without the benefit of a valid bedside delirium tool",
       "scope": "on-scope",
       "note": "States that the more common hypoactive subtype is easily missed without a screening tool — direct support for 'mostly hypoactive... easily missed without a screen.'",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "Large cohort studies using valid and reliable delirium monitoring tools have demonstrated that delirium occurs in up to 80% of mechanically ventilated adults and 50% of lower severity of illness patients, (1) and is associated with worse outcomes including higher mortality, and development of long-term cognitive impairment (LTCI). (2) (3) (4) Small case series have reported pediatric delirium rates between 10-30%. (5) (6) (7) Prevalence studies based on consultations to the psychiatry service usually consist of patients with hyperactive delirium (i.e. agitated, combative patients). Hypoactive delirium, (i.e. patients who manifest negative symptomatology, apathy, or decreased level of consciousness), is frequently missed in routine clinical practice without use of a valid delirium tool and therefore rarely leads to psychiatry evaluation. Pediatric delirium research has lagged behind that of adult delirium research due to the paucity of pediatric-specific delirium assessment tools and resources, delaying the completion of large prospective cohort studies.",
       "highlight": "is frequently missed in routine clinical practice without use of a valid delirium tool",
       "scope": "on-scope",
       "note": "Background/intro statement that hypoactive delirium is frequently missed without a valid tool, reinforcing the 'easily missed without a screen' claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "271 patients were eligible for delirium evaluation. The overall delirium prevalence of this cohort using the psCAM-ICU was 44%, with at least one delirium positive evaluation occurring in 124 of 281 assessed patients.",
       "highlight": "The overall delirium prevalence of this cohort using the psCAM-ICU was 44%",
       "scope": "different-population",
       "note": "Cohort is infants and preschoolers (6 mo–5 yr); prevalence 44–47% is higher than the ~25% overall PICU figure, though the hypoactive predominance still supports the subtype portion.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Lin 2023 (ICU Liberation)",
     "cite": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Cited for the pediatric ABCDEF (ICU Liberation) bundle collaborative; full text not provided in this corpus.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000003262",
     "paragraphs": []
    },
    {
     "label": "Traube 2017 (mortality)",
     "cite": "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
     "kind": "pdf",
     "stance": "partial",
     "note": "The attached file is Traube's single-center epidemiology/mortality study, not the International Point Prevalence Study its citation names: it strongly supports the subtype and 'missed-without-screening' portions but reports 16.6% prevalence / 17.3% incidence, not the ~25% figure — and the quoted '835 subjects, 25% screened positive' passage is not in this file.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000002324",
     "paragraphs": [
      {
       "context": "Measurements and Main Results--Of 1547 consecutive patients, delirium was diagnosed in 267 (17%), and lasted a median of two days (IQR 1,5). Seventy-eight percent of children with delirium developed it within the first three PICU days. Most cases of delirium were of the hypoactive (46%) and mixed (45%) subtypes; only 8% of delirium episodes were characterized as hyperactive delirium. In multivariable analysis, independent predictors of delirium included age 2 years, developmental delay, severity of illness, prior coma, mechanical ventilation, and receipt of benzodiazepines and anticholinergics. PICU LOS was increased in children with delirium (adjusted relative LOS 2.3, CI= 2.1, 2.5, p<0.001), as was duration of MV (median 4 vs. 1 day, p<0.001). Delirium was a strong and independent predictor of mortality (adjusted OR 4.39, CI= 1.96-9.99, p<0.001).",
       "highlight": "Most cases of delirium were of the hypoactive (46%) and mixed (45%) subtypes; only 8% of delirium episodes were characterized as hyperactive delirium.",
       "scope": "on-scope",
       "note": "Directly supports 'mostly hypoactive or mixed' — 46% hypoactive plus 45% mixed, with only 8% hyperactive, in a PICU cohort.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      },
      {
       "context": "Consistent with the literature, many children were delirious during their first few PICU days. Without routine screening, these children, as well as children with hypoactive delirium, are likely underdiagnosed(29). This is of great clinical significance, as screening facilitates detection which allows for earlier intervention, and may lead to a decrease in delirium duration(30).",
       "highlight": "Without routine screening, these children, as well as children with hypoactive delirium, are likely underdiagnosed",
       "scope": "on-scope",
       "note": "Directly supports 'easily missed without a screen' — hypoactive cases are underdiagnosed absent routine screening.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      },
      {
       "context": "It is important to note that, as in adults, only a minority of delirium was of the easily recognizable hyperactive subtype(1,25,26). In adults, hypoactive delirium is thought to be the most severe form of delirium, with worse prognostic implications(27). In addition, hypoactive subtype of delirium may be less likely to respond to treatment with antipsychotics (28). Further study is needed to determine whether this is true in children as well.",
       "highlight": "only a minority of delirium was of the easily recognizable hyperactive subtype",
       "scope": "on-scope",
       "note": "Reinforces that the easily recognizable hyperactive form is the minority, so most delirium (hypoactive/mixed) is not obvious at the bedside.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      },
      {
       "context": "Delirium was diagnosed in 267 patients, for an incidence of 17.3%. Of the 7,591 patient study days, 1,259 were days with delirium, for a prevalence of 16.6% in this cohort. 566 patient days (7.5%) were classified as days with coma (almost always medication-induced), and 5671 patient days (74.7%) as days with normal mental status (DFCF). Only 95 patient days (<2%) were classified as unknown, due to missed opportunities for delirium screening.",
       "highlight": "for a prevalence of 16.6% in this cohort",
       "scope": "narrower",
       "note": "This single-center study reports 17.3% incidence / 16.6% prevalence — lower than the claimed ~25%; the 25% point-prevalence figure comes from the separate international study the citation names, whose text is not in this file.",
       "page": "ms. p.5",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      }
     ]
    },
    {
     "label": "Traube 2017 (point prevalence)",
     "cite": "Traube C, Silver G, Reeder RW, et al. Delirium in critically ill children: an international point prevalence study. Crit Care Med. 2017;45(4):584–590.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The ~25% figure is this study, not its mortality companion. The full text is not archived here; the published abstract states the proportion directly, so that is what is quoted.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000002250",
     "paragraphs": [
      {
       "context": "Measurements and Main Results: Primary study outcome measure was prevalence of delirium. In 159 children, a final determination of mental status could not be ascertained. Of the 835 remaining subjects, 25% screened positive for delirium, 13% were classified as comatose, and 62% were delirium-free and coma-free. Delirium prevalence rates varied significantly with reason for ICU admission, with highest delirium rates found in children admitted with an infectious or inflammatory disorder. For children who were in the PICU for 6 or more days, delirium prevalence rate was 38%.",
       "highlight": "Of the 835 remaining subjects, 25% screened positive for delirium",
       "scope": "on-scope",
       "note": "Read from the published abstract. 835 subjects is this study’s denominator after 159 indeterminate screens; the mortality companion reports a different cohort of 1,547 patients.",
       "page": "Abstract",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002250"
      }
     ]
    }
   ],
   "synthesis": "The sources agree that PICU delirium is common and predominantly hypoactive or mixed, and is easily missed without routine screening — the SCCM PANDEM 2022 guideline states this directly (“highly prevalent... with predominance of the hypoactive subtype which is most easily missed without routine screening”) and governs the qualitative claim, concordant with Traube 2014 (20.6% prevalence) and Smith 2016 psCAM-ICU (hypoactive predominant, easily undetected). The two Traube 2017 papers are cited separately because they are different studies. The ~25% figure is the international point-prevalence study, which screened 835 evaluable children across twenty-five units; its full text is not held here, so the proportion is quoted from its abstract. The mortality companion, which is archived, followed 1,547 consecutive patients at a single centre and reports a 17.3% incidence and 16.6% prevalence of delirium days — a different design and a lower rate, and the source of this statement’s subtype figures (hypoactive 46%, mixed 45%, hyperactive 8%). Read the ~25% as a point prevalence across many units rather than a rate any single cohort reported.",
   "discrepancy": true
  },
  {
   "id": "picu-wf-r5",
   "toolId": "picu-wf",
   "tool": "PICU Workflow",
   "page": "1",
   "section": "2 · Arousal first — the gate",
   "statement": "Score RASS (older / verbal) or SBS (intubated infants & young children).",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM PANDEM 2022",
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "Lin 2023 (ICU Liberation)",
    "Traube 2017 (mortality)"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 10",
   "passage": "… Rationale: The Comfort-B Scale (56, 117, 118) and the SBS (119, 120) have both been validated in several PICU settings to assess the level of sedation in mechanically ventilated pediatric patients. Both scales reliably differentiate adequate from overor undersedation in patients not receiving NMBAs. Their psychometric validity has been supported in a meta-analysis of 13 sedation scales (121). Although the RASS has only been validated in a single trial, it is extensively used in pediatric critical care as it forms the basis for determining the appropriateness of delirium screening with the pediatric Confusion Assessment Method for the ICU (pCAM-ICU) and Cornell Assessment of Pediatric Delirium (CAPD) delirium screening tools (122). Characteristics of each sedation assessment scale are described in detail in SDC Table 6 (http://links.lww. com/PCC/B920). Protocolized Sedation. Question: Should critically ill pediatric patients requiring MV routinely be assigned a target depth of sedation? (SDC Section C2, http://links.lww.com/ PCC/B920). Answer: \"We suggest\" that all pediatric patients requiring MV be assigned a target depth of sedation using a validated sedation assessment tool at least once daily (conditional, low-level evidence). …\nAlso Curley 2006 (SBS): \"The SBS was specifically designed for and tested in young intubated mechanically ventilated patients\"\nIn the PANDEM passage, 'it' refers to the RASS; both the RASS and SBS are endorsed sedation/arousal tools, and Curley 2006 confirms the SBS was designed for intubated infants and young children (6 wk–6 yr). The RASS-for-older/verbal versus SBS-for-infants assignment is clinical convention rather than a rule stated in either source.",
   "evidence": "Full text, p. 10",
   "status": "fulltext",
   "pageNum": "10",
   "citations": [
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
    "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898."
   ],
   "links": [
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000003262",
    "https://doi.org/10.1097/CCM.0000000000002250"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governing pediatric guideline — recommends SBS (or COMFORT-B) and suggests RASS to assess sedation/arousal in ventilated children.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "1) We recommend the use of the COMFORT-B Scale or the State Behavioral Scale, to assess level of sedation in mechanically ventilated pediatric patients.",
       "highlight": "We recommend the use of the COMFORT-B Scale or the State Behavioral Scale, to assess level of sedation in mechanically ventilated pediatric patients",
       "scope": "on-scope",
       "note": "PANDEM recommends the SBS and suggests RASS to assess sedation/arousal in ventilated pediatric patients — the arousal-scoring gate the claim states.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The SBS validation study — SBS is the sedation-assessment instrument for young intubated children.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "The purpose of this study was to empirically construct and demonstrate preliminary construct validity and inter-rater reliability of a pediatric sedation assessment scale, the State Behavioral Scale (SBS), for use in young critically ill pediatric patients supported on mechanical ventilation.",
       "highlight": "the State Behavioral Scale (SBS), for use in young critically ill pediatric patients",
       "scope": "on-scope",
       "note": "Defines the SBS as a sedation-assessment scale for young critically ill (mechanically ventilated) children — the SBS arm of the claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Pediatric delirium screening begins with a RASS arousal assessment.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "All psCAM-ICU assessments were completed using a two-step approach based on Plum and Posner's (14) categorization of consciousness: arousal and content. The first step was the assessment of patient arousal using the Richmond Agitation-Sedation Scale (RASS).",
       "highlight": "The first step was the assessment of patient arousal using the Richmond Agitation-Sedation Scale (RASS)",
       "scope": "on-scope",
       "note": "psCAM-ICU screening starts by scoring arousal with the RASS — supports RASS as the arousal gate before delirium screening.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Uses RASS to gate arousal before CAPD delirium assessment.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "All patients in the PICU on a given study day were eligible if there was a parent or guardian available to provide informed consent. The only exclusion criterion was a sedation score of less than -3 (deeply sedated or unarousable), using the Richmond Agitation and Sedation Scale (RASS) (38, 39). Demographic and clinical data were collected on each subject.",
       "highlight": "a sedation score of less than -3 (deeply sedated or unarousable), using the Richmond Agitation and Sedation Scale (RASS)",
       "scope": "on-scope",
       "note": "CAPD validation uses the RASS to establish arousal (RASS < -3 = unarousable) before delirium can be scored.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "The RASS instrument itself (adult-derived; the pediatric guideline and screens adopt it). Paywalled paper — cited by DOI, no archived snapshot.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU validation (≥5 yr) uses a RASS arousal gate; cited by DOI — no archived full text.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Lin 2023 (ICU Liberation)",
     "cite": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Pediatric ICU Liberation (ABCDEF) implementation; cited by DOI — no archived full text.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000003262",
     "paragraphs": []
    },
    {
     "label": "Traube 2017 (mortality)",
     "cite": "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
     "kind": "pdf",
     "stance": "background",
     "note": "Pediatric delirium epidemiology/mortality — supplies burden context, not the arousal-scoring method (different scope).",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000002324",
     "paragraphs": []
    }
   ],
   "synthesis": "The 2022 SCCM PANDEM pediatric guideline governs: it recommends the State Behavioral Scale (or COMFORT-B) and suggests the RASS to assess sedation/arousal in mechanically ventilated children. Curley 2006 validates the SBS for young intubated children, and the pediatric delirium screens (psCAM-ICU, CAPD) each begin with a RASS arousal assessment — together supporting scoring RASS (older/verbal) or SBS (intubated infants and young children) as the arousal gate.",
   "discrepancy": false
  },
  {
   "id": "picu-wf-r6",
   "toolId": "picu-wf",
   "tool": "PICU Workflow",
   "page": "1",
   "section": "2 · Arousal first — the gate",
   "statement": "Comatose floor (RASS −4/−5 · SBS −2/−3) → record \"unable to assess\"; reassess when the child responds.",
   "contentType": "Validated instrument wording",
   "sources": [
    "SCCM PANDEM 2022",
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "Lin 2023 (ICU Liberation)",
    "Traube 2017 (mortality)"
   ],
   "anchor": "Smith 2016 (psCAM-ICU) — p. 4",
   "passage": "… All psCAM-ICU assessments were completed using a two-step approach based on Plum and Posner's (14) categorization of consciousness: arousal and content. The first step was the assessment of patient arousal using the Richmond Agitation-Sedation Scale (RASS). (15) There are three major categories of an abnormal arousal state when using the RASS: agitation (RASS +1 through +4), decreased arousal, though reactive to voice (-1 through -3), and unreactive to voice (-4 or -5). A patient who is comatose (RASS -4 or -5) cannot be clinically assessed for delirium . The stage of sleep that a child is in determines ease of awakening; i.e. infants and young children may require a more pronounced period of stimulation if in a stage of deep sleep to differentiate deep sleep from an assessed level of consciousness of either moderate or deep sedation. Therefore, patients who were initially assessed as having a RASS -3, -4, or -5 were stimulated by physical touch for 15 seconds, followed by a non-stimulating period of 15 seconds, and then reassessed using the RASS. If the patient remained deeply sedated or comatose then they were deemed unable to be assessed (UTA). For patients who were at least responsive to voice (RASS ≥ -3), their content of consciousness or delirium assessment was then performed using the psCAM-ICU. The psCAM-ICU delirium assessment is based on four features. An acute change or fluctuation from baseline mental status (Feature 1) was determined using the documented sedation or Glasgow coma scale scores (i.e. RASS, GCS) and/or patient evaluation. The sedation scores (RASS) were reviewed for the past 24 hours to establish whether fluctuation in consciousness was present, while an abnormal GCS score or patient history and examination helped to determine whether an acute alteration from their baseline mental status was present (i.e. when the patient's mental status is not the same as when they are in good health). …\nAlso Smith 2011 (pCAM-ICU): \"If RASS is – 4 or – 5 then STOP and REASSESS patient later.\"\nSmith 2016 supports RASS −4/−5 as comatose and unable to assess, with reassessment once the child is responsive to voice (RASS ≥ −3); Smith 2011 corroborates with 'STOP and REASSESS patient later.' The SBS −2/−3 equivalent floor is not stated in either source and is a clinical mapping.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
    "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898."
   ],
   "links": [
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000003262",
    "https://doi.org/10.1097/CCM.0000000000002250"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Guideline-level endorsement of the arousal-first gate plus the SBS/RASS sedation instruments; does not itself state the specific RASS -4/-5 unable-to-assess floor.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "Rationale: The Comfort-B Scale (56, 117, 118) and the SBS (119, 120) have both been validated in several PICU settings to assess the level of sedation in mechanically ventilated pediatric patients. Both scales reliably differentiate adequate from over- or undersedation in patients not receiving NMBAs. Their psychometric validity has been supported in a meta-analysis of 13 sedation scales (121). Although the RASS has only been validated in a single trial, it is extensively used in pediatric critical care as it forms the basis for determining the appropriateness of delirium screening with the pediatric Confusion Assessment Method for the ICU (pCAM-ICU) and Cornell Assessment of Pediatric Delirium (CAPD) delirium screening tools (122). Characteristics of each sedation assessment scale are described in detail in SDC Table 6 (http://links.lww. com/PCC/B920).",
       "highlight": "it forms the basis for determining the appropriateness of delirium screening",
       "scope": "on-scope",
       "note": "Endorses the arousal-first gate: the RASS/sedation score determines whether delirium screening with pCAM-ICU/CAPD is appropriate, which is the thesis of the 'arousal first' section.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "1) \"We recommend\" the use the Comfort-B Scale or the State Behavioral Scale (SBS) to assess level of sedation in mechanically ventilated pediatric patients (strong, moderatelevel evidence).",
       "highlight": "State Behavioral Scale (SBS) to assess level of sedation in mechanically ventilated pediatric patients",
       "scope": "narrower",
       "note": "Recommends SBS (and RASS) to measure sedation depth, grounding the arousal instruments the claim uses, but addresses sedation measurement rather than the delirium 'unable to assess' gate.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Original RASS validation (adult ICU); cited by section as the source of the arousal scale (-5 unarousable to +4 combative) whose -4/-5 floor defines coma. Different-population source cited for the instrument only.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Defines the SBS scale levels the claim cites (-3 'Unresponsive'/-2 'Responsive to noxious stimuli') but is a sedation-scale validation, not a delirium-assessment gate.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Specifically, the nurse first spoke the patient's name using a calm voice, then, if there was no response, spoke the patient's name and gently touched the patient's body. If there was still no response, the patient's response to a planned noxious stimulus was assessed such as endotracheal suctioning or less than 5 seconds of nail bed pressure.",
       "highlight": "If there was still no response, the patient's response to a planned noxious stimulus was assessed such as endotracheal suctioning or less than 5 seconds of nail bed pressure",
       "scope": "narrower",
       "note": "The SBS scores response to a graded voice then gentle touch then noxious stimulus, grounding the arousal floor the claim uses (SBS -3 unresponsive / -2 responsive only to noxious); it does not address delirium screenability.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "CAPD validation excluded deeply sedated/unarousable children (RASS < -3, i.e. -4/-5), operationalizing the same arousal floor as an exclusion criterion.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "All patients in the PICU on a given study day were eligible if there was a parent or guardian available to provide informed consent. The only exclusion criterion was a sedation score of less than -3 (deeply sedated or unarousable), using the Richmond Agitation and Sedation Scale (RASS) (38, 39). Demographic and clinical data were collected on each subject.",
       "highlight": "a sedation score of less than -3 (deeply sedated or unarousable)",
       "scope": "on-scope",
       "note": "Children with RASS < -3 (i.e. -4/-5) were not screened with the CAPD, mirroring the claim's comatose floor though framed as a study exclusion rather than a bedside 'record unable to assess'.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Original pCAM-ICU validation (children >5y) using the same two-step arousal-then-content approach with RASS as the arousal gate; cited by section and DOI; the full text is not held in the local archive.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary anchor: directly states the comatose RASS -4/-5 floor cannot be assessed for delirium, is recorded UTA, and is reassessed only once responsive to voice.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "A patient who is comatose (RASS -4 or -5) cannot be clinically assessed for delirium.",
       "highlight": "A patient who is comatose (RASS -4 or -5) cannot be clinically assessed for delirium",
       "scope": "on-scope",
       "note": "States the exact comatose RASS floor at which a child cannot be assessed for delirium.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "If the patient remained deeply sedated or comatose then they were deemed unable to be assessed (UTA). For patients who were at least responsive to voice (RASS -3), their content of consciousness or delirium assessment was then performed using the psCAM-ICU.",
       "highlight": "then they were deemed unable to be assessed (UTA)",
       "scope": "on-scope",
       "note": "After a stimulation-and-recheck step, persistently comatose children are recorded unable to assess (UTA) and only screened once responsive to voice (RASS >= -3) — the reassess-when-responds step.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Lin 2023 (ICU Liberation)",
     "cite": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Pediatric ABCDEF (ICU Liberation) collaborative; cited by section for the bundle context of arousal/sedation assessment feeding delirium screening. The full text is not held in the local archive, so no passage is quoted.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000003262",
     "paragraphs": []
    },
    {
     "label": "Traube 2017 (mortality)",
     "cite": "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Defines daily 'comatose' status as RASS -4/-5, unarousable, and therefore impossible to assess for delirium — matching the claim's floor.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000002324",
     "paragraphs": [
      {
       "context": "Each child was assigned a daily status: \"comatose\" (patients with a Richmond Agitation Sedation Scale (RASS) score of -4 or -5, who are unarousable to verbal stimulation(10,11), and therefore impossible to assess for delirium), \"delirious\" (CAPD score 9 with diagnosis confirmed by physician), or \"normal\" mental status (i.e.: delirium-free and coma-free (DFCF)). If an assessment opportunity was missed (due to noncompliance with screening protocol), status for that day was designated as \"unknown\".",
       "highlight": "and therefore impossible to assess for delirium",
       "scope": "on-scope",
       "note": "Assigns children with RASS -4/-5 (unarousable to verbal stimulation) a 'comatose' daily status that is impossible to assess for delirium, exactly the claim's comatose floor.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      }
     ]
    }
   ],
   "synthesis": "The two on-scope validation sources agree directly: the psCAM-ICU (Smith 2016, the primary anchor) states a comatose child (RASS -4/-5) cannot be assessed for delirium and is recorded \"unable to assess\" (UTA), then only assessed once responsive to voice, and Traube 2017 defines the same daily \"comatose\" status (RASS -4/-5, unarousable, \"impossible to assess for delirium\"); Traube 2014 operationalizes the identical floor by excluding RASS < -3 from CAPD screening, and PANDEM 2022 endorses the gate at guideline level (the sedation/arousal score determines the appropriateness of delirium screening). The SBS half of the floor (SBS -2/-3) is grounded in Curley 2006, which defines those as the \"Unresponsive\"/\"Responsive to noxious stimuli\" levels but is a sedation-scale validation (narrower scope, not a delirium gate), so Smith 2016 governs the RASS floor while Curley 2006 supplies the SBS scale definition.",
   "discrepancy": true
  },
  {
   "id": "picu-wf-r7",
   "toolId": "picu-wf",
   "tool": "PICU Workflow",
   "page": "1",
   "section": "3 · Score the screen",
   "statement": "CAPD — default for every age (observational, over the shift).",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM PANDEM 2022",
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "Lin 2023 (ICU Liberation)",
    "Traube 2017 (mortality)"
   ],
   "anchor": "Traube 2014 (CAPD) — p. 3",
   "passage": "children more than 5 years old, limited in patients with developmental delay, and requires extensive nurse training. The PAED (35) designed, for immediate postoperative use by anesthesiologists, selects for the hyperactive subtype of delirium. An ideal screening tool would detect all types of delirium (hyperactive, hypoactive, and mixed), in patients of all ages and developmental levels. Our primary objective was to describe the development of the Cornell Assessment of Pediatric Delirium (CAPD) and test its validity and reliability as a screening tool. In addition, we explored the instrument's performance in subgroups defined by developmental delay, gender, respiratory support, prematurity, and severity of illness. MATERIALS AND METHODS Phase I: Development of the CAPD The CAPD is an adaptation of the PAED. As the original PAED was designed to detect transient emergence delirium following anesthesia, it selects for patients with a hyperactive, agitated delirium subtype and would be incomplete for assessing the PICU population. …\n'Observational' and 'over the shift' are supported elsewhere in Traube 2014: the tool is described as observational in the article title, and nurses completed the assessment midshift after several hours of observing the child's behavior.",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
    "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898."
   ],
   "links": [
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000003262",
    "https://doi.org/10.1097/CCM.0000000000002250"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "1) We recommend use of the preschool and pediatric Confusion Assessment Methods for the ICU or the Cornell Assessment for Pediatric Delirium as the most valid and reliable delirium monitoring tools in critically ill pediatric patients.",
       "highlight": "We recommend use of the preschool and pediatric Confusion Assessment Methods for the ICU or the Cornell Assessment for Pediatric Delirium as the most valid and reliable delirium monitoring tools",
       "scope": "on-scope",
       "note": "Strong, high-level-evidence recommendation of the CAPD (or ps/pCAM-ICU) as a valid, reliable pediatric delirium screen, supporting its use as the workflow default.",
       "page": "e76",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "\"We recommend\" use of the preschool and pCAM-ICU (ps/pCAM-ICU) or the CAPD as the most valid and reliable delirium monitoring tools in critically ill pediatric patients (strong, high-level evidence).",
       "highlight": "the CAPD as the most valid and reliable delirium monitoring tools in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "Recommends the CAPD (with the ps/pCAM-ICU) as a most valid and reliable delirium monitoring tool in critically ill pediatric patients — the basis for CAPD as an every-age default.",
       "page": "e87",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "The pCAM-ICU was originally validated in a prospective cohort of general medical/surgical PICU patients over 5 years old and performed with a high sensitivity (83%) and specificity (99%) compared with psychiatry assessment, and high interrater reliability (kappa of 0.96) (225).",
       "highlight": "over 5 years old",
       "scope": "different-intervention",
       "note": "The CAM-based alternative (pCAM-ICU) is age-restricted to patients over 5 years old, which is why the all-age observational CAPD is the sensible every-age default rather than this tool.",
       "page": "e87",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Adult-ICU validation of the RASS arousal scale; cited by the Score-the-screen section as the arousal gate that must precede delirium screening, not as evidence for CAPD or for an every-age delirium screen.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Objective--To develop and test the reliability and validity of the State Behavioral Scale (SBS) for use in describing sedation/agitation levels in young intubated patients supported on mechanical ventilation.",
       "highlight": "describing sedation/agitation levels in young intubated patients supported on mechanical ventilation",
       "scope": "different-intervention",
       "note": "The SBS measures depth of sedation/agitation in ventilated children 6 wk-6 yr, not delirium; it is a companion arousal tool in the same workflow section, not the every-age delirium screen the claim describes.",
       "page": "114",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "children more than 5 years old, limited in patients with developmental delay, and requires extensive nurse training. The PAED (35) designed, for immediate postoperative use by anesthesiologists, selects for the hyperactive subtype of delirium. An ideal screening tool would detect all types of delirium (hyperactive, hypoactive, and mixed), in patients of all ages and developmental levels.",
       "highlight": "in patients of all ages and developmental levels",
       "scope": "on-scope",
       "note": "The primary-anchor page (p.3): the CAPD was designed to be the ideal screen across all ages and developmental levels, the basis for an every-age default.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "The CAPD screen performed similarly in all age groups of children from 0 to 13 years old. The exceptional group was adolescents (> 13-21 years old) where sensitivity was lower (50%; 95% CI, 1.3-99%) and specificity was high (98.1%; 95% CI, 94.3-100%), but this is based on only two confirmed diagnoses of delirium (out of 56 total encounters) in this age group. The performance of the CAPD by gender, respiratory support, prematurity, and illness severity as determined by PIM-2 score is presented in Table 4.",
       "highlight": "The CAPD screen performed similarly in all age groups of children from 0 to 13 years old",
       "scope": "on-scope",
       "note": "Validated similar performance across all age groups 0-13 yr; the adolescent subgroup (>13-21 yr) rested on only two confirmed cases, a caveat to 'every age.'",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "Conclusions--With an overall prevalence rate of 20.6% in our study population, delirium is a common problem in pediatric critical care. The Cornell Assessment of Pediatric Delirium is a valid, rapid, observational nursing screen that is urgently needed for the detection of delirium in PICU settings.",
       "highlight": "a valid, rapid, observational nursing screen",
       "scope": "on-scope",
       "note": "Conclusion states the CAPD is an observational nursing screen, supporting 'observational.'",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "It is significant that 31% of our assessments were in children less than 2 years old, and 27% of our assessments were in children who are developmentally delayed. Our study indicates that the CAPD is a valid and reliable delirium screen in these vulnerable populations. The developmental anchor points for each item were a valuable point-of-use reference for assessing the youngest of patients. With the addition of these anchor points and minimal training, the critical care nursing staff became adept at using the CAPD in all but the most developmentally delayed patients. The nurses completed the assessment midshift, after several hours of observing the child's behavior. In every assessment, the nurses required less than 2 minutes to complete the CAPD screen.",
       "highlight": "The nurses completed the assessment midshift, after several hours of observing the",
       "scope": "on-scope",
       "note": "Nurses scored the CAPD midshift after several hours of observing the child, directly supporting 'observational, over the shift.'",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "For study purposes, the CAPD and psychiatric evaluations happened during the daylight hours, at approximately noon each day. To more accurately capture delirious patients, who may be more symptomatic at night, the CAPD will need to be performed a minimum of twice daily, once by each shift nurse.",
       "highlight": "the CAPD will need to be performed a minimum of twice daily, once by each shift nurse",
       "scope": "on-scope",
       "note": "Recommends performing the CAPD once by each shift nurse (twice daily), the over-the-shift cadence in the claim.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Validates the pCAM-ICU for critically ill children >5 yr; cited by the section as the age-restricted, in-the-moment CAM alternative, not the every-age observational default (citation/DOI only, unarchived).",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "Despite the advances in pediatric delirium monitoring with the pCAM-ICU (objective, brief, in the moment assessment) and the CAPD (subjective scoring over a nursing shift), delirium remains under-recognized and poorly understood, especially among the very young. To address the challenges of delirium monitoring in pediatric patients, we designed this investigation 1) to create a principally objective and interactive, developmentally-targeted, delirium monitoring tool for critically ill infants and preschool-aged children, the Preschool Confusion Assessment Method for the ICU (psCAM-ICU); 2) to determine validity and reliability of objective delirium assessments using the psCAM-ICU; and 3) to simultaneously determine the prevalence of pediatric delirium in this population.",
       "highlight": "the CAPD (subjective scoring over a nursing shift)",
       "scope": "on-scope",
       "note": "Explicitly characterizes the CAPD as subjective/observational scoring over a nursing shift, the exact 'over the shift' descriptor in the claim.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "This study demonstrates that delirium monitoring using the psCAM-ICU is highly valid and reliable in critically ill infants and preschool-aged children. The long-form (research) psCAM-ICU demonstrated a high specificity (91%), sensitivity (75%), NPV (86%), and PPV (84%) compared to the reference standard. In post-hoc analysis, the short-form (clinical) psCAM-ICU, with fewer required assessment components for Features 2 and 4, demonstrated improved sensitivity (78%) and maintained a high specificity (86%), taking less than 2 minutes to complete. Additionally, the psCAM-ICU demonstrated excellent reliability with a kappa statistic of 0.79. Both the adult and pediatric ICU landscapes now have access to different lines of evidence-based practices by which to measure ICU delirium, one being a brief \"in the moment\" assessment (psCAM-ICU, pCAM-ICU, CAMICU) (6) (9) and the other being performed over a nursing shift (CAPD, ICDCS) (8) (22).",
       "highlight": "the other being performed over a nursing shift (CAPD, ICDCS)",
       "scope": "on-scope",
       "note": "Classifies the CAPD as the over-a-nursing-shift instrument, contrasted with in-the-moment CAM tools.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "The approach for delirium diagnosis differs among available bedside tools which allow clinicians a choice in deciding on a tool that best fits their needs, based on resources, and ease of implementation in their particular ICUs. For instance, the CAPD applies scoring of observations over time to screen for delirium, providing an opportunity for the detection of subtle changes in patient behaviors which may not be picked up by an \"in the moment\" delirium screening test. However, the CAPD requires anchor points for each developmental stage as one is assessing for a range of behavior from normal to varied levels of abnormal. To be done appropriately this detailed assessment using the CAPD takes time. In contrast, the psCAM-ICU does not require developmental anchor points as the tool assesses for the lowest common denominator which would be considered abnormal for the broader cohort. The psCAM-ICU is unique as a fast and largely objective delirium assessment tool that requires the presence of inattention, the most fundamental feature of delirium. Additionally, the psCAM-ICU can be used to detect abrupt changes in brain function during shock, respiratory insufficiency, or even indolent disease processes, and subsequently be used for efficient reassessment to reflect acute delirium resolution following appropriate interventions.",
       "highlight": "the CAPD applies scoring of observations over time to screen for delirium",
       "scope": "on-scope",
       "note": "Describes the CAPD as scoring observations over time and requiring developmental anchor points for each stage, i.e. usable across developmental ages.",
       "page": "ms. p.9",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "CONCLUSIONS--The psCAM-ICU is a highly valid and reliable delirium instrument for critically ill infants and preschool-aged children, in whom delirium is extremely prevalent.",
       "highlight": "critically ill infants and preschool-aged children",
       "scope": "different-population",
       "note": "The paper's own subject, the psCAM-ICU, is a different, age-restricted (6 mo-5 yr) interactive in-the-moment tool, not the every-age observational CAPD.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Lin 2023 (ICU Liberation)",
     "cite": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Pediatric ABCDEF (ICU Liberation) collaborative; cited by the section as bundle context for the delirium-monitoring 'D' element, not as specific evidence that CAPD is the every-age default (citation/DOI only, unarchived).",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000003262",
     "paragraphs": []
    },
    {
     "label": "Traube 2017 (mortality)",
     "cite": "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000002324",
     "paragraphs": [
      {
       "context": "Consistent with our PICU standard, each child was screened for delirium twice daily by the bedside nurse, at 6 am and 6 pm, using the Cornell Assessment of Pediatric Delirium (CAPD)(8). This is also consistent with the recent position paper published by the European Society of Paediatric and Neonatal Intensive Care (ESPNIC), recommending use of CAPD to assess for pediatric delirium (grade of recommendation = A) every 8-12 hours(9). The CAPD is a well-validated observational 8-item tool that can reliably distinguish between pain, agitation, residual sedation, and delirium(8,9). A CAPD score of 9 or higher represents a positive screen; the diagnosis is then confirmed by the physician(8). Any developmentally delayed child who screened positive for delirium on the CAPD subsequently had the diagnosis of delirium confirmed (or refuted) by an intensivist or psychiatrist prior to being classified as delirious. (The clinician had to establish an alteration from mental status at prehospital baseline, in order to ensure that static encephalopathy - i.e.: the underlying developmental delay - was not confused with delirium).",
       "highlight": "each child was screened for delirium twice daily by the bedside nurse, at 6 am and 6 pm",
       "scope": "on-scope",
       "note": "Every admitted child was universally screened per shift (6 am/6 pm) with the CAPD, consistent with ESPNIC grade-A every 8-12 h; the every-age, over-the-shift default in practice.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      },
      {
       "context": "Consistent with our PICU standard, each child was screened for delirium twice daily by the bedside nurse, at 6 am and 6 pm, using the Cornell Assessment of Pediatric Delirium (CAPD)(8). This is also consistent with the recent position paper published by the European Society of Paediatric and Neonatal Intensive Care (ESPNIC), recommending use of CAPD to assess for pediatric delirium (grade of recommendation = A) every 8-12 hours(9). The CAPD is a well-validated observational 8-item tool that can reliably distinguish between pain, agitation, residual sedation, and delirium(8,9). A CAPD score of 9 or higher represents a positive screen; the diagnosis is then confirmed by the physician(8). Any developmentally delayed child who screened positive for delirium on the CAPD subsequently had the diagnosis of delirium confirmed (or refuted) by an intensivist or psychiatrist prior to being classified as delirious. (The clinician had to establish an alteration from mental status at prehospital baseline, in order to ensure that static encephalopathy - i.e.: the underlying developmental delay - was not confused with delirium).",
       "highlight": "The CAPD is a well-validated observational 8-item tool",
       "scope": "on-scope",
       "note": "Confirms the CAPD is a well-validated observational tool that distinguishes delirium from sedation/agitation; the paper's own aim (prevalence/mortality) is broader epidemiology.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      }
     ]
    }
   ],
   "synthesis": "The on-scope sources agree: Traube 2014 (the validation study, primary anchor) establishes the CAPD as a rapid observational nursing screen validated across all ages and developmental levels (0-21 yr, similar performance 0-13 yr) and completed midshift/once per shift, and Traube 2017, Smith 2016, and PANDEM 2022 independently confirm it is an observational tool scored over a nursing shift; Traube 2014 governs the \"default for every age (observational, over the shift)\" statement. Discrepancy is flagged because the nearest keyword matches are different-scope — Curley 2006 (SBS) is a sedation-depth scale, not a delirium screen, and the ps/pCAM-ICU are age-restricted, in-the-moment CAM tools — so they share vocabulary but do not support the every-age observational delirium-screen claim.",
   "discrepancy": true
  },
  {
   "id": "picu-wf-r8",
   "toolId": "picu-wf",
   "tool": "PICU Workflow",
   "page": "1",
   "section": "3 · Score the screen",
   "statement": "psCAM-ICU — dev. age 6 mo–5 yr · pCAM-ICU — chronological and dev. age ≥ 5 yr: point-in-time interactive screens.",
   "contentType": "Validated instrument wording",
   "sources": [
    "SCCM PANDEM 2022",
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "Lin 2023 (ICU Liberation)",
    "Traube 2017 (mortality)"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 15",
   "passage": "… Delirium Monitoring. Question: Which delirium screening tools have the best validity and reliability in critically ill pediatric patients? (SDC Section E2, http://links.lww.com/ PCC/B920). Answer: \"We recommend\" use of the preschool and pCAM-ICU (ps/pCAM-ICU) or the CAPD as the most valid and reliable delirium monitoring tools in critically ill pediatric patients (strong, high-level evidence). Rationale: Of five pediatric-specific delirium screening tools available, three are relevant to PICU patients (SDC Section E2b, http://links.lww.com/PCC/B920). The ps/pCAM-ICU are considered \"point-in-time\" assessments, using both observation and interactive components (241), and maintaining the basic foundation of its highly valid and reliable precursor, the adult Confusion Assessment Method for the ICU. The pCAM-ICU was originally validated in a prospective cohort of general medical/surgical PICU patients over 5 years old and performed with a high sensitivity (83%) and specificity (99%) compared with psychiatry assessment, and high interrater reliability (kappa of 0.96) (225). The preschool CAM-ICU psCAM-ICU is an adaptation of the pCAM-ICU for purposes of meeting the language and cognitive deficits in children developmentally less than 5 years old. …\nAlso Smith 2016 (psCAM-ICU): \"Participants aged 6 months to 5 years and admitted to the pediatric ICU\"\nPANDEM additionally notes the pCAM-ICU was validated in patients over 5 years and the psCAM-ICU in those under 5, consistent with the printed age ranges.",
   "evidence": "Full text, p. 15",
   "status": "fulltext",
   "pageNum": "15",
   "citations": [
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
    "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898."
   ],
   "links": [
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000003262",
    "https://doi.org/10.1097/CCM.0000000000002250"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary anchor (journal p. e88 / PDF p. 15): the delirium-monitoring recommendation directly states the point-in-time interactive nature and the >5-yr vs developmentally-<5-yr age split.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "The ps/pCAM-ICU are considered \"point-in-time\" assessments, using both observation and interactive components (241), and maintaining the basic foundation of its highly valid and reliable precursor, the adult Confusion Assessment Method for the ICU.",
       "highlight": "The ps/pCAM-ICU are considered \"point-in-time\" assessments, using both observation and interactive components",
       "scope": "on-scope",
       "note": "Directly supports both tools being point-in-time interactive screens.",
       "page": "e88 (PDF p. 15)",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "The pCAM-ICU was originally validated in a prospective cohort of general medical/surgical PICU patients over 5 years old and performed with a high sensitivity (83%) and specificity (99%) compared with psychiatry assessment, and high interrater reliability (kappa of 0.96) (225).",
       "highlight": "PICU patients over 5 years old",
       "scope": "on-scope",
       "note": "Supports the pCAM-ICU age assignment (>=5 yr).",
       "page": "e88 (PDF p. 15)",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "The preschool CAM-ICU psCAM-ICU is an adaptation of the pCAM-ICU for purposes of meeting the language and cognitive deficits in children developmentally less than 5 years old.",
       "highlight": "in children developmentally less than 5 years old",
       "scope": "on-scope",
       "note": "Supports the psCAM-ICU developmental-age framing (< 5 yr), the complement of the >=5-yr pCAM-ICU band.",
       "page": "e88 (PDF p. 15)",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Archived web source with no local text file; RASS is the arousal scale that gates whether a delirium screen is performed, cited by the Score-the-screen section rather than supporting the psCAM/pCAM age assignment.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest-topic but a different intervention: SBS is a sedation/arousal instrument for ventilated infants and young children, not one of the interactive point-in-time delirium screens the claim describes.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "The SBS was specifically designed for and tested in young intubated mechanically ventilated patients - a population who often experience extremes in level of sedation over their normal trajectory of illness. The tool reflects the presence and severity of the clinical conditions for which sedation is administered in this population. [20,36] We designed the SBS to require an evaluation of patient response to a progressive stimulus. This approach is familiar to intensive care clinicians as it is similar to the progressive stimulus performed during a neurological exam. We believe that appropriate levels of sedation should help the young patient through necessary care procedures that require a stimulated state while avoiding over-sedation when not stimulated.",
       "highlight": "The SBS was specifically designed for and tested in young intubated mechanically ventilated patients",
       "scope": "different-intervention",
       "note": "SBS measures the sedation-agitation continuum (a level-of-consciousness prerequisite), not delirium; it neither supports nor contradicts the psCAM/pCAM point-in-time claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Confirms the pCAM-ICU >5-yr restriction and its cooperation/interactive requirement, but its own tool (CAPD) is a different intervention — an observational nursing screen completed over a shift across all ages.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "children more than 5 years old, limited in patients with developmental delay, and requires extensive nurse training. The PAED (35) designed, for immediate postoperative use by anesthesiologists, selects for the hyperactive subtype of delirium. An ideal screening tool would detect all types of delirium (hyperactive, hypoactive, and mixed), in patients of all ages and developmental levels.",
       "highlight": "children more than 5 years old",
       "scope": "on-scope",
       "note": "The pCAM-ICU (an interactive cognitive tool requiring patient cooperation) is restricted to children more than 5 years old, matching the claim's pCAM-ICU age band.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "It is significant that 31% of our assessments were in children less than 2 years old, and 27% of our assessments were in children who are developmentally delayed. Our study indicates that the CAPD is a valid and reliable delirium screen in these vulnerable populations. The developmental anchor points for each item were a valuable point-of-use reference for assessing the youngest of patients. With the addition of these anchor points and minimal training, the critical care nursing staff became adept at using the CAPD in all but the most developmentally delayed patients. The nurses completed the assessment midshift, after several hours of observing the child's behavior. In every assessment, the nurses required less than 2 minutes to complete the CAPD screen.",
       "highlight": "The nurses completed the assessment midshift, after several hours of observing the child's behavior",
       "scope": "different-intervention",
       "note": "CAPD is an observational over-a-shift screen (all ages 0-21), the contrast to the interactive point-in-time psCAM/pCAM this claim describes.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Unarchived (no local text file); the original pCAM-ICU validation in children >5 yr, cited by section/DOI as the source instrument for the >=5-yr band.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The psCAM-ICU validation paper: supplies the 6-month-to-5-year enrollment range, the pCAM-ICU >5-yr comparison, and the 'in the moment' interactive framing that distinguishes these screens from over-a-shift tools.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "PATIENTS--Participants aged 6 months to 5 years and admitted to the pediatric ICU regardless of admission diagnosis were enrolled.",
       "highlight": "Participants aged 6 months to 5 years",
       "scope": "on-scope",
       "note": "Direct source for the psCAM-ICU 6 mo-5 yr age range.",
       "page": "p. 1 (abstract)",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "The Pediatric Confusion Assessment Method for the Intensive Care Unit (pCAM-ICU) was the first validated tool for objective delirium monitoring in critically ill children over 5 years of age, demonstrating a specificity of 99% and sensitivity of 83%. (6) The majority of pediatric ICU (PICU) patients are less than 5 years of age, in whom objective and interactive delirium monitoring is fraught with challenges as a result of variations in both language and cognitive development. Consequently, subjective and observational approaches to delirium screening in infants and young children have been validated. One such tool, the Cornell Assessment for Pediatric Delirium (CAPD) (8) was introduced as a subjective delirium screening tool in critically ill children with a reported specificity of 79% and sensitivity of 94%.",
       "highlight": "objective delirium monitoring in critically ill children over 5 years of age",
       "scope": "on-scope",
       "note": "Supports pCAM-ICU as the objective/interactive screen for children over 5 years of age.",
       "page": "p. 2",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "Despite the advances in pediatric delirium monitoring with the pCAM-ICU (objective, brief, in the moment assessment) and the CAPD (subjective scoring over a nursing shift), delirium remains under-recognized and poorly understood, especially among the very young. To address the challenges of delirium monitoring in pediatric patients, we designed this investigation 1) to create a principally objective and interactive, developmentally-targeted, delirium monitoring tool for critically ill infants and preschool-aged children, the Preschool Confusion Assessment Method for the ICU (psCAM-ICU); 2) to determine validity and reliability of objective delirium assessments using the psCAM-ICU; and 3) to simultaneously determine the prevalence of pediatric delirium in this population.",
       "highlight": "the pCAM-ICU (objective, brief, in the moment assessment)",
       "scope": "on-scope",
       "note": "'In the moment' = point-in-time; explicitly contrasted with CAPD 'subjective scoring over a nursing shift.'",
       "page": "p. 3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "Despite the advances in pediatric delirium monitoring with the pCAM-ICU (objective, brief, in the moment assessment) and the CAPD (subjective scoring over a nursing shift), delirium remains under-recognized and poorly understood, especially among the very young. To address the challenges of delirium monitoring in pediatric patients, we designed this investigation 1) to create a principally objective and interactive, developmentally-targeted, delirium monitoring tool for critically ill infants and preschool-aged children, the Preschool Confusion Assessment Method for the ICU (psCAM-ICU); 2) to determine validity and reliability of objective delirium assessments using the psCAM-ICU; and 3) to simultaneously determine the prevalence of pediatric delirium in this population.",
       "highlight": "a principally objective and interactive, developmentally-targeted, delirium monitoring tool",
       "scope": "on-scope",
       "note": "Establishes the psCAM-ICU as an objective and interactive screen for infants/preschool-aged children.",
       "page": "p. 3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "This study demonstrates that delirium monitoring using the psCAM-ICU is highly valid and reliable in critically ill infants and preschool-aged children. The long-form (research) psCAM-ICU demonstrated a high specificity (91%), sensitivity (75%), NPV (86%), and PPV (84%) compared to the reference standard. In post-hoc analysis, the short-form (clinical) psCAM-ICU, with fewer required assessment components for Features 2 and 4, demonstrated improved sensitivity (78%) and maintained a high specificity (86%), taking less than 2 minutes to complete. Additionally, the psCAM-ICU demonstrated excellent reliability with a kappa statistic of 0.79. Both the adult and pediatric ICU landscapes now have access to different lines of evidence-based practices by which to measure ICU delirium, one being a brief \"in the moment\" assessment (psCAM-ICU, pCAM-ICU, CAMICU) (6) (9) and the other being performed over a nursing shift (CAPD, ICDCS) (8) (22).",
       "highlight": "one being a brief \"in the moment\" assessment (psCAM-ICU, pCAM-ICU, CAMICU)",
       "scope": "on-scope",
       "note": "Groups psCAM-ICU/pCAM-ICU as brief in-the-moment (point-in-time) screens, distinct from over-a-nursing-shift tools (CAPD, ICDSC).",
       "page": "p. 8",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Lin 2023 (ICU Liberation)",
     "cite": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Unarchived (no local text file); ABCDEF-bundle pediatric collaborative, cited by section/DOI for implementation context, not for the tool-by-age assignment itself.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000003262",
     "paragraphs": []
    },
    {
     "label": "Traube 2017 (mortality)",
     "cite": "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest-topic epidemiology study but a different intervention: it screens with CAPD twice daily (observational), not the interactive point-in-time psCAM/pCAM the claim describes.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000002324",
     "paragraphs": [
      {
       "context": "Consistent with our PICU standard, each child was screened for delirium twice daily by the bedside nurse, at 6 am and 6 pm, using the Cornell Assessment of Pediatric Delirium (CAPD)(8). This is also consistent with the recent position paper published by the European Society of Paediatric and Neonatal Intensive Care (ESPNIC), recommending use of CAPD to assess for pediatric delirium (grade of recommendation = A) every 8-12 hours(9). The CAPD is a well-validated observational 8-item tool that can reliably distinguish between pain, agitation, residual sedation, and delirium(8,9). A CAPD score of 9 or higher represents a positive screen; the diagnosis is then confirmed by the physician(8). Any developmentally delayed child who screened positive for delirium on the CAPD subsequently had the diagnosis of delirium confirmed (or refuted) by an intensivist or psychiatrist prior to being classified as delirious. (The clinician had to establish an alteration from mental status at prehospital baseline, in order to ensure that static encephalopathy - i.e.: the underlying developmental delay - was not confused with delirium).",
       "highlight": "The CAPD is a well-validated observational 8-item tool",
       "scope": "different-intervention",
       "note": "Uses CAPD (observational, twice-daily) as the screen; contrasts with the interactive point-in-time psCAM/pCAM and does not address their age assignment.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      }
     ]
    }
   ],
   "synthesis": "The two on-scope sources agree and govern: the PANDEM 2022 guideline (primary) states the ps/pCAM-ICU are \"point-in-time\" assessments using observation and interactive components, with the pCAM-ICU validated in PICU patients over 5 years old and the psCAM-ICU adapted for children developmentally under 5, and Smith 2016 confirms the psCAM-ICU 6-month-to-5-year range plus the pCAM-ICU >5-year \"in the moment\" interactive design. The CAPD sources (Traube 2014, Traube 2017) and the SBS (Curley 2006) are nearest-topic but different interventions — CAPD is an observational over-a-shift/twice-daily screen and SBS a sedation-arousal scale — so they contrast with, rather than support, the interactive point-in-time framing.",
   "discrepancy": true
  },
  {
   "id": "picu-wf-r9",
   "toolId": "picu-wf",
   "tool": "PICU Workflow",
   "page": "1",
   "section": "3 · Score the screen",
   "statement": "Positive: CAPD ≥ 9, or CAM Feature 1 + 2 + (3 or 4).",
   "contentType": "Validated instrument wording",
   "sources": [
    "SCCM PANDEM 2022",
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "Lin 2023 (ICU Liberation)",
    "Traube 2017 (mortality)"
   ],
   "anchor": "Traube 2014 (CAPD) — p. 5",
   "passage": "… Developmental delay was a significant risk factor for delirium as children with developmental delay were diagnosed with delirium almost three times as often as children without delay (38.8% vs 13.9% of assessments, respectively). Prevalence of delirium in the \"sicker\" patients, as measured by Pediatric Index of Mortality II (PIM2) score above the median, was notably higher than in those children with PIM2 score below the median (29.7% vs 12.3%). This is consistent with prior pediatric delirium research (42). The lowest delirium prevalence was observed in children more than 13 years old (3.6%) and in children not on respiratory support (5.2%). CAPD Performance Cut point analysis showed the best sensitivity and specificity for the screening instrument (prioritizing high sensitivity) at a total CAPD score of 9 or greater. Sensitivity was 94.1% (95% CI, 83.8-98.8%) and specificity 79.2% (95% CI, 73.5-84.9%). At a cut point of greater than or equal to 9, there were three false-negative CAPD screens (Table 3) and 41 false-positive screens. Concordance between CAPD and psychiatric diagnosis was 82.3% (r = 0.62). Nurses' CAPD interrater reliability was also highest at a cut point of 9, with κ = 0.94. κ ranged from 0.68 to 0.78 for each of the eight CAPD items. CAPD performance compared with the \"gold standard\" psychiatric diagnosis by subgroups is reported in Table 4. …\nAlso Smith 2011 (pCAM-ICU): \"Pediatric CAM-ICU (pCAM-ICU):  DELIRIUM  =  Presence of FEATURES  1  +  2  +  either  3  or  4\"",
   "evidence": "Full text, p. 5",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
    "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898."
   ],
   "links": [
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000003262",
    "https://doi.org/10.1097/CCM.0000000000002250"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary source for the CAPD >= 9 positive threshold.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Cut point analysis showed the best sensitivity and specificity for the screening instrument (prioritizing high sensitivity) at a total CAPD score of 9 or greater. Sensitivity was 94.1% (95% CI, 83.8-98.8%) and specificity 79.2% (95% CI, 73.5-84.9%). At a cut point of greater than or equal to 9, there were three false-negative CAPD screens (Table 3) and 41 false-positive screens. Concordance between CAPD and psychiatric diagnosis was 82.3% (r = 0.62). Nurses' CAPD interrater reliability was also highest at a cut point of 9, with = 0.94. ranged from 0.68 to 0.78 for each of the eight CAPD items.",
       "highlight": "at a total CAPD score of 9 or greater",
       "scope": "on-scope",
       "note": "Directly establishes CAPD score of 9 or greater as the validated positive cutoff (sens 94.1%, spec 79.2%).",
       "page": "ms. p.5",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "Although each individual item in the tool may describe behaviors or symptoms that can be associated with other causes of cerebral dysfunction (such as sedation, agitation, pain, and anxiety), the combination of these items with a total cutoff score of 9 successfully selects for delirium.",
       "highlight": "a total cutoff score of 9 successfully selects for delirium",
       "scope": "on-scope",
       "note": "Reaffirms the total cutoff score of 9 as the delirium-selecting threshold.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope for the CAM algorithm: Feature 1 + 2 + (3 or 4).",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "An interdisciplinary team comprising of pediatric anesthesiology/critical care, neurodevelopmental pediatrics, and child and adolescent psychiatry developed the psCAMICU based on the hierarchical design of the pCAM-ICU and the CAM-ICU, (9) which required the following for delirium diagnosis: 1) fluctuation or acute change from baseline mental status, 2) inattention, and either 3) a current altered level of consciousness, or 4) presence of disorganized thinking. Valid pediatric neurocognitive assessments, (10) pain and behavior scales, (11) (12) and developmental milestones, (13) were reviewed and used as a guide to ensure the cognitive and consciousness assessments within the psCAM-ICU were appropriate for both infants and preschool-aged children. As with the adult CAM-ICU and pCAM-ICU, and in agreement with the recent DSM-V, the psCAM-ICU requires the presence of inattention, the most fundamental feature of delirium, and is based on objective and interactive patient assessments.",
       "highlight": "1) fluctuation or acute change from baseline mental status, 2) inattention, and either 3) a current altered level of consciousness, or 4) presence of disorganized thinking",
       "scope": "on-scope",
       "note": "States the hierarchical CAM-ICU/pCAM-ICU/psCAM-ICU diagnostic requirement matching Feature 1 + 2 + (3 or 4).",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "Delirium was diagnosed when patients demonstrated the presence of Feature 1 and Feature 2 plus either Feature 3 or 4.",
       "highlight": "the presence of Feature 1 and Feature 2 plus either Feature 3 or 4",
       "scope": "on-scope",
       "note": "Explicit feature-numbered statement of the CAM positivity algorithm cited in the claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Traube 2017 (mortality)",
     "cite": "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Corroborates CAPD >= 9 as a positive screen in an independent study.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000002324",
     "paragraphs": [
      {
       "context": "Consistent with our PICU standard, each child was screened for delirium twice daily by the bedside nurse, at 6 am and 6 pm, using the Cornell Assessment of Pediatric Delirium (CAPD)(8). This is also consistent with the recent position paper published by the European Society of Paediatric and Neonatal Intensive Care (ESPNIC), recommending use of CAPD to assess for pediatric delirium (grade of recommendation = A) every 8-12 hours(9). The CAPD is a well-validated observational 8-item tool that can reliably distinguish between pain, agitation, residual sedation, and delirium(8,9). A CAPD score of 9 or higher represents a positive screen; the diagnosis is then confirmed by the physician(8). Any developmentally delayed child who screened positive for delirium on the CAPD subsequently had the diagnosis of delirium confirmed (or refuted) by an intensivist or psychiatrist prior to being classified as delirious. (The clinician had to establish an alteration from mental status at prehospital baseline, in order to ensure that static encephalopathy - i.e.: the underlying developmental delay - was not confused with delirium).",
       "highlight": "A CAPD score of 9 or higher represents a positive screen",
       "scope": "on-scope",
       "note": "Directly restates the CAPD >= 9 positive-screen threshold used at the bedside.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      }
     ]
    },
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Guideline that endorses the two instrument families the workflow uses, without restating the numeric cut points.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "1) We recommend use of the preschool and pediatric Confusion Assessment Methods for the ICU or the Cornell Assessment for Pediatric Delirium as the most valid and reliable delirium monitoring tools in critically ill pediatric patients.",
       "highlight": "the most valid and reliable delirium monitoring tools in critically ill pediatric patients",
       "scope": "broader",
       "note": "Recommends ps/pCAM-ICU or CAPD as the validated tools (tool selection), a level above the specific CAPD >= 9 / CAM algorithm cut points.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest different-scope match: the State Behavioral Scale is a sedation-assessment (arousal) instrument, not a delirium-positivity rule.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Objective--To develop and test the reliability and validity of the State Behavioral Scale (SBS) for use in describing sedation/agitation levels in young intubated patients supported on mechanical ventilation.",
       "highlight": "for use in describing sedation/agitation levels in young intubated patients supported on mechanical ventilation",
       "scope": "different-intervention",
       "note": "SBS scores the sedation-agitation continuum (the arousal gate before screening), not the CAPD/CAM delirium positivity threshold the claim states.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Cited by the workflow's Score-the-screen section as the arousal scale that gates delirium screening; does not itself define the CAPD/CAM positivity rule.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Original pCAM-ICU validation (children >5y) that defines the same CAM Feature 1 + 2 + (3 or 4) algorithm; cited by section/DOI, not archived here.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Lin 2023 (ICU Liberation)",
     "cite": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Pediatric ICU Liberation (ABCDEF) collaborative; cited as implementation context for the bundled screening workflow, not the scoring cut points.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000003262",
     "paragraphs": []
    }
   ],
   "synthesis": "The on-scope sources agree and jointly cover both halves of the rule: Traube 2014 (primary) validated CAPD >= 9 as the positive threshold (94% sensitivity / 79% specificity) and Traube 2017 restates \"a CAPD score of 9 or higher represents a positive screen,\" while Smith 2016 (psCAM-ICU) defines the CAM algorithm as Feature 1 and Feature 2 plus either Feature 3 or 4 — together matching the claim exactly. PANDEM 2022 endorses the ps/pCAM-ICU and CAPD instruments at a broader tool-selection level rather than restating the cut points, and the nearest different-scope match, Curley 2006's State Behavioral Scale, is a sedation-assessment instrument (the arousal gate applied before screening), not a delirium-positivity rule.",
   "discrepancy": true
  },
  {
   "id": "picu-wf-r10",
   "toolId": "picu-wf",
   "tool": "PICU Workflow",
   "page": "1",
   "section": "4 · Act on the result",
   "statement": "Negative → keep the prevention bundle going; rescreen next shift.",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM PANDEM 2022",
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "Lin 2023 (ICU Liberation)",
    "Traube 2017 (mortality)"
   ],
   "anchor": "Traube 2014 (CAPD) — p. 8",
   "passage": "For study purposes, the CAPD and psychiatric evaluations happened during the daylight hours, at approximately noon each day. To more accurately capture delirious patients, who may be more symptomatic at night, the CAPD will need to be performed a minimum of twice daily, once by each shift nurse. SUMMARY The CAPD is a promising new clinical screening tool designed and validated for use in the PICU setting to detect delirium in most children. Future work will address further clinical applications of the CAPD, such as diagnostic algorithms for special populations in which delirium diagnoses are challenging. The CAPD may facilitate the development of much needed research investigating the causes, pathophysiology, treatment, and long-term implications of pediatric delirium. Acknowledgments This work was performed at Weill Cornell Medical College/NY Presbyterian Hospital. Drs. Traube and Greenwald received support for travel from Weill Cornell Medical College. Dr. …\nAlso SCCM PANDEM 2022: \"optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct patient care\"\nTraube 2014 supports rescreening each shift, and PANDEM's nonpharmacologic prevention strategies support continuing the bundle. Neither source frames prevention as conditional on a negative screen — it is recommended universally — so support for the compound statement is partial.",
   "evidence": "Full text, p. 8 — partial support",
   "status": "fulltext",
   "pageNum": "8",
   "citations": [
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
    "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898."
   ],
   "links": [
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000003262",
    "https://doi.org/10.1097/CCM.0000000000002250"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Guideline endorses both halves of the step: routine delirium monitoring with validated tools and a nonpharmacologic prevention bundle; broader than the specific shift cadence.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "We now recognize that ICU delirium is highly prevalent among critically ill children, with predominance of the hypoactive subtype which is most easily missed without routine screening.",
       "highlight": "which is most easily missed without routine screening",
       "scope": "on-scope",
       "note": "Rationale for implementing routine (repeated) delirium screening in the PICU — the practice the rescreen-next-shift step enacts.",
       "page": "e88",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "3) Given low patient risk, and possible patient benefit to reduce the incidence and/or decrease duration or severity of delirium we suggest the following non-pharmacologic strategies: optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct-patient care.",
       "highlight": "optimization of sleep hygiene, use of interdisciplinary rounds, family engagement on rounds, and family involvement with direct-patient care",
       "scope": "on-scope",
       "note": "The guideline's nonpharmacologic prevention recommendation — the content of the prevention bundle that a negative screen means you keep going.",
       "page": "e77",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "ICU care bundles, including the ICU Liberation ABCDEF bundle, provide a new paradigm for liberating critically ill patients from mechanical ventilation (MV) and ICU environment, while optimizing post-ICU outcomes (1, 2). Despite growing appreciation of this bundled patient care approach, PICU sedation and analgesia practices remain highly variable (3-5). Although valuable, previous pain/agitation/delirium guidelines (6, 7) have provided only limited guidance in the areas of prevention and management strategies for these conditions.",
       "highlight": "ICU care bundles, including the ICU Liberation ABCDEF bundle",
       "scope": "background",
       "note": "Introduces the ABCDEF bundle that the workflow's prevention bundle is built on; framing context rather than the specific recommendation.",
       "page": "e75",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Cited for the RASS arousal scale that gates delirium assessment; does not address rescreening cadence or the prevention bundle. Cited by section/journal reference.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Nearest match on assessment frequency, but it is a sedation-depth scale, not a delirium screen; it does not address delirium rescreening or a prevention bundle.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "We recommended that sedation assessment be completed at the start of normal cares at a frequency that aligns with the patient's clinical state. The Joint Commission for the Accreditation of Hospitals suggests that pain scoring be considered the 5th vital sign. [38] We suggest that sedation scoring should be completed with the patient's pain assessment every four hours and also before and after an intervention that impacts the patient's level of sedation.",
       "highlight": "sedation scoring should be completed with the patient's pain assessment every four hours and also before and after an intervention that impacts the patient's level of sedation",
       "scope": "different-intervention",
       "note": "Shares the keyword 'assessment frequency' but sets the every-4-hour cadence for the State Behavioral Scale (depth of sedation/agitation), not delirium rescreening — must not be read as support for the rescreen step.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary source: directly recommends serial CAPD screening on each shift, governing the rescreen-next-shift cadence.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "For study purposes, the CAPD and psychiatric evaluations happened during the daylight hours, at approximately noon each day. To more accurately capture delirious patients, who may be more symptomatic at night, the CAPD will need to be performed a minimum of twice daily, once by each shift nurse.",
       "highlight": "the CAPD will need to be performed a minimum of twice daily, once by each shift nurse.",
       "scope": "on-scope",
       "note": "The explicit cadence recommendation — CAPD a minimum of twice daily, once by each shift nurse — directly supports rescreening on the next shift.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "With a sensitivity of 94.1%, the CAPD produced three false negatives out of 248 assessments. Of these (Table 3), two of the three children screened positive on a prior or subsequent CAPD. By performing the screen twice daily, these subjects would have been detected. Because one of these children had significant developmental delay, and the other a preexisting psychiatric illness, it is possible that these factors complicated the nursing assessment. The third screen may not have been performed accurately as it conflicts with the psychiatric assessment in many item responses. Larger studies are needed to further assess factors that confound detection of delirium.",
       "highlight": "By performing the screen twice daily, these subjects would have been detected",
       "scope": "on-scope",
       "note": "Serial twice-daily screening would have caught false negatives a single screen missed — the rationale for rescreening after a negative result.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU validation (children >5y) — one of the recommended delirium monitoring tools the rescreen step uses; full text unarchived. Cited by section/DOI.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Validates a delirium monitoring tool and supports serial reassessment, but in a narrower population and without specifying a shift cadence.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "The approach for delirium diagnosis differs among available bedside tools which allow clinicians a choice in deciding on a tool that best fits their needs, based on resources, and ease of implementation in their particular ICUs. For instance, the CAPD applies scoring of observations over time to screen for delirium, providing an opportunity for the detection of subtle changes in patient behaviors which may not be picked up by an \"in the moment\" delirium screening test. However, the CAPD requires anchor points for each developmental stage as one is assessing for a range of behavior from normal to varied levels of abnormal. To be done appropriately this detailed assessment using the CAPD takes time. In contrast, the psCAM-ICU does not require developmental anchor points as the tool assesses for the lowest common denominator which would be considered abnormal for the broader cohort. The psCAM-ICU is unique as a fast and largely objective delirium assessment tool that requires the presence of inattention, the most fundamental feature of delirium. Additionally, the psCAM-ICU can be used to detect abrupt changes in brain function during shock, respiratory insufficiency, or even indolent disease processes, and subsequently be used for efficient reassessment to reflect acute delirium resolution following appropriate interventions.",
       "highlight": "efficient reassessment to reflect acute delirium resolution following appropriate interventions",
       "scope": "narrower",
       "note": "Supports serial reassessment with a validated delirium tool, but validated specifically in critically ill infants/preschool (<5y) and does not state a rescreen cadence — narrower than the general PICU step.",
       "page": "ms. p.9",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "This study demonstrates that delirium monitoring using the psCAM-ICU is highly valid and reliable in critically ill infants and preschool-aged children. The long-form (research) psCAM-ICU demonstrated a high specificity (91%), sensitivity (75%), NPV (86%), and PPV (84%) compared to the reference standard. In post-hoc analysis, the short-form (clinical) psCAM-ICU, with fewer required assessment components for Features 2 and 4, demonstrated improved sensitivity (78%) and maintained a high specificity (86%), taking less than 2 minutes to complete. Additionally, the psCAM-ICU demonstrated excellent reliability with a kappa statistic of 0.79. Both the adult and pediatric ICU landscapes now have access to different lines of evidence-based practices by which to measure ICU delirium, one being a brief \"in the moment\" assessment (psCAM-ICU, pCAM-ICU, CAMICU) (6) (9) and the other being performed over a nursing shift (CAPD, ICDCS) (8) (22).",
       "highlight": "performed over a nursing shift (CAPD, ICDCS)",
       "scope": "background",
       "note": "Characterizes the CAPD as scored over a nursing shift — the per-shift observation window the rescreen step relies on.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Lin 2023 (ICU Liberation)",
     "cite": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Pediatric ICU Liberation ABCDEF bundle collaborative — the prevention bundle the 'keep the bundle going' half of the step refers to; full text unarchived. Cited by section.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000003262",
     "paragraphs": []
    },
    {
     "label": "Traube 2017 (mortality)",
     "cite": "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "A prevalence study, but its screening protocol operationalizes twice-daily each-shift CAPD screening and cites the ESPNIC every-8-12-hour recommendation — directly on point for the rescreen cadence.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000002324",
     "paragraphs": [
      {
       "context": "Consistent with our PICU standard, each child was screened for delirium twice daily by the bedside nurse, at 6 am and 6 pm, using the Cornell Assessment of Pediatric Delirium (CAPD)(8). This is also consistent with the recent position paper published by the European Society of Paediatric and Neonatal Intensive Care (ESPNIC), recommending use of CAPD to assess for pediatric delirium (grade of recommendation = A) every 8-12 hours(9). The CAPD is a well-validated observational 8-item tool that can reliably distinguish between pain, agitation, residual sedation, and delirium(8,9). A CAPD score of 9 or higher represents a positive screen; the diagnosis is then confirmed by the physician(8). Any developmentally delayed child who screened positive for delirium on the CAPD subsequently had the diagnosis of delirium confirmed (or refuted) by an intensivist or psychiatrist prior to being classified as delirious. (The clinician had to establish an alteration from mental status at prehospital baseline, in order to ensure that static encephalopathy - i.e.: the underlying developmental delay - was not confused with delirium).",
       "highlight": "recommending use of CAPD to assess for pediatric delirium (grade of recommendation = A) every 8-12 hours",
       "scope": "on-scope",
       "note": "Twice-daily bedside CAPD screening tied to the ESPNIC every-8-12-hour (each-shift) recommendation — directly supports rescreening next shift.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      },
      {
       "context": "Setting--Urban academic tertiary care pediatric intensive care unit (PICU). Patients--All consecutive admissions from September 2014 through August 2015. Intervention--Children were screened for delirium twice daily throughout their ICU stay. Measurements and Main Results--Of 1547 consecutive patients, delirium was diagnosed in 267 (17%), and lasted a median of two days (IQR 1,5). Seventy-eight percent of children with delirium developed it within the first three PICU days. Most cases of delirium were of the hypoactive (46%) and mixed (45%) subtypes; only 8% of delirium episodes were characterized as hyperactive delirium. In multivariable analysis, independent predictors of delirium included age 2 years, developmental delay, severity of illness, prior coma, mechanical ventilation, and receipt of benzodiazepines and anticholinergics. PICU LOS was increased in children with delirium (adjusted relative LOS 2.3, CI= 2.1, 2.5, p<0.001), as was duration of MV (median 4 vs. 1 day, p<0.001). Delirium was a strong and independent predictor of mortality (adjusted OR 4.39, CI= 1.96-9.99, p<0.001). Conclusions--Delirium occurs frequently in critically ill children and is independently associated with mortality. Some in-hospital risk factors for delirium development are modifiable. Interventional studies are needed to determine best practices to limit delirium exposure in at-risk children.",
       "highlight": "Children were screened for delirium twice daily throughout their ICU stay",
       "scope": "on-scope",
       "note": "Protocol was twice-daily screening for the full ICU stay — i.e., repeated each shift, not a one-time screen.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      },
      {
       "context": "Consistent with the literature, many children were delirious during their first few PICU days. Without routine screening, these children, as well as children with hypoactive delirium, are likely underdiagnosed(29). This is of great clinical significance, as screening facilitates detection which allows for earlier intervention, and may lead to a decrease in delirium duration(30).",
       "highlight": "screening facilitates detection which allows for earlier intervention",
       "scope": "on-scope",
       "note": "Rationale that routine (repeated) screening enables earlier detection and intervention — supports why a negative screen is followed by rescreening rather than stopping.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      }
     ]
    }
   ],
   "synthesis": "The on-scope sources agree. Traube 2014 (CAPD, p. 8) is the primary and governs the specific cadence — CAPD performed a minimum of twice daily, once by each shift nurse — with Traube 2017 corroborating twice-daily each-shift CAPD screening (and citing the ESPNIC every-8-12-hour recommendation), and PANDEM 2022 endorsing routine delirium monitoring plus a nonpharmacologic (ICU Liberation) prevention bundle at guideline level. Curley 2006 is the nearest match on assessment frequency but a different intervention — the State Behavioral Scale's every-4-hour sedation-scoring cadence is not delirium rescreening — so it must not be read as direct support.",
   "discrepancy": true
  },
  {
   "id": "picu-wf-r11",
   "toolId": "picu-wf",
   "tool": "PICU Workflow",
   "page": "1",
   "section": "4 · Act on the result",
   "statement": "Positive → rule out withdrawal (WAT-1); find and fix precipitants; bundle levers first — drugs treat symptoms only.",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM PANDEM 2022",
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "Lin 2023 (ICU Liberation)",
    "Traube 2017 (mortality)"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 16",
   "passage": "… Family presence and involvement, familiar care team members, and comforting objects from home can also help reassure and reorient patients. Studies in critically ill adults have shown decreased occurrence rate and duration of delirium with implementation of EM. A single-center prospective study indirectly supports potential effectiveness of this approach in children. Over a 22-month period, phased implementation of protocolized sedation followed by EM was associated with a near 40% reduction in delirium rates (224). Mitigation of delirium is often achieved by resolution of the underlying critical illness or other contributing medical conditions. Therefore, the initial steps in delirium management should focus on identification and treatment of these underlying etiologies (231, 239, 240, 247-249). Differential diagnoses should be considered using a model such as Bring oxygen, Remove/ Reduce deliriogenic drugs, patient Atmosphere, Immobilization, New organ dysfunction, Metabolic disturbances, Awake, Pain, Sedation (SDC Table 19, http://links.lww.com/PCC/B920) (247). Pharmacologic management of delirium Question: What \"pharmacologic\" sedation strategies reduce the incidence and/or decrease the duration or severity of delirium in critically ill pediatric patients? Answer: 1) \"We recommend\" minimizing benzodiazepine-based sedation when feasible in critically ill pediatric patients to\nPANDEM's initial management steps (identify and treat underlying etiologies; the BRAIN-MAPS differential) support 'find and fix precipitants; bundle levers first.' The guideline also recommends the WAT-1 or Sophia Observation Scale for withdrawal assessment (pp. 5, 18) and warns that sedating for delirium symptoms further exacerbates them, supporting the WAT-1 step and 'drugs treat symptoms only.'",
   "evidence": "Full text, p. 16",
   "status": "fulltext",
   "pageNum": "16",
   "citations": [
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
    "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898."
   ],
   "links": [
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000003262",
    "https://doi.org/10.1097/CCM.0000000000002250"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "Mitigation of delirium is often achieved by resolution of the underlying critical illness or other contributing medical conditions. Therefore, the initial steps in delirium management should focus on identification and treatment of these underlying etiologies (231, 239, 240, 247-249).",
       "highlight": "the initial steps in delirium management should focus on identification and treatment of these underlying etiologies",
       "scope": "on-scope",
       "note": "Guideline: delirium is mitigated by resolving underlying illness, so first steps target identifying/treating underlying etiologies — supports 'find and fix precipitants'.",
       "page": "e89",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "As antipsychotics do not \"treat\" the cause(s) of delirium, vigilance to identify and modify exacerbating factors remains key.",
       "highlight": "As antipsychotics do not \"treat\" the cause(s) of delirium, vigilance to identify and modify exacerbating factors remains key.",
       "scope": "on-scope",
       "note": "Antipsychotics do not treat delirium's cause; vigilance to identify and modify exacerbating factors remains key — supports 'bundle levers first; drugs treat symptoms only'.",
       "page": "e89",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "1) \"We recommend\" use of either the Withdrawal Assessment Tool-1 (WAT-1) or Sophia Observation Scale (SOS) for the assessment of IWS due to opioid or benzodiazepine withdrawal in critically ill pediatric patients (strong, moderate-level evidence).",
       "highlight": "use of either the Withdrawal Assessment Tool-1 (WAT-1) or Sophia Observation Scale (SOS) for the assessment of IWS",
       "scope": "on-scope",
       "note": "Strong recommendation for WAT-1 (or SOS) to assess iatrogenic opioid/benzodiazepine withdrawal — the tool named in \"rule out withdrawal (WAT-1).\"",
       "page": "e90",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "to be unique to alpha2-agonist withdrawal, especially otherwise unexplained hypertension and tachycardia (264, 266, 274-276, 278) (SDC Table 22, http://links. lww.com/PCC/B920). As opioids and benzodiazepines may also be administered concurrently with alpha2agonists, overlap of IWS symptoms across all three agent classes may make identification of the agent(s) responsible for IWS development challenging, prevent correct diagnosis, and, thus, prompt initiation of appropriate mitigation strategies. Common to IWS from all agents, the relative nonspecificity of symptoms may also prevent identification of pain, nonwithdrawal based agitation, and delirium, which may further delay appropriately directed interventions (6, 115).",
       "highlight": "the relative nonspecificity of symptoms may also prevent identification of pain, nonwithdrawal based agitation, and delirium",
       "scope": "on-scope",
       "note": "Withdrawal symptoms overlap with and can mask delirium — the rationale for ruling out withdrawal when acting on a positive delirium screen.",
       "page": "e90",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "RASS validation, cited in the \"act on the result\" section as the arousal/sedation scale applied before delirium assessment; it does not address the positive-delirium management steps.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Ensuring the comfort of critically ill infants and children is integral to the practice of pediatric critical care. Humane pediatric intensive care often includes the administration of sedatives, once pain, physiologic imbalance and environmental stressors have been addressed.[1] Over 90% of infants and children supported on mechanical ventilation receive some form of sedative therapy. [2] Sedation in this patient population is required for anxiolysis, amnesia, facilitation of care, patient safety in avoidance of adverse events and for decreasing oxygen consumption. For most young patients supported on mechanical ventilation, the goal of sedation is to attain a calm but responsive state [2,3] that protects the young patient from self-harm. Inadequate sedation is associated with potentially dangerous complications such as unplanned endotracheal extubation. [4] High-dose, long-term, and continuous intravenous sedation has been associated with prolonged weaning from mechanical ventilation and/or withdrawal syndrome. [5-7] Therefore, insufficient or excessive sedation is likely to add to the personal and financial burden of intensive care.",
       "highlight": "administration of sedatives, once pain, physiologic imbalance and environmental stressors have been addressed",
       "scope": "different-intervention",
       "note": "SBS is a sedation-assessment scale; its ladder of addressing pain/physiologic/environmental stressors before sedatives is a keyword-adjacent nearest match but concerns sedation dosing, not delirium management — must not be read as direct support.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Delirium is acute cerebral dysfunction caused by systemic illness or the effects of treatment (1). There is an urgent need for pediatric-specific research into delirium (2-5). Recognition of delirium in children in the PICU has been suboptimal; therefore, the impact of delirium and therapeutic interventions have been understudied (6-9). Pediatric delirium is associated with increased length of PICU stay (10), posttraumatic symptoms (11), and possible neurocognitive dysfunction in children after discharge (12, 13). A growing body of literature in adult critical care describes delirium as exacerbated by the use of various sedative medications and has identified risk factors that predispose to delirium (5, 14-17). An impediment to the progress of pediatric delirium research has been the absence of an easily administered and widely applicable screening tool.",
       "highlight": "Delirium is acute cerebral dysfunction caused by systemic illness or the effects of treatment",
       "scope": "background",
       "note": "CAPD is the screening tool that produces the positive result; the paper defines delirium as caused by systemic illness/treatment effects (conceptual backdrop for \"find the cause\") but gives no management steps.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU validation, cited as the confirmatory delirium diagnostic tool for the positive screen; it does not address the post-positive management pathway.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "The specific associations between delirium and outcomes have not been delineated in children, though critically ill children who survive to home demonstrate decreases in spatial and verbal memory, inability to sustain attention, (23) have significantly longer school absences, (24) and demonstrate executive dysfunction months after discharge. (25) It is possible that elements of critical illness or management factors may contribute to these worse patient outcomes. Of these, sedation practices may be a modifiable risk factor for the development of delirium just as it has been reported in adults. (26) (27) (28) This is a poignant supposition given that 90% of pediatric patients are supported on sedative infusions, including high dose benzodiazepines, during mechanical ventilation. (29) In fact, benzodiazepine administration in critically ill children has previously been associated with the development of post-traumatic stress disorder and delusional memories following critical illness. (30) Using delirium tools such as the psCAM-ICU and pCAM-ICU, novel investigations can be conducted to answer key questions related to highly prevalent sedation practices and brain dysfunction outcomes (acute and long-term) in our sickest children.",
       "highlight": "sedation practices may be a modifiable risk factor for the development of delirium",
       "scope": "background",
       "note": "psCAM-ICU is the preschool screening tool; it notes sedation as a modifiable risk factor (prevention/risk framing, background) but does not lay out the positive-result action steps.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Lin 2023 (ICU Liberation)",
     "cite": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Pediatric ICU Liberation (ABCDEF) bundle collaborative, cited as the source for the \"bundle levers\" referenced in the statement.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000003262",
     "paragraphs": []
    },
    {
     "label": "Traube 2017 (mortality)",
     "cite": "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000002324",
     "paragraphs": [
      {
       "context": "Although as yet there are few evidence-based treatment strategies for delirium, we suggest the following three-pronged approach: investigating for underlying illness, iatrogenic causes, and abnormal environment. When delirium is diagnosed, the clinician should first assess for underlying illness that may have precipitated the delirium (as examples: a new urinary tract infection, or hypoxia). Then, investigation into iatrogenic causes is necessary (for instance, does the patient have evidence of opiate withdrawal?). Finally, environmental causes should be recognized and modified as able (mobilization of a bed-bound patient, attempts at creating an environment that promotes sleep, etc...) (6, 21, 45). For those children who remain delirious after the clinician has addressed these factors, pharmacologic treatment may be considered. The atypical antipsychotics (in particular, quetiapine) have been used safely for treatment of delirium in critically ill children (46-48).",
       "highlight": "When delirium is diagnosed, the clinician should first assess for underlying illness that may have precipitated the delirium",
       "scope": "on-scope",
       "note": "On a positive screen the clinician first assesses for the underlying illness that precipitated the delirium — directly supports \"find and fix precipitants.\"",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      },
      {
       "context": "Although as yet there are few evidence-based treatment strategies for delirium, we suggest the following three-pronged approach: investigating for underlying illness, iatrogenic causes, and abnormal environment. When delirium is diagnosed, the clinician should first assess for underlying illness that may have precipitated the delirium (as examples: a new urinary tract infection, or hypoxia). Then, investigation into iatrogenic causes is necessary (for instance, does the patient have evidence of opiate withdrawal?). Finally, environmental causes should be recognized and modified as able (mobilization of a bed-bound patient, attempts at creating an environment that promotes sleep, etc...) (6, 21, 45). For those children who remain delirious after the clinician has addressed these factors, pharmacologic treatment may be considered. The atypical antipsychotics (in particular, quetiapine) have been used safely for treatment of delirium in critically ill children (46-48).",
       "highlight": "does the patient have evidence of opiate withdrawal?",
       "scope": "on-scope",
       "note": "Second prong is investigating iatrogenic causes, explicitly opiate withdrawal — supports \"rule out withdrawal.\"",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      },
      {
       "context": "Although as yet there are few evidence-based treatment strategies for delirium, we suggest the following three-pronged approach: investigating for underlying illness, iatrogenic causes, and abnormal environment. When delirium is diagnosed, the clinician should first assess for underlying illness that may have precipitated the delirium (as examples: a new urinary tract infection, or hypoxia). Then, investigation into iatrogenic causes is necessary (for instance, does the patient have evidence of opiate withdrawal?). Finally, environmental causes should be recognized and modified as able (mobilization of a bed-bound patient, attempts at creating an environment that promotes sleep, etc...) (6, 21, 45). For those children who remain delirious after the clinician has addressed these factors, pharmacologic treatment may be considered. The atypical antipsychotics (in particular, quetiapine) have been used safely for treatment of delirium in critically ill children (46-48).",
       "highlight": "For those children who remain delirious after the clinician has addressed these factors, pharmacologic treatment may be considered",
       "scope": "on-scope",
       "note": "Pharmacologic treatment is considered only after precipitating, iatrogenic and environmental factors are addressed — supports \"bundle levers first; drugs treat symptoms only.\"",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      }
     ]
    }
   ],
   "synthesis": "The two on-scope sources agree fully: SCCM PANDEM 2022 (the governing PICU guideline) directs that initial delirium management target identifying and treating underlying etiologies (BRAIN MAPS), recommends WAT-1/SOS to assess iatrogenic withdrawal, and states antipsychotics \"do not treat the cause(s)\" — reserved for refractory/severe delirium and used only alongside/after low-risk nonpharmacologic measures; Traube 2017 independently prescribes the same sequence (assess precipitating illness, then iatrogenic causes including opiate withdrawal, then environment, with drugs only if the child remains delirious after these are addressed). PANDEM governs as the primary source and Traube 2017 concurs; the screening/arousal tools (CAPD, psCAM-ICU, pCAM-ICU, RASS) and the ICU Liberation bundle are cited as the assessment/bundle machinery, not the positive-result action steps, and Curley's SBS is a keyword-adjacent sedation scale (different intervention) that must not be read as support for the delirium-management statement.",
   "discrepancy": true
  },
  {
   "id": "picu-wf-r12",
   "toolId": "picu-wf",
   "tool": "PICU Workflow",
   "page": "1",
   "section": "10-second rounds script",
   "statement": "Target arousal (unit RASS / SBS goal for this child)",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM PANDEM 2022",
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "Lin 2023 (ICU Liberation)",
    "Traube 2017 (mortality)"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 10",
   "passage": "… Although the RASS has only been validated in a single trial, it is extensively used in pediatric critical care as it forms the basis for determining the appropriateness of delirium screening with the pediatric Confusion Assessment Method for the ICU (pCAM-ICU) and Cornell Assessment of Pediatric Delirium (CAPD) delirium screening tools (122). Characteristics of each sedation assessment scale are described in detail in SDC Table 6 (http://links.lww. com/PCC/B920). Protocolized Sedation. Question: Should critically ill pediatric patients requiring MV routinely be assigned a target depth of sedation? (SDC Section C2, http://links.lww.com/ PCC/B920). Answer: \"We suggest\" that all pediatric patients requiring MV be assigned a target depth of sedation using a validated sedation assessment tool at least once daily (conditional, low-level evidence). Rationale: Two studies assessing the impact of goaldirected sedation concluded that targeting a sedation score may minimize time the patient is agitated (123, 124). Although a larger multicenter RCT found no difference in rates of inadequate sedation or analgesia, the intervention group in this study was exposed to interventions beyond just targeting sedation depth (69). Question: Is protocolized sedation superior to nonprotocolized sedation in critically ill pediatric patients? …\nPANDEM supports assigning a target depth of sedation using a validated tool such as the RASS or SBS. The statement is an organizational rounds prompt rather than a specific clinical threshold.",
   "evidence": "Full text, p. 10 — partial support",
   "status": "fulltext",
   "pageNum": "10",
   "citations": [
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
    "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898."
   ],
   "links": [
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000003262",
    "https://doi.org/10.1097/CCM.0000000000002250"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope governing guideline: recommends SBS/RASS to assess sedation level and suggests assigning a target depth of sedation using a validated tool at least daily (p. e83 / PDF p.10, matching the primary anchor).",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "\"We suggest\" that all pediatric patients requiring MV be assigned a target depth of sedation using a validated sedation assessment tool at least once daily (conditional, low-level evidence).",
       "highlight": "all pediatric patients requiring MV be assigned a target depth of sedation using a validated sedation assessment tool at least once daily",
       "scope": "on-scope",
       "note": "Directly supports the statement: assign a per-patient target depth of sedation using a validated sedation tool — i.e. a RASS/SBS goal for this child.",
       "page": "e83",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "We recommend the use of the COMFORT-B Scale or the State Behavioral Scale, to assess level of sedation in mechanically ventilated pediatric patients.",
       "highlight": "the State Behavioral Scale, to assess level of sedation in mechanically ventilated pediatric patients",
       "scope": "on-scope",
       "note": "Recommends the SBS (or COMFORT-B) as the validated sedation scale, underpinning the SBS goal in the statement.",
       "page": "e83",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "2) \"We suggest\" the use of the Richmond Agitation-Sedation Scale (RASS) to assess level of sedation in mechanically ventilated pediatric patients (conditional, low-level evidence).",
       "highlight": "the use of the Richmond Agitation-Sedation Scale (RASS) to assess level of sedation in mechanically ventilated pediatric patients",
       "scope": "on-scope",
       "note": "Conditional recommendation for RASS as the validated sedation scale, underpinning the RASS goal; rationale also notes RASS forms the basis for delirium screening.",
       "page": "e83",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Origin/validation of the Richmond Agitation-Sedation Scale named in the statement; the RASS source referenced by PANDEM 2022 and the pediatric delirium tools. Cited by section/journal reference; no file to quote.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope SBS validation/definition in young intubated mechanically ventilated PICU patients — the instrument and sedation-goal concept behind an SBS target.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Ensuring the comfort of critically ill infants and children is integral to the practice of pediatric critical care. Humane pediatric intensive care often includes the administration of sedatives, once pain, physiologic imbalance and environmental stressors have been addressed.[1] Over 90% of infants and children supported on mechanical ventilation receive some form of sedative therapy. [2] Sedation in this patient population is required for anxiolysis, amnesia, facilitation of care, patient safety in avoidance of adverse events and for decreasing oxygen consumption. For most young patients supported on mechanical ventilation, the goal of sedation is to attain a calm but responsive state [2,3] that protects the young patient from self-harm. Inadequate sedation is associated with potentially dangerous complications such as unplanned endotracheal extubation. [4] High-dose, long-term, and continuous intravenous sedation has been associated with prolonged weaning from mechanical ventilation and/or withdrawal syndrome. [5-7] Therefore, insufficient or excessive sedation is likely to add to the personal and financial burden of intensive care.",
       "highlight": "the goal of sedation is to attain a calm but responsive state",
       "scope": "on-scope",
       "note": "States the sedation goal (calm but responsive state) that a per-child SBS target operationalizes.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      },
      {
       "context": "Objective--To develop and test the reliability and validity of the State Behavioral Scale (SBS) for use in describing sedation/agitation levels in young intubated patients supported on mechanical ventilation.",
       "highlight": "describing sedation/agitation levels in young intubated patients supported on mechanical ventilation",
       "scope": "on-scope",
       "note": "Defines the SBS and its population/purpose — describing sedation/agitation level — the scale by which the goal is set.",
       "page": "ms. p.1",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      },
      {
       "context": "Valid and reliable tools that standardize the description of a pediatric patient's behavioral state while supported on mechanical ventilation would enhance systematic assessment and documentation of a patient's response to sedation, allow patient-specific alterations in the therapeutic regimen, and help avoid insufficient or excessive sedative use. [13,14] Such an assessment tool would enhance interdisciplinary agreement on the desired level of sedation, provide a foundation for the development of guidelines that would decrease unnecessary variation in the care [15-17] and permit objective study of the pharmacodynamics of sedative agents in the pediatric population. [18] From a research perspective, Kollef and colleagues [5] suggest that sedation practices should be standardized in any investigation employing the duration of mechanical ventilation as an outcome variable.",
       "highlight": "enhance interdisciplinary agreement on the desired level of sedation",
       "scope": "on-scope",
       "note": "Supports agreeing a shared desired (target) level of sedation for the patient using the tool.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest match sharing the RASS keyword, but RASS is used as an arousal eligibility gate for delirium screening (CAPD), not as a sedation titration target.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "All patients in the PICU on a given study day were eligible if there was a parent or guardian available to provide informed consent. The only exclusion criterion was a sedation score of less than -3 (deeply sedated or unarousable), using the Richmond Agitation and Sedation Scale (RASS) (38, 39). Demographic and clinical data were collected on each subject.",
       "highlight": "using the Richmond Agitation and Sedation Scale (RASS)",
       "scope": "different-intervention",
       "note": "RASS here gates delirium-screening eligibility (excludes RASS < -3), a different use of RASS than setting a target arousal goal.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU validation; a RASS-gated pediatric delirium diagnostic tool cited by section/DOI. Contributes context that RASS gates delirium screening, not a sedation-target source; no file to quote.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest match sharing the RASS keyword, but RASS is the step-1 arousal assessment gating preschool delirium screening, not a sedation titration target.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "The first step was the assessment of patient arousal using the Richmond Agitation-Sedation Scale (RASS).",
       "highlight": "the assessment of patient arousal using the Richmond Agitation-Sedation Scale (RASS)",
       "scope": "different-intervention",
       "note": "RASS used to gate/anchor delirium assessment (arousal then content), not to set a sedation goal for the child.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Lin 2023 (ICU Liberation)",
     "cite": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Pediatric ICU Liberation (ABCDEF) collaborative; provides bundle context for assessing/targeting sedation and arousal. Cited by section/DOI; no file to quote.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000003262",
     "paragraphs": []
    },
    {
     "label": "Traube 2017 (mortality)",
     "cite": "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
     "kind": "pdf",
     "stance": "background",
     "note": "Delirium point-prevalence/outcomes study using RASS descriptively (coma and motoric subtype), not to set or recommend a sedation target.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000002324",
     "paragraphs": [
      {
       "context": "Delirium subtype was determined by psychomotor activity and level of alertness, as assessed by the RASS, over the 24 hour period(11, 12). The frequency of RASS assessment was dependent on patient's acuity level, and ranged from hourly to every 4 hours. The RASS score ranges from -5 (unarousable), through 0 (alert and calm), to +4 (combative)(10). Delirious children with RASS scores from 0 to -3 were designated as having hypoactive delirium. Delirious children with RASS scores from 0 to +4 were designated as having hyperactive delirium. Children with RASS scores crossing zero (including both negative and positive numbers) were designated as having mixed delirium.",
       "highlight": "The RASS score ranges from -5 (unarousable), through 0 (alert and calm), to +4 (combative)",
       "scope": "background",
       "note": "Describes the RASS range for classifying coma/delirium subtype in an epidemiology study — supplies RASS context but does not address setting an arousal target.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      }
     ]
    }
   ],
   "synthesis": "The on-scope sources agree and govern: SCCM PANDEM 2022 (p. e83 / PDF p.10) recommends the SBS (strong) or RASS (conditional) to assess sedation level and suggests assigning a per-patient target depth of sedation using a validated tool at least daily, and Curley 2006 defines the SBS with the sedation goal of a calm but responsive state — together supporting a unit RASS/SBS arousal goal for the child. The delirium tools (Traube 2014 CAPD, Smith 2016 psCAM-ICU, Traube 2017) and the RASS source (Sessler 2002) share the RASS keyword but use it as an arousal gate or subtype descriptor for delirium screening/epidemiology, a different-intervention scope that should not be read as direct support for setting a sedation target.",
   "discrepancy": true
  },
  {
   "id": "picu-wf-r13",
   "toolId": "picu-wf",
   "tool": "PICU Workflow",
   "page": "1",
   "section": "10-second rounds script",
   "statement": "Actual arousal (this shift’s RASS / SBS)",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM PANDEM 2022",
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "Lin 2023 (ICU Liberation)",
    "Traube 2017 (mortality)"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 10",
   "passage": "… Assessment of Sedation. Question: What sedation assessment scales are valid for assessing depth of sedation in critically ill pediatric patients? (SDC Section C1, http://links.lww.com/ PCC/B920). Answer: 1) \"We recommend\" the use the Comfort-B Scale or the State Behavioral Scale (SBS) to assess level of sedation in mechanically ventilated pediatric patients (strong, moderatelevel evidence). 2) \"We suggest\" the use of the Richmond Agitation-Sedation Scale (RASS) to assess level of sedation in mechanically ventilated pediatric patients (conditional, low-level evidence). Rationale: The Comfort-B Scale (56, 117, 118) and the SBS (119, 120) have both been validated in several PICU settings to assess the level of sedation in mechanically ventilated pediatric patients. Both scales reliably differentiate adequate from overor undersedation in patients not receiving NMBAs. Their psychometric validity has been supported in a meta-analysis of 13 sedation scales (121). Although the RASS has only been validated in a single trial, it is extensively used in pediatric critical care as it forms the basis for determining the appropriateness of delirium screening with the pediatric Confusion Assessment Method for the ICU (pCAM-ICU) and Cornell Assessment of Pediatric Delirium (CAPD) delirium screening tools (122). …\nPANDEM endorses the SBS — and notes the RASS is extensively used in pediatric critical care — for assessing current level of sedation. The statement is an organizational rounds prompt rather than a numeric claim.",
   "evidence": "Full text, p. 10 — partial support",
   "status": "fulltext",
   "pageNum": "10",
   "citations": [
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
    "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898."
   ],
   "links": [
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000003262",
    "https://doi.org/10.1097/CCM.0000000000002250"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary anchor: the pediatric guideline that recommends exactly the arousal/sedation scales named in the prompt.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "We recommend the use of the COMFORT-B Scale or the State Behavioral Scale, to assess level of sedation in mechanically ventilated pediatric patients.",
       "highlight": "the COMFORT-B Scale or the State Behavioral Scale, to assess level of sedation in mechanically ventilated pediatric patients",
       "scope": "on-scope",
       "note": "Strong recommendation for the SBS (or COMFORT-B) to assess level of sedation/arousal in ventilated children — supports the SBS arm of the rounds line.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "2) \"We suggest\" the use of the Richmond Agitation-Sedation Scale (RASS) to assess level of sedation in mechanically ventilated pediatric patients (conditional, low-level evidence).",
       "highlight": "the Richmond Agitation-Sedation Scale (RASS) to assess level of sedation in mechanically ventilated pediatric patients (conditional, low-level evidence)",
       "scope": "on-scope",
       "note": "Conditional suggestion for RASS to assess level of sedation/arousal in ventilated peds — directly supports the RASS arm of the prompt.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Rationale: The Comfort-B Scale (56, 117, 118) and the SBS (119, 120) have both been validated in several PICU settings to assess the level of sedation in mechanically ventilated pediatric patients. Both scales reliably differentiate adequate from over- or undersedation in patients not receiving NMBAs. Their psychometric validity has been supported in a meta-analysis of 13 sedation scales (121). Although the RASS has only been validated in a single trial, it is extensively used in pediatric critical care as it forms the basis for determining the appropriateness of delirium screening with the pediatric Confusion Assessment Method for the ICU (pCAM-ICU) and Cornell Assessment of Pediatric Delirium (CAPD) delirium screening tools (122). Characteristics of each sedation assessment scale are described in detail in SDC Table 6 (http://links.lww. com/PCC/B920).",
       "highlight": "the RASS has only been validated in a single trial",
       "scope": "background",
       "note": "Rationale caveat: pediatric RASS evidence is thin (single trial) and it underpins delirium screening — context for why RASS is only 'suggested' vs SBS 'recommended'.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Original RASS validation, but in adult ICU patients; cited as the primary reference for the RASS instrument itself (Am J Respir Crit Care Med 2002;166:1338). Not archived as text.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary validation of the SBS, the pediatric arousal scale named in the prompt.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Objective--To develop and test the reliability and validity of the State Behavioral Scale (SBS) for use in describing sedation/agitation levels in young intubated patients supported on mechanical ventilation.",
       "highlight": "the reliability and validity of the State Behavioral Scale (SBS) for use in describing sedation/agitation levels in young intubated patients",
       "scope": "on-scope",
       "note": "Study objective establishes SBS as a validated tool for describing arousal (sedation/agitation) level — direct support for the SBS arm.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      },
      {
       "context": "Conclusions--Based on empirically derived state behavior profiles, we have constructed the SBS to allow systematic description of the sedation-agitation continuum in young pediatric patients supported on mechanical ventilation. Further studies including prospective validation and describing the effect of SBS implementation on clinical outcomes including the quality of sedation and length of mechanical ventilation are warranted.",
       "highlight": "systematic description of the sedation-agitation continuum in young pediatric patients",
       "scope": "narrower",
       "note": "Conclusion; SBS is validated specifically in young intubated infants/children (a narrower population than all PICU patients), which is why it pairs with RASS for older children.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      },
      {
       "context": "We recommended that sedation assessment be completed at the start of normal cares at a frequency that aligns with the patient's clinical state. The Joint Commission for the Accreditation of Hospitals suggests that pain scoring be considered the 5th vital sign. [38] We suggest that sedation scoring should be completed with the patient's pain assessment every four hours and also before and after an intervention that impacts the patient's level of sedation.",
       "highlight": "sedation scoring should be completed with the patient's pain assessment every four hours",
       "scope": "on-scope",
       "note": "Supports the recurring per-shift cadence ('this shift's') at which arousal/sedation should be scored.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "background",
     "note": "Validates the CAPD delirium screen, not an arousal scale; it uses RASS only as an arousability gate. Shares the RASS keyword but is a different intervention.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "All patients in the PICU on a given study day were eligible if there was a parent or guardian available to provide informed consent. The only exclusion criterion was a sedation score of less than -3 (deeply sedated or unarousable), using the Richmond Agitation and Sedation Scale (RASS) (38, 39). Demographic and clinical data were collected on each subject.",
       "highlight": "a sedation score of less than -3 (deeply sedated or unarousable), using the Richmond Agitation and Sedation Scale (RASS)",
       "scope": "different-intervention",
       "note": "Nearest match: RASS is used here to gate delirium screening (arousable vs not), not to validate RASS as the arousal measure — keyword overlap, different purpose.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "pCAM-ICU is a pediatric delirium diagnostic tool (different intervention from arousal scoring); cited by DOI/section as part of the workflow's instrument set. No archived text to search.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "background",
     "note": "Validates the preschool CAM-ICU delirium tool; it operationalizes arousal via RASS as its required first step. Shares the RASS/arousal keyword but the study's purpose is delirium screening.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "The first step was the assessment of patient arousal using the Richmond Agitation-Sedation Scale (RASS).",
       "highlight": "the assessment of patient arousal using the Richmond Agitation-Sedation Scale (RASS)",
       "scope": "different-intervention",
       "note": "Nearest match: describes RASS as the arousal step preceding delirium assessment — corroborates RASS-as-arousal in practice but within a delirium-tool validation, not direct validation of the arousal prompt.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Lin 2023 (ICU Liberation)",
     "cite": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
     "kind": "unarchived",
     "stance": "background",
     "note": "ABCDEF bundle collaborative results; the 'A' (assess/manage) element frames arousal/sedation monitoring but the paper is a bundle-implementation study, not an arousal-scale source. Cited by section/DOI; no archived text.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000003262",
     "paragraphs": []
    },
    {
     "label": "Traube 2017 (mortality)",
     "cite": "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
     "kind": "pdf",
     "stance": "background",
     "note": "International delirium point-prevalence/mortality study; uses RASS to grade level of alertness but its scope is delirium epidemiology, not validation of the arousal scale.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000002324",
     "paragraphs": [
      {
       "context": "Delirium subtype was determined by psychomotor activity and level of alertness, as assessed by the RASS, over the 24 hour period(11, 12). The frequency of RASS assessment was dependent on patient's acuity level, and ranged from hourly to every 4 hours. The RASS score ranges from -5 (unarousable), through 0 (alert and calm), to +4 (combative)(10). Delirious children with RASS scores from 0 to -3 were designated as having hypoactive delirium. Delirious children with RASS scores from 0 to +4 were designated as having hyperactive delirium. Children with RASS scores crossing zero (including both negative and positive numbers) were designated as having mixed delirium.",
       "highlight": "level of alertness, as assessed by the RASS, over the 24 hour period",
       "scope": "different-intervention",
       "note": "Nearest match: RASS used to grade alertness/arousal for delirium subtyping — shares the keyword but the study aim is delirium prevalence/mortality.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      },
      {
       "context": "Delirium subtype was determined by psychomotor activity and level of alertness, as assessed by the RASS, over the 24 hour period(11, 12). The frequency of RASS assessment was dependent on patient's acuity level, and ranged from hourly to every 4 hours. The RASS score ranges from -5 (unarousable), through 0 (alert and calm), to +4 (combative)(10). Delirious children with RASS scores from 0 to -3 were designated as having hypoactive delirium. Delirious children with RASS scores from 0 to +4 were designated as having hyperactive delirium. Children with RASS scores crossing zero (including both negative and positive numbers) were designated as having mixed delirium.",
       "highlight": "The frequency of RASS assessment was dependent on patient's acuity level, and ranged from hourly to every 4 hours",
       "scope": "background",
       "note": "Documents real-world RASS assessment cadence (hourly to q4h), consistent with the per-shift arousal prompt, though within an epidemiology study.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      }
     ]
    }
   ],
   "synthesis": "SCCM PANDEM 2022 governs and directly supports the prompt: it strongly recommends the COMFORT-B Scale or SBS and conditionally suggests the RASS to assess level of sedation (arousal) in mechanically ventilated pediatric patients, with SBS validated by Curley 2006 and the RASS instrument by Sessler 2002 (adult ICU). The pediatric delirium instruments (CAPD/Traube 2014, psCAM-ICU/Smith 2016) and the delirium point-prevalence study (Traube 2017) share the RASS/arousal keyword but validate or study delirium screening and only operationalize arousal via RASS as a gating step, so they are nearest-match different-intervention support rather than direct validation of the arousal prompt.",
   "discrepancy": true
  },
  {
   "id": "picu-wf-r14",
   "toolId": "picu-wf",
   "tool": "PICU Workflow",
   "page": "1",
   "section": "10-second rounds script",
   "statement": "Screen result (CAPD score or ps/pCAM-ICU ±)",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM PANDEM 2022",
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "Lin 2023 (ICU Liberation)",
    "Traube 2017 (mortality)"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 15",
   "passage": "… \"Precipitating risk factors\" include benzodiazepine exposure, coma and deep sedation, requirement for invasive MV, and prolonged cardiopulmonary bypass time (113, 151, 152, 221, 222, 226, 234, 237-239) (SDC Section E1, Table 16, http://links.lww. com/PCC/B920). Delirium in critically ill pediatric patients is associated with increases in hospital and PICU LOS, duration of MV, hospital costs, and in-hospital mortality (113, 151, 221, 222, 224, 234, 237-240). Delirium Monitoring. Question: Which delirium screening tools have the best validity and reliability in critically ill pediatric patients? (SDC Section E2, http://links.lww.com/ PCC/B920). Answer: \"We recommend\" use of the preschool and pCAM-ICU (ps/pCAM-ICU) or the CAPD as the most valid and reliable delirium monitoring tools in critically ill pediatric patients (strong, high-level evidence). Rationale: Of five pediatric-specific delirium screening tools available, three are relevant to PICU patients (SDC Section E2b, http://links.lww.com/PCC/B920). The ps/pCAM-ICU are considered \"point-in-time\" assessments, using both observation and interactive components (241), and maintaining the basic foundation of its highly valid and reliable precursor, the adult Confusion Assessment Method for the ICU. …\nPANDEM's endorsement of the ps/pCAM-ICU and CAPD supports naming these tools on rounds. The statement is an organizational rounds prompt rather than a discrete clinical claim.",
   "evidence": "Full text, p. 15 — partial support",
   "status": "fulltext",
   "pageNum": "15",
   "citations": [
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
    "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898."
   ],
   "links": [
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000003262",
    "https://doi.org/10.1097/CCM.0000000000002250"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The governing on-scope source: strong, high-level guideline recommendation naming the ps/pCAM-ICU or CAPD as the delirium monitoring tools for the PICU.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "\"We recommend\" use of the preschool and pCAM-ICU (ps/pCAM-ICU) or the CAPD as the most valid and reliable delirium monitoring tools in critically ill pediatric patients (strong, high-level evidence).",
       "highlight": "use of the preschool and pCAM-ICU (ps/pCAM-ICU) or the CAPD as the most valid and reliable delirium monitoring tools in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "The Delirium Monitoring recommendation governs which screen result the rounds line reports: ps/pCAM-ICU or CAPD.",
       "page": "e88 (p. 15)",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "1) We recommend use of the preschool and pediatric Confusion Assessment Methods for the ICU or the Cornell Assessment for Pediatric Delirium as the most valid and reliable delirium monitoring tools in critically ill pediatric patients.",
       "highlight": "the Cornell Assessment for Pediatric Delirium as the most valid and reliable delirium monitoring tools in critically ill pediatric patients",
       "scope": "on-scope",
       "note": "Summary-box recommendation restating that ps/pCAM-ICU or CAPD are the recommended delirium monitoring tools.",
       "page": "e77",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "Rationale: The Comfort-B Scale (56, 117, 118) and the SBS (119, 120) have both been validated in several PICU settings to assess the level of sedation in mechanically ventilated pediatric patients. Both scales reliably differentiate adequate from over- or undersedation in patients not receiving NMBAs. Their psychometric validity has been supported in a meta-analysis of 13 sedation scales (121). Although the RASS has only been validated in a single trial, it is extensively used in pediatric critical care as it forms the basis for determining the appropriateness of delirium screening with the pediatric Confusion Assessment Method for the ICU (pCAM-ICU) and Cornell Assessment of Pediatric Delirium (CAPD) delirium screening tools (122). Characteristics of each sedation assessment scale are described in detail in SDC Table 6 (http://links.lww. com/PCC/B920).",
       "highlight": "the appropriateness of delirium screening with the pediatric Confusion Assessment Method for the ICU (pCAM-ICU) and Cornell Assessment of Pediatric Delirium (CAPD) delirium screening tools",
       "scope": "different-intervention",
       "note": "This passage is about sedation/arousal scales (RASS/SBS) that gate delirium screening, not the delirium screen result itself; keyword overlap only.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "RASS (adult ICU sedation-agitation scale) is cited for the arousal-level step that must precede delirium screening (patient must be RASS >= -3); background for the workflow, not direct support for the CAPD/psCAM screen result.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "background",
     "note": "State Behavioral Scale measures sedation/agitation depth, a different intervention from delirium screening; cited as the pediatric arousal scale that gates screening, not as a delirium screen result.",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Objective--To develop and test the reliability and validity of the State Behavioral Scale (SBS) for use in describing sedation/agitation levels in young intubated patients supported on mechanical ventilation.",
       "highlight": "sedation/agitation levels in young intubated patients supported on mechanical ventilation",
       "scope": "different-intervention",
       "note": "SBS assesses the sedation-agitation continuum (arousal), not delirium; it is the pre-screen arousal gate, sharing keywords but a different measurement than the CAPD/psCAM screen result.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope validation of the CAPD delirium screen and its score cut point of >=9 - the 'CAPD score' the rounds line reports.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Objective--To determine validity and reliability of the Cornell Assessment of Pediatric Delirium, a rapid observational screening tool.",
       "highlight": "the Cornell Assessment of Pediatric Delirium, a rapid observational screening tool",
       "scope": "on-scope",
       "note": "Establishes CAPD as a valid, rapid observational delirium screen, directly supporting the CAPD half of the screen result.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "Cut point analysis showed the best sensitivity and specificity for the screening instrument (prioritizing high sensitivity) at a total CAPD score of 9 or greater. Sensitivity was 94.1% (95% CI, 83.8-98.8%) and specificity 79.2% (95% CI, 73.5-84.9%). At a cut point of greater than or equal to 9, there were three false-negative CAPD screens (Table 3) and 41 false-positive screens. Concordance between CAPD and psychiatric diagnosis was 82.3% (r = 0.62). Nurses' CAPD interrater reliability was also highest at a cut point of 9, with = 0.94. ranged from 0.68 to 0.78 for each of the eight CAPD items.",
       "highlight": "at a total CAPD score of 9 or greater",
       "scope": "on-scope",
       "note": "Defines the CAPD score threshold (>=9), the numeric screen result named in the statement.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Original pCAM-ICU validation (children >5 y); cited as the source of the pCAM-ICU named in the statement (its performance is summarized within the PANDEM guideline and Smith 2016).",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope validation of the psCAM-ICU delirium screen for infants/preschoolers; also describes the pCAM-ICU, together supporting the 'ps/pCAM-ICU' screen result.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "CONCLUSIONS--The psCAM-ICU is a highly valid and reliable delirium instrument for critically ill infants and preschool-aged children, in whom delirium is extremely prevalent.",
       "highlight": "The psCAM-ICU is a highly valid and reliable delirium instrument for critically ill infants and preschool-aged children",
       "scope": "on-scope",
       "note": "Validates the psCAM-ICU as a delirium screen for <5 y, directly supporting the ps-CAM-ICU half of the screen result.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "The Pediatric Confusion Assessment Method for the Intensive Care Unit (pCAM-ICU) was the first validated tool for objective delirium monitoring in critically ill children over 5 years of age, demonstrating a specificity of 99% and sensitivity of 83%. (6) The majority of pediatric ICU (PICU) patients are less than 5 years of age, in whom objective and interactive delirium monitoring is fraught with challenges as a result of variations in both language and cognitive development. Consequently, subjective and observational approaches to delirium screening in infants and young children have been validated. One such tool, the Cornell Assessment for Pediatric Delirium (CAPD) (8) was introduced as a subjective delirium screening tool in critically ill children with a reported specificity of 79% and sensitivity of 94%.",
       "highlight": "the first validated tool for objective delirium monitoring in critically ill children over 5 years of age",
       "scope": "on-scope",
       "note": "Describes the pCAM-ICU (children >5 y), supporting the pCAM-ICU half of the ps/pCAM-ICU screen result.",
       "page": "",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Lin 2023 (ICU Liberation)",
     "cite": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Pediatric ABCDEF bundle collaborative in which 'D' is delirium monitoring; cited for the bundle context of routine delirium screening, not for a specific screen-tool result.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000003262",
     "paragraphs": []
    },
    {
     "label": "Traube 2017 (mortality)",
     "cite": "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Archived text is Traube et al.'s single-center pediatric delirium epidemiology/mortality cohort (twice-daily CAPD screening), not the 'international point prevalence' paper named in the citation - a content/label mismatch - but both use CAPD screening and the passage supports the CAPD score usage.",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000002324",
     "paragraphs": [
      {
       "context": "Consistent with our PICU standard, each child was screened for delirium twice daily by the bedside nurse, at 6 am and 6 pm, using the Cornell Assessment of Pediatric Delirium (CAPD)(8). This is also consistent with the recent position paper published by the European Society of Paediatric and Neonatal Intensive Care (ESPNIC), recommending use of CAPD to assess for pediatric delirium (grade of recommendation = A) every 8-12 hours(9). The CAPD is a well-validated observational 8-item tool that can reliably distinguish between pain, agitation, residual sedation, and delirium(8,9). A CAPD score of 9 or higher represents a positive screen; the diagnosis is then confirmed by the physician(8). Any developmentally delayed child who screened positive for delirium on the CAPD subsequently had the diagnosis of delirium confirmed (or refuted) by an intensivist or psychiatrist prior to being classified as delirious. (The clinician had to establish an alteration from mental status at prehospital baseline, in order to ensure that static encephalopathy - i.e.: the underlying developmental delay - was not confused with delirium).",
       "highlight": "A CAPD score of 9 or higher represents a positive screen; the diagnosis is then confirmed by the physician",
       "scope": "on-scope",
       "note": "Operationalizes CAPD screening with score >=9 as a positive screen, directly supporting the 'CAPD score' screen result reported on rounds.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      }
     ]
    }
   ],
   "synthesis": "The on-scope sources agree: the PANDEM 2022 guideline (strong, high-level evidence) governs, recommending the ps/pCAM-ICU or CAPD as the most valid and reliable pediatric delirium monitoring tools, and the validation/operational studies concur - Traube 2014 (CAPD, positive at a score >=9), Smith 2016 (psCAM-ICU, and the pCAM-ICU it describes for children >5 y), and the Traube 2017 cohort (CAPD score >=9 = positive screen). RASS (Sessler 2002) and SBS (Curley 2006) are different-intervention arousal/sedation scales cited only for the pre-screen arousal gate, not for the delirium screen result itself.",
   "discrepancy": true
  },
  {
   "id": "picu-wf-r15",
   "toolId": "picu-wf",
   "tool": "PICU Workflow",
   "page": "1",
   "section": "10-second rounds script",
   "statement": "Sedation, analgesia & delirium plan for today",
   "contentType": "Cited clinical content",
   "sources": [
    "SCCM PANDEM 2022",
    "Sessler 2002 (RASS)",
    "Curley 2006 (SBS)",
    "Traube 2014 (CAPD)",
    "Smith 2011 (pCAM-ICU)",
    "Smith 2016 (psCAM-ICU)",
    "Lin 2023 (ICU Liberation)",
    "Traube 2017 (mortality)"
   ],
   "anchor": "SCCM PANDEM 2022 — p. 2",
   "passage": "Copyright © 2022 by the Society of Critical Care Medicine and the World Federation of Pediatric Intensive and Critical Care Societies. Unauthorized reproduction of this article is prohibited Online Special Article Pediatric Critical Care Medicine www.pccmjournal.org e75 CONCLUSIONS: The current guidelines represent a comprehensive list of practical clinical recommendations for the assessment, prevention, and management of key aspects for the comprehensive critical care of infants and children. Main areas of focus included 1) need for the routine monitoring of pain, agitation, withdrawal, and delirium using validated tools, 2) enhanced use of protocolized sedation and analgesia , and 3) recognition of the importance of nonpharmacologic interventions for enhancing patient comfort and comprehensive care provision. KEY WORDS: analgesia; delirium; guidelines; neuromuscular blockade; pediatric critical care; sedation I CU care bundles, including the ICU Liberation ABCDEF bundle, provide a new paradigm for liberating critically ill patients from mechanical ventilation (MV) and ICU environment, while optimizing post-ICU outcomes (1, 2). Despite growing appreciation of this bundled patient care approach, PICU sedation and analgesia practices remain highly variable (3-5). …\nThe statement maps to PANDEM's integrated scope of daily pain, sedation/agitation, analgesia, and delirium management; it is an organizational rounds prompt rather than a discrete clinical assertion.",
   "evidence": "Full text, p. 2 — partial support",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
    "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
    "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
    "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
    "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
    "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
    "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
    "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898."
   ],
   "links": [
    "https://doi.org/10.1097/PCC.0000000000002873",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
    "https://doi.org/10.1097/CCM.0b013e3182a66b76",
    "https://doi.org/10.1097/CCM.0b013e3181feb489",
    "https://doi.org/10.1097/CCM.0000000000001428",
    "https://doi.org/10.1097/PCC.0000000000003262",
    "https://doi.org/10.1097/CCM.0000000000002250"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "SCCM PANDEM 2022",
     "cite": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary on-scope source: the pediatric guideline that addresses sedation, pain, and delirium together and prescribes routine, at-least-daily assessment with validated tools plus protocolized sedation/analgesia — the substance of the rounds-script daily plan.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000002873",
     "paragraphs": [
      {
       "context": "RATIONALE: A guideline that both evaluates current practice and provides recommendations to address sedation, pain, and delirium management with regard for neuromuscular blockade and withdrawal is not currently available.",
       "highlight": "address sedation, pain, and delirium management",
       "scope": "on-scope",
       "note": "The guideline's stated purpose names exactly the three domains in the rounds-script line (sedation, analgesia/pain, delirium).",
       "page": "e74",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "CONCLUSIONS: The current guidelines represent a comprehensive list of practical clinical recommendations for the assessment, prevention, and management of key aspects for the comprehensive critical care of infants and children. Main areas of focus included 1) need for the routine monitoring of pain, agitation, withdrawal, and delirium using validated tools, 2) enhanced use of protocolized sedation and analgesia, and 3) recognition of the importance of nonpharmacologic interventions for enhancing patient comfort and comprehensive care provision.",
       "highlight": "enhanced use of protocolized sedation and analgesia",
       "scope": "on-scope",
       "note": "Conclusions name routine validated-tool monitoring and protocolized sedation/analgesia as core recommendations — the content a daily plan operationalizes.",
       "page": "e74",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      },
      {
       "context": "3) We suggest that all pediatric patients requiring MV are assigned a target depth of sedation using a validated sedation assessment tool at least once daily.",
       "highlight": "target depth of sedation using a validated sedation assessment tool at least once daily",
       "scope": "on-scope",
       "note": "The 'at least once daily' sedation-target recommendation is the explicit per-day planning element behind 'plan for today.'",
       "page": "e82",
       "docUrl": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "RASS is the adult-ICU-validated sedation scale that underpins the sedation-assessment step of the plan (and gates pediatric delirium screening); cited by section, no archived text to quote.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Curley 2006 (SBS)",
     "cite": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Validates the State Behavioral Scale, one of PANDEM's two recommended sedation tools; supports the sedation-assessment component of the plan at narrower scope (single-instrument validation in infants/young children on MV).",
     "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
     "paragraphs": [
      {
       "context": "Objective--To develop and test the reliability and validity of the State Behavioral Scale (SBS) for use in describing sedation/agitation levels in young intubated patients supported on mechanical ventilation.",
       "highlight": "describing sedation/agitation levels in young intubated patients supported on mechanical ventilation",
       "scope": "narrower",
       "note": "Validates a specific sedation scale for a specific population — supports the sedation slice of the plan, not the full sedation/analgesia/delirium plan.",
       "page": "107",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      },
      {
       "context": "Valid and reliable tools that standardize the description of a pediatric patient's behavioral state while supported on mechanical ventilation would enhance systematic assessment and documentation of a patient's response to sedation, allow patient-specific alterations in the therapeutic regimen, and help avoid insufficient or excessive sedative use. [13,14] Such an assessment tool would enhance interdisciplinary agreement on the desired level of sedation, provide a foundation for the development of guidelines that would decrease unnecessary variation in the care [15-17] and permit objective study of the pharmacodynamics of sedative agents in the pediatric population. [18] From a research perspective, Kollef and colleagues [5] suggest that sedation practices should be standardized in any investigation employing the duration of mechanical ventilation as an outcome variable.",
       "highlight": "allow patient-specific alterations in the therapeutic regimen",
       "scope": "narrower",
       "note": "States the rationale for a validated sedation tool driving day-to-day therapeutic adjustments — the sedation component of the daily plan.",
       "page": "108",
       "docUrl": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    },
    {
     "label": "Traube 2014 (CAPD)",
     "cite": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Validates the Cornell Assessment of Pediatric Delirium; supports the delirium-screening component of the plan at narrower scope (single-tool validation in a general PICU).",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
     "paragraphs": [
      {
       "context": "Objective--To determine validity and reliability of the Cornell Assessment of Pediatric Delirium, a rapid observational screening tool.",
       "highlight": "a rapid observational screening tool",
       "scope": "narrower",
       "note": "Validates the delirium-screening instrument — the delirium slice of the plan; narrower than the full rounds-script plan.",
       "page": "656",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      },
      {
       "context": "Conclusions--With an overall prevalence rate of 20.6% in our study population, delirium is a common problem in pediatric critical care. The Cornell Assessment of Pediatric Delirium is a valid, rapid, observational nursing screen that is urgently needed for the detection of delirium in PICU settings.",
       "highlight": "urgently needed for the detection of delirium in PICU settings",
       "scope": "narrower",
       "note": "Conclusion supports routine PICU delirium screening — the delirium element the plan prompts, but scoped to one tool.",
       "page": "656",
       "docUrl": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    },
    {
     "label": "Smith 2011 (pCAM-ICU)",
     "cite": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
     "kind": "unarchived",
     "stance": "background",
     "note": "The pCAM-ICU is the validated objective delirium tool for children over 5 years that underpins the delirium step of the plan; cited by DOI/section, no archived text to quote.",
     "docUrl": "https://doi.org/10.1097/CCM.0b013e3181feb489",
     "paragraphs": []
    },
    {
     "label": "Smith 2016 (psCAM-ICU)",
     "cite": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Validates the preschool delirium tool and documents daily delirium assessment; supports the delirium component at narrower scope (infants/preschool 6 months–5 years).",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000001428",
     "paragraphs": [
      {
       "context": "RATIONALE and OBJECTIVE--Delirium assessments in critically ill infants and young children pose unique challenges due to evolution of cognitive and language skills. The objectives of this study were to determine the validity and reliability of a fundamentally objective and developmentally appropriate delirium assessment tool for critically ill infants and preschool-aged children, and to determine delirium prevalence.",
       "highlight": "developmentally appropriate delirium assessment tool for critically ill infants and preschool-aged children",
       "scope": "narrower",
       "note": "Validates the delirium tool for a specific younger population — supports the delirium slice of the plan; narrower than the whole plan.",
       "page": "592",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      },
      {
       "context": "INTERVENTIONS, MEASUREMENTS and MAIN RESULTS--An interdisciplinary team created the psCAM-ICU for pediatric delirium monitoring. To assess validity, patients were independently assessed for delirium daily by the research team using the psCAM-ICU and by a child psychiatrist using the Diagnostic and Statistical Manual of Mental Disorders criteria. Reliability was assessed using blinded, concurrent psCAM-ICU evaluations by research staff. A total of 530-paired delirium assessments were completed among 300 patients, with a median age of 20 months (IQR 11, 37) and 43% requiring mechanical ventilation. The psCAM-ICU demonstrated a specificity of 91% (95%CI 90, 93), sensitivity of 75% (72, 78), negative predictive value of 86% (84, 88), positive predictive value of 84% (81, 87), and a reliability kappa statistic of 0.79 (0.76, 0.83). Delirium prevalence was 44% using the psCAM-ICU and 47% by the referencerater. The rates of delirium were 53% vs. 56% in patients < 2 years of age and 33% vs. 35% in patients 2 - 5 years of age using the psCAM-ICU and reference-rater respectively. The shortform psCAM-ICU maintained a high specificity (87%) and sensitivity (78%) in post-hoc analysis.",
       "highlight": "assessed for delirium daily",
       "scope": "narrower",
       "note": "Operationalizes daily delirium assessment — the per-day delirium element — but within a single-tool validation, not a care-plan recommendation.",
       "page": "593",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    },
    {
     "label": "Lin 2023 (ICU Liberation)",
     "cite": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Pediatric ABCDEF/ICU Liberation bundle collaborative — the bundle framework that makes a daily sedation/analgesia/delirium plan operational; cited by section, no archived text to quote.",
     "docUrl": "https://doi.org/10.1097/PCC.0000000000003262",
     "paragraphs": []
    },
    {
     "label": "Traube 2017 (mortality)",
     "cite": "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest match on the delirium topic but a DIFFERENT SCOPE — an epidemiology/mortality cohort supplying rationale for delirium being on the plan, not a care-plan study. Also a metadata mismatch: the citation ('international point prevalence study,' 45(4):584–590) does not match the stored file ('Delirium and Mortality... Epidemiology and Outcomes,' 45(5):891–898).",
     "docUrl": "https://doi.org/10.1097/CCM.0000000000002324",
     "paragraphs": [
      {
       "context": "Conclusions--Delirium occurs frequently in critically ill children and is independently associated with mortality. Some in-hospital risk factors for delirium development are modifiable. Interventional studies are needed to determine best practices to limit delirium exposure in at-risk children.",
       "highlight": "independently associated with mortality",
       "scope": "broader",
       "note": "Establishes delirium burden and mortality association — rationale for including delirium in the plan, not a recommendation about the plan itself.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      },
      {
       "context": "Consistent with our PICU standard, each child was screened for delirium twice daily by the bedside nurse, at 6 am and 6 pm, using the Cornell Assessment of Pediatric Delirium (CAPD)(8). This is also consistent with the recent position paper published by the European Society of Paediatric and Neonatal Intensive Care (ESPNIC), recommending use of CAPD to assess for pediatric delirium (grade of recommendation = A) every 8-12 hours(9). The CAPD is a well-validated observational 8-item tool that can reliably distinguish between pain, agitation, residual sedation, and delirium(8,9). A CAPD score of 9 or higher represents a positive screen; the diagnosis is then confirmed by the physician(8). Any developmentally delayed child who screened positive for delirium on the CAPD subsequently had the diagnosis of delirium confirmed (or refuted) by an intensivist or psychiatrist prior to being classified as delirious. (The clinician had to establish an alteration from mental status at prehospital baseline, in order to ensure that static encephalopathy - i.e.: the underlying developmental delay - was not confused with delirium).",
       "highlight": "screened for delirium twice daily by the bedside nurse, at 6 am and 6 pm",
       "scope": "broader",
       "note": "Its twice-daily CAPD screening protocol illustrates routine delirium-monitoring cadence, but the study's aim is epidemiologic outcomes rather than a daily plan.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1097/CCM.0000000000002324"
      }
     ]
    }
   ],
   "synthesis": "The on-scope governing source is the SCCM PANDEM 2022 pediatric guideline, which directly frames the day's plan for the rounds-script line: it addresses sedation, pain (analgesia), and delirium together, recommends a validated-tool sedation target \"at least once daily\" plus protocolized sedation/analgesia, and routine delirium monitoring with validated tools. The instrument-validation papers (SBS, CAPD, psCAM-ICU) and the RASS / pCAM-ICU / ICU Liberation references each support one narrower component (a sedation scale, a delirium screen, or the ABCDEF bundle) rather than the whole plan, and Traube 2017 supplies broader epidemiologic rationale rather than a care plan — and its stored file (Epidemiology and Outcomes, 45(5):891–898) does not match the citation metadata (international point prevalence study, 45(4):584–590), a mismatch worth flagging.",
   "discrepancy": true
  },
  {
   "id": "ed-cards-r3",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "1",
   "section": "Pathways card",
   "statement": "Two-step: DTS → bCAM",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "Geriatric ED Guidelines (2014)",
    "GED Guidelines 2.0 (2026)"
   ],
   "anchor": "Han 2013 (DTS/bCAM) — p. 2",
   "passage": "… The positive likelihood ratios for the bCAM were 19.9 (95%CI: 12.0 - 33.2) and 25.2 (95%CI: 13.9 - 46.0), respectively. If the RA DTS was followed by the physician bCAM, the sensitivity of this combination was 84.0% (95%CI: 71.5% - 91.7%) and the specificity was 95.8% (95%CI: 93.2% - 97.4%). If the RA performed both the DTS and bCAM, this combination was 78.0% (95%CI: 64.8% - 87.2%) sensitive and 97.2% (95%CI: 94.9% - 98.5%) specific. If the physician performed both the DTS and bCAM, this combination was 82.0% (95%CI: 69.2% - 90.2%) sensitive and 95.8% (95CI: 93.2% - 97.4%) specific. Conclusions- In older ED patients, this two-step approach (highly sensitive DTS followed by highly specific bCAM) may enable healthcare professionals, regardless of clinical background, to efficiently screen for delirium. Larger, multi-centered trials are needed to confirm these findings and to determine the impact of these assessments on delirium recognition in the ED. …\nHan 2013 presents the DTS and bCAM as the rule-out and rule-in components of the two-step approach (p. 3), and the Figure 1 caption (p. 12) states that a positive DTS should be followed by a confirmatory bCAM.",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "American College of Emergency Physicians, American Geriatrics Society, Emergency Nurses Association, Society for Academic Emergency Medicine. Geriatric Emergency Department Guidelines. 2014.",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.acep.org/geda/",
    "https://doi.org/10.1111/acem.70167"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The validation study that developed the two-step DTS (rule-out) to bCAM (rule-in) approach for older ED patients; governs this claim.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "Conclusions--In older ED patients, this two-step approach (highly sensitive DTS followed by highly specific bCAM) may enable healthcare professionals, regardless of clinical background, to efficiently screen for delirium. Larger, multi-centered trials are needed to confirm these findings and to determine the impact of these assessments on delirium recognition in the ED.",
       "highlight": "this two-step approach (highly sensitive DTS followed by highly specific bCAM)",
       "scope": "on-scope",
       "note": "Abstract Conclusions state the exact sequence claimed: highly sensitive DTS followed by highly specific bCAM in older ED patients.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "Background--Delirium is a common form of acute brain dysfunction with prognostic significance. Health care professionals caring for older emergency department (ED) patients miss delirium approximately 75% of cases. This error results from a lack of available measures that can be performed rapidly enough to be incorporated into clinical practice. Therefore, we developed and evaluated a novel two-step approach to delirium surveillance for the ED.",
       "highlight": "we developed and evaluated a novel two-step approach to delirium surveillance for the ED",
       "scope": "on-scope",
       "note": "Abstract Background frames the whole study as a two-step ED delirium surveillance approach.",
       "page": "465",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "One method to improve delirium detection would be to use a two-step approach: a sequential testing strategy that utilizes brief, valid, and reliable delirium assessments that can be performed by healthcare professionals of all clinical backgrounds. The first step would be to perform a very brief (<20 seconds), highly sensitive delirium screen to rule-out delirium. This rapid rule-out screen can be incorporated into the ED triage assessment or can be part of the initial nursing assessment after the patient has been placed in an ED bed. A negative screen would rule out delirium, reduce the number of formal delirium assessments needed, and enhance screening efficiency. A positive screen would trigger a formal delirium assessment performed by another health care provider (i.e., physician) at the patient's bedside that would be highly specific to rule-in delirium. Ideally, this rule-in assessment should be brief (<1 minute) to maximize feasibility. We developed Delirium Triage Screen (DTS) and the Brief Confusion Assessment Method (bCAM) to serve as the rule-out and rule-in tests for the two-step approach to delirium surveillance (Figure 1), respectively.",
       "highlight": "to serve as the rule-out and rule-in tests for the two-step approach to delirium surveillance",
       "scope": "on-scope",
       "note": "Introduction names DTS as the rule-out step and bCAM as the rule-in step of the two-step approach.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "negative, then delirium is ruled out and no additional testing is needed. If the DTS result is positive, then a confirmatory delirium assessment such as the bCAM should be performed.",
       "highlight": "If the DTS result is positive, then a confirmatory delirium assessment such as the bCAM should be performed.",
       "scope": "on-scope",
       "note": "Figure 1 caption spells out the DTS-then-bCAM ordering: a positive DTS triggers the confirmatory bCAM.",
       "page": "ms. p.12",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "Geriatric ED Guidelines (2014)",
     "cite": "American College of Emergency Physicians, American Geriatrics Society, Emergency Nurses Association, Society for Academic Emergency Medicine. Geriatric Emergency Department Guidelines. 2014.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The consensus geriatric ED guideline adopts the two-step process (Step 1 DTS, Step 2 bCAM), citing Han 2013.",
     "docUrl": "https://www.acep.org/geda/",
     "paragraphs": [
      {
       "context": "delirium. The assessment for delirium will use a two-step process. Step 1 (Figure 4) is the highly sensitive delirium triage screen. Step 2 is the highly specific Brief Confusion Assessment Method.157 A variety of ED-appropriate dementia and mild cognitive impairment screening instruments have been validated, but all are most useful to reduce the probability of non-delirium cognitive impairment (dementia or mild cognitive impairment) rather than to rule-in the diagnosis. An assessment for dementia should be conducted after delirium screening. One of the most accurate dementia screening instruments is reproduced below in Figure 5.155, 158 Figure 4.",
       "highlight": "The assessment for delirium will use a two-step process. Step 1 (Figure 4) is the highly sensitive delirium triage screen. Step 2 is the highly specific Brief Confusion Assessment Method.",
       "scope": "on-scope",
       "note": "Delirium/Dementia procedure directly prescribes Step 1 = highly sensitive delirium triage screen (DTS), Step 2 = highly specific bCAM, referencing Han 2013 (ref 157).",
       "page": "27",
       "docUrl": "https://www.acep.org/geda/"
      }
     ]
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "partial",
     "note": "GRADE update endorses DTS (rule-out) and bCAM (rule-in) individually but frames them within a broader menu of instruments rather than re-mandating the specific DTS-then-bCAM sequence.",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": [
      {
       "context": "Recommendation #5: In older adults in the ED, DTS may be used to rule out delirium (Conditional, FOR) [Very low certainty of evidence].",
       "highlight": "DTS may be used to rule out delirium",
       "scope": "narrower",
       "note": "Recommendation #5 endorses only the DTS rule-out component (explicitly not to rule in), supporting step 1 of the two-step sequence but not the full pairing.",
       "page": "e70167",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "In older ED patients with suspected delirium, there is sufficient direct evidence to select delirium diagnostic instruments that accurately rule in (i.e., confirm) or rule out (i.e., exclude) delirium [ 22 ]. The 4AT had the largest quantity of ED‐based research and may be used to rule in or rule out delirium [ 90 ]. The CAM‐ICU, brief Confusion Assessment Method (bCAM), modified Confusion Assessment Method (mCAM) for the Emergency Department, AMT‐4, and Richmond Agitation and Sedation Scale (RASS) are superior to clinical gestalt [ 91 ], and may also be used to rule in or rule out delirium. The Delirium Triage Screen is superior to clinical gestalt in ruling out delirium [ 92 ] (Table 3 ).",
       "highlight": "and may also be used to rule in or rule out delirium",
       "scope": "broader",
       "note": "Recommendation #4 / summary lists bCAM as one of several rule-in/rule-out tools (4AT, CAM-ICU, mCAM, AMT-4, RASS), not specifically as the sequential step-2 after DTS, so it broadens beyond the DTS-to-bCAM pathway.",
       "page": "e70167",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      }
     ]
    }
   ],
   "synthesis": "Han 2013 and the 2014 Geriatric ED Guidelines both explicitly define and recommend the sequential two-step DTS to bCAM approach - a highly sensitive rule-out screen (DTS) followed by a highly specific rule-in confirmation (bCAM); Han 2013 is the validation source that governs. The 2026 GED Guidelines 2.0 update endorses DTS to rule out and bCAM to rule in but lists them within a broader menu of instruments (4AT, CAM-ICU, mCAM, AMT-4, RASS) rather than re-mandating the specific DTS to bCAM sequence, so the two-step DTS to bCAM pathway remains the current position, consistent with (not overturned by) the 2026 update.",
   "discrepancy": true
  },
  {
   "id": "ed-cards-r4",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "1",
   "section": "Pathways card",
   "statement": "bCAM directly",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "ED-DEL change package & toolkit"
   ],
   "anchor": "Han 2013 (DTS/bCAM) — p. 8",
   "passage": "… Several delirium multi-component interventions exist for hospitalized patients, but their efficacy has been equivocal.45 Many of these studies, however, enrolled delirious patients across the entire spectrum of severity 24 to 48 hours after admission. Conceivably, performing these interventions in high-risk delirious patients early in the ED course may cost-effectively improve shortand long-term outcomes. This hypothesis should be tested in future investigations using randomized-control trial methodology. Our study has several strengths. The DTS and bCAM achieved a NLR of 0.04 and PLR of 20, respectively. These assessments strongly influence clinical decision making.46 The twostep approach to delirium surveillance also serves as a conceptual model and can be tailored to each institution; one or both components can be used. In addition, each component can reliably performed by healthcare professionals regardless of clinical background and at different times during the ED course, further adding to this approach's flexibility. These Han et al. Page 8 Ann Emerg Med. Author manuscript; available in PMC 2014 November 01. NIH-PA Author Manuscript NIH-PA Author Manuscript NIH-PA Author Manuscript\nThe source states that one or both components may be used, supporting a standalone bCAM pathway. The bCAM used alone was approximately 84% (physician) / 78% (research assistant) sensitive versus 98% for the DTS rule-out, so this pathway trades some sensitivity.",
   "evidence": "Full text, p. 8",
   "status": "fulltext",
   "pageNum": "8",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Validates the bCAM as a highly specific, brief rule-in test and explicitly permits using it as a standalone component; the population is older (65+) ED patients, matching the claim's high-risk framing.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "Method (bCAM), designed to be a highly specific rule-in test for delirium. The reference standard for delirium was a comprehensive psychiatrist assessment using Diagnostic and Statistical Manual of Mental Disorders, Fourth Edition, Text Revision (DSM-IV-TR) criteria. All assessments were independently conducted within 3 hours of each other. Sensitivities, specificities, and likelihood ratios with their 95% confidence intervals (95%CI) were calculated.",
       "highlight": "a highly specific rule-in test for delirium",
       "scope": "on-scope",
       "note": "Directly supports the claim's characterization of the bCAM as a highly specific rule-in instrument.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "The DTS is analogous to D-dimer (highly sensitive) which was intended to reduce computed tomography pulmonary angiography (highly specific) use for pulmonary embolism diagnosis. A negative DTS can potentially reduce the number of formal delirium assessments needed by 50%, while a positive DTS would require a more specific rule-in test. We developed the bCAM to be a brief (<1 minute) rule-in test. If performed in an algorithmic fashion (i.e. stopping if the patient can recite the months backwards with 1 errors), then the bCAM would take even less time which may be appealing for many clinical environments. The bCAM, however, missed subtler forms of inattention, and these patients required a more extensive psychiatrist evaluation than usually needed. The CAM, which has revolutionized delirium diagnosis for non-psychiatrists, can also potentially serve as the rule-in test for delirium. A recent meta-analysis reported it to be 86% sensitive and 93% specific.21 However, the CAM may take over 5 minutes to complete,41, 42 require significant training, and may have decreased diagnostic accuracy when used by non-physicians.22, 23 In addition to the dramatic effect that these instruments could have on the routine clinical practice, the availability of feasible assessments will open a new frontier to additional delirium investigations.",
       "highlight": "the bCAM to be a brief (<1 minute) rule-in test",
       "scope": "on-scope",
       "note": "Supports the claim's 'quick, go straight to the bCAM' framing; Han's <1-minute design target is within the tool's stated <2-minute budget.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "Our study has several strengths. The DTS and bCAM achieved a NLR of 0.04 and PLR of 20, respectively. These assessments strongly influence clinical decision making.46 The twostep approach to delirium surveillance also serves as a conceptual model and can be tailored to each institution; one or both components can be used. In addition, each component can reliably performed by healthcare professionals regardless of clinical background and at different times during the ED course, further adding to this approach's flexibility. These NIH-PA Author Manuscript Ann Emerg Med.",
       "highlight": "one or both components can be used",
       "scope": "on-scope",
       "note": "Explicitly sanctions using the bCAM alone (without the DTS), which is exactly the 'bCAM directly' pathway.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "ED-DEL change package & toolkit",
     "cite": "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Provides the governing on-scope statement of the pathway: for high-risk-only screening (65+ or dementia history), skip triage and go straight to a delirium-specific instrument such as the bCAM.",
     "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf",
     "paragraphs": [
      {
       "context": "There are many available instruments for the screening of delirium in the emergency department. There are several important considerations when determining your screening approach. First, will you be screening all patients, or just those at high risk? If you are screening all patients, then use a very brief instrument at triage, such as Delirium Triage Screen (DTS) or Ultrabrief Two-Item Bedside Test (UB-2). If you will only screen high risk (such as those age 65+ or with a history of dementia), see risk procedure for triage in Toolkit, then go straight to evaluation with a delirium-specific instrument by the RN or MD, such as Brief Confusion Assessment Method (bCAM), Mini-Cog test with short CAM, or the 3DConfusion Assessment Method (3D-CAM). When patients have baseline cognitive information available from family member or proxy reporter (e.g., nurse from nursing home), then a determination of delirium can be readily made or ruled out. However, when screening confused patients whose baseline cognitive information is not available, then treat the patient as delirious until the acuity of change mental status can be confirmed. All high-risk patients should continue on the delirium evaluation pathway, regardless of their initial delirium rating.",
       "highlight": "then go straight to evaluation with a delirium-specific instrument by the RN or MD, such as Brief Confusion Assessment Method (bCAM)",
       "scope": "on-scope",
       "note": "Verbatim source for the 'bCAM directly / skip the triage screen for high-risk patients (age 65+ or dementia history)' pathway.",
       "page": "87",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "The Delirium Triage Screen and b-CAM are noted as validated screening tools for delirium.",
       "highlight": "b-CAM are noted as validated screening tools for delirium",
       "scope": "broader",
       "note": "General Geriatric ED Guidelines note that the b-CAM is a validated delirium screening tool — a broader endorsement supporting, but not specific to, the high-risk-direct pathway.",
       "page": "52",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      }
     ]
    }
   ],
   "synthesis": "Both sources agree and are complementary. The ED-DEL toolkit's Delirium Assessment Approach (Resource V-B) is the on-scope governing source for the \"bCAM directly\" pathway: it explicitly states that when screening only high-risk patients (age 65+ or a history of dementia), you skip the triage screen and \"go straight to evaluation with a delirium-specific instrument... such as Brief Confusion Assessment Method (bCAM).\" Han 2013 supplies the bCAM's validated characteristics (a \"highly specific rule-in test\" designed to be brief) and sanctions standalone use, noting the two-step model \"can be tailored... one or both components can be used\"; note Han designed the bCAM to be <1 minute, so the tool's \"<2-minute\" descriptor is a conservative rounding, not a conflict.",
   "discrepancy": false
  },
  {
   "id": "ed-cards-r5",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "1",
   "section": "Pathways card",
   "statement": "4AT",
   "contentType": "Cited clinical content",
   "sources": [
    "4AT v1.2",
    "SIGN 157",
    "NICE CG103",
    "GED Guidelines 2.0 (2026)"
   ],
   "anchor": "4AT v1.2 — p. 1, ¶37",
   "passage": "Version 1.2. Information and download: www.the4AT.com The 4AT is a screening instrument designed for rapid initial assessment of delirium and cognitive impairment. A score of 4 or more suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis. A score of 1-3 suggests cognitive impairment and more detailed cognitive testing and informant history-taking are required. A score of 0 does not definitively exclude delirium or cognitive impairment: more detailed testing may be required depending on the clinical context. Items 1-3 are rated solely on observation of the patient at the time of assessment. Item 4 requires information from one or more source(s), eg. your own knowledge of the patient, other staff who know the patient (eg. ward nurses), GP letter, case notes, carers. …\nThe DTS manual also lists the 4AT as an acceptable rule-in assessment.",
   "evidence": "Full text, p. 1",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167."
   ],
   "links": [
    "https://www.the4at.com/",
    "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
    "https://www.nice.org.uk/guidance/cg103",
    "https://doi.org/10.1111/acem.70167"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The instrument itself: defines the 4AT and gives the score bands the ED card cites.",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": [
      {
       "context": "The 4AT is a screening instrument designed for rapid initial assessment of delirium and cognitive impairment. A score of 4 or more suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis.",
       "highlight": "screening instrument designed for rapid initial assessment of delirium and cognitive impairment",
       "scope": "on-scope",
       "note": "The instrument's own guidance defines the 4AT as a rapid delirium and cognitive-impairment screen.",
       "page": "1",
       "docUrl": "https://www.the4at.com/"
      },
      {
       "context": "A score of 4 or more suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis. A score of 1-3 suggests cognitive impairment and more detailed cognitive testing and informant history-taking are required. A score of 0 does not definitively exclude delirium or cognitive impairment: more detailed testing may be required depending on the clinical context.",
       "highlight": "A score of 4 or more suggests delirium but is not diagnostic",
       "scope": "on-scope",
       "note": "Instrument guidance-note prose giving the three interpretation bands (>=4, 1-3, 0) the card reproduces.",
       "page": "1",
       "docUrl": "https://www.the4at.com/"
      }
     ]
    },
    {
     "label": "SIGN 157",
     "cite": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Graded recommendation to use the 4AT in ED and acute hospital settings; also validates it in older ED attendees.",
     "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
     "paragraphs": [
      {
       "context": "RThe 4AT tool should be used for identifying patients with probable delirium in emergency department and acute hospital settings.",
       "highlight": "The 4AT tool should be used for identifying patients with probable delirium in emergency department and acute hospital settings",
       "scope": "on-scope",
       "note": "Directly on-scope: SIGN 157 key recommendation to use the 4AT in the emergency department and acute hospital settings.",
       "page": "4",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "A commonly used tool, the Confusion Assessment Method (CAM) and its variants have been reported as useful tools for detecting delirium.18,21,22 However, sensitivity and specificity varied broadly, possibly due to the need for users to have training and knowledge of delirium and its differential diagnoses. The CAM-ICU has particularly broad use within ICU settings but has the same limitations.19,23 The 4 As Test (Arousal, Attention, Abbreviated Mental Test 4, Acute change) 2+ 2++ (4AT) was developed, validated and widely implemented in Scotland in non-ICU settings. It does 2+ not require specific training, is brief and easy to use and has wide applicability in various clinical settings.24,25 It performed well for sensitivity and patient completion rate compared to other similar tools within the same patient group.20,26 The 4AT is also applicable as an assessment tool in older emergency department attendees.27 Other tools had significant disadvantages over CAM and 4AT, such as longer assessment time, poorer sensitivity and/or specificity, and/or relative lack of validation in published studies (see Table 1).",
       "highlight": "applicable as an assessment tool in older emergency department attendees",
       "scope": "on-scope",
       "note": "Supporting narrative confirming the 4AT applies to older ED attendees.",
       "page": "5",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "RUse of the 4AT tool could be considered for use in community or other settings for identifying patients with probable delirium.",
       "highlight": "could be considered for use in community or other settings",
       "scope": "different-setting",
       "note": "Parallel recommendation extends the 4AT to community/other settings - same tool, but a different care setting than the ED card.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "2023 recommendation to use the 4AT when delirium indicators are present, with a critical-care carve-out to CAM-ICU/ICDSC.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "competent to do so should carry out an assessment using the 4AT. In critical care or in the recovery room after surgery use the Confusion Assessment Method for the Intensive Care Unit (CAM-ICU) or Intensive Care Delirium Screening Checklist (ICDSC) instead of the 4AT.",
       "highlight": "carry out an assessment using the 4AT",
       "scope": "on-scope",
       "note": "Rec 1.6.1 directs use of the 4AT when delirium indicators are found; the same sentence carves out CAM-ICU/ICDSC only for critical care/recovery (a different-setting boundary, not the ED).",
       "page": "24",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Balancing the evidence for accuracy and cost effectiveness with the practicality of implementing the tests, the committee agreed that the 4AT was the best option for most settings. It is among the most accurate of the tools reviewed, quick and simple to use, and has a broader range of evidence to support it.",
       "highlight": "the 4AT was the best option for most settings",
       "scope": "on-scope",
       "note": "Committee rationale: the 4AT is the best option for most settings - accurate, quick, no special training required.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "GRADE-based ED guideline conditionally recommending the 4AT among delirium tools, with the largest ED evidence base.",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": [
      {
       "context": "Recommendation #4: In older adults in the ED, 4AT, bCAM, CAM‐ICU, mCAM, AMT‐4, or RASS may be used to rule in or rule out delirium (Conditional, FOR) [Very low certainty of evidence].",
       "highlight": "In older adults in the ED, 4AT, bCAM,",
       "scope": "on-scope",
       "note": "Recommendation #4 conditionally recommends the 4AT (among bCAM, CAM-ICU, mCAM, AMT-4, RASS) to rule delirium in or out in older ED adults.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "In older ED patients with suspected delirium, there is sufficient direct evidence to select delirium diagnostic instruments that accurately rule in (i.e., confirm) or rule out (i.e., exclude) delirium [ 22 ]. The 4AT had the largest quantity of ED‐based research and may be used to rule in or rule out delirium [ 90 ]. The CAM‐ICU, brief Confusion Assessment Method (bCAM), modified Confusion Assessment Method (mCAM) for the Emergency Department, AMT‐4, and Richmond Agitation and Sedation Scale (RASS) are superior to clinical gestalt [ 91 ], and may also be used to rule in or rule out delirium. The Delirium Triage Screen is superior to clinical gestalt in ruling out delirium [ 92 ] (Table 3 ).",
       "highlight": "The 4AT had the largest quantity of",
       "scope": "on-scope",
       "note": "Summary of evidence: the 4AT had the largest quantity of ED-based research (pooled LR+ 7.5, LR- 0.18).",
       "page": "",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "DTS was assessed in a single‐center study ( n = 406) [ 22 , 91 ] demonstrating that ED clinicians using DTS inaccurately rule‐in delirium (LR+ 2.2 [95% CI 1.9–2.5]) but can rule‐out delirium (LR− 0.04 [95% CI 0.01–0.25]) [ 22 ]. Indirect evidence from settings beyond the ED was concordant with our findings. A systematic review of 17 studies (3702 observations) examining the 4AT in acute medicine, surgery, care home, and the ED setting reported pooled sensitivity 0.88 (95% CI 0.90–0.93) and pooled specificity 0.88 (95% CI 0.82–0.92) indicating good diagnostic accuracy [ 116 ]. Miranda et al. [ 117 ] conducted a Cochrane review of 25 studies (2817 participants) of the CAM‐ICU for the diagnosis of delirium in the intensive care unit and estimated a pooled sensitivity of 0.78 (95% CI 0.72–0.83) and pooled specificity of 0.95 (95% CI 0.92–0.97). This indirect evidence further strengthened our findings, as it is unlikely that the setting of tool administration (i.e., ED vs. inpatient setting) significantly affects the tool's accuracy.",
       "highlight": "A systematic review of 17 studies (3702 observations) examining the 4AT in acute medicine, surgery, care home, and the ED setting",
       "scope": "broader",
       "note": "Indirect supporting evidence from a 17-study review spanning acute medicine, surgery, care home and ED - broader than ED-only, but concordant with the ED recommendation.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      }
     ]
    }
   ],
   "synthesis": "All four sources agree that the 4AT is an appropriate rapid delirium screening instrument for the emergency department / acute setting: the 4AT v1.2 form defines the tool and its 0 / 1-3 / >=4 score bands, SIGN 157 gives a graded recommendation to use the 4AT in emergency department and acute hospital settings, NICE CG103 (2023) directs use of the 4AT when delirium indicators are present, and GED Guidelines 2.0 (2026) conditionally recommend the 4AT among ED delirium tools and note it has the largest ED evidence base. The on-scope ED recommendations govern; the different-scope nearest matches are boundary conditions rather than contradictions — SIGN's parallel community-setting recommendation and the NICE/SIGN critical-care carve-out that substitutes CAM-ICU/ICDSC for the 4AT in ICU/recovery, plus GED2's broader multi-setting review used as indirect evidence.",
   "discrepancy": true
  },
  {
   "id": "ed-cards-r6",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "2",
   "section": "DTS card (Step 1)",
   "statement": "Delirium Triage Screen — script \"Say: “Can you spell the word LUNCH backwards?”\"; RASS 0 and 0–1 errors → DTS negative — delirium less likely (98% sensitive rule-out). Continue clinical evaluation; rescreen with any change in mental status.",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "DTS manual (Vanderbilt)"
   ],
   "anchor": "DTS manual (Vanderbilt) — p. 2, ¶4",
   "passage": "The DTS has two components (Figure): 1) Altered level of consciousness which is assessed for by using an arousal scale and 2) inattention which is tested for by asking the patient to spell the world LUNCH backwards. If the patient has normal level of consciousness and makes 0 or 1 errors on the LUNCH backwards task, then the DTS is negative and delirium is ruled out. No additional delirium assessment is needed. If the patient has altered level of consciousness or makes 2 or more errors on the LUNCH backwards task, then the DTS is positive. A more specific delirium assessment such as the bCAM, CAM, 3D-CAM, CAM-ICU or 4AT is needed to rule-in delirium.\nAlso Han 2013 (DTS/bCAM): \"The DTS was 98.0% (95%CI: 89.5% – 99.5%) sensitive with an expected specificity of approximately 55% for both raters.\"\nThe DTS manual provides the exact script (p. 7), the RASS 0 with 0–1 errors negative logic (p. 2), and the 98% sensitive rule-out (p. 2); Han 2013 independently reports 98.0% sensitivity. The instruction to rescreen with any change in mental status is not stated in the DTS manual, which says only that no further delirium assessment is needed.",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "Han JH. Delirium Triage Screen (DTS) Instruction Manual, v1.0 (2015). Vanderbilt University School of Medicine; eddelirium.org."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://eddelirium.org/delirium-assessment/assessment-instruments/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope ED validation of the DTS: confirms the LUNCH-backwards script, the RASS-0/≤1-error negative threshold, and the 98% sensitivity rule-out; the 'rescreen with any change in mental status' management line is not stated here (paper says a negative screen needs no additional testing) and comes from the manual.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "If a patient had a RASS other than 0, or made >1 error on the \"LUNCH\" backwards spelling test, then the DTS was considered positive.",
       "highlight": "If a patient had a RASS other than 0, or made >1 error on the \"LUNCH\" backwards spelling test, then the DTS was considered positive.",
       "scope": "on-scope",
       "note": "Defines the DTS positivity rule (spell LUNCH backwards; RASS other than 0 or >1 error = positive), so RASS 0 with 0-1 errors is a negative rule-out screen.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "Results--Of 406 enrolled patients, 50 (12.3%) had delirium diagnosed by the psychiatrist reference standard. The DTS was 98.0% (95%CI: 89.5% - 99.5%) sensitive with an expected specificity of approximately 55% for both raters. The DTS' negative likelihood ratio was 0.04 (95%CI: 0.01 - 0.25) in both raters. As the complement, the bCAM had a specificity of 95.8% (95%CI: 93.2% - 97.4%) and 96.9% (95%CI: 94.6% - 98.3%) and a sensitivity of 84.0% (95%CI: 71.5% - 91.7%) and 78.0% (95%CI: 64.8% - 87.2%) when performed by the physician and RA, respectively. The positive likelihood ratios for the bCAM were 19.9 (95%CI: 12.0 - 33.2) and 25.2 (95%CI: 13.9 - 46.0), respectively. If the RA DTS was followed by the physician bCAM, the sensitivity of this combination was 84.0% (95%CI: 71.5% - 91.7%) and the specificity was 95.8% (95%CI: 93.2% - 97.4%). If the RA performed both the DTS and bCAM, this combination was 78.0% (95%CI: 64.8% - 87.2%) sensitive and 97.2% (95%CI: 94.9% - 98.5%) specific. If the physician performed both the DTS and bCAM, this combination was 82.0% (95%CI: 69.2% - 90.2%) sensitive and 95.8% (95CI: 93.2% - 97.4%) specific.",
       "highlight": "The DTS was 98.0% (95%CI: 89.5% - 99.5%) sensitive",
       "scope": "on-scope",
       "note": "Directly supports the '98% sensitive rule-out' figure the card cites.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "The DTS' diagnostic performance can be seen in the Table 2. The DTS had excellent sensitivity and moderate specificity when performed by the physician and RA. Both raters had a negative likelihood ratio of 0.04 (95%CI: 0.01 - 0.25), indicating that a negative DTS essentially ruled out delirium. The kappa was 0.79 (95%CI: 0.73 - 0.85) between the two raters indicating very good inter-observer reliability. The bCAM's diagnostic performance in the physician and RAs with their inter-observer reliabilities can be seen in Table 2. The bCAM had very good sensitivity and excellent specificity for both the physician and RA. The bCAM's positive likelihood ratios were 19.9 (95%CI: 12.0 - 33.2) and 25.2 (95%CI: 13.9 - 46.0) when performed by the physician and RAs, respectively. This indicated that a positive bCAM strongly increased the likelihood of delirium. The kappa was 0.88 (95%CI: 0.81 - 0.95) indicating excellent inter-observer reliability between the physician and RA rater.",
       "highlight": "indicating that a negative DTS essentially ruled out delirium",
       "scope": "on-scope",
       "note": "Supports 'DTS negative → delirium less likely' as an essentially rule-out result.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "One method to improve delirium detection would be to use a two-step approach: a sequential testing strategy that utilizes brief, valid, and reliable delirium assessments that can be performed by healthcare professionals of all clinical backgrounds. The first step would be to perform a very brief (<20 seconds), highly sensitive delirium screen to rule-out delirium. This rapid rule-out screen can be incorporated into the ED triage assessment or can be part of the initial nursing assessment after the patient has been placed in an ED bed. A negative screen would rule out delirium, reduce the number of formal delirium assessments needed, and enhance screening efficiency. A positive screen would trigger a formal delirium assessment performed by another health care provider (i.e., physician) at the patient's bedside that would be highly specific to rule-in delirium. Ideally, this rule-in assessment should be brief (<1 minute) to maximize feasibility. We developed Delirium Triage Screen (DTS) and the Brief Confusion Assessment Method (bCAM) to serve as the rule-out and rule-in tests for the two-step approach to delirium surveillance (Figure 1), respectively.",
       "highlight": "A negative screen would rule out delirium, reduce the number of formal delirium assessments needed, and enhance screening efficiency.",
       "scope": "on-scope",
       "note": "Frames a negative DTS as ruling out delirium and a positive screen as triggering further clinical evaluation.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "Delirium is missed at an alarmingly high rate because healthcare professionals do not screen for it.2, 8-13 This compromise in the quality and safety of care occurs15 because brief (<1 minute) and easy to use delirium assessments are not readily available. This investigation provides a novel and simple two-step approach to delirium surveillance that is reliable, valid, and could significantly improve patient care and health outcomes. The DTS (spell \"LUNCH\" backwards) and bCAM (recite the months of the year backwards), when used sequentially, showed a very good sensitivity and excellent specificity. The DTS was highly sensitive with a negative likelihood ratio of 0.04; a negative DTS essentially ruled-out delirium. The bCAM was highly specific and those with a positive bCAM were 20 to 25 times more likely to have delirium than those with a negative bCAM. Furthermore, both these assessments can be reliably performed by healthcare professionals regardless of clinical background and experience. Though formal validation studies are needed, our subgroup analysis suggests that the DTS and bCAM may also have utility in the in-hospital setting where delirium is similarly missed; their diagnostic performances were similar in a subgroup of hospitalized non-ICU patients.",
       "highlight": "a negative DTS essentially ruled-out delirium",
       "scope": "on-scope",
       "note": "Discussion restates the LUNCH-backwards script and the negative-DTS rule-out.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "Step 1 (DTS) can be integrated into the nurses' triage assessment. If the DTS result is negative, then delirium is ruled out and no additional testing is needed. If the DTS result is positive, then a confirmatory delirium assessment such as the bCAM should be performed.",
       "highlight": "If the DTS result is negative, then delirium is ruled out and no additional testing is needed.",
       "scope": "on-scope",
       "note": "Figure 1 confirms RASS 0 = normal level of consciousness and that a negative DTS rules out delirium.",
       "page": "ms. p.12",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "To determine how generalizable our findings were to non-critically ill hospitalized older patients, we analyzed a subgroup of 278 older ED patients who were admitted to non-ICUs; of these, 38 (13.7%) were delirious. The DTS and bCAM's diagnostic performances and inter-observer reliabilities were similar as the main analysis (Table 3). The overall diagnostic performances of the two-step approach performed sequentially by various raters were also similar in this subgroup.",
       "highlight": "The DTS and bCAM's diagnostic performances and inter-observer reliabilities were similar as the main analysis",
       "scope": "different-setting",
       "note": "Nearest performance match but in an in-hospital admitted non-ICU subgroup, not the ED-bedside triage screening the card describes.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "settings. More importantly, the bCAM and DTS may have different diagnostic performances in patients less than 65 years of age. We chose to focus on older patients, because they are disproportionately affected by delirium.",
       "highlight": "the bCAM and DTS may have different diagnostic performances in patients less than 65 years of age",
       "scope": "different-population",
       "note": "The 98% sensitivity was established in ED patients ≥65; the authors caution performance may differ in patients under 65.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "DTS manual (Vanderbilt)",
     "cite": "Han JH. Delirium Triage Screen (DTS) Instruction Manual, v1.0 (2015). Vanderbilt University School of Medicine; eddelirium.org.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Not archived (file null); it is the claim's primaryAnchor (p. 2, ¶4) and supplies the operator-facing script wording and the 'continue clinical evaluation / rescreen with any change in mental status' management guidance that Han 2013 does not state.",
     "docUrl": "https://eddelirium.org/delirium-assessment/assessment-instruments/",
     "paragraphs": []
    }
   ],
   "synthesis": "Han 2013 is the on-scope ED validation that governs the card: it establishes the DTS script (spell LUNCH backwards), the RASS-0-plus-≤1-error negative threshold, and the 98% sensitivity rule-out, while the Vanderbilt DTS manual (the primaryAnchor, unarchived) supplies the operator script and the 'continue evaluation / rescreen with any change in mental status' guidance not found in the paper. The two sources agree on the core; the nearest different-scope matches within Han 2013 (an in-hospital non-ICU admitted subgroup, and the caveat that performance may differ in patients under 65) share keywords but do not replace the primary ED-bedside, ≥65 validation.",
   "discrepancy": true
  },
  {
   "id": "ed-cards-r7",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "2",
   "section": "DTS card — arousal",
   "statement": "Any RASS other than 0 → altered arousal — the DTS is already positive; on the bCAM this is Feature 3.",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "DTS manual (Vanderbilt)",
    "Sessler 2002 (RASS)"
   ],
   "anchor": "DTS manual (Vanderbilt) — p. 3, ¶2",
   "passage": "2. Detailed Procedures for Each DTS Feature a) Altered Level of Consciousness Level of consciousness is determined during the routine patient evaluation by simply observing the patient. The Richmond Agitation Sedation Scale (RASS, Box 1) is used to determine if the patient has altered level of consciousness.30 A RASS of 0 indicates normal level of consciousness. A RASS other than 0 indicates altered level of consciousness and the patient would be considered DTS positive.\nAlso bCAM manual (Vanderbilt): \"A RASS other than “0” indicates that the patient has altered level of consciousness and feature 3 is considered positive.\"\nThe DTS manual (p. 3; FAQ p. 4) supports that any RASS other than 0 makes the DTS positive, and the bCAM manual (p. 5) supports its role as Feature 3; Han 2013 (p. 4) states both.",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "Han JH. Delirium Triage Screen (DTS) Instruction Manual, v1.0 (2015). Vanderbilt University School of Medicine; eddelirium.org."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://eddelirium.org/delirium-assessment/assessment-instruments/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary validation paper for the DTS/bCAM in older ED patients; directly states both halves of the claim.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "The DTS (Figure 1) was designed to be very brief (<20 seconds) so that it could be easily integrated into the clinical workflow. The DTS consists consisted of two components: 1) Level of consciousness - measuring the Richmond Agitation Sedation Scale (RASS) and 2) Attention - spelling the word \"LUNCH\" backwards. The RASS is an arousal scale commonly used in the intensive care unit to assess level of sedation. It ranges from -5 (unarousable) to +4 (combative), and 0 indicates a normal level of alertness.25 Spelling a word backwards is commonly used to assess for inattention.26 If a patient had a RASS other than 0, or made >1 error on the \"LUNCH\" backwards spelling test, then the DTS was considered positive.",
       "highlight": "If a patient had a RASS other than 0, or made >1 error on the \"LUNCH\" backwards spelling test, then the DTS was considered positive.",
       "scope": "on-scope",
       "note": "States that any RASS other than 0 (or a failed LUNCH spelling) makes the DTS positive — the first half of the claim, in the same older-ED-patient population and setting; the clause calling RASS an ICU sedation scale is provenance within this on-scope paragraph, not separate different-setting support.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "to minimize the time spent on this task. Similar to the CAM-ICU, altered level of consciousness (feature 3) was determined by the RASS and disorganized thinking (feature 4) was determined by asking the patient four yes/no questions and to follow a simple command.",
       "highlight": "altered level of consciousness (feature 3) was determined by the RASS and disorganized thinking",
       "scope": "on-scope",
       "note": "Defines altered level of consciousness as bCAM feature 3, scored by RASS, with any RASS other than 0 counting as altered — the second half of the claim.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "Both assessments use the Richmond Agitation Sedation Scale (RASS), which assesses for arousal and ranges from -5 (coma) to +4 (combative);25 a score of 0 indicates normal level of consciousness.",
       "highlight": "Both assessments use the Richmond Agitation Sedation Scale (RASS), which assesses for arousal and ranges from -5 (coma) to +4 (combative);25 a score of 0 indicates normal level of consciousness.",
       "scope": "background",
       "note": "Figure 1 legend framing RASS as the shared arousal measure for both the DTS and bCAM, with 0 as normal — supports the arousal framing but does not itself state the positivity threshold.",
       "page": "ms. p.12",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "DTS manual (Vanderbilt)",
     "cite": "Han JH. Delirium Triage Screen (DTS) Instruction Manual, v1.0 (2015). Vanderbilt University School of Medicine; eddelirium.org.",
     "kind": "unarchived",
     "stance": "background",
     "note": "The card's primary anchor (Delirium Triage Screen Instruction Manual v1.0, eddelirium.org, p.3 ¶2); not archived in this corpus, so no paragraphs. It is the operational source for the RASS-other-than-0 → DTS-positive rule, which Han 2013 confirms.",
     "docUrl": "https://eddelirium.org/delirium-assessment/assessment-instruments/",
     "paragraphs": []
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation–Sedation Scale: validity and reliability in adult intensive care unit patients. Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
     "kind": "pdf",
     "stance": "background",
     "note": "Derivation and validation of the RASS, the scale this claim's arousal rule reads. The DTS manual passage above cites it by reference marker for exactly this purpose. Paywalled and not archived here, so no paragraphs are extractable.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "Han 2013 directly supports both halves of the statement in the same older-ED-patient population and care setting: any RASS other than 0 makes the DTS positive, and on the bCAM an abnormal RASS defines altered level of consciousness (feature 3). The Vanderbilt DTS manual is the card's cited primary anchor and states the same threshold but is unarchived here; the archived source (Han 2013) governs and agrees with it, so the two are concordant.",
   "discrepancy": false
  },
  {
   "id": "ed-cards-r8",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "3",
   "section": "bCAM card (confirm)",
   "statement": "Brief CAM — bCAM positive = Feature 1 + Feature 2 + (Feature 3 or Feature 4)",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "bCAM manual (Vanderbilt)"
   ],
   "anchor": "bCAM manual (Vanderbilt) — p. 2, ¶5",
   "passage": "… The bCAM is a brief delirium screening tool that is a modification of the Confusion Assessment Method of the Intensive Care Unit (CAM-ICU).35 Both the bCAM and CAM-ICU use the Confusion Assessment Method algorithm developed by Inouye et al.36 The bCAM (and CAM-ICU) incorporates objective measures with prespecified cutoffs to test for inattention and disorganized thinking. Like the CAM and CAM-ICU, the bCAM has four features: (1) altered mental status or fluctuating course, (2) inattention, (3) altered level of consciousness, and (4) disorganized thinking. For a patient to meet criteria for delirium, a patient must be positive for features 1 and 2 and positive for either feature 3 or 4 (Figure 1). 2,3\nAlso Han 2013 (DTS/bCAM): \"A patient was considered to be delirious if both features 1 (altered mental status or fluctuating course) and feature 2 (inattention) were present, and either feature 3 (altered level of consciousness) or feature 4 (disorganized thinking) were present.\"",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "Han JH. Brief Confusion Assessment Method (bCAM) Instruction Manual, v1.0 (2015). Vanderbilt University School of Medicine; eddelirium.org."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://eddelirium.org/delirium-assessment/assessment-instruments/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary validation paper; Methods section states the bCAM's four-feature positivity logic and how each feature is scored.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "The bCAM (Figure 1) was a modification of the CAM-ICU,27 both of which were progeny of the Confusion Assessment Method (CAM) developed by Inouye et al.28 The CAM-ICU takes a median of 55 seconds to complete.29 It is over 90% sensitive and specific in critically ill patients but it has not been validated in older ED patients.27, 30 Based upon our previous experience,13 the bCAM was developed to improve the CAM-ICU's sensitivity and enhance its brevity. Similar to the CAM-ICU, the bCAM had four features: 1) altered mental status or fluctuating course, 2) inattention, 3) altered level of consciousness, and 4) disorganized thinking. A patient was considered to be delirious if both features 1 (altered mental status or fluctuating course) and feature 2 (inattention) were present, and either feature 3 (altered level of consciousness) or feature 4 (disorganized thinking) were present.",
       "highlight": "A patient was considered to be delirious if both features 1 (altered mental status or fluctuating course) and feature 2 (inattention) were present, and either feature 3 (altered level of consciousness) or feature 4 (disorganized thinking) were present.",
       "scope": "on-scope",
       "note": "States the bCAM positivity rule identical to the claim: Feature 1 AND Feature 2 AND (Feature 3 OR Feature 4).",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "A patient was considered to be delirious if both features 1 (altered mental status or fluctuating course) and feature 2 (inattention) were present, and either feature 3 (altered level of consciousness) or feature 4 (disorganized thinking) were present.",
       "highlight": "both features 1 (altered mental status or fluctuating course) and feature 2 (inattention) were present, and either feature 3 (altered level of consciousness) or feature 4 (disorganized thinking) were present",
       "scope": "on-scope",
       "note": "States the bCAM-positive rule directly: features 1 and 2 both present plus either feature 3 or feature 4, matching the combination rule in the claim.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "bCAM manual (Vanderbilt)",
     "cite": "Han JH. Brief Confusion Assessment Method (bCAM) Instruction Manual, v1.0 (2015). Vanderbilt University School of Medicine; eddelirium.org.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Companion bedside instruction manual (Han, Vanderbilt; eddelirium.org) operationalizing the same four-feature bCAM algorithm; cited as the section's primaryAnchor for the bCAM confirm card, but no archived text is available to quote.",
     "docUrl": "https://eddelirium.org/delirium-assessment/assessment-instruments/",
     "paragraphs": []
    }
   ],
   "synthesis": "The on-scope Han 2013 validation paper states the bCAM positivity rule almost verbatim — a patient is delirious when Feature 1 and Feature 2 are present plus either Feature 3 or Feature 4 — exactly matching the claim; the CAM-ICU is referenced only as the parent instrument within that same on-scope paragraph, not as a competing rule. The Vanderbilt bCAM manual (unarchived) is the companion bedside instruction source for the identical four-feature algorithm, so the sources agree and the Han 2013 paper governs.",
   "discrepancy": false
  },
  {
   "id": "ed-cards-r9",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "3",
   "section": "bCAM card — Feature 2",
   "statement": "Inattention: Say: “Can you name the months backwards from December to July?”",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "bCAM manual (Vanderbilt)"
   ],
   "anchor": "bCAM manual (Vanderbilt) — p. 1",
   "passage": "1) Will a stone float on water? 2) Are there fish in the sea? 3) Does one pound weigh more than two pounds? 4) Can you use a hammer to pound a nail? Command: \"Hold up this many fingers\" (Hold up two fingers). \"Now do the same thing with the other hand\" (Do not demonstrate). No Brief Confusion Assessment Method (bCAM) Flow Sheet No Errors Any Errors Feature 2 - Inattention \" Can you name the months backwards from December to July? \" Feature 1 - Altered Mental Status or Fluctuating Course Yes Copyright © 2012. Vanderbilt University.\nAlso Han 2013 (DTS/bCAM): \"the bCAM simply asked the patient to recite months backwards from December to July to assess for inattention (feature 2).\"\nThe printed wording matches the bCAM flow sheet verbatim; the bCAM worksheet (p. 10) uses the slight variant \"Can you name the months backwards starting from December to July?\" Han 2013 (p. 4) confirms the December-to-July task.",
   "evidence": "Full text, p. 10",
   "status": "fulltext",
   "pageNum": "10",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "Han JH. Brief Confusion Assessment Method (bCAM) Instruction Manual, v1.0 (2015). Vanderbilt University School of Medicine; eddelirium.org."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://eddelirium.org/delirium-assessment/assessment-instruments/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Validation paper for the DTS/bCAM in older ED patients; its Methods describe the bCAM Feature 2 inattention test (months backwards, December to July), supporting the card's substance.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "ICU,27 the bCAM simply asked the patient to recite months backwards from December to July to assess for inattention (feature 2).31-33 If the patient made >1 error, or was unable or refused to perform the task, then he/she was considered to be positive for inattention.",
       "highlight": "recite months backwards from December to July to assess for inattention (feature 2)",
       "scope": "on-scope",
       "note": "Directly describes the bCAM Feature 2 inattention test in older ED patients — reciting the months backwards from December to July — the exact method the card scripts.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "The DTS (Figure 1) was designed to be very brief (<20 seconds) so that it could be easily integrated into the clinical workflow. The DTS consists consisted of two components: 1) Level of consciousness - measuring the Richmond Agitation Sedation Scale (RASS) and 2) Attention - spelling the word \"LUNCH\" backwards. The RASS is an arousal scale commonly used in the intensive care unit to assess level of sedation. It ranges from -5 (unarousable) to +4 (combative), and 0 indicates a normal level of alertness.25 Spelling a word backwards is commonly used to assess for inattention.26 If a patient had a RASS other than 0, or made >1 error on the \"LUNCH\" backwards spelling test, then the DTS was considered positive.",
       "highlight": "Attention - spelling the word \"LUNCH\" backwards",
       "scope": "different-intervention",
       "note": "Nearest keyword match on attention testing, but this is the DTS rule-out screen's attention component (spell LUNCH backwards), a different instrument's test — not the bCAM months-backwards inattention script.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "bCAM manual (Vanderbilt)",
     "cite": "Han JH. Brief Confusion Assessment Method (bCAM) Instruction Manual, v1.0 (2015). Vanderbilt University School of Medicine; eddelirium.org.",
     "kind": "unarchived",
     "stance": "background",
     "note": "Primary source (unarchived, no file) for the exact bedside script wording 'Can you name the months backwards from December to July?'; cited as the bCAM instruction manual p. 1.",
     "docUrl": "https://eddelirium.org/delirium-assessment/assessment-instruments/",
     "paragraphs": []
    }
   ],
   "synthesis": "Han 2013 is on-scope and agrees: its Methods state the bCAM asks the patient to recite the months backwards from December to July to assess inattention (Feature 2) in older ED patients, supporting the card's substance, while the exact scripted phrasing (\"Can you name the months...\") comes from the bCAM manual (unarchived). The same paper's DTS \"spell LUNCH backwards\" attention test is a nearest keyword match but a different instrument's test and does not support the months-backwards script.",
   "discrepancy": true
  },
  {
   "id": "ed-cards-r10",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "4",
   "section": "4AT card",
   "statement": "4AT — alertness + AMT4 + months-backward + acute change. Bands: ≥ 4: possible delirium ± cognitive impairment (≥4); 1–3: possible cognitive impairment (≥1); 0: delirium or severe cognitive impairment unlikely (≥0)",
   "contentType": "Cited clinical content",
   "sources": [
    "4AT v1.2",
    "Bellelli 2014",
    "Shenkin 2019",
    "Tieges 2021"
   ],
   "anchor": "4AT v1.2 — p. 1, ¶34",
   "passage": "4 or above: possible delirium +/- cognitive impairment 1-3: possible cognitive impairment 0: delirium or severe cognitive impairment unlikely (but delirium still possible if [4] information incomplete)\nThe 4AT v1.2 instrument lists the four items — Alertness, AMT4, Attention (months of the year backwards), and Acute Change or Fluctuating Course — and the three score bands as quoted.",
   "evidence": "Full text, p. 1",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Bellelli G, et al. Validation of the 4AT, a new instrument for rapid delirium screening: a study in 234 hospitalised older people. Age Ageing. 2014;43(4):496–502.",
    "Shenkin SD, et al. Delirium detection in older acute medical inpatients: a multicentre prospective comparative diagnostic test accuracy study of the 4AT and the confusion assessment method. BMC Med. 2019;17:138.",
    "Tieges Z, et al. Diagnostic accuracy of the 4AT for delirium detection in older adults: systematic review and meta-analysis. Age Ageing. 2021;50(3):733–743."
   ],
   "links": [
    "https://www.the4at.com/",
    "https://doi.org/10.1093/ageing/afu021",
    "https://doi.org/10.1186/s12916-019-1367-9",
    "https://doi.org/10.1093/ageing/afaa224"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary instrument: defines the four items and all three score bands exactly as claimed.",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": [
      {
       "context": "A score of 4 or more suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis. A score of 1-3 suggests cognitive impairment and more detailed cognitive testing and informant history-taking are required. A score of 0 does not definitively exclude delirium or cognitive impairment: more detailed testing may be required depending on the clinical context.",
       "highlight": "A score of 4 or more suggests delirium but is not diagnostic",
       "scope": "on-scope",
       "note": "The instrument's own guidance prose stating all three bands (>=4 delirium, 1-3 cognitive impairment, 0 not definitively excluded).",
       "page": "1",
       "docUrl": "https://www.the4at.com/"
      },
      {
       "context": "Ask the patient: \"Please tell me the months of the year in backwards order, starting at December.\" To assist initial understanding one prompt of \"what is the month before December?\" is permitted.",
       "highlight": "the months of the year in backwards order",
       "scope": "on-scope",
       "note": "Defines item [3] attention as the Months-Backward test, one of the four named components.",
       "page": "1",
       "docUrl": "https://www.the4at.com/"
      },
      {
       "context": "A score of 4 or more suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis. A score of 1-3 suggests cognitive impairment and more detailed cognitive testing and informant history-taking are required.",
       "highlight": "suggests delirium but is not diagnostic",
       "scope": "on-scope",
       "note": "Guidance-note prose restating the >=4 delirium and 1-3 cognitive-impairment interpretation bands.",
       "page": "1",
       "docUrl": "https://www.the4at.com/"
      }
     ]
    },
    {
     "label": "Bellelli 2014",
     "cite": "Bellelli G, et al. Validation of the 4AT, a new instrument for rapid delirium screening: a study in 234 hospitalised older people. Age Ageing. 2014;43(4):496–502.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Enumerates all four items and all three bands; validation population is hospitalized older people (geriatric admission), but the description of the instrument is on-scope.",
     "docUrl": "https://doi.org/10.1093/ageing/afu021",
     "paragraphs": [
      {
       "context": "A score of 0 is intended to suggest that delirium and/or moderate to severe cognitive impairment is unlikely, though the latter possibility is not being evaluated in the present study. Scores between 1 and 3 are intended to suggest possible moderate to severe general cognitive impairment (that is, corresponding to moderate to severe impairment on standalone dementia screening tools). A score of 4 or above suggests possible delirium.",
       "highlight": "A score of 4 or above suggests possible delirium.",
       "scope": "on-scope",
       "note": "States the three 4AT score bands: 0 = delirium/severe cognitive impairment unlikely, 1–3 = possible cognitive impairment, ≥4 = possible delirium.",
       "page": "",
       "docUrl": "https://doi.org/10.1093/ageing/afu021"
      }
     ]
    },
    {
     "label": "Shenkin 2019",
     "cite": "Shenkin SD, et al. Delirium detection in older acute medical inpatients: a multicentre prospective comparative diagnostic test accuracy study of the 4AT and the confusion assessment method. BMC Med. 2019;17:138.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Confirms the four items and the ≥4 (>3) possible-delirium cutoff; a DTA study in older acute medical inpatients that does not restate the 1–3 / 0 bands but does not conflict.",
     "docUrl": "https://doi.org/10.1186/s12916-019-1367-9",
     "paragraphs": [
      {
       "context": "The 4AT [ 25 , 26 ] comprises four items: (A) Alertness, (B) Abbreviated Mental Test-4, (C) Attention (Months Backwards test), and (D) acute change or fluctuating course [ 25 , 27 ], Fig. 1 . The 4AT was not derived directly from a single set of diagnostic criteria; rather, it has items that inform the core features of standard diagnostic criteria. It has a score range of 0–12, with scores of 4 or more (> 3) suggesting possible delirium.",
       "highlight": "scores of 4 or more (> 3) suggesting possible delirium",
       "scope": "on-scope",
       "note": "Lists the four items and the pre-specified ≥4 (>3) threshold for possible delirium; lower interpretation bands not separately addressed.",
       "page": "",
       "docUrl": "https://doi.org/10.1186/s12916-019-1367-9"
      }
     ]
    },
    {
     "label": "Tieges 2021",
     "cite": "Tieges Z, et al. Diagnostic accuracy of the 4AT for delirium detection in older adults: systematic review and meta-analysis. Age Ageing. 2021;50(3):733–743.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Meta-analysis describing the four items and the pre-specified ≥4 delirium cutoff for a tool intended for general first-presentation use; corroborates the instrument's structure.",
     "docUrl": "https://doi.org/10.1093/ageing/afaa224",
     "paragraphs": [
      {
       "context": "The 4 ‘A’s Test or 4AT was developed as a short delirium assessment tool intended for clinical use in general settings at first presentation and when delirium is suspected. It was initially published on a dedicated website in 2011 [ 9 ]. It consists of four items: an item assessing level of alertness, a test of orientation (the Abbreviated Mental Test–4, comprising 4 orientation questions), a test of attention (Months Backward test); and an item ascertaining acute change or fluctuating course ( Appendix S1 ). The first diagnostic test accuracy study in general settings was published in 2014 [ 10 ]. Since publication 4AT performance has been evaluated in multiple studies [ 11 ]. The 4AT has become a standard tool in clinical practice [ 12 , 13 ] and it is recommended in guidelines and pathways [ 6 , 14 ].",
       "highlight": "It consists of four items: an item assessing level of alertness",
       "scope": "on-scope",
       "note": "Enumerates the four items: alertness, orientation (AMT-4), attention (Months Backward), and acute change/fluctuating course.",
       "page": "",
       "docUrl": "https://doi.org/10.1093/ageing/afaa224"
      },
      {
       "context": "Studies were assessed for methodological quality by two independent review authors (R.G. and Z.T.) using the Quality Assessment of Diagnostic Accuracy Studies (QUADAS-2) tool. Narrative summaries were generated describing risk of bias (high, low or unclear) and concerns regarding applicability. As part of a tailoring phase of the QUADAS-2 tool, the item on the threshold used was omitted because the design of the 4AT pre-specifies the threshold to be used for delirium detection (cutoff ≥ 4). For the item on the appropriate interval between index test and reference standard, the interval was set to a maximum of 3 hours ( Appendix S3 : Assessment of methodological quality with the QUADAS-2 tool).",
       "highlight": "the threshold to be used for delirium detection (cutoff ≥ 4)",
       "scope": "on-scope",
       "note": "Confirms the ≥4 delirium cutoff is pre-specified in the instrument's design, matching the claim's ≥4 band.",
       "page": "",
       "docUrl": "https://doi.org/10.1093/ageing/afaa224"
      }
     ]
    }
   ],
   "synthesis": "All four sources agree on the 4AT's four items (alertness, AMT4, Months-Backward attention, acute change/fluctuating course) and its score bands. The 4AT v1.2 instrument (primary, on-scope) states the full three-band structure verbatim (≥4 possible delirium ± cognitive impairment; 1–3 possible cognitive impairment; 0 delirium/severe cognitive impairment unlikely), and Bellelli 2014 restates all three bands; Shenkin 2019 and Tieges 2021 corroborate the four items and the pre-specified ≥4 delirium cutoff. The instrument governs because the claim describes the tool's own structure, which is population- and setting-independent, so the validation studies (geriatric ward / acute medical inpatients / general first-presentation) reinforce rather than qualify it.",
   "discrepancy": false
  },
  {
   "id": "ed-cards-r11",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "5",
   "section": "Act-on-a-positive — Look for the cause — delirium is a symptom",
   "statement": "Review medications first (new, changed, or deliriogenic drugs; anticholinergics, benzodiazepines, opioids) and consider withdrawal (alcohol, benzodiazepines).",
   "contentType": "Cited clinical content",
   "sources": [
    "ADEPT (2020)",
    "ED-DEL change package & toolkit"
   ],
   "anchor": "ADEPT (2020) — p. 6",
   "passage": "Infections are the most common cause of delirium identified in ED studies, responsible for 30% to 40% of cases, followed by acute neurologic disorders such as ischemic stroke, intracranial hemorrhage, or intracranial mass.9,27 Adverse effects of medications commonly cause delirium and are estimated to be responsible for 12% to 39% of delirium across medical settings.28 Accordingly, it is critical that the emergency clinician perform a medication review to identify recent medication changes and use of medications at high risk of causing delirium (Table 1). Delirium is also frequently multifactorial.29 For example, a patient with a urinary tract infection may experience delirium from the infection, but other compounding factors such as dehydration, pain, new antibiotic medications, and change in environment can also contribute. Although every evaluation should be tailored to the patient, most patients should receive an ECG, CBC count, metabolic panel, point-of-care glucose level test, and a urinalysis with culture. Although urinary tract infections are a common delirium precipitant, asymptomatic bacteriuria is also very common in geriatric populations. …\nTable 1 (p. 16) names the specific classes, including anticholinergic medications and sedative hypnotics (benzodiazepines), and lists alcohol or benzodiazepine withdrawal among toxicologic precipitants. Opioids are not named in Table 1, though ADEPT's recommendation of nonsedating, nonopioid analgesia implies they are deliriogenic.",
   "evidence": "Full text, p. 6",
   "status": "fulltext",
   "pageNum": "6",
   "citations": [
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope diagnostic guidance to review medications for recent changes/high-risk deliriogenic drugs and to consider alcohol/benzodiazepine withdrawal; opioids only implied via the prevention step.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "Adverse effects of medications commonly cause delirium and are estimated to be responsible for 12% to 39% of delirium across medical settings.28 Accordingly, it is critical that the emergency clinician perform a medication review to identify recent medication changes and use of medications at high risk of causing delirium (Table 1).",
       "highlight": "perform a medication review to identify recent medication changes and use of medications at high risk of causing delirium",
       "scope": "on-scope",
       "note": "Directly supports reviewing medications first (new, changed, or deliriogenic drugs) as part of the cause search for a delirious ED patient.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Examples Hypoxia, hypercarbia, hypoglycemia, hyperglycemia, hyponatremia, hyperkalemia Urinary tract infection, pneumonia, intra-abdominal infections, meningitis/encephalitis, sepsis from other source Transient ischemic attack, stroke, intracranial hemorrhage, intracranial mass Anticholinergic medications (including tricyclic antidepressants, antihistamines, muscle relaxants, promethazine, typical antipsychotics, sedative hypnotics (benzodiazepines, zolpidem), corticosteroids, polypharmacy (considered 4 medications), salicylate toxicity Intoxication with alcohol or substance use, alcohol or benzodiazepine withdrawal Hyper- or hypoglycemia, hyper- or hyponatremia, dehydration, acute kidney injury, uremia, diabetic ketoacidosis Acute coronary syndrome, dissection, hypoxia, hypotension, anemia New or unfamiliar environment, lack of sleep, lack of hearing or vision aids Pain, urinary retention Page 16 Author Manuscript Author Manuscript Author Manuscript Author Manuscript Comparison of brief delirium assessment tools.",
       "highlight": "sedative hypnotics (benzodiazepines, zolpidem)",
       "scope": "on-scope",
       "note": "Table 1 itemizes the deliriogenic classes named in the claim — anticholinergics and benzodiazepines.",
       "page": "ms. p.16",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "If a patient has a history of long-term benzodiazepine use, do not stop these medications precipitately because it may lead to withdrawal and worsening delirium.",
       "highlight": "it may lead to withdrawal and worsening delirium",
       "scope": "on-scope",
       "note": "Prose warns that abruptly stopping long-term benzodiazepines can precipitate withdrawal and worsening delirium, supporting 'consider withdrawal (benzodiazepines)'; alcohol and benzodiazepine withdrawal also appear in Table 1's reversible-causes list.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "These include treating the underlying condition and managing pain,36 ideally with nonsedating, nonopioid medications if possible.",
       "highlight": "nonsedating, nonopioid medications if possible",
       "scope": "different-intervention",
       "note": "Nearest mention of opioids, but in the Prevent step (choose non-opioid analgesia) rather than the diagnostic medication review the claim describes.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "ED-DEL change package & toolkit",
     "cite": "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope: the ADEPT-derived assessment protocol and 'identifying causes' list direct medication-history review and drug/withdrawal consideration; separate prevention/treatment passages echo the same drug classes under a management scope.",
     "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf",
     "paragraphs": [
      {
       "context": "o Assess for medication history, including use of OTC medications, alcohol (amount, last drink), illicit drugs, recent changes in medications, high-risk medications, and medication noncompliance.",
       "highlight": "recent changes in medications, high-risk medications, and medication noncompliance",
       "scope": "on-scope",
       "note": "Assessment protocol directs reviewing medication history including recent changes and high-risk drugs plus alcohol history (last drink) — matches 'review medications first' and 'consider withdrawal (alcohol)'.",
       "page": "91",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "It is important to act quickly if you suspect a patient has delirium. Serious causes of delirium include:1 Any local infection (pneumonia, upper or lower urinary tract infection, skin or soft tissue, intraabdominal, brain) Sepsis Drug-related: toxicity, withdrawal, intolerance, excess Metabolic abnormality (dehydration, abnormally decreased or increased levels of sodium, calcium, potassium, glucose; acute renal impairment) Acute coronary syndrome Intracranial event (Transient Ischemic Attack, TIA, ischemic/hemorrhagic cerebrovascular accident, CVA) Physical discomfort (untreated pain, fecal impaction, urinary retention)",
       "highlight": "Drug-related: toxicity, withdrawal, intolerance, excess",
       "scope": "on-scope",
       "note": "Lists drug-related toxicity/withdrawal among the serious causes to look for, supporting the 'delirium is a symptom -> look for the cause' framing.",
       "page": "",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Review medications: minimize Beers criteria medications (use less harmful alternatives); minimize doses. Avoid use of high-risk medications: benzodiazepines (unless taking chronically and at risk of withdrawal), diphenhydramine, sedatives, muscle-relaxants, anticholinergics, anti-histamines, antipsychotics, ketamine. [See also Beers criteria medications].",
       "highlight": "benzodiazepines (unless taking chronically and at risk of withdrawal)",
       "scope": "different-intervention",
       "note": "Prevention/treatment protocol that says 'review medications' and names benzodiazepine-withdrawal risk and anticholinergics — same drug classes but framed as avoid/minimize (management), not the diagnostic cause search.",
       "page": "96",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Treat the contributors to delirium Ensure the person is eating, drinking, moving, and toileting regularly Keep them as comfortable as possible (warm blanket, appropriate lighting) Ensure stimulation and orientation by staff, family and other caregivers. Enhance sensory input (make an effort to get eyeglasses, hearing aids) Minimize inappropriate medications, especially anticholinergics and benzodiazepines.",
       "highlight": "Minimize inappropriate medications, especially anticholinergics and benzodiazepines",
       "scope": "different-intervention",
       "note": "Closest keyword echo of the claim's anticholinergic/benzodiazepine list, but under 'How to Prevent, Treat, or Improve Delirium' (minimize deliriogenic drugs) rather than reviewing to find the cause.",
       "page": "",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      }
     ]
    }
   ],
   "synthesis": "Both on-scope sources agree with the claim: ADEPT's evaluation guidance and the ADEPT-derived ED-DEL assessment protocol both direct the clinician to review medications for recent changes and high-risk/deliriogenic drugs and to assess alcohol/benzodiazepine use, with ADEPT Table 1 explicitly naming anticholinergics and benzodiazepines and listing \"alcohol or benzodiazepine withdrawal.\" The one weakly-supported element is \"opioids\": neither source itemizes opioids in its deliriogenic list — support is only oblique (ADEPT's prevention step to prefer \"nonsedating, nonopioid\" analgesia), and the prevention/treatment passages that echo the same drug classes are a different-intervention scope (avoid/minimize) that does not govern this \"look for the cause\" statement.",
   "discrepancy": true
  },
  {
   "id": "ed-cards-r12",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "5",
   "section": "Act-on-a-positive — Look for the cause — delirium is a symptom",
   "statement": "Screen for infection, hypoxia, hypoglycemia, metabolic derangement, and neurologic causes as clinically indicated.",
   "contentType": "Cited clinical content",
   "sources": [
    "ADEPT (2020)",
    "ED-DEL change package & toolkit"
   ],
   "anchor": "ADEPT (2020) — p. 6",
   "passage": "… Delirium is also frequently multifactorial.29 For example, a patient with a urinary tract infection may experience delirium from the infection, but other compounding factors such as dehydration, pain, new antibiotic medications, and change in environment can also contribute. Although every evaluation should be tailored to the patient, most patients should receive an ECG, CBC count, metabolic panel, point-of-care glucose level test, and a urinalysis with culture. Although urinary tract infections are a common delirium precipitant, asymptomatic bacteriuria is also very common in geriatric populations. Among community-dwelling older adults, 5% of men and 6% to 10% of women have asymptomatic bacteriuria. …\nThe quoted workup (p. 6) covers infection, hypoglycemia, and metabolic derangement; Table 1 (p. 16) adds hypoxia among readily reversible causes and neurologic causes (TIA, stroke, intracranial hemorrhage or mass). The p. 6 narrative also names infection as the most common cause, followed by acute neurologic disorders.",
   "evidence": "Full text, p. 6",
   "status": "fulltext",
   "pageNum": "6",
   "citations": [
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ADEPT tool for older ED patients; primary anchor (p. 6). Directly supports screening delirium-positive patients for underlying causes across infection, hypoxia, hypoglycemia, metabolic, and neurologic categories.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "Infections, neurologic disorders, and metabolic or electrolyte disorder are 3 of the most common causes of acute alterations in mental status among older patients.9 Adverse medication effects are another common cause. A list of medications that are high risk for causing confusion, altered mental status, or delirium is shown in Table 1.",
       "highlight": "Infections, neurologic disorders, and metabolic or electrolyte disorder are 3 of the most common causes",
       "scope": "on-scope",
       "note": "Names infection, neurologic, and metabolic/electrolyte disorders as the three most common causes of acute mental-status change in older patients.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Third is \"Evaluate.\" Although the \"Diagnose\" step focuses on determining whether delirium is present, the \"Evaluate\" step focuses on evaluation for underlying causes (Table 1).26 The evaluation should be directed by a focused history and careful physical examination.",
       "highlight": "The evaluation should be directed by a focused history and careful physical examination",
       "scope": "on-scope",
       "note": "The ADEPT 'Evaluate' step is explicitly evaluation for underlying causes, directed by focused history and physical exam — the framing the claim summarizes.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "First is \"Assess.\" Once life threats and immediately treatable conditions such as hypoxia, hypoglycemia, and ST-segment elevation myocardial infarction have been ruled out and patient and staff safety are ensured, the next step is to determine whether there has been a change from baseline and the time course.8 First establish the patient's baseline mental status and the time course of any changes, a process that will typically require contacting a family member or caregiver.",
       "highlight": "hypoxia, hypoglycemia, and ST-segment elevation myocardial infarction",
       "scope": "on-scope",
       "note": "The 'Assess' step lists hypoxia and hypoglycemia among immediately treatable life threats to rule out — two of the claim's screening targets.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Infections are the most common cause of delirium identified in ED studies, responsible for 30% to 40% of cases, followed by acute neurologic disorders such as ischemic stroke, intracranial hemorrhage, or intracranial mass.9,27 Adverse effects of medications commonly cause delirium and are estimated to be responsible for 12% to 39% of delirium across medical settings.28 Accordingly, it is critical that the emergency clinician perform a medication review to identify recent medication changes and use of medications at high risk of causing delirium (Table 1). Delirium is also frequently multifactorial.29 For example, a patient with a urinary tract infection may experience delirium from the infection, but other compounding factors such as dehydration, pain, new antibiotic medications, and change in environment can also contribute.",
       "highlight": "such as ischemic stroke, intracranial hemorrhage, or intracranial mass",
       "scope": "on-scope",
       "note": "Quantifies infection and acute neurologic disorders as the leading ED delirium causes to screen for.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Although every evaluation should be tailored to the patient, most patients should receive an ECG, CBC count, metabolic panel, point-of-care glucose level test, and a urinalysis with culture. Although urinary tract infections are a common delirium precipitant, asymptomatic bacteriuria is also very common in geriatric populations. Among community-dwelling older adults, 5% of men and 6% to 10% of women have asymptomatic bacteriuria. The rates of asymptomatic bacteriuria are higher among institutionalized older adults, with 15% to 35% of men and 25% to 50% of women having asymptomatic bacteriuria.30 Pyuria with or without bacteriuria is also common in asymptomatic older adults, particularly those with chronic incontinence.30 Emergency clinicians should be wary of premature diagnostic closure, incorrectly attributing behavioral changes to a urinary tract infection when the evidence for this condition is sparse.",
       "highlight": "metabolic panel, point-of-care glucose level test, and a urinalysis with culture",
       "scope": "on-scope",
       "note": "The recommended workup operationalizes metabolic, hypoglycemia (glucose), and infection (urinalysis/culture) screening 'as clinically indicated'.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Infections, neurologic disorders, and metabolic or electrolyte disorder are 3 of the most common causes of acute alterations in mental status among older patients.",
       "highlight": "Infections, neurologic disorders, and metabolic or electrolyte disorder are 3 of the most common causes of acute alterations in mental status",
       "scope": "on-scope",
       "note": "Prose names infection, neurologic, and metabolic or electrolyte disorders as the most common causes of acute mental-status change in older adults, matching the claim's screen list (hypoxia and hypoglycemia appear among Table 1's reversible causes).",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "ED-DEL change package & toolkit",
     "cite": "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ACEP ED-DEL toolkit for the older ED delirium patient; corroborates the ADEPT screening list with 'do not miss' conditions and a focused medical workup.",
     "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf",
     "paragraphs": [
      {
       "context": "Change Tactics Perform history, physical and neurological examination, vital signs, O2 saturation, and finger stick glucose Assess history of alcohol and benzodiazepine usage Conduct targeted laboratory evaluation, guided by the history and physical examination Identify and Evaluate prescription medication address listing and determine any recent medications changes posing high risk Assess all over-the-counter for delirium medication usage, including herbal and complementary and alternative approaches, as well as recreational substances (alcohol, cannabis, other) Institute de-prescribing as appropriate Apply effective Use proven approaches to provide non- adequate nutrition and hydration, pharmacologic promote mobility and reduce approaches to tethers and alarms, maximize vision prevent delirium and hearing, provide orienting (prioritized by communication, and maintain sleep anticipated ED cycle.",
       "highlight": "physical and neurological examination, vital signs, O2 saturation, and finger stick glucose",
       "scope": "on-scope",
       "note": "The 'Evaluate' change concept directs neurological exam, O2 saturation (hypoxia), and fingerstick glucose (hypoglycemia) as core workup to identify underlying causes.",
       "page": "",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "hypoxia/hypercarbia/respiratory failure, hypoglycemia, stroke, acute MI, epidural/subdural hematoma, herpes encephalitis, alcohol/drug intoxication or withdrawal, toxic exposures (e.g., carbon monoxide), myxedema Additional testing to consider as indicated o Drug levels: Digoxin, lithium, acetaminophen, salicylate, carboxyhemoglobin o Lumbar puncture These recommendations are designed to be adapted into a standing order set in your emergency department.",
       "highlight": "hypoxia/hypercarbia/respiratory failure, hypoglycemia, stroke",
       "scope": "on-scope",
       "note": "The 'do not miss' conditions prioritize evaluation for hypoxia, hypoglycemia, and stroke (neurologic) — three of the claim's categories.",
       "page": "",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "It is important to act quickly if you suspect a patient has delirium. Serious causes of delirium include:1 Any local infection (pneumonia, upper or lower urinary tract infection, skin or soft tissue, intraabdominal, brain) Sepsis Drug-related: toxicity, withdrawal, intolerance, excess Metabolic abnormality (dehydration, abnormally decreased or increased levels of sodium, calcium, potassium, glucose; acute renal impairment) Acute coronary syndrome Intracranial event (Transient Ischemic Attack, TIA, ischemic/hemorrhagic cerebrovascular accident, CVA) Physical discomfort (untreated pain, fecal impaction, urinary retention)",
       "highlight": "Metabolic abnormality (dehydration, abnormally decreased or increased levels of sodium, calcium, potassium, glucose; acute renal impairment)",
       "scope": "on-scope",
       "note": "The 'serious causes of delirium' list covers infection, metabolic abnormality (glucose), and intracranial events, matching the claim's underlying-cause categories.",
       "page": "",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Prioritize evaluation for the following conditions: hypoxia/respiratory failure, hypoglycemia, stroke, acute coronary syndrome, epidural/subdural hematoma, herpes encephalitis, drug overdose or withdrawal, toxic exposures (e.g., carbon monoxide), myxedema",
       "highlight": "hypoxia/respiratory failure, hypoglycemia, stroke",
       "scope": "on-scope",
       "note": "The assessment protocol's 'do not miss' conditions prioritize screening for hypoxia, hypoglycemia, stroke, and other neurologic and metabolic causes — the targeted workup the claim describes.",
       "page": "",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      }
     ]
    }
   ],
   "synthesis": "Both sources directly support screening delirium-positive older ED patients for underlying causes spanning infection, hypoxia, hypoglycemia, metabolic derangement, and neurologic conditions: the ADEPT 'Evaluate' step with its Table 1 of readily reversible causes names each category, and the ED-DEL toolkit's 'do not miss' conditions and focused workup corroborate the same list. The sources agree and are entirely on-scope for the ED Card Set's 'delirium is a symptom — look for the cause' framing, with the ADEPT tool governing as the primary anchor (p. 6).",
   "discrepancy": false
  },
  {
   "id": "ed-cards-r13",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "5",
   "section": "Act-on-a-positive — Look for the cause — delirium is a symptom",
   "statement": "Check for pain, urinary retention, and constipation — common, reversible precipitants.",
   "contentType": "Cited clinical content",
   "sources": [
    "ADEPT (2020)",
    "ED-DEL change package & toolkit"
   ],
   "anchor": "ADEPT (2020) — p. 6",
   "passage": "… However, there are measures that can be undertaken for individual patients to prevent the development of delirium, to prevent its progression, and to mitigate its symptoms.34,35 These include treating the underlying condition and managing pain,36 ideally with nonsedating, nonopioid medications if possible. Treatment of other bothersome symptoms such as nausea, vomiting, and constipation can be helpful. Unless contraindicated, a patient's home medications should be administered on schedule to prevent exacerbation of baseline medical problems. Medications that can cause delirium should be avoided (Table 1). Normalize the patient's daily function by providing hydration, food (unless contraindicated), access and assistance to toileting, mobility assistance or aids, and hearing-assistive devices. Limit unnecessary disruptions. Unless medically necessary, things that tether the patient to the bed should be avoided, including blood pressure cuffs, monitor leads, continuous intravenous infusions, Shenvi et al. Page 6 Ann Emerg Med. Author manuscript; available in PMC 2021 March 10. …\nThe quote covers constipation (p. 6); pain and urinary retention appear in Table 1 (p. 16) under \"Other factors,\" and the table's title, \"Common and important precipitants,\" matches the statement's framing. Pain is also listed on p. 6 as a compounding factor.",
   "evidence": "Full text, p. 6",
   "status": "fulltext",
   "pageNum": "6",
   "citations": [
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "For example, a patient with a urinary tract infection may experience delirium from the infection, but other compounding factors such as dehydration, pain, new antibiotic medications, and change in environment can also contribute.",
       "highlight": "other compounding factors such as dehydration, pain, new antibiotic medications, and change in environment can also contribute",
       "scope": "on-scope",
       "note": "Prose names pain among the compounding, reversible factors that contribute to delirium; urinary retention and constipation appear in Table 1's 'Other factors' example list rather than in prose.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "The fourth is \"Prevent.\" Most EDs are busy, bright, noisy, and potentially deliriogenic environments, especially for older patients. However, there are measures that can be undertaken for individual patients to prevent the development of delirium, to prevent its progression, and to mitigate its symptoms.34,35 These include treating the underlying condition and managing pain,36 ideally with nonsedating, nonopioid medications if possible. Treatment of other bothersome symptoms such as nausea, vomiting, and constipation can be helpful. Unless contraindicated, a patient's home medications should be administered on schedule to prevent exacerbation of baseline medical problems.",
       "highlight": "nausea, vomiting, and constipation",
       "scope": "on-scope",
       "note": "Constipation appears in the Prevent step as a bothersome symptom worth treating; supports acting on it, though framed as symptom management rather than an explicitly listed precipitant.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Infections are the most common cause of delirium identified in ED studies, responsible for 30% to 40% of cases, followed by acute neurologic disorders such as ischemic stroke, intracranial hemorrhage, or intracranial mass.9,27 Adverse effects of medications commonly cause delirium and are estimated to be responsible for 12% to 39% of delirium across medical settings.28 Accordingly, it is critical that the emergency clinician perform a medication review to identify recent medication changes and use of medications at high risk of causing delirium (Table 1). Delirium is also frequently multifactorial.29 For example, a patient with a urinary tract infection may experience delirium from the infection, but other compounding factors such as dehydration, pain, new antibiotic medications, and change in environment can also contribute.",
       "highlight": "dehydration, pain",
       "scope": "on-scope",
       "note": "Reinforces pain as a common compounding/contributing factor in multifactorial ED delirium.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "ED-DEL change package & toolkit",
     "cite": "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf",
     "paragraphs": [
      {
       "context": "It is important to act quickly if you suspect a patient has delirium. Serious causes of delirium include:1 Any local infection (pneumonia, upper or lower urinary tract infection, skin or soft tissue, intraabdominal, brain) Sepsis Drug-related: toxicity, withdrawal, intolerance, excess Metabolic abnormality (dehydration, abnormally decreased or increased levels of sodium, calcium, potassium, glucose; acute renal impairment) Acute coronary syndrome Intracranial event (Transient Ischemic Attack, TIA, ischemic/hemorrhagic cerebrovascular accident, CVA) Physical discomfort (untreated pain, fecal impaction, urinary retention)",
       "highlight": "untreated pain, fecal impaction, urinary retention",
       "scope": "on-scope",
       "note": "Lists untreated pain, fecal impaction (constipation), and urinary retention together as serious causes of delirium to identify in the older ED patient.",
       "page": "",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Treat symptoms, such as pain, nausea, constipation, dry mouth, etc.",
       "highlight": "pain, nausea, constipation",
       "scope": "on-scope",
       "note": "Standing-order prevention protocol directs treating symptoms such as pain, nausea, and constipation — common reversible contributors named in the claim.",
       "page": "",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Other targeted assessments to consider: bladder ultrasound for urinary retention, venous or arterial blood gas, TSH (thyroid stimulating hormone), carboxyhemoglobin, toxicology screen, core temperature for hypothermia, CXR (chest x-ray), CT (computerized tomography) abdomen/pelvis, CT head, ETOH (ethyl alcohol) level",
       "highlight": "bladder ultrasound for urinary retention",
       "scope": "on-scope",
       "note": "ED evaluation guidance to assess for urinary retention (bladder ultrasound) during the delirium work-up.",
       "page": "",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Delirium is an acute neurologic emergency (think \"brain attack\"). Delirium is present in approximately 10% of all older ED patients. It is a symptom of changed mental status (usually sedation or hypoactivity, occasionally agitation) that develops over hours or days and is a clear change from the patient's normal mental status even if they already have dementia. It is usually a reversible symptom of an often serious underlying medical or pharmacologic problem. Delirium is associated with increased hospital length of stay, falls, re-hospitalization or institutionalization, and costs.",
       "highlight": "reversible symptom of an often serious underlying medical or pharmacologic problem",
       "scope": "background",
       "note": "Establishes the 'delirium is a reversible symptom of an underlying problem' framing that motivates checking for reversible precipitants.",
       "page": "",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      }
     ]
    }
   ],
   "synthesis": "Both ED-focused sources agree that pain, urinary retention, and constipation are common, reversible precipitants/contributors to look for in the older ED patient. The ED-DEL toolkit governs the exact wording: it names untreated pain, fecal impaction, and urinary retention together as serious causes and labels pain/constipation as factors that precipitate/exacerbate delirium, while ADEPT's Table 1 lists pain and urinary retention among readily reversible precipitants and addresses constipation as a bothersome symptom to treat — complementary, not conflicting, and all on-scope.",
   "discrepancy": false
  },
  {
   "id": "ed-cards-r14",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "5",
   "section": "Act-on-a-positive — Non-pharmacologic management first",
   "statement": "Reorient frequently; involve family or a sitter; keep glasses and hearing aids on.",
   "contentType": "Cited clinical content",
   "sources": [
    "ADEPT (2020)",
    "ED-DEL change package & toolkit"
   ],
   "anchor": "ADEPT (2020) — p. 7",
   "passage": "and bladder catheters. Greater numbers of restraints or tethers, immobilization, and use of bladder catheters are associated with higher rates of delirium.29,37 Although the measures just discussed can be accomplished in any ED, other measures require hospitalor systems-based organization and planning. Providing large-font clocks and other visual cues about the date and location can help self-orientation.38 In addition, promoting and creating a culture that encourages family members and caregivers who demonstrate a calming presence to remain at the bedside can be helpful. 29 If feasible, volunteers can be trained to help redirect and calm patients.39 Patients with delirium are at higher risk for falls,40 so measures should be taken to help prevent injury while still promoting mobility, if possible. Some measures include low beds, getting out of bed to chairs, physical therapy, nonslip floors or socks, and 1:1 sitters.41,42 An ED length of stay of greater than 10 hours has been demonstrated to double the risk for incident delirium.43 Therefore, systems measures and protocols that reduce ED length of stay and avoid boarding patients in hallways should be considered for patients at risk of delirium. …\nThe quote covers reorientation and family involvement; \"1:1 sitters\" also appears on p. 7, and glasses and hearing aids are supported by Table 1 (p. 16, \"lack of hearing or vision aids\") and by p. 6. The ED-DEL toolkit's transfer checklist likewise lists hearing aids and glasses.",
   "evidence": "Full text, p. 7",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The ADEPT tool for the older ED patient directly supports all three components of the statement across its PREVENT/TREAT sections (p.6-7) and Table 1.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "Although the measures just discussed can be accomplished in any ED, other measures require hospital- or systems-based organization and planning. Providing large-font clocks and other visual cues about the date and location can help self-orientation.38 In addition, promoting and creating a culture that encourages family members and caregivers who demonstrate a calming presence to remain at the bedside can be helpful.29 If feasible, volunteers can be trained to help redirect and calm patients.39 Patients with delirium are at higher risk for falls,40 so measures should be taken to help prevent injury while still promoting mobility, if possible. Some measures include low beds, getting out of bed to chairs, physical therapy, nonslip floors or socks, and 1:1 sitters.41,42 An ED length of stay of greater than 10 hours has been demonstrated to double the risk for incident delirium.43 Therefore, systems measures and protocols that reduce ED length of stay and avoid boarding patients in hallways should be considered for patients at risk of delirium.",
       "highlight": "Providing large-font clocks and other visual cues about the date and location can help self-orientation.",
       "scope": "on-scope",
       "note": "Reorientation via clocks and visual cues about date/location — supports 'reorient frequently.'",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Although the measures just discussed can be accomplished in any ED, other measures require hospital- or systems-based organization and planning. Providing large-font clocks and other visual cues about the date and location can help self-orientation.38 In addition, promoting and creating a culture that encourages family members and caregivers who demonstrate a calming presence to remain at the bedside can be helpful.29 If feasible, volunteers can be trained to help redirect and calm patients.39 Patients with delirium are at higher risk for falls,40 so measures should be taken to help prevent injury while still promoting mobility, if possible. Some measures include low beds, getting out of bed to chairs, physical therapy, nonslip floors or socks, and 1:1 sitters.41,42 An ED length of stay of greater than 10 hours has been demonstrated to double the risk for incident delirium.43 Therefore, systems measures and protocols that reduce ED length of stay and avoid boarding patients in hallways should be considered for patients at risk of delirium.",
       "highlight": "family members and caregivers who demonstrate a calming presence to remain at the bedside",
       "scope": "on-scope",
       "note": "Family/caregiver calming presence at the bedside — supports 'involve family.'",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Although the measures just discussed can be accomplished in any ED, other measures require hospital- or systems-based organization and planning. Providing large-font clocks and other visual cues about the date and location can help self-orientation.38 In addition, promoting and creating a culture that encourages family members and caregivers who demonstrate a calming presence to remain at the bedside can be helpful.29 If feasible, volunteers can be trained to help redirect and calm patients.39 Patients with delirium are at higher risk for falls,40 so measures should be taken to help prevent injury while still promoting mobility, if possible. Some measures include low beds, getting out of bed to chairs, physical therapy, nonslip floors or socks, and 1:1 sitters.41,42 An ED length of stay of greater than 10 hours has been demonstrated to double the risk for incident delirium.43 Therefore, systems measures and protocols that reduce ED length of stay and avoid boarding patients in hallways should be considered for patients at risk of delirium.",
       "highlight": "1:1 sitters",
       "scope": "on-scope",
       "note": "1:1 sitters listed as a nonpharmacologic measure — supports 'or a sitter.'",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Nonpharmacologic interventions such as verbal de-escalation, distraction, and reassurance can be used with assistance from sitters, family, or staff.",
       "highlight": "with assistance from sitters, family, or staff",
       "scope": "on-scope",
       "note": "Nonpharmacologic de-escalation delivered with assistance from sitters, family, or staff supports involving family or a sitter.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Medications that can cause delirium should be avoided (Table 1). Normalize the patient's daily function by providing hydration, food (unless contraindicated), access and assistance to toileting, mobility assistance or aids, and hearing-assistive devices. Limit unnecessary disruptions. Unless medically necessary, things that tether the patient to the bed should be avoided, including blood pressure cuffs, monitor leads, continuous intravenous infusions, Author Manuscript Author Manuscript Ann Emerg Med.",
       "highlight": "hearing-assistive devices",
       "scope": "on-scope",
       "note": "Providing hearing-assistive devices to normalize daily function — supports keeping hearing aids on.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Intoxication with alcohol or substance use, alcohol or benzodiazepine withdrawal Hyper- or hypoglycemia, hyper- or hyponatremia, dehydration, acute kidney injury, uremia, diabetic ketoacidosis Acute coronary syndrome, dissection, hypoxia, hypotension, anemia New or unfamiliar environment, lack of sleep, lack of hearing or vision aids Pain, urinary retention Page 16 Author Manuscript Author Manuscript Author Manuscript Author Manuscript Comparison of brief delirium assessment tools.",
       "highlight": "lack of hearing or vision aids",
       "scope": "on-scope",
       "note": "Table 1 names 'lack of hearing or vision aids' as a delirium precipitant — the only place ADEPT references vision aids/glasses; framed as a cause, it supports keeping glasses and hearing aids on.",
       "page": "Table 1",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "ED-DEL change package & toolkit",
     "cite": "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The ACEP ED-DEL toolkit's ED delirium-prevention protocol and fact sheet corroborate every element; one caregiver-guide passage repeats the advice for an inpatient hospital stay (different setting).",
     "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf",
     "paragraphs": [
      {
       "context": "Normalize daily function and implement nonpharmacologic prevention approaches: o Encourage family presence and involvement in orienting and calming patient. Family brochure (See Resources): includes information about delirium, orienting patients, help with mobilizing, hydration, nutrition o Offer activity toolbox4 Protocol for Delirium Prevention and Treatment 2020 by Dr.",
       "highlight": "Encourage family presence and involvement in orienting and calming patient.",
       "scope": "on-scope",
       "note": "ED delirium-prevention protocol directs encouraging family presence and involvement in orienting the patient — supports reorient + involve family.",
       "page": "97",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "pressure sores, out of bed with meals o Provide vision and hearing adaptations if impairments present. Be sure glasses and hearing aids worn if needed.",
       "highlight": "Provide vision and hearing adaptations if impairments present.",
       "scope": "on-scope",
       "note": "Protocol directs vision/hearing adaptations and that glasses and hearing aids be worn if needed — directly supports 'keep glasses and hearing aids on.'",
       "page": "98",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Melatonin 3-6mg at HS (at bedtime) o Provide chairs, order non-skid socks o 1:1 sitters for those who are agitated or very high risk Avoid tethers and immobilizing devices: Foley catheters, continuous IV infusions, BP cuffs, monitors, bed/chair alarms, restraints, continuous O2 monitor, nasal cannula, etc. Management of delirium (once delirium is detected) (Part III of Standing Order Recommendations): Treat any underlying conditions which may contribute to delirium (infection, electrolyte disorders, medication-related, etc.); causes are often multifactorial Treat symptoms, such as pain, nausea, constipation. Anticipate basic needs (hunger, hydration, toileting) and provide reassurance and comfort measures (i.e., pain relief, warm blanket) Provide reassurance, redirection, distraction (e.g., activity carts3-4) and means for self-orientation (clocks, calendars, signs). o Encourage family involvement for reorientation, calming communication, therapeutic activities, hydration/nutrition Prevent injury or other complications: o High falls risk--order lower beds, provide chairs, use non-skid socks.",
       "highlight": "Encourage family involvement for reorientation",
       "scope": "on-scope",
       "note": "Provides means for self-orientation (clocks, calendars, signs) plus family involvement for reorientation — supports reorient + family.",
       "page": "98",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Consider sitters for patients with agitation or very high falls risk.",
       "highlight": "Consider sitters for patients with agitation or very high falls risk",
       "scope": "on-scope",
       "note": "Standing-order guidance to consider sitters for agitated or very-high-falls-risk patients — supports the 'or a sitter' element.",
       "page": "98",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Treat the contributors to delirium Ensure the person is eating, drinking, moving, and toileting regularly Keep them as comfortable as possible (warm blanket, appropriate lighting) Ensure stimulation and orientation by staff, family and other caregivers. Enhance sensory input (make an effort to get eyeglasses, hearing aids) Minimize inappropriate medications, especially anticholinergics and benzodiazepines.",
       "highlight": "Enhance sensory input (make an effort to get eyeglasses, hearing aids)",
       "scope": "on-scope",
       "note": "ED fact sheet: orientation by staff/family and getting eyeglasses/hearing aids — covers all three components in one place.",
       "page": "49",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Additional interventions may be helpful while the patient is waiting to be evaluated o Ask what typically helps a patient during times of stress o Make sure the patient has glasses and hearing aids if appropriate o Try to create a calm environment by lowering the lights or having the patient listen to soft music if possible o Orient the patient to their location and reason for being there o se calming and reassuring communication, validate the patient's feelings or frustrations 112 Appendix B: ED Delirium Toolkit Section VIII.",
       "highlight": "Make sure the patient has glasses and hearing aids if appropriate",
       "scope": "on-scope",
       "note": "Interventions while the patient waits to be evaluated — ensure glasses/hearing aids and orient the patient to their location — supports all three components in the ED.",
       "page": "112",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "At-risk patients will also need to have as much of their \"faculties\" as possible to keep them oriented; glasses, dentures, and hearing aids will help prevent delirium.",
       "highlight": "glasses, dentures, and hearing aids will help prevent delirium",
       "scope": "different-setting",
       "note": "Same advice (keep glasses/hearing aids, keep patients oriented) but framed for an inpatient hospital-stay caregiver guide (Resource III-N), not ED bedside management — nearest match at a different care setting.",
       "page": "78",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      }
     ]
    }
   ],
   "synthesis": "Both cited sources agree and are on-scope for the older ED patient: ADEPT (p.7, the primary anchor) directs reorientation with large-font clocks/visual cues, family/caregiver calming presence and 1:1 sitters, and provision of hearing/vision aids (its Table 1 flags \"lack of hearing or vision aids\" as a precipitant), and the ED-DEL toolkit's ED delirium-prevention protocol independently directs family involvement in orienting, ensuring glasses and hearing aids are worn, self-orientation cues, and 1:1 sitters — so ADEPT governs as the primary source with the ED-DEL protocol corroborating every element. Discrepancy is flagged only because one ED-DEL passage (the \"Navigating a Hospital Stay\" caregiver guide) gives the same glasses/hearing-aid and reorientation advice for an inpatient ward rather than the ED bedside, a different-setting nearest match rather than direct support.",
   "discrepancy": true
  },
  {
   "id": "ed-cards-r15",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "5",
   "section": "Act-on-a-positive — Non-pharmacologic management first",
   "statement": "Minimize tethers (catheters, telemetry, restraints) and disruptions; mobilize when safe.",
   "contentType": "Cited clinical content",
   "sources": [
    "ADEPT (2020)",
    "ED-DEL change package & toolkit"
   ],
   "anchor": "ADEPT (2020) — p. 6",
   "passage": "… Treatment of other bothersome symptoms such as nausea, vomiting, and constipation can be helpful. Unless contraindicated, a patient's home medications should be administered on schedule to prevent exacerbation of baseline medical problems. Medications that can cause delirium should be avoided (Table 1). Normalize the patient's daily function by providing hydration, food (unless contraindicated), access and assistance to toileting, mobility assistance or aids, and hearing-assistive devices. Limit unnecessary disruptions. Unless medically necessary, things that tether the patient to the bed should be avoided, including blood pressure cuffs, monitor leads, continuous intravenous infusions, Shenvi et al. Page 6 Ann Emerg Med. Author manuscript; available in PMC 2021 March 10. Author Manuscript Author Manuscript Author Manuscript Author Manuscript\nRestraints and mobilization are covered on p. 7: \"Greater numbers of restraints or tethers, immobilization, and use of bladder catheters are associated with higher rates of delirium,\" and \"measures should be taken to help prevent injury while still promoting mobility, if possible.\"",
   "evidence": "Full text, p. 6",
   "status": "fulltext",
   "pageNum": "6",
   "citations": [
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "PREVENT and TREAT sections of the ADEPT ED tool for older patients: avoid tethering to the bed, note that more restraints/tethers/immobilization/bladder catheters raise delirium rates, and promote mobility while preventing falls.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "Medications that can cause delirium should be avoided (Table 1). Normalize the patient's daily function by providing hydration, food (unless contraindicated), access and assistance to toileting, mobility assistance or aids, and hearing-assistive devices. Limit unnecessary disruptions. Unless medically necessary, things that tether the patient to the bed should be avoided, including blood pressure cuffs, monitor leads, continuous intravenous infusions, Author Manuscript Author Manuscript Ann Emerg Med.",
       "highlight": "Unless medically necessary, things that tether the patient to the bed should be avoided, including blood pressure cuffs, monitor leads, continuous intravenous infusions,",
       "scope": "on-scope",
       "note": "PREVENT step directly instructs limiting disruptions and avoiding bed tethers (BP cuffs, monitor leads/telemetry, IV lines) unless medically necessary.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "and bladder catheters. Greater numbers of restraints or tethers, immobilization, and use of bladder catheters are associated with higher rates of delirium.29,37 Although the measures just discussed can be accomplished in any ED, other measures require hospital- or systems-based organization and planning.",
       "highlight": "Greater numbers of restraints or tethers, immobilization, and use of bladder catheters are associated with higher rates of delirium.",
       "scope": "on-scope",
       "note": "Continuation of the tether list onto p.7 (bladder catheters) and the rationale linking restraints/tethers/immobilization to higher delirium rates.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Although the measures just discussed can be accomplished in any ED, other measures require hospital- or systems-based organization and planning. Providing large-font clocks and other visual cues about the date and location can help self-orientation.38 In addition, promoting and creating a culture that encourages family members and caregivers who demonstrate a calming presence to remain at the bedside can be helpful.29 If feasible, volunteers can be trained to help redirect and calm patients.39 Patients with delirium are at higher risk for falls,40 so measures should be taken to help prevent injury while still promoting mobility, if possible. Some measures include low beds, getting out of bed to chairs, physical therapy, nonslip floors or socks, and 1:1 sitters.41,42 An ED length of stay of greater than 10 hours has been demonstrated to double the risk for incident delirium.43 Therefore, systems measures and protocols that reduce ED length of stay and avoid boarding patients in hallways should be considered for patients at risk of delirium.",
       "highlight": "measures should be taken to help prevent injury while still promoting mobility, if possible.",
       "scope": "on-scope",
       "note": "Supports 'mobilize when safe' — prevent fall injury while still promoting mobility (low beds, out of bed to chairs).",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Benzodiazepines should be avoided if possible because they may cause prolonged sedation, paradoxic agitation, or worsening of delirium. If they are used, low doses such as 0.5 mg lorazepam should be given rather than the more common 2 mg used in younger patients. However, if a patient is receiving benzodiazepines long term, his or her home medication should be continued to prevent precipitating withdrawal. Physical restraints should be avoided if at all possible because patients can become injured, and their use precludes mobility.",
       "highlight": "Physical restraints should be avoided if at all possible because patients can become injured, and their use precludes mobility.",
       "scope": "on-scope",
       "note": "Table 4 intervention guidance ties minimizing restraints to preserving mobility, reinforcing both halves of the claim.",
       "page": "Table 4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "ED-DEL change package & toolkit",
     "cite": "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ACEP ED-DEL delirium-prevention protocol and standing-order sets for the older ED patient: avoid/remove tethers and immobilizing devices, limit disruptions and vital-sign cycling, and ensure ambulation/out-of-bed mobility.",
     "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf",
     "paragraphs": [
      {
       "context": "Melatonin 3-6mg at HS (at bedtime) o Provide chairs, order non-skid socks o 1:1 sitters for those who are agitated or very high risk Avoid tethers and immobilizing devices: Foley catheters, continuous IV infusions, BP cuffs, monitors, bed/chair alarms, restraints, continuous O2 monitor, nasal cannula, etc. Management of delirium (once delirium is detected) (Part III of Standing Order Recommendations): Treat any underlying conditions which may contribute to delirium (infection, electrolyte disorders, medication-related, etc.); causes are often multifactorial Treat symptoms, such as pain, nausea, constipation. Anticipate basic needs (hunger, hydration, toileting) and provide reassurance and comfort measures (i.e., pain relief, warm blanket) Provide reassurance, redirection, distraction (e.g., activity carts3-4) and means for self-orientation (clocks, calendars, signs). o Encourage family involvement for reorientation, calming communication, therapeutic activities, hydration/nutrition Prevent injury or other complications: o High falls risk--order lower beds, provide chairs, use non-skid socks.",
       "highlight": "Avoid tethers and immobilizing devices: Foley catheters, continuous IV infusions, BP cuffs, monitors, bed/chair alarms, restraints, continuous O2 monitor, nasal cannula, etc.",
       "scope": "on-scope",
       "note": "Delirium-prevention protocol explicitly lists the tethers to avoid — catheters, telemetry/monitors, restraints — mirroring the claim verbatim.",
       "page": "97",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "aids worn if needed. o Limit disruptions and unnecessary VS and BP (blood pressure) cuff cycling, telemetry, pulse ox (especially while patient is waiting for transition and has completed work-up) o Provide day/night signals and maintain sleep-wake cycle as much as possible.",
       "highlight": "Limit disruptions and unnecessary VS and BP (blood pressure) cuff cycling, telemetry, pulse ox",
       "scope": "on-scope",
       "note": "Directly supports 'and disruptions' — limit unnecessary vital-sign/telemetry cycling.",
       "page": "97",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "o Assure access to toileting and enhance mobility o Ensure ambulation or up in chair every 2-4 hours if possible during daytime hours, prevent pressure sores, out of bed with meals o Provide vision and hearing adaptations if impairments present.",
       "highlight": "Ensure ambulation or up in chair every 2-4 hours if possible during daytime hours",
       "scope": "on-scope",
       "note": "Supports 'mobilize when safe' — enhance mobility, ambulate or sit up in a chair when possible.",
       "page": "97",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "measurements as clinically appropriate Discontinue unnecessary VS and BP cuff cycling, telemetry, pulse ox (especially while patient is waiting for transition and has completed work-up) Remove tethers if possible (Foley catheter, telemetry, continuous O2 monitor, nasal cannula, etc.)",
       "highlight": "Remove tethers if possible (Foley catheter, telemetry, continuous O2 monitor, nasal cannula, etc.)",
       "scope": "on-scope",
       "note": "Standing-order / order-set restatement pairing 'Discontinue unnecessary VS and BP cuff cycling, telemetry, pulse ox' with removing tethers (Foley, telemetry).",
       "page": "",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Avoid tethers and immobilizing devices: Foley catheters, continuous IV infusions, BP cuffs, monitors, bed/chair alarms, restraints, continuous O2 monitor, nasal cannula, etc.",
       "highlight": "Avoid tethers and immobilizing devices: Foley catheters, continuous IV infusions, BP cuffs, monitors, bed/chair alarms, restraints",
       "scope": "on-scope",
       "note": "Standing-order prevention protocol to avoid tethers and immobilizing devices — Foley catheters, monitors, and restraints — matching the claim's catheters/telemetry/restraints.",
       "page": "",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      }
     ]
    }
   ],
   "synthesis": "Both sources are ED-specific older-adult delirium guidance and agree directly with the claim: ADEPT's PREVENT step and the ACEP ED-DEL toolkit each instruct minimizing tethers (bladder/Foley catheters, monitor leads/telemetry, BP cuffs, IV lines), avoiding physical restraints, limiting unnecessary disruptions/vital-sign cycling, and promoting mobility (ambulation, up in a chair) when safe. No discrepancy — the two sources reinforce the same on-scope, non-pharmacologic management position.",
   "discrepancy": false
  },
  {
   "id": "ed-cards-r16",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "5",
   "section": "Act-on-a-positive — Non-pharmacologic management first",
   "statement": "Avoid new psychoactive medications where possible; treat pain adequately.",
   "contentType": "Cited clinical content",
   "sources": [
    "ADEPT (2020)",
    "ED-DEL change package & toolkit"
   ],
   "anchor": "ADEPT (2020) — p. 6",
   "passage": "… Routine computed tomography of the brain is low yield overall but should be performed for patients with focal neurologic deficits, fall, or head trauma, or decreased level of consciousness, and should be considered in patients receiving anticoagulation.31-33 PREVENT The fourth is \"Prevent.\" Most EDs are busy, bright, noisy, and potentially deliriogenic environments, especially for older patients. However, there are measures that can be undertaken for individual patients to prevent the development of delirium, to prevent its progression, and to mitigate its symptoms.34,35 These include treating the underlying condition and managing pain,36 ideally with nonsedating, nonopioid medications if possible. Treatment of other bothersome symptoms such as nausea, vomiting, and constipation can be helpful. Unless contraindicated, a patient's home medications should be administered on schedule to prevent exacerbation of baseline medical problems. Medications that can cause delirium should be avoided (Table 1). Normalize the patient's daily function by providing hydration, food (unless contraindicated), access and assistance to toileting, mobility assistance or aids, and hearing-assistive devices. Limit unnecessary disruptions. …\nThe quote covers treating pain adequately; avoiding new psychoactive medications is supported on the same page: \"Medications that can cause delirium should be avoided (Table 1).\"",
   "evidence": "Full text, p. 6",
   "status": "fulltext",
   "pageNum": "6",
   "citations": [
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary source (Ann Emerg Med 2020;75(2):136-145). The ADEPT 'Prevent' and 'Treat' steps directly support both halves of the claim: treat pain (with nonsedating, nonopioid agents) and avoid new deliriogenic/psychoactive medications.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "The fourth is \"Prevent.\" Most EDs are busy, bright, noisy, and potentially deliriogenic environments, especially for older patients. However, there are measures that can be undertaken for individual patients to prevent the development of delirium, to prevent its progression, and to mitigate its symptoms.34,35 These include treating the underlying condition and managing pain,36 ideally with nonsedating, nonopioid medications if possible. Treatment of other bothersome symptoms such as nausea, vomiting, and constipation can be helpful. Unless contraindicated, a patient's home medications should be administered on schedule to prevent exacerbation of baseline medical problems.",
       "highlight": "treating the underlying condition and managing pain,36 ideally with nonsedating, nonopioid medications if possible",
       "scope": "on-scope",
       "note": "The 'Prevent' step directly supports 'treat pain adequately' and favors nonsedating, nonopioid analgesia in the older ED delirium patient.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Medications that can cause delirium should be avoided (Table 1). Normalize the patient's daily function by providing hydration, food (unless contraindicated), access and assistance to toileting, mobility assistance or aids, and hearing-assistive devices. Limit unnecessary disruptions. Unless medically necessary, things that tether the patient to the bed should be avoided, including blood pressure cuffs, monitor leads, continuous intravenous infusions, Author Manuscript Author Manuscript Ann Emerg Med.",
       "highlight": "Medications that can cause delirium should be avoided (Table 1).",
       "scope": "on-scope",
       "note": "Directly supports avoiding new deliriogenic/psychoactive medications where possible.",
       "page": "ms. p.6",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "If a patient has a history of long-term benzodiazepine use, do not stop these medications precipitately because it may lead to withdrawal and worsening delirium. Benzodiazepines should be avoided in individuals not already receiving them because there is increased risk of prolonged sedation, paradoxic agitation, and worsening delirium.52,57 Diphenhydramine should not be used for the treatment of older individuals.",
       "highlight": "Benzodiazepines should be avoided in individuals not already receiving them",
       "scope": "on-scope",
       "note": "Most literal support for 'avoid NEW psychoactive medications' — do not start benzodiazepines in patients not already on them.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "The care of agitated patients in the ED can be challenging. The presence of agitation or behavioral changes is often a clue to underlying delirium, but the diagnosis of delirium is often not formally made in the ED setting.5 Delirium is an acute change in mental status, with waxing and waning symptoms, that can present with hyperactive, hypoactive, or mixed symptoms. Its presentation can be subtle or can be confounded by other symptoms or disorders, such as strokes, sepsis, adverse drug reactions, or intoxication. A greater understanding and recognition of delirium may help clinicians better care for patients and prevent symptom progression. In addition, when patients are agitated or delirious, clinicians often use pharmacologic measures such as antipsychotics or benzodiazepines for symptom control. However, these medications have significant potential complications, so nonpharmacologic measures should be used first when possible.",
       "highlight": "nonpharmacologic measures should be used first when possible",
       "scope": "background",
       "note": "Frames the overall principle that antipsychotics/benzodiazepines carry risk and nonpharmacologic measures come first; supports but is broader than the specific claim.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "ED-DEL change package & toolkit",
     "cite": "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ACEP GEDA ED-DEL toolkit independently echoes ADEPT: minimize/avoid high-risk psychoactive (Beers) medications and provide measures for pain in the older ED delirium patient.",
     "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf",
     "paragraphs": [
      {
       "context": "Review medications: minimize Beers criteria medications (use less harmful alternatives); minimize doses. Avoid use of high-risk medications: benzodiazepines (unless taking chronically and at risk of withdrawal), diphenhydramine, sedatives, muscle-relaxants, anticholinergics, anti-histamines, antipsychotics, ketamine. [See also Beers criteria medications].",
       "highlight": "Avoid use of high-risk medications: benzodiazepines (unless taking chronically and at risk of withdrawal), diphenhydramine, sedatives, muscle-relaxants, anticholinergics, anti-histamines, antipsychotics, ketamine.",
       "scope": "on-scope",
       "note": "Prevention/management step directly supports avoiding new psychoactive/deliriogenic medications where possible.",
       "page": "97",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Orientation Ensure hydration/nutrition Minimize inappropriate medications Measures for pain (including analgesics if pain suspected - consider PAIN-AD)",
       "highlight": "Measures for pain (including analgesics if pain suspected - consider PAIN-AD)",
       "scope": "on-scope",
       "note": "Nonpharmacologic-treatment list pairs 'minimize inappropriate medications' with 'measures for pain' — both halves of the claim.",
       "page": "56",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Melatonin 3-6mg at HS (at bedtime) o Provide chairs, order non-skid socks o 1:1 sitters for those who are agitated or very high risk Avoid tethers and immobilizing devices: Foley catheters, continuous IV infusions, BP cuffs, monitors, bed/chair alarms, restraints, continuous O2 monitor, nasal cannula, etc. Management of delirium (once delirium is detected) (Part III of Standing Order Recommendations): Treat any underlying conditions which may contribute to delirium (infection, electrolyte disorders, medication-related, etc.); causes are often multifactorial Treat symptoms, such as pain, nausea, constipation. Anticipate basic needs (hunger, hydration, toileting) and provide reassurance and comfort measures (i.e., pain relief, warm blanket) Provide reassurance, redirection, distraction (e.g., activity carts3-4) and means for self-orientation (clocks, calendars, signs). o Encourage family involvement for reorientation, calming communication, therapeutic activities, hydration/nutrition Prevent injury or other complications: o High falls risk--order lower beds, provide chairs, use non-skid socks.",
       "highlight": "Treat symptoms, such as pain, nausea, constipation.",
       "scope": "on-scope",
       "note": "Management-of-delirium step directs treating pain adequately as part of symptom management.",
       "page": "97",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      }
     ]
    }
   ],
   "synthesis": "Both sources agree and are on-scope for the older ED delirium patient. ADEPT (2020), the primary/governing source, states prevention includes managing pain 'ideally with nonsedating, nonopioid medications,' that deliriogenic medications should be avoided, and that benzodiazepines should be avoided in patients not already receiving them; the ACEP ED-DEL toolkit independently echoes the same guidance (avoid/minimize high-risk psychoactive Beers medications; provide measures for pain).",
   "discrepancy": false
  },
  {
   "id": "ed-cards-r17",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "5",
   "section": "Act-on-a-positive — Document & communicate",
   "statement": "Document the screen result, the suspected causes, and the interventions started.",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2010",
    "ED-DEL change package & toolkit"
   ],
   "anchor": "ED-DEL change package & toolkit — p. 106, ¶6",
   "passage": "Describe delirium symptoms present: _________________________________________________________ Any agitation present? Yes or No________ If Y, describe symptoms: ________________________________________________________________________________________ Evaluation/Work Up (Any potential contributors Identified, symptoms present) Specify:___________________________________________________________________________________ __________________________________________________________________________________________ __ _______________________________________________________________________________________ Delirium Prevention: Indicate prevention strategies implemented in ED (with details):  Hydration/Nutrition: _______________________________________________________________________  Time of last meal: _______________________________________________________________  Reorientation techniques: __________________________________________________________________  Mobility (any aids needed?): _______________________ …\nThe quoted line is from the toolkit's Delirium Transfer Checklist (p. 106), which captures all three items: the screen result (\"Delirium Assessment: Is delirium present?\" and \"What screening test done\"), suspected causes, and interventions started (\"Delirium Prevention: Indicate prevention strategies implemented in ED\").",
   "evidence": "Full text, p. 106",
   "status": "fulltext",
   "pageNum": "106",
   "citations": [
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
    "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2010.03.003",
    "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "partial",
     "note": "ED-setting paper on delirium as a mortality predictor; partially supports the communicate/causes elements but frames them as clinical management, not a documentation step, and does not address recording interventions started.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": [
      {
       "context": "Once delirium is diagnosed in the ED, the diagnostic evaluation should then focus on uncovering the underlying etiology.48 Infections, such as a urinary tract infection or pneumonia, dehydration, electrolyte abnormalities, central nervous system insults, and medication reactions are common causes.32 If admitted, physicians at the next level of care should be notified of the patient's delirium status. Other than these interventions, however, the optimal management of delirium is still unclear, especially within the ED setting. Several multi-component delirium interventions have been developed for hospitalized patients and can be tailored for the ED,49, 50 but their efficacy is questionable.51 Because many of these interventions were started 24 to 48 hours after admission, early detection and early intervention of delirium in the ED may improve their effectiveness similar to what has been observed in sepsis and ST-elevation myocardial infarction care.52, 53 A multi-faceted line of research must be undertaken to develop delirium interventions specifically tailored for the ED setting and determine their cost-effectiveness using randomized control trial methodology.",
       "highlight": "physicians at the next level of care should be notified of the patient's delirium status",
       "scope": "narrower",
       "note": "Once delirium is diagnosed in the ED, Han recommends uncovering the underlying etiology (the suspected causes) and notifying the next level of care of delirium status (communicate the result), but treats this as management/handoff rather than a documentation step and says nothing about recording interventions started.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      },
      {
       "context": "ED patients with unrecognized delirium may receive incomplete diagnostic workups and an underlying life-threatening illness may remain undiagnosed.",
       "highlight": "an underlying life-threatening illness may remain undiagnosed",
       "scope": "background",
       "note": "Explains why recognizing and recording delirium matters — unrecognized delirium leads to incomplete workups and missed underlying illness — supporting the rationale for documenting, not the documentation instruction itself.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    },
    {
     "label": "ED-DEL change package & toolkit",
     "cite": "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The ED-to-inpatient/SNF Delirium Transfer Checklist (p. 106-107) is the toolkit's document-and-communicate instrument and directly captures the screen result, suspected causes, and interventions started.",
     "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf",
     "paragraphs": [
      {
       "context": "DELIRIUM TRANSFER CHECKLIST Nurse and physician should communicate about the following areas in all patients with delirium or at high risk for delirium when transferring patient from ED to floor.",
       "highlight": "Nurse and physician should communicate about the following areas in all patients with delirium or at high risk for delirium when transferring patient from ED to floor",
       "scope": "on-scope",
       "note": "Frames the Transfer Checklist as the document-and-communicate tool used at ED-to-floor handoff for delirium/high-risk patients.",
       "page": "106",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Delirium Assessment: Is delirium present? Yes or No____________________________________________________ Describe patient's baseline mental and functional status (intact, impaired degree of impairment, symptoms): _________________________________________________________________________________________ _________________________________________________________________________________________ What screening test done: __________________________________________________________________ Describe delirium symptoms present: _________________________________________________________ Any agitation present?",
       "highlight": "What screening test done",
       "scope": "on-scope",
       "note": "Records the screen result — whether delirium is present and which screening test was done.",
       "page": "106",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Nurse and physician should communicate about the following areas in all patients with delirium or at high risk for delirium when transferring patient from ED to floor.",
       "highlight": "communicate about the following areas in all patients with delirium",
       "scope": "on-scope",
       "note": "The ED-to-inpatient transfer checklist directs nurse and physician to communicate the delirium screen, work-up findings, and interventions at handoff — the document-and-communicate step the claim describes.",
       "page": "106",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Delirium Prevention: Indicate prevention strategies implemented in ED (with details): Hydration/Nutrition: _______________________________________________________________________ Time of last meal: _______________________________________________________________ Reorientation techniques: __________________________________________________________________ Mobility (any aids needed?): ________________________________________________________________ Hearing aids: _____________________________________________________________________________ Visual aids, glasses: ________________________________________________________________________ Non-pharmacological sleep protocol: __________________________________________________________ Transfer Checklist from ED to Inpatient Unit or to Skilled Nursing Facility 2020 by Dr.",
       "highlight": "Indicate prevention strategies implemented in ED",
       "scope": "on-scope",
       "note": "Records the prevention interventions started in the ED.",
       "page": "106",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Delirium Management: Indicate management strategies implemented in ED: Medication/Pharmacist Review - avoid or minimize antipsychotic use/Beers List meds Minimized restraints and alarms Maintained orientation Maintained mobility Delirium assessment ongoing Agitation management? What nonpharmacologic approaches helped? Avoided Foley catheter Used \"Tolerate, Anticipate, Don't Agitate\" (TADA) approach; details: _____________________________________________________________________ Family involvement: ___________________________________________________ Medications required (indicate):__________________________________________ Describe what helped most: _________________________________________________________________________________________ _________________________________________________________________________________________ Important contact information: Family: _________________________________________________________________________________________ Primary Care Physician: ___________________________________________________________________________ Pharmacy: ______________________________________________________________________________________ Transfer Checklist from ED to Inpatient Unit or to Skilled Nursing Facility 2020 by Dr.",
       "highlight": "Indicate management strategies implemented in ED",
       "scope": "on-scope",
       "note": "Records the management interventions started in the ED (continuation of the checklist).",
       "page": "107",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Identifying and treating reversible causes. After a diagnosis of delirium, it is recommended to consider underlying causes and provide intervention for known risk factors.",
       "highlight": "consider underlying causes and provide intervention for known risk factors",
       "scope": "broader",
       "note": "General act-on-a-positive recommendation to find causes and intervene, which the transfer checklist then documents; broader clinical guidance rather than the specific document step.",
       "page": "52",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Competing priorities There are challenges with competing priorities and demand for staff. It is important to have someone or a team to communicate their priorities for screening and identifying Delirium in the ED. DEL-ED Toolkit A major highlight the sites experienced is how comprehensive the toolkit is. The toolkit allows each site to pick their own starting point and analyze how it fits into each individual site. Sharing Successes Sharing testimonials and stories of successes in the ED around identifying Delirium can be helpful and motivating to show that what the staff is doing can make a change and difference in the way the patient is cared for moving forward. Also, sharing data to make the case of why the screens are important to conduct. Being able to highlight some \"good catches\" made by the team, helps keep them motivated and interested in the work they are doing. Documenting Outcomes Documenting outcomes was a major win/ highlight for sites. It allowed sites to present data from the toolkit and talk to why it is so important to be implementing it and why they are doing what they are doing and the outcomes along with it. Having this information to present to physicians and prove the benefits of it was helpful for recognition.",
       "highlight": "Documenting outcomes was a major win/ highlight for sites",
       "scope": "different-intervention",
       "note": "Nearest keyword collision on 'document' but refers to program-level quality-improvement outcome documentation (presenting site data to leadership), not documentation of an individual patient's screen result, causes, or interventions.",
       "page": "126",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      }
     ]
    }
   ],
   "synthesis": "The ED-DEL toolkit's ED-to-inpatient/SNF Delirium Transfer Checklist (p. 106-107) is the governing on-scope source and fully supports the statement: it explicitly records the screening test done and whether delirium is present (screen result), potential contributors identified on work-up (suspected causes), and prevention/management strategies implemented in the ED (interventions started). Han 2010 agrees only in part — it recommends uncovering the underlying etiology and notifying the next level of care of delirium status once delirium is diagnosed in the ED, but frames this as clinical management/handoff rather than a documentation step and does not address recording interventions, so it is a narrower, partial match; a same-source keyword collision (\"Documenting Outcomes\") concerns program-level QI data, a different scope.",
   "discrepancy": true
  },
  {
   "id": "ed-cards-r18",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "5",
   "section": "Act-on-a-positive — Document & communicate",
   "statement": "Hand the result off explicitly at disposition — delirium found in the ED changes inpatient management and follow-up.",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2010",
    "ED-DEL change package & toolkit"
   ],
   "anchor": "ED-DEL change package & toolkit — p. 9, ¶4",
   "passage": "… • Review medication list and reduce/minimize psychoactive medications • Encourage and facilitate the involvement of families and caregivers throughout ED stay • Pg. 95 Protocol for Delirium Prevention and Treatment • Pg. 100 Recommendation Set Part 2: Prevention of Delirium • Pg. 102 Non-Pharmacological Interventions from the Hospital Elder Life Program Optimize communication and approaches to assure effective and safe transitions of care from ED to next site of care (e.g. home, inpatient, SNF, etc.) • Communicate clearly to inpatient care providers about the presence of delirium in the patient, the risk of developing delirium, and the management strategies implemented • Use clear communication when transferring care from ED to home or care facility about delirium risk and management, with special education of patient, family, and caregivers about delirium • Pg. 103 The Hospital Elder Life Program: One-Page Summary • Pg. 106 Be Prepared to Go Home Checklist • Pg. 69 Family Education: What is Delirium? • Pg. 73 How to Be an Effective Advocate for Aging Parents • Pg. 75 Navigating a Hospital Stay: A Guide for Caregivers and Patients with Cognitive Loss • Pg. 78 Family Education: Delirium Care After Discharge • Pg. 104 Transfer Checklist: ED to Inpatient\nThe change package's aim of optimizing communication for safe transitions from the ED (p. 9) supports the explicit handoff, and the transfer checklist (p. 106) operationalizes it. The rationale that ED delirium changes inpatient management and follow-up is implicit rather than stated.",
   "evidence": "Full text, p. 9",
   "status": "fulltext",
   "pageNum": "9",
   "citations": [
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
    "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2010.03.003",
    "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Cited in the ED tool's Document & communicate section; directly recommends notifying the next level of care of ED delirium status and documents why it matters.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": [
      {
       "context": "Once delirium is diagnosed in the ED, the diagnostic evaluation should then focus on uncovering the underlying etiology.48 Infections, such as a urinary tract infection or pneumonia, dehydration, electrolyte abnormalities, central nervous system insults, and medication reactions are common causes.32 If admitted, physicians at the next level of care should be notified of the patient's delirium status. Other than these interventions, however, the optimal management of delirium is still unclear, especially within the ED setting. Several multi-component delirium interventions have been developed for hospitalized patients and can be tailored for the ED,49, 50 but their efficacy is questionable.51 Because many of these interventions were started 24 to 48 hours after admission, early detection and early intervention of delirium in the ED may improve their effectiveness similar to what has been observed in sepsis and ST-elevation myocardial infarction care.52, 53 A multi-faceted line of research must be undertaken to develop delirium interventions specifically tailored for the ED setting and determine their cost-effectiveness using randomized control trial methodology.",
       "highlight": "If admitted, physicians at the next level of care should be notified of the patient's delirium status.",
       "scope": "on-scope",
       "note": "Explicitly directs handing off ED-diagnosed delirium to the admitting team, the core of the claim that a positive result must be communicated at disposition.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      },
      {
       "context": "ED patients with unrecognized delirium may receive incomplete diagnostic workups and an underlying life-threatening illness may remain undiagnosed. These patients may also receive inappropriate interventions known to exacerbate delirium such as medications with anticholinergic properties or benzodiazepines.38, 39 Additionally, delirious patients who are discharged from the ED may be less likely to comprehend their discharge instructions,40 leading to poor adherence, return ED visits, and potentially increased mortality and morbidity.41, 42 The ED is ideally positioned to perform delirium surveillance because it is at the nexus of geriatric health care and serves as the gateway for the majority of hospital admissions.",
       "highlight": "delirious patients who are discharged from the ED may be less likely to comprehend their discharge instructions",
       "scope": "on-scope",
       "note": "Shows that failing to recognize/communicate ED delirium degrades both the inpatient workup and post-discharge follow-up, matching 'changes inpatient management and follow-up.'",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      },
      {
       "context": "Despite being a marker of death, delirium is missed by emergency physicians in up to 75% of the cases.1, 2 This has been characterized as a serious quality of care issue,37 and may lead to higher mortality in older ED patients.31 Though the mechanisms for this are unclear, NIH-PA Author Manuscript Ann Emerg Med.",
       "highlight": "delirium is missed by emergency physicians in up to 75% of the cases",
       "scope": "background",
       "note": "Establishes the recognition gap and quality-of-care framing that make explicit documentation and handoff necessary; rationale rather than the handoff instruction itself.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    },
    {
     "label": "ED-DEL change package & toolkit",
     "cite": "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary source (anchor p.9 change package); its Strategy 4 'Optimize communication / transitions of care' tactic and transition instruments direct explicit handoff of delirium status at disposition.",
     "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf",
     "paragraphs": [
      {
       "context": "Transitions: Communicate to inpatient MD and RN (and family/caregivers) about high risk for delirium (e.g., previous delirium, cognitive impairment), presence of delirium and/or agitation.",
       "highlight": "Communicate to inpatient MD and RN (and family/caregivers) about high risk for delirium (e.g., previous delirium, cognitive impairment), presence of delirium and/or agitation",
       "scope": "on-scope",
       "note": "Standing-order transitions guidance directing explicit communication to inpatient MD/RN and family about delirium risk, presence, and agitation at handoff.",
       "page": "99",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Delirium Management: Indicate management strategies implemented in ED: Medication/Pharmacist Review - avoid or minimize antipsychotic use/Beers List meds Minimized restraints and alarms Maintained orientation Maintained mobility Delirium assessment ongoing Agitation management? What nonpharmacologic approaches helped? Avoided Foley catheter Used \"Tolerate, Anticipate, Don't Agitate\" (TADA) approach; details: _____________________________________________________________________ Family involvement: ___________________________________________________ Medications required (indicate):__________________________________________ Describe what helped most: _________________________________________________________________________________________ _________________________________________________________________________________________ Important contact information: Family: _________________________________________________________________________________________ Primary Care Physician: ___________________________________________________________________________ Pharmacy: ______________________________________________________________________________________ Transfer Checklist from ED to Inpatient Unit or to Skilled Nursing Facility 2020 by Dr.",
       "highlight": "Indicate management strategies implemented in ED",
       "scope": "on-scope",
       "note": "The ED-to-inpatient/SNF Transfer Checklist is the disposition handoff instrument that carries the delirium finding and its ED management forward to the admitting unit.",
       "page": "107",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      }
     ]
    }
   ],
   "synthesis": "Both sources agree and are on-scope for older ED patients. The ED-DEL change package and toolkit (the primary source) directs clinicians to communicate delirium status explicitly to the inpatient MD and RN and at transitions of care from the ED to the next site (its Strategy 4 'Optimize communication' tactic on p.9, restated cleanly in the prevention/treatment protocol on p.99 and embodied in the ED-to-inpatient/SNF transfer checklist on p.107), and Han 2010 independently states that if admitted, physicians at the next level of care should be notified of the patient's delirium status, documenting that unrecognized ED delirium worsens the inpatient workup and post-discharge follow-up. The ED-DEL toolkit governs as the primary source and Han corroborates the disposition-handoff imperative.",
   "discrepancy": false
  },
  {
   "id": "ed-cards-r19",
   "toolId": "ed-cards",
   "tool": "ED Card Set",
   "page": "5",
   "section": "Act-on-a-positive — Document & communicate",
   "statement": "A positive screen in the ED independently predicts mortality — treat it as a finding that matters.",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2010",
    "ED-DEL change package & toolkit"
   ],
   "anchor": "Han 2010 — p. 2",
   "passage": "adjusting for age, comorbidity burden, severity of illness, dementia, functional dependence, and nursing home residence. The \"delirium*nursing home\" interaction was non-significant (p=0.86), indicating that place of residence had no effect on the relationship between delirium in the ED and 6-month mortality. Conclusion- Delirium in older ED patients is an independent predictor of increased 6-month mortality and this relationship appears to be present regardless of nursing home status. Introduction Background Delirium occurs in 8 - 10% of older emergency department (ED) patients.1, 2 This form of brain dysfunction is characterized by an acute change in cognition that cannot be better accounted for by a preexisting or evolving dementia.3 Approximately 1.5 million older patients with delirium will be evaluated in the ED each year in the United States.4 This is similar to the number of annual acute coronary syndromes, a disease with comparable mortality and morbidity.5 Despite the magnitude of this problem, emergency physicians miss delirium in up to 75% of the cases.1, 2, 6 Importance The lack of delirium recognition may be secondary to a dearth of ED outcomes data. …\nHan 2010 reports delirium as an independent predictor of 6-month mortality after adjustment (HR 1.72, 95% CI 1.04–2.86; 37.0% vs. 14.3% mortality).",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
    "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2010.03.003",
    "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary study directly on the claim: prospective ED cohort (CAM-ICU screen) showing delirium independently predicts 6-month mortality after multivariable adjustment.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": [
      {
       "context": "Conclusion--Delirium in older ED patients is an independent predictor of increased 6-month mortality and this relationship appears to be present regardless of nursing home status.",
       "highlight": "Delirium in older ED patients is an independent predictor of increased 6-month mortality",
       "scope": "on-scope",
       "note": "Abstract Conclusion states the exact claim — ED delirium independently predicts 6-month mortality.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      },
      {
       "context": "Delirium in older ED patients is an independent predictor of increased 6-month mortality and this relationship appears to be present regardless of nursing home status.",
       "highlight": "independent predictor of increased 6-month mortality",
       "scope": "on-scope",
       "note": "The study's conclusion establishes delirium as an independent predictor of increased 6-month mortality after covariate adjustment (the abstract Results HR sentence is split across the page break, so the clean conclusion statement is used).",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      },
      {
       "context": "In older ED patients, delirium is an independent predictor for death, even after adjusting for age, comorbidity burden, severity of illness, dementia, functional dependence, and nursing home residence. This relationship is present regardless of nursing home residence. Future studies are needed to determine optimal screening and management strategies for delirium in the ED, and to determine if earlier detection and intervention of delirium in the ED improves patient outcomes.",
       "highlight": "delirium is an independent predictor for death",
       "scope": "on-scope",
       "note": "Final Conclusion restates independent prediction of death after full covariate adjustment.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      },
      {
       "context": "Despite being a marker of death, delirium is missed by emergency physicians in up to 75% of the cases.1, 2 This has been characterized as a serious quality of care issue,37 and may lead to higher mortality in older ED patients.31 Though the mechanisms for this are unclear, NIH-PA Author Manuscript Ann Emerg Med.",
       "highlight": "Despite being a marker of death, delirium is missed by emergency physicians in up to 75% of the cases",
       "scope": "on-scope",
       "note": "Supports the 'treat it as a finding that matters' framing — delirium is a marker of death yet frequently missed in the ED.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    },
    {
     "label": "ED-DEL change package & toolkit",
     "cite": "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Secondary implementation toolkit that cites Han 2010 for the same ED-delirium mortality finding to justify screening; also contains adjacent, different-scope mortality figures.",
     "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf",
     "paragraphs": [
      {
       "context": "Delirium (also referred to as acute brain failure) is a neurologic emergency characterized by an acute decline in cognitive functioning. It is common and often the only presenting symptom of serious, even fatal, medical conditions, especially among older adults. It is a presenting condition for up to 30% of older adults in the emergency department (ED) (Gower 2012) and costs over $164 billion (2011 USD) per year in the United States (Oh 2017). Only 24-35% of delirium cases are recognized, and nearly half of patients are discharged with little consideration of the seriousness of the delirium (Gower 2012), which can lead to substantially increased mortality during the 6 months following ED discharge, 37% vs. 14% (Han 2010, Kakuma 2003). Importantly, delirium prolongs ED length of stay, and hospital stay by a median of 2 days (Kennedy 2014).",
       "highlight": "substantially increased mortality during the 6 months following ED discharge, 37% vs. 14% (Han 2010, Kakuma 2003)",
       "scope": "on-scope",
       "note": "Background & Rationale cites Han 2010 for the same 6-month mortality finding (37% vs 14%), directly supporting the claim.",
       "page": "4",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Failure to identify and admit patients with D is associated with a 3- 5- fold increased risk of death compared to those without D.",
       "highlight": "with a 3- 5- fold increased risk of death compared to",
       "scope": "on-scope",
       "note": "Toolkit facts card ties missed ED delirium to a 3-5 fold death risk, reinforcing that a positive screen is a finding that matters.",
       "page": "38",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Hospital stays ending in death are responsible for 5.1 percent ($17.6 billion, 2007 USD) of all hospital inpatient costs [$21.46 billion in 2019 USD]. Moreover, delirium associated with 7.4-fold increased risk of death",
       "highlight": "delirium associated with 7.4-fold increased risk of death",
       "scope": "different-setting",
       "note": "Nearest keyword match on delirium mortality but from an inpatient hospital cost-of-death (HCUP) context, not the ED positive-screen finding.",
       "page": "38",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      },
      {
       "context": "Delirium can present as hypoactive, hyperactive, or mixed psychomotor subtype. Hypoactive delirium is more common in older adults in the emergency department, is associated with a worse prognosis including increased risk of mortality, and is commonly missed by clinicians (Han 2009). Older patients presenting with delirium are often quiet, withdrawn, or described as \"not quite her usual self\"; thus, it is important to consider delirium in older patients with any subdued change in mental status.",
       "highlight": "worse prognosis including increased risk of mortality",
       "scope": "broader",
       "note": "About the hypoactive subtype's prognosis (Han 2009), broader than and distinct from Han 2010's independent-predictor result.",
       "page": "4",
       "docUrl": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      }
     ]
    }
   ],
   "synthesis": "The two sources agree: Han 2010 is the on-scope primary study, showing that ED delirium (CAM-ICU positive) independently predicts 6-month mortality after adjustment (HR 1.72, 95% CI 1.04-2.86), and the ACEP ED-DEL toolkit cites Han 2010 for the same 37% vs 14% mortality figure to justify screening — so Han 2010 governs the claim. The toolkit's other mortality numbers (inpatient 7.4-fold cost-of-death figure; the hypoactive-subtype prognosis from Han 2009) are nearest keyword matches from a different setting/framing and do not bear on the independent-predictor claim.",
   "discrepancy": true
  },
  {
   "id": "ed-wf-r3",
   "toolId": "ed-wf",
   "tool": "ED Workflow",
   "page": "1",
   "section": "1 · Screen every older adult",
   "statement": "Screen older ED patients per your department’s policy — most ED delirium is hypoactive and quiet, and is missed without a screen.",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "4AT v1.2",
    "GED Guidelines 2.0 (2026)",
    "SIGN 157",
    "NICE CG103",
    "ADEPT (2020)",
    "Han 2010"
   ],
   "anchor": "ADEPT (2020) — p. 4",
   "passage": "… The hallmarks of delirium include acute onset, waxing and waning symptoms, inattention (eg, unable to recite the months of the year or days of the week backwards), change in cognition (new memory deficit, disorientation, perceptual disturbance, or disorganized thinking), or altered level of awareness (reduced orientation to environment such as somnolence or agitation).14 Delirium can be subcategorized into 3 main psychomotor types. Hyperactive delirium is characterized by agitation, increased psychomotor activity, and heightened level of arousal. It is the most recognizable type but accounts for less than 10% of delirium observed in the ED.15 Hypoactive delirium is by far the most common type, accounting for approximately 90%.1 It is characterized by somnolence and psychomotor retardation. It is more likely to be missed by the clinician because patients may be somnolent, quiet, and unlikely to draw attention to themselves. Hypoactive delirium is associated with the highest mortality rate.1 Finally, mixed delirium involves alternating hypoactive and hyperactive states. Risk factors for delirium include a history of neurocognitive disorder (dementia), previous episodes of delirium, increased age, vision or hearing impairment, previous stroke, impaired functional status, nursing facility residence, or home health aide for activities of daily living. There are numerous brief tools that can be used to diagnose delirium in the ED. …\nADEPT also notes delirium is frequently underrecognized in the ED, with clinicians diagnosing fewer than 20% of delirious patients. 'Per your department's policy' is operational framing rather than a sourced recommendation.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
    "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.the4at.com/",
    "https://doi.org/10.1111/acem.70167",
    "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
    "https://www.nice.org.uk/guidance/cg103",
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://doi.org/10.1016/j.annemergmed.2010.03.003"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Supports the screen/missed parts strongly (silent delirium stays unrecognized without a formal screen; ~75% miss rate in older ED patients); it does not itself state that most ED delirium is hypoactive.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "Delirium is often clinically silent and will remain unrecognized without a formal delirium assessment. Most healthcare professionals do not screen for delirium in their clinical practice,13, 20 because there is a dearth of brief and easy to use assessments.",
       "highlight": "Most healthcare professionals do not screen for delirium in their clinical practice",
       "scope": "on-scope",
       "note": "Direct support for 'missed without a screen' - clinically silent delirium stays unrecognized unless a formal assessment is done, and most clinicians do not screen.",
       "page": "p. 2",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "Background--Delirium is a common form of acute brain dysfunction with prognostic significance. Health care professionals caring for older emergency department (ED) patients miss delirium approximately 75% of cases. This error results from a lack of available measures that can be performed rapidly enough to be incorporated into clinical practice. Therefore, we developed and evaluated a novel two-step approach to delirium surveillance for the ED.",
       "highlight": "miss delirium approximately 75% of cases",
       "scope": "on-scope",
       "note": "Quantifies ED under-detection — clinicians caring for older ED patients miss ~75% of delirium.",
       "page": "p. 1",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "Unfortunately, delirium is frequently missed by healthcare professionals in all clinical settings,2, 7 and this is especially the case in the ED where it is missed 57% to 83% of the time.",
       "highlight": "in the ED where it is missed 57% to 83% of the time",
       "scope": "on-scope",
       "note": "ED-specific miss rate (57-83%), reinforcing that delirium is missed without a formal screen.",
       "page": "p. 2",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "background",
     "note": "Provides the cited brief bedside screen a department could adopt; the instrument text is setting-general and makes no ED-specific, prevalence, or psychomotor-subtype claim.",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": [
      {
       "context": "The 4AT is a screening instrument designed for rapid initial assessment of delirium and cognitive impairment. A score of 4 or more suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis.",
       "highlight": "a screening instrument designed for rapid initial assessment of delirium and cognitive impairment",
       "scope": "background",
       "note": "Defines the cited screen (one option under a department's policy) but does not itself address the ED setting, hypoactive predominance, or under-recognition.",
       "page": "",
       "docUrl": "https://www.the4at.com/"
      },
      {
       "context": "Alertness: Altered level of alertness is very likely to be delirium in general hospital settings. If the patient shows significant altered alertness during the bedside assessment, score 4 for this item. AMT4 (Abbreviated Mental Test - 4): This score can be extracted from items in the AMT10 if the latter is done immediately before. Acute Change or Fluctuating Course: Fluctuation can occur without delirium in some cases of dementia, but marked fluctuation usually indicates delirium. To help elicit any hallucinations and/or paranoid thoughts ask the patient questions such as, \"Are you concerned about anything going on here?\"; \"Do you feel frightened by anything or anyone?\"; \"Have you been seeing or hearing anything unusual?\"",
       "highlight": "very likely to be delirium in general hospital settings",
       "scope": "different-setting",
       "note": "The 4AT guidance frames altered alertness for general hospital settings, not the ED specifically.",
       "page": "",
       "docUrl": "https://www.the4at.com/"
      }
     ]
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ED guideline confirming delirium is often underdiagnosed and endorsing screening/risk-stratification set by local protocol; it does not assert hypoactive predominance and notes subtype accuracy of tools is unclear.",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": [
      {
       "context": "Delirium is often underdiagnosed, and routine screening for all older adults is resource‐intensive [ 69 ]. Furthermore, structured approaches to screen all older adults in ED settings for prevalent (pre‐ED) or incident delirium do not consistently increase the frequency with which delirium is recognized [ 70 ].",
       "highlight": "Delirium is often underdiagnosed",
       "scope": "on-scope",
       "note": "Confirms delirium is often underdiagnosed and, because universal screening is resource-intensive and does not consistently improve recognition, favors risk-stratified screening — supporting 'per your department's policy.'",
       "page": "p. 7",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "Nearly 15 years ago, the American Geriatrics Society (AGS) and SAEM recommended prioritizing delirium care, including delirium screening and preventative interventions [ 24 , 25 , 26 , 27 , 28 ].",
       "highlight": "recommended prioritizing delirium care, including delirium screening",
       "scope": "on-scope",
       "note": "AGS and SAEM recommend prioritizing delirium care, including delirium screening, in older ED patients.",
       "page": "p. 2",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "In older ED patients with suspected delirium, there is sufficient direct evidence to select delirium diagnostic instruments that accurately rule in (i.e., confirm) or rule out (i.e., exclude) delirium [ 22 ]. The 4AT had the largest quantity of ED‐based research and may be used to rule in or rule out delirium [ 90 ]. The CAM‐ICU, brief Confusion Assessment Method (bCAM), modified Confusion Assessment Method (mCAM) for the Emergency Department, AMT‐4, and Richmond Agitation and Sedation Scale (RASS) are superior to clinical gestalt [ 91 ], and may also be used to rule in or rule out delirium. The Delirium Triage Screen is superior to clinical gestalt in ruling out delirium [ 92 ] (Table 3 ).",
       "highlight": "select delirium diagnostic instruments that accurately rule in",
       "scope": "on-scope",
       "note": "Names the validated ED screening/diagnostic instruments (4AT, bCAM, CAM-ICU, AMT-4, RASS, DTS) a department may adopt.",
       "page": "p. 9",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "Diagnostic accuracy studies have mostly been conducted in academic centers, which limits the external validity to other settings, such as community EDs or low‐resource settings. Applying these diagnostic instruments in less‐resourced non‐research settings without local opinion leaders or delirium expertise may yield differing levels of instrument acceptance and fidelity, accuracy, and overall impact in reducing the sequelae of delirium [ 115 , 124 , 125 ]. It is also unclear if the diagnostic accuracy of these tools differs across delirium motor subtypes (hyperactive vs. hypoactive), or in identifying incident versus prevalent (pre‐ED) delirium.",
       "highlight": "delirium motor subtypes (hyperactive vs. hypoactive)",
       "scope": "narrower",
       "note": "Shares the 'hypoactive' keyword but addresses tool accuracy across motor subtypes — it does NOT state that most ED delirium is hypoactive, so it is not direct support for that sub-claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      }
     ]
    },
    {
     "label": "SIGN 157",
     "cite": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "National guideline (acute hospital/ICU/long-term care) that explicitly recommends the 4AT in the ED and agrees hypoactive delirium is more common; its prevalence figures are from non-ED populations.",
     "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
     "paragraphs": [
      {
       "context": "RThe 4AT tool should be used for identifying patients with probable delirium in emergency department and acute hospital settings.",
       "highlight": "in emergency department and acute hospital settings",
       "scope": "on-scope",
       "note": "SIGN explicitly recommends the 4AT screen in the emergency department (and acute hospital) setting.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "Delirium is frequently missed in routine clinical care and lack of detection is associated with poor outcomes.18,19 Delirium detection should ideally be undertaken at the earliest opportunity. Numerous assessment tools have been developed to help identify probable delirium in patients in a variety of settings, which can then prompt a more accurate diagnosis and consideration of underlying causes. For practical reasons, for implementation and acceptability to patients, assessment tools should be brief, require little or no training and be appropriate to the clinical setting.20 The sensitivity of the tool is also important, as it is vital not to miss delirium.",
       "highlight": "Delirium is frequently missed in routine clinical care",
       "scope": "on-scope",
       "note": "Supports 'missed without a screen' — non-detection is common and harmful, motivating a brief sensitive screening tool.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "Delirium is frequently missed in routine clinical care and lack of detection is associated with poor outcomes.",
       "highlight": "frequently missed in routine clinical care and lack of detection is associated with poor outcomes",
       "scope": "broader",
       "note": "Corroborates the screening rationale that delirium is frequently missed without detection, as a general all-settings statement rather than an ED-specific hypoactive figure (the only hypoactive-predominance sentence in the source is broken by an embedded evidence-level marker).",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "Delirium is among the most common of medical emergencies. A UK study found a prevalence of 20% in adult acute general medical patients.5 The prevalence is higher in particular clinical groups, such as patients in intensive care units (ICU). It affects up to 50% who have hip fracture and up to 75% in intensive care.1 Several predisposing factors increase the risk of delirium, including older age, dementia, frailty, the presence of multiple comorbidities, male sex, sensory impairments, a history of depression, a history of delirium, and alcohol misuse.1,6 Despite its importance, there are deficiencies in care of people with delirium in Scotland.",
       "highlight": "up to 50% who have hip fracture and up to 75% in intensive care",
       "scope": "different-setting",
       "note": "Nearest prevalence data, but from acute general-medical, hip-fracture and ICU populations — not the ED, so not direct support for ED figures.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "partial",
     "note": "Strongly corroborates the hypoactive-quiet-often-missed clinical picture and recommends the 4AT, but its validated remit is hospital and long-term care — it explicitly lists the ED as a research gap, so it is a different-setting nearest match rather than ED support.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "Be particularly vigilant for changes that may indicate hypoactive delirium, which are often missed, such as withdrawal, slow responses, reduced mobility and movement, worsened concentration and reduced appetite.",
       "highlight": "are often missed, such as withdrawal, slow responses, reduced mobility and",
       "scope": "different-setting",
       "note": "Corroborates that hypoactive delirium is often missed, but NICE's scope is presentation to hospital or long-term care, not the ED.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "A person may already have delirium when they present to hospital or long-term care or it may develop during a hospital admission or residential stay in long-term care. Delirium can be hypoactive or hyperactive but some people show signs of both (mixed). People with hyperactive delirium have heightened arousal and can be restless, agitated and aggressive. People with hypoactive delirium become withdrawn, quiet and sleepy. Hypoactive and mixed delirium can be more difficult to recognise.",
       "highlight": "Hypoactive and mixed delirium can be more difficult to recognise",
       "scope": "different-setting",
       "note": "Confirms the quiet, hard-to-recognize hypoactive picture — again for hospital/long-term-care patients rather than the ED.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "competent to do so should carry out an assessment using the 4AT. In critical care or in the recovery room after surgery use the Confusion Assessment Method for the Intensive Care Unit (CAM-ICU) or Intensive Care Delirium Screening Checklist (ICDSC) instead of the 4AT.",
       "highlight": "carry out an assessment using the 4AT",
       "scope": "different-setting",
       "note": "NICE's 4AT screening recommendation applies to hospital and long-term care, not specifically the ED.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Delirium: prevention, diagnosis and management in hospital and long-term care (CG103) Recommendations for research The guideline committee has made the following key recommendations for research. 1 Delirium assessment tools What is the diagnostic accuracy, and ease of implementation, of different delirium assessment tools: for people with pre-existing cognitive impairment, for example dementia, learning disability or severe depression for people who do not speak English as a first language in different settings, for example emergency departments, residential care homes or virtual consultations when delivered by different types of health and social care practitioners, for example healthcare assistants or allied health professionals such as paramedics? [2023] For a short explanation of why the committee made this recommendation for research, see the rationale section on assessment and diagnosis. Full details of the evidence and the committee's discussion are in evidence review A: diagnostic accuracy of tests to identify delirium. 2 Pharmacological prevention In people in hospital who are at high risk of delirium, which medication (atypical antipsychotics, typical antipsychotics, benzodiazepines or acetylcholinesterase inhibitors), compared with placebo or each other, is more clinically and cost effective in preventing the development of delirium? [2010]",
       "highlight": "emergency departments",
       "scope": "different-setting",
       "note": "NICE explicitly lists the emergency department as a setting where assessment-tool accuracy is a research gap — confirming CG103 is not ED-validated.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary anchor and the governing ED-specific source — states most ED delirium is hypoactive (~90%), quiet, and more likely to be missed, and frames screening as a locally developed departmental protocol.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "Delirium can be subcategorized into 3 main psychomotor types. Hyperactive delirium is characterized by agitation, increased psychomotor activity, and heightened level of arousal. It is the most recognizable type but accounts for less than 10% of delirium observed in the ED.15 Hypoactive delirium is by far the most common type, accounting for approximately 90%.1 It is characterized by somnolence and psychomotor retardation. It is more likely to be missed by the clinician because patients may be somnolent, quiet, and unlikely to draw attention to themselves. Hypoactive delirium is associated with the highest mortality rate.1 Finally, mixed delirium involves alternating hypoactive and hyperactive states. Risk factors for delirium include a history of neurocognitive disorder (dementia), previous episodes of delirium, increased age, vision or hearing impairment, previous stroke, impaired functional status, nursing facility residence, or home health aide for activities of daily living.",
       "highlight": "It is more likely to be missed by the clinician because patients may be somnolent, quiet, and unlikely to draw attention to themselves.",
       "scope": "on-scope",
       "note": "Primary anchor — directly states most ED delirium is hypoactive (~90%), quiet, and more likely to be missed by clinicians.",
       "page": "p. 4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Despite delirium's prevalence among geriatric ED patients, emergency clinicians formally diagnose it in less than 20% of delirious patients.2,3 Underrecognition of delirium may result in adverse outcomes, including higher mortality.4 Distinguishing between delirium, dementia, and primary psychiatric conditions can be challenging in older adults because neuropsychiatric symptoms, such as depression, agitation, and psychotic symptoms, are common in patients with dementia.13 In addition, patients with baseline dementia are at increased risk of developing superimposed delirium during an acute illness.",
       "highlight": "Underrecognition of delirium may result in adverse outcomes, including higher mortality.",
       "scope": "on-scope",
       "note": "Quantifies under-recognition in geriatric ED patients (<20% diagnosed), supporting 'missed without a screen.'",
       "page": "p. 4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Finally, perhaps the largest controversy pertains to optimal delirium screening strategies; in particular, who should be screened and what screening methods should be used. Because delirium is underrecognized in ED patients,2,3 some individuals advocate ED-based screening of older patients for cognitive impairment.71 However, to our knowledge, to date there are no randomized controlled studies examining the effect of routine delirium screening in the ED setting. Benefits of screening include earlier diagnosis of delirium and potential avoidance of inappropriate discharge, which may be associated with increased mortality4; however, the potential risks include false-positive diagnoses, which may result in unnecessary resource use, including hospitalization and the potential for inappropriate treatment with antipsychotic medications.63,72 We have reviewed the ED screening, diagnosis, and treatment of older patients with alterations of mental status, using the ADEPT framework.",
       "highlight": "who should be screened and what screening methods should be used",
       "scope": "on-scope",
       "note": "Supports 'per your department's policy' — who and how to screen is unsettled, with no RCT of routine ED screening, so it is a local decision.",
       "page": "p. 9",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "present with or develop delirium or agitation in the ED. It is therefore important for hospitals to develop protocols and procedures to help reduce the development and severity of agitation and delirium, and for every clinician to be educated and prepared to care for patients with delirium.",
       "highlight": "important for hospitals to develop protocols and procedures",
       "scope": "on-scope",
       "note": "Explicitly frames screening as a locally developed protocol — hospitals develop their own procedures, matching 'per your department's policy.'",
       "page": "p. 9",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Near-verbatim ED corroboration — most delirium is the hypoactive 'quiet' subtype and is often missed without a formal assessment; SAEM recommends ED delirium surveillance.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": [
      {
       "context": "subtype,2 the clinical presentation can be subtle and is often missed without performing a delirium assessment.44 Currently, the Confusion Assessment Method (CAM) is the only delirium assessment validated for the ED setting.",
       "highlight": "the clinical presentation can be subtle and is often missed without performing a delirium assessment",
       "scope": "on-scope",
       "note": "Near-verbatim match to the claim — the majority of ED delirium is the hypoactive 'quiet' subtype and is often missed without performing a delirium assessment.",
       "page": "p. 8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      },
      {
       "context": "Despite being a marker of death, delirium is missed by emergency physicians in up to 75% of the cases.1, 2 This has been characterized as a serious quality of care issue,37 and may lead to higher mortality in older ED patients.",
       "highlight": "delirium is missed by emergency physicians in up to 75% of the cases",
       "scope": "on-scope",
       "note": "Quantifies ED under-detection (~75%) and frames it as a serious quality-of-care issue.",
       "page": "p. 7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      },
      {
       "context": "Consequently, the Society for Academic Emergency Medicine Geriatrics Task Force recently recommended that delirium surveillance in the ED be a key quality indicator for emergency geriatric care.43 Because the majority of delirium is the hypoactive \"quiet\" subtype,2 the clinical presentation can be subtle and is often missed without performing a delirium assessment.44 Currently, the Confusion Assessment Method (CAM) is the only delirium assessment validated for the ED setting.",
       "highlight": "delirium surveillance in the ED be a key quality indicator for emergency geriatric care",
       "scope": "on-scope",
       "note": "Supports departmental screening policy — SAEM recommends ED delirium surveillance as a key geriatric quality indicator, with high-risk-only screening as one efficiency option.",
       "page": "p. 8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    }
   ],
   "synthesis": "The ED-specific sources agree: ADEPT 2020 (p.4, the primary anchor) and Han 2010 (p.8) state directly that most ED delirium is the hypoactive, \"quiet\" subtype (~90%) and is often missed without a formal assessment, while Han 2013 and GED Guidelines 2.0 corroborate high ED miss rates and support screening set by local/departmental protocol (GED 2.0 favors risk-stratified rather than universal screening). SIGN 157 also recommends the 4AT in the ED and agrees hypoactive delirium predominates, but NICE CG103 corroborates the same hypoactive-quiet-often-missed picture only for hospital/long-term care and explicitly flags the ED as a research gap, and the 4AT sheet is setting-general — so ADEPT, as the ED-specific source, governs.",
   "discrepancy": true
  },
  {
   "id": "ed-wf-r4",
   "toolId": "ed-wf",
   "tool": "ED Workflow",
   "page": "1",
   "section": "1 · Screen every older adult",
   "statement": "Pick one pathway: two-step DTS → bCAM, the bCAM directly (high-risk), or the 4AT.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "4AT v1.2",
    "GED Guidelines 2.0 (2026)",
    "SIGN 157",
    "NICE CG103",
    "ADEPT (2020)",
    "Han 2010"
   ],
   "anchor": "Han 2013 (DTS/bCAM) — p. 2",
   "passage": "… The positive likelihood ratios for the bCAM were 19.9 (95%CI: 12.0 - 33.2) and 25.2 (95%CI: 13.9 - 46.0), respectively. If the RA DTS was followed by the physician bCAM, the sensitivity of this combination was 84.0% (95%CI: 71.5% - 91.7%) and the specificity was 95.8% (95%CI: 93.2% - 97.4%). If the RA performed both the DTS and bCAM, this combination was 78.0% (95%CI: 64.8% - 87.2%) sensitive and 97.2% (95%CI: 94.9% - 98.5%) specific. If the physician performed both the DTS and bCAM, this combination was 82.0% (95%CI: 69.2% - 90.2%) sensitive and 95.8% (95CI: 93.2% - 97.4%) specific. Conclusions- In older ED patients, this two-step approach (highly sensitive DTS followed by highly specific bCAM) may enable healthcare professionals, regardless of clinical background, to efficiently screen for delirium. Larger, multi-centered trials are needed to confirm these findings and to determine the impact of these assessments on delirium recognition in the ED. …\nAlso GED Guidelines 2.0 (2026): \"For diagnosis, 4AT, bCAM, CAM-ICU, mCAM, AMT-4, or RASS may be used to rule delirium in or out, based on very low certainty. The Delirium Triage Screen (DTS) may be used to rule out\"\nHan 2013 establishes the two-step DTS-to-bCAM pathway, and GED Guidelines 2.0 endorses the 4AT and bCAM (with the DTS to rule out) as validated alternatives, supporting 'pick one pathway.' The 'bCAM directly (high-risk)' qualifier is not stated as such, though the bCAM as a standalone rule-in tool is supported.",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
    "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.the4at.com/",
    "https://doi.org/10.1111/acem.70167",
    "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
    "https://www.nice.org.uk/guidance/cg103",
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://doi.org/10.1016/j.annemergmed.2010.03.003"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Validates the two-step DTS-then-bCAM approach in older ED patients and notes either component can be used alone; does not address the 4AT.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "Conclusions--In older ED patients, this two-step approach (highly sensitive DTS followed by highly specific bCAM) may enable healthcare professionals, regardless of clinical background, to efficiently screen for delirium. Larger, multi-centered trials are needed to confirm these findings and to determine the impact of these assessments on delirium recognition in the ED.",
       "highlight": "this two-step approach (highly sensitive DTS followed by highly specific bCAM) may enable healthcare professionals, regardless of clinical background, to efficiently screen for delirium",
       "scope": "on-scope",
       "note": "Abstract conclusion: the two-step DTS-then-bCAM approach for older ED patients, the first pathway in the menu.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "One method to improve delirium detection would be to use a two-step approach: a sequential testing strategy that utilizes brief, valid, and reliable delirium assessments that can be performed by healthcare professionals of all clinical backgrounds. The first step would be to perform a very brief (<20 seconds), highly sensitive delirium screen to rule-out delirium. This rapid rule-out screen can be incorporated into the ED triage assessment or can be part of the initial nursing assessment after the patient has been placed in an ED bed. A negative screen would rule out delirium, reduce the number of formal delirium assessments needed, and enhance screening efficiency. A positive screen would trigger a formal delirium assessment performed by another health care provider (i.e., physician) at the patient's bedside that would be highly specific to rule-in delirium. Ideally, this rule-in assessment should be brief (<1 minute) to maximize feasibility. We developed Delirium Triage Screen (DTS) and the Brief Confusion Assessment Method (bCAM) to serve as the rule-out and rule-in tests for the two-step approach to delirium surveillance (Figure 1), respectively.",
       "highlight": "a two-step approach: a sequential testing strategy that utilizes brief, valid, and reliable delirium assessments",
       "scope": "on-scope",
       "note": "Describes the design: a brief highly sensitive rule-out (DTS) followed by a specific rule-in (bCAM).",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "negative, then delirium is ruled out and no additional testing is needed. If the DTS result is positive, then a confirmatory delirium assessment such as the bCAM should be performed.",
       "highlight": "If the DTS result is positive, then a confirmatory delirium assessment such as the bCAM should be performed",
       "scope": "on-scope",
       "note": "Figure 1 flow: a negative DTS rules out; a positive DTS triggers bCAM confirmation, the DTS-to-bCAM pathway.",
       "page": "ms. p.12",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "Our study has several strengths. The DTS and bCAM achieved a NLR of 0.04 and PLR of 20, respectively. These assessments strongly influence clinical decision making.46 The twostep approach to delirium surveillance also serves as a conceptual model and can be tailored to each institution; one or both components can be used. In addition, each component can reliably performed by healthcare professionals regardless of clinical background and at different times during the ED course, further adding to this approach's flexibility. These NIH-PA Author Manuscript Ann Emerg Med.",
       "highlight": "one or both components can be used",
       "scope": "on-scope",
       "note": "States either component can be used alone, supporting the bCAM-directly option.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The 4AT instrument itself: a standalone rapid delirium/cognitive screen (its guidance frames alertness scoring for general hospital settings).",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": [
      {
       "context": "The 4AT is a screening instrument designed for rapid initial assessment of delirium and cognitive impairment. A score of 4 or more suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis.",
       "highlight": "a screening instrument designed for rapid initial assessment of delirium and cognitive impairment",
       "scope": "on-scope",
       "note": "Defines the 4AT as a rapid initial delirium screen, the third pathway option.",
       "page": "",
       "docUrl": "https://www.the4at.com/"
      },
      {
       "context": "A score of 4 or more suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis.",
       "highlight": "A score of 4 or more suggests delirium but is not diagnostic",
       "scope": "on-scope",
       "note": "The 4AT positive threshold: a score of 4 or more suggests delirium.",
       "page": "",
       "docUrl": "https://www.the4at.com/"
      }
     ]
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Current GRADE-based ED delirium guideline; endorses 4AT and bCAM to rule in/out and DTS to rule out - the governing on-scope source for this menu.",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": [
      {
       "context": "Recommendation #4: In older adults in the ED, 4AT, bCAM, CAM‐ICU, mCAM, AMT‐4, or RASS may be used to rule in or rule out delirium (Conditional, FOR) [Very low certainty of evidence].",
       "highlight": "In older adults in the ED, 4AT, bCAM,",
       "scope": "on-scope",
       "note": "Recommendation #4 lists the 4AT and bCAM (among others) as tools that may rule delirium in or out in older ED patients, supporting the bCAM-directly and 4AT options.",
       "page": "9",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "Recommendation #5: In older adults in the ED, DTS may be used to rule out delirium (Conditional, FOR) [Very low certainty of evidence].",
       "highlight": "DTS may be used to rule out delirium",
       "scope": "on-scope",
       "note": "Recommendation #5: the DTS may be used to rule out delirium, the sensitive first step of the two-step pathway.",
       "page": "9",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "Some patients expressed frustration when the delirium protocol questions are perceived as irrelevant to their medical condition [ 121 ]. Missing delirium in older ED patients (i.e., a false negative test) leads to undertreatment, with subsequent falls, pressure ulcers, dehydration, aspiration, and death [ 80 ]. On the other hand, overdiagnosing delirium (i.e., a false positive test) may result in an increased ED length of stay, care delays, anchoring bias, additional testing, and possible unnecessary hospitalization [ 122 ]. Until a delirium diagnostic tool that is both highly sensitive and specific and easy to implement is created, these aforementioned risks can be mitigated by choosing delirium diagnostic tools with high sensitivity and confirming the results with a highly specific diagnostic test [ 92 ].",
       "highlight": "choosing delirium diagnostic tools with high sensitivity and confirming the results with a highly specific diagnostic test",
       "scope": "on-scope",
       "note": "Endorses the sensitive-screen-then-specific-confirmation logic that underlies the DTS-to-bCAM two-step.",
       "page": "11",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      }
     ]
    },
    {
     "label": "SIGN 157",
     "cite": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Endorses the 4AT for ED/acute-hospital delirium detection but does not address the DTS/bCAM two-step, and confines CAM-ICU/ICDSC to the ICU.",
     "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
     "paragraphs": [
      {
       "context": "RThe 4AT tool should be used for identifying patients with probable delirium in emergency department and acute hospital settings.",
       "highlight": "The 4AT tool should be used for identifying patients with probable delirium in emergency department and acute hospital settings",
       "scope": "on-scope",
       "note": "Key recommendation to use the 4AT in emergency department and acute hospital settings, supporting the 4AT option.",
       "page": "5",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "A commonly used tool, the Confusion Assessment Method (CAM) and its variants have been reported as useful tools for detecting delirium.18,21,22 However, sensitivity and specificity varied broadly, possibly due to the need for users to have training and knowledge of delirium and its differential diagnoses. The CAM-ICU has particularly broad use within ICU settings but has the same limitations.19,23 The 4 As Test (Arousal, Attention, Abbreviated Mental Test 4, Acute change) 2+ 2++ (4AT) was developed, validated and widely implemented in Scotland in non-ICU settings. It does 2+ not require specific training, is brief and easy to use and has wide applicability in various clinical settings.24,25 It performed well for sensitivity and patient completion rate compared to other similar tools within the same patient group.20,26 The 4AT is also applicable as an assessment tool in older emergency department attendees.27 Other tools had significant disadvantages over CAM and 4AT, such as longer assessment time, poorer sensitivity and/or specificity, and/or relative lack of validation in published studies (see Table 1).",
       "highlight": "The 4AT is also applicable as an assessment tool in older emergency department attendees",
       "scope": "on-scope",
       "note": "Explicitly extends 4AT applicability to older ED attendees.",
       "page": "6",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "The CAM-ICU has particularly broad use within ICU settings but has the same limitations.",
       "highlight": "particularly broad use within ICU settings",
       "scope": "different-setting",
       "note": "Names CAM-ICU as an ICU-setting screening tool, a nearest match on tool names but a different care setting than the ED pathways the claim lists, not part of the ED menu.",
       "page": "6",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "partial",
     "note": "Endorses the 4AT for delirium assessment across hospital/long-term-care settings (not ED-specific); reserves CAM-ICU/ICDSC for critical care.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "competent to do so should carry out an assessment using the 4AT. In critical care or in the recovery room after surgery use the Confusion Assessment Method for the Intensive Care Unit (CAM-ICU) or Intensive Care Delirium Screening Checklist (ICDSC) instead of the 4AT.",
       "highlight": "carry out an assessment using the 4AT",
       "scope": "on-scope",
       "note": "Recommendation 1.6.1 directs assessment using the 4AT when delirium is indicated, supporting the 4AT option; NICE spans hospital and long-term care rather than the ED specifically.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Balancing the evidence for accuracy and cost effectiveness with the practicality of implementing the tests, the committee agreed that the 4AT was the best option for most settings. It is among the most accurate of the tools reviewed, quick and simple to use, and has a broader range of evidence to support it.",
       "highlight": "the 4AT was the best option for most settings",
       "scope": "on-scope",
       "note": "Committee judged the 4AT the best option for most settings.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "For critical care and post-surgical settings, the Confusion Assessment Method for the Intensive Care Unit (CAM-ICU) and Intensive Care Delirium Screening Checklist (ICDSC) worked best because they were specifically designed for those settings. However, the committee noted that training is needed for both CAM-ICU and ICDSC before practitioners can use them.",
       "highlight": "worked best because they were specifically designed for those settings",
       "scope": "different-setting",
       "note": "Reserves CAM-ICU/ICDSC for critical care and post-surgical settings, a nearest match on tool names but a different setting.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ED-specific guidance endorsing the sensitive DTS screen confirmed by the bCAM/CAM (the two-step pathway); does not cover the 4AT.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "The Delirium Triage Screen (Figure 2) can be rapidly administered, does not require collateral information, and is very sensitive, so it functions well as a screening tool.",
       "highlight": "is very sensitive, so it functions well as a screening tool",
       "scope": "on-scope",
       "note": "The DTS is rapid and sensitive, functioning as the screening step in the ED.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "attention. A positive Delirium Triage Screen result should trigger confirmation with a test that is more specific, such as the Confusion Assessment Method or Brief Confusion Assessment Method (Table 2).16-18 A patient is delirious if he or she has acute onset or fluctuating course, inattention, and either disorganized thinking or altered level of consciousness.",
       "highlight": "such as the Confusion Assessment Method or Brief Confusion Assessment Method",
       "scope": "on-scope",
       "note": "A positive DTS should trigger confirmation with the CAM or bCAM, the two-step DTS-to-bCAM pathway.",
       "page": "ms. p.5",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "background",
     "note": "Predates the DTS/bCAM/4AT; establishes why to screen (ED delirium predicts 6-month mortality) and the high-risk-targeting concept, but using the CAM/CAM-ICU.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": [
      {
       "context": "demanding ED environment.46 Performing the CAM in high risk patients only (dementia, functional impairment, hearing impairment, or nursing home residence) may improve screening efficiency.2, 9 The CAM-ICU may be a more suitable alternative because it takes less than 2 minutes to perform, is highly reliable in physicians and nurses, is easy to use, and requires minimal training.",
       "highlight": "Performing the CAM in high risk patients only (dementia, functional impairment, hearing impairment, or nursing home residence) may improve screening efficiency",
       "scope": "different-intervention",
       "note": "The rationale behind targeting screening to high-risk patients (the bCAM-directly-in-high-risk idea), but using the older CAM rather than the pathway tools.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      },
      {
       "context": "Consequently, the Society for Academic Emergency Medicine Geriatrics Task Force recently recommended that delirium surveillance in the ED be a key quality indicator for emergency geriatric care.43 Because the majority of delirium is the hypoactive \"quiet\" subtype,2 the clinical presentation can be subtle and is often missed without performing a delirium assessment.44 Currently, the Confusion Assessment Method (CAM) is the only delirium assessment validated for the ED setting.",
       "highlight": "delirium surveillance in the ED be a key quality indicator for emergency geriatric care",
       "scope": "background",
       "note": "Frames ED delirium surveillance as a key quality indicator, supporting screening every older adult (the section premise), not a specific pathway.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    }
   ],
   "synthesis": "The ED-specific sources agree that all three are valid screening pathways: GED Guidelines 2.0 (the current GRADE-based ED guideline, which governs) endorses the 4AT and bCAM to rule delirium in or out and the DTS to rule out, Han 2013 and ADEPT 2020 validate the two-step DTS-to-bCAM (and using the bCAM alone), and the 4AT instrument plus SIGN 157 and NICE CG103 support the 4AT option. The discrepancy flag reflects nearest-match rather than contradictory content: SIGN and NICE reserve CAM-ICU/ICDSC for the ICU/critical-care setting, and Han 2010 speaks to high-risk-targeted CAM screening with an older instrument.",
   "discrepancy": true
  },
  {
   "id": "ed-wf-r5",
   "toolId": "ed-wf",
   "tool": "ED Workflow",
   "page": "1",
   "section": "2 · Arousal — the gate",
   "statement": "Score the RASS first. Any RASS other than 0 is altered arousal.",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "4AT v1.2",
    "GED Guidelines 2.0 (2026)",
    "SIGN 157",
    "NICE CG103",
    "ADEPT (2020)",
    "Han 2010"
   ],
   "anchor": "Han 2013 (DTS/bCAM) — p. 4",
   "passage": "… We limited the recitation to 6 months so that brevity, reliability, and feasibility could be maximized. Because some patients would occasionally perseverate on specific months, the assessment was stopped after a 15 second break (i.e. pause or repetition of a month) in order to minimize the time spent on this task. Similar to the CAM-ICU, altered level of consciousness (feature 3) was determined by the RASS and disorganized thinking (feature 4) was determined by asking the patient four yes/no questions and to follow a simple command. If the RASS was other than 0 (alert, normal level of consciousness) then the patient was considered to have altered level of consciousness. If the patient made any errors (as opposed to > 1 error in the CAM-ICU) in the disorganized thinking assessment, then he/ she was considered to be positive for feature 4. A physician and a RA performed the DTS and bCAM concurrently. The physician was board-certified in emergency medicine and had experience in performing the CAM-ICU, but no other formal instruction on performing mental status assessments on elders. RAs had diverse backgrounds consisting of college graduates, basic emergency medical technicians, Han et al. Page 4 Ann Emerg Med. Author manuscript; available in PMC 2014 November 01. NIH-PA Author Manuscript NIH-PA Author Manuscript NIH-PA Author Manuscript\nHan 2013 also supports scoring the RASS first — the DTS lists level of consciousness (RASS) as its first component — and GED Guidelines 2.0 corroborates the diagnostic value of an mRASS other than 0.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
    "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.the4at.com/",
    "https://doi.org/10.1111/acem.70167",
    "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
    "https://www.nice.org.uk/guidance/cg103",
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://doi.org/10.1016/j.annemergmed.2010.03.003"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "The DTS (Figure 1) was designed to be very brief (<20 seconds) so that it could be easily integrated into the clinical workflow. The DTS consists consisted of two components: 1) Level of consciousness - measuring the Richmond Agitation Sedation Scale (RASS) and 2) Attention - spelling the word \"LUNCH\" backwards. The RASS is an arousal scale commonly used in the intensive care unit to assess level of sedation. It ranges from -5 (unarousable) to +4 (combative), and 0 indicates a normal level of alertness.25 Spelling a word backwards is commonly used to assess for inattention.26 If a patient had a RASS other than 0, or made >1 error on the \"LUNCH\" backwards spelling test, then the DTS was considered positive.",
       "highlight": "If a patient had a RASS other than 0",
       "scope": "on-scope",
       "note": "Defines the DTS: component 1 is level of consciousness measured by the RASS (scored first), and a RASS other than 0 makes the screen positive — directly supports scoring RASS first and treating any non-zero RASS as altered arousal.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "command. If the RASS was other than 0 (alert, normal level of consciousness) then the patient was considered to have altered level of consciousness. If the patient made any errors (as opposed to > 1 error in the CAM-ICU) in the disorganized thinking assessment, then he/ she was considered to be positive for feature 4.",
       "highlight": "If the RASS was other than 0 (alert, normal level of consciousness) then the patient was considered to have altered level of consciousness",
       "scope": "on-scope",
       "note": "States the numeric rule explicitly: any RASS other than 0 counts as altered level of consciousness/arousal.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "Both assessments use the Richmond Agitation Sedation Scale (RASS), which assesses for arousal and ranges from -5 (coma) to +4 (combative);25 a score of 0 indicates normal level of consciousness.",
       "highlight": "which assesses for arousal and ranges from -5 (coma) to +4 (combative)",
       "scope": "on-scope",
       "note": "Figure 1 legend confirms the RASS assesses arousal with 0 as the normal baseline, so any other score is altered arousal.",
       "page": "ms. p.12",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "partial",
     "note": "Nearest match by concept but a different instrument.",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": [
      {
       "context": "Alertness: Altered level of alertness is very likely to be delirium in general hospital settings. If the patient shows significant altered alertness during the bedside assessment, score 4 for this item. AMT4 (Abbreviated Mental Test - 4): This score can be extracted from items in the AMT10 if the latter is done immediately before. Acute Change or Fluctuating Course: Fluctuation can occur without delirium in some cases of dementia, but marked fluctuation usually indicates delirium. To help elicit any hallucinations and/or paranoid thoughts ask the patient questions such as, \"Are you concerned about anything going on here?\"; \"Do you feel frightened by anything or anyone?\"; \"Have you been seeing or hearing anything unusual?\"",
       "highlight": "Altered level of alertness is very likely to be delirium in general hospital settings",
       "scope": "different-intervention",
       "note": "The 4AT also gates on alertness as its first item ([1] ALERTNESS) but scores its own Alertness item (0 or 4) in general hospital settings, not the RASS — it corroborates the arousal-first-gate principle through a different tool, not the RASS≠0 rule.",
       "page": "",
       "docUrl": "https://www.the4at.com/"
      }
     ]
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": [
      {
       "context": "center study (n=406) in which ED clinicians accurately rule in delirium (LR+ 19.9 [95% CI 12-33]) and rule out (LR- 0.17 [95% CI 0.09-0.32]) delirium using bCAM [91]. CAM- ICU was also reported in a single center study (n=406) [91] in which ED clinicians accurately rule in delirium (LR+ 51.3 [95% CI 21-125]) and to a lesser extent rule out (LR- 0.28 [95% CI 0.18-0.44]) delirium. mCAM was also evaluated in a single ED setting (n=286) [103] and ED clinicians accurately rule in (LR+ 39.9 [95% CI 19-60]) and rule out (LR- 0.1 [95% CI 0.02-0.30]) delirium by using mCAM. Han et al. (n=406) evaluated the use of RASS score for delirium detection. ED physicians accurately ruled in (LR+ 5.5 [95% CI 4-7]) and ruled out (LR- 0.21 [95% CI 0.12-0.38]) delirium [18, 22, 91]. Furthermore, Grossman found that among 285 patients, LR+ 10.31 (95% CI 6.06; 17.51), LR- 0.32 (95% CI 0.16; 0.63) for mRASS other than 0 when tested by trained nurses [113].",
       "highlight": "for mRASS other than 0 when tested by trained nurses",
       "scope": "on-scope",
       "note": "In older ED patients, endorses RASS for delirium detection and cites the mRASS-other-than-0 cutpoint (Grossmann), matching the claim's threshold and population.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "Recommendation #4: In older adults in the ED, 4AT, bCAM, CAM‐ICU, mCAM, AMT‐4, or RASS may be used to rule in or rule out delirium (Conditional, FOR) [Very low certainty of evidence].",
       "highlight": "or RASS may be used to rule in or rule out delirium (Conditional, FOR)",
       "scope": "broader",
       "note": "Recommendation #4 lists RASS among several acceptable ED delirium tools — supports using RASS in the ED gate but as a menu of tools rather than the specific score-first / RASS≠0 rule.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      }
     ]
    },
    {
     "label": "SIGN 157",
     "cite": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
     "paragraphs": [
      {
       "context": "The main features of delirium are acute cognitive deficits and altered level of arousal, with up to half of patients also experiencing hallucinations or delusions.3 Delirium varies in duration, mostly resolving within days, but in some people it can last weeks or months.4 Delirium is among the most common of medical emergencies.",
       "highlight": "The main features of delirium are acute cognitive deficits and altered level of arousal",
       "scope": "background",
       "note": "Hospital-wide (non-ED-specific) guideline; names altered level of arousal as a core delirium feature but does not define a RASS-scored-first gate — mRASS appears only as a monitoring tool.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "A person may already have delirium when they present to hospital or long-term care or it may develop during a hospital admission or residential stay in long-term care. Delirium can be hypoactive or hyperactive but some people show signs of both (mixed). People with hyperactive delirium have heightened arousal and can be restless, agitated and aggressive. People with hypoactive delirium become withdrawn, quiet and sleepy. Hypoactive and mixed delirium can be more difficult to recognise.",
       "highlight": "People with hyperactive delirium have heightened arousal",
       "scope": "different-setting",
       "note": "Hospital and long-term-care guidance references arousal only to distinguish hyperactive vs hypoactive subtypes; it does not use the RASS or an arousal-scored-first ED gate.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "The Delirium Triage Screen (Figure 2) can be rapidly administered, does not require collateral information, and is very sensitive, so it functions well as a screening tool.",
       "highlight": "The Delirium Triage Screen (Figure 2) can be rapidly administered",
       "scope": "on-scope",
       "note": "ADEPT's rapid, sensitive Delirium Triage Screen is the ED arousal-first screen; its formal arousal (RASS) assessment is detailed in the tool's Figure 2, corroborating the arousal-first gate without restating the RASS-0 cut.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": [
      {
       "context": "Delirium was assessed using the Confusion Assessment Method for the Intensive Care Unit (CAM-ICU). The CAM-ICU was chosen because of its brevity (< two minutes), ease of use, and excellent interrater reliability.14 This delirium assessment uses the exact same construct as the Confusion Assessment Method (CAM) and utilizes four features: 1) acute onset of mental status changes or a fluctuating course, 2) inattention, 3) disorganized thinking, and 4) altered level of consciousness.15 Like the CAM, a patient must possess both features 1 and 2, and either 3 or 4 in order to meet criteria for delirium. The CAM-ICU has been validated in both mechanically ventilated and non-mechanically ventilated patients. This assessment is highly sensitive (93% - 100%) and specific (89% - 100%), and has excellent interrater reliability between physicians and nurses (kappa = 0.84 - 0.96).14, 16 Because the CAMICU's ease of use and excellent interrater reliability in non-physicians, no reliability testing was performed during the study.",
       "highlight": "4) altered level of consciousness",
       "scope": "different-intervention",
       "note": "This ED mortality study uses the CAM-ICU, not the DTS/RASS gate; 'altered level of consciousness' is CAM-ICU feature 4 — a nearest keyword match but not the RASS-scored-first arousal rule.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    }
   ],
   "synthesis": "Han 2013 governs and directly supports the claim: the Delirium Triage Screen scores the RASS (arousal) as its first component, and any RASS other than 0 is treated as altered level of consciousness/arousal; ADEPT (also ED) and GED Guidelines 2.0 — which cites the mRASS-other-than-0 cutpoint in older ED patients — corroborate on-scope. The nearest matches differ in scope and must not be read as direct support for the RASS≠0 rule: the 4AT gates on its own Alertness item rather than RASS, while SIGN 157, NICE CG103, and Han 2010 describe altered arousal or use other instruments (CAM-ICU) without defining the RASS-scored-first ED gate.",
   "discrepancy": true
  },
  {
   "id": "ed-wf-r6",
   "toolId": "ed-wf",
   "tool": "ED Workflow",
   "page": "1",
   "section": "2 · Arousal — the gate",
   "statement": "RASS −4 / −5 → stupor / coma — record “unable to assess”; reassess when the patient responds to voice.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "4AT v1.2",
    "GED Guidelines 2.0 (2026)",
    "SIGN 157",
    "NICE CG103",
    "ADEPT (2020)",
    "Han 2010"
   ],
   "anchor": "GED Guidelines 2.0 (2026) — p. 2",
   "passage": "… It is characterized by the following diagnostic criteria 1. A disturbance in attention (i.e., reduced ability to direct, focus, sustain, and shift attention) accompanied by reduced awareness of the environment. 2. Develops over a short period of time (usually hours to a few days), represents an acute change from baseline, and tends to fluctuate in severity during the course of the day. 3. An additional disturbance in cognition (e.g., memory deficit, disorientation, language, visuospatial ability, or perception). 4. The disturbances in attention and cognition are not better explained by another preexisting, established, or evolving neurocognitive disorder and do not occur in the context of a severely reduced level of arousal, such as coma. 5. There is evidence from the history, physical examination, or laboratory findings that the disturbance is a direct physiological consequence of another medical condition, substance intoxication or withdrawal (e.g., due to a drug of abuse or a medication), exposure to a toxin, or is due to multiple etiologies. 15532712, 2026, 2, Downloaded from https://onlinelibrary.wiley.com/doi/10.1111/acem.70167, Wiley Online Library on [02/07/2026]. See the Terms and Conditions (https://onlinelibrary.wiley.com/terms-and-conditions) on Wiley Online Library for rules of use; OA articles are governed by the applicable Creative Commons License\nAlso Han 2013 (DTS/bCAM): \"It ranges from −5 (unarousable) to +4 (combative), and 0 indicates a normal level of alertness.\"\nGED Guidelines 2.0, via the DSM-5 criteria, establishes that delirium cannot be diagnosed in severely reduced arousal or coma, and Han 2013 defines RASS −5 as unarousable. The instruction to record 'unable to assess' and reassess when the patient responds to voice reflects standard CAM-ICU/bCAM practice and is not stated in the cited ED sources.",
   "evidence": "Full text, p. 2 — partial support",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
    "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.the4at.com/",
    "https://doi.org/10.1111/acem.70167",
    "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
    "https://www.nice.org.uk/guidance/cg103",
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://doi.org/10.1016/j.annemergmed.2010.03.003"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Source of the RASS arousal scale used in the ED tool; defines the -5 = coma/unarousable end and puts arousal (RASS) first in the DTS/bCAM.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "The DTS (Figure 1) was designed to be very brief (<20 seconds) so that it could be easily integrated into the clinical workflow. The DTS consists consisted of two components: 1) Level of consciousness - measuring the Richmond Agitation Sedation Scale (RASS) and 2) Attention - spelling the word \"LUNCH\" backwards. The RASS is an arousal scale commonly used in the intensive care unit to assess level of sedation. It ranges from -5 (unarousable) to +4 (combative), and 0 indicates a normal level of alertness.25 Spelling a word backwards is commonly used to assess for inattention.26 If a patient had a RASS other than 0, or made >1 error on the \"LUNCH\" backwards spelling test, then the DTS was considered positive.",
       "highlight": "It ranges from -5 (unarousable) to +4 (combative), and 0 indicates a normal level of alertness",
       "scope": "on-scope",
       "note": "Defines the RASS arousal scale the ED tool relies on, anchoring the -4/-5 = stupor/coma end of the range.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "Both assessments use the Richmond Agitation Sedation Scale (RASS), which assesses for arousal and ranges from -5 (coma) to +4 (combative);25 a score of 0 indicates normal level of consciousness.",
       "highlight": "ranges from -5 (coma) to +4 (combative)",
       "scope": "on-scope",
       "note": "Figure 1 caption maps RASS -5 to coma; the DTS measures arousal (RASS) as step 1, matching the arousal-gate structure.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "partial",
     "note": "Nearest match on arousal but a different tool/setting: the 4AT scores altered arousal toward delirium rather than recording 'unable to assess.'",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": [
      {
       "context": "This includes patients who may be markedly drowsy (eg. difficult to rouse and/or obviously sleepy during assessment) or agitated/hyperactive. Observe the patient. If asleep, attempt to wake with speech or gentle touch on shoulder. Ask the patient to state their name and address to assist rating.",
       "highlight": "If asleep, attempt to wake with speech or gentle touch on shoulder",
       "scope": "different-intervention",
       "note": "The 4AT rouses with speech and rates alertness, but a markedly drowsy patient is scored as abnormal, not deferred as 'unable to assess.'",
       "page": "",
       "docUrl": "https://www.the4at.com/"
      },
      {
       "context": "Alertness: Altered level of alertness is very likely to be delirium in general hospital settings. If the patient shows significant altered alertness during the bedside assessment, score 4 for this item. AMT4 (Abbreviated Mental Test - 4): This score can be extracted from items in the AMT10 if the latter is done immediately before. Acute Change or Fluctuating Course: Fluctuation can occur without delirium in some cases of dementia, but marked fluctuation usually indicates delirium. To help elicit any hallucinations and/or paranoid thoughts ask the patient questions such as, \"Are you concerned about anything going on here?\"; \"Do you feel frightened by anything or anyone?\"; \"Have you been seeing or hearing anything unusual?\"",
       "highlight": "If the patient shows significant altered alertness during the bedside assessment, score 4 for this item",
       "scope": "different-intervention",
       "note": "General-hospital tool that scores reduced arousal as delirium-likely (score 4) — a different handling and setting than the ED arousal gate that defers assessment.",
       "page": "",
       "docUrl": "https://www.the4at.com/"
      }
     ]
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary anchor (p.2): reproduces the DSM-5-TR coma exclusion and frames RASS/level-of-consciousness as the essential first assessment.",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": [
      {
       "context": "4. The disturbances in attention and cognition are not better explained by another preexisting, established, or evolving neurocognitive disorder and do not occur in the context of a severely reduced level of arousal, such as coma.",
       "highlight": "do not occur in the context of a severely reduced level of arousal, such as coma",
       "scope": "on-scope",
       "note": "DSM-5-TR criterion (Table 1, p.2): coma / severely reduced arousal precludes a delirium diagnosis — the rationale for recording 'unable to assess' at RASS -4/-5.",
       "page": "2",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "The inclusion of RASS as a delirium diagnosis tool, although only focusing on the level of consciousness, addresses several shortcomings of traditional tools, such as language barrier, time for completion, and requiring additional collateral history which may not be available. In addition, the assessment of the level of consciousness is an essential part of several other tools, such as 4AT, bCAM, CAM‐ICU, and mCAM.",
       "highlight": "the assessment of the level of consciousness is an essential part of several other tools",
       "scope": "on-scope",
       "note": "Level-of-consciousness (RASS) assessment is the essential first step across ED delirium tools, supporting arousal as the gate.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      }
     ]
    },
    {
     "label": "SIGN 157",
     "cite": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
     "kind": "pdf",
     "stance": "partial",
     "note": "General national guideline: supports the coma exclusion (broader setting) and, in a sedation-drug context, maps RASS 0 to -3 as arousable to voice.",
     "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
     "paragraphs": [
      {
       "context": "According to the Diagnostic and Statistical Manual of Mental Disorders, fifth edition (DSM-5), delirium is a disturbance in attention and awareness with an additional disturbance in cognition, not explained by another pre-existing, established or evolving neurocognitive disorder or coma. The disturbance develops over a short period of time and tends to fluctuate in severity during the course of the day with evidence of direct physiological consequence of another medical condition, substance intoxication or withdrawal, or exposure to a toxin, or is due to multiple aetiologies. It's specified as `acute', lasting a few hours or days and `persistent', lasting weeks or months.13 Delirium presents variably but its main characteristics are rapid onset (hours, days) of acute mental status deterioration.",
       "highlight": "not explained by another pre-existing, established or evolving neurocognitive disorder or coma",
       "scope": "broader",
       "note": "DSM-5 coma exclusion (coma is not delirium) stated for a whole-hospital audience across all settings, not the ED workflow specifically.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "In May 2012 the SMC accepted dexmedetomidine hydrochloride for sedation in adult patients in intensive care unit requiring a sedation level not deeper than arousal in response to verbal stimulation (corresponding to RASS 0 to -3).",
       "highlight": "arousal in response to verbal stimulation (corresponding to RASS 0 to -3)",
       "scope": "different-intervention",
       "note": "Stated as a dexmedetomidine sedation indication, but operationalizes RASS 0 to -3 as arousable to voice — implying -4/-5 is not, consistent with 'reassess when the patient responds to voice.'",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Recommends the 4AT (and CAM-ICU/ICDSC in critical care) for delirium assessment but does not address a RASS-based arousal gate or an 'unable to assess' rule for deeply sedated/comatose patients.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": []
    },
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ED-setting review confirming the DTS opens with a formal arousal assessment; supports arousal as the gate without specifying the -4/-5 unable-to-assess rule.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "The Delirium Triage Screen (Figure 2) can be rapidly administered, does not require collateral information, and is very sensitive, so it functions well as a screening tool.",
       "highlight": "The Delirium Triage Screen (Figure 2) can be rapidly administered",
       "scope": "on-scope",
       "note": "ADEPT uses the rapid Delirium Triage Screen as the arousal-first ED screen, corroborating that arousal is the gate; it does not state the RASS -4/-5 'unable to assess' rule verbatim.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Most direct on-scope statement of the arousal gate in older ED patients; governs the claim.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": [
      {
       "context": "Comatose patients were excluded because a patient must be arousable to verbal stimuli in order to assess for delirium.",
       "highlight": "a patient must be arousable to verbal stimuli in order to assess for delirium",
       "scope": "on-scope",
       "note": "States plainly that a comatose patient (not arousable to voice) cannot be assessed for delirium; assessment requires arousability to verbal stimuli — the exact gate the claim encodes.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    }
   ],
   "synthesis": "The on-scope emergency-department sources agree: Han 2010 states directly that a patient must be arousable to verbal stimuli to assess for delirium (comatose patients are excluded), and the GED 2.0 DSM-5-TR criterion on p.2 confirms delirium cannot be diagnosed under severely reduced arousal such as coma; Han 2013 defines RASS -5 as coma/unarousable and ADEPT shows the DTS begins with a formal arousal assessment — together supporting \"RASS -4/-5 → record unable to assess, reassess when the patient responds to voice,\" with Han 2010 governing as the most direct on-scope statement. The nearest different-scope matches — the 4AT alertness item (a general-hospital tool that scores reduced arousal as delirium-likely rather than deferring) and SIGN 157's RASS 0-to-3 verbal-response mapping (stated for dexmedetomidine sedation) — are consistent but must not be read as the ED gate itself, and NICE CG103 does not address it.",
   "discrepancy": true
  },
  {
   "id": "ed-wf-r7",
   "toolId": "ed-wf",
   "tool": "ED Workflow",
   "page": "1",
   "section": "3 · Screen & confirm",
   "statement": "DTS (<20 s): altered arousal, ≥ 2 errors spelling LUNCH backwards, or unable / refused → positive → confirm with the bCAM.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "4AT v1.2",
    "GED Guidelines 2.0 (2026)",
    "SIGN 157",
    "NICE CG103",
    "ADEPT (2020)",
    "Han 2010"
   ],
   "anchor": "Han 2013 (DTS/bCAM) — p. 4",
   "passage": "approached those who met inclusion criteria and determined if any exclusion criteria were present. If none of the exclusion criteria were met, then the patient was considered eligible for enrollment. Methods of Measurement The DTS (Figure 1) was designed to be very brief (<20 seconds) so that it could be easily integrated into the clinical workflow. The DTS consists consisted of two components: 1) Level of consciousness - measuring the Richmond Agitation Sedation Scale (RASS) and 2) Attention - spelling the word \"LUNCH\" backwards. The RASS is an arousal scale commonly used in the intensive care unit to assess level of sedation. It ranges from -5 (unarousable) to +4 (combative), and 0 indicates a normal level of alertness.25 Spelling a word backwards is commonly used to assess for inattention.26 If a patient had a RASS other than 0, or made >1 error on the \"LUNCH\" backwards spelling test, then the DTS was considered positive. The bCAM (Figure 1) was a modification of the CAM-ICU,27 both of which were progeny of the Confusion Assessment Method (CAM) developed by Inouye et al.28 The CAM-ICU takes a median of 55 seconds to complete.29 It is over 90% sensitive and specific in critically ill patients but it has not been validated in older ED patients.27, 30 Based upon our previous experience,13 the bCAM was developed to improve the CAM-ICU's sensitivity and enhance its brevity. Similar to the CAM-ICU, the bCAM had four features: 1) altered mental status or fluctuating course, 2) inattention, 3) altered level of consciousness, and 4) disorganized thinking. …\nHan 2013 supports the timing, the altered-arousal criterion, the '>1 error' (i.e., ≥2 errors) threshold, and a positive DTS triggering a bCAM assessment. The 'unable/refused' option appears on the DTS form itself rather than in the cited sources.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
    "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.the4at.com/",
    "https://doi.org/10.1111/acem.70167",
    "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
    "https://www.nice.org.uk/guidance/cg103",
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://doi.org/10.1016/j.annemergmed.2010.03.003"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary source; defines the DTS positivity criteria, the <20 s screen, and the positive-DTS -> bCAM confirmation flow.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "If a patient had a RASS other than 0, or made >1 error on the \"LUNCH\" backwards spelling test, then the DTS was considered positive.",
       "highlight": "If a patient had a RASS other than 0, or made >1 error on the \"LUNCH\" backwards spelling test, then the DTS was considered positive.",
       "scope": "on-scope",
       "note": "Core definition: a positive DTS is altered arousal (RASS other than 0) or >1 error (>=2 errors) spelling LUNCH backwards, which then triggers the confirmatory bCAM.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "Step 1 (DTS) can be integrated into the nurses' triage assessment. If the DTS result is negative, then delirium is ruled out and no additional testing is needed. If the DTS result is positive, then a confirmatory delirium assessment such as the bCAM should be performed.",
       "highlight": "If the DTS result is positive, then a confirmatory delirium assessment such as the bCAM should be performed.",
       "scope": "on-scope",
       "note": "Figure 1 flow: a positive DTS triggers confirmation with the bCAM, exactly the claim's 'positive -> confirm with the bCAM'.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "One method to improve delirium detection would be to use a two-step approach: a sequential testing strategy that utilizes brief, valid, and reliable delirium assessments that can be performed by healthcare professionals of all clinical backgrounds. The first step would be to perform a very brief (<20 seconds), highly sensitive delirium screen to rule-out delirium. This rapid rule-out screen can be incorporated into the ED triage assessment or can be part of the initial nursing assessment after the patient has been placed in an ED bed. A negative screen would rule out delirium, reduce the number of formal delirium assessments needed, and enhance screening efficiency. A positive screen would trigger a formal delirium assessment performed by another health care provider (i.e., physician) at the patient's bedside that would be highly specific to rule-in delirium. Ideally, this rule-in assessment should be brief (<1 minute) to maximize feasibility. We developed Delirium Triage Screen (DTS) and the Brief Confusion Assessment Method (bCAM) to serve as the rule-out and rule-in tests for the two-step approach to delirium surveillance (Figure 1), respectively.",
       "highlight": "A positive screen would trigger a formal delirium assessment",
       "scope": "on-scope",
       "note": "States the two-step design: a brief highly-sensitive screen whose positive result prompts a more specific rule-in assessment.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "July to assess for inattention (feature 2).31-33 If the patient made >1 error, or was unable or refused to perform the task, then he/she was considered to be positive for inattention. We limited the recitation to 6 months so that brevity, reliability, and feasibility could be maximized.",
       "highlight": "was unable or refused to perform the task, then he/she was considered to be positive for inattention",
       "scope": "on-scope",
       "note": "Source of the 'unable or refused -> positive' wording; stated here for the bCAM (confirmatory step) months-backwards attention item, which the claim applies to the DTS attention component.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "background",
     "note": "Different rapid delirium instrument; does not mention the DTS or bCAM (cited as the nearest-analog screening tool).",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": [
      {
       "context": "The 4AT is a screening instrument designed for rapid initial assessment of delirium and cognitive impairment. A score of 4 or more suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis.",
       "highlight": "suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis.",
       "scope": "different-intervention",
       "note": "A distinct single-step screen scored 0 / 1-3 / 4+ using an alertness item and months-backwards attention, not the DTS's LUNCH/arousal criteria or the DTS->bCAM two-step; nearest analog only.",
       "page": "",
       "docUrl": "https://www.the4at.com/"
      }
     ]
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "GRADE ED guideline endorsing the DTS as a rule-out screen in older ED adults (positive cannot rule in, so requires confirmation).",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": [
      {
       "context": "Recommendation #5: In older adults in the ED, DTS may be used to rule out delirium (Conditional, FOR) [Very low certainty of evidence].",
       "highlight": "DTS may be used to rule out delirium",
       "scope": "on-scope",
       "note": "Same population (older ED patients) and instrument (DTS): the guideline recommends the DTS for ruling out delirium.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "In older ED patients with suspected delirium, there is sufficient direct evidence to select delirium diagnostic instruments that accurately rule in (i.e., confirm) or rule out (i.e., exclude) delirium [ 22 ]. The 4AT had the largest quantity of ED‐based research and may be used to rule in or rule out delirium [ 90 ]. The CAM‐ICU, brief Confusion Assessment Method (bCAM), modified Confusion Assessment Method (mCAM) for the Emergency Department, AMT‐4, and Richmond Agitation and Sedation Scale (RASS) are superior to clinical gestalt [ 91 ], and may also be used to rule in or rule out delirium. The Delirium Triage Screen is superior to clinical gestalt in ruling out delirium [ 92 ] (Table 3 ).",
       "highlight": "The Delirium Triage Screen is superior to clinical gestalt in ruling out delirium",
       "scope": "on-scope",
       "note": "Confirms the DTS's role is ruling out; because it cannot accurately rule in (LR+ ~2.2), a positive result needs a confirmatory rule-in test.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      }
     ]
    },
    {
     "label": "SIGN 157",
     "cite": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
     "kind": "pdf",
     "stance": "background",
     "note": "Scottish national guideline for adults at risk of delirium; reviewed the B-CAM among many candidate tools but does not describe the DTS or the ED two-step screen.",
     "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
     "paragraphs": [
      {
       "context": "3.1 1. What tool(s) should be used to detect delirium and when?",
       "highlight": "What tool(s) should be used to detect delirium and when?",
       "scope": "broader",
       "note": "Lists the B-CAM (the claim's confirmatory tool) among 16 detection instruments reviewed for adults at risk of delirium generally; broader population/setting, does not address the DTS or the two-step flow.",
       "page": "34",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "background",
     "note": "Hospital/long-term-care guideline recommending the 4AT (CAM-ICU/ICDSC in critical care); does not mention the DTS or bCAM.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "competent to do so should carry out an assessment using the 4AT. In critical care or in the recovery room after surgery use the Confusion Assessment Method for the Intensive Care Unit (CAM-ICU) or Intensive Care Delirium Screening Checklist (ICDSC) instead of the 4AT.",
       "highlight": "should carry out an assessment using the 4AT",
       "scope": "different-intervention",
       "note": "Nearest match (which tool to assess suspected delirium) but recommends the 4AT in hospital/long-term care, adults 18+, not the DTS/bCAM ED two-step; different instrument and setting.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ED-focused tool that describes the DTS as a rapid arousal+attention screen and states a positive DTS should be confirmed with the CAM/bCAM.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "A positive Delirium Triage Screen result should trigger confirmation with a test that is more specific, such as the Confusion Assessment Method or Brief Confusion Assessment Method (Table 2).",
       "highlight": "A positive Delirium Triage Screen result should trigger confirmation with a test that is more specific",
       "scope": "on-scope",
       "note": "A positive Delirium Triage Screen triggers confirmation with a more specific test (the CAM or bCAM), matching the claim's screen-then-confirm flow.",
       "page": "ms. p.5",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "attention. A positive Delirium Triage Screen result should trigger confirmation with a test that is more specific, such as the Confusion Assessment Method or Brief Confusion Assessment Method (Table 2).16-18 A patient is delirious if he or she has acute onset or fluctuating course, inattention, and either disorganized thinking or altered level of consciousness.",
       "highlight": "such as the Confusion Assessment Method or Brief Confusion",
       "scope": "on-scope",
       "note": "Directly states a positive DTS should trigger confirmation with a more specific test such as the CAM or bCAM, mirroring the claim's confirm step.",
       "page": "ms. p.5",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "background",
     "note": "Same author/ED population but predates the DTS/bCAM (used CAM-ICU); establishes the need for rapid ED delirium screening without addressing the DTS.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": [
      {
       "context": "However, the CAM-ICU still requires validation in the ED setting and delirium screening strategies that maximize accuracy yet minimize burden to the ED staff must be developed. These studies are currently ongoing.",
       "highlight": "delirium screening strategies that maximize accuracy yet minimize burden to the ED staff must be developed",
       "scope": "background",
       "note": "Motivates a brief ED delirium screen (CAM/CAM-ICU era) but does not describe the DTS, its LUNCH/arousal criteria, or the DTS->bCAM two-step.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    }
   ],
   "synthesis": "The three on-scope emergency-department sources agree: Han 2013 (the governing primary source) defines the DTS as a <20 s screen that is positive on altered arousal (RASS other than 0) or >1 error (i.e., >=2 errors) spelling LUNCH backwards and routes a positive result to bCAM confirmation, while GED 2.0 and ADEPT corroborate the DTS as a rule-out-only screen whose positive result must trigger a more specific confirmatory test such as the bCAM. The \"unable/refused -> positive\" wording is stated in Han 2013 for the bCAM's months-backwards attention item and is reasonably extended to the DTS attention item; the 4AT, NICE CG103, and SIGN 157 describe different instruments/settings and Han 2010 predates the DTS, so they are nearest-match but different-scope rather than direct support.",
   "discrepancy": true
  },
  {
   "id": "ed-wf-r8",
   "toolId": "ed-wf",
   "tool": "ED Workflow",
   "page": "1",
   "section": "3 · Screen & confirm",
   "statement": "bCAM (<2 min): bCAM positive = Feature 1 + Feature 2 + (Feature 3 or Feature 4).",
   "contentType": "Validated instrument wording",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "4AT v1.2",
    "GED Guidelines 2.0 (2026)",
    "SIGN 157",
    "NICE CG103",
    "ADEPT (2020)",
    "Han 2010"
   ],
   "anchor": "Han 2013 (DTS/bCAM) — p. 4",
   "passage": "… The bCAM (Figure 1) was a modification of the CAM-ICU,27 both of which were progeny of the Confusion Assessment Method (CAM) developed by Inouye et al.28 The CAM-ICU takes a median of 55 seconds to complete.29 It is over 90% sensitive and specific in critically ill patients but it has not been validated in older ED patients.27, 30 Based upon our previous experience,13 the bCAM was developed to improve the CAM-ICU's sensitivity and enhance its brevity. Similar to the CAM-ICU, the bCAM had four features: 1) altered mental status or fluctuating course, 2) inattention, 3) altered level of consciousness, and 4) disorganized thinking. A patient was considered to be delirious if both features 1 (altered mental status or fluctuating course) and feature 2 (inattention) were present, and either feature 3 (altered level of consciousness) or feature 4 (disorganized thinking) were present. Feature 1 was the same as the CAM-ICU and was positive if the patient had altered mental status or a fluctuating course. This feature was primarily determined by surrogate interview in the ED or by phone. If the patient was from a nursing home, then the nursing home nurse was contacted. If the patient lived alone at home and no collateral history was available, then the medical record was reviewed to help determine the patient's baseline mental status. …\nThe '<2 min' timing is not given a precise figure in Han 2013 — the bCAM was designed for brevity against the CAM-ICU's ~55-second median, and GED Guidelines 2.0 notes such instruments take under 5 minutes — so the printed timing is approximate.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
    "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.the4at.com/",
    "https://doi.org/10.1111/acem.70167",
    "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
    "https://www.nice.org.uk/guidance/cg103",
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://doi.org/10.1016/j.annemergmed.2010.03.003"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "The bCAM (Figure 1) was a modification of the CAM-ICU,27 both of which were progeny of the Confusion Assessment Method (CAM) developed by Inouye et al.28 The CAM-ICU takes a median of 55 seconds to complete.29 It is over 90% sensitive and specific in critically ill patients but it has not been validated in older ED patients.27, 30 Based upon our previous experience,13 the bCAM was developed to improve the CAM-ICU's sensitivity and enhance its brevity. Similar to the CAM-ICU, the bCAM had four features: 1) altered mental status or fluctuating course, 2) inattention, 3) altered level of consciousness, and 4) disorganized thinking. A patient was considered to be delirious if both features 1 (altered mental status or fluctuating course) and feature 2 (inattention) were present, and either feature 3 (altered level of consciousness) or feature 4 (disorganized thinking) were present.",
       "highlight": "A patient was considered to be delirious if both features 1 (altered mental status or fluctuating course) and feature 2 (inattention) were present, and either feature 3 (altered level of consciousness) or feature 4 (disorganized thinking) were present.",
       "scope": "on-scope",
       "note": "Primary source; defines the bCAM-positive algorithm exactly as the claim states — features 1 and 2 both present plus either feature 3 or feature 4.",
       "page": "ms. p.4",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "The DTS is analogous to D-dimer (highly sensitive) which was intended to reduce computed tomography pulmonary angiography (highly specific) use for pulmonary embolism diagnosis. A negative DTS can potentially reduce the number of formal delirium assessments needed by 50%, while a positive DTS would require a more specific rule-in test. We developed the bCAM to be a brief (<1 minute) rule-in test. If performed in an algorithmic fashion (i.e. stopping if the patient can recite the months backwards with 1 errors), then the bCAM would take even less time which may be appealing for many clinical environments. The bCAM, however, missed subtler forms of inattention, and these patients required a more extensive psychiatrist evaluation than usually needed. The CAM, which has revolutionized delirium diagnosis for non-psychiatrists, can also potentially serve as the rule-in test for delirium. A recent meta-analysis reported it to be 86% sensitive and 93% specific.21 However, the CAM may take over 5 minutes to complete,41, 42 require significant training, and may have decreased diagnostic accuracy when used by non-physicians.22, 23 In addition to the dramatic effect that these instruments could have on the routine clinical practice, the availability of feasible assessments will open a new frontier to additional delirium investigations.",
       "highlight": "We developed the bCAM to be a brief (<1 minute) rule-in test.",
       "scope": "on-scope",
       "note": "Supports the tool's speed: bCAM was designed as a rule-in test taking under one minute, which is within the claim's <2-minute bound.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "A patient is delirious if he or she has acute onset or fluctuating course, inattention, and either disorganized thinking or altered level of consciousness.",
       "highlight": "A patient is delirious if he or she has acute onset or fluctuating course, inattention, and either disorganized thinking or altered level of consciousness.",
       "scope": "on-scope",
       "note": "ADEPT restates the bCAM positive rule as confirmation via the Confusion Assessment Method or Brief Confusion Assessment Method: acute onset or fluctuating course, inattention, and either disorganized thinking or altered level of consciousness.",
       "page": "ms. p.5",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": [
      {
       "context": "Recommendation #4: In older adults in the ED, 4AT, bCAM, CAM‐ICU, mCAM, AMT‐4, or RASS may be used to rule in or rule out delirium (Conditional, FOR) [Very low certainty of evidence].",
       "highlight": "may be used to rule in or rule out delirium",
       "scope": "broader",
       "note": "Current ED guideline endorses bCAM as one of several acceptable rule-in/rule-out instruments but does not restate the feature-combination algorithm itself.",
       "page": "8",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      }
     ]
    },
    {
     "label": "SIGN 157",
     "cite": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
     "kind": "pdf",
     "stance": "background",
     "note": "",
     "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
     "paragraphs": [
      {
       "context": "Population: Adults at risk of delirium Assessment tools: a. 4 As Test (Arousal, Attention, Abbreviated Mental Test 4, Acute change Test) (4AT) b. Confusion Assessment Method Instrument (CAM) c. 3D Confusion Assessment Method Instrument (3D-CAM) d. Delirium Observation Screening Scale (DOS) e. Single Question to Identify Delirium (SQID) f. Memorial Delirium Assessment Scale (MDAS) g. Recognizing Acute Delirium As part of your Routine (RADAR) h. Delirium Rating Scale - 98 - Revised (DRS-98-R) i. Intensive Care Delirium Screening Checklist (ICD-SC) j. CAM for the intensive care unit (CAM-ICU) k. Richmond agitation sedation score (RASS); Modified RASS l. Family Confusion Assessment Method Instrument (FAM-CAM) m. Brief Confusion Assessment Method Instrument (B-CAM) n. Nursing Delirium Screening Scale (Nu-DESC) o. Organic Brain Syndrome scale (OBS) p. Mini Mental State Examination Comparison: Diagnostic and Statistical Manual (DSM-5) or International Classification of Diseases (ICD-10) defined diagnosis; between tools Outcomes: Sensitivity, specificity, evidence of adherence in clinical practical 3.2, 3.3 2.What tool(s) should be used for monitoring purposes and when should they be used?",
       "highlight": "Brief Confusion Assessment Method Instrument (B-CAM)",
       "scope": "broader",
       "note": "UK national guideline lists B-CAM among the many delirium assessment tools it reviewed; it does not state the bCAM algorithm and is not ED-specific.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "competent to do so should carry out an assessment using the 4AT. In critical care or in the recovery room after surgery use the Confusion Assessment Method for the Intensive Care Unit (CAM-ICU) or Intensive Care Delirium Screening Checklist (ICDSC) instead of the 4AT.",
       "highlight": "carry out an assessment using the 4AT",
       "scope": "different-intervention",
       "note": "NICE recommends the 4AT (and CAM-ICU/ICDSC in critical care), not the bCAM, and never addresses the bCAM feature rule.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": [
      {
       "context": "Delirium was assessed using the Confusion Assessment Method for the Intensive Care Unit (CAM-ICU). The CAM-ICU was chosen because of its brevity (< two minutes), ease of use, and excellent interrater reliability.14 This delirium assessment uses the exact same construct as the Confusion Assessment Method (CAM) and utilizes four features: 1) acute onset of mental status changes or a fluctuating course, 2) inattention, 3) disorganized thinking, and 4) altered level of consciousness.15 Like the CAM, a patient must possess both features 1 and 2, and either 3 or 4 in order to meet criteria for delirium. The CAM-ICU has been validated in both mechanically ventilated and non-mechanically ventilated patients. This assessment is highly sensitive (93% - 100%) and specific (89% - 100%), and has excellent interrater reliability between physicians and nurses (kappa = 0.84 - 0.96).14, 16 Because the CAMICU's ease of use and excellent interrater reliability in non-physicians, no reliability testing was performed during the study.",
       "highlight": "Like the CAM, a patient must possess both features 1 and 2, and either 3 or 4 in order to meet criteria for delirium.",
       "scope": "different-intervention",
       "note": "States the identical 1+2+(3 or 4) combination rule, but for the CAM-ICU — the predecessor instrument this earlier ED study used — not the bCAM; shares the algorithm keywords under a different tool.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    },
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": [
      {
       "context": "4 or above: possible delirium +/- cognitive impairment 1-3: possible cognitive impairment 0: delirium or severe cognitive impairment unlikely (but delirium still possible if [4] information incomplete)",
       "highlight": "4 or above: possible delirium +/- cognitive impairment",
       "scope": "different-intervention",
       "note": "The 4AT is the paired alternative ED screen but scores by a summed 0-to-4+ threshold, not the bCAM feature-combination algorithm; nearest match on the screening topic under a different instrument.",
       "page": "",
       "docUrl": "https://www.the4at.com/"
      }
     ]
    }
   ],
   "synthesis": "Han 2013 (the primary source) defines the bCAM-positive algorithm verbatim — delirium requires features 1 and 2 plus either feature 3 or 4 — and the ED-focused ADEPT tool (Shenvi 2020) independently restates the same rule and times bCAM at about one minute, so the two on-scope sources agree and govern. The remaining sources are different-scope: GED Guidelines 2.0 and SIGN 157 endorse or review bCAM among a menu of tools without restating the feature rule, NICE CG103 recommends the 4AT (and CAM-ICU/ICDSC) rather than bCAM, the 4AT itself scores by a summed 0-4+ threshold, and Han 2010 states the identical 1+2+(3 or 4) rule but for the CAM-ICU predecessor — none contradict the claim.",
   "discrepancy": true
  },
  {
   "id": "ed-wf-r9",
   "toolId": "ed-wf",
   "tool": "ED Workflow",
   "page": "1",
   "section": "3 · Screen & confirm",
   "statement": "4AT: alertness + AMT4 + months-backward + acute change; ≥ 4 → possible delirium, 1–3 → possible cognitive impairment.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "4AT v1.2",
    "GED Guidelines 2.0 (2026)",
    "SIGN 157",
    "NICE CG103",
    "ADEPT (2020)",
    "Han 2010"
   ],
   "anchor": "4AT v1.2 — p. 1, ¶34",
   "passage": "4 or above: possible delirium +/- cognitive impairment 1-3: possible cognitive impairment 0: delirium or severe cognitive impairment unlikely (but delirium still possible if [4] information incomplete)\nThe instrument also confirms the four items: alertness, AMT4 (age, date of birth, place, current year), attention (months of the year backwards), and acute change or fluctuating course.",
   "evidence": "Full text, p. 1",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
    "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.the4at.com/",
    "https://doi.org/10.1111/acem.70167",
    "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
    "https://www.nice.org.uk/guidance/cg103",
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://doi.org/10.1016/j.annemergmed.2010.03.003"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "background",
     "note": "Validates the DTS/bCAM, a different two-step ED instrument; shares the months-backward keyword but is not the 4AT.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "Delirium is missed at an alarmingly high rate because healthcare professionals do not screen for it.2, 8-13 This compromise in the quality and safety of care occurs15 because brief (<1 minute) and easy to use delirium assessments are not readily available. This investigation provides a novel and simple two-step approach to delirium surveillance that is reliable, valid, and could significantly improve patient care and health outcomes. The DTS (spell \"LUNCH\" backwards) and bCAM (recite the months of the year backwards), when used sequentially, showed a very good sensitivity and excellent specificity. The DTS was highly sensitive with a negative likelihood ratio of 0.04; a negative DTS essentially ruled-out delirium. The bCAM was highly specific and those with a positive bCAM were 20 to 25 times more likely to have delirium than those with a negative bCAM. Furthermore, both these assessments can be reliably performed by healthcare professionals regardless of clinical background and experience. Though formal validation studies are needed, our subgroup analysis suggests that the DTS and bCAM may also have utility in the in-hospital setting where delirium is similarly missed; their diagnostic performances were similar in a subgroup of hospitalized non-ICU patients.",
       "highlight": "bCAM (recite the months of the year backwards)",
       "scope": "different-intervention",
       "note": "Describes the DTS/bCAM two-step screen, a different instrument than the 4AT even though bCAM also uses a months-backward inattention task.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "ICU,27 the bCAM simply asked the patient to recite months backwards from December to July to assess for inattention (feature 2).31-33 If the patient made >1 error, or was unable or refused to perform the task, then he/she was considered to be positive for inattention.",
       "highlight": "recite months backwards from December to July to assess for inattention",
       "scope": "different-intervention",
       "note": "bCAM's months-backward runs December-to-July (6 months) as feature 2 of the CAM; not the 4AT attention item, so it is a keyword match at a different scope.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The instrument itself: names the four items and states the score bands verbatim; directly and fully supports the claim.",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": [
      {
       "context": "A score of 4 or more suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis. A score of 1-3 suggests cognitive impairment and more detailed cognitive testing and informant history-taking are required.",
       "highlight": "A score of 4 or more suggests delirium but is not diagnostic",
       "scope": "on-scope",
       "note": "The scoring key in prose: >=4 suggests delirium, 1-3 suggests cognitive impairment.",
       "page": "1",
       "docUrl": "https://www.the4at.com/"
      },
      {
       "context": "Ask the patient: \"Please tell me the months of the year in backwards order, starting at December.\" To assist initial understanding one prompt of \"what is the month before December?\" is permitted.",
       "highlight": "Please tell me the months of the year in backwards order, starting at December",
       "scope": "on-scope",
       "note": "Item [3] ATTENTION is the months-of-the-year-backward task named in the claim.",
       "page": "1",
       "docUrl": "https://www.the4at.com/"
      },
      {
       "context": "Evidence of significant change or fluctuation in: alertness, cognition, other mental function (eg. paranoia, hallucinations) arising over the last 2 weeks and still evident in last 24hrs",
       "highlight": "Evidence of significant change or fluctuation in: alertness, cognition, other mental function",
       "scope": "on-scope",
       "note": "Item [4] ACUTE CHANGE OR FLUCTUATING COURSE -- the acute-change component of the claim.",
       "page": "1",
       "docUrl": "https://www.the4at.com/"
      },
      {
       "context": "Age, date of birth, place (name of the hospital or building), current year.",
       "highlight": "Age, date of birth, place (name of the hospital or building), current year",
       "scope": "on-scope",
       "note": "Item [2] AMT4 -- the abbreviated mental test 4 orientation component.",
       "page": "1",
       "docUrl": "https://www.the4at.com/"
      },
      {
       "context": "This includes patients who may be markedly drowsy (eg. difficult to rouse and/or obviously sleepy during assessment) or agitated/hyperactive. Observe the patient. If asleep, attempt to wake with speech or gentle touch on shoulder. Ask the patient to state their name and address to assist rating.",
       "highlight": "markedly drowsy (eg. difficult to rouse and/or obviously sleepy during assessment) or agitated/hyperactive",
       "scope": "on-scope",
       "note": "Item [1] ALERTNESS — the alertness component of the claim.",
       "page": "1",
       "docUrl": "https://www.the4at.com/"
      },
      {
       "context": "The 4AT is a screening instrument designed for rapid initial assessment of delirium and cognitive impairment. A score of 4 or more suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis.",
       "highlight": "The 4AT is a screening instrument designed for rapid initial assessment of delirium and cognitive impairment",
       "scope": "on-scope",
       "note": "Guidance note restating that a score of 4 or more suggests delirium and 1–3 suggests cognitive impairment.",
       "page": "1",
       "docUrl": "https://www.the4at.com/"
      }
     ]
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ED-specific guideline that recommends the 4AT and reproduces its four-component structure; on-scope for ED use, though it does not restate the numeric bands.",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": [
      {
       "context": "Recommendation #4: In older adults in the ED, 4AT, bCAM, CAM‐ICU, mCAM, AMT‐4, or RASS may be used to rule in or rule out delirium (Conditional, FOR) [Very low certainty of evidence].",
       "highlight": "may be used to rule in or rule out delirium",
       "scope": "on-scope",
       "note": "GRADE recommendation placing the 4AT among the tools usable to rule delirium in or out in older ED adults — establishes the ED-setting fit of the claim's tool.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      }
     ]
    },
    {
     "label": "SIGN 157",
     "cite": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
     "kind": "pdf",
     "stance": "background",
     "note": "General delirium guideline (adults at risk, hospital-oriented); corroborates the 4AT's four-'A' structure but at a different setting and without the ED score bands.",
     "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
     "paragraphs": [
      {
       "context": "Population: Adults at risk of delirium Assessment tools: a. 4 As Test (Arousal, Attention, Abbreviated Mental Test 4, Acute change Test) (4AT) b. Confusion Assessment Method Instrument (CAM) c. 3D Confusion Assessment Method Instrument (3D-CAM) d. Delirium Observation Screening Scale (DOS) e. Single Question to Identify Delirium (SQID) f. Memorial Delirium Assessment Scale (MDAS) g. Recognizing Acute Delirium As part of your Routine (RADAR) h. Delirium Rating Scale - 98 - Revised (DRS-98-R) i. Intensive Care Delirium Screening Checklist (ICD-SC) j. CAM for the intensive care unit (CAM-ICU) k. Richmond agitation sedation score (RASS); Modified RASS l. Family Confusion Assessment Method Instrument (FAM-CAM) m. Brief Confusion Assessment Method Instrument (B-CAM) n. Nursing Delirium Screening Scale (Nu-DESC) o. Organic Brain Syndrome scale (OBS) p. Mini Mental State Examination Comparison: Diagnostic and Statistical Manual (DSM-5) or International Classification of Diseases (ICD-10) defined diagnosis; between tools Outcomes: Sensitivity, specificity, evidence of adherence in clinical practical 3.2, 3.3 2.What tool(s) should be used for monitoring purposes and when should they be used?",
       "highlight": "4 As Test (Arousal, Attention, Abbreviated Mental Test 4, Acute change Test)",
       "scope": "different-setting",
       "note": "Names the 4AT's four As (arousal/alertness, attention, AMT4, acute change) but within a general at-risk-adults guideline rather than the ED workflow.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "The 4AT tool should be used for identifying patients with probable delirium in emergency department and acute hospital settings.",
       "highlight": "The 4AT tool should be used for identifying patients with probable delirium",
       "scope": "different-setting",
       "note": "SIGN recommends the 4AT to identify probable delirium in ED and acute hospital settings but does not state the ≥4 / 1–3 score interpretation.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "background",
     "note": "Hospital and long-term-care guideline recommending the 4AT (and CAM-ICU/ICDSC instead of it in critical care); different setting from the ED and without the numeric bands.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "competent to do so should carry out an assessment using the 4AT. In critical care or in the recovery room after surgery use the Confusion Assessment Method for the Intensive Care Unit (CAM-ICU) or Intensive Care Delirium Screening Checklist (ICDSC) instead of the 4AT.",
       "highlight": "carry out an assessment using the 4AT",
       "scope": "different-setting",
       "note": "Recommends the 4AT for assessment when delirium indicators are identified, but for the hospital/long-term-care setting (explicitly substituting CAM-ICU/ICDSC in critical care) rather than the ED.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Balancing the evidence for accuracy and cost effectiveness with the practicality of implementing the tests, the committee agreed that the 4AT was the best option for most settings. It is among the most accurate of the tools reviewed, quick and simple to use, and has a broader range of evidence to support it.",
       "highlight": "the 4AT was the best option for most settings",
       "scope": "broader",
       "note": "Endorses the 4AT as the best tool across most settings for accuracy and simplicity — supportive of the tool but not the ED-specific scoring in the claim.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "background",
     "note": "ED tool that recommends the Delirium Triage Screen + bCAM/CAM rather than the 4AT; mentions the months-backward inattention concept but does not address the 4AT or its scoring.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "The hallmarks of delirium include acute onset, waxing and waning symptoms, inattention (eg, unable to recite the months of the year or days of the week backwards), change in cognition (new memory deficit, disorientation, perceptual disturbance, or disorganized thinking), or altered level of awareness (reduced orientation to environment such as somnolence or agitation).14 Delirium can be subcategorized into 3 main psychomotor types.",
       "highlight": "unable to recite the months of the year or days of the week backwards",
       "scope": "background",
       "note": "Lists inability to recite months-of-the-year backward as a hallmark of delirium's inattention — the clinical rationale behind the 4AT attention item, but not the 4AT tool or its bands.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "The Delirium Triage Screen (Figure 2) can be rapidly administered, does not require collateral information, and is very sensitive, so it functions well as a screening tool.",
       "highlight": "The Delirium Triage Screen (Figure 2) can be rapidly administered",
       "scope": "different-intervention",
       "note": "ADEPT's ED screening choice is the Delirium Triage Screen (then bCAM/CAM), a different instrument than the 4AT this claim describes.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "background",
     "note": "ED prognosis study (delirium as a 6-month mortality predictor, screened via CAM-ICU); does not mention the 4AT or its scoring, so no relevant paragraph.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": []
    }
   ],
   "synthesis": "The 4AT v1.2 instrument is the on-scope governing source: it defines the four items (alertness, AMT4, months-of-the-year backward, acute change) and states the score bands verbatim (≥4 → possible delirium; 1–3 → possible cognitive impairment), and GED Guidelines 2.0 confirms the identical four-component structure and the 4AT's use in the ED. The other sources are near-matches at a different scope and do not directly establish this scoring: Han 2013 validates the DTS/bCAM (a different instrument that also uses a months-backward task), SIGN 157 and NICE CG103 recommend the 4AT for general-hospital/long-term-care rather than the ED and do not restate the numeric bands, and ADEPT's ED pathway relies on the DTS/bCAM — so the instrument governs the claim.",
   "discrepancy": true
  },
  {
   "id": "ed-wf-r10",
   "toolId": "ed-wf",
   "tool": "ED Workflow",
   "page": "1",
   "section": "4 · Act on the result",
   "statement": "Negative → document it; rescreen with any change in mental status.",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "4AT v1.2",
    "GED Guidelines 2.0 (2026)",
    "SIGN 157",
    "NICE CG103",
    "ADEPT (2020)",
    "Han 2010"
   ],
   "anchor": "NICE CG103 — p. 9",
   "passage": "… [2010] 1.4.12 Address sensory impairment by: • resolving any reversible cause of the impairment, such as impacted ear wax • ensuring hearing and visual aids are available to and used by people who need them, and that they are in good working order. [2010] 1.4.13 Promote good sleep patterns and sleep hygiene by: • avoiding nursing or medical procedures during sleeping hours, if possible • scheduling medication rounds to avoid disturbing sleep • reducing noise to a minimum during sleep periods. [2010] 1.5 Indicators of delirium: daily observations 1.5.1 Observe, at least daily, all people in hospital or long-term care for recent (within hours or days) changes or fluctuations indicating delirium (for example, see recommendation 1.3.1). These may be reported by the person at risk, or a carer or relative. If any of these changes are present the person should have an assessment using an appropriate tool (see recommendation 1.6.1). [2010, amended 2023] 1.5.2 Ensure that any changes that may indicate delirium are documented in the person's record or notes. [2023] Delirium: prevention, diagnosis and management in hospital and long-term care (CG103) © NICE 2025. All rights reserved. Subject to Notice of rights (https://www.nice.org.uk/terms-andconditions#notice-of-rights). Page 9 of 24\nNICE CG103 also supports the documentation element ('Ensure that any changes that may indicate delirium are documented in the person's record or notes'). The guidance is framed for daily hospital observation rather than an ED-specific negative-screen action, but is directly on point.",
   "evidence": "Full text, p. 9",
   "status": "fulltext",
   "pageNum": "9",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
    "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.the4at.com/",
    "https://doi.org/10.1111/acem.70167",
    "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
    "https://www.nice.org.uk/guidance/cg103",
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://doi.org/10.1016/j.annemergmed.2010.03.003"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "With regard to the eight false negative physician bCAMs, seven could recite the months backwards from December to July perfectly. Three had very subtle symptoms and required a more comprehensive psychiatrist evaluation than would have been typically needed to detect their inattention. For one false negative, the surrogate stated the patient was at her mental status baseline and there was no evidence of a fluctuating course to the physician and RAs; this patient may have developed delirium during the ED course. Another false negative evaluation received morphine during the ED course, possibly confounding the assessments.",
       "highlight": "this patient may have developed delirium during the ED course",
       "scope": "on-scope",
       "note": "A false-negative whose delirium emerged during the ED stay, showing delirium can develop after an initial negative screen - direct support for rescreening on any change in mental status.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "One method to improve delirium detection would be to use a two-step approach: a sequential testing strategy that utilizes brief, valid, and reliable delirium assessments that can be performed by healthcare professionals of all clinical backgrounds. The first step would be to perform a very brief (<20 seconds), highly sensitive delirium screen to rule-out delirium. This rapid rule-out screen can be incorporated into the ED triage assessment or can be part of the initial nursing assessment after the patient has been placed in an ED bed. A negative screen would rule out delirium, reduce the number of formal delirium assessments needed, and enhance screening efficiency. A positive screen would trigger a formal delirium assessment performed by another health care provider (i.e., physician) at the patient's bedside that would be highly specific to rule-in delirium. Ideally, this rule-in assessment should be brief (<1 minute) to maximize feasibility. We developed Delirium Triage Screen (DTS) and the Brief Confusion Assessment Method (bCAM) to serve as the rule-out and rule-in tests for the two-step approach to delirium surveillance (Figure 1), respectively.",
       "highlight": "A negative screen would rule out delirium",
       "scope": "on-scope",
       "note": "Defines the DTS negative pathway the ED tool is built on: a negative rules out delirium and needs no further formal assessment at that encounter; does not itself state document/rescreen.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "Step 1 (DTS) can be integrated into the nurses' triage assessment. If the DTS result is negative, then delirium is ruled out and no additional testing is needed. If the DTS result is positive, then a confirmatory delirium assessment such as the bCAM should be performed.",
       "highlight": "delirium is ruled out and no additional testing is needed",
       "scope": "on-scope",
       "note": "Figure 1 two-step algorithm - a negative DTS closes testing for that encounter ('no additional testing'), the flip side of rescreening only when mental status later changes.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": [
      {
       "context": "definitively exclude delirium or cognitive impairment: more detailed testing may be required depending on the clinical context. Items 1-3 are rated solely on observation of the patient at the time of assessment.",
       "highlight": "more detailed testing may be required depending on the clinical context",
       "scope": "on-scope",
       "note": "The instrument's own negative-result caveat: a score of 0 does not definitively exclude delirium and more testing may be needed by clinical context - the basis for staying vigilant and rescreening on change; documentation is not addressed.",
       "page": "",
       "docUrl": "https://www.the4at.com/"
      }
     ]
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": [
      {
       "context": "When delirium diagnosis is targeted only on a subset of patients identified as high‐risk for delirium, this may lead to missed delirium cases and subsequent harm from undertreatment, such as falls, pressure ulcers, dehydration, aspiration, and death [ 80 ]. For example, REDEEM score with sensitivity 84.1% at the cutoff of 11, 15.9% of patients with delirium would be identified as non‐high‐risk, and the diagnosis of delirium might be missed [ 73 ]. In addition, the reliance on binary results from a delirium‐risk screening could discount a change in mental status not meeting the threshold for delirium [ 81 ].",
       "highlight": "could discount a change in mental status not meeting the threshold for delirium",
       "scope": "broader",
       "note": "Same ED geriatric setting: cautions that reliance on a binary negative screen can miss a subthreshold change in mental status - rationale for rescreening on change, but framed as a harm of risk-stratification screening rather than an explicit document/rescreen directive.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      }
     ]
    },
    {
     "label": "SIGN 157",
     "cite": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
     "paragraphs": [
      {
       "context": "Repeat delirium screening when clinically indicated until two successive daily negatives.",
       "highlight": "Repeat delirium screening when clinically indicated until two successive daily negatives",
       "scope": "different-population",
       "note": "Nearest match on 'repeat screening,' but this sits in the 'Patient Improving' treatment-monitoring pathway - repeated screening to confirm resolution in a patient already diagnosed with delirium, not rescreening after a negative ED screen.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "Ensure that any changes that may indicate delirium are documented in the person's record or notes.",
       "highlight": "any changes that may indicate delirium are documented in the",
       "scope": "on-scope",
       "note": "Primary anchor (rec 1.5.2): requires documenting any changes that may indicate delirium in the person's record - supports the 'document it' step.",
       "page": "9",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Observe, at least daily, all people in hospital or long-term care for recent (within hours or days) changes or fluctuations indicating delirium (for example, see recommendation 1.3.1).",
       "highlight": "Observe, at least daily, all people in hospital or long-term care for recent",
       "scope": "on-scope",
       "note": "Rec 1.5.1: reassess with an appropriate tool whenever a change appears - the 'rescreen with any change in mental status' step; framed as inpatient/long-term-care daily observation, adapted here to the ED encounter.",
       "page": "9",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "The ADEPT tool covers assess/diagnose/evaluate/prevent/treat and agitation management of delirium in older ED patients; it does not address documenting a negative screen or rescreening on change in mental status. Cited for the ED workflow but not for this step.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": []
    },
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Cohort study establishing ED delirium as an independent predictor of 6-month mortality; no content on documenting a negative screen or rescreening. Cited elsewhere for prognostic weight, not this workflow step.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": []
    }
   ],
   "synthesis": "The primary on-scope source, NICE CG103 section 1.5, governs: document any changes that may indicate delirium and reassess with an appropriate tool whenever mental status changes - i.e., the 'document it / rescreen on change' step. The ED instruments agree in spirit (Han 2013's negative DTS rules out delirium at that encounter but 4AT notes a score of 0 does not definitively exclude it, and GED2 warns a binary negative can miss a subthreshold change, so vigilance and rescreening on change are warranted), while SIGN 157's 'repeat screening until two successive daily negatives' is a different scope - monitoring resolution in a patient already diagnosed with delirium, not rescreening after a negative ED screen; ADEPT and Han 2010 do not address this step.",
   "discrepancy": true
  },
  {
   "id": "ed-wf-r11",
   "toolId": "ed-wf",
   "tool": "ED Workflow",
   "page": "1",
   "section": "4 · Act on the result",
   "statement": "Positive → find the cause (review meds first), manage without new harm, and hand the finding off at disposition — a positive ED screen predicts 6-month mortality.",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "4AT v1.2",
    "GED Guidelines 2.0 (2026)",
    "SIGN 157",
    "NICE CG103",
    "ADEPT (2020)",
    "Han 2010"
   ],
   "anchor": "Han 2010 — p. 2",
   "passage": "adjusting for age, comorbidity burden, severity of illness, dementia, functional dependence, and nursing home residence. The \"delirium*nursing home\" interaction was non-significant (p=0.86), indicating that place of residence had no effect on the relationship between delirium in the ED and 6-month mortality. Conclusion- Delirium in older ED patients is an independent predictor of increased 6-month mortality and this relationship appears to be present regardless of nursing home status. Introduction Background Delirium occurs in 8 - 10% of older emergency department (ED) patients.1, 2 This form of brain dysfunction is characterized by an acute change in cognition that cannot be better accounted for by a preexisting or evolving dementia.3 Approximately 1.5 million older patients with delirium will be evaluated in the ED each year in the United States.4 This is similar to the number of annual acute coronary syndromes, a disease with comparable mortality and morbidity.5 Despite the magnitude of this problem, emergency physicians miss delirium in up to 75% of the cases.1, 2, 6 Importance The lack of delirium recognition may be secondary to a dearth of ED outcomes data. …\nAlso ADEPT (2020): \"The overall goal for treatment of delirium in the ED is to identify and address the underlying cause while avoiding actions or inactions that may worsen delirium.\"\nHan 2010 supports the 6-month mortality claim, and ADEPT supports cause-finding while avoiding new harm. ADEPT also recommends medication review to identify high-risk drugs and explicit communication of the delirium finding to the inpatient team, covering 'review meds first' and the disposition hand-off.",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
    "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.the4at.com/",
    "https://doi.org/10.1111/acem.70167",
    "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
    "https://www.nice.org.uk/guidance/cg103",
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://doi.org/10.1016/j.annemergmed.2010.03.003"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary source; the ED-specific evidence that delirium independently predicts 6-month mortality and the basis for the act-on-result steps (find etiology, avoid harmful meds, notify next level of care).",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": [
      {
       "context": "Conclusion--Delirium in older ED patients is an independent predictor of increased 6-month mortality and this relationship appears to be present regardless of nursing home status.",
       "highlight": "an independent predictor of increased 6-month mortality",
       "scope": "on-scope",
       "note": "Directly supports the mortality clause: delirium in older ED patients independently predicts 6-month mortality.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      },
      {
       "context": "Once delirium is diagnosed in the ED, the diagnostic evaluation should then focus on uncovering the underlying etiology.48 Infections, such as a urinary tract infection or pneumonia, dehydration, electrolyte abnormalities, central nervous system insults, and medication reactions are common causes.32 If admitted, physicians at the next level of care should be notified of the patient's delirium status. Other than these interventions, however, the optimal management of delirium is still unclear, especially within the ED setting. Several multi-component delirium interventions have been developed for hospitalized patients and can be tailored for the ED,49, 50 but their efficacy is questionable.51 Because many of these interventions were started 24 to 48 hours after admission, early detection and early intervention of delirium in the ED may improve their effectiveness similar to what has been observed in sepsis and ST-elevation myocardial infarction care.52, 53 A multi-faceted line of research must be undertaken to develop delirium interventions specifically tailored for the ED setting and determine their cost-effectiveness using randomized control trial methodology.",
       "highlight": "the diagnostic evaluation should then focus on uncovering the underlying etiology",
       "scope": "on-scope",
       "note": "Supports 'find the cause' — same paragraph lists medication reactions among common causes, backing 'review meds first'.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      },
      {
       "context": "Once delirium is diagnosed in the ED, the diagnostic evaluation should then focus on uncovering the underlying etiology.48 Infections, such as a urinary tract infection or pneumonia, dehydration, electrolyte abnormalities, central nervous system insults, and medication reactions are common causes.32 If admitted, physicians at the next level of care should be notified of the patient's delirium status. Other than these interventions, however, the optimal management of delirium is still unclear, especially within the ED setting. Several multi-component delirium interventions have been developed for hospitalized patients and can be tailored for the ED,49, 50 but their efficacy is questionable.51 Because many of these interventions were started 24 to 48 hours after admission, early detection and early intervention of delirium in the ED may improve their effectiveness similar to what has been observed in sepsis and ST-elevation myocardial infarction care.52, 53 A multi-faceted line of research must be undertaken to develop delirium interventions specifically tailored for the ED setting and determine their cost-effectiveness using randomized control trial methodology.",
       "highlight": "physicians at the next level of care should be notified of the patient's delirium status",
       "scope": "on-scope",
       "note": "Supports handing the finding off at disposition — notify the next level of care on admission.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      },
      {
       "context": "ED patients with unrecognized delirium may receive incomplete diagnostic workups and an underlying life-threatening illness may remain undiagnosed. These patients may also receive inappropriate interventions known to exacerbate delirium such as medications with anticholinergic properties or benzodiazepines.38, 39 Additionally, delirious patients who are discharged from the ED may be less likely to comprehend their discharge instructions,40 leading to poor adherence, return ED visits, and potentially increased mortality and morbidity.41, 42 The ED is ideally positioned to perform delirium surveillance because it is at the nexus of geriatric health care and serves as the gateway for the majority of hospital admissions.",
       "highlight": "inappropriate interventions known to exacerbate delirium such as medications with anticholinergic properties or benzodiazepines",
       "scope": "on-scope",
       "note": "Supports 'manage without new harm' by naming the interventions (anticholinergics, benzodiazepines) that worsen delirium.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    },
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ED-specific management tool that directly prescribes every act-on-result step and restates the 6-month mortality prediction; co-governs with Han 2010 for the ED setting.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "Older adults, defined as aged 65 years and older, frequently present to the emergency department (ED) for or with agitation, confusion, or behavioral changes.1 The number of older patients who present to the ED is expected to increase as the population ages. In older patients presenting with behavioral changes, there is more often an underlying medical condition or trigger causing the acute change than in younger patients. It is rare for patients in this age group to present with a new-onset primary psychotic disorder or new-onset schizophrenia, so a medical cause should almost always be assumed until proven otherwise. Furthermore, the signs and symptoms of these patients' presentation may be subtle or atypical, so the evaluation should be thorough. Management should focus on treatment of the underlying disorder, proactive measures to prevent worsening symptoms, and treatment of agitation, with a cautious awareness of the high risk of potential medication adverse effects. Delirium is frequently underrecognized in the ED2,3 and is an independent predictor of 6-month mortality.4 The care of agitated patients in the ED can be challenging.",
       "highlight": "an independent predictor of 6-month mortality",
       "scope": "on-scope",
       "note": "Restates the mortality clause for the ED (citing Han 2010).",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "The fifth is \"Treat.\" The overall goal for treatment of delirium in the ED is to identify and address the underlying cause while avoiding actions or inactions that may worsen delirium. Following the preventive steps outlined in this review will assist with these goals. Some patients may require additional interventions or medications to successfully and safely manage their agitation.44 If the patient is agitated, it is imperative to calm and protect him or her and staff, and to allow the patient to participate in care to whatever extent is possible.",
       "highlight": "identify and address the underlying cause while avoiding actions or inactions that may worsen delirium",
       "scope": "on-scope",
       "note": "Directly supports both 'find the cause' and 'manage without new harm' in one sentence.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Infections are the most common cause of delirium identified in ED studies, responsible for 30% to 40% of cases, followed by acute neurologic disorders such as ischemic stroke, intracranial hemorrhage, or intracranial mass.9,27 Adverse effects of medications commonly cause delirium and are estimated to be responsible for 12% to 39% of delirium across medical settings.28 Accordingly, it is critical that the emergency clinician perform a medication review to identify recent medication changes and use of medications at high risk of causing delirium (Table 1). Delirium is also frequently multifactorial.29 For example, a patient with a urinary tract infection may experience delirium from the infection, but other compounding factors such as dehydration, pain, new antibiotic medications, and change in environment can also contribute.",
       "highlight": "the emergency clinician perform a medication review",
       "scope": "on-scope",
       "note": "Directly supports 'review meds first' — medication review to find recent changes and delirium-risk drugs.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "The care of agitated patients in the ED can be challenging. The presence of agitation or behavioral changes is often a clue to underlying delirium, but the diagnosis of delirium is often not formally made in the ED setting.5 Delirium is an acute change in mental status, with waxing and waning symptoms, that can present with hyperactive, hypoactive, or mixed symptoms. Its presentation can be subtle or can be confounded by other symptoms or disorders, such as strokes, sepsis, adverse drug reactions, or intoxication. A greater understanding and recognition of delirium may help clinicians better care for patients and prevent symptom progression. In addition, when patients are agitated or delirious, clinicians often use pharmacologic measures such as antipsychotics or benzodiazepines for symptom control. However, these medications have significant potential complications, so nonpharmacologic measures should be used first when possible.",
       "highlight": "nonpharmacologic measures should be used first when possible",
       "scope": "on-scope",
       "note": "Supports 'manage without new harm' — nonpharmacologic first before antipsychotics/benzodiazepines.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "An ED length of stay of greater than 10 hours has been demonstrated to double the risk for incident delirium.43 Therefore, systems measures and protocols that reduce ED length of stay and avoid boarding patients in hallways should be considered for patients at risk of delirium. Prioritizing the transfer of older or frail patients to floor beds when they become available is one potential measure. In addition, it is important that the ED clinicians and nursing staff communicate the presence of delirium or agitation to the inpatient team. When the diagnosis of delirium is not made in the ED, it is also more likely to be missed by the inpatient teams,1 so it is important that the diagnosis be communicated explicitly.",
       "highlight": "communicate the presence of delirium or agitation to the inpatient team",
       "scope": "on-scope",
       "note": "Directly supports handing the finding off at disposition to the inpatient team.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "SIGN 157",
     "cite": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "National guideline corroborating identify-and-treat-causes, medication review, nonpharmacologic-first, and document-for-transfer principles, but scoped to general hospital/care settings rather than the ED.",
     "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
     "paragraphs": [
      {
       "context": "RHealthcare professionals should follow established pathways of good care to manage patients with delirium. First consider acute, life-threatening causes of delirium, including low oxygen level, low blood pressure, low glucose level, and drug intoxication or withdrawal. Systematically identify and treat potential causes (medications, acute illness, etc), noting that multiple causes are common. Optimise physiology, management of concurrent conditions, environment (reduce noise), medications, and natural sleep, to promote brain recovery. Specifically detect, assess causes of, and treat agitation and/or distress, using nonpharmacological means only if possible (see section 7 for pharmacological treatment). Communicate the diagnosis to patients and carers, encourage involvement of carers and provide ongoing engagement and support. Aim to prevent complications of delirium such as immobility, falls, pressure sores, dehydration, malnourishment, isolation. Monitor for recovery and consider specialist referral if not recovering. Consider follow up (see section 8).",
       "highlight": "Systematically identify and treat potential causes (medications, acute illness, etc)",
       "scope": "different-setting",
       "note": "Corroborates 'find the cause / review meds' but as a general-hospital care pathway, not ED-derived.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "All patients at risk of delirium should have a medication review conducted by an experienced healthcare professional.",
       "highlight": "medication review conducted by an experienced healthcare professional",
       "scope": "different-setting",
       "note": "Supports 'review meds first', but framed for at-risk patients generally rather than a positive ED screen.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "99 Where delirium is detected, the diagnosis of delirium should be clearly documented and coded to aid transfers of care (eg handover notes, referral and discharge letters).",
       "highlight": "clearly documented and coded to aid transfers of care (eg handover notes, referral and discharge letters)",
       "scope": "different-setting",
       "note": "Corroborates handoff at disposition (handover/referral/discharge letters) but from the general-hospital guideline.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "Delirium is an acute deterioration in mental functioning arising over hours or days that is triggered mainly by acute medical illness, surgery, trauma, or drugs.1 It was previously termed `acute confusional state'. Delirium is independently linked with poor outcomes including medical complications, falls, increased length of hospital stay, new institutionalisation, and mortality.1 It can cause significant patient and carer distress.2 The main features of delirium are acute cognitive deficits and altered level of arousal, with up to half of patients also experiencing hallucinations or delusions.3 Delirium varies in duration, mostly resolving within days, but in some people it can last weeks or months.4 Delirium is among the most common of medical emergencies.",
       "highlight": "Delirium is independently linked with poor outcomes including medical complications, falls, increased length of hospital stay, new institutionalisation, and mortality",
       "scope": "broader",
       "note": "General delirium-mortality link across settings, not the ED-specific 6-month prediction the claim makes.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Hospital and long-term-care guideline corroborating the identify-the-cause, medication-review, and de-escalate-before-medicating principles; does not address the ED setting or the mortality-prediction clause.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "In people diagnosed with delirium, identify and manage the possible underlying cause or combination of causes.",
       "highlight": "identify and manage the possible underlying",
       "scope": "different-setting",
       "note": "Recommendation 1.7.1 supports 'find the cause', but scoped to hospital and long-term care, not the ED.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Carry out a medication review for people taking multiple drugs, taking into account both the type and number of medications. For information on medicines optimisation see the NICE guideline on medicines optimisation. [2010]",
       "highlight": "Carry out a medication review for people taking multiple drugs",
       "scope": "different-setting",
       "note": "Supports 'review meds', placed under prevention for at-risk patients in hospital/long-term care.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "others, first use verbal and non-verbal techniques to de-escalate the situation.",
       "highlight": "first use verbal and non-verbal techniques to de-escalate the situation",
       "scope": "different-setting",
       "note": "Supports 'manage without new harm' (de-escalate before medicating), from the hospital/long-term-care setting.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "background",
     "note": "Validation of the ED screen (DTS/bCAM) that produces the positive result; supplies background on the consequences of missed delirium rather than direct guidance on acting on a positive screen.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "This form of acute brain dysfunction often leads to devastating consequences such as death and accelerated cognitive decline.",
       "highlight": "devastating consequences such as death and accelerated cognitive decline",
       "scope": "broader",
       "note": "General consequence-of-delirium statement (cites Han 2010) motivating screening, not the ED 6-month mortality prediction itself.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "likely to comprehend their discharge instructions which may lead to decreased compliance.16, 19 Lastly, if admitted, delirium that is missed in the ED will also be missed in the inpatient setting in over 90% of cases.13 Delirium is often clinically silent and will remain unrecognized without a formal delirium assessment.",
       "highlight": "delirium that is missed in the ED will also be missed in the inpatient setting in over 90% of cases",
       "scope": "background",
       "note": "Rationale for handing the finding off at disposition — unrecognized delirium propagates to the inpatient team.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "background",
     "note": "Guideline scoped to ED delirium risk stratification, screening, and brain imaging; it does not address the management, disposition-handoff, or mortality-prediction content of this claim.",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": [
      {
       "context": "Delirium increases mortality rates and leads to functional decline at an estimated cost of $152 billion US dollars to the healthcare system annually [ 17 , 23 ].",
       "highlight": "Delirium increases mortality rates and leads to functional decline",
       "scope": "broader",
       "note": "Background burden statement (general delirium raises mortality and causes functional decline), not the ED-specific 6-month mortality prediction or the act-on-result steps.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      }
     ]
    },
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "background",
     "note": "The screening instrument itself; defines what a positive score means but gives no guidance on cause-finding, medication review, management, handoff, or mortality.",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": [
      {
       "context": "The 4AT is a screening instrument designed for rapid initial assessment of delirium and cognitive impairment. A score of 4 or more suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis.",
       "highlight": "more detailed assessment of mental status may be required to reach a diagnosis",
       "scope": "background",
       "note": "Only states that a positive 4AT is not diagnostic and may need further assessment — no act-on-result content.",
       "page": "",
       "docUrl": "https://www.the4at.com/"
      }
     ]
    }
   ],
   "synthesis": "The two ED-specific sources govern and agree with the full claim: Han 2010 shows delirium in older ED patients independently predicts 6-month mortality, and ADEPT (2020) directly prescribes identifying/treating the underlying cause, performing a medication review, avoiding harmful sedatives, and communicating the delirium diagnosis to the inpatient team at disposition. SIGN 157 and NICE CG103 corroborate the same identify-the-cause / review-medications / nonpharmacologic-first / document-for-transfer-of-care principles but from general hospital and long-term-care settings (different-setting), while the 4AT instrument, Han 2013 (its validation), and GED 2.0 (a screening/imaging guideline) are background rather than direct support for acting on a positive ED screen.",
   "discrepancy": true
  },
  {
   "id": "ed-wf-r12",
   "toolId": "ed-wf",
   "tool": "ED Workflow",
   "page": "1",
   "section": "Disposition hand-off script",
   "statement": "Screen used and result (DTS/bCAM or 4AT)",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "4AT v1.2",
    "GED Guidelines 2.0 (2026)",
    "SIGN 157",
    "NICE CG103",
    "ADEPT (2020)",
    "Han 2010"
   ],
   "anchor": "ADEPT (2020) — p. 7",
   "passage": "… Some measures include low beds, getting out of bed to chairs, physical therapy, nonslip floors or socks, and 1:1 sitters.41,42 An ED length of stay of greater than 10 hours has been demonstrated to double the risk for incident delirium.43 Therefore, systems measures and protocols that reduce ED length of stay and avoid boarding patients in hallways should be considered for patients at risk of delirium. Prioritizing the transfer of older or frail patients to floor beds when they become available is one potential measure. In addition, it is important that the ED clinicians and nursing staff communicate the presence of delirium or agitation to the inpatient team . When the diagnosis of delirium is not made in the ED, it is also more likely to be missed by the inpatient teams,1 so it is important that the diagnosis be communicated explicitly. TREAT The fifth is \"Treat.\" The overall goal for treatment of delirium in the ED is to identify and address the underlying cause while avoiding actions or inactions that may worsen delirium. Following the preventive steps outlined in this review will assist with these goals. Some patients may require additional interventions or medications to successfully and safely manage their agitation.44 If the patient is agitated, it is imperative to calm and protect him or her and staff, and to allow the patient to participate in care to whatever extent is possible. …\nADEPT supports explicit communication of the delirium finding at the transition of care; the specific instrument names derive from the tool-selection sources. The statement is a structural checklist item rather than a discrete clinical claim.",
   "evidence": "Full text, p. 7 — partial support",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
    "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.the4at.com/",
    "https://doi.org/10.1111/acem.70167",
    "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
    "https://www.nice.org.uk/guidance/cg103",
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://doi.org/10.1016/j.annemergmed.2010.03.003"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary/governing source: ED-specific, addresses hand-off communication at disposition and names the DTS/bCAM screens.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "An ED length of stay of greater than 10 hours has been demonstrated to double the risk for incident delirium.43 Therefore, systems measures and protocols that reduce ED length of stay and avoid boarding patients in hallways should be considered for patients at risk of delirium. Prioritizing the transfer of older or frail patients to floor beds when they become available is one potential measure. In addition, it is important that the ED clinicians and nursing staff communicate the presence of delirium or agitation to the inpatient team. When the diagnosis of delirium is not made in the ED, it is also more likely to be missed by the inpatient teams,1 so it is important that the diagnosis be communicated explicitly.",
       "highlight": "it is important that the diagnosis be communicated explicitly",
       "scope": "on-scope",
       "note": "Directly supports the disposition hand-off item: the ED team must communicate delirium presence to the receiving inpatient team and the diagnosis must be communicated explicitly.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "attention. A positive Delirium Triage Screen result should trigger confirmation with a test that is more specific, such as the Confusion Assessment Method or Brief Confusion Assessment Method (Table 2).16-18 A patient is delirious if he or she has acute onset or fluctuating course, inattention, and either disorganized thinking or altered level of consciousness.",
       "highlight": "such as the Confusion Assessment Method or Brief Confusion Assessment Method",
       "scope": "on-scope",
       "note": "Names the DTS/bCAM two-step ED screen and its result (positive DTS triggers confirmatory bCAM), matching the screen/result named in the claim.",
       "page": "ms. p.5",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Contains an on-scope hand-off statement plus the prognostic rationale for why the result matters; used CAM-ICU rather than DTS/bCAM.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": [
      {
       "context": "Once delirium is diagnosed in the ED, the diagnostic evaluation should then focus on uncovering the underlying etiology.48 Infections, such as a urinary tract infection or pneumonia, dehydration, electrolyte abnormalities, central nervous system insults, and medication reactions are common causes.32 If admitted, physicians at the next level of care should be notified of the patient's delirium status. Other than these interventions, however, the optimal management of delirium is still unclear, especially within the ED setting. Several multi-component delirium interventions have been developed for hospitalized patients and can be tailored for the ED,49, 50 but their efficacy is questionable.51 Because many of these interventions were started 24 to 48 hours after admission, early detection and early intervention of delirium in the ED may improve their effectiveness similar to what has been observed in sepsis and ST-elevation myocardial infarction care.52, 53 A multi-faceted line of research must be undertaken to develop delirium interventions specifically tailored for the ED setting and determine their cost-effectiveness using randomized control trial methodology.",
       "highlight": "physicians at the next level of care should be notified of the patient's delirium status",
       "scope": "on-scope",
       "note": "Directly supports hand-off of the screen result: if admitted, the next level of care should be notified of the patient's delirium status.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      },
      {
       "context": "Conclusion--Delirium in older ED patients is an independent predictor of increased 6-month mortality and this relationship appears to be present regardless of nursing home status.",
       "highlight": "an independent predictor of increased 6-month mortality",
       "scope": "background",
       "note": "Prognostic rationale for why communicating the delirium result at hand-off matters; the paper's main topic is mortality, not the hand-off practice itself.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    },
    {
     "label": "SIGN 157",
     "cite": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Supports documenting the delirium diagnosis at transfers of care and endorses the 4AT for the ED; does not endorse DTS/bCAM (UK guideline).",
     "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
     "paragraphs": [
      {
       "context": "99 Where delirium is detected, the diagnosis of delirium should be clearly documented and coded to aid transfers of care (eg handover notes, referral and discharge letters).",
       "highlight": "clearly documented and coded to aid transfers of care (eg handover notes, referral and discharge letters)",
       "scope": "on-scope",
       "note": "Directly supports documenting the delirium result at hand-off: diagnosis documented to aid transfers of care via handover notes, referral and discharge letters.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "The 4AT tool should be used for identifying patients with probable delirium in emergency department and acute hospital settings.",
       "highlight": "in emergency department and acute hospital settings",
       "scope": "on-scope",
       "note": "Endorses the 4AT (the alternative screen named in the claim) for the ED and acute hospital settings.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ED-specific GRADE guideline that endorses exactly the screens named (4AT/bCAM rule in-or-out; DTS rule out) with rule-in/rule-out results.",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": [
      {
       "context": "Recommendation #4: In older adults in the ED, 4AT, bCAM, CAM‐ICU, mCAM, AMT‐4, or RASS may be used to rule in or rule out delirium (Conditional, FOR) [Very low certainty of evidence].",
       "highlight": "may be used to rule in or rule out delirium",
       "scope": "on-scope",
       "note": "Recommendation #4 endorses 4AT and bCAM (among others) to rule in or rule out delirium in older ED adults, matching the claim's screen/result.",
       "page": "9",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "Recommendation #5: In older adults in the ED, DTS may be used to rule out delirium (Conditional, FOR) [Very low certainty of evidence].",
       "highlight": "DTS may be used to rule out delirium",
       "scope": "on-scope",
       "note": "Recommendation #5 endorses the DTS to rule out delirium in older ED adults, matching the DTS arm of the named screen/result.",
       "page": "9",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "In older ED patients with suspected delirium, there is sufficient direct evidence to select delirium diagnostic instruments that accurately rule in (i.e., confirm) or rule out (i.e., exclude) delirium [ 22 ]. The 4AT had the largest quantity of ED‐based research and may be used to rule in or rule out delirium [ 90 ]. The CAM‐ICU, brief Confusion Assessment Method (bCAM), modified Confusion Assessment Method (mCAM) for the Emergency Department, AMT‐4, and Richmond Agitation and Sedation Scale (RASS) are superior to clinical gestalt [ 91 ], and may also be used to rule in or rule out delirium. The Delirium Triage Screen is superior to clinical gestalt in ruling out delirium [ 92 ] (Table 3 ).",
       "highlight": "accurately rule in (i.e., confirm) or rule out (i.e., exclude) delirium",
       "scope": "on-scope",
       "note": "Summary of evidence: 4AT has the largest ED evidence base; the named instruments accurately rule in or rule out delirium in older ED patients.",
       "page": "9",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "DTS was assessed in a single‐center study ( n = 406) [ 22 , 91 ] demonstrating that ED clinicians using DTS inaccurately rule‐in delirium (LR+ 2.2 [95% CI 1.9–2.5]) but can rule‐out delirium (LR− 0.04 [95% CI 0.01–0.25]) [ 22 ]. Indirect evidence from settings beyond the ED was concordant with our findings. A systematic review of 17 studies (3702 observations) examining the 4AT in acute medicine, surgery, care home, and the ED setting reported pooled sensitivity 0.88 (95% CI 0.90–0.93) and pooled specificity 0.88 (95% CI 0.82–0.92) indicating good diagnostic accuracy [ 116 ]. Miranda et al. [ 117 ] conducted a Cochrane review of 25 studies (2817 participants) of the CAM‐ICU for the diagnosis of delirium in the intensive care unit and estimated a pooled sensitivity of 0.78 (95% CI 0.72–0.83) and pooled specificity of 0.95 (95% CI 0.92–0.97). This indirect evidence further strengthened our findings, as it is unlikely that the setting of tool administration (i.e., ED vs. inpatient setting) significantly affects the tool's accuracy.",
       "highlight": "examining the 4AT in acute medicine, surgery, care home, and the ED setting",
       "scope": "different-setting",
       "note": "Nearest match at a different setting: some accuracy evidence for the 4AT/CAM-ICU comes from acute medicine, surgery, care home and ICU rather than the ED.",
       "page": "10",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "partial",
     "note": "Concordant on documenting the diagnosis and using the 4AT, but scoped to hospital/long-term care generally rather than an ED hand-off, and endorses 4AT (not DTS/bCAM).",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "Ensure that the diagnosis of delirium is documented both in the person's record or notes, and in their primary care health record.",
       "highlight": "the diagnosis of delirium is documented both in the person's record",
       "scope": "broader",
       "note": "Supports documenting the delirium diagnosis in the record, but as a general hospital/long-term-care practice rather than the ED disposition hand-off specifically.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "competent to do so should carry out an assessment using the 4AT. In critical care or in the recovery room after surgery use the Confusion Assessment Method for the Intensive Care Unit (CAM-ICU) or Intensive Care Delirium Screening Checklist (ICDSC) instead of the 4AT.",
       "highlight": "carry out an assessment using the 4AT",
       "scope": "broader",
       "note": "Endorses the 4AT for most settings (CAM-ICU/ICDSC for critical care), broader than the ED and without endorsing DTS/bCAM.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "background",
     "note": "Defines and validates the DTS/bCAM instrument the claim names; does not address hand-off/disposition documentation.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "One method to improve delirium detection would be to use a two-step approach: a sequential testing strategy that utilizes brief, valid, and reliable delirium assessments that can be performed by healthcare professionals of all clinical backgrounds. The first step would be to perform a very brief (<20 seconds), highly sensitive delirium screen to rule-out delirium. This rapid rule-out screen can be incorporated into the ED triage assessment or can be part of the initial nursing assessment after the patient has been placed in an ED bed. A negative screen would rule out delirium, reduce the number of formal delirium assessments needed, and enhance screening efficiency. A positive screen would trigger a formal delirium assessment performed by another health care provider (i.e., physician) at the patient's bedside that would be highly specific to rule-in delirium. Ideally, this rule-in assessment should be brief (<1 minute) to maximize feasibility. We developed Delirium Triage Screen (DTS) and the Brief Confusion Assessment Method (bCAM) to serve as the rule-out and rule-in tests for the two-step approach to delirium surveillance (Figure 1), respectively.",
       "highlight": "to serve as the rule-out and rule-in tests for the two-step approach to delirium surveillance",
       "scope": "background",
       "note": "Establishes the DTS/bCAM two-step ED screen (rule-out then rule-in) that the claim's parenthetical references; the paper is instrument validation, not hand-off.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "To determine how generalizable our findings were to non-critically ill hospitalized older patients, we analyzed a subgroup of 278 older ED patients who were admitted to non-ICUs; of these, 38 (13.7%) were delirious. The DTS and bCAM's diagnostic performances and inter-observer reliabilities were similar as the main analysis (Table 3). The overall diagnostic performances of the two-step approach performed sequentially by various raters were also similar in this subgroup.",
       "highlight": "a subgroup of 278 older ED patients who were admitted to non-ICUs",
       "scope": "different-setting",
       "note": "Nearest match at a different setting: a generalizability subgroup of admitted non-ICU hospitalized patients rather than the ED-disposition context of the claim.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "background",
     "note": "The 4AT instrument itself (the alternative screen named) and its score-result bands; does not address hand-off documentation.",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": [
      {
       "context": "The 4AT is a screening instrument designed for rapid initial assessment of delirium and cognitive impairment. A score of 4 or more suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis.",
       "highlight": "screening instrument designed for rapid initial assessment of delirium and cognitive impairment",
       "scope": "background",
       "note": "Defines the 4AT, the alternative screen named in the claim.",
       "page": "",
       "docUrl": "https://www.the4at.com/"
      },
      {
       "context": "A score of 4 or more suggests delirium but is not diagnostic: more detailed assessment of mental status may be required to reach a diagnosis. A score of 1-3 suggests cognitive impairment and more detailed cognitive testing and informant history-taking are required.",
       "highlight": "A score of 4 or more suggests delirium but is not diagnostic",
       "scope": "background",
       "note": "The 4AT score interpretation (>=4 possible delirium; 1-3 possible cognitive impairment) supplies the result for the 4AT arm of the hand-off.",
       "page": "",
       "docUrl": "https://www.the4at.com/"
      }
     ]
    }
   ],
   "synthesis": "The on-scope ED sources agree that at disposition the delirium screen result should be handed off to the receiving team: ADEPT (the governing primary source, p.7) states the diagnosis must be communicated explicitly to the inpatient team, Han 2010 says physicians at the next level of care should be notified of the patient's delirium status, SIGN 157 directs documenting the diagnosis to aid transfers of care (handover notes, referral, discharge letters), and GED Guidelines 2.0 endorses exactly the named screens (4AT/bCAM to rule in-or-out, DTS to rule out) in older ED patients, with Han 2013 and the 4AT instrument supplying those tools and their result bands. NICE CG103 is concordant but broader — hospital/long-term-care documentation and 4AT use rather than an ED hand-off with DTS/bCAM — so it is a nearest match at a wider scope rather than direct support; ADEPT governs because it is ED-specific and directly addresses the hand-off.",
   "discrepancy": true
  },
  {
   "id": "ed-wf-r13",
   "toolId": "ed-wf",
   "tool": "ED Workflow",
   "page": "1",
   "section": "Disposition hand-off script",
   "statement": "Suspected cause(s) and what was ruled out",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "4AT v1.2",
    "GED Guidelines 2.0 (2026)",
    "SIGN 157",
    "NICE CG103",
    "ADEPT (2020)",
    "Han 2010"
   ],
   "anchor": "ADEPT (2020) — p. 7",
   "passage": "… Prioritizing the transfer of older or frail patients to floor beds when they become available is one potential measure. In addition, it is important that the ED clinicians and nursing staff communicate the presence of delirium or agitation to the inpatient team. When the diagnosis of delirium is not made in the ED, it is also more likely to be missed by the inpatient teams,1 so it is important that the diagnosis be communicated explicitly. TREAT The fifth is \"Treat.\" The overall goal for treatment of delirium in the ED is to identify and address the underlying cause while avoiding actions or inactions that may worsen delirium. Following the preventive steps outlined in this review will assist with these goals. Some patients may require additional interventions or medications to successfully and safely manage their agitation.44 If the patient is agitated, it is imperative to calm and protect him or her and staff, and to allow the patient to participate in care to whatever extent is possible. …\nADEPT supports identifying and addressing the underlying cause, and elsewhere recommends medication review and workup. The statement is a structural checklist item rather than a discrete clinical threshold.",
   "evidence": "Full text, p. 7 — partial support",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
    "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.the4at.com/",
    "https://doi.org/10.1111/acem.70167",
    "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
    "https://www.nice.org.uk/guidance/cg103",
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://doi.org/10.1016/j.annemergmed.2010.03.003"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "background",
     "note": "Validation study of the DTS/bCAM screening pathway; contributes only background and different-scope keyword matches, not hand-off guidance.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "One method to improve delirium detection would be to use a two-step approach: a sequential testing strategy that utilizes brief, valid, and reliable delirium assessments that can be performed by healthcare professionals of all clinical backgrounds. The first step would be to perform a very brief (<20 seconds), highly sensitive delirium screen to rule-out delirium. This rapid rule-out screen can be incorporated into the ED triage assessment or can be part of the initial nursing assessment after the patient has been placed in an ED bed. A negative screen would rule out delirium, reduce the number of formal delirium assessments needed, and enhance screening efficiency. A positive screen would trigger a formal delirium assessment performed by another health care provider (i.e., physician) at the patient's bedside that would be highly specific to rule-in delirium. Ideally, this rule-in assessment should be brief (<1 minute) to maximize feasibility. We developed Delirium Triage Screen (DTS) and the Brief Confusion Assessment Method (bCAM) to serve as the rule-out and rule-in tests for the two-step approach to delirium surveillance (Figure 1), respectively.",
       "highlight": "delirium screen to rule-out delirium",
       "scope": "different-intervention",
       "note": "'Rule-out' here means excluding the delirium diagnosis with a rapid triage screen (DTS), not the hand-off item of stating which alternative causes were excluded.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      },
      {
       "context": "likely to comprehend their discharge instructions which may lead to decreased compliance.16, 19 Lastly, if admitted, delirium that is missed in the ED will also be missed in the inpatient setting in over 90% of cases.13 Delirium is often clinically silent and will remain unrecognized without a formal delirium assessment.",
       "highlight": "delirium that is missed in the ED will also be missed in the inpatient setting",
       "scope": "background",
       "note": "Background rationale for why delirium must be communicated at hand-off (missed ED delirium is missed inpatient in >90% of cases), but the paper does not prescribe hand-off content.",
       "page": "",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "Bedside screening instrument (4 scored items plus guidance notes); it says nothing about disposition, hand-off, or documenting suspected/ruled-out causes.",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": []
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "background",
     "note": "GRADE guideline scoped to risk stratification, screening, and brain imaging; its 'cause/etiology' and 'rule out' content is a different-scope keyword match, not hand-off guidance.",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": [
      {
       "context": "In older ED patients with suspected delirium, there is sufficient direct evidence to select delirium diagnostic instruments that accurately rule in (i.e., confirm) or rule out (i.e., exclude) delirium [ 22 ]. The 4AT had the largest quantity of ED‐based research and may be used to rule in or rule out delirium [ 90 ]. The CAM‐ICU, brief Confusion Assessment Method (bCAM), modified Confusion Assessment Method (mCAM) for the Emergency Department, AMT‐4, and Richmond Agitation and Sedation Scale (RASS) are superior to clinical gestalt [ 91 ], and may also be used to rule in or rule out delirium. The Delirium Triage Screen is superior to clinical gestalt in ruling out delirium [ 92 ] (Table 3 ).",
       "highlight": "rule out (i.e., exclude) delirium",
       "scope": "different-intervention",
       "note": "'Rule out' refers to excluding the delirium diagnosis with a screening instrument (a diagnostic action), not the hand-off item of listing which alternative causes were excluded.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      },
      {
       "context": "Delirium may be associated with many disease processes or medication interactions, including neurological etiologies such as stroke, intracranial hemorrhage, and brain tumors [ 131 ]. Often, the etiology for delirium is undifferentiated in the ED. Obtaining a head CT is common practice in older adults presenting to the ED with altered mental status (AMS), occurring in 13%–23% [ 132 , 133 ]. No clear guidance exists on whether to obtain a head CT in older adults presenting to the ED with delirium. The American College of Radiology (ACR) Appropriateness Criteria recommend obtaining brain imaging (specifically, a non‐contrast head CT) in patients with AMS, coma, delirium, or acute psychosis “unless the etiology is clear and the risk of intracranial pathology is low” [ 134 ].",
       "highlight": "the etiology for delirium is undifferentiated in the ED",
       "scope": "different-intervention",
       "note": "Nearest match on 'cause/etiology,' but framed as whether to obtain a head CT to find an etiology (an imaging-workup decision), not communicating the suspected cause at hand-off.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/acem.70167"
      }
     ]
    },
    {
     "label": "SIGN 157",
     "cite": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "General (all-settings) delirium guideline whose transfer-of-care and cause-identification recommendations apply directly to the ED disposition hand-off.",
     "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
     "paragraphs": [
      {
       "context": "99 Where delirium is detected, the diagnosis of delirium should be clearly documented and coded to aid transfers of care (eg handover notes, referral and discharge letters).",
       "highlight": "to aid transfers of care (eg handover notes, referral and discharge letters)",
       "scope": "on-scope",
       "note": "Directly supports documenting the delirium diagnosis at transfer of care via handover notes / referral / discharge letters — the hand-off communication the claim describes.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "RHealthcare professionals should follow established pathways of good care to manage patients with delirium. First consider acute, life-threatening causes of delirium, including low oxygen level, low blood pressure, low glucose level, and drug intoxication or withdrawal. Systematically identify and treat potential causes (medications, acute illness, etc), noting that multiple causes are common. Optimise physiology, management of concurrent conditions, environment (reduce noise), medications, and natural sleep, to promote brain recovery. Specifically detect, assess causes of, and treat agitation and/or distress, using nonpharmacological means only if possible (see section 7 for pharmacological treatment). Communicate the diagnosis to patients and carers, encourage involvement of carers and provide ongoing engagement and support. Aim to prevent complications of delirium such as immobility, falls, pressure sores, dehydration, malnourishment, isolation. Monitor for recovery and consider specialist referral if not recovering. Consider follow up (see section 8).",
       "highlight": "Systematically identify and treat potential causes (medications, acute illness, etc), noting that multiple causes are common",
       "scope": "on-scope",
       "note": "Supports both hand-off components — first rule out acute life-threatening causes, then systematically identify the (often multiple) underlying causes.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Hospital and long-term-care guideline (not ED-specific), but endorses the underlying principle: identify the cause and document the diagnosis for continuity across the hand-off.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "In people diagnosed with delirium, identify and manage the possible underlying cause or combination of causes.",
       "highlight": "identify and manage the possible underlying",
       "scope": "on-scope",
       "note": "Supports the 'suspected cause(s)' component: identify and manage the possible underlying cause or combination of causes; a general hospital/LTC guideline, so the ED-disposition framing is the tool's application.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Ensure that the diagnosis of delirium is documented both in the person's record or notes, and in their primary care health record.",
       "highlight": "the diagnosis of delirium is documented both in the",
       "scope": "on-scope",
       "note": "Supports documenting the delirium diagnosis in the record (and primary-care record) for continuity of care across the hand-off.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary anchor (p.7); the ED-specific tool that most directly governs communicating the diagnosis and its worked-up/ruled-out causes at hand-off.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "An ED length of stay of greater than 10 hours has been demonstrated to double the risk for incident delirium.43 Therefore, systems measures and protocols that reduce ED length of stay and avoid boarding patients in hallways should be considered for patients at risk of delirium. Prioritizing the transfer of older or frail patients to floor beds when they become available is one potential measure. In addition, it is important that the ED clinicians and nursing staff communicate the presence of delirium or agitation to the inpatient team. When the diagnosis of delirium is not made in the ED, it is also more likely to be missed by the inpatient teams,1 so it is important that the diagnosis be communicated explicitly.",
       "highlight": "it is important that the diagnosis be communicated explicitly",
       "scope": "on-scope",
       "note": "Primary anchor (p.7): the ED team must explicitly communicate the delirium diagnosis to the receiving inpatient team at hand-off.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "The fifth is \"Treat.\" The overall goal for treatment of delirium in the ED is to identify and address the underlying cause while avoiding actions or inactions that may worsen delirium. Following the preventive steps outlined in this review will assist with these goals. Some patients may require additional interventions or medications to successfully and safely manage their agitation.44 If the patient is agitated, it is imperative to calm and protect him or her and staff, and to allow the patient to participate in care to whatever extent is possible.",
       "highlight": "identify and address the underlying cause",
       "scope": "on-scope",
       "note": "Supports the 'suspected cause(s)' component — the Treat step's goal is to identify and address the underlying cause.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "First is \"Assess.\" Once life threats and immediately treatable conditions such as hypoxia, hypoglycemia, and ST-segment elevation myocardial infarction have been ruled out and patient and staff safety are ensured, the next step is to determine whether there has been a change from baseline and the time course.8 First establish the patient's baseline mental status and the time course of any changes, a process that will typically require contacting a family member or caregiver.",
       "highlight": "have been ruled out",
       "scope": "on-scope",
       "note": "Supports the 'what was ruled out' component — life-threatening, immediately treatable conditions are ruled out first in the Assess step.",
       "page": "ms. p.3",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Although the \"Diagnose\" step focuses on determining whether delirium is present, the \"Evaluate\" step focuses on evaluation for underlying causes (Table 1).26 The evaluation should be directed by a focused history and careful physical examination.",
       "highlight": "focuses on evaluation for underlying causes",
       "scope": "on-scope",
       "note": "The Evaluate step is dedicated to working up the underlying cause(s) that the hand-off then conveys.",
       "page": "ms. p.5",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ED-specific study whose management discussion directly states the two hand-off components: work up the etiology and notify the next level of care of delirium status.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": [
      {
       "context": "Once delirium is diagnosed in the ED, the diagnostic evaluation should then focus on uncovering the underlying etiology.48 Infections, such as a urinary tract infection or pneumonia, dehydration, electrolyte abnormalities, central nervous system insults, and medication reactions are common causes.32 If admitted, physicians at the next level of care should be notified of the patient's delirium status. Other than these interventions, however, the optimal management of delirium is still unclear, especially within the ED setting. Several multi-component delirium interventions have been developed for hospitalized patients and can be tailored for the ED,49, 50 but their efficacy is questionable.51 Because many of these interventions were started 24 to 48 hours after admission, early detection and early intervention of delirium in the ED may improve their effectiveness similar to what has been observed in sepsis and ST-elevation myocardial infarction care.52, 53 A multi-faceted line of research must be undertaken to develop delirium interventions specifically tailored for the ED setting and determine their cost-effectiveness using randomized control trial methodology.",
       "highlight": "physicians at the next level of care should be notified",
       "scope": "on-scope",
       "note": "Directly on-scope: after the evaluation focuses on uncovering the underlying etiology, if admitted the next level of care must be notified of the patient's delirium status — both hand-off components.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    }
   ],
   "synthesis": "The on-scope sources agree: the primary anchor ADEPT (2020, p.7) directs the ED team to explicitly communicate the delirium diagnosis to the receiving team and to identify/rule out its underlying cause, and Han 2010, SIGN 157, and NICE CG103 concur that the etiology should be worked up and the delirium diagnosis documented/notified at transfer of care — together governing the \"suspected cause(s) and what was ruled out\" hand-off item. The nearest-match content in GED Guidelines 2.0, Han 2013, and the 4AT is different-scope (diagnostic \"rule out delirium\" screening and head-CT etiology workup): it shares keywords but must not be read as direct support, and ADEPT p.7 governs as the primary ED hand-off source.",
   "discrepancy": true
  },
  {
   "id": "ed-wf-r14",
   "toolId": "ed-wf",
   "tool": "ED Workflow",
   "page": "1",
   "section": "Disposition hand-off script",
   "statement": "Interventions started in the ED",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "4AT v1.2",
    "GED Guidelines 2.0 (2026)",
    "SIGN 157",
    "NICE CG103",
    "ADEPT (2020)",
    "Han 2010"
   ],
   "anchor": "ADEPT (2020) — p. 7",
   "passage": "… In addition, it is important that the ED clinicians and nursing staff communicate the presence of delirium or agitation to the inpatient team. When the diagnosis of delirium is not made in the ED, it is also more likely to be missed by the inpatient teams,1 so it is important that the diagnosis be communicated explicitly. TREAT The fifth is \"Treat.\" The overall goal for treatment of delirium in the ED is to identify and address the underlying cause while avoiding actions or inactions that may worsen delirium. Following the preventive steps outlined in this review will assist with these goals. Some patients may require additional interventions or medications to successfully and safely manage their agitation. 44 If the patient is agitated, it is imperative to calm and protect him or her and staff, and to allow the patient to participate in care to whatever extent is possible. Nonpharmacologic interventions such as verbal de-escalation, distraction, and reassurance can be used with assistance from sitters, family, or staff.45-47 Successful de-escalation helps the patient regain control without need for further treatment45,48 and may even be effective in patients with cognitive deficits such as dementia.49 A video recording message of family members can also help calm and de-escalate agitated older patients.50 Medications may be needed if the above measures fail. …\nADEPT's treatment section describes ED interventions — nonpharmacologic de-escalation and, when needed, medications. The statement is a structural checklist item rather than a discrete clinical claim.",
   "evidence": "Full text, p. 7 — partial support",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
    "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.the4at.com/",
    "https://doi.org/10.1111/acem.70167",
    "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
    "https://www.nice.org.uk/guidance/cg103",
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://doi.org/10.1016/j.annemergmed.2010.03.003"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "background",
     "note": "A diagnostic-validation study for the DTS/bCAM screen; it grounds the 'screen used' handoff item, not the 'interventions started' item.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "In addition to the dramatic effect that these instruments could have on the routine clinical practice, the availability of feasible assessments will open a new frontier to additional delirium investigations. As with ST-segment elevation myocardial infarction and severe sepsis care, we envision establishing similar paradigms for delirium care in which early identification and intervention in the ED of delirious patients at higher risk is emphasized.43, 44 However, a multi-faceted investigative approach must be taken to achieve this goal. We must determine if our two-step approach captures patients at highest risk for adverse outcomes and those who would benefit most from intervention. Several delirium multi-component interventions exist for hospitalized patients, but their efficacy has been equivocal.45 Many of these studies, however, enrolled delirious patients across the entire spectrum of severity 24 to 48 hours after admission. Conceivably, performing these interventions in high-risk delirious patients early in the ED course may cost-effectively improve short- and long-term outcomes. This hypothesis should be tested in future investigations using randomized-control trial methodology.",
       "highlight": "performing these interventions in high-risk delirious patients early in the ED course",
       "scope": "background",
       "note": "Its only mention of ED intervention is an aspirational future-research paradigm, not support for relaying interventions already started at disposition.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "background",
     "note": "The 4AT instrument grounds the 'screen used' handoff item; it contains no management or handoff content and does not address interventions started in the ED.",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": []
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "background",
     "note": "GED 2.0 addresses only risk stratification, diagnosis, and brain imaging in the ED; it does not cover delirium management/interventions or disposition handoff, so it does not speak to this claim.",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": []
    },
    {
     "label": "SIGN 157",
     "cite": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Nearest match on the handoff concept, but broader in scope and about the diagnosis rather than the interventions started.",
     "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
     "paragraphs": [
      {
       "context": "99 Where delirium is detected, the diagnosis of delirium should be clearly documented and coded to aid transfers of care (eg handover notes, referral and discharge letters).",
       "highlight": "to aid transfers of care (eg handover notes, referral and discharge letters)",
       "scope": "broader",
       "note": "Directs documenting/coding the delirium diagnosis at all transfers of care (ED and acute hospital) — a wider-scope handover recommendation that centers on the diagnosis, not the ED interventions started.",
       "page": "",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "partial",
     "note": "Different care setting and about documenting the diagnosis rather than the interventions started; the nearest analog to the handoff item.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "Ensure that the diagnosis of delirium is documented both in the person's record or notes, and in their primary care health record.",
       "highlight": "the diagnosis of delirium is documented both in the person's record",
       "scope": "different-setting",
       "note": "Hospital and long-term care (not ED) and framed as documenting the diagnosis in the record rather than relaying the ED interventions started at disposition.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary, ED-specific source (p. 7): directs handing delirium off to the receiving inpatient team and describes the Prevent/Treat interventions started in the ED — the governing basis for this handoff item.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "An ED length of stay of greater than 10 hours has been demonstrated to double the risk for incident delirium.43 Therefore, systems measures and protocols that reduce ED length of stay and avoid boarding patients in hallways should be considered for patients at risk of delirium. Prioritizing the transfer of older or frail patients to floor beds when they become available is one potential measure. In addition, it is important that the ED clinicians and nursing staff communicate the presence of delirium or agitation to the inpatient team. When the diagnosis of delirium is not made in the ED, it is also more likely to be missed by the inpatient teams,1 so it is important that the diagnosis be communicated explicitly.",
       "highlight": "communicate the presence of delirium or agitation to the inpatient team",
       "scope": "on-scope",
       "note": "ED-specific direction to explicitly hand off delirium to the receiving inpatient team at disposition — the governing basis for the handoff script.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "If the patient is agitated, it is imperative to calm and protect him or her and staff, and to allow the patient to participate in care to whatever extent is possible. Nonpharmacologic interventions such as verbal de-escalation, distraction, and reassurance can be used with assistance from sitters, family, or staff.45-47 Successful de-escalation helps the patient regain control without need for further treatment45,48 and may even be effective in patients with cognitive deficits such as dementia.49 A video recording message of family members can also help calm and de-escalate agitated older patients.50 Medications may be needed if the above measures fail. However, if at all possible, physical restraints should be avoided because they can lead to injuries.51 If nonpharmacologic management and verbal de-escalation are unsuccessful, pharmacologic interventions may be necessary.",
       "highlight": "Nonpharmacologic interventions such as verbal de-escalation, distraction, and reassurance",
       "scope": "on-scope",
       "note": "Describes the nonpharmacologic ('Treat') interventions started in the ED that the handoff item asks the clinician to relay to the receiving team.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "Although the measures just discussed can be accomplished in any ED, other measures require hospital- or systems-based organization and planning. Providing large-font clocks and other visual cues about the date and location can help self-orientation.38 In addition, promoting and creating a culture that encourages family members and caregivers who demonstrate a calming presence to remain at the bedside can be helpful.29 If feasible, volunteers can be trained to help redirect and calm patients.39 Patients with delirium are at higher risk for falls,40 so measures should be taken to help prevent injury while still promoting mobility, if possible. Some measures include low beds, getting out of bed to chairs, physical therapy, nonslip floors or socks, and 1:1 sitters.41,42 An ED length of stay of greater than 10 hours has been demonstrated to double the risk for incident delirium.43 Therefore, systems measures and protocols that reduce ED length of stay and avoid boarding patients in hallways should be considered for patients at risk of delirium.",
       "highlight": "low beds, getting out of bed to chairs, physical therapy, nonslip floors or socks, and 1:1 sitters",
       "scope": "on-scope",
       "note": "Describes the 'Prevent' interventions (mobility measures, sitters) initiated in the ED — part of the 'interventions started' content being handed off.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ED study; supports notifying the receiving team of delirium at admission and situates delirium interventions within the ED course.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": [
      {
       "context": "Once delirium is diagnosed in the ED, the diagnostic evaluation should then focus on uncovering the underlying etiology.48 Infections, such as a urinary tract infection or pneumonia, dehydration, electrolyte abnormalities, central nervous system insults, and medication reactions are common causes.32 If admitted, physicians at the next level of care should be notified of the patient's delirium status. Other than these interventions, however, the optimal management of delirium is still unclear, especially within the ED setting. Several multi-component delirium interventions have been developed for hospitalized patients and can be tailored for the ED,49, 50 but their efficacy is questionable.51 Because many of these interventions were started 24 to 48 hours after admission, early detection and early intervention of delirium in the ED may improve their effectiveness similar to what has been observed in sepsis and ST-elevation myocardial infarction care.52, 53 A multi-faceted line of research must be undertaken to develop delirium interventions specifically tailored for the ED setting and determine their cost-effectiveness using randomized control trial methodology.",
       "highlight": "physicians at the next level of care should be notified of the patient's delirium status",
       "scope": "on-scope",
       "note": "Directly supports handing off delirium status to the receiving team at admission; the same paragraph frames delirium interventions as occurring within the ED course.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    }
   ],
   "synthesis": "The ED-specific ADEPT tool governs (primary, p. 7): it directs ED clinicians to communicate delirium to the receiving inpatient team and describes the nonpharmacologic ('Treat') and preventive interventions started in the ED, and Han 2010 concurs that the next level of care should be notified at admission. SIGN 157 and NICE CG103 are nearest-topic matches at a different scope — documenting/handing over the delirium diagnosis across all care transitions or in hospital/long-term care rather than the ED interventions specifically — while GED 2.0, Han 2013, and the 4AT are screening/diagnosis sources that do not address management or handoff, so ADEPT remains the on-scope source that governs this claim.",
   "discrepancy": true
  },
  {
   "id": "ed-wf-r15",
   "toolId": "ed-wf",
   "tool": "ED Workflow",
   "page": "1",
   "section": "Disposition hand-off script",
   "statement": "Reassessment / follow-up plan for the admitting or receiving team",
   "contentType": "Cited clinical content",
   "sources": [
    "Han 2013 (DTS/bCAM)",
    "4AT v1.2",
    "GED Guidelines 2.0 (2026)",
    "SIGN 157",
    "NICE CG103",
    "ADEPT (2020)",
    "Han 2010"
   ],
   "anchor": "ADEPT (2020) — p. 7",
   "passage": "… Some measures include low beds, getting out of bed to chairs, physical therapy, nonslip floors or socks, and 1:1 sitters.41,42 An ED length of stay of greater than 10 hours has been demonstrated to double the risk for incident delirium.43 Therefore, systems measures and protocols that reduce ED length of stay and avoid boarding patients in hallways should be considered for patients at risk of delirium. Prioritizing the transfer of older or frail patients to floor beds when they become available is one potential measure. In addition, it is important that the ED clinicians and nursing staff communicate the presence of delirium or agitation to the inpatient team . When the diagnosis of delirium is not made in the ED, it is also more likely to be missed by the inpatient teams,1 so it is important that the diagnosis be communicated explicitly. TREAT The fifth is \"Treat.\" The overall goal for treatment of delirium in the ED is to identify and address the underlying cause while avoiding actions or inactions that may worsen delirium. Following the preventive steps outlined in this review will assist with these goals. Some patients may require additional interventions or medications to successfully and safely manage their agitation.44 If the patient is agitated, it is imperative to calm and protect him or her and staff, and to allow the patient to participate in care to whatever extent is possible. …\nADEPT supports handing the finding off to the admitting team, and NICE and SIGN similarly call for follow-up and documentation in the record. The statement is a structural checklist item rather than a discrete clinical claim.",
   "evidence": "Full text, p. 7 — partial support",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
    "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
    "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
    "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
    "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
    "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
    "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252."
   ],
   "links": [
    "https://doi.org/10.1016/j.annemergmed.2013.05.003",
    "https://www.the4at.com/",
    "https://doi.org/10.1111/acem.70167",
    "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
    "https://www.nice.org.uk/guidance/cg103",
    "https://doi.org/10.1016/j.annemergmed.2019.07.023",
    "https://doi.org/10.1016/j.annemergmed.2010.03.003"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Han 2013 (DTS/bCAM)",
     "cite": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
     "kind": "pdf",
     "stance": "background",
     "note": "Provides the rationale for a delirium hand-off (ED-missed delirium stays missed in the inpatient setting) but does not itself recommend a follow-up plan.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
     "paragraphs": [
      {
       "context": "likely to comprehend their discharge instructions which may lead to decreased compliance.16, 19 Lastly, if admitted, delirium that is missed in the ED will also be missed in the inpatient setting in over 90% of cases.13 Delirium is often clinically silent and will remain unrecognized without a formal delirium assessment.",
       "highlight": "delirium that is missed in the ED will also be missed in the inpatient setting in over 90% of cases",
       "scope": "background",
       "note": "Supplies the justification for communicating delirium at disposition rather than describing the hand-off/follow-up plan itself.",
       "page": "ms. p.2",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    },
    {
     "label": "4AT v1.2",
     "cite": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "A bedside screening instrument only; it does not address disposition hand-off or follow-up planning for the receiving team.",
     "docUrl": "https://www.the4at.com/",
     "paragraphs": []
    },
    {
     "label": "GED Guidelines 2.0 (2026)",
     "cite": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
     "kind": "pdf",
     "stance": "not_stated",
     "note": "This GRADE guideline is scoped to ED delirium risk stratification, diagnosis, and brain imaging and does not address the disposition hand-off or a follow-up plan for the admitting team.",
     "docUrl": "https://doi.org/10.1111/acem.70167",
     "paragraphs": []
    },
    {
     "label": "SIGN 157",
     "cite": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "General-delirium national guideline; agrees that the diagnosis be documented to aid transfers of care and that follow-up be arranged with primary care, but as broad hospital/community guidance rather than an ED-specific disposition script.",
     "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
     "paragraphs": [
      {
       "context": "99 Where delirium is detected, the diagnosis of delirium should be clearly documented and coded to aid transfers of care (eg handover notes, referral and discharge letters).",
       "highlight": "documented and coded to aid transfers of care (eg handover notes, referral and discharge letters)",
       "scope": "broader",
       "note": "Directs documentation of delirium to aid transfers of care/handover notes across all settings (including ED), broader than the ED disposition hand-off in the claim.",
       "page": "5",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      },
      {
       "context": "impairment which may have been undetected, or exacerbated in the context of delirium. Appropriate cognitive and functional assessment should be considered. Timing of this assessment must take into account persistent delirium. RIn patients who have experienced delirium in ICU consideration should be given to follow up for psychological sequelae including cognitive impairment. 99 Patient records should be coded to highlight a previous episode of delirium so that hospital staff are aware of the increased risk on readmission. 99 Ensure that delirium is noted in the discharge letter for the primary care team. 99 All patients who have had delirium should be reviewed by the primary care team.",
       "highlight": "All patients who have had delirium should be reviewed by the primary care team.",
       "scope": "broader",
       "note": "Supports a follow-up plan for the receiving/primary-care team, but from the general post-episode follow-up section, not an ED disposition workflow.",
       "page": "21",
       "docUrl": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "General hospital/long-term-care guideline; agrees that the delirium diagnosis be documented in the record and primary care health record for continuity, broader than the ED-specific hand-off.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "Ensure that the diagnosis of delirium is documented both in the person's record or notes, and in their primary care health record.",
       "highlight": "the diagnosis of delirium is documented both in the person's record",
       "scope": "broader",
       "note": "Recommendation 1.6.4 requires documenting the diagnosis in the person's record and their primary care health record, supporting continuity/hand-off across all care settings rather than the ED disposition script specifically.",
       "page": "",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "ADEPT (2020)",
     "cite": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "The on-scope, ED-specific governing source (primary anchor, p.7): explicitly directs ED clinicians to communicate delirium to the inpatient team at disposition so it is not missed.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
     "paragraphs": [
      {
       "context": "An ED length of stay of greater than 10 hours has been demonstrated to double the risk for incident delirium.43 Therefore, systems measures and protocols that reduce ED length of stay and avoid boarding patients in hallways should be considered for patients at risk of delirium. Prioritizing the transfer of older or frail patients to floor beds when they become available is one potential measure. In addition, it is important that the ED clinicians and nursing staff communicate the presence of delirium or agitation to the inpatient team. When the diagnosis of delirium is not made in the ED, it is also more likely to be missed by the inpatient teams,1 so it is important that the diagnosis be communicated explicitly.",
       "highlight": "communicate the presence of delirium or agitation to the inpatient team",
       "scope": "on-scope",
       "note": "Directly supports the disposition hand-off item: ED staff must communicate delirium to the admitting/inpatient team, and communicate the diagnosis explicitly.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      },
      {
       "context": "If nonpharmacologic management and verbal de-escalation are unsuccessful, pharmacologic interventions may be necessary. It is important to select medications carefully, dose them appropriately, and reassess their effects frequently. All available antipsychotics and benzodiazepines are listed as potentially inappropriate by the Beers criteria, and even at low doses, these medications may have increased adverse effects such as prolonged sedation or paradoxic agitation (with benzodiazepines) in older patients.52,53 In addition, all Author Manuscript Author Manuscript Ann Emerg Med.",
       "highlight": "reassess their effects frequently",
       "scope": "different-intervention",
       "note": "Nearest match sharing the word 'reassess' but concerns frequent reassessment of agitation-medication effects, not a hand-off/follow-up reassessment plan for the receiving team.",
       "page": "ms. p.7",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    },
    {
     "label": "Han 2010",
     "cite": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope ED source: directs that on admission the next level of care be notified of the patient's delirium status.",
     "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
     "paragraphs": [
      {
       "context": "Once delirium is diagnosed in the ED, the diagnostic evaluation should then focus on uncovering the underlying etiology.48 Infections, such as a urinary tract infection or pneumonia, dehydration, electrolyte abnormalities, central nervous system insults, and medication reactions are common causes.32 If admitted, physicians at the next level of care should be notified of the patient's delirium status. Other than these interventions, however, the optimal management of delirium is still unclear, especially within the ED setting. Several multi-component delirium interventions have been developed for hospitalized patients and can be tailored for the ED,49, 50 but their efficacy is questionable.51 Because many of these interventions were started 24 to 48 hours after admission, early detection and early intervention of delirium in the ED may improve their effectiveness similar to what has been observed in sepsis and ST-elevation myocardial infarction care.52, 53 A multi-faceted line of research must be undertaken to develop delirium interventions specifically tailored for the ED setting and determine their cost-effectiveness using randomized control trial methodology.",
       "highlight": "physicians at the next level of care should be notified of the patient's delirium status",
       "scope": "on-scope",
       "note": "Directly supports the hand-off item — the admitting/receiving team must be notified of delirium status at disposition.",
       "page": "ms. p.8",
       "docUrl": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    }
   ],
   "synthesis": "The ED-specific sources govern and agree: ADEPT (p.7, the primary anchor) and Han 2010 both direct that a patient's delirium be explicitly communicated to the inpatient/next-level-of-care team at disposition, which is exactly the hand-off item claimed. SIGN 157 and NICE CG103 concur but as broader general-delirium guidance (document the diagnosis to aid transfers of care and arrange primary-care follow-up), Han 2013 supplies only the rationale, GED2 and the 4AT do not address hand-off, and one nearest match (ADEPT's advice to \"reassess their effects frequently\") shares the word \"reassess\" yet refers to agitation-medication monitoring, not a follow-up plan.",
   "discrepancy": true
  },
  {
   "id": "sd-cards-r3",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "1",
   "section": "Arousal card — RASS scale",
   "statement": "Richmond Agitation-Sedation Scale, 10 levels: +4 Combative (overtly combative/violent; immediate danger to staff) … 0 Alert & calm … −5 Unarousable (no response to voice or physical stimulation).",
   "contentType": "Validated instrument wording",
   "sources": [
    "Sessler 2002 (RASS)",
    "Ely 2003 (RASS)",
    "Han 2015 (RASS in the ED)",
    "Chester 2012 (mRASS)"
   ],
   "anchor": "Han 2015 (RASS in the ED) — p. 3",
   "passage": "For this study, we replaced the term “sedation” with “drowsy,” (Figure 1) to describe level of consciousness regardless of sedation administration. A RASS of 0 represented normal level of consciousness whereas a RASS other than 0 represented the presence of altered level of consciousness.\nAlso Beyer 2024 (CAM-IMC) (p. 6): “° RASS ranges from − 5 (deeply sedated) to + 4 (aggressive)”\nThe 10 anchor descriptors printed on the card are the canonical Richmond Agitation-Sedation Scale wording (Sessler 2002; Ely 2003), which the tool cites but which is not held in the local reference archive. The archived sources confirm the scale's use and structure rather than each descriptor string: Han 2015 relabels the sedation levels 'drowsy' (matching the card's '−1 Drowsy') and confirms RASS 0 = normal / any RASS ≠ 0 = altered; Beyer 2024 confirms the −5 to +4 range. Verify the individual anchor strings against Sessler 2002 / Ely 2003.",
   "evidence": "Validated instrument — anchor wording per Sessler 2002 / Ely 2003 (not in local archive); use confirmed in Han 2015 (p. 3) & Beyer 2024 (p. 6)",
   "status": "instrument",
   "pageNum": "3",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
    "Ely EW, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA 2003;289:2983.",
    "Han JH, et al. The diagnostic performance of the RASS for detecting delirium in older ED patients. Acad Emerg Med 2015;22:878.",
    "Chester JG, et al. Serial administration of a modified RASS for delirium screening. J Hosp Med 2012;7:450."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1001/jama.289.22.2983",
    "https://doi.org/10.1111/acem.12706",
    "https://doi.org/10.1002/jhm.1003"
   ],
   "decision": "",
   "notes": "RASS anchor strings trace to Sessler 2002 / Ely 2003, cited but not archived locally.",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Original derivation and validation of the RASS in adult ICU patients (Am J Respir Crit Care Med 2002;166:1338); the primary source of the 10-level scale and endpoint descriptors reproduced in the claim, cited by citation/DOI (no archived text file here).",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Ely 2003 (RASS)",
     "cite": "Ely EW, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA 2003;289:2983.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Validation study in adult medical/coronary ICU patients whose Table 1 reproduces the full 10-level RASS with the exact endpoint wording quoted in the claim; the ICU population does not narrow the scale definition, so this is the on-scope governing source.",
     "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
     "paragraphs": [
      {
       "context": "The Richmond Agitation-Sedation Scale (RASS) was developed by a multidisciplinary team at Virginia Commonwealth University in Richmond. It is a 10-point scale that can be rated briefly using 3 clearly defined steps and that has discrete criteria for levels of sedation and agitation.",
       "highlight": "It is a 10-point scale",
       "scope": "on-scope",
       "note": "Read from the printed page. The text layer runs these words together and drops the hyphen in \"10-point\" at a line break.",
       "page": "2984",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      },
      {
       "context": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
       "highlight": "+4 Combative — Overtly combative, violent, immediate danger to staff",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed; the table’s term and description columns are joined with an em dash so each row reads as one line. The two ten-second anchors are −1 at more than 10 seconds and −2 at under 10 seconds — the distinction between them is the direction of that comparison.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      },
      {
       "context": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
       "highlight": "0 Alert and calm",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed; the table’s term and description columns are joined with an em dash so each row reads as one line. The two ten-second anchors are −1 at more than 10 seconds and −2 at under 10 seconds — the distinction between them is the direction of that comparison.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      },
      {
       "context": "Table 1. The Richmond Agitation-Sedation Scale (RASS). Score, term, description. +4 Combative — Overtly combative, violent, immediate danger to staff. +3 Very agitated — Pulls or removes tube(s) or catheter(s); aggressive. +2 Agitated — Frequent nonpurposeful movement, fights ventilator. +1 Restless — Anxious but movements not aggressive or vigorous. 0 Alert and calm. −1 Drowsy — Not fully alert, but has sustained awakening (eye opening/eye contact) to voice (>10 seconds). −2 Light sedation — Briefly awakens with eye contact to voice (<10 seconds). −3 Moderate sedation — Movement or eye opening to voice (but no eye contact). The −1 to −3 rows are bracketed in the table as verbal stimulation. −4 Deep sedation — No response to voice, but movement or eye opening to physical stimulation. −5 Unarousable — No response to voice or physical stimulation. The −4 and −5 rows are bracketed as physical stimulation.",
       "highlight": "−5 Unarousable — No response to voice or physical stimulation",
       "scope": "on-scope",
       "note": "Transcribed from Table 1 as printed; the table’s term and description columns are joined with an em dash so each row reads as one line. The two ten-second anchors are −1 at more than 10 seconds and −2 at under 10 seconds — the distinction between them is the direction of that comparison.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      }
     ]
    },
    {
     "label": "Han 2015 (RASS in the ED)",
     "cite": "Han JH, et al. The diagnostic performance of the RASS for detecting delirium in older ED patients. Acad Emerg Med 2015;22:878.",
     "kind": "pdf",
     "stance": "partial",
     "note": "The card's primary citation presents the same scale as its Figure 1, but the study is set in older ED patients and its extractable text describes the RASS (relabeling 'sedation' as 'drowsy') without spelling out the 10 levels, so it partially and at a different setting supports the claim rather than governing the endpoint wording.",
     "docUrl": "https://doi.org/10.1111/acem.12706",
     "paragraphs": [
      {
       "context": "A RASS of 0 represented normal level of consciousness whereas a RASS other than 0 represented the presence of altered level of consciousness.",
       "highlight": "A RASS of 0 represented normal level of consciousness",
       "scope": "different-setting",
       "note": "Page 3 Study Protocol identifies the RASS via its Figure 1 but applies it to older ED patients and relabels 'sedation' as 'drowsy'; this sentence describes the 0-vs-not-0 endpoints rather than enumerating the 10 levels, so it is a same-instrument/different-setting reference, not the source of the level descriptors.",
       "page": "3",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      },
      {
       "context": "The Richmond Agitation Sedation Scale (RASS; Figure 1), which quantifies level of consciousness, may be a reasonable alternative to delirium screening in the ED.",
       "highlight": "which quantifies level of consciousness",
       "scope": "background",
       "note": "Introduction confirms the RASS quantifies level of consciousness, establishing the instrument's identity but not the enumerated level descriptors.",
       "page": "2",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      }
     ]
    },
    {
     "label": "Chester 2012 (mRASS)",
     "cite": "Chester JG, et al. Serial administration of a modified RASS for delirium screening. J Hosp Med 2012;7:450.",
     "kind": "pdf",
     "stance": "background",
     "note": "Evaluates a modified RASS (mRASS) in VA medical inpatients; it references the RASS as an ICU-validated consciousness scale but studies a different instrument and does not carry the 10-level enumeration, making it a different-intervention nearest match.",
     "docUrl": "https://doi.org/10.1002/jhm.1003",
     "paragraphs": [
      {
       "context": "The RASS is an observational instrument that has been validated in the ICU setting for objectively determining level of sedation. It has been shown to be highly reliable and associated with delirium.14-15 The RASS is a quick, objective scale of consciousness with a scoring system that captures both hyperactive and hypoactive levels of consciousness. A disadvantage of using the RASS includes its limited attention assessment. The Consensus panel modified the RASS to improve its assessment of attention, using a brief open-ended question that was asked prior to scoring (\"Describe how you are feeling today\") (Figure 1).",
       "highlight": "The Consensus panel modified the RASS to improve its assessment of attention",
       "scope": "different-intervention",
       "note": "Chester describes the standard RASS generically but the study validates a modified RASS (adds an open-ended inattention prompt) in older VA medical inpatients and does not enumerate the 10 standard levels, so it is a nearest match at a different intervention, not direct support for the standard RASS enumeration.",
       "page": "3",
       "docUrl": "https://doi.org/10.1002/jhm.1003"
      }
     ]
    }
   ],
   "synthesis": "All four sources concern the same instrument, the Richmond Agitation-Sedation Scale, and the claim's exact 10-level enumeration with endpoint wording (\"+4 Combative … immediate danger to staff\", \"0 Alert and calm\", \"−5 Unarousable … no response to voice or physical stimulation\") is reproduced verbatim in Ely 2003 Table 1 (explicitly a \"10-point scale\", originally derived by Sessler 2002), which is the on-scope governing source. Han 2015 — the card's primary citation — presents the same scale as its Figure 1 but studies it in older ED patients and relabels \"sedation\" as \"drowsy,\" and Chester 2012 evaluates a modified RASS (mRASS) in VA medical inpatients, so both are nearest matches at a different scope rather than the source of the standard endpoint descriptors.",
   "discrepancy": true
  },
  {
   "id": "sd-cards-r4",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "1",
   "section": "Arousal card — administration",
   "statement": "Score arousal first (Look, then Talk, then Touch). It is the CAM-IMC’s level-of-consciousness item.",
   "contentType": "Cited clinical content",
   "sources": [
    "Sessler 2002 (RASS)",
    "Ely 2003 (RASS)",
    "Han 2015 (RASS in the ED)",
    "Chester 2012 (mRASS)",
    "Beyer 2024 (CAM-IMC)"
   ],
   "anchor": "Han 2015 (RASS in the ED) — p. 2",
   "passage": "It takes less than 10 seconds to perform and can be assessed for by simply observing the patient during routine clinical care and does not require additional cognitive testing.\nAlso Beyer 2024 (CAM-IMC) (p. 3): “The elements “Acute change or fluctuating course of mental status” and “Altered level of consciousness” are dichotomous, allowing for the assignment of one point for an abnormal test result.”\nThe Look / Talk / Touch framing restates the standard RASS administration (observe, then rouse to voice, then to physical stimulation), whose stepwise-stimulus wording lives in the Sessler 2002 anchors (not archived). Han 2015 confirms the RASS is scored by observing the patient during routine care (p. 2); Beyer 2024 confirms the RASS is the CAM-IMC's level-of-consciousness item (p. 3). 'Look, then Talk, then Touch' is a mnemonic for the standard escalating-stimulus procedure, not a phrase quoted from a source.",
   "evidence": "Validated instrument procedure (Sessler 2002, not archived); RASS-as-LOC-item per Beyer 2024, p. 3 — partial support",
   "status": "instrument",
   "pageNum": "3",
   "citations": [
    "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
    "Ely EW, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA 2003;289:2983.",
    "Han JH, et al. The diagnostic performance of the RASS for detecting delirium in older ED patients. Acad Emerg Med 2015;22:878.",
    "Chester JG, et al. Serial administration of a modified RASS for delirium screening. J Hosp Med 2012;7:450.",
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451."
   ],
   "links": [
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1001/jama.289.22.2983",
    "https://doi.org/10.1111/acem.12706",
    "https://doi.org/10.1002/jhm.1003",
    "https://doi.org/10.1186/s12871-024-02849-3"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Original RASS validation paper (Am J Respir Crit Care Med 2002;166:1338), cited by reference; it defines the RASS instrument and its stepwise observe-then-verbal-then-physical scoring procedure that the 'Look, Talk, Touch' administration is built on. Not archived as full text here.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Ely 2003 (RASS)",
     "cite": "Ely EW, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA 2003;289:2983.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "ICU / mechanically ventilated validation cohort, but the three-step scoring sequence is the instrument definition and setting-independent; supports the administration clause ('score arousal first, Look/Talk/Touch'), not the CAM-IMC clause.",
     "docUrl": "https://doi.org/10.1001/jama.289.22.2983",
     "paragraphs": [
      {
       "context": "performed the RASS using the same sequence of 3 steps as outlined in Table 1. If the patients were alert or agitated prior to stimulation, they were scored 0 to+4 accordingly. If patients were not spontaneously alert, they were then called by name to look at the rater, with the duration of eye contact measured, at which time a positive response was scored accordingly as -1 to -3. If the patients did not respond to verbal stimulation, they were then physically stimulated (ie, shoulder shake and/or sternal rub) and scored according to their response as -4 or -5. If calm and not alert prior to verbal and physical stimulation, patients were then rated as -1 to -5 (as standardized in Table 1) even if they became agitated on stimulation. Assessments required less than 20 seconds.",
       "highlight": "If the patients did not respond to verbal stimulation, they were then physically stimulated",
       "scope": "on-scope",
       "note": "Documents the RASS scoring order: observe, then call by name to look (Look/Talk), then physical stimulation (Touch) - directly supporting 'score arousal first (Look, then Talk, then Touch).'",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      },
      {
       "context": "Procedure for RASS Assessment 1. Observe patient Patient is alert, restless, or agitated. 2. If not alert, state patient's name and say to open eyes and look at speaker. Patient awakens with sustained eye opening and eye contact. Patient awakens with eye opening and eye contact, but not sustained. Patient has any movement in response to voice but no eye contact. 3. When no response to verbal stimulation, physically stimulate patient by shaking shoulder and/or rubbing sternum. Patient has any movement to physical stimulation. Patient has no response to any stimulation.",
       "highlight": "When no response to verbal stimulation, physically stimulate patient by shaking shoulder and/or rubbing sternum",
       "scope": "on-scope",
       "note": "The RASS Procedure table's three ordered steps (Observe, then verbal, then physical) are the canonical Look/Talk/Touch administration sequence.",
       "page": "2985",
       "docUrl": "https://doi.org/10.1001/jama.289.22.2983"
      }
     ]
    },
    {
     "label": "Han 2015 (RASS in the ED)",
     "cite": "Han JH, et al. The diagnostic performance of the RASS for detecting delirium in older ED patients. Acad Emerg Med 2015;22:878.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Named primary anchor (p.2). Supports RASS-as-level-of-consciousness for delirium in principle, but Han's setting is the emergency department and its RASS is a standalone screen, so it is a different-setting nearest match rather than direct support for the step-down CAM-IMC claim; it does not describe the Look/Talk/Touch steps.",
     "docUrl": "https://doi.org/10.1111/acem.12706",
     "paragraphs": [
      {
       "context": "Altered level of consciousness is often observed in delirium and is key feature in several delirium assessments.",
       "highlight": "Altered level of consciousness is often observed in delirium and is key feature in several delirium assessments",
       "scope": "different-setting",
       "note": "Nearest match: altered level of consciousness is a key delirium feature that the RASS captures, but studied as a standalone screen in older ED patients, not the step-down/IMC CAM-IMC context.",
       "page": "2",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      },
      {
       "context": "The RASS is an arousal scale commonly used in intensive care units to assess for depth of sedation (Figure 1),10 but has been incorporated into several delirium assessments to assess for level of consciousness.6 For this study, we replaced the term \"sedation\" with \"drowsy,\" (Figure 1) to describe level of consciousness regardless of sedation administration. A RASS of 0 represented normal level of consciousness whereas a RASS other than 0 represented the presence of altered level of consciousness. The RASS was determined by an emergency physician (EP) and research assistants (RAs; college graduates, emergency medical technicians, and paramedics). Before the study began, the RAs were given a 5-minute didactic lecture about the RASS. The principal investigator then observed them perform the RASS in five older ED patients and provided them instruction if there was any discordance.",
       "highlight": "has been incorporated into several delirium assessments to assess for level of consciousness",
       "scope": "background",
       "note": "General framing that RASS serves as the level-of-consciousness measure within delirium assessments - conceptually parallels the CAM-IMC LOC-item clause but does not name CAM-IMC.",
       "page": "3",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      }
     ]
    },
    {
     "label": "Chester 2012 (mRASS)",
     "cite": "Chester JG, et al. Serial administration of a modified RASS for delirium screening. J Hosp Med 2012;7:450.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Modified-RASS ward-inpatient study; supports the underlying principle (arousal/RASS quantifies level of consciousness for delirium) but via a different instrument and population, and does not address the standard Look/Talk/Touch sequence or the CAM-IMC.",
     "docUrl": "https://doi.org/10.1002/jhm.1003",
     "paragraphs": [
      {
       "context": "The RASS is an observational instrument that has been validated in the ICU setting for objectively determining level of sedation. It has been shown to be highly reliable and associated with delirium.14-15 The RASS is a quick, objective scale of consciousness with a scoring system that captures both hyperactive and hypoactive levels of consciousness. A disadvantage of using the RASS includes its limited attention assessment. The Consensus panel modified the RASS to improve its assessment of attention, using a brief open-ended question that was asked prior to scoring (\"Describe how you are feeling today\") (Figure 1).",
       "highlight": "The Consensus panel modified the RASS to improve its assessment of attention, using a brief open-ended question that was asked prior to scoring",
       "scope": "different-intervention",
       "note": "Nearest match: treats RASS as an objective scale of consciousness for delirium, but the instrument studied is the MODIFIED RASS (adds an inattention question) in older VA medical inpatients - a different intervention/population.",
       "page": "3",
       "docUrl": "https://doi.org/10.1002/jhm.1003"
      }
     ]
    },
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "cite": "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Non-intubated intermediate-care / cardiac-surgery patients - the step-down setting matching the card; the governing on-scope source for the 'CAM-IMC's level-of-consciousness item' clause.",
     "docUrl": "https://doi.org/10.1186/s12871-024-02849-3",
     "paragraphs": [
      {
       "context": "Background Disorientation is an early indicator of developing postoperative delirium (POD), which is associated with increased mortality and cognitive decline. The well-established \"Confusion-Assessment-Method-for-IntensiveCare-Unit\" (CAM-ICU) for diagnosing POD in intubated patients cannot make use of the feature `disorientation', as this requires verbal communication. Other tools such as the 4AT test for disorientation but are not established in ICU settings. We therefore combined test-variables of the CAM-ICU (level of consciousness, fluctuating mental status and inattention) with verbal testing for disorientation to develop and enhance diagnostic accuracy of the \"Confusion Assessment Method for Intermediate Care Unit\" (CAM-IMC). In the present study we describe the development and the evaluation of the diagnostic accuracy of the CAM-IMC.",
       "highlight": "test-variables of the CAM-ICU (level of consciousness, fluctuating mental status and inattention)",
       "scope": "on-scope",
       "note": "Level of consciousness is one of the CAM-IMC's constituent test-variables, directly supporting 'It is the CAM-IMC's level-of-consciousness item.'",
       "page": "1",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "The elements “Acute change or fluctuating course of mental status” and “Altered level of consciousness” are dichotomous, allowing for the assignment of one point for an abnormal test result.",
       "highlight": "“Altered level of consciousness” are dichotomous, allowing for the assignment of one point for an abnormal test result",
       "scope": "on-scope",
       "note": "The CAM-IMC's point-based scoring names 'Altered level of consciousness' as a dichotomous element scoring one point for an abnormal result — the tool's level-of-consciousness item.",
       "page": "3",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "By creating the CAM-IMC flowchart design as a pointbased scoring system, the importance of disorientation as a central feature of POD has been reinforced. The features disorientation and inattention can each trigger a positive test result. The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome. This is reflected in their limited ability to discriminate POD, as shown by a distinct lower AUROC compared to disorientation, inattention and overall CAM-IMC. As a result, disorientation and inattention exert the greatest influence Beyer et al.",
       "highlight": "each contribute one point to the total score but are not mandatory for a positive test outcome",
       "scope": "on-scope",
       "note": "The level-of-consciousness element is operationalized via RASS (RASS other than 0), confirming arousal/RASS is the CAM-IMC's LOC item; note it contributes one point and is not the gating step.",
       "page": "5",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      }
     ]
    }
   ],
   "synthesis": "The statement's two clauses are supported by different on-scope sources: the RASS administration sequence (score arousal first, observe-then-verbal-then-physical = Look/Talk/Touch) is defined by Sessler 2002 and validated by Ely 2003, while 'altered level of consciousness' is confirmed as a CAM-IMC element operationalized by RASS in Beyer 2024, whose non-intubated intermediate-care setting matches the step-down card. Han 2015 (the named primary anchor) and Chester 2012 agree in principle that RASS quantifies level of consciousness for delirium but are different-scope nearest matches (Han: ED, standalone screen; Chester: modified RASS in ward inpatients), so Beyer 2024 governs the CAM-IMC clause and Ely/Sessler govern the administration sequence; all sources are mutually consistent with no contradiction.",
   "discrepancy": true
  },
  {
   "id": "sd-cards-r5",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "1",
   "section": "Arousal card — gate (altered)",
   "statement": "Any RASS other than 0 → altered arousal — scores the CAM-IMC level-of-consciousness point (+1).",
   "contentType": "Cited clinical content",
   "sources": [
    "Beyer 2024 (CAM-IMC)",
    "Han 2015 (RASS in the ED)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 3",
   "passage": "The elements “Acute change or fluctuating course of mental status” and “Altered level of consciousness” are dichotomous, allowing for the assignment of one point for an abnormal test result.\nAlso Beyer 2024 (CAM-IMC) (p. 5): “The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome.”\nAlso Beyer 2024 (CAM-IMC) (p. 8): “RASS ≠ 0 and disorientation are binary”\nAlso Han 2015 (RASS in the ED) (p. 3): “A RASS of 0 represented normal level of consciousness whereas a RASS other than 0 represented the presence of altered level of consciousness.”\nFully supported. In the CAM-IMC the altered-level-of-consciousness element is dichotomous and any RASS other than 0 contributes exactly one point (Beyer 2024, p. 3, p. 5, and the Table footnote 'RASS ≠ 0 … are binary', p. 8). Han 2015 independently confirms RASS 0 = normal and any RASS other than 0 = altered level of consciousness (p. 3).",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451.",
    "Han JH, et al. The diagnostic performance of the RASS for detecting delirium in older ED patients. Acad Emerg Med 2015;22:878."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3",
    "https://doi.org/10.1111/acem.12706"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "cite": "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary on-scope source: the CAM-IMC validation paper that defines the arousal/level-of-consciousness point.",
     "docUrl": "https://doi.org/10.1186/s12871-024-02849-3",
     "paragraphs": [
      {
       "context": "By creating the CAM-IMC flowchart design as a pointbased scoring system, the importance of disorientation as a central feature of POD has been reinforced. The features disorientation and inattention can each trigger a positive test result. The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome. This is reflected in their limited ability to discriminate POD, as shown by a distinct lower AUROC compared to disorientation, inattention and overall CAM-IMC. As a result, disorientation and inattention exert the greatest influence Beyer et al.",
       "highlight": "RASS0 have been reduced in significance and each contribute one point to the total score",
       "scope": "on-scope",
       "note": "Directly states that in the CAM-IMC scoring a RASS other than 0 (rendered 'RASS0' where the not-equals symbol was lost in text extraction) contributes one point — exactly the arousal-card level-of-consciousness point (+1).",
       "page": "5",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "The elements “Acute change or fluctuating course of mental status” and “Altered level of consciousness” are dichotomous, allowing for the assignment of one point for an abnormal test result.",
       "highlight": "allowing for the assignment of one point for an abnormal test result",
       "scope": "on-scope",
       "note": "Defines the altered level-of-consciousness element as dichotomous, scoring one point for an abnormal result — the CAM-IMC LOC point the arousal gate awards.",
       "page": "3",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome.",
       "highlight": "RASS≠0 have been reduced in significance and each contribute one point to the total score",
       "scope": "on-scope",
       "note": "Discussion states the RASS≠0 category contributes one point to the total score — the level-of-consciousness point any non-zero RASS awards.",
       "page": "8",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      }
     ]
    },
    {
     "label": "Han 2015 (RASS in the ED)",
     "cite": "Han JH, et al. The diagnostic performance of the RASS for detecting delirium in older ED patients. Acad Emerg Med 2015;22:878.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest keyword match ('a RASS other than 0', 'altered level of consciousness') but a different setting/use: RASS as a standalone delirium screen in older ED patients, not the CAM-IMC scoring component.",
     "docUrl": "https://doi.org/10.1111/acem.12706",
     "paragraphs": [
      {
       "context": "The RASS is an arousal scale commonly used in intensive care units to assess for depth of sedation (Figure 1),10 but has been incorporated into several delirium assessments to assess for level of consciousness.6 For this study, we replaced the term \"sedation\" with \"drowsy,\" (Figure 1) to describe level of consciousness regardless of sedation administration. A RASS of 0 represented normal level of consciousness whereas a RASS other than 0 represented the presence of altered level of consciousness. The RASS was determined by an emergency physician (EP) and research assistants (RAs; college graduates, emergency medical technicians, and paramedics). Before the study began, the RAs were given a 5-minute didactic lecture about the RASS. The principal investigator then observed them perform the RASS in five older ED patients and provided them instruction if there was any discordance.",
       "highlight": "a RASS other than 0 represented the presence of altered level of consciousness",
       "scope": "different-setting",
       "note": "States the exact operational definition the claim uses (RASS 0 = normal, RASS other than 0 = altered level of consciousness), but validated in older ED patients as a standalone screen — a different setting and use than the CAM-IMC arousal component, so not direct support for the +1 scoring.",
       "page": "3",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      },
      {
       "context": "Conclusions--In older ED patients, a RASS other than 0 has very good sensitivity and specificity for delirium as diagnosed by a psychiatrist. A RASS > +1 or < -1 is nearly diagnostic for delirium given the very high positive likelihood ratio.",
       "highlight": "a RASS other than 0 has very good sensitivity and specificity for delirium as diagnosed by a psychiatrist",
       "scope": "different-setting",
       "note": "Reports RASS-not-0 diagnostic performance for delirium as a standalone ED screen against a psychiatrist reference — shares the 'RASS other than 0' keyword but is a different setting/intervention, not the CAM-IMC +1 scoring rule.",
       "page": "2",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      },
      {
       "context": "The Richmond Agitation Sedation Scale (RASS; Figure 1), which quantifies level of consciousness, may be a reasonable alternative to delirium screening in the ED. Altered level of consciousness is often observed in delirium and is key feature in several delirium assessments.",
       "highlight": "Altered level of consciousness is often observed in delirium and is key feature in several delirium assessments",
       "scope": "background",
       "note": "General grounding that altered level of consciousness is a key feature across delirium assessments and the RASS is offered as a rapid ED alternative — context, not CAM-IMC-specific support.",
       "page": "2",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      }
     ]
    }
   ],
   "synthesis": "Beyer 2024 is the governing on-scope source and directly supports the rule: in the CAM-IMC point-based scoring, a RASS other than 0 (\"altered level of consciousness\") is a binary item that contributes one point to the total. Han 2015 supplies the same RASS-not-0 = altered-arousal operational definition but validates it as a standalone delirium screen in older ED patients — a different setting and use — so it grounds the definition without addressing the CAM-IMC +1 scoring.",
   "discrepancy": true
  },
  {
   "id": "sd-cards-r6",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "1",
   "section": "Arousal card — gate (stop)",
   "statement": "RASS −4 / −5 → STOP — stupor or coma; the CAM-IMC cannot be scored now. Reassess when the patient responds to voice.",
   "contentType": "Cited clinical content",
   "sources": [
    "Beyer 2024 (CAM-IMC)",
    "Sessler 2002 (RASS)",
    "Han 2015 (RASS in the ED)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 1",
   "passage": "for diagnosing POD in intubated patients cannot make use of the feature ‘disorientation’, as this requires verbal communication. Other tools such as the 4AT test for disorientation but are not established in ICU settings.\nAlso Beyer 2024 (CAM-IMC) (p. 3): “Inattention was assessed by having the patient read aloud a ten-letter word (ANANASBAUM or CASABLANCA) and squeeze the examiner’s hand each time they heard the letter “A.””\nAlso Han 2015 (RASS in the ED) (p. 3): “Patients were excluded if they were non-English speaking, deaf or blind, previously enrolled, non-verbal or unable to follow simple commands prior to their acute illnesses, comatose, or did not complete all the study assessments.”\nIndirect support. The CAM-IMC's disorientation and inattention items require the patient to speak and follow commands (read a word aloud, squeeze the hand), so a patient who does not respond to voice cannot complete them (Beyer 2024, p. 1, p. 3); Han 2015 excluded comatose / non-verbal patients from RASS-based delirium assessment for the same reason (p. 3). The specific −4 / −5 cut-off and 'reassess when the patient responds to voice' are standard CAM-ICU / RASS practice (RASS −4 = no response to voice, −5 = unarousable; Sessler 2002, not archived), not wording quoted from the cited step-down sources.",
   "evidence": "Full text, p. 1 — partial support",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451.",
    "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
    "Han JH, et al. The diagnostic performance of the RASS for detecting delirium in older ED patients. Acad Emerg Med 2015;22:878."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1111/acem.12706"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "cite": "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "On-scope source for the tool named in the claim: the CAM-IMC is a verbal delirium test for non-intubated intermediate/step-down patients, so it cannot be scored when the patient is not orally responsive.",
     "docUrl": "https://doi.org/10.1186/s12871-024-02849-3",
     "paragraphs": [
      {
       "context": "This cohort study evaluates the test performance of the newly developed CAM-IMC and its disorientation component in a prospective cohort study. The CAM-IMC shows a sensitivity of 0.96 and specificity of 0.94 in diagnosis of POD in non-intubated postoperative cardiac surgery patients. Its test performance is comparable to the widely used CAM-ICU demonstrating a high level of accuracy [ 19 ]. While testing for disorientation alone shows good test performance values, it does not surpass the CAM-IMC. The study indicates that using the CAM-IMC by combing the features of the CAM-ICU with assessing of disorientation as a verbal testing variable, improves effectiveness and provides excellent sensitivity and specificity for diagnosing POD. These findings highlight the importance of incorporating verbal testing for disorientation whenever patients are accessible to oral evaluation to improve POD diagnostics. The CAM-IMC outperforms each individual feature of the CAM-IMC.",
       "highlight": "whenever patients are accessible to oral evaluation",
       "scope": "on-scope",
       "note": "The CAM-IMC's disorientation testing can only be applied when the patient is accessible to oral evaluation, which is exactly why a stuporous/comatose patient (RASS -4/-5) cannot be scored.",
       "page": "5",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "Background Disorientation is an early indicator of developing postoperative delirium (POD), which is associated with increased mortality and cognitive decline. The well-established \"Confusion-Assessment-Method-for-IntensiveCare-Unit\" (CAM-ICU) for diagnosing POD in intubated patients cannot make use of the feature `disorientation', as this requires verbal communication. Other tools such as the 4AT test for disorientation but are not established in ICU settings. We therefore combined test-variables of the CAM-ICU (level of consciousness, fluctuating mental status and inattention) with verbal testing for disorientation to develop and enhance diagnostic accuracy of the \"Confusion Assessment Method for Intermediate Care Unit\" (CAM-IMC). In the present study we describe the development and the evaluation of the diagnostic accuracy of the CAM-IMC.",
       "highlight": "with verbal testing for disorientation",
       "scope": "on-scope",
       "note": "The CAM-IMC (the tool the card cites) adds verbal testing for disorientation to the CAM-ICU features, so it requires a patient who can respond verbally; matches the primary anchor at p.1.",
       "page": "1",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "RASS ranges from -5 (deeply sedated) to +4 (aggressive)",
       "highlight": "-5 (deeply sedated)",
       "scope": "background",
       "note": "Table 1 footnote defining the deep-sedation pole of the RASS (-5 = deeply sedated), anchoring the coma/deeply-sedated end of the STOP gate.",
       "page": "6",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "The Confusion-Assessment-Method for Intensive Care Unit (CAM-ICU), which originally derived from the Confusion Assessment Method (CAM), was developed for monitoring of POD in intubated ICU-patients [ 19 , 20 ]. It omits the feature ‘disorientation’, as this requires a more differentiated verbal response than ‘yes’ and ‘no’, or nodding ‘yes’ and shaking your head ‘no’. Disorientation should not be missed as a frequent symptom and early indicator of POD as stated above. Screening for disorientation has been shown to provide high sensitivity (96.6%) in the diagnosis of POD [ 21 ].",
       "highlight": "was developed for monitoring of POD in intubated ICU-patients",
       "scope": "different-population",
       "note": "Nearest match on the same arousal/level-of-consciousness theme but describes the CAM-ICU for intubated ICU patients — a different tool and population; the card uses the non-intubated CAM-IMC, which inherits the same arousal-gate logic.",
       "page": "2",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Cited for the RASS arousal levels: the scale definition sets -4 (deep sedation, no response to voice) and -5 (unarousable) as the STOP thresholds and -3 (responds to voice) as the reassessment trigger. It is the definitional basis for 'stupor or coma' versus 'responds to voice' (cited by section/DOI; no archived text).",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Han 2015 (RASS in the ED)",
     "cite": "Han JH, et al. The diagnostic performance of the RASS for detecting delirium in older ED patients. Acad Emerg Med 2015;22:878.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest match on RASS + arousal + delirium, but an emergency-department study that used the RASS as a delirium screen and excluded comatose patients — a different setting and a different use of the RASS than the arousal STOP-gate this claim describes.",
     "docUrl": "https://doi.org/10.1111/acem.12706",
     "paragraphs": [
      {
       "context": "because the psychiatrists' comprehensive assessments were conducted in addition to their clinical duties. The first patient who met all the eligibility criteria was enrolled each day. Patients who were 65 years or older, in the ED for less than 12 hours at the time of enrollment, and not in a hallway bed were eligible. The 12 hour cut-off was used to include patients who presented to the ED in the evening and early morning hours. Patients were excluded if they were non-English speaking, deaf or blind, previously enrolled, non-verbal or unable to follow simple commands prior to their acute illnesses, comatose, or did not complete all the study assessments. Patients who were non-verbal or unable to follow simple commands prior to their acute illnesses were considered to have end-stage dementia. These patients were excluded because diagnosing delirium in this patient group can be challenging, even for an experienced psychiatrist.",
       "highlight": "comatose, or did not complete all the study assessments",
       "scope": "different-setting",
       "note": "Comatose patients were excluded from this ED validation because delirium cannot be assessed in them — parallels the gate concept but is an ED enrollment exclusion, not an IMC/CAM-IMC arousal gate.",
       "page": "3",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      },
      {
       "context": "The RASS is an arousal scale commonly used in intensive care units to assess for depth of sedation (Figure 1),10 but has been incorporated into several delirium assessments to assess for level of consciousness.6 For this study, we replaced the term \"sedation\" with \"drowsy,\" (Figure 1) to describe level of consciousness regardless of sedation administration. A RASS of 0 represented normal level of consciousness whereas a RASS other than 0 represented the presence of altered level of consciousness. The RASS was determined by an emergency physician (EP) and research assistants (RAs; college graduates, emergency medical technicians, and paramedics). Before the study began, the RAs were given a 5-minute didactic lecture about the RASS. The principal investigator then observed them perform the RASS in five older ED patients and provided them instruction if there was any discordance.",
       "highlight": "but has been incorporated into several delirium assessments to assess for level of consciousness",
       "scope": "background",
       "note": "General framing of the RASS as an arousal / level-of-consciousness scale — background to why the RASS defines the gate's arousal thresholds.",
       "page": "3",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      },
      {
       "context": "Delirium is an under-recognized public health problem that is frequently missed by ED health care providers because it is not routinely screened for. The RASS may be a reasonable alternative to screen for delirium in the fast-paced ED environment. Because the RASS can be performed with a brief structured observation, it can be easily incorporated into the routine ED clinical work flow. We observed that a RASS other than 0 had very good sensitivity and specificity and moderately affected the likelihood of delirium. A RASS > +1 or < -1 was nearly diagnostic of delirium as evidenced by its very high specificity and likelihood ratio; no further delirium assessments would be needed in these patients. Despite a brief training period, there was moderately good agreement between the research staff and physician.",
       "highlight": "a RASS other than 0 had very good sensitivity and specificity",
       "scope": "different-intervention",
       "note": "Han used the RASS itself as a delirium detector (RASS other than 0 = likely delirium) in older ED patients — a different use of the RASS than the arousal STOP-gate in this claim.",
       "page": "4",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      }
     ]
    }
   ],
   "synthesis": "The on-scope governing source is Beyer 2024 (CAM-IMC): it establishes the CAM-IMC as a verbal delirium test for non-intubated step-down patients that can only be applied when the patient is accessible to oral evaluation, which directly supports stopping and not scoring at RASS -4/-5 (stupor/coma), while the specific RASS thresholds and the 'responds to voice' reassessment trigger come from the Sessler 2002 scale definition. Han 2015 is the nearest match on RASS and arousal but is an ED study that used the RASS as a delirium screen and explicitly excluded comatose patients, so it is a different setting and a different use of the RASS and does not govern this arousal gate.",
   "discrepancy": true
  },
  {
   "id": "sd-cards-r7",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "1",
   "section": "CAM-IMC card — rule",
   "statement": "CAM-IMC positive = total ≥ 3 of 10.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Beyer 2024 (CAM-IMC)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 4",
   "passage": "Patients scoring three points or higher were considered as positive for POD, while those less than three points were considered negative.\nAlso Beyer 2024 (CAM-IMC) (p. 5): “The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score”\nExact match. Beyer 2024 set the CAM-IMC cut-off at three points by the Youden index — patients scoring ≥ 3 are positive, < 3 negative (p. 4). The maximum is 10: disorientation up to 5 + inattention up to 3 + acute change 1 + altered LOC 1 (p. 5).",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "stance": "agrees",
     "note": "Beyer set the cut-off at three points by Youden index in the validation cohort; the card's rule is that cut-off.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "Overall, the CAM-IMC showed an AUROC of 0.98 (CI 95%: 0.96-1.00). The optimal cut-off based on the Youden-Index was chosen at three points for the CAM-IMC to determine the presence of POD. This is displayed in the ROC-analysis in Fig. 3. Patients scoring three points or higher were considered as positive for POD, while those less than three points were considered negative.",
       "highlight": "Patients scoring three points or higher were considered as positive for POD, while those less than three points were considered negative.",
       "page": "4"
      },
      {
       "scope": "on-scope",
       "context": "The CAM-IMC outperforms each individual feature of the CAM-IMC. By creating the CAM-IMC flowchart design as a pointbased scoring system, the importance of disorientation as a central feature of POD has been reinforced. The features disorientation and inattention can each trigger a positive test result. The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome.",
       "highlight": "The system assigns up to five points for disorientation and three points for inattention",
       "page": "5"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-cards-r8",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "1",
   "section": "CAM-IMC card — Feature 1",
   "statement": "Acute change or fluctuating course (+1). Prompt: “Acute change from the patient’s mental-status baseline, or fluctuation over the past 24 h?”",
   "contentType": "Validated instrument wording",
   "sources": [
    "Beyer 2024 (CAM-IMC)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 3",
   "passage": "The elements “Acute change or fluctuating course of mental status” and “Altered level of consciousness” are dichotomous, allowing for the assignment of one point for an abnormal test result.\nSupported. Acute change / fluctuating course is one of the two dichotomous CAM-IMC elements, scoring one point when abnormal (Beyer 2024, p. 3). The 24-hour / baseline framing restates the CAM/CAM-ICU acute-change feature the CAM-IMC inherits.",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "stance": "agrees",
     "note": "Acute change or fluctuating course is one of the two dichotomous elements scoring a single point.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "Figure 1 illustrates the diagnostic workup using CAM-IMC as the index test. A point-based scoring system was introduced in CAM-IMC, allowing for a modified weighting of each element in the diagnosis of POD. The elements \"Acute change or fluctuating course of mental status\" and \"Altered level of consciousness\" are dichotomous, allowing for the assignment of one point for an abnormal test result. Inattention was assessed by having the patient read aloud a ten-letter word (ANANASBAUM or CASABLANCA) and squeeze the examiner's hand each time they heard the letter \"A.\" Consistent with the CAM-ICU, a maximum of three errors were permitted, with one point deducted for each mistake. Disorientation was newly introduced and evaluated across five different dimensions.",
       "highlight": "The elements \"Acute change or fluctuating course of mental status\" and \"Altered level of consciousness\" are dichotomous, allowing for the assignment of one point for an abnormal test result.",
       "page": "3"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-cards-r9",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "1",
   "section": "CAM-IMC card — Feature 2",
   "statement": "Altered level of consciousness (+1). Read from the RASS above — any value other than 0 scores 1 point.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Beyer 2024 (CAM-IMC)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 3",
   "passage": "The elements “Acute change or fluctuating course of mental status” and “Altered level of consciousness” are dichotomous, allowing for the assignment of one point for an abnormal test result.\nAlso Beyer 2024 (CAM-IMC) (p. 8): “RASS ≠ 0 and disorientation are binary”\nSupported (Beyer 2024, p. 3; Table footnote 'RASS ≠ 0 … are binary', p. 8) — mirrors the arousal-gate row.",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "stance": "agrees",
     "note": "Altered level of consciousness is the second dichotomous element; the card reads it from the RASS, and Beyer describes the same item as RASS≠0.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "Figure 1 illustrates the diagnostic workup using CAM-IMC as the index test. A point-based scoring system was introduced in CAM-IMC, allowing for a modified weighting of each element in the diagnosis of POD. The elements \"Acute change or fluctuating course of mental status\" and \"Altered level of consciousness\" are dichotomous, allowing for the assignment of one point for an abnormal test result. Inattention was assessed by having the patient read aloud a ten-letter word (ANANASBAUM or CASABLANCA) and squeeze the examiner's hand each time they heard the letter \"A.\" Consistent with the CAM-ICU, a maximum of three errors were permitted, with one point deducted for each mistake. Disorientation was newly introduced and evaluated across five different dimensions.",
       "highlight": "\"Altered level of consciousness\" are dichotomous, allowing for the assignment of one point for an abnormal test result",
       "page": "3"
      },
      {
       "scope": "on-scope",
       "context": "The CAM-IMC outperforms each individual feature of the CAM-IMC. By creating the CAM-IMC flowchart design as a pointbased scoring system, the importance of disorientation as a central feature of POD has been reinforced. The features disorientation and inattention can each trigger a positive test result. The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome.",
       "highlight": "The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score",
       "page": "5"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-cards-r10",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "1",
   "section": "CAM-IMC card — Feature 3 (inattention)",
   "statement": "Inattention (0–3). Script: “Read the 10-letter word ‘ANANASBAUM’ (or ‘CASABLANCA’) aloud, letter by letter, and squeeze my hand each time you hear the letter A.” One point per error, to a maximum of 3; the item alone is positive at ≥ 3 errors.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Beyer 2024 (CAM-IMC)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 3",
   "passage": "Inattention was assessed by having the patient read aloud a ten-letter word (ANANASBAUM or CASABLANCA) and squeeze the examiner’s hand each time they heard the letter “A.” Consistent with the CAM-ICU, a maximum of three errors were permitted, with one point deducted for each mistake.\nAlso Beyer 2024 (CAM-IMC) (p. 8): “Cut-Off for ANANASBAUM-test was three or more errors. Cut-Off for Disorientation was two or more errors.”\nExact match. The read-aloud script (ten-letter word ANANASBAUM or CASABLANCA, squeeze on the letter A), the one-point-per-error scoring to a maximum of 3, and the item-level positive at ≥ 3 errors are all Beyer 2024 (p. 3; cut-off note p. 8).",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "stance": "agrees",
     "note": "The ten-letter word, the hand squeeze on 'A', and the three-error maximum are the instrument's own wording.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "Figure 1 illustrates the diagnostic workup using CAM-IMC as the index test. A point-based scoring system was introduced in CAM-IMC, allowing for a modified weighting of each element in the diagnosis of POD. The elements \"Acute change or fluctuating course of mental status\" and \"Altered level of consciousness\" are dichotomous, allowing for the assignment of one point for an abnormal test result. Inattention was assessed by having the patient read aloud a ten-letter word (ANANASBAUM or CASABLANCA) and squeeze the examiner's hand each time they heard the letter \"A.\" Consistent with the CAM-ICU, a maximum of three errors were permitted, with one point deducted for each mistake. Disorientation was newly introduced and evaluated across five different dimensions.",
       "highlight": "Inattention was assessed by having the patient read aloud a ten-letter word (ANANASBAUM or CASABLANCA) and squeeze the examiner's hand each time they heard the letter \"A.\" Consistent with the CAM-ICU, a maximum of three errors were permitted",
       "page": "3"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-cards-r11",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "1",
   "section": "CAM-IMC card — Feature 4 (disorientation)",
   "statement": "Disorientation (0–5): Age, Date of birth, Place, Year, Situational awareness. One point per error across five dimensions; the item alone is positive at ≥ 2 errors.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Beyer 2024 (CAM-IMC)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 4",
   "passage": "we chose the four dimensions age, date of birth, place and year\nAlso Beyer 2024 (CAM-IMC) (p. 4): “The fifth dimension we added was ‘situational awareness’”\nAlso Beyer 2024 (CAM-IMC) (p. 4): “Each error in these dimensions resulted in one point, with a maximum of five points possible.”\nAlso Beyer 2024 (CAM-IMC) (p. 8): “Cut-Off for ANANASBAUM-test was three or more errors. Cut-Off for Disorientation was two or more errors.”\nExact match. Beyer 2024 evaluates disorientation across five dimensions — age, date of birth, place, year, and the newly added situational awareness — one point per error to a maximum of 5 (p. 4), with the item positive at ≥ 2 errors (cut-off note, p. 8). The card's five dimensions match verbatim.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "stance": "agrees",
     "note": "The five dimensions and the one-point-per-error maximum of five are stated directly; the card reproduces them.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "(AMT4) which was also the base for the 4AT we chose the four dimensions age, date of birth, place and year [21, 29, 30]. The fifth dimension we added was 'situational awareness', as during a prior study by Guenther et al., it was discovered a useful addition [24]. Interestingly, one of the earliest reports on delirium (Levin, 1956) described it as a useful diagnostic criterion, by \"asking the patient how to get from one place to another\" [1]. In this study we asked about their way they took from onset of symptoms to our hospital. Each error in these dimensions resulted in one point, with a maximum of five points possible.",
       "highlight": "we chose the four dimensions age, date of birth, place and year",
       "page": "4"
      },
      {
       "scope": "on-scope",
       "context": "(AMT4) which was also the base for the 4AT we chose the four dimensions age, date of birth, place and year [21, 29, 30]. The fifth dimension we added was 'situational awareness', as during a prior study by Guenther et al., it was discovered a useful addition [24]. Interestingly, one of the earliest reports on delirium (Levin, 1956) described it as a useful diagnostic criterion, by \"asking the patient how to get from one place to another\" [1]. In this study we asked about their way they took from onset of symptoms to our hospital. Each error in these dimensions resulted in one point, with a maximum of five points possible.",
       "highlight": "The fifth dimension we added was 'situational awareness'",
       "page": "4"
      },
      {
       "scope": "on-scope",
       "context": "(AMT4) which was also the base for the 4AT we chose the four dimensions age, date of birth, place and year [21, 29, 30]. The fifth dimension we added was 'situational awareness', as during a prior study by Guenther et al., it was discovered a useful addition [24]. Interestingly, one of the earliest reports on delirium (Levin, 1956) described it as a useful diagnostic criterion, by \"asking the patient how to get from one place to another\" [1]. In this study we asked about their way they took from onset of symptoms to our hospital. Each error in these dimensions resulted in one point, with a maximum of five points possible.",
       "highlight": "Each error in these dimensions resulted in one point, with a maximum of five points possible.",
       "page": "4"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-cards-r12",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "1",
   "section": "CAM-IMC card — scope / non-veto",
   "statement": "For the verbal, non-intubated patient. Disorientation or inattention can drive a positive on their own.",
   "contentType": "Cited clinical content",
   "sources": [
    "Beyer 2024 (CAM-IMC)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 5",
   "passage": "The features disorientation and inattention can each trigger a positive test result.\nAlso Beyer 2024 (CAM-IMC) (p. 6): “the CAM-ICU does not diagnose POD if “Acute change or fluctuating course of the mental status” is assessed as negative, even when inattention or disorganized thinking” is present. By employing a point-based scoring system, the CAM-IMC avoids this limitation.”\nAlso Beyer 2024 (CAM-IMC) (p. 5): “The CAM-IMC shows a sensitivity of 0.96 and specificity of 0.94 in diagnosis of POD in non-intubated postoperative cardiac surgery patients.”\nSupported. Beyer 2024 states disorientation and inattention can each trigger a positive result and — unlike the CAM-ICU, which requires a positive acute-change feature — the CAM-IMC's point system removes that veto (p. 5–6). The CAM-IMC was validated in non-intubated post-cardiac-surgery intermediate-care patients (sensitivity 0.96 / specificity 0.94; p. 5); applying it across the broader step-down / progressive-care population is a reasonable but noted scope extension.",
   "evidence": "Full text, p. 5",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3"
   ],
   "decision": "",
   "notes": "Validated for postoperative delirium in a non-intubated cardiac-surgery intermediate-care unit; step-down / progressive-care use extends that population.",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "stance": "agrees",
     "note": "Beyer states the non-veto design explicitly: neither dichotomous item is mandatory for a positive result.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "The CAM-IMC outperforms each individual feature of the CAM-IMC. By creating the CAM-IMC flowchart design as a pointbased scoring system, the importance of disorientation as a central feature of POD has been reinforced. The features disorientation and inattention can each trigger a positive test result. The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome.",
       "highlight": "The features disorientation and inattention can each trigger a positive test result.",
       "page": "5"
      },
      {
       "scope": "on-scope",
       "context": "The CAM-IMC outperforms each individual feature of the CAM-IMC. By creating the CAM-IMC flowchart design as a pointbased scoring system, the importance of disorientation as a central feature of POD has been reinforced. The features disorientation and inattention can each trigger a positive test result. The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome.",
       "highlight": "are not mandatory for a positive test outcome",
       "page": "5"
      },
      {
       "scope": "different-population",
       "context": "This cohort study evaluates the test performance of the newly developed CAM-IMC and its disorientation component in a prospective cohort study. The CAM-IMC shows a sensitivity of 0.96 and specificity of 0.94 in diagnosis of POD in non-intubated postoperative cardiac surgery patients. Its test performance is comparable to the widely used CAM-ICU demonstrating a high level of accuracy [19].",
       "highlight": "in non-intubated postoperative cardiac surgery patients",
       "page": "5"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-cards-r13",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "2",
   "section": "Risk card — rule",
   "statement": "Admission delirium risk (Martinez): three admission variables, 0–3 points, banded to predicted incidence. A validated ward prediction rule for direct admits — use it to target the prevention bundle.",
   "contentType": "Cited clinical content",
   "sources": [
    "Martinez 2012 (ward risk rule)",
    "NICE CG103"
   ],
   "anchor": "Martinez 2012 (ward risk rule) — p. 1",
   "passage": "the individual risk of delirium is obtained by adding one point for each criterion met (age≥85, high level of dependence, and being on psychotropic medication).\nAlso Martinez 2012 (ward risk rule) (p. 4): “One point was given to patients older than 85 years, to those who had two or more points in the variable drugs, and to those with impairments in ﬁve or more of the ADL”\nSupported. Martinez 2012 derived and validated a medical-ward rule adding one point each for age ≥ 85, dependence in ≥ 5 of 6 ADLs, and a psychotropic-drug subtotal ≥ 2 (abstract; p. 4). Using the score to target prevention aligns with NICE CG103's risk-factor-based prevention approach.",
   "evidence": "Full text, p. 1",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "Martinez JA, et al. Derivation and validation of a clinical prediction rule for delirium in patients admitted to a medical ward. BMJ Open 2012;2:e001599.",
    "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023)."
   ],
   "links": [
    "https://doi.org/10.1136/bmjopen-2012-001599",
    "https://www.nice.org.uk/guidance/cg103"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Martinez 2012 (ward risk rule)",
     "cite": "Martinez JA, et al. Derivation and validation of a clinical prediction rule for delirium in patients admitted to a medical ward. BMJ Open 2012;2:e001599.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1136/bmjopen-2012-001599",
     "paragraphs": [
      {
       "context": "prediction rule, based on variables easily measurable at admission, to identify patients at high risk of developing delirium during their hospital stay on an internal medicine ward.",
       "highlight": "to identify patients at high risk of developing delirium during their hospital stay on an internal medicine ward",
       "scope": "on-scope",
       "note": "States the aim — derive and validate an admission-measurable prediction rule for internal-medicine ward inpatients, matching the claim's validated ward rule for direct admits.",
       "page": "1",
       "docUrl": "https://doi.org/10.1136/bmjopen-2012-001599"
      },
      {
       "context": "analysed and finally included in the rule were: being aged 85 years old or older, being dependent in five or more activities of daily living, and taking two or more psychotropic drugs (antipsychotics, benzodiazepines, antidepressants, anticonvulsant and/or antidementia drugs). The variable of interest was delirium as defined by the short Confusion Assessment Method, which assesses four characteristics: acute onset and fluctuating course, inattention, disorganised thinking and altered level of consciousness.",
       "highlight": "being aged 85 years old or older, being dependent in five or more activities of daily living, and taking two or more psychotropic drugs",
       "scope": "on-scope",
       "note": "The three admission variables that make up the rule, exactly as the claim describes.",
       "page": "1",
       "docUrl": "https://doi.org/10.1136/bmjopen-2012-001599"
      },
      {
       "context": "The scores for the clinical prediction rule were assigned on the basis of regression coefficients obtained in the logistic regression model ( table 7 ). One point was given to patients older than 85 years, to those who had two or more points in the variable drugs, and to those with impairments in five or more of the ADL considered. Therefore, the total score for the rule ranged between 0 and 3.",
       "highlight": "Therefore, the total score for the rule ranged between 0 and 3",
       "scope": "on-scope",
       "note": "One point per criterion gives a total ranging 0-3, matching the claim's 0-3 points.",
       "page": "4",
       "docUrl": "https://doi.org/10.1136/bmjopen-2012-001599"
      },
      {
       "context": "The clinical prediction rule was applied to the validation cohort. We report the incidence of delirium as a function of score on the rule and the ORs using the lowest risk category as the reference. The performance of the rule in the two cohorts was explored using receiver operator characteristic (ROC) curve analysis.",
       "highlight": "the incidence of delirium as a function of score on the rule",
       "scope": "on-scope",
       "note": "Delirium incidence is reported by score band (4%/14%/43% by score 0/1/2 in the derivation cohort), i.e. the score is banded to predicted incidence.",
       "page": "3",
       "docUrl": "https://doi.org/10.1136/bmjopen-2012-001599"
      },
      {
       "context": "This rule may facilitate early identification of high risk patients and target early initiation of preventive measures.",
       "highlight": "target early initiation of preventive measures",
       "scope": "on-scope",
       "note": "The rule's stated purpose is to flag high-risk patients so preventive measures can begin early — i.e. to target the prevention bundle.",
       "page": "1",
       "docUrl": "https://doi.org/10.1136/bmjopen-2012-001599"
      },
      {
       "context": "The association between delirium and an increase of morbidity and mortality 5 6 9 is well known, as are the effectiveness of preventive measures to avoid the development of the disease. 15–18 The use of the proposed predictive rule would allow us to classify around half of our inpatients (53%) as high risk. Taking preventative measures in this high-risk group, up to 93.4% of those who developed delirium in our study would have been covered by the measures and might not have then developed the condition.",
       "highlight": "Taking preventative measures in this high-risk group, up to 93.4% of those who developed delirium in our study would have been covered by the measures",
       "scope": "on-scope",
       "note": "Applying the rule classifies ~53% as high-risk and would have covered 93.4% of eventual delirium cases with preventive measures, supporting its use to target prevention.",
       "page": "6",
       "docUrl": "https://doi.org/10.1136/bmjopen-2012-001599"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "partial",
     "note": "Agrees on the risk-directed prevention principle but supplies a different, non-scored admission risk model.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "within 24 hours of admission, assess people at risk for clinical factors contributing to delirium based on the results of this assessment, provide a multicomponent intervention tailored to the person's individual needs and care setting as described in recommendations 1.4.4 to 1.4.13. [2010] 1.4.3 The tailored multicomponent intervention package should be delivered by a multidisciplinary team trained and competent in delirium prevention. [2010]",
       "highlight": "based on the results of this assessment, provide a multicomponent intervention tailored to the person's individual needs and care setting",
       "scope": "on-scope",
       "note": "Supports the claim's directive to use admission risk assessment to target a multicomponent prevention bundle within 24 hours.",
       "page": "7",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "treating delirium. In particular, the guideline focuses on preventing delirium in people identified to be at risk, using a targeted, multicomponent, non-pharmacological intervention that addresses a number of modifiable risk factors ('clinical factors').",
       "highlight": "using a targeted, multicomponent, non-pharmacological intervention that addresses a number of modifiable risk factors",
       "scope": "on-scope",
       "note": "Confirms the risk-directed prevention principle the claim invokes — target the prevention bundle at patients identified at risk.",
       "page": "22",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "following risk factors. If any of these risk factors are present, the person is at risk of delirium.",
       "highlight": "following risk factors. If any of these risk factors are present, the person is at risk",
       "scope": "broader",
       "note": "Nearest match on admission risk but a different scheme: any one of four dichotomous factors (age >=65, cognitive impairment/dementia, hip fracture, severe illness) flags at-risk, not Martinez's validated 0-3 scored rule keyed to age >=85 — broader and non-scored.",
       "page": "5",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Older people and people with dementia, severe illness or a hip fracture are more at risk of delirium. The prevalence of delirium in people on medical wards in hospital is about 20% to 30%, and 10% to 50% of people having surgery develop delirium. In long-term care the prevalence is under 20%. But reporting of delirium is poor in the UK, indicating that awareness and reporting procedures need to be improved.",
       "highlight": "The prevalence of delirium in people on medical wards in hospital is about 20% to 30%",
       "scope": "background",
       "note": "General medical-ward delirium prevalence for context; not a per-band predicted incidence like the Martinez rule.",
       "page": "21",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    }
   ],
   "synthesis": "Martinez 2012 directly supports every element of the claim — three admission-measurable variables (age >=85, dependence in >=5 ADL, >=2 psychotropic-drug points) summed to a 0-3 score whose bands map to rising delirium incidence, derived and validated on internal-medicine ward admissions to target early prevention. NICE CG103 agrees with the underlying principle of assessing admission risk to trigger a multicomponent prevention bundle, but its own risk model (any one of age >=65, cognitive impairment, hip fracture, or severe illness) is a broader, non-scored scheme, so Martinez remains the governing on-scope source for the specific validated 0-3 prediction rule the claim describes.",
   "discrepancy": true
  },
  {
   "id": "sd-cards-r14",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "2",
   "section": "Risk card — Age",
   "statement": "Age ≥ 85 (+1).",
   "contentType": "Validated instrument wording",
   "sources": [
    "Martinez 2012 (ward risk rule)"
   ],
   "anchor": "Martinez 2012 (ward risk rule) — p. 1",
   "passage": "the individual risk of delirium is obtained by adding one point for each criterion met (age≥85, high level of dependence, and being on psychotropic medication).\nSupported (Martinez 2012, abstract; p. 4). Note: the rule statement and abstract use age ≥ 85, while the Table 7 footnote reads '> 85 years'; the card follows the abstract's ≥ 85.",
   "evidence": "Full text, p. 1",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "Martinez JA, et al. Derivation and validation of a clinical prediction rule for delirium in patients admitted to a medical ward. BMJ Open 2012;2:e001599."
   ],
   "links": [
    "https://doi.org/10.1136/bmjopen-2012-001599"
   ],
   "decision": "",
   "notes": "Source is internally inconsistent (abstract ≥ 85 vs Table 7 footnote > 85); card follows the abstract.",
   "perSource": [
    {
     "label": "Martinez 2012 (ward risk rule)",
     "stance": "agrees",
     "note": "One point for age over 85 is the rule's first criterion.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "Accordingly, the medication data was coded according to the number of different drugs patients were taking at admission with each antidepressant, antidementia or anticonvulsant drug contributing equally, while antipsychotic drugs were weighted by a factor of two. The ADL data were also dichotomised with a cut-off of reported impairments in five activities. The scores for the clinical prediction rule were assigned on the basis of regression coefficients obtained in the logistic regression model (table 7). One point was given to patients older than 85 years, to those who had two or more points in the variable drugs, and to those with impairments in five or more of the ADL considered. Therefore, the total score for the rule ranged between 0 and 3.",
       "highlight": "One point was given to patients older than 85 years",
       "page": "4"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-cards-r15",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "2",
   "section": "Risk card — ADL dependence",
   "statement": "Dependence in ≥ 5 of 6 ADLs (+1): personal hygiene & grooming; dressing & undressing; getting on/off the toilet; ambulation; bowel & bladder control; self-feeding.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Martinez 2012 (ward risk rule)"
   ],
   "anchor": "Martinez 2012 (ward risk rule) — p. 2",
   "passage": "personal hygiene and grooming, dressing and undressing, getting onto or off toilet, ambulation, bowel and bladder control and self-feeding\nAlso Martinez 2012 (ward risk rule) (p. 4): “One point was given to patients older than 85 years, to those who had two or more points in the variable drugs, and to those with impairments in ﬁve or more of the ADL”\nExact match. The six ADLs are Martinez 2012 (p. 2), and dependence in ≥ 5 of 6 scores the point (p. 4).",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Martinez JA, et al. Derivation and validation of a clinical prediction rule for delirium in patients admitted to a medical ward. BMJ Open 2012;2:e001599."
   ],
   "links": [
    "https://doi.org/10.1136/bmjopen-2012-001599"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Martinez 2012 (ward risk rule)",
     "stance": "agrees",
     "note": "Martinez assessed six activities of daily living and dichotomised dependence at five; the card lists the same six.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "Finally, certain characteristics of patients prior to admission were also assessed: level of dependence for activities of daily living (ADL) (personal hygiene and grooming, dressing and undressing, getting onto or off toilet, ambulation, bowel and bladder control and self-feeding) as dichotomous variables (dependent; independent); presence of pressure ulcers and excess alcohol intake (>60 g/ethanol/day), as well as use of certain types of medication: benzodiazepines, antidepressants, antidementia drugs, antipsychotics, anti-Parkinson's drugs or anticonvulsants.",
       "highlight": "personal hygiene and grooming, dressing and undressing, getting onto or off toilet, ambulation, bowel and bladder control and self-feeding",
       "page": "2"
      },
      {
       "scope": "on-scope",
       "context": "Accordingly, the medication data was coded according to the number of different drugs patients were taking at admission with each antidepressant, antidementia or anticonvulsant drug contributing equally, while antipsychotic drugs were weighted by a factor of two. The ADL data were also dichotomised with a cut-off of reported impairments in five activities. The scores for the clinical prediction rule were assigned on the basis of regression coefficients obtained in the logistic regression model (table 7). One point was given to patients older than 85 years, to those who had two or more points in the variable drugs, and to those with impairments in five or more of the ADL considered. Therefore, the total score for the rule ranged between 0 and 3.",
       "highlight": "The ADL data were also dichotomised with a cut-off of reported impairments in five activities.",
       "page": "4"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-cards-r16",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "2",
   "section": "Risk card — Psychotropic burden",
   "statement": "Psychotropic subtotal ≥ 2 (+1): antidepressant / antidementia / anticonvulsant score 1 each; antipsychotic scores 2.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Martinez 2012 (ward risk rule)"
   ],
   "anchor": "Martinez 2012 (ward risk rule) — p. 5",
   "passage": "antidepressants, antidementia drugs and anticonvulsants score one point each, and antipsychotics score two points.\nExact match. Antidepressants, antidementia drugs and anticonvulsants score one point each and antipsychotics score two; a subtotal ≥ 2 scores the criterion (Martinez 2012, Table 7 footnote, p. 5). Benzodiazepines were recorded in the study but not weighted, so the card does not score them.",
   "evidence": "Full text, p. 5",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Martinez JA, et al. Derivation and validation of a clinical prediction rule for delirium in patients admitted to a medical ward. BMJ Open 2012;2:e001599."
   ],
   "links": [
    "https://doi.org/10.1136/bmjopen-2012-001599"
   ],
   "decision": "",
   "notes": "Benzodiazepines recorded in the study but not weighted — correctly excluded from scoring on the card.",
   "perSource": [
    {
     "label": "Martinez 2012 (ward risk rule)",
     "stance": "agrees",
     "note": "The weighting is stated twice: in the methods, and in the Table 7 footnote that defines the drugs criterion. Benzodiazepines were recorded at admission but are not part of the weighted score.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "Accordingly, the medication data was coded according to the number of different drugs patients were taking at admission with each antidepressant, antidementia or anticonvulsant drug contributing equally, while antipsychotic drugs were weighted by a factor of two. The ADL data were also dichotomised with a cut-off of reported impairments in five activities. The scores for the clinical prediction rule were assigned on the basis of regression coefficients obtained in the logistic regression model (table 7). One point was given to patients older than 85 years, to those who had two or more points in the variable drugs, and to those with impairments in five or more of the ADL considered. Therefore, the total score for the rule ranged between 0 and 3.",
       "highlight": "each antidepressant, antidementia or anticonvulsant drug contributing equally, while antipsychotic drugs were weighted by a factor of two",
       "page": "4"
      },
      {
       "scope": "on-scope",
       "context": "*Age: >85 years old. †DADLs: dependence in five or more activities of daily livings. ‡Drugs: total of two or more points for drugs taken on admission where antidepressants, antidementia drugs and anticonvulsants score one point each, and antipsychotics score two points.",
       "highlight": "total of two or more points for drugs taken on admission where antidepressants, antidementia drugs and anticonvulsants score one point each, and antipsychotics score two points",
       "page": "5"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-cards-r17",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "2",
   "section": "Risk card — bands",
   "statement": "Score 0 → Low (predicted incidence ~4%); 1 → Intermediate (~14–23%); 2–3 → High (~43–64%).",
   "contentType": "Cited clinical content",
   "sources": [
    "Martinez 2012 (ward risk rule)"
   ],
   "anchor": "Martinez 2012 — Table 8, p. 5 (delirium incidence by score; derivation / validation cohorts):",
   "passage": "score 0 → 9/219 (4) / 5/142 (3.5); score 1 → 16/116 (14) / 18/77 (23); score ≥ 2 → 27/62 (43) / 53/83 (64).\nExact match: the card's bands (~4%, ~14–23%, ~43–64%) are these derivation–validation incidence ranges. The High band covers scores 2–3 (Martinez's ≥ 2, since the maximum score is 3).",
   "evidence": "Full text, Table 8, p. 5",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Martinez JA, et al. Derivation and validation of a clinical prediction rule for delirium in patients admitted to a medical ward. BMJ Open 2012;2:e001599."
   ],
   "links": [
    "https://doi.org/10.1136/bmjopen-2012-001599"
   ],
   "decision": "",
   "notes": "Band percentages are the derivation-to-validation incidence ranges from Martinez Table 8.",
   "perSource": [
    {
     "label": "Martinez 2012 (ward risk rule)",
     "stance": "agrees",
     "note": "The bands are Table 8's incidence by score, read across the derivation and validation cohorts. The card's High band covers 2-3 because 3 is the rule's maximum, where Martinez reports the open-ended category as 2 or more.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "Table 8 Logistic regression model Group Points on the prediction rule Incidence of delirium (%) OR AUC (95% IC) Derivation cohort (n=397) 0.77 (0.73 to 0.82) 0 9/219 (4) Reference 1 16/116 (14) 3.7 (1.5 to 8.7) ≥2 27/62 (43) 18 (7.8 to 41.5) Validation cohort (n=302) 0.85 (0.8 to 0.88) 0 5/142 (3.5) Reference 1 18/77 (23) 8.3 (2.9 to 23.6) ≥2 53/83 (64) 48.4 (17.8 to 131.4)",
       "highlight": "0 9/219 (4) Reference 1 16/116 (14)",
       "page": "5"
      },
      {
       "scope": "on-scope",
       "context": "Table 8 Logistic regression model Group Points on the prediction rule Incidence of delirium (%) OR AUC (95% IC) Derivation cohort (n=397) 0.77 (0.73 to 0.82) 0 9/219 (4) Reference 1 16/116 (14) 3.7 (1.5 to 8.7) ≥2 27/62 (43) 18 (7.8 to 41.5) Validation cohort (n=302) 0.85 (0.8 to 0.88) 0 5/142 (3.5) Reference 1 18/77 (23) 8.3 (2.9 to 23.6) ≥2 53/83 (64) 48.4 (17.8 to 131.4)",
       "highlight": "0 5/142 (3.5) Reference 1 18/77 (23)",
       "page": "5"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-cards-r18",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "2",
   "section": "Prevention card — intro",
   "statement": "A multicomponent non-pharmacologic bundle reduced incident delirium in non-ICU inpatients (Cochrane RR 0.69). Antipsychotics do NOT prevent delirium — do not use them prophylactically.",
   "contentType": "Cited clinical content",
   "sources": [
    "Siddiqi 2016 (Cochrane)",
    "Inouye 1999 (HELP)",
    "Hshieh 2015 (meta-analysis)",
    "AGS 2015 (postoperative delirium guideline)",
    "Oh 2019 (antipsychotics — prevention)",
    "Neufeld 2016 (antipsychotics meta-analysis)"
   ],
   "anchor": "Siddiqi 2016 (Cochrane) — p. 7",
   "passage": "We found multi-component interventions reduced the incidence of delirium compared to usual care (RR 0.69, 95% CI 0.59 to 0.81; seven studies; 1950 participants; moderate-quality evidence).\nAlso Oh 2019 (antipsychotics — prevention) (p. 1): “Conclusion: Current evidence does not support routine use of haloperidol or second-generation antipsychotics for prevention of delirium.”\nAlso Neufeld 2016 (antipsychotics meta-analysis) (p. 2): “In seven studies comparing antipsychotics to placebo or no treatment for delirium prevention in postoperative patients, there was no significant effect on delirium incidence (OR 0.56; 95% CI 0.23, 1.34; I2 = 93%).”\nAlso AGS 2015 (postoperative delirium guideline) (p. 8): “There is insufficient evidence to recommend for or against the use of antipsychotic medications prophylactically in older surgical patients to prevent delirium”\nExact match on the number. Siddiqi 2016 (Cochrane) found multicomponent interventions reduced delirium incidence in non-ICU inpatients with RR 0.69 (95% CI 0.59–0.81; the card prints the point estimate; p. 7). On antipsychotics: Oh 2019 concludes current evidence does not support routine antipsychotics to prevent delirium, and Neufeld 2016 found no significant effect on incidence. AGS 2015 is more equivocal — it found 'insufficient evidence to recommend for or against' prophylactic antipsychotics (p. 8) — so the card's stronger 'do NOT prevent' rests on Oh 2019 / Neufeld 2016, not AGS.",
   "evidence": "Full text, p. 7",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Siddiqi N, et al. Interventions for preventing delirium in hospitalised non-ICU patients. Cochrane Database Syst Rev 2016;CD005563.",
    "Inouye SK, et al. A multicomponent intervention to prevent delirium in hospitalized older patients. N Engl J Med 1999;340:669.",
    "Hshieh TT, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med 2015;175:512.",
    "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142.",
    "Oh ES, et al. Antipsychotics for preventing delirium in hospitalized adults: a systematic review. Ann Intern Med 2019;171:474.",
    "Neufeld KJ, et al. Antipsychotic medication for prevention and treatment of delirium in hospitalized adults: a systematic review and meta-analysis. J Am Geriatr Soc 2016;64:705."
   ],
   "links": [
    "https://doi.org/10.1002/14651858.CD005563.pub3",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779",
    "https://doi.org/10.1111/jgs.13281",
    "https://doi.org/10.7326/M19-1859",
    "https://doi.org/10.1111/jgs.14076"
   ],
   "decision": "",
   "notes": "Antipsychotic-prophylaxis prohibition follows Oh 2019 / Neufeld 2016; AGS 2015 itself found insufficient evidence for or against.",
   "perSource": [
    {
     "label": "Siddiqi 2016 (Cochrane)",
     "cite": "Siddiqi N, et al. Interventions for preventing delirium in hospitalised non-ICU patients. Cochrane Database Syst Rev 2016;CD005563.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary on-scope source: Cochrane review of hospitalized non-ICU patients that directly supplies both the RR 0.69 multicomponent figure and the class-level antipsychotic conclusion.",
     "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3",
     "paragraphs": [
      {
       "context": "We found multi-component interventions reduced the incidence of delirium compared to usual care (RR 0.69, 95% CI 0.59 to 0.81; seven studies; 1950 participants; moderate-quality evidence). E ect sizes were similar in medical (RR 0.63, 95% CI 0.43 to 0.92; four studies; 1365 participants) and surgical settings (RR 0.71, 95% CI 0.59 to 0.85; three studies; 585 participants). In the subgroup of patients with preexisting dementia, the e ect of multi-component interventions remains uncertain (RR 0.90, 95% CI 0.59 to 1.36; one study, 50 participants; low-quality evidence).",
       "highlight": "multi-component interventions reduced the incidence of delirium compared to usual care (RR 0.69, 95% CI 0.59 to 0.81; seven studies; 1950 participants; moderate-quality evidence)",
       "scope": "on-scope",
       "note": "Abstract headline result and exact source of the claim's RR 0.69 in hospitalized non-ICU patients.",
       "page": "7",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "Available case analysis was performed on 1950 of 2018 randomised participants, using data from all seven studies. Pooled analysis showed evidence of a reduction in the incidence of delirium for multi-component interventions compared to usual care (risk ratio (RR) 0.69, 95% confidence interval (CI) 0.59 to 0.81, I2 = 0%; 1950 participants. We assessed this as moderate-quality evidence (downgraded due to risk of bias) (Analysis 1.1; Figure 3).",
       "highlight": "risk ratio (RR) 0.69, 95% confidence interval (CI) 0.59 to 0.81, I2 = 0%; 1950 participants",
       "scope": "on-scope",
       "note": "Results section restating the same RR 0.69 pooled estimate for multicomponent interventions.",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "Three trials provide no clear evidence of an e ect of antipsychotic medications as a group on the incidence of delirium (RR 0.73, 95% CI, 0.33 to 1.59; 916 participants; very low-quality evidence).",
       "highlight": "no clear evidence of an e ect of antipsychotic medications as a group on the incidence of delirium (RR 0.73, 95% CI, 0.33 to 1.59; 916 participants; very low-quality evidence)",
       "scope": "on-scope",
       "note": "Abstract statement supporting the second prong: antipsychotics as a class show no clear preventive effect.",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "Pooled analysis of all three studies was inconclusive regarding an e ect of antipsychotic treatment on incident delirium, but there was moderate heterogeneity between the studies (RR 0.73, 95% CI 0.33 to 1.59, I2= 90%; 916 participants; very low-quality evidence due to risk of bias, imprecision and inconsistency) (Analysis 3.1; Figure 5).",
       "highlight": "RR 0.73, 95% CI 0.33 to 1.59, I2= 90%; 916 participants; very low-quality evidence due to risk of bias, imprecision and inconsistency",
       "scope": "on-scope",
       "note": "Results-section detail confirming the inconclusive class-level antipsychotic finding.",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "There is strong evidence supporting multi-component interventions to prevent delirium in hospitalised patients. There is no clear evidence that cholinesterase inhibitors, antipsychotic medication or melatonin reduce the incidence of delirium. Using the Bispectral Index to monitor and control depth of anaesthesia reduces the incidence of postoperative delirium. The role of drugs and other anaesthetic techniques to prevent delirium remains uncertain.",
       "highlight": "There is no clear evidence that cholinesterase inhibitors, antipsychotic medication or melatonin reduce the incidence of delirium",
       "scope": "on-scope",
       "note": "Authors' conclusions capturing both prongs in one statement (multicomponent works; antipsychotics unproven).",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "version, and the evidence summarised in this update supports the use of multi-component interventions. However, we found a continuing lack of evidence to support the use of antipsychotic medication as a group in the prevention of delirium.",
       "highlight": "we found a continuing lack of evidence to support the use of antipsychotic medication as a group in the prevention of delirium",
       "scope": "on-scope",
       "note": "Discussion reaffirming no class-level evidence for antipsychotic prophylaxis.",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "The pre-planned subgroup analysis assessed the e ect of typical and atypical antipsychotics separately on delirium incidence. There was no evidence of e ect of haloperidol on delirium incidence (RR 1.05, 95% CI 0.69 to 1.60, I2= 43%; two studies; 516 participants; lowquality evidence downgraded due to risk of bias and inconsistency). However, the risk of incident delirium was lower with olanzapine than with placebo (RR 0.36, 95% CI 0.24 to 0.52; one study; 400 participants; moderate-quality evidence due to risk of bias) (Figure 5).",
       "highlight": "the risk of incident delirium was lower with olanzapine than with placebo (RR 0.36, 95% CI 0.24 to 0.52; one study; 400 participants; moderate-quality evidence due to risk of bias)",
       "scope": "different-intervention",
       "note": "Nearest-match caveat: within this review one atypical agent (olanzapine, surgical trial) DID lower incidence, so the blanket 'antipsychotics do not prevent delirium' holds only at class level, not for this specific drug.",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      }
     ]
    },
    {
     "label": "Inouye 1999 (HELP)",
     "cite": "Inouye SK, et al. A multicomponent intervention to prevent delirium in hospitalized older patients. N Engl J Med 1999;340:669.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Landmark HELP trial supporting only the multicomponent prong (no antipsychotic content); population is hospitalized older general-medicine patients, i.e. non-ICU.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Results Delirium developed in 9.9 percent of the intervention group, as compared with 15.0 percent of the usual-care group (matched odds ratio, 0.60; 95 percent confidence interval, 0.39 to 0.92). The total number of days with delirium (105 vs. 161, P=0.02) and the total number of episodes (62 vs. 90, P=0.03) were significantly lower in the intervention group. However, the severity of delirium and recurrence rates were not significantly different. The overall rate of adherence to the intervention was 87 percent, and the total number of targeted risk factors per patient was significantly reduced. Intervention was associated with significant improvement in the degree of cognitive impairment among patients with cognitive impairment at admission and with a significant reduction in the rate of use of sleep medications among all patients. Among the other risk factors, there were trends toward improvement in immobility, visual impairment, and hearing impairment. Conclusions The risk-factor intervention strategy that we studied resulted in significant reductions in the number and duration of episodes of delirium in hospitalized older patients. The intervention had no significant effect on the severity of delirium or on recurrence rates; this finding suggests that primary prevention of delirium is probably the most effective treatment strategy. (N Engl J Med 1999;340:669-76.)",
       "highlight": "Delirium developed in 9.9 percent of the intervention group, as compared with 15.0 percent of the usual-care group (matched odds ratio, 0.60; 95 percent confidence interval, 0.39 to 0.92)",
       "scope": "on-scope",
       "note": "Primary result: multicomponent bundle reduced incident delirium (OR 0.60) in non-ICU older inpatients; a different effect metric than Cochrane's RR but same direction.",
       "page": "669",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Methods We studied 852 patients 70 years of age or older who had been admitted to the general-medicine service at a teaching hospital. Patients from one intervention unit and two usual-care units were enrolled by means of a prospective matching strategy. The intervention consisted of standardized protocols for the management of six risk factors for delirium: cognitive impairment, sleep deprivation, immobility, visual impairment, hearing impairment, and dehydration. Delirium, the primary outcome, was assessed daily until discharge.",
       "highlight": "standardized protocols for the management of six risk factors for delirium: cognitive impairment, sleep deprivation, immobility, visual impairment, hearing impairment, and dehydration",
       "scope": "on-scope",
       "note": "Defines the multicomponent non-pharmacologic bundle referenced by the claim.",
       "page": "669",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "Hshieh 2015 (meta-analysis)",
     "cite": "Hshieh TT, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med 2015;175:512.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Meta-analysis supporting the multicomponent prong across hospitalized older patients; does not address antipsychotics.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "MAIN OUTCOMES AND MEASURES We identified 14 interventional studies. The results for outcomes of delirium incidence, falls, length of stay, and institutionalization were pooled for the meta-analysis, but heterogeneity limited our meta-analysis of the results for change in functional or cognitive status. Overall, 11 studies demonstrated significant reductions in delirium incidence (odds ratio [OR], 0.47; 95% CI, 0.38-0.58). Four randomized or matched trials reduced delirium incidence by 44% (OR, 0.56; 95% CI, 0.42-0.76). The rate of falls decreased significantly among intervention patients in 4 studies (OR, 0.38; 95% CI, 0.25-0.60); in 2 randomized or matched trials, the rate of falls was reduced by 64% (OR, 0.36; 95% CI, 0.22-0.61). Length of stay and institutionalization also trended toward decreases in the intervention groups, with a mean difference of -0.16 (95% CI, -0.97 to 0.64) day shorter and the odds of institutionalization 5% lower (OR, 0.95; 95% CI, 0.71-1.26). Among higher-quality randomized or matched trials, length of stay trended -0.33 (95% CI, -1.38 to 0.72) day shorter, and the odds of institutionalization trended 6% lower (OR, 0.94; 95% CI, 0.69-1.30).",
       "highlight": "11 studies demonstrated significant reductions in delirium incidence (odds ratio [OR], 0.47; 95% CI, 0.38-0.58)",
       "scope": "on-scope",
       "note": "Pooled effect of multicomponent nonpharmacological interventions on delirium incidence (OR 0.47).",
       "page": "512",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "Delirium Incidence Eleven studies measured delirium incidence (Table 2). Overall, the meta-analysis involving 4267 patients showed that the odds of delirium were 53% lower in the intervention group compared with controls (OR, 0.47; 95% CI, 0.38-0.58) (Figure 2). The NNT in the combined sample was 14.3 (95% CI, 11.1-20.0).",
       "highlight": "the odds of delirium were 53% lower in the intervention group compared with controls (OR, 0.47; 95% CI, 0.38-0.58)",
       "scope": "on-scope",
       "note": "Results-section restatement of the 53% reduction in delirium incidence.",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "Stratified by study type, multicomponent nonpharmacological delirium interventions lowered the odds of delirium by 44% (relative risk, 0.56; 95% CI, 0.42-0.76) among 977 intervention patients included in 4 RMTs and by 63% (OR, 0.37; 95% CI, 0.27-0.53) among 752 intervention patients included in 7 non-RMTs (Table 2 and eFigure 1 in the Supplement). The NNTs were 20.0 (95% CI, 12.5-33.3) among RMTs and 11.1 (95% CI, 8.316.7) among non-RMTs. Delirium incidence was also stratified by patient type (eFigure 2 in the Supplement).",
       "highlight": "lowered the odds of delirium by 44% (relative risk, 0.56; 95% CI, 0.42-0.76)",
       "scope": "on-scope",
       "note": "Higher-quality randomized/matched-trial subset still shows a significant reduction (RR 0.56).",
       "page": "",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "CONCLUSIONS AND RELEVANCE Multicomponent nonpharmacological delirium prevention interventions are effective in reducing delirium incidence and preventing falls, with a trend toward decreasing length of stay and avoiding institutionalization. Given the current focus on prevention of hospital-based complications and improved cost-effectiveness of care, this meta-analysis supports the use of these interventions to advance acute care for older persons.",
       "highlight": "Multicomponent nonpharmacological delirium prevention interventions are effective in reducing delirium incidence and preventing falls",
       "scope": "on-scope",
       "note": "Conclusion endorsing multicomponent nonpharmacological prevention.",
       "page": "512",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    },
    {
     "label": "AGS 2015 (postoperative delirium guideline)",
     "cite": "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Guideline scoped to postoperative/surgical older adults (explicitly excludes ICU): strongly backs multicomponent prevention but rates prophylactic antipsychotics as 'insufficient evidence' rather than clearly ineffective.",
     "docUrl": "https://doi.org/10.1111/jgs.13281",
     "paragraphs": [
      {
       "context": "Recommendation--Healthcare systems and hospitals should implement multicomponent nonpharmacologic intervention programs delivered by an interdisciplinary team (including physicians, nurses, and possibly other healthcare professionals) for the entire hospitalization in at-risk older adults undergoing surgery to prevent delirium (strength of recommendation: strong; quality of evidence: moderate).",
       "highlight": "in at-risk older adults undergoing surgery to prevent delirium (strength of recommendation: strong; quality of evidence: moderate)",
       "scope": "different-setting",
       "note": "Strong recommendation for multicomponent prevention, but framed for the perioperative surgical population rather than general non-ICU inpatients.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "Recommendation--There is insufficient evidence to recommend for or against the use of antipsychotic medications prophylactically in older surgical patients to prevent delirium (strength of recommendation: not applicable; quality of evidence: low).",
       "highlight": "There is insufficient evidence to recommend for or against the use of antipsychotic medications prophylactically in older surgical patients to prevent delirium",
       "scope": "different-setting",
       "note": "Partial divergence: for surgical patients AGS concludes insufficient evidence (equivocal), not the claim's clear 'do not use prophylactically.'",
       "page": "",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "A. Evidence for Recommendation: Prophylactic use of antipsychotic medications to prevent delirium in postoperative patients has limited, inconsistent, and contradictory support in the literature. Five studies found decreased incidence of delirium,66ET,67ET,68ET,69ET,70ET and three did not.71ET,72ET,73ET Most studies are of low quality and often have a high risk of bias.",
       "highlight": "Five studies found decreased incidence of delirium,66ET,67ET,68ET,69ET,70ET and three did not",
       "scope": "different-setting",
       "note": "Evidence rationale noting several postoperative studies found antipsychotics DID lower incidence, underpinning the equivocal (not clearly negative) stance.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "XII. Antipsychotics in the Setting of Severe Agitation Recommendation--The prescribing practitioner may use antipsychotics at the lowest effective dose for the shortest possible duration to treat patients who are severely agitated or distressed, and are threatening substantial harm to self and/or others. In all cases, treatment with antipsychotics should be employed only if behavioral interventions have failed or are not possible, and ongoing use should be evaluated daily with in-person examination of patients (strength of recommendation: weak; quality of evidence: low).",
       "highlight": "The prescribing practitioner may use antipsychotics at the lowest effective dose for the shortest possible duration to treat patients who are severely agitated",
       "scope": "different-intervention",
       "note": "Addresses antipsychotics for symptomatic treatment of severe agitation, not prophylaxis — a distinct use the claim does not cover.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "The guideline is limited to the aims described. Some of these recommendations will not apply to specific areas of care, such as intensive care unit (ICU) sedation, palliative care, and nursing home settings. Diagnosis and screening are not addressed in these guidelines. Other topics, such as prescription of melatonin to prevent delirium, were considered but not addressed due to a lack of evidence.9ET,10ET Since delirium is a burgeoning area of clinical investigation, regular updates of the recommendations are planned as new evidence becomes available.",
       "highlight": "Some of these recommendations will not apply to specific areas of care, such as intensive care unit (ICU) sedation, palliative care, and nursing home settings",
       "scope": "background",
       "note": "Scope boundary confirming the guideline targets perioperative surgical care and excludes ICU.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      }
     ]
    },
    {
     "label": "Oh 2019 (antipsychotics — prevention)",
     "cite": "Oh ES, et al. Antipsychotics for preventing delirium in hospitalized adults: a systematic review. Ann Intern Med 2019;171:474.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "AHRQ systematic review directly supporting the antipsychotic prong (no support for routine preventive use) and also endorsing multicomponent prevention; carries a postoperative second-generation-antipsychotic caveat.",
     "docUrl": "https://doi.org/10.7326/M19-1859",
     "paragraphs": [
      {
       "context": "Conclusion: Current evidence does not support routine use of haloperidol or second-generation antipsychotics for prevention of delirium. There is limited evidence that second-generation antipsychotics may lower the incidence of delirium in postoperative patients, but more research is needed. Future trials should use standardized outcome measures.",
       "highlight": "Current evidence does not support routine use of haloperidol or second-generation antipsychotics for prevention of delirium",
       "scope": "on-scope",
       "note": "Headline conclusion directly supporting 'do not use antipsychotics prophylactically.'",
       "page": "474",
       "docUrl": "https://doi.org/10.7326/M19-1859"
      },
      {
       "context": "Data Synthesis: A total of 14 RCTs were included. There were no differences in delirium incidence or duration, hospital length of stay (high strength of evidence [SOE]), and mortality between haloperidol and placebo used for delirium prevention. Little to no evidence was found to determine the effect of haloperidol on cognitive function, delirium severity (insufficient SOE), inappropriate continuation, and sedation (insufficient SOE).",
       "highlight": "There were no differences in delirium incidence or duration, hospital length of stay (high strength of evidence [SOE]), and mortality between haloperidol and placebo used for delirium prevention",
       "scope": "on-scope",
       "note": "High-SOE finding of no haloperidol benefit for prevention.",
       "page": "474",
       "docUrl": "https://doi.org/10.7326/M19-1859"
      },
      {
       "context": "Nine RCTs with varying ROB (29, 32, 33, 36 -38, 40 - 42) (3412 participants) compared delirium incidence between haloperidol and placebo groups. These RCTs included patients in both surgical and medical ICU and non-ICU settings, and used a variety of validated instruments for diagnosis of delirium. We found no difference in the RR for delirium with haloperidol compared with placebo (0.94 [CI, 0.77 to 1.16]) (Figure 3; Supplement Figure 3 and Supplement Table 9, available at Annals.org).",
       "highlight": "We found no difference in the RR for delirium with haloperidol compared with placebo (0.94 [CI, 0.77 to 1.16])",
       "scope": "on-scope",
       "note": "Pooled result (medical and surgical, ICU and non-ICU) showing haloperidol does not reduce incidence.",
       "page": "478",
       "docUrl": "https://doi.org/10.7326/M19-1859"
      },
      {
       "context": "At this time, multicomponent nonpharmacologic interventions, including such therapeutic activities as reminiscing, interacting with family and friends, sleep enhancement, and early mobilization (9, 10), are effective (11) and are recommended for delirium prevention (12). Despite the efficacy and cost-effectiveness of multicomponent nonpharmacologic interventions in delirium prevention (13), pharmacologic interventions, including antipsychotic medications, continue to be evaluated for potential benefit in preventing delirium.",
       "highlight": "are effective (11) and are recommended for delirium prevention (12)",
       "scope": "on-scope",
       "note": "Independently reaffirms the multicomponent prong as effective and recommended.",
       "page": "474",
       "docUrl": "https://doi.org/10.7326/M19-1859"
      },
      {
       "context": "We found a statistically significant and clinically meaningful difference favoring second-generation antipsychotics in the pooled analysis (RR, 0.36 [CI, 0.26 to 0.50]) (Figure 3; Supplement Figure 3 and Supplement Table 9).",
       "highlight": "We found a statistically significant and clinically meaningful difference favoring second-generation antipsychotics in the pooled analysis (RR, 0.36 [CI, 0.26 to 0.50])",
       "scope": "different-setting",
       "note": "Nearest-match caveat: second-generation antipsychotics did lower incidence, but only in the postoperative on-pump cardiac/joint-replacement surgery setting — not general non-ICU prophylaxis.",
       "page": "478",
       "docUrl": "https://doi.org/10.7326/M19-1859"
      }
     ]
    },
    {
     "label": "Neufeld 2016 (antipsychotics meta-analysis)",
     "cite": "Neufeld KJ, et al. Antipsychotic medication for prevention and treatment of delirium in hospitalized adults: a systematic review and meta-analysis. J Am Geriatr Soc 2016;64:705.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Systematic review/meta-analysis supporting the antipsychotic prong; its preventive evidence is drawn specifically from postoperative trials while the conclusion generalizes to hospitalized adults.",
     "docUrl": "https://doi.org/10.1111/jgs.14076",
     "paragraphs": [
      {
       "context": "Conclusion--Antipsychotics for prevention or treatment of delirium is not supported by current evidence. Additional methodologically rigorous studies using standardized outcome measures are needed.",
       "highlight": "Antipsychotics for prevention or treatment of delirium is not supported by current evidence",
       "scope": "on-scope",
       "note": "Abstract conclusion supporting the claim that antipsychotics do not prevent delirium.",
       "page": "705",
       "docUrl": "https://doi.org/10.1111/jgs.14076"
      },
      {
       "context": "There is insufficient evidence currently to support the routine use of antipsychotic pharmacotherapy to prevent or treat delirium in hospitalized adult patients, including in the postoperative setting. There is a great need to standardize outcome measures via creation of a core outcome set for delirium prevention and treatment trials and conduct of additional rigorous well-powered RCTs in high risk populations.",
       "highlight": "There is insufficient evidence currently to support the routine use of antipsychotic pharmacotherapy to prevent or treat delirium in hospitalized adult patients, including in the postoperative setting",
       "scope": "on-scope",
       "note": "Formal conclusion generalizing the no-benefit finding to hospitalized adults.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/jgs.14076"
      },
      {
       "context": "This systematic review and meta-analysis suggests that antipsychotic pharmacotherapy does not improve outcomes when used for prevention or treatment of delirium in hospitalized adult patients. Antipsychotics were not associated with improvements short-term mortality, severity or duration of delirium, and length of ICU and hospital stay. However, existing studies demonstrate heterogeneity in study design, including diverse populations, with few studies focused specifically on older postoperative patients. There was substantial variability in outcome measures with few postoperative studies evaluating mortality and functional outcomes.",
       "highlight": "antipsychotic pharmacotherapy does not improve outcomes when used for prevention or treatment of delirium in hospitalized adult patients",
       "scope": "on-scope",
       "note": "Discussion statement reinforcing lack of preventive benefit across hospitalized adults.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/jgs.14076"
      },
      {
       "context": "Results--Screening of 10,877 eligible records identified 19 studies. In seven studies comparing antipsychotics to placebo or no treatment for delirium prevention in postoperative patients, there was no significant effect on delirium incidence (OR 0.56; 95% CI 0.23, 1.34; I2 = 93%). Using data reported from all 19 studies, antipsychotic use was not associated with change in delirium duration, severity, hospital or ICU LOS, with high heterogeneity among studies. No association with mortality was detected (OR 0.90; 95% CI 0.62, 1.29; I2 = 0%).",
       "highlight": "there was no significant effect on delirium incidence (OR 0.56; 95% CI 0.23, 1.34; I2 = 93%)",
       "scope": "different-setting",
       "note": "The actual prevention meta-analysis pools only postoperative surgical trials, so the underlying preventive evidence is narrower than the generalized conclusion.",
       "page": "705",
       "docUrl": "https://doi.org/10.1111/jgs.14076"
      }
     ]
    }
   ],
   "synthesis": "The primary on-scope source, Siddiqi 2016 (Cochrane, hospitalized non-ICU patients), directly supports both prongs — multicomponent interventions cut incident delirium (RR 0.69) while antipsychotics as a class show no clear benefit — and it governs because it is the exact population and figure the claim cites; it is corroborated for the bundle by Inouye 1999 and Hshieh 2015 and for antipsychotics by Oh 2019 and Neufeld 2016. The only divergence is scope, not direction: atypical/second-generation antipsychotics reduced incidence in postoperative surgical trials (Siddiqi's olanzapine subgroup and Oh's second-generation pooled RR 0.36), and the AGS 2015 postoperative guideline rates prophylactic antipsychotics as \"insufficient evidence\" rather than clearly ineffective — a different surgical setting/agent that should not be read as endorsing routine antipsychotic prophylaxis in general non-ICU inpatients.",
   "discrepancy": true
  },
  {
   "id": "sd-cards-r19",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "2",
   "section": "Prevention card — bundle",
   "statement": "Ten-component HELP-style bundle: reorientation; glasses & hearing aids; early mobilization; sleep protocol; hydration & nutrition; deliriogenic/anticholinergic medication review; pain treated without over-sedation; bowel/bladder care; infection/hypoxia/metabolic work-up; family engagement & education.",
   "contentType": "Cited clinical content",
   "sources": [
    "Siddiqi 2016 (Cochrane)",
    "Inouye 1999 (HELP)",
    "Hshieh 2015 (meta-analysis)",
    "AGS 2015 (postoperative delirium guideline)"
   ],
   "anchor": "AGS 2015 (postoperative delirium guideline) — p. 4",
   "passage": "Nonpharmacologic interventions to prevent postoperative delirium may include the following elements: cognitive reorientation, sleep enhancement (i.e., nonpharmacologic sleep protocol and sleep hygiene), early mobility and/or physical rehabilitation, adaptations for visual and hearing impairment, nutrition and fluid repletion, pain management, appropriate medication usage, adequate oxygenation, and prevention of constipation.\nAlso Siddiqi 2016 (Cochrane) (p. 16): “Risk factors that have so far been identified include: increased age, sensory deprivation (visual or hearing impairment), sleep deprivation, social isolation, physical restraint, use of bladder catheter, iatrogenic adverse events, poly-pharmacy (more than three new medications added), use of psychoactive drugs, co-morbidities, severe illness (especially infection, fracture or stroke), prior cognitive impairment, temperature abnormality (fever or hypothermia), dehydration, malnutrition and low serum albumin”\nComposite (HELP-style). AGS 2015 (p. 4) lists most components verbatim — cognitive reorientation, sleep enhancement, early mobility, adaptations for visual/hearing impairment, nutrition and fluid repletion, pain management, appropriate medication use, adequate oxygenation, prevention of constipation. Siddiqi 2016 frames the same as modifiable risk factors (adds physical restraint and bladder catheter; p. 16). A few card specifics — whiteboard/clock/calendar, eye mask/earplugs, family engagement & delirium education — trace to the Hospital Elder Life Program (Inouye 1999) and Hshieh 2015, which the tool cites but which are not held in the local reference archive.",
   "evidence": "Full text, p. 4 — partial support",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Siddiqi N, et al. Interventions for preventing delirium in hospitalised non-ICU patients. Cochrane Database Syst Rev 2016;CD005563.",
    "Inouye SK, et al. A multicomponent intervention to prevent delirium in hospitalized older patients. N Engl J Med 1999;340:669.",
    "Hshieh TT, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med 2015;175:512.",
    "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142."
   ],
   "links": [
    "https://doi.org/10.1002/14651858.CD005563.pub3",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1001/jamainternmed.2014.7779",
    "https://doi.org/10.1111/jgs.13281"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Siddiqi 2016 (Cochrane)",
     "cite": "Siddiqi N, et al. Interventions for preventing delirium in hospitalised non-ICU patients. Cochrane Database Syst Rev 2016;CD005563.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Cochrane review of prevention in hospitalized non-ICU patients — the exact step-down/ward setting the card targets; supports the multicomponent nonpharmacological approach but treats the specific component list as variable rather than prescribing all ten.",
     "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3",
     "paragraphs": [
      {
       "context": "Most included individualised care, an educational component, reorientation, and early mobilisation. Many of the delirium risk factors targeted with multi-component interventions relate to good basic care.",
       "highlight": "Most included individualised care, an educational component, reorientation, and early mobilisation.",
       "scope": "on-scope",
       "note": "Across seven non-ICU multicomponent-intervention trials, the bundles commonly included individualized care, education, reorientation, and early mobilization.",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "On the basis of seven randomised controlled trials (RCTs) (four in medical patients and three in surgical patients) n = 1950 participants, there is moderate-quality evidence that multicomponent delirium prevention interventions can reduce rates of incident delirium; this is consistent across the included trials. Evidence has been downgraded due to the possibility of performance bias (the nature of the intervention precludes blinding of participants and those delivering intervention). Outcome assessors were unblinded to the intervention in two studies, including the study with the largest weighting and highest event rate. Furthermore, there is a risk of other bias in two of the included studies due to an imbalance between the intervention and control groups in respect to the prevalence of pre-existing dementia.",
       "highlight": "multicomponent delirium prevention interventions can reduce rates of incident delirium",
       "scope": "on-scope",
       "note": "Moderate-quality evidence that a multicomponent prevention bundle lowers incident delirium in hospitalized non-ICU (medical and surgical) patients.",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "Preliminary evidence for the content of multicomponent interventions suggests that they should include as a minimum: sta education; individualised care (sometimes referred to as person-centred care); re-orientation at frequent intervals; and early mobilisation, but this needs further investigation. These areas are familiar aspects of care but are currently poorly and unreliably delivered.",
       "highlight": "re-orientation at frequent intervals; and early mobilisation",
       "scope": "on-scope",
       "note": "The review's view of minimum bundle content reinforces reorientation and early mobilization as core elements.",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "There are many risk factors for developing delirium (e.g. infection, dehydration, certain medications). Therefore, one approach (called `multi-component interventions') to preventing delirium is to target these multiple risk factors. Some medications have e ects on the brain chemicals implicated in developing delirium, and may, therefore, have a role in prevention. There are also a number of other interventions that target delirium risk factors related to anaesthesia and medical treatment around the time of surgery.",
       "highlight": "There are many risk factors for developing delirium (e.g. infection, dehydration, certain medications).",
       "scope": "background",
       "note": "Rationale for the bundle — targeting multiple modifiable risk factors (infection, dehydration, medications) underpins the work-up, hydration, and medication-review components.",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "Research in older people has identified a range of risk factors for delirium. The condition clearly has a multi-factorial aetiology, and these risk factors interact (Inouye 1998b); the more risk factors that are present, the greater the likelihood that the patient will develop delirium. Risk factors that have so far been identified include: increased age, sensory deprivation (visual or hearing impairment), sleep deprivation, social isolation, physical restraint, use of bladder catheter, iatrogenic adverse events, poly-pharmacy (more than three new medications added), use of psychoactive drugs, comorbidities, severe illness (especially infection, fracture or stroke), prior cognitive impairment, temperature abnormality (fever or hypothermia), dehydration, malnutrition and low serum albumin (Inouye 1998b; Inouye 1999c; NICE 2010).",
       "highlight": "use of bladder catheter, iatrogenic adverse events, poly-pharmacy (more than three new medications added)",
       "scope": "background",
       "note": "The risk-factor list grounds several otherwise weakly-cited components — bladder catheters, polypharmacy, sensory deprivation, sleep, and infection are all recognized delirium risk factors.",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      }
     ]
    },
    {
     "label": "Inouye 1999 (HELP)",
     "cite": "Inouye SK, et al. A multicomponent intervention to prevent delirium in hospitalized older patients. N Engl J Med 1999;340:669.",
     "kind": "pdf",
     "stance": "partial",
     "note": "The foundational HELP randomized trial in hospitalized older medical (non-ICU) patients; establishes six of the ten listed components but does not address nutrition, medication review, pain, bowel/bladder care, infection/hypoxia/metabolic work-up, or family engagement as discrete components.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "Methods We studied 852 patients 70 years of age or older who had been admitted to the general-medicine service at a teaching hospital. Patients from one intervention unit and two usual-care units were enrolled by means of a prospective matching strategy. The intervention consisted of standardized protocols for the management of six risk factors for delirium: cognitive impairment, sleep deprivation, immobility, visual impairment, hearing impairment, and dehydration. Delirium, the primary outcome, was assessed daily until discharge.",
       "highlight": "standardized protocols for the management of six risk factors for delirium: cognitive impairment, sleep deprivation, immobility, visual impairment, hearing impairment, and dehydration",
       "scope": "on-scope",
       "note": "The HELP protocol the bundle is named for — six targeted risk factors mapping to reorientation, sleep, mobilization, glasses, hearing aids, and hydration.",
       "page": "669",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Orientation protocol: board with names of care-team members and day's schedule; communication to reorient to surroundings",
       "highlight": "communication to reorient to surroundings",
       "scope": "on-scope",
       "note": "Supports the reorientation component.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Nonpharmacologic sleep protocol: at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage",
       "highlight": "at bedtime, warm drink (milk or herbal tea), relaxation tapes or music, and back massage",
       "scope": "on-scope",
       "note": "Supports the nonpharmacologic sleep-protocol component.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints)",
       "highlight": "ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints)",
       "scope": "on-scope",
       "note": "Supports early mobilization; also minimizes immobilizing equipment such as bladder catheters, touching the bowel/bladder-care component.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Vision protocol: visual aids (e.g., glasses or magnifying lenses) and adaptive equipment (e.g., large illuminated telephone keypads, large-print books, and fluorescent tape on call bell), with daily reinforcement of their use",
       "highlight": "visual aids (e.g., glasses or magnifying lenses)",
       "scope": "on-scope",
       "note": "Supports the glasses/visual-aids component.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Hearing protocol: portable amplifying devices, earwax disimpaction, and special communication techniques, with daily reinforcement of these adaptations",
       "highlight": "portable amplifying devices, earwax disimpaction, and special communication techniques",
       "scope": "on-scope",
       "note": "Supports the hearing-aids component.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Dehydration protocol: early recognition of dehydration and volume repletion (i.e., encouragement of oral intake of fluids)",
       "highlight": "early recognition of dehydration and volume repletion (i.e., encouragement of oral intake of fluids)",
       "scope": "on-scope",
       "note": "Supports the hydration component (nutrition is not addressed separately).",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "Hshieh 2015 (meta-analysis)",
     "cite": "Hshieh TT, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med 2015;175:512.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Meta-analysis of 14 trials in hospitalized older persons confirming the HELP-style multicomponent approach; enumerates the core HELP components (adding nutrition and family-delivered care) but does not prescribe medication review, pain, bowel/bladder, or infection/hypoxia/metabolic work-up as components.",
     "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779",
     "paragraphs": [
      {
       "context": "The HELP uses an interdisciplinary team and trained volunteers to implement practical interventions, including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations.",
       "highlight": "including reorientation, early mobilization, therapeutic activities, hydration, nutrition, sleep strategies, and hearing and vision adaptations",
       "scope": "on-scope",
       "note": "Names the HELP components the card mirrors: reorientation, mobilization, therapeutic activities, hydration, nutrition, sleep, and hearing/vision adaptations.",
       "page": "513",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "b Evidence-based nonpharmacological interventions include the following: cognition or orientation (C), early mobility (E), hearing (H), sleep-wake cycle preservation (P), vision (V), and hydration (W).",
       "highlight": "cognition or orientation (C), early mobility (E), hearing (H), sleep-wake cycle preservation (P), vision (V), and hydration (W)",
       "scope": "on-scope",
       "note": "The six evidence-based HELP interventions used to characterize included studies — maps to reorientation, mobilization, hearing, sleep, glasses, and hydration.",
       "page": "515",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      },
      {
       "context": "New multicomponent nonpharmacological delirium interventions have been developed, targeting perioperative patients16-18 or using volunteers, family members, and nurses in the delivery of interventions.",
       "highlight": "using volunteers, family members, and nurses in the delivery of interventions",
       "scope": "on-scope",
       "note": "Supports the family-engagement component: family members can help deliver reorientation and other bundle elements.",
       "page": "513",
       "docUrl": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    },
    {
     "label": "AGS 2015 (postoperative delirium guideline)",
     "cite": "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary anchor. This AGS guideline enumerates nearly all ten bundle components in a single strong recommendation and adds the work-up, pain, and medication-review pieces; its population is at-risk older SURGICAL/postoperative adults, and it explicitly excludes ICU sedation, palliative, and nursing-home care.",
     "docUrl": "https://doi.org/10.1111/jgs.13281",
     "paragraphs": [
      {
       "context": "A. Evidence for Recommendation: Nonpharmacologic interventions to prevent postoperative delirium may include the following elements: cognitive reorientation, sleep enhancement (i.e., nonpharmacologic sleep protocol and sleep hygiene), early mobility and/or physical rehabilitation, adaptations for visual and hearing impairment, nutrition and fluid repletion, pain management, appropriate medication usage, adequate oxygenation, and prevention of constipation. The managing team should perform daily rounds providing both general and specific recommendations. Adherence is an important consideration.",
       "highlight": "cognitive reorientation, sleep enhancement (i.e., nonpharmacologic sleep protocol and sleep hygiene), early mobility and/or physical rehabilitation, adaptations for visual and hearing impairment, nutrition and fluid repletion, pain management, appropriate medication usage, adequate oxygenation, and prevention of constipation",
       "scope": "on-scope",
       "note": "The primary anchor — one recommendation enumerating nine of the ten components, including oxygenation (hypoxia) and prevention of constipation (bowel care).",
       "page": "4",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "Recommendation--Healthcare systems and hospitals should implement multicomponent nonpharmacologic intervention programs delivered by an interdisciplinary team (including physicians, nurses, and possibly other healthcare professionals) for the entire hospitalization in at-risk older adults undergoing surgery to prevent delirium (strength of recommendation: strong; quality of evidence: moderate).",
       "highlight": "implement multicomponent nonpharmacologic intervention programs delivered by an interdisciplinary team",
       "scope": "on-scope",
       "note": "Strong recommendation for the interdisciplinary multicomponent prevention bundle — the guideline basis for the card.",
       "page": "4",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "Recommendation--The healthcare professional should perform a medical evaluation, make medication and/or environmental adjustments, and order appropriate diagnostic tests and clinical consultations after an older adult has been diagnosed with postoperative delirium to identify and manage underlying contributors to delirium (strength of recommendation: strong; quality of evidence: low).",
       "highlight": "order appropriate diagnostic tests and clinical consultations after an older adult has been diagnosed with postoperative delirium to identify and manage underlying contributors to delirium",
       "scope": "on-scope",
       "note": "Supports the infection/hypoxia/metabolic work-up component (evaluate and manage underlying contributors), though framed for management after delirium is diagnosed.",
       "page": "5",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "VIII. Analgesia Recommendation--Healthcare professionals should optimize postoperative pain control, preferably with nonopioid pain medications, to minimize pain in older adults to prevent delirium (strength of recommendation: strong; quality of evidence: low).",
       "highlight": "optimize postoperative pain control, preferably with nonopioid pain medications, to minimize pain in older adults to prevent delirium",
       "scope": "on-scope",
       "note": "Supports pain treated without over-sedation — nonopioid-preferred analgesia to minimize both pain and sedating opioids.",
       "page": "7",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "A. Evidence for Recommendation: Relevant medications or medication classes include benzodiazepines, anticholinergics (e.g., cyclobenzaprine, oxybutynin, prochlorperazine, promethazine, tricyclic antidepressants, paroxetine and drugs with high anticholinergic properties), diphenhydramine, hydroxyzine, histamine2-receptor antagonists (e.g., cimetidine), sedative-hypnotics, and meperidine. Since the studies regarding specific medications provide generally low-level evidence, the current recommendation relied on the 2012 AGS Beers Criteria.11 Current evidence most strongly associates use of anticholinergic drugs, meperidine and benzodiazepines with increased postoperative delirium. Studies have identified the following medications with increased delirium: diphenhydramine,63ET meperidine,2ET midazolam,64ET and anticholinergic medications.65ET Drugs that contribute to serotonin syndrome can increase delirium risk, as can the use of multiple medications (five or greater).",
       "highlight": "Current evidence most strongly associates use of anticholinergic drugs, meperidine and benzodiazepines with increased postoperative delirium",
       "scope": "on-scope",
       "note": "Supports the deliriogenic/anticholinergic medication-review component — avoid anticholinergics, benzodiazepines, and meperidine.",
       "page": "8",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "The guideline is limited to the aims described. Some of these recommendations will not apply to specific areas of care, such as intensive care unit (ICU) sedation, palliative care, and nursing home settings. Diagnosis and screening are not addressed in these guidelines. Other topics, such as prescription of melatonin to prevent delirium, were considered but not addressed due to a lack of evidence.9ET,10ET Since delirium is a burgeoning area of clinical investigation, regular updates of the recommendations are planned as new evidence becomes available.",
       "highlight": "Some of these recommendations will not apply to specific areas of care, such as intensive care unit (ICU) sedation, palliative care, and nursing home settings.",
       "scope": "background",
       "note": "Defines the guideline's applicability limits — it excludes ICU sedation, palliative care, and nursing-home settings; a step-down card sits adjacent to but outside ICU.",
       "page": "2",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      }
     ]
    }
   ],
   "synthesis": "All four sources support a HELP-style multicomponent nonpharmacological prevention bundle for hospitalized older adults and none contradicts the claim: the AGS 2015 postoperative-delirium guideline (primary anchor, p. 4) governs the specific list, enumerating nearly all ten components in one strong recommendation, while Inouye 1999 (HELP) and Hshieh 2015 establish and meta-analytically validate the core six (reorientation, sleep, mobilization, vision/hearing, hydration) and Siddiqi 2016 confirms multicomponent prevention works in the exact hospitalized non-ICU (step-down) setting. The four extra components (medication review, pain without over-sedation, bowel/bladder care, infection/hypoxia/metabolic work-up, family engagement) rest chiefly on the AGS enumeration — drawn from an older-surgical population — rather than on all four sources, so the AGS list is the governing citation for the full ten while the HELP trials cover only the core six.",
   "discrepancy": true
  },
  {
   "id": "sd-cards-r20",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "3",
   "section": "Act card — Find the cause",
   "statement": "Review deliriogenic / anticholinergic medications first — minimize the burden.",
   "contentType": "Cited clinical content",
   "sources": [
    "Lisibach 2022 (anticholinergic burden)",
    "AGS 2015 (postoperative delirium guideline)"
   ],
   "anchor": "Lisibach 2022 (anticholinergic burden) — p. 1",
   "passage": "A high anticholinergic burden within 24 hours after admission was significantly associated with incident delirium. Although prospective studies need to confirm these results, discontinuing or substituting drugs with a score of ≥3 at admission might be a targeted intervention to reduce incident delirium.\nAlso AGS 2015 (postoperative delirium guideline) (p. 8): “The prescribing practitioner should avoid medications that induce delirium postoperatively in older adults to prevent delirium (strength of recommendation: strong; quality of evidence: low).”\nAlso AGS 2015 (postoperative delirium guideline) (p. 8): “Current evidence most strongly associates use of anticholinergic drugs, meperidine and benzodiazepines with increased postoperative delirium.”\nSupported. Lisibach 2022 found high anticholinergic burden within 24 h of admission was significantly associated with incident delirium and that discontinuing/substituting high-burden drugs is a plausible reducing intervention (p. 1). AGS 2015 issues a strong recommendation to avoid deliriogenic medications and names anticholinergics among the drugs most strongly associated with postoperative delirium (p. 8). 'First' is the card's operational ordering.",
   "evidence": "Full text, p. 1",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "Lisibach A, et al. Quantifying anticholinergic burden and its association with delirium (comparison of 19 scales). Br J Clin Pharmacol 2022;88:4915.",
    "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142."
   ],
   "links": [
    "https://doi.org/10.1111/bcp.15432",
    "https://doi.org/10.1111/jgs.13281"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Lisibach 2022 (anticholinergic burden)",
     "cite": "Lisibach A, et al. Quantifying anticholinergic burden and its association with delirium (comparison of 19 scales). Br J Clin Pharmacol 2022;88:4915.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Cohort study of >26,000 older hospitalized (non-ICU) patients: a high cumulative anticholinergic burden was independently associated with incident delirium, and reducing that burden is framed as a targeted intervention. Closest available scope to a general step-down/ward card.",
     "docUrl": "https://doi.org/10.1111/bcp.15432",
     "paragraphs": [
      {
       "context": "Although prospective studies need to confirm these results, discontinuing or substituting drugs with a score of 3 at admission might be a targeted intervention to reduce incident delirium.",
       "highlight": "discontinuing or substituting drugs with a score of 3 at admission might be a targeted intervention to reduce incident delirium",
       "scope": "on-scope",
       "note": "Abstract conclusion directly supports reviewing anticholinergic medications and minimizing the burden — discontinuing or substituting high-score drugs is a targeted intervention to reduce delirium.",
       "page": "4915",
       "docUrl": "https://doi.org/10.1111/bcp.15432"
      },
      {
       "context": "A cumulative ACH burden score of three points or more can be considered a high burden, which was statistically significantly and independently associated with the development of delirium during hospitalisation. The ABSs are convenient clinical tools to measure the ACH burden in hospitalised patients. Newer high‐quality ABSs built from previously published scales seem to perform better. However, cut‐off values might differ depending on the scale and outcome studied. Discontinuing or substituting drugs with an ACH score of three points or more upon admission might be a targeted intervention to reduce the risk of delirium development. However, it should be noted that delirium is a multifactorial syndrome, and that drugs are only one factor to be considered in delirium prevention. Further studies should be conducted in order to prospectively verify whether discontinuing drugs with ACH properties might reduce delirium occurrences.",
       "highlight": "three points or more upon admission might be a targeted intervention to reduce the risk of delirium development",
       "scope": "on-scope",
       "note": "Conclusion reiterates that reducing anticholinergic burden is a targeted delirium-prevention intervention, while hedging that medications are only one of several contributors.",
       "page": "4925",
       "docUrl": "https://doi.org/10.1111/bcp.15432"
      }
     ]
    },
    {
     "label": "AGS 2015 (postoperative delirium guideline)",
     "cite": "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Guideline endorses the same medication-minimisation principle, but its evidence base and population are postoperative older surgical patients, not a general step-down/ward population; it also explicitly notes some recommendations do not apply to ICU sedation, palliative, or nursing-home settings.",
     "docUrl": "https://doi.org/10.1111/jgs.13281",
     "paragraphs": [
      {
       "context": "Recommendation--The prescribing practitioner should avoid medications that induce delirium postoperatively in older adults to prevent delirium (strength of recommendation: strong; quality of evidence: low).",
       "highlight": "The prescribing practitioner should avoid medications that induce delirium postoperatively in older adults",
       "scope": "different-population",
       "note": "Strong recommendation to avoid deliriogenic/anticholinergic drugs supports 'minimize the burden', but is scoped to postoperative older surgical patients rather than a general step-down population.",
       "page": "Page 8",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "Recommendation--The healthcare professional should perform a medical evaluation, make medication and/or environmental adjustments, and order appropriate diagnostic tests and clinical consultations after an older adult has been diagnosed with postoperative delirium to identify and manage underlying contributors to delirium (strength of recommendation: strong; quality of evidence: low).",
       "highlight": "to identify and manage underlying contributors to delirium",
       "scope": "different-population",
       "note": "This is the guideline's 'Find the cause' analog (medical evaluation plus medication adjustments to manage contributors), but again framed for postoperative surgical patients diagnosed with delirium.",
       "page": "Page 5",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      }
     ]
    }
   ],
   "synthesis": "Both sources endorse reviewing and minimizing deliriogenic/anticholinergic medications to reduce delirium. Lisibach 2022 is the on-scope, governing source for a general step-down/ward card: in older hospitalized (non-ICU) patients a high cumulative anticholinergic burden was independently associated with incident delirium, and discontinuing or substituting high-burden drugs is presented as a targeted preventive intervention (with the caveat that drugs are only one factor in a multifactorial syndrome). AGS 2015 corroborates the same principle — a strong recommendation to avoid anticholinergic/deliriogenic drugs and to evaluate medications to identify causes — but from a different population (postoperative older surgical patients), so it is a nearest-match at a different scope rather than direct on-scope support.",
   "discrepancy": true
  },
  {
   "id": "sd-cards-r21",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "3",
   "section": "Act card — Find the cause",
   "statement": "Look for infection, hypoxia, and metabolic causes; check pain and elimination.",
   "contentType": "Cited clinical content",
   "sources": [
    "AGS 2015 (postoperative delirium guideline)",
    "NICE CG103"
   ],
   "anchor": "AGS 2015 (postoperative delirium guideline) — p. 5",
   "passage": "The healthcare professional should perform a medical evaluation, make medication and/or environmental adjustments, and order appropriate diagnostic tests and clinical consultations after an older adult has been diagnosed with postoperative delirium to identify and manage underlying contributors to delirium (strength of recommendation: strong; quality of evidence: low).\nAlso AGS 2015 (postoperative delirium guideline) (p. 4): “Nonpharmacologic interventions to prevent postoperative delirium may include the following elements: cognitive reorientation, sleep enhancement (i.e., nonpharmacologic sleep protocol and sleep hygiene), early mobility and/or physical rehabilitation, adaptations for visual and hearing impairment, nutrition and fluid repletion, pain management, appropriate medication usage, adequate oxygenation, and prevention of constipation.”\nAlso AGS 2015 (postoperative delirium guideline) (p. 6): “This recommendation balances the risks of delay in treatment for underlying cause(s) of delirium with the risks and costs of diagnostic tests and procedures, as well as the possibility of pain and infection.”\nPartial. AGS 2015 recommends a medical evaluation to identify and manage underlying contributors to delirium (Recommendation IV, p. 5) and names hypoxia ('adequate oxygenation'), pain, constipation, and infection among the elements/precipitants (p. 4, p. 6). 'Metabolic causes' and urinary retention are not stated as precipitants in the archived AGS text; screening for the full set of reversible precipitants is standard practice reinforced by NICE CG103.",
   "evidence": "Full text, p. 5 — partial support",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142.",
    "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023)."
   ],
   "links": [
    "https://doi.org/10.1111/jgs.13281",
    "https://www.nice.org.uk/guidance/cg103"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "AGS 2015 (postoperative delirium guideline)",
     "cite": "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Recommendation IV 'Identify and Manage Causes of Delirium' (p.5, the primary anchor) directly backs the find-the-cause action, but it is generic; the specific precipitants appear only in the prevention bundle (p.4), and 'metabolic' and 'infection' are not enumerated there.",
     "docUrl": "https://doi.org/10.1111/jgs.13281",
     "paragraphs": [
      {
       "context": "Recommendation--The healthcare professional should perform a medical evaluation, make medication and/or environmental adjustments, and order appropriate diagnostic tests and clinical consultations after an older adult has been diagnosed with postoperative delirium to identify and manage underlying contributors to delirium (strength of recommendation: strong; quality of evidence: low).",
       "highlight": "to identify and manage underlying contributors to delirium",
       "scope": "on-scope",
       "note": "Recommendation IV (strong): after delirium is diagnosed, perform a medical evaluation and order diagnostic tests to identify and manage underlying contributors — the core 'find the cause' action, though stated generically without naming specific causes.",
       "page": "5",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "A. Evidence for Recommendation: Nonpharmacologic interventions to prevent postoperative delirium may include the following elements: cognitive reorientation, sleep enhancement (i.e., nonpharmacologic sleep protocol and sleep hygiene), early mobility and/or physical rehabilitation, adaptations for visual and hearing impairment, nutrition and fluid repletion, pain management, appropriate medication usage, adequate oxygenation, and prevention of constipation. The managing team should perform daily rounds providing both general and specific recommendations. Adherence is an important consideration.",
       "highlight": "adequate oxygenation, and prevention of constipation",
       "scope": "different-intervention",
       "note": "Nearest keyword match for the enumerated precipitants (oxygenation ≈ hypoxia, pain, constipation ≈ elimination), but this is the multicomponent PREVENTION bundle to prevent delirium, not a cause-workup of established delirium; infection and metabolic are not listed here.",
       "page": "4",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "partial",
     "note": "1.7.1 (p.11) directly backs identifying and managing the underlying cause of diagnosed delirium; the enumerated precipitants (infection, hypoxia, pain, constipation) come from the prevention recommendations 1.4.5–1.4.9 (p.7–8), and 'metabolic' is not named.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "In people diagnosed with delirium, identify and manage the possible underlying cause or combination of causes.",
       "highlight": "cause or combination of causes",
       "scope": "on-scope",
       "note": "Recommendation 1.7.1 (Treating delirium — Initial management): once delirium is diagnosed, identify and manage the underlying cause(s). Directly supports the card's action; a [2010] recommendation that remains the current position after the 2023 focused update (which re-addressed only assessment/diagnosis).",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "For people in whom delirium does not resolve: re-evaluate for underlying causes follow up and assess for possible dementia (see the NICE guideline on dementia).",
       "highlight": "re-evaluate for underlying causes",
       "scope": "on-scope",
       "note": "Recommendation 1.7.5: for delirium that does not resolve, re-evaluate for underlying causes — reinforces the cause-finding action (persistent-delirium branch).",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "implementing infection control procedures in line with the NICE guideline on healthcare-associated infections. [2010]",
       "highlight": "implementing infection control procedures in line with the NICE guideline on healthcare-associated infections",
       "scope": "different-intervention",
       "note": "Names infection (and, via 'avoiding unnecessary catheterization', urinary/elimination), but within recommendation 1.4.7 of the PREVENTION multicomponent package aimed at preventing delirium, not the cause-workup of established delirium.",
       "page": "8",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Assess for hypoxia and optimise oxygen saturation if necessary, as clinically appropriate.",
       "highlight": "Assess for hypoxia and optimise oxygen saturation",
       "scope": "different-intervention",
       "note": "Recommendation 1.4.6 names hypoxia explicitly, but as a prevention target in the multicomponent bundle rather than as part of finding the cause of diagnosed delirium.",
       "page": "8",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "looking for non-verbal signs of pain, particularly in those with communication difficulties (for example, people with learning difficulties or dementia, or people on a ventilator or who have a tracheostomy)",
       "highlight": "looking for non-verbal signs of pain, particularly in those with communication difficulties",
       "scope": "different-intervention",
       "note": "Recommendation 1.4.9 covers assessing and treating pain, again framed as a prevention component of the multicomponent package rather than cause-finding for established delirium.",
       "page": "8",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "ensuring adequate fluid intake to prevent dehydration by encouraging the person to drink; consider offering subcutaneous or intravenous fluids if necessary taking advice if necessary, when managing fluid balance in people with comorbidities (for example, heart failure or chronic kidney disease).",
       "highlight": "ensuring adequate fluid intake to prevent dehydration by encouraging the person to drink",
       "scope": "different-intervention",
       "note": "Recommendation 1.4.5 addresses constipation (elimination), but as a prevention target in the multicomponent bundle, not as a cause-workup item.",
       "page": "7",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    }
   ],
   "synthesis": "Both guidelines directly support the card's core action — AGS 2015 Recommendation IV (p.5, the primary anchor) and NICE CG103 1.7.1 (p.11, a [2010] recommendation that remains the current position after the 2023 focused update on assessment) each direct clinicians to perform a medical evaluation and identify/manage the underlying cause(s) once delirium is diagnosed — but both state this generically. The card's specific precipitants (infection, hypoxia, pain, elimination) map to the prevention multicomponent bundles of both sources (AGS p.4; NICE 1.4.5–1.4.9, p.7–8), a different-intervention scope aimed at preventing delirium rather than a cause-workup checklist, and neither source explicitly cites 'metabolic causes'; the generic on-scope cause-finding recommendations govern.",
   "discrepancy": true
  },
  {
   "id": "sd-cards-r22",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "3",
   "section": "Act card — Find the cause",
   "statement": "In post-ICU transfers, consider sedative / opioid withdrawal (onset 1–11 days).",
   "contentType": "Cited clinical content",
   "sources": [
    "Wang 2017 (iatrogenic withdrawal)"
   ],
   "anchor": "Wang 2017 (iatrogenic withdrawal) — p. 4",
   "passage": "Onset of IWS ranged from 1 to 11 days following opioid cessation or dose reduction (median = 2 days; 25th–75th percentile 1–4).\nExact numeric match. Wang 2017 reports onset of iatrogenic withdrawal ranged from 1 to 11 days after opioid cessation or dose reduction (median 2 days; p. 4). Scope note: Wang measured opioid-associated withdrawal specifically; the card broadens 'opioid' to 'sedative / opioid,' whereas Wang could not isolate the benzodiazepine/sedative contribution.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Wang PP, et al. Opioid-associated iatrogenic withdrawal in critically ill adult patients. Ann Intensive Care 2017;7:88."
   ],
   "links": [
    "https://doi.org/10.1186/s13613-017-0310-5"
   ],
   "decision": "",
   "notes": "Onset window is opioid-associated (Wang 2017); the card extends the framing to sedatives.",
   "perSource": [
    {
     "label": "Wang 2017 (iatrogenic withdrawal)",
     "stance": "partial",
     "note": "The onset window is an exact match. Wang measured opioid-associated withdrawal specifically and could not isolate a benzodiazepine or sedative contribution, so the card's 'sedative / opioid' is broader than the source.",
     "paragraphs": [
      {
       "scope": "narrower",
       "context": "Incidence of IWS was 16.7% (9 out of 54 patients) (95% CI, 6-27%). Onset of IWS ranged from 1 to 11 days following opioid cessation or dose reduction (median = 2 days; 25th-75th percentile 1-4). The agreement between two raters for the 38 evaluations of IWS-based DSM-V criteria was concordant in 90.1% of cases.",
       "highlight": "Onset of IWS ranged from 1 to 11 days following opioid cessation or dose reduction (median = 2 days; 25th-75th percentile 1-4).",
       "page": "4"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-cards-r23",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "3",
   "section": "Act card — Manage without new harm",
   "statement": "Apply the multicomponent non-pharmacologic bundle — first-line for every patient.",
   "contentType": "Cited clinical content",
   "sources": [
    "Siddiqi 2016 (Cochrane)",
    "Inouye 1999 (HELP)",
    "AGS 2015 (postoperative delirium guideline)"
   ],
   "anchor": "Siddiqi 2016 (Cochrane) — p. 7",
   "passage": "We found multi-component interventions reduced the incidence of delirium compared to usual care (RR 0.69, 95% CI 0.59 to 0.81; seven studies; 1950 participants; moderate-quality evidence).\nAlso AGS 2015 (postoperative delirium guideline) (p. 4): “Healthcare systems and hospitals should implement multi-component nonpharmacologic intervention programs delivered by an interdisciplinary team (including physicians, nurses, and possibly other healthcare professionals) for the entire hospitalization in at-risk older adults undergoing surgery to prevent delirium (strength of recommendation: strong; quality of evidence: moderate).”\nSupported. The multicomponent non-pharmacologic bundle is the evidence-based first-line intervention (Siddiqi 2016 RR 0.69, p. 7; AGS 2015 strong recommendation to implement multicomponent programs for at-risk inpatients, p. 4).",
   "evidence": "Full text, p. 7",
   "status": "fulltext",
   "pageNum": "7",
   "citations": [
    "Siddiqi N, et al. Interventions for preventing delirium in hospitalised non-ICU patients. Cochrane Database Syst Rev 2016;CD005563.",
    "Inouye SK, et al. A multicomponent intervention to prevent delirium in hospitalized older patients. N Engl J Med 1999;340:669.",
    "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142."
   ],
   "links": [
    "https://doi.org/10.1002/14651858.CD005563.pub3",
    "https://doi.org/10.1056/NEJM199903043400901",
    "https://doi.org/10.1111/jgs.13281"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Siddiqi 2016 (Cochrane)",
     "cite": "Siddiqi N, et al. Interventions for preventing delirium in hospitalised non-ICU patients. Cochrane Database Syst Rev 2016;CD005563.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Systematic review of prevention in hospitalized non-ICU patients (medical + surgical wards) — the closest scope to a step-down unit; strongly supports multicomponent interventions as routine care.",
     "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3",
     "paragraphs": [
      {
       "context": "The evidence base for multi-component interventions to prevent delirium in patients admitted to medical and surgical wards is strong and supports the adoption of systems of care that incorporate multi-component interventions to prevent delirium in hospitals as part of routine care.",
       "highlight": "supports the adoption of systems of care that incorporate multi-component interventions to prevent delirium in hospitals as part of routine care",
       "scope": "on-scope",
       "note": "Authors' Implications for practice: directly endorses adopting multicomponent interventions as routine care across medical and surgical wards.",
       "page": "36",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "There is moderate-quality evidence to indicate that multi-component interventions reduce the incidence of delirium. The evidence supports implementing multi-component delirium prevention interventions into routine care for patients in hospital.",
       "highlight": "The evidence supports implementing multi-component delirium prevention interventions into routine care for patients in hospital",
       "scope": "on-scope",
       "note": "Abstract conclusion: moderate-quality evidence that multicomponent interventions reduce delirium incidence and belong in routine care.",
       "page": "3",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "There is strong evidence supporting multi-component interventions to prevent delirium in hospitalised patients. There is no clear evidence that cholinesterase inhibitors, antipsychotic medication or melatonin reduce the incidence of delirium. Using the Bispectral Index to monitor and control depth of anaesthesia reduces the incidence of postoperative delirium. The role of drugs and other anaesthetic techniques to prevent delirium remains uncertain.",
       "highlight": "There is strong evidence supporting multi-component interventions to prevent delirium in hospitalised patients",
       "scope": "on-scope",
       "note": "Abstract authors' conclusions: strong evidence for the multicomponent bundle, contrasted with no clear benefit from cholinesterase inhibitors, antipsychotics, or melatonin.",
       "page": "2",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "Seven studies (2018 participants) evaluated non-pharmacological multi-component interventions (Abizanda 2011; Bonaventura 2007; Hempenius 2013; Je s 2013; Lundstrom 2007; Marcantonio 2001; Martinez 2012) in comparison to usual care. Individual components of each multi-component intervention are summarised in Table 1. The number of components varied between two (Je s 2013) and 13 (Hempenius 2013) (Table 1). Most included individualised care, an educational component, reorientation, and early mobilisation. Many of the delirium risk factors targeted with multi-component interventions relate to good basic care. The nature in which interventions were implemented varied between the studies: some relied on a protocol-driven approach (Bonaventura 2007; Je s 2013; Marcantonio 2001), whilst others were more pragmatic in the delivery of the intervention (e.g. the family delivered the reorientation intervention in Martinez 2012). Two studies were based on therapist interventions (Abizanda 2011; Je s 2013), one was multidisciplinary including a Comprehensive Geriatric Assessment (Lundstrom 2007), and two were based on proactive perioperative input from a geriatrician (Hempenius 2013; Marcantonio 2001).",
       "highlight": "Most included individualised care, an educational component, reorientation, and early mobilisation",
       "scope": "background",
       "note": "Describes what the bundle contains — the components common to the seven trials — grounding what 'the multicomponent bundle' means.",
       "page": "17",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "Multi-component interventions for delirium prevention are now also recognised and recommended in practice guidelines. The UK National Institute for Health and Care Excellence (NICE) guidelines for delirium were published in 2010 (NICE 2010). These identified multi-component interventions as having a critical role in identifying and addressing modifiable, clinical risk factors for delirium prevention. Multi-component assessment and intervention is recommended within 24 hours of admission for those at risk; the intervention should be personalised to the needs of the individual and delivered by a multidisciplinary team (NICE 2010). Cost savings are identified to be anticipated, although we found no data on this in our review.",
       "highlight": "Multi-component assessment and intervention is recommended within 24 hours of admission for those at risk",
       "scope": "narrower",
       "note": "Nearest match on timing/eligibility (NICE): the intervention is recommended for those 'at risk,' a narrower target than the claim's 'every patient.'",
       "page": "36",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      }
     ]
    },
    {
     "label": "Inouye 1999 (HELP)",
     "cite": "Inouye SK, et al. A multicomponent intervention to prevent delirium in hospitalized older patients. N Engl J Med 1999;340:669.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Foundational RCT of the multicomponent (Elder Life Program) bundle; establishes the risk-factor-targeted non-pharmacologic approach as effective and harm-free, though tested in older at-risk general-medicine inpatients.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "(i.e., the presence of predisposing conditions, such as cognitive impairment, severe illness, or visual impairment) and hospital-related insults (i.e., medications and procedures).1,24 The risk of delirium increases with the number of risk factors present.24,25 Therefore, a multicomponent approach targeted to the patient's risk factors is the most clinically relevant and potentially effective intervention for delirium.",
       "highlight": "a multicomponent approach targeted to the patient's risk factors is the most clinically relevant and potentially effective intervention for delirium",
       "scope": "on-scope",
       "note": "States the rationale that a risk-factor-targeted multicomponent approach is the most clinically relevant and effective intervention — direct support for it being first-line.",
       "page": "669",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Results Delirium developed in 9.9 percent of the intervention group, as compared with 15.0 percent of the usual-care group (matched odds ratio, 0.60; 95 percent confidence interval, 0.39 to 0.92). The total number of days with delirium (105 vs. 161, P=0.02) and the total number of episodes (62 vs. 90, P=0.03) were significantly lower in the intervention group. However, the severity of delirium and recurrence rates were not significantly different. The overall rate of adherence to the intervention was 87 percent, and the total number of targeted risk factors per patient was significantly reduced. Intervention was associated with significant improvement in the degree of cognitive impairment among patients with cognitive impairment at admission and with a significant reduction in the rate of use of sleep medications among all patients. Among the other risk factors, there were trends toward improvement in immobility, visual impairment, and hearing impairment. Conclusions The risk-factor intervention strategy that we studied resulted in significant reductions in the number and duration of episodes of delirium in hospitalized older patients. The intervention had no significant effect on the severity of delirium or on recurrence rates; this finding suggests that primary prevention of delirium is probably the most effective treatment strategy. (N Engl J Med 1999;340:669-76.)",
       "highlight": "primary prevention of delirium is probably the most effective treatment strategy",
       "scope": "on-scope",
       "note": "Because severity and recurrence of established delirium were unchanged, the authors conclude the bundle's value is as first-line primary prevention.",
       "page": "669",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "of 2452 patient-days), 81 percent for volume repletion (68 of 84 patient-days), and 71 percent for the nonpharmacologic sleep protocol (962 of 1352 patient-days). The most common reasons for nonadherence included refusal by the patient, lack of availability of the patient because of procedures elsewhere in the hospital, medical contraindications, and lack of availability of intervention staff members. No adverse effects were associated with the intervention protocols.",
       "highlight": "No adverse effects were associated with the intervention protocols",
       "scope": "on-scope",
       "note": "Supports the 'manage without new harm' framing: the non-pharmacologic bundle caused no adverse effects.",
       "page": "",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Methods We studied 852 patients 70 years of age or older who had been admitted to the general-medicine service at a teaching hospital. Patients from one intervention unit and two usual-care units were enrolled by means of a prospective matching strategy. The intervention consisted of standardized protocols for the management of six risk factors for delirium: cognitive impairment, sleep deprivation, immobility, visual impairment, hearing impairment, and dehydration. Delirium, the primary outcome, was assessed daily until discharge.",
       "highlight": "852 patients 70 years of age or older who had been admitted to the general-medicine service",
       "scope": "different-population",
       "note": "Population is older (≥70) general-medicine inpatients enrolled by intermediate/high delirium risk — not literally 'every patient,' and not a step-down cohort.",
       "page": "669",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    },
    {
     "label": "AGS 2015 (postoperative delirium guideline)",
     "cite": "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Guideline for postoperative delirium in older surgical adults: strong recommendation for the multicomponent non-pharmacologic bundle for prevention, but only a weak recommendation for treating established delirium.",
     "docUrl": "https://doi.org/10.1111/jgs.13281",
     "paragraphs": [
      {
       "context": "Recommendation--Healthcare systems and hospitals should implement multicomponent nonpharmacologic intervention programs delivered by an interdisciplinary team (including physicians, nurses, and possibly other healthcare professionals) for the entire hospitalization in at-risk older adults undergoing surgery to prevent delirium (strength of recommendation: strong; quality of evidence: moderate).",
       "highlight": "for the entire hospitalization in at-risk older adults undergoing surgery to prevent delirium (strength of recommendation: strong; quality of evidence: moderate)",
       "scope": "on-scope",
       "note": "Recommendation II — a strong recommendation to implement the multicomponent non-pharmacologic bundle to prevent delirium; setting is postoperative at-risk surgical older adults.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "B. Potential Harms of All Nonpharmacologic Recommendations: No harmful effects of nonpharmacologic approaches to delirium prevention or management have been reported, other than costs of program resources, which may be offset by the considerable costs of delirium. Cost-effectiveness of multicomponent delirium intervention strategies in a variety of settings has been demonstrated.",
       "highlight": "No harmful effects of nonpharmacologic approaches to delirium prevention or management have been reported",
       "scope": "on-scope",
       "note": "Directly supports 'manage without new harm': the non-pharmacologic approaches carry no reported harms.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "The criteria used by the panel to designate the strength of recommendation appear in Table S1. In all cases, the strength of recommendation was based on carefully balancing the benefits of treatment against the potential harms. For example, strong recommendations were made when the panel determined that the benefits clearly outweighed harms (such as with nonpharmacologic interventions) or when the potential harms clearly outweighed the benefits (such as with benzodiazepine treatment).",
       "highlight": "the benefits clearly outweighed harms (such as with nonpharmacologic interventions)",
       "scope": "on-scope",
       "note": "Grades non-pharmacologic interventions as benefits-outweigh-harms (strong) versus benzodiazepines as harms-outweigh-benefits — supports non-pharm as the safe first-line.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "Recommendation--Healthcare professionals should consider multicomponent interventions implemented by an interdisciplinary team in older adults diagnosed with postoperative delirium to improve clinical outcomes (strength of recommendation: weak; quality of evidence: low).",
       "highlight": "to improve clinical outcomes (strength of recommendation: weak; quality of evidence: low)",
       "scope": "narrower",
       "note": "Recommendation III — nearest match to the 'Manage' scope, but for treating established delirium the multicomponent bundle is only a weak, low-quality recommendation (vs strong for prevention).",
       "page": "",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "Recommendation--The prescribing practitioner should not use benzodiazepines as a first-line treatment of the agitated postoperative delirious patient who is threatening substantial harm to self and/or others to treat postoperative delirium except when benzodiazepines are specifically indicated (including, but not limited to, treatment of alcohol or benzodiazepine withdrawal). Treatment with benzodiazepines should be at the lowest effective dose for the shortest possible duration, and should be employed only if behavioral measures have failed or are not possible and ongoing use should be evaluated daily with inperson examination of the patient (strength of recommendation: strong; quality of evidence: low).",
       "highlight": "should not use benzodiazepines as a first-line treatment",
       "scope": "different-intervention",
       "note": "Different intervention (benzodiazepines), included because it explicitly reserves pharmacologic agents as non-first-line, reinforcing that the non-pharm bundle comes first.",
       "page": "",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      }
     ]
    }
   ],
   "synthesis": "All three sources agree that a multicomponent non-pharmacologic bundle is the recommended, harm-free first-line intervention for delirium; Siddiqi 2016 — the only source covering hospitalized non-ICU medical and surgical wards, the closest match to a step-down setting — governs and concludes these interventions should be adopted into routine care. The supporting evidence is strongest for primary prevention in at-risk patients (Inouye's HELP RCT was in older ≥70 general-medicine inpatients; AGS gives a strong prevention recommendation but only a weak one for treating established postoperative delirium), so \"first-line for every patient\" is a reasonable extrapolation of the consensus rather than a directly tested claim.",
   "discrepancy": true
  },
  {
   "id": "sd-cards-r24",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "3",
   "section": "Act card — Manage without new harm",
   "statement": "Antipsychotics do NOT prevent or treat delirium — do not use them routinely.",
   "contentType": "Cited clinical content",
   "sources": [
    "Neufeld 2016 (antipsychotics meta-analysis)",
    "Oh 2019 (antipsychotics — prevention)",
    "Nikooie 2019 (antipsychotics — treatment)"
   ],
   "anchor": "Neufeld 2016 (antipsychotics meta-analysis) — p. 2",
   "passage": "Conclusion—Antipsychotics for prevention or treatment of delirium is not supported by current evidence.\nAlso Nikooie 2019 (antipsychotics — treatment) (p. 1): “Conclusion: Current evidence does not support routine use of haloperidol or second-generation antipsychotics to treat delirium in adult inpatients.”\nAlso Nikooie 2019 (antipsychotics — treatment) (p. 9): “In conclusion, antipsychotics for treatment of delirium in adult inpatients did not improve patient outcomes, with little evidence of neurologic harms but a tendency for more frequent potentially harmful cardiac effects.”\nSupported on both limbs. Neufeld 2016 concludes antipsychotics for prevention or treatment of delirium are not supported by current evidence (p. 2). Nikooie 2019 concludes current evidence does not support routine antipsychotics to treat delirium and that treatment did not improve outcomes (p. 1, p. 9); Oh 2019 (prevention) is cited on the prevention card.",
   "evidence": "Full text, p. 2",
   "status": "fulltext",
   "pageNum": "2",
   "citations": [
    "Neufeld KJ, et al. Antipsychotic medication for prevention and treatment of delirium in hospitalized adults: a systematic review and meta-analysis. J Am Geriatr Soc 2016;64:705.",
    "Oh ES, et al. Antipsychotics for preventing delirium in hospitalized adults: a systematic review. Ann Intern Med 2019;171:474.",
    "Nikooie R, et al. Antipsychotics for treating delirium in hospitalized adults: a systematic review. Ann Intern Med 2019;171:485."
   ],
   "links": [
    "https://doi.org/10.1111/jgs.14076",
    "https://doi.org/10.7326/M19-1859",
    "https://doi.org/10.7326/M19-1860"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Neufeld 2016 (antipsychotics meta-analysis)",
     "cite": "Neufeld KJ, et al. Antipsychotic medication for prevention and treatment of delirium in hospitalized adults: a systematic review and meta-analysis. J Am Geriatr Soc 2016;64:705.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary source; the only one covering BOTH halves of the claim (prevention and treatment) in hospitalized adults, and it concludes the practice is unsupported.",
     "docUrl": "https://doi.org/10.1111/jgs.14076",
     "paragraphs": [
      {
       "context": "Conclusion--Antipsychotics for prevention or treatment of delirium is not supported by current evidence. Additional methodologically rigorous studies using standardized outcome measures are needed.",
       "highlight": "Antipsychotics for prevention or treatment of delirium is not supported by current evidence.",
       "scope": "on-scope",
       "note": "Abstract conclusion (the cited primaryAnchor, p. 2) directly supporting the card statement for both prevention and treatment.",
       "page": "2",
       "docUrl": "https://doi.org/10.1111/jgs.14076"
      },
      {
       "context": "There is insufficient evidence currently to support the routine use of antipsychotic pharmacotherapy to prevent or treat delirium in hospitalized adult patients, including in the postoperative setting. There is a great need to standardize outcome measures via creation of a core outcome set for delirium prevention and treatment trials and conduct of additional rigorous well-powered RCTs in high risk populations.",
       "highlight": "There is insufficient evidence currently to support the routine use of antipsychotic pharmacotherapy to prevent or treat delirium in hospitalized adult patients, including in the postoperative setting.",
       "scope": "on-scope",
       "note": "Concluding paragraph uses the exact 'routine use' framing that matches the card's 'do not use them routinely.'",
       "page": "8",
       "docUrl": "https://doi.org/10.1111/jgs.14076"
      },
      {
       "context": "This systematic review and meta-analysis suggests that antipsychotic pharmacotherapy does not improve outcomes when used for prevention or treatment of delirium in hospitalized adult patients. Antipsychotics were not associated with improvements short-term mortality, severity or duration of delirium, and length of ICU and hospital stay. However, existing studies demonstrate heterogeneity in study design, including diverse populations, with few studies focused specifically on older postoperative patients. There was substantial variability in outcome measures with few postoperative studies evaluating mortality and functional outcomes.",
       "highlight": "antipsychotic pharmacotherapy does not improve outcomes when used for prevention or treatment of delirium in hospitalized adult patients",
       "scope": "on-scope",
       "note": "Discussion synthesis reiterating no benefit for either indication.",
       "page": "6",
       "docUrl": "https://doi.org/10.1111/jgs.14076"
      },
      {
       "context": "Results--Screening of 10,877 eligible records identified 19 studies. In seven studies comparing antipsychotics to placebo or no treatment for delirium prevention in postoperative patients, there was no significant effect on delirium incidence (OR 0.56; 95% CI 0.23, 1.34; I2 = 93%). Using data reported from all 19 studies, antipsychotic use was not associated with change in delirium duration, severity, hospital or ICU LOS, with high heterogeneity among studies. No association with mortality was detected (OR 0.90; 95% CI 0.62, 1.29; I2 = 0%).",
       "highlight": "there was no significant effect on delirium incidence",
       "scope": "on-scope",
       "note": "Abstract Results giving the meta-analytic basis (no effect on incidence, duration, severity, LOS, mortality).",
       "page": "2",
       "docUrl": "https://doi.org/10.1111/jgs.14076"
      },
      {
       "context": "Careful reflection on which outcomes are most meaningful to clinicians and patients should also inform future research. While antipsychotics in this review do not appear to decrease the incidence of delirium in the postoperative period, or improve other outcomes when used to treat delirious adult inpatients, none of the studies evaluated symptomatic relief attributable to these medications. Decreasing patient agitation and distress is a common reason for the prescription of antipsychotics in hospitalized adults and yet the field has no uniform data on those outcomes. Much more work in this area is needed to delineate the best strategies around delirium prevention, particularly in high-risk populations such as older postoperative patients. Well-powered randomized controlled evaluations, particularly among older at-risk patients immediately post-anesthesia, with well-defined outcomes are warranted in order to better understand whether there is any benefit from these medications.",
       "highlight": "none of the studies evaluated symptomatic relief attributable to these medications",
       "scope": "narrower",
       "note": "Nearest-match caveat: the reviewed evidence did not assess short-term symptomatic (agitation/distress) relief, so 'do not use routinely' addresses preventing/treating the delirium syndrome, not acute agitation control — must not be over-read as covering that indication.",
       "page": "8",
       "docUrl": "https://doi.org/10.1111/jgs.14076"
      }
     ]
    },
    {
     "label": "Oh 2019 (antipsychotics — prevention)",
     "cite": "Oh ES, et al. Antipsychotics for preventing delirium in hospitalized adults: a systematic review. Ann Intern Med 2019;171:474.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Covers only the PREVENTION half of the claim, and carries a genuine subgroup exception (second-generation antipsychotics in postoperative surgery), so it partially qualifies the blanket 'do not prevent.'",
     "docUrl": "https://doi.org/10.7326/M19-1859",
     "paragraphs": [
      {
       "context": "Conclusion: Current evidence does not support routine use of haloperidol or second-generation antipsychotics for prevention of delirium. There is limited evidence that second-generation antipsychotics may lower the incidence of delirium in postoperative patients, but more research is needed. Future trials should use standardized outcome measures.",
       "highlight": "Current evidence does not support routine use of haloperidol or second-generation antipsychotics for prevention of delirium.",
       "scope": "on-scope",
       "note": "Abstract conclusion; governs the prevention half of the card statement.",
       "page": "474",
       "docUrl": "https://doi.org/10.7326/M19-1859"
      },
      {
       "context": "Our systematic review of 14 RCTs (4281 participants) found insufficient or no evidence supporting the routine use of antipsychotics for the prevention of delirium in adult inpatients.",
       "highlight": "found insufficient or no evidence supporting the routine use of antipsychotics for the prevention of delirium in adult inpatients",
       "scope": "on-scope",
       "note": "Opening of Discussion restating the primary finding across 14 RCTs.",
       "page": "481",
       "docUrl": "https://doi.org/10.7326/M19-1859"
      },
      {
       "context": "In conclusion, evidence was insufficient to support the routine use of antipsychotics for preventing delirium in adult patients. Second-generation antipsychotics may lower delirium incidence in postoperative patients, but more research is needed to confirm this finding. Although statistically significant differences were not detected in cardiac side effects when antipsychotics were compared with placebo, in some of the trials, events were more common in patients receiving an antipsychotic.",
       "highlight": "evidence was insufficient to support the routine use of antipsychotics for preventing delirium in adult patients",
       "scope": "on-scope",
       "note": "Closing conclusion, verbatim support for 'do not use routinely' in prevention.",
       "page": "481",
       "docUrl": "https://doi.org/10.7326/M19-1859"
      },
      {
       "context": "Three RCTs with varying ROB (30, 31, 39) (627 participants) compared delirium incidence with secondgeneration antipsychotics (olanzapine, risperidone) versus placebo in on-pump cardiac or joint-replacement surgery. We found a statistically significant and clinically meaningful difference favoring second-generation antipsychotics in the pooled analysis (RR, 0.36 [CI, 0.26 to 0.50]) (Figure 3; Supplement Figure 3 and Supplement Table 9).",
       "highlight": "We found a statistically significant and clinically meaningful difference favoring second-generation antipsychotics in the pooled analysis (RR, 0.36 [CI, 0.26 to 0.50])",
       "scope": "narrower",
       "note": "Nearest match that must NOT be read as blanket support: in postoperative on-pump cardiac / joint-replacement surgery patients, second-generation antipsychotics (not haloperidol) lowered delirium incidence — limited evidence the authors flag as needing confirmation; a subgroup exception, not a treatment finding.",
       "page": "478",
       "docUrl": "https://doi.org/10.7326/M19-1859"
      }
     ]
    },
    {
     "label": "Nikooie 2019 (antipsychotics — treatment)",
     "cite": "Nikooie R, et al. Antipsychotics for treating delirium in hospitalized adults: a systematic review. Ann Intern Med 2019;171:485.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Covers only the TREATMENT half of the claim; every treatment comparison showed no benefit or harm, so it fully supports 'do not routinely treat delirium with antipsychotics.'",
     "docUrl": "https://doi.org/10.7326/M19-1860",
     "paragraphs": [
      {
       "context": "Conclusion: Current evidence does not support routine use of haloperidol or second-generation antipsychotics to treat delirium in adult inpatients.",
       "highlight": "Current evidence does not support routine use of haloperidol or second-generation antipsychotics to treat delirium in adult inpatients.",
       "scope": "on-scope",
       "note": "Abstract conclusion; governs the treatment half of the card statement.",
       "page": "485",
       "docUrl": "https://doi.org/10.7326/M19-1860"
      },
      {
       "context": "Our systematic review of 26 RCTs and observational studies, evaluating 5607 adult inpatients with delirium, does not support routine use of haloperidol or second-generation antipsychotics for treating delirium in adult inpatients.",
       "highlight": "does not support routine use of haloperidol or second-generation antipsychotics for treating delirium in adult inpatients",
       "scope": "on-scope",
       "note": "Opening sentence of the Discussion, summarizing 26 studies / 5607 inpatients.",
       "page": "492",
       "docUrl": "https://doi.org/10.7326/M19-1860"
      },
      {
       "context": "In conclusion, antipsychotics for treatment of delirium in adult inpatients did not improve patient outcomes, with little evidence of neurologic harms but a tendency for more frequent potentially harmful cardiac effects. For some clinically important outcomes and specific patient subgroups (such as older adults and palliative care patients), there was insufficient or no evidence, emphasizing the need for continued future research in the field.",
       "highlight": "antipsychotics for treatment of delirium in adult inpatients did not improve patient outcomes",
       "scope": "on-scope",
       "note": "Closing conclusion; adds that harmful cardiac effects tended to occur more frequently.",
       "page": "492",
       "docUrl": "https://doi.org/10.7326/M19-1860"
      },
      {
       "context": "Moreover, a single RCT in 249 palliative care patients (37) reported that haloperidol and risperidone had less improvement in delirium severity and more extrapyramidal symptoms compared with placebo, with haloperidol (versus placebo) demonstrating significantly worse survival.",
       "highlight": "haloperidol (versus placebo) demonstrating significantly worse survival",
       "scope": "different-population",
       "note": "Nearest-match different population: in palliative-care patients the single RCT showed antipsychotics were WORSE than placebo (less severity improvement, more EPS, worse survival) — an active-harm signal specific to that population, reinforcing 'do not use routinely' rather than contradicting it.",
       "page": "492",
       "docUrl": "https://doi.org/10.7326/M19-1860"
      }
     ]
    }
   ],
   "synthesis": "All three systematic reviews agree that current evidence does not support the routine use of antipsychotics to prevent (Oh 2019) or treat (Nikooie 2019) delirium in hospitalized adults, and the primary source, Neufeld 2016 — which addresses both indications — reaches the same conclusion, so the card statement is well grounded and governed by Neufeld 2016. The only qualifications are nearest-match subgroups that must not be read as endorsement: Oh 2019's limited-evidence finding that second-generation antipsychotics (not haloperidol) may lower delirium incidence specifically in postoperative surgical patients, Nikooie 2019's palliative-care signal of net harm, and Neufeld 2016's caveat that none of the trials evaluated short-term symptomatic relief of agitation/distress.",
   "discrepancy": true
  },
  {
   "id": "sd-cards-r25",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "3",
   "section": "Act card — Manage without new harm",
   "statement": "Reserve short-term, low-dose antipsychotics only for severe agitation endangering the patient.",
   "contentType": "Cited clinical content",
   "sources": [
    "AGS 2015 (postoperative delirium guideline)",
    "NICE CG103"
   ],
   "anchor": "AGS 2015 (postoperative delirium guideline) — p. 9",
   "passage": "Recommendation—The prescribing practitioner may use antipsychotics at the lowest effective dose for the shortest possible duration to treat patients who are severely agitated or distressed, and are threatening substantial harm to self and/or others. In all cases, treatment with antipsychotics should be employed only if behavioral interventions have failed or are\nSupported. AGS 2015 permits antipsychotics 'at the lowest effective dose for the shortest possible duration' only for patients 'severely agitated or distressed … threatening substantial harm to self and/or others,' and only after behavioural interventions fail (Recommendation XII, p. 9). This matches NICE CG103's short-term, distress/risk-limited use.",
   "evidence": "Full text, p. 9",
   "status": "fulltext",
   "pageNum": "9",
   "citations": [
    "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142.",
    "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023)."
   ],
   "links": [
    "https://doi.org/10.1111/jgs.13281",
    "https://www.nice.org.uk/guidance/cg103"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "AGS 2015 (postoperative delirium guideline)",
     "cite": "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Directly supports the claim: antipsychotics only at the lowest effective dose for the shortest duration, reserved for delirious patients who are severely agitated/distressed and threatening substantial harm, and only after behavioral interventions fail.",
     "docUrl": "https://doi.org/10.1111/jgs.13281",
     "paragraphs": [
      {
       "context": "XII. Antipsychotics in the Setting of Severe Agitation Recommendation--The prescribing practitioner may use antipsychotics at the lowest effective dose for the shortest possible duration to treat patients who are severely agitated or distressed, and are threatening substantial harm to self and/or others. In all cases, treatment with antipsychotics should be employed only if behavioral interventions have failed or are not possible, and ongoing use should be evaluated daily with in-person examination of patients (strength of recommendation: weak; quality of evidence: low).",
       "highlight": "antipsychotics at the lowest effective dose for the shortest possible duration to treat patients who are severely agitated or distressed, and are threatening substantial harm to self and/or others",
       "scope": "on-scope",
       "note": "Recommendation XII is the primary on-scope support: reserve low-dose, short-duration antipsychotics for patients severely agitated/distressed and threatening substantial harm, only if behavioral interventions fail.",
       "page": "9",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "A. Evidence for Recommendation: Pharmacologic treatment has not been consistently shown to modify the duration or severity of postoperative delirium. 83ET,84ET,91ET In addition, the harms of both antipsychotics and benzodiazepines are substantial and well documented, with the potential for increased morbidity and mortality. Healthcare providers should not prescribe these classes of drugs for treatment of delirium in patients without significant agitation that threatens the patient's safety or the safety of others. The use of antipsychotics at the lowest J Am Geriatr Soc.",
       "highlight": "that threatens the patient's safety or the safety of others",
       "scope": "on-scope",
       "note": "Recommendation XIV states antipsychotics should not be prescribed for delirium in patients without significant agitation threatening safety, establishing the 'only for severe agitation endangering the patient' limit.",
       "page": "10",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "Author Manuscript effective dose should be reserved for short-term management of acute agitation in the setting of possible substantial harm.",
       "highlight": "reserved for short-term management of acute agitation in the setting of possible substantial harm",
       "scope": "on-scope",
       "note": "The same recommendation's closing sentence is a near-verbatim match for 'reserve short-term, low-dose antipsychotics only for severe agitation endangering the patient.'",
       "page": "11",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "The use of antipsychotics (e.g., haloperidol, risperidone, olanzapine, quetiapine, or ziprasidone) at the lowest effective dose for the shortest possible duration may be considered to treat delirious patients who are severely agitated or distressed or who are threatening substantial harm to self and/or others.",
       "highlight": "may be considered to treat delirious patients who are severely agitated or distressed or who are threatening substantial harm to self and/or others",
       "scope": "on-scope",
       "note": "Box 1 clinical-practice-guideline summary restates the same reserve principle for severely agitated/distressed patients threatening harm.",
       "page": "15",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "Recommendation--There is insufficient evidence to recommend for or against the use of antipsychotic medications prophylactically in older surgical patients to prevent delirium (strength of recommendation: not applicable; quality of evidence: low).",
       "highlight": "the use of antipsychotic medications prophylactically in older surgical patients to prevent delirium",
       "scope": "different-intervention",
       "note": "Nearest keyword match but different intervention: Recommendation X concerns prophylactic antipsychotics to PREVENT delirium (insufficient evidence), not reserving antipsychotics to treat severe agitation; must not be read as support.",
       "page": "8",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "Recommendation--The prescribing practitioner should not use benzodiazepines as a first-line treatment of the agitated postoperative delirious patient who is threatening substantial harm to self and/or others to treat postoperative delirium except when benzodiazepines are specifically indicated (including, but not limited to, treatment of alcohol or benzodiazepine withdrawal). Treatment with benzodiazepines should be at the lowest effective dose for the shortest possible duration, and should be employed only if behavioral measures have failed or are not possible and ongoing use should be evaluated daily with inperson examination of the patient (strength of recommendation: strong; quality of evidence: low).",
       "highlight": "should not use benzodiazepines as a first-line treatment of the agitated postoperative delirious patient who is threatening substantial harm to self and/or others",
       "scope": "different-intervention",
       "note": "Different drug class: Recommendation XIII addresses benzodiazepines (advises against first-line use), sharing the 'agitated/threatening substantial harm' framing but not the antipsychotic reserve principle in the claim.",
       "page": "10",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Concordant: reserve short-term haloperidol at the lowest clinically appropriate dose for a delirious person distressed or a risk to self/others, only after verbal/non-verbal de-escalation fails. This treatment recommendation remains the current position (the 2023 update re-addressed only assessment/diagnosis).",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "Start at the lowest clinically appropriate dose and titrate cautiously according to symptoms.",
       "highlight": "Start at the lowest clinically appropriate dose and titrate cautiously according to",
       "scope": "on-scope",
       "note": "Recommendation 1.7.4 directly supports the claim: short-term (1 week or less), lowest clinically appropriate dose antipsychotic (haloperidol), only when the person is distressed or a risk to self/others and de-escalation is ineffective or inappropriate.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "others, first use verbal and non-verbal techniques to de-escalate the situation.",
       "highlight": "first use verbal and non-verbal techniques to de-escalate the situation",
       "scope": "on-scope",
       "note": "Recommendation 1.7.3 grounds the 'only for' limit: verbal/non-verbal de-escalation is first-line for a distressed or at-risk delirious person before any antipsychotic is considered.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "In people in hospital who are at high risk of delirium, which medication (atypical antipsychotics, typical antipsychotics, benzodiazepines or acetylcholinesterase inhibitors), compared with placebo or each other, is more clinically and cost effective in preventing the development of delirium? [2010]",
       "highlight": "is more clinically and cost effective in preventing the development of delirium",
       "scope": "different-intervention",
       "note": "Nearest keyword match but different scope: research recommendation 2 concerns antipsychotics for PREVENTING delirium in at-risk patients (prophylaxis), not reserving them to treat established severe agitation.",
       "page": "14",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "In people in hospital who have delirium, which is the most effective medication (atypical antipsychotics, typical antipsychotics or benzodiazepines) compared with placebo or each other for treating delirium? [2010]",
       "highlight": "the most effective medication (atypical antipsychotics, typical antipsychotics or benzodiazepines) compared with placebo or each other for treating delirium",
       "scope": "broader",
       "note": "Research recommendation 3 asks about the most effective medication for treating delirium generally (recovery/duration outcomes) and whether it should be given routinely or for selected symptoms, broader than the specific reserve-for-severe-agitation indication.",
       "page": "15",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    }
   ],
   "synthesis": "AGS 2015 (postoperative delirium in older surgical adults) and NICE CG103 (hospital and long-term care, adults 18+) agree and directly support the claim: reserve short-term, low-dose antipsychotics only for delirious patients who are severely agitated/distressed and endangering themselves or others, after behavioral de-escalation has failed — AGS recommendation XII plus the reserve statement in XIV, and NICE 1.7.4 (short-term haloperidol at the lowest clinically appropriate dose). NICE's treatment recommendation (marked 2010, amended 2022) remains the current position because the 2023 NICE update re-addressed only assessment and diagnosis; the nearest-match paragraphs on prophylactic/preventive antipsychotics (AGS section X, NICE research recommendation 2) share the 'antipsychotic' keyword but concern prevention rather than treatment of agitation and must not be read as support.",
   "discrepancy": true
  },
  {
   "id": "sd-cards-r26",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "3",
   "section": "Act card — Document & hand off",
   "statement": "Document the screen used and its result; rescreen with any change in mental status.",
   "contentType": "Documentation practice",
   "sources": [
    "NICE CG103"
   ],
   "anchor": "Cited to NICE CG103, a live web guideline that is not held in the local reference archive, so no passage is quoted here. NICE CG103 directs teams to record the delirium diagnosis and to reassess; documenting the screen used and its result and rescreening on any mental-status change is standard delirium documentation practice consistent with that guideline. Among the archived sources, AGS 2015 explicitly states diagnosis and screening are outside its scope (p. 2), so it offers no support here.",
   "passage": "",
   "evidence": "Guideline (NICE CG103) — cited, not in local archive",
   "status": "guideline",
   "pageNum": null,
   "citations": [
    "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023)."
   ],
   "links": [
    "https://www.nice.org.uk/guidance/cg103"
   ],
   "decision": "",
   "notes": "Operational/documentation line — verify against NICE CG103 directly."
  },
  {
   "id": "sd-cards-r27",
   "toolId": "sd-cards",
   "tool": "Step-Down Card Set",
   "page": "3",
   "section": "Act card — Document & hand off",
   "statement": "Hand off the finding, suspected cause, and plan to the receiving / covering team.",
   "contentType": "Care-transition practice",
   "sources": [
    "NICE CG103"
   ],
   "anchor": "Cited to NICE CG103 (a live web guideline, not held in the local archive, so no passage is quoted). Communicating a delirium finding, its suspected cause and the plan at care transitions is standard practice consistent with NICE CG103's emphasis on sharing the diagnosis. Not stated in any archived step-down source.",
   "passage": "",
   "evidence": "Guideline (NICE CG103) — cited, not in local archive",
   "status": "guideline",
   "pageNum": null,
   "citations": [
    "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023)."
   ],
   "links": [
    "https://www.nice.org.uk/guidance/cg103"
   ],
   "decision": "",
   "notes": "Operational/care-transition line — verify against NICE CG103 directly."
  },
  {
   "id": "sd-wf-r3",
   "toolId": "sd-wf",
   "tool": "Step-Down Workflow",
   "page": "1",
   "section": "1 · Screen the verbal patient",
   "statement": "For the monitored, non-intubated (step-down / progressive-care) patient. Under ICU-level sedation, use the CAM-ICU instead.",
   "contentType": "Cited clinical content",
   "sources": [
    "Beyer 2024 (CAM-IMC)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 5",
   "passage": "The CAM-IMC shows a sensitivity of 0.96 and specificity of 0.94 in diagnosis of POD in non-intubated postoperative cardiac surgery patients.\nAlso Beyer 2024 (CAM-IMC) (p. 1): “for diagnosing POD in intubated patients cannot make use of the feature ‘disorientation’, as this requires verbal communication. Other tools such as the 4AT test for disorientation but are not established in ICU settings.”\nSupported. The CAM-IMC was validated in non-intubated intermediate-care (post-cardiac-surgery) patients (Beyer 2024, p. 5); Beyer notes intubated patients cannot use the disorientation feature (it requires verbal communication), so under ICU-level sedation the CAM-ICU applies instead (p. 1).",
   "evidence": "Full text, p. 5",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "stance": "agrees",
     "note": "The performance figures and the population are stated in the same sentence; the cohort is cardiac-surgery intermediate care, which is narrower than the step-down population the workflow addresses.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "This cohort study evaluates the test performance of the newly developed CAM-IMC and its disorientation component in a prospective cohort study. The CAM-IMC shows a sensitivity of 0.96 and specificity of 0.94 in diagnosis of POD in non-intubated postoperative cardiac surgery patients. Its test performance is comparable to the widely used CAM-ICU demonstrating a high level of accuracy [19].",
       "highlight": "The CAM-IMC shows a sensitivity of 0.96 and specificity of 0.94 in diagnosis of POD",
       "page": "5"
      },
      {
       "scope": "different-population",
       "context": "This cohort study evaluates the test performance of the newly developed CAM-IMC and its disorientation component in a prospective cohort study. The CAM-IMC shows a sensitivity of 0.96 and specificity of 0.94 in diagnosis of POD in non-intubated postoperative cardiac surgery patients. Its test performance is comparable to the widely used CAM-ICU demonstrating a high level of accuracy [19].",
       "highlight": "in non-intubated postoperative cardiac surgery patients",
       "page": "5"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-wf-r4",
   "toolId": "sd-wf",
   "tool": "Step-Down Workflow",
   "page": "1",
   "section": "1 · Screen the verbal patient",
   "statement": "Score arousal (RASS), then run the CAM-IMC — additive 0–10, positive at ≥ 3.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Beyer 2024 (CAM-IMC)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 4",
   "passage": "Patients scoring three points or higher were considered as positive for POD, while those less than three points were considered negative.\nAlso Beyer 2024 (CAM-IMC) (p. 5): “The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score”\nSupported — additive 0–10 screen, positive at ≥ 3 (Beyer 2024, p. 4–5). See the CAM-IMC card rows.",
   "evidence": "Full text, p. 4",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "stance": "agrees",
     "note": "The additive score and its three-point cut-off are the instrument as published.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "Overall, the CAM-IMC showed an AUROC of 0.98 (CI 95%: 0.96-1.00). The optimal cut-off based on the Youden-Index was chosen at three points for the CAM-IMC to determine the presence of POD. This is displayed in the ROC-analysis in Fig. 3. Patients scoring three points or higher were considered as positive for POD, while those less than three points were considered negative.",
       "highlight": "Patients scoring three points or higher were considered as positive for POD",
       "page": "4"
      },
      {
       "scope": "on-scope",
       "context": "The CAM-IMC outperforms each individual feature of the CAM-IMC. By creating the CAM-IMC flowchart design as a pointbased scoring system, the importance of disorientation as a central feature of POD has been reinforced. The features disorientation and inattention can each trigger a positive test result. The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome.",
       "highlight": "The system assigns up to five points for disorientation and three points for inattention",
       "page": "5"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-wf-r5",
   "toolId": "sd-wf",
   "tool": "Step-Down Workflow",
   "page": "1",
   "section": "2 · Arousal — the gate",
   "statement": "Score the RASS first. Any RASS other than 0 scores the CAM-IMC level-of-consciousness point.",
   "contentType": "Cited clinical content",
   "sources": [
    "Beyer 2024 (CAM-IMC)",
    "Han 2015 (RASS in the ED)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 3",
   "passage": "The elements “Acute change or fluctuating course of mental status” and “Altered level of consciousness” are dichotomous, allowing for the assignment of one point for an abnormal test result.\nAlso Beyer 2024 (CAM-IMC) (p. 8): “RASS ≠ 0 and disorientation are binary”\nAlso Han 2015 (RASS in the ED) (p. 3): “A RASS of 0 represented normal level of consciousness whereas a RASS other than 0 represented the presence of altered level of consciousness.”\nSupported (Beyer 2024, p. 3, p. 8; Han 2015, p. 3). See the arousal-gate (altered) row.",
   "evidence": "Full text, p. 3",
   "status": "fulltext",
   "pageNum": "3",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451.",
    "Han JH, et al. The diagnostic performance of the RASS for detecting delirium in older ED patients. Acad Emerg Med 2015;22:878."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3",
    "https://doi.org/10.1111/acem.12706"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "cite": "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "",
     "docUrl": "https://doi.org/10.1186/s12871-024-02849-3",
     "paragraphs": [
      {
       "context": "The elements “Acute change or fluctuating course of mental status” and “Altered level of consciousness” are dichotomous, allowing for the assignment of one point for an abnormal test result.",
       "highlight": "“Altered level of consciousness” are dichotomous, allowing for the assignment of one point for an abnormal test result",
       "scope": "on-scope",
       "note": "The CAM-IMC's point-based scoring makes altered level of consciousness a dichotomous element worth one point — the level-of-consciousness point the claim describes.",
       "page": "3",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "By creating the CAM-IMC flowchart design as a pointbased scoring system, the importance of disorientation as a central feature of POD has been reinforced. The features disorientation and inattention can each trigger a positive test result. The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome. This is reflected in their limited ability to discriminate POD, as shown by a distinct lower AUROC compared to disorientation, inattention and overall CAM-IMC. As a result, disorientation and inattention exert the greatest influence Beyer et al.",
       "highlight": "RASS0 have been reduced in significance and each contribute one point to the total score",
       "scope": "on-scope",
       "note": "Names the level-of-consciousness element as RASS≠0 (shown as 'RASS0' in the extracted text) and confirms it contributes one point, directly linking any RASS other than 0 to the CAM-IMC point.",
       "page": "5",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome.",
       "highlight": "RASS≠0 have been reduced in significance and each contribute one point to the total score",
       "scope": "on-scope",
       "note": "Discussion states the RASS≠0 category contributes one point to the total score, consistent with a single point for any non-zero RASS.",
       "page": "8",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      }
     ]
    },
    {
     "label": "Han 2015 (RASS in the ED)",
     "cite": "Han JH, et al. The diagnostic performance of the RASS for detecting delirium in older ED patients. Acad Emerg Med 2015;22:878.",
     "kind": "pdf",
     "stance": "partial",
     "note": "",
     "docUrl": "https://doi.org/10.1111/acem.12706",
     "paragraphs": [
      {
       "context": "The RASS is an arousal scale commonly used in intensive care units to assess for depth of sedation (Figure 1),10 but has been incorporated into several delirium assessments to assess for level of consciousness.6 For this study, we replaced the term \"sedation\" with \"drowsy,\" (Figure 1) to describe level of consciousness regardless of sedation administration. A RASS of 0 represented normal level of consciousness whereas a RASS other than 0 represented the presence of altered level of consciousness. The RASS was determined by an emergency physician (EP) and research assistants (RAs; college graduates, emergency medical technicians, and paramedics). Before the study began, the RAs were given a 5-minute didactic lecture about the RASS. The principal investigator then observed them perform the RASS in five older ED patients and provided them instruction if there was any discordance.",
       "highlight": "a RASS other than 0 represented the presence of altered level of consciousness",
       "scope": "different-setting",
       "note": "Defines RASS≠0 as altered level of consciousness — the same arousal cut-point the claim uses — but validated in older ED patients with RASS as a standalone screen, not as the CAM-IMC's level-of-consciousness element.",
       "page": "3",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      },
      {
       "context": "Conclusions--In older ED patients, a RASS other than 0 has very good sensitivity and specificity for delirium as diagnosed by a psychiatrist. A RASS > +1 or < -1 is nearly diagnostic for delirium given the very high positive likelihood ratio.",
       "highlight": "a RASS other than 0 has very good sensitivity and specificity for delirium",
       "scope": "different-setting",
       "note": "Quantifies RASS≠0's diagnostic accuracy for delirium in the emergency department — supports the arousal cut-point in a different care setting rather than the CAM-IMC scoring step itself.",
       "page": "2",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      }
     ]
    }
   ],
   "synthesis": "Beyer 2024 is the on-scope governing source: the CAM-IMC's point-based scoring makes an altered level of consciousness (RASS≠0) a dichotomous item worth one point, exactly as the claim states. Han 2015 corroborates that a RASS other than 0 marks altered level of consciousness and flags delirium, but in older emergency-department patients using RASS as a standalone screen — a different care setting and use — so it supports the underlying arousal cut-point rather than the CAM-IMC scoring rule itself.",
   "discrepancy": true
  },
  {
   "id": "sd-wf-r6",
   "toolId": "sd-wf",
   "tool": "Step-Down Workflow",
   "page": "1",
   "section": "2 · Arousal — the gate",
   "statement": "RASS −4 / −5 → stupor / coma — record “unable to assess”; reassess when the patient responds to voice.",
   "contentType": "Cited clinical content",
   "sources": [
    "Beyer 2024 (CAM-IMC)",
    "Sessler 2002 (RASS)",
    "Han 2015 (RASS in the ED)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 1",
   "passage": "for diagnosing POD in intubated patients cannot make use of the feature ‘disorientation’, as this requires verbal communication. Other tools such as the 4AT test for disorientation but are not established in ICU settings.\nAlso Han 2015 (RASS in the ED) (p. 3): “Patients were excluded if they were non-English speaking, deaf or blind, previously enrolled, non-verbal or unable to follow simple commands prior to their acute illnesses, comatose, or did not complete all the study assessments.”\nIndirect support (Beyer 2024, p. 1; Han 2015, p. 3). The −4 / −5 threshold and 'reassess when responds to voice' are standard RASS / CAM-ICU practice (Sessler 2002, not archived). See the arousal-gate (stop) row.",
   "evidence": "Full text, p. 1 — partial support",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451.",
    "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
    "Han JH, et al. The diagnostic performance of the RASS for detecting delirium in older ED patients. Acad Emerg Med 2015;22:878."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/",
    "https://doi.org/10.1111/acem.12706"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "cite": "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Governs the step-down/intermediate-care setting: RASS is embedded as the arousal/level-of-consciousness measure in the CAM-IMC and the scale's deeply-sedated endpoint is defined, but the paper never states the 'unable to assess'/'reassess when responds to voice' gate itself.",
     "docUrl": "https://doi.org/10.1186/s12871-024-02849-3",
     "paragraphs": [
      {
       "context": "RASS ranges from -5 (deeply sedated) to +4 (aggressive)",
       "highlight": "-5 (deeply sedated)",
       "scope": "on-scope",
       "note": "Defines the RASS scale inside the step-down (intermediate-care) tool, grounding the -5 = deeply sedated end that the claim maps to stupor/coma; the non-intubated IMC setting matches the Step-Down Workflow.",
       "page": "6",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "Postoperative day one through three index testing was obtained by two independent examiners who engaged the patients on that day. These examiners were both residents and nursing staff. For reference rating, patients were assessed for POD by an experienced reference-rater once every day. The reference-raters used DSM-5 criteria, Richmond Agitation-Sedation Scale (RASS), CAM-ICU and features of disorientation for diagnosing POD. The reference rater was allowed to make his diagnosis based on all the diagnostic criteria and his professional experience. The reference raters were experienced senior consultants in intensive care (BER, UG) and geriatrics (TZ). Clinical information, e.g. nurses’ notes and electronic medical records, was available to all examiners. All examination results were blinded in a sealed box. No examiner had knowledge about other index test results or preoperative cognitive testing. The examinations were carried out alongside the morning ward round without no more than 60 min in between examinations.",
       "highlight": "Richmond Agitation-Sedation Scale (RASS), CAM-ICU and features of disorientation for diagnosing POD",
       "scope": "background",
       "note": "Shows RASS is part of the delirium workup in this step-down cohort, but this methods sentence does not describe the -4/-5 assessability gate.",
       "page": "4",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "By creating the CAM-IMC flowchart design as a point-based scoring system, the importance of disorientation as a central feature of POD has been reinforced. The features disorientation and inattention can each trigger a positive test result. The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome. This is reflected in their limited ability to discriminate POD, as shown by a distinct lower AUROC compared to disorientation, inattention and overall CAM-IMC. As a result, disorientation and inattention exert the greatest influence on CAM-IMC test-results. In comparison, the CAM-ICU does not diagnose POD if “Acute change or fluctuating course of the mental status” is assessed as negative, even when inattention or disorganized thinking” is present. By employing a point-based scoring system, the CAM-IMC avoids this limitation.",
       "highlight": "each contribute one point to the total score but are not mandatory for a positive test outcome",
       "scope": "background",
       "note": "Here RASS is used as a low-weight delirium scoring feature (RASS not equal to 0), a different role than the arousal gate that decides whether a patient is assessable at all.",
       "page": "5",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "Cited (Am J Respir Crit Care Med 2002;166:1338) as the RASS validation source defining the scale semantics behind the claim: -4 = deep sedation with no response to voice, -5 = unarousable, and 'responds to voice' as the -4/-3 threshold. Not archived as full text here, so no paragraphs extracted.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    },
    {
     "label": "Han 2015 (RASS in the ED)",
     "cite": "Han JH, et al. The diagnostic performance of the RASS for detecting delirium in older ED patients. Acad Emerg Med 2015;22:878.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest keyword match (RASS, arousal, level of consciousness) but a different scope throughout: an emergency-department study using RASS not equal to 0 as a standalone delirium screen and excluding comatose patients; it does not support the step-down assessability-gate rule and must not be read as direct support.",
     "docUrl": "https://doi.org/10.1111/acem.12706",
     "paragraphs": [
      {
       "context": "The RASS is an arousal scale commonly used in intensive care units to assess for depth of sedation (Figure 1),10 but has been incorporated into several delirium assessments to assess for level of consciousness.6 For this study, we replaced the term \"sedation\" with \"drowsy,\" (Figure 1) to describe level of consciousness regardless of sedation administration. A RASS of 0 represented normal level of consciousness whereas a RASS other than 0 represented the presence of altered level of consciousness. The RASS was determined by an emergency physician (EP) and research assistants (RAs; college graduates, emergency medical technicians, and paramedics). Before the study began, the RAs were given a 5-minute didactic lecture about the RASS. The principal investigator then observed them perform the RASS in five older ED patients and provided them instruction if there was any discordance.",
       "highlight": "an arousal scale commonly used in intensive care units to assess for depth of sedation",
       "scope": "different-setting",
       "note": "Closest statement on RASS-as-arousal, but framed for an ED study that repurposes RASS as a delirium screen rather than as a step-down arousal gate.",
       "page": "3",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      },
      {
       "context": "The Richmond Agitation Sedation Scale (RASS; Figure 1), which quantifies level of consciousness, may be a reasonable alternative to delirium screening in the ED.",
       "highlight": "a reasonable alternative to delirium screening in the ED",
       "scope": "different-intervention",
       "note": "Uses RASS as a delirium-detection screen (RASS not equal to 0 flags delirium), a different application than gating out deeply sedated patients who cannot be assessed.",
       "page": "2",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      },
      {
       "context": "because the psychiatrists' comprehensive assessments were conducted in addition to their clinical duties. The first patient who met all the eligibility criteria was enrolled each day. Patients who were 65 years or older, in the ED for less than 12 hours at the time of enrollment, and not in a hallway bed were eligible. The 12 hour cut-off was used to include patients who presented to the ED in the evening and early morning hours. Patients were excluded if they were non-English speaking, deaf or blind, previously enrolled, non-verbal or unable to follow simple commands prior to their acute illnesses, comatose, or did not complete all the study assessments. Patients who were non-verbal or unable to follow simple commands prior to their acute illnesses were considered to have end-stage dementia. These patients were excluded because diagnosing delirium in this patient group can be challenging, even for an experienced psychiatrist.",
       "highlight": "unable to follow simple commands prior to their acute illnesses, comatose",
       "scope": "different-population",
       "note": "Comatose ED patients were excluded from enrollment rather than flagged 'unable to assess' and reassessed later; a parallel idea handled by exclusion in a different setting/population.",
       "page": "3",
       "docUrl": "https://doi.org/10.1111/acem.12706"
      }
     ]
    }
   ],
   "synthesis": "The claim's arousal gate rests on the RASS scale's own semantics — defined by the cited Sessler 2002 validation (-4 = deep sedation with no response to voice, -5 = unarousable, so a patient who 'responds to voice' has crossed back above the gate) — while Beyer 2024 is the on-scope source that governs the step-down/intermediate-care setting, embedding RASS as the CAM-IMC's arousal measure and defining the -5 (deeply sedated) endpoint, though it does not itself spell out the 'record unable to assess / reassess' wording. Han 2015 shares the keywords but is a different scope: an emergency-department study that uses RASS not equal to 0 as a standalone delirium screen and excludes comatose patients, so it should not be read as direct support for the step-down assessability gate.",
   "discrepancy": true
  },
  {
   "id": "sd-wf-r7",
   "toolId": "sd-wf",
   "tool": "Step-Down Workflow",
   "page": "1",
   "section": "3 · CAM-IMC — score",
   "statement": "CAM-IMC = acute change (+1) + altered LOC / RASS ≠ 0 (+1) + inattention (up to 3) + disorientation (up to 5); ≥ 3 → positive.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Beyer 2024 (CAM-IMC)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 5",
   "passage": "The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score\nAlso Beyer 2024 (CAM-IMC) (p. 3): “The elements “Acute change or fluctuating course of mental status” and “Altered level of consciousness” are dichotomous, allowing for the assignment of one point for an abnormal test result.”\nAlso Beyer 2024 (CAM-IMC) (p. 4): “Patients scoring three points or higher were considered as positive for POD, while those less than three points were considered negative.”\nExact match to the CAM-IMC scoring (Beyer 2024, p. 3–5).",
   "evidence": "Full text, p. 5",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "stance": "agrees",
     "note": "Each element's point value is stated across the methods and the discussion.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "Figure 1 illustrates the diagnostic workup using CAM-IMC as the index test. A point-based scoring system was introduced in CAM-IMC, allowing for a modified weighting of each element in the diagnosis of POD. The elements \"Acute change or fluctuating course of mental status\" and \"Altered level of consciousness\" are dichotomous, allowing for the assignment of one point for an abnormal test result. Inattention was assessed by having the patient read aloud a ten-letter word (ANANASBAUM or CASABLANCA) and squeeze the examiner's hand each time they heard the letter \"A.\" Consistent with the CAM-ICU, a maximum of three errors were permitted, with one point deducted for each mistake. Disorientation was newly introduced and evaluated across five different dimensions.",
       "highlight": "The elements \"Acute change or fluctuating course of mental status\" and \"Altered level of consciousness\" are dichotomous, allowing for the assignment of one point for an abnormal test result.",
       "page": "3"
      },
      {
       "scope": "on-scope",
       "context": "The CAM-IMC outperforms each individual feature of the CAM-IMC. By creating the CAM-IMC flowchart design as a pointbased scoring system, the importance of disorientation as a central feature of POD has been reinforced. The features disorientation and inattention can each trigger a positive test result. The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome.",
       "highlight": "The system assigns up to five points for disorientation and three points for inattention",
       "page": "5"
      },
      {
       "scope": "on-scope",
       "context": "Overall, the CAM-IMC showed an AUROC of 0.98 (CI 95%: 0.96-1.00). The optimal cut-off based on the Youden-Index was chosen at three points for the CAM-IMC to determine the presence of POD. This is displayed in the ROC-analysis in Fig. 3. Patients scoring three points or higher were considered as positive for POD, while those less than three points were considered negative.",
       "highlight": "The optimal cut-off based on the Youden-Index was chosen at three points",
       "page": "4"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-wf-r8",
   "toolId": "sd-wf",
   "tool": "Step-Down Workflow",
   "page": "1",
   "section": "3 · CAM-IMC — score",
   "statement": "Disorientation or inattention can drive a positive result on their own — a negative acute-change item does not veto it.",
   "contentType": "Cited clinical content",
   "sources": [
    "Beyer 2024 (CAM-IMC)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 5",
   "passage": "The features disorientation and inattention can each trigger a positive test result.\nAlso Beyer 2024 (CAM-IMC) (p. 6): “the CAM-ICU does not diagnose POD if “Acute change or fluctuating course of the mental status” is assessed as negative, even when inattention or disorganized thinking” is present. By employing a point-based scoring system, the CAM-IMC avoids this limitation.”\nExact match. Beyer 2024: disorientation and inattention each trigger a positive; the CAM-IMC's point system removes the CAM-ICU's acute-change veto (p. 5–6).",
   "evidence": "Full text, p. 5",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "stance": "agrees",
     "note": "The non-veto behavior is stated directly.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "The CAM-IMC outperforms each individual feature of the CAM-IMC. By creating the CAM-IMC flowchart design as a pointbased scoring system, the importance of disorientation as a central feature of POD has been reinforced. The features disorientation and inattention can each trigger a positive test result. The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome.",
       "highlight": "The features disorientation and inattention can each trigger a positive test result.",
       "page": "5"
      },
      {
       "scope": "on-scope",
       "context": "The CAM-IMC outperforms each individual feature of the CAM-IMC. By creating the CAM-IMC flowchart design as a pointbased scoring system, the importance of disorientation as a central feature of POD has been reinforced. The features disorientation and inattention can each trigger a positive test result. The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS≠0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome.",
       "highlight": "are not mandatory for a positive test outcome",
       "page": "5"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-wf-r9",
   "toolId": "sd-wf",
   "tool": "Step-Down Workflow",
   "page": "1",
   "section": "4 · Risk & prevent",
   "statement": "Admission risk: age ≥ 85, ADL dependence ≥ 5 of 6, psychotropic subtotal ≥ 2 — one point each → Low / Intermediate / High.",
   "contentType": "Validated instrument wording",
   "sources": [
    "Martinez 2012 (ward risk rule)"
   ],
   "anchor": "Martinez 2012 (ward risk rule) — p. 1",
   "passage": "the individual risk of delirium is obtained by adding one point for each criterion met (age≥85, high level of dependence, and being on psychotropic medication).\nAlso Martinez 2012 (ward risk rule) (p. 4): “One point was given to patients older than 85 years, to those who had two or more points in the variable drugs, and to those with impairments in ﬁve or more of the ADL”\nSupported (Martinez 2012, abstract; p. 4). Band incidences 4% / 14–23% / 43–64% — see the risk card bands row.",
   "evidence": "Full text, p. 1",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "Martinez JA, et al. Derivation and validation of a clinical prediction rule for delirium in patients admitted to a medical ward. BMJ Open 2012;2:e001599."
   ],
   "links": [
    "https://doi.org/10.1136/bmjopen-2012-001599"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Martinez 2012 (ward risk rule)",
     "stance": "agrees",
     "note": "The three criteria, the one-point-each scoring and the 0-3 range are stated together in the methods.",
     "paragraphs": [
      {
       "scope": "on-scope",
       "context": "Accordingly, the medication data was coded according to the number of different drugs patients were taking at admission with each antidepressant, antidementia or anticonvulsant drug contributing equally, while antipsychotic drugs were weighted by a factor of two. The ADL data were also dichotomised with a cut-off of reported impairments in five activities. The scores for the clinical prediction rule were assigned on the basis of regression coefficients obtained in the logistic regression model (table 7). One point was given to patients older than 85 years, to those who had two or more points in the variable drugs, and to those with impairments in five or more of the ADL considered. Therefore, the total score for the rule ranged between 0 and 3.",
       "highlight": "One point was given to patients older than 85 years, to those who had two or more points in the variable drugs, and to those with impairments in five or more of the ADL considered. Therefore, the total score for the rule ranged between 0 and 3.",
       "page": "4"
      }
     ]
    }
   ]
  },
  {
   "id": "sd-wf-r10",
   "toolId": "sd-wf",
   "tool": "Step-Down Workflow",
   "page": "1",
   "section": "4 · Risk & prevent",
   "statement": "Apply the multicomponent non-pharmacologic prevention bundle to every at-risk patient, every shift.",
   "contentType": "Cited clinical content",
   "sources": [
    "Siddiqi 2016 (Cochrane)",
    "AGS 2015 (postoperative delirium guideline)",
    "Inouye 1999 (HELP)"
   ],
   "anchor": "AGS 2015 (postoperative delirium guideline) — p. 4",
   "passage": "Healthcare systems and hospitals should implement multi-component nonpharmacologic intervention programs delivered by an interdisciplinary team (including physicians, nurses, and possibly other healthcare professionals) for the entire hospitalization in at-risk older adults undergoing surgery to prevent delirium (strength of recommendation: strong; quality of evidence: moderate).\nAlso Siddiqi 2016 (Cochrane) (p. 16): “we may be able to identify patients at high risk of developing delirium, and by modifying these risk factors could attempt to prevent it; such prevention strategies could be targeted to specific groups of patients.”\nSupported for targeted multicomponent prevention in at-risk inpatients (AGS 2015 strong recommendation, p. 4; Siddiqi 2016, p. 16). The 'every shift' cadence is the card's operational framing — AGS says 'for the entire hospitalization,' not per shift.",
   "evidence": "Full text, p. 4 — partial support",
   "status": "fulltext",
   "pageNum": "4",
   "citations": [
    "Siddiqi N, et al. Interventions for preventing delirium in hospitalised non-ICU patients. Cochrane Database Syst Rev 2016;CD005563.",
    "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142.",
    "Inouye SK, et al. A multicomponent intervention to prevent delirium in hospitalized older patients. N Engl J Med 1999;340:669."
   ],
   "links": [
    "https://doi.org/10.1002/14651858.CD005563.pub3",
    "https://doi.org/10.1111/jgs.13281",
    "https://doi.org/10.1056/NEJM199903043400901"
   ],
   "decision": "",
   "notes": "'Every shift' cadence is operational; sources say 'for the entire hospitalization' / targeted prevention.",
   "perSource": [
    {
     "label": "Siddiqi 2016 (Cochrane)",
     "cite": "Siddiqi N, et al. Interventions for preventing delirium in hospitalised non-ICU patients. Cochrane Database Syst Rev 2016;CD005563.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Cochrane review of interventions for preventing delirium in hospitalized non-ICU patients — the most directly on-scope source for a general step-down (non-ICU) setting; pooled RCT evidence that the multicomponent nonpharmacologic bundle reduces incident delirium.",
     "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3",
     "paragraphs": [
      {
       "context": "We found multi-component interventions reduced the incidence of delirium compared to usual care (RR 0.69, 95% CI 0.59 to 0.81; seven studies; 1950 participants; moderate-quality evidence). E ect sizes were similar in medical (RR 0.63, 95% CI 0.43 to 0.92; four studies; 1365 participants) and surgical settings (RR 0.71, 95% CI 0.59 to 0.85; three studies; 585 participants). In the subgroup of patients with preexisting dementia, the e ect of multi-component interventions remains uncertain (RR 0.90, 95% CI 0.59 to 1.36; one study, 50 participants; low-quality evidence).",
       "highlight": "multi-component interventions reduced the incidence of delirium compared to usual care",
       "scope": "on-scope",
       "note": "Primary pooled result — the multicomponent bundle cuts delirium incidence vs usual care (RR 0.69; seven RCTs; 1950 participants) in hospitalized non-ICU patients, directly supporting the claim.",
       "page": "1",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "We found strong evidence that multi-component interventions can prevent delirium in both medical and surgical settings and less robust evidence that they reduce the severity of delirium. Evidence about their e ect on the duration of delirium is inconclusive.",
       "highlight": "multi-component interventions can prevent delirium in both medical and surgical settings",
       "scope": "on-scope",
       "note": "Key finding spans both medical and surgical non-ICU settings — the population/setting that a step-down workflow serves.",
       "page": "2",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "There is strong evidence supporting multi-component interventions to prevent delirium in hospitalised patients. There is no clear evidence that cholinesterase inhibitors, antipsychotic medication or melatonin reduce the incidence of delirium. Using the Bispectral Index to monitor and control depth of anaesthesia reduces the incidence of postoperative delirium. The role of drugs and other anaesthetic techniques to prevent delirium remains uncertain.",
       "highlight": "There is strong evidence supporting multi-component interventions to prevent delirium in hospitalised patients",
       "scope": "on-scope",
       "note": "Authors' conclusion — strong evidence for the multicomponent bundle in hospitalized patients.",
       "page": "1",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "Preliminary evidence for the content of multicomponent interventions suggests that they should include as a minimum: sta education; individualised care (sometimes referred to as person-centred care); re-orientation at frequent intervals; and early mobilisation, but this needs further investigation. These areas are familiar aspects of care but are currently poorly and unreliably delivered.",
       "highlight": "re-orientation at frequent intervals; and early mobilisation",
       "scope": "on-scope",
       "note": "Describes the review's minimum bundle content (staff education, individualized care, re-orientation at frequent intervals, early mobilization) and the 'frequent intervals' cadence that underpins per-shift delivery.",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "On the basis of two RCTs (n = 2057 participants), there is moderate-quality evidence that BIS-guided anaesthesia reduces the incidence of delirium compared to BIS-blinded anaesthesia/ clinical judgement.",
       "highlight": "BIS-guided anaesthesia reduces the incidence of delirium",
       "scope": "different-intervention",
       "note": "Nearest keyword match ('reduces the incidence of delirium'), but BIS-guided anesthesia is an intraoperative anesthetic-depth technique, not the nonpharmacologic bundle - must not be read as support for the claim.",
       "page": "1",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "Three trials provide no clear evidence of an e ect of antipsychotic medications as a group on the incidence of delirium (RR 0.73, 95% CI, 0.33 to 1.59; 916 participants; very low-quality evidence).",
       "highlight": "no clear evidence of an e ect of antipsychotic medications as a group",
       "scope": "different-intervention",
       "note": "Pharmacologic prevention (antipsychotics) showed no clear effect; included to distinguish the effective nonpharmacologic bundle from drug prophylaxis that the claim does not cover.",
       "page": "1",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      }
     ]
    },
    {
     "label": "AGS 2015 (postoperative delirium guideline)",
     "cite": "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Primary anchor — AGS strong recommendation for the multicomponent nonpharmacologic bundle, but scoped specifically to at-risk older SURGICAL/postoperative adults (a narrower population than a general step-down census).",
     "docUrl": "https://doi.org/10.1111/jgs.13281",
     "paragraphs": [
      {
       "context": "Recommendation--Healthcare systems and hospitals should implement multicomponent nonpharmacologic intervention programs delivered by an interdisciplinary team (including physicians, nurses, and possibly other healthcare professionals) for the entire hospitalization in at-risk older adults undergoing surgery to prevent delirium (strength of recommendation: strong; quality of evidence: moderate).",
       "highlight": "for the entire hospitalization in at-risk older adults undergoing surgery to prevent delirium",
       "scope": "on-scope",
       "note": "The strong recommendation (moderate-quality evidence) to apply the multicomponent nonpharmacologic bundle to at-risk patients for the whole stay; note the population is at-risk older adults undergoing surgery, narrower than the general step-down population.",
       "page": "4",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "Multicomponent nonpharmacologic interventions delivered by an interdisciplinary team should be administered to at-risk older adults to prevent delirium.",
       "highlight": "should be administered to at-risk older adults to prevent delirium",
       "scope": "on-scope",
       "note": "Guideline summary box restates the recommendation — administer the bundle to at-risk older adults to prevent delirium.",
       "page": "15",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "A. Evidence for Recommendation: Nonpharmacologic interventions to prevent postoperative delirium may include the following elements: cognitive reorientation, sleep enhancement (i.e., nonpharmacologic sleep protocol and sleep hygiene), early mobility and/or physical rehabilitation, adaptations for visual and hearing impairment, nutrition and fluid repletion, pain management, appropriate medication usage, adequate oxygenation, and prevention of constipation. The managing team should perform daily rounds providing both general and specific recommendations. Adherence is an important consideration.",
       "highlight": "early mobility and/or physical rehabilitation, adaptations for visual and hearing impairment, nutrition and fluid repletion, pain management",
       "scope": "on-scope",
       "note": "Enumerates the bundle components; the same paragraph specifies daily rounds and adherence, supporting the every-shift cadence in the claim.",
       "page": "4",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "The guideline is limited to the aims described. Some of these recommendations will not apply to specific areas of care, such as intensive care unit (ICU) sedation, palliative care, and nursing home settings. Diagnosis and screening are not addressed in these guidelines. Other topics, such as prescription of melatonin to prevent delirium, were considered but not addressed due to a lack of evidence.9ET,10ET Since delirium is a burgeoning area of clinical investigation, regular updates of the recommendations are planned as new evidence becomes available.",
       "highlight": "will not apply to specific areas of care, such as intensive care unit (ICU) sedation, palliative care, and nursing home settings",
       "scope": "background",
       "note": "Explicitly scopes the guideline OUT of ICU sedation, palliative care and nursing homes — a step-down (non-ICU ward) sits within the general hospital setting the guideline addresses.",
       "page": "2",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      }
     ]
    },
    {
     "label": "Inouye 1999 (HELP)",
     "cite": "Inouye SK, et al. A multicomponent intervention to prevent delirium in hospitalized older patients. N Engl J Med 1999;340:669.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Seminal HELP/Elder Life Program controlled trial establishing the multicomponent risk-factor bundle; population is at-risk hospitalized older MEDICAL (general-medicine, non-ICU) patients, complementing AGS's surgical scope.",
     "docUrl": "https://doi.org/10.1056/NEJM199903043400901",
     "paragraphs": [
      {
       "context": "(i.e., the presence of predisposing conditions, such as cognitive impairment, severe illness, or visual impairment) and hospital-related insults (i.e., medications and procedures).1,24 The risk of delirium increases with the number of risk factors present.24,25 Therefore, a multicomponent approach targeted to the patient's risk factors is the most clinically relevant and potentially effective intervention for delirium.",
       "highlight": "a multicomponent approach targeted to the patient's risk factors is the most clinically relevant and potentially effective intervention for delirium",
       "scope": "on-scope",
       "note": "Rationale for a risk-factor-targeted multicomponent bundle — directly underpins applying it to at-risk patients.",
       "page": "670",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Results Delirium developed in 9.9 percent of the intervention group, as compared with 15.0 percent of the usual-care group (matched odds ratio, 0.60; 95 percent confidence interval, 0.39 to 0.92). The total number of days with delirium (105 vs. 161, P=0.02) and the total number of episodes (62 vs. 90, P=0.03) were significantly lower in the intervention group. However, the severity of delirium and recurrence rates were not significantly different. The overall rate of adherence to the intervention was 87 percent, and the total number of targeted risk factors per patient was significantly reduced. Intervention was associated with significant improvement in the degree of cognitive impairment among patients with cognitive impairment at admission and with a significant reduction in the rate of use of sleep medications among all patients. Among the other risk factors, there were trends toward improvement in immobility, visual impairment, and hearing impairment. Conclusions The risk-factor intervention strategy that we studied resulted in significant reductions in the number and duration of episodes of delirium in hospitalized older patients. The intervention had no significant effect on the severity of delirium or on recurrence rates; this finding suggests that primary prevention of delirium is probably the most effective treatment strategy. (N Engl J Med 1999;340:669-76.)",
       "highlight": "primary prevention of delirium is probably the most effective treatment strategy",
       "scope": "on-scope",
       "note": "Abstract conclusion — the bundle reduced number and duration of delirium and primary prevention is the most effective strategy, supporting proactive application to every at-risk patient.",
       "page": "669",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "This controlled clinical trial provides evidence that a multicomponent, targeted intervention strategy, the Elder Life Program, is effective for the prevention of delirium in hospitalized older medical patients. The intervention prevented the initial development of delirium and reduced the total number of days of delirium. It was most effective in patients who were at intermediate risk for delirium at base line. Once an initial episode of delirium had occurred, however, the intervention had no significant effect on the severity of delirium or on the likelihood of recurrence. This finding has an important implication for the treatment of delirium: primary prevention is probably the most effective strategy. Once delirium has occurred, our intervention strategy will be less effective and less efficient.",
       "highlight": "effective for the prevention of delirium in hospitalized older medical patients",
       "scope": "on-scope",
       "note": "Main conclusion; note the tested population is older MEDICAL patients (non-surgical, non-ICU), complementing AGS's surgical population.",
       "page": "674",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "outcome data, with no losses to follow-up; the targeting of at-risk patients for intervention, an approach that maximizes the efficiency and clinical relevance of the intervention; and the detailed tracking of adherence to the intervention protocols. Moreover, the practical, realistic nature of the intervention protocols, designed to target well-documented risk factors for delirium, enhances their feasibility and the extent to which they can be applied in other settings.",
       "highlight": "the targeting of at-risk patients for intervention",
       "scope": "on-scope",
       "note": "Supports targeting the bundle specifically to at-risk patients, as the claim directs.",
       "page": "674",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      },
      {
       "context": "Early-mobilization protocol: ambulation or active range-of-motion exercises three times daily; minimal use of immobilizing equipment (e.g., bladder catheters or physical restraints)",
       "highlight": "ambulation or active range-of-motion exercises three times daily",
       "scope": "on-scope",
       "note": "Protocols were delivered multiple times daily (e.g., three times daily), operationalizing the 'every shift' cadence in the claim.",
       "page": "671",
       "docUrl": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    }
   ],
   "synthesis": "All three sources agree that a multicomponent, risk-factor–targeted nonpharmacologic bundle reduces incident delirium in at-risk hospitalized non-ICU patients: the Cochrane 2016 review (RR 0.69, effect similar in medical and surgical settings) is the most directly on-scope source and governs the general step-down setting, underpinned by the Inouye 1999 HELP RCT (older medical patients) and the AGS 2015 strong recommendation (at-risk older surgical patients). Two caveats warrant flagging: the claim's \"every shift\" cadence is an operational specification — the sources specify daily rounds, three-times-daily protocols, \"the entire hospitalization,\" and \"re-orientation at frequent intervals\" rather than literally every shift — and Cochrane's pharmacologic/anesthetic prevention findings (antipsychotics with no clear effect; BIS-guided anesthesia positive) are different interventions that share the \"prevent delirium\" keyword but must not be read as support for the nonpharmacologic bundle.",
   "discrepancy": true
  },
  {
   "id": "sd-wf-r11",
   "toolId": "sd-wf",
   "tool": "Step-Down Workflow",
   "page": "1",
   "section": "5 · Act on the result",
   "statement": "Negative → document it; normal arousal does not exclude delirium — rescreen with any change.",
   "contentType": "Cited clinical content",
   "sources": [
    "Beyer 2024 (CAM-IMC)",
    "NICE CG103"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 5",
   "passage": "The features disorientation and inattention can each trigger a positive test result.\nSupported clinically. Because disorientation or inattention can be positive independent of arousal (Beyer 2024, p. 5), a normal RASS does not exclude delirium. 'Document it / rescreen with any change' is standard documentation practice cited to NICE CG103 (not archived).",
   "evidence": "Full text, p. 5 — partial support",
   "status": "fulltext",
   "pageNum": "5",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451.",
    "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023)."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3",
    "https://www.nice.org.uk/guidance/cg103"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "cite": "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Validation of the CAM-IMC in non-intubated post-cardiac-surgery patients on an intermediate/step-down unit — the on-scope setting for a step-down workflow; directly supports that normal arousal does not exclude delirium.",
     "docUrl": "https://doi.org/10.1186/s12871-024-02849-3",
     "paragraphs": [
      {
       "context": "By creating the CAM-IMC flowchart design as a pointbased scoring system, the importance of disorientation as a central feature of POD has been reinforced. The features disorientation and inattention can each trigger a positive test result. The system assigns up to five points for disorientation and three points for inattention, thereby increasing the weight of these single features in the overall diagnosis. The categories of acute or fluctuating change and RASS0 have been reduced in significance and each contribute one point to the total score but are not mandatory for a positive test outcome. This is reflected in their limited ability to discriminate POD, as shown by a distinct lower AUROC compared to disorientation, inattention and overall CAM-IMC. As a result, disorientation and inattention exert the greatest influence Beyer et al.",
       "highlight": "but are not mandatory for a positive test outcome",
       "scope": "on-scope",
       "note": "In the CAM-IMC point-based scoring the altered-arousal item (RASS0 / level of consciousness) is not required for a positive result, so a fully alert patient can still screen positive via disorientation or inattention — normal arousal does not exclude delirium.",
       "page": "5",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "AUROC of inattention is 0.91 (CI 95%: 0.86–0.96), acute change or fluctuation is 0.82 (CI 95%: 0.77–0.87) and altered level of consciousness is 0.62 (CI 95%: 0.56–0.69). A comparison between the ROC of the CAM-IMC and the individual items included in the CAM-IMC is depicted in Fig. 3 . The test performance values and AUROC of each individual item are depicted in Table 3 .",
       "highlight": "altered level of consciousness is 0.62",
       "scope": "narrower",
       "note": "Altered level of consciousness was the weakest-discriminating CAM-IMC item (AUROC 0.62), reinforcing that arousal status alone should not be used to rule delirium in or out.",
       "page": "4",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "Risk factors include non-modifiable conditions including advanced age, impaired pre-existing cognition, significant comorbidities, and potentially modifiable (precipitating) factors such as deep sedation, untreated trauma, pharmacological interactions, and new-onset infections [ 13 , 14 ]. Particularly the latter require urgent treatment and make quick diagnosis of POD mandatory. Early recognition of POD features is key to delirium management, as there are several modifiable risk factors, such as new-onset infections, pain, inappropriate drug use and pharmacological interactions [ 13 , 14 ]. Since the predominant manifestation is hypoactive delirium, exhibiting no or reduced motor activity, it often goes undiagnosed [ 15 – 18 ].",
       "highlight": "the predominant manifestation is hypoactive delirium, exhibiting no or reduced motor activity, it often goes undiagnosed",
       "scope": "broader",
       "note": "Background on why delirium is easily missed — hypoactive presentations with little motor activity go undiagnosed — adjacent to the claim but framed around motor activity rather than arousal per se.",
       "page": "2",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      }
     ]
    },
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Hospital/long-term-care guideline (broader population than step-down but inclusive of it); governs the 'document it' and 'rescreen with any change' components via its daily-observation, assess-on-change and record-in-notes recommendations.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "Observe, at least daily, all people in hospital or long-term care for recent (within hours or days) changes or fluctuations indicating delirium (for example, see recommendation 1.3.1).",
       "highlight": "Observe, at least daily, all people in hospital or long-term care for recent (within",
       "scope": "on-scope",
       "note": "Core support for rescreening on change: observe at least daily for changes or fluctuations and, if present, reassess with an appropriate tool.",
       "page": "9",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Observe people at every opportunity for any changes in the risk factors for delirium.",
       "highlight": "Observe people at every opportunity for any changes in the risk factors for delirium",
       "scope": "on-scope",
       "note": "Supports continuous re-evaluation — observe at every opportunity for change — consistent with 'rescreen with any change'.",
       "page": "6",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "At presentation, assess people at risk for recent (within hours or days) changes or fluctuations that may indicate delirium.",
       "highlight": "At presentation, assess people at risk for recent (within hours or days) changes",
       "scope": "on-scope",
       "note": "Any recent change or fluctuation triggers a formal assessment — the trigger-on-change principle behind rescreening.",
       "page": "6",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Ensure that any changes that may indicate delirium are documented in the person's record or notes. [2023]",
       "highlight": "documented in the person's record or notes",
       "scope": "on-scope",
       "note": "Supports the 'document it' step — record delirium-relevant findings in the notes; NICE frames this around documenting changes/indicators, which the tool extends to recording the screen result itself.",
       "page": "9",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Be particularly vigilant for changes that may indicate hypoactive delirium, which are often missed, such as withdrawal, slow responses, reduced mobility and movement, worsened concentration and reduced appetite.",
       "highlight": "changes that may indicate hypoactive delirium, which are often missed",
       "scope": "broader",
       "note": "Nearest NICE match to the arousal warning, but about hypoactive delirium (reduced arousal/withdrawal) rather than normal arousal — a different, broader concept that must not be read as direct support for 'normal arousal does not exclude delirium'.",
       "page": "6",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "A person may already have delirium when they present to hospital or long-term care or it may develop during a hospital admission or residential stay in long-term care. Delirium can be hypoactive or hyperactive but some people show signs of both (mixed). People with hyperactive delirium have heightened arousal and can be restless, agitated and aggressive. People with hypoactive delirium become withdrawn, quiet and sleepy. Hypoactive and mixed delirium can be more difficult to recognise.",
       "highlight": "Hypoactive and mixed delirium can be more difficult to recognise",
       "scope": "background",
       "note": "Definitional background — hypoactive/mixed delirium is harder to recognize — contextualizing why an unremarkable or negative screen must not be treated as ruling delirium out.",
       "page": "21",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    }
   ],
   "synthesis": "The two sources are complementary rather than conflicting: Beyer 2024 — validated in the intermediate/step-down care setting the tool targets — is the on-scope source for \"normal arousal does not exclude delirium,\" because the CAM-IMC's point-based scoring makes the altered-arousal item non-mandatory so a fully alert (RASS 0) patient can still screen positive, while NICE CG103 governs \"document it\" and \"rescreen with any change\" through its daily-observation, assess-on-change and record-in-notes recommendations (for the broader hospital/long-term-care population). The nearest NICE match to the arousal point is its hypoactive-delirium vigilance guidance, which concerns reduced — not normal — arousal and should not be read as direct support for that clause.",
   "discrepancy": true
  },
  {
   "id": "sd-wf-r12",
   "toolId": "sd-wf",
   "tool": "Step-Down Workflow",
   "page": "1",
   "section": "5 · Act on the result",
   "statement": "Positive → find the cause (review meds first), manage without new harm, and hand the finding off.",
   "contentType": "Cited clinical content",
   "sources": [
    "Lisibach 2022 (anticholinergic burden)",
    "AGS 2015 (postoperative delirium guideline)",
    "Siddiqi 2016 (Cochrane)",
    "NICE CG103"
   ],
   "anchor": "Lisibach 2022 (anticholinergic burden) — p. 1",
   "passage": "A high anticholinergic burden within 24 hours after admission was significantly associated with incident delirium. Although prospective studies need to confirm these results, discontinuing or substituting drugs with a score of ≥3 at admission might be a targeted intervention to reduce incident delirium.\nAlso Siddiqi 2016 (Cochrane) (p. 7): “We found multi-component interventions reduced the incidence of delirium compared to usual care (RR 0.69, 95% CI 0.59 to 0.81; seven studies; 1950 participants; moderate-quality evidence).”\nSupported. Review deliriogenic / anticholinergic medications (Lisibach 2022, p. 1; AGS 2015, p. 8); manage with the multicomponent bundle rather than antipsychotics (Siddiqi 2016, p. 7); hand off per NICE CG103 (not archived). A compressed restatement of the Act-on-a-positive card.",
   "evidence": "Full text, p. 1",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "Lisibach A, et al. Quantifying anticholinergic burden and its association with delirium (comparison of 19 scales). Br J Clin Pharmacol 2022;88:4915.",
    "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142.",
    "Siddiqi N, et al. Interventions for preventing delirium in hospitalised non-ICU patients. Cochrane Database Syst Rev 2016;CD005563.",
    "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023)."
   ],
   "links": [
    "https://doi.org/10.1111/bcp.15432",
    "https://doi.org/10.1111/jgs.13281",
    "https://doi.org/10.1002/14651858.CD005563.pub3",
    "https://www.nice.org.uk/guidance/cg103"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "NICE CG103",
     "cite": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Governing on-scope source: covers all three claim elements (find/manage the cause, review meds, manage without new harm, and document/hand off) for hospital and long-term care, including critical care.",
     "docUrl": "https://www.nice.org.uk/guidance/cg103",
     "paragraphs": [
      {
       "context": "In people diagnosed with delirium, identify and manage the possible underlying cause or combination of causes.",
       "highlight": "identify and manage the possible underlying",
       "scope": "on-scope",
       "note": "Recommendation 1.7.1 is the exact 'find the cause' step after a positive diagnosis — identify and manage the underlying cause or combination of causes.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Carry out a medication review for people taking multiple drugs, taking into account both the type and number of medications. For information on medicines optimisation see the NICE guideline on medicines optimisation. [2010]",
       "highlight": "Carry out a medication review for people taking multiple drugs, taking into account both the type and number of medications",
       "scope": "on-scope",
       "note": "Direct support for 'review meds first'; NICE lists medication review among its measures for people taking multiple drugs (recommendation 1.4.10).",
       "page": "9",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "others, first use verbal and non-verbal techniques to de-escalate the situation.",
       "highlight": "first use verbal and non-verbal techniques to de-escalate the situation",
       "scope": "on-scope",
       "note": "Recommendation 1.7.3 — non-pharmacological de-escalation first for a distressed patient, the 'manage without new harm' approach.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "inappropriate, consider giving short-term haloperidol (usually for 1 week or less).",
       "highlight": "consider giving short-term haloperidol (usually for 1 week or less)",
       "scope": "on-scope",
       "note": "Recommendation 1.7.4 — only if de-escalation fails, cautious short-term low-dose haloperidol with MHRA risk caveats: the drug-use guardrail against new harm.",
       "page": "11",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      },
      {
       "context": "Ensure that the diagnosis of delirium is documented both in the person's record or notes, and in their primary care health record.",
       "highlight": "the diagnosis of delirium is documented both in the person's record",
       "scope": "on-scope",
       "note": "Recommendation 1.6.4 supports 'hand the finding off' — document the diagnosis in the person's notes and their primary care health record.",
       "page": "10",
       "docUrl": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    },
    {
     "label": "AGS 2015 (postoperative delirium guideline)",
     "cite": "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142.",
     "kind": "pdf",
     "stance": "agrees",
     "note": "Strongly supports the identify-and-manage-cause, review/avoid-harmful-medication, and avoid-harmful-sedation/restraint elements; population is postoperative older surgical adults and it does not address the hand-off.",
     "docUrl": "https://doi.org/10.1111/jgs.13281",
     "paragraphs": [
      {
       "context": "Recommendation--The healthcare professional should perform a medical evaluation, make medication and/or environmental adjustments, and order appropriate diagnostic tests and clinical consultations after an older adult has been diagnosed with postoperative delirium to identify and manage underlying contributors to delirium (strength of recommendation: strong; quality of evidence: low).",
       "highlight": "make medication and/or environmental adjustments, and order appropriate diagnostic tests and clinical consultations",
       "scope": "on-scope",
       "note": "Recommendation IV 'Identify and Manage Causes of Delirium' is the exact find-the-cause / adjust-medications workflow after diagnosis; population is postoperative older adults.",
       "page": "6",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "The healthcare professional should perform a medical evaluation, make medication and/or environmental adjustments, and order appropriate diagnostic tests and clinical consultations after an older adult has been diagnosed with postoperative delirium to identify and manage underlying contributors to delirium",
       "highlight": "identify and manage underlying contributors to delirium",
       "scope": "on-scope",
       "note": "Section IV recommendation: on a positive finding, evaluate, adjust medications/environment, and order tests/consultations to find and manage the cause.",
       "page": "18",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "A. Evidence for Recommendation: Relevant medications or medication classes include benzodiazepines, anticholinergics (e.g., cyclobenzaprine, oxybutynin, prochlorperazine, promethazine, tricyclic antidepressants, paroxetine and drugs with high anticholinergic properties), diphenhydramine, hydroxyzine, histamine2-receptor antagonists (e.g., cimetidine), sedative-hypnotics, and meperidine. Since the studies regarding specific medications provide generally low-level evidence, the current recommendation relied on the 2012 AGS Beers Criteria.11 Current evidence most strongly associates use of anticholinergic drugs, meperidine and benzodiazepines with increased postoperative delirium. Studies have identified the following medications with increased delirium: diphenhydramine,63ET meperidine,2ET midazolam,64ET and anticholinergic medications.65ET Drugs that contribute to serotonin syndrome can increase delirium risk, as can the use of multiple medications (five or greater).",
       "highlight": "Current evidence most strongly associates use of anticholinergic drugs, meperidine and benzodiazepines with increased postoperative delirium",
       "scope": "on-scope",
       "note": "Names the drug classes to target when reviewing meds (anticholinergics, meperidine, benzodiazepines) — supports 'review meds first'; postoperative population.",
       "page": "9",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "Recommendation--The prescribing practitioner should not prescribe antipsychotic or benzodiazepine medications for the treatment of older adults with postoperative delirium who are not agitated and threatening substantial harm to self or others (strength of recommendation: strong; quality of evidence: low).",
       "highlight": "should not prescribe antipsychotic or benzodiazepine medications for the treatment of older adults with postoperative delirium who are not agitated",
       "scope": "on-scope",
       "note": "Recommendation XIV supports 'manage without new harm' — do not reach for antipsychotics/benzodiazepines in non-agitated delirium.",
       "page": "11",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      },
      {
       "context": "B. Potential Harms of Recommendation: This recommendation balances the risks of delay in treatment for underlying cause(s) of delirium with the risks and costs of diagnostic tests and procedures, as well as the possibility of pain and infection. Overuse of neuroimaging (computed tomography (CT)/magnet resonance imaging (MRI)) is an additional potential risk. For agitated patients, sedation and/or restraints may be required to obtain these studies; however, both sedating medications and restraints may exacerbate delirium. The AGS recommends avoiding physical restraints to manage behavioral symptoms of hospitalized older adults with delirium.46 See complete harms statement in the AGS Delirium Guideline at .",
       "highlight": "both sedating medications and restraints may exacerbate delirium",
       "scope": "on-scope",
       "note": "Harms statement for Recommendation IV — sedating drugs and restraints can worsen delirium; the 'without new harm' guardrail.",
       "page": "7",
       "docUrl": "https://doi.org/10.1111/jgs.13281"
      }
     ]
    },
    {
     "label": "Lisibach 2022 (anticholinergic burden)",
     "cite": "Lisibach A, et al. Quantifying anticholinergic burden and its association with delirium (comparison of 19 scales). Br J Clin Pharmacol 2022;88:4915.",
     "kind": "pdf",
     "stance": "partial",
     "note": "Substantiates the 'review meds first' element specifically for anticholinergic burden in non-ICU older inpatients; frames deprescribing as reducing incident delirium and does not address the other claim elements.",
     "docUrl": "https://doi.org/10.1111/bcp.15432",
     "paragraphs": [
      {
       "context": "Although prospective studies need to confirm these results, discontinuing or substituting drugs with a score of 3 at admission might be a targeted intervention to reduce incident delirium.",
       "highlight": "discontinuing or substituting drugs with a score of 3 at admission might be a targeted intervention to reduce incident delirium",
       "scope": "on-scope",
       "note": "Supports 'review meds first' — discontinuing/substituting high-anticholinergic drugs is a targeted intervention to reduce delirium; population is non-ICU older inpatients (ICU stays >24h excluded).",
       "page": "4915",
       "docUrl": "https://doi.org/10.1111/bcp.15432"
      },
      {
       "context": "A cumulative ACH burden score of three points or more can be considered a high burden, which was statistically significantly and independently associated with the development of delirium during hospitalisation. The ABSs are convenient clinical tools to measure the ACH burden in hospitalised patients. Newer high‐quality ABSs built from previously published scales seem to perform better. However, cut‐off values might differ depending on the scale and outcome studied. Discontinuing or substituting drugs with an ACH score of three points or more upon admission might be a targeted intervention to reduce the risk of delirium development. However, it should be noted that delirium is a multifactorial syndrome, and that drugs are only one factor to be considered in delirium prevention. Further studies should be conducted in order to prospectively verify whether discontinuing drugs with ACH properties might reduce delirium occurrences.",
       "highlight": "drugs are only one factor to be considered in delirium prevention",
       "scope": "on-scope",
       "note": "Reinforces reviewing meds while cautioning that delirium is multifactorial and drugs are only one contributor — supports 'find the cause' without overclaiming meds as the sole cause.",
       "page": "4925",
       "docUrl": "https://doi.org/10.1111/bcp.15432"
      },
      {
       "context": "A cumulative anticholinergic burden score of 3 points within the first 24 hours of admission is associated with delirium development during hospitalisation.",
       "highlight": "A cumulative anticholinergic burden score of 3 points within the first 24 hours of admission is associated with delirium development during hospitalisation",
       "scope": "narrower",
       "note": "The specific anticholinergic-burden-to-delirium association underpinning the review-meds action; narrower than the general 'review meds first' step.",
       "page": "4916",
       "docUrl": "https://doi.org/10.1111/bcp.15432"
      }
     ]
    },
    {
     "label": "Siddiqi 2016 (Cochrane)",
     "cite": "Siddiqi N, et al. Interventions for preventing delirium in hospitalised non-ICU patients. Cochrane Database Syst Rev 2016;CD005563.",
     "kind": "pdf",
     "stance": "background",
     "note": "Nearest match on multi-component and medication approaches but scoped to PREVENTION of delirium in hospitalized non-ICU patients, not acting on a positive screen — a different-intervention scope that does not govern this claim.",
     "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3",
     "paragraphs": [
      {
       "context": "There is strong evidence supporting multi-component interventions to prevent delirium in hospitalised patients. There is no clear evidence that cholinesterase inhibitors, antipsychotic medication or melatonin reduce the incidence of delirium. Using the Bispectral Index to monitor and control depth of anaesthesia reduces the incidence of postoperative delirium. The role of drugs and other anaesthetic techniques to prevent delirium remains uncertain.",
       "highlight": "There is no clear evidence that cholinesterase inhibitors, antipsychotic medication or melatonin reduce the incidence of delirium",
       "scope": "different-intervention",
       "note": "Authors' conclusion is about PREVENTING delirium before onset, not the post-positive management workflow — shares keywords (medications, multi-component) but a different intervention target.",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "There is moderate-quality evidence to indicate that multi-component interventions reduce the incidence of delirium. The evidence supports implementing multi-component delirium prevention interventions into routine care for patients in hospital.",
       "highlight": "implementing multi-component delirium prevention interventions into routine care for patients in hospital",
       "scope": "different-intervention",
       "note": "Recommends multi-component PREVENTION into routine care, not acting on an established positive screen.",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      },
      {
       "context": "There are many risk factors for developing delirium (e.g. infection, dehydration, certain medications). Therefore, one approach (called `multi-component interventions') to preventing delirium is to target these multiple risk factors. Some medications have e ects on the brain chemicals implicated in developing delirium, and may, therefore, have a role in prevention. There are also a number of other interventions that target delirium risk factors related to anaesthesia and medical treatment around the time of surgery.",
       "highlight": "many risk factors for developing delirium (e.g. infection, dehydration, certain medications)",
       "scope": "background",
       "note": "Background that medications are among delirium risk factors — supports the rationale for reviewing meds, but framed for prevention.",
       "page": "",
       "docUrl": "https://doi.org/10.1002/14651858.CD005563.pub3"
      }
     ]
    }
   ],
   "synthesis": "The on-scope guidance agrees on the workflow. NICE CG103 governs this \"act on a positive\" step: identify and manage the underlying cause(s) (including medication review), de-escalate non-pharmacologically first with only cautious short-term haloperidol if needed, and document the diagnosis in the person's notes and primary-care record (the hand-off). AGS 2015 concurs on identifying/managing the cause and avoiding harmful sedatives, restraints and non-indicated antipsychotics/benzodiazepines, though its population is postoperative older adults; Lisibach 2022 supports \"review meds first\" specifically for anticholinergic burden in non-ICU older inpatients (narrower). Siddiqi 2016 is the nearest match on multi-component/medication approaches but addresses prevention rather than acting on a positive screen — a different-intervention scope, so it does not govern this claim.",
   "discrepancy": true
  },
  {
   "id": "sd-wf-r13",
   "toolId": "sd-wf",
   "tool": "Step-Down Workflow",
   "page": "1",
   "section": "Loop — unable to assess",
   "statement": "RASS −4/−5 — stupor or coma. Record it, and reassess when the patient responds to voice.",
   "contentType": "Cited clinical content",
   "sources": [
    "Beyer 2024 (CAM-IMC)",
    "Sessler 2002 (RASS)"
   ],
   "anchor": "Beyer 2024 (CAM-IMC) — p. 1",
   "passage": "for diagnosing POD in intubated patients cannot make use of the feature ‘disorientation’, as this requires verbal communication. Other tools such as the 4AT test for disorientation but are not established in ICU settings.\nSame content as the arousal-gate stop (indirect / standard RASS practice) — see stage 2.",
   "evidence": "Full text, p. 1 — partial support",
   "status": "fulltext",
   "pageNum": "1",
   "citations": [
    "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451.",
    "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338."
   ],
   "links": [
    "https://doi.org/10.1186/s12871-024-02849-3",
    "https://pubmed.ncbi.nlm.nih.gov/12421743/"
   ],
   "decision": "",
   "notes": "",
   "perSource": [
    {
     "label": "Beyer 2024 (CAM-IMC)",
     "cite": "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451.",
     "kind": "pdf",
     "stance": "background",
     "note": "CAM-IMC validation in non-intubated cardiac-surgery step-down patients; corroborates that the setting uses RASS/level-of-consciousness and defines RASS -5 as deeply sedated, but never states the RASS -4/-5 unable-to-assess record-and-reassess-on-voice gate.",
     "docUrl": "https://doi.org/10.1186/s12871-024-02849-3",
     "paragraphs": [
      {
       "context": "RASS ranges from -5 (deeply sedated) to +4 (aggressive)",
       "highlight": "-5 (deeply sedated)",
       "scope": "background",
       "note": "Table 1 footnote defining the RASS scale endpoints (RASS -5 = deeply sedated, the stupor/coma end); corroborates the definitional half of the claim but not the record-and-reassess gating action.",
       "page": "Table 1",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "Background Disorientation is an early indicator of developing postoperative delirium (POD), which is associated with increased mortality and cognitive decline. The well-established \"Confusion-Assessment-Method-for-IntensiveCare-Unit\" (CAM-ICU) for diagnosing POD in intubated patients cannot make use of the feature `disorientation', as this requires verbal communication. Other tools such as the 4AT test for disorientation but are not established in ICU settings. We therefore combined test-variables of the CAM-ICU (level of consciousness, fluctuating mental status and inattention) with verbal testing for disorientation to develop and enhance diagnostic accuracy of the \"Confusion Assessment Method for Intermediate Care Unit\" (CAM-IMC). In the present study we describe the development and the evaluation of the diagnostic accuracy of the CAM-IMC.",
       "highlight": "level of consciousness, fluctuating mental status and inattention",
       "scope": "background",
       "note": "Establishes that the step-down CAM-IMC tool incorporates the CAM-ICU level-of-consciousness/RASS variable and requires verbal communication, setting the scene for an arousal gate but not stating the RASS -4/-5 defer rule.",
       "page": "1",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "Among 178 scheduled cardiac surgery patients, 155 proved eligible between November 2021 and February 2022, 23 of which were excluded. In these, 624 paired examinations were completed on the first three postoperative days (see flowchart in Fig. 2 ). Aggressive patients could not be accurately examined due to lack of cooperation and no plausible disorientation assessment.",
       "highlight": "Aggressive patients could not be accurately examined",
       "scope": "different-population",
       "note": "An unable-to-assess scenario at the opposite, agitated (RASS-positive) end of the arousal spectrum from the claim's RASS -4/-5 stupor/coma; shares the unable-to-examine keyword but must not be read as supporting the coma/sedation defer rule.",
       "page": "4",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      },
      {
       "context": "This cohort study evaluates the test performance of the newly developed CAM-IMC and its disorientation component in a prospective cohort study. The CAM-IMC shows a sensitivity of 0.96 and specificity of 0.94 in diagnosis of POD in non-intubated postoperative cardiac surgery patients. Its test performance is comparable to the widely used CAM-ICU demonstrating a high level of accuracy [ 19 ]. While testing for disorientation alone shows good test performance values, it does not surpass the CAM-IMC. The study indicates that using the CAM-IMC by combing the features of the CAM-ICU with assessing of disorientation as a verbal testing variable, improves effectiveness and provides excellent sensitivity and specificity for diagnosing POD. These findings highlight the importance of incorporating verbal testing for disorientation whenever patients are accessible to oral evaluation to improve POD diagnostics. The CAM-IMC outperforms each individual feature of the CAM-IMC.",
       "highlight": "whenever patients are accessible to oral evaluation",
       "scope": "narrower",
       "note": "Conditions verbal disorientation testing on the patient being accessible to oral evaluation - conceptually adjacent to the unable-to-assess gate but framed around verbal-test accessibility, not the RASS -4/-5 record-and-reassess-when-responds-to-voice rule.",
       "page": "5",
       "docUrl": "https://doi.org/10.1186/s12871-024-02849-3"
      }
     ]
    },
    {
     "label": "Sessler 2002 (RASS)",
     "cite": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
     "kind": "web",
     "stance": "background",
     "note": "The RASS validation reference; contributes the scale's arousal anchor points that govern the gate - RASS -4 (no response to voice, movement to physical stimulation) and RASS -5 (unarousable, no response to voice or physical stimulation) - and the 'responds to voice' threshold for resuming assessment. Cited by the 'Loop - unable to assess' section; per-instruction web source, so no paragraph extraction.",
     "docUrl": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
     "paragraphs": []
    }
   ],
   "synthesis": "Neither cited source states the claim's gating rule verbatim: the direct authority for the RASS -4/-5 arousal threshold (stupor/coma, unarousable) and the \"responds to voice\" cue for resuming assessment is Sessler 2002 (RASS), the web source, which governs here. Beyer 2024 (the CAM-IMC step-down validation named as primary anchor) only corroborates that the setting uses RASS/level-of-consciousness and defines RASS -5 as deeply sedated; its keyword-adjacent passages - aggressive patients who could not be examined, and verbal testing only when patients are accessible to oral evaluation - are different-scope and must not be read as direct support.",
   "discrepancy": true
  },
  {
   "id": "sd-wf-r14",
   "toolId": "sd-wf",
   "tool": "Step-Down Workflow",
   "page": "1",
   "section": "Hand-off script (four items)",
   "statement": "On transfer / hand-off of a positive screen: (1) screen used and result (CAM-IMC score / band); (2) suspected cause(s) and what was ruled out; (3) interventions started (bundle, medication changes); (4) reassessment / follow-up plan for the receiving team.",
   "contentType": "Care-transition structure",
   "sources": [
    "NICE CG103"
   ],
   "anchor": "An SBAR-style hand-off structure. The four items operationalize a delirium care-transition communication (cited to NICE CG103, a live web guideline not held in the local archive, so no passage is quoted). Not drawn verbatim from any archived source; it is an operational template consistent with structured hand-off practice.",
   "passage": "",
   "evidence": "Operational structure (cited NICE CG103) — not in local archive",
   "status": "structure",
   "pageNum": null,
   "citations": [
    "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023)."
   ],
   "links": [
    "https://www.nice.org.uk/guidance/cg103"
   ],
   "decision": "",
   "notes": "Operational SBAR-style structure — verify against NICE CG103 / local hand-off policy."
  }
 ],
 "references": [
  {
   "tool": "Adult ICU",
   "source": "ACB Scale",
   "citation": "Boustani M, Campbell N, Munger S, Maidment I, Fox C. Impact of anticholinergics on the aging brain: a review and practical application (Anticholinergic Cognitive Burden scale). Aging Health. 2008;4(3):311-320.",
   "link": "https://doi.org/10.2217/1745509X.4.3.311",
   "archived": false,
   "statements": 2,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Deliriogenic medications",
    "SPA Quick Reference — Deliriogenic medications"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Beers 2023",
   "citation": "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081.",
   "link": "https://pubmed.ncbi.nlm.nih.gov/37139824/",
   "archived": true,
   "statements": 3,
   "check": "Confirmed — the citation shortens the article title; authors, journal, year, volume, and pages match the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Deliriogenic medications",
    "SPA Quick Reference — Deliriogenic medications",
    "SPA Quick Reference — S·P·A action cards — Pain / Pharmacy"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "CAM-ICU Worksheet",
   "citation": "Ely EW; Vanderbilt University. CAM-ICU Worksheet. ICUDelirium.org.",
   "link": "https://www.icudelirium.org/resource-downloads/cam-icu-worksheet",
   "archived": true,
   "statements": 1,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Status strip — CAM-ICU result"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "DELIRIUM(S)",
   "citation": "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis. ICUDelirium.org.",
   "link": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics",
   "archived": false,
   "statements": 1,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — DELIRIUM(S) causative factors"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Dexmedetomidine PI",
   "citation": "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM.",
   "link": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74",
   "archived": false,
   "statements": 1,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Pharmacologic considerations"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Early Mobility",
   "citation": "Vanderbilt CIBS Center. Early Mobility and Exercise. ICUDelirium.org.",
   "link": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise",
   "archived": false,
   "statements": 4,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "SPA Quick Reference — Deeper guidance — A — Activity / Awareness",
    "SPA Quick Reference — Deeper guidance — P — Pain / Pharmacy",
    "SPA Quick Reference — Deeper guidance — S — Sedation",
    "SPA Quick Reference — S·P·A action cards — Activity / Awareness"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Ely 2001",
   "citation": "Ely EW, Inouye SK, Bernard GR, et al. Delirium in mechanically ventilated patients: validity and reliability of the CAM-ICU. JAMA. 2001;286(21):2703-2710.",
   "link": "https://doi.org/10.1001/jama.286.21.2703",
   "archived": true,
   "statements": 1,
   "check": "Confirmed — the citation shortens the article title; authors, journal, year, volume, and pages match the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Status strip — CAM-ICU result"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Ely 2003",
   "citation": "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991.",
   "link": "https://doi.org/10.1001/jama.289.22.2983",
   "archived": true,
   "statements": 2,
   "check": "Confirmed — the citation shortens the article title; authors, journal, year, volume, and pages match the indexed record.",
   "usedIn": [
    "SPA Quick Reference — RASS scale",
    "SPA Quick Reference — RASS sedation target"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Flaherty 2011",
   "citation": "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577.",
   "link": "https://pubmed.ncbi.nlm.nih.gov/21549878/",
   "archived": false,
   "statements": 1,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — DELIRIUM(S) causative factors"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Haloperidol PI",
   "citation": "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM.",
   "link": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f",
   "archived": true,
   "statements": 4,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Pharmacologic considerations",
    "SPA Quick Reference — Deeper guidance — A — Activity / Awareness",
    "SPA Quick Reference — Deeper guidance — P — Pain / Pharmacy",
    "SPA Quick Reference — Deeper guidance — S — Sedation"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Hayhurst 2020",
   "citation": "Hayhurst CJ, Patel MB, McNeil JB, et al. Association of hypoactive and hyperactive delirium with cognitive function after critical illness. Crit Care Med. 2020;48(6):e480-e488.",
   "link": "https://doi.org/10.1097/CCM.0000000000004313",
   "archived": true,
   "statements": 1,
   "check": "Real publication, but the cited author list is wrong — Patel is the fourth author and McNeil is not an author. Correct: Hayhurst CJ, Marra A, Han JH, et al. Association of hypoactive and hyperactive delirium with cognitive function after critical illness. Crit Care Med. 2020;48(6):e480-e488.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Status strip — Motor subtype"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Hodgson 2014",
   "citation": "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658.",
   "link": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y",
   "archived": true,
   "statements": 4,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "SPA Quick Reference — Deeper guidance — A — Activity / Awareness",
    "SPA Quick Reference — Deeper guidance — P — Pain / Pharmacy",
    "SPA Quick Reference — Deeper guidance — S — Sedation",
    "SPA Quick Reference — S·P·A action cards — Activity / Awareness"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Hshieh 2015",
   "citation": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520.",
   "link": "https://doi.org/10.1001/jamainternmed.2014.7779",
   "archived": true,
   "statements": 7,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Non-pharm bundle — Engagement",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Hydration & Nutrition",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Mobility",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Reorientation",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Sensory",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Sleep",
    "SPA Quick Reference — S·P·A action cards — Activity / Awareness"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Inouye 1999",
   "citation": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676.",
   "link": "https://doi.org/10.1056/NEJM199903043400901",
   "archived": true,
   "statements": 7,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Non-pharm bundle — Engagement",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Hydration & Nutrition",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Mobility",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Reorientation",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Sensory",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Sleep",
    "SPA Quick Reference — S·P·A action cards — Activity / Awareness"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Krewulak 2018",
   "citation": "Krewulak KD, Stelfox HT, Leigh JP, Ely EW, Fiest KM. Incidence and prevalence of delirium subtypes in an adult ICU: a systematic review and meta-analysis. Crit Care Med. 2018;46(12):2029-2035.",
   "link": "https://doi.org/10.1097/CCM.0000000000003402",
   "archived": false,
   "statements": 1,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Status strip — Motor subtype"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "la Cour 2022",
   "citation": "la Cour KN, Andersen-Ranberg NC, Weihe S, et al. Distribution of delirium motor subtypes in the ICU: a systematic scoping review. Crit Care. 2022;26:53.",
   "link": "https://doi.org/10.1186/s13054-022-03931-3",
   "archived": true,
   "statements": 1,
   "check": "Confirmed — the citation shortens the article title; authors, journal, year, volume, and pages match the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Status strip — Motor subtype"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Maldonado 2018",
   "citation": "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457.",
   "link": "https://doi.org/10.1002/gps.4823",
   "archived": false,
   "statements": 1,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — DELIRIUM(S) causative factors"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Marra 2017",
   "citation": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243.",
   "link": "https://doi.org/10.1016/j.ccc.2016.12.005",
   "archived": true,
   "statements": 6,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Non-pharm bundle — Engagement",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Hydration & Nutrition",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Mobility",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Reorientation",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Sensory",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Sleep"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Melatonin ICU meta-analysis 2025",
   "citation": "Tang BHY, Manalo J, Chowdhury SR, et al. Melatonin use in the ICU: a systematic review and meta-analysis. Crit Care Med. 2025;53(9):e1714-e1724. (32 RCTs, n=3895; may reduce delirium RR 0.72 and improve sleep — low certainty; slight reduction in adverse events.)",
   "link": "https://doi.org/10.1097/CCM.0000000000006767",
   "archived": false,
   "statements": 1,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "SPA Quick Reference — S·P·A action cards — Pain / Pharmacy"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "MENDS2 2021",
   "citation": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436.",
   "link": "https://doi.org/10.1056/NEJMoa2024922",
   "archived": true,
   "statements": 5,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Pharmacologic considerations",
    "SPA Quick Reference — Deeper guidance — A — Activity / Awareness",
    "SPA Quick Reference — Deeper guidance — P — Pain / Pharmacy",
    "SPA Quick Reference — Deeper guidance — S — Sedation",
    "SPA Quick Reference — S·P·A action cards — Sedation"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "MIND-USA 2018",
   "citation": "Girard TD, Exline MC, Carson SS, et al. Haloperidol and ziprasidone for treatment of delirium in critical illness (MIND-USA). N Engl J Med. 2018;379(26):2506-2516.",
   "link": "https://doi.org/10.1056/NEJMoa1808217",
   "archived": true,
   "statements": 1,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Pharmacologic considerations"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "NICE CG103",
   "citation": "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023).",
   "link": "https://www.nice.org.uk/guidance/cg103",
   "archived": true,
   "statements": 10,
   "check": "Confirmed — the citation shortens the article title; authors, journal, year, volume, and pages match the indexed record.",
   "usedIn": [
    "ED Delirium Card Set — Pathways card",
    "ED Delirium Workflow — 1 · Screen every older adult",
    "ED Delirium Workflow — 2 · Arousal — the gate",
    "ED Delirium Workflow — 3 · Screen & confirm",
    "ED Delirium Workflow — 4 · Act on the result",
    "ED Delirium Workflow — Disposition hand-off script",
    "SPA Quick Reference — Escalation ladder — 1 · All patients",
    "SPA Quick Reference — Escalation ladder — 2 · CAM positive",
    "SPA Quick Reference — Escalation ladder — 3 · Persistent > 1 shift",
    "SPA Quick Reference — Escalation ladder — 4 · Safety risk only"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "PADIS 2018",
   "citation": "Devlin JW, Skrobik Y, Gelinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873.",
   "link": "https://pubmed.ncbi.nlm.nih.gov/30113379/",
   "archived": true,
   "statements": 12,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Deliriogenic medications",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Engagement",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Hydration & Nutrition",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Mobility",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Reorientation",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Sensory",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Sleep",
    "ICU Delirium Rounding Tool — Pharmacologic considerations",
    "ICU Delirium Rounding Tool — Status strip — Sedation",
    "SPA Quick Reference — Deliriogenic medications",
    "SPA Quick Reference — S·P·A action cards — Pain / Pharmacy",
    "SPA Quick Reference — S·P·A action cards — Sedation"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "PADIS 2025",
   "citation": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines (adds Anxiety). Crit Care Med. 2025;53(3):e711-e727.",
   "link": "https://doi.org/10.1097/CCM.0000000000006574",
   "archived": true,
   "statements": 11,
   "check": "Confirmed — the citation shortens the article title; authors, journal, year, volume, and pages match the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Pharmacologic considerations",
    "ICU Delirium Rounding Tool — Status strip — Sedation",
    "SPA Quick Reference — Deeper guidance — A — Activity / Awareness",
    "SPA Quick Reference — Deeper guidance — P — Pain / Pharmacy",
    "SPA Quick Reference — Deeper guidance — S — Sedation",
    "SPA Quick Reference — Escalation ladder — 1 · All patients",
    "SPA Quick Reference — Escalation ladder — 2 · CAM positive",
    "SPA Quick Reference — Escalation ladder — 3 · Persistent > 1 shift",
    "SPA Quick Reference — Escalation ladder — 4 · Safety risk only",
    "SPA Quick Reference — S·P·A action cards — Pain / Pharmacy",
    "SPA Quick Reference — S·P·A action cards — Sedation"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Pro-MEDIC 2022",
   "citation": "Wibrow B, Martinez FE, Myers E, et al. Prophylactic melatonin for delirium in intensive care (Pro-MEDIC): an RCT. Intensive Care Med. 2022;48(4):414-425.",
   "link": "https://doi.org/10.1007/s00134-022-06638-9",
   "archived": false,
   "statements": 1,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "SPA Quick Reference — S·P·A action cards — Pain / Pharmacy"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Project BETA",
   "citation": "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the American Association for Emergency Psychiatry Project BETA De-escalation Workgroup. West J Emerg Med. 2012;13(1):17-25.",
   "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/",
   "archived": true,
   "statements": 4,
   "check": "Confirmed against the indexed record. The consensus statement is from the American Association for Emergency Psychiatry.",
   "usedIn": [
    "SPA Quick Reference — Escalation ladder — 1 · All patients",
    "SPA Quick Reference — Escalation ladder — 2 · CAM positive",
    "SPA Quick Reference — Escalation ladder — 3 · Persistent > 1 shift",
    "SPA Quick Reference — Escalation ladder — 4 · Safety risk only"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Pun 2019",
   "citation": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14.",
   "link": "https://doi.org/10.1097/CCM.0000000000003482",
   "archived": true,
   "statements": 6,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Non-pharm bundle — Engagement",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Hydration & Nutrition",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Mobility",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Reorientation",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Sensory",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Sleep"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "SAT/SBT",
   "citation": "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe). ICUDelirium.org.",
   "link": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt",
   "archived": false,
   "statements": 2,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Status strip — Sedation",
    "SPA Quick Reference — S·P·A action cards — Sedation"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "SCCM ICU Liberation",
   "citation": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F).",
   "link": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles",
   "archived": false,
   "statements": 7,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Non-pharm bundle — Engagement",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Hydration & Nutrition",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Mobility",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Reorientation",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Sensory",
    "ICU Delirium Rounding Tool — Non-pharm bundle — Sleep",
    "SPA Quick Reference — S·P·A action cards — Activity / Awareness"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Sessler 2002",
   "citation": "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344.",
   "link": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
   "archived": false,
   "statements": 2,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "SPA Quick Reference — RASS scale",
    "SPA Quick Reference — RASS sedation target"
   ],
   "verdict": ""
  },
  {
   "tool": "Emergency Dept",
   "source": "4AT v1.2",
   "citation": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use).",
   "link": "https://www.the4at.com/",
   "archived": true,
   "statements": 7,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ED Delirium Card Set — 4AT card",
    "ED Delirium Card Set — Pathways card",
    "ED Delirium Workflow — 1 · Screen every older adult",
    "ED Delirium Workflow — 2 · Arousal — the gate",
    "ED Delirium Workflow — 3 · Screen & confirm",
    "ED Delirium Workflow — 4 · Act on the result",
    "ED Delirium Workflow — Disposition hand-off script"
   ],
   "verdict": ""
  },
  {
   "tool": "Emergency Dept",
   "source": "ADEPT (2020)",
   "citation": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145.",
   "link": "https://doi.org/10.1016/j.annemergmed.2019.07.023",
   "archived": true,
   "statements": 7,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ED Delirium Card Set — Act-on-a-positive — Look for the cause — delirium is a symptom",
    "ED Delirium Card Set — Act-on-a-positive — Non-pharmacologic management first",
    "ED Delirium Workflow — 1 · Screen every older adult",
    "ED Delirium Workflow — 2 · Arousal — the gate",
    "ED Delirium Workflow — 3 · Screen & confirm",
    "ED Delirium Workflow — 4 · Act on the result",
    "ED Delirium Workflow — Disposition hand-off script"
   ],
   "verdict": ""
  },
  {
   "tool": "Emergency Dept",
   "source": "bCAM manual (Vanderbilt)",
   "citation": "Han JH. Brief Confusion Assessment Method (bCAM) Instruction Manual, v1.0 (2015). Vanderbilt University School of Medicine; eddelirium.org.",
   "link": "https://eddelirium.org/delirium-assessment/assessment-instruments/",
   "archived": true,
   "statements": 2,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ED Delirium Card Set — bCAM card (confirm)",
    "ED Delirium Card Set — bCAM card — Feature 2"
   ],
   "verdict": ""
  },
  {
   "tool": "Emergency Dept",
   "source": "Bellelli 2014",
   "citation": "Bellelli G, et al. Validation of the 4AT, a new instrument for rapid delirium screening: a study in 234 hospitalised older people. Age Ageing. 2014;43(4):496–502.",
   "link": "https://doi.org/10.1093/ageing/afu021",
   "archived": true,
   "statements": 1,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ED Delirium Card Set — 4AT card"
   ],
   "verdict": ""
  },
  {
   "tool": "Emergency Dept",
   "source": "DTS manual (Vanderbilt)",
   "citation": "Han JH. Delirium Triage Screen (DTS) Instruction Manual, v1.0 (2015). Vanderbilt University School of Medicine; eddelirium.org.",
   "link": "https://eddelirium.org/delirium-assessment/assessment-instruments/",
   "archived": true,
   "statements": 2,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ED Delirium Card Set — DTS card (Step 1)",
    "ED Delirium Card Set — DTS card — arousal"
   ],
   "verdict": ""
  },
  {
   "tool": "Emergency Dept",
   "source": "ED-DEL change package & toolkit",
   "citation": "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program.",
   "link": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf",
   "archived": true,
   "statements": 4,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ED Delirium Card Set — Act-on-a-positive — Document & communicate",
    "ED Delirium Card Set — Act-on-a-positive — Look for the cause — delirium is a symptom",
    "ED Delirium Card Set — Act-on-a-positive — Non-pharmacologic management first",
    "ED Delirium Card Set — Pathways card"
   ],
   "verdict": ""
  },
  {
   "tool": "Emergency Dept",
   "source": "GED Guidelines 2.0 (2026)",
   "citation": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167.",
   "link": "https://doi.org/10.1111/acem.70167",
   "archived": true,
   "statements": 6,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ED Delirium Card Set — Pathways card",
    "ED Delirium Workflow — 1 · Screen every older adult",
    "ED Delirium Workflow — 2 · Arousal — the gate",
    "ED Delirium Workflow — 3 · Screen & confirm",
    "ED Delirium Workflow — 4 · Act on the result",
    "ED Delirium Workflow — Disposition hand-off script"
   ],
   "verdict": ""
  },
  {
   "tool": "Emergency Dept",
   "source": "Geriatric ED Guidelines (2014)",
   "citation": "American College of Emergency Physicians, American Geriatrics Society, Emergency Nurses Association, Society for Academic Emergency Medicine. Geriatric Emergency Department Guidelines. 2014.",
   "link": "https://www.acep.org/geda/",
   "archived": true,
   "statements": 1,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ED Delirium Card Set — Pathways card"
   ],
   "verdict": ""
  },
  {
   "tool": "Emergency Dept",
   "source": "Han 2010",
   "citation": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252.",
   "link": "https://doi.org/10.1016/j.annemergmed.2010.03.003",
   "archived": true,
   "statements": 6,
   "check": "Confirmed — matches the indexed record; the indexed page range carries an online-appendix suffix (244-252.e1).",
   "usedIn": [
    "ED Delirium Card Set — Act-on-a-positive — Document & communicate",
    "ED Delirium Workflow — 1 · Screen every older adult",
    "ED Delirium Workflow — 2 · Arousal — the gate",
    "ED Delirium Workflow — 3 · Screen & confirm",
    "ED Delirium Workflow — 4 · Act on the result",
    "ED Delirium Workflow — Disposition hand-off script"
   ],
   "verdict": ""
  },
  {
   "tool": "Emergency Dept",
   "source": "Han 2013 (DTS/bCAM)",
   "citation": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465.",
   "link": "https://doi.org/10.1016/j.annemergmed.2013.05.003",
   "archived": true,
   "statements": 10,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ED Delirium Card Set — DTS card (Step 1)",
    "ED Delirium Card Set — DTS card — arousal",
    "ED Delirium Card Set — Pathways card",
    "ED Delirium Card Set — bCAM card (confirm)",
    "ED Delirium Card Set — bCAM card — Feature 2",
    "ED Delirium Workflow — 1 · Screen every older adult",
    "ED Delirium Workflow — 2 · Arousal — the gate",
    "ED Delirium Workflow — 3 · Screen & confirm",
    "ED Delirium Workflow — 4 · Act on the result",
    "ED Delirium Workflow — Disposition hand-off script"
   ],
   "verdict": ""
  },
  {
   "tool": "Emergency Dept",
   "source": "Shenkin 2019",
   "citation": "Shenkin SD, et al. Delirium detection in older acute medical inpatients: a multicentre prospective comparative diagnostic test accuracy study of the 4AT and the confusion assessment method. BMC Med. 2019;17:138.",
   "link": "https://doi.org/10.1186/s12916-019-1367-9",
   "archived": true,
   "statements": 1,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ED Delirium Card Set — 4AT card"
   ],
   "verdict": ""
  },
  {
   "tool": "Emergency Dept",
   "source": "SIGN 157",
   "citation": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019.",
   "link": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/",
   "archived": true,
   "statements": 6,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ED Delirium Card Set — Pathways card",
    "ED Delirium Workflow — 1 · Screen every older adult",
    "ED Delirium Workflow — 2 · Arousal — the gate",
    "ED Delirium Workflow — 3 · Screen & confirm",
    "ED Delirium Workflow — 4 · Act on the result",
    "ED Delirium Workflow — Disposition hand-off script"
   ],
   "verdict": ""
  },
  {
   "tool": "Emergency Dept",
   "source": "Tieges 2021",
   "citation": "Tieges Z, et al. Diagnostic accuracy of the 4AT for delirium detection in older adults: systematic review and meta-analysis. Age Ageing. 2021;50(3):733–743.",
   "link": "https://doi.org/10.1093/ageing/afaa224",
   "archived": true,
   "statements": 1,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "ED Delirium Card Set — 4AT card"
   ],
   "verdict": ""
  },
  {
   "tool": "Emergency Dept",
   "source": "Sessler 2002 (RASS)",
   "citation": "Sessler CN, et al. The Richmond Agitation–Sedation Scale: validity and reliability in adult intensive care unit patients. Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
   "link": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
   "archived": false,
   "check": "Confirmed — the identifier resolves to the matching record. Paywalled and not archived here; cited as the source of the RASS the ED cards reproduce.",
   "verdict": "",
   "statements": 1,
   "usedIn": [
    "ED Delirium Card Set — DTS card — arousal"
   ]
  },
  {
   "tool": "Pediatric",
   "source": "Curley 2006 (SBS)",
   "citation": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114.",
   "link": "https://doi.org/10.1097/01.PCC.0000200955.40962.38",
   "archived": true,
   "statements": 11,
   "check": "Confirmed — the citation shortens the article title; authors, journal, year, volume, and pages match the indexed record.",
   "usedIn": [
    "PICU Delirium Workflow — 1 · Screen every child",
    "PICU Delirium Workflow — 10-second rounds script",
    "PICU Delirium Workflow — 2 · Arousal first — the gate",
    "PICU Delirium Workflow — 3 · Score the screen",
    "PICU Delirium Workflow — 4 · Act on the result",
    "Peds Delirium Card Set — Act-on-a-positive — bundle",
    "Peds Delirium Card Set — Act-on-a-positive — escalate",
    "Peds Delirium Card Set — Act-on-a-positive — find/fix",
    "Peds Delirium Card Set — Arousal card — SBS gate",
    "Peds Delirium Card Set — Prevention bundle (ABCDEF)",
    "Peds Delirium Card Set — Prevention measures"
   ],
   "verdict": ""
  },
  {
   "tool": "Pediatric",
   "source": "Gupta 2021",
   "citation": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)",
   "link": "https://doi.org/10.1055/s-0041-1728784",
   "archived": true,
   "statements": 6,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "Peds Delirium Card Set — Act-on-a-positive — bundle",
    "Peds Delirium Card Set — Act-on-a-positive — escalate",
    "Peds Delirium Card Set — Act-on-a-positive — find/fix",
    "Peds Delirium Card Set — CAPD card",
    "Peds Delirium Card Set — Prevention bundle (ABCDEF)",
    "Peds Delirium Card Set — Prevention measures"
   ],
   "verdict": ""
  },
  {
   "tool": "Pediatric",
   "source": "Kerson 2016 (RASS)",
   "citation": "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)",
   "link": "https://doi.org/10.1186/s40560-016-0189-5",
   "archived": true,
   "statements": 2,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "Peds Delirium Card Set — Arousal card — RASS anchors",
    "Peds Delirium Card Set — Arousal card — RASS gate"
   ],
   "verdict": ""
  },
  {
   "tool": "Pediatric",
   "source": "Lin 2023 (ICU Liberation)",
   "citation": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651.",
   "link": "https://doi.org/10.1097/PCC.0000000000003262",
   "archived": false,
   "statements": 5,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "PICU Delirium Workflow — 1 · Screen every child",
    "PICU Delirium Workflow — 10-second rounds script",
    "PICU Delirium Workflow — 2 · Arousal first — the gate",
    "PICU Delirium Workflow — 3 · Score the screen",
    "PICU Delirium Workflow — 4 · Act on the result"
   ],
   "verdict": ""
  },
  {
   "tool": "Pediatric",
   "source": "Mody 2018",
   "citation": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491.",
   "link": "https://doi.org/10.1097/CCM.0000000000003194",
   "archived": true,
   "statements": 5,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "Peds Delirium Card Set — Act-on-a-positive — bundle",
    "Peds Delirium Card Set — Act-on-a-positive — escalate",
    "Peds Delirium Card Set — Act-on-a-positive — find/fix",
    "Peds Delirium Card Set — Prevention bundle (ABCDEF)",
    "Peds Delirium Card Set — Prevention measures"
   ],
   "verdict": ""
  },
  {
   "tool": "Pediatric",
   "source": "SCCM PANDEM 2022",
   "citation": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110.",
   "link": "https://doi.org/10.1097/PCC.0000000000002873",
   "archived": true,
   "statements": 10,
   "check": "Confirmed — the citation shortens the article title; authors, journal, year, volume, and pages match the indexed record.",
   "usedIn": [
    "PICU Delirium Workflow — 1 · Screen every child",
    "PICU Delirium Workflow — 10-second rounds script",
    "PICU Delirium Workflow — 2 · Arousal first — the gate",
    "PICU Delirium Workflow — 3 · Score the screen",
    "PICU Delirium Workflow — 4 · Act on the result",
    "Peds Delirium Card Set — Act-on-a-positive — bundle",
    "Peds Delirium Card Set — Act-on-a-positive — escalate",
    "Peds Delirium Card Set — Act-on-a-positive — find/fix",
    "Peds Delirium Card Set — Prevention bundle (ABCDEF)",
    "Peds Delirium Card Set — Prevention measures"
   ],
   "verdict": ""
  },
  {
   "tool": "Pediatric",
   "source": "Sessler 2002 (RASS)",
   "citation": "Sessler CN, et al. The Richmond Agitation–Sedation Scale (RASS). Am J Respir Crit Care Med. 2002;166(10):1338–1344.",
   "link": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
   "archived": false,
   "statements": 12,
   "check": "Confirmed — the citation shortens the article title; authors, journal, year, volume, and pages match the indexed record.",
   "usedIn": [
    "PICU Delirium Workflow — 1 · Screen every child",
    "PICU Delirium Workflow — 10-second rounds script",
    "PICU Delirium Workflow — 2 · Arousal first — the gate",
    "PICU Delirium Workflow — 3 · Score the screen",
    "PICU Delirium Workflow — 4 · Act on the result",
    "Peds Delirium Card Set — Act-on-a-positive — bundle",
    "Peds Delirium Card Set — Act-on-a-positive — escalate",
    "Peds Delirium Card Set — Act-on-a-positive — find/fix",
    "Peds Delirium Card Set — Arousal card — RASS anchors",
    "Peds Delirium Card Set — Arousal card — RASS gate",
    "Peds Delirium Card Set — Prevention bundle (ABCDEF)",
    "Peds Delirium Card Set — Prevention measures"
   ],
   "verdict": ""
  },
  {
   "tool": "Pediatric",
   "source": "Smith 2011 (pCAM-ICU)",
   "citation": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157.",
   "link": "https://doi.org/10.1097/CCM.0b013e3181feb489",
   "archived": false,
   "statements": 12,
   "check": "Confirmed — the citation shortens the article title; authors, journal, year, volume, and pages match the indexed record.",
   "usedIn": [
    "PICU Delirium Workflow — 1 · Screen every child",
    "PICU Delirium Workflow — 10-second rounds script",
    "PICU Delirium Workflow — 2 · Arousal first — the gate",
    "PICU Delirium Workflow — 3 · Score the screen",
    "PICU Delirium Workflow — 4 · Act on the result",
    "Peds Delirium Card Set — Act-on-a-positive — bundle",
    "Peds Delirium Card Set — Act-on-a-positive — escalate",
    "Peds Delirium Card Set — Act-on-a-positive — find/fix",
    "Peds Delirium Card Set — Choose-the-screen card",
    "Peds Delirium Card Set — Prevention bundle (ABCDEF)",
    "Peds Delirium Card Set — Prevention measures",
    "Peds Delirium Card Set — pCAM-ICU card"
   ],
   "verdict": ""
  },
  {
   "tool": "Pediatric",
   "source": "Smith 2016 (psCAM-ICU)",
   "citation": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600.",
   "link": "https://doi.org/10.1097/CCM.0000000000001428",
   "archived": true,
   "statements": 12,
   "check": "Confirmed — the citation shortens the article title; authors, journal, year, volume, and pages match the indexed record.",
   "usedIn": [
    "PICU Delirium Workflow — 1 · Screen every child",
    "PICU Delirium Workflow — 10-second rounds script",
    "PICU Delirium Workflow — 2 · Arousal first — the gate",
    "PICU Delirium Workflow — 3 · Score the screen",
    "PICU Delirium Workflow — 4 · Act on the result",
    "Peds Delirium Card Set — Act-on-a-positive — bundle",
    "Peds Delirium Card Set — Act-on-a-positive — escalate",
    "Peds Delirium Card Set — Act-on-a-positive — find/fix",
    "Peds Delirium Card Set — Choose-the-screen card",
    "Peds Delirium Card Set — Prevention bundle (ABCDEF)",
    "Peds Delirium Card Set — Prevention measures",
    "Peds Delirium Card Set — psCAM-ICU card"
   ],
   "verdict": ""
  },
  {
   "tool": "Pediatric",
   "source": "Traube 2014 (CAPD)",
   "citation": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663.",
   "link": "https://doi.org/10.1097/CCM.0b013e3182a66b76",
   "archived": true,
   "statements": 12,
   "check": "Confirmed — matches the indexed record.",
   "usedIn": [
    "PICU Delirium Workflow — 1 · Screen every child",
    "PICU Delirium Workflow — 10-second rounds script",
    "PICU Delirium Workflow — 2 · Arousal first — the gate",
    "PICU Delirium Workflow — 3 · Score the screen",
    "PICU Delirium Workflow — 4 · Act on the result",
    "Peds Delirium Card Set — Act-on-a-positive — bundle",
    "Peds Delirium Card Set — Act-on-a-positive — escalate",
    "Peds Delirium Card Set — Act-on-a-positive — find/fix",
    "Peds Delirium Card Set — CAPD card",
    "Peds Delirium Card Set — Choose-the-screen card",
    "Peds Delirium Card Set — Prevention bundle (ABCDEF)",
    "Peds Delirium Card Set — Prevention measures"
   ],
   "verdict": ""
  },
  {
   "tool": "Pediatric",
   "source": "Traube 2017 (mortality)",
   "citation": "Traube C, Silver G, Gerber LM, et al. Delirium and mortality in critically ill children: epidemiology and outcomes of pediatric delirium. Crit Care Med. 2017;45(5):891–898.",
   "link": "https://doi.org/10.1097/CCM.0000000000002324",
   "archived": true,
   "statements": 5,
   "usedIn": [
    "PICU Delirium Workflow — 1 · Screen every child",
    "PICU Delirium Workflow — 10-second rounds script",
    "PICU Delirium Workflow — 2 · Arousal first — the gate",
    "PICU Delirium Workflow — 3 · Score the screen",
    "PICU Delirium Workflow — 4 · Act on the result"
   ],
   "check": "Confirmed — matches the indexed record. Distinct from the point-prevalence study published by the same first author in the same year; the passages quoted on this tool are all from this paper.",
   "verdict": ""
  },
  {
   "tool": "Pediatric",
   "source": "Traube 2017 (point prevalence)",
   "citation": "Traube C, Silver G, Reeder RW, et al. Delirium in critically ill children: an international point prevalence study. Crit Care Med. 2017;45(4):584–590.",
   "link": "https://doi.org/10.1097/CCM.0000000000002250",
   "archived": false,
   "statements": 1,
   "usedIn": [
    "PICU Delirium Workflow — 1 · Screen every child"
   ],
   "check": "Confirmed — matches the indexed record. The full text is not archived here; the published abstract carries the prevalence figure quoted on the statement below.",
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "AGS 2015 (postoperative delirium guideline)",
   "citation": "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142.",
   "link": "https://doi.org/10.1111/jgs.13281",
   "archived": true,
   "statements": 8,
   "check": "Confirmed — DOI resolves to the matching title; Crossref lists the 2014 online-first date, print issue J Am Geriatr Soc 2015;63:142 (matches references/INDEX.md).",
   "usedIn": [
    "Step-Down Card Set — Prevention card — intro",
    "Step-Down Card Set — Prevention card — bundle",
    "Step-Down Card Set — Act card — Find the cause",
    "Step-Down Card Set — Act card — Manage without new harm",
    "Step-Down Workflow — 4 · Risk & prevent",
    "Step-Down Workflow — 5 · Act on the result"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "Beyer 2024 (CAM-IMC)",
   "citation": "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451.",
   "link": "https://doi.org/10.1186/s12871-024-02849-3",
   "archived": true,
   "statements": 17,
   "check": "Confirmed — the DOI resolves to the matching record and matches the reference index.",
   "usedIn": [
    "Step-Down Card Set — Arousal card — administration",
    "Step-Down Card Set — Arousal card — gate (altered)",
    "Step-Down Card Set — Arousal card — gate (stop)",
    "Step-Down Card Set — CAM-IMC card — rule",
    "Step-Down Card Set — CAM-IMC card — Feature 1",
    "Step-Down Card Set — CAM-IMC card — Feature 2",
    "Step-Down Card Set — CAM-IMC card — Feature 3 (inattention)",
    "Step-Down Card Set — CAM-IMC card — Feature 4 (disorientation)",
    "Step-Down Card Set — CAM-IMC card — scope / non-veto",
    "Step-Down Workflow — 1 · Screen the verbal patient",
    "Step-Down Workflow — 2 · Arousal — the gate",
    "Step-Down Workflow — 3 · CAM-IMC — score",
    "Step-Down Workflow — 5 · Act on the result",
    "Step-Down Workflow — Loop — unable to assess"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "Chester 2012 (mRASS)",
   "citation": "Chester JG, et al. Serial administration of a modified RASS for delirium screening. J Hosp Med 2012;7:450.",
   "link": "https://doi.org/10.1002/jhm.1003",
   "archived": true,
   "statements": 2,
   "check": "Confirmed — DOI resolves to the matching title; Crossref lists the 2011 online-first date, print issue J Hosp Med 2012;7:450 (matches references/INDEX.md).",
   "usedIn": [
    "Step-Down Card Set — Arousal card — RASS scale",
    "Step-Down Card Set — Arousal card — administration"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "Han 2015 (RASS in the ED)",
   "citation": "Han JH, et al. The diagnostic performance of the RASS for detecting delirium in older ED patients. Acad Emerg Med 2015;22:878.",
   "link": "https://doi.org/10.1111/acem.12706",
   "archived": true,
   "statements": 6,
   "check": "Confirmed — the DOI resolves to the matching record and matches the reference index.",
   "usedIn": [
    "Step-Down Card Set — Arousal card — RASS scale",
    "Step-Down Card Set — Arousal card — administration",
    "Step-Down Card Set — Arousal card — gate (altered)",
    "Step-Down Card Set — Arousal card — gate (stop)",
    "Step-Down Workflow — 2 · Arousal — the gate"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "Lisibach 2022 (anticholinergic burden)",
   "citation": "Lisibach A, et al. Quantifying anticholinergic burden and its association with delirium (comparison of 19 scales). Br J Clin Pharmacol 2022;88:4915.",
   "link": "https://doi.org/10.1111/bcp.15432",
   "archived": true,
   "statements": 2,
   "check": "Confirmed — the DOI resolves to the matching record and matches the reference index.",
   "usedIn": [
    "Step-Down Card Set — Act card — Find the cause",
    "Step-Down Workflow — 5 · Act on the result"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "Martinez 2012 (ward risk rule)",
   "citation": "Martinez JA, et al. Derivation and validation of a clinical prediction rule for delirium in patients admitted to a medical ward. BMJ Open 2012;2:e001599.",
   "link": "https://doi.org/10.1136/bmjopen-2012-001599",
   "archived": true,
   "statements": 6,
   "check": "Confirmed — the DOI resolves to the matching record and matches the reference index.",
   "usedIn": [
    "Step-Down Card Set — Risk card — rule",
    "Step-Down Card Set — Risk card — Age",
    "Step-Down Card Set — Risk card — ADL dependence",
    "Step-Down Card Set — Risk card — Psychotropic burden",
    "Step-Down Card Set — Risk card — bands",
    "Step-Down Workflow — 4 · Risk & prevent"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "Neufeld 2016 (antipsychotics meta-analysis)",
   "citation": "Neufeld KJ, et al. Antipsychotic medication for prevention and treatment of delirium in hospitalized adults: a systematic review and meta-analysis. J Am Geriatr Soc 2016;64:705.",
   "link": "https://doi.org/10.1111/jgs.14076",
   "archived": true,
   "statements": 2,
   "check": "Confirmed — the DOI resolves to the matching record and matches the reference index.",
   "usedIn": [
    "Step-Down Card Set — Prevention card — intro",
    "Step-Down Card Set — Act card — Manage without new harm"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "Nikooie 2019 (antipsychotics — treatment)",
   "citation": "Nikooie R, et al. Antipsychotics for treating delirium in hospitalized adults: a systematic review. Ann Intern Med 2019;171:485.",
   "link": "https://doi.org/10.7326/M19-1860",
   "archived": true,
   "statements": 1,
   "check": "Confirmed — the DOI resolves to the matching record and matches the reference index.",
   "usedIn": [
    "Step-Down Card Set — Act card — Manage without new harm"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "Oh 2019 (antipsychotics — prevention)",
   "citation": "Oh ES, et al. Antipsychotics for preventing delirium in hospitalized adults: a systematic review. Ann Intern Med 2019;171:474.",
   "link": "https://doi.org/10.7326/M19-1859",
   "archived": true,
   "statements": 2,
   "check": "Confirmed — the DOI resolves to the matching record and matches the reference index.",
   "usedIn": [
    "Step-Down Card Set — Prevention card — intro",
    "Step-Down Card Set — Act card — Manage without new harm"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "Siddiqi 2016 (Cochrane)",
   "citation": "Siddiqi N, et al. Interventions for preventing delirium in hospitalised non-ICU patients. Cochrane Database Syst Rev 2016;CD005563.",
   "link": "https://doi.org/10.1002/14651858.CD005563.pub3",
   "archived": true,
   "statements": 5,
   "check": "Confirmed — the DOI resolves to the matching record and matches the reference index.",
   "usedIn": [
    "Step-Down Card Set — Prevention card — intro",
    "Step-Down Card Set — Prevention card — bundle",
    "Step-Down Card Set — Act card — Manage without new harm",
    "Step-Down Workflow — 4 · Risk & prevent",
    "Step-Down Workflow — 5 · Act on the result"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "Wang 2017 (iatrogenic withdrawal)",
   "citation": "Wang PP, et al. Opioid-associated iatrogenic withdrawal in critically ill adult patients. Ann Intensive Care 2017;7:88.",
   "link": "https://doi.org/10.1186/s13613-017-0310-5",
   "archived": true,
   "statements": 1,
   "check": "Confirmed — the DOI resolves to the matching record and matches the reference index.",
   "usedIn": [
    "Step-Down Card Set — Act card — Find the cause"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "Ely 2003 (RASS)",
   "citation": "Ely EW, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA 2003;289:2983.",
   "link": "https://doi.org/10.1001/jama.289.22.2983",
   "archived": true,
   "statements": 2,
   "check": "Confirmed — identifier resolves with matching author/year/title; the archive copy is held once in the shared reference archive rather than under references/stepdown/.",
   "usedIn": [
    "Step-Down Card Set — Arousal card — RASS scale",
    "Step-Down Card Set — Arousal card — administration"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "Hshieh 2015 (meta-analysis)",
   "citation": "Hshieh TT, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med 2015;175:512.",
   "link": "https://doi.org/10.1001/jamainternmed.2014.7779",
   "archived": true,
   "statements": 2,
   "check": "Confirmed — identifier resolves with matching author/year/title; the archive copy is held once in the shared reference archive rather than under references/stepdown/.",
   "usedIn": [
    "Step-Down Card Set — Prevention card — intro",
    "Step-Down Card Set — Prevention card — bundle"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "Inouye 1999 (HELP)",
   "citation": "Inouye SK, et al. A multicomponent intervention to prevent delirium in hospitalized older patients. N Engl J Med 1999;340:669.",
   "link": "https://doi.org/10.1056/NEJM199903043400901",
   "archived": true,
   "statements": 4,
   "check": "Confirmed — identifier resolves with matching author/year/title; the archive copy is held once in the shared reference archive rather than under references/stepdown/.",
   "usedIn": [
    "Step-Down Card Set — Prevention card — intro",
    "Step-Down Card Set — Prevention card — bundle",
    "Step-Down Card Set — Act card — Manage without new harm",
    "Step-Down Workflow — 4 · Risk & prevent"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "NICE CG103",
   "citation": "National Institute for Health and Care Excellence. Delirium: prevention, diagnosis and management in hospital and long-term care. CG103 (updated 2023).",
   "link": "https://www.nice.org.uk/guidance/cg103",
   "archived": true,
   "statements": 8,
   "check": "Confirmed against the NICE guideline record — a web guideline has no DOI or PMID to resolve. A snapshot is held in the shared reference archive.",
   "usedIn": [
    "Step-Down Card Set — Risk card — rule",
    "Step-Down Card Set — Act card — Find the cause",
    "Step-Down Card Set — Act card — Manage without new harm",
    "Step-Down Card Set — Act card — Document & hand off",
    "Step-Down Workflow — 5 · Act on the result",
    "Step-Down Workflow — Hand-off script (four items)"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult Step-Down",
   "source": "Sessler 2002 (RASS)",
   "citation": "Sessler CN, et al. The Richmond Agitation-Sedation Scale: validity and reliability in adult ICU patients. Am J Respir Crit Care Med 2002;166:1338.",
   "link": "https://pubmed.ncbi.nlm.nih.gov/12421743/",
   "archived": false,
   "statements": 5,
   "check": "Confirmed — the identifier resolves to the matching record. The article is paywalled and cited by its PubMed record rather than held in the archive.",
   "usedIn": [
    "Step-Down Card Set — Arousal card — RASS scale",
    "Step-Down Card Set — Arousal card — administration",
    "Step-Down Card Set — Arousal card — gate (stop)",
    "Step-Down Workflow — 2 · Arousal — the gate",
    "Step-Down Workflow — Loop — unable to assess"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "CAM-ICU Manual",
   "citation": "Ely EW; Vanderbilt University. The Complete CAM-ICU Training Manual (rev. 2016). ICUDelirium.org.",
   "link": "https://www.icudelirium.org/resource-downloads/cam-icu-training-manual",
   "archived": true,
   "statements": 1,
   "check": "Confirmed against the Vanderbilt CIBS Center record; the archive holds the 2016 revision.",
   "usedIn": [
    "ICU Delirium Rounding Tool — Status strip — CAM-ICU result"
   ],
   "verdict": ""
  },
  {
   "tool": "Adult ICU",
   "source": "Flaherty & Little 2011",
   "citation": "Flaherty JH, Little MO. Matching the environment to patients with delirium: lessons learned from the delirium room. J Am Geriatr Soc. 2011;59(Suppl 2):S295-S300.",
   "link": "https://pubmed.ncbi.nlm.nih.gov/22091576/",
   "archived": false,
   "check": "Confirmed — matches the indexed record. The full text is paywalled and not archived here; the published abstract names the T-A-DA method and expands all three principles, and that sentence is quoted on the statements below. Distinct from Flaherty 2011 (Med Clin North Am), a different paper by the same first author in the same year.",
   "verdict": "",
   "statements": 2,
   "usedIn": [
    "ICU Delirium Rounding Tool — Non-pharm bundle — Engagement",
    "SPA Quick Reference — Deeper guidance — A — Activity / Awareness"
   ]
  },
  {
   "tool": "Adult ICU",
   "source": "Quetiapine PI",
   "citation": "Seroquel (quetiapine fumarate) prescribing information — QTc prolongation and orthostatic hypotension. DailyMed, U.S. NLM.",
   "link": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=0584dda8-bc3c-48fe-1a90-79608f78e8a0",
   "archived": true,
   "check": "Confirmed — the DailyMed record resolves (AstraZeneca SEROQUEL, SPL version 50). The label states orthostatic hypotension outright; its QT section is more qualified than a routine-monitoring instruction, and that wording is quoted on the statement below.",
   "verdict": "",
   "statements": 1,
   "usedIn": [
    "SPA Quick Reference — Deeper guidance — P — Pain / Pharmacy"
   ]
  }
 ],
 "legend": [
  "Bedside templates — claim-to-source review",
  "deliriumtool.com/templates · prepared July 31, 2026; adult step-down / progressive-care tool added August 1, 2026",
  "Purpose",
  "This workbook lists every clinical statement that can appear on the printable bedside templates, together with the published source each statement cites and the passage from that source that supports it. For sources held in the reference archive, the supporting passage is shown in its surrounding paragraph with the exact cited text in bold blue; the line above each passage gives the source and page (and the paragraph number where the source's layout allows one to be counted). Passages were checked against the archive copy. Rows where the cited source does not state the claim are shaded red for review.",
  "How to use this workbook",
  "Each template has its own sheet, one row per printed statement. Column filters are enabled. The Reviewer decision and Notes columns are reserved for the review team; the decision column offers Accept, Revise wording, Remove, Needs source, and Check evidence. The All references sheet lists each source once, with the sections that rely on it, for source-level sign-off.",
  "Content types",
  "Cited clinical content — screening logic, thresholds, prevention-bundle items, and medication cautions drawn from published guidelines and validated instruments.",
  "Validated instrument wording — the screening tools themselves (CAM-ICU, RASS, CAPD, DTS, bCAM, 4AT). This wording is reproduced from the instrument and is not editable by sites.",
  "Local protocol — the nurse care pathway and any site-authored sections. Sites adapt these to their own practice; they carry no central citation and need no reference review.",
  "Reading the Evidence column",
  "Full text, p. N — the quoted passage appears in the source at the page shown.",
  "Abstract / Web page — the source is quoted from its public abstract or web page rather than an archive copy.",
  "Source not accessible — the source could not be consulted directly; verify against the DOI given in the row.",
  "Not stated in cited source — no supporting statement was found in the source(s) the row cites. Review these rows first; several are general-practice items whose support lies outside the cited papers.",
  "Coverage: 241 printed statements in total across eight templates. 216 cite central sources; 25 are site-customized rows with no citation to review. Of the 216, 169 are supported by a full-text passage (168 page-confirmed), 24 by an abstract or web source, 18 are flagged where the cited source does not state the claim, and 5 (all on the step-down templates) cite a guideline or instrument whose wording is held outside the local archive — NICE CG103 and the Sessler/Ely RASS anchor set. The 37 step-down statements are all sourced: 32 are anchored to a verbatim full-text passage and none are flagged.",
  "Citation verification",
  "Every source was checked against its indexed record (CrossRef or PubMed) or the issuing organization’s site. All 70 source rows are real publications or guidelines; none are fabricated. In the original set, two corrections were identified and are noted in the Citation check column of the All references sheet: the Hayhurst 2020 author list is cited incorrectly, and Project BETA belongs to the American Association for Emergency Psychiatry rather than the APA. The 16 step-down sources were re-checked online: 15 of 16 identifiers resolve with matching author, year, and title; the sixteenth (AGS 2015 postoperative-delirium guideline, doi 10.1111/jgs.13281) resolves to the correct title but CrossRef lists its 2014 online-first date rather than the 2015 print issue (J Am Geriatr Soc 2015;63:142). NICE CG103 carries no DOI/PMID and is the issuing body’s record.",
  "The printed sheets themselves carry a one-line source list and the reference-aid disclaimer; the full reference set lives in the project documentation rather than on the laminated card."
 ],
 "methodology": [
  {
   "t": "p",
   "spans": [
    {
     "text": "Project:",
     "b": 1
    },
    {
     "text": " Delirium Bedside Reference Tool (deliriumtool.com)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Scope of this document:",
     "b": 1
    },
    {
     "text": " An account of every clinical instrument, threshold, score band, and decision rule "
    },
    {
     "text": "as actually implemented in the application",
     "i": 1
    },
    {
     "text": ", together with the primary-source citations each maps to, so clinicians, pharmacists, and quality reviewers can audit the evidence base directly."
    }
   ]
  },
  {
   "t": "h",
   "level": 2,
   "spans": [
    {
     "text": "1. Intended use, and what this tool is "
    },
    {
     "text": "not",
     "i": 1
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "This is a "
    },
    {
     "text": "reference aid only",
     "b": 1
    },
    {
     "text": ". It supports — and does not replace — clinical judgment, local protocol, and prescriber/pharmacy review. It is "
    },
    {
     "text": "not a standalone order set",
     "b": 1
    },
    {
     "text": " and "
    },
    {
     "text": "not a validated clinical decision-support device",
     "b": 1
    },
    {
     "text": ". All medication decisions must be verified against current institutional policy."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "These statements are surfaced to the user throughout the application:"
    }
   ]
  },
  {
   "t": "ul",
   "items": [
    [
     {
      "text": "The persistent banner above every tab reads: "
     },
     {
      "text": "\"Reference aid only. This tool supports — and does not replace — clinical judgment, local protocol, and prescriber/pharmacy review. It is not a standalone order set or a validated decision-support device. Verify all medication decisions against current institutional policy.\"",
      "i": 1
     }
    ],
    [
     {
      "text": "Every generated PDF and printable sheet carries a footer: "
     },
     {
      "text": "\"Reference aid only. These sheets support — and do not replace — clinical judgment, local protocol, and prescriber/pharmacy review. They are not a validated decision-support device or an order set. Verify all medication content against your formulary before use.\"",
      "i": 1
     }
    ],
    [
     {
      "text": "The Medications tab states plainly: "
     },
     {
      "text": "\"No agent has FDA approval for delirium treatment.\"",
      "i": 1
     }
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Setting.",
     "b": 1
    },
    {
     "text": " The tool is ICU-focused. It is built around CAM-ICU, RASS, and the ABCDEF/ICU Liberation bundle. The application advises: "
    },
    {
     "text": "\"on the ward, use a ward-validated screen (4AT / 3D-CAM).\"",
     "i": 1
    },
    {
     "text": " The CAM-ICU, RASS, and ABCDEF elements are not validated for, and should not be transplanted unmodified onto, general-ward populations."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Data handling.",
     "b": 1
    },
    {
     "text": " The tool runs entirely in the browser. The assessment is a session scratchpad: it clears on reload and is never written to browser storage. Saving or handing off an assessment is an explicit JSON export. Protocol-governance settings are stored locally. No patient data is transmitted or persisted server-side."
    }
   ]
  },
  {
   "t": "h",
   "level": 2,
   "spans": [
    {
     "text": "2. Instruments implemented"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Each subsection documents the instrument, the exact logic/thresholds "
    },
    {
     "text": "as implemented",
     "i": 1
    },
    {
     "text": ", and the primary-source citation IDs (see the registry in §3 for full citations)."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "2.1 Risk-factor tally (admission / q24h)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "A "
    },
    {
     "text": "count of present risk factors",
     "b": 1
    },
    {
     "text": ". In the UI subtitle, the score caption, and the band caption, the application states that this is "
    },
    {
     "text": "\"a count of present risk factors (not a validated score)\"",
     "i": 1
    },
    {
     "text": " and "
    },
    {
     "text": "\"a checklist tally, not a validated prediction score.\"",
     "i": 1
    },
    {
     "text": " For a validated ICU model it directs users to "
    },
    {
     "text": "E-PRE-DELIRIC",
     "b": 1
    },
    {
     "text": " (at admission) or "
    },
    {
     "text": "PRE-DELIRIC",
     "b": 1
    },
    {
     "text": " (after 24 h)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Scoring:",
     "b": 1
    },
    {
     "text": " 15 checkboxes, maximum "
    },
    {
     "text": "15 points",
     "b": 1
    },
    {
     "text": ". Every factor scores "
    },
    {
     "text": "+1",
     "b": 1
    },
    {
     "text": ": a flat checklist count with no weighting. (The earlier +2 on dementia was removed so a non-validated tally cannot imply a calibration it does not have; "
    },
    {
     "text": "mechanical ventilation was removed",
     "b": 1
    },
    {
     "text": " in the 2026-07-01 revision because PADIS 2018 reports strong evidence it does not alter delirium risk and it appears in none of the cited prediction models.)"
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "Group"
     }
    ],
    [
     {
      "text": "Factor (points)"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "Predisposing — Cognitive/Psychiatric"
      }
     ],
     [
      {
       "text": "Dementia / cognitive impairment (+1); Prior delirium episode (+1); Depression / psychiatric history (+1)"
      }
     ]
    ],
    [
     [
      {
       "text": "Predisposing — Functional/Sensory"
      }
     ],
     [
      {
       "text": "Visual impairment (+1); Hearing impairment (+1); Functional dependence / immobility (+1)"
      }
     ]
    ],
    [
     [
      {
       "text": "Predisposing — Demographics/Comorbidities"
      }
     ],
     [
      {
       "text": "Age ≥ 70 (+1); Severe illness (high APACHE-II — no numeric cutoff is stated by the cited sources) (+1); Dehydration / poor nutrition (+1); Alcohol / substance use disorder (+1)"
      }
     ]
    ],
    [
     [
      {
       "text": "Precipitating"
      }
     ],
     [
      {
       "text": "Surgery / general anesthesia (+1); Physical restraints in use (+1); Urinary catheter (+1); Metabolic abnormality (+1); Sleep / circadian disruption (+1)"
      }
     ]
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Band boundaries and actions",
     "b": 1
    },
    {
     "text": " (range 0–15):"
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "Score"
     }
    ],
    [
     {
      "text": "Band"
     }
    ],
    [
     {
      "text": "Guidance"
     }
    ],
    [
     {
      "text": "Escalation logic"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "0–3"
      }
     ],
     [
      {
       "text": "Few risk factors"
      }
     ],
     [
      {
       "text": "Maintain baseline prevention measures"
      }
     ],
     [
      {
       "text": "Standard prevention + routine CAM"
      }
     ]
    ],
    [
     [
      {
       "text": "4–6"
      }
     ],
     [
      {
       "text": "Several risk factors"
      }
     ],
     [
      {
       "text": "Enhanced ABCDEF bundle · monitor closely"
      }
     ],
     [
      {
       "text": "Initiate full ABCDEF bundle"
      }
     ]
    ],
    [
     [
      {
       "text": "7–10"
      }
     ],
     [
      {
       "text": "Many risk factors"
      }
     ],
     [
      {
       "text": "Full bundle · consider geriatrics input (per local protocol)"
      }
     ],
     [
      {
       "text": "Geriatrics suggested when score > 6 (pragmatic, non-validated threshold)"
      }
     ]
    ],
    [
     [
      {
       "text": "11–15"
      }
     ],
     [
      {
       "text": "Very many risk factors"
      }
     ],
     [
      {
       "text": "Full bundle · consider geriatrics input (per local protocol)"
      }
     ],
     [
      {
       "text": "No score-triggered psychiatry — psychiatry is indicated by clinical features (diagnostic uncertainty, refractory agitation, comorbid psychiatric illness), not by a risk-factor count"
      }
     ]
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The band cut-points are labeled "
    },
    {
     "text": "\"(heuristic)\"",
     "i": 1
    },
    {
     "text": " in the interface."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Citations mapped (Risk tab):",
     "b": 1
    },
    {
     "text": " "
    },
    {
     "text": "predeliric2012",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "epredeliric2015",
     "code": 1
    },
    {
     "text": " (cited inline as the validated alternatives); supporting reference list also carries "
    },
    {
     "text": "zaal2015",
     "code": 1
    },
    {
     "text": " (ICU risk-factor systematic review), "
    },
    {
     "text": "inouye1993",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "marcantonio1994",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "inouye_charpentier1996",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "rudolph2009",
     "code": 1
    },
    {
     "text": " (cardiac-surgery prediction rule), "
    },
    {
     "text": "pisani2009",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "snigurska2023",
     "code": 1
    },
    {
     "text": " (prediction-model risk-of-bias caveat), "
    },
    {
     "text": "nice_cg103",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "padis2018",
     "code": 1
    },
    {
     "text": ". "
    },
    {
     "text": "Item-level provenance",
     "b": 1
    },
    {
     "text": " (2026-07-01 verification): dementia/cognitive impairment, visual impairment, severe illness, dehydration/nutrition, age, alcohol use, functional dependence, surgery, restraints, urinary catheter, and metabolic abnormality map to the prediction-model sources (Inouye 1993/1996, Marcantonio 1994, PRE-/E-PRE-DELIRIC, PADIS 2018 risk-factor tables); "
    },
    {
     "text": "prior delirium episode, depression/psychiatric history, hearing impairment, and sleep/circadian disruption are clinically recognized factors carried on the strength of NICE CG103's risk-factor enumeration and (for sleep) the PADIS 2018 sleep section rather than any cited prediction model",
     "b": 1
    },
    {
     "text": ". They are unweighted +1 prompts in an explicitly pragmatic tally. "
    },
    {
     "text": "Mechanical ventilation was removed",
     "b": 1
    },
    {
     "text": ": PADIS 2018 states sex, opioid use, and mechanical ventilation \"have been strongly shown NOT to alter the risk of delirium occurrence,\" and no cited model includes it. All factors count +1 (a flat checklist); the band cut-points are pragmatic, which is why the tool routes clinicians to the validated models (E-PRE-DELIRIC / PRE-DELIRIC). The geriatrics-consult threshold is likewise a pragmatic, non-validated prompt; there is no score-triggered psychiatry suggestion."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "2.2 CAM-ICU (Confusion Assessment Method for the ICU)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Implemented as the standard four-feature algorithm with an arousal gate. Performed once per shift and with any acute mental-status change."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Decision logic:",
     "b": 1
    }
   ]
  },
  {
   "t": "ol",
   "items": [
    [
     {
      "text": "Level of consciousness first (two-step assessment).",
      "b": 1
     },
     {
      "text": " The instrument's Step 1 is the RASS. The tool returns "
     },
     {
      "text": "no verdict until a RASS is documented",
      "b": 1
     },
     {
      "text": " (the result stays \"Incomplete\" with a \"document the RASS first\" prompt). If RASS is "
     },
     {
      "text": "−4 or −5",
      "b": 1
     },
     {
      "text": ", the result is "
     },
     {
      "text": "\"Unable to assess\"",
      "b": 1
     },
     {
      "text": " (patient too sedated); the tool instructs re-assessment when RASS ≥ −3 ("
     },
     {
      "text": "camicu_manual",
      "code": 1
     },
     {
      "text": " p.6)."
     }
    ],
    [
     {
      "text": "Feature 1: Acute onset or fluctuating course",
      "b": 1
     },
     {
      "text": " "
     },
     {
      "text": "(required)",
      "i": 1
     },
     {
      "text": ". Acute change from the mental-status baseline, OR "
     },
     {
      "text": "fluctuation in mental status in the past 24 hours",
      "b": 1
     },
     {
      "text": " (e.g., on RASS/GCS or a previous delirium assessment; the worksheet's 24-hour window, not \"during the day\"). The baseline is anchored from family/collateral "
     },
     {
      "text": "or the H&P",
      "b": 1
     },
     {
      "text": ", and a normal baseline may be presumed in a younger patient admitted from home with no known neurocognitive disease ("
     },
     {
      "text": "camicu_manual",
      "code": 1
     },
     {
      "text": " p.9); "
     },
     {
      "text": "documented 24-hour fluctuation satisfies Feature 1 even when no baseline informant is available",
      "b": 1
     },
     {
      "text": ". The two questions are an OR, so Feature 1 is never blocked on collateral (the on-page tip previously said Feature 1 \"cannot be scored without\" a collateral-anchored baseline, which was stricter than the instrument; corrected (see §6.5)."
     }
    ],
    [
     {
      "text": "Feature 2: Inattention",
      "b": 1
     },
     {
      "text": " "
     },
     {
      "text": "(required)",
      "i": 1
     },
     {
      "text": ". Letters task (\"SAVEAHAART\", 10 letters, ~1 every 3 s; squeeze on each \"A\"). "
     },
     {
      "text": "Cut-point: > 2 errors = positive",
      "b": 1
     },
     {
      "text": " (error entry constrained to 0–10). The "
     },
     {
      "text": "Pictures ASE",
      "b": 1
     },
     {
      "text": " alternative is the validated 10-item recognition task (show 5 pictures to memorize, then 10 recognition pictures, yes/no), "
     },
     {
      "text": "scored out of 10 with the same > 2-error cut-point",
      "b": 1
     },
     {
      "text": ". The threshold is equivalent across modalities. (The on-screen text previously described it loosely as \"5 cards,\" which has been corrected to the validated /10 form; cited to "
     },
     {
      "text": "camicu_worksheet",
      "code": 1
     },
     {
      "text": ".)"
     }
    ],
    [
     {
      "text": "Feature 3: Altered level of consciousness.",
      "b": 1
     },
     {
      "text": " "
     },
     {
      "text": "Positive if the actual RASS is anything other than alert and calm (zero)",
      "b": 1
     },
     {
      "text": "; negative only at RASS 0; the current worksheet's operationalization ("
     },
     {
      "text": "camicu_worksheet",
      "code": 1
     },
     {
      "text": "; the CAM-ICU is only performed at RASS ≥ −3). Feature 3 is read directly from the RASS documented in the same panel (there is no separate control to enter), so it can never contradict the documented arousal. (The earlier descriptor form, Alert vs Vigilant/Lethargic/Stuporous, the Ely-2001 Table-1 wording, was replaced with the worksheet criterion; see §6.5/§6.6.)"
     }
    ],
    [
     {
      "text": "Feature 4: Disorganized thinking.",
      "b": 1
     },
     {
      "text": " Four yes/no questions plus the command, worded per the worksheet: \"Hold up this many fingers\" (2 shown), then \"Now do the same thing with the other hand\" ("
     },
     {
      "text": "do not repeat the number of fingers",
      "b": 1
     },
     {
      "text": "); the \"add one more finger\" variant applies "
     },
     {
      "text": "only if the patient cannot move both arms",
      "b": 1
     },
     {
      "text": ". "
     },
     {
      "text": "Positive if combined errors > 1.",
      "b": 1
     }
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Result rule (displayed and enforced):",
     "b": 1
    },
    {
     "text": " "
    },
    {
     "text": "Positive if Feature 1 AND Feature 2 AND (Feature 3 OR Feature 4)",
     "b": 1
    },
    {
     "text": ", evaluated only once a RASS is documented (Step 1). Features 1 and 2 must both be answered before any result; if either is absent the screen is Negative; if 1 and 2 are positive but both secondary features are assessed and negative the screen is Negative; otherwise \"Incomplete\" until a secondary feature is assessed."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The result panel reinforces that "
    },
    {
     "text": "\"A positive CAM-ICU is a screen, not a diagnosis: confirm clinically and exclude mimics,\"",
     "i": 1
    },
    {
     "text": " and provides a delirium-vs-mimics differential (dementia, depression, receptive aphasia/focal stroke, non-convulsive seizures, catatonia, intoxication/withdrawal). "
    },
    {
     "text": "ICDSC",
     "b": 1
    },
    {
     "text": " ("
    },
    {
     "text": "icdsc_bergeron",
     "code": 1
    },
    {
     "text": ") is the validated adult-ICU alternative screen. PADIS endorses CAM-ICU and ICDSC, and the Setup \"Screening Tool\" selector offers these two. CAM-ICU is validated for the adult ICU only; the pathway picker carries a prominent scope panel directing out-of-ICU users to the setting-appropriate validated tool (§4, item 2)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Citations mapped (CAM tab):",
     "b": 1
    },
    {
     "text": " "
    },
    {
     "text": "inouye1990",
     "code": 1
    },
    {
     "text": " (the parent CAM), "
    },
    {
     "text": "camicu_worksheet",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "camicu_manual",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "ely2001",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "ely2003",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "sessler2002",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "icdsc_bergeron",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "dsm5tr",
     "code": 1
    },
    {
     "text": " (the diagnostic reference standard), "
    },
    {
     "text": "hayhurst2016",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "icudelirium_monitoring",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "nice_cg103",
     "code": 1
    },
    {
     "text": ". (CAM-ICU validation → "
    },
    {
     "text": "ely2001",
     "code": 1
    },
    {
     "text": "; worksheet/Pictures-ASE operationalization → "
    },
    {
     "text": "camicu_worksheet",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "icudelirium_monitoring",
     "code": 1
    },
    {
     "text": "; baseline sources and the agitated-patient / UTA rules → "
    },
    {
     "text": "camicu_manual",
     "code": 1
    },
    {
     "text": "; accuracy limitations → "
    },
    {
     "text": "hayhurst2016",
     "code": 1
    },
    {
     "text": ".)"
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "2.3 RASS (Richmond Agitation-Sedation Scale)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Range:",
     "b": 1
    },
    {
     "text": " the full "
    },
    {
     "text": "+4 to −5",
     "b": 1
    },
    {
     "text": " scale (+4 Combative, +3 Very Agitated, +2 Agitated, +1 Restless, 0 Alert & Calm, −1 Drowsy, −2 Light Sedation, −3 Moderate Sedation, −4 Deep Sedation, −5 Unarousable)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Target band:",
     "b": 1
    },
    {
     "text": " "
    },
    {
     "text": "0 to −2",
     "b": 1
    },
    {
     "text": " (light sedation; the ICU default, and the only target savable/shareable as a default). The Setup tab also offers "
    },
    {
     "text": "0 to −1 (general ward)",
     "i": 1
    },
    {
     "text": " and a deeper "
    },
    {
     "text": "−3 to −4 (deep: indication required)",
     "i": 1
    },
    {
     "text": " band. The deep band is "
    },
    {
     "text": "indication-gated",
     "b": 1
    },
    {
     "text": ": selecting it reveals a required \"indication for deeper sedation\" field and a caution that deeper sedation is "
    },
    {
     "text": "associated with",
     "i": 1
    },
    {
     "text": " longer ventilation, more delirium, and higher mortality (observational evidence + one small RCT; PADIS conditional, low-certainty). (RASS −2 is "
    },
    {
     "text": "light",
     "i": 1
    },
    {
     "text": " sedation and −3 "
    },
    {
     "text": "moderate",
     "i": 1
    },
    {
     "text": " per the scale anchors, so the earlier \"−2 to −3 (moderate sedation)\" label was corrected. A light −2 target is never gated.)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Color/zoning of the RASS strip: follows the configured target band.",
     "b": 1
    },
    {
     "text": " Green (at target) = every RASS inside the configured band; amber (caution) = restless/agitation short of intervention and the level one step off-goal; red = marked agitation (+2/+3/+4) and over-sedation (≥ 2 levels below the band); "
    },
    {
     "text": "RASS −5 (unarousable) is always red",
     "b": 1
    },
    {
     "text": ", regardless of the configured target, so a deep target cannot mask an over-sedated patient. For the 0 to −2 default this is green 0/−1/−2, amber +1 and −3, red +2/+3/+4 and −4/−5. The patient-RASS dropdown's ✓ TARGET markers and the printed "
    },
    {
     "text": "[TARGET]",
     "code": 1
    },
    {
     "text": " rows are driven by the same band, so a reconfigured target stays consistent on screen and in the PDF. RASS −4/−5 also triggers the CAM-ICU \"unable to assess\" gate (§2.2). Per-level advisory prompts are provided and were source-aligned in the 2026-07-01 revision: agitation prompts are non-pharmacologic-first (pharmacologic control reserved for danger to the patient or staff, per PADIS 2018); reassessment intervals defer to unit protocol (no interval is source-defined); −4 states the "
    },
    {
     "text": "association",
     "i": 1
    },
    {
     "text": " between deeper sedation and delirium/delayed extubation/mortality (PADIS 2018 observational evidence) with daily reassessment/SAT unless deeper sedation is indicated; −5 carries the instrument's stop-and-recheck directive (CAM-ICU unable to assess) with neurologic evaluation only when unresponsiveness is unexplained by sedation."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Citations mapped:",
     "b": 1
    },
    {
     "text": " "
    },
    {
     "text": "sessler2002",
     "code": 1
    },
    {
     "text": " (original RASS validation), "
    },
    {
     "text": "ely2003",
     "code": 1
    },
    {
     "text": " (RASS reliability/validity over time in ICU), with "
    },
    {
     "text": "rass_mdcalc",
     "code": 1
    },
    {
     "text": " available in the registry as a scoring-procedure reference."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "2.4 Delirium motor subtype"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "A three-option classifier (Hyperactive / Hypoactive / Mixed) with teaching notes. The percentages are the "
    },
    {
     "text": "proportion of patients *with* delirium by motor subtype",
     "b": 1
    },
    {
     "text": " (la Cour 2022: hypoactive 50.3% / mixed 27.7% / hyperactive 22.7%). This is "
    },
    {
     "text": "not",
     "b": 1
    },
    {
     "text": " the population prevalence of delirium (Krewulak 2018: ~31% overall, a different denominator). The on-screen and PDF wording now states this denominator explicitly and avoids the bare word \"prevalence.\""
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "Subtype"
     }
    ],
    [
     {
      "text": "Description (proportion of delirious cases — la Cour 2022)"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "Hyperactive"
      }
     ],
     [
      {
       "text": "\"~23% of delirious cases, least common\"; agitation, line-pulling, combativeness"
      }
     ]
    ],
    [
     [
      {
       "text": "Hypoactive"
      }
     ],
     [
      {
       "text": "\"~50% of delirious cases, most common\"; somnolence, reduced responsiveness; \"frequently missed and associated with poor outcomes\""
      }
     ]
    ],
    [
     [
      {
       "text": "Mixed"
      }
     ],
     [
      {
       "text": "\"~28% of delirious cases\"; alternating features; \"associated with the longest duration and length of stay\""
      }
     ]
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Citations mapped (Mnemonic tab reference list):",
     "b": 1
    },
    {
     "text": " "
    },
    {
     "text": "lacour2022",
     "code": 1
    },
    {
     "text": " (motor-subtype distribution scoping review, the source of the proportions), "
    },
    {
     "text": "krewulak2018",
     "code": 1
    },
    {
     "text": " (overall-prevalence meta-analysis, the distinct population denominator), "
    },
    {
     "text": "hayhurst2020",
     "code": 1
    },
    {
     "text": " (subtype and post-critical-illness cognition). The figures are approximate, drawn from these cited reviews rather than exact single-source constants."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "2.5 ABCDEF / ICU Liberation prevention bundle"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Non-pharmacologic, first-line for all patients, documented each shift. A live completion percentage and per-letter status indicator are computed from the checked items."
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "Letter"
     }
    ],
    [
     {
      "text": "Element"
     }
    ],
    [
     {
      "text": "Notable embedded logic"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "A",
       "b": 1
      }
     ],
     [
      {
       "text": "Assess, Prevent & Manage Pain"
      }
     ],
     [
      {
       "text": "NRS if able to self-report; CPOT/BPS if not"
      }
     ]
    ],
    [
     [
      {
       "text": "B",
       "b": 1
      }
     ],
     [
      {
       "text": "Both SAT & SBT"
      }
     ],
     [
      {
       "text": "Includes a full SAT/SBT safety screen and failure criteria (SAT contraindications; SAT failure → restart sedation at "
      },
      {
       "text": "half",
       "b": 1
      },
      {
       "text": " prior dose; SBT proceed criteria SpO₂ ≥ 88% on FiO₂ ≤ 50% & PEEP ≤ 7.5 — the ABC-trial screen; SBT failure → resume full ventilatory support, half-dose sedation restart if needed; re-screen in 24 h), cited inline to "
      },
      {
       "text": "girard2008",
       "code": 1
      },
      {
       "text": " + "
      },
      {
       "text": "icudelirium_satsbt",
       "code": 1
      },
      {
       "text": ". (An earlier revision printed \"pH > 7.15\", which appears in no ABC-trial primary source — removed 2026-07-01.)"
      }
     ]
    ],
    [
     [
      {
       "text": "C",
       "b": 1
      }
     ],
     [
      {
       "text": "Choice of Analgesia & Sedation"
      }
     ],
     [
      {
       "text": "eCASH",
       "b": 1
      },
      {
       "text": " framing (Vincent 2016); target RASS 0 to −2; benzodiazepines minimized, a non-benzodiazepine sedative preferred — in ventilated adults consider dexmedetomidine over propofol when light sedation, delirium reduction, or agitation preventing weaning is a priority (PADIS 2025 conditional, "
      },
      {
       "text": "padis2025",
       "code": 1
      },
      {
       "text": "); analgesia-first; bolus over continuous infusion labeled an observational association (Kollef 1998 — PADIS classifies intermittent-vs-continuous as an evidence gap)"
      }
     ]
    ],
    [
     [
      {
       "text": "D",
       "b": 1
      }
     ],
     [
      {
       "text": "Delirium: Assess, Prevent & Manage"
      }
     ],
     [
      {
       "text": "CAM-ICU this shift; RASS documented; precipitants addressed; family education"
      }
     ]
    ],
    [
     [
      {
       "text": "E",
       "b": 1
      }
     ],
     [
      {
       "text": "Early Mobility & Exercise"
      }
     ],
     [
      {
       "text": "Safety screen (\"reddest parameter wins\") covering respiratory/cardiovascular/neuro/lines, then a 5-step progression (passive ROM → active ROM → sit/edge of bed → stand/transfer → ambulate)"
      }
     ]
    ],
    [
     [
      {
       "text": "F",
       "b": 1
      }
     ],
     [
      {
       "text": "Family Engagement & Empowerment"
      }
     ],
     [
      {
       "text": "Presence, education, familiar objects/T-A-D-A, glasses/hearing aids, music"
      }
     ]
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "A separate "
    },
    {
     "text": "Sleep & Orientation Measures",
     "b": 1
    },
    {
     "text": " card (quiet-hours, eye mask/earplugs, orientation board, clustered cares, clock/calendar, reorientation, oral care/hydration) accompanies the bundle."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Citations mapped (Bundle tab):",
     "b": 1
    },
    {
     "text": " "
    },
    {
     "text": "sccm_abcdef",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "pun2019",
     "code": 1
    },
    {
     "text": " (ICU Liberation Collaborative, >15,000 adults), "
    },
    {
     "text": "marra2017",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "balas2014",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "padis2018",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "padis2025",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "inouye1999",
     "code": 1
    },
    {
     "text": " (HELP RCT), "
    },
    {
     "text": "hshieh2015",
     "code": 1
    },
    {
     "text": " (non-pharm meta-analysis), "
    },
    {
     "text": "icudelirium_satsbt",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "schweickert2009",
     "code": 1
    },
    {
     "text": " (early-mobility RCT, the element-E efficacy trial), "
    },
    {
     "text": "hodgson2014",
     "code": 1
    },
    {
     "text": " (mobilization safety criteria, cited inline at element E), "
    },
    {
     "text": "nice_cg103",
     "code": 1
    },
    {
     "text": ". "
    },
    {
     "text": "eCASH is cited inline to `ecash2016` (Vincent 2016, the concept paper) plus `padis2018`",
     "b": 1
    },
    {
     "text": " (which carries the analgesia-first / light-sedation content); the bolus-over-continuous item is cited to "
    },
    {
     "text": "kollef1998",
     "code": 1
    },
    {
     "text": " and labeled an observational association; eye mask/earplugs to "
    },
    {
     "text": "padis2018",
     "code": 1
    },
    {
     "text": ". (An earlier revision cited eCASH to "
    },
    {
     "text": "padis2025",
     "code": 1
    },
    {
     "text": ", which contains no eCASH or analgesia-first recommendation; corrected, see §6.5.)"
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "2.6 DELIRIUM(S) mnemonic (causative-factor review)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Nine review domains, each with a \"Reviewed\" toggle, a prompt, and a free-text action field; a progress strip tracks domains reviewed."
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "Letter"
     }
    ],
    [
     {
      "text": "Domain"
     }
    ],
    [
     {
      "text": "Prompt highlights"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "D",
       "b": 1
      }
     ],
     [
      {
       "text": "Drugs / Withdrawal"
      }
     ],
     [
      {
       "text": "Deliriogenic agents; dose reduction; alcohol/benzo/opioid withdrawal — in the ICU titrate to an objective scale such as RASS; CIWA-Ar needs an awake, communicative, non-delirious patient ("
      },
      {
       "text": "asam2020",
       "code": 1
      },
      {
       "text": ")"
      }
     ]
    ],
    [
     [
      {
       "text": "E",
       "b": 1
      }
     ],
     [
      {
       "text": "Eyes / Ears (sensory deficits)"
      }
     ],
     [
      {
       "text": "Glasses & hearing aids; other sensory deficits (environment prompts live under Dr. DRE per the cited source)"
      }
     ]
    ],
    [
     [
      {
       "text": "L",
       "b": 1
      }
     ],
     [
      {
       "text": "Low O₂ states"
      }
     ],
     [
      {
       "text": "SpO₂, Hgb; MI, stroke, pulmonary embolism (liver function reviews under M — Metabolic)"
      }
     ]
    ],
    [
     [
      {
       "text": "I",
       "b": 1
      }
     ],
     [
      {
       "text": "Infection"
      }
     ],
     [
      {
       "text": "Fever, leukocytosis, cultures, occult sepsis"
      }
     ]
    ],
    [
     [
      {
       "text": "R",
       "b": 1
      }
     ],
     [
      {
       "text": "Retention"
      }
     ],
     [
      {
       "text": "Urinary retention/constipation; bladder scan; disimpact/catheterize"
      }
     ]
    ],
    [
     [
      {
       "text": "I",
       "b": 1
      }
     ],
     [
      {
       "text": "Ictal / Seizure"
      }
     ],
     [
      {
       "text": "Non-convulsive seizures/status; consider EEG with unexplained ↓LOC"
      }
     ]
    ],
    [
     [
      {
       "text": "U",
       "b": 1
      }
     ],
     [
      {
       "text": "Under-hydration / Nutrition"
      }
     ],
     [
      {
       "text": "Volume/electrolytes; "
      },
      {
       "text": "parenteral thiamine promptly in at-risk patients — do not delay glucose for hypoglycemia",
       "b": 1
      },
      {
       "text": " (ASAM 2020: either order or concurrent, "
      },
      {
       "text": "asam2020",
       "code": 1
      },
      {
       "text": "; EFNS still advises thiamine before carbohydrate, a disclosed guideline divergence) — at-risk 100–300 mg IV daily ("
      },
      {
       "text": "espen_icu",
       "code": 1
      },
      {
       "text": "); suspected Wernicke, guidelines diverge (low-certainty): EFNS 200 mg IV TID ("
      },
      {
       "text": "efns_wernicke",
       "code": 1
      },
      {
       "text": ") or RCP 500 mg IV TID × 2–3 days then 250 mg taper ("
      },
      {
       "text": "rcp_wernicke",
       "code": 1
      },
      {
       "text": ")"
      }
     ]
    ],
    [
     [
      {
       "text": "M",
       "b": 1
      }
     ],
     [
      {
       "text": "Metabolic"
      }
     ],
     [
      {
       "text": "Na, Mg, Ca, glucose, BUN/Cr, acid-base, liver function"
      }
     ]
    ],
    [
     [
      {
       "text": "(S)",
       "b": 1
      }
     ],
     [
      {
       "text": "Subdural / Sleep"
      }
     ],
     [
      {
       "text": "Subdural hematoma (fall/anticoagulation); sleep deprivation"
      }
     ]
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Citations mapped:",
     "b": 1
    },
    {
     "text": " "
    },
    {
     "text": "icudelirium_mnemonics",
     "code": 1
    },
    {
     "text": " (the Vanderbilt DELIRIUM(S) differential), "
    },
    {
     "text": "flaherty2011",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "maldonado2018",
     "code": 1
    },
    {
     "text": " (delirium pathophysiology), "
    },
    {
     "text": "inouye_charpentier1996",
     "code": 1
    },
    {
     "text": " (precipitating-factor model), "
    },
    {
     "text": "asam2020",
     "code": 1
    },
    {
     "text": " (thiamine/glucose ordering; withdrawal-scale selection), "
    },
    {
     "text": "espen_icu",
     "code": 1
    },
    {
     "text": " / "
    },
    {
     "text": "efns_wernicke",
     "code": 1
    },
    {
     "text": " / "
    },
    {
     "text": "rcp_wernicke",
     "code": 1
    },
    {
     "text": " (the at-risk and divergent Wernicke thiamine regimens), plus the subtype sources "
    },
    {
     "text": "lacour2022",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "krewulak2018",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "hayhurst2020",
     "code": 1
    },
    {
     "text": "."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "2.7 Treatment algorithm"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Applies when CAM-ICU is positive. The governing principle is "
    },
    {
     "text": "\"Non-pharmacological interventions are the cornerstone of treatment. Pharmacologic therapy is reserved for patient safety concerns only.\"",
     "i": 1
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Visual decision tree:",
     "b": 1
    },
    {
     "text": " entry for the acutely agitated patient (RASS +2 to +4: the entry node states that agitation does "
    },
    {
     "text": "not",
     "b": 1
    },
    {
     "text": " make a patient \"unable to assess\": CAM-ICU is still performed, a patient too agitated to participate scores inattentive, and UTA is reserved for RASS −4/−5, "
    },
    {
     "text": "camicu_manual",
     "code": 1
    },
    {
     "text": " pp.5-6/12/20; an earlier wording implied CAM-ICU \"may read unable to assess\" in the agitated patient; corrected, see §6.5) → rule out/treat reversible causes (pain, hypoxia, hypoglycaemia, alcohol/benzo withdrawal, urinary retention, new deliriogenic med) → "
    },
    {
     "text": "verbal de-escalation first",
     "b": 1
    },
    {
     "text": " → branch on CAM-ICU result (Negative → continue prevention; Unable to assess at RASS −4/−5 → re-screen when RASS ≥ −3; Positive → management) → "
    },
    {
     "text": "Dr. DRE",
     "b": 1
    },
    {
     "text": " (Diseases, Drug removal, Remove Environmental contributors) → intensify ABCDEF → safety-risk decision determining whether short, lowest-dose pharmacotherapy is warranted."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Working checklist (Steps 1–3):",
     "b": 1
    }
   ]
  },
  {
   "t": "ul",
   "items": [
    [
     {
      "text": "Step 1. Identify & treat the underlying cause:",
      "b": 1
     },
     {
      "text": " electrolytes; occult infection/sepsis (CBC, cultures, UA when clinically indicated; do not attribute delirium to asymptomatic bacteriuria, "
     },
     {
      "text": "nicolle2019",
      "code": 1
     },
     {
      "text": "); oxygenation/ventilation; retention/constipation/pain; "
     },
     {
      "text": "alcohol/benzo withdrawal titrated to an objective scale (RASS)",
      "b": 1
     },
     {
      "text": " ("
     },
     {
      "text": "\"CIWA-Ar is not validated in intubated / sedated / delirious patients\"",
      "i": 1
     },
     {
      "text": "; ASAM 2020 recommends objective scales (CAM-ICU, DDS, RASS, MINDS) in withdrawal delirium and names RASS for ICU monitoring, "
     },
     {
      "text": "asam2020",
      "code": 1
     },
     {
      "text": "); brain imaging if focal neuro signs."
     }
    ],
    [
     {
      "text": "Step 2. Intensify non-pharmacologic measures:",
      "b": 1
     },
     {
      "text": " full ABCDEF; family/volunteer presence; 1:1 sitter if active safety risk; geriatric/psychiatric consult."
     }
    ],
    [
     {
      "text": "Step 3. Pharmacologic (safety indication only):",
      "b": 1
     },
     {
      "text": " antipsychotics "
     },
     {
      "text": "\"have not been shown to treat or shorten delirium (MIND-USA negative; PADIS 2025: unable to recommend for or against)\"",
      "i": 1
     },
     {
      "text": ". The no-demonstrated-benefit clause is anchored to "
     },
     {
      "text": "mindusa2018",
      "code": 1
     },
     {
      "text": " and the no-recommendation clause to "
     },
     {
      "text": "padis2025",
      "code": 1
     },
     {
      "text": ", on screen and in the PDFs (the earlier categorical \"do not treat or shorten\" asserted more than the evidence: PADIS 2025's pooled estimates are equivocal, so the verb was softened on every surface; see §6.5); requires documented safety indication, baseline QTc (haloperidol caution if > 500 ms), lowest effective dose, daily reassessment for discontinuation, "
     },
     {
      "text": "no scheduled antipsychotics at discharge without a psychiatric indication",
      "b": 1
     },
     {
      "text": ", and a \"do NOT stop abruptly\" list (benzodiazepines, opioids, SSRIs, steroids, antiepileptics, dexmedetomidine)."
     }
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Supporting frameworks:",
     "b": 1
    },
    {
     "text": " "
    },
    {
     "text": "T-A-D-A",
     "b": 1
    },
    {
     "text": " (Tolerate / Anticipate / Don't Agitate; Flaherty & Little 2011, "
    },
    {
     "text": "flaherty_little2011",
     "code": 1
    },
    {
     "text": "); a "
    },
    {
     "text": "7-step Nurse Care Pathway",
     "b": 1
    },
    {
     "text": " (1 Deter · 2 Detect · 3 Do (Acute) · 4–6 Daily · 7 Discharge); and a note that restraints are the last resort after de-escalation, environment, device removal, and 1:1 observation: least-restrictive option, re-evaluated per institutional policy, discontinued at the earliest possible time ("
    },
    {
     "text": "nice_ng10",
     "code": 1
    },
    {
     "text": "; NG10 itself sets shorter review intervals for restrictive interventions rather than a daily rule, which is why the earlier \"re-evaluate daily\" wording was dropped)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Citations mapped (Treatment tab):",
     "b": 1
    },
    {
     "text": " "
    },
    {
     "text": "projectbeta",
     "code": 1
    },
    {
     "text": " (verbal de-escalation, APA Project BETA: inline at the de-escalation node; \"≥ 2 arms' lengths\" per Richmond 2012), "
    },
    {
     "text": "icudelirium_mnemonics",
     "code": 1
    },
    {
     "text": " (Dr. DRE: the mnemonic is a Vanderbilt CIBS teaching aid; it does not appear in Hayhurst 2016, to which it was previously miscited), "
    },
    {
     "text": "flaherty_little2011",
     "code": 1
    },
    {
     "text": " (T-A-D-A), "
    },
    {
     "text": "awissi2013",
     "code": 1
    },
    {
     "text": " (no withdrawal scale, including CIWA-Ar, is validated in ICU patients; the claim previously carried only the MDCalc scale link), "
    },
    {
     "text": "asam2020",
     "code": 1
    },
    {
     "text": " (objective withdrawal monitoring in delirium; CIWA-Ar prerequisites), "
    },
    {
     "text": "ciwa_mdcalc",
     "code": 1
    },
    {
     "text": " (CIWA-Ar scale reference), "
    },
    {
     "text": "nicolle2019",
     "code": 1
    },
    {
     "text": " (asymptomatic bacteriuria in delirium: observe, work up other causes), "
    },
    {
     "text": "padis2025",
     "code": 1
    },
    {
     "text": " / "
    },
    {
     "text": "padis2018",
     "code": 1
    },
    {
     "text": " (antipsychotic stance and prevention), "
    },
    {
     "text": "mindusa2018",
     "code": 1
    },
    {
     "text": " (haloperidol/ziprasidone RCT), "
    },
    {
     "text": "nice_ng10",
     "code": 1
    },
    {
     "text": " (restraints / management of aggression), "
    },
    {
     "text": "hshieh2015",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "balas2014",
     "code": 1
    },
    {
     "text": "."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "2.8 Medication tables and deliriogenic-medication list"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Pharmacologic options table (safety indication only), doses as shown:",
     "b": 1
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "Drug"
     }
    ],
    [
     {
      "text": "Typical dose"
     }
    ],
    [
     {
      "text": "Key notes (abridged)"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "Haloperidol"
      }
     ],
     [
      {
       "text": "0.25–0.5 mg q4–6h PRN; lowest effective dose, cap per local protocol"
      }
     ],
     [
      {
       "text": "Elderly more sensitive (EPS/QTc); ECG baseline; QTc caution > 500 ms; avoid Parkinson/Lewy; dementia-mortality boxed warning; IV route off-label (higher QT/Torsades); stop & escalate if NMS"
      }
     ]
    ],
    [
     [
      {
       "text": "Quetiapine"
      }
     ],
     [
      {
       "text": "12.5–25 mg q12h PO; lowest dose, shortest duration"
      }
     ],
     [
      {
       "text": "Sedating; orthostatic hypotension; QTc prolongation; antipsychotic-class boxed warning"
      }
     ]
    ],
    [
     [
      {
       "text": "Dexmedetomidine"
      }
     ],
     [
      {
       "text": "0.2–0.7 mcg/kg/hr IV infusion — the label's ICU-sedation maintenance range ("
      },
      {
       "text": "dex_label",
       "code": 1
      },
      {
       "text": ")"
      }
     ],
     [
      {
       "text": "In ventilated adults: agitation precluding weaning/extubation (PADIS 2018, conditional); or where light sedation/delirium reduction is the highest priority — suggested over propofol (PADIS 2025 Rec 2). A2B RCT caveat ("
      },
      {
       "text": "a2b2025",
       "code": 1
      },
      {
       "text": "): no extubation benefit vs propofol, more agitation and severe bradycardia — reserve the preference for the delirium/light-sedation priority. Monitor bradycardia/hypotension"
      }
     ]
    ],
    [
     [
      {
       "text": "Lorazepam "
      },
      {
       "text": "(specific use)",
       "i": 1
      }
     ],
     [
      {
       "text": "Symptom-triggered per institutional withdrawal protocol"
      }
     ],
     [
      {
       "text": "Rescue / alcohol withdrawal "
      },
      {
       "text": "only",
       "b": 1
      },
      {
       "text": " — may worsen delirium; in delirious / intubated / sedated ICU patients monitor withdrawal with an objective scale (RASS, CAM-ICU, MINDS), not CIWA-Ar ("
      },
      {
       "text": "asam2020",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "awissi2013",
       "code": 1
      },
      {
       "text": ")"
      }
     ]
    ],
    [
     [
      {
       "text": "Melatonin"
      }
     ],
     [
      {
       "text": "0.5–3 mg nightly — labeled conventional sleep dosing, "
      },
      {
       "text": "not drawn from the cited trials",
       "b": 1
      },
      {
       "text": " (Pro-MEDIC used 4 mg; cited ICU trials 3–5 mg; PADIS 2025 makes no dose recommendation)"
      }
     ],
     [
      {
       "text": "PADIS 2025 conditionally suggests melatonin in adult ICU patients (low certainty; may reduce delirium prevalence and improve perceived sleep) ("
      },
      {
       "text": "padis2025",
       "code": 1
      },
      {
       "text": "); the largest RCT (Pro-MEDIC) was negative ("
      },
      {
       "text": "promedic2022",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "melatonin_meta2025",
       "code": 1
      },
      {
       "text": "); not a treatment for established delirium. Ramelteon is named by PADIS 2025 as the FDA-regulated melatonin-receptor-agonist alternative"
      }
     ]
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "These doses are "
    },
    {
     "text": "conventional / expert starting references",
     "b": 1
    },
    {
     "text": " for short-term agitation control, "
    },
    {
     "text": "not RCT- or guideline-calibrated doses for delirium",
     "b": 1
    },
    {
     "text": " (no agent is guideline-recommended to treat delirium): haloperidol low-dose is off-label, quetiapine 12.5–25 mg is a conservative starting fraction, and dexmedetomidine 0.2–0.7 mcg/kg/hr is a "
    },
    {
     "text": "sedative infusion for ventilated patients, not a PRN antipsychotic-equivalent",
     "b": 1
    },
    {
     "text": ". The three are not interchangeable."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Deliriogenic-medication review list:",
     "b": 1
    },
    {
     "text": " "
    },
    {
     "text": "11 categories containing 103 individual agents",
     "b": 1
    },
    {
     "text": ", each independently toggleable. The three classes with the strongest / most-actionable ICU delirium signal ("
    },
    {
     "text": "benzodiazepines, opioids, and anticholinergics",
     "b": 1
    },
    {
     "text": ") are "
    },
    {
     "text": "enabled by default",
     "b": 1
    },
    {
     "text": "; the rest of the list is available but "
    },
    {
     "text": "off by default (opt-in)",
     "b": 1
    },
    {
     "text": " to reduce alert fatigue. Toggling an agent adds/removes it from the printed documents."
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "Category"
     }
    ],
    [
     {
      "text": "Agent count"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "Benzodiazepines"
      }
     ],
     [
      {
       "text": "9"
      }
     ]
    ],
    [
     [
      {
       "text": "Opioids / Analgesics"
      }
     ],
     [
      {
       "text": "10"
      }
     ]
    ],
    [
     [
      {
       "text": "Anticholinergics"
      }
     ],
     [
      {
       "text": "15"
      }
     ]
    ],
    [
     [
      {
       "text": "Sedatives / Hypnotics"
      }
     ],
     [
      {
       "text": "7"
      }
     ]
    ],
    [
     [
      {
       "text": "Antipsychotics (high-dose / typical)"
      }
     ],
     [
      {
       "text": "6"
      }
     ]
    ],
    [
     [
      {
       "text": "Antidepressants / Mood (anticholinergic)"
      }
     ],
     [
      {
       "text": "8"
      }
     ]
    ],
    [
     [
      {
       "text": "Antimicrobials"
      }
     ],
     [
      {
       "text": "13"
      }
     ]
    ],
    [
     [
      {
       "text": "Cardiovascular / Cardiac"
      }
     ],
     [
      {
       "text": "8"
      }
     ]
    ],
    [
     [
      {
       "text": "Corticosteroids / Immunosuppressants"
      }
     ],
     [
      {
       "text": "7"
      }
     ]
    ],
    [
     [
      {
       "text": "GI / Antiemetics / H2 blockers"
      }
     ],
     [
      {
       "text": "6"
      }
     ]
    ],
    [
     [
      {
       "text": "Other / Miscellaneous"
      }
     ],
     [
      {
       "text": "14"
      }
     ]
    ],
    [
     [
      {
       "text": "Total",
       "b": 1
      }
     ],
     [
      {
       "text": "103",
       "b": 1
      }
     ]
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The list is explicitly framed as "
    },
    {
     "text": "\"a medication-review prompt, not a list of equally harmful drugs\"",
     "i": 1
    },
    {
     "text": ": risk varies by agent, dose, route, renal/hepatic function, interactions, and temporal association. A citation-backed "
    },
    {
     "text": "higher-risk",
     "b": 1
    },
    {
     "text": " marker (a binary flag, not an invented ordinal tier) is shown on the agents with the clearest evidence: "
    },
    {
     "text": "benzodiazepines",
     "b": 1
    },
    {
     "text": " (PADIS), "
    },
    {
     "text": "strong anticholinergics",
     "b": 1
    },
    {
     "text": " (AGS Beers Table 7 / Anticholinergic Cognitive Burden scale), and "
    },
    {
     "text": "meperidine",
     "b": 1
    },
    {
     "text": " (Beers; higher neurotoxicity risk than other opioids). "
    },
    {
     "text": "Glycopyrrolate carries no higher-risk flag",
     "b": 1
    },
    {
     "text": ": it appears in neither anchor (Beers Table 7 nor the ACB scale) and is a quaternary ammonium with minimal CNS penetration; it stays on the list as a review-prompt item only. "
    },
    {
     "text": "Dexmedetomidine is not on the list",
     "b": 1
    },
    {
     "text": ": it is the preferred, delirium-sparing sedative (PADIS 2025 / MENDS2); its only caution (rebound on abrupt withdrawal after a prolonged infusion) lives on the treatment tab's \"do NOT stop abruptly\" list. "
    },
    {
     "text": "Metoclopramide",
     "b": 1
    },
    {
     "text": " is grouped under GI / antiemetics (it is a D2 antagonist, not an anticholinergic). Renal/hepatic-accumulation cautions are included, each anchored to a source that actually carries it: meperidine: avoid, higher neurotoxicity risk ("
    },
    {
     "text": "beers2023",
     "code": 1
    },
    {
     "text": "); morphine/hydromorphone glucuronide metabolites accumulate in renal impairment with neuroexcitatory toxicity ("
    },
    {
     "text": "dean2004_renal",
     "code": 1
    },
    {
     "text": "; this claim is "
    },
    {
     "text": "not",
     "b": 1
    },
    {
     "text": " in Beers and is no longer cited to it); gabapentin/pregabalin: reduce dose at CrCl < 60, stated qualitatively per Beers Table 6 (the earlier \"~50%\" quantifier was removed as untraceable to the cited source). Beers Criteria are noted to apply to adults ≥ 65. The AGS 2025 "
    },
    {
     "text": "Beers Alternatives",
     "b": 1
    },
    {
     "text": " companion ("
    },
    {
     "text": "beers_alt2025",
     "code": 1
    },
    {
     "text": ") is referenced from the card as the evidence-based \"what to use instead\" resource."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Citations mapped (Medications tab):",
     "b": 1
    },
    {
     "text": " "
    },
    {
     "text": "beers2023",
     "code": 1
    },
    {
     "text": " (AGS Beers Criteria 2023), "
    },
    {
     "text": "beers_alt2025",
     "code": 1
    },
    {
     "text": " (AGS 2025 Alternatives companion), "
    },
    {
     "text": "acb_boustani",
     "code": 1
    },
    {
     "text": " (Anticholinergic Cognitive Burden scale: anchor for the anticholinergic higher-risk flag), "
    },
    {
     "text": "clegg2011",
     "code": 1
    },
    {
     "text": " (deliriogenic-medication systematic review), "
    },
    {
     "text": "pandharipande2006",
     "code": 1
    },
    {
     "text": " (benzodiazepine-to-delirium primary trial), "
    },
    {
     "text": "padis2025",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "padis2018",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "haldol_label",
     "code": 1
    },
    {
     "text": " (haloperidol prescribing information), "
    },
    {
     "text": "dex_label",
     "code": 1
    },
    {
     "text": " (Precedex prescribing information: the 0.2–0.7 mcg/kg/hr maintenance range), "
    },
    {
     "text": "quetiapine_label",
     "code": 1
    },
    {
     "text": " (quetiapine prescribing information: QTc/orthostasis caution), "
    },
    {
     "text": "mends2",
     "code": 1
    },
    {
     "text": " (MENDS2 dexmedetomidine vs propofol), "
    },
    {
     "text": "a2b2025",
     "code": 1
    },
    {
     "text": " (A2B RCT), "
    },
    {
     "text": "mindusa2018",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "promedic2022",
     "code": 1
    },
    {
     "text": " (Pro-MEDIC prophylactic-melatonin RCT), "
    },
    {
     "text": "melatonin_meta2025",
     "code": 1
    },
    {
     "text": " (2025 ICU melatonin systematic review / meta-analysis), "
    },
    {
     "text": "dean2004_renal",
     "code": 1
    },
    {
     "text": " (opioid metabolites in renal failure), "
    },
    {
     "text": "asam2020",
     "code": 1
    },
    {
     "text": " (lorazepam row: withdrawal-scale selection)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Printed SPA analgesia note:",
     "b": 1
    },
    {
     "text": " the SPA Quick Reference's acetaminophen line is deliberately "
    },
    {
     "text": "dose-free",
     "b": 1
    },
    {
     "text": " (\"scheduled acetaminophen, dose per local order set, avoid/reduce with hepatic impairment\"). PADIS 2018 recommends the adjunct without a dose, and the tool prints no analgesic regimen it cannot cite. (An earlier draft printed \"650–975 mg q6h\" with no source; removed.)"
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "2.9 Printable bedside templates (/templates/)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The template designer produces two laminate-ready sheets: an "
    },
    {
     "text": "ICU Delirium Rounding Tool",
     "b": 1
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "(per-patient landscape checklist marked with a dry-erase pen) and an "
    },
    {
     "text": "SPA Quick Reference",
     "b": 1
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "(unit-level portrait poster: Sedation · Pain/Pharmacy · Activity). The designer edits protocol"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "configuration only (facility name, section/item selection, medication selection, sedation"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "target, added local-protocol lines); no assessment or patient data is entered or printed."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Content provenance rule:",
     "b": 1
    },
    {
     "text": " every clinical statement on the sheets **mirrors the interactive"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "tool's cited content**. The sheets introduce no new clinical values. The mapping:"
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "Sheet block"
     }
    ],
    [
     {
      "text": "Mirrors"
     }
    ],
    [
     {
      "text": "Citations"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "Sedation goal / target RASS"
      }
     ],
     [
      {
       "text": "§2.3, §2.5 (eCASH light-sedation framing)"
      }
     ],
     [
      {
       "text": "padis2018",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "padis2025",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "icudelirium_satsbt",
       "code": 1
      }
     ]
    ],
    [
     [
      {
       "text": "CAM-ICU result options (incl. RASS −4/−5 unable-to-assess)"
      }
     ],
     [
      {
       "text": "§2.2"
      }
     ],
     [
      {
       "text": "camicu_worksheet",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "ely2001",
       "code": 1
      }
     ]
    ],
    [
     [
      {
       "text": "Delirium subtype (hyperactive / hypoactive / mixed)"
      }
     ],
     [
      {
       "text": "§2.4"
      }
     ],
     [
      {
       "text": "lacour2022",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "krewulak2018",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "hayhurst2020",
       "code": 1
      }
     ]
    ],
    [
     [
      {
       "text": "RASS mini-table (compact grouped rows)"
      }
     ],
     [
      {
       "text": "§2.3"
      }
     ],
     [
      {
       "text": "sessler2002",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "ely2003",
       "code": 1
      }
     ]
    ],
    [
     [
      {
       "text": "Causative factors — DELIRIUM(S), nine cells"
      }
     ],
     [
      {
       "text": "§2.6 (notes shortened to card length; the thiamine dosing detail stays on the web tool, the card says only \"thiamine promptly in at-risk patients — do not delay glucose\")"
      }
     ],
     [
      {
       "text": "icudelirium_mnemonics",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "flaherty2011",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "maldonado2018",
       "code": 1
      }
     ]
    ],
    [
     [
      {
       "text": "Non-pharmacologic bundle (six bedside groups)"
      }
     ],
     [
      {
       "text": "§2.5 items regrouped for bedside scanning (Reorientation / Sensory / Sleep / Mobility / Hydration & Nutrition / Engagement)"
      }
     ],
     [
      {
       "text": "sccm_abcdef",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "pun2019",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "marra2017",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "padis2018",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "inouye1999",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "hshieh2015",
       "code": 1
      }
     ]
    ],
    [
     [
      {
       "text": "Pharmacologic considerations"
      }
     ],
     [
      {
       "text": "§2.7 Step 3 + §2.8; "
      },
      {
       "text": "doses print only when \"example starting doses\" is switched on",
       "b": 1
      },
      {
       "text": " — the default defers to the local order set"
      }
     ],
     [
      {
       "text": "padis2025",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "mindusa2018",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "haldol_label",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "dex_label",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "mends2",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "padis2018",
       "code": 1
      }
     ]
    ],
    [
     [
      {
       "text": "Deliriogenic medications grid"
      }
     ],
     [
      {
       "text": "§2.8 registry — the designer's picker toggles the same per-agent flags"
      }
     ],
     [
      {
       "text": "beers2023",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "padis2018",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "acb_boustani",
       "code": 1
      }
     ]
    ],
    [
     [
      {
       "text": "SPA columns + deeper guidance + escalation ladder"
      }
     ],
     [
      {
       "text": "§2.5, §2.7, §2.8 statements recast as poster actions"
      }
     ],
     [
      {
       "text": "per-column keys in "
      },
      {
       "text": "src/js/templates/data/content.js",
       "code": 1
      }
     ]
    ],
    [
     [
      {
       "text": "Nurse care pathway (rounding sheet, step 4)"
      }
     ],
     [
      {
       "text": "Local unit workflow — the only uncited section.",
       "b": 1
      },
      {
       "text": " It carries process steps (documentation, handoff, teaching), not clinical values, is flagged \"unit workflow — edit to match your local protocol\" in the designer, and is fully editable/removable."
      }
     ],
     [
      {
       "text": "—"
      }
     ]
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Presentation rules.",
     "b": 1
    },
    {
     "text": " Medication names print "
    },
    {
     "text": "generic-only by default",
     "b": 1
    },
    {
     "text": ". Brand names in"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "the registry are stripped for the sheet (clinical qualifiers such as routes and \"high dose\""
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "always remain) and reappear only when the unit enables \"show brand names\". The designer's"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "default medication selection mirrors the interactive tool's documented defaults: the three"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "classes with the strongest, most actionable ICU delirium signal (**benzodiazepines, opioids,"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "anticholinergics**; PADIS 2018, AGS Beers 2023/ACB, §2.8), with the rest of the shared"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "catalog opt-in via per-category and select-all/none controls. The printed list is a mosaic of"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "color cards, one check-off square per medication, with the type size and column count"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "scaling to the selection so the full catalog still fits; a classic category-rows view remains"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "available."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The two pharmacology caution lines with the strongest bedside consequence carry a printed warning marker: benzodiazepines as withdrawal rescue only, and no antipsychotics at discharge without a psychiatric indication. The sedation-target"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "selector offers the interactive tool's three bands (0 to −2 light/ICU default; 0 to −1"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "general ward; −3 to −4 deep, which prints a \"documented indication required\" caveat) plus a"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "\"no unit target\" option that prints a write-in blank with a \"per prescriber order\" note."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "This is a presentation choice, not a new clinical value. Each RASS row carries a check mark"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "(circle) so the current level can be marked at the bedside. \"Save as"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "PDF\" captures the on-screen sheet itself. The PDF embeds a print-resolution image of the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "exact rendered sheet, so it cannot differ from the preview or the browser print output in any"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "way, and overlays interactive form fields at the captured elements' measured positions"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "(checkboxes over every check square, one mutually-exclusive radio group over the RASS"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "circles, text fields over the write-in blanks). The \"date created\" label defaults to the day"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "the configuration was created (editable); it and the optional \"revision\" label print in the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "footer and suffix the PDF filename for unit version-tracking. They carry no clinical"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "content. Reworded lines, added lines, and"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "unit-authored sections are local protocol content. Like the nurse care pathway, they carry no"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "citation and are the unit's responsibility."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Each printed sheet carries the verbatim reference-aid disclaimer and a footer source line"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "naming the primary guidelines. Unit tests enforce that every citation key in the template"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "content resolves in the registry, that the medication defaults track the shared catalog, that"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "brand-name stripping preserves clinical qualifiers, and that the disclaimer text stays"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "verbatim ("
    },
    {
     "text": "tests/unit/templates-data.test.js",
     "code": 1
    },
    {
     "text": ")."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "2.10 Pediatric bedside card set & PICU workflow poster (/templates/)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Two pediatric templates extend the designer: the "
    },
    {
     "text": "Peds Delirium Card Set",
     "b": 1
    },
    {
     "text": " (landscape pages"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "for lamination and ring-binding: arousal gate card, screen-routing card, CAPD card,"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "psCAM-ICU and pCAM-ICU cards, act-on-a-positive card, prevention-bundle card, and three"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "pages of attention picture cards with cut guides) and the "
    },
    {
     "text": "PICU Delirium Workflow",
     "b": 1
    },
    {
     "text": " poster"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "(landscape: screen → arousal gate → score → act, with the rounds reporting script)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Clinical values are "
    },
    {
     "text": "imported directly from the pediatric tool's data modules",
     "b": 1
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "("
    },
    {
     "text": "src/js/templates/data/peds-content.js",
     "code": 1
    },
    {
     "text": " imports "
    },
    {
     "text": "src/js/peds/data/…",
     "code": 1
    },
    {
     "text": "), so the printed cards"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "cannot carry different thresholds, scripts, or wording than the interactive tool: the arousal"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "scales and comatose floors (Curley 2006; Sessler 2002), the CAPD items, 0–4 frequency scale,"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "≥ 9 cut point, and developmental-delay caveat (Traube 2014; Gupta 2021), and the ps/pCAM-ICU"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "features, tasks, letter sequence, error thresholds, and the psCAM Feature-2 alternate"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "positivity path (Smith 2011; Smith 2016). The RASS row descriptions on the arousal card carry"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "the scale's published wording (Sessler 2002, as used on the validated pediatric assessment"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "card). Validated-instrument text is deliberately "
    },
    {
     "text": "not",
     "b": 1
    },
    {
     "text": " unit-editable in the designer."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "On the workflow poster, protocol lines are unit-editable like the adult sheets, but the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "lines carrying validated values (the comatose floors, the age routing, and the positivity"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "thresholds) are locked: always printed, never editable, and interpolated from the tool's"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "constants so they cannot drift. The card set and the poster print as landscape Letter pages (the bedside"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "ring-deck format)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The attention picture cards are "
    },
    {
     "text": "original artwork",
     "b": 1
    },
    {
     "text": " (drawn for this site as inline SVG)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The card faces are deliberately picture-only: naming the object or marking its set on the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "face would cue the recognition task's answer; set membership is listed on the clinician"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "instructions card instead."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The validated element of the picture tasks is the procedure (ten presentations for psCAM-ICU"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Feature 2; five memory pictures plus five \"other\" pictures for the pCAM-ICU memory-pictures"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "alternative), not the specific images; the instructions card notes that units may substitute"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "their validated picture set per local practice. Mirror tests pin the card content to the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "pediatric tool's modules ("
    },
    {
     "text": "tests/unit/templates-peds.test.js",
     "code": 1
    },
    {
     "text": ")."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Memory-pictures attention task inside the interactive tool.",
     "b": 1
    },
    {
     "text": " The pediatric tool ("
    },
    {
     "text": "/peds/",
     "code": 1
    },
    {
     "text": ")"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "runs the pCAM-ICU memory-pictures alternative to Feature 2 as an on-screen task, not only a printed"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "reference. Under Feature 2 it shows the five memory pictures, then steps through all ten recognition"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "pictures with a Seen / New control per picture, scoring errors live against each picture's set"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "membership: a memory picture answered \"new\", or a distractor answered \"seen\", is an error. Tapping"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "any picture, or the \"Present to child\" button, opens a large one-picture-at-a-time modal to turn"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "toward the bed: it walks the five memory pictures, then the ten recognition pictures where Seen / New"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "is picked in the modal and auto-advances (an accessible dialog: focus-trapped, Esc/arrow-key"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "operable). It"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "reuses the shared stimulus deck ("
    },
    {
     "text": "src/js/shared/stim-deck.js",
     "code": 1
    },
    {
     "text": ") and artwork"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "("
    },
    {
     "text": "src/js/templates/stim-art.js",
     "code": 1
    },
    {
     "text": "), so the on-screen task and the printed picture cards draw the same"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "set and cannot drift. Both Feature-2 tasks are offered together; either the squeeze-on-A letters or"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "the pictures reaching the ≥ 3-error cut makes Feature 2 positive"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "("
    },
    {
     "text": "src/js/peds/scoring.js",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "featurePresent",
     "code": 1
    },
    {
     "text": " / "
    },
    {
     "text": "pictureErrors",
     "code": 1
    },
    {
     "text": "; "
    },
    {
     "text": "tests/unit/peds-scoring.test.js",
     "code": 1
    },
    {
     "text": ")."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The card design system ("
    },
    {
     "text": ".pc-*",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": ".sheet",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": ".sh-*",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": ".tone-*",
     "code": 1
    },
    {
     "text": ") lives in a shared"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "src/styles/cards.css",
     "code": 1
    },
    {
     "text": " imported by both the designer and the pediatric tool."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "2.11 Emergency-department screening tool (/ed/)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The ED tool implements three guideline-backed screening pathways for older"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "emergency-department patients: the two-step DTS → bCAM, the bCAM directly"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "(the ACEP ED-DEL change package's option when screening high-risk patients"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "only), and the 4AT. The instruments are conditionally recommended by the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Geriatric Emergency Department Guidelines 2.0 delirium chapter (Lee 2026,"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "recommendation 4: \"4AT, bCAM, CAM-ICU, mCAM, AMT-4, or RASS may be used to"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "rule in or rule out delirium\"; recommendation 5: the DTS \"may be used to rule"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "out delirium\"; all conditional, very-low-certainty evidence). GED 2.0 makes"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "no recommendation for universal screening. It notes routine screening of all"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "older ED adults is resource-intensive and offers validated risk scores to"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "identify low-risk patients and reduce universal screening; the tool's Setup"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "tab carries that framing verbatim."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "**Two-step DTS → bCAM (Han 2013; Vanderbilt DTS/bCAM manuals v1.0; Geriatric"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "ED Guidelines 2014).** The Delirium Triage Screen is positive when the RASS is"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "anything other than 0, or the patient makes ≥2 errors spelling \"LUNCH\""
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "backwards (a missing letter is one error; refusal or inability to start is"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "positive; the task stops after a >15-second pause). Sensitivity 98% for both"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "physician and non-physician raters. A negative DTS makes delirium unlikely and, in the two-step pathway, does not require the bCAM on its own (GED 2.0 grades this rule-out very-low certainty; continue clinical evaluation if suspicion persists). A"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "positive DTS triggers the bCAM: Feature 1 (acute change or fluctuation, by"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "informant; assumed positive when no informant is available and Features 2 and"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "3-or-4 are positive) AND Feature 2 (months backwards December→July, >1 error"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "or unable; the required cardinal feature) AND (Feature 3: RASS ≠ 0, carried"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "over from the arousal assessment, OR Feature 4: four yes/no questions in"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "alternating sets plus a two-step command, ANY error positive). Physician"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "84%/95.8%, non-physician 78%/96.9%. RASS −4/−5 is stupor/coma: the tool"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "records \"unable to assess\" and directs reassessment, mirroring the CAM-ICU"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "and pediatric gates. The RASS rows carry the ED-adapted behavioral anchors"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "printed on the DTS/bCAM worksheets (e.g. −1 \"sustained awakening to voice"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": ">10 seconds\", −4 \"arousable to pain only\") rather than Sessler's ICU sedation"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "labels, because the 0 vs −1 boundary decides DTS positivity and −3 vs −4"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "decides the unable gate. Both attention tasks are tap-to-count flowsheets"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "(tap each missed letter/month; the error count scores the rule), and stale"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "answers are cleared when a gate closes (leaving RASS 0 clears the LUNCH task;"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "a negative DTS clears the bCAM features behind it)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "**4AT v1.2 (MacLullich/Ryan/Cash; free to use; SIGN 157 and NICE CG103 2023"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "recommend it for ED/acute settings).** Four items with the form's verbatim"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "anchors: alertness (0/4), AMT4 (age, date of birth, place, current year:"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "0/1/2), attention months-backwards (≥7 months = 0; starts but <7 = 1;"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "untestable = 2), acute change or fluctuating course (0/4), summing 0–12."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Bands per the form: ≥4 possible delirium ± cognitive impairment; 1–3 possible"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "cognitive impairment; 0 delirium unlikely (the tool carries the form's caveat"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "that 0 does not definitively exclude delirium when item-4 information is"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "incomplete). Validation: Bellelli 2014; Shenkin 2019 (randomised head-to-head"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "vs CAM: 4AT sensitivity 76% / specificity 94%); Tieges 2021 meta-analysis"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "(pooled sensitivity 0.88)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Validated instrument scripts and thresholds render verbatim from"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "src/js/ed/data/instruments.js",
     "code": 1
    },
    {
     "text": " and are pinned by golden-value tests"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "("
    },
    {
     "text": "tests/unit/ed-scoring.test.js",
     "code": 1
    },
    {
     "text": "); the act-on-a-positive content follows the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "ADEPT tool (Shenvi 2020) and the ACEP ED-DEL toolkit. The intro's"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "epidemiology (prevalence ~8–10%, with reported estimates ranging 6–38%;"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "~76% missed; 6-month mortality HR ≈ 1.7) carries Han 2009/2010 for the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "8–10% and missed-case figures and GED 2.0 for the 6–38% range (an earlier"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "\"8–17%\" figure appeared in none of the cited sources and was corrected;"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "see §6.5). The tool is de-identified by construction and"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "generates a local print/PDF summary only (assessor, editable assessment"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "time, pathway, scores, actions started, and de-identified notes). Out of"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "scope in this version: ED-specific risk-stratification scores (GED 2.0"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "recommendations 1–3), head-CT decision support (GED 2.0 recommendation 6"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "found insufficient evidence to recommend for or against), and agitation"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "pharmacotherapy; all listed for future work."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Licensing note.",
     "b": 1
    },
    {
     "text": " The 4AT is free to use (the4at.com; form © MacLullich,"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Ryan, Cash). The DTS and bCAM flowsheets are © 2012 Vanderbilt University"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "(\"not to be reproduced without permission\"; the underlying CAM algorithm is"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "© 2003 Hospital Elder Life Program, LLC), though the instruments and manuals"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "are distributed free from eddelirium.org for clinical use. The tool renders"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "the instruments' scripted wording for bedside fidelity; permission status for"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "public redistribution should be confirmed before wide promotion of this page."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "2.12 Emergency-department bedside card set & ED workflow poster (/templates/)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Two ED templates extend the designer: the "
    },
    {
     "text": "ED Delirium Card Set",
     "b": 1
    },
    {
     "text": " (portrait pocket cards for"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "lamination and ring-binding: a pathways card, a combined "
    },
    {
     "text": "Step 1 · DTS",
     "b": 1
    },
    {
     "text": " card that carries"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "the RASS ladder plus the LUNCH task, the bCAM confirmatory stepper card, the 4AT single-step"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "card, and an act-on-a-positive card) and the "
    },
    {
     "text": "ED Delirium Workflow",
     "b": 1
    },
    {
     "text": " poster (landscape:"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "screen → arousal gate → confirm → act, with the disposition hand-off script). Portrait suits"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "the ED instruments, whose validated forms are pocket cards/worksheets; the DTS is presented"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "as arousal + LUNCH on one card because the RASS score is its first step. They reuse the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "pediatric card design system ("
    },
    {
     "text": ".pc-*",
     "code": 1
    },
    {
     "text": ")."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Clinical values are "
    },
    {
     "text": "imported directly from the ED tool's data modules",
     "b": 1
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "("
    },
    {
     "text": "src/js/templates/data/ed-content.js",
     "code": 1
    },
    {
     "text": " imports "
    },
    {
     "text": "src/js/ed/data/instruments.js",
     "code": 1
    },
    {
     "text": " and "
    },
    {
     "text": "refs.js",
     "code": 1
    },
    {
     "text": "),"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "so the printed cards cannot carry different scripts, thresholds, or wording than the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "interactive tool: the ED-adapted RASS behavioral anchors (Vanderbilt DTS/bCAM worksheets;"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "scale Sessler 2002); the DTS positivity rule (altered arousal or ≥ 2 LUNCH-backwards errors"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "or unable → positive; RASS 0 with 0–1 errors → negative) and its LUNCH script; the bCAM"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "stepper: Feature 1 (acute change / fluctuation), Feature 2 (months-backward inattention, the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "required cardinal feature), Feature 3 (RASS ≠ 0), Feature 4 (the alternating question sets,"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "the two-step command, and the any-error rule) and the \"Feature 1 + Feature 2 + (Feature 3 or"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Feature 4)\" positivity rule; and the 4AT four items, point values, and 0 / 1–3 / ≥ 4 bands"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "with the form's caveat (Han 2013; the Vanderbilt manuals; the 4AT v1.2 form). The DTS and"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "bCAM error thresholds and the bCAM rule string are **interpolated from the instrument"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "constants"
    },
    {
     "text": " so the printed cut cannot drift. Validated-instrument text is deliberately ",
     "b": 1
    },
    {
     "text": "not**"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "unit-editable in the designer; the act-on-a-positive lines and the workflow poster's"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "protocol lines are unit-editable, while the poster's locked threshold lines (the DTS/bCAM/4AT"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "cuts and the RASS −4/−5 unable floor) are always printed and interpolated. The bCAM"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Feature-4 question set (A or B) is selectable in the designer's Your unit panel. Mirror"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "tests pin the card content to"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "the ED tool's modules ("
    },
    {
     "text": "tests/unit/templates-ed.test.js",
     "code": 1
    },
    {
     "text": ")."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "2.13 Adult step-down / progressive-care screening tool (/stepdown/)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The step-down tool screens the verbal, monitored-but-non-intubated"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "(intermediate-care / progressive-care) patient, where the CAM-ICU loses"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "sensitivity for the mild and hypoactive delirium common on the ward. It"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "implements the CAM-IMC as the screen, a RASS arousal gate, the Martinez"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "admission-risk rule, and a multicomponent non-pharmacologic prevention bundle."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The setting sits between the ICU tool (CAM-ICU) and a general acute ward, where"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "the ward-validated 3D-CAM or the 4AT apply (Marcantonio 2014; SIGN 157; NICE"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "CG103); the Setup tab carries that routing."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "CAM-IMC (Beyer 2024).",
     "b": 1
    },
    {
     "text": " A weighted, additive 0–10 screen, positive at ≥ 3 —"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "the Youden-index cut-off in the validation cohort — developed and validated in"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "non-intubated postoperative cardiac-surgery patients in an intermediate-care"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "unit (sensitivity 0.96, specificity 0.94). Four elements score into the total:"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "acute change or fluctuating course (dichotomous, +1) and altered level of"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "consciousness (dichotomous, RASS ≠ 0 → +1); inattention (0–3), read as the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "ten-letter word \"ANANASBAUM\" or \"CASABLANCA\" with a hand squeeze on each \"A\""
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "(one point per error, the item positive at ≥ 3 errors); and disorientation"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "(0–5) across five dimensions — age, date of birth, place, year, and situational"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "awareness — one point per error, the item positive at ≥ 2 errors. Unlike the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "CAM-ICU, the point system does not gate on a positive acute-change feature:"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "disorientation or inattention can each drive a positive result on their own."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Applying an instrument validated in a cardiac-surgery intermediate-care cohort"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "to the broader step-down / progressive-care population is a scope extension the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "on-page framing notes."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "**RASS arousal gate (Sessler 2002; Ely 2003; ward use Han 2015; mRASS Chester"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "2012).** The RASS is scored first and supplies the CAM-IMC's level-of-"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "consciousness point: any value other than 0 is altered arousal. RASS −4/−5 is"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "stupor or coma — the CAM-IMC's verbal items cannot be completed, so the tool"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "records \"unable to assess\" and directs reassessment when the patient responds to"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "voice, mirroring the CAM-ICU and pediatric gates. The RASS anchor descriptors"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "are the canonical Sessler/Ely wording."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Admission delirium risk (Martinez 2012).",
     "b": 1
    },
    {
     "text": " A ward prediction rule for direct"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "admits: one point each for age ≥ 85, dependence in ≥ 5 of 6 activities of daily"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "living, and a psychotropic-drug subtotal ≥ 2 (antidepressant, antidementia, and"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "anticonvulsant score 1 each; antipsychotic scores 2; benzodiazepines were"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "recorded in the study but not weighted, and are not scored). The 0–3 total bands"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "to predicted incidence — 0 Low (~4%), 1 Intermediate (~14–23%), 2–3 High"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "(~43–64%), the ranges spanning the derivation and validation cohorts — and is"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "used to target prevention, not to diagnose. NICE CG103 anchors the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "risk-factor-based prevention framing."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "**Multicomponent prevention (Siddiqi 2016; Inouye 1999 HELP; Hshieh 2015; AGS"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "2015).** A multicomponent non-pharmacologic bundle reduced incident delirium in"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "non-ICU inpatients (Cochrane RR 0.69, 95% CI 0.59–0.81); the tool carries the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "point estimate. Antipsychotics do not prevent delirium (Oh 2019; Neufeld 2016 —"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "no reduction in incidence, duration, length of stay, or mortality) and are not"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "supported for routine treatment (Nikooie 2019; Neufeld 2016); AGS 2015 permits"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "short-term, low-dose use only for severe agitation threatening the patient. The"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "act-on-a-positive guidance reviews deliriogenic and anticholinergic medications"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "first (Lisibach 2022; AGS 2015) and, for post-ICU transfers, considers"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "sedative/opioid withdrawal — Wang 2017 reports iatrogenic withdrawal onset 1–11"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "days after opioid cessation or dose reduction."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Validated instrument scripts and thresholds render verbatim from"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "src/js/stepdown/data/instruments.js",
     "code": 1
    },
    {
     "text": " and are pinned by golden-value tests"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "("
    },
    {
     "text": "tests/unit/templates-stepdown.test.js",
     "code": 1
    },
    {
     "text": "). The tool is de-identified by"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "construction and generates a local print/PDF summary only (facility, editable"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "assessment time, RASS, CAM-IMC, risk, prevention, and de-identified notes). Out"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "of scope in this version: a CAM-IMC severity scale, EEG-assisted assessment, and"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "post-intensive-care-syndrome follow-up."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "2.14 Adult step-down bedside card set & workflow poster (/templates/)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Two step-down templates extend the designer: the "
    },
    {
     "text": "Step-Down Delirium Card Set",
     "b": 1
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "(landscape cards, two per page — an arousal/RASS card with the −4/−5 unable gate,"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "the CAM-IMC scoring card, the Martinez admission-risk worksheet, a"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "prevention-bundle card, and an act-on-a-positive card) and the **Step-Down"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Delirium Workflow** poster (landscape: screen → arousal gate → score → risk →"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "act, with a transfer/hand-off script). They reuse the pediatric card design"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "system ("
    },
    {
     "text": ".pc-*",
     "code": 1
    },
    {
     "text": ")."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Clinical values are "
    },
    {
     "text": "imported directly from the step-down tool's data modules",
     "b": 1
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "("
    },
    {
     "text": "src/js/templates/data/stepdown-content.js",
     "code": 1
    },
    {
     "text": " imports"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "src/js/stepdown/data/instruments.js",
     "code": 1
    },
    {
     "text": " and "
    },
    {
     "text": "refs.js",
     "code": 1
    },
    {
     "text": "), so the printed cards cannot"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "carry different scripts, thresholds, or wording than the interactive tool: the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "CAM-IMC 0–10 additive score positive at ≥ 3, its five components and their"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "per-item cut-offs (inattention ≥ 3 errors, disorientation ≥ 2 errors); the RASS"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "anchors and the −4/−5 unable floor; the Martinez rule (age ≥ 85, ADL dependence"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "≥ 5 of 6, psychotropic subtotal ≥ 2, one point each) with its Low / Intermediate"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "/ High bands; and the ten-component prevention bundle (Beyer 2024; Martinez 2012;"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Siddiqi 2016; AGS 2015). The cut-points and the workflow poster's locked"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "threshold lines (the CAM-IMC rule, the Martinez rule, and the RASS −4/−5 floor)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "are "
    },
    {
     "text": "interpolated from the instrument constants",
     "b": 1
    },
    {
     "text": " so the printed cut cannot"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "drift, and validated-instrument text is deliberately "
    },
    {
     "text": "not",
     "b": 1
    },
    {
     "text": " unit-editable in the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "designer; the prevention and act-on-a-positive lines and the poster's protocol"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "lines are unit-editable. Mirror tests pin the card content to the step-down"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "tool's modules ("
    },
    {
     "text": "tests/unit/templates-stepdown.test.js",
     "code": 1
    },
    {
     "text": ")."
    }
   ]
  },
  {
   "t": "h",
   "level": 2,
   "spans": [
    {
     "text": "3. Citation registry"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Every source cited anywhere in the application, reproduced as each tool stores it. The adult ICU tool's registry is the primary table below; the emergency-department, pediatric, and step-down tools each add the sources their registries hold that the adult table does not already list (shared sources are not repeated). Inline citations and per-tab reference lists are generated from these registries. Identifiers in the adult table marked "
    },
    {
     "text": "† not locally archived",
     "b": 1
    },
    {
     "text": " are cited by canonical URL only (see §4); per-source archive status for every tool is recorded in "
    },
    {
     "text": "references/INDEX.md",
     "href": "../references/INDEX.md"
    },
    {
     "text": "."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "Adult ICU tool"
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "ID"
     }
    ],
    [
     {
      "text": "Citation"
     }
    ],
    [
     {
      "text": "DOI / URL"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "camicu_worksheet",
       "code": 1
      }
     ],
     [
      {
       "text": "Ely EW; Vanderbilt University. CAM-ICU Worksheet. ICUDelirium.org."
      }
     ],
     [
      {
       "text": "https://www.icudelirium.org/resource-downloads/cam-icu-worksheet"
      }
     ]
    ],
    [
     [
      {
       "text": "camicu_manual",
       "code": 1
      }
     ],
     [
      {
       "text": "Ely EW; Vanderbilt University. The Complete CAM-ICU Training Manual (rev. 2016)."
      }
     ],
     [
      {
       "text": "https://www.icudelirium.org/resource-downloads/cam-icu-training-manual"
      }
     ]
    ],
    [
     [
      {
       "text": "icudelirium_monitoring",
       "code": 1
      }
     ],
     [
      {
       "text": "Vanderbilt CIBS Center. Monitoring Delirium in the ICU."
      }
     ],
     [
      {
       "text": "https://www.icudelirium.org/medical-professionals/delirium/monitoring-delirium-in-the-icu"
      }
     ]
    ],
    [
     [
      {
       "text": "ely2001",
       "code": 1
      }
     ],
     [
      {
       "text": "Ely EW, Inouye SK, Bernard GR, et al. Delirium in mechanically ventilated patients: validity and reliability of the CAM-ICU. JAMA. 2001;286(21):2703-2710."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1001/jama.286.21.2703"
      }
     ]
    ],
    [
     [
      {
       "text": "inouye1990",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Inouye SK, van Dyck CH, Alessi CA, Balkin S, Siegal AP, Horwitz RI. Clarifying confusion: the Confusion Assessment Method. Ann Intern Med. 1990;113(12):941-948. (The original CAM; the four-feature 1 AND 2 AND (3 OR 4) algorithm the CAM-ICU adapts.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.7326/0003-4819-113-12-941"
      }
     ]
    ],
    [
     [
      {
       "text": "dsm5tr",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "American Psychiatric Association. Diagnostic and Statistical Manual of Mental Disorders, 5th ed, Text Revision (DSM-5-TR). Washington, DC: APA; 2022. (Delirium diagnostic criteria — the reference standard every bedside screen is validated against.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1176/appi.books.9780890425787"
      }
     ]
    ],
    [
     [
      {
       "text": "icdsc_bergeron",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Bergeron N, Dubois MJ, Dumont M, Dial S, Skrobik Y. Intensive Care Delirium Screening Checklist: evaluation of a new screening tool. Intensive Care Med. 2001;27(5):859-864. (8-item checklist; ≥ 4 = positive.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1007/s001340100909"
      }
     ]
    ],
    [
     [
      {
       "text": "marcantonio2014_3dcam",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Marcantonio ER, Ngo LH, O'Connor M, et al. 3D-CAM: derivation and validation of a 3-minute diagnostic interview for CAM-defined delirium. Ann Intern Med. 2014;161(8):554-561. (The ward-validated CAM the general/step-down pathway recommends.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.7326/M14-0865"
      }
     ]
    ],
    [
     [
      {
       "text": "sessler2002",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Sessler CN, Gosnell MS, Grap MJ, et al. The Richmond Agitation-Sedation Scale (RASS): validity and reliability in adult ICU patients. Am J Respir Crit Care Med. 2002;166(10):1338-1344."
      }
     ],
     [
      {
       "text": "https://pubmed.ncbi.nlm.nih.gov/12421743/"
      }
     ]
    ],
    [
     [
      {
       "text": "ely2003",
       "code": 1
      }
     ],
     [
      {
       "text": "Ely EW, Truman B, Shintani A, et al. Monitoring sedation status over time in ICU patients: reliability and validity of the RASS. JAMA. 2003;289(22):2983-2991."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1001/jama.289.22.2983"
      }
     ]
    ],
    [
     [
      {
       "text": "hayhurst2016",
       "code": 1
      }
     ],
     [
      {
       "text": "Hayhurst CJ, Pandharipande PP, Hughes CG. ICU delirium: a review of diagnosis, prevention, and treatment. Anesthesiology. 2016;125(6):1229-1241."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/ALN.0000000000001378"
      }
     ]
    ],
    [
     [
      {
       "text": "sccm_abcdef",
       "code": 1
      }
     ],
     [
      {
       "text": "Society of Critical Care Medicine. ICU Liberation Bundle (A-F)."
      }
     ],
     [
      {
       "text": "https://sccm.org/clinical-resources/iculiberation-home/abcdef-bundles"
      }
     ]
    ],
    [
     [
      {
       "text": "pun2019",
       "code": 1
      }
     ],
     [
      {
       "text": "Pun BT, Balas MC, Barnes-Daly MA, et al. Caring for critically ill patients with the ABCDEF bundle: ICU Liberation Collaborative in over 15,000 adults. Crit Care Med. 2019;47(1):3-14."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/CCM.0000000000003482"
      }
     ]
    ],
    [
     [
      {
       "text": "marra2017",
       "code": 1
      }
     ],
     [
      {
       "text": "Marra A, Ely EW, Pandharipande PP, Patel MB. The ABCDEF bundle in critical care. Crit Care Clin. 2017;33(2):225-243."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1016/j.ccc.2016.12.005"
      }
     ]
    ],
    [
     [
      {
       "text": "padis2018",
       "code": 1
      }
     ],
     [
      {
       "text": "Devlin JW, Skrobik Y, Gélinas C, et al. Clinical practice guidelines for the prevention and management of pain, agitation/sedation, delirium, immobility, and sleep disruption in adult ICU patients (PADIS). Crit Care Med. 2018;46(9):e825-e873."
      }
     ],
     [
      {
       "text": "https://pubmed.ncbi.nlm.nih.gov/30113379/"
      }
     ]
    ],
    [
     [
      {
       "text": "padis2025",
       "code": 1
      }
     ],
     [
      {
       "text": "Lewis K, Balas MC, Stollings JL, et al. A focused update to the PADIS guidelines. Crit Care Med. 2025;53(3):e711-e727."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/CCM.0000000000006574"
      }
     ]
    ],
    [
     [
      {
       "text": "inouye1999",
       "code": 1
      }
     ],
     [
      {
       "text": "Inouye SK, Bogardus ST Jr, Charpentier PA, et al. A multicomponent intervention to prevent delirium in hospitalized older patients (HELP). N Engl J Med. 1999;340(9):669-676."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1056/NEJM199903043400901"
      }
     ]
    ],
    [
     [
      {
       "text": "hshieh2015",
       "code": 1
      }
     ],
     [
      {
       "text": "Hshieh TT, Yue J, Oh E, et al. Effectiveness of multicomponent nonpharmacological delirium interventions: a meta-analysis. JAMA Intern Med. 2015;175(4):512-520."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1001/jamainternmed.2014.7779"
      }
     ]
    ],
    [
     [
      {
       "text": "schweickert2009",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Schweickert WD, Pohlman MC, Pohlman AS, et al. Early physical and occupational therapy in mechanically ventilated, critically ill patients: a randomised controlled trial. Lancet. 2009;373(9678):1874-1882. (Landmark RCT: early mobility shortens delirium duration — the evidence behind bundle element E.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1016/S0140-6736(09)60658-9"
      }
     ]
    ],
    [
     [
      {
       "text": "nice_cg103",
       "code": 1
      }
     ],
     [
      {
       "text": "NICE. Delirium: prevention, diagnosis and management. Clinical guideline CG103 (updated 2023)."
      }
     ],
     [
      {
       "text": "https://www.nice.org.uk/guidance/cg103"
      }
     ]
    ],
    [
     [
      {
       "text": "icudelirium_satsbt",
       "code": 1
      }
     ],
     [
      {
       "text": "Vanderbilt CIBS Center. Both SAT and SBT (Wake Up and Breathe)."
      }
     ],
     [
      {
       "text": "https://www.icudelirium.org/medical-professionals/both-sat-and-sbt"
      }
     ]
    ],
    [
     [
      {
       "text": "icudelirium_mobility",
       "code": 1
      }
     ],
     [
      {
       "text": "Vanderbilt CIBS Center. Early Mobility and Exercise."
      }
     ],
     [
      {
       "text": "https://www.icudelirium.org/medical-professionals/early-mobility-and-exercise"
      }
     ]
    ],
    [
     [
      {
       "text": "hodgson2014",
       "code": 1
      }
     ],
     [
      {
       "text": "Hodgson CL, Stiller K, Needham DM, et al. Expert consensus and recommendations on safety criteria for active mobilization of mechanically ventilated critically ill adults. Crit Care. 2014;18(6):658."
      }
     ],
     [
      {
       "text": "https://ccforum.biomedcentral.com/articles/10.1186/s13054-014-0658-y"
      }
     ]
    ],
    [
     [
      {
       "text": "icudelirium_mnemonics",
       "code": 1
      }
     ],
     [
      {
       "text": "Vanderbilt CIBS Center. Terminology and Mnemonics: DELIRIUM(S) differential diagnosis."
      }
     ],
     [
      {
       "text": "https://www.icudelirium.org/medical-professionals/terminology-mnemonics"
      }
     ]
    ],
    [
     [
      {
       "text": "flaherty2011",
       "code": 1
      }
     ],
     [
      {
       "text": "Flaherty JH. The evaluation and management of delirium among older persons. Med Clin North Am. 2011;95(3):555-577."
      }
     ],
     [
      {
       "text": "https://pubmed.ncbi.nlm.nih.gov/21549878/"
      }
     ]
    ],
    [
     [
      {
       "text": "maldonado2018",
       "code": 1
      }
     ],
     [
      {
       "text": "Maldonado JR. Delirium pathophysiology: an updated hypothesis of the etiology of acute brain failure. Int J Geriatr Psychiatry. 2018;33(11):1428-1457."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1002/gps.4823"
      }
     ]
    ],
    [
     [
      {
       "text": "inouye_charpentier1996",
       "code": 1
      }
     ],
     [
      {
       "text": "Inouye SK, Charpentier PA. Precipitating factors for delirium in hospitalized elderly persons: predictive model and interrelationship with baseline vulnerability. JAMA. 1996;275(11):852-857."
      }
     ],
     [
      {
       "text": "https://pubmed.ncbi.nlm.nih.gov/8596223/"
      }
     ]
    ],
    [
     [
      {
       "text": "lacour2022",
       "code": 1
      }
     ],
     [
      {
       "text": "la Cour KN, Andersen-Ranberg NC, Weihe S, et al. Distribution of delirium motor subtypes in the ICU: a systematic scoping review. Crit Care. 2022;26:53."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1186/s13054-022-03931-3"
      }
     ]
    ],
    [
     [
      {
       "text": "krewulak2018",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Krewulak KD, Stelfox HT, Leigh JP, Ely EW, Fiest KM. Incidence and prevalence of delirium subtypes in an adult ICU: a systematic review and meta-analysis. Crit Care Med. 2018;46(12):2029-2035."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/CCM.0000000000003402"
      }
     ]
    ],
    [
     [
      {
       "text": "zaal2015",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Zaal IJ, Devlin JW, Peelen LM, Slooter AJC. A systematic review of risk factors for delirium in the ICU. Crit Care Med. 2015;43(1):40-47. (ICU-specific risk-factor review grading each factor.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/CCM.0000000000000625"
      }
     ]
    ],
    [
     [
      {
       "text": "rudolph2009",
       "code": 1
      }
     ],
     [
      {
       "text": "Rudolph JL, Jones RN, Levkoff SE, et al. Derivation and validation of a preoperative prediction rule for delirium after cardiac surgery. Circulation. 2009;119(2):229-236. (Validated surgery-specific delirium prediction rule.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1161/CIRCULATIONAHA.108.795260"
      }
     ]
    ],
    [
     [
      {
       "text": "snigurska2023",
       "code": 1
      }
     ],
     [
      {
       "text": "Snigurska UA, Keil MF, Chin AR, et al. Risk of bias in delirium prediction models: a systematic review. PLoS ONE. 2023;18(5):e0285527. (Even published prediction models carry substantial risk of bias — nuance for the prefer-a-validated-model framing.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1371/journal.pone.0285527"
      }
     ]
    ],
    [
     [
      {
       "text": "hayhurst2020",
       "code": 1
      }
     ],
     [
      {
       "text": "Hayhurst CJ, Patel MB, McNeil JB, et al. Association of hypoactive and hyperactive delirium with cognitive function after critical illness. Crit Care Med. 2020;48(6):e480-e488."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/CCM.0000000000004313"
      }
     ]
    ],
    [
     [
      {
       "text": "pisani2009",
       "code": 1
      }
     ],
     [
      {
       "text": "Pisani MA, Kong SY, Kasl SV, et al. Days of delirium are associated with 1-year mortality in an older ICU population. Am J Respir Crit Care Med. 2009;180(11):1092-1097."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1164/rccm.200904-0537OC"
      }
     ]
    ],
    [
     [
      {
       "text": "beers2023",
       "code": 1
      }
     ],
     [
      {
       "text": "2023 AGS Beers Criteria Update Expert Panel. AGS 2023 updated Beers Criteria for potentially inappropriate medication use in older adults. J Am Geriatr Soc. 2023;71(7):2052-2081."
      }
     ],
     [
      {
       "text": "https://pubmed.ncbi.nlm.nih.gov/37139824/"
      }
     ]
    ],
    [
     [
      {
       "text": "clegg2011",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Clegg A, Young JB. Which medications to avoid in people at risk of delirium: a systematic review. Age Ageing. 2011;40(1):23-29. (Canonical review of delirium-precipitating medications.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1093/ageing/afq140"
      }
     ]
    ],
    [
     [
      {
       "text": "pandharipande2006",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Pandharipande P, Shintani A, Peterson J, et al. Lorazepam is an independent risk factor for transitioning to delirium in ICU patients. Anesthesiology. 2006;104(1):21-26. (Primary trial establishing the independent, dose-dependent benzodiazepine-to-delirium relationship.)"
      }
     ],
     [
      {
       "text": "https://pubmed.ncbi.nlm.nih.gov/16394685/"
      }
     ]
    ],
    [
     [
      {
       "text": "nicolle2019",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Nicolle LE, Gupta K, Bradley SF, et al. Clinical practice guideline for the management of asymptomatic bacteriuria: 2019 update by the Infectious Diseases Society of America. Clin Infect Dis. 2019;68(10):e83-e110. (Delirium with bacteriuria but no genitourinary symptoms or systemic signs: assess for other causes and observe rather than treat.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1093/cid/ciy1121"
      }
     ]
    ],
    [
     [
      {
       "text": "haldol_label",
       "code": 1
      }
     ],
     [
      {
       "text": "Haloperidol prescribing information (boxed warnings, QTc/Torsades, Parkinson/Lewy). DailyMed, U.S. NLM."
      }
     ],
     [
      {
       "text": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=8397a841-f240-4767-9dcd-781e6d3f7c7f"
      }
     ]
    ],
    [
     [
      {
       "text": "mends2",
       "code": 1
      }
     ],
     [
      {
       "text": "Hughes CG, Mailloux PT, Devlin JW, et al. Dexmedetomidine or propofol for sedation in mechanically ventilated adults with sepsis (MENDS2). N Engl J Med. 2021;384(15):1424-1436."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1056/NEJMoa2024922"
      }
     ]
    ],
    [
     [
      {
       "text": "promedic2022",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Wibrow B, Martinez FE, Myers E, et al. Prophylactic melatonin for delirium in intensive care (Pro-MEDIC): an RCT. Intensive Care Med. 2022;48(4):414-425."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1007/s00134-022-06638-9"
      }
     ]
    ],
    [
     [
      {
       "text": "melatonin_meta2025",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Tang BHY, Manalo J, Chowdhury SR, et al. Melatonin use in the ICU: a systematic review and meta-analysis. Crit Care Med. 2025;53(9):e1714-e1724. (32 RCTs, n=3895; may reduce delirium / improve sleep — low certainty.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/CCM.0000000000006767"
      }
     ]
    ],
    [
     [
      {
       "text": "mindusa2018",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Girard TD, Exline MC, Carson SS, et al. Haloperidol and ziprasidone for treatment of delirium in critical illness (MIND-USA). N Engl J Med. 2018;379(26):2506-2516."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1056/NEJMoa1808217"
      }
     ]
    ],
    [
     [
      {
       "text": "balas2014",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Balas MC, Vasilevskis EE, Olsen KM, et al. Effectiveness and safety of the ABCDE bundle. Crit Care Med. 2014;42(5):1024-1036."
      }
     ],
     [
      {
       "text": "https://pubmed.ncbi.nlm.nih.gov/24394627/"
      }
     ]
    ],
    [
     [
      {
       "text": "projectbeta",
       "code": 1
      }
     ],
     [
      {
       "text": "Richmond JS, Berlin JS, Fishkind AB, et al. Verbal de-escalation of the agitated patient: consensus statement of the APA Project BETA. West J Emerg Med. 2012;13(1):17-25."
      }
     ],
     [
      {
       "text": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3298202/"
      }
     ]
    ],
    [
     [
      {
       "text": "nice_ng10",
       "code": 1
      }
     ],
     [
      {
       "text": "NICE. Violence and aggression: short-term management in mental health, health and community settings. NG10."
      }
     ],
     [
      {
       "text": "https://www.nice.org.uk/guidance/ng10"
      }
     ]
    ],
    [
     [
      {
       "text": "inouye1993",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Inouye SK, Viscoli CM, Horwitz RI, et al. A predictive model for delirium in hospitalized elderly based on admission characteristics. Ann Intern Med. 1993;119(6):474-481."
      }
     ],
     [
      {
       "text": "https://pubmed.ncbi.nlm.nih.gov/8357112/"
      }
     ]
    ],
    [
     [
      {
       "text": "marcantonio1994",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Marcantonio ER, Goldman L, Mangione CM, et al. A clinical prediction rule for delirium after elective noncardiac surgery. JAMA. 1994;271(2):134-139."
      }
     ],
     [
      {
       "text": "https://pubmed.ncbi.nlm.nih.gov/8264068/"
      }
     ]
    ],
    [
     [
      {
       "text": "predeliric2012",
       "code": 1
      }
     ],
     [
      {
       "text": "van den Boogaard M, Pickkers P, Slooter AJC, et al. Development and validation of PRE-DELIRIC. BMJ. 2012;344:e420."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1136/bmj.e420"
      }
     ]
    ],
    [
     [
      {
       "text": "epredeliric2015",
       "code": 1
      }
     ],
     [
      {
       "text": "Wassenaar A, van den Boogaard M, van Achterberg T, et al. Multinational development and validation of an early (admission) delirium prediction model for ICU patients (E-PRE-DELIRIC). Intensive Care Med. 2015;41(6):1048-1056."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1007/s00134-015-3777-2"
      }
     ]
    ],
    [
     [
      {
       "text": "ciwa_mdcalc",
       "code": 1
      }
     ],
     [
      {
       "text": "CIWA-Ar (Clinical Institute Withdrawal Assessment for Alcohol, revised). MDCalc."
      }
     ],
     [
      {
       "text": "https://www.mdcalc.com/calc/1736/ciwa-ar-alcohol-withdrawal"
      }
     ]
    ],
    [
     [
      {
       "text": "rass_mdcalc",
       "code": 1
      }
     ],
     [
      {
       "text": "Richmond Agitation-Sedation Scale (RASS) — scoring procedure. MDCalc."
      }
     ],
     [
      {
       "text": "https://www.mdcalc.com/calc/1872/richmond-agitation-sedation-scale-rass"
      }
     ]
    ],
    [
     [
      {
       "text": "efns_wernicke",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Galvin R, Bråthen G, Ivashynka A, et al. EFNS guidelines for diagnosis, therapy and prevention of Wernicke encephalopathy. Eur J Neurol. 2010;17(12):1408-1418. (Thiamine 200 mg IV TID, before carbohydrate; Level C.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1111/j.1468-1331.2010.03153.x"
      }
     ]
    ],
    [
     [
      {
       "text": "rcp_wernicke",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Thomson AD, Cook CCH, Touquet R, Henry JA. The Royal College of Physicians report on alcohol: guidelines for managing Wernicke's encephalopathy in the accident and emergency department. Alcohol Alcohol. 2002;37(6):513-521. (Higher-dose regimen, e.g. 500 mg IV TID × 2–3 days then taper.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1093/alcalc/37.6.513"
      }
     ]
    ],
    [
     [
      {
       "text": "espen_icu",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Singer P, Blaser AR, Berger MM, et al. ESPEN guideline on clinical nutrition in the intensive care unit. Clin Nutr. 2019;38(1):48-79. (Thiamine in refeeding / at-risk critically ill.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1016/j.clnu.2018.08.037"
      }
     ]
    ],
    [
     [
      {
       "text": "acb_boustani",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Boustani M, Campbell N, Munger S, Maidment I, Fox C. Impact of anticholinergics on the aging brain (Anticholinergic Cognitive Burden scale). Aging Health. 2008;4(3):311-320."
      }
     ],
     [
      {
       "text": "https://doi.org/10.2217/1745509X.4.3.311"
      }
     ]
    ],
    [
     [
      {
       "text": "ecash2016",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Vincent JL, Shehabi Y, Walsh TS, et al. Comfort and patient-centred care without excessive sedation: the eCASH concept. Intensive Care Med. 2016;42(6):962-971."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1007/s00134-016-4297-4"
      }
     ]
    ],
    [
     [
      {
       "text": "a2b2025",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Walsh TS, Aitken LM, McKenzie CA, et al. Dexmedetomidine- or clonidine-based sedation compared with propofol in critically ill patients: the A2B randomized clinical trial. JAMA. 2025;334(1):32-45."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1001/jama.2025.7200"
      }
     ]
    ],
    [
     [
      {
       "text": "kollef1998",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Kollef MH, Levy NT, Ahrens TS, Schaiff R, Prentice D, Sherman G. The use of continuous IV sedation is associated with prolongation of mechanical ventilation. Chest. 1998;114(2):541-548. (Observational cohort.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1378/chest.114.2.541"
      }
     ]
    ],
    [
     [
      {
       "text": "dean2004_renal",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Dean M. Opioids in renal failure and dialysis patients. J Pain Symptom Manage. 2004;28(5):497-504."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1016/j.jpainsymman.2004.02.021"
      }
     ]
    ],
    [
     [
      {
       "text": "beers_alt2025",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "American Geriatrics Society Beers Criteria Alternatives Panel. Alternative treatments to selected medications in the 2023 AGS Beers Criteria. J Am Geriatr Soc. 2025;73(9):2657-2677."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1111/jgs.19500"
      }
     ]
    ],
    [
     [
      {
       "text": "girard2008",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Girard TD, Kress JP, Fuchs BD, et al. Efficacy and safety of a paired sedation and ventilator weaning protocol for mechanically ventilated patients in intensive care (Awakening and Breathing Controlled trial): a randomised controlled trial. Lancet. 2008;371(9607):126-134."
      }
     ],
     [
      {
       "text": "https://pubmed.ncbi.nlm.nih.gov/18191684/"
      }
     ]
    ],
    [
     [
      {
       "text": "awissi2013",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Awissi DK, Lebrun G, Coursin DB, Riker RR, Skrobik Y. Alcohol withdrawal and delirium tremens in the critically ill: a systematic review and commentary. Intensive Care Med. 2013;39(1):16-30."
      }
     ],
     [
      {
       "text": "https://pubmed.ncbi.nlm.nih.gov/23184039/"
      }
     ]
    ],
    [
     [
      {
       "text": "asam2020",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "The ASAM Clinical Practice Guideline on Alcohol Withdrawal Management. J Addict Med. 2020;14(3S):1-72. (Thiamine and glucose in either order or concurrently — do not delay glucose; objective scales (CAM-ICU, DDS, RASS, MINDS) for withdrawal delirium; CIWA-Ar not recommended in delirium.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/ADM.0000000000000668"
      }
     ]
    ],
    [
     [
      {
       "text": "flaherty_little2011",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Flaherty JH, Little MO. Matching the environment to patients with delirium: lessons learned from the delirium room, a restraint-free environment for older hospitalized adults with delirium. J Am Geriatr Soc. 2011;59(Suppl 2):S295-S300."
      }
     ],
     [
      {
       "text": "https://pubmed.ncbi.nlm.nih.gov/22091576/"
      }
     ]
    ],
    [
     [
      {
       "text": "dex_label",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Precedex (dexmedetomidine hydrochloride) prescribing information — ICU sedation maintenance infusion 0.2-0.7 mcg/kg/hour. DailyMed, U.S. NLM."
      }
     ],
     [
      {
       "text": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=4419162d-81d4-49bd-96de-1729440bdb74"
      }
     ]
    ],
    [
     [
      {
       "text": "quetiapine_label",
       "code": 1
      },
      {
       "text": " "
      },
      {
       "text": "†",
       "b": 1
      }
     ],
     [
      {
       "text": "Seroquel (quetiapine fumarate) prescribing information — QTc prolongation and orthostatic hypotension. DailyMed, U.S. NLM."
      }
     ],
     [
      {
       "text": "https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=0584dda8-bc3c-48fe-1a90-79608f78e8a0"
      }
     ]
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Edition/year details are reproduced as they appear in the source registry; where a source is a living web resource (e.g., the SCCM/Vanderbilt pages, NICE guidelines, DailyMed label) it carries the version/update designation the registry records and is otherwise undated.",
     "i": 1
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "Emergency-department tool (/ed/)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Sources this tool cites that are not already listed above (shared sources are not repeated; each is shown under the key this tool stores it as). Per-source archive status is in "
    },
    {
     "text": "references/INDEX.md",
     "href": "../references/INDEX.md"
    },
    {
     "text": "."
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "ID"
     }
    ],
    [
     {
      "text": "Citation"
     }
    ],
    [
     {
      "text": "DOI / URL"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "han2013_dts_bcam",
       "code": 1
      }
     ],
     [
      {
       "text": "Han JH, et al. Diagnosing delirium in older emergency department patients: validity and reliability of the Delirium Triage Screen and the Brief Confusion Assessment Method. Ann Emerg Med. 2013;62(5):457–465."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1016/j.annemergmed.2013.05.003"
      }
     ]
    ],
    [
     [
      {
       "text": "dts_manual",
       "code": 1
      }
     ],
     [
      {
       "text": "Han JH. Delirium Triage Screen (DTS) Instruction Manual, v1.0 (2015). Vanderbilt University School of Medicine; eddelirium.org."
      }
     ],
     [
      {
       "text": "https://eddelirium.org/delirium-assessment/assessment-instruments/"
      }
     ]
    ],
    [
     [
      {
       "text": "fourat_form",
       "code": 1
      }
     ],
     [
      {
       "text": "MacLullich A, Ryan T, Cash H. 4AT — Assessment Test for Delirium & Cognitive Impairment, v1.2 (2011–2014). the4at.com (free to use)."
      }
     ],
     [
      {
       "text": "https://www.the4at.com/"
      }
     ]
    ],
    [
     [
      {
       "text": "bellelli2014",
       "code": 1
      }
     ],
     [
      {
       "text": "Bellelli G, et al. Validation of the 4AT, a new instrument for rapid delirium screening: a study in 234 hospitalised older people. Age Ageing. 2014;43(4):496–502."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1093/ageing/afu021"
      }
     ]
    ],
    [
     [
      {
       "text": "shenkin2019",
       "code": 1
      }
     ],
     [
      {
       "text": "Shenkin SD, et al. Delirium detection in older acute medical inpatients: a multicentre prospective comparative diagnostic test accuracy study of the 4AT and the confusion assessment method. BMC Med. 2019;17:138."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1186/s12916-019-1367-9"
      }
     ]
    ],
    [
     [
      {
       "text": "tieges2021",
       "code": 1
      }
     ],
     [
      {
       "text": "Tieges Z, et al. Diagnostic accuracy of the 4AT for delirium detection in older adults: systematic review and meta-analysis. Age Ageing. 2021;50(3):733–743."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1093/ageing/afaa224"
      }
     ]
    ],
    [
     [
      {
       "text": "ged2_2026",
       "code": 1
      }
     ],
     [
      {
       "text": "Lee S, et al. GRADE-based clinical practice guidelines for emergency department delirium risk stratification, screening, and brain imaging in older patients with suspected delirium (Geriatric ED Guidelines 2.0). Acad Emerg Med. 2026;33(2):e70167."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1111/acem.70167"
      }
     ]
    ],
    [
     [
      {
       "text": "geda2014",
       "code": 1
      }
     ],
     [
      {
       "text": "American College of Emergency Physicians, American Geriatrics Society, Emergency Nurses Association, Society for Academic Emergency Medicine. Geriatric Emergency Department Guidelines. 2014."
      }
     ],
     [
      {
       "text": "https://www.acep.org/geda/"
      }
     ]
    ],
    [
     [
      {
       "text": "sign157",
       "code": 1
      }
     ],
     [
      {
       "text": "Scottish Intercollegiate Guidelines Network. Risk reduction and management of delirium: a national clinical guideline (SIGN 157). 2019."
      }
     ],
     [
      {
       "text": "https://www.sign.ac.uk/our-guidelines/risk-reduction-and-management-of-delirium/"
      }
     ]
    ],
    [
     [
      {
       "text": "adept2020",
       "code": 1
      }
     ],
     [
      {
       "text": "Shenvi C, Kennedy M, Austin CA, Wilson MP, Gerardi M, Schneider S. Managing delirium and agitation in the older emergency department patient: the ADEPT tool. Ann Emerg Med. 2020;75(2):136–145."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1016/j.annemergmed.2019.07.023"
      }
     ]
    ],
    [
     [
      {
       "text": "eddel_toolkit",
       "code": 1
      }
     ],
     [
      {
       "text": "Delirium in the Older Emergency Department Patient (ED-DEL): Change Package and Toolkit. ACEP Geriatric Emergency Department Accreditation program."
      }
     ],
     [
      {
       "text": "https://www.acep.org/siteassets/sites/geda/media/documnets/ed-delirium-toolkit.pdf"
      }
     ]
    ],
    [
     [
      {
       "text": "han2009",
       "code": 1
      }
     ],
     [
      {
       "text": "Han JH, et al. Delirium in older emergency department patients: recognition, risk factors, and psychomotor subtypes. Acad Emerg Med. 2009;16(3):193–200."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1111/j.1553-2712.2008.00339.x"
      }
     ]
    ],
    [
     [
      {
       "text": "han2010",
       "code": 1
      }
     ],
     [
      {
       "text": "Han JH, et al. Delirium in the emergency department: an independent predictor of death within 6 months. Ann Emerg Med. 2010;56(3):244–252."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1016/j.annemergmed.2010.03.003"
      }
     ]
    ]
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "Pediatric ICU tool (/peds/)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Sources this tool cites that are not already listed above (shared sources are not repeated; each is shown under the key this tool stores it as). Per-source archive status is in "
    },
    {
     "text": "references/INDEX.md",
     "href": "../references/INDEX.md"
    },
    {
     "text": "."
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "ID"
     }
    ],
    [
     {
      "text": "Citation"
     }
    ],
    [
     {
      "text": "DOI / URL"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "traube2014_capd",
       "code": 1
      }
     ],
     [
      {
       "text": "Traube C, et al. Cornell Assessment of Pediatric Delirium: a valid, rapid, observational tool for screening delirium in the PICU. Crit Care Med. 2014;42(3):656–663."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/CCM.0b013e3182a66b76"
      }
     ]
    ],
    [
     [
      {
       "text": "smith2011_pcam",
       "code": 1
      }
     ],
     [
      {
       "text": "Smith HAB, et al. Diagnosing delirium in critically ill children: validity and reliability of the pCAM-ICU. Crit Care Med. 2011;39(1):150–157."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/CCM.0b013e3181feb489"
      }
     ]
    ],
    [
     [
      {
       "text": "smith2016_pscam",
       "code": 1
      }
     ],
     [
      {
       "text": "Smith HAB, et al. The Preschool Confusion Assessment Method for the ICU (psCAM-ICU). Crit Care Med. 2016;44(3):592–600."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/CCM.0000000000001428"
      }
     ]
    ],
    [
     [
      {
       "text": "curley2006_sbs",
       "code": 1
      }
     ],
     [
      {
       "text": "Curley MAQ, et al. State Behavioral Scale (SBS) for infants and young children on mechanical ventilation. Pediatr Crit Care Med. 2006;7(2):107–114."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/01.PCC.0000200955.40962.38"
      }
     ]
    ],
    [
     [
      {
       "text": "traube2017_outcomes",
       "code": 1
      }
     ],
     [
      {
       "text": "Traube C, et al. Delirium and mortality in critically ill children. Crit Care Med. 2017;45(5):891–898."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/CCM.0000000000002324"
      }
     ]
    ],
    [
     [
      {
       "text": "traube2017_prevalence",
       "code": 1
      }
     ],
     [
      {
       "text": "Traube C, et al. Delirium in critically ill children: an international point prevalence study. Crit Care Med. 2017;45(4):584–590."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/CCM.0000000000002250"
      }
     ]
    ],
    [
     [
      {
       "text": "mody2018_benzo",
       "code": 1
      }
     ],
     [
      {
       "text": "Mody K, et al. Benzodiazepines and development of delirium in critically ill children: estimating the causal effect. Crit Care Med. 2018;46(9):1486–1491."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/CCM.0000000000003194"
      }
     ]
    ],
    [
     [
      {
       "text": "pandem2022",
       "code": 1
      }
     ],
     [
      {
       "text": "Smith HAB, et al. 2022 SCCM PANDEM clinical practice guidelines (pain, agitation, neuromuscular blockade, delirium, environment, early mobility) in critically ill pediatric patients. Pediatr Crit Care Med. 2022;23(2):e74–e110."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/PCC.0000000000002873"
      }
     ]
    ],
    [
     [
      {
       "text": "lin2023_liberation",
       "code": 1
      }
     ],
     [
      {
       "text": "Lin JC, Srivastava A, Malone S, et al. Caring for critically ill children with the ICU Liberation Bundle (ABCDEF): results of the pediatric collaborative. Pediatr Crit Care Med. 2023;24(8):636–651."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1097/PCC.0000000000003262"
      }
     ]
    ],
    [
     [
      {
       "text": "campbell2020_risperidone",
       "code": 1
      }
     ],
     [
      {
       "text": "Campbell CT, et al. Risperidone dosing for pediatric delirium in children ≤ 2 years. Ann Pharmacother. 2020;54(5):464–469."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1177/1060028019891969"
      }
     ]
    ],
    [
     [
      {
       "text": "joyce2015_quetiapine",
       "code": 1
      }
     ],
     [
      {
       "text": "Joyce C, et al. Safety of quetiapine in treating delirium in critically ill children. J Child Adolesc Psychopharmacol. 2015;25(9):666–670."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1089/cap.2015.0093"
      }
     ]
    ],
    [
     [
      {
       "text": "madden2021_prescribing",
       "code": 1
      }
     ],
     [
      {
       "text": "Madden K, et al. Antipsychotic drug prescription in pediatric intensive care units: a 10-year U.S. retrospective database study. J Pediatr Intensive Care. 2024;13(1):46–54 (online 2021)."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1055/s-0041-1736523"
      }
     ]
    ],
    [
     [
      {
       "text": "capino2020",
       "code": 1
      }
     ],
     [
      {
       "text": "Capino AC, Thomas AN, Baylor S, Hughes KM, Miller JL, Johnson PN. Antipsychotic use in the prevention and treatment of intensive care unit delirium in pediatric patients. J Pediatr Pharmacol Ther. 2020;25(2):81–95."
      }
     ],
     [
      {
       "text": "https://doi.org/10.5863/1551-6776-25.2.81"
      }
     ]
    ],
    [
     [
      {
       "text": "phan2008_dexmed",
       "code": 1
      }
     ],
     [
      {
       "text": "Phan H, Nahata MC. Clinical uses of dexmedetomidine in pediatric patients. Paediatr Drugs. 2008;10(1):49–69."
      }
     ],
     [
      {
       "text": "https://doi.org/10.2165/00148581-200810010-00006"
      }
     ]
    ],
    [
     [
      {
       "text": "bruni2015_melatonin",
       "code": 1
      }
     ],
     [
      {
       "text": "Bruni O, Alonso-Alconada D, Besag F, et al. Current role of melatonin in pediatric neurology: clinical recommendations. Eur J Paediatr Neurol. 2015;19(2):122–133. (Age-banded pediatric sleep dosing; not delirium-specific.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1016/j.ejpn.2014.12.007"
      }
     ]
    ],
    [
     [
      {
       "text": "peds_apsych_sr2025",
       "code": 1
      }
     ],
     [
      {
       "text": "Cavagnero F, et al. Antipsychotic medications for delirium treatment in the pediatric intensive care unit: a systematic review. Paediatr Drugs. 2025;27(6):707-722."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1007/s40272-025-00716-3"
      }
     ]
    ],
    [
     [
      {
       "text": "picuup_kudchadkar",
       "code": 1
      }
     ],
     [
      {
       "text": "Kudchadkar SR, et al. PICU Up! multicenter early mobility trial (protocol: Azamfirei R, et al. Trials. 2023;24(1):191). NCT04989790."
      }
     ],
     [
      {
       "text": "https://clinicaltrials.gov/study/NCT04989790"
      }
     ]
    ],
    [
     [
      {
       "text": "gupta2021_capd_mv",
       "code": 1
      }
     ],
     [
      {
       "text": "Gupta N, et al. Performance of the Cornell Assessment of Pediatric Delirium scale in mechanically ventilated children. J Pediatr Intensive Care. 2023;12(1):24–30 (online 2021). (At CAPD ≥ 9: overall specificity 44.8%; 16.5% with developmental delay.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1055/s-0041-1728784"
      }
     ]
    ],
    [
     [
      {
       "text": "kerson2016_rass",
       "code": 1
      }
     ],
     [
      {
       "text": "Kerson AG, DeMaria R, Mauer E, et al. Validity of the Richmond Agitation-Sedation Scale (RASS) in critically ill children. J Intensive Care. 2016;4:65. (Pediatric RASS validation — the arousal scale the tool applies to verbal children.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1186/s40560-016-0189-5"
      }
     ]
    ],
    [
     [
      {
       "text": "schieveld2009",
       "code": 1
      }
     ],
     [
      {
       "text": "Schieveld JNM, van der Valk JA, Smeets I, et al. Diagnostic considerations regarding pediatric delirium: a review and a proposal for an algorithm for pediatric intensive care units. Intensive Care Med. 2009;35(11):1843-1849. (Open access.)"
      }
     ],
     [
      {
       "text": "https://doi.org/10.1007/s00134-009-1652-8"
      }
     ]
    ],
    [
     [
      {
       "text": "waak2022_picustars",
       "code": 1
      }
     ],
     [
      {
       "text": "Waak M, et al. Every child, every day, back to play: the PICUstars protocol — implementation of a nurse-led PICU liberation program. BMC Pediatr. 2022;22:279."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1186/s12887-022-03232-2"
      }
     ]
    ]
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "Adult step-down / progressive-care tool (/stepdown/)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Sources this tool cites that are not already listed above (shared sources are not repeated; each is shown under the key this tool stores it as). Per-source archive status is in "
    },
    {
     "text": "references/INDEX.md",
     "href": "../references/INDEX.md"
    },
    {
     "text": "."
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "ID"
     }
    ],
    [
     {
      "text": "Citation"
     }
    ],
    [
     {
      "text": "DOI / URL"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "beyer2024_camimc",
       "code": 1
      }
     ],
     [
      {
       "text": "Beyer LP, et al. Disorientation as a delirium feature in non-intubated patients: development and evaluation of the CAM-IMC. BMC Anesthesiol 2024;24:451."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1186/s12871-024-02849-3"
      }
     ]
    ],
    [
     [
      {
       "text": "han2015_rass",
       "code": 1
      }
     ],
     [
      {
       "text": "Han JH, et al. The diagnostic performance of the RASS for detecting delirium in older ED patients. Acad Emerg Med 2015;22:878."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1111/acem.12706"
      }
     ]
    ],
    [
     [
      {
       "text": "chester2012_mrass",
       "code": 1
      }
     ],
     [
      {
       "text": "Chester JG, et al. Serial administration of a modified RASS for delirium screening. J Hosp Med 2012;7:450."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1002/jhm.1003"
      }
     ]
    ],
    [
     [
      {
       "text": "kuczmarska2016",
       "code": 1
      }
     ],
     [
      {
       "text": "Kuczmarska A, et al. Detection of delirium in hospitalized older general medicine patients: a comparison of the 3D-CAM and CAM-ICU. J Gen Intern Med 2016;31:297."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1007/s11606-015-3514-0"
      }
     ]
    ],
    [
     [
      {
       "text": "martinez2012",
       "code": 1
      }
     ],
     [
      {
       "text": "Martinez JA, et al. Derivation and validation of a clinical prediction rule for delirium in patients admitted to a medical ward. BMJ Open 2012;2:e001599."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1136/bmjopen-2012-001599"
      }
     ]
    ],
    [
     [
      {
       "text": "siddiqi2016",
       "code": 1
      }
     ],
     [
      {
       "text": "Siddiqi N, et al. Interventions for preventing delirium in hospitalised non-ICU patients. Cochrane Database Syst Rev 2016;CD005563."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1002/14651858.CD005563.pub3"
      }
     ]
    ],
    [
     [
      {
       "text": "ags2015",
       "code": 1
      }
     ],
     [
      {
       "text": "American Geriatrics Society. Abstracted clinical practice guideline for postoperative delirium in older adults. J Am Geriatr Soc 2015;63:142."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1111/jgs.13281"
      }
     ]
    ],
    [
     [
      {
       "text": "neufeld2016",
       "code": 1
      }
     ],
     [
      {
       "text": "Neufeld KJ, et al. Antipsychotic medication for prevention and treatment of delirium in hospitalized adults: a systematic review and meta-analysis. J Am Geriatr Soc 2016;64:705."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1111/jgs.14076"
      }
     ]
    ],
    [
     [
      {
       "text": "oh2019",
       "code": 1
      }
     ],
     [
      {
       "text": "Oh ES, et al. Antipsychotics for preventing delirium in hospitalized adults: a systematic review. Ann Intern Med 2019;171:474."
      }
     ],
     [
      {
       "text": "https://doi.org/10.7326/M19-1859"
      }
     ]
    ],
    [
     [
      {
       "text": "nikooie2019",
       "code": 1
      }
     ],
     [
      {
       "text": "Nikooie R, et al. Antipsychotics for treating delirium in hospitalized adults: a systematic review. Ann Intern Med 2019;171:485."
      }
     ],
     [
      {
       "text": "https://doi.org/10.7326/M19-1860"
      }
     ]
    ],
    [
     [
      {
       "text": "wang2017",
       "code": 1
      }
     ],
     [
      {
       "text": "Wang PP, et al. Opioid-associated iatrogenic withdrawal in critically ill adult patients. Ann Intensive Care 2017;7:88."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1186/s13613-017-0310-5"
      }
     ]
    ],
    [
     [
      {
       "text": "lisibach2022",
       "code": 1
      }
     ],
     [
      {
       "text": "Lisibach A, et al. Quantifying anticholinergic burden and its association with delirium (comparison of 19 scales). Br J Clin Pharmacol 2022;88:4915."
      }
     ],
     [
      {
       "text": "https://doi.org/10.1111/bcp.15432"
      }
     ]
    ]
   ]
  },
  {
   "t": "h",
   "level": 2,
   "spans": [
    {
     "text": "4. Known limitations"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "These are stated by the tool itself or follow directly from how it is implemented:"
    }
   ]
  },
  {
   "t": "ol",
   "items": [
    [
     {
      "text": "The risk-factor tally is a non-validated heuristic.",
      "b": 1
     },
     {
      "text": " It is a count of present factors, not a calibrated probability. Every factor counts "
     },
     {
      "text": "+1",
      "b": 1
     },
     {
      "text": " (a flat checklist, no weighting), and the band boundaries are explicitly labeled heuristic. For validated ICU prediction the tool directs clinicians to "
     },
     {
      "text": "E-PRE-DELIRIC",
      "b": 1
     },
     {
      "text": " (admission) and "
     },
     {
      "text": "PRE-DELIRIC",
      "b": 1
     },
     {
      "text": " (after 24 h). The only score-linked escalation prompt (geriatrics above a count of 6) is pragmatic and labeled as such; there is no score-triggered psychiatry suggestion."
     }
    ],
    [
     {
      "text": "Adult-ICU scope (a prominent panel at the pathway picker, not just prose).",
      "b": 1
     },
     {
      "text": " CAM-ICU, RASS, and ABCDEF are validated for the "
     },
     {
      "text": "adult ICU",
      "b": 1
     },
     {
      "text": "; "
     },
     {
      "text": "ICDSC",
      "b": 1
     },
     {
      "text": " is the in-ICU alternative screen. They are not validated for other settings. The picker panel directs users to the setting-appropriate validated tool: "
     },
     {
      "text": "ED → bCAM (DTS → bCAM) or 4AT",
      "b": 1
     },
     {
      "text": "; "
     },
     {
      "text": "general / step-down ward → 3D-CAM or 4AT",
      "b": 1
     },
     {
      "text": "; "
     },
     {
      "text": "pediatric ICU → pCAM-ICU (≥ 5 yr) / psCAM-ICU (6 mo–5 yr) / CAPD (all ages)",
      "b": 1
     },
     {
      "text": "; "
     },
     {
      "text": "pregnancy →",
      "b": 1
     },
     {
      "text": " the adult ICU screens apply but medication safety/dosing must be adjusted. The framing is \"developed and validated in the adult ICU; use the setting-appropriate tool elsewhere,\" not a claim that these instruments were disproven outside the ICU."
     }
    ],
    [
     {
      "text": "CAM-ICU is a screen, not a diagnosis.",
      "b": 1
     },
     {
      "text": " The tool flags reduced accuracy in primary neurologic injury/TBI, aphasia, and deep sedation; requires scoring against the patient's baseline; and notes that missed cases are predominantly hypoactive, hence the every-shift screening."
     }
    ],
    [
     {
      "text": "CIWA-Ar is not validated in intubated/sedated/delirious patients.",
      "b": 1
     },
     {
      "text": " CIWA-Ar requires an awake, communicative, non-delirious patient who can self-report; for withdrawal delirium and intubated/sedated ICU patients the tool directs monitoring with an objective structured scale (RASS, CAM-ICU, MINDS) per the institutional withdrawal protocol ("
     },
     {
      "text": "asam2020",
      "code": 1
     },
     {
      "text": ", "
     },
     {
      "text": "awissi2013",
      "code": 1
     },
     {
      "text": ")."
     }
    ],
    [
     {
      "text": "The deliriogenic list is a review prompt, not a risk ranking.",
      "b": 1
     },
     {
      "text": " Of 103 agents, the strongest classes (benzodiazepines, opioids, anticholinergics) are on by default and the rest are opt-in; benzodiazepines, strong anticholinergics, and meperidine carry a citation-backed "
     },
     {
      "text": "higher-risk",
      "i": 1
     },
     {
      "text": " flag. Actual risk still varies by agent, dose, route, organ function, interactions, and temporal association. Beers Criteria apply to adults ≥ 65."
     }
    ],
    [
     {
      "text": "No pharmacotherapy is FDA-approved for delirium.",
      "b": 1
     },
     {
      "text": " Antipsychotics have not been shown to treat or shorten delirium (MIND-USA negative; PADIS 2025 was unable to recommend for or against); the tool restricts them to short-term control of dangerous agitation with documented indication, QTc monitoring, daily reassessment, and no discharge continuation without a psychiatric indication. Doses shown are generic starting-point references (\"cap per local protocol\"), not orders."
     }
    ],
    [
     {
      "text": "Not a record system.",
      "b": 1
     },
     {
      "text": " The assessment is a session scratchpad that clears on reload and is not saved to any chart; the PDFs are generated locally. The tool is not a substitute for the medical record or for a sanctioned order set."
     }
    ],
    [
     {
      "text": "Subtype figures are the proportion of delirious cases",
      "b": 1
     },
     {
      "text": " (la Cour 2022), not population prevalence (Krewulak 2018); they are approximate, drawn from the cited reviews, and should not be quoted as exact constants."
     }
    ],
    [
     {
      "text": "Reference-archive completeness.",
      "b": 1
     },
     {
      "text": " A substantial minority of registry sources are cited by canonical URL but not held in the local archive; "
     },
     {
      "text": "references/INDEX.md",
      "code": 1
     },
     {
      "text": " records the per-source archive status (\"not archived\" rows) and is the authoritative list, and the §3 registry marks the same sources "
     },
     {
      "text": "†",
      "b": 1
     },
     {
      "text": ". Examples include Sessler 2002 (RASS), the Pro-MEDIC main RCT (only the statistical-analysis plan and an editorial are archived), MIND-USA, and the thiamine dose sources (EFNS, RCP, ESPEN)."
     }
    ]
   ]
  },
  {
   "t": "h",
   "level": 2,
   "spans": [
    {
     "text": "5. Questions for clinical reviewers"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Resolved in the current revision",
     "b": 1
    },
    {
     "text": " (recorded in the change log, §6.5):"
    }
   ]
  },
  {
   "t": "ul",
   "items": [
    [
     {
      "text": "(1) Risk-factor weighting",
      "b": 1
     },
     {
      "text": ": flattened to all +1 (the dementia +2 was removed) so the unvalidated tally cannot imply a calibration. (Whether "
     },
     {
      "text": "\"high APACHE-II\"",
      "i": 1
     },
     {
      "text": " / "
     },
     {
      "text": "age ≥ 70",
      "i": 1
     },
     {
      "text": " are the right operationalizations remains open to review.)"
     }
    ],
    [
     {
      "text": "(2) Risk-band escalation",
      "b": 1
     },
     {
      "text": ": the score-triggered psychiatry suggestion was removed (psychiatry follows clinical features, not a count). Geriatrics above 6 is kept, relabelled \"pragmatic, not validated.\""
     }
    ],
    [
     {
      "text": "(3) CAM-ICU inattention cut-point",
      "b": 1
     },
     {
      "text": ": the Pictures ASE wording was corrected to the validated 10-item recognition task (> 2/10), so the > 2-error cut-point is equivalent across modalities."
     }
    ],
    [
     {
      "text": "(5) Subtype wording",
      "b": 1
     },
     {
      "text": ": restated as the "
     },
     {
      "text": "proportion of delirious cases",
      "i": 1
     },
     {
      "text": " (la Cour 2022), explicitly distinguished from population prevalence (Krewulak 2018)."
     }
    ],
    [
     {
      "text": "(6) Deliriogenic-list breadth/defaults",
      "b": 1
     },
     {
      "text": ": higher-risk agents now flagged (benzodiazepines, strong anticholinergics, meperidine); the long tail defaults off (opt-in); dexmedetomidine delisted; metoclopramide recategorized."
     }
    ],
    [
     {
      "text": "(8) Thiamine guidance",
      "b": 1
     },
     {
      "text": ": now cited (ESPEN at-risk range; EFNS vs RCP Wernicke regimens stated as a disclosed divergence, see §2.6)."
     }
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Addressed this revision, with residual points a reviewer may still weigh:",
     "b": 1
    }
   ]
  },
  {
   "t": "ul",
   "items": [
    [
     {
      "text": "(4) RASS target and caution zoning",
      "b": 1
     },
     {
      "text": ". "
     },
     {
      "text": "Resolved:",
      "i": 1
     },
     {
      "text": " the light "
     },
     {
      "text": "0 to −2",
      "b": 1
     },
     {
      "text": " is the only savable/shareable default; the mislabeled \"−2 to −3 (moderate sedation)\" option was corrected to a "
     },
     {
      "text": "−3 to −4 (deep: indication required)",
      "b": 1
     },
     {
      "text": " band that is indication-gated (required reason + association-worded caution), and RASS −5 is now always flagged danger so a deep target cannot mask over-sedation. (Whether the amber/red zoning edges are exactly right remains open to review.)"
     }
    ],
    [
     {
      "text": "(7) Dosing references",
      "b": 1
     },
     {
      "text": ". "
     },
     {
      "text": "Resolved:",
      "i": 1
     },
     {
      "text": " labeled \"conventional / expert starting references, not guideline-calibrated for delirium\" (rather than attributing them to specific named sources), with the note that dexmedetomidine is a sedative infusion for ventilated patients, not a PRN antipsychotic-equivalent, so the agents are not interchangeable."
     }
    ],
    [
     {
      "text": "(9) Melatonin",
      "b": 1
     },
     {
      "text": ". "
     },
     {
      "text": "Resolved:",
      "i": 1
     },
     {
      "text": " kept as a low-risk sleep/circadian adjunct, not a delirium treatment; the \"low-certainty ICU evidence\" claim is anchored to the dedicated evidence ("
     },
     {
      "text": "promedic2022",
      "code": 1
     },
     {
      "text": " + "
     },
     {
      "text": "melatonin_meta2025",
      "code": 1
     },
     {
      "text": "), and (per the 2026-07-01 revision) the PADIS 2025 "
     },
     {
      "text": "conditional recommendation FOR melatonin",
      "b": 1
     },
     {
      "text": " is now surfaced with its own "
     },
     {
      "text": "padis2025",
      "code": 1
     },
     {
      "text": " cite (low certainty; no dose specified), the 0.5–3 mg range is labeled conventional sleep dosing not drawn from the cited trials (Pro-MEDIC used 4 mg), and ramelteon is noted as the PADIS-named alternative."
     }
    ],
    [
     {
      "text": "(10) Out-of-scope gate",
      "b": 1
     },
     {
      "text": ". "
     },
     {
      "text": "Resolved:",
      "i": 1
     },
     {
      "text": " a prominent (non-blocking) adult/ICU scope panel now sits at the pathway picker with setting-specific redirects (ED → bCAM/4AT; ward → 3D-CAM/4AT; peds → pCAM-ICU/psCAM-ICU/CAPD; pregnancy → adjust drug safety); ICDSC was kept as the in-ICU alternative and the Setup screening-tool selector trimmed to the two adult-ICU screens (CAM-ICU, ICDSC) so it no longer implies ward/ED validity."
     }
    ]
   ]
  },
  {
   "t": "h",
   "level": 2,
   "spans": [
    {
     "text": "6. Maintenance & provenance"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "This section describes how the source content in this repository is kept accurate and traceable: how each change is recorded, what prompts a re-check when a cited source is updated, how evidence is graded, and how the validated published instruments (CAM-ICU, RASS) are attributed and kept distinct from the tool's own checklists. It is a maintenance and provenance record for the code in this repository, not a clinical endorsement. Clinical governance for any deployment is the adopter's responsibility (§6.1)."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "6.1 Adoption, licensing, and responsibility"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "This project is open-source software, released under the MIT License (see "
    },
    {
     "text": "LICENSE",
     "code": 1
    },
    {
     "text": "). Anyone may use, copy, modify, and adopt it, in whole or in part, and adapt it to their own setting."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "It is provided "
    },
    {
     "text": "\"as is\", without warranty of any kind",
     "b": 1
    },
    {
     "text": " (as the MIT License states). It is a "
    },
    {
     "text": "reference aid that assists — and does not replace — clinical judgment, local protocol, and prescriber/pharmacy review",
     "b": 1
    },
    {
     "text": " (§1). It is "
    },
    {
     "text": "not a validated clinical decision-support device and is not cleared, certified, or validated for any specific clinical decision",
     "b": 1
    },
    {
     "text": "."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Governance is the adopter's responsibility.",
     "b": 1
    },
    {
     "text": " Anyone who deploys this tool, or a derivative of it, for clinical use owns the clinical governance for that deployment: validating the content against current sources for their population, obtaining whatever local clinical, pharmacy, and information-governance review or sign-off their institution requires, and making their own regulatory determination for their jurisdiction and intended use. The maintainers provide the source content and its citations as reference material; they "
    },
    {
     "text": "do not sign off adopters' deployments, and take no ownership of, or responsibility for, any clinical use, decision, or outcome.",
     "b": 1
    },
    {
     "text": " An adopter who wants a clinical sign-off can obtain one; it is theirs to arrange, and it binds their deployment, not this project."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "What this repository does maintain — as engineering hygiene, not a clinical warranty — is a record of what the content is and where it comes from: the citation registry (§3), the evidence-grade scheme (§6.4), the change log (§6.5), the source-watch that flags when a cited source is updated (§6.3), and the instrument attribution that keeps the validated published instruments distinct from the tool's own checklists (§6.6)."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "6.2 Content version & change history"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "```"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Content version : 2026.07 (content revised through 2026-07-31)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Change history  : every clinical-content change is recorded in the change log (§6.5)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Source watch    : re-checks are prompted when a cited source updates (§6.3)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "```"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "There is no central review-and-approve gate in this repository. An adopting unit records its own review dates and approvals for its deployment (for example, in the Setup tab's protocol-version and review fields); those belong to the adopter and are not a statement about this repository's content."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "6.3 Review cadence: source-cycle triggers"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "ED source watch (added with §2.11): the 4AT form version (v1.2, the4at.com),"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "GED Guidelines 2.0 (Lee 2026, new; watch for errata/updates), the Vanderbilt"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "DTS/bCAM manuals (eddelirium.org, v1.0 2015), SIGN 157, NICE CG103, and the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "ADEPT tool / ACEP ED-DEL change package. Re-verify on each release that the"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "rendered instrument wording still matches the archived copies in"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "references/ed/",
     "code": 1
    },
    {
     "text": "."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The base cadence is an "
    },
    {
     "text": "annual full review",
     "b": 1
    },
    {
     "text": ". In addition, any publication in the table below triggers an "
    },
    {
     "text": "out-of-cycle review",
     "b": 1
    },
    {
     "text": " of the rows it governs, within the stated window. When a trigger fires, update the affected content "
    },
    {
     "text": "and its citation together",
     "i": 1
    },
    {
     "text": " (per the project's hard invariant), log a change-log row (§6.5)."
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "Source"
     }
    ],
    [
     {
      "text": "Governs (tool sections)"
     }
    ],
    [
     {
      "text": "Cadence / what to watch"
     }
    ],
    [
     {
      "text": "Action on update"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "PADIS",
       "b": 1
      },
      {
       "text": " (SCCM) — "
      },
      {
       "text": "padis2018",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "padis2025",
       "code": 1
      }
     ],
     [
      {
       "text": "§2.5, §2.7, §2.8, dosing table, RASS target rationale"
      }
     ],
     [
      {
       "text": "Irregular; full guideline 2018, focused update 2025. Watch SCCM for the next focused update or full revision"
      }
     ],
     [
      {
       "text": "Re-review sedation/analgesia choice, antipsychotic stance, dexmedetomidine niche, and dose anchors; confirm \"no recommendation for/against antipsychotics to treat delirium\" still holds"
      }
     ]
    ],
    [
     [
      {
       "text": "AGS Beers Criteria",
       "b": 1
      },
      {
       "text": " — "
      },
      {
       "text": "beers2023",
       "code": 1
      }
     ],
     [
      {
       "text": "§2.8 deliriogenic list, the ≥ 65 framing"
      }
     ],
     [
      {
       "text": "~Every 3 years (2023 current; next update expected ~2026 — watch JAGS)"
      }
     ],
     [
      {
       "text": "Reconcile the 11-category / 103-agent list and anticholinergic flags against the new edition; bump the citation year"
      }
     ]
    ],
    [
     [
      {
       "text": "CAM-ICU",
       "b": 1
      },
      {
       "text": " — "
      },
      {
       "text": "ely2001",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "camicu_worksheet",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "camicu_manual",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "icudelirium_monitoring",
       "code": 1
      }
     ],
     [
      {
       "text": "§2.2 (feature logic, SAVEAHAART, Pictures-ASE)"
      }
     ],
     [
      {
       "text": "Instrument owned by Vanderbilt CIBS Center (Ely). Worksheet/Manual last rev. 2016. Watch icudelirium.org for worksheet/manual revisions and any change to the Pictures-ASE / ASE operationalization"
      }
     ],
     [
      {
       "text": "Re-verify the four-feature algorithm and cut-points are reproduced faithfully; confirm the Pictures-ASE remains the validated 10-item > 2/10 task"
      }
     ]
    ],
    [
     [
      {
       "text": "RASS",
       "b": 1
      },
      {
       "text": " — "
      },
      {
       "text": "sessler2002",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "ely2003",
       "code": 1
      }
     ],
     [
      {
       "text": "§2.3 scale anchors, arousal gate"
      }
     ],
     [
      {
       "text": "Scale is fixed/validated and stable; effectively no revision cadence. Watch only the procedural reference ("
      },
      {
       "text": "rass_mdcalc",
       "code": 1
      },
      {
       "text": ") and PADIS-driven target-band guidance"
      }
     ],
     [
      {
       "text": "Confirm the +4…−5 anchors are verbatim; the configurable target band is local, not part of the validated scale"
      }
     ]
    ],
    [
     [
      {
       "text": "NICE",
       "b": 1
      },
      {
       "text": " — "
      },
      {
       "text": "nice_cg103",
       "code": 1
      },
      {
       "text": " (delirium), "
      },
      {
       "text": "nice_ng10",
       "code": 1
      },
      {
       "text": " (violence/aggression)"
      }
     ],
     [
      {
       "text": "§2.2, §2.5, §2.7"
      }
     ],
     [
      {
       "text": "NICE runs rolling surveillance; CG103 last updated 2023. Watch nice.org.uk for CG103/NG10 status changes"
      }
     ],
     [
      {
       "text": "Re-review prevention and de-escalation/restraint content; update the \"(updated YYYY)\" designation"
      }
     ]
    ],
    [
     [
      {
       "text": "FDA Clinical Decision Support guidance",
       "b": 1
      },
      {
       "text": " (final, Jan 2026; 4-criterion non-device CDS structure)"
      }
     ],
     [
      {
       "text": "Whole-tool design discipline; the §6.7 design principles"
      }
     ],
     [
      {
       "text": "Watch FDA for revisions to the CDS guidance and adjacent software-function policy"
      }
     ],
     [
      {
       "text": "Re-check against the §6.7 non-device CDS design principles (supports-not-directs; basis independently reviewable)"
      }
     ]
    ],
    [
     [
      {
       "text": "SCCM ICU Liberation pages",
       "b": 1
      },
      {
       "text": " — "
      },
      {
       "text": "sccm_abcdef",
       "code": 1
      },
      {
       "text": "; "
      },
      {
       "text": "ICUDelirium.org",
       "b": 1
      },
      {
       "text": " Vanderbilt pages"
      }
     ],
     [
      {
       "text": "§2.5, §2.6, §2.2"
      }
     ],
     [
      {
       "text": "Living web resources; no fixed cadence. Check at each annual review"
      }
     ],
     [
      {
       "text": "Re-confirm bundle elements and mnemonic content match the current pages"
      }
     ]
    ],
    [
     [
      {
       "text": "Thiamine (ESPEN / EFNS / RCP)",
       "b": 1
      }
     ],
     [
      {
       "text": "§2.6 \"U\" domain (at-risk 100–300 mg/day; Wernicke EFNS 200 mg TID vs RCP 500 mg TID)"
      }
     ],
     [
      {
       "text": "Now cited: "
      },
      {
       "text": "espen_icu",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "efns_wernicke",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "rcp_wernicke",
       "code": 1
      },
      {
       "text": ". Guidelines diverge on the Wernicke dose and the evidence is low-certainty"
      }
     ],
     [
      {
       "text": "On update, re-confirm the divergence note still reflects current ESPEN / EFNS / RCP (and BAP) guidance"
      }
     ]
    ],
    [
     [
      {
       "text": "Fixed trials",
       "b": 1
      },
      {
       "text": " — "
      },
      {
       "text": "mindusa2018",
       "code": 1
      },
      {
       "text": " (MIND-USA), "
      },
      {
       "text": "mends2",
       "code": 1
      },
      {
       "text": " (MENDS2), "
      },
      {
       "text": "promedic2022",
       "code": 1
      },
      {
       "text": " (Pro-MEDIC), "
      },
      {
       "text": "pun2019",
       "code": 1
      },
      {
       "text": ", "
      },
      {
       "text": "hshieh2015",
       "code": 1
      }
     ],
     [
      {
       "text": "§2.7, §2.8"
      }
     ],
     [
      {
       "text": "No cadence (single studies). Watch only for a practice-changing replication or pooled analysis"
      }
     ],
     [
      {
       "text": "If superseded, log the change and re-grade the affected recommendation"
      }
     ]
    ]
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "6.4 Evidence-tier / grade scheme"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Every numeric or directive output carries a tier so a reviewer can see at a glance whether it rests on a validated instrument, a guideline, a label, or a pragmatic choice. The tier is recorded in the change log (§6.5) and should be surfaceable to the clinician (citation + grade visible, FDA non-device CDS criterion 4)."
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "Tier"
     }
    ],
    [
     {
      "text": "Meaning"
     }
    ],
    [
     {
      "text": "Examples in this tool"
     }
    ],
    [
     {
      "text": "Maintenance rule"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "V — Validated instrument",
       "b": 1
      }
     ],
     [
      {
       "text": "Published, psychometrically validated, reproduced faithfully"
      }
     ],
     [
      {
       "text": "CAM-ICU, RASS, PRE-DELIRIC / E-PRE-DELIRIC (as referrals)"
      }
     ],
     [
      {
       "text": "Reproduce verbatim. Any deviation from the source algorithm/cut-point must be re-tiered "
      },
      {
       "text": "P",
       "b": 1
      },
      {
       "text": " and labeled as a modification (§6.6)"
      }
     ]
    ],
    [
     [
      {
       "text": "G — Guideline recommendation",
       "b": 1
      }
     ],
     [
      {
       "text": "From a society/national guideline; carry the source's own strength/certainty where stated"
      }
     ],
     [
      {
       "text": "PADIS, NICE CG103/NG10, AGS Beers, SCCM ABCDEF"
      }
     ],
     [
      {
       "text": "Track the guideline's GRADE strength + certainty; re-review on each guideline revision (§6.3)"
      }
     ]
    ],
    [
     [
      {
       "text": "R — Regulatory / label",
       "b": 1
      }
     ],
     [
      {
       "text": "Drug label or regulatory guidance"
      }
     ],
     [
      {
       "text": "Haloperidol PI (boxed warnings, QTc), FDA CDS guidance"
      }
     ],
     [
      {
       "text": "Update when the label/guidance changes"
      }
     ]
    ],
    [
     [
      {
       "text": "P — Pragmatic / non-validated",
       "b": 1
      }
     ],
     [
      {
       "text": "Home-grown; explicitly unvalidated"
      }
     ],
     [
      {
       "text": "Risk-factor tally (flat +1 per factor, no weighting), band cut-points 0–3 / 4–6 / 7–10 / 11–15, geriatrics-consult > 6 escalation"
      }
     ],
     [
      {
       "text": "Must be flattened/relabelled or carry an explicit \"pragmatic, not validated\" note.",
       "b": 1
      },
      {
       "text": " A P-tier number may never be presented as a calibrated score"
      }
     ]
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Governing rule.",
     "b": 1
    },
    {
     "text": " Anywhere the tool emits a number that drives an action (weighted scores, escalation thresholds, cut-points), that number is "
    },
    {
     "text": "P",
     "b": 1
    },
    {
     "text": " unless it traces to a "
    },
    {
     "text": "V",
     "b": 1
    },
    {
     "text": " instrument or a "
    },
    {
     "text": "G/R",
     "b": 1
    },
    {
     "text": " source. P-tier numbers stay flattened or explicitly caveated; V-tier instruments stay faithful and attributed (§6.6)."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "6.5 Clinical-content change log"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The change log — one row per change to a clinical value, threshold, band, dose, instrument logic, or citation, with its source, evidence tier, and whether the in-app text was updated in the same change — is maintained separately in "
    },
    {
     "text": "CLINICAL_CHANGELOG.md",
     "href": "CLINICAL_CHANGELOG.md"
    },
    {
     "text": "."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "6.6 Instrument provenance & attribution"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "CAM-ICU and RASS are "
    },
    {
     "text": "validated, published instruments",
     "b": 1
    },
    {
     "text": " with named authors. They must be attributed correctly and reproduced faithfully, and they must stay "
    },
    {
     "text": "visually and functionally separate",
     "b": 1
    },
    {
     "text": " from the tool's home-grown risk-factor tally so no clinician conflates the unvalidated checklist with the validated screens."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "CAM-ICU (Confusion Assessment Method for the ICU).",
     "b": 1
    },
    {
     "text": " Developed by E. Wesley Ely and colleagues, Vanderbilt University (CIBS Center / icudelirium.org); validated in "
    },
    {
     "text": "ely2001",
     "code": 1
    },
    {
     "text": ". Operationalization (worksheet, training manual, Pictures-ASE) per "
    },
    {
     "text": "camicu_worksheet",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "camicu_manual",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "icudelirium_monitoring",
     "code": 1
    },
    {
     "text": ". Reproduce the four-feature algorithm and its cut-points without alteration. The Pictures-ASE is implemented as the validated 10-item recognition task scored "
    },
    {
     "text": "> 2/10",
     "code": 1
    },
    {
     "text": " (20%), the same cut-point as the 10-letter SAVEAHAART task. It is reproduced faithfully (tier V), with no tool-introduced cut-point deviation (corrected 2026-06-27; see §6.5)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "RASS (Richmond Agitation-Sedation Scale).",
     "b": 1
    },
    {
     "text": " Developed by Sessler et al., 2002 ("
    },
    {
     "text": "sessler2002",
     "code": 1
    },
    {
     "text": "); reliability/validity over time established by Ely et al., 2003 ("
    },
    {
     "text": "ely2003",
     "code": 1
    },
    {
     "text": "). Reproduce the 10-point scale (+4 Combative … −5 Unarousable) verbatim. The "
    },
    {
     "text": "target band and color zoning are a local, configurable, PADIS-informed overlay",
     "b": 1
    },
    {
     "text": ", not part of the validated scale, and must remain visually distinct from the scale anchors so a configured target is never mistaken for a validated cut-point."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Separation mandate.",
     "b": 1
    },
    {
     "text": " The risk-factor tally (§2.1) is a non-validated count (tier P). It must not:"
    }
   ]
  },
  {
   "t": "ul",
   "items": [
    [
     {
      "text": "adopt CAM-ICU or RASS visual styling, color language, or results panel;"
     }
    ],
    [
     {
      "text": "be presented as a \"score\" without the \"(not a validated score)\" / \"(heuristic)\" qualifier the tool already carries;"
     }
    ],
    [
     {
      "text": "share a print block or PDF region with the CAM-ICU result in a way that implies a single validated output."
     }
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Any future UI change must preserve this separation. The instruments stay attributed and faithful (tier V); the tally stays flattened or explicitly caveated (tier P)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Modification register.",
     "b": 1
    },
    {
     "text": " Record here any place the tool deliberately departs from a source instrument, so reviewers can audit deviations at a glance."
    }
   ]
  },
  {
   "t": "table",
   "head": [
    [
     {
      "text": "Instrument"
     }
    ],
    [
     {
      "text": "Deviation"
     }
    ],
    [
     {
      "text": "Tier"
     }
    ],
    [
     {
      "text": "Disclosed where"
     }
    ],
    [
     {
      "text": "Status"
     }
    ]
   ],
   "rows": [
    [
     [
      {
       "text": "CAM-ICU"
      }
     ],
     [
      {
       "text": "Pictures-ASE corrected to the validated 10-item > 2/10 task (no cut-point deviation)"
      }
     ],
     [
      {
       "text": "V"
      }
     ],
     [
      {
       "text": "§2.2, §6.5"
      }
     ],
     [
      {
       "text": "Resolved 2026-06-27"
      }
     ]
    ],
    [
     [
      {
       "text": "CAM-ICU"
      }
     ],
     [
      {
       "text": "Feature 3 had shipped in the superseded descriptor form (Alert vs Vigilant/Lethargic/Stuporous) — an "
      },
      {
       "text": "undisclosed deviation",
       "b": 1
      },
      {
       "text": " found in the 2026-07-01 audit; replaced with the worksheet's RASS ≠ 0 operationalization, so no deviation remains"
      }
     ],
     [
      {
       "text": "V"
      }
     ],
     [
      {
       "text": "§2.2, §6.5"
      }
     ],
     [
      {
       "text": "Resolved 2026-07-01"
      }
     ]
    ],
    [
     [
      {
       "text": "CAM-ICU"
      }
     ],
     [
      {
       "text": "Verdict gating now requires a documented RASS before any result (return to the source's two-step order; previously a verdict could be produced with RASS unset)"
      }
     ],
     [
      {
       "text": "V"
      }
     ],
     [
      {
       "text": "§2.2, §6.5"
      }
     ],
     [
      {
       "text": "Resolved 2026-07-01"
      }
     ]
    ],
    [
     [
      {
       "text": "RASS"
      }
     ],
     [
      {
       "text": "Configurable target band / color zoning overlaid on the validated scale"
      }
     ],
     [
      {
       "text": "P (overlay)"
      }
     ],
     [
      {
       "text": "§2.3, Setup tab"
      }
     ],
     [
      {
       "text": "Disclosed"
      }
     ]
    ],
    [
     [
      {
       "text": "CAPD (peds)"
      }
     ],
     [
      {
       "text": "The source's point-age anchor columns (NB/4 wk/6 wk/8 wk/28 wk/1 yr/2 yr) are mapped to ranges that begin at each labeled age (score-neutral; picks which inline hint shows)"
      }
     ],
     [
      {
       "text": "P (band mapping)"
      }
     ],
     [
      {
       "text": "§7.1, "
      },
      {
       "text": "capd.js",
       "code": 1
      },
      {
       "text": " comment"
      }
     ],
     [
      {
       "text": "Disclosed 2026-07-01"
      }
     ]
    ]
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "6.7 Non-device CDS design principles"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The tool is designed to the FDA non-device Clinical Decision Support criteria (Cures Act §520(o)(1)(E); Jan-2026 final guidance) as a "
    },
    {
     "text": "voluntary design discipline",
     "b": 1
    },
    {
     "text": " — not a regulatory determination, clearance, or claim of status. Two criteria bind the content design and are worth preserving in any derivative:"
    }
   ]
  },
  {
   "t": "ul",
   "items": [
    [
     {
      "text": "Supports, does not direct.",
      "b": 1
     },
     {
      "text": " Each output offers options or complete information for the clinician to weigh, not a single push-button directive. No output instructs a specific action without surfacing alternatives and the \"verify against local policy / prescriber & pharmacy review\" framing."
     }
    ],
    [
     {
      "text": "Basis is independently reviewable.",
      "b": 1
     },
     {
      "text": " For every threshold, band, cut-point, and dose, the clinician can see the citation and its tier/grade (§6.4), so they can independently review the basis rather than rely on the tool. P-tier numbers carry the \"pragmatic, not validated\" note; V-tier instruments carry their attribution (§6.6)."
     }
    ]
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "An adopter that changes the tool's inputs (e.g., ingesting a device signal), its autonomy (issuing orders or acted-upon scores), its intended use, or its distribution should make its own device/non-device determination for that change; these design principles no longer speak for a materially altered derivative."
    }
   ]
  },
  {
   "t": "h",
   "level": 2,
   "spans": [
    {
     "text": "7. Pediatric tool (/peds/)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "A sibling bedside reference for the pediatric ICU at "
    },
    {
     "text": "/peds/",
     "code": 1
    },
    {
     "text": ", built on the same framework and held to the same rules. Clinical values are sourced; pharmacologic content is off-label and limited-evidence, and any deployment is validated by the adopting unit (§6.1). This section grows as the pediatric modules are added, beginning with screening."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "7.1 Screening: arousal gate + CAPD / pCAM-ICU / psCAM-ICU"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The user picks the validated screen for the child's age and developmental level; arousal is scored first as the gate."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Arousal gate (all screens).",
     "b": 1
    },
    {
     "text": " RASS "
    },
    {
     "text": "−4/−5",
     "b": 1
    },
    {
     "text": " (or SBS "
    },
    {
     "text": "−2/−3",
     "b": 1
    },
    {
     "text": ") = comatose → "
    },
    {
     "text": "\"Unable to assess\"",
     "b": 1
    },
    {
     "text": "; screen once the child responds to voice (RASS ≥ −3). Same logic as the adult CAM-ICU gate (§2.2), carried into all three pediatric tools."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "CAPD (Cornell Assessment of Pediatric Delirium), all ages (0–21 yr).",
     "b": 1
    },
    {
     "text": " Eight-item observational nursing screen rated over the shift against age-expected behavior; each item 0–4 (total 0–32). Items 1–4 (eye contact, purposeful actions, awareness, communication) are reverse-scored (Never = 4 … Always = 0); items 5–8 (restless, inconsolable, underactive, slow to respond) are scored Never = 0 … Always = 4. "
    },
    {
     "text": "Cut point ≥ 9 = positive",
     "b": 1
    },
    {
     "text": " (Traube 2014: sensitivity 94.1%, specificity 79.2%). "
    },
    {
     "text": "Developmental-delay caveat surfaced at the result",
     "b": 1
    },
    {
     "text": " (matching in-app text): CAPD ≥ 9 remains positive, but specificity falls in baseline developmental delay (Traube 2014: 51.2% at ≥ 9; Gupta 2021: 44.8% overall, 16.5% with delay in ventilated children), so the result is interpreted against the child's own developmental baseline and the anchors, with experienced-clinician or pediatric-psychiatry review when needed. The tool does not advise substituting a higher cut point: reduced specificity is a false-positive problem, not a validated replacement threshold, and the ventilated-cohort ≥ 17 figure is population-specific. The 0–32 score and positive/negative are withheld until all eight items are rated. "
    },
    {
     "text": "Anchor-band mapping:",
     "b": 1
    },
    {
     "text": " the source anchor table defines point-age columns (NB, 4 wk, 6 wk, 8 wk, 28 wk, 1 yr, 2 yr); the tool maps a developmental age to the column whose labeled age it has reached (cuts at ≈0.92 / 1.38 / 1.84 / 6.44 / 12 / 24 months), so a child at or past a labeled age sees that column's anchors. The mapping is score-neutral (it selects the inline hint only) and is recorded in the §6.6 register as a disclosed P-tier presentation choice."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "pCAM-ICU (≥ 5 yr) and psCAM-ICU (6 mo–5 yr).",
     "b": 1
    },
    {
     "text": " The CAM-ICU hierarchical algorithm, reused from the adult tool: "
    },
    {
     "text": "positive if Feature 1 AND Feature 2 AND (Feature 3 OR Feature 4)",
     "b": 1
    },
    {
     "text": ", with the RASS arousal gate. "
    },
    {
     "text": "Feature 3 (altered level of consciousness) is derived from the recorded RASS/SBS",
     "b": 1
    },
    {
     "text": ": a score of 0 (alert and calm) is absent, any other assessable level present. It is shown read-only rather than entered separately, so it can never contradict the arousal score (the same operationalization the adult CAM-ICU and ED bCAM use; guarded by a unit test). pCAM-ICU uses verbal attention/command tasks (developmental age ≥ 5 yr); Feature 2 offers the validated "
    },
    {
     "text": "memory-pictures alternative",
     "b": 1
    },
    {
     "text": " as an interactive on-screen task (show 5 pictures to memorize, then 10 recognition pictures scored Seen/New; same ≥ 3-error cut) alongside the squeeze-on-A letters, for children who cannot squeeze (either task at threshold makes Feature 2 positive). Feature 4 carries the instrument's alternate question set and the two-step command per the pCAM instruction tool (\"now do that with the other hand\" "
    },
    {
     "text": "or",
     "b": 1
    },
    {
     "text": " \"add one more finger\"; the pediatric instrument gives the second step as a plain alternative, unlike the adult worksheet's cannot-use-both-hands conditional; do not repeat the number of fingers). The Feature-2 letters are read in an even tone \"without stopping\" per the instruction tool; no per-second rate is stated by the pediatric instrument (an earlier \"about one per second\" instruction traced to no cited source and was removed; see §6.5). psCAM-ICU uses age-adapted observational tasks (6 mo–5 yr); its "
    },
    {
     "text": "Feature 2 implements both validated positivity paths",
     "b": 1
    },
    {
     "text": ": (1) no eye contact on ≥ 3 of 10 presentations, or (2) eye contact on 8+ presentations but "
    },
    {
     "text": "unable to maintain sustained eye opening during at least half the assessment despite verbal prompts",
     "b": 1
    },
    {
     "text": " (the assessor talks to the child throughout as ongoing stimulation). Feature 2 is absent only if neither path is met (Smith 2016, Fig. 2/Table 3; psCAM worksheet). The result is withheld until Features 1 and 2 (and a secondary feature) are answered."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Citations mapped (pediatric Screening tab):",
     "b": 1
    },
    {
     "text": " CAPD → Traube 2014 (Crit Care Med 2014;42(3):656–663; PMID 24145848; cut point 9, developmental-delay specificity 51.2%); pCAM-ICU → Smith 2011 (Crit Care Med 2011;39(1):150–157; PMID 20959783; developmental age ≥ 5 yr); psCAM-ICU → Smith 2016 (Crit Care Med 2016;44(3):592–600; PMID 26565631; 6 mo–5 yr); arousal scales → Curley 2006 (State Behavioral Scale; Pediatr Crit Care Med 2006;7(2):107–114) and Sessler 2002 / Kerson 2016 (RASS, adult + pediatric validation); screening practice → SCCM PANDEM 2022 (Pediatr Crit Care Med 2022;23(2):e74–e110)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Adopter validation:",
     "b": 1
    },
    {
     "text": " the CAPD scoring direction and cut point, the developmental-delay caveat, and the age/developmental boundaries that route a child to CAPD vs psCAM-ICU vs pCAM-ICU should be confirmed by the adopting unit's pediatric-clinician review before clinical use."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "7.2 Risk factors"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "A review aid listing reported associations, "
    },
    {
     "text": "not a validated predictive score",
     "b": 1
    },
    {
     "text": " (no pediatric equivalent of PRE-DELIRIC is in routine bedside use). Factors are grouped modifiable vs patient/illness, each tagged by evidence strength; the clinician checks those that apply. No numeric score or band is computed or implied."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Modifiable (review and minimize):",
     "b": 1
    },
    {
     "text": " benzodiazepine exposure (the strongest, most consistent factor: dose-dependent, causal-effect estimate OR ≈ 3.3 from a marginal structural model, vs crude OR 4.4); deep sedation; anticholinergic cumulative burden; mechanical ventilation; physical restraints (partly confounded by indication); immobility / device tethering."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Patient / illness:",
     "b": 1
    },
    {
     "text": " young age (≤ 2 yr); developmental delay / baseline cognitive impairment; greater severity of illness; prior coma; prolonged PICU stay (both a risk marker and an outcome)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Citations mapped (pediatric Risk tab):",
     "b": 1
    },
    {
     "text": " Traube 2017 epidemiology & mortality (PMID 28288026, independent predictors: age ≤ 2, developmental delay, severity, prior coma, mechanical ventilation, benzodiazepines, anticholinergics; delirium independently predicted mortality, aOR 4.39); Traube 2017 international point-prevalence (PMID 28079605, ~25%); Mody 2018 benzodiazepine causal effect (PMID 29727363, the corrected reference; the previously cited 29879008 resolves to an unrelated paper); SCCM PANDEM 2022 (PMID 35119438)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Adopter validation:",
     "b": 1
    },
    {
     "text": " the risk-factor list, the evidence-strength tags, and the benzodiazepine effect-size wording should be confirmed by the adopting unit's pediatric-clinician review before clinical use."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "7.3 Prevention bundle"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "The pediatric ABCDEF / PICU Liberation bundle, presented as a shift checklist with its evidence framing: non-pharmacologic multicomponent prevention is first-line and routine pharmacologic prophylaxis is not recommended; bundle benefit is best established for mortality and care-process measures rather than a proven reduction in delirium incidence, with benzodiazepine minimization the best-supported single lever."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Elements:",
     "b": 1
    },
    {
     "text": " A: pain (FLACC/FACES/self-report); B: spontaneous awakening + breathing trials, protocolized titration, watch iatrogenic withdrawal (WAT-1); C: light goal-directed sedation (SBS −1 to 0), minimize benzodiazepines, prefer dexmedetomidine; D: screen ≥ each shift; E: developmentally appropriate early mobility; F: family engagement. Plus non-pharmacologic sleep/circadian protection, day–night normalization, sensory aids, and minimizing restraints and deliriogenic medications. Melatonin/pharmacologic sleep aids are noted as "
    },
    {
     "text": "not established",
     "b": 1
    },
    {
     "text": " for pediatric delirium prevention."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Citations mapped (pediatric Prevention tab):",
     "b": 1
    },
    {
     "text": " SCCM PANDEM 2022 (PMID 35119438); SCCM Pediatric ICU Liberation collaborative, Lin 2023 (Lin JC et al., Pediatr Crit Care Med 2023;24(8):636–651, PMID 37125798; previously mis-attributed to \"Ista E\"; higher bundle utilization associated with lower mortality, not consistently lower delirium incidence; an observational collaborative, not a randomized bundle trial); RESTORE goal-directed sedation (Curley 2015, JAMA, "
    },
    {
     "text": "negative for its primary mechanical-ventilation-duration outcome",
     "b": 1
    },
    {
     "text": "; cited only for the SBS-titration model, not an efficacy claim); PICU Up! early mobility (Kudchadkar et al., Johns Hopkins; protocol Azamfirei, Trials 2023;24:191, PMID 36918956; "
    },
    {
     "text": "NCT04989790",
     "b": 1
    },
    {
     "text": ", previously mis-attributed to \"Choong K\"); Mody 2018 benzodiazepine causal effect (PMID 29727363)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Adopter validation:",
     "b": 1
    },
    {
     "text": " the bundle elements, the SBS comfort-target wording, the \"melatonin not established\" statement, and the evidence-framing of bundle benefit should be confirmed by the adopting unit's pediatric-clinician review before clinical use."
    }
   ]
  },
  {
   "t": "h",
   "level": 3,
   "spans": [
    {
     "text": "7.4 Pharmacology (Treatment + Medications)"
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Framing:",
     "b": 1
    },
    {
     "text": " treat the cause and apply the non-pharmacologic bundle first; drugs are adjunctive. Pharmacologic treatment of symptoms is reserved for short-term, refractory, safety-threatening agitation. All agents are "
    },
    {
     "text": "off-label",
     "b": 1
    },
    {
     "text": " in pediatric delirium with "
    },
    {
     "text": "limited (retrospective/observational) evidence",
     "b": 1
    },
    {
     "text": ". In reported PICU practice the atypicals are usually chosen before IV haloperidol, a prescribing-pattern and safety-profile preference ("
    },
    {
     "text": "madden2021_prescribing",
     "code": 1
    },
    {
     "text": ", "
    },
    {
     "text": "capino2020",
     "code": 1
    },
    {
     "text": "), "
    },
    {
     "text": "not a guideline ranking",
     "b": 1
    },
    {
     "text": ": PANDEM's recommendation for severe refractory manifestations names \"haloperidol or atypical antipsychotics\" without preferring either ("
    },
    {
     "text": "pandem2022",
     "code": 1
    },
    {
     "text": "), and the tool labels the hierarchy accordingly. The Medications tab opens with a prominent \"not an order set: verify against formulary\" banner. Doses are starting points from the literature, not orders; before use they must be reconciled by the adopting unit's pediatric-clinician + pharmacist review against a current pediatric dosing reference (Lexicomp Pediatric / Harriet Lane), with the edition pinned by the adopter."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Sedation / sleep.",
     "b": 1
    },
    {
     "text": " Dexmedetomidine 0.2–1 mcg/kg/hr IV, cited to Phan & Nahata 2008 ("
    },
    {
     "text": "phan2008_dexmed",
     "code": 1
    },
    {
     "text": ", within its reported 0.2–2 mcg/kg/h pediatric-ICU range) (preferred, delirium-sparing; loading bolus often omitted in the PICU; bradycardia/hypotension; taper to avoid rebound; not a substitute for analgesia (opioid-sparing at most) nor reliable amnesia; "
    },
    {
     "text": "PICU continuous sedation is off-label",
     "b": 1
    },
    {
     "text": ", while the current label's only pediatric indication is procedural sedation of non-intubated children ≥ 1 month for non-invasive procedures, "
    },
    {
     "text": "dex_label",
     "code": 1
    },
    {
     "text": "; the earlier unqualified \"off-label < 18 yr\" predated that indication and was corrected, see §6.5). Benzodiazepines: limit/avoid as continuous sedation (independent dose-related risk). Melatonin 0.5–3 mg (younger) up to 3–5 mg (older) for sleep/circadian support, "
    },
    {
     "text": "not",
     "b": 1
    },
    {
     "text": " a delirium treatment. The mg values are general pediatric sleep dosing cited to Bruni 2015 ("
    },
    {
     "text": "bruni2015_melatonin",
     "code": 1
    },
    {
     "text": "), and the adult-ICU meta-analysis ("
    },
    {
     "text": "melatonin_meta2025",
     "code": 1
    },
    {
     "text": ") anchors only the evidence framing, not the pediatric numbers."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Antipsychotics (enteral unless noted).",
     "b": 1
    },
    {
     "text": " Risperidone, started low and titrated by age/weight band: ≤ 2 yr ~0.01–0.04 mg/kg/day (Campbell 2020, a 17-patient cohort; pharmacist verification required), < 5 yr ~0.1 mg q12–24h, ≥ 5 yr ~0.2 mg q12–24h (Capino 2020, per Kishk); "
    },
    {
     "text": "no single daily maximum is shown",
     "b": 1
    },
    {
     "text": ". The previously displayed ~2 mg/day (Capino 2020, per Schieveld, enteral 0.1–2 mg/day) was an unqualified figure that could read as spanning infants to adolescents, so the ceiling is deferred to a named institutional protocol / formulary for the child's age and weight. Quetiapine ~0.43–0.7 mg/kg/dose q8h: "
    },
    {
     "text": "initiation ≈ 1.5 mg/kg/day divided q8h; reported median 1.3 mg/kg/day, IQR 0.4–2.3",
     "b": 1
    },
    {
     "text": " (Joyce 2015; this single representation is used identically in the app, the report data, and here). Olanzapine age-banded (infants ~0.625 mg, toddlers ~1.25 mg, older ~2.5–5 mg; Capino 2020). Haloperidol "
    },
    {
     "text": "reserve",
     "b": 1
    },
    {
     "text": ", IV off-label: "
    },
    {
     "text": "no generic loading or maintenance dose is shown",
     "b": 1
    },
    {
     "text": ". IV haloperidol is gated to a current institutional pediatric agitation/delirium protocol that must specify age/weight eligibility, route, the repeat interval, a maximum cumulative loading dose and maximum daily dose, ECG/electrolyte monitoring, contraindications, and treatment of acute dystonia ("
    },
    {
     "text": "haldol_label",
     "code": 1
    },
    {
     "text": " for the QTc/torsades warnings). The cited case series (Capino 2020) repeated ~0.025–0.1 mg/kg/dose roughly q10min for 3–4 doses (loading totals 0.09–0.25 mg/kg, one dystonia in five children); that per-dose figure is no longer displayed as a numeric instruction, because at its upper bound four repeats (0.4 mg/kg) would exceed the observed totals and the tool cannot supply the protocol's interval or cumulative cap. The previously listed \"~0.015–0.15 mg/kg/dose IV q6–8h\" was the observed per-dose range of a single 5-patient 2002 case series (Harrison, via Capino 2020 Table 1, ventilated children on neuromuscular blockade) that Capino itself declines to convert into a recommendation; at q6h its upper bound permits 0.60 mg/kg/day, several-fold above published institutional protocols (e.g. maintenance 0.015–0.025 mg/kg/dose q6h with a 0.45 mg/kg/day maximum, or daily-dose titration 0.05 → 0.15 mg/kg/day divided for infants and young children). Maintenance dosing is therefore deferred to the unit formulary / pediatric pharmacist with an agreed "
    },
    {
     "text": "maximum daily dose",
     "b": 1
    },
    {
     "text": ", which the adopting unit validates before use; any future numeric range must be age/weight-banded, carry an explicit daily maximum, and pin to a dated pediatric dosing reference."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Monitoring (all antipsychotics).",
     "b": 1
    },
    {
     "text": " Baseline 12-lead ECG (QTc), electrolytes, QT-drug review; read the QTc against age-, sex-, rhythm- and correction-formula-appropriate limits. (The earlier \"> 450–500 ms or ≥ 25% rise\" was ambiguous, and the 25% delta is unsupported in the cited pediatric sources and behaves unintuitively: 25% of a 400 ms baseline is 100 ms, missing a clinically meaningful 60 ms change.) A borderline/prolonged result prompts repeat/verify ECG, electrolyte correction, and interacting-drug review; QTc ≥ 500 ms or a substantial absolute rise (commonly ≥ 60 ms in QT-safety practice) warrants urgent prescriber/pharmacy review under the local cardiology or medication-safety protocol, which sets the stop/reduce thresholds. Watch EPS/dystonia (most with haloperidol), NMS, and metabolic effects (olanzapine/quetiapine highest)."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Citations mapped (pediatric Treatment + Medications tabs):",
     "b": 1
    },
    {
     "text": " Capino 2020 ("
    },
    {
     "text": "capino2020",
     "code": 1
    },
    {
     "text": ", PMC7025750, registered and cited inline on the haloperidol/olanzapine/risperidone dose figures); Precedex label ("
    },
    {
     "text": "dex_label",
     "code": 1
    },
    {
     "text": ", the pediatric procedural-sedation indication and the not-established-for-pediatric-ICU-sedation statement); SCCM PANDEM 2022 ("
    },
    {
     "text": "pandem2022",
     "code": 1
    },
    {
     "text": ", PMID 35119438; the no-agent-preference antipsychotic recommendation, cited inline on the practice-preference statements); Campbell 2020 risperidone ≤ 2 yr (PMID 31771334); Joyce 2015 quetiapine safety (PMID 26469214); Madden prescribing/outcomes (J Pediatr Intensive Care 2024;13(1):46–54, online 2021; PMID 38571986); QTc-effects study (PMC7792149); Cavagnero 2025 pediatric antipsychotic systematic review ("
    },
    {
     "text": "peds_apsych_sr2025",
     "code": 1
    },
    {
     "text": ", PMID 40906237); Phan & Nahata dexmedetomidine ("
    },
    {
     "text": "phan2008_dexmed",
     "code": 1
    },
    {
     "text": ", Paediatr Drugs 2008, PMID 18162008; registered and cited on the infusion dose); Bruni 2015 pediatric melatonin dosing ("
    },
    {
     "text": "bruni2015_melatonin",
     "code": 1
    },
    {
     "text": "); plus a pinned pediatric dosing reference (Lexicomp Pediatric / Harriet Lane) for the numeric weight-based values."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "Adopter validation:",
     "b": 1
    },
    {
     "text": " every weight-based dose, route, frequency, and maximum (and the haloperidol correction in particular) should be confirmed by the adopting unit's pediatric-clinician + pharmacist review and pinned to a dated dosing reference before clinical use."
    }
   ]
  },
  {
   "t": "p",
   "spans": [
    {
     "text": "This document describes the tool as implemented. Where the application's wording and this document differ, the in-application disclaimers and your institution's policy govern clinical use.",
     "i": 1
    }
   ]
  }
 ]
}